// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M2 5l6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10l3 3l6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgb%28187.8214285714, 190.9642857143, 239.6785714286%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%233ac47d%27 d=%27M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23d92550%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23d92550%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%280, 0, 0, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgb%2875.6, 82.8, 194.4%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23495057%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("./utils/images/Arkos_color_logo 1.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("./utils/images/arkosLogo.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("./utils/images/Arkos_white_logo 1.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("./demo-ui/images/search-icons.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MiIgaGVpZ2h0PSI0MiI+PGcgc3Ryb2tlPSIjRkZGIiBzdHJva2Utd2lkdGg9IjIuOSIgPjxwYXRoIGQ9Ik0xNCAxNS43aDE0LjQiLz48cGF0aCBkPSJNMTQgMjEuNGgxNC40Ii8+PHBhdGggZD0iTTE0IDI3LjFoMTQuNCIvPjwvZz4KPC9zdmc+", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCI+PGNpcmNsZSBjeD0iOSIgY3k9IjkiIHI9IjgiIGZpbGw9IiNGRkYiLz48ZyBzdHJva2U9IiM5ODk4OTgiIHN0cm9rZS13aWR0aD0iMS45IiA+PHBhdGggZD0iTTQuNSA5aDkiLz48L2c+Cjwvc3ZnPg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCI+PGNpcmNsZSBjeD0iOSIgY3k9IjkiIHI9IjgiIGZpbGw9IiNGRkYiLz48ZyBzdHJva2U9IiM5ODk4OTgiIHN0cm9rZS13aWR0aD0iMS45IiA+PHBhdGggZD0iTTQuNSA5aDkiLz48cGF0aCBkPSJNOSA0LjV2OSIvPjwvZz4KPC9zdmc+", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("./components/icons/linearicons/Linearicons-Free.eot?w118d", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("./components/icons/linearicons/Linearicons-Free.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("./components/icons/linearicons/Linearicons-Free.woff2?w118d", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("./components/icons/linearicons/Linearicons-Free.woff?w118d", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("./components/icons/linearicons/Linearicons-Free.ttf?w118d", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("./components/icons/linearicons/Linearicons-Free.svg?w118d", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("pe7-icon/dist/fonts/Pe-icon-7-stroke.eot?d7yf1v", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("pe7-icon/dist/fonts/Pe-icon-7-stroke.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("pe7-icon/dist/fonts/Pe-icon-7-stroke.woff?d7yf1v", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("pe7-icon/dist/fonts/Pe-icon-7-stroke.ttf?d7yf1v", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("pe7-icon/dist/fonts/Pe-icon-7-stroke.svg?d7yf1v", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___, { hash: "?#iefixw118d" });
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___, { hash: "#Linearicons-Free" });
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___, { hash: "?#iefixd7yf1v" });
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___, { hash: "#Pe-icon-7-stroke" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.border-primary {
  border-color: #545cd8;
}

.border-secondary {
  border-color: #6c757d;
}

.border-success {
  border-color: #3ac47d;
}

.border-info {
  border-color: #30b1ff;
}

.border-warning {
  border-color: #f7b924;
}

.border-danger {
  border-color: #d92550;
}

.border-light {
  border-color: #eeeeee;
}

.border-dark {
  border-color: #343a40;
}

.border-focus {
  border-color: #444054;
}

.border-alternate {
  border-color: #83588a;
}

:root {
  --bs-blue: #86c6fb;
  --bs-indigo: #444054;
  --bs-purple: #83588a;
  --bs-pink: #f65ca2;
  --bs-red: #d92550;
  --bs-orange: #fd7e14;
  --bs-yellow: #f7b924;
  --bs-green: #3ac47d;
  --bs-teal: #16E0BD;
  --bs-cyan: #30b1ff;
  --bs-white: #fff;
  --bs-gray: #6c757d;
  --bs-gray-dark: #343a40;
  --bs-primary: #545cd8;
  --bs-secondary: #6c757d;
  --bs-success: #3ac47d;
  --bs-info: #30b1ff;
  --bs-warning: #f7b924;
  --bs-danger: #d92550;
  --bs-light: #eeeeee;
  --bs-dark: #343a40;
  --bs-focus: #444054;
  --bs-alternate: #83588a;
  --bs-font-sans-serif: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-family: var(--bs-font-sans-serif);
  font-size: 0.88rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  background-color: currentColor;
  border: 0;
  opacity: 0.25;
}

hr:not([size]) {
  height: 1px;
}

h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 400;
  line-height: 1.2;
}

h1, .h1 {
  font-size: calc(1.345rem + 1.14vw);
}
@media (min-width: 1200px) {
  h1, .h1 {
    font-size: 2.2rem;
  }
}

h2, .h2 {
  font-size: calc(1.301rem + 0.612vw);
}
@media (min-width: 1200px) {
  h2, .h2 {
    font-size: 1.76rem;
  }
}

h3, .h3 {
  font-size: calc(1.279rem + 0.348vw);
}
@media (min-width: 1200px) {
  h3, .h3 {
    font-size: 1.54rem;
  }
}

h4, .h4 {
  font-size: calc(1.257rem + 0.084vw);
}
@media (min-width: 1200px) {
  h4, .h4 {
    font-size: 1.32rem;
  }
}

h5, .h5 {
  font-size: 1.1rem;
}

h6, .h6 {
  font-size: 0.88rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title],
abbr[data-bs-original-title] {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  -webkit-text-decoration-skip-ink: none;
          text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small, .small {
  font-size: 0.875em;
}

mark, .mark {
  padding: 0.2em;
  background-color: #fcf8e3;
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: #545cd8;
  text-decoration: underline;
}
a:hover {
  color: rgb(67.2, 73.6, 172.8);
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-family: var(--bs-font-monospace);
  font-size: 1em;
  direction: ltr /* rtl:ignore */;
  unicode-bidi: bidi-override;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 0.875em;
  color: #f65ca2;
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.2rem 0.4rem;
  font-size: 0.875em;
  color: #fff;
  background-color: #212529;
  border-radius: 0.2rem;
}
kbd kbd {
  padding: 0;
  font-size: 1em;
  font-weight: 700;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: #6c757d;
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]::-webkit-calendar-picker-indicator {
  display: none;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
  line-height: inherit;
}
@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  outline-offset: -2px;
  -webkit-appearance: textfield;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::-webkit-file-upload-button {
  font: inherit;
}

::file-selector-button {
  font: inherit;
}

::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.1rem;
  font-weight: 300;
}

.display-1 {
  font-size: calc(1.625rem + 4.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}

.display-2 {
  font-size: calc(1.575rem + 3.9vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}

.display-3 {
  font-size: calc(1.525rem + 3.3vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}

.display-4 {
  font-size: calc(1.475rem + 2.7vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}

.display-5 {
  font-size: calc(1.425rem + 2.1vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}

.display-6 {
  font-size: calc(1.375rem + 1.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.1rem;
}
.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #6c757d;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: #fff;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 0.875em;
  color: #6c757d;
}

.container, .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .body-tabs.body-tabs-layout.body-tabs-big,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  width: 100%;
  padding-right: 0.75rem;
  padding-right: var(--bs-gutter-x, 0.75rem);
  padding-left: 0.75rem;
  padding-left: var(--bs-gutter-x, 0.75rem);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container, .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .body-tabs.body-tabs-layout.body-tabs-big {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container, .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .body-tabs.body-tabs-layout.body-tabs-big {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container, .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .body-tabs.body-tabs-layout.body-tabs-big {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container, .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .body-tabs.body-tabs-layout.body-tabs-big {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container, .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .body-tabs.body-tabs-layout.body-tabs-big {
    max-width: 1320px;
  }
}
.row {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(var(--bs-gutter-y) * -1);
  margin-right: calc(var(--bs-gutter-x) * -0.5);
  margin-left: calc(var(--bs-gutter-x) * -0.5);
}
.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}

.col {
  flex: 1 0;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.3333333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.6666666667%;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0;
  }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
}
.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-0,
.gx-0 {
  --bs-gutter-x: 0;
}

.g-0,
.gy-0 {
  --bs-gutter-y: 0;
}

.g-1,
.gx-1 {
  --bs-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
  --bs-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
  --bs-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
  --bs-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
  --bs-gutter-x: 1rem;
}

.g-3,
.gy-3 {
  --bs-gutter-y: 1rem;
}

.g-4,
.gx-4 {
  --bs-gutter-x: 1.5rem;
}

.g-4,
.gy-4 {
  --bs-gutter-y: 1.5rem;
}

.g-5,
.gx-5 {
  --bs-gutter-x: 3rem;
}

.g-5,
.gy-5 {
  --bs-gutter-y: 3rem;
}

@media (min-width: 576px) {
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  .g-sm-0,
  .gx-sm-0 {
    --bs-gutter-x: 0;
  }
  .g-sm-0,
  .gy-sm-0 {
    --bs-gutter-y: 0;
  }
  .g-sm-1,
  .gx-sm-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-sm-1,
  .gy-sm-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-sm-2,
  .gx-sm-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-sm-2,
  .gy-sm-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-sm-3,
  .gx-sm-3 {
    --bs-gutter-x: 1rem;
  }
  .g-sm-3,
  .gy-sm-3 {
    --bs-gutter-y: 1rem;
  }
  .g-sm-4,
  .gx-sm-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-sm-4,
  .gy-sm-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-sm-5,
  .gx-sm-5 {
    --bs-gutter-x: 3rem;
  }
  .g-sm-5,
  .gy-sm-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 768px) {
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
  .g-md-0,
  .gx-md-0 {
    --bs-gutter-x: 0;
  }
  .g-md-0,
  .gy-md-0 {
    --bs-gutter-y: 0;
  }
  .g-md-1,
  .gx-md-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-md-1,
  .gy-md-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-md-2,
  .gx-md-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-md-2,
  .gy-md-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-md-3,
  .gx-md-3 {
    --bs-gutter-x: 1rem;
  }
  .g-md-3,
  .gy-md-3 {
    --bs-gutter-y: 1rem;
  }
  .g-md-4,
  .gx-md-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-md-4,
  .gy-md-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-md-5,
  .gx-md-5 {
    --bs-gutter-x: 3rem;
  }
  .g-md-5,
  .gy-md-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 992px) {
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  .g-lg-0,
  .gx-lg-0 {
    --bs-gutter-x: 0;
  }
  .g-lg-0,
  .gy-lg-0 {
    --bs-gutter-y: 0;
  }
  .g-lg-1,
  .gx-lg-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-lg-1,
  .gy-lg-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-lg-2,
  .gx-lg-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-lg-2,
  .gy-lg-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-lg-3,
  .gx-lg-3 {
    --bs-gutter-x: 1rem;
  }
  .g-lg-3,
  .gy-lg-3 {
    --bs-gutter-y: 1rem;
  }
  .g-lg-4,
  .gx-lg-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-lg-4,
  .gy-lg-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-lg-5,
  .gx-lg-5 {
    --bs-gutter-x: 3rem;
  }
  .g-lg-5,
  .gy-lg-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1200px) {
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  .g-xl-0,
  .gx-xl-0 {
    --bs-gutter-x: 0;
  }
  .g-xl-0,
  .gy-xl-0 {
    --bs-gutter-y: 0;
  }
  .g-xl-1,
  .gx-xl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xl-1,
  .gy-xl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xl-2,
  .gx-xl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xl-2,
  .gy-xl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xl-3,
  .gx-xl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xl-3,
  .gy-xl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xl-4,
  .gx-xl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xl-4,
  .gy-xl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xl-5,
  .gx-xl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xl-5,
  .gy-xl-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1400px) {
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xxl-0 {
    margin-left: 0;
  }
  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xxl-3 {
    margin-left: 25%;
  }
  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xxl-6 {
    margin-left: 50%;
  }
  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xxl-9 {
    margin-left: 75%;
  }
  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  .g-xxl-0,
  .gx-xxl-0 {
    --bs-gutter-x: 0;
  }
  .g-xxl-0,
  .gy-xxl-0 {
    --bs-gutter-y: 0;
  }
  .g-xxl-1,
  .gx-xxl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xxl-1,
  .gy-xxl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xxl-2,
  .gx-xxl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xxl-2,
  .gy-xxl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xxl-3,
  .gx-xxl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xxl-3,
  .gy-xxl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xxl-4,
  .gx-xxl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xxl-4,
  .gy-xxl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xxl-5,
  .gx-xxl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xxl-5,
  .gy-xxl-5 {
    --bs-gutter-y: 3rem;
  }
}
.table {
  --bs-table-bg: transparent;
  --bs-table-accent-bg: rgba(0, 0, 0, 0.03);
  --bs-table-striped-color: #495057;
  --bs-table-striped-bg: rgba(0, 0, 0, 0.05);
  --bs-table-active-color: #495057;
  --bs-table-active-bg: #e0f3ff;
  --bs-table-hover-color: #495057;
  --bs-table-hover-bg: #e0f3ff;
  width: 100%;
  margin-bottom: 1rem;
  color: #495057;
  vertical-align: top;
  border-color: #e9ecef;
}
.table > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
  background-color: var(--bs-table-bg);
  border-bottom-width: 1px;
  box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);
}
.table > tbody {
  vertical-align: inherit;
}
.table > thead {
  vertical-align: bottom;
}
.table > :not(:last-child) > :last-child > * {
  border-bottom-color: currentColor;
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.25rem 0.25rem;
}

.table-bordered > :not(caption) > * {
  border-width: 1px 0;
}
.table-bordered > :not(caption) > * > * {
  border-width: 0 1px;
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) {
  --bs-table-accent-bg: var(--bs-table-striped-bg);
  color: var(--bs-table-striped-color);
}

.table-active {
  --bs-table-accent-bg: var(--bs-table-active-bg);
  color: var(--bs-table-active-color);
}

.table-hover > tbody > tr:hover {
  --bs-table-accent-bg: var(--bs-table-hover-bg);
  color: var(--bs-table-hover-color);
}

.table-primary {
  --bs-table-bg: rgb(220.8, 222.4, 247.2);
  --bs-table-striped-bg: rgb(209.76, 211.28, 234.84);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(198.72, 200.16, 222.48);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(204.24, 205.72, 228.66);
  --bs-table-hover-color: #000;
  color: #000;
  border-color: rgb(198.72, 200.16, 222.48);
}

.table-secondary {
  --bs-table-bg: rgb(225.6, 227.4, 229);
  --bs-table-striped-bg: rgb(214.32, 216.03, 217.55);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(203.04, 204.66, 206.1);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(208.68, 210.345, 211.825);
  --bs-table-hover-color: #000;
  color: #000;
  border-color: rgb(203.04, 204.66, 206.1);
}

.table-success {
  --bs-table-bg: rgb(215.6, 243.2, 229);
  --bs-table-striped-bg: rgb(204.82, 231.04, 217.55);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(194.04, 218.88, 206.1);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(199.43, 224.96, 211.825);
  --bs-table-hover-color: #000;
  color: #000;
  border-color: rgb(194.04, 218.88, 206.1);
}

.table-info {
  --bs-table-bg: rgb(213.6, 239.4, 255);
  --bs-table-striped-bg: rgb(202.92, 227.43, 242.25);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(192.24, 215.46, 229.5);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(197.58, 221.445, 235.875);
  --bs-table-hover-color: #000;
  color: #000;
  border-color: rgb(192.24, 215.46, 229.5);
}

.table-warning {
  --bs-table-bg: rgb(253.4, 241, 211.2);
  --bs-table-striped-bg: rgb(240.73, 228.95, 200.64);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(228.06, 216.9, 190.08);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(234.395, 222.925, 195.36);
  --bs-table-hover-color: #000;
  color: #000;
  border-color: rgb(228.06, 216.9, 190.08);
}

.table-danger {
  --bs-table-bg: rgb(247.4, 211.4, 220);
  --bs-table-striped-bg: rgb(235.03, 200.83, 209);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(222.66, 190.26, 198);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(228.845, 195.545, 203.5);
  --bs-table-hover-color: #000;
  color: #000;
  border-color: rgb(222.66, 190.26, 198);
}

.table-light {
  --bs-table-bg: #eeeeee;
  --bs-table-striped-bg: rgb(226.1, 226.1, 226.1);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(214.2, 214.2, 214.2);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(220.15, 220.15, 220.15);
  --bs-table-hover-color: #000;
  color: #000;
  border-color: rgb(214.2, 214.2, 214.2);
}

.table-dark {
  --bs-table-bg: #343a40;
  --bs-table-striped-bg: rgb(62.15, 67.85, 73.55);
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: rgb(72.3, 77.7, 83.1);
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: rgb(67.225, 72.775, 78.325);
  --bs-table-hover-color: #fff;
  color: #fff;
  border-color: rgb(72.3, 77.7, 83.1);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.form-label {
  margin-bottom: 0.5rem;
}

.col-form-label {
  padding-top: calc(0.375rem + 1px);
  padding-bottom: calc(0.375rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + 1px);
  font-size: 1.1rem;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + 1px);
  padding-bottom: calc(0.25rem + 1px);
  font-size: 0.968rem;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #6c757d;
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 0.88rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  -webkit-appearance: none;
          appearance: none;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control:focus {
  color: #495057;
  background-color: #fff;
  border-color: rgb(187.8214285714, 190.9642857143, 239.6785714286);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(84, 92, 216, 0.25);
}
.form-control::-webkit-date-and-time-value {
  height: 1.5em;
}
.form-control::placeholder {
  color: #6c757d;
  opacity: 1;
}
.form-control:disabled, .form-control[readonly] {
  background-color: #e9ecef;
  opacity: 1;
}
.form-control::-webkit-file-upload-button {
  padding: 0.375rem 0.75rem;
  margin: -0.375rem -0.75rem;
  -webkit-margin-end: 0.75rem;
          margin-inline-end: 0.75rem;
  color: #495057;
  background-color: rgb(239.3, 248.9225806452, 255);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: 1px;
  border-radius: 0;
  -webkit-transition: color 0.15s, background-color 0.15s, border-color 0.15s, box-shadow 0.15s;
  transition: color 0.15s, background-color 0.15s, border-color 0.15s, box-shadow 0.15s;
}
.form-control::file-selector-button {
  padding: 0.375rem 0.75rem;
  margin: -0.375rem -0.75rem;
  -webkit-margin-end: 0.75rem;
          margin-inline-end: 0.75rem;
  color: #495057;
  background-color: rgb(239.3, 248.9225806452, 255);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: 1px;
  border-radius: 0;
  transition: color 0.15s, background-color 0.15s, border-color 0.15s, box-shadow 0.15s;
}
@media (prefers-reduced-motion: reduce) {
  .form-control::-webkit-file-upload-button {
    -webkit-transition: none;
    transition: none;
  }
  .form-control::file-selector-button {
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::-webkit-file-upload-button {
  background-color: rgb(227.335, 236.4764516129, 242.25);
}
.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: rgb(227.335, 236.4764516129, 242.25);
}
.form-control::-webkit-file-upload-button {
  padding: 0.375rem 0.75rem;
  margin: -0.375rem -0.75rem;
  -webkit-margin-end: 0.75rem;
          margin-inline-end: 0.75rem;
  color: #495057;
  background-color: rgb(239.3, 248.9225806452, 255);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: 1px;
  border-radius: 0;
  -webkit-transition: color 0.15s, background-color 0.15s, border-color 0.15s, box-shadow 0.15s;
  transition: color 0.15s, background-color 0.15s, border-color 0.15s, box-shadow 0.15s;
}
@media (prefers-reduced-motion: reduce) {
  .form-control::-webkit-file-upload-button {
    -webkit-transition: none;
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::-webkit-file-upload-button {
  background-color: rgb(227.335, 236.4764516129, 242.25);
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.375rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: #495057;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.5em + (0.5rem + 2px));
  padding: 0.25rem 0.5rem;
  font-size: 0.968rem;
  border-radius: 0.2rem;
}
.form-control-sm::-webkit-file-upload-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  -webkit-margin-end: 0.5rem;
          margin-inline-end: 0.5rem;
}
.form-control-sm::file-selector-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  -webkit-margin-end: 0.5rem;
          margin-inline-end: 0.5rem;
}
.form-control-sm::-webkit-file-upload-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  -webkit-margin-end: 0.5rem;
          margin-inline-end: 0.5rem;
}

.form-control-lg {
  min-height: calc(1.5em + (1rem + 2px));
  padding: 0.5rem 1rem;
  font-size: 1.1rem;
  border-radius: 0.3rem;
}
.form-control-lg::-webkit-file-upload-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  -webkit-margin-end: 1rem;
          margin-inline-end: 1rem;
}
.form-control-lg::file-selector-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  -webkit-margin-end: 1rem;
          margin-inline-end: 1rem;
}
.form-control-lg::-webkit-file-upload-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  -webkit-margin-end: 1rem;
          margin-inline-end: 1rem;
}

textarea.form-control {
  min-height: calc(1.5em + (0.75rem + 2px));
}
textarea.form-control-sm {
  min-height: calc(1.5em + (0.5rem + 2px));
}
textarea.form-control-lg {
  min-height: calc(1.5em + (1rem + 2px));
}

.form-control-color {
  max-width: 3rem;
  height: auto;
  padding: 0.375rem;
}
.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control-color::-moz-color-swatch {
  height: 1.5em;
  border-radius: 0.25rem;
}
.form-control-color::-webkit-color-swatch {
  height: 1.5em;
  border-radius: 0.25rem;
}

.form-select {
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  -moz-padding-start: calc(0.75rem - 3px);
  font-size: 0.88rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  -webkit-appearance: none;
          appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}
.form-select:focus {
  border-color: rgb(187.8214285714, 190.9642857143, 239.6785714286);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(84, 92, 216, 0.25);
}
.form-select[multiple], .form-select[size]:not([size="1"]) {
  padding-right: 0.75rem;
  background-image: none;
}
.form-select:disabled {
  background-color: #e9ecef;
}
.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #495057;
}

.form-select-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.968rem;
}

.form-select-lg {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.1rem;
}

.form-check {
  display: block;
  min-height: 1.32rem;
  padding-left: 1.5em;
  margin-bottom: 0.125rem;
}
.form-check .form-check-input {
  float: left;
  margin-left: -1.5em;
}

.form-check-input {
  width: 1em;
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  background-color: #fff;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid rgba(0, 0, 0, 0.25);
  -webkit-appearance: none;
          appearance: none;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}
.form-check-input[type=checkbox] {
  border-radius: 0.25em;
}
.form-check-input[type=radio] {
  border-radius: 50%;
}
.form-check-input:active {
  filter: brightness(90%);
}
.form-check-input:focus {
  border-color: rgb(187.8214285714, 190.9642857143, 239.6785714286);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(84, 92, 216, 0.25);
}
.form-check-input:checked {
  background-color: #545cd8;
  border-color: #545cd8;
}
.form-check-input:checked[type=checkbox] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.form-check-input:checked[type=radio] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.form-check-input[type=checkbox]:indeterminate {
  background-color: #545cd8;
  border-color: #545cd8;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  opacity: 0.5;
}

.form-switch {
  padding-left: 2.5em;
}
.form-switch .form-check-input {
  width: 2em;
  margin-left: -2.5em;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}
.form-switch .form-check-input:focus {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.form-switch .form-check-input:checked {
  background-position: right center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.btn-check[disabled] + .btn, .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

.form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  background-color: transparent;
  -webkit-appearance: none;
          appearance: none;
}
.form-range:focus {
  outline: 0;
}
.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(84, 92, 216, 0.25);
}
.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(84, 92, 216, 0.25);
}
.form-range::-moz-focus-outer {
  border: 0;
}
.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  background-color: #545cd8;
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  -webkit-appearance: none;
          appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.form-range::-webkit-slider-thumb:active {
  background-color: rgb(203.7, 206.1, 243.3);
}
.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  border-color: transparent;
  border-radius: 1rem;
}
.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  background-color: #545cd8;
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.form-range::-moz-range-thumb:active {
  background-color: rgb(203.7, 206.1, 243.3);
}
.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  border-color: transparent;
  border-radius: 1rem;
}
.form-range:disabled {
  pointer-events: none;
}
.form-range:disabled::-webkit-slider-thumb {
  background-color: #adb5bd;
}
.form-range:disabled::-moz-range-thumb {
  background-color: #adb5bd;
}

.form-floating {
  position: relative;
}
.form-floating > .form-control,
.form-floating > .form-select {
  height: calc(3.5rem + 2px);
  line-height: 1.25;
}
.form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  padding: 1rem 0.75rem;
  pointer-events: none;
  border: 1px solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}
.form-floating > .form-control {
  padding: 1rem 0.75rem;
}
.form-floating > .form-control::placeholder {
  color: transparent;
}
.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-select ~ label {
  opacity: 0.65;
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control:-webkit-autofill ~ label {
  opacity: 0.65;
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-select {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus {
  z-index: 3;
}
.input-group .btn {
  position: relative;
  z-index: 2;
}
.input-group .btn:focus {
  z-index: 3;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  font-size: 0.88rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: rgb(239.3, 248.9225806452, 255);
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.1rem;
  border-radius: 0.3rem;
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.968rem;
  border-radius: 0.2rem;
}

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 3rem;
}

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: -1px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #3ac47d;
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.968rem;
  color: #000;
  background-color: rgba(58, 196, 125, 0.9);
  border-radius: 0.25rem;
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: #3ac47d;
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: #3ac47d;
  box-shadow: 0 0 0 0.25rem rgba(58, 196, 125, 0.25);
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: #3ac47d;
}
.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  padding-right: 4.125rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}), url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-select:valid:focus, .form-select.is-valid:focus {
  border-color: #3ac47d;
  box-shadow: 0 0 0 0.25rem rgba(58, 196, 125, 0.25);
}

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: #3ac47d;
}
.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
  background-color: #3ac47d;
}
.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.25rem rgba(58, 196, 125, 0.25);
}
.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: #3ac47d;
}

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group .form-control:valid, .input-group .form-control.is-valid,
.was-validated .input-group .form-select:valid,
.input-group .form-select.is-valid {
  z-index: 1;
}
.was-validated .input-group .form-control:valid:focus, .input-group .form-control.is-valid:focus,
.was-validated .input-group .form-select:valid:focus,
.input-group .form-select.is-valid:focus {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #d92550;
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.968rem;
  color: #fff;
  background-color: rgba(217, 37, 80, 0.9);
  border-radius: 0.25rem;
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: #d92550;
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: #d92550;
  box-shadow: 0 0 0 0.25rem rgba(217, 37, 80, 0.25);
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: #d92550;
}
.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  padding-right: 4.125rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}), url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
  border-color: #d92550;
  box-shadow: 0 0 0 0.25rem rgba(217, 37, 80, 0.25);
}

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: #d92550;
}
.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
  background-color: #d92550;
}
.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.25rem rgba(217, 37, 80, 0.25);
}
.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: #d92550;
}

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group .form-control:invalid, .input-group .form-control.is-invalid,
.was-validated .input-group .form-select:invalid,
.input-group .form-select.is-invalid {
  z-index: 2;
}
.was-validated .input-group .form-control:invalid:focus, .input-group .form-control.is-invalid:focus,
.was-validated .input-group .form-select:invalid:focus,
.input-group .form-select.is-invalid:focus {
  z-index: 3;
}

.btn {
  display: inline-block;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 0.88rem;
  border-radius: 0.25rem;
  transition: color 0.15s, background-color 0.15s, border-color 0.15s, box-shadow 0.15s;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: #495057;
}
.btn-check:focus + .btn, .btn:focus {
  outline: 0;
  box-shadow: none;
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  pointer-events: none;
  opacity: 0.65;
}

.btn-primary {
  color: #fff;
  background-color: #545cd8;
  border-color: #545cd8;
}
.btn-primary:hover {
  color: #fff;
  background-color: rgb(71.4, 78.2, 183.6);
  border-color: rgb(67.2, 73.6, 172.8);
}
.btn-check:focus + .btn-primary, .btn-primary:focus {
  color: #fff;
  background-color: rgb(71.4, 78.2, 183.6);
  border-color: rgb(67.2, 73.6, 172.8);
  box-shadow: 0 0 0 0 rgba(109.65, 116.45, 221.85, 0.5);
}
.btn-check:checked + .btn-primary, .btn-check:active + .btn-primary, .btn-primary:active, .btn-primary.active, .show > .btn-primary.dropdown-toggle {
  color: #fff;
  background-color: rgb(67.2, 73.6, 172.8);
  border-color: #3f45a2;
}
.btn-check:checked + .btn-primary:focus, .btn-check:active + .btn-primary:focus, .btn-primary:active:focus, .btn-primary.active:focus, .show > .btn-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(109.65, 116.45, 221.85, 0.5);
}
.btn-primary:disabled, .btn-primary.disabled {
  color: #fff;
  background-color: #545cd8;
  border-color: #545cd8;
}

.btn-secondary {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.btn-secondary:hover {
  color: #fff;
  background-color: rgb(91.8, 99.45, 106.25);
  border-color: rgb(86.4, 93.6, 100);
}
.btn-check:focus + .btn-secondary, .btn-secondary:focus {
  color: #fff;
  background-color: rgb(91.8, 99.45, 106.25);
  border-color: rgb(86.4, 93.6, 100);
  box-shadow: 0 0 0 0 rgba(130.05, 137.7, 144.5, 0.5);
}
.btn-check:checked + .btn-secondary, .btn-check:active + .btn-secondary, .btn-secondary:active, .btn-secondary.active, .show > .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: rgb(86.4, 93.6, 100);
  border-color: rgb(81, 87.75, 93.75);
}
.btn-check:checked + .btn-secondary:focus, .btn-check:active + .btn-secondary:focus, .btn-secondary:active:focus, .btn-secondary.active:focus, .show > .btn-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(130.05, 137.7, 144.5, 0.5);
}
.btn-secondary:disabled, .btn-secondary.disabled {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}

.btn-success {
  color: #000;
  background-color: #3ac47d;
  border-color: #3ac47d;
}
.btn-success:hover {
  color: #000;
  background-color: rgb(87.55, 204.85, 144.5);
  border-color: rgb(77.7, 201.9, 138);
}
.btn-check:focus + .btn-success, .btn-success:focus {
  color: #000;
  background-color: rgb(87.55, 204.85, 144.5);
  border-color: rgb(77.7, 201.9, 138);
  box-shadow: 0 0 0 0 rgba(49.3, 166.6, 106.25, 0.5);
}
.btn-check:checked + .btn-success, .btn-check:active + .btn-success, .btn-success:active, .btn-success.active, .show > .btn-success.dropdown-toggle {
  color: #000;
  background-color: rgb(97.4, 207.8, 151);
  border-color: rgb(77.7, 201.9, 138);
}
.btn-check:checked + .btn-success:focus, .btn-check:active + .btn-success:focus, .btn-success:active:focus, .btn-success.active:focus, .show > .btn-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(49.3, 166.6, 106.25, 0.5);
}
.btn-success:disabled, .btn-success.disabled {
  color: #000;
  background-color: #3ac47d;
  border-color: #3ac47d;
}

.btn-info {
  color: #000;
  background-color: #30b1ff;
  border-color: #30b1ff;
}
.btn-info:hover {
  color: #000;
  background-color: rgb(79.05, 188.7, 255);
  border-color: rgb(68.7, 184.8, 255);
}
.btn-check:focus + .btn-info, .btn-info:focus {
  color: #000;
  background-color: rgb(79.05, 188.7, 255);
  border-color: rgb(68.7, 184.8, 255);
  box-shadow: 0 0 0 0 rgba(40.8, 150.45, 216.75, 0.5);
}
.btn-check:checked + .btn-info, .btn-check:active + .btn-info, .btn-info:active, .btn-info.active, .show > .btn-info.dropdown-toggle {
  color: #000;
  background-color: rgb(89.4, 192.6, 255);
  border-color: rgb(68.7, 184.8, 255);
}
.btn-check:checked + .btn-info:focus, .btn-check:active + .btn-info:focus, .btn-info:active:focus, .btn-info.active:focus, .show > .btn-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(40.8, 150.45, 216.75, 0.5);
}
.btn-info:disabled, .btn-info.disabled {
  color: #000;
  background-color: #30b1ff;
  border-color: #30b1ff;
}

.btn-warning {
  color: #000;
  background-color: #f7b924;
  border-color: #f7b924;
}
.btn-warning:hover {
  color: #000;
  background-color: rgb(248.2, 195.5, 68.85);
  border-color: rgb(247.8, 192, 57.9);
}
.btn-check:focus + .btn-warning, .btn-warning:focus {
  color: #000;
  background-color: rgb(248.2, 195.5, 68.85);
  border-color: rgb(247.8, 192, 57.9);
  box-shadow: 0 0 0 0 rgba(209.95, 157.25, 30.6, 0.5);
}
.btn-check:checked + .btn-warning, .btn-check:active + .btn-warning, .btn-warning:active, .btn-warning.active, .show > .btn-warning.dropdown-toggle {
  color: #000;
  background-color: rgb(248.6, 199, 79.8);
  border-color: rgb(247.8, 192, 57.9);
}
.btn-check:checked + .btn-warning:focus, .btn-check:active + .btn-warning:focus, .btn-warning:active:focus, .btn-warning.active:focus, .show > .btn-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(209.95, 157.25, 30.6, 0.5);
}
.btn-warning:disabled, .btn-warning.disabled {
  color: #000;
  background-color: #f7b924;
  border-color: #f7b924;
}

.btn-danger {
  color: #fff;
  background-color: #d92550;
  border-color: #d92550;
}
.btn-danger:hover {
  color: #fff;
  background-color: rgb(184.45, 31.45, 68);
  border-color: rgb(173.6, 29.6, 64);
}
.btn-check:focus + .btn-danger, .btn-danger:focus {
  color: #fff;
  background-color: rgb(184.45, 31.45, 68);
  border-color: rgb(173.6, 29.6, 64);
  box-shadow: 0 0 0 0 rgba(222.7, 69.7, 106.25, 0.5);
}
.btn-check:checked + .btn-danger, .btn-check:active + .btn-danger, .btn-danger:active, .btn-danger.active, .show > .btn-danger.dropdown-toggle {
  color: #fff;
  background-color: rgb(173.6, 29.6, 64);
  border-color: rgb(162.75, 27.75, 60);
}
.btn-check:checked + .btn-danger:focus, .btn-check:active + .btn-danger:focus, .btn-danger:active:focus, .btn-danger.active:focus, .show > .btn-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(222.7, 69.7, 106.25, 0.5);
}
.btn-danger:disabled, .btn-danger.disabled {
  color: #fff;
  background-color: #d92550;
  border-color: #d92550;
}

.btn-light {
  color: #000;
  background-color: #eeeeee;
  border-color: #eeeeee;
}
.btn-light:hover {
  color: #000;
  background-color: rgb(240.55, 240.55, 240.55);
  border-color: rgb(239.7, 239.7, 239.7);
}
.btn-check:focus + .btn-light, .btn-light:focus {
  color: #000;
  background-color: rgb(240.55, 240.55, 240.55);
  border-color: rgb(239.7, 239.7, 239.7);
  box-shadow: 0 0 0 0 rgba(202.3, 202.3, 202.3, 0.5);
}
.btn-check:checked + .btn-light, .btn-check:active + .btn-light, .btn-light:active, .btn-light.active, .show > .btn-light.dropdown-toggle {
  color: #000;
  background-color: rgb(241.4, 241.4, 241.4);
  border-color: rgb(239.7, 239.7, 239.7);
}
.btn-check:checked + .btn-light:focus, .btn-check:active + .btn-light:focus, .btn-light:active:focus, .btn-light.active:focus, .show > .btn-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(202.3, 202.3, 202.3, 0.5);
}
.btn-light:disabled, .btn-light.disabled {
  color: #000;
  background-color: #eeeeee;
  border-color: #eeeeee;
}

.btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-dark:hover {
  color: #fff;
  background-color: rgb(44.2, 49.3, 54.4);
  border-color: rgb(41.6, 46.4, 51.2);
}
.btn-check:focus + .btn-dark, .btn-dark:focus {
  color: #fff;
  background-color: rgb(44.2, 49.3, 54.4);
  border-color: rgb(41.6, 46.4, 51.2);
  box-shadow: 0 0 0 0 rgba(82.45, 87.55, 92.65, 0.5);
}
.btn-check:checked + .btn-dark, .btn-check:active + .btn-dark, .btn-dark:active, .btn-dark.active, .show > .btn-dark.dropdown-toggle {
  color: #fff;
  background-color: rgb(41.6, 46.4, 51.2);
  border-color: rgb(39, 43.5, 48);
}
.btn-check:checked + .btn-dark:focus, .btn-check:active + .btn-dark:focus, .btn-dark:active:focus, .btn-dark.active:focus, .show > .btn-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(82.45, 87.55, 92.65, 0.5);
}
.btn-dark:disabled, .btn-dark.disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}

.btn-focus {
  color: #fff;
  background-color: #444054;
  border-color: #444054;
}
.btn-focus:hover {
  color: #fff;
  background-color: rgb(57.8, 54.4, 71.4);
  border-color: rgb(54.4, 51.2, 67.2);
}
.btn-check:focus + .btn-focus, .btn-focus:focus {
  color: #fff;
  background-color: rgb(57.8, 54.4, 71.4);
  border-color: rgb(54.4, 51.2, 67.2);
  box-shadow: 0 0 0 0 rgba(96.05, 92.65, 109.65, 0.5);
}
.btn-check:checked + .btn-focus, .btn-check:active + .btn-focus, .btn-focus:active, .btn-focus.active, .show > .btn-focus.dropdown-toggle {
  color: #fff;
  background-color: rgb(54.4, 51.2, 67.2);
  border-color: #33303f;
}
.btn-check:checked + .btn-focus:focus, .btn-check:active + .btn-focus:focus, .btn-focus:active:focus, .btn-focus.active:focus, .show > .btn-focus.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(96.05, 92.65, 109.65, 0.5);
}
.btn-focus:disabled, .btn-focus.disabled {
  color: #fff;
  background-color: #444054;
  border-color: #444054;
}

.btn-alternate {
  color: #fff;
  background-color: #83588a;
  border-color: #83588a;
}
.btn-alternate:hover {
  color: #fff;
  background-color: rgb(111.35, 74.8, 117.3);
  border-color: rgb(104.8, 70.4, 110.4);
}
.btn-check:focus + .btn-alternate, .btn-alternate:focus {
  color: #fff;
  background-color: rgb(111.35, 74.8, 117.3);
  border-color: rgb(104.8, 70.4, 110.4);
  box-shadow: 0 0 0 0 rgba(149.6, 113.05, 155.55, 0.5);
}
.btn-check:checked + .btn-alternate, .btn-check:active + .btn-alternate, .btn-alternate:active, .btn-alternate.active, .show > .btn-alternate.dropdown-toggle {
  color: #fff;
  background-color: rgb(104.8, 70.4, 110.4);
  border-color: rgb(98.25, 66, 103.5);
}
.btn-check:checked + .btn-alternate:focus, .btn-check:active + .btn-alternate:focus, .btn-alternate:active:focus, .btn-alternate.active:focus, .show > .btn-alternate.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(149.6, 113.05, 155.55, 0.5);
}
.btn-alternate:disabled, .btn-alternate.disabled {
  color: #fff;
  background-color: #83588a;
  border-color: #83588a;
}

.btn-outline-primary {
  color: #545cd8;
  border-color: #545cd8;
}
.btn-outline-primary:hover {
  color: #fff;
  background-color: #545cd8;
  border-color: #545cd8;
}
.btn-check:focus + .btn-outline-primary, .btn-outline-primary:focus {
  box-shadow: 0 0 0 0 rgba(84, 92, 216, 0.5);
}
.btn-check:checked + .btn-outline-primary, .btn-check:active + .btn-outline-primary, .btn-outline-primary:active, .btn-outline-primary.active, .btn-outline-primary.dropdown-toggle.show {
  color: #fff;
  background-color: #545cd8;
  border-color: #545cd8;
}
.btn-check:checked + .btn-outline-primary:focus, .btn-check:active + .btn-outline-primary:focus, .btn-outline-primary:active:focus, .btn-outline-primary.active:focus, .btn-outline-primary.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(84, 92, 216, 0.5);
}
.btn-outline-primary:disabled, .btn-outline-primary.disabled {
  color: #545cd8;
  background-color: transparent;
}

.btn-outline-secondary {
  color: #6c757d;
  border-color: #6c757d;
}
.btn-outline-secondary:hover {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.btn-check:focus + .btn-outline-secondary, .btn-outline-secondary:focus {
  box-shadow: 0 0 0 0 rgba(108, 117, 125, 0.5);
}
.btn-check:checked + .btn-outline-secondary, .btn-check:active + .btn-outline-secondary, .btn-outline-secondary:active, .btn-outline-secondary.active, .btn-outline-secondary.dropdown-toggle.show {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.btn-check:checked + .btn-outline-secondary:focus, .btn-check:active + .btn-outline-secondary:focus, .btn-outline-secondary:active:focus, .btn-outline-secondary.active:focus, .btn-outline-secondary.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(108, 117, 125, 0.5);
}
.btn-outline-secondary:disabled, .btn-outline-secondary.disabled {
  color: #6c757d;
  background-color: transparent;
}

.btn-outline-success {
  color: #3ac47d;
  border-color: #3ac47d;
}
.btn-outline-success:hover {
  color: #000;
  background-color: #3ac47d;
  border-color: #3ac47d;
}
.btn-check:focus + .btn-outline-success, .btn-outline-success:focus {
  box-shadow: 0 0 0 0 rgba(58, 196, 125, 0.5);
}
.btn-check:checked + .btn-outline-success, .btn-check:active + .btn-outline-success, .btn-outline-success:active, .btn-outline-success.active, .btn-outline-success.dropdown-toggle.show {
  color: #000;
  background-color: #3ac47d;
  border-color: #3ac47d;
}
.btn-check:checked + .btn-outline-success:focus, .btn-check:active + .btn-outline-success:focus, .btn-outline-success:active:focus, .btn-outline-success.active:focus, .btn-outline-success.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(58, 196, 125, 0.5);
}
.btn-outline-success:disabled, .btn-outline-success.disabled {
  color: #3ac47d;
  background-color: transparent;
}

.btn-outline-info {
  color: #30b1ff;
  border-color: #30b1ff;
}
.btn-outline-info:hover {
  color: #000;
  background-color: #30b1ff;
  border-color: #30b1ff;
}
.btn-check:focus + .btn-outline-info, .btn-outline-info:focus {
  box-shadow: 0 0 0 0 rgba(48, 177, 255, 0.5);
}
.btn-check:checked + .btn-outline-info, .btn-check:active + .btn-outline-info, .btn-outline-info:active, .btn-outline-info.active, .btn-outline-info.dropdown-toggle.show {
  color: #000;
  background-color: #30b1ff;
  border-color: #30b1ff;
}
.btn-check:checked + .btn-outline-info:focus, .btn-check:active + .btn-outline-info:focus, .btn-outline-info:active:focus, .btn-outline-info.active:focus, .btn-outline-info.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(48, 177, 255, 0.5);
}
.btn-outline-info:disabled, .btn-outline-info.disabled {
  color: #30b1ff;
  background-color: transparent;
}

.btn-outline-warning {
  color: #f7b924;
  border-color: #f7b924;
}
.btn-outline-warning:hover {
  color: #000;
  background-color: #f7b924;
  border-color: #f7b924;
}
.btn-check:focus + .btn-outline-warning, .btn-outline-warning:focus {
  box-shadow: 0 0 0 0 rgba(247, 185, 36, 0.5);
}
.btn-check:checked + .btn-outline-warning, .btn-check:active + .btn-outline-warning, .btn-outline-warning:active, .btn-outline-warning.active, .btn-outline-warning.dropdown-toggle.show {
  color: #000;
  background-color: #f7b924;
  border-color: #f7b924;
}
.btn-check:checked + .btn-outline-warning:focus, .btn-check:active + .btn-outline-warning:focus, .btn-outline-warning:active:focus, .btn-outline-warning.active:focus, .btn-outline-warning.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(247, 185, 36, 0.5);
}
.btn-outline-warning:disabled, .btn-outline-warning.disabled {
  color: #f7b924;
  background-color: transparent;
}

.btn-outline-danger {
  color: #d92550;
  border-color: #d92550;
}
.btn-outline-danger:hover {
  color: #fff;
  background-color: #d92550;
  border-color: #d92550;
}
.btn-check:focus + .btn-outline-danger, .btn-outline-danger:focus {
  box-shadow: 0 0 0 0 rgba(217, 37, 80, 0.5);
}
.btn-check:checked + .btn-outline-danger, .btn-check:active + .btn-outline-danger, .btn-outline-danger:active, .btn-outline-danger.active, .btn-outline-danger.dropdown-toggle.show {
  color: #fff;
  background-color: #d92550;
  border-color: #d92550;
}
.btn-check:checked + .btn-outline-danger:focus, .btn-check:active + .btn-outline-danger:focus, .btn-outline-danger:active:focus, .btn-outline-danger.active:focus, .btn-outline-danger.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(217, 37, 80, 0.5);
}
.btn-outline-danger:disabled, .btn-outline-danger.disabled {
  color: #d92550;
  background-color: transparent;
}

.btn-outline-light {
  color: #eeeeee;
  border-color: #eeeeee;
}
.btn-outline-light:hover {
  color: #000;
  background-color: #eeeeee;
  border-color: #eeeeee;
}
.btn-check:focus + .btn-outline-light, .btn-outline-light:focus {
  box-shadow: 0 0 0 0 rgba(238, 238, 238, 0.5);
}
.btn-check:checked + .btn-outline-light, .btn-check:active + .btn-outline-light, .btn-outline-light:active, .btn-outline-light.active, .btn-outline-light.dropdown-toggle.show {
  color: #000;
  background-color: #eeeeee;
  border-color: #eeeeee;
}
.btn-check:checked + .btn-outline-light:focus, .btn-check:active + .btn-outline-light:focus, .btn-outline-light:active:focus, .btn-outline-light.active:focus, .btn-outline-light.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(238, 238, 238, 0.5);
}
.btn-outline-light:disabled, .btn-outline-light.disabled {
  color: #eeeeee;
  background-color: transparent;
}

.btn-outline-dark {
  color: #343a40;
  border-color: #343a40;
}
.btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-check:focus + .btn-outline-dark, .btn-outline-dark:focus {
  box-shadow: 0 0 0 0 rgba(52, 58, 64, 0.5);
}
.btn-check:checked + .btn-outline-dark, .btn-check:active + .btn-outline-dark, .btn-outline-dark:active, .btn-outline-dark.active, .btn-outline-dark.dropdown-toggle.show {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-check:checked + .btn-outline-dark:focus, .btn-check:active + .btn-outline-dark:focus, .btn-outline-dark:active:focus, .btn-outline-dark.active:focus, .btn-outline-dark.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(52, 58, 64, 0.5);
}
.btn-outline-dark:disabled, .btn-outline-dark.disabled {
  color: #343a40;
  background-color: transparent;
}

.btn-outline-focus {
  color: #444054;
  border-color: #444054;
}
.btn-outline-focus:hover {
  color: #fff;
  background-color: #444054;
  border-color: #444054;
}
.btn-check:focus + .btn-outline-focus, .btn-outline-focus:focus {
  box-shadow: 0 0 0 0 rgba(68, 64, 84, 0.5);
}
.btn-check:checked + .btn-outline-focus, .btn-check:active + .btn-outline-focus, .btn-outline-focus:active, .btn-outline-focus.active, .btn-outline-focus.dropdown-toggle.show {
  color: #fff;
  background-color: #444054;
  border-color: #444054;
}
.btn-check:checked + .btn-outline-focus:focus, .btn-check:active + .btn-outline-focus:focus, .btn-outline-focus:active:focus, .btn-outline-focus.active:focus, .btn-outline-focus.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(68, 64, 84, 0.5);
}
.btn-outline-focus:disabled, .btn-outline-focus.disabled {
  color: #444054;
  background-color: transparent;
}

.btn-outline-alternate {
  color: #83588a;
  border-color: #83588a;
}
.btn-outline-alternate:hover {
  color: #fff;
  background-color: #83588a;
  border-color: #83588a;
}
.btn-check:focus + .btn-outline-alternate, .btn-outline-alternate:focus {
  box-shadow: 0 0 0 0 rgba(131, 88, 138, 0.5);
}
.btn-check:checked + .btn-outline-alternate, .btn-check:active + .btn-outline-alternate, .btn-outline-alternate:active, .btn-outline-alternate.active, .btn-outline-alternate.dropdown-toggle.show {
  color: #fff;
  background-color: #83588a;
  border-color: #83588a;
}
.btn-check:checked + .btn-outline-alternate:focus, .btn-check:active + .btn-outline-alternate:focus, .btn-outline-alternate:active:focus, .btn-outline-alternate.active:focus, .btn-outline-alternate.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(131, 88, 138, 0.5);
}
.btn-outline-alternate:disabled, .btn-outline-alternate.disabled {
  color: #83588a;
  background-color: transparent;
}

.btn-link {
  font-weight: 400;
  color: #545cd8;
  text-decoration: underline;
}
.btn-link:hover {
  color: rgb(67.2, 73.6, 172.8);
}
.btn-link:disabled, .btn-link.disabled {
  color: #6c757d;
}

.btn-lg, .btn-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.1rem;
  border-radius: 0.3rem;
}

.btn-sm, .btn-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.968rem;
  border-radius: 0.2rem;
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}

.dropup,
.dropend,
.dropdown,
.dropstart {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  position: absolute;
  z-index: 1000;
  display: none;
  min-width: 15rem;
  padding: 0.65rem 0;
  margin: 0;
  font-size: 0.88rem;
  color: #495057;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}
.dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: 0.125rem;
}

.dropdown-menu-start {
  --bs-position: start;
}
.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --bs-position: end;
}
.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start;
  }
  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-end {
    --bs-position: end;
  }
  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start;
  }
  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-end {
    --bs-position: end;
  }
  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start;
  }
  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-end {
    --bs-position: end;
  }
  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start;
  }
  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-end {
    --bs-position: end;
  }
  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bs-position: start;
  }
  .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xxl-end {
    --bs-position: end;
  }
  .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 0.125rem;
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: 0.125rem;
}
.dropend .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.dropend .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: 0.125rem;
}
.dropstart .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.dropstart .dropdown-toggle::after {
  display: none;
}
.dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.dropstart .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: 0.5rem 0;
  overflow: hidden;
  border-top: 1px solid rgba(0, 0, 0, 0.15);
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.4rem 1rem;
  clear: both;
  font-weight: 400;
  color: #212529;
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}
.dropdown-item:hover, .dropdown-item:focus {
  color: rgb(29.7, 33.3, 36.9);
  background-color: #e0f3ff;
}
.dropdown-item.active, .dropdown-item:active {
  color: #fff;
  text-decoration: none;
  background-color: #545cd8;
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: #adb5bd;
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: 0.65rem 1rem;
  margin-bottom: 0;
  font-size: 0.968rem;
  color: #6c757d;
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: 0.4rem 1rem;
  color: #212529;
}

.dropdown-menu-dark {
  color: #dee2e6;
  background-color: #343a40;
  border-color: rgba(0, 0, 0, 0.15);
}
.dropdown-menu-dark .dropdown-item {
  color: #dee2e6;
}
.dropdown-menu-dark .dropdown-item:hover, .dropdown-menu-dark .dropdown-item:focus {
  color: #fff;
  background-color: rgba(255, 255, 255, 0.15);
}
.dropdown-menu-dark .dropdown-item.active, .dropdown-menu-dark .dropdown-item:active {
  color: #fff;
  background-color: #545cd8;
}
.dropdown-menu-dark .dropdown-item.disabled, .dropdown-menu-dark .dropdown-item:disabled {
  color: #adb5bd;
}
.dropdown-menu-dark .dropdown-divider {
  border-color: rgba(0, 0, 0, 0.15);
}
.dropdown-menu-dark .dropdown-item-text {
  color: #dee2e6;
}
.dropdown-menu-dark .dropdown-header {
  color: #adb5bd;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) {
  margin-left: -1px;
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:nth-child(n+3),
.btn-group > :not(.btn-check) + .btn,
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: -1px;
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn ~ .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: 0.5rem 1rem;
  color: #545cd8;
  text-decoration: none;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}
.nav-link:hover, .nav-link:focus {
  color: rgb(67.2, 73.6, 172.8);
}
.nav-link.disabled {
  color: #6c757d;
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  border-bottom: 1px solid #dee2e6;
}
.nav-tabs .nav-link {
  margin-bottom: -1px;
  background: none;
  border: 1px solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  border-color: #e9ecef #e9ecef #dee2e6;
  isolation: isolate;
}
.nav-tabs .nav-link.disabled {
  color: #6c757d;
  background-color: transparent;
  border-color: transparent;
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #495057;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff;
}
.nav-tabs .dropdown-menu {
  margin-top: -1px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills .nav-link {
  background: none;
  border: 0;
  border-radius: 0.25rem;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
  background-color: #545cd8;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.err-select {
  border: 1px solid #d92550;
}

.navbar {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.navbar > .container, .navbar > .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .navbar > .body-tabs.body-tabs-layout.body-tabs-big,
.navbar > .container-fluid,
.navbar > .container-sm,
.navbar > .container-md,
.navbar > .container-lg,
.navbar > .container-xl,
.navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  padding-top: 0.335rem;
  padding-bottom: 0.335rem;
  margin-right: 1rem;
  font-size: 1.1rem;
  text-decoration: none;
  white-space: nowrap;
}
.navbar-nav {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link {
  padding-right: 0;
  padding-left: 0;
}
.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: 0.25rem 0.75rem;
  font-size: 1.1rem;
  line-height: 1;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  transition: box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}
.navbar-toggler:hover {
  text-decoration: none;
}
.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 0;
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: 75vh;
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
}
@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}

.navbar-light .navbar-brand {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-brand:hover, .navbar-light .navbar-brand:focus {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-nav .nav-link {
  color: rgba(0, 0, 0, 0.55);
}
.navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {
  color: rgba(0, 0, 0, 0.7);
}
.navbar-light .navbar-nav .nav-link.disabled {
  color: rgba(0, 0, 0, 0.3);
}
.navbar-light .navbar-nav .show > .nav-link,
.navbar-light .navbar-nav .nav-link.active {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-toggler {
  color: rgba(0, 0, 0, 0.55);
  border-color: rgba(0, 0, 0, 0.1);
}
.navbar-light .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}
.navbar-light .navbar-text {
  color: rgba(0, 0, 0, 0.55);
}
.navbar-light .navbar-text a,
.navbar-light .navbar-text a:hover,
.navbar-light .navbar-text a:focus {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-dark .navbar-brand {
  color: #fff;
}
.navbar-dark .navbar-brand:hover, .navbar-dark .navbar-brand:focus {
  color: #fff;
}
.navbar-dark .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.55);
}
.navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link:focus {
  color: rgba(255, 255, 255, 0.75);
}
.navbar-dark .navbar-nav .nav-link.disabled {
  color: rgba(255, 255, 255, 0.25);
}
.navbar-dark .navbar-nav .show > .nav-link,
.navbar-dark .navbar-nav .nav-link.active {
  color: #fff;
}
.navbar-dark .navbar-toggler {
  color: rgba(255, 255, 255, 0.55);
  border-color: rgba(255, 255, 255, 0.1);
}
.navbar-dark .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}
.navbar-dark .navbar-text {
  color: rgba(255, 255, 255, 0.55);
}
.navbar-dark .navbar-text a,
.navbar-dark .navbar-text a:hover,
.navbar-dark .navbar-text a:focus {
  color: #fff;
}

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(32.0357142857, 38.6071428571, 140.4642857143, 0.125);
  border-radius: 0.25rem;
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: calc(0.25rem - 1px);
  border-bottom-left-radius: calc(0.25rem - 1px);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: 1rem 1rem;
}

.card-title {
  margin-bottom: 0.5rem;
}

.card-subtitle {
  margin-top: -0.25rem;
  margin-bottom: 0;
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link:hover {
  text-decoration: none;
}
.card-link + .card-link {
  margin-left: 1rem;
}

.card-header {
  padding: 0.5rem 1rem;
  margin-bottom: 0;
  background-color: #fff;
  border-bottom: 1px solid rgba(32.0357142857, 38.6071428571, 140.4642857143, 0.125);
}
.card-header:first-child {
  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
}

.card-footer {
  padding: 0.5rem 1rem;
  background-color: #fff;
  border-top: 1px solid rgba(32.0357142857, 38.6071428571, 140.4642857143, 0.125);
}
.card-footer:last-child {
  border-radius: 0 0 calc(0.25rem - 1px) calc(0.25rem - 1px);
}

.card-header-tabs {
  margin-right: -0.5rem;
  margin-bottom: -0.5rem;
  margin-left: -0.5rem;
  border-bottom: 0;
}

.card-header-pills {
  margin-right: -0.5rem;
  margin-left: -0.5rem;
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 1rem;
  border-radius: calc(0.25rem - 1px);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: calc(0.25rem - 1px);
  border-bottom-left-radius: calc(0.25rem - 1px);
}

.card-group > .card {
  margin-bottom: 0.75rem;
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
  .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
  .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
  .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
  .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: 1rem 1.25rem;
  font-size: 0.88rem;
  color: #495057;
  text-align: left;
  background-color: #fff;
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: color 0.15s, background-color 0.15s, border-color 0.15s, box-shadow 0.15s, border-radius 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}
.accordion-button:not(.collapsed) {
  color: rgb(75.6, 82.8, 194.4);
  background-color: rgb(237.9, 238.7, 251.1);
  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.125);
}
.accordion-button:not(.collapsed)::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  transform: rotate(-180deg);
}
.accordion-button::after {
  flex-shrink: 0;
  width: 1.25rem;
  height: 1.25rem;
  margin-left: auto;
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  background-repeat: no-repeat;
  background-size: 1.25rem;
  transition: transform 0.2s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}
.accordion-button:hover {
  z-index: 2;
}
.accordion-button:focus {
  z-index: 3;
  border-color: rgb(187.8214285714, 190.9642857143, 239.6785714286);
  outline: 0;
  box-shadow: none;
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  background-color: #fff;
}
.accordion-item:first-of-type {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.accordion-item:first-of-type .accordion-button {
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}
.accordion-item:not(:first-of-type) {
  border-top: 0;
}
.accordion-item:last-of-type {
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.accordion-item:last-of-type .accordion-button.collapsed {
  border-bottom-right-radius: calc(0.25rem - 1px);
  border-bottom-left-radius: calc(0.25rem - 1px);
}
.accordion-item:last-of-type .accordion-collapse {
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}

.accordion-body {
  padding: 1rem 1.25rem;
}

.accordion-flush .accordion-collapse {
  border-width: 0;
}
.accordion-flush .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.accordion-flush .accordion-item:first-child {
  border-top: 0;
}
.accordion-flush .accordion-item:last-child {
  border-bottom: 0;
}
.accordion-flush .accordion-item .accordion-button {
  border-radius: 0;
}

.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  padding: 0 0;
  margin-bottom: 1rem;
  list-style: none;
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: 0.5rem;
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: 0.5rem;
  color: #6c757d;
  content: "/" /* rtl: var(--bs-breadcrumb-divider, "/") */;
  content: var(--bs-breadcrumb-divider, "/") /* rtl: var(--bs-breadcrumb-divider, "/") */;
}
.breadcrumb-item.active {
  color: #6c757d;
}

.pagination {
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  color: #545cd8;
  text-decoration: none;
  background-color: #fff;
  border: 1px solid #dee2e6;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: rgb(67.2, 73.6, 172.8);
  background-color: #e9ecef;
  border-color: #dee2e6;
}
.page-link:focus {
  z-index: 3;
  color: rgb(67.2, 73.6, 172.8);
  background-color: #e9ecef;
  outline: 0;
  box-shadow: none;
}

.page-item:not(:first-child) .page-link, .pagination .page-number:not(:first-child) .page-link {
  margin-left: -1px;
}
.page-item.active .page-link, .pagination .active.page-number .page-link {
  z-index: 3;
  color: #fff;
  background-color: #545cd8;
  border-color: #545cd8;
}
.page-item.disabled .page-link, .pagination .disabled.page-number .page-link {
  color: #6c757d;
  pointer-events: none;
  background-color: #fff;
  border-color: #dee2e6;
}

.page-link {
  padding: 0.375rem 0.75rem;
}

.page-item:first-child .page-link, .pagination .page-number:first-child .page-link {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.page-item:last-child .page-link, .pagination .page-number:last-child .page-link {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}

.pagination-lg .page-link {
  padding: 0.75rem 1.5rem;
  font-size: 1.1rem;
}
.pagination-lg .page-item:first-child .page-link, .pagination-lg .pagination .page-number:first-child .page-link, .pagination .pagination-lg .page-number:first-child .page-link {
  border-top-left-radius: 0.3rem;
  border-bottom-left-radius: 0.3rem;
}
.pagination-lg .page-item:last-child .page-link, .pagination-lg .pagination .page-number:last-child .page-link, .pagination .pagination-lg .page-number:last-child .page-link {
  border-top-right-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
}

.pagination-sm .page-link {
  padding: 0.25rem 0.5rem;
  font-size: 0.968rem;
}
.pagination-sm .page-item:first-child .page-link, .pagination-sm .pagination .page-number:first-child .page-link, .pagination .pagination-sm .page-number:first-child .page-link {
  border-top-left-radius: 0.2rem;
  border-bottom-left-radius: 0.2rem;
}
.pagination-sm .page-item:last-child .page-link, .pagination-sm .pagination .page-number:last-child .page-link, .pagination .pagination-sm .page-number:last-child .page-link {
  border-top-right-radius: 0.2rem;
  border-bottom-right-radius: 0.2rem;
}

.badge {
  display: inline-block;
  padding: 0.35em 0.65em;
  font-size: 0.75em;
  font-weight: 700;
  line-height: 1;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
}
.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.alert {
  position: relative;
  padding: 1rem 1rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
}

.alert-dismissible {
  padding-right: 3rem;
}
.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 1.25rem 1rem;
}

.alert-primary {
  color: rgb(50.4, 55.2, 129.6);
  background-color: rgb(220.8, 222.4, 247.2);
  border-color: rgb(203.7, 206.1, 243.3);
}
.alert-primary .alert-link {
  color: rgb(40.32, 44.16, 103.68);
}

.alert-secondary {
  color: rgb(64.8, 70.2, 75);
  background-color: rgb(225.6, 227.4, 229);
  border-color: rgb(210.9, 213.6, 216);
}
.alert-secondary .alert-link {
  color: rgb(51.84, 56.16, 60);
}

.alert-success {
  color: rgb(34.8, 117.6, 75);
  background-color: rgb(215.6, 243.2, 229);
  border-color: rgb(195.9, 237.3, 216);
}
.alert-success .alert-link {
  color: rgb(27.84, 94.08, 60);
}

.alert-info {
  color: rgb(28.8, 106.2, 153);
  background-color: rgb(213.6, 239.4, 255);
  border-color: rgb(192.9, 231.6, 255);
}
.alert-info .alert-link {
  color: rgb(23.04, 84.96, 122.4);
}

.alert-warning {
  color: rgb(98.8, 74, 14.4);
  background-color: rgb(253.4, 241, 211.2);
  border-color: rgb(252.6, 234, 189.3);
}
.alert-warning .alert-link {
  color: rgb(79.04, 59.2, 11.52);
}

.alert-danger {
  color: rgb(130.2, 22.2, 48);
  background-color: rgb(247.4, 211.4, 220);
  border-color: rgb(243.6, 189.6, 202.5);
}
.alert-danger .alert-link {
  color: rgb(104.16, 17.76, 38.4);
}

.alert-light {
  color: rgb(95.2, 95.2, 95.2);
  background-color: rgb(251.6, 251.6, 251.6);
  border-color: rgb(249.9, 249.9, 249.9);
}
.alert-light .alert-link {
  color: rgb(76.16, 76.16, 76.16);
}

.alert-dark {
  color: rgb(31.2, 34.8, 38.4);
  background-color: rgb(214.4, 215.6, 216.8);
  border-color: rgb(194.1, 195.9, 197.7);
}
.alert-dark .alert-link {
  color: rgb(24.96, 27.84, 30.72);
}

.alert-focus {
  color: rgb(40.8, 38.4, 50.4);
  background-color: rgb(217.6, 216.8, 220.8);
  border-color: rgb(198.9, 197.7, 203.7);
}
.alert-focus .alert-link {
  color: rgb(32.64, 30.72, 40.32);
}

.alert-alternate {
  color: rgb(78.6, 52.8, 82.8);
  background-color: rgb(230.2, 221.6, 231.6);
  border-color: rgb(217.8, 204.9, 219.9);
}
.alert-alternate .alert-link {
  color: rgb(62.88, 42.24, 66.24);
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: 1rem;
  }
}
.progress {
  display: flex;
  height: 1rem;
  overflow: hidden;
  font-size: 0.66rem;
  background-color: #e9ecef;
  border-radius: 0.25rem;
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  background-color: #545cd8;
  transition: width 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: 1rem 1rem;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.list-group {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: 0.25rem;
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}
.list-group-numbered > li::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item-action {
  width: 100%;
  color: #495057;
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: #495057;
  text-decoration: none;
  background-color: #f8f9fa;
}
.list-group-item-action:active {
  color: #495057;
  background-color: #e9ecef;
}

.list-group-item {
  position: relative;
  display: block;
  padding: 0.5rem 1rem;
  color: #212529;
  text-decoration: none;
  background-color: #fff;
  border: 1px solid rgba(84, 92, 216, 0.08);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: #6c757d;
  pointer-events: none;
  background-color: #fff;
}
.list-group-item.active {
  z-index: 2;
  color: #fff;
  background-color: #545cd8;
  border-color: #545cd8;
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: -1px;
  border-top-width: 1px;
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child {
  border-bottom-left-radius: 0.25rem;
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child {
  border-top-right-radius: 0.25rem;
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: 1px;
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: -1px;
  border-left-width: 1px;
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }
  .list-group-horizontal-xxl > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 1px;
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  color: rgb(50.4, 55.2, 129.6);
  background-color: rgb(220.8, 222.4, 247.2);
}
.list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {
  color: rgb(50.4, 55.2, 129.6);
  background-color: rgb(198.72, 200.16, 222.48);
}
.list-group-item-primary.list-group-item-action.active {
  color: #fff;
  background-color: rgb(50.4, 55.2, 129.6);
  border-color: rgb(50.4, 55.2, 129.6);
}

.list-group-item-secondary {
  color: rgb(64.8, 70.2, 75);
  background-color: rgb(225.6, 227.4, 229);
}
.list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {
  color: rgb(64.8, 70.2, 75);
  background-color: rgb(203.04, 204.66, 206.1);
}
.list-group-item-secondary.list-group-item-action.active {
  color: #fff;
  background-color: rgb(64.8, 70.2, 75);
  border-color: rgb(64.8, 70.2, 75);
}

.list-group-item-success {
  color: rgb(34.8, 117.6, 75);
  background-color: rgb(215.6, 243.2, 229);
}
.list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {
  color: rgb(34.8, 117.6, 75);
  background-color: rgb(194.04, 218.88, 206.1);
}
.list-group-item-success.list-group-item-action.active {
  color: #fff;
  background-color: rgb(34.8, 117.6, 75);
  border-color: rgb(34.8, 117.6, 75);
}

.list-group-item-info {
  color: rgb(28.8, 106.2, 153);
  background-color: rgb(213.6, 239.4, 255);
}
.list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {
  color: rgb(28.8, 106.2, 153);
  background-color: rgb(192.24, 215.46, 229.5);
}
.list-group-item-info.list-group-item-action.active {
  color: #fff;
  background-color: rgb(28.8, 106.2, 153);
  border-color: rgb(28.8, 106.2, 153);
}

.list-group-item-warning {
  color: rgb(98.8, 74, 14.4);
  background-color: rgb(253.4, 241, 211.2);
}
.list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {
  color: rgb(98.8, 74, 14.4);
  background-color: rgb(228.06, 216.9, 190.08);
}
.list-group-item-warning.list-group-item-action.active {
  color: #fff;
  background-color: rgb(98.8, 74, 14.4);
  border-color: rgb(98.8, 74, 14.4);
}

.list-group-item-danger {
  color: rgb(130.2, 22.2, 48);
  background-color: rgb(247.4, 211.4, 220);
}
.list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {
  color: rgb(130.2, 22.2, 48);
  background-color: rgb(222.66, 190.26, 198);
}
.list-group-item-danger.list-group-item-action.active {
  color: #fff;
  background-color: rgb(130.2, 22.2, 48);
  border-color: rgb(130.2, 22.2, 48);
}

.list-group-item-light {
  color: rgb(95.2, 95.2, 95.2);
  background-color: rgb(251.6, 251.6, 251.6);
}
.list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {
  color: rgb(95.2, 95.2, 95.2);
  background-color: rgb(226.44, 226.44, 226.44);
}
.list-group-item-light.list-group-item-action.active {
  color: #fff;
  background-color: rgb(95.2, 95.2, 95.2);
  border-color: rgb(95.2, 95.2, 95.2);
}

.list-group-item-dark {
  color: rgb(31.2, 34.8, 38.4);
  background-color: rgb(214.4, 215.6, 216.8);
}
.list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {
  color: rgb(31.2, 34.8, 38.4);
  background-color: rgb(192.96, 194.04, 195.12);
}
.list-group-item-dark.list-group-item-action.active {
  color: #fff;
  background-color: rgb(31.2, 34.8, 38.4);
  border-color: rgb(31.2, 34.8, 38.4);
}

.list-group-item-focus {
  color: rgb(40.8, 38.4, 50.4);
  background-color: rgb(217.6, 216.8, 220.8);
}
.list-group-item-focus.list-group-item-action:hover, .list-group-item-focus.list-group-item-action:focus {
  color: rgb(40.8, 38.4, 50.4);
  background-color: rgb(195.84, 195.12, 198.72);
}
.list-group-item-focus.list-group-item-action.active {
  color: #fff;
  background-color: rgb(40.8, 38.4, 50.4);
  border-color: rgb(40.8, 38.4, 50.4);
}

.list-group-item-alternate {
  color: rgb(78.6, 52.8, 82.8);
  background-color: rgb(230.2, 221.6, 231.6);
}
.list-group-item-alternate.list-group-item-action:hover, .list-group-item-alternate.list-group-item-action:focus {
  color: rgb(78.6, 52.8, 82.8);
  background-color: rgb(207.18, 199.44, 208.44);
}
.list-group-item-alternate.list-group-item-action.active {
  color: #fff;
  background-color: rgb(78.6, 52.8, 82.8);
  border-color: rgb(78.6, 52.8, 82.8);
}

.btn-close {
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: #000;
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_13___}) center/1em auto no-repeat;
  border: 0;
  border-radius: 0.25rem;
  opacity: 0.5;
}
.btn-close:hover {
  color: #000;
  text-decoration: none;
  opacity: 0.75;
}
.btn-close:focus {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(84, 92, 216, 0.25);
  opacity: 1;
}
.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  opacity: 0.25;
}

.btn-close-white {
  filter: invert(1) grayscale(100%) brightness(200%);
}

.toast {
  width: 350px;
  max-width: 100%;
  font-size: 0.875rem;
  pointer-events: auto;
  background-color: rgba(255, 255, 255, 0.85);
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}
.toast:not(.showing):not(.show) {
  opacity: 0;
}
.toast.hide {
  display: none;
}

.toast-container {
  width: -webkit-max-content;
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}
.toast-container > :not(:last-child) {
  margin-bottom: 0.75rem;
}

.toast-header {
  display: flex;
  align-items: center;
  padding: 0.5rem 0.75rem;
  color: #6c757d;
  background-color: rgba(255, 255, 255, 0.85);
  background-clip: padding-box;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}
.toast-header .btn-close {
  margin-right: -0.375rem;
  margin-left: 0.75rem;
}

.toast-body {
  padding: 0.75rem;
  word-wrap: break-word;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1060;
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: 0.5rem;
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - 1rem);
}
.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - 1rem);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
  outline: 0;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: 0.5;
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1rem;
  border-bottom: 1px solid #dee2e6;
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
}
.modal-header .btn-close {
  padding: 0.5rem 0.5rem;
  margin: -0.5rem -0.5rem -0.5rem auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: 1.5;
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 1rem;
}

.modal-footer {
  display: flex;
  flex-wrap: wrap;
  flex-shrink: 0;
  align-items: center;
  justify-content: flex-end;
  padding: 0.75rem;
  border-top: 1px solid #dee2e6;
  border-bottom-right-radius: calc(0.3rem - 1px);
  border-bottom-left-radius: calc(0.3rem - 1px);
}
.modal-footer > * {
  margin: 0.25rem;
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 500px;
    margin: 1.75rem auto;
  }
  .modal-dialog-scrollable {
    height: calc(100% - 3.5rem);
  }
  .modal-dialog-centered {
    min-height: calc(100% - 3.5rem);
  }
  .modal-sm {
    max-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    max-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    max-width: 1140px;
  }
}
.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}
.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.modal-fullscreen .modal-header {
  border-radius: 0;
}
.modal-fullscreen .modal-body {
  overflow-y: auto;
}
.modal-fullscreen .modal-footer {
  border-radius: 0;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-header {
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
}
@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-header {
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
}
@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-header {
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
}
@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-header {
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
}
@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-header {
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
}
.tooltip {
  position: absolute;
  z-index: 1080;
  display: block;
  margin: 0;
  font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.968rem;
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: 0.9;
}
.tooltip .tooltip-arrow {
  position: absolute;
  display: block;
  width: 0.8rem;
  height: 0.4rem;
}
.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top, .bs-tooltip-auto[data-popper-placement^=top] {
  padding: 0.4rem 0;
}
.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: 0;
}
.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: 0.4rem 0.4rem 0;
  border-top-color: #000;
}

.bs-tooltip-end, .bs-tooltip-auto[data-popper-placement^=right] {
  padding: 0 0.4rem;
}
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: 0;
  width: 0.4rem;
  height: 0.8rem;
}
.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: 0.4rem 0.4rem 0.4rem 0;
  border-right-color: #000;
}

.bs-tooltip-bottom, .bs-tooltip-auto[data-popper-placement^=bottom] {
  padding: 0.4rem 0;
}
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: 0;
}
.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 0.4rem 0.4rem;
  border-bottom-color: #000;
}

.bs-tooltip-start, .bs-tooltip-auto[data-popper-placement^=left] {
  padding: 0 0.4rem;
}
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: 0;
  width: 0.4rem;
  height: 0.8rem;
}
.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: 0.4rem 0 0.4rem 0.4rem;
  border-left-color: #000;
}

.tooltip-inner {
  max-width: 200px;
  padding: 0.25rem 0.5rem;
  color: #fff;
  text-align: center;
  background-color: #000;
  border-radius: 0.25rem;
}

.popover {
  position: absolute;
  top: 0;
  left: 0 /* rtl:ignore */;
  z-index: 1070;
  display: block;
  max-width: 320px;
  font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.968rem;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(32.0357142857, 38.6071428571, 140.4642857143, 0.125);
  border-radius: 0.3rem;
}
.popover .popover-arrow {
  position: absolute;
  display: block;
  width: 1rem;
  height: 0.5rem;
}
.popover .popover-arrow::before, .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-0.5rem - 1px);
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: rgba(32.0357142857, 38.6071428571, 140.4642857143, 0.175);
}
.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: 1px;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: #fff;
}

.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-0.5rem - 1px);
  width: 0.5rem;
  height: 1rem;
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: rgba(32.0357142857, 38.6071428571, 140.4642857143, 0.175);
}
.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: 1px;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: #fff;
}

.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-0.5rem - 1px);
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: rgba(32.0357142857, 38.6071428571, 140.4642857143, 0.175);
}
.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: 1px;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: #fff;
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: 1rem;
  margin-left: -0.5rem;
  content: "";
  border-bottom: 1px solid #fff;
}

.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-0.5rem - 1px);
  width: 0.5rem;
  height: 1rem;
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: rgba(32.0357142857, 38.6071428571, 140.4642857143, 0.175);
}
.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: 1px;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: #fff;
}

.popover-header {
  padding: 0.5rem 1rem;
  margin-bottom: 0;
  font-size: 0.88rem;
  background-color: #fff;
  border-bottom: 1px solid rgba(32.0357142857, 38.6071428571, 140.4642857143, 0.125);
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: 1rem 1rem;
  color: #495057;
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

/* rtl:begin:ignore */
.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%);
}

/* rtl:end:ignore */
.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-start,
  .carousel-fade .active.carousel-item-end {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

/* rtl:options: {
  "autoRename": true,
  "stringMap":[ {
    "name"    : "prev-next",
    "search"  : "prev",
    "replace" : "next"
  } ]
} */
.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
  list-style: none;
}
.carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-bs-target] {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #fff;
  text-align: center;
}

.carousel-dark .carousel-control-prev-icon,
.carousel-dark .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
.carousel-dark .carousel-indicators [data-bs-target] {
  background-color: #000;
}
.carousel-dark .carousel-caption {
  color: #000;
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: -0.125em;
  border: 0.25em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: 0.75s linear infinite spinner-border;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
  border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: -0.125em;
  background-color: currentColor;
  border-radius: 50%;
  opacity: 0;
  animation: 0.75s linear infinite spinner-grow;
}

.spinner-grow-sm {
  width: 1rem;
  height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    animation-duration: 1.5s;
  }
}
.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: 1050;
  display: flex;
  flex-direction: column;
  max-width: 100%;
  visibility: hidden;
  background-color: #fff;
  background-clip: padding-box;
  outline: 0;
  transition: transform 0.3s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}

.offcanvas-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1rem;
}
.offcanvas-header .btn-close {
  padding: 0.5rem 0.5rem;
  margin-top: -0.5rem;
  margin-right: -0.5rem;
  margin-bottom: -0.5rem;
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: 1.5;
}

.offcanvas-body {
  flex-grow: 1;
  padding: 1rem 1rem;
  overflow-y: auto;
}

.offcanvas-start {
  top: 0;
  left: 0;
  width: 400px;
  border-right: 1px solid rgba(0, 0, 0, 0.2);
  transform: translateX(-100%);
}

.offcanvas-end {
  top: 0;
  right: 0;
  width: 400px;
  border-left: 1px solid rgba(0, 0, 0, 0.2);
  transform: translateX(100%);
}

.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: 30vh;
  max-height: 100%;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  transform: translateY(-100%);
}

.offcanvas-bottom {
  right: 0;
  left: 0;
  height: 30vh;
  max-height: 100%;
  border-top: 1px solid rgba(0, 0, 0, 0.2);
  transform: translateY(100%);
}

.offcanvas.show {
  transform: none;
}

.jumbotron {
  padding: 2rem 1rem;
  margin-bottom: 2rem;
  background-color: #e9ecef;
  border-radius: 0.3rem;
}
@media (min-width: 576px) {
  .jumbotron {
    padding: 4rem 2rem;
  }
}

.jumbotron-fluid {
  padding-right: 0;
  padding-left: 0;
  border-radius: 0;
}

.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.link-primary {
  color: #545cd8;
}
.link-primary:hover, .link-primary:focus {
  color: rgb(67.2, 73.6, 172.8);
}

.link-secondary {
  color: #6c757d;
}
.link-secondary:hover, .link-secondary:focus {
  color: rgb(86.4, 93.6, 100);
}

.link-success {
  color: #3ac47d;
}
.link-success:hover, .link-success:focus {
  color: rgb(97.4, 207.8, 151);
}

.link-info {
  color: #30b1ff;
}
.link-info:hover, .link-info:focus {
  color: rgb(89.4, 192.6, 255);
}

.link-warning {
  color: #f7b924;
}
.link-warning:hover, .link-warning:focus {
  color: rgb(248.6, 199, 79.8);
}

.link-danger {
  color: #d92550;
}
.link-danger:hover, .link-danger:focus {
  color: rgb(173.6, 29.6, 64);
}

.link-light {
  color: #eeeeee;
}
.link-light:hover, .link-light:focus {
  color: rgb(241.4, 241.4, 241.4);
}

.link-dark {
  color: #343a40;
}
.link-dark:hover, .link-dark:focus {
  color: rgb(41.6, 46.4, 51.2);
}

.link-focus {
  color: #444054;
}
.link-focus:hover, .link-focus:focus {
  color: rgb(54.4, 51.2, 67.2);
}

.link-alternate {
  color: #83588a;
}
.link-alternate:hover, .link-alternate:focus {
  color: rgb(104.8, 70.4, 110.4);
}

.ratio {
  position: relative;
  width: 100%;
}
.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}
.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --bs-aspect-ratio: 100%;
}

.ratio-4x3 {
  --bs-aspect-ratio: 75%;
}

.ratio-16x9 {
  --bs-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --bs-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}
.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}

.shadow-lg {
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: -webkit-sticky !important;
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: 1px solid #dee2e6 !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: 1px solid #dee2e6 !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: 1px solid #dee2e6 !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: 1px solid #dee2e6 !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: 1px solid #dee2e6 !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-primary {
  border-color: #545cd8 !important;
}

.border-secondary {
  border-color: #6c757d !important;
}

.border-success {
  border-color: #3ac47d !important;
}

.border-info {
  border-color: #30b1ff !important;
}

.border-warning {
  border-color: #f7b924 !important;
}

.border-danger {
  border-color: #d92550 !important;
}

.border-light {
  border-color: #eeeeee !important;
}

.border-dark {
  border-color: #343a40 !important;
}

.border-focus {
  border-color: #444054 !important;
}

.border-alternate {
  border-color: #83588a !important;
}

.border-white {
  border-color: #fff !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 1rem !important;
}

.gap-4 {
  gap: 1.5rem !important;
}

.gap-5 {
  gap: 3rem !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.25rem !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.me-3 {
  margin-right: 1rem !important;
}

.me-4 {
  margin-right: 1.5rem !important;
}

.me-5 {
  margin-right: 3rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.25rem !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.ms-3 {
  margin-left: 1rem !important;
}

.ms-4 {
  margin-left: 1.5rem !important;
}

.ms-5 {
  margin-left: 3rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.25rem !important;
}

.pe-2 {
  padding-right: 0.5rem !important;
}

.pe-3 {
  padding-right: 1rem !important;
}

.pe-4 {
  padding-right: 1.5rem !important;
}

.pe-5 {
  padding-right: 3rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.25rem !important;
}

.ps-2 {
  padding-left: 0.5rem !important;
}

.ps-3 {
  padding-left: 1rem !important;
}

.ps-4 {
  padding-left: 1.5rem !important;
}

.ps-5 {
  padding-left: 3rem !important;
}

.font-monospace {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important;
  font-family: var(--bs-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.345rem + 1.14vw) !important;
}

.fs-2 {
  font-size: calc(1.301rem + 0.612vw) !important;
}

.fs-3 {
  font-size: calc(1.279rem + 0.348vw) !important;
}

.fs-4 {
  font-size: calc(1.257rem + 0.084vw) !important;
}

.fs-5 {
  font-size: 1.1rem !important;
}

.fs-6 {
  font-size: 0.88rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-bold {
  font-weight: 700 !important;
}

.fw-bolder {
  font-weight: bolder !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 2 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-primary {
  color: #545cd8 !important;
}

.text-secondary {
  color: #6c757d !important;
}

.text-success {
  color: #3ac47d !important;
}

.text-info {
  color: #30b1ff !important;
}

.text-warning {
  color: #f7b924 !important;
}

.text-danger {
  color: #d92550 !important;
}

.text-light {
  color: #eeeeee !important;
}

.text-dark {
  color: #343a40 !important;
}

.text-focus {
  color: #444054 !important;
}

.text-alternate {
  color: #83588a !important;
}

.text-white {
  color: #fff !important;
}

.text-body {
  color: #495057 !important;
}

.text-muted {
  color: #6c757d !important;
}

.text-black-50 {
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-reset {
  color: inherit !important;
}

.bg-primary {
  background-color: #545cd8 !important;
}

.bg-secondary {
  background-color: #6c757d !important;
}

.bg-success {
  background-color: #3ac47d !important;
}

.bg-info {
  background-color: #30b1ff !important;
}

.bg-warning {
  background-color: #f7b924 !important;
}

.bg-danger {
  background-color: #d92550 !important;
}

.bg-light {
  background-color: #eeeeee !important;
}

.bg-dark {
  background-color: #343a40 !important;
}

.bg-focus {
  background-color: #444054 !important;
}

.bg-alternate {
  background-color: #83588a !important;
}

.bg-body {
  background-color: #fff !important;
}

.bg-white {
  background-color: #fff !important;
}

.bg-transparent {
  background-color: transparent !important;
}

.bg-gradient {
  background-image: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0)) !important;
  background-image: var(--bs-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: 0.25rem !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: 0.2rem !important;
}

.rounded-2 {
  border-radius: 0.25rem !important;
}

.rounded-3 {
  border-radius: 0.3rem !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: 50rem !important;
}

.rounded-top {
  border-top-left-radius: 0.25rem !important;
  border-top-right-radius: 0.25rem !important;
}

.rounded-end {
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important;
}

.rounded-bottom {
  border-bottom-right-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
}

.rounded-start {
  border-bottom-left-radius: 0.25rem !important;
  border-top-left-radius: 0.25rem !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }
  .float-sm-end {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .gap-sm-0 {
    gap: 0 !important;
  }
  .gap-sm-1 {
    gap: 0.25rem !important;
  }
  .gap-sm-2 {
    gap: 0.5rem !important;
  }
  .gap-sm-3 {
    gap: 1rem !important;
  }
  .gap-sm-4 {
    gap: 1.5rem !important;
  }
  .gap-sm-5 {
    gap: 3rem !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mt-sm-3 {
    margin-top: 1rem !important;
  }
  .mt-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-5 {
    margin-top: 3rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  .me-sm-0 {
    margin-right: 0 !important;
  }
  .me-sm-1 {
    margin-right: 0.25rem !important;
  }
  .me-sm-2 {
    margin-right: 0.5rem !important;
  }
  .me-sm-3 {
    margin-right: 1rem !important;
  }
  .me-sm-4 {
    margin-right: 1.5rem !important;
  }
  .me-sm-5 {
    margin-right: 3rem !important;
  }
  .me-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 3rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .ms-sm-0 {
    margin-left: 0 !important;
  }
  .ms-sm-1 {
    margin-left: 0.25rem !important;
  }
  .ms-sm-2 {
    margin-left: 0.5rem !important;
  }
  .ms-sm-3 {
    margin-left: 1rem !important;
  }
  .ms-sm-4 {
    margin-left: 1.5rem !important;
  }
  .ms-sm-5 {
    margin-left: 3rem !important;
  }
  .ms-sm-auto {
    margin-left: auto !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pt-sm-3 {
    padding-top: 1rem !important;
  }
  .pt-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-5 {
    padding-top: 3rem !important;
  }
  .pe-sm-0 {
    padding-right: 0 !important;
  }
  .pe-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pe-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pe-sm-3 {
    padding-right: 1rem !important;
  }
  .pe-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pe-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 3rem !important;
  }
  .ps-sm-0 {
    padding-left: 0 !important;
  }
  .ps-sm-1 {
    padding-left: 0.25rem !important;
  }
  .ps-sm-2 {
    padding-left: 0.5rem !important;
  }
  .ps-sm-3 {
    padding-left: 1rem !important;
  }
  .ps-sm-4 {
    padding-left: 1.5rem !important;
  }
  .ps-sm-5 {
    padding-left: 3rem !important;
  }
  .text-sm-start {
    text-align: left !important;
  }
  .text-sm-end {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }
  .float-md-end {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .gap-md-0 {
    gap: 0 !important;
  }
  .gap-md-1 {
    gap: 0.25rem !important;
  }
  .gap-md-2 {
    gap: 0.5rem !important;
  }
  .gap-md-3 {
    gap: 1rem !important;
  }
  .gap-md-4 {
    gap: 1.5rem !important;
  }
  .gap-md-5 {
    gap: 3rem !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.25rem !important;
  }
  .mt-md-2 {
    margin-top: 0.5rem !important;
  }
  .mt-md-3 {
    margin-top: 1rem !important;
  }
  .mt-md-4 {
    margin-top: 1.5rem !important;
  }
  .mt-md-5 {
    margin-top: 3rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  .me-md-0 {
    margin-right: 0 !important;
  }
  .me-md-1 {
    margin-right: 0.25rem !important;
  }
  .me-md-2 {
    margin-right: 0.5rem !important;
  }
  .me-md-3 {
    margin-right: 1rem !important;
  }
  .me-md-4 {
    margin-right: 1.5rem !important;
  }
  .me-md-5 {
    margin-right: 3rem !important;
  }
  .me-md-auto {
    margin-right: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-md-3 {
    margin-bottom: 1rem !important;
  }
  .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-5 {
    margin-bottom: 3rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  .ms-md-0 {
    margin-left: 0 !important;
  }
  .ms-md-1 {
    margin-left: 0.25rem !important;
  }
  .ms-md-2 {
    margin-left: 0.5rem !important;
  }
  .ms-md-3 {
    margin-left: 1rem !important;
  }
  .ms-md-4 {
    margin-left: 1.5rem !important;
  }
  .ms-md-5 {
    margin-left: 3rem !important;
  }
  .ms-md-auto {
    margin-left: auto !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.25rem !important;
  }
  .pt-md-2 {
    padding-top: 0.5rem !important;
  }
  .pt-md-3 {
    padding-top: 1rem !important;
  }
  .pt-md-4 {
    padding-top: 1.5rem !important;
  }
  .pt-md-5 {
    padding-top: 3rem !important;
  }
  .pe-md-0 {
    padding-right: 0 !important;
  }
  .pe-md-1 {
    padding-right: 0.25rem !important;
  }
  .pe-md-2 {
    padding-right: 0.5rem !important;
  }
  .pe-md-3 {
    padding-right: 1rem !important;
  }
  .pe-md-4 {
    padding-right: 1.5rem !important;
  }
  .pe-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-md-3 {
    padding-bottom: 1rem !important;
  }
  .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-5 {
    padding-bottom: 3rem !important;
  }
  .ps-md-0 {
    padding-left: 0 !important;
  }
  .ps-md-1 {
    padding-left: 0.25rem !important;
  }
  .ps-md-2 {
    padding-left: 0.5rem !important;
  }
  .ps-md-3 {
    padding-left: 1rem !important;
  }
  .ps-md-4 {
    padding-left: 1.5rem !important;
  }
  .ps-md-5 {
    padding-left: 3rem !important;
  }
  .text-md-start {
    text-align: left !important;
  }
  .text-md-end {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }
  .float-lg-end {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .gap-lg-0 {
    gap: 0 !important;
  }
  .gap-lg-1 {
    gap: 0.25rem !important;
  }
  .gap-lg-2 {
    gap: 0.5rem !important;
  }
  .gap-lg-3 {
    gap: 1rem !important;
  }
  .gap-lg-4 {
    gap: 1.5rem !important;
  }
  .gap-lg-5 {
    gap: 3rem !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mt-lg-3 {
    margin-top: 1rem !important;
  }
  .mt-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-5 {
    margin-top: 3rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  .me-lg-0 {
    margin-right: 0 !important;
  }
  .me-lg-1 {
    margin-right: 0.25rem !important;
  }
  .me-lg-2 {
    margin-right: 0.5rem !important;
  }
  .me-lg-3 {
    margin-right: 1rem !important;
  }
  .me-lg-4 {
    margin-right: 1.5rem !important;
  }
  .me-lg-5 {
    margin-right: 3rem !important;
  }
  .me-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 3rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .ms-lg-0 {
    margin-left: 0 !important;
  }
  .ms-lg-1 {
    margin-left: 0.25rem !important;
  }
  .ms-lg-2 {
    margin-left: 0.5rem !important;
  }
  .ms-lg-3 {
    margin-left: 1rem !important;
  }
  .ms-lg-4 {
    margin-left: 1.5rem !important;
  }
  .ms-lg-5 {
    margin-left: 3rem !important;
  }
  .ms-lg-auto {
    margin-left: auto !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pt-lg-3 {
    padding-top: 1rem !important;
  }
  .pt-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-5 {
    padding-top: 3rem !important;
  }
  .pe-lg-0 {
    padding-right: 0 !important;
  }
  .pe-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pe-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pe-lg-3 {
    padding-right: 1rem !important;
  }
  .pe-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pe-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 3rem !important;
  }
  .ps-lg-0 {
    padding-left: 0 !important;
  }
  .ps-lg-1 {
    padding-left: 0.25rem !important;
  }
  .ps-lg-2 {
    padding-left: 0.5rem !important;
  }
  .ps-lg-3 {
    padding-left: 1rem !important;
  }
  .ps-lg-4 {
    padding-left: 1.5rem !important;
  }
  .ps-lg-5 {
    padding-left: 3rem !important;
  }
  .text-lg-start {
    text-align: left !important;
  }
  .text-lg-end {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }
  .float-xl-end {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .gap-xl-0 {
    gap: 0 !important;
  }
  .gap-xl-1 {
    gap: 0.25rem !important;
  }
  .gap-xl-2 {
    gap: 0.5rem !important;
  }
  .gap-xl-3 {
    gap: 1rem !important;
  }
  .gap-xl-4 {
    gap: 1.5rem !important;
  }
  .gap-xl-5 {
    gap: 3rem !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xl-3 {
    margin-top: 1rem !important;
  }
  .mt-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-5 {
    margin-top: 3rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  .me-xl-0 {
    margin-right: 0 !important;
  }
  .me-xl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xl-3 {
    margin-right: 1rem !important;
  }
  .me-xl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xl-5 {
    margin-right: 3rem !important;
  }
  .me-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .ms-xl-0 {
    margin-left: 0 !important;
  }
  .ms-xl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xl-3 {
    margin-left: 1rem !important;
  }
  .ms-xl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xl-5 {
    margin-left: 3rem !important;
  }
  .ms-xl-auto {
    margin-left: auto !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xl-3 {
    padding-top: 1rem !important;
  }
  .pt-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-5 {
    padding-top: 3rem !important;
  }
  .pe-xl-0 {
    padding-right: 0 !important;
  }
  .pe-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xl-3 {
    padding-right: 1rem !important;
  }
  .pe-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xl-0 {
    padding-left: 0 !important;
  }
  .ps-xl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xl-3 {
    padding-left: 1rem !important;
  }
  .ps-xl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xl-5 {
    padding-left: 3rem !important;
  }
  .text-xl-start {
    text-align: left !important;
  }
  .text-xl-end {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important;
  }
  .float-xxl-end {
    float: right !important;
  }
  .float-xxl-none {
    float: none !important;
  }
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .gap-xxl-0 {
    gap: 0 !important;
  }
  .gap-xxl-1 {
    gap: 0.25rem !important;
  }
  .gap-xxl-2 {
    gap: 0.5rem !important;
  }
  .gap-xxl-3 {
    gap: 1rem !important;
  }
  .gap-xxl-4 {
    gap: 1.5rem !important;
  }
  .gap-xxl-5 {
    gap: 3rem !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.25rem !important;
  }
  .m-xxl-2 {
    margin: 0.5rem !important;
  }
  .m-xxl-3 {
    margin: 1rem !important;
  }
  .m-xxl-4 {
    margin: 1.5rem !important;
  }
  .m-xxl-5 {
    margin: 3rem !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xxl-3 {
    margin-top: 1rem !important;
  }
  .mt-xxl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xxl-5 {
    margin-top: 3rem !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  .me-xxl-0 {
    margin-right: 0 !important;
  }
  .me-xxl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xxl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xxl-3 {
    margin-right: 1rem !important;
  }
  .me-xxl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xxl-5 {
    margin-right: 3rem !important;
  }
  .me-xxl-auto {
    margin-right: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  .ms-xxl-0 {
    margin-left: 0 !important;
  }
  .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xxl-3 {
    margin-left: 1rem !important;
  }
  .ms-xxl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xxl-5 {
    margin-left: 3rem !important;
  }
  .ms-xxl-auto {
    margin-left: auto !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.25rem !important;
  }
  .p-xxl-2 {
    padding: 0.5rem !important;
  }
  .p-xxl-3 {
    padding: 1rem !important;
  }
  .p-xxl-4 {
    padding: 1.5rem !important;
  }
  .p-xxl-5 {
    padding: 3rem !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xxl-3 {
    padding-top: 1rem !important;
  }
  .pt-xxl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xxl-5 {
    padding-top: 3rem !important;
  }
  .pe-xxl-0 {
    padding-right: 0 !important;
  }
  .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xxl-3 {
    padding-right: 1rem !important;
  }
  .pe-xxl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xxl-5 {
    padding-right: 3rem !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xxl-0 {
    padding-left: 0 !important;
  }
  .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xxl-3 {
    padding-left: 1rem !important;
  }
  .ps-xxl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xxl-5 {
    padding-left: 3rem !important;
  }
  .text-xxl-start {
    text-align: left !important;
  }
  .text-xxl-end {
    text-align: right !important;
  }
  .text-xxl-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.2rem !important;
  }
  .fs-2 {
    font-size: 1.76rem !important;
  }
  .fs-3 {
    font-size: 1.54rem !important;
  }
  .fs-4 {
    font-size: 1.32rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}
a,
button,
.btn {
  outline: none !important;
}

.app-container {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  margin: 0;
}

.SidebarAnimation-appear {
  transform: translateX(-30px);
  opacity: 0;
}
.SidebarAnimation-appear.SidebarAnimation-appear-active {
  opacity: 1;
  transform: translateX(0);
  transition: all 0.4s linear;
}

.HeaderAnimation-appear {
  transform: translateY(-30px);
  opacity: 0;
}
.HeaderAnimation-appear.HeaderAnimation-appear-active {
  opacity: 1;
  transform: translateY(0);
  transition: all 0.4s linear;
}

.MainAnimation-appear {
  transform: translateY(-30px);
  opacity: 0;
}
.MainAnimation-appear.MainAnimation-appear-active {
  opacity: 1;
  transform: translateY(0);
  transition: all 0.4s linear;
}

.app-header {
  height: 60px;
  display: flex;
  align-items: center;
  align-content: center;
  position: relative;
  z-index: 10;
  transition: all 0.2s;
}
.app-header.header-shadow {
  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);
}
.app-header .app-header__content {
  display: flex;
  align-items: center;
  align-content: center;
  flex: 1 1;
  padding: 0 1.5rem;
  height: 60px;
}
.app-header .app-header__content .app-header-left {
  display: flex;
  align-items: center;
}
.app-header .app-header__content .app-header-right {
  align-items: center;
  display: flex;
  margin-left: auto;
}
.app-header .header-user-info > .widget-heading, .app-header .header-user-info > .widget-subheading {
  white-space: nowrap;
}
.app-header .header-user-info > .widget-subheading {
  font-size: 0.8rem;
}

.app-header__logo {
  padding: 0 1.5rem;
  height: 60px;
  width: 280px;
  display: flex;
  align-items: center;
  transition: width 0.2s;
}
.app-header__logo .logo-src {
  height: 23px;
  width: 97px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
}

.app-header__menu,
.app-header__mobile-menu {
  display: none;
  padding: 0 1.5rem;
  height: 60px;
  align-items: center;
}

.fixed-header .app-header {
  position: fixed;
  width: 100%;
  top: 0;
}
.fixed-header .app-header .app-header__logo {
  visibility: visible;
}
.fixed-header .app-main {
  padding-top: 60px;
}
.fixed-header:not(.fixed-sidebar):not(.closed-sidebar) .app-sidebar .app-header__logo {
  visibility: hidden;
}

.check-align-center {
  display: flex;
  align-items: center;
}

.check-column-center {
  display: flex;
  justify-content: center;
}

.header-dots {
  margin-left: auto;
  display: flex;
}
.header-dots > .dropdown {
  display: flex;
  align-content: center;
}
.header-dots .icon-wrapper-alt {
  margin: 0;
  height: 44px;
  width: 44px;
  text-align: center;
  overflow: visible;
}
.header-dots .icon-wrapper-alt .language-icon {
  border-radius: 30px;
  position: relative;
  z-index: 4;
  width: 28px;
  height: 28px;
  overflow: hidden;
  margin: 0 auto;
}
.header-dots .icon-wrapper-alt .language-icon img {
  position: relative;
  top: 50%;
  left: 50%;
  margin: -22px 0 0 -20px;
}
.header-dots .icon-wrapper-alt .icon-wrapper-bg {
  opacity: 0.1;
  transition: opacity 0.2s;
  border-radius: 40px;
}
.header-dots .icon-wrapper-alt svg {
  margin: 0 auto;
}
@-moz-document url-prefix() {
  .header-dots .icon-wrapper-alt svg {
    width: 50%;
  }
}
.header-dots .icon-wrapper-alt i {
  font-size: 1.3rem;
}
.header-dots .icon-wrapper-alt:hover {
  cursor: pointer;
}
.header-dots .icon-wrapper-alt:hover .icon-wrapper-bg {
  opacity: 0.2;
}
.header-dots .icon-wrapper-alt .badge-dot {
  top: 1px;
  right: 1px;
  border: 0;
}

.header-megamenu.nav > li > .nav-link {
  color: #6c757d;
  padding-left: 0.6666666667rem;
  padding-right: 0.6666666667rem;
}
.header-megamenu.nav > li > .nav-link .rounded-pill {
  padding: 5px 7px;
}
.header-megamenu.nav > li > .nav-link:hover {
  color: #343a40;
}
.header-megamenu.nav > li > .nav-link svg {
  margin-top: 1px;
}

.header-btn-lg {
  padding: 0 0 0 1.5rem;
  margin-left: 1.5rem;
  display: flex;
  align-items: center;
  position: relative;
  /*&::before {
    position: absolute;
    left: -1px;
    top: 50%;
    background: \$border-color;
    width: 1px;
    height: 30px;
    margin-top: -15px;
    content: '';
  }*/
}
.header-btn-lg .hamburger-inner,
.header-btn-lg .hamburger-inner::before,
.header-btn-lg .hamburger-inner::after {
  background: #6c757d;
}

.app-header.header-text-light .app-header-left > .nav > li > .nav-link {
  color: rgba(255, 255, 255, 0.7);
}
.app-header.header-text-light .app-header-left > .nav > li > .nav-link .nav-link-icon {
  color: rgba(255, 255, 255, 0.8);
}
.app-header.header-text-light .app-header-left > .nav > li > .nav-link:hover {
  color: rgb(255, 255, 255);
}
.app-header.header-text-light .app-header-right .icon-wrapper-alt svg {
  fill: rgba(255, 255, 255, 0.7);
  transition: all 0.2s;
}
.app-header.header-text-light .app-header-right .icon-wrapper-alt .icon-wrapper-bg {
  background: rgba(255, 255, 255, 0.1) !important;
  transition: all 0.2s;
  opacity: 1;
}
.app-header.header-text-light .app-header-right .icon-wrapper-alt:hover svg {
  fill: rgba(255, 255, 255, 0.95);
}
.app-header.header-text-light .app-header-right .icon-wrapper-alt:hover .icon-wrapper-bg {
  background: rgba(255, 255, 255, 0.15) !important;
}
.app-header.header-text-light .app-header-right .icon-wrapper-alt .badge-dot {
  border-color: transparent;
}
.app-header.header-text-light .app-header-right > .header-btn-lg .widget-content-left .btn-group > .btn-link,
.app-header.header-text-light .app-header-right > .header-btn-lg .widget-heading,
.app-header.header-text-light .app-header-right > .header-btn-lg .widget-subheading {
  color: rgba(255, 255, 255, 0.8);
}
.app-header.header-text-light .app-header-right > .header-btn-lg .header-user-info > .btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(0, 0, 0, 0.1), 0 0.0625rem 0.125rem rgba(0, 0, 0, 0.2);
}
.app-header.header-text-light .search-wrapper .input-holder .search-icon {
  background: rgba(0, 0, 0, 0.1);
}
.app-header.header-text-light .search-wrapper .input-holder .search-input::placeholder, .app-header.header-text-light .search-wrapper .input-holder .search-input::-webkit-input-placeholder, .app-header.header-text-light .search-wrapper .input-holder .search-input:-ms-input-placeholder, .app-header.header-text-light .search-wrapper .input-holder .search-input:-moz-placeholder, .app-header.header-text-light .search-wrapper .input-holder .search-input::-moz-placeholder {
  color: rgba(255, 255, 255, 0.5) !important;
}
.app-header.header-text-light .search-wrapper.active .input-holder {
  background: rgba(255, 255, 255, 0.1);
}
.app-header.header-text-light .search-wrapper.active .input-holder .search-input {
  color: rgba(255, 255, 255, 0.8);
}
.app-header.header-text-light .search-wrapper.active .input-holder .search-icon {
  background: rgba(255, 255, 255, 0.1);
}
.app-header.header-text-light .header-btn-lg::before {
  background: rgba(255, 255, 255, 0.2);
}
.app-header.header-text-light .header-btn-lg .hamburger-inner,
.app-header.header-text-light .header-btn-lg .hamburger.is-active .hamburger-inner,
.app-header.header-text-light .header-btn-lg .hamburger-inner::before,
.app-header.header-text-light .header-btn-lg .hamburger-inner::after,
.app-header.header-text-light .header__pane .hamburger-inner,
.app-header.header-text-light .header__pane .hamburger.is-active .hamburger-inner,
.app-header.header-text-light .header__pane .hamburger-inner::before,
.app-header.header-text-light .header__pane .hamburger-inner::after {
  background-color: rgba(255, 255, 255, 0.8) !important;
}
.app-header.header-text-light .search-wrapper .input-holder .search-icon span::after {
  border-color: rgba(255, 255, 255, 0.8);
}
.app-header.header-text-light .search-wrapper .close::before,
.app-header.header-text-light .search-wrapper .close::after,
.app-header.header-text-light .search-wrapper .input-holder .search-icon span::before {
  background: rgba(255, 255, 255, 0.8);
}
.app-header.header-text-light .app-header__logo .logo-src {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
}
.app-header.header-text-light .app-header__mobile-menu .hamburger-inner,
.app-header.header-text-light .app-header__mobile-menu .hamburger-inner::before,
.app-header.header-text-light .app-header__mobile-menu .hamburger-inner::after {
  background: rgba(255, 255, 255, 0.9);
}

.app-header.header-text-dark .app-header-left > .nav > li > .nav-link {
  color: rgba(0, 0, 0, 0.7);
}
.app-header.header-text-dark .app-header-left > .nav > li > .nav-link .nav-link-icon {
  color: rgba(0, 0, 0, 0.8);
}
.app-header.header-text-dark .app-header-left > .nav > li > .nav-link:hover {
  color: rgb(0, 0, 0);
}
.app-header.header-text-dark .app-header-right .icon-wrapper-alt svg {
  fill: rgba(0, 0, 0, 0.7);
  transition: all 0.2s;
}
.app-header.header-text-dark .app-header-right .icon-wrapper-alt .icon-wrapper-bg {
  background: rgba(0, 0, 0, 0.1) !important;
  transition: all 0.2s;
  opacity: 1;
}
.app-header.header-text-dark .app-header-right .icon-wrapper-alt:hover svg {
  fill: rgba(0, 0, 0, 0.95);
}
.app-header.header-text-dark .app-header-right .icon-wrapper-alt:hover .icon-wrapper-bg {
  background: rgba(0, 0, 0, 0.15) !important;
}
.app-header.header-text-dark .app-header-right .icon-wrapper-alt .badge-dot {
  border-color: transparent;
}
.app-header.header-text-dark .app-header-right .widget-content-left > .btn-group > .btn-link,
.app-header.header-text-dark .app-header-right .widget-content-left .widget-heading,
.app-header.header-text-dark .app-header-right .widget-content-left .widget-subheading {
  color: rgba(0, 0, 0, 0.8);
}
.app-header.header-text-dark .search-wrapper .input-holder .search-icon {
  background: rgba(0, 0, 0, 0.1);
}
.app-header.header-text-dark .search-wrapper.active .input-holder {
  background: rgba(0, 0, 0, 0.1);
}
.app-header.header-text-dark .search-wrapper.active .input-holder .search-input {
  color: rgba(0, 0, 0, 0.8);
}
.app-header.header-text-dark .search-wrapper.active .input-holder .search-icon {
  background: rgba(0, 0, 0, 0.1);
}
.app-header.header-text-dark .header-btn-lg::before {
  background: rgba(0, 0, 0, 0.2);
}
.app-header.header-text-dark .header-btn-lg .hamburger-inner,
.app-header.header-text-dark .header-btn-lg .hamburger.is-active .hamburger-inner,
.app-header.header-text-dark .header-btn-lg .hamburger-inner::before,
.app-header.header-text-dark .header-btn-lg .hamburger-inner::after,
.app-header.header-text-dark .header__pane .hamburger-inner,
.app-header.header-text-dark .header__pane .hamburger.is-active .hamburger-inner,
.app-header.header-text-dark .header__pane .hamburger-inner::before,
.app-header.header-text-dark .header__pane .hamburger-inner::after {
  background-color: rgba(0, 0, 0, 0.8) !important;
}
.app-header.header-text-dark .search-wrapper .input-holder .search-icon span::after {
  border-color: rgba(0, 0, 0, 0.8);
}
.app-header.header-text-dark .search-wrapper .close::before,
.app-header.header-text-dark .search-wrapper .close::after,
.app-header.header-text-dark .search-wrapper .input-holder .search-icon span::before {
  background: rgba(0, 0, 0, 0.8);
}
.app-header.header-text-dark .app-header__logo .logo-src {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
}

.app-sidebar {
  width: 280px;
  display: flex;
  z-index: 11;
  overflow: hidden;
  min-width: 280px;
  position: relative;
  flex: 0 0 280px;
  margin-top: -60px;
  padding-top: 60px;
  transition: all 0.2s;
}
.app-sidebar .app-sidebar__inner {
  padding: 10px 1.5rem 1.5rem;
}
.app-sidebar .scrollbar-container {
  z-index: 15;
  width: 100%;
}
.app-sidebar .app-sidebar-bg {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  opacity: 0.05;
  background-size: cover;
  z-index: 10;
}
.app-sidebar .app-header__logo {
  position: absolute;
  left: 0;
  top: 0;
  display: none;
  z-index: 11;
}
.app-sidebar.sidebar-shadow {
  box-shadow: 7px 0 60px rgba(0, 0, 0, 0.05);
}

.app-sidebar__heading {
  text-transform: uppercase;
  font-size: 0.8rem;
  margin: 0.75rem 0;
  font-weight: bold;
  color: #545cd8;
  white-space: nowrap;
  position: relative;
}

.sidebar-mobile-overlay {
  display: none;
  position: fixed;
  width: 100%;
  height: 100%;
  background: #333;
  opacity: 0.6;
  left: 0;
  top: 0;
  z-index: 12;
}

.vertical-nav-menu {
  position: relative;
}
.vertical-nav-menu::after {
  content: " ";
  pointer-events: none;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
}
.vertical-nav-menu .metismenu-container,
.vertical-nav-menu .metismenu-item {
  margin: 0;
  padding: 0;
  position: relative;
}
.vertical-nav-menu .metismenu-container {
  list-style: none;
}
.vertical-nav-menu .metismenu-container:before {
  opacity: 0;
  transition: opacity 300ms;
}
.vertical-nav-menu .metismenu-container .metismenu-link {
  transition: transform 0.2s, height 300ms, color 300ms, background-color 300ms;
  display: block;
  line-height: 2.5rem;
  height: 2.5rem;
  padding: 0 1.5rem 0 45px;
  position: relative;
  border-radius: 0.25rem;
  color: #343a40;
  white-space: nowrap;
}
.vertical-nav-menu .metismenu-container .metismenu-link:hover {
  background: #e0f3ff;
  text-decoration: none;
}
.vertical-nav-menu .metismenu-container .metismenu-link:hover i.metismenu-icon {
  opacity: 0.6;
}
.vertical-nav-menu .metismenu-container .metismenu-link:hover i.metismenu-state-icon {
  opacity: 1;
}
.vertical-nav-menu .metismenu-container .metismenu-link.active {
  color: #545cd8;
  background: #e0f3ff;
}
.vertical-nav-menu .metismenu-container .metismenu-link.has-active-child, .vertical-nav-menu .metismenu-container .metismenu-link.active {
  font-weight: bold;
}
.vertical-nav-menu .metismenu-container i.metismenu-state-icon,
.vertical-nav-menu .metismenu-container i.metismenu-icon {
  text-align: center;
  width: 34px;
  height: 34px;
  line-height: 34px;
  position: absolute;
  left: 5px;
  top: 50%;
  margin-top: -17px;
  font-size: 1.5rem;
  opacity: 0.3;
  transition: color 300ms;
}
.vertical-nav-menu .metismenu-container i.metismenu-state-icon {
  transition: transform 300ms;
  left: auto;
  right: 0;
}
.vertical-nav-menu .metismenu-container i.metismenu-state-icon.rotate-minus-90 {
  transform: rotate(-180deg);
}
.vertical-nav-menu .metismenu-container .metismenu-container {
  transition: padding 300ms;
}
.vertical-nav-menu .metismenu-container .metismenu-container.visible {
  padding: 0.5em 0 0 2rem;
}
.vertical-nav-menu .metismenu-container .metismenu-container.visible:before {
  content: "";
  height: 100%;
  opacity: 1;
  width: 3px;
  background: #e0f3ff;
  position: absolute;
  left: 20px;
  top: 0;
  border-radius: 15px;
}
.vertical-nav-menu .metismenu-container .metismenu-container.visible > .metismenu-item > .metismenu-link {
  height: 2.3em;
  line-height: 2.3em;
  color: #6c757d;
  margin: 0 0 3px;
}
.vertical-nav-menu .metismenu-container .metismenu-container.visible > .metismenu-item > .metismenu-link:hover {
  color: #545cd8;
}
.vertical-nav-menu .metismenu-container .metismenu-container.visible > .metismenu-item > .metismenu-link .metismenu-icon {
  display: none;
}
.vertical-nav-menu .metismenu-container .metismenu-container.visible > .metismenu-item > .metismenu-link.active {
  color: #545cd8;
  background: #e0f3ff;
}
.vertical-nav-menu .metismenu-container .metismenu-container .metismenu-item > .metismenu-link {
  height: 0;
  overflow: hidden;
}
.vertical-nav-menu .metismenu-container .metismenu-container .metismenu-link {
  padding-left: 1em;
}

.app-sidebar.sidebar-text-light {
  border-right: 0 !important;
}
.app-sidebar.sidebar-text-light .app-sidebar__heading {
  color: rgba(255, 255, 255, 0.6);
}
.app-sidebar.sidebar-text-light .app-sidebar__heading::before {
  background: rgba(255, 255, 255, 0.2) !important;
}
.app-sidebar.sidebar-text-light .metismenu .metismenu-container .metismenu-link {
  color: rgba(255, 255, 255, 0.7);
}
.app-sidebar.sidebar-text-light .metismenu .metismenu-container .metismenu-link:hover {
  color: rgb(255, 255, 255);
  background: rgba(255, 255, 255, 0.1);
}
.app-sidebar.sidebar-text-light .metismenu .metismenu-container .metismenu-link.active {
  background: rgba(255, 255, 255, 0.1);
}
.app-sidebar.sidebar-text-light .metismenu .metismenu-container.metismenu-container.visible .metismenu-item > .metismenu-link {
  color: rgba(255, 255, 255, 0.6);
}
.app-sidebar.sidebar-text-light .metismenu .metismenu-container.metismenu-container.visible .metismenu-item > .metismenu-link.active {
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.8);
}
.app-sidebar.sidebar-text-light .metismenu .metismenu-container.metismenu-container.visible .metismenu-item > .metismenu-link:hover {
  color: rgb(255, 255, 255);
}
.app-sidebar.sidebar-text-light .metismenu .metismenu-container.metismenu-container.visible::before {
  background: rgba(255, 255, 255, 0.3);
}
.app-sidebar.sidebar-text-light .metismenu .metismenu-container i.metismenu-state-icon,
.app-sidebar.sidebar-text-light .metismenu .metismenu-container i.metismenu-icon {
  opacity: 0.5;
}
.app-sidebar.sidebar-text-light .ps__thumb-y {
  background: rgba(255, 255, 255, 0.3);
}
.app-sidebar.sidebar-text-light .ps__rail-y:hover .ps__thumb-y {
  background: rgba(255, 255, 255, 0.2);
}
.app-sidebar.sidebar-text-light .app-header__logo .logo-src {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
}
.app-sidebar.sidebar-text-light .app-header__logo .hamburger-inner,
.app-sidebar.sidebar-text-light .app-header__logo .hamburger-inner::before,
.app-sidebar.sidebar-text-light .app-header__logo .hamburger-inner::after {
  background-color: rgba(255, 255, 255, 0.8);
}

.app-sidebar.sidebar-text-dark {
  border-right: 0 !important;
}
.app-sidebar.sidebar-text-dark .app-sidebar__heading {
  color: rgba(0, 0, 0, 0.6);
}
.app-sidebar.sidebar-text-dark .app-sidebar__heading::before {
  background: rgba(0, 0, 0, 0.5) !important;
}
.app-sidebar.sidebar-text-dark .metismenu .metismenu-container .metismenu-link {
  color: rgba(0, 0, 0, 0.7);
}
.app-sidebar.sidebar-text-dark .metismenu .metismenu-container .metismenu-link:hover {
  color: rgb(0, 0, 0);
  background: rgba(0, 0, 0, 0.1);
}
.app-sidebar.sidebar-text-dark .metismenu .metismenu-container .metismenu-link.active {
  background: rgba(0, 0, 0, 0.1);
}
.app-sidebar.sidebar-text-dark .metismenu .metismenu-container.metismenu-container.visible .metismenu-item > .metismenu-link {
  color: rgba(0, 0, 0, 0.6);
}
.app-sidebar.sidebar-text-dark .metismenu .metismenu-container.metismenu-container.visible .metismenu-item > .metismenu-link.active {
  background: rgba(0, 0, 0, 0.1);
}
.app-sidebar.sidebar-text-dark .metismenu .metismenu-container.metismenu-container.visible::before {
  background: rgba(0, 0, 0, 0.3);
}
.app-sidebar.sidebar-text-dark .metismenu .metismenu-container.metismenu-container i.metismenu-state-icon,
.app-sidebar.sidebar-text-dark .metismenu .metismenu-container.metismenu-container i.metismenu-icon {
  opacity: 0.5;
}
.app-sidebar.sidebar-text-dark .ps__thumb-y {
  background: rgba(0, 0, 0, 0.3);
}
.app-sidebar.sidebar-text-dark .ps__rail-y:hover .ps__thumb-y {
  background: rgba(0, 0, 0, 0.2);
}
.app-sidebar.sidebar-text-dark .app-header__logo .hamburger-inner,
.app-sidebar.sidebar-text-dark .app-header__logo .hamburger-inner::before,
.app-sidebar.sidebar-text-dark .app-header__logo .hamburger-inner::after {
  background-color: rgba(0, 0, 0, 0.8);
}

.fixed-sidebar .app-sidebar {
  position: fixed;
  height: 100vh;
}
.fixed-sidebar .app-main .app-main__outer {
  z-index: 9;
  padding-left: 280px;
}
.fixed-sidebar.fixed-header .app-sidebar .app-header__logo {
  display: none;
}
.fixed-sidebar:not(.fixed-header) .app-sidebar .app-header__logo {
  display: flex;
}
.fixed-sidebar:not(.fixed-header) .app-header {
  margin-left: 280px;
}
.fixed-sidebar:not(.fixed-header) .app-header .app-header__logo {
  display: none;
}
.fixed-sidebar.closed-sidebar:not(.fixed-header) .app-header {
  margin-left: 80px;
}
.fixed-sidebar.closed-sidebar:not(.fixed-header) .app-sidebar .app-header__logo {
  width: 80px;
  padding: 0;
}
.fixed-sidebar.closed-sidebar:not(.fixed-header) .app-sidebar .app-header__logo .logo-src {
  display: none;
}
.fixed-sidebar.closed-sidebar:not(.fixed-header) .app-sidebar .app-header__logo .header__pane {
  margin-right: auto;
}

.closed-sidebar .app-sidebar {
  transition: all 0.3s ease;
  width: 80px;
  min-width: 80px;
  flex: 0 0 80px;
  z-index: 13;
}
.closed-sidebar .app-sidebar .app-sidebar__inner .app-sidebar__heading {
  text-indent: -999em;
}
.closed-sidebar .app-sidebar .app-sidebar__inner .app-sidebar__heading::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 1px;
  background: #e0f3ff;
  text-indent: 1px;
}
.closed-sidebar .app-sidebar .app-sidebar__inner .metismenu-link {
  text-indent: -99rem;
  padding: 0;
}
.closed-sidebar .app-sidebar .app-sidebar__inner .metismenu-icon {
  text-indent: 0;
  left: 50%;
  margin-left: -17px;
}
.closed-sidebar .app-sidebar .app-sidebar__inner .metismenu-state-icon {
  visibility: hidden;
}
.closed-sidebar .app-sidebar .app-sidebar__inner .metismenu-container.visible {
  padding: 0;
}
.closed-sidebar .app-sidebar .app-sidebar__inner .metismenu-container.visible > .metismenu-item > .metismenu-link {
  height: 0;
}
.closed-sidebar .app-sidebar:hover {
  flex: 0 0 280px !important;
  width: 280px !important;
}
.closed-sidebar .app-sidebar:hover .app-sidebar__inner .app-sidebar__heading {
  text-indent: 0;
  text-indent: initial;
}
.closed-sidebar .app-sidebar:hover .app-sidebar__inner .app-sidebar__heading::before {
  display: none;
}
.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-link {
  text-indent: 0;
  text-indent: initial;
  padding: 0 1.5rem 0 45px;
}
.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-icon {
  text-indent: 0;
  text-indent: initial;
  left: 5px;
  margin-left: 0;
}
.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-state-icon {
  visibility: visible;
}
.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-container.visible {
  padding: 0.5em 0 0 2rem;
}
.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-container.visible > .metismenu-item > .metismenu-link {
  height: 2.3em;
}
.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-container .metismenu-container .metismenu-link {
  padding-left: 1em;
}
.closed-sidebar:not(.sidebar-mobile-open) .app-sidebar .scrollbar-container {
  position: static;
  height: auto;
  overflow: visible !important;
  overflow: initial !important;
}
.closed-sidebar:not(.sidebar-mobile-open) .app-sidebar:hover .scrollbar-container {
  position: absolute;
  height: 100%;
  overflow: hidden !important;
}
.closed-sidebar:not(.closed-sidebar-mobile) .app-header .app-header__logo {
  width: 80px;
}
.closed-sidebar:not(.closed-sidebar-mobile) .app-header .app-header__logo .logo-src {
  display: none;
}
.closed-sidebar:not(.closed-sidebar-mobile) .app-header .app-header__logo .header__pane {
  margin-right: auto;
}
.closed-sidebar.fixed-sidebar .app-main__outer {
  padding-left: 80px;
}
.closed-sidebar.fixed-header:not(.fixed-sidebar) .app-sidebar .app-header__logo {
  visibility: hidden;
}
.closed-sidebar.closed-sidebar-mobile .app-sidebar .app-header__logo,
.closed-sidebar.closed-sidebar-mobile .app-header .app-header__logo {
  width: auto;
  display: flex;
}
.closed-sidebar.closed-sidebar-mobile .app-sidebar .app-header__logo .header__pane,
.closed-sidebar.closed-sidebar-mobile .app-header .app-header__logo .header__pane {
  display: none;
}
.closed-sidebar.closed-sidebar-mobile .app-sidebar .app-header__logo {
  display: flex;
  width: 80px;
  padding: 0 1.5rem !important;
}
.closed-sidebar.closed-sidebar-mobile .app-sidebar .app-header__logo .logo-src {
  display: block !important;
  margin: 0 auto;
  width: 21px;
}
.closed-sidebar.closed-sidebar-mobile .app-sidebar .app-header__logo .header__pane {
  display: none;
}
.closed-sidebar.closed-sidebar-mobile .app-sidebar:hover .app-header__logo {
  width: 280px;
}
.closed-sidebar.closed-sidebar-mobile .app-sidebar:hover .app-header__logo .logo-src {
  width: 97px;
  margin: 0;
}
.closed-sidebar.closed-sidebar-mobile .app-header {
  margin-left: 0 !important;
}
.closed-sidebar.fixed-footer .app-footer__inner {
  margin-left: 0 !important;
}

.app-main {
  z-index: 8;
  position: relative;
  display: flex;
}
.app-main .app-main__outer {
  flex: 1 1;
  flex-direction: column;
  display: flex;
  z-index: 12;
  width: 1px;
}
.app-main .app-main__inner {
  padding: 1.5rem 1.5rem 0;
  flex: 1 1;
}
.app-main .app-main__inner > .RRT__container > .RRT__panel {
  margin-top: 1.5rem;
}
.app-main .app-main__inner > .RRT__container > .body-tabs-layout .RRT__tab {
  margin-top: -0.5rem;
}

.body-tabs-shadow-btn .app-main__inner > .RRT__container > .RRT__panel {
  margin-top: 1rem;
}
.body-tabs-shadow-btn .app-main__inner > .RRT__container .body-tabs-layout {
  border: 0;
  background: transparent;
  position: relative;
  z-index: 7;
}
.body-tabs-shadow-btn .app-main__inner > .RRT__container .body-tabs-layout .RRT__showmore {
  margin-top: -13px;
}
.body-tabs-shadow-btn .app-main__inner > .RRT__container .body-tabs-layout .RRT__tab {
  margin-top: 0.5rem;
}
.body-tabs-shadow-btn .app-main__inner > .RRT__container .body-tabs-layout .RRT__tab--selected {
  color: #fff;
}
.body-tabs-shadow-btn .app-main__inner > .RRT__container .body-tabs-layout + .RRT__inkbar-wrapper {
  position: absolute;
  top: 1.1rem;
  z-index: 5;
}
.body-tabs-shadow-btn .app-main__inner > .RRT__container .body-tabs-layout + .RRT__inkbar-wrapper .RRT__inkbar {
  height: 35px;
  margin-top: 0;
  border-radius: 0.25rem;
  box-shadow: 0 16px 26px -10px rgba(84, 92, 216, 0.56), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(84, 92, 216, 0.2);
}

.app-theme-white.app-container {
  background: #f1f4f6;
}
.app-theme-white .app-sidebar {
  background: #ffffff;
}
.app-theme-white .app-page-title {
  background: rgba(255, 255, 255, 0.55);
}
.app-theme-white .app-footer .app-footer__inner,
.app-theme-white .app-header {
  background: #fafbfc;
}
.app-theme-white.fixed-header .app-header__logo {
  background: rgba(250, 251, 252, 0.1);
}

.app-theme-gray.app-container {
  background: #ffffff;
}
.app-theme-gray .app-sidebar {
  background: #ffffff;
  border-right: #dee2e6 solid 1px;
}
.app-theme-gray .app-page-title {
  background: rgba(0, 0, 0, 0.03);
}
.app-theme-gray .app-footer,
.app-theme-gray .app-header {
  background: #f8f9fa;
}
.app-theme-gray .app-footer {
  border-top: #dee2e6 solid 1px;
}
.app-theme-gray .app-header .app-header__logo {
  border-right: rgba(0, 0, 0, 0.1) solid 1px;
}
.app-theme-gray.fixed-header .app-header__logo {
  background: rgba(0, 0, 0, 0.03);
}
.app-theme-gray .card {
  border-width: 1px;
}
.app-theme-gray .main-card {
  box-shadow: 0 0 0 0 transparent !important;
}
.app-theme-gray .main-card > .card-body > .card-title {
  text-transform: none;
  font-size: 1.1rem;
  font-weight: normal;
  border-bottom: #dee2e6 solid 1px;
  position: relative;
  padding: 0 0 1.5rem;
  margin: 0 0 1.5rem;
}
.app-theme-gray .main-card > .card-body > .card-title::before {
  position: absolute;
  width: 40px;
  background: #545cd8;
  border-radius: 30px;
  height: 5px;
  left: 0;
  bottom: -2px;
  content: "";
}
.app-theme-gray .app-inner-layout__sidebar {
  border-left: 0 !important;
}

.app-footer {
  height: 60px;
}
.app-footer .app-footer__inner {
  padding: 0 1.5rem 0 0.75rem;
  height: 60px;
  transition: all 0.2s;
  display: flex;
  align-content: center;
  align-items: center;
}
.app-footer .app-footer__inner .app-footer-left {
  display: flex;
  align-items: center;
}
.app-footer .app-footer__inner .app-footer-right {
  margin-left: auto;
  display: flex;
}

.footer-dots {
  display: flex;
  align-items: center;
  align-content: center;
}
.footer-dots .dots-separator {
  height: 40px;
  margin: 0 0.6rem;
  width: 1px;
  background: #e9ecef;
}

.dot-btn-wrapper {
  padding: 0.5rem;
  position: relative;
  display: flex;
  opacity: 0.7;
  transition: opacity 0.2s;
}
.dot-btn-wrapper .badge-abs {
  right: 50%;
}
.dot-btn-wrapper .badge-abs.badge-dot-sm {
  top: -2px;
  margin-right: -3px;
}
.dot-btn-wrapper .dot-btn-icon {
  font-size: 1.8rem;
}
.dot-btn-wrapper:hover {
  text-decoration: none;
  opacity: 1;
}

.fixed-footer .app-footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  z-index: 7;
}
.fixed-footer .app-footer .app-footer__inner {
  margin-left: 280px;
  box-shadow: 0.3rem -0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.02), 0.3rem -0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.02), 0.3rem -0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.04), 0.3rem -0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.02);
}
.fixed-footer .app-main .app-main__outer {
  padding-bottom: 60px;
}
.fixed-footer.closed-sidebar .app-footer .app-footer__inner {
  margin-left: 80px !important;
}

.app-page-title {
  padding: 1.5rem;
  margin: -1.5rem -1.5rem 1.5rem;
  position: relative;
}
.app-page-title .page-title-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}
.app-page-title .page-title-heading,
.app-page-title .page-title-subheading {
  margin: 0;
  padding: 0;
}
.app-page-title .page-title-heading {
  font-size: 1.1rem;
  font-weight: 400;
  display: flex;
  align-content: center;
  align-items: center;
}
.app-page-title .page-title-subheading {
  padding: 3px 0 0;
  font-size: 0.88rem;
  opacity: 0.6;
}
.app-page-title .page-title-subheading .breadcrumb {
  padding: 0;
  margin: 3px 0 0;
  background: transparent;
}
.app-page-title .page-title-actions {
  margin-left: auto;
}
.app-page-title .page-title-actions .breadcrumb {
  margin: 0;
  padding: 0;
  background: transparent;
}
.app-page-title .page-title-icon {
  font-size: 2rem;
  display: flex;
  align-items: center;
  align-content: center;
  text-align: center;
  padding: 0.8333333333rem;
  margin: 0 1.5rem 0 0;
  background: #fff;
  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);
  border-radius: 0.25rem;
  width: 60px;
  height: 60px;
}
.app-page-title .page-title-icon i {
  margin: auto;
}
.app-page-title .page-title-icon.rounded-circle {
  margin: 0 1rem 0 0;
}
.app-page-title + .RRT__container {
  margin-top: -1.1538461538rem;
}
.app-page-title + .rc-tabs {
  max-width: calc(100vw - 322px);
  margin: -1.5rem -0.75rem 1.95rem;
}
@media only screen and (max-width: 812px) and (min-width: 360px) {
  .app-page-title + .rc-tabs {
    max-width: calc(100vw - 0px);
    margin: -1.5rem -0.75rem 1.95rem;
  }
}
.app-page-title.app-page-title-simple {
  margin: 0;
  background: none !important;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
}

.page-title-icon-rounded .page-title-icon {
  border-radius: 50px;
}

.closed-sidebar .rc-tabs {
  max-width: calc(100vw - 140px);
}

@media only screen and (max-width: 812px) and (min-width: 360px) {
  .closed-sidebar .rc-tabs {
    max-width: calc(100vw - 0px);
  }
}
.body-tabs.body-tabs-layout {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
  padding: 0 1.5rem;
  border-top: 0;
  border-bottom: #dee2e6 solid 1px;
}

.search-wrapper {
  position: relative;
  margin-right: 0.6666666667rem;
}
.search-wrapper .input-holder {
  height: 42px;
  width: 42px;
  overflow: hidden;
  position: relative;
  transition: all 0.3s ease-in-out;
}
.search-wrapper .input-holder .search-input {
  width: 100%;
  padding: 0 70px 0 20px;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  background: transparent;
  box-sizing: border-box;
  border: none;
  outline: none;
  transform: translate(0, 60px);
  transition: all 0.3s cubic-bezier(0, 0.105, 0.035, 1.57);
  transition-delay: 0.3s;
  font-size: 0.88rem;
}
.search-wrapper .input-holder .search-icon {
  width: 42px;
  height: 42px;
  border: none;
  padding: 0;
  outline: none;
  position: relative;
  z-index: 2;
  float: right;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  background: rgba(0, 0, 0, 0.06);
  border-radius: 30px;
}
.search-wrapper .input-holder .search-icon span {
  width: 22px;
  height: 22px;
  display: inline-block;
  vertical-align: middle;
  position: relative;
  transform: rotate(45deg);
  transition: all 0.4s cubic-bezier(0.65, -0.6, 0.24, 1.65);
}
.search-wrapper .input-holder .search-icon span::before, .search-wrapper .input-holder .search-icon span::after {
  position: absolute;
  content: "";
}
.search-wrapper .input-holder .search-icon span::before {
  width: 4px;
  height: 11px;
  left: 9px;
  top: 13px;
  border-radius: 2px;
  background: #545cd8;
}
.search-wrapper .input-holder .search-icon span::after {
  width: 14px;
  height: 14px;
  left: 4px;
  top: 0;
  border-radius: 16px;
  border: 2px solid #545cd8;
}
.search-wrapper .btn-close {
  position: absolute;
  z-index: 1;
  top: 50%;
  left: 0;
  width: 20px;
  height: 20px;
  margin-top: -10px;
  cursor: pointer;
  opacity: 0 !important;
  transition: all 0.2s cubic-bezier(0.285, -0.45, 0.935, 0.11);
  transition-delay: 0.1s;
}
.search-wrapper .btn-close::before, .search-wrapper .btn-close::after {
  position: absolute;
  background: #545cd8;
  border-radius: 2px;
}
.search-wrapper .btn-close::before {
  width: 2px;
  height: 20px;
  left: 9px;
  top: 0;
}
.search-wrapper .btn-close::after {
  width: 20px;
  height: 2px;
  left: 0;
  top: 9px;
}
.search-wrapper.active {
  width: 330px;
}
.search-wrapper.active .input-holder {
  width: 290px;
  border-radius: 50px;
  background: rgba(0, 0, 0, 0.05);
  transition: all 0.5s cubic-bezier(0, 0.105, 0.035, 1.57);
}
.search-wrapper.active .input-holder .search-input {
  opacity: 1;
  transform: translate(0, 11px);
}
.search-wrapper.active .input-holder .search-icon {
  width: 42px;
  height: 42px;
  margin: 0;
  border-radius: 30px;
}
.search-wrapper.active .input-holder .search-icon span {
  transform: rotate(-45deg);
}
.search-wrapper.active .btn-close {
  left: 300px;
  opacity: 0.6 !important;
  transition: all 0.6s cubic-bezier(0, 0.105, 0.035, 1.57);
  transition-delay: 0.5s;
}
.search-wrapper.active .btn-close:hover {
  opacity: 1 !important;
}
.search-wrapper.active + .header-megamenu {
  opacity: 0;
}

.opacity-01 {
  opacity: 0.01 !important;
}

.opacity-02 {
  opacity: 0.02 !important;
}

.opacity-03 {
  opacity: 0.03 !important;
}

.opacity-04 {
  opacity: 0.04 !important;
}

.opacity-05 {
  opacity: 0.05 !important;
}

.opacity-06 {
  opacity: 0.06 !important;
}

.opacity-07 {
  opacity: 0.07 !important;
}

.opacity-08 {
  opacity: 0.08 !important;
}

.opacity-09 {
  opacity: 0.09 !important;
}

.opacity-1 {
  opacity: 0.1 !important;
}

.opacity-15 {
  opacity: 0.15 !important;
}

.opacity-2 {
  opacity: 0.2 !important;
}

.opacity-3 {
  opacity: 0.3 !important;
}

.opacity-4 {
  opacity: 0.4 !important;
}

.opacity-5 {
  opacity: 0.5 !important;
}

.opacity-6 {
  opacity: 0.6 !important;
}

.opacity-7 {
  opacity: 0.7 !important;
}

.opacity-8 {
  opacity: 0.8 !important;
}

.opacity-9 {
  opacity: 0.9 !important;
}

.opacity-10 {
  opacity: 1 !important;
}

.filter-grayscale-5 {
  filter: grayscale(5%) !important;
}

.filter-grayscale-10 {
  filter: grayscale(10%) !important;
}

.filter-grayscale-20 {
  filter: grayscale(20%) !important;
}

.filter-grayscale-30 {
  filter: grayscale(30%) !important;
}

.filter-grayscale-40 {
  filter: grayscale(40%) !important;
}

.filter-grayscale-50 {
  filter: grayscale(50%) !important;
}

.filter-grayscale-80 {
  filter: grayscale(80%) !important;
}

.filter-grayscale-100 {
  filter: grayscale(100%) !important;
}

.br-tl {
  border-top-left-radius: 0.25rem !important;
}

.br-tr {
  border-top-right-radius: 0.25rem !important;
}

.br-bl {
  border-bottom-left-radius: 0.25rem !important;
}

.br-br {
  border-bottom-right-radius: 0.25rem !important;
}

.b-radius-0 {
  border-radius: 0 !important;
}

.rm-border {
  border-width: 0 !important;
}

.br-a {
  border-radius: 0.25rem;
}

.margin-h-center {
  margin-left: auto !important;
  margin-right: auto !important;
}

.center-svg {
  margin: 0 auto;
}
.center-svg svg {
  margin: 0 auto;
}

.apexcharts-canvas {
  margin: 0 auto;
}

.apexcharts-donut {
  display: flex;
  align-items: center;
  align-content: center;
}

.alert-dismissible .close {
  top: 0;
  right: 5px;
  padding: 5px;
}

.icon-gradient {
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
}

.font-size-xlg {
  font-size: 1.3rem !important;
}

.font-size-md {
  font-size: 0.9rem !important;
}

.font-size-lg {
  font-size: 1.1rem !important;
}

.no-shadow {
  box-shadow: 0 0 0 transparent !important;
}

.h-100 {
  height: 100vh !important;
}

.he-auto {
  height: auto !important;
}

.he-100 {
  height: 100%;
}

.h-sm {
  height: 150px;
}

.text-nowrap {
  white-space: nowrap;
}

.fsize-1 {
  font-size: 0.95rem !important;
}

.fsize-2 {
  font-size: 1.3rem !important;
}

.fsize-3 {
  font-size: 1.6rem !important;
}

.fsize-4 {
  font-size: 2rem !important;
}

.z-index-6 {
  z-index: 6;
}

.line-height-1 {
  line-height: 1;
}

.center-elem {
  display: flex;
  align-items: center;
  align-content: center;
}

.flex2 {
  flex: 2 1;
}

.divider {
  margin-top: 1rem;
  margin-bottom: 1rem;
  height: 1px;
  overflow: hidden;
  background: #e9ecef;
}

.list-group-item:hover {
  z-index: auto;
  z-index: initial;
}

.no-results {
  padding: 1.5rem;
  text-align: center;
}
.no-results .results-title {
  color: #495057;
  font-size: 1.1rem;
}
.no-results .results-subtitle {
  color: #adb5bd;
  font-size: 1.1rem;
}

.bg-animation {
  animation: bg-pan-left 8s both;
}
@keyframes bg-pan-left {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
.w-100 {
  width: 100%;
}

.mb--2 {
  margin-bottom: -1.5rem;
}

.mbg-3 {
  margin-bottom: 1.5rem;
}

.loader-container {
  align-items: center;
  display: flex;
  height: 100vh;
  justify-content: center;
  width: 100vw;
  text-align: center;
  line-height: 1.6rem;
}
.loader-container .loader-container-inner {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 0 1.5rem;
}
.loader-container small, .loader-container .small {
  margin: 10px 0 0;
  display: block;
  color: #6c757d;
  font-weight: normal;
}
.loader-container h3, .loader-container .h3 {
  text-align: center;
  display: block;
}

.btn-info, .btn-success {
  color: #fff !important;
}

.bg-warning {
  color: #212529;
}

.list-group-item {
  border: 1px solid rgba(0, 0, 0, 0.125);
}

.btn-link, a {
  text-decoration: none !important;
}

.bg-light {
  color: #212529;
}

.table {
  --bs-table-accent-bg: none;
}

.form-check-input-custom {
  width: 1rem;
  height: 1rem;
}

.bg-warm-flame {
  background-image: linear-gradient(45deg, #ff9a9e 0%, #fad0c4 99%, #fad0c4 100%) !important;
}

.bg-night-fade {
  background-image: linear-gradient(to top, #a18cd1 0%, #fbc2eb 100%) !important;
}

.bg-sunny-morning {
  background-image: linear-gradient(120deg, #f6d365 0%, #fda085 100%) !important;
}

.bg-tempting-azure {
  background-image: linear-gradient(120deg, #84fab0 0%, #8fd3f4 100%) !important;
}

.bg-amy-crisp {
  background-image: linear-gradient(120deg, #a6c0fe 0%, #f68084 100%) !important;
}

.bg-heavy-rain {
  background-image: linear-gradient(to top, #cfd9df 0%, #e2ebf0 100%) !important;
}

.bg-mean-fruit {
  background-image: linear-gradient(120deg, #fccb90 0%, #d57eeb 100%) !important;
}

.bg-malibu-beach {
  background-image: linear-gradient(to right, #4facfe 0%, #00f2fe 100%) !important;
}

.bg-deep-blue {
  background-image: linear-gradient(120deg, #e0c3fc 0%, #8ec5fc 100%) !important;
}

.bg-ripe-malin {
  background-image: linear-gradient(120deg, #f093fb 0%, #f5576c 100%) !important;
}

.bg-arielle-smile {
  background-image: radial-gradient(circle 248px at center, #16d9e3 0%, #30c7ec 47%, #46aef7 100%) !important;
}

.bg-plum-plate {
  background-image: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
}

.bg-happy-fisher {
  background-image: linear-gradient(120deg, #89f7fe 0%, #66a6ff 100%) !important;
}

.bg-happy-itmeo {
  background-image: linear-gradient(180deg, #2af598 0%, #009efd 100%) !important;
}

.bg-mixed-hopes {
  background-image: linear-gradient(to top, #c471f5 0%, #fa71cd 100%) !important;
}

.bg-strong-bliss {
  background-image: linear-gradient(to right, #f78ca0 0%, #f9748f 19%, #fd868c 60%, #fe9a8b 100%) !important;
}

.bg-grow-early {
  background-image: linear-gradient(to top, #0ba360 0%, #3cba92 100%) !important;
}

.bg-love-kiss {
  background-image: linear-gradient(to top, #ff0844 0%, #ffb199 100%) !important;
}

.bg-premium-dark {
  background-image: linear-gradient(to right, #434343 0%, black 100%) !important;
}

.bg-happy-green {
  background-image: linear-gradient(to bottom, #00b09b, #96c93d) !important;
}

.bg-vicious-stance {
  background-image: linear-gradient(60deg, #29323c 0%, #485563 100%) !important;
}

.bg-midnight-bloom {
  background-image: linear-gradient(-20deg, #2b5876 0%, #4e4376 100%) !important;
}

.bg-night-sky {
  background-image: linear-gradient(to top, #1e3c72 0%, #1e3c72 1%, #2a5298 100%) !important;
}

.bg-slick-carbon {
  background-image: linear-gradient(to bottom, #323232 0%, #3F3F3F 40%, #1C1C1C 150%), linear-gradient(to top, rgba(255, 255, 255, 0.4) 0%, rgba(0, 0, 0, 0.25) 200%) !important;
  background-blend-mode: multiply;
}

.bg-royal {
  background-image: linear-gradient(to right, #141e30, #243b55) !important;
}

.bg-asteroid {
  background-image: linear-gradient(to right, #0f2027, #203a43, #2c5364) !important;
}

.bg-transparent {
  background: transparent !important;
}

/*!
Animate.css - http://daneden.me/animate
Licensed under the MIT license - http://opensource.org/licenses/MIT
Copyright (c) 2015 Daniel Eden
*/
body {
  -webkit-backface-visibility: hidden;
}

.animated, .TabsAnimation-appear {
  animation-duration: calc(1s);
  animation-fill-mode: both;
}
.animated.infinite, .infinite.TabsAnimation-appear {
  animation-iteration-count: infinite;
}
.animated.hinge, .hinge.TabsAnimation-appear {
  animation-duration: calc(1s * 2);
}
.animated.bounceIn, .bounceIn.TabsAnimation-appear, .animated.bounceOut, .bounceOut.TabsAnimation-appear {
  animation-duration: calc(1s * 0.75);
}
.animated.flipOutX, .flipOutX.TabsAnimation-appear, .animated.flipOutY, .flipOutY.TabsAnimation-appear {
  animation-duration: calc(1s * 0.75);
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.fadeIn {
  animation-name: fadeIn;
}
@keyframes fadeInDown {
  0% {
    opacity: 0;
    transform: translateY(-20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.fadeInDown {
  animation-name: fadeInDown;
}
@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.fadeInUp, .TabsAnimation-appear {
  animation-name: fadeInUp;
}
@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.fadeOut {
  animation-name: fadeOut;
}
@keyframes lightSpeedIn {
  0% {
    transform: translateX(100%) skewX(-30deg);
    opacity: 0;
  }
  60% {
    transform: translateX(-20%) skewX(30deg);
    opacity: 1;
  }
  80% {
    transform: translateX(0%) skewX(-15deg);
    opacity: 1;
  }
  100% {
    transform: translateX(0%) skewX(0deg);
    opacity: 1;
  }
}
.lightSpeedIn {
  animation-name: lightSpeedIn;
  animation-timing-function: ease-out;
}
@keyframes lightSpeedOut {
  0% {
    transform: translateX(0%) skewX(0deg);
    opacity: 1;
  }
  100% {
    transform: translateX(100%) skewX(-30deg);
    opacity: 0;
  }
}
.lightSpeedOut {
  animation-name: lightSpeedOut;
  animation-timing-function: ease-in;
}

.dropdown-menu.show {
  animation: fade-in2 0.2s cubic-bezier(0.39, 0.575, 0.565, 1) both;
}

.popover.show {
  display: block;
  animation: fade-in2 0.2s cubic-bezier(0.39, 0.575, 0.565, 1) both;
}

.dropdown-menu[data-placement^=top].show {
  animation: fade-in3 0.2s cubic-bezier(0.39, 0.575, 0.565, 1) both;
  bottom: auto !important;
  top: auto !important;
}

@keyframes fade-in2 {
  0% {
    margin-top: -50px;
    visibility: hidden;
    opacity: 0;
  }
  100% {
    margin-top: 0px;
    visibility: visible;
    opacity: 1;
  }
}
.form-control {
  transition: all 0.2s;
}

.btn-outline-2x {
  border-width: 2px;
}

.btn-group .btn {
  font-size: 0.8rem;
  font-weight: 500;
}
.btn-group .btn-outline-2x + .btn-outline-2x {
  margin-left: -2px;
}
.btn-group .btn-square {
  border-radius: 0;
}

.btn {
  font-size: 0.8rem;
  font-weight: 500;
}
.btn.btn-pill.btn-wide, .btn.btn-pill {
  border-top-left-radius: 50px;
  border-bottom-left-radius: 50px;
  border-top-right-radius: 50px;
  border-bottom-right-radius: 50px;
}

.btn-dashed {
  border-style: dashed;
}

.btn-icon {
  vertical-align: bottom;
}
.btn-icon.btn-icon-right .btn-icon-wrapper {
  margin-left: 0.5rem;
  margin-right: 0;
}
.btn-icon .btn-icon-wrapper {
  margin-right: 0.5rem;
  margin-left: 0;
  margin-top: 0;
  font-size: 17px;
  vertical-align: middle;
  transition: color 0.1s;
  display: inline-block;
}
.btn-icon.btn-link {
  text-decoration: none;
}
.btn-icon.btn-lg:not(.btn-block) .btn-icon-wrapper, .btn-group-lg > .btn-icon.btn:not(.btn-block) .btn-icon-wrapper {
  font-size: 25px;
}
.btn-icon.btn-sm:not(.btn-block) .btn-icon-wrapper, .btn-group-sm > .btn-icon.btn:not(.btn-block) .btn-icon-wrapper {
  font-size: 16px;
}

.btn-icon-only .btn-icon-wrapper {
  margin-left: 0;
  margin-right: 0;
}

.btn-hover-shine {
  position: relative;
}
.btn-hover-shine:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.4);
  transition: none;
}
.btn-hover-shine:hover:after {
  width: 120%;
  background-color: rgba(255, 255, 255, 0);
  transition: all 0.4s ease-in-out;
}
.btn-hover-shine.btn-pill::after {
  border-top-left-radius: 50px;
  border-bottom-left-radius: 50px;
  border-top-right-radius: 50px;
  border-bottom-right-radius: 50px;
}

.btn-icon-vertical {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.btn-icon-vertical .btn-icon-wrapper {
  display: block;
  font-size: 200%;
  margin: 5px 0;
  opacity: 0.6;
}
.btn-icon-vertical.btn-link {
  text-decoration: none;
}
.btn-icon-vertical.btn-lg:not(.btn-block) .btn-icon-wrapper, .btn-group-lg > .btn-icon-vertical.btn:not(.btn-block) .btn-icon-wrapper {
  font-size: 25px;
}
.btn-icon-vertical.btn-sm:not(.btn-block) .btn-icon-wrapper, .btn-group-sm > .btn-icon-vertical.btn:not(.btn-block) .btn-icon-wrapper {
  font-size: 16px;
}
.btn-icon-vertical:active .btn-icon-wrapper, .btn-icon-vertical.active .btn-icon-wrapper, .btn-icon-vertical:hover .btn-icon-wrapper {
  opacity: 1;
}
.btn-icon-vertical.btn-icon-bottom .btn-icon-wrapper {
  margin: 0.2rem 0 5px;
}
.btn-icon-vertical.btn-transition-text .btn-icon-wrapper {
  transition: all 0.2s !important;
}
.btn-icon-vertical.btn-transition-text:hover .btn-icon-wrapper {
  transform: scale(1.3);
}
.btn-icon-vertical.btn-transition-text.btn-transition-alt:hover .btn-icon-wrapper {
  color: #fff !important;
}

.btn-icon-lg {
  font-size: 2.2rem !important;
}

.btn-transition {
  color: #6c757d;
  border-color: #e9ecef;
  background-color: none;
}
.btn-transition.btn-outline-link {
  border-color: transparent;
  background-color: transparent;
}
.btn-transition.btn-outline-link:hover {
  color: #545cd8;
  background: #f8f9fa;
}
.btn-transition.disabled, .btn-transition:disabled {
  color: #6c757d;
  border-color: #e9ecef;
}
.btn-transition:hover .btn-icon-wrapper {
  transition: none;
}

.btn-transition-alt:hover .icon-gradient {
  -webkit-background-clip: initial;
  -webkit-text-fill-color: initial;
  background-clip: border-box;
  background-clip: initial;
  text-fill-color: initial;
  background: none !important;
  color: #fff;
}

.btn-square {
  border-radius: 0 !important;
}

.btn.btn-wide {
  padding: 0.375rem 1.5rem;
  font-size: 0.8rem;
  border-radius: 0.25rem;
}

.btn-lg.btn-wide, .btn-group-lg > .btn-wide.btn {
  padding: 0.5rem 2rem;
  font-size: 1.1rem;
  border-radius: 0.3rem;
}

.btn-sm.btn-wide, .btn-group-sm > .btn-wide.btn {
  padding: 0.25rem 1rem;
  font-size: 0.8rem;
  border-radius: 0.2rem;
}

.dropdown-toggle::after {
  position: relative;
  top: 2px;
  opacity: 0.8;
}

.dropright .dropdown-toggle::after {
  top: 0;
}

.dropdown-toggle-split {
  border-left: rgba(255, 255, 255, 0.1) solid 1px;
}

.btn-gradient-primary {
  background-image: linear-gradient(140deg, rgb(41.5071428571, 50.0214285714, 181.9928571429) -30%, #545cd8 90%);
  background-color: rgb(41.5071428571, 50.0214285714, 181.9928571429);
  border-color: rgb(41.5071428571, 50.0214285714, 181.9928571429);
  color: color-yiq(rgb(32.0357142857, 38.6071428571, 140.4642857143));
}
.btn-gradient-primary.active, .btn-gradient-primary:active, .btn-gradient-primary:not(:disabled):not(.disabled):hover {
  background-image: linear-gradient(120deg, rgb(38.6657142857, 46.5971428571, 169.5342857143) 0%, rgb(71.5414285714, 80.1242857143, 213.1585714286) 100%);
  color: color-yiq(rgb(32.0357142857, 38.6071428571, 140.4642857143));
  border-color: rgb(32.0357142857, 38.6071428571, 140.4642857143);
}
.btn-gradient-primary:focus, .btn-gradient-primary.focus, .btn-gradient-primary:active, .btn-gradient-primary.active {
  color: color-yiq(rgb(32.0357142857, 38.6071428571, 140.4642857143)) !important;
  border-color: rgb(36.7714285714, 44.3142857143, 161.2285714286) !important;
}
.btn-gradient-primary.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(84, 92, 216, 0.4), 0 0.0625rem 0.125rem rgba(84, 92, 216, 0.5);
}
.btn-gradient-primary.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(84, 92, 216, 0.5), 0 0.0625rem 0.125rem rgba(84, 92, 216, 0.6);
}

.btn-gradient-secondary {
  background-image: linear-gradient(140deg, rgb(72.5407725322, 78.5858369099, 83.9592274678) -30%, #6c757d 90%);
  background-color: rgb(72.5407725322, 78.5858369099, 83.9592274678);
  border-color: rgb(72.5407725322, 78.5858369099, 83.9592274678);
  color: color-yiq(rgb(48.9012875536, 52.9763948498, 56.5987124464));
}
.btn-gradient-secondary.active, .btn-gradient-secondary:active, .btn-gradient-secondary:not(:disabled):not(.disabled):hover {
  background-image: linear-gradient(120deg, rgb(65.4489270386, 70.9030042918, 75.7510729614) 0%, rgb(100.9081545064, 109.317167382, 116.7918454936) 100%);
  color: color-yiq(rgb(48.9012875536, 52.9763948498, 56.5987124464));
  border-color: rgb(48.9012875536, 52.9763948498, 56.5987124464);
}
.btn-gradient-secondary:focus, .btn-gradient-secondary.focus, .btn-gradient-secondary:active, .btn-gradient-secondary.active {
  color: color-yiq(rgb(48.9012875536, 52.9763948498, 56.5987124464)) !important;
  border-color: rgb(60.7210300429, 65.7811158798, 70.2789699571) !important;
}
.btn-gradient-secondary.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(108, 117, 125, 0.4), 0 0.0625rem 0.125rem rgba(108, 117, 125, 0.5);
}
.btn-gradient-secondary.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(108, 117, 125, 0.5), 0 0.0625rem 0.125rem rgba(108, 117, 125, 0.6);
}

.btn-gradient-success {
  background-image: linear-gradient(140deg, rgb(40.531496063, 136.968503937, 87.3523622047) -30%, #3ac47d 90%);
  background-color: rgb(40.531496063, 136.968503937, 87.3523622047);
  border-color: rgb(40.531496063, 136.968503937, 87.3523622047);
  color: color-yiq(rgb(28.8858267717, 97.6141732283, 62.2539370079));
}
.btn-gradient-success.active, .btn-gradient-success:active, .btn-gradient-success:not(:disabled):not(.disabled):hover {
  background-image: linear-gradient(120deg, rgb(37.0377952756, 125.1622047244, 79.8228346457) 0%, rgb(54.5062992126, 184.1937007874, 117.4704724409) 100%);
  color: color-yiq(rgb(28.8858267717, 97.6141732283, 62.2539370079));
  border-color: rgb(28.8858267717, 97.6141732283, 62.2539370079);
}
.btn-gradient-success:focus, .btn-gradient-success.focus, .btn-gradient-success:active, .btn-gradient-success.active {
  color: color-yiq(rgb(28.8858267717, 97.6141732283, 62.2539370079)) !important;
  border-color: rgb(34.7086614173, 117.2913385827, 74.8031496063) !important;
}
.btn-gradient-success.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(58, 196, 125, 0.4), 0 0.0625rem 0.125rem rgba(58, 196, 125, 0.5);
}
.btn-gradient-success.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(58, 196, 125, 0.5), 0 0.0625rem 0.125rem rgba(58, 196, 125, 0.6);
}

.btn-gradient-info {
  background-image: linear-gradient(140deg, rgb(0, 141.152173913, 226.5) -30%, #30b1ff 90%);
  background-color: rgb(0, 141.152173913, 226.5);
  border-color: rgb(0, 141.152173913, 226.5);
  color: color-yiq(rgb(0, 109.3695652174, 175.5));
}
.btn-gradient-info.active, .btn-gradient-info:active, .btn-gradient-info:not(:disabled):not(.disabled):hover {
  background-image: linear-gradient(120deg, rgb(0, 131.6173913043, 211.2) 0%, rgb(32.7, 171.2347826087, 255) 100%);
  color: color-yiq(rgb(0, 109.3695652174, 175.5));
  border-color: rgb(0, 109.3695652174, 175.5);
}
.btn-gradient-info:focus, .btn-gradient-info.focus, .btn-gradient-info:active, .btn-gradient-info.active {
  color: color-yiq(rgb(0, 109.3695652174, 175.5)) !important;
  border-color: rgb(0, 125.2608695652, 201) !important;
}
.btn-gradient-info.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(48, 177, 255, 0.4), 0 0.0625rem 0.125rem rgba(48, 177, 255, 0.5);
}
.btn-gradient-info.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(48, 177, 255, 0.5), 0 0.0625rem 0.125rem rgba(48, 177, 255, 0.6);
}

.btn-gradient-warning {
  background-image: linear-gradient(140deg, rgb(199.2224669604, 142.8215859031, 7.2775330396) -30%, #f7b924 90%);
  background-color: rgb(199.2224669604, 142.8215859031, 7.2775330396);
  border-color: rgb(199.2224669604, 142.8215859031, 7.2775330396);
  color: color-yiq(rgb(150.0198237885, 107.5484581498, 5.4801762115));
}
.btn-gradient-warning.active, .btn-gradient-warning:active, .btn-gradient-warning:not(:disabled):not(.disabled):hover {
  background-image: linear-gradient(120deg, rgb(184.4616740088, 132.2396475771, 6.7383259912) 0%, rgb(246.4607929515, 180.281938326, 21.2392070485) 100%);
  color: color-yiq(rgb(150.0198237885, 107.5484581498, 5.4801762115));
  border-color: rgb(150.0198237885, 107.5484581498, 5.4801762115);
}
.btn-gradient-warning:focus, .btn-gradient-warning.focus, .btn-gradient-warning:active, .btn-gradient-warning.active {
  color: color-yiq(rgb(150.0198237885, 107.5484581498, 5.4801762115)) !important;
  border-color: rgb(174.6211453744, 125.1850220264, 6.3788546256) !important;
}
.btn-gradient-warning.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(247, 185, 36, 0.4), 0 0.0625rem 0.125rem rgba(247, 185, 36, 0.5);
}
.btn-gradient-warning.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(247, 185, 36, 0.5), 0 0.0625rem 0.125rem rgba(247, 185, 36, 0.6);
}

.btn-gradient-danger {
  background-image: linear-gradient(140deg, rgb(151.6437007874, 25.8562992126, 55.905511811) -30%, #d92550 90%);
  background-color: rgb(151.6437007874, 25.8562992126, 55.905511811);
  border-color: rgb(151.6437007874, 25.8562992126, 55.905511811);
  color: color-yiq(rgb(108.0728346457, 18.4271653543, 39.842519685));
}
.btn-gradient-danger.active, .btn-gradient-danger:active, .btn-gradient-danger:not(:disabled):not(.disabled):hover {
  background-image: linear-gradient(120deg, rgb(138.5724409449, 23.6275590551, 51.0866141732) 0%, rgb(203.9287401575, 34.7712598425, 75.1811023622) 100%);
  color: color-yiq(rgb(108.0728346457, 18.4271653543, 39.842519685));
  border-color: rgb(108.0728346457, 18.4271653543, 39.842519685);
}
.btn-gradient-danger:focus, .btn-gradient-danger.focus, .btn-gradient-danger:active, .btn-gradient-danger.active {
  color: color-yiq(rgb(108.0728346457, 18.4271653543, 39.842519685)) !important;
  border-color: rgb(129.8582677165, 22.1417322835, 47.874015748) !important;
}
.btn-gradient-danger.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(217, 37, 80, 0.4), 0 0.0625rem 0.125rem rgba(217, 37, 80, 0.5);
}
.btn-gradient-danger.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(217, 37, 80, 0.5), 0 0.0625rem 0.125rem rgba(217, 37, 80, 0.6);
}

.btn-gradient-focus {
  background-image: linear-gradient(140deg, rgb(32.8513513514, 30.9189189189, 40.5810810811) -30%, #444054 90%);
  background-color: rgb(32.8513513514, 30.9189189189, 40.5810810811);
  border-color: rgb(32.8513513514, 30.9189189189, 40.5810810811);
  color: color-yiq(rgb(9.4189189189, 8.8648648649, 11.6351351351));
}
.btn-gradient-focus.active, .btn-gradient-focus:active, .btn-gradient-focus:not(:disabled):not(.disabled):hover {
  background-image: linear-gradient(120deg, rgb(25.8216216216, 24.3027027027, 31.8972972973) 0%, rgb(60.9702702703, 57.3837837838, 75.3162162162) 100%);
  color: color-yiq(rgb(9.4189189189, 8.8648648649, 11.6351351351));
  border-color: rgb(9.4189189189, 8.8648648649, 11.6351351351);
}
.btn-gradient-focus:focus, .btn-gradient-focus.focus, .btn-gradient-focus:active, .btn-gradient-focus.active {
  color: color-yiq(rgb(9.4189189189, 8.8648648649, 11.6351351351)) !important;
  border-color: rgb(21.1351351351, 19.8918918919, 26.1081081081) !important;
}
.btn-gradient-focus.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(68, 64, 84, 0.4), 0 0.0625rem 0.125rem rgba(68, 64, 84, 0.5);
}
.btn-gradient-focus.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(68, 64, 84, 0.5), 0 0.0625rem 0.125rem rgba(68, 64, 84, 0.6);
}

.btn-gradient-alternate {
  background-image: linear-gradient(140deg, rgb(86.657079646, 58.2123893805, 91.2876106195) -30%, #83588a 90%);
  background-color: rgb(86.657079646, 58.2123893805, 91.2876106195);
  border-color: rgb(86.657079646, 58.2123893805, 91.2876106195);
  color: color-yiq(rgb(57.0951327434, 38.3539823009, 60.1460176991));
}
.btn-gradient-alternate.active, .btn-gradient-alternate:active, .btn-gradient-alternate:not(:disabled):not(.disabled):hover {
  background-image: linear-gradient(120deg, rgb(77.7884955752, 52.2548672566, 81.9451327434) 0%, rgb(122.1314159292, 82.0424778761, 128.6575221239) 100%);
  color: color-yiq(rgb(57.0951327434, 38.3539823009, 60.1460176991));
  border-color: rgb(57.0951327434, 38.3539823009, 60.1460176991);
}
.btn-gradient-alternate:focus, .btn-gradient-alternate.focus, .btn-gradient-alternate:active, .btn-gradient-alternate.active {
  color: color-yiq(rgb(57.0951327434, 38.3539823009, 60.1460176991)) !important;
  border-color: rgb(71.8761061947, 48.2831858407, 75.7168141593) !important;
}
.btn-gradient-alternate.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(131, 88, 138, 0.4), 0 0.0625rem 0.125rem rgba(131, 88, 138, 0.5);
}
.btn-gradient-alternate.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(131, 88, 138, 0.5), 0 0.0625rem 0.125rem rgba(131, 88, 138, 0.6);
}

.btn-gradient-light {
  background-image: linear-gradient(140deg, rgb(199.75, 199.75, 199.75) -30%, #eeeeee 90%);
  background-color: rgb(199.75, 199.75, 199.75);
  border-color: rgb(199.75, 199.75, 199.75);
  color: color-yiq(rgb(174.25, 174.25, 174.25));
}
.btn-gradient-light.active, .btn-gradient-light:active, .btn-gradient-light:not(:disabled):not(.disabled):hover {
  background-image: linear-gradient(120deg, rgb(192.1, 192.1, 192.1) 0%, rgb(230.35, 230.35, 230.35) 100%);
  color: color-yiq(rgb(174.25, 174.25, 174.25));
  border-color: rgb(174.25, 174.25, 174.25);
}
.btn-gradient-light:focus, .btn-gradient-light.focus, .btn-gradient-light:active, .btn-gradient-light.active {
  color: color-yiq(rgb(174.25, 174.25, 174.25)) !important;
  border-color: #bbbbbb !important;
}
.btn-gradient-light.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(238, 238, 238, 0.4), 0 0.0625rem 0.125rem rgba(238, 238, 238, 0.5);
}
.btn-gradient-light.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(238, 238, 238, 0.5), 0 0.0625rem 0.125rem rgba(238, 238, 238, 0.6);
}

.btn-gradient-dark {
  background-image: linear-gradient(140deg, rgb(17.7068965517, 19.75, 21.7931034483) -30%, #343a40 90%);
  background-color: rgb(17.7068965517, 19.75, 21.7931034483);
  border-color: rgb(17.7068965517, 19.75, 21.7931034483);
  color: color-yiq(black);
}
.btn-gradient-dark.active, .btn-gradient-dark:active, .btn-gradient-dark:not(:disabled):not(.disabled):hover {
  background-image: linear-gradient(120deg, rgb(10.8482758621, 12.1, 13.3517241379) 0%, rgb(45.1413793103, 50.35, 55.5586206897) 100%);
  color: color-yiq(black);
  border-color: black;
}
.btn-gradient-dark:focus, .btn-gradient-dark.focus, .btn-gradient-dark:active, .btn-gradient-dark.active {
  color: color-yiq(black) !important;
  border-color: rgb(6.275862069, 7, 7.724137931) !important;
}
.btn-gradient-dark.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(52, 58, 64, 0.4), 0 0.0625rem 0.125rem rgba(52, 58, 64, 0.5);
}
.btn-gradient-dark.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(52, 58, 64, 0.5), 0 0.0625rem 0.125rem rgba(52, 58, 64, 0.6);
}

.btn-shadow.active {
  box-shadow: 0 0 0 0 transparent !important;
}

.btn-primary {
  color: #fff;
  background-color: #545cd8;
  border-color: #545cd8;
}
.btn-primary:hover {
  color: #fff;
  background-color: rgb(71.4, 78.2, 183.6);
  border-color: rgb(67.2, 73.6, 172.8);
}
.btn-check:focus + .btn-primary, .btn-primary:focus {
  color: #fff;
  background-color: rgb(71.4, 78.2, 183.6);
  border-color: rgb(67.2, 73.6, 172.8);
  box-shadow: 0 0 0 0 rgba(109.65, 116.45, 221.85, 0.5);
}
.btn-check:checked + .btn-primary, .btn-check:active + .btn-primary, .btn-primary:active, .btn-primary.active, .show > .btn-primary.dropdown-toggle {
  color: #fff;
  background-color: rgb(67.2, 73.6, 172.8);
  border-color: #3f45a2;
}
.btn-check:checked + .btn-primary:focus, .btn-check:active + .btn-primary:focus, .btn-primary:active:focus, .btn-primary.active:focus, .show > .btn-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(109.65, 116.45, 221.85, 0.5);
}
.btn-primary:disabled, .btn-primary.disabled {
  color: #fff;
  background-color: #545cd8;
  border-color: #545cd8;
}
.btn-primary.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(84, 92, 216, 0.4), 0 0.0625rem 0.125rem rgba(84, 92, 216, 0.5);
}
.btn-primary.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(84, 92, 216, 0.5), 0 0.0625rem 0.125rem rgba(84, 92, 216, 0.6);
}

.btn-secondary {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.btn-secondary:hover {
  color: #fff;
  background-color: rgb(91.8, 99.45, 106.25);
  border-color: rgb(86.4, 93.6, 100);
}
.btn-check:focus + .btn-secondary, .btn-secondary:focus {
  color: #fff;
  background-color: rgb(91.8, 99.45, 106.25);
  border-color: rgb(86.4, 93.6, 100);
  box-shadow: 0 0 0 0 rgba(130.05, 137.7, 144.5, 0.5);
}
.btn-check:checked + .btn-secondary, .btn-check:active + .btn-secondary, .btn-secondary:active, .btn-secondary.active, .show > .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: rgb(86.4, 93.6, 100);
  border-color: rgb(81, 87.75, 93.75);
}
.btn-check:checked + .btn-secondary:focus, .btn-check:active + .btn-secondary:focus, .btn-secondary:active:focus, .btn-secondary.active:focus, .show > .btn-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(130.05, 137.7, 144.5, 0.5);
}
.btn-secondary:disabled, .btn-secondary.disabled {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.btn-secondary.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(108, 117, 125, 0.4), 0 0.0625rem 0.125rem rgba(108, 117, 125, 0.5);
}
.btn-secondary.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(108, 117, 125, 0.5), 0 0.0625rem 0.125rem rgba(108, 117, 125, 0.6);
}

.btn-success {
  color: #000;
  background-color: #3ac47d;
  border-color: #3ac47d;
}
.btn-success:hover {
  color: #000;
  background-color: rgb(87.55, 204.85, 144.5);
  border-color: rgb(77.7, 201.9, 138);
}
.btn-check:focus + .btn-success, .btn-success:focus {
  color: #000;
  background-color: rgb(87.55, 204.85, 144.5);
  border-color: rgb(77.7, 201.9, 138);
  box-shadow: 0 0 0 0 rgba(49.3, 166.6, 106.25, 0.5);
}
.btn-check:checked + .btn-success, .btn-check:active + .btn-success, .btn-success:active, .btn-success.active, .show > .btn-success.dropdown-toggle {
  color: #000;
  background-color: rgb(97.4, 207.8, 151);
  border-color: rgb(77.7, 201.9, 138);
}
.btn-check:checked + .btn-success:focus, .btn-check:active + .btn-success:focus, .btn-success:active:focus, .btn-success.active:focus, .show > .btn-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(49.3, 166.6, 106.25, 0.5);
}
.btn-success:disabled, .btn-success.disabled {
  color: #000;
  background-color: #3ac47d;
  border-color: #3ac47d;
}
.btn-success.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(58, 196, 125, 0.4), 0 0.0625rem 0.125rem rgba(58, 196, 125, 0.5);
}
.btn-success.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(58, 196, 125, 0.5), 0 0.0625rem 0.125rem rgba(58, 196, 125, 0.6);
}

.btn-info {
  color: #000;
  background-color: #30b1ff;
  border-color: #30b1ff;
}
.btn-info:hover {
  color: #000;
  background-color: rgb(79.05, 188.7, 255);
  border-color: rgb(68.7, 184.8, 255);
}
.btn-check:focus + .btn-info, .btn-info:focus {
  color: #000;
  background-color: rgb(79.05, 188.7, 255);
  border-color: rgb(68.7, 184.8, 255);
  box-shadow: 0 0 0 0 rgba(40.8, 150.45, 216.75, 0.5);
}
.btn-check:checked + .btn-info, .btn-check:active + .btn-info, .btn-info:active, .btn-info.active, .show > .btn-info.dropdown-toggle {
  color: #000;
  background-color: rgb(89.4, 192.6, 255);
  border-color: rgb(68.7, 184.8, 255);
}
.btn-check:checked + .btn-info:focus, .btn-check:active + .btn-info:focus, .btn-info:active:focus, .btn-info.active:focus, .show > .btn-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(40.8, 150.45, 216.75, 0.5);
}
.btn-info:disabled, .btn-info.disabled {
  color: #000;
  background-color: #30b1ff;
  border-color: #30b1ff;
}
.btn-info.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(48, 177, 255, 0.4), 0 0.0625rem 0.125rem rgba(48, 177, 255, 0.5);
}
.btn-info.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(48, 177, 255, 0.5), 0 0.0625rem 0.125rem rgba(48, 177, 255, 0.6);
}

.btn-warning {
  color: #000;
  background-color: #f7b924;
  border-color: #f7b924;
}
.btn-warning:hover {
  color: #000;
  background-color: rgb(248.2, 195.5, 68.85);
  border-color: rgb(247.8, 192, 57.9);
}
.btn-check:focus + .btn-warning, .btn-warning:focus {
  color: #000;
  background-color: rgb(248.2, 195.5, 68.85);
  border-color: rgb(247.8, 192, 57.9);
  box-shadow: 0 0 0 0 rgba(209.95, 157.25, 30.6, 0.5);
}
.btn-check:checked + .btn-warning, .btn-check:active + .btn-warning, .btn-warning:active, .btn-warning.active, .show > .btn-warning.dropdown-toggle {
  color: #000;
  background-color: rgb(248.6, 199, 79.8);
  border-color: rgb(247.8, 192, 57.9);
}
.btn-check:checked + .btn-warning:focus, .btn-check:active + .btn-warning:focus, .btn-warning:active:focus, .btn-warning.active:focus, .show > .btn-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(209.95, 157.25, 30.6, 0.5);
}
.btn-warning:disabled, .btn-warning.disabled {
  color: #000;
  background-color: #f7b924;
  border-color: #f7b924;
}
.btn-warning.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(247, 185, 36, 0.4), 0 0.0625rem 0.125rem rgba(247, 185, 36, 0.5);
}
.btn-warning.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(247, 185, 36, 0.5), 0 0.0625rem 0.125rem rgba(247, 185, 36, 0.6);
}

.btn-danger {
  color: #fff;
  background-color: #d92550;
  border-color: #d92550;
}
.btn-danger:hover {
  color: #fff;
  background-color: rgb(184.45, 31.45, 68);
  border-color: rgb(173.6, 29.6, 64);
}
.btn-check:focus + .btn-danger, .btn-danger:focus {
  color: #fff;
  background-color: rgb(184.45, 31.45, 68);
  border-color: rgb(173.6, 29.6, 64);
  box-shadow: 0 0 0 0 rgba(222.7, 69.7, 106.25, 0.5);
}
.btn-check:checked + .btn-danger, .btn-check:active + .btn-danger, .btn-danger:active, .btn-danger.active, .show > .btn-danger.dropdown-toggle {
  color: #fff;
  background-color: rgb(173.6, 29.6, 64);
  border-color: rgb(162.75, 27.75, 60);
}
.btn-check:checked + .btn-danger:focus, .btn-check:active + .btn-danger:focus, .btn-danger:active:focus, .btn-danger.active:focus, .show > .btn-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(222.7, 69.7, 106.25, 0.5);
}
.btn-danger:disabled, .btn-danger.disabled {
  color: #fff;
  background-color: #d92550;
  border-color: #d92550;
}
.btn-danger.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(217, 37, 80, 0.4), 0 0.0625rem 0.125rem rgba(217, 37, 80, 0.5);
}
.btn-danger.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(217, 37, 80, 0.5), 0 0.0625rem 0.125rem rgba(217, 37, 80, 0.6);
}

.btn-light {
  color: #000;
  background-color: #eeeeee;
  border-color: #eeeeee;
}
.btn-light:hover {
  color: #000;
  background-color: rgb(240.55, 240.55, 240.55);
  border-color: rgb(239.7, 239.7, 239.7);
}
.btn-check:focus + .btn-light, .btn-light:focus {
  color: #000;
  background-color: rgb(240.55, 240.55, 240.55);
  border-color: rgb(239.7, 239.7, 239.7);
  box-shadow: 0 0 0 0 rgba(202.3, 202.3, 202.3, 0.5);
}
.btn-check:checked + .btn-light, .btn-check:active + .btn-light, .btn-light:active, .btn-light.active, .show > .btn-light.dropdown-toggle {
  color: #000;
  background-color: rgb(241.4, 241.4, 241.4);
  border-color: rgb(239.7, 239.7, 239.7);
}
.btn-check:checked + .btn-light:focus, .btn-check:active + .btn-light:focus, .btn-light:active:focus, .btn-light.active:focus, .show > .btn-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(202.3, 202.3, 202.3, 0.5);
}
.btn-light:disabled, .btn-light.disabled {
  color: #000;
  background-color: #eeeeee;
  border-color: #eeeeee;
}
.btn-light.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(238, 238, 238, 0.4), 0 0.0625rem 0.125rem rgba(238, 238, 238, 0.5);
}
.btn-light.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(238, 238, 238, 0.5), 0 0.0625rem 0.125rem rgba(238, 238, 238, 0.6);
}

.btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-dark:hover {
  color: #fff;
  background-color: rgb(44.2, 49.3, 54.4);
  border-color: rgb(41.6, 46.4, 51.2);
}
.btn-check:focus + .btn-dark, .btn-dark:focus {
  color: #fff;
  background-color: rgb(44.2, 49.3, 54.4);
  border-color: rgb(41.6, 46.4, 51.2);
  box-shadow: 0 0 0 0 rgba(82.45, 87.55, 92.65, 0.5);
}
.btn-check:checked + .btn-dark, .btn-check:active + .btn-dark, .btn-dark:active, .btn-dark.active, .show > .btn-dark.dropdown-toggle {
  color: #fff;
  background-color: rgb(41.6, 46.4, 51.2);
  border-color: rgb(39, 43.5, 48);
}
.btn-check:checked + .btn-dark:focus, .btn-check:active + .btn-dark:focus, .btn-dark:active:focus, .btn-dark.active:focus, .show > .btn-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(82.45, 87.55, 92.65, 0.5);
}
.btn-dark:disabled, .btn-dark.disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-dark.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(52, 58, 64, 0.4), 0 0.0625rem 0.125rem rgba(52, 58, 64, 0.5);
}
.btn-dark.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(52, 58, 64, 0.5), 0 0.0625rem 0.125rem rgba(52, 58, 64, 0.6);
}

.btn-focus {
  color: #fff;
  background-color: #444054;
  border-color: #444054;
}
.btn-focus:hover {
  color: #fff;
  background-color: rgb(57.8, 54.4, 71.4);
  border-color: rgb(54.4, 51.2, 67.2);
}
.btn-check:focus + .btn-focus, .btn-focus:focus {
  color: #fff;
  background-color: rgb(57.8, 54.4, 71.4);
  border-color: rgb(54.4, 51.2, 67.2);
  box-shadow: 0 0 0 0 rgba(96.05, 92.65, 109.65, 0.5);
}
.btn-check:checked + .btn-focus, .btn-check:active + .btn-focus, .btn-focus:active, .btn-focus.active, .show > .btn-focus.dropdown-toggle {
  color: #fff;
  background-color: rgb(54.4, 51.2, 67.2);
  border-color: #33303f;
}
.btn-check:checked + .btn-focus:focus, .btn-check:active + .btn-focus:focus, .btn-focus:active:focus, .btn-focus.active:focus, .show > .btn-focus.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(96.05, 92.65, 109.65, 0.5);
}
.btn-focus:disabled, .btn-focus.disabled {
  color: #fff;
  background-color: #444054;
  border-color: #444054;
}
.btn-focus.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(68, 64, 84, 0.4), 0 0.0625rem 0.125rem rgba(68, 64, 84, 0.5);
}
.btn-focus.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(68, 64, 84, 0.5), 0 0.0625rem 0.125rem rgba(68, 64, 84, 0.6);
}

.btn-alternate {
  color: #fff;
  background-color: #83588a;
  border-color: #83588a;
}
.btn-alternate:hover {
  color: #fff;
  background-color: rgb(111.35, 74.8, 117.3);
  border-color: rgb(104.8, 70.4, 110.4);
}
.btn-check:focus + .btn-alternate, .btn-alternate:focus {
  color: #fff;
  background-color: rgb(111.35, 74.8, 117.3);
  border-color: rgb(104.8, 70.4, 110.4);
  box-shadow: 0 0 0 0 rgba(149.6, 113.05, 155.55, 0.5);
}
.btn-check:checked + .btn-alternate, .btn-check:active + .btn-alternate, .btn-alternate:active, .btn-alternate.active, .show > .btn-alternate.dropdown-toggle {
  color: #fff;
  background-color: rgb(104.8, 70.4, 110.4);
  border-color: rgb(98.25, 66, 103.5);
}
.btn-check:checked + .btn-alternate:focus, .btn-check:active + .btn-alternate:focus, .btn-alternate:active:focus, .btn-alternate.active:focus, .show > .btn-alternate.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(149.6, 113.05, 155.55, 0.5);
}
.btn-alternate:disabled, .btn-alternate.disabled {
  color: #fff;
  background-color: #83588a;
  border-color: #83588a;
}
.btn-alternate.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(131, 88, 138, 0.4), 0 0.0625rem 0.125rem rgba(131, 88, 138, 0.5);
}
.btn-alternate.btn-shadow:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(131, 88, 138, 0.5), 0 0.0625rem 0.125rem rgba(131, 88, 138, 0.6);
}

.btn-shadow-primary:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(84, 92, 216, 0.4), 0 0.0625rem 0.125rem rgba(84, 92, 216, 0.5);
}

.btn-shadow-secondary:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(108, 117, 125, 0.4), 0 0.0625rem 0.125rem rgba(108, 117, 125, 0.5);
}

.btn-shadow-success:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(58, 196, 125, 0.4), 0 0.0625rem 0.125rem rgba(58, 196, 125, 0.5);
}

.btn-shadow-info:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(48, 177, 255, 0.4), 0 0.0625rem 0.125rem rgba(48, 177, 255, 0.5);
}

.btn-shadow-warning:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(247, 185, 36, 0.4), 0 0.0625rem 0.125rem rgba(247, 185, 36, 0.5);
}

.btn-shadow-danger:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(217, 37, 80, 0.4), 0 0.0625rem 0.125rem rgba(217, 37, 80, 0.5);
}

.btn-shadow-light:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(238, 238, 238, 0.4), 0 0.0625rem 0.125rem rgba(238, 238, 238, 0.5);
}

.btn-shadow-dark:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(52, 58, 64, 0.4), 0 0.0625rem 0.125rem rgba(52, 58, 64, 0.5);
}

.btn-shadow-focus:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(68, 64, 84, 0.4), 0 0.0625rem 0.125rem rgba(68, 64, 84, 0.5);
}

.btn-shadow-alternate:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(131, 88, 138, 0.4), 0 0.0625rem 0.125rem rgba(131, 88, 138, 0.5);
}

.btn-outline-primary {
  color: #545cd8;
  border-color: #545cd8;
}
.btn-outline-primary:hover {
  color: #fff;
  background-color: #545cd8;
  border-color: #545cd8;
}
.btn-check:focus + .btn-outline-primary, .btn-outline-primary:focus {
  box-shadow: 0 0 0 0 rgba(84, 92, 216, 0.5);
}
.btn-check:checked + .btn-outline-primary, .btn-check:active + .btn-outline-primary, .btn-outline-primary:active, .btn-outline-primary.active, .btn-outline-primary.dropdown-toggle.show {
  color: #fff;
  background-color: #545cd8;
  border-color: #545cd8;
}
.btn-check:checked + .btn-outline-primary:focus, .btn-check:active + .btn-outline-primary:focus, .btn-outline-primary:active:focus, .btn-outline-primary.active:focus, .btn-outline-primary.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(84, 92, 216, 0.5);
}
.btn-outline-primary:disabled, .btn-outline-primary.disabled {
  color: #545cd8;
  background-color: transparent;
}
.btn-outline-primary.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(84, 92, 216, 0.4), 0 0.0625rem 0.125rem rgba(84, 92, 216, 0.5);
}
.btn-outline-primary.btn-shadow.active:hover, .btn-outline-primary.btn-shadow.disabled:hover, .btn-outline-primary.btn-shadow:active:hover, .btn-outline-primary.btn-shadow:disabled:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(84, 92, 216, 0.5), 0 0.0625rem 0.125rem rgba(84, 92, 216, 0.6);
}
.btn-outline-primary.btn-shadow:hover {
  box-shadow: 0px 5px 15px 2px rgba(84, 92, 216, 0.19);
}

.btn-outline-secondary {
  color: #6c757d;
  border-color: #6c757d;
}
.btn-outline-secondary:hover {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.btn-check:focus + .btn-outline-secondary, .btn-outline-secondary:focus {
  box-shadow: 0 0 0 0 rgba(108, 117, 125, 0.5);
}
.btn-check:checked + .btn-outline-secondary, .btn-check:active + .btn-outline-secondary, .btn-outline-secondary:active, .btn-outline-secondary.active, .btn-outline-secondary.dropdown-toggle.show {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.btn-check:checked + .btn-outline-secondary:focus, .btn-check:active + .btn-outline-secondary:focus, .btn-outline-secondary:active:focus, .btn-outline-secondary.active:focus, .btn-outline-secondary.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(108, 117, 125, 0.5);
}
.btn-outline-secondary:disabled, .btn-outline-secondary.disabled {
  color: #6c757d;
  background-color: transparent;
}
.btn-outline-secondary.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(108, 117, 125, 0.4), 0 0.0625rem 0.125rem rgba(108, 117, 125, 0.5);
}
.btn-outline-secondary.btn-shadow.active:hover, .btn-outline-secondary.btn-shadow.disabled:hover, .btn-outline-secondary.btn-shadow:active:hover, .btn-outline-secondary.btn-shadow:disabled:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(108, 117, 125, 0.5), 0 0.0625rem 0.125rem rgba(108, 117, 125, 0.6);
}
.btn-outline-secondary.btn-shadow:hover {
  box-shadow: 0px 5px 15px 2px rgba(108, 117, 125, 0.19);
}

.btn-outline-success {
  color: #3ac47d;
  border-color: #3ac47d;
}
.btn-outline-success:hover {
  color: #000;
  background-color: #3ac47d;
  border-color: #3ac47d;
}
.btn-check:focus + .btn-outline-success, .btn-outline-success:focus {
  box-shadow: 0 0 0 0 rgba(58, 196, 125, 0.5);
}
.btn-check:checked + .btn-outline-success, .btn-check:active + .btn-outline-success, .btn-outline-success:active, .btn-outline-success.active, .btn-outline-success.dropdown-toggle.show {
  color: #000;
  background-color: #3ac47d;
  border-color: #3ac47d;
}
.btn-check:checked + .btn-outline-success:focus, .btn-check:active + .btn-outline-success:focus, .btn-outline-success:active:focus, .btn-outline-success.active:focus, .btn-outline-success.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(58, 196, 125, 0.5);
}
.btn-outline-success:disabled, .btn-outline-success.disabled {
  color: #3ac47d;
  background-color: transparent;
}
.btn-outline-success.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(58, 196, 125, 0.4), 0 0.0625rem 0.125rem rgba(58, 196, 125, 0.5);
}
.btn-outline-success.btn-shadow.active:hover, .btn-outline-success.btn-shadow.disabled:hover, .btn-outline-success.btn-shadow:active:hover, .btn-outline-success.btn-shadow:disabled:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(58, 196, 125, 0.5), 0 0.0625rem 0.125rem rgba(58, 196, 125, 0.6);
}
.btn-outline-success.btn-shadow:hover {
  box-shadow: 0px 5px 15px 2px rgba(58, 196, 125, 0.19);
}

.btn-outline-info {
  color: #30b1ff;
  border-color: #30b1ff;
}
.btn-outline-info:hover {
  color: #000;
  background-color: #30b1ff;
  border-color: #30b1ff;
}
.btn-check:focus + .btn-outline-info, .btn-outline-info:focus {
  box-shadow: 0 0 0 0 rgba(48, 177, 255, 0.5);
}
.btn-check:checked + .btn-outline-info, .btn-check:active + .btn-outline-info, .btn-outline-info:active, .btn-outline-info.active, .btn-outline-info.dropdown-toggle.show {
  color: #000;
  background-color: #30b1ff;
  border-color: #30b1ff;
}
.btn-check:checked + .btn-outline-info:focus, .btn-check:active + .btn-outline-info:focus, .btn-outline-info:active:focus, .btn-outline-info.active:focus, .btn-outline-info.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(48, 177, 255, 0.5);
}
.btn-outline-info:disabled, .btn-outline-info.disabled {
  color: #30b1ff;
  background-color: transparent;
}
.btn-outline-info.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(48, 177, 255, 0.4), 0 0.0625rem 0.125rem rgba(48, 177, 255, 0.5);
}
.btn-outline-info.btn-shadow.active:hover, .btn-outline-info.btn-shadow.disabled:hover, .btn-outline-info.btn-shadow:active:hover, .btn-outline-info.btn-shadow:disabled:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(48, 177, 255, 0.5), 0 0.0625rem 0.125rem rgba(48, 177, 255, 0.6);
}
.btn-outline-info.btn-shadow:hover {
  box-shadow: 0px 5px 15px 2px rgba(48, 177, 255, 0.19);
}

.btn-outline-warning {
  color: #f7b924;
  border-color: #f7b924;
}
.btn-outline-warning:hover {
  color: #000;
  background-color: #f7b924;
  border-color: #f7b924;
}
.btn-check:focus + .btn-outline-warning, .btn-outline-warning:focus {
  box-shadow: 0 0 0 0 rgba(247, 185, 36, 0.5);
}
.btn-check:checked + .btn-outline-warning, .btn-check:active + .btn-outline-warning, .btn-outline-warning:active, .btn-outline-warning.active, .btn-outline-warning.dropdown-toggle.show {
  color: #000;
  background-color: #f7b924;
  border-color: #f7b924;
}
.btn-check:checked + .btn-outline-warning:focus, .btn-check:active + .btn-outline-warning:focus, .btn-outline-warning:active:focus, .btn-outline-warning.active:focus, .btn-outline-warning.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(247, 185, 36, 0.5);
}
.btn-outline-warning:disabled, .btn-outline-warning.disabled {
  color: #f7b924;
  background-color: transparent;
}
.btn-outline-warning.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(247, 185, 36, 0.4), 0 0.0625rem 0.125rem rgba(247, 185, 36, 0.5);
}
.btn-outline-warning.btn-shadow.active:hover, .btn-outline-warning.btn-shadow.disabled:hover, .btn-outline-warning.btn-shadow:active:hover, .btn-outline-warning.btn-shadow:disabled:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(247, 185, 36, 0.5), 0 0.0625rem 0.125rem rgba(247, 185, 36, 0.6);
}
.btn-outline-warning.btn-shadow:hover {
  box-shadow: 0px 5px 15px 2px rgba(247, 185, 36, 0.19);
}

.btn-outline-danger {
  color: #d92550;
  border-color: #d92550;
}
.btn-outline-danger:hover {
  color: #fff;
  background-color: #d92550;
  border-color: #d92550;
}
.btn-check:focus + .btn-outline-danger, .btn-outline-danger:focus {
  box-shadow: 0 0 0 0 rgba(217, 37, 80, 0.5);
}
.btn-check:checked + .btn-outline-danger, .btn-check:active + .btn-outline-danger, .btn-outline-danger:active, .btn-outline-danger.active, .btn-outline-danger.dropdown-toggle.show {
  color: #fff;
  background-color: #d92550;
  border-color: #d92550;
}
.btn-check:checked + .btn-outline-danger:focus, .btn-check:active + .btn-outline-danger:focus, .btn-outline-danger:active:focus, .btn-outline-danger.active:focus, .btn-outline-danger.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(217, 37, 80, 0.5);
}
.btn-outline-danger:disabled, .btn-outline-danger.disabled {
  color: #d92550;
  background-color: transparent;
}
.btn-outline-danger.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(217, 37, 80, 0.4), 0 0.0625rem 0.125rem rgba(217, 37, 80, 0.5);
}
.btn-outline-danger.btn-shadow.active:hover, .btn-outline-danger.btn-shadow.disabled:hover, .btn-outline-danger.btn-shadow:active:hover, .btn-outline-danger.btn-shadow:disabled:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(217, 37, 80, 0.5), 0 0.0625rem 0.125rem rgba(217, 37, 80, 0.6);
}
.btn-outline-danger.btn-shadow:hover {
  box-shadow: 0px 5px 15px 2px rgba(217, 37, 80, 0.19);
}

.btn-outline-light {
  color: #eeeeee;
  border-color: #eeeeee;
}
.btn-outline-light:hover {
  color: #000;
  background-color: #eeeeee;
  border-color: #eeeeee;
}
.btn-check:focus + .btn-outline-light, .btn-outline-light:focus {
  box-shadow: 0 0 0 0 rgba(238, 238, 238, 0.5);
}
.btn-check:checked + .btn-outline-light, .btn-check:active + .btn-outline-light, .btn-outline-light:active, .btn-outline-light.active, .btn-outline-light.dropdown-toggle.show {
  color: #000;
  background-color: #eeeeee;
  border-color: #eeeeee;
}
.btn-check:checked + .btn-outline-light:focus, .btn-check:active + .btn-outline-light:focus, .btn-outline-light:active:focus, .btn-outline-light.active:focus, .btn-outline-light.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(238, 238, 238, 0.5);
}
.btn-outline-light:disabled, .btn-outline-light.disabled {
  color: #eeeeee;
  background-color: transparent;
}
.btn-outline-light.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(238, 238, 238, 0.4), 0 0.0625rem 0.125rem rgba(238, 238, 238, 0.5);
}
.btn-outline-light.btn-shadow.active:hover, .btn-outline-light.btn-shadow.disabled:hover, .btn-outline-light.btn-shadow:active:hover, .btn-outline-light.btn-shadow:disabled:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(238, 238, 238, 0.5), 0 0.0625rem 0.125rem rgba(238, 238, 238, 0.6);
}
.btn-outline-light.btn-shadow:hover {
  box-shadow: 0px 5px 15px 2px rgba(238, 238, 238, 0.19);
}

.btn-outline-dark {
  color: #343a40;
  border-color: #343a40;
}
.btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-check:focus + .btn-outline-dark, .btn-outline-dark:focus {
  box-shadow: 0 0 0 0 rgba(52, 58, 64, 0.5);
}
.btn-check:checked + .btn-outline-dark, .btn-check:active + .btn-outline-dark, .btn-outline-dark:active, .btn-outline-dark.active, .btn-outline-dark.dropdown-toggle.show {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-check:checked + .btn-outline-dark:focus, .btn-check:active + .btn-outline-dark:focus, .btn-outline-dark:active:focus, .btn-outline-dark.active:focus, .btn-outline-dark.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(52, 58, 64, 0.5);
}
.btn-outline-dark:disabled, .btn-outline-dark.disabled {
  color: #343a40;
  background-color: transparent;
}
.btn-outline-dark.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(52, 58, 64, 0.4), 0 0.0625rem 0.125rem rgba(52, 58, 64, 0.5);
}
.btn-outline-dark.btn-shadow.active:hover, .btn-outline-dark.btn-shadow.disabled:hover, .btn-outline-dark.btn-shadow:active:hover, .btn-outline-dark.btn-shadow:disabled:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(52, 58, 64, 0.5), 0 0.0625rem 0.125rem rgba(52, 58, 64, 0.6);
}
.btn-outline-dark.btn-shadow:hover {
  box-shadow: 0px 5px 15px 2px rgba(52, 58, 64, 0.19);
}

.btn-outline-focus {
  color: #444054;
  border-color: #444054;
}
.btn-outline-focus:hover {
  color: #fff;
  background-color: #444054;
  border-color: #444054;
}
.btn-check:focus + .btn-outline-focus, .btn-outline-focus:focus {
  box-shadow: 0 0 0 0 rgba(68, 64, 84, 0.5);
}
.btn-check:checked + .btn-outline-focus, .btn-check:active + .btn-outline-focus, .btn-outline-focus:active, .btn-outline-focus.active, .btn-outline-focus.dropdown-toggle.show {
  color: #fff;
  background-color: #444054;
  border-color: #444054;
}
.btn-check:checked + .btn-outline-focus:focus, .btn-check:active + .btn-outline-focus:focus, .btn-outline-focus:active:focus, .btn-outline-focus.active:focus, .btn-outline-focus.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(68, 64, 84, 0.5);
}
.btn-outline-focus:disabled, .btn-outline-focus.disabled {
  color: #444054;
  background-color: transparent;
}
.btn-outline-focus.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(68, 64, 84, 0.4), 0 0.0625rem 0.125rem rgba(68, 64, 84, 0.5);
}
.btn-outline-focus.btn-shadow.active:hover, .btn-outline-focus.btn-shadow.disabled:hover, .btn-outline-focus.btn-shadow:active:hover, .btn-outline-focus.btn-shadow:disabled:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(68, 64, 84, 0.5), 0 0.0625rem 0.125rem rgba(68, 64, 84, 0.6);
}
.btn-outline-focus.btn-shadow:hover {
  box-shadow: 0px 5px 15px 2px rgba(68, 64, 84, 0.19);
}

.btn-outline-alternate {
  color: #83588a;
  border-color: #83588a;
}
.btn-outline-alternate:hover {
  color: #fff;
  background-color: #83588a;
  border-color: #83588a;
}
.btn-check:focus + .btn-outline-alternate, .btn-outline-alternate:focus {
  box-shadow: 0 0 0 0 rgba(131, 88, 138, 0.5);
}
.btn-check:checked + .btn-outline-alternate, .btn-check:active + .btn-outline-alternate, .btn-outline-alternate:active, .btn-outline-alternate.active, .btn-outline-alternate.dropdown-toggle.show {
  color: #fff;
  background-color: #83588a;
  border-color: #83588a;
}
.btn-check:checked + .btn-outline-alternate:focus, .btn-check:active + .btn-outline-alternate:focus, .btn-outline-alternate:active:focus, .btn-outline-alternate.active:focus, .btn-outline-alternate.dropdown-toggle.show:focus {
  box-shadow: 0 0 0 0 rgba(131, 88, 138, 0.5);
}
.btn-outline-alternate:disabled, .btn-outline-alternate.disabled {
  color: #83588a;
  background-color: transparent;
}
.btn-outline-alternate.btn-shadow {
  box-shadow: 0 0.125rem 0.625rem rgba(131, 88, 138, 0.4), 0 0.0625rem 0.125rem rgba(131, 88, 138, 0.5);
}
.btn-outline-alternate.btn-shadow.active:hover, .btn-outline-alternate.btn-shadow.disabled:hover, .btn-outline-alternate.btn-shadow:active:hover, .btn-outline-alternate.btn-shadow:disabled:hover {
  box-shadow: 0 0.125rem 0.625rem rgba(131, 88, 138, 0.5), 0 0.0625rem 0.125rem rgba(131, 88, 138, 0.6);
}
.btn-outline-alternate.btn-shadow:hover {
  box-shadow: 0px 5px 15px 2px rgba(131, 88, 138, 0.19);
}

.btn {
  position: relative;
  transition: color 0.15s, background-color 0.15s, border-color 0.15s, box-shadow 0.15s;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}

.btn-light {
  border-color: rgb(219.5, 219.5, 219.5);
}

.btn-outline-light {
  color: #8f8f8f;
}

.dropdown-menu {
  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);
  font-size: 0.88rem;
  margin: 0.125rem;
}
.dropdown-menu.dropdown-menu-right {
  right: 0 !important;
}
.dropdown-menu .dropdown-header {
  text-transform: uppercase;
  font-size: 0.7333333333rem;
  color: #545cd8;
  font-weight: bold;
}
.dropdown-menu .dropdown-item {
  font-size: 0.88rem;
  display: flex;
  align-items: center;
  transition: background-color 0.3s ease, color 0.3s ease;
  cursor: pointer;
  z-index: 6;
  position: relative;
}
.dropdown-menu .dropdown-item .dropdown-icon {
  font-size: 1rem;
  margin-right: 0.325rem;
  width: 30px;
  text-align: center;
  opacity: 0.3;
  margin-left: -10px;
}
.dropdown-menu .dropdown-item:hover .dropdown-icon {
  opacity: 0.7;
}
.dropdown-menu.dropdown-menu-shadow {
  box-shadow: 0 0.66875rem 2.3875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 1.1375rem 1.60625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.45rem 0.73125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.325rem 0.3875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);
}

.dropdown-menu-rounded {
  border-radius: 10px;
  padding: 0.65rem;
}
.dropdown-menu-rounded .dropdown-item {
  border-radius: 30px;
}
.dropdown-menu-rounded .dropdown-divider {
  margin-left: -0.65rem;
  margin-right: -0.65rem;
}
.dropdown-menu-rounded .dropdown-menu-header {
  margin-left: -0.65rem;
  margin-right: -0.65rem;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.dropdown-menu-rounded .menu-header-image,
.dropdown-menu-rounded .dropdown-menu-header-inner {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.dropdown-menu-hover-link .dropdown-item:hover {
  background: none;
  color: #545cd8;
}

.dropdown-menu-hover-primary .dropdown-item:hover {
  background: #545cd8;
  color: #fff;
}

.dropdown-menu.dropdown-menu-lg {
  min-width: 22rem;
}
.dropdown-menu.dropdown-menu-xl {
  min-width: 25rem;
}

.dropdown-menu .dropdown-menu-header,
.dropdown-menu .menu-header-image,
.dropdown-menu .dropdown-menu-header-inner {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}

.dropdown-menu-header {
  color: #fff;
  margin-top: -0.65rem;
  margin-bottom: 0.65rem;
  position: relative;
  z-index: 6;
}
.dropdown-menu-header .dropdown-menu-header-inner {
  margin: -1px -1px 0;
  padding: 1.5rem 0.5rem;
  position: relative;
}
.dropdown-menu-header .menu-header-image {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: 8;
  opacity: 0.25;
  filter: grayscale(80%);
  background-size: cover;
}
.dropdown-menu-header .menu-header-content {
  text-align: center;
  position: relative;
  z-index: 10;
}
.dropdown-menu-header .menu-header-content.text-start {
  padding-left: 0.5rem;
}
.dropdown-menu-header .menu-header-content.btn-pane-right {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  display: flex;
  align-content: center;
  align-items: center;
  text-align: left;
}
.dropdown-menu-header .menu-header-content.btn-pane-right .menu-header-btn-pane {
  margin: 0 0 0 auto;
}
.dropdown-menu-header .menu-header-content .menu-header-btn-pane {
  margin-top: 10px;
  margin-bottom: 3px;
}
.dropdown-menu-header + .grid-menu {
  margin-top: -0.65rem;
}

.menu-header-title {
  font-weight: 500;
  font-size: 1.1rem;
  margin: 0;
}

.menu-header-subtitle {
  font-size: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-size: var(--bs-font-sans-serif);
  margin: 5px 0 0;
  opacity: 0.8;
}

.dropdown-menu .grid-menu {
  margin-bottom: -0.65rem;
  padding: 1px;
}
.dropdown-menu .grid-menu [class*=col-] {
  padding: 0.65rem;
}
.dropdown-menu .grid-menu-xl {
  margin-bottom: -0.4814814815rem;
}
.dropdown-menu .grid-menu-xl [class*=col-] {
  padding: 0;
}

.dropdown-toggle::after {
  position: relative;
  top: 2px;
  opacity: 0.8;
  margin-left: 5px;
}

.dropdown-toggle-split::after {
  margin-left: 0;
}

.dropright .dropdown-toggle::after {
  top: 0;
}

.dropdown-toggle-split {
  border-left: rgba(255, 255, 255, 0.1) solid 2px;
}

.dropdown-menu::before, .dropdown-menu::after {
  position: absolute;
  width: 14px;
  height: 14px;
  left: 5px;
  top: -5px;
  transform: rotate(45deg);
  border-radius: 4px;
  content: "";
  display: block;
  z-index: 5;
}
.dropdown-menu::before {
  background: #fff;
  z-index: 5;
}
.dropdown-menu::after {
  top: -6px;
  background: rgba(0, 0, 0, 0.15);
  z-index: 4;
}
.dropdown-menu[data-placement=top-start]::before, .dropdown-menu[data-placement=top-start]::after {
  top: auto;
  bottom: -5px;
}
.dropdown-menu[data-placement=top-start]::after {
  bottom: -6px;
}
.dropdown-menu[data-placement=left-start]::before, .dropdown-menu[data-placement=left-start]::after {
  left: auto;
  right: -5px;
  top: 5px;
}
.dropdown-menu[data-placement=left-start]::after {
  top: 5px;
  right: -6px;
}
.dropdown-menu[data-placement=right-start]::before, .dropdown-menu[data-placement=right-start]::after {
  right: auto;
  left: -5px;
  top: 5px;
}
.dropdown-menu[data-placement=right-start]::after {
  top: 5px;
  left: -6px;
}
.dropdown-menu.dropdown-menu-right::before, .dropdown-menu.dropdown-menu-right::after {
  left: auto;
  right: 6px;
}
.dropdown-menu.dropdown-menu-right::after {
  right: 6px;
}
.dropdown-menu.rm-pointers::before, .dropdown-menu.rm-pointers::after {
  display: none;
}

.dropdown-mega-menu {
  width: 56rem;
  padding: 1rem;
}
.dropdown-mega-menu .nav-item.nav-item-header {
  text-transform: none;
  font-size: 0.88rem;
  padding-top: 0;
  font-weight: normal;
}
.dropdown-mega-menu .grid-menu {
  margin-bottom: 0;
}

.dropdown-mega-menu-sm {
  width: 40rem;
}

body .dropdown-menu.dropdown-menu-inline {
  border: 0;
  position: static !important;
  box-shadow: 0 0 0 transparent;
  background: transparent;
  border-radius: 0;
  display: inline-block;
  float: none;
  left: 0 !important;
  top: 0 !important;
  width: 100% !important;
  transform: translateY(0) !important;
}
body .dropdown-menu.dropdown-menu-inline::before, body .dropdown-menu.dropdown-menu-inline::after {
  display: none;
}

.nav-item .nav-link {
  font-weight: normal;
}

.nav-link {
  display: flex;
  align-items: center;
  transition: background-color 0.3s ease, color 0.3s ease;
  cursor: pointer;
}
.nav-link .nav-link-icon {
  color: #545cd8;
  font-size: 1rem;
  width: 30px;
  text-align: center;
  opacity: 0.45;
  margin-left: -10px;
}
.nav-link:hover {
  color: #495057;
}
.nav-link:hover .nav-link-icon {
  opacity: 0.9;
  color: #545cd8;
}
.nav-link:disabled .nav-link-icon, .nav-link.disabled .nav-link-icon {
  opacity: 0.3;
}

.nav-item.nav-item-header {
  text-transform: uppercase;
  font-size: 0.7333333333rem;
  color: #6c757d;
  font-weight: bold;
  padding: 0.5rem 1rem;
}
.nav-item.nav-item-btn {
  padding: 0.5rem 1rem;
}
.nav-item.nav-item-divider {
  margin: 0.5rem 0;
  height: 1px;
  overflow: hidden;
  background: #dee2e6;
}

.nav .badge {
  margin-left: 8px;
}

.nav-pills .nav-link.active, .nav-pills .nav-link.active:hover {
  color: #fff;
}
.nav-pills .nav-link.active .nav-link-icon, .nav-pills .nav-link.active:hover .nav-link-icon {
  color: #fff;
  opacity: 0.8;
}
.nav-pills .nav-link:hover {
  color: #495057 !important;
}

.grid-menu [class*=col-] {
  border-right: #dee2e6 solid 0;
  border-bottom: #dee2e6 solid 1px;
}
.grid-menu [class*=col-]:hover {
  z-index: 5;
}
.grid-menu [class*=col-]:nth-last-child(-n+2) {
  border-bottom-width: 0;
}
.grid-menu [class*=col-]:nth-child(1n) {
  border-right-width: 1px;
}
.grid-menu [class*=col-]:nth-child(2n) {
  border-right-width: 0;
}
.grid-menu [class*=col-]:nth-last-child(-n+1) {
  border-bottom-width: 0;
}
.grid-menu.grid-menu-3col [class*=col-]:nth-last-child(-n+3) {
  border-bottom-width: 0;
}
.grid-menu.grid-menu-3col [class*=col-]:nth-child(2n) {
  border-right-width: 1px;
}
.grid-menu.grid-menu-3col [class*=col-]:nth-child(3n) {
  border-right-width: 0;
}
.grid-menu .btn {
  display: block;
  border: 0;
  min-width: 100%;
}

.badge {
  font-weight: bold;
  text-transform: uppercase;
  padding: 5px 10px;
  min-width: 19px;
}

.badge-light {
  background: #fff;
}

.badge-dot {
  text-indent: -999em;
  padding: 0;
  width: 8px;
  height: 8px;
  border: transparent solid 1px;
  border-radius: 30px;
  min-width: 2px;
}

.badge-dot-lg {
  width: 10px;
  height: 10px;
}

.badge-dot-xl {
  width: 18px;
  height: 18px;
  position: relative;
}
.badge-dot-xl::before {
  content: "";
  width: 10px;
  height: 10px;
  border-radius: 0.25rem;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -5px 0 0 -5px;
  background: #fff;
}

.badge-dot-sm {
  width: 6px;
  height: 6px;
}

.btn .badge {
  margin-left: 8px;
}
.btn .badge-dot {
  position: absolute;
  border: #fff solid 2px;
  top: -5px;
  right: -5px;
  width: 11px;
  height: 11px;
}
.btn .badge-dot.badge-dot-lg {
  width: 14px;
  height: 14px;
}
.btn .badge-dot.badge-dot-sm {
  width: 8px;
  height: 8px;
  border-width: 1px;
}
.btn .badge-dot-inside {
  top: 10px;
  right: 10px;
}

.btn-sm .badge-dot-sm, .btn-group-sm > .btn .badge-dot-sm {
  top: 1px;
  right: 4px;
}
.btn-sm .badge-dot, .btn-group-sm > .btn .badge-dot {
  top: 0px;
  right: 2px;
}
.btn-sm .badge-dot-lg, .btn-group-sm > .btn .badge-dot-lg {
  top: -3px;
  right: -2px;
}
.btn-sm .rounded-pill, .btn-group-sm > .btn .rounded-pill {
  position: absolute;
  top: -4px;
  right: -4px;
}

.badge-abs {
  position: absolute;
  right: -3px;
  top: -3px;
}

.avatar-icon-wrapper {
  display: inline-block;
  margin-right: 0.1rem;
  position: relative;
}
.avatar-icon-wrapper .badge {
  position: absolute;
  right: -2px;
  top: -2px;
}
.avatar-icon-wrapper .badge:empty {
  display: block;
}
.avatar-icon-wrapper .badge.badge-bottom {
  top: auto;
  right: -2px;
  bottom: -2px;
}
.avatar-icon-wrapper .badge-dot {
  width: 10px;
  height: 10px;
  border: #fff solid 2px;
}
.avatar-icon-wrapper .badge-dot.badge-dot-lg {
  width: 14px;
  height: 14px;
  border: #fff solid 2px;
  top: 0;
  right: 0;
}
.avatar-icon-wrapper .badge-dot.badge-dot-lg.badge-bottom {
  top: auto;
  right: 0;
  bottom: 0;
}

.avatar-icon-add .avatar-icon {
  background: #e0f3ff;
  border: rgb(146.2928571429, 151.3785714286, 230.2071428571) dashed 1px;
  color: #545cd8;
  text-align: center;
  opacity: 0.6;
}
.avatar-icon-add .avatar-icon i {
  font-style: normal;
  vertical-align: middle;
  font-size: 1.32rem;
  display: block;
  height: 100%;
}
.avatar-icon-add:hover {
  cursor: pointer;
}
.avatar-icon-add:hover .avatar-icon {
  opacity: 1;
}

a.avatar-icon-wrapper:hover .avatar-icon {
  opacity: 0.8;
}

.avatar-icon {
  display: block;
  width: 44px;
  height: 44px;
  transition: all 0.2s;
  opacity: 1;
  border-radius: 50px;
}
.avatar-icon.rounded {
  border-radius: 0.39rem !important;
}

.avatar-icon-xl .avatar-icon {
  width: 64px;
  height: 64px;
}
.avatar-icon-xl.avatar-icon-add i {
  font-size: 1.76rem;
}

.avatar-icon-lg .avatar-icon {
  width: 54px;
  height: 54px;
}
.avatar-icon-lg.avatar-icon-add i {
  font-size: 1.54rem;
}

.avatar-icon-sm .avatar-icon {
  width: 34px;
  height: 34px;
}
.avatar-icon-sm.avatar-icon-add i {
  font-size: 1.1rem;
}

.avatar-icon-xs .avatar-icon {
  width: 26px;
  height: 26px;
  transition: transform 0.2s;
}
.avatar-icon-xs.avatar-icon-add i {
  line-height: 26px;
  font-size: 0.88rem;
}
.avatar-icon-xs:hover .avatar-icon {
  transform: scale(2);
}

.avatar-icon {
  border: #fff solid 3px;
  overflow: hidden;
}
.avatar-icon img {
  width: 100%;
  height: 100%;
}

.avatar-wrapper-overlap .avatar-icon-wrapper {
  z-index: 5;
  margin-left: -18px;
}
.avatar-wrapper-overlap .avatar-icon-wrapper:hover {
  z-index: 7;
}
.avatar-wrapper-overlap .avatar-icon-wrapper.avatar-icon-xl {
  margin-left: -30px;
}
.avatar-wrapper-overlap .avatar-icon-wrapper.avatar-icon-lg {
  margin-left: -24px;
}
.avatar-wrapper-overlap .avatar-icon-wrapper.avatar-icon-sm {
  margin-left: -14px;
}
.avatar-wrapper-overlap .avatar-icon-wrapper.avatar-icon-xs {
  margin-left: -10px;
}
.avatar-wrapper-overlap .avatar-icon-wrapper.avatar-icon-add, .avatar-wrapper-overlap .avatar-icon-wrapper:first-child {
  margin-left: 0 !important;
}
.badge-pulse {
  -webkit-animation: pulse 2s ease-out;
  -webkit-animation-iteration-count: infinite;
  position: relative;
}
.badge-pulse::before, .badge-pulse::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  border: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  -webkit-animation: sploosh 2s cubic-bezier(0.165, 0.84, 0.44, 1);
  -webkit-animation-iteration-count: infinite;
}
.badge-pulse::after {
  -webkit-animation-delay: 0.33s;
  -webkit-animation-duration: 2.2s;
}

.card {
  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);
  border-width: 0;
  transition: all 0.2s;
}
.card > .dropdown-menu-header {
  margin: 0;
}
.card > .dropdown-menu-header .dropdown-menu-header-inner {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.card.text-dark.text-white .card-footer,
.card.text-dark.text-white .card-header, .card.text-white .card-footer,
.card.text-white .card-header {
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.9);
}
.card.text-dark.text-white .card-footer,
.card.text-dark.text-white .card-header {
  color: rgba(0, 0, 0, 0.9);
}
.card .card-footer {
  display: flex;
  align-items: center;
}

.btn-actions-pane-right {
  margin-left: auto;
  white-space: nowrap;
}

.btn-actions-pane-left {
  margin-right: auto;
}

.actions-icon-btn .btn-icon-only {
  padding-left: 0;
  padding-right: 0;
  color: #495057;
}
.actions-icon-btn .btn-icon-only .btn-icon-wrapper {
  font-size: 1.3rem;
  width: 30px;
  text-align: center;
}
.actions-icon-btn .btn-icon-only:hover {
  color: #545cd8;
}

.card-header,
.card-title {
  text-transform: uppercase;
  color: rgba(17.8285714286, 21.4857142857, 78.1714285714, 0.7);
  font-weight: bold;
  font-size: 0.88rem;
}

.card-header {
  display: flex;
  align-items: center;
  border-bottom-width: 1px;
  padding-top: 0;
  padding-bottom: 0;
  padding-right: 0.5rem;
  height: 3.5rem;
}
.card-header.no-border {
  border: 0;
  padding: 0;
  height: auto;
}
.card-header .menu-header-subtitle {
  display: block;
}
.card-header.card-header-tab .nav {
  width: auto;
  margin-left: auto;
}
.card-header.card-header-tab .card-header-title {
  display: flex;
  align-items: center;
  white-space: nowrap;
}
.card-header .header-icon {
  font-size: 1.65rem;
  margin-right: 0.5rem;
}
.card-header > .nav {
  margin-left: -0.5rem;
  height: 100%;
  width: 100%;
}
.card-header > .nav .nav-item {
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
}
.card-header > .nav .nav-link {
  text-transform: none;
  width: 100%;
  display: block;
  color: #495057;
}
.card-header > .nav .nav-link::before {
  content: "";
  border-radius: 15px;
  background: #545cd8;
  transition: all 0.2s;
  height: 4px;
  width: 100%;
  position: absolute;
  left: 0;
  bottom: -2px;
  opacity: 0;
}
.card-header > .nav .nav-link:hover {
  color: #545cd8;
}
.card-header > .nav .nav-link.active {
  color: #545cd8;
}
.card-header > .nav .nav-link.active::before {
  opacity: 1;
}
.card-header.card-header-tab-animation .nav .nav-link::before {
  transform: scale(0);
  opacity: 1;
  width: 90%;
  left: 5%;
}
.card-header.card-header-tab-animation .nav .nav-link.active::before, .card-header.card-header-tab-animation .nav .nav-link:hover::before {
  transform: scale(1);
}

.card-border {
  box-shadow: 0 0 0 transparent;
  border-width: 1px;
}

.card-hover-shadow:hover {
  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);
}

.card-hover-shadow-2x:hover {
  box-shadow: 0 0.66875rem 2.3875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 1.1375rem 1.60625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.45rem 0.73125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.325rem 0.3875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);
}

.card-subtitle {
  margin-bottom: 1rem;
  font-size: 0.968rem;
  color: rgba(17.8285714286, 21.4857142857, 78.1714285714, 0.55);
}

.card-shadow-primary {
  box-shadow: 0 0.46875rem 2.1875rem rgba(84, 92, 216, 0.03), 0 0.9375rem 1.40625rem rgba(84, 92, 216, 0.03), 0 0.25rem 0.53125rem rgba(84, 92, 216, 0.05), 0 0.125rem 0.1875rem rgba(84, 92, 216, 0.03);
}

.card-shadow-secondary {
  box-shadow: 0 0.46875rem 2.1875rem rgba(108, 117, 125, 0.03), 0 0.9375rem 1.40625rem rgba(108, 117, 125, 0.03), 0 0.25rem 0.53125rem rgba(108, 117, 125, 0.05), 0 0.125rem 0.1875rem rgba(108, 117, 125, 0.03);
}

.card-shadow-success {
  box-shadow: 0 0.46875rem 2.1875rem rgba(58, 196, 125, 0.03), 0 0.9375rem 1.40625rem rgba(58, 196, 125, 0.03), 0 0.25rem 0.53125rem rgba(58, 196, 125, 0.05), 0 0.125rem 0.1875rem rgba(58, 196, 125, 0.03);
}

.card-shadow-info {
  box-shadow: 0 0.46875rem 2.1875rem rgba(48, 177, 255, 0.03), 0 0.9375rem 1.40625rem rgba(48, 177, 255, 0.03), 0 0.25rem 0.53125rem rgba(48, 177, 255, 0.05), 0 0.125rem 0.1875rem rgba(48, 177, 255, 0.03);
}

.card-shadow-warning {
  box-shadow: 0 0.46875rem 2.1875rem rgba(247, 185, 36, 0.03), 0 0.9375rem 1.40625rem rgba(247, 185, 36, 0.03), 0 0.25rem 0.53125rem rgba(247, 185, 36, 0.05), 0 0.125rem 0.1875rem rgba(247, 185, 36, 0.03);
}

.card-shadow-danger {
  box-shadow: 0 0.46875rem 2.1875rem rgba(217, 37, 80, 0.03), 0 0.9375rem 1.40625rem rgba(217, 37, 80, 0.03), 0 0.25rem 0.53125rem rgba(217, 37, 80, 0.05), 0 0.125rem 0.1875rem rgba(217, 37, 80, 0.03);
}

.card-shadow-light {
  box-shadow: 0 0.46875rem 2.1875rem rgba(238, 238, 238, 0.03), 0 0.9375rem 1.40625rem rgba(238, 238, 238, 0.03), 0 0.25rem 0.53125rem rgba(238, 238, 238, 0.05), 0 0.125rem 0.1875rem rgba(238, 238, 238, 0.03);
}

.card-shadow-dark {
  box-shadow: 0 0.46875rem 2.1875rem rgba(52, 58, 64, 0.03), 0 0.9375rem 1.40625rem rgba(52, 58, 64, 0.03), 0 0.25rem 0.53125rem rgba(52, 58, 64, 0.05), 0 0.125rem 0.1875rem rgba(52, 58, 64, 0.03);
}

.card-shadow-focus {
  box-shadow: 0 0.46875rem 2.1875rem rgba(68, 64, 84, 0.03), 0 0.9375rem 1.40625rem rgba(68, 64, 84, 0.03), 0 0.25rem 0.53125rem rgba(68, 64, 84, 0.05), 0 0.125rem 0.1875rem rgba(68, 64, 84, 0.03);
}

.card-shadow-alternate {
  box-shadow: 0 0.46875rem 2.1875rem rgba(131, 88, 138, 0.03), 0 0.9375rem 1.40625rem rgba(131, 88, 138, 0.03), 0 0.25rem 0.53125rem rgba(131, 88, 138, 0.05), 0 0.125rem 0.1875rem rgba(131, 88, 138, 0.03);
}

.card-header-lg {
  padding: 2rem 2rem;
  height: auto;
}

.sticky-active-class .sticky-inner-wrapper > div {
  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);
}

.nav-pills,
.nav-tabs {
  margin-bottom: 1rem;
}

.nav-link {
  font-weight: bold;
}
.nav-link:hover {
  cursor: pointer;
}

.nav-tabs .nav-link:hover {
  color: #545cd8 !important;
}
.nav-tabs .nav-link.active {
  color: #545cd8;
}

.nav-pills .nav-link:hover {
  color: #545cd8 !important;
}
.nav-pills .nav-link.active {
  background: #545cd8;
}
.nav-pills .nav-link.active:hover {
  color: #fff !important;
}

.RRT__container {
  position: relative;
}

.RRT__tabs {
  display: flex;
  flex-wrap: wrap;
  position: relative;
}

.RRT__accordion {
  flex-direction: column;
}

.RRT__tab {
  cursor: pointer;
  z-index: 1;
  white-space: nowrap;
  padding: 0.5rem 1rem;
  transition: all 0.2s;
}
.RRT__tab:hover {
  color: #545cd8;
}
.RRT__tab:focus {
  outline: 0;
}

.RRT__tab--selected {
  color: #545cd8;
}

.RRT__tab--disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.RRT__tab:focus {
  z-index: 2;
}

.RRT__tab--selected .RRT__removable {
  position: relative;
}

.RRT__tab--selected .RRT__removable-text {
  margin-right: 10px;
}

.RRT__tab--selected .RRT__removable-icon {
  position: absolute;
  font-size: 18px;
  right: 0.5em;
  top: 0.2em;
}

.body-tabs.body-tabs-layout.body-tabs-big {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  margin: 0 auto;
  padding: 10px;
  border-radius: 50px;
  border: #e9ecef solid 1px;
  z-index: 7;
}
.body-tabs.body-tabs-layout.body-tabs-big .RRT__tab {
  margin: 0;
  font-size: 1rem;
  font-weight: 300;
  padding: 0;
  height: 50px;
  line-height: 50px;
  flex: 1 1;
  text-align: center;
  position: relative;
  color: #545cd8;
}
.body-tabs.body-tabs-layout.body-tabs-big .RRT__tab:hover {
  color: #212529;
}
.body-tabs.body-tabs-layout.body-tabs-big .RRT__tab.RRT__tab--selected {
  color: #fff;
}
.body-tabs.body-tabs-layout.body-tabs-big .RRT__tab.RRT__tab--selected:hover {
  color: #fff;
}
.body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper {
  height: 70px !important;
  top: -70px !important;
  margin: 0 auto -3.4rem;
  position: relative;
  padding: 0 10px;
}
.body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper::before {
  position: absolute;
  content: "";
  background: #fff;
  width: 100%;
  height: 100%;
  left: 0;
  top: -11px;
  border-radius: 50px;
}
.body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper .RRT__inkbar {
  height: 50px !important;
  margin-top: 10px;
  border-radius: 50px;
  box-shadow: 0 0 0 transparent;
}
.body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper + .RRT__panel {
  margin-top: -1rem;
}

.RRT__panel {
  margin-top: 1rem;
}

.RRT__showmore {
  border-radius: 0.25rem;
  background: #545cd8;
  cursor: pointer;
  z-index: 1;
  white-space: nowrap;
  font-weight: bold;
  width: 36px;
  text-align: center;
  height: 36px;
  display: block;
  margin-left: 15px;
  position: absolute;
  right: 1.5rem;
  top: 50%;
  margin-top: -18px;
  font-size: 1.4rem;
}
.RRT__showmore:focus {
  outline: none;
}

.RRT__showmore-label {
  position: relative;
  z-index: 1;
  color: #fff;
  width: 36px;
  text-align: center;
  height: 36px;
  line-height: 24px;
}

.RRT__showmore--selected {
  box-shadow: 0 16px 26px -10px rgba(84, 92, 216, 0.56), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(84, 92, 216, 0.2);
}

.RRT__showmore-list {
  position: absolute;
  right: -1px;
  top: 100%;
  display: none;
  min-width: 15rem;
  padding: 0.65rem 0;
  margin: 0.125rem 0 0;
  font-size: 0.88rem;
  color: #495057;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);
}
.RRT__showmore-list .RRT__tab {
  display: block;
  width: 100%;
  padding: 0.4rem 1rem;
  clear: both;
  font-weight: 400;
  color: #212529;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  margin: 0;
}
.RRT__showmore-list .RRT__tab:hover, .RRT__showmore-list .RRT__tab.RRT__tab--selected {
  color: rgb(29.7, 33.3, 36.9) !important;
  text-decoration: none;
  background: #e0f3ff;
}

.RRT__showmore-list--opened {
  display: block;
}
.RRT__showmore-list--opened .RRT__tab--selected {
  color: #545cd8;
}

.RRT__inkbar-wrapper {
  width: 100%;
}

.RRT__inkbar {
  position: relative;
  bottom: 0;
  height: 3px;
  margin-top: -3px;
  background-color: #545cd8;
  border-radius: 15px;
  transition: all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1) 0s;
  z-index: 2;
}

.card-tabs .card-header {
  padding: 0 1.25rem;
}
.card-tabs .card-header.RRT__tabs {
  cursor: pointer;
  font-weight: normal;
}
.card-tabs .card-header.RRT__tabs .RRT__tab {
  text-transform: none;
  line-height: 1.3;
}
.card-tabs .RRT__inkbar-wrapper {
  width: calc(100% - 1.5rem) !important;
  margin-left: 1.25rem;
}
.card-tabs .RRT__panel {
  padding: 1rem;
  margin: 0;
}
.card-tabs.text-white .RRT__tab {
  color: rgba(255, 255, 255, 0.6);
}
.card-tabs.text-white .RRT__tab:hover {
  color: #fff;
}
.card-tabs.text-white .RRT__tab--selected {
  color: #fff;
}
.card-tabs.text-white .RRT__inkbar {
  background: rgb(250.1142857143, 250.3428571429, 253.8857142857);
}

.card-tabs-animated .RRT__container > .RRT__tabs {
  background: transparent;
  position: relative;
  z-index: 7;
}
.card-tabs-animated .RRT__container > .RRT__tabs.card-header {
  border-bottom: 0;
  height: auto;
  padding: 1.5rem 1.5rem 0.5rem;
}
.card-tabs-animated .RRT__inkbar-wrapper {
  position: absolute;
  top: 1.5rem;
  z-index: 5;
}
.card-tabs-animated .RRT__tab {
  padding: 0.5rem 1.2rem;
}
.card-tabs-animated .RRT__tab--selected {
  color: #fff;
}
.card-tabs-animated .RRT__inkbar {
  height: 35px;
  margin-top: 0;
  border-radius: 0.25rem;
  box-shadow: 0 16px 26px -10px rgba(84, 92, 216, 0.56), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(84, 92, 216, 0.2);
}

.card-tabs-animated-inner .RRT__tabs {
  padding: 0 5%;
}
.card-tabs-animated-inner .RRT__inkbar-wrapper {
  left: 5%;
  width: 90%;
  height: 36px;
  top: 14px;
}
.card-tabs-animated-inner .RRT__inkbar {
  height: 36px;
}

.body-tabs {
  border-bottom: #dee2e6 solid 2px;
}
.body-tabs > .RRT__tab {
  padding: 1rem 1.25rem;
  font-weight: normal;
  font-size: 0.88rem;
}
.body-tabs.body-tabs-alt > .RRT__tab {
  padding: 1.3636363636rem 0.5rem;
  font-weight: normal;
  font-size: 0.86rem;
  width: 33%;
  text-align: center;
}
.body-tabs.body-tabs-alt .RRT__inkbar {
  height: 2px;
  margin-top: -2px;
}

.popover .RRT__panel,
.dropdown-menu .RRT__panel {
  margin: 0;
  padding: 0;
  position: relative;
}
.popover .RRT__panel::after, .popover .RRT__panel::before,
.dropdown-menu .RRT__panel::after,
.dropdown-menu .RRT__panel::before {
  width: 100%;
  bottom: auto;
  top: 0;
  left: 0;
  height: 20px;
  position: absolute;
  z-index: 10;
  content: "";
  background: linear-gradient(to bottom, rgb(255, 255, 255) 20%, rgba(255, 255, 255, 0) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#ffffff", endColorstr="#00ffffff", GradientType=0);
}
.popover .RRT__panel::after,
.dropdown-menu .RRT__panel::after {
  bottom: 0;
  top: auto;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgb(255, 255, 255) 80%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#00ffffff", endColorstr="#ffffff", GradientType=0);
}

.tabs-lg-alternate.card-header {
  padding: 0;
  height: auto;
}
.tabs-lg-alternate.card-header .widget-number {
  font-size: 1.76rem;
  font-weight: 300;
}
.tabs-lg-alternate.card-header .tab-subheading {
  padding: 5px 0 0;
  opacity: 0.6;
  transition: all 0.2s;
}
.tabs-lg-alternate.card-header > .nav {
  margin: 0;
}
.tabs-lg-alternate.card-header > .nav .nav-link {
  padding: 1.5rem 0;
  border-right: #e9ecef solid 1px;
  background: #f8f9fa;
}
.tabs-lg-alternate.card-header > .nav .nav-link:hover {
  background: #fff;
}
.tabs-lg-alternate.card-header > .nav .nav-link:hover .tab-subheading {
  color: #000;
  opacity: 0.9;
}
.tabs-lg-alternate.card-header > .nav .nav-link::before {
  background: #fff;
  border-radius: 0;
}
.tabs-lg-alternate.card-header > .nav .nav-link.active {
  background: #fff;
}
.tabs-lg-alternate.card-header > .nav .nav-link.active .tab-subheading {
  color: #000;
  opacity: 0.9;
}
.tabs-lg-alternate.card-header > .nav .nav-item:last-child .nav-link {
  border-right: 0;
}

.accordion-wrapper {
  border-radius: 0.25rem;
  border: #e9ecef solid 1px;
}
.accordion-wrapper > .card {
  box-shadow: 0 0 0 0 transparent;
}
.accordion-wrapper > .card > .card-header {
  padding: 1rem;
  height: auto;
}
.accordion-wrapper > .card > .card-header .btn:active,
.accordion-wrapper > .card > .card-header .btn:focus,
.accordion-wrapper > .card > .card-header .btn:hover {
  text-decoration: none;
}
.accordion-wrapper > .card > .card-header .form-heading p {
  margin: 0;
}
.accordion-wrapper > .card .collapse {
  border-bottom: transparent solid 1px;
}
.accordion-wrapper > .card .collapse.show {
  border-bottom-color: #e9ecef;
}

.modal-header,
.modal-footer {
  background: #f8f9fa;
}

.modal-footer {
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}

.modal-dialog {
  box-shadow: 0 0.76875rem 2.4875rem rgba(52, 58, 64, 0.3), 0 1.3375rem 1.70625rem rgba(52, 58, 64, 0.3), 0 0.55rem 0.53125rem rgba(0, 0, 0, 0.05), 0 0.225rem 0.4375rem rgba(52, 58, 64, 0.3);
  border-radius: 0.25rem;
}

/**
 * Dots
 */
@keyframes scale {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  45% {
    transform: scale(0.1);
    opacity: 0.7;
  }
  80% {
    transform: scale(1);
    opacity: 1;
  }
}
.ball-pulse > div:nth-child(0) {
  animation: scale 0.75s -0.36s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
}
.ball-pulse > div:nth-child(1) {
  animation: scale 0.75s -0.24s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
}
.ball-pulse > div:nth-child(2) {
  animation: scale 0.75s -0.12s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
}
.ball-pulse > div:nth-child(3) {
  animation: scale 0.75s 0s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
}
.ball-pulse > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  display: inline-block;
}

@keyframes ball-pulse-sync {
  33% {
    transform: translateY(10px);
  }
  66% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(0);
  }
}
.ball-pulse-sync > div:nth-child(0) {
  animation: ball-pulse-sync 0.6s -0.21s infinite ease-in-out;
}
.ball-pulse-sync > div:nth-child(1) {
  animation: ball-pulse-sync 0.6s -0.14s infinite ease-in-out;
}
.ball-pulse-sync > div:nth-child(2) {
  animation: ball-pulse-sync 0.6s -0.07s infinite ease-in-out;
}
.ball-pulse-sync > div:nth-child(3) {
  animation: ball-pulse-sync 0.6s 0s infinite ease-in-out;
}
.ball-pulse-sync > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  display: inline-block;
}

@keyframes ball-scale {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}
.ball-scale > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  display: inline-block;
  height: 60px;
  width: 60px;
  animation: ball-scale 1s 0s ease-in-out infinite;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.ball-rotate {
  position: relative;
}
.ball-rotate > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  position: relative;
}
.ball-rotate > div:first-child {
  animation: rotate 1s 0s cubic-bezier(0.7, -0.13, 0.22, 0.86) infinite;
}
.ball-rotate > div:before, .ball-rotate > div:after {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  content: "";
  position: absolute;
  opacity: 0.8;
}
.ball-rotate > div:before {
  top: 0px;
  left: -28px;
}
.ball-rotate > div:after {
  top: 0px;
  left: 25px;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg) scale(1);
  }
  50% {
    transform: rotate(180deg) scale(0.6);
  }
  100% {
    transform: rotate(360deg) scale(1);
  }
}
.ball-clip-rotate > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  border: 2px solid #545cd8;
  border-bottom-color: transparent;
  height: 25px;
  width: 25px;
  background: transparent !important;
  display: inline-block;
  animation: rotate 0.75s 0s linear infinite;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg) scale(1);
  }
  50% {
    transform: rotate(180deg) scale(0.6);
  }
  100% {
    transform: rotate(360deg) scale(1);
  }
}
@keyframes scale {
  30% {
    transform: scale(0.3);
  }
  100% {
    transform: scale(1);
  }
}
.ball-clip-rotate-pulse {
  position: relative;
  transform: translateY(-15px);
}
.ball-clip-rotate-pulse > div {
  animation-fill-mode: both;
  position: absolute;
  top: 0px;
  left: 0px;
  border-radius: 100%;
}
.ball-clip-rotate-pulse > div:first-child {
  background: #545cd8;
  height: 16px;
  width: 16px;
  top: 7px;
  left: -7px;
  animation: scale 1s 0s cubic-bezier(0.09, 0.57, 0.49, 0.9) infinite;
}
.ball-clip-rotate-pulse > div:last-child {
  position: absolute;
  border: 2px solid #545cd8;
  width: 30px;
  height: 30px;
  left: -16px;
  top: -2px;
  background: transparent;
  border: 2px solid;
  border-color: #545cd8 transparent #545cd8 transparent;
  animation: rotate 1s 0s cubic-bezier(0.09, 0.57, 0.49, 0.9) infinite;
  animation-duration: 1s;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg) scale(1);
  }
  50% {
    transform: rotate(180deg) scale(0.6);
  }
  100% {
    transform: rotate(360deg) scale(1);
  }
}
.ball-clip-rotate-multiple {
  position: relative;
}
.ball-clip-rotate-multiple > div {
  animation-fill-mode: both;
  position: absolute;
  left: -20px;
  top: -20px;
  border: 2px solid #545cd8;
  border-bottom-color: transparent;
  border-top-color: transparent;
  border-radius: 100%;
  height: 35px;
  width: 35px;
  animation: rotate 1s 0s ease-in-out infinite;
}
.ball-clip-rotate-multiple > div:last-child {
  display: inline-block;
  top: -10px;
  left: -10px;
  width: 15px;
  height: 15px;
  animation-duration: 0.5s;
  border-color: #545cd8 transparent #545cd8 transparent;
  animation-direction: reverse;
}

@keyframes ball-scale-ripple {
  0% {
    transform: scale(0.1);
    opacity: 1;
  }
  70% {
    transform: scale(1);
    opacity: 0.7;
  }
  100% {
    opacity: 0;
  }
}
.ball-scale-ripple > div {
  animation-fill-mode: both;
  height: 50px;
  width: 50px;
  border-radius: 100%;
  border: 2px solid #545cd8;
  animation: ball-scale-ripple 1s 0s infinite cubic-bezier(0.21, 0.53, 0.56, 0.8);
}

@keyframes ball-scale-ripple-multiple {
  0% {
    transform: scale(0.1);
    opacity: 1;
  }
  70% {
    transform: scale(1);
    opacity: 0.7;
  }
  100% {
    opacity: 0;
  }
}
.ball-scale-ripple-multiple {
  position: relative;
  transform: translateY(-25px);
}
.ball-scale-ripple-multiple > div:nth-child(0) {
  animation-delay: -0.8s;
}
.ball-scale-ripple-multiple > div:nth-child(1) {
  animation-delay: -0.6s;
}
.ball-scale-ripple-multiple > div:nth-child(2) {
  animation-delay: -0.4s;
}
.ball-scale-ripple-multiple > div:nth-child(3) {
  animation-delay: -0.2s;
}
.ball-scale-ripple-multiple > div {
  animation-fill-mode: both;
  position: absolute;
  top: -2px;
  left: -26px;
  width: 50px;
  height: 50px;
  border-radius: 100%;
  border: 2px solid #545cd8;
  animation: ball-scale-ripple-multiple 1.25s 0s infinite cubic-bezier(0.21, 0.53, 0.56, 0.8);
}

@keyframes ball-beat {
  50% {
    opacity: 0.2;
    transform: scale(0.75);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
.ball-beat > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  display: inline-block;
  animation: ball-beat 0.7s 0s infinite linear;
}
.ball-beat > div:nth-child(2n-1) {
  animation-delay: -0.35s !important;
}

@keyframes ball-scale-multiple {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  5% {
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}
.ball-scale-multiple {
  position: relative;
  transform: translateY(-30px);
}
.ball-scale-multiple > div:nth-child(2) {
  animation-delay: -0.4s;
}
.ball-scale-multiple > div:nth-child(3) {
  animation-delay: -0.2s;
}
.ball-scale-multiple > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  position: absolute;
  left: -30px;
  top: 0px;
  opacity: 0;
  margin: 0;
  width: 60px;
  height: 60px;
  animation: ball-scale-multiple 1s 0s linear infinite;
}

@keyframes ball-triangle-path-1 {
  33% {
    transform: translate(25px, -50px);
  }
  66% {
    transform: translate(50px, 0px);
  }
  100% {
    transform: translate(0px, 0px);
  }
}
@keyframes ball-triangle-path-2 {
  33% {
    transform: translate(25px, 50px);
  }
  66% {
    transform: translate(-25px, 50px);
  }
  100% {
    transform: translate(0px, 0px);
  }
}
@keyframes ball-triangle-path-3 {
  33% {
    transform: translate(-50px, 0px);
  }
  66% {
    transform: translate(-25px, -50px);
  }
  100% {
    transform: translate(0px, 0px);
  }
}
.ball-triangle-path {
  position: relative;
  transform: translate(-29.9940011998px, -37.5093773443px);
}
.ball-triangle-path > div:nth-child(1) {
  animation-name: ball-triangle-path-1;
  animation-delay: 0;
  animation-duration: 2s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
}
.ball-triangle-path > div:nth-child(2) {
  animation-name: ball-triangle-path-2;
  animation-delay: 0;
  animation-duration: 2s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
}
.ball-triangle-path > div:nth-child(3) {
  animation-name: ball-triangle-path-3;
  animation-delay: 0;
  animation-duration: 2s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
}
.ball-triangle-path > div {
  animation-fill-mode: both;
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 100%;
  border: 1px solid #545cd8;
}
.ball-triangle-path > div:nth-of-type(1) {
  top: 50px;
}
.ball-triangle-path > div:nth-of-type(2) {
  left: 25px;
}
.ball-triangle-path > div:nth-of-type(3) {
  top: 50px;
  left: 50px;
}

@keyframes ball-pulse-rise-even {
  0% {
    transform: scale(1.1);
  }
  25% {
    transform: translateY(-30px);
  }
  50% {
    transform: scale(0.4);
  }
  75% {
    transform: translateY(30px);
  }
  100% {
    transform: translateY(0);
    transform: scale(1);
  }
}
@keyframes ball-pulse-rise-odd {
  0% {
    transform: scale(0.4);
  }
  25% {
    transform: translateY(30px);
  }
  50% {
    transform: scale(1.1);
  }
  75% {
    transform: translateY(-30px);
  }
  100% {
    transform: translateY(0);
    transform: scale(0.75);
  }
}
.ball-pulse-rise > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  display: inline-block;
  animation-duration: 1s;
  animation-timing-function: cubic-bezier(0.15, 0.46, 0.9, 0.6);
  animation-iteration-count: infinite;
  animation-delay: 0;
}
.ball-pulse-rise > div:nth-child(2n) {
  animation-name: ball-pulse-rise-even;
}
.ball-pulse-rise > div:nth-child(2n-1) {
  animation-name: ball-pulse-rise-odd;
}

@keyframes ball-grid-beat {
  50% {
    opacity: 0.7;
  }
  100% {
    opacity: 1;
  }
}
.ball-grid-beat {
  width: 57px;
}
.ball-grid-beat > div:nth-child(1) {
  animation-delay: 0.05s;
  animation-duration: 1.54s;
}
.ball-grid-beat > div:nth-child(2) {
  animation-delay: 0.36s;
  animation-duration: 1.29s;
}
.ball-grid-beat > div:nth-child(3) {
  animation-delay: 0.03s;
  animation-duration: 1.4s;
}
.ball-grid-beat > div:nth-child(4) {
  animation-delay: 0.08s;
  animation-duration: 0.8s;
}
.ball-grid-beat > div:nth-child(5) {
  animation-delay: 0.22s;
  animation-duration: 0.72s;
}
.ball-grid-beat > div:nth-child(6) {
  animation-delay: 0.06s;
  animation-duration: 1.15s;
}
.ball-grid-beat > div:nth-child(7) {
  animation-delay: 0.75s;
  animation-duration: 0.7s;
}
.ball-grid-beat > div:nth-child(8) {
  animation-delay: 0.8s;
  animation-duration: 0.67s;
}
.ball-grid-beat > div:nth-child(9) {
  animation-delay: 0.73s;
  animation-duration: 0.77s;
}
.ball-grid-beat > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  display: inline-block;
  float: left;
  animation-name: ball-grid-beat;
  animation-iteration-count: infinite;
  animation-delay: 0;
}

@keyframes ball-grid-pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.5);
    opacity: 0.7;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.ball-grid-pulse {
  width: 57px;
}
.ball-grid-pulse > div:nth-child(1) {
  animation-delay: 0.45s;
  animation-duration: 1.33s;
}
.ball-grid-pulse > div:nth-child(2) {
  animation-delay: 0.63s;
  animation-duration: 1.13s;
}
.ball-grid-pulse > div:nth-child(3) {
  animation-delay: 0.21s;
  animation-duration: 1.45s;
}
.ball-grid-pulse > div:nth-child(4) {
  animation-delay: 0.5s;
  animation-duration: 0.77s;
}
.ball-grid-pulse > div:nth-child(5) {
  animation-delay: 0.17s;
  animation-duration: 1s;
}
.ball-grid-pulse > div:nth-child(6) {
  animation-delay: 0.79s;
  animation-duration: 1.31s;
}
.ball-grid-pulse > div:nth-child(7) {
  animation-delay: 0.29s;
  animation-duration: 1.24s;
}
.ball-grid-pulse > div:nth-child(8) {
  animation-delay: 0.59s;
  animation-duration: 1.55s;
}
.ball-grid-pulse > div:nth-child(9) {
  animation-delay: 0.17s;
  animation-duration: 1.56s;
}
.ball-grid-pulse > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  display: inline-block;
  float: left;
  animation-name: ball-grid-pulse;
  animation-iteration-count: infinite;
  animation-delay: 0;
}

@keyframes ball-spin-fade-loader {
  50% {
    opacity: 0.3;
    transform: scale(0.4);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
.ball-spin-fade-loader {
  position: relative;
  top: -10px;
  left: -10px;
}
.ball-spin-fade-loader > div:nth-child(1) {
  top: 25px;
  left: 0;
  animation: ball-spin-fade-loader 1s -0.96s infinite linear;
}
.ball-spin-fade-loader > div:nth-child(2) {
  top: 17.0454545455px;
  left: 17.0454545455px;
  animation: ball-spin-fade-loader 1s -0.84s infinite linear;
}
.ball-spin-fade-loader > div:nth-child(3) {
  top: 0;
  left: 25px;
  animation: ball-spin-fade-loader 1s -0.72s infinite linear;
}
.ball-spin-fade-loader > div:nth-child(4) {
  top: -17.0454545455px;
  left: 17.0454545455px;
  animation: ball-spin-fade-loader 1s -0.6s infinite linear;
}
.ball-spin-fade-loader > div:nth-child(5) {
  top: -25px;
  left: 0;
  animation: ball-spin-fade-loader 1s -0.48s infinite linear;
}
.ball-spin-fade-loader > div:nth-child(6) {
  top: -17.0454545455px;
  left: -17.0454545455px;
  animation: ball-spin-fade-loader 1s -0.36s infinite linear;
}
.ball-spin-fade-loader > div:nth-child(7) {
  top: 0;
  left: -25px;
  animation: ball-spin-fade-loader 1s -0.24s infinite linear;
}
.ball-spin-fade-loader > div:nth-child(8) {
  top: 17.0454545455px;
  left: -17.0454545455px;
  animation: ball-spin-fade-loader 1s -0.12s infinite linear;
}
.ball-spin-fade-loader > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  position: absolute;
}

@keyframes ball-spin-loader {
  75% {
    opacity: 0.2;
  }
  100% {
    opacity: 1;
  }
}
.ball-spin-loader {
  position: relative;
}
.ball-spin-loader > span:nth-child(1) {
  top: 45px;
  left: 0;
  animation: ball-spin-loader 2s 0.9s infinite linear;
}
.ball-spin-loader > span:nth-child(2) {
  top: 30.6818181818px;
  left: 30.6818181818px;
  animation: ball-spin-loader 2s 1.8s infinite linear;
}
.ball-spin-loader > span:nth-child(3) {
  top: 0;
  left: 45px;
  animation: ball-spin-loader 2s 2.7s infinite linear;
}
.ball-spin-loader > span:nth-child(4) {
  top: -30.6818181818px;
  left: 30.6818181818px;
  animation: ball-spin-loader 2s 3.6s infinite linear;
}
.ball-spin-loader > span:nth-child(5) {
  top: -45px;
  left: 0;
  animation: ball-spin-loader 2s 4.5s infinite linear;
}
.ball-spin-loader > span:nth-child(6) {
  top: -30.6818181818px;
  left: -30.6818181818px;
  animation: ball-spin-loader 2s 5.4s infinite linear;
}
.ball-spin-loader > span:nth-child(7) {
  top: 0;
  left: -45px;
  animation: ball-spin-loader 2s 6.3s infinite linear;
}
.ball-spin-loader > span:nth-child(8) {
  top: 30.6818181818px;
  left: -30.6818181818px;
  animation: ball-spin-loader 2s 7.2s infinite linear;
}
.ball-spin-loader > div {
  animation-fill-mode: both;
  position: absolute;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  background: green;
}

@keyframes ball-zig {
  33% {
    transform: translate(-15px, -30px);
  }
  66% {
    transform: translate(15px, -30px);
  }
  100% {
    transform: translate(0, 0);
  }
}
@keyframes ball-zag {
  33% {
    transform: translate(15px, 30px);
  }
  66% {
    transform: translate(-15px, 30px);
  }
  100% {
    transform: translate(0, 0);
  }
}
.ball-zig-zag {
  position: relative;
  transform: translate(-15px, -15px);
}
.ball-zig-zag > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  position: absolute;
  margin-left: 15px;
  top: 4px;
  left: -7px;
}
.ball-zig-zag > div:first-child {
  animation: ball-zig 0.7s 0s infinite linear;
}
.ball-zig-zag > div:last-child {
  animation: ball-zag 0.7s 0s infinite linear;
}

@keyframes ball-zig-deflect {
  17% {
    transform: translate(-15px, -30px);
  }
  34% {
    transform: translate(15px, -30px);
  }
  50% {
    transform: translate(0, 0);
  }
  67% {
    transform: translate(15px, -30px);
  }
  84% {
    transform: translate(-15px, -30px);
  }
  100% {
    transform: translate(0, 0);
  }
}
@keyframes ball-zag-deflect {
  17% {
    transform: translate(15px, 30px);
  }
  34% {
    transform: translate(-15px, 30px);
  }
  50% {
    transform: translate(0, 0);
  }
  67% {
    transform: translate(-15px, 30px);
  }
  84% {
    transform: translate(15px, 30px);
  }
  100% {
    transform: translate(0, 0);
  }
}
.ball-zig-zag-deflect {
  position: relative;
  transform: translate(-15px, -15px);
}
.ball-zig-zag-deflect > div {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  animation-fill-mode: both;
  position: absolute;
  margin-left: 15px;
  top: 4px;
  left: -7px;
}
.ball-zig-zag-deflect > div:first-child {
  animation: ball-zig-deflect 1.5s 0s infinite linear;
}
.ball-zig-zag-deflect > div:last-child {
  animation: ball-zag-deflect 1.5s 0s infinite linear;
}

/**
 * Lines
 */
@keyframes line-scale {
  0% {
    transform: scaley(1);
  }
  50% {
    transform: scaley(0.4);
  }
  100% {
    transform: scaley(1);
  }
}
.line-scale > div:nth-child(1) {
  animation: line-scale 1s -0.4s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
}
.line-scale > div:nth-child(2) {
  animation: line-scale 1s -0.3s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
}
.line-scale > div:nth-child(3) {
  animation: line-scale 1s -0.2s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
}
.line-scale > div:nth-child(4) {
  animation: line-scale 1s -0.1s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
}
.line-scale > div:nth-child(5) {
  animation: line-scale 1s 0s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
}
.line-scale > div {
  background-color: #545cd8;
  width: 4px;
  height: 35px;
  border-radius: 2px;
  margin: 2px;
  animation-fill-mode: both;
  display: inline-block;
}

@keyframes line-scale-party {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.5);
  }
  100% {
    transform: scale(1);
  }
}
.line-scale-party > div:nth-child(1) {
  animation-delay: 0.55s;
  animation-duration: 0.91s;
}
.line-scale-party > div:nth-child(2) {
  animation-delay: 0.78s;
  animation-duration: 1.01s;
}
.line-scale-party > div:nth-child(3) {
  animation-delay: 0.8s;
  animation-duration: 0.94s;
}
.line-scale-party > div:nth-child(4) {
  animation-delay: 0.42s;
  animation-duration: 0.39s;
}
.line-scale-party > div {
  background-color: #545cd8;
  width: 4px;
  height: 35px;
  border-radius: 2px;
  margin: 2px;
  animation-fill-mode: both;
  display: inline-block;
  animation-name: line-scale-party;
  animation-iteration-count: infinite;
  animation-delay: 0;
}

@keyframes line-scale-pulse-out {
  0% {
    transform: scaley(1);
  }
  50% {
    transform: scaley(0.4);
  }
  100% {
    transform: scaley(1);
  }
}
.line-scale-pulse-out > div {
  background-color: #545cd8;
  width: 4px;
  height: 35px;
  border-radius: 2px;
  margin: 2px;
  animation-fill-mode: both;
  display: inline-block;
  animation: line-scale-pulse-out 0.9s -0.6s infinite cubic-bezier(0.85, 0.25, 0.37, 0.85);
}
.line-scale-pulse-out > div:nth-child(2), .line-scale-pulse-out > div:nth-child(4) {
  animation-delay: -0.4s !important;
}
.line-scale-pulse-out > div:nth-child(1), .line-scale-pulse-out > div:nth-child(5) {
  animation-delay: -0.2s !important;
}

@keyframes line-scale-pulse-out-rapid {
  0% {
    transform: scaley(1);
  }
  80% {
    transform: scaley(0.3);
  }
  90% {
    transform: scaley(1);
  }
}
.line-scale-pulse-out-rapid > div {
  background-color: #545cd8;
  width: 4px;
  height: 35px;
  border-radius: 2px;
  margin: 2px;
  animation-fill-mode: both;
  display: inline-block;
  vertical-align: middle;
  animation: line-scale-pulse-out-rapid 0.9s -0.5s infinite cubic-bezier(0.11, 0.49, 0.38, 0.78);
}
.line-scale-pulse-out-rapid > div:nth-child(2), .line-scale-pulse-out-rapid > div:nth-child(4) {
  animation-delay: -0.25s !important;
}
.line-scale-pulse-out-rapid > div:nth-child(1), .line-scale-pulse-out-rapid > div:nth-child(5) {
  animation-delay: 0s !important;
}

@keyframes line-spin-fade-loader {
  50% {
    opacity: 0.3;
  }
  100% {
    opacity: 1;
  }
}
.line-spin-fade-loader {
  position: relative;
  top: -10px;
  left: -4px;
}
.line-spin-fade-loader > div:nth-child(1) {
  top: 20px;
  left: 0;
  animation: line-spin-fade-loader 1.2s -0.84s infinite ease-in-out;
}
.line-spin-fade-loader > div:nth-child(2) {
  top: 13.6363636364px;
  left: 13.6363636364px;
  transform: rotate(-45deg);
  animation: line-spin-fade-loader 1.2s -0.72s infinite ease-in-out;
}
.line-spin-fade-loader > div:nth-child(3) {
  top: 0;
  left: 20px;
  transform: rotate(90deg);
  animation: line-spin-fade-loader 1.2s -0.6s infinite ease-in-out;
}
.line-spin-fade-loader > div:nth-child(4) {
  top: -13.6363636364px;
  left: 13.6363636364px;
  transform: rotate(45deg);
  animation: line-spin-fade-loader 1.2s -0.48s infinite ease-in-out;
}
.line-spin-fade-loader > div:nth-child(5) {
  top: -20px;
  left: 0;
  animation: line-spin-fade-loader 1.2s -0.36s infinite ease-in-out;
}
.line-spin-fade-loader > div:nth-child(6) {
  top: -13.6363636364px;
  left: -13.6363636364px;
  transform: rotate(-45deg);
  animation: line-spin-fade-loader 1.2s -0.24s infinite ease-in-out;
}
.line-spin-fade-loader > div:nth-child(7) {
  top: 0;
  left: -20px;
  transform: rotate(90deg);
  animation: line-spin-fade-loader 1.2s -0.12s infinite ease-in-out;
}
.line-spin-fade-loader > div:nth-child(8) {
  top: 13.6363636364px;
  left: -13.6363636364px;
  transform: rotate(45deg);
  animation: line-spin-fade-loader 1.2s 0s infinite ease-in-out;
}
.line-spin-fade-loader > div {
  background-color: #545cd8;
  width: 4px;
  height: 35px;
  border-radius: 2px;
  margin: 2px;
  animation-fill-mode: both;
  position: absolute;
  width: 5px;
  height: 15px;
}

/**
 * Misc
 */
@keyframes triangle-skew-spin {
  25% {
    transform: perspective(100px) rotateX(180deg) rotateY(0);
  }
  50% {
    transform: perspective(100px) rotateX(180deg) rotateY(180deg);
  }
  75% {
    transform: perspective(100px) rotateX(0) rotateY(180deg);
  }
  100% {
    transform: perspective(100px) rotateX(0) rotateY(0);
  }
}
.triangle-skew-spin > div {
  animation-fill-mode: both;
  width: 0;
  height: 0;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-bottom: 20px solid #545cd8;
  animation: triangle-skew-spin 3s 0s cubic-bezier(0.09, 0.57, 0.49, 0.9) infinite;
}

@keyframes square-spin {
  25% {
    transform: perspective(100px) rotateX(180deg) rotateY(0);
  }
  50% {
    transform: perspective(100px) rotateX(180deg) rotateY(180deg);
  }
  75% {
    transform: perspective(100px) rotateX(0) rotateY(180deg);
  }
  100% {
    transform: perspective(100px) rotateX(0) rotateY(0);
  }
}
.square-spin > div {
  animation-fill-mode: both;
  width: 50px;
  height: 50px;
  background: #545cd8;
  animation: square-spin 3s 0s cubic-bezier(0.09, 0.57, 0.49, 0.9) infinite;
}

@keyframes rotate_pacman_half_up {
  0% {
    transform: rotate(270deg);
  }
  50% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(270deg);
  }
}
@keyframes rotate_pacman_half_down {
  0% {
    transform: rotate(90deg);
  }
  50% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(90deg);
  }
}
@keyframes pacman-balls {
  75% {
    opacity: 0.7;
  }
  100% {
    transform: translate(-100px, -6.25px);
  }
}
.pacman {
  position: relative;
}
.pacman > div:nth-child(2) {
  animation: pacman-balls 1s -0.99s infinite linear;
}
.pacman > div:nth-child(3) {
  animation: pacman-balls 1s -0.66s infinite linear;
}
.pacman > div:nth-child(4) {
  animation: pacman-balls 1s -0.33s infinite linear;
}
.pacman > div:nth-child(5) {
  animation: pacman-balls 1s 0s infinite linear;
}
.pacman > div:first-of-type {
  width: 0px;
  height: 0px;
  border-right: 25px solid transparent;
  border-top: 25px solid #545cd8;
  border-left: 25px solid #545cd8;
  border-bottom: 25px solid #545cd8;
  border-radius: 25px;
  animation: rotate_pacman_half_up 0.5s 0s infinite;
  position: relative;
  left: -30px;
}
.pacman > div:nth-child(2) {
  width: 0px;
  height: 0px;
  border-right: 25px solid transparent;
  border-top: 25px solid #545cd8;
  border-left: 25px solid #545cd8;
  border-bottom: 25px solid #545cd8;
  border-radius: 25px;
  animation: rotate_pacman_half_down 0.5s 0s infinite;
  margin-top: -50px;
  position: relative;
  left: -30px;
}
.pacman > div:nth-child(3),
.pacman > div:nth-child(4),
.pacman > div:nth-child(5),
.pacman > div:nth-child(6) {
  background-color: #545cd8;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  width: 10px;
  height: 10px;
  position: absolute;
  transform: translate(0, -6.25px);
  top: 25px;
  left: 70px;
}

@keyframes cube-transition {
  25% {
    transform: translateX(50px) scale(0.5) rotate(-90deg);
  }
  50% {
    transform: translate(50px, 50px) rotate(-180deg);
  }
  75% {
    transform: translateY(50px) scale(0.5) rotate(-270deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}
.cube-transition {
  position: relative;
  transform: translate(-25px, -25px);
}
.cube-transition > div {
  animation-fill-mode: both;
  width: 10px;
  height: 10px;
  position: absolute;
  top: -5px;
  left: -5px;
  background-color: #545cd8;
  animation: cube-transition 1.6s 0s infinite ease-in-out;
}
.cube-transition > div:last-child {
  animation-delay: -0.8s;
}

@keyframes spin-rotate {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.semi-circle-spin {
  position: relative;
  width: 35px;
  height: 35px;
  overflow: hidden;
}
.semi-circle-spin > div {
  position: absolute;
  border-width: 0px;
  border-radius: 100%;
  animation: spin-rotate 0.6s 0s infinite linear;
  background-image: linear-gradient(transparent 0%, transparent 70%, #545cd8 30%, #545cd8 100%);
  width: 100%;
  height: 100%;
}

.progress .progress-bar:last-child {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.progress.progress-bar-sm {
  height: 0.5rem;
}
.progress.progress-bar-xs {
  height: 0.3rem;
}
.progress.progress-bar-rounded {
  border-radius: 30px;
}

.progress-bar-animated-alt.progress-bar,
.progress-bar-animated-alt .progress-bar {
  position: relative;
}
.progress-bar-animated-alt.progress-bar::after,
.progress-bar-animated-alt .progress-bar::after {
  content: "";
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  animation: progress-active 2s ease infinite;
}

@keyframes progress-active {
  0% {
    opacity: 0.4;
    width: 0;
  }
  100% {
    opacity: 0;
    width: 100%;
  }
}
.vertical-timeline {
  width: 100%;
  position: relative;
  padding: 1.5rem 0 1rem;
}
.vertical-timeline::after {
  content: "";
  display: table;
  clear: both;
}
.vertical-timeline::before {
  content: "";
  position: absolute;
  top: 0;
  left: 67px;
  height: 100%;
  width: 4px;
  background: #e9ecef;
  border-radius: 0.25rem;
}

.vertical-timeline-element {
  position: relative;
  margin: 0 0 1rem;
}
.vertical-timeline-element:after {
  content: "";
  display: table;
  clear: both;
}
.vertical-timeline-element:last-child {
  margin-bottom: 0;
}

.vertical-timeline-element-content {
  position: relative;
  margin-left: 90px;
  font-size: 0.8rem;
}
.vertical-timeline-element-content:after {
  content: "";
  display: table;
  clear: both;
}
.vertical-timeline-element-content .timeline-title {
  font-size: 0.8rem;
  text-transform: uppercase;
  margin: 0 0 0.5rem;
  padding: 2px 0 0;
  font-weight: bold;
}
.vertical-timeline-element-content p {
  color: #6c757d;
  margin: 0 0 0.5rem;
}
.vertical-timeline-element-content .vertical-timeline-element-date {
  display: block;
  position: absolute;
  left: -90px;
  top: 0;
  padding-right: 10px;
  text-align: right;
  color: #adb5bd;
  font-size: 0.7619047619rem;
  white-space: nowrap;
}

.vertical-timeline-element-icon {
  position: absolute;
  top: 0;
  left: 60px;
}
.vertical-timeline-element-icon .badge-dot-xl {
  box-shadow: 0 0 0 5px #fff;
}

.vertical-timeline-element--no-children .vertical-timeline-element-content {
  background: 0 0;
  box-shadow: none;
}
.vertical-timeline-element--no-children .vertical-timeline-element-content::before {
  display: none;
}

.vertical-without-time::before {
  left: 11px;
}
.vertical-without-time .vertical-timeline-element-content {
  margin-left: 36px;
}
.vertical-without-time .vertical-timeline-element-icon {
  left: 4px;
}

.vertical-time-icons {
  padding: 2rem 0 0;
}
.vertical-time-icons::before {
  content: "";
  position: absolute;
  top: 0;
  left: 14px;
  height: 100%;
  width: 6px;
  background: #e9ecef;
  border-radius: 0.25rem;
}
.vertical-time-icons .vertical-timeline-element {
  margin-bottom: 1rem;
}
.vertical-time-icons .vertical-timeline-element-content {
  margin-left: 50px;
}
.vertical-time-icons .vertical-timeline-element-icon {
  width: 34px;
  height: 34px;
  left: 0;
  top: -7px;
}
.vertical-time-icons .vertical-timeline-element-icon .timeline-icon {
  width: 34px;
  height: 34px;
  background: #fff;
  border-radius: 50px;
  border-width: 2px;
  border-style: solid;
  box-shadow: 0 0 0 5px #fff;
  text-align: center;
  display: flex;
  align-items: center;
  align-content: center;
}
.vertical-time-icons .vertical-timeline-element-icon .timeline-icon i {
  display: block;
  font-size: 1.1rem;
  margin: 0 auto;
}
.vertical-time-icons .vertical-timeline-element-icon .timeline-icon svg {
  margin: 0 auto;
}

.vertical-time-simple {
  padding: 0.5rem 0;
}
.vertical-time-simple .vertical-timeline-element {
  margin: 0 0 0.5rem;
}
.vertical-time-simple .timeline-title {
  font-weight: normal;
  font-size: 0.9166666667rem;
  padding: 0;
}
.vertical-time-simple .vertical-timeline-element-icon {
  height: 14px;
  width: 14px;
  background: #e9ecef;
  position: absolute;
  left: 6px;
  top: 2px;
  display: block;
  border-radius: 20px;
}
.vertical-time-simple .vertical-timeline-element-icon::after {
  content: "";
  position: absolute;
  background: #fff;
  left: 50%;
  top: 50%;
  margin: -4px 0 0 -4px;
  display: block;
  width: 8px;
  height: 8px;
  border-radius: 20px;
}
.vertical-time-simple .timeline-title {
  text-transform: none;
}

.dot-primary .vertical-timeline-element-icon {
  background: #545cd8;
}

.dot-secondary .vertical-timeline-element-icon {
  background: #6c757d;
}

.dot-success .vertical-timeline-element-icon {
  background: #3ac47d;
}

.dot-info .vertical-timeline-element-icon {
  background: #30b1ff;
}

.dot-warning .vertical-timeline-element-icon {
  background: #f7b924;
}

.dot-danger .vertical-timeline-element-icon {
  background: #d92550;
}

.dot-light .vertical-timeline-element-icon {
  background: #eeeeee;
}

.dot-dark .vertical-timeline-element-icon {
  background: #343a40;
}

.dot-focus .vertical-timeline-element-icon {
  background: #444054;
}

.dot-alternate .vertical-timeline-element-icon {
  background: #83588a;
}

.vertical-timeline--animate .vertical-timeline-element-icon.is-hidden {
  visibility: hidden;
}

.vertical-timeline--animate .vertical-timeline-element-icon.bounce-in {
  visibility: visible;
  animation: cd-bounce-1 0.8s;
}
@keyframes cd-bounce-1 {
  0% {
    opacity: 0;
    transform: scale(0.5);
  }
  60% {
    opacity: 1;
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
.vertical-timeline--animate .vertical-timeline-element-content.is-hidden {
  visibility: hidden;
}

.vertical-timeline--animate .vertical-timeline-element-content.bounce-in {
  visibility: visible;
  animation: cd-bounce-2 0.6s;
}

@media only screen and (min-width: 1170px) {
  .vertical-timeline--two-columns.vertical-timeline--animate .vertical-timeline-element.vertical-timeline-element--right .vertical-timeline-element-content.bounce-in, .vertical-timeline--two-columns.vertical-timeline--animate .vertical-timeline-element:nth-child(even):not(.vertical-timeline-element--left) .vertical-timeline-element-content.bounce-in {
    animation: cd-bounce-2-inverse 0.6s;
  }
}
@media only screen and (max-width: 1169px) {
  .vertical-timeline--animate .vertical-timeline-element-content.bounce-in {
    visibility: visible;
    animation: cd-bounce-2-inverse 0.6s;
  }
}
@keyframes cd-bounce-2 {
  0% {
    opacity: 0;
    transform: translateX(-100px);
  }
  60% {
    opacity: 1;
    transform: translateX(20px);
  }
  100% {
    transform: translateX(0);
  }
}
@keyframes cd-bounce-2-inverse {
  0% {
    opacity: 0;
    transform: translateX(100px);
  }
  60% {
    opacity: 1;
    transform: translateX(-20px);
  }
  100% {
    transform: translateX(0);
  }
}
.todo-list-wrapper .todo-indicator {
  position: absolute;
  width: 4px;
  height: 60%;
  border-radius: 0.3rem;
  left: 0.5rem;
  top: 20%;
  opacity: 0.6;
  transition: opacity 0.2s;
}
.todo-list-wrapper .list-group-item:hover .todo-indicator {
  opacity: 0.9;
}
.todo-list-wrapper .custom-control,
.todo-list-wrapper input[checkbox] {
  margin-left: 0.5rem;
}

.list-group-flush + .card-footer {
  border-top: 0;
}

.rm-list-borders .list-group-item {
  border: 0;
  padding: 0.6666666667rem 0;
}

.rm-list-borders-scroll .list-group-item {
  border: 0;
  padding-right: 1.5rem;
}

.input-group .input-group-prepend div:not([class]) .react-datepicker__input-container .form-control, .input-group .input-group-prepend + div .react-datepicker__input-container .form-control {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important;
}
.input-group > div:not([class]) {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
}
.input-group > div:not([class]) .react-datepicker__input-container .form-control {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group .input-group-prepend + div {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
}
.input-group > .react-datepicker-wrapper {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
}
.input-group > .react-datepicker-wrapper > .react-datepicker__input-container > .form-control {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

legend {
  font-size: 0.88rem;
  font-weight: bold;
}

.form-heading {
  font-size: 1.1rem;
  margin: 0;
  color: #545cd8;
}
.form-heading p {
  color: #6c757d;
  padding: 0.3rem 0 0;
  font-size: 0.88rem;
}

.customPassErr {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #d92550;
}

.custom-select {
  -webkit-appearance: none;
  -moz-appearance: none;
}

.pagination li a {
  position: relative;
  display: block;
  padding: 0.375rem 0.75rem;
  margin-left: -1px;
  color: #545cd8;
  background-color: #fff;
  border: 1px solid #dee2e6;
}
.pagination li a:hover {
  z-index: 2;
  color: rgb(67.2, 73.6, 172.8);
  text-decoration: none;
  background-color: #e9ecef;
  border-color: #dee2e6;
}
.pagination li a:focus {
  z-index: 2;
  outline: 0;
  box-shadow: none;
}
.pagination li a:not(:disabled):not(.disabled) {
  cursor: pointer;
}
.pagination li:first-child a {
  margin-left: 0;
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.pagination li:last-child a {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.pagination li.active a {
  z-index: 1;
  color: #fff;
  background-color: #545cd8;
  border-color: #545cd8;
}
.pagination li.active a:hover {
  color: #fff;
}
.pagination li.disabled a {
  color: #6c757d;
  pointer-events: none;
  cursor: auto;
  background-color: #fff;
  border-color: #dee2e6;
}

.pagination-rounded li a {
  border-radius: 50px !important;
  margin: 0 0.3rem;
}

.chat-box-wrapper {
  display: flex;
  clear: both;
  padding: 0.75rem;
}
.chat-box-wrapper + .chat-box-wrapper {
  padding-top: 0;
}
.chat-box-wrapper .chat-box {
  box-shadow: 0 0 0 transparent;
  position: relative;
  opacity: 1;
  background: #e0f3ff;
  border: 0;
  padding: 0.75rem 1.5rem;
  border-radius: 30px;
  border-top-left-radius: 0.25rem;
  flex: 1 1;
  display: flex;
  max-width: 50%;
  min-width: 100%;
  text-align: left;
}
.chat-box-wrapper .chat-box + small, .chat-box-wrapper .chat-box + .small {
  text-align: left;
  padding: 0.5rem 0 0;
  margin-left: 1.5rem;
  display: block;
}
.chat-box-wrapper.chat-box-wrapper-right {
  text-align: right;
}
.chat-box-wrapper.chat-box-wrapper-right .chat-box {
  border-radius: 30px;
  border-top-left-radius: 30px;
  border-top-right-radius: 0.25rem;
  margin-left: auto;
}
.chat-box-wrapper.chat-box-wrapper-right .chat-box + small, .chat-box-wrapper.chat-box-wrapper-right .chat-box + .small {
  text-align: right;
  margin-right: 1.5rem;
  margin-left: 0;
}

.forms-wizard {
  margin: 0;
  padding: 0;
  list-style-type: none;
  width: 100%;
  display: table;
  table-layout: fixed;
  border-radius: 0.25rem;
}
.forms-wizard li {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  cursor: pointer;
  font-size: 1rem;
  padding: 1rem 0;
  color: #adb5bd;
  position: relative;
}
.forms-wizard li::after, .forms-wizard li::before {
  position: absolute;
  height: 4px;
  top: 50%;
  margin-top: -1rem;
  width: 50%;
  content: "";
  background: #dee2e6;
  z-index: 5;
  transition: all 0.2s;
}
.forms-wizard li::after {
  left: 50%;
}
.forms-wizard li::before {
  left: 0;
}
.forms-wizard li:first-child::before {
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
}
.forms-wizard li:last-child::after {
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
}
.forms-wizard li em {
  font-style: normal;
  font-size: 1.32rem;
  background: #ced4da;
  color: #fff;
  text-align: center;
  padding: 0;
  width: 40px;
  height: 40px;
  line-height: 40px;
  border-radius: 50px;
  display: block;
  margin: 0 auto 0.5rem;
  position: relative;
  z-index: 7;
  transition: all 0.2s;
}
.forms-wizard li.form-wizard-step-doing {
  color: #495057;
}
.forms-wizard li.form-wizard-step-doing em {
  background: #545cd8;
}
.forms-wizard li.form-wizard-step-doing::before {
  background: #545cd8;
}
.forms-wizard li.form-wizard-step-done em {
  font-family: "Linearicons-Free";
  background: #3ac47d;
  overflow: hidden;
}
.forms-wizard li.form-wizard-step-done em::before {
  width: 42px;
  height: 42px;
  font-size: 1.2rem;
  line-height: 40px;
  text-align: center;
  display: block;
}
.forms-wizard li.form-wizard-step-done::after, .forms-wizard li.form-wizard-step-done::before {
  background: #3ac47d;
}
.forms-wizard li:hover {
  color: #6c757d;
}

.forms-wizard-alt .forms-wizard li {
  font-size: 0.88rem;
}
.forms-wizard-alt .forms-wizard li em {
  width: 14px;
  height: 14px;
  line-height: 14px;
  text-indent: -999rem;
  border: #fff solid 2px;
  margin: -7px auto 0;
}

.forms-wizard-vertical .forms-wizard {
  display: block;
  width: 30%;
  float: left;
  padding: 0 1.5rem 1.5rem 0;
}
.forms-wizard-vertical .forms-wizard li {
  text-align: left;
  display: flex;
  align-items: center;
  align-content: flex-start;
  padding: 0.75rem;
  margin-bottom: 0.5rem;
  border-radius: 0.3rem;
  transition: all 0.2s;
}
.forms-wizard-vertical .forms-wizard li::before, .forms-wizard-vertical .forms-wizard li::after {
  display: none;
}
.forms-wizard-vertical .forms-wizard li em {
  margin: 0 0.75rem 0 0;
}
.forms-wizard-vertical .forms-wizard li:hover {
  background: #e9ecef;
}
.forms-wizard-vertical .forms-wizard li.form-wizard-step-doing {
  background: #545cd8;
  color: #fff;
}
.forms-wizard-vertical .forms-wizard li.form-wizard-step-doing em {
  background: rgba(255, 255, 255, 0.2);
}
.forms-wizard-vertical .form-wizard-content {
  width: 70%;
  overflow: auto;
}

@media screen and (min-width: 360px) and (max-width: 812px) {
  .forms-wizard-vertical .forms-wizard {
    display: block;
    width: 50%;
    float: left;
    padding: 0 1.5rem 1.5rem 0;
  }
  .forms-wizard-vertical .forms-wizard li {
    text-align: left;
    display: flex;
    align-items: center;
    align-content: flex-start;
    padding: 0.75rem;
    margin-bottom: 0.5rem;
    border-radius: 0.3rem;
    transition: all 0.2s;
  }
  .forms-wizard-vertical .forms-wizard li::before, .forms-wizard-vertical .forms-wizard li::after {
    display: none;
  }
  .forms-wizard-vertical .forms-wizard li em {
    margin: 0 0.75rem 0 0;
  }
  .forms-wizard-vertical .forms-wizard li:hover {
    background: #e9ecef;
  }
  .forms-wizard-vertical .forms-wizard li.form-wizard-step-doing {
    background: #545cd8;
    color: #fff;
  }
  .forms-wizard-vertical .forms-wizard li.form-wizard-step-doing em {
    background: rgba(255, 255, 255, 0.2);
  }
  .forms-wizard-vertical .form-wizard-content {
    width: 50%;
    overflow: auto;
  }
}
.icon-wrapper {
  display: flex;
  align-content: center;
  align-items: center;
}

.widget-chart {
  text-align: center;
  padding: 1rem;
  position: relative;
}
.widget-chart .progress-sub-label {
  opacity: 0.8;
  padding: 5px 0 0;
}
.widget-chart .progress-circle-wrapper {
  min-width: 68px;
  margin-right: 1rem;
}
.widget-chart .progress-circle-wrapper .react-sweet-progress-symbol {
  font-size: 0.8rem;
}
.widget-chart .widget-chart-content {
  position: relative;
  z-index: 5;
}
.widget-chart .widget-chart-content-lg {
  padding: 2rem 0 1rem 2rem;
}
.widget-chart .widget-chart-content-lg .widget-numbers {
  margin-bottom: 0;
}
.widget-chart .widget-chart-wrapper {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  opacity: 0.25;
  z-index: 6;
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
  overflow: hidden;
}
.widget-chart .widget-numbers {
  font-weight: bold;
  font-size: 2.5rem;
  display: block;
  line-height: 1;
  margin: 1rem auto;
}
.widget-chart .widget-numbers + .widget-chart-flex, .widget-chart .widget-numbers + .widget-description, .widget-chart .widget-numbers + .widget-subheading {
  margin-top: -0.5rem;
}
.widget-chart .widget-subheading {
  margin: -0.5rem 0 0;
  display: block;
  opacity: 0.6;
}
.widget-chart .widget-subheading:first-child {
  margin-top: 0;
}
.widget-chart .widget-subheading + .widget-numbers {
  margin-top: 0.5rem;
}
.widget-chart .widget-description {
  margin: 1rem 0 0;
}
.widget-chart.widget-chart-hover {
  transition: all 0.2s;
}
.widget-chart.widget-chart-hover:hover {
  z-index: 15;
  transform: scale(1.15);
  box-shadow: 0 0.46875rem 4.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.9375rem 2.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.25rem 1.3125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.06), 0 0.125rem 1.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.06);
  cursor: pointer;
  background: #fff;
}
.widget-chart .widget-chart-actions {
  position: absolute;
  right: 0.5rem;
  top: 0.5rem;
  z-index: 12;
}
.widget-chart .widget-chart-actions .btn-link {
  font-size: 1.1rem;
  padding-top: 0;
  padding-bottom: 0;
  opacity: 0.6;
}
.widget-chart .widget-progress-wrapper {
  margin-top: 1rem;
}
.widget-chart .widget-progress-wrapper.progress-wrapper-bottom {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
}
.widget-chart .widget-progress-wrapper.progress-wrapper-bottom .progress {
  margin: 0 -1px -1px;
}
.widget-chart .widget-progress-wrapper.progress-wrapper-bottom .progress {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.widget-chart .widget-progress-wrapper.progress-wrapper-bottom .progress .progress-bar {
  border-bottom-left-radius: 0.25rem;
}
.widget-chart .widget-chart-flex {
  display: flex;
  align-items: center;
  align-content: center;
  margin-bottom: 1rem;
}
.widget-chart .widget-chart-flex:last-child {
  margin-bottom: 0;
}
.widget-chart .widget-chart-flex .widget-subheading {
  margin: 0;
}
.widget-chart .widget-chart-flex .widget-description {
  margin-top: 0;
}
.widget-chart.text-start {
  flex-direction: row;
  align-items: center;
}
.widget-chart.text-start .icon-wrapper {
  min-width: 54px;
  margin: 0 1rem 0 0;
}
.widget-chart.text-start .widget-numbers {
  margin-left: 0;
}
.widget-chart.text-start .widget-chart-content {
  display: flex;
  flex-direction: column;
  align-content: center;
  flex: 1 1;
  position: relative;
}
.widget-chart.text-start .widget-chart-content > .widget-numbers:first-child {
  margin-top: 0;
}
.widget-chart.text-start .widget-chart-content .widget-description {
  align-self: flex-start;
}
.widget-chart.text-start .widget-chart-wrapper {
  height: 35%;
}
.widget-chart.widget-chart-left {
  padding-bottom: 15%;
}
.widget-chart .chart-wrapper-relative {
  position: relative;
  opacity: 1;
  margin-top: 1rem;
}

.widget-chart-actions {
  position: absolute;
  right: 1rem;
  top: 1rem;
  z-index: 12;
}
.widget-chart-actions .btn-link {
  font-size: 1.1rem;
  padding-top: 0;
  padding-bottom: 0;
  opacity: 0.6;
}

.widget-chart:hover .widget-chart-actions .btn-link,
.widget-content:hover .widget-chart-actions .btn-link {
  opacity: 1;
}

.grid-menu .widget-chart.widget-chart-hover:hover {
  background: #fff;
  border-radius: 0.25rem;
}

.icon-wrapper {
  width: 54px;
  height: 54px;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
}
.icon-wrapper[class*=border-] {
  border-width: 1px;
  border-style: solid;
}
.icon-wrapper .icon-wrapper-bg {
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 3;
  opacity: 0.2;
}
.icon-wrapper .icon-wrapper-bg.bg-light {
  opacity: 0.08;
}
.icon-wrapper i {
  margin: 0 auto;
  font-size: 1.7rem;
  position: relative;
  z-index: 5;
}
.icon-wrapper i:before {
  margin-top: -3px;
}
.icon-wrapper .progress-circle-wrapper {
  width: 100%;
  margin-right: 0;
}

.widget-chart2 .widget-chart-flex {
  display: flex;
  align-items: baseline;
  align-content: center;
  margin-bottom: 0;
}
.widget-chart2 .widget-chart-flex .widget-subtitle {
  margin-left: auto;
}
.widget-chart2 .widget-chart-flex .widget-numbers {
  font-weight: normal;
}
.widget-chart2 .widget-chart-flex + .widget-chart-flex .widget-numbers {
  margin-bottom: 0;
}
.widget-chart2 .widget-chat-wrapper-outer {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  max-width: 100%;
}
.widget-chart2 .widget-chat-wrapper-outer .widget-chart-wrapper {
  height: 70px;
  opacity: 0.8;
  position: relative;
  margin: 1rem auto -0.5rem;
}
.widget-chart2 .widget-chat-wrapper-outer .widget-chart-wrapper-lg {
  height: 130px;
}

.card-btm-border {
  border-bottom: transparent solid 4px;
}

.progress-box {
  text-align: center;
}
.progress-box h4, .progress-box .h4 {
  font-size: 0.88rem;
  font-weight: bold;
  opacity: 0.6;
  text-transform: uppercase;
  padding-bottom: 0.3333333333rem;
}
.progress-box svg {
  margin: 0 auto;
}

.svg-bg {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0.1;
}
.svg-bg svg {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.widget-numbers-sm {
  font-size: 1.5rem;
}

.widget-content {
  padding: 1rem;
  flex-direction: row;
  align-items: center;
}
.widget-content .widget-content-wrapper {
  display: flex;
  flex: 1 1;
  position: relative;
  align-items: center;
}
.widget-content .widget-content-left .widget-heading {
  opacity: 0.8;
  font-weight: bold;
}
.widget-content .widget-content-left .widget-subheading {
  opacity: 0.5;
}
.widget-content .widget-content-right {
  margin-left: auto;
}
.widget-content .widget-numbers {
  font-weight: bold;
  font-size: 1.8rem;
  display: block;
}
.widget-content .widget-content-outer {
  display: flex;
  flex: 1 1;
  flex-direction: column;
}
.widget-content .widget-progress-wrapper {
  margin-top: 1rem;
}
.widget-content .widget-progress-wrapper .progress-sub-label {
  margin-top: 0.3333333333rem;
  opacity: 0.5;
  display: flex;
  align-content: center;
  align-items: center;
}
.widget-content .widget-progress-wrapper .progress-sub-label .sub-label-right {
  margin-left: auto;
}
.widget-content .widget-content-right.widget-content-actions {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.2s;
}
.widget-content:hover .widget-content-right.widget-content-actions {
  visibility: visible;
  opacity: 1;
}

.profile-block {
  position: relative;
  overflow: hidden;
}
.profile-block .profile-blur {
  width: 100%;
  height: 100%;
  filter: blur(5px);
  transform: scale(1.8);
  position: absolute;
  left: -25%;
  top: -25%;
}
.profile-block .profile-inner {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  left: 0;
  top: 0;
}
.profile-block .dropdown-menu-header .menu-header-content {
  padding: 3rem;
}
.profile-block .dropdown-menu-header .menu-header-content .menu-header-title {
  margin: 0.75rem 0 0;
}
.profile-block .dropdown-menu-header .menu-header-content .menu-header-subtitle {
  margin: 0.5rem 0 0;
}
.profile-block .dropdown-menu-header .menu-header-btn-pane {
  margin: 0.5rem 0 0;
}
.profile-block .dropdown-menu-header .menu-header-btn-pane .btn-icon {
  color: #fff;
  padding: 0;
  width: 44px;
  height: 44px;
  line-height: 37px;
  font-size: 1.1rem;
}
.profile-block .dropdown-menu-header .menu-header-btn-pane .btn-icon:hover {
  background: rgba(255, 255, 255, 0.2);
}

.app-logo {
  height: 23px;
  width: 97px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
}

.app-logo-inverse {
  height: 23px;
  width: 97px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
}

.app-login-box .app-logo {
  margin-bottom: 3rem;
}
.app-login-box h4, .app-login-box .h4 {
  margin-bottom: 1.5rem;
  font-weight: normal;
}
.app-login-box h4 div, .app-login-box .h4 div {
  opacity: 0.6;
}
.app-login-box h4 span, .app-login-box .h4 span {
  font-size: 1.1rem;
}

span.ps-menu-label i {
  font-size: 24px;
  position: relative;
  top: 5px;
  margin-right: 16px;
}

i.pe {
  font-size: 24px;
  position: relative;
  right: 5px;
}

.css-dip3t8 {
  background-color: rgba(249, 249, 249, 0) !important;
}

.css-1wvake5 {
  border: none !important;
}

.page-heading-sections {
  padding-bottom: 19px;
}
.page-heading-sections h2, .page-heading-sections .h2 {
  margin-bottom: 0px;
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
  color: #1d1d1d;
}
.page-heading-sections .form-check {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 11px;
}
.page-heading-sections .form-check label.form-check-label {
  font-weight: 400;
  font-size: 15px;
  line-height: 22px;
  color: #3f3f3f;
}
.page-heading-sections .form-check input.form-check-input {
  width: 20px;
  height: 20px;
}
.page-heading-sections .form-check input.form-check-input:focus {
  box-shadow: none;
}
.page-heading-sections .form-check input.form-check-input:checked {
  background-color: #545cd8;
  border-color: #545cd8;
}

.formula-page .rounded-3 {
  border: 1px solid #cacaca;
  border-radius: 10px !important;
  margin-top: 30px;
}
.formula-page table {
  margin-bottom: 0px !important;
}
.formula-page table thead {
  background-color: #545cd8;
  color: #fff;
}
.formula-page table thead tr th {
  text-align: center;
  padding: 17px 34px;
  font-weight: 500;
  font-size: 15px;
  line-height: 22px;
  color: #ffffff;
}
.formula-page table tbody tr td {
  text-align: center;
  font-weight: 400;
  font-size: 15px;
  line-height: 22px;
  color: #1d1d1d;
  padding: 10px;
}
.formula-page table tbody tr td a {
  padding-left: 10px;
}
.formula-page table tbody .input-group {
  border: 1px solid #c8c8c8;
  border-radius: 4px;
  max-width: 172px;
  margin: 0px !important;
}
.formula-page table tbody .input-group .form-control {
  border: 0px;
}
.formula-page table button {
  background: #545cd8;
  border-color: #545cd8;
  color: #1d1d1d;
  font-size: 15px;
}
.formula-page .foot-form {
  background: #f4f4f4;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 27px 34px;
  gap: 10px;
  flex-wrap: wrap;
  border-top: 1px solid #e7e7e7 !important;
}
.formula-page .foot-form .auto-generate {
  min-width: 172px;
  margin-bottom: 0px !important;
  border: 1px solid #c8c8c8;
  border-radius: 4px;
  max-width: 20%;
}
.formula-page .foot-form .auto-generate .form-control {
  border: 0px !important;
  box-shadow: none;
}
.formula-page .foot-form .auto-generate .form-control:hover {
  box-shadow: none;
}
.formula-page .foot-form .auto-generate span {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  background-color: #f2f2f2;
  padding: 5px 10px;
  width: 35px;
  height: 35px;
  text-align: center;
}
.formula-page .foot-form .search-items {
  position: relative;
  border: 1px solid #ccc;
  border-radius: 4px;
  min-width: 200px;
  padding-left: 30px;
  background: #fff;
  max-width: 20%;
  flex-shrink: 1;
}
.formula-page .foot-form .search-items::before {
  content: "";
  display: block;
  position: absolute;
  left: 15px;
  top: 9px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  background-size: contain;
  background-repeat: no-repeat;
  width: 17px;
  height: 17px;
}
.formula-page .foot-form .search-items .mb-3 {
  margin-bottom: 0px !important;
}
.formula-page .foot-form .search-items select.form-select {
  border: 0px;
  margin: 0px;
  box-shadow: none;
}
.formula-page .foot-form .search-items select.form-select:focus, .formula-page .foot-form .search-items select.form-select:hover {
  box-shadow: none;
}
.formula-page .foot-form .btn {
  padding: 10px 25px !important;
}
.formula-page .editbtns {
  background: transparent;
  box-shadow: none;
  border: 0;
}
.formula-page .delet-icon {
  text-align: center;
}
.formula-page span.tags {
  padding: 5px 21px;
  border-radius: 50px;
  background: #dddddd;
  font-size: 13px;
  margin-left: 20px;
}

.equation-modal .modal-content {
  min-width: 700px;
}
.equation-modal .modal-content textarea {
  height: 200px;
  resize: none;
  box-shadow: none;
  margin-bottom: 24px;
}
.equation-modal .modal-content textarea:hover, .equation-modal .modal-content textarea:focus {
  box-shadow: none;
}
.equation-modal .modal-content .search-input {
  background: #ffffff;
  border: 1px solid #1d1d1d;
  border-radius: 50px;
  color: #1d1d1d;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
  padding: 11px 24px;
  box-shadow: none;
}
.equation-modal .modal-content table tr td,
.equation-modal .modal-content table tr th {
  padding: 10px 20px;
}
.equation-modal .modal-content .rounded-3 {
  border: 1px solid #cacaca;
  border-radius: 10px !important;
  margin-top: 16px;
  margin-bottom: 50px;
}
.equation-modal .modal-head {
  padding-left: 30px;
  padding-right: 30px;
}
.equation-modal .modal-body {
  padding-left: 30px;
  padding-right: 30px;
}
.equation-modal .modal-footer {
  padding: 26px 30px 50px;
}
.equation-modal .modal-footer button {
  border-radius: 50px;
  font-size: 15px;
  padding: 9px 25px;
  width: 100px;
}
.equation-modal .modal-footer button .btn-secondary-1 {
  border: 1px solid #1d1d1d;
  color: #1d1d1d !important;
  background-color: #ffffff;
}
.equation-modal .modal-footer button .btn-secondary {
  background-color: #1d1d1d;
}
.equation-modal.twocol .modal-dialog {
  max-width: 1000px;
}

.foot-save-btn {
  border-radius: 50px;
  font-size: 15px;
  padding: 9px 40px;
  width: 142px;
}

.listing-table {
  margin-bottom: 30px;
}

.equation-box {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 16px;
  border-radius: 8px;
  background-color: #fff;
}

.equation-box .text-primary {
  font-weight: bold;
}

.formula_acceptance {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: nowrap;
  gap: 18px;
  padding: 27px 35px;
  background: #ffffff;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.12);
  border-radius: 10px;
  margin-bottom: 36px;
  margin-top: 30px;
}
@media (max-width: 767px) {
  .formula_acceptance {
    flex-direction: column;
  }
}
.formula_acceptance label {
  font-family: "Poppins", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 27px;
  color: #1d1d1d;
  margin-right: 45px;
}
.formula_acceptance .data-field {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 14px;
  min-width: 40%;
}
@media (max-width: 992px) {
  .formula_acceptance .data-field {
    min-width: 30%;
  }
}
.formula_acceptance .data-field span {
  font-family: "Poppins", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  color: #5e5e5e;
}
.formula_acceptance .data-field .auto-generate {
  margin-bottom: 0px !important;
  border: 1px solid #c8c8c8;
  border-radius: 4px;
  display: flex;
  flex-wrap: nowrap;
}
.formula_acceptance .data-field .auto-generate .form-control {
  border: 0px !important;
  box-shadow: none;
}
.formula_acceptance .data-field .auto-generate .form-control:hover {
  box-shadow: none;
}
.formula_acceptance .data-field .auto-generate span {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  background-color: #f2f2f2;
  padding: 5px 10px;
  width: 35px;
  height: 35px;
  text-align: center;
}
.formula_acceptance .data-field input {
  flex-shrink: 1;
}

.filter-search header {
  padding: 0 !important;
}

.app-inner-layout.rm-sidebar .app-inner-layout__wrapper .app-inner-layout__content {
  width: auto;
  float: none;
}
.app-inner-layout .app-inner-layout__header {
  width: 100%;
  padding: 1.5rem;
  text-align: left;
  border-bottom: #e9ecef solid 1px;
}
.app-inner-layout .app-inner-layout__header .app-page-title {
  margin: 0;
  padding: 0;
  background: transparent;
}
.app-inner-layout .app-inner-layout__header-boxed {
  padding: 1.5rem;
}
.app-inner-layout .app-inner-layout__header-boxed .app-inner-layout__header {
  border-radius: 0.3rem;
}
.app-inner-layout .app-inner-layout__wrapper {
  position: relative;
  display: flex;
  flex-direction: row;
  min-height: 100vh;
}
.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__content {
  flex: 1 1;
  display: flex;
}
.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__content.card {
  box-shadow: 0 0 0 0 transparent;
  border-radius: 0;
  border: 0;
}
.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__content .app-inner-layout__top-pane {
  display: flex;
  align-content: center;
  align-items: center;
  text-align: left;
  padding: 0.75rem 1.5rem;
}
.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__content .pane-left {
  display: flex;
  align-items: center;
}
.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__content .pane-right {
  display: flex;
  align-items: center;
  margin-left: auto;
}
.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__content .app-inner-layout__bottom-pane {
  padding: 1.5rem;
  border-top: #e9ecef solid 1px;
}
.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__sidebar {
  width: 270px;
  list-style: none;
  text-align: left;
  order: -1;
  flex: 0 0 270px;
  display: flex;
  margin: 0;
  position: relative;
}
.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__sidebar .dropdown-item {
  white-space: normal;
}
.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__sidebar.card {
  box-shadow: 0 0 0 0 transparent;
  border-radius: 0;
  background: #f8f9fa;
  border: 0;
  border-right: #e9ecef solid 1px;
  border-left: #e9ecef solid 1px;
}
.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__sidebar .app-inner-layout__sidebar-footer,
.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__sidebar .app-inner-layout__sidebar-header {
  background: #f8f9fa;
}
.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__aside {
  width: 60px;
}
.app-inner-layout .app-inner-layout__footer {
  width: 100%;
  height: 50px;
}

.app-wrapper-footer .app-footer {
  border-top: #e9ecef solid 1px;
}
.app-wrapper-footer .app-footer .app-footer__inner {
  border-left: #e9ecef solid 1px;
}

.chat-layout.app-inner-layout .app-inner-layout__sidebar {
  width: 360px;
  flex: 0 0 360px;
}
.chat-layout .app-inner-layout__top-pane h4, .chat-layout .app-inner-layout__top-pane .h4 {
  font-size: 1.1rem;
}
.chat-layout .app-inner-layout__top-pane h4 div, .chat-layout .app-inner-layout__top-pane .h4 div {
  font-size: 0.88rem;
}
.chat-layout .chat-box-wrapper {
  padding: 1.5rem;
}

@media (max-width: 991.98px) {
  .chat-layout.app-inner-layout .app-inner-layout__sidebar .widget-content .widget-content-left .widget-subheading {
    white-space: normal;
  }
}
.mobile-app-menu-btn {
  display: none;
  margin: 3px 1.5rem 0 0;
}

@media (max-width: 767.98px) {
  .app-inner-layout__sidebar {
    display: none !important;
  }
  .mobile-app-menu-btn {
    display: block;
  }
  .open-mobile-menu .app-inner-layout__sidebar {
    display: block !important;
  }
}
/*
 * Container style
 */
.ps {
  overflow: hidden !important;
  overflow-anchor: none;
  touch-action: auto;
}

/*
 * Scrollbar rail styles
 */
.ps__rail-x {
  display: none !important;
  opacity: 0;
  transition: background-color 0.2s linear, opacity 0.2s linear;
  height: 15px;
  /* there must be 'bottom' or 'top' for ps__rail-x */
  bottom: 0;
  /* please don't change 'position' */
  position: absolute;
  z-index: 7;
}

.ps__rail-y {
  display: none;
  opacity: 0;
  transition: background-color 0.2s linear, opacity 0.2s linear;
  width: 15px;
  /* there must be 'right' or 'left' for ps__rail-y */
  right: 0;
  /* please don't change 'position' */
  position: absolute;
  border-radius: 50px;
  z-index: 7;
}

.ps--active-x > .ps__rail-x,
.ps--active-y > .ps__rail-y {
  display: block;
  background-color: transparent;
}

.ps:hover > .ps__rail-x,
.ps:hover > .ps__rail-y,
.ps--focus > .ps__rail-x,
.ps--focus > .ps__rail-y,
.ps--scrolling-x > .ps__rail-x,
.ps--scrolling-y > .ps__rail-y {
  opacity: 0.6;
}

.ps__rail-x:hover,
.ps__rail-y:hover,
.ps__rail-x:focus,
.ps__rail-y:focus {
  background-color: rgba(0, 0, 0, 0.1);
  opacity: 0.9;
}

/*
 * Scrollbar thumb styles
 */
.ps__thumb-x {
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  transition: background-color 0.2s linear, height 0.2s ease-in-out;
  height: 6px;
  /* there must be 'bottom' for ps__thumb-x */
  bottom: 2px;
  /* please don't change 'position' */
  position: absolute;
}

.ps__thumb-y {
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  transition: background-color 0.2s linear, width 0.2s ease-in-out;
  width: 6px;
  /* there must be 'right' for ps__thumb-y */
  right: 2px;
  /* please don't change 'position' */
  position: absolute;
}

.ps__rail-x:hover > .ps__thumb-x,
.ps__rail-x:focus > .ps__thumb-x {
  background-color: rgba(0, 0, 0, 0.12);
  height: 11px;
}

.ps__rail-y:hover > .ps__thumb-y,
.ps__rail-y:focus > .ps__thumb-y {
  background-color: rgba(0, 0, 0, 0.12);
  width: 11px;
}

/* MS supports */
@supports (-ms-overflow-style: none) {
  .ps {
    overflow: auto !important;
  }
}
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .ps {
    overflow: auto !important;
  }
}
.scrollbar-container {
  position: relative;
  height: 100%;
}

.scroll-area {
  overflow-x: hidden;
  height: 400px;
}

.scroll-area-xs {
  height: 150px;
  overflow-x: hidden;
}

.scroll-area-sm {
  height: 200px;
  overflow-x: hidden;
}

.scroll-area-md {
  height: 300px;
  overflow-x: hidden;
}

.scroll-area-lg {
  height: 400px;
  overflow-x: hidden;
}

.scroll-area-x {
  overflow-x: auto;
  width: 100%;
  max-width: 100%;
}

.shadow-overflow {
  position: relative;
}
.shadow-overflow::after, .shadow-overflow::before {
  width: 100%;
  bottom: auto;
  top: 0;
  left: 0;
  height: 1.5rem;
  position: absolute;
  z-index: 10;
  content: "";
  background: linear-gradient(to bottom, rgb(255, 255, 255) 20%, rgba(255, 255, 255, 0) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#ffffff", endColorstr="#00ffffff", GradientType=0);
}
.shadow-overflow::after {
  bottom: 0;
  top: auto;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgb(255, 255, 255) 80%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#00ffffff", endColorstr="#ffffff", GradientType=0);
}

.rc-tabs {
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}

.rc-tabs-bar,
.rc-tabs-nav-container {
  font-size: 14px;
  line-height: 1.5;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  white-space: nowrap;
  outline: none;
  zoom: 1;
  transition: padding 0.45s;
}

.rc-tabs-ink-bar {
  margin-top: 0;
  border-radius: 0.25rem;
  box-shadow: 0 16px 26px -10px rgba(84, 92, 216, 0.56), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(84, 92, 216, 0.2);
}

.rc-tabs-ink-bar-animated {
  transition: all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1) 0s;
}

.rc-tabs-tab-prev,
.rc-tabs-tab-next {
  -webkit-user-select: none;
  user-select: none;
  z-index: 1;
  line-height: 36px;
  cursor: pointer;
  border: none;
  background-color: transparent;
  position: absolute;
}

.rc-tabs-tab-prev-icon,
.rc-tabs-tab-next-icon {
  position: relative;
  display: inline-block;
  font-style: normal;
  font-weight: normal;
  font-feature-settings: normal;
  font-variant: normal;
  line-height: inherit;
  vertical-align: baseline;
  text-align: center;
  text-transform: none;
  font-smoothing: antialiased;
  text-stroke-width: 0;
  font-family: sans-serif;
}

.rc-tabs-tab-prev-icon:before,
.rc-tabs-tab-next-icon:before {
  display: block;
}

.rc-tabs-tab-btn-disabled {
  cursor: default;
  color: #495057;
}

.rc-tabs-nav-wrap {
  overflow: hidden;
}

.rc-tabs-nav {
  box-sizing: border-box;
  padding-left: 0;
  position: relative;
  margin: 0;
  float: left;
  list-style: none;
  display: inline-block;
  transform-origin: 0 0;
}
.rc-tabs-nav > div:first-child {
  z-index: 5;
  position: relative;
}

.rc-tabs-nav-animated {
  transition: transform 0.5s cubic-bezier(0.35, 0, 0.25, 1);
}

.rc-tabs-nav:before,
.rc-tabs-nav:after {
  display: table;
  content: " ";
}

.rc-tabs-nav:after {
  clear: both;
}

.rc-tabs-tab {
  box-sizing: border-box;
  position: relative;
  display: block;
  transition: color 0.3s cubic-bezier(0.35, 0, 0.25, 1);
  padding: 8px 20px;
  cursor: pointer;
}

.rc-tabs-tab:hover {
  color: #545cd8;
}

.rc-tabs-tab-active,
.rc-tabs-tab-active:hover {
  color: #fff;
  cursor: default;
  transform: translateZ(0);
}

.rc-tabs-tab-disabled {
  cursor: default;
  color: #495057;
}

.rc-tabs-tab-disabled:hover {
  color: #495057;
}

.rc-tabs-content {
  zoom: 1;
}

.rc-tabs-content .rc-tabs-tabpane {
  overflow: hidden;
}

.rc-tabs-content-animated {
  transition: transform 0.3s cubic-bezier(0.35, 0, 0.25, 1), margin-left 0.3s cubic-bezier(0.35, 0, 0.25, 1), margin-top 0.3s cubic-bezier(0.35, 0, 0.25, 1);
  display: flex;
  will-change: transform;
}

.rc-tabs-content-animated .rc-tabs-tabpane {
  flex-shrink: 0;
}

.no-flexbox .rc-tabs-content {
  transform: none !important;
  overflow: hidden;
}

.no-csstransitions .rc-tabs-tabpane-inactive,
.no-flexbox .rc-tabs-tabpane-inactive,
.rc-tabs-content-no-animated .rc-tabs-tabpane-inactive {
  display: none;
}

.rc-tabs-bottom .rc-tabs-tab-arrow-show {
  opacity: 1;
  width: 100%;
  height: 35px;
}

.rc-tabs-top .rc-tabs-tab-arrow-show {
  opacity: 1;
  width: 100%;
  height: 35px;
}

.rc-tabs-top .rc-tabs-content {
  width: 100%;
}

.rc-tabs-top .rc-tabs-nav-container-scrolling {
  padding-left: 35px;
  padding-right: 35px;
}

.rc-tabs-top .rc-tabs-nav-scroll {
  width: 99999px;
}

.rc-tabs-top .rc-tabs-nav-swipe {
  position: relative;
  left: 0;
}

.rc-tabs-top .rc-tabs-nav-swipe .rc-tabs-nav {
  display: flex;
  flex: 1 1;
  width: 100%;
}

.rc-tabs-top .rc-tabs-nav-swipe .rc-tabs-nav .rc-tabs-tab {
  display: flex;
  flex-shrink: 0;
  margin-right: 0;
  padding: 8px 0;
  justify-content: center;
}

.rc-tabs-top .rc-tabs-nav-wrap {
  width: 100%;
  padding: 1.5rem 0.75rem;
}

.rc-tabs-top .rc-tabs-content-animated {
  flex-direction: row;
}

.rc-tabs-top .rc-tabs-content-animated .rc-tabs-tabpane {
  width: 100%;
}

.rc-tabs-top .rc-tabs-tab-next {
  right: 2px;
}

.rc-tabs-top .rc-tabs-tab-next-icon:before {
  content: ">";
}

.rc-tabs-top .rc-tabs-tab-prev {
  left: 0;
}

.rc-tabs-top .rc-tabs-tab-prev-icon:before {
  content: "<";
}

.rc-tabs-top .rc-tabs-tab-prev,
.rc-tabs-top .rc-tabs-tab-next {
  margin-right: -2px;
  width: 0;
  height: 0;
  top: 0;
  text-align: center;
  opacity: 0;
  transition: width 0.3s, height 0.3s, opacity 0.3s;
}

.rc-tabs-top .rc-tabs-tab-arrow-show {
  opacity: 1;
  width: 35px;
  height: 100%;
}

.rc-tabs-top .rc-tabs-ink-bar {
  height: 35px;
  bottom: 0;
  left: 0;
  background: #545cd8;
}

.rc-tabs-top .rc-tabs-tab {
  float: left;
  height: 100%;
  line-height: 1.3;
  margin-right: 0.75rem;
}

.rc-tabs-top .rc-tabs-tabpane-inactive {
  height: 0;
  overflow: visible;
}

/*!
 * Ladda
 * http://lab.hakim.se/ladda
 * MIT licensed
 *
 * Copyright (C) 2018 Hakim El Hattab, http://hakim.se
 */
/*************************************
 * CONFIG
 */
/*************************************
 * MIXINS
 */
/*************************************
 * Opacity animation for spin.js
 */
@keyframes ladda-spinner-line-fade {
  0%, 100% {
    opacity: 0.22; /* minimum opacity */
  }
  1% {
    opacity: 1;
  }
}
/*************************************
 * BUTTON BASE
 */
.ladda-button {
  position: relative;
}

/* Spinner animation */
.ladda-button .ladda-spinner {
  position: absolute;
  z-index: 2;
  display: inline-block;
  width: 32px;
  top: 50%;
  margin-top: 0;
  opacity: 0;
  pointer-events: none;
}

/* Button label */
.ladda-button .ladda-label {
  position: relative;
  z-index: 3;
}

[class*=btn-outline-] .ladda-spinner div div div {
  background: #000 !important;
}
[class*=btn-outline-].ladda-button .ladda-label {
  transition: none !important;
}

/* Progress bar */
.ladda-button .ladda-progress {
  position: absolute;
  width: 0;
  height: 100%;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.2);
  display: none;
  transition: 0.1s linear all !important;
}

.ladda-button[data-loading] .ladda-progress {
  display: block;
}

/*************************************
 * EASING
 */
.ladda-button,
.ladda-button .ladda-spinner,
.ladda-button .ladda-label {
  transition: 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) all !important;
}

.ladda-button[data-style=zoom-in],
.ladda-button[data-style=zoom-in] .ladda-spinner,
.ladda-button[data-style=zoom-in] .ladda-label,
.ladda-button[data-style=zoom-out],
.ladda-button[data-style=zoom-out] .ladda-spinner,
.ladda-button[data-style=zoom-out] .ladda-label {
  transition: 0.3s ease all !important;
}

/*************************************
 * EXPAND RIGHT
 */
.ladda-button[data-style=expand-right] .ladda-spinner {
  right: -6px;
}
.ladda-button[data-style=expand-right][data-size=s] .ladda-spinner, .ladda-button[data-style=expand-right][data-size=xs] .ladda-spinner {
  right: -12px;
}
.ladda-button[data-style=expand-right][data-loading] {
  padding-right: 56px;
}
.ladda-button[data-style=expand-right][data-loading] .ladda-spinner {
  opacity: 1;
}
.ladda-button[data-style=expand-right][data-loading][data-size=s], .ladda-button[data-style=expand-right][data-loading][data-size=xs] {
  padding-right: 40px;
}

/*************************************
 * EXPAND LEFT
 */
.ladda-button[data-style=expand-left] .ladda-spinner {
  left: 26px;
}
.ladda-button[data-style=expand-left][data-size=s] .ladda-spinner, .ladda-button[data-style=expand-left][data-size=xs] .ladda-spinner {
  left: 4px;
}
.ladda-button[data-style=expand-left][data-loading] {
  padding-left: 56px;
}
.ladda-button[data-style=expand-left][data-loading] .ladda-spinner {
  opacity: 1;
}
.ladda-button[data-style=expand-left][data-loading][data-size=s], .ladda-button[data-style=expand-left][data-loading][data-size=xs] {
  padding-left: 40px;
}

/*************************************
 * EXPAND UP
 */
.ladda-button[data-style=expand-up] {
  overflow: hidden;
}
.ladda-button[data-style=expand-up] .ladda-spinner {
  top: -32px;
  left: 50%;
  margin-left: 0;
}
.ladda-button[data-style=expand-up][data-loading] {
  padding-top: 54px;
}
.ladda-button[data-style=expand-up][data-loading] .ladda-spinner {
  opacity: 1;
  top: 26px;
  margin-top: 0;
}
.ladda-button[data-style=expand-up][data-loading][data-size=s], .ladda-button[data-style=expand-up][data-loading][data-size=xs] {
  padding-top: 32px;
}
.ladda-button[data-style=expand-up][data-loading][data-size=s] .ladda-spinner, .ladda-button[data-style=expand-up][data-loading][data-size=xs] .ladda-spinner {
  top: 4px;
}

/*************************************
 * EXPAND DOWN
 */
.ladda-button[data-style=expand-down] {
  overflow: hidden;
}
.ladda-button[data-style=expand-down] .ladda-spinner {
  top: 52px;
  left: 50%;
  margin-left: 0;
}
.ladda-button[data-style=expand-down][data-size=s] .ladda-spinner, .ladda-button[data-style=expand-down][data-size=xs] .ladda-spinner {
  top: 40px;
}
.ladda-button[data-style=expand-down][data-loading] {
  padding-bottom: 54px;
}
.ladda-button[data-style=expand-down][data-loading] .ladda-spinner {
  opacity: 1;
}
.ladda-button[data-style=expand-down][data-loading][data-size=s], .ladda-button[data-style=expand-down][data-loading][data-size=xs] {
  padding-bottom: 32px;
}

/*************************************
 * SLIDE LEFT
 */
.ladda-button[data-style=slide-left] {
  overflow: hidden;
}
.ladda-button[data-style=slide-left] .ladda-label {
  position: relative;
}
.ladda-button[data-style=slide-left] .ladda-spinner {
  left: 100%;
  margin-left: 0;
}
.ladda-button[data-style=slide-left][data-loading] .ladda-label {
  opacity: 0;
  left: -100%;
}
.ladda-button[data-style=slide-left][data-loading] .ladda-spinner {
  opacity: 1;
  left: 50%;
}

/*************************************
 * SLIDE RIGHT
 */
.ladda-button[data-style=slide-right] {
  overflow: hidden;
}
.ladda-button[data-style=slide-right] .ladda-label {
  position: relative;
}
.ladda-button[data-style=slide-right] .ladda-spinner {
  right: 100%;
  margin-left: 0;
  left: 16px;
}
[dir=rtl] .ladda-button[data-style=slide-right] .ladda-spinner {
  right: auto;
}
.ladda-button[data-style=slide-right][data-loading] .ladda-label {
  opacity: 0;
  left: 100%;
}
.ladda-button[data-style=slide-right][data-loading] .ladda-spinner {
  opacity: 1;
  left: 50%;
}

/*************************************
 * SLIDE UP
 */
.ladda-button[data-style=slide-up] {
  overflow: hidden;
}
.ladda-button[data-style=slide-up] .ladda-label {
  position: relative;
}
.ladda-button[data-style=slide-up] .ladda-spinner {
  left: 50%;
  margin-left: 0;
  margin-top: 1em;
}
.ladda-button[data-style=slide-up][data-loading] .ladda-label {
  opacity: 0;
  top: -1em;
}
.ladda-button[data-style=slide-up][data-loading] .ladda-spinner {
  opacity: 1;
  margin-top: 0;
}

/*************************************
 * SLIDE DOWN
 */
.ladda-button[data-style=slide-down] {
  overflow: hidden;
}
.ladda-button[data-style=slide-down] .ladda-label {
  position: relative;
}
.ladda-button[data-style=slide-down] .ladda-spinner {
  left: 50%;
  margin-left: 0;
  margin-top: -2em;
}
.ladda-button[data-style=slide-down][data-loading] .ladda-label {
  opacity: 0;
  top: 1em;
}
.ladda-button[data-style=slide-down][data-loading] .ladda-spinner {
  opacity: 1;
  margin-top: 0;
}

/*************************************
 * ZOOM-OUT
 */
.ladda-button[data-style=zoom-out] {
  overflow: hidden;
}

.ladda-button[data-style=zoom-out] .ladda-spinner {
  left: 50%;
  margin-left: 32px;
  transform: scale(2.5);
}

.ladda-button[data-style=zoom-out] .ladda-label {
  position: relative;
  display: inline-block;
}

.ladda-button[data-style=zoom-out][data-loading] .ladda-label {
  opacity: 0;
  transform: scale(0.5);
}

.ladda-button[data-style=zoom-out][data-loading] .ladda-spinner {
  opacity: 1;
  margin-left: 0;
  transform: none;
}

/*************************************
 * ZOOM-IN
 */
.ladda-button[data-style=zoom-in] {
  overflow: hidden;
}

.ladda-button[data-style=zoom-in] .ladda-spinner {
  left: 50%;
  margin-left: -16px;
  transform: scale(0.2);
}

.ladda-button[data-style=zoom-in] .ladda-label {
  position: relative;
  display: inline-block;
}

.ladda-button[data-style=zoom-in][data-loading] .ladda-label {
  opacity: 0;
  transform: scale(2.2);
}

.ladda-button[data-style=zoom-in][data-loading] .ladda-spinner {
  opacity: 1;
  margin-left: 0;
  transform: none;
}

/*************************************
 * CONTRACT
 */
.ladda-button[data-style=contract] {
  overflow: hidden;
  width: 100px;
}

.ladda-button[data-style=contract] .ladda-spinner {
  left: 50%;
  margin-left: 0;
}

.ladda-button[data-style=contract][data-loading] {
  border-radius: 50%;
  width: 52px;
}

.ladda-button[data-style=contract][data-loading] .ladda-label {
  opacity: 0;
}

.ladda-button[data-style=contract][data-loading] .ladda-spinner {
  opacity: 1;
}

/*************************************
 * OVERLAY
 */
.ladda-button[data-style=contract-overlay] {
  overflow: hidden;
  width: 100px;
  box-shadow: 0px 0px 0px 2000px rgba(0, 0, 0, 0);
}

.ladda-button[data-style=contract-overlay] .ladda-spinner {
  left: 50%;
  margin-left: 0;
}

.ladda-button[data-style=contract-overlay][data-loading] {
  border-radius: 50%;
  width: 52px;
  /*outline: 10000px solid rgba( 0, 0, 0, 0.5 );*/
  box-shadow: 0px 0px 0px 2000px rgba(0, 0, 0, 0.8);
}

.ladda-button[data-style=contract-overlay][data-loading] .ladda-label {
  opacity: 0;
}

.ladda-button[data-style=contract-overlay][data-loading] .ladda-spinner {
  opacity: 1;
}

[dir=rtl] .ladda-spinner > div {
  left: 25% !important;
}

/*!
 * Hamburgers
 * @description Tasty CSS-animated hamburgers
 * @author Jonathan Suh @jonsuh
 * @site https://jonsuh.com/hamburgers
 * @link https://github.com/jonsuh/hamburgers
 */
.hamburger {
  padding: 0px 0px;
  display: inline-block;
  cursor: pointer;
  transition-property: opacity, filter;
  transition-duration: 0.15s;
  transition-timing-function: linear;
  font: inherit;
  color: inherit;
  text-transform: none;
  background-color: transparent;
  border: 0;
  margin: 0;
  overflow: visible;
}
.hamburger:hover {
  opacity: 0.7;
}
.hamburger.is-active:hover {
  opacity: 0.7;
}
.hamburger.is-active .hamburger-inner,
.hamburger.is-active .hamburger-inner::before,
.hamburger.is-active .hamburger-inner::after {
  background-color: #545cd8;
}

.hamburger-box {
  width: 24px;
  height: 14px;
  display: inline-block;
  position: relative;
}

.hamburger-inner {
  display: block;
  top: 50%;
  margin-top: -1px;
}
.hamburger-inner, .hamburger-inner::before, .hamburger-inner::after {
  width: 24px;
  height: 2px;
  background-color: #545cd8;
  border-radius: 10px;
  position: absolute;
  transition-property: transform;
  transition-duration: 0.15s;
  transition-timing-function: ease;
}
.hamburger-inner::before, .hamburger-inner::after {
  content: "";
  display: block;
}
.hamburger-inner::before {
  top: -6px;
}
.hamburger-inner::after {
  bottom: -6px;
}

/*
 * Elastic
 */
.hamburger--elastic .hamburger-inner {
  top: 1px;
  transition-duration: 0.275s;
  transition-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);
}
.hamburger--elastic .hamburger-inner::before {
  top: 6px;
  transition: opacity 0.125s 0.275s ease;
}
.hamburger--elastic .hamburger-inner::after {
  top: 12px;
  transition: transform 0.275s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}
.hamburger--elastic.is-active .hamburger-inner {
  transform: translate3d(0, 6px, 0) rotate(135deg);
  transition-delay: 0.075s;
}
.hamburger--elastic.is-active .hamburger-inner::before {
  transition-delay: 0s;
  opacity: 0;
}
.hamburger--elastic.is-active .hamburger-inner::after {
  transform: translate3d(0, -12px, 0) rotate(-270deg);
  transition-delay: 0.075s;
}

.drawer-content-wrapper {
  background: #fff;
  position: relative;
  padding: 1.5rem;
}
.drawer-content-wrapper .drawer-heading {
  font-size: 0.968rem;
  color: #495057;
  margin: 0;
  background: #f8f9fa;
  padding: 0.75rem 1.5rem;
  border-bottom: #dee2e6 solid 1px;
  border-top: #dee2e6 solid 1px;
}
.drawer-content-wrapper .drawer-heading:first-child {
  border-top: 0;
}
.drawer-content-wrapper .drawer-section {
  padding: 1.5rem;
}
.drawer-content-wrapper > .app-sidebar__heading:first-child {
  margin-top: 0;
}

.drawer-nav-btn {
  border-radius: 30px;
  background: #fff;
  position: fixed;
  right: 0.75rem;
  top: 0.75rem;
  padding: 0.5rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  z-index: 20;
}
.drawer-nav-btn .hamburger {
  margin-top: 4px;
}

.sa-icon {
  width: 80px;
  height: 80px;
  border: 4px solid #dee2e6;
  border-radius: 50%;
  margin: 20px auto;
  padding: 0;
  position: relative;
  box-sizing: content-box;
}
.sa-icon.sa-error {
  border-color: #d92550;
}
.sa-icon.sa-error .sa-x-mark {
  position: relative;
  display: block;
}
.sa-icon.sa-error .sa-line {
  position: absolute;
  height: 5px;
  width: 47px;
  background-color: #d92550;
  display: block;
  top: 37px;
  border-radius: 2px;
}
.sa-icon.sa-error .sa-line.sa-left {
  transform: rotate(45deg);
  left: 17px;
}
.sa-icon.sa-error .sa-line.sa-right {
  transform: rotate(-45deg);
  right: 16px;
}
.sa-icon.sa-warning {
  border-color: #f7b924;
}
.sa-icon.sa-warning .sa-body {
  position: absolute;
  width: 5px;
  height: 47px;
  left: 50%;
  top: 10px;
  border-radius: 2px;
  margin-left: -2px;
  background-color: #f7b924;
}
.sa-icon.sa-warning .sa-dot {
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  margin-left: -3px;
  left: 50%;
  bottom: 10px;
  background-color: #f7b924;
}
.sa-icon.sa-info {
  border-color: #30b1ff;
}
.sa-icon.sa-info::before {
  content: "";
  position: absolute;
  width: 5px;
  height: 29px;
  left: 50%;
  bottom: 17px;
  border-radius: 2px;
  margin-left: -2px;
  background-color: #30b1ff;
}
.sa-icon.sa-info::after {
  content: "";
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  margin-left: -3px;
  top: 19px;
  background-color: #30b1ff;
}
.sa-icon.sa-success {
  border-color: #3ac47d;
}
.sa-icon.sa-success::before, .sa-icon.sa-success::after {
  content: "";
  border-radius: 50%;
  position: absolute;
  width: 60px;
  height: 120px;
  background: #fff;
  transform: rotate(45deg);
}
.sa-icon.sa-success::before {
  border-radius: 120px 0 0 120px;
  top: -7px;
  left: -33px;
  transform: rotate(-45deg);
  transform-origin: 60px 60px;
}
.sa-icon.sa-success::after {
  border-radius: 0 120px 120px 0;
  top: -11px;
  left: 30px;
  transform: rotate(-45deg);
  transform-origin: 0 60px;
}
.sa-icon.sa-success .sa-placeholder {
  width: 80px;
  height: 80px;
  border: 4px solid rgba(165, 220, 134, 0.2);
  border-radius: 40px;
  border-radius: 50%;
  box-sizing: content-box;
  position: absolute;
  left: -4px;
  top: -4px;
  z-index: 2;
}
.sa-icon.sa-success .sa-fix {
  width: 5px;
  height: 90px;
  background-color: #fff;
  position: absolute;
  left: 28px;
  top: 8px;
  z-index: 1;
  transform: rotate(-45deg);
}
.sa-icon.sa-success .sa-line {
  height: 5px;
  background-color: #3ac47d;
  display: block;
  border-radius: 2px;
  position: absolute;
  z-index: 2;
}
.sa-icon.sa-success .sa-line.sa-tip {
  width: 25px;
  left: 14px;
  top: 46px;
  transform: rotate(45deg);
}
.sa-icon.sa-success .sa-line.sa-long {
  width: 47px;
  right: 8px;
  top: 38px;
  transform: rotate(-45deg);
}
.sa-icon.sa-custom {
  background-size: contain;
  border-radius: 0;
  border: none;
  background-position: center center;
  background-repeat: no-repeat;
}
@keyframes animateSuccessTip {
  0% {
    width: 0;
    left: 1px;
    top: 19px;
  }
  54% {
    width: 0;
    left: 1px;
    top: 19px;
  }
  70% {
    width: 50px;
    left: -8px;
    top: 37px;
  }
  84% {
    width: 17px;
    left: 21px;
    top: 48px;
  }
  100% {
    width: 25px;
    left: 14px;
    top: 45px;
  }
}
@keyframes animateSuccessLong {
  0% {
    width: 0;
    right: 46px;
    top: 54px;
  }
  65% {
    width: 0;
    right: 46px;
    top: 54px;
  }
  84% {
    width: 55px;
    right: 0;
    top: 35px;
  }
  100% {
    width: 47px;
    right: 8px;
    top: 38px;
  }
}
.animateSuccessTip {
  animation: animateSuccessTip 0.75s;
}

.animateSuccessLong {
  animation: animateSuccessLong 0.75s;
}

.sa-icon.sa-success.animate::after {
  animation: rotatePlaceholder 4.25s ease-in;
}

/* Success icon */
.sweet-alert .sa-icon.sa-success {
  border-color: transparent \\9 ;
}

.sweet-alert .sa-icon.sa-success .sa-line.sa-tip {
  -ms-transform: rotate(45deg) \\9 ;
}

.sweet-alert .sa-icon.sa-sucsuccesscess .sa-line.sa-long {
  -ms-transform: rotate(-45deg) \\9 ;
}

.Toastify__toast-container {
  z-index: 9999;
  position: fixed;
  padding: 0;
  width: 320px;
  box-sizing: border-box;
  color: #fff;
}
.Toastify__toast-container--top-left {
  top: 1rem;
  left: 1rem;
}
.Toastify__toast-container--top-center {
  top: 1rem;
  left: 50%;
  margin-left: -160px;
}
.Toastify__toast-container--top-right {
  top: 1rem;
  right: 1rem;
}
.Toastify__toast-container--bottom-left {
  bottom: 1rem;
  left: 1rem;
}
.Toastify__toast-container--bottom-center {
  bottom: 1rem;
  left: 50%;
  margin-left: -160px;
}
.Toastify__toast-container--bottom-right {
  bottom: 1rem;
  right: 1rem;
}

@media only screen and (max-width : 480px) {
  .Toastify__toast-container {
    width: 100vw;
    padding: 0;
    left: 0;
    margin: 0;
  }
  .Toastify__toast-container--top-left, .Toastify__toast-container--top-center, .Toastify__toast-container--top-right {
    top: 0;
  }
  .Toastify__toast-container--bottom-left, .Toastify__toast-container--bottom-center, .Toastify__toast-container--bottom-right {
    bottom: 0;
  }
  .Toastify__toast-container--rtl {
    right: 0;
    left: auto;
    left: initial;
  }
}
.Toastify__toast {
  position: relative;
  min-height: 54px;
  box-sizing: border-box;
  margin-bottom: 1rem;
  padding: 1rem;
  border-radius: 0.25rem;
  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);
  display: flex;
  justify-content: space-between;
  max-height: 800px;
  overflow: hidden;
  font-family: sans-serif;
  cursor: pointer;
  direction: ltr;
}
.Toastify__toast--rtl {
  direction: rtl;
}
.Toastify__toast--default {
  background: #fff;
  color: #495057;
  box-shadow: 0 0.66875rem 2.3875rem rgba(84, 92, 216, 0.03), 0 1.1375rem 1.60625rem rgba(84, 92, 216, 0.03), 0 0.45rem 0.73125rem rgba(84, 92, 216, 0.05), 0 0.325rem 0.3875rem rgba(84, 92, 216, 0.03);
}
.Toastify__toast--info {
  background: #30b1ff;
  box-shadow: 0 0.66875rem 2.3875rem rgba(48, 177, 255, 0.03), 0 1.1375rem 1.60625rem rgba(48, 177, 255, 0.03), 0 0.45rem 0.73125rem rgba(48, 177, 255, 0.05), 0 0.325rem 0.3875rem rgba(48, 177, 255, 0.03);
}
.Toastify__toast--success {
  background: #3ac47d;
  box-shadow: 0 0.66875rem 2.3875rem rgba(58, 196, 125, 0.03), 0 1.1375rem 1.60625rem rgba(58, 196, 125, 0.03), 0 0.45rem 0.73125rem rgba(58, 196, 125, 0.05), 0 0.325rem 0.3875rem rgba(58, 196, 125, 0.03);
}
.Toastify__toast--warning {
  background: #f7b924;
  box-shadow: 0 0.66875rem 2.3875rem rgba(247, 185, 36, 0.03), 0 1.1375rem 1.60625rem rgba(247, 185, 36, 0.03), 0 0.45rem 0.73125rem rgba(247, 185, 36, 0.05), 0 0.325rem 0.3875rem rgba(247, 185, 36, 0.03);
}
.Toastify__toast--error {
  background: #d92550;
  box-shadow: 0 0.66875rem 2.3875rem rgba(217, 37, 80, 0.03), 0 1.1375rem 1.60625rem rgba(217, 37, 80, 0.03), 0 0.45rem 0.73125rem rgba(217, 37, 80, 0.05), 0 0.325rem 0.3875rem rgba(217, 37, 80, 0.03);
}
.Toastify__toast-body {
  margin: auto 0;
  padding: 0 0 0.4rem;
}

@media only screen and (max-width : 480px) {
  .Toastify__toast {
    margin-bottom: 0;
  }
}
.Toastify__close-button {
  color: #fff;
  font-size: 14px;
  background: transparent;
  outline: none;
  border: none;
  padding: 0;
  cursor: pointer;
  opacity: 0.7;
  transition: 0.3s ease;
  position: absolute;
  top: 5px;
  right: 9px;
}
.Toastify__close-button--default {
  color: #000;
  opacity: 0.3;
}
.Toastify__close-button:hover, .Toastify__close-button:focus {
  opacity: 1;
}

@keyframes Toastify__trackProgress {
  0% {
    width: 96%;
  }
  100% {
    width: 0;
  }
}
.Toastify__progress-bar {
  position: absolute;
  bottom: 9%;
  left: 2%;
  width: 0;
  height: 5px;
  z-index: 9999;
  animation: Toastify__trackProgress linear 1;
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 0.25rem;
}
.Toastify__progress-bar--rtl {
  right: 0;
  left: auto;
  left: initial;
}
.Toastify__progress-bar--default {
  background: #545cd8;
}
@keyframes Toastify__bounceInRight {
  from, 60%, 75%, 90%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  from {
    opacity: 0;
    transform: translate3d(3000px, 0, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(-25px, 0, 0);
  }
  75% {
    transform: translate3d(10px, 0, 0);
  }
  90% {
    transform: translate3d(-5px, 0, 0);
  }
  to {
    transform: none;
  }
}
@keyframes Toastify__bounceOutRight {
  20% {
    opacity: 1;
    transform: translate3d(-20px, 0, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(2000px, 0, 0);
  }
}
@keyframes Toastify__bounceInLeft {
  from, 60%, 75%, 90%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    transform: translate3d(-3000px, 0, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(25px, 0, 0);
  }
  75% {
    transform: translate3d(-10px, 0, 0);
  }
  90% {
    transform: translate3d(5px, 0, 0);
  }
  to {
    transform: none;
  }
}
@keyframes Toastify__bounceOutLeft {
  20% {
    opacity: 1;
    transform: translate3d(20px, 0, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(-2000px, 0, 0);
  }
}
@keyframes Toastify__bounceInUp {
  from, 60%, 75%, 90%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  from {
    opacity: 0;
    transform: translate3d(0, 3000px, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(0, -20px, 0);
  }
  75% {
    transform: translate3d(0, 10px, 0);
  }
  90% {
    transform: translate3d(0, -5px, 0);
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes Toastify__bounceOutUp {
  20% {
    transform: translate3d(0, -10px, 0);
  }
  40%, 45% {
    opacity: 1;
    transform: translate3d(0, 20px, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(0, -2000px, 0);
  }
}
@keyframes Toastify__bounceInDown {
  from, 60%, 75%, 90%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    transform: translate3d(0, -3000px, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(0, 25px, 0);
  }
  75% {
    transform: translate3d(0, -10px, 0);
  }
  90% {
    transform: translate3d(0, 5px, 0);
  }
  to {
    transform: none;
  }
}
@keyframes Toastify__bounceOutDown {
  20% {
    transform: translate3d(0, 10px, 0);
  }
  40%, 45% {
    opacity: 1;
    transform: translate3d(0, -20px, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(0, 2000px, 0);
  }
}
.Toastify__bounce-enter--top-left, .Toastify__bounce-enter--bottom-left {
  animation-name: Toastify__bounceInLeft;
}
.Toastify__bounce-enter--top-right, .Toastify__bounce-enter--bottom-right {
  animation-name: Toastify__bounceInRight;
}
.Toastify__bounce-enter--top-center {
  animation-name: Toastify__bounceInDown;
}
.Toastify__bounce-enter--bottom-center {
  animation-name: Toastify__bounceInUp;
}

.Toastify__bounce-exit--top-left, .Toastify__bounce-exit--bottom-left {
  animation-name: Toastify__bounceOutLeft;
}
.Toastify__bounce-exit--top-right, .Toastify__bounce-exit--bottom-right {
  animation-name: Toastify__bounceOutRight;
}
.Toastify__bounce-exit--top-center {
  animation-name: Toastify__bounceOutUp;
}
.Toastify__bounce-exit--bottom-center {
  animation-name: Toastify__bounceOutDown;
}

@keyframes Toastify__zoomIn {
  from {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
  50% {
    opacity: 1;
  }
}
@keyframes Toastify__zoomOut {
  from {
    opacity: 1;
  }
  50% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
  to {
    opacity: 0;
  }
}
.Toastify__zoom-enter {
  animation-name: Toastify__zoomIn;
}

.Toastify__zoom-exit {
  animation-name: Toastify__zoomOut;
}

@keyframes Toastify__flipIn {
  from {
    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    animation-timing-function: ease-in;
    opacity: 0;
  }
  40% {
    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    animation-timing-function: ease-in;
  }
  60% {
    transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
    opacity: 1;
  }
  80% {
    transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
  }
  to {
    transform: perspective(400px);
  }
}
@keyframes Toastify__flipOut {
  from {
    transform: perspective(400px);
  }
  30% {
    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    opacity: 1;
  }
  to {
    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    opacity: 0;
  }
}
.Toastify__flip-enter {
  animation-name: Toastify__flipIn;
}

.Toastify__flip-exit {
  animation-name: Toastify__flipOut;
}

@keyframes Toastify__slideInRight {
  from {
    transform: translate3d(110%, 0, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes Toastify__slideInLeft {
  from {
    transform: translate3d(-110%, 0, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes Toastify__slideInUp {
  from {
    transform: translate3d(0, 110%, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes Toastify__slideInDown {
  from {
    transform: translate3d(0, -110%, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes Toastify__slideOutRight {
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(110%, 0, 0);
  }
}
@keyframes Toastify__slideOutLeft {
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(-110%, 0, 0);
  }
}
@keyframes Toastify__slideOutDown {
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(0, 500px, 0);
  }
}
@keyframes Toastify__slideOutUp {
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(0, -500px, 0);
  }
}
.Toastify__slide-enter--top-left, .Toastify__slide-enter--bottom-left {
  animation-name: Toastify__slideInLeft;
}
.Toastify__slide-enter--top-right, .Toastify__slide-enter--bottom-right {
  animation-name: Toastify__slideInRight;
}
.Toastify__slide-enter--top-center {
  animation-name: Toastify__slideInDown;
}
.Toastify__slide-enter--bottom-center {
  animation-name: Toastify__slideInUp;
}

.Toastify__slide-exit--top-left, .Toastify__slide-exit--bottom-left {
  animation-name: Toastify__slideOutLeft;
}
.Toastify__slide-exit--top-right, .Toastify__slide-exit--bottom-right {
  animation-name: Toastify__slideOutRight;
}
.Toastify__slide-exit--top-center {
  animation-name: Toastify__slideOutUp;
}
.Toastify__slide-exit--bottom-center {
  animation-name: Toastify__slideOutDown;
}

/* -- container -- */
.rodal,
.rodal-mask {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
}

.rodal {
  position: fixed;
}

/* -- mask -- */
.rodal-mask {
  position: absolute;
  background-color: #000;
  opacity: 0.5;
}

/* -- dialog -- */
.rodal-dialog {
  position: absolute;
  top: 10%;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 101;
  background: #fff;
  box-shadow: 0 0.76875rem 2.4875rem rgba(52, 58, 64, 0.3), 0 1.3375rem 1.70625rem rgba(52, 58, 64, 0.3), 0 0.55rem 0.53125rem rgba(0, 0, 0, 0.05), 0 0.225rem 0.4375rem rgba(52, 58, 64, 0.3);
  border-radius: 0.25rem;
  height: auto !important;
}

.rodal-dialog:focus {
  outline: none;
}

/* -- close button -- */
.rodal-close {
  position: absolute;
  cursor: pointer;
  top: 16px;
  right: 16px;
  width: 16px;
  height: 16px;
}

.rodal-close:before,
.rodal-close:after {
  position: absolute;
  content: "";
  height: 2px;
  width: 100%;
  top: 50%;
  left: 0;
  margin-top: -1px;
  background: #adb5bd;
  border-radius: 100%;
  transition: background 0.2s;
}

.rodal-close:before {
  transform: rotate(45deg);
}

.rodal-close:after {
  transform: rotate(-45deg);
}

.rodal-close:hover:before,
.rodal-close:hover:after {
  background: #343a40;
}

/* -- fade -- */
@keyframes rodal-fade-enter {
  from {
    opacity: 0;
  }
}
.rodal-fade-enter {
  animation: rodal-fade-enter both ease-in;
}

@keyframes rodal-fade-leave {
  to {
    opacity: 0;
  }
}
.rodal-fade-leave {
  animation: rodal-fade-leave both ease-out;
}

@keyframes rodal-zoom-enter {
  from {
    transform: scale3d(0.3, 0.3, 0.3);
  }
}
.rodal-zoom-enter {
  animation: rodal-zoom-enter both cubic-bezier(0.4, 0, 0, 1.5);
}

@keyframes rodal-zoom-leave {
  to {
    transform: scale3d(0.3, 0.3, 0.3);
  }
}
.rodal-zoom-leave {
  animation: rodal-zoom-leave both;
}

@keyframes rodal-slideDown-enter {
  from {
    transform: translate3d(0, -100px, 0);
  }
}
.rodal-slideDown-enter {
  animation: rodal-slideDown-enter both cubic-bezier(0.4, 0, 0, 1.5);
}

@keyframes rodal-slideDown-leave {
  to {
    transform: translate3d(0, -100px, 0);
  }
}
.rodal-slideDown-leave {
  animation: rodal-slideDown-leave both;
}

/* -- slideLeft -- */
@keyframes rodal-slideLeft-enter {
  from {
    transform: translate3d(-150px, 0, 0);
  }
}
.rodal-slideLeft-enter {
  animation: rodal-slideLeft-enter both cubic-bezier(0.4, 0, 0, 1.5);
}

@keyframes rodal-slideLeft-leave {
  to {
    transform: translate3d(-150px, 0, 0);
  }
}
.rodal-slideLeft-leave {
  animation: rodal-slideLeft-leave both;
}

/* -- slideRight -- */
@keyframes rodal-slideRight-enter {
  from {
    transform: translate3d(150px, 0, 0);
  }
}
.rodal-slideRight-enter {
  animation: rodal-slideRight-enter both cubic-bezier(0.4, 0, 0, 1.5);
}

@keyframes rodal-slideRight-leave {
  to {
    transform: translate3d(150px, 0, 0);
  }
}
.rodal-slideRight-leave {
  animation: rodal-slideRight-leave both;
}

/* -- slideUp -- */
@keyframes rodal-slideUp-enter {
  from {
    transform: translate3d(0, 100px, 0);
  }
}
.rodal-slideUp-enter {
  animation: rodal-slideUp-enter both cubic-bezier(0.4, 0, 0, 1.5);
}

@keyframes rodal-slideUp-leave {
  to {
    transform: translate3d(0, 100px, 0);
  }
}
.rodal-slideUp-leave {
  animation: rodal-slideUp-leave both;
}

/* -- flip -- */
@keyframes rodal-flip-enter {
  from {
    transform: perspective(400px) rotate3d(1, 0, 0, 60deg);
  }
  70% {
    transform: perspective(400px) rotate3d(1, 0, 0, -15deg);
  }
  to {
    transform: perspective(400px);
  }
}
.rodal-flip-enter {
  animation: rodal-flip-enter both ease-in;
  -webkit-backface-visibility: visible !important;
          backface-visibility: visible !important;
}

@keyframes rodal-flip-leave {
  from {
    transform: perspective(400px);
  }
  30% {
    transform: perspective(400px) rotate3d(1, 0, 0, -15deg);
  }
  to {
    transform: perspective(400px) rotate3d(1, 0, 0, 45deg);
  }
}
.rodal-flip-leave {
  animation: rodal-flip-leave both;
  -webkit-backface-visibility: visible !important;
          backface-visibility: visible !important;
}

/* -- rotate -- */
@keyframes rodal-rotate-enter {
  from {
    transform: rotate3d(0, 0, 1, -180deg) scale3d(0.3, 0.3, 0.3);
  }
}
.rodal-rotate-enter {
  animation: rodal-rotate-enter both;
  transform-origin: center;
}

@keyframes rodal-rotate-leave {
  to {
    transform: rotate3d(0, 0, 1, 180deg) scale3d(0.3, 0.3, 0.3);
  }
}
.rodal-rotate-leave {
  animation: rodal-rotate-leave both;
  transform-origin: center;
}

/* -- door -- */
@keyframes rodal-door-enter {
  from {
    transform: scale3d(0, 1, 1);
  }
}
.rodal-door-enter {
  animation: rodal-door-enter both cubic-bezier(0.4, 0, 0, 1.5);
}

@keyframes rodal-door-leave {
  60% {
    transform: scale3d(0.01, 1, 1);
  }
  to {
    transform: scale3d(0, 1, 0.1);
  }
}
.rodal-door-leave {
  animation: rodal-door-leave both;
}

.react-sweet-progress {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.react-sweet-progress-symbol {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 35px;
  height: 20px;
  padding-left: 10px;
  color: rgba(0, 0, 0, 0.7);
  font-weight: 200;
}

.react-sweet-progress-symbol-absolute {
  display: flex;
  position: absolute;
  top: 50%;
  left: 50%;
  align-items: center;
  justify-content: center;
  transform: translate3d(-50%, -50%, 0);
}

.react-sweet-progress-symbol-absolute .react-sweet-progress-symbol {
  padding: 0;
  width: 100%;
}

.react-sweet-progress-circle-outer {
  position: relative;
  display: inline-block;
  vertical-align: middle;
}

.react-sweet-progress-line {
  width: 100%;
  border-radius: 100px;
  background-color: #efefef;
  vertical-align: middle;
}

.react-sweet-progress-line-inner {
  position: relative;
  min-height: 10px;
  border-radius: 100px;
  transition: width 0.3s ease;
}

.react-sweet-progress-line-inner-status-active:before {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border-radius: 10px;
  background: #fff;
  animation: active-anim 2s cubic-bezier(0.25, 1, 0.6, 1) infinite;
  content: "";
  opacity: 0;
}

@keyframes active-anim {
  0% {
    width: 0;
    opacity: 0.1;
  }
  20% {
    width: 0;
    opacity: 0.5;
  }
  to {
    width: 100%;
    opacity: 0;
  }
}
.react-sweet-progress-circle path {
  stroke-linecap: round;
}

/* Slider */
.slick-slider {
  position: relative;
  display: block;
  box-sizing: border-box;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
  touch-action: pan-y;
  -webkit-tap-highlight-color: transparent;
  max-width: 1400px;
  margin-left: auto;
  margin-right: auto;
}

.slick-slider-sm .slick-slider {
  max-width: 450px;
}
.slick-slider-sm .slick-slider .slick-prev {
  left: -20px;
}
.slick-slider-sm .slick-slider .slick-next {
  right: -20px;
}

.slick-slider-md .slick-slider {
  max-width: 650px;
  margin: 0 auto;
}

.slick-slider-hover .slick-arrow {
  opacity: 0;
  background: #545cd8;
  color: #fff !important;
}
.slick-slider-hover .slick-prev {
  left: -30px;
}
.slick-slider-hover .slick-next {
  right: -30px;
}
.slick-slider-hover:hover .slick-arrow {
  opacity: 1;
}

.slick-list {
  position: relative;
  overflow: hidden;
  display: block;
  margin: 0;
  padding: 0;
}
.slick-list:focus {
  outline: none;
}
.slick-list.dragging {
  cursor: pointer;
  cursor: hand;
}

.slick-slider .slick-track,
.slick-slider .slick-list {
  transform: translate3d(0, 0, 0);
}

.slick-track {
  position: relative;
  left: 0;
  top: 0;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.slick-track:before, .slick-track:after {
  content: "";
  display: table;
}
.slick-track:after {
  clear: both;
}
.slick-loading .slick-track {
  visibility: hidden;
}

.slick-slide {
  float: left;
  height: 100%;
  min-height: 1px;
  display: none;
}
[dir=rtl] .slick-slide {
  float: right;
}
.slick-slide img {
  display: block;
}
.slick-slide.slick-loading img {
  display: none;
}
.slick-slide.dragging img {
  pointer-events: none;
}
.slick-initialized .slick-slide {
  display: block;
}
.slick-loading .slick-slide {
  visibility: hidden;
}
.slick-vertical .slick-slide {
  display: block;
  height: auto;
  border: 1px solid transparent;
}

.slick-arrow.slick-hidden {
  display: none;
}

/* Arrows */
.slick-prev,
.slick-next {
  position: absolute;
  display: block;
  height: 40px;
  width: 40px;
  cursor: pointer;
  color: #6c757d;
  top: 50%;
  transform: translate(0, -80%);
  padding: 0;
  border: none;
  outline: none;
  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);
  transition: all 0.2s;
  font-family: "Pe-icon-7-stroke";
  border-radius: 50px;
  background: #fff;
  z-index: 6;
  overflow: hidden;
}
.slick-prev::before,
.slick-next::before {
  font-size: 35px;
  height: 40px;
  line-height: 40px;
  width: 40px;
}
.slick-prev:hover, .slick-prev:focus,
.slick-next:hover,
.slick-next:focus {
  outline: none;
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  color: #545cd8;
}
.slick-prev.slick-disabled:before,
.slick-next.slick-disabled:before {
  opacity: 0.25;
}

.slick-prev {
  left: 0;
}
.slick-prev:before {
  content: "\\e686";
}

.slick-next {
  right: 0;
}
.slick-next:before {
  content: "\\e684";
}

/* Dots */
.slick-dots {
  list-style: none;
  display: block;
  text-align: center;
  padding: 0;
  margin: 0.75rem 0 0;
  width: 100%;
}
.slick-dots li {
  position: relative;
  display: inline-block;
  padding: 0;
  margin: 0 5px;
  cursor: pointer;
  transform: scale(0.8);
  transition: all 0.2s;
}
.slick-dots li button {
  border: 0;
  background: transparent;
  display: block;
  height: 14px;
  width: 14px;
  background: #545cd8;
  cursor: pointer;
  position: relative;
  border-radius: 20px;
  color: transparent;
}
.slick-dots li button::before {
  content: "";
  position: absolute;
  background: #fff;
  left: 50%;
  top: 50%;
  margin: -4px 0 0 -4px;
  display: block;
  width: 8px;
  height: 8px;
  border-radius: 20px;
}
.slick-dots li.slick-active {
  transform: scale(1.2);
}

.slick-center {
  transform: scale(1.1);
}

.slick-slider .slide-img-bg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  opacity: 0.4;
  z-index: 10;
}
.slick-slider .slider-content {
  position: relative;
  z-index: 15;
  text-align: center;
  margin: 0 6rem;
}
.slick-slider .slider-content h3, .slick-slider .slider-content .h3 {
  font-size: 1.54rem;
  font-weight: normal;
  margin-bottom: 1.5rem;
}
.slick-slider .slider-content p {
  font-size: 0.88rem;
  opacity: 0.7;
}

.slider-light .slick-dots {
  position: absolute;
  bottom: 10px;
}
.slider-light .slick-dots li button {
  background: rgba(255, 255, 255, 0.25);
}
.slider-light .slick-prev,
.slider-light .slick-next {
  background: transparent;
  color: #fff;
  box-shadow: 0 0 0 0 transparent;
}
.slider-light .slick-prev:hover,
.slider-light .slick-next:hover {
  background: rgba(255, 255, 255, 0.15);
}
.slider-light .slick-next {
  right: 15px;
}
.slider-light .slick-prev {
  left: 15px;
}
.slider-light .slider-content {
  color: #fff;
}

.loading-indicator {
  text-align: center;
}

.loading-bullet {
  display: inline-block;
  opacity: 0;
  font-size: 2em;
  color: #02a17c;
}

.block-ui {
  position: relative;
  min-height: 3em;
}

.block-ui-container {
  position: absolute;
  z-index: 1010;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: 100%;
  min-height: 2em;
  cursor: wait;
  overflow: hidden;
}

.block-ui-container:focus {
  outline: none;
}

.block-ui-overlay {
  width: 100%;
  height: 100%;
  opacity: 0.5;
  filter: alpha(opacity=50);
  background-color: white;
}

.block-ui-message-container {
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  right: 0;
  text-align: center;
  transform: translateY(-50%);
  z-index: 10001;
}

.block-ui-message {
  color: #333;
  background: none;
  z-index: 1011;
  display: flex;
  align-items: center;
  justify-content: center;
}

.block-overlay-dark .block-ui-overlay {
  background: rgb(0, 0, 0);
}

.popover {
  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);
}
.popover .grid-menu {
  margin-bottom: -1rem;
  padding: 1px;
}
.popover .grid-menu [class*=col-] {
  padding: 1rem;
}
.popover .grid-menu + .nav .nav-item-btn {
  margin-bottom: 1rem;
}
.popover .grid-menu-xl {
  margin-bottom: -0.7407407407rem;
}
.popover .grid-menu-xl [class*=col-] {
  padding: 0;
}
.popover .popover-inner .dropdown-menu-header {
  border-top-left-radius: 0.3rem;
  border-top-right-radius: 0.3rem;
  overflow: hidden;
  margin-top: -1px;
  margin-left: -1px;
  margin-right: -1px;
}

.rm-max-width > .popover {
  max-width: none;
  max-width: initial;
}

.rm-pointers > .popover .arrow {
  display: none !important;
}

.popover-primary {
  background-color: #545cd8 !important;
}

.popover-secondary {
  background-color: #6c757d !important;
}

.popover-success {
  background-color: #3ac47d !important;
}

.popover-info {
  background-color: #30b1ff !important;
}

.popover-warning {
  background-color: #f7b924 !important;
}

.popover-danger {
  background-color: #d92550 !important;
}

.popover-light {
  background-color: #eeeeee !important;
}

.popover-dark {
  background-color: #343a40 !important;
}

.popover-focus {
  background-color: #444054 !important;
}

.popover-alternate {
  background-color: #83588a !important;
}

.popover-custom .popover-body {
  padding-top: 0;
  padding-left: 0;
  padding-right: 0;
}
.popover-custom .popover-body .dropdown-menu-header {
  margin-top: 0;
  border-top-left-radius: 0.3rem;
  border-top-right-radius: 0.3rem;
  overflow: hidden;
}
.popover-custom .popover-body .dropdown-menu-header .menu-header-content {
  padding: 0 1.5rem;
}
.popover-custom .popover-body .dropdown-menu-header .dropdown-menu-header-inner.bg-light {
  color: rgba(0, 0, 0, 0.8);
}
.popover-custom.popover-custom-lg {
  min-width: 22rem;
}
.popover-custom.popover-custom-xl {
  min-width: 25rem;
}
.popover-custom.popover-custom-sm {
  min-width: 15rem;
}

.popover-bg {
  border: 0;
}
.popover-bg .arrow {
  display: none;
}
.popover-bg .popover-header {
  background: rgba(255, 255, 255, 0.1);
  border-bottom: 0;
  color: rgb(255, 255, 255);
}
.popover-bg .popover-header::before {
  display: none;
}
.popover-bg .popover-body {
  color: rgba(255, 255, 255, 0.7);
}
.popover-bg.text-dark .popover-header {
  color: rgba(0, 0, 0, 0.8);
}
.popover-bg.text-dark .popover-body {
  color: rgba(0, 0, 0, 0.7);
}

.tooltip-light > .tooltip .tooltip-inner {
  background: #fff;
  color: #343a40;
  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);
  border: rgba(32.0357142857, 38.6071428571, 140.4642857143, 0.125) solid 1px;
}
.tooltip-light > .tooltip .arrow {
  display: none;
}

.scrollable-block {
  margin-bottom: 50px;
  overflow: hidden;
  position: relative;
}
.scrollable-block .sticky {
  z-index: 2;
}

.rbc-btn {
  color: inherit;
  font: inherit;
  margin: 0;
}

button.rbc-btn {
  overflow: visible;
  text-transform: none;
  -webkit-appearance: button;
  cursor: pointer;
}

button[disabled].rbc-btn {
  cursor: not-allowed;
}

button.rbc-input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

.rbc-calendar {
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex: 1 1;
  min-height: 580px;
}

.rbc-calendar *,
.rbc-calendar *:before,
.rbc-calendar *:after {
  box-sizing: inherit;
}

.rbc-abs-full, .rbc-row-bg {
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.rbc-ellipsis, .rbc-show-more, .rbc-row-segment .rbc-event-content, .rbc-event-label {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rbc-rtl {
  direction: rtl;
}

.rbc-off-range {
  color: rgb(178.5, 178.5, 178.5);
}

.rbc-header {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 3px;
  text-align: center;
  vertical-align: middle;
  font-weight: bold;
  font-size: 90%;
  min-height: 0;
  flex: 1 0;
  flex-basis: auto !important;
}
.rbc-header > a, .rbc-header > a:active, .rbc-header > a:visited {
  color: inherit;
  text-decoration: none;
}

.rbc-row-content {
  position: relative;
  -webkit-user-select: none;
          user-select: none;
  z-index: 4;
}

.rbc-today {
  background-color: #e0f3ff;
}

.rbc-toolbar {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-size: 16px;
}
.rbc-toolbar .rbc-toolbar-label {
  width: 100%;
  padding: 0 10px;
  text-align: center;
}
.rbc-toolbar button {
  color: #fff;
  display: inline-block;
  margin: 0;
  text-align: center;
  vertical-align: middle;
  background: #545cd8;
  border: 1px solid #545cd8;
  padding: 0.375rem 1rem;
  border-radius: 0.25rem;
  line-height: normal;
  white-space: nowrap;
  font-weight: bold;
  text-transform: capitalize;
  font-size: 0.88rem;
}
.rbc-toolbar button:active, .rbc-toolbar button.rbc-active {
  background-image: none;
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  background-color: rgb(46.2428571429, 55.7285714286, 202.7571428571);
  border-color: rgb(44.3485714286, 53.4457142857, 194.4514285714);
}
.rbc-toolbar button:active:hover, .rbc-toolbar button:active:focus, .rbc-toolbar button.rbc-active:hover, .rbc-toolbar button.rbc-active:focus {
  color: #fff;
  background-color: rgb(39.6128571429, 47.7385714286, 173.6871428571);
  border-color: rgb(32.0357142857, 38.6071428571, 140.4642857143);
}
.rbc-toolbar button:focus {
  color: #fff;
  background-color: rgb(46.2428571429, 55.7285714286, 202.7571428571);
  border-color: rgb(44.3485714286, 53.4457142857, 194.4514285714);
}
.rbc-toolbar button:hover {
  color: #fff;
  background-color: rgb(46.2428571429, 55.7285714286, 202.7571428571);
  border-color: rgb(44.3485714286, 53.4457142857, 194.4514285714);
}

.rbc-btn-group {
  display: inline-block;
  white-space: nowrap;
}
.rbc-btn-group > button:first-child:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.rbc-btn-group > button:last-child:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.rbc-rtl .rbc-btn-group > button:first-child:not(:last-child) {
  border-radius: 4px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.rbc-rtl .rbc-btn-group > button:last-child:not(:first-child) {
  border-radius: 4px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.rbc-btn-group > button:not(:first-child):not(:last-child) {
  border-radius: 0;
}
.rbc-btn-group button + button {
  margin-left: -1px;
}
.rbc-rtl .rbc-btn-group button + button {
  margin-left: 0;
  margin-right: -1px;
}
.rbc-btn-group + .rbc-btn-group, .rbc-btn-group + button {
  margin-left: 10px;
}

.rbc-event {
  cursor: pointer;
  padding: 0.125rem;
  background-color: #545cd8;
  border-radius: 0.25rem;
  color: #fff;
}
.rbc-event.rbc-selected {
  background-color: rgb(46.2428571429, 55.7285714286, 202.7571428571);
}

.rbc-event-label {
  font-size: 80%;
}

.rbc-event-overlaps {
  box-shadow: -1px 1px 5px 0px rgba(51, 51, 51, 0.5);
}

.rbc-event-continues-prior {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.rbc-event-continues-after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.rbc-event-continues-earlier {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.rbc-event-continues-later {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.rbc-row {
  display: flex;
  flex-direction: row;
}

.rbc-row-segment {
  padding: 0 1px 1px 1px;
}
.rbc-selected-cell {
  background-color: rgba(0, 0, 0, 0.1);
}

.rbc-show-more {
  background-color: rgba(255, 255, 255, 0.3);
  z-index: 4;
  font-weight: bold;
  font-size: 85%;
  height: auto;
  line-height: normal;
  white-space: nowrap;
}

.rbc-month-view {
  position: relative;
  border: 1px solid #e9ecef;
  display: flex;
  flex-direction: column;
  flex: 1 0;
  width: 100%;
  -webkit-user-select: none;
          user-select: none;
  height: 100%;
}
.rbc-month-view .rbc-header {
  border-bottom: 1px solid #e9ecef;
}
.rbc-month-view .rbc-header + .rbc-header {
  border-left: 1px solid #e9ecef;
}
.rbc-rtl .rbc-month-view .rbc-header + .rbc-header {
  border-left-width: 0;
  border-right: 1px solid #e9ecef;
}

.rbc-month-header {
  display: flex;
  flex-direction: row;
}

.rbc-month-row {
  display: flex;
  position: relative;
  flex-direction: column;
  flex: 1 0;
  overflow: hidden;
  height: 100%;
}
.rbc-month-row + .rbc-month-row {
  border-top: 1px solid #e9ecef;
}

.rbc-date-cell {
  padding-right: 5px;
  text-align: right;
  flex: 1 1;
}
.rbc-date-cell.rbc-now {
  font-weight: bold;
}
.rbc-date-cell > a, .rbc-date-cell > a:active, .rbc-date-cell > a:visited {
  color: inherit;
  text-decoration: none;
}

.rbc-row-bg {
  display: flex;
  flex-direction: row;
  flex: 1 0;
  overflow: hidden;
}

.rbc-day-bg {
  flex: 1 0;
}
.rbc-day-bg + .rbc-day-bg {
  border-left: 1px solid #e9ecef;
}
.rbc-rtl .rbc-day-bg + .rbc-day-bg {
  border-left-width: 0;
  border-right: 1px solid #e9ecef;
}

.rbc-off-range-bg {
  background: #f8f9fa;
}

.rbc-overlay {
  position: absolute;
  z-index: 5;
  border: 1px solid #e5e5e5;
  background-color: #fff;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);
  padding: 10px;
}
.rbc-overlay > * + * {
  margin-top: 1px;
}

.rbc-overlay-header {
  border-bottom: 1px solid #e5e5e5;
  margin: -10px -10px 5px -10px;
  padding: 2px 10px;
}

.rbc-agenda-view {
  display: flex;
  flex-direction: column;
  flex: 1 0;
  overflow: auto;
}
.rbc-agenda-view table {
  width: 100%;
  border: 1px solid #e9ecef;
}
.rbc-agenda-view table tbody > tr > td {
  padding: 5px 10px;
  vertical-align: top;
}
.rbc-agenda-view table .rbc-agenda-time-cell {
  padding-left: 15px;
  padding-right: 15px;
  text-transform: lowercase;
}
.rbc-agenda-view table tbody > tr > td + td {
  border-left: 1px solid #e9ecef;
}
.rbc-rtl .rbc-agenda-view table tbody > tr > td + td {
  border-left-width: 0;
  border-right: 1px solid #e9ecef;
}
.rbc-agenda-view table tbody > tr + tr {
  border-top: 1px solid #e9ecef;
}
.rbc-agenda-view table thead > tr > th {
  padding: 3px 5px;
  text-align: left;
  border-bottom: 1px solid #e9ecef;
}
.rbc-rtl .rbc-agenda-view table thead > tr > th {
  text-align: right;
}

.rbc-agenda-time-cell {
  text-transform: lowercase;
}
.rbc-agenda-time-cell .rbc-continues-after:after {
  content: " »";
}
.rbc-agenda-time-cell .rbc-continues-prior:before {
  content: "« ";
}

.rbc-agenda-date-cell,
.rbc-agenda-time-cell {
  white-space: nowrap;
}

.rbc-agenda-event-cell {
  width: 100%;
}

.rbc-time-column {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}
.rbc-time-column .rbc-timeslot-group {
  flex: 1 1;
}

.rbc-timeslot-group {
  border-bottom: 1px solid #e9ecef;
  min-height: 40px;
  display: flex;
  flex-flow: column nowrap;
}

.rbc-time-gutter,
.rbc-header-gutter {
  flex: none;
}

.rbc-label {
  padding: 0 5px;
}

.rbc-day-slot {
  position: relative;
}
.rbc-day-slot .rbc-event {
  border: 1px solid rgb(46.2428571429, 55.7285714286, 202.7571428571);
  display: flex;
  max-height: 100%;
  flex-flow: column wrap;
  align-items: flex-start;
  overflow: hidden;
}
.rbc-day-slot .rbc-event-label {
  flex: none;
  padding-right: 5px;
  width: auto;
}
.rbc-day-slot .rbc-event-content {
  width: 100%;
  flex: 1 1;
  word-wrap: break-word;
  line-height: 1;
  height: 100%;
  min-height: 1em;
}
.rbc-day-slot .rbc-time-slot {
  border-top: 1px solid white;
}

.rbc-time-slot {
  flex: 1 0;
}
.rbc-time-slot.rbc-now {
  font-weight: bold;
}

.rbc-day-header {
  text-align: center;
}

.rbc-day-slot .rbc-event {
  position: absolute;
  z-index: 2;
}

.rbc-slot-selection {
  z-index: 10;
  position: absolute;
  cursor: default;
  background-color: rgba(0, 0, 0, 0.5);
  color: #white;
  font-size: 75%;
  padding: 3px;
}

.rbc-time-view {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  width: 100%;
  border: 1px solid #e9ecef;
  min-height: 0;
}
.rbc-time-view .rbc-time-gutter {
  white-space: nowrap;
}
.rbc-time-view .rbc-allday-cell {
  width: 100%;
  position: relative;
}
.rbc-time-view .rbc-allday-events {
  position: relative;
  z-index: 4;
}
.rbc-time-view .rbc-row {
  min-height: 20px;
}

.rbc-time-header {
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
}
.rbc-time-header.rbc-overflowing {
  border-right: 1px solid #e9ecef;
}
.rbc-rtl .rbc-time-header.rbc-overflowing {
  border-right-width: 0;
  border-left: 1px solid #e9ecef;
}
.rbc-time-header > .rbc-row > * + * {
  border-left: 1px solid #e9ecef;
}
.rbc-rtl .rbc-time-header > .rbc-row > * + * {
  border-left-width: 0;
  border-right: 1px solid #e9ecef;
}
.rbc-time-header > .rbc-row:first-child {
  border-bottom: 1px solid #e9ecef;
}
.rbc-time-header .rbc-gutter-cell {
  flex: none;
}
.rbc-time-header > .rbc-gutter-cell + * {
  width: 100%;
}

.rbc-time-content {
  display: flex;
  flex: 1 0;
  align-items: flex-start;
  width: 100%;
  border-top: 2px solid #e9ecef;
  overflow-y: auto;
  position: relative;
}
.rbc-time-content > .rbc-time-gutter {
  flex: none;
}
.rbc-time-content > * + * > * {
  border-left: 1px solid #e9ecef;
}
.rbc-rtl .rbc-time-content > * + * > * {
  border-left-width: 0;
  border-right: 1px solid #e9ecef;
}
.rbc-time-content > .rbc-day-slot {
  width: 100%;
  -webkit-user-select: none;
          user-select: none;
}

.rbc-current-time-indicator {
  position: absolute;
  z-index: 1;
  left: 0;
  height: 1px;
  background-color: #3ac47d;
  pointer-events: none;
}
.rbc-current-time-indicator::before {
  display: block;
  position: absolute;
  left: -3px;
  top: -3px;
  content: " ";
  background-color: #3ac47d;
  border-radius: 50%;
  width: 8px;
  height: 8px;
}
.rbc-rtl .rbc-current-time-indicator::before {
  left: 0;
  right: -3px;
}

.handle-bar {
  background: transparent !important;
  border-radius: 30px;
}
.handle-bar:active, .handle-bar:hover, .handle-bar.handle-bar_clone {
  background-color: #e9ecef !important;
}
.handle-bar.resize-not-allowed:hover {
  background-color: #e9ecef;
}
.handle-bar .handle-bar_drag {
  border-color: #545cd8 !important;
}

/**
 * Extra class applied to VirtualScroll through className prop
 */
.rst__virtualScrollOverride {
  overflow: auto !important;
}

.ReactVirtualized__Grid__innerScrollContainer {
  overflow: visible !important;
}

.rst__rtl .ReactVirtualized__Grid__innerScrollContainer {
  direction: rtl;
}

.ReactVirtualized__Grid {
  outline: none;
}

.rst__node {
  min-width: 100%;
  white-space: nowrap;
  position: relative;
  text-align: left;
}

.rst__node.rst__rtl {
  text-align: right;
}

.rst__nodeContent {
  position: absolute;
  top: 0;
  bottom: 0;
}

/* ==========================================================================
   Scaffold

    Line-overlaid blocks used for showing the tree structure
   ========================================================================== */
.rst__lineBlock,
.rst__absoluteLineBlock {
  height: 100%;
  position: relative;
  display: inline-block;
}

.rst__absoluteLineBlock {
  position: absolute;
  top: 0;
}

.rst__lineHalfHorizontalRight::before,
.rst__lineFullVertical::after,
.rst__lineHalfVerticalTop::after,
.rst__lineHalfVerticalBottom::after {
  position: absolute;
  content: "";
  background-color: black;
}

/**
 * +-----+
 * |     |
 * |  +--+
 * |     |
 * +-----+
 */
.rst__lineHalfHorizontalRight::before {
  height: 1px;
  top: 50%;
  right: 0;
  width: 50%;
}

.rst__rtl.rst__lineHalfHorizontalRight::before {
  left: 0;
  right: auto;
  right: initial;
}

.rst__lineFullVertical::after,
.rst__lineHalfVerticalTop::after,
.rst__lineHalfVerticalBottom::after {
  width: 1px;
  left: 50%;
  top: 0;
  height: 100%;
}

.rst__rtl.rst__lineFullVertical::after,
.rst__rtl.rst__lineHalfVerticalTop::after,
.rst__rtl.rst__lineHalfVerticalBottom::after {
  right: 50%;
  left: auto;
  left: initial;
}

.rst__lineHalfVerticalTop::after {
  height: 50%;
}

.rst__lineHalfVerticalBottom::after {
  top: auto;
  bottom: 0;
  height: 50%;
}

/* Highlight line for pointing to dragged row destination
   ========================================================================== */
.rst__highlightLineVertical {
  z-index: 3;
}

.rst__highlightLineVertical::before {
  position: absolute;
  content: "";
  background-color: #545cd8;
  width: 8px;
  margin-left: -4px;
  left: 50%;
  top: 0;
  height: 100%;
}

.rst__rtl.rst__highlightLineVertical::before {
  margin-left: 0;
  margin-left: initial;
  margin-right: -4px;
  left: auto;
  left: initial;
  right: 50%;
}

@keyframes arrow-pulse {
  0% {
    transform: translate(0, 0);
    opacity: 0;
  }
  30% {
    transform: translate(0, 300%);
    opacity: 1;
  }
  70% {
    transform: translate(0, 700%);
    opacity: 1;
  }
  100% {
    transform: translate(0, 1000%);
    opacity: 0;
  }
}
.rst__highlightLineVertical::after {
  content: "";
  position: absolute;
  height: 0;
  margin-left: -4px;
  left: 50%;
  top: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid white;
  animation: arrow-pulse 1s infinite linear both;
}

.rst__rtl.rst__highlightLineVertical::after {
  margin-left: 0;
  margin-left: initial;
  margin-right: -4px;
  right: 50%;
  left: auto;
  left: initial;
}

/**
 * +-----+
 * |     |
 * |  +--+
 * |  |  |
 * +--+--+
 */
.rst__highlightTopLeftCorner::before {
  z-index: 3;
  content: "";
  position: absolute;
  border-top: solid 8px #545cd8;
  border-left: solid 8px #545cd8;
  box-sizing: border-box;
  height: calc(50% + 4px);
  top: 50%;
  margin-top: -4px;
  right: 0;
  width: calc(50% + 4px);
}

.rst__rtl.rst__highlightTopLeftCorner::before {
  border-right: solid 8px #545cd8;
  border-left: none;
  left: 0;
  right: auto;
  right: initial;
}

/**
 * +--+--+
 * |  |  |
 * |  |  |
 * |  +->|
 * +-----+
 */
.rst__highlightBottomLeftCorner {
  z-index: 3;
}

.rst__highlightBottomLeftCorner::before {
  content: "";
  position: absolute;
  border-bottom: solid 8px #545cd8;
  border-left: solid 8px #545cd8;
  box-sizing: border-box;
  height: calc(100% + 4px);
  top: 0;
  right: 12px;
  width: calc(50% - 8px);
}

.rst__rtl.rst__highlightBottomLeftCorner::before {
  border-right: solid 8px #545cd8;
  border-left: none;
  left: 12px;
  right: auto;
  right: initial;
}

.rst__highlightBottomLeftCorner::after {
  content: "";
  position: absolute;
  height: 0;
  right: 0;
  top: 100%;
  margin-top: -12px;
  border-top: 12px solid transparent;
  border-bottom: 12px solid transparent;
  border-left: 12px solid #545cd8;
}

.rst__rtl.rst__highlightBottomLeftCorner::after {
  left: 0;
  right: auto;
  right: initial;
  border-right: 12px solid #545cd8;
  border-left: none;
}

.rst__rowWrapper {
  padding: 10px 10px 10px 0;
  height: 100%;
  box-sizing: border-box;
}

.rst__rtl.rst__rowWrapper {
  padding: 10px 0 10px 10px;
}

.rst__row {
  height: 100%;
  white-space: nowrap;
  display: flex;
}

.rst__row > * {
  box-sizing: border-box;
}

/**
 * The outline of where the element will go if dropped, displayed while dragging
 */
.rst__rowLandingPad,
.rst__rowCancelPad {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

.rst__rowLandingPad > *,
.rst__rowCancelPad > * {
  opacity: 0 !important;
}

.rst__rowLandingPad::before,
.rst__rowCancelPad::before {
  background-color: lightblue;
  border: 1px dashed #fff;
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
}

/**
 * Alternate appearance of the landing pad when the dragged location is invalid
 */
.rst__rowCancelPad::before {
  background-color: #e6a8ad;
}

/**
 * Nodes matching the search conditions are highlighted
 */
.rst__rowSearchMatch {
  outline: solid 3px #0080ff;
}

/**
 * The node that matches the search conditions and is currently focused
 */
.rst__rowSearchFocus {
  outline: solid 3px #fc6421;
}

.rst__rowContents,
.rst__rowLabel,
.rst__rowToolbar,
.rst__moveHandle,
.rst__toolbarButton {
  display: inline-block;
  vertical-align: middle;
}

.rst__rowContents {
  position: relative;
  height: 100%;
  border: solid #dee2e6 1px;
  border-left: none;
  padding: 0 5px 0 10px;
  border-radius: 2px;
  min-width: 230px;
  flex: 1 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: white;
}

.rst__rtl.rst__rowContents {
  border-right: none;
  border-left: solid #dee2e6 1px;
  padding: 0 10px 0 5px;
}

.rst__rowContentsDragDisabled {
  border-left: solid #dee2e6 1px;
}

.rst__rtl.rst__rowContentsDragDisabled {
  border-right: solid #dee2e6 1px;
  border-left: solid #dee2e6 1px;
}

.rst__rowLabel {
  flex: 0 1 auto;
  padding-right: 20px;
}

.rst__rtl.rst__rowLabel {
  padding-left: 20px;
  padding-right: inherit;
}

.rst__rowToolbar {
  flex: 0 1 auto;
  display: flex;
}

.rst__moveHandle,
.rst__loadingHandle {
  height: 100%;
  width: 44px;
  background: #e9ecef url(${___CSS_LOADER_URL_REPLACEMENT_20___}) no-repeat center;
  border: solid #aaa 1px;
  cursor: move;
  border-radius: 1px;
  z-index: 1;
}

.rst__loadingHandle {
  cursor: default;
  background: #e9ecef;
}

@keyframes pointFade {
  0%, 19.999%, 100% {
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
}
.rst__loadingCircle {
  width: 80%;
  height: 80%;
  margin: 10%;
  position: relative;
}

.rst__loadingCirclePoint {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.rst__rtl.rst__loadingCirclePoint {
  right: 0;
  left: auto;
  left: initial;
}

.rst__loadingCirclePoint::before {
  content: "";
  display: block;
  margin: 0 auto;
  width: 11%;
  height: 30%;
  background-color: #fff;
  border-radius: 30%;
  animation: pointFade 800ms infinite ease-in-out both;
}

.rst__loadingCirclePoint:nth-of-type(1) {
  transform: rotate(0deg);
}

.rst__loadingCirclePoint:nth-of-type(7) {
  transform: rotate(180deg);
}

.rst__loadingCirclePoint:nth-of-type(1)::before,
.rst__loadingCirclePoint:nth-of-type(7)::before {
  animation-delay: -800ms;
}

.rst__loadingCirclePoint:nth-of-type(2) {
  transform: rotate(30deg);
}

.rst__loadingCirclePoint:nth-of-type(8) {
  transform: rotate(210deg);
}

.rst__loadingCirclePoint:nth-of-type(2)::before,
.rst__loadingCirclePoint:nth-of-type(8)::before {
  animation-delay: -666ms;
}

.rst__loadingCirclePoint:nth-of-type(3) {
  transform: rotate(60deg);
}

.rst__loadingCirclePoint:nth-of-type(9) {
  transform: rotate(240deg);
}

.rst__loadingCirclePoint:nth-of-type(3)::before,
.rst__loadingCirclePoint:nth-of-type(9)::before {
  animation-delay: -533ms;
}

.rst__loadingCirclePoint:nth-of-type(4) {
  transform: rotate(90deg);
}

.rst__loadingCirclePoint:nth-of-type(10) {
  transform: rotate(270deg);
}

.rst__loadingCirclePoint:nth-of-type(4)::before,
.rst__loadingCirclePoint:nth-of-type(10)::before {
  animation-delay: -400ms;
}

.rst__loadingCirclePoint:nth-of-type(5) {
  transform: rotate(120deg);
}

.rst__loadingCirclePoint:nth-of-type(11) {
  transform: rotate(300deg);
}

.rst__loadingCirclePoint:nth-of-type(5)::before,
.rst__loadingCirclePoint:nth-of-type(11)::before {
  animation-delay: -266ms;
}

.rst__loadingCirclePoint:nth-of-type(6) {
  transform: rotate(150deg);
}

.rst__loadingCirclePoint:nth-of-type(12) {
  transform: rotate(330deg);
}

.rst__loadingCirclePoint:nth-of-type(6)::before,
.rst__loadingCirclePoint:nth-of-type(12)::before {
  animation-delay: -133ms;
}

.rst__loadingCirclePoint:nth-of-type(7) {
  transform: rotate(180deg);
}

.rst__loadingCirclePoint:nth-of-type(13) {
  transform: rotate(360deg);
}

.rst__loadingCirclePoint:nth-of-type(7)::before,
.rst__loadingCirclePoint:nth-of-type(13)::before {
  animation-delay: 0ms;
}

.rst__rowTitle {
  font-weight: bold;
}

.rst__rowTitleWithSubtitle {
  font-size: 85%;
  display: block;
  height: 0.8rem;
}

.rst__rowSubtitle {
  font-size: 70%;
  line-height: 1;
}

.rst__collapseButton,
.rst__expandButton {
  -webkit-appearance: none;
          appearance: none;
  border: none;
  position: absolute;
  border-radius: 100%;
  box-shadow: 0 0 0 1px #000;
  width: 16px;
  height: 16px;
  padding: 0;
  top: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
}

.rst__rtl.rst__collapseButton,
.rst__rtl.rst__expandButton {
  transform: translate(50%, -50%);
}

.rst__collapseButton:focus,
.rst__expandButton:focus {
  outline: none;
  box-shadow: 0 0 0 1px #000, 0 0 1px 3px #83bef9;
}

.rst__collapseButton:hover:not(:active),
.rst__expandButton:hover:not(:active) {
  background-size: 24px;
  height: 20px;
  width: 20px;
}

.rst__collapseButton {
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_21___}) no-repeat center;
}

.rst__expandButton {
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_22___}) no-repeat center;
}

/**
 * Line for under a node with children
 */
.rst__lineChildren {
  height: 100%;
  display: inline-block;
  position: absolute;
}

.rst__lineChildren::after {
  content: "";
  position: absolute;
  background-color: black;
  width: 1px;
  left: 50%;
  bottom: 0;
  height: 10px;
}

.rst__rtl.rst__lineChildren::after {
  right: 50%;
  left: auto;
  left: initial;
}

.rst__placeholder {
  position: relative;
  height: 68px;
  max-width: 300px;
  padding: 10px;
}

.rst__placeholder,
.rst__placeholder > * {
  box-sizing: border-box;
}

.rst__placeholder::before {
  border: 3px dashed #e9ecef;
  content: "";
  position: absolute;
  top: 5px;
  right: 5px;
  bottom: 5px;
  left: 5px;
  z-index: -1;
}

/**
 * The outline of where the element will go if dropped, displayed while dragging
 */
.rst__placeholderLandingPad,
.rst__placeholderCancelPad {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

.rst__placeholderLandingPad *,
.rst__placeholderCancelPad * {
  opacity: 0 !important;
}

.rst__placeholderLandingPad::before,
.rst__placeholderCancelPad::before {
  background-color: lightblue;
  border-color: white;
}

/**
 * Alternate appearance of the landing pad when the dragged location is invalid
 */
.rst__placeholderCancelPad::before {
  background-color: #e6a8ad;
}

/* Collection default theme */
/* Grid default theme */
/* Table default theme */
.ReactVirtualized__Table__headerRow {
  font-weight: 700;
  text-transform: uppercase;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.ReactVirtualized__Table__row {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.ReactVirtualized__Table__headerTruncatedText {
  display: inline-block;
  max-width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.ReactVirtualized__Table__headerColumn,
.ReactVirtualized__Table__rowColumn {
  margin-right: 10px;
  min-width: 0px;
}

.ReactVirtualized__Table__rowColumn {
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ReactVirtualized__Table__headerColumn:first-of-type,
.ReactVirtualized__Table__rowColumn:first-of-type {
  margin-left: 10px;
}

.ReactVirtualized__Table__sortableHeaderColumn {
  cursor: pointer;
}

.ReactVirtualized__Table__sortableHeaderIconContainer {
  display: flex;
  align-items: center;
}

.ReactVirtualized__Table__sortableHeaderIcon {
  flex: 0 0 24px;
  height: 1em;
  width: 1em;
  fill: currentColor;
}

/* List default theme */
.ReactTable {
  position: relative;
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(0, 0, 0, 0.1);
}
.ReactTable .rt-table {
  flex: auto 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  border-collapse: collapse;
  overflow: auto;
}
.ReactTable .-pagination input,
.ReactTable .-pagination select,
.ReactTable .rt-thead.-filters input,
.ReactTable .rt-thead.-filters select {
  display: block;
  width: 100%;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  height: calc(1.5em + (0.5rem + 2px));
  padding: 0.25rem 0.5rem;
  border-radius: 0.2rem;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;
}
.ReactTable .-pagination input::-ms-expand,
.ReactTable .-pagination select::-ms-expand,
.ReactTable .rt-thead.-filters input::-ms-expand,
.ReactTable .rt-thead.-filters select::-ms-expand {
  background-color: transparent;
  border: 0;
}
.ReactTable .-pagination input::placeholder,
.ReactTable .-pagination select::placeholder,
.ReactTable .rt-thead.-filters input::placeholder,
.ReactTable .rt-thead.-filters select::placeholder {
  color: #6c757d;
  opacity: 1;
}
.ReactTable .-pagination input:disabled, .ReactTable .-pagination input[readonly],
.ReactTable .-pagination select:disabled,
.ReactTable .-pagination select[readonly],
.ReactTable .rt-thead.-filters input:disabled,
.ReactTable .rt-thead.-filters input[readonly],
.ReactTable .rt-thead.-filters select:disabled,
.ReactTable .rt-thead.-filters select[readonly] {
  background-color: #e9ecef;
  opacity: 1;
}
.ReactTable .rt-thead {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  -webkit-user-select: none;
          user-select: none;
}
.ReactTable .rt-thead.-headerGroups {
  background: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid #e9ecef;
}
.ReactTable .rt-thead.-headerGroups .rt-th,
.ReactTable .rt-thead.-headerGroups .rt-td {
  padding: 0.3rem;
  color: #6c757d;
}
.ReactTable .rt-thead.-headerGroups .rt-th:hover,
.ReactTable .rt-thead.-headerGroups .rt-td:hover {
  color: #6c757d;
}
.ReactTable .rt-thead.-headerGroups .rt-th:empty,
.ReactTable .rt-thead.-headerGroups .rt-td:empty {
  padding: 0;
}
.ReactTable .rt-thead.-filters {
  border-bottom: 1px solid #e9ecef;
  background: #f8f9fa;
}
.ReactTable .rt-thead.-filters .rt-th {
  border-right: 1px solid #e9ecef;
}
.ReactTable .rt-thead.-filters.-header {
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.15);
}
.ReactTable .rt-thead .rt-tr {
  text-align: center;
}
.ReactTable .rt-thead .rt-th,
.ReactTable .rt-thead .rt-td {
  padding: 0.55rem;
  line-height: normal;
  position: relative;
  font-weight: bold;
  border-right: 1px solid #e9ecef;
  border-bottom: 1px solid #e9ecef;
  transition: box-shadow 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  box-shadow: inset 0 0 0 0 transparent;
  color: #545cd8;
}
.ReactTable .rt-thead .rt-th:hover,
.ReactTable .rt-thead .rt-td:hover {
  color: rgb(41.5071428571, 50.0214285714, 181.9928571429);
}
.ReactTable .rt-thead .rt-th.-sort-asc,
.ReactTable .rt-thead .rt-td.-sort-asc {
  box-shadow: inset 0 3px 0 0 #545cd8;
}
.ReactTable .rt-thead .rt-th.-sort-desc,
.ReactTable .rt-thead .rt-td.-sort-desc {
  box-shadow: inset 0 -3px 0 0 #545cd8;
}
.ReactTable .rt-thead .rt-th.-cursor-pointer,
.ReactTable .rt-thead .rt-td.-cursor-pointer {
  cursor: pointer;
}
.ReactTable .rt-thead .rt-th:last-child,
.ReactTable .rt-thead .rt-td:last-child {
  border-right: 0;
}
.ReactTable .rt-thead .rt-resizable-header {
  overflow: visible;
}
.ReactTable .rt-thead .rt-resizable-header:last-child {
  overflow: hidden;
}
.ReactTable .rt-thead .rt-resizable-header-content {
  overflow: hidden;
  text-overflow: ellipsis;
}
.ReactTable .rt-thead .rt-header-pivot {
  border-right-color: #f7f7f7;
}
.ReactTable .rt-thead .rt-header-pivot:after,
.ReactTable .rt-thead .rt-header-pivot:before {
  left: 100%;
  top: 50%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}
.ReactTable .rt-thead .rt-header-pivot:after {
  border-color: rgba(255, 255, 255, 0);
  border-left-color: #fff;
  border-width: 8px;
  margin-top: -8px;
}
.ReactTable .rt-thead .rt-header-pivot:before {
  border-color: rgba(102, 102, 102, 0);
  border-left-color: #f7f7f7;
  border-width: 10px;
  margin-top: -10px;
}
.ReactTable .rt-tbody {
  flex: 99999 1 auto;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
.ReactTable .rt-tbody .rt-tr-group {
  border-bottom: solid 1px #e9ecef;
}
.ReactTable .rt-tbody .rt-tr-group:last-child {
  border-bottom: 0;
}
.ReactTable .rt-tbody .rt-td {
  border-right: 1px solid #e9ecef;
  align-items: center;
  align-content: center;
  display: flex;
}
.ReactTable .rt-tbody .rt-td [contenteditable=true] {
  width: 100%;
  border: 1px solid transparent;
  background: #fff !important;
  border-radius: 0.2rem;
}
.ReactTable .rt-tbody .rt-td [contenteditable=true]:focus {
  padding: 3px 5px;
  border-color: rgb(187.8214285714, 190.9642857143, 239.6785714286);
  outline: none;
}
.ReactTable .rt-tbody .rt-td:last-child {
  border-right: 0;
}
.ReactTable .rt-tbody .rt-expandable {
  cursor: pointer;
  text-overflow: clip;
}
.ReactTable .rt-tr-group {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.ReactTable .rt-tr {
  flex: 1 0 auto;
  display: inline-flex;
}
.ReactTable .rt-th,
.ReactTable .rt-td {
  flex: 1 0;
  text-overflow: ellipsis;
  padding: 0.55rem;
  transition: 0.3s ease;
  transition-property: width, min-width, padding, opacity;
}
.ReactTable .rt-th.-hidden,
.ReactTable .rt-td.-hidden {
  width: 0 !important;
  min-width: 0 !important;
  padding: 0 !important;
  border: 0 !important;
  opacity: 0 !important;
}
.ReactTable .rt-expander {
  display: inline-block;
  position: relative;
  color: transparent;
  margin: 0 10px 0 0;
}
.ReactTable .rt-expander:after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-90deg);
  border-left: 5.04px solid transparent;
  border-right: 5.04px solid transparent;
  border-top: 7px solid rgba(0, 0, 0, 0.8);
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  cursor: pointer;
}
.ReactTable .rt-expander.-open:after {
  transform: translate(-50%, -50%) rotate(0);
}
.ReactTable .rt-resizer {
  display: inline-block;
  position: absolute;
  width: 36px;
  top: 0;
  bottom: 0;
  right: -18px;
  cursor: col-resize;
  z-index: 10;
}
.ReactTable .rt-tfoot {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);
}
.ReactTable .rt-tfoot .rt-td {
  border-right: 1px solid #e9ecef;
}
.ReactTable .rt-tfoot .rt-td:last-child {
  border-right: 0;
}
.ReactTable.-striped .rt-tr.-odd {
  background: rgba(0, 0, 0, 0.03);
}
.ReactTable.-fixed .-header {
  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.07);
}
.ReactTable.-fixed .pagination-bottom {
  box-shadow: 0 -2px 7px 0 rgba(0, 0, 0, 0.07);
}
.ReactTable.-highlight .rt-tbody .rt-tr:not(.-padRow):hover {
  background: #e0f3ff;
}
.ReactTable .-pagination {
  z-index: 1;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  flex-wrap: wrap;
  padding: 3px;
  border-top: 2px solid rgba(0, 0, 0, 0.1);
}
.ReactTable .-pagination .-btn {
  -webkit-appearance: none;
          appearance: none;
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
  border-radius: 0.25rem;
  padding: 6px;
  font-size: 1em;
  color: #545cd8;
  background: #f8f9fa;
  transition: all 0.2s ease;
  cursor: pointer;
  outline: none;
  font-weight: bold;
}
.ReactTable .-pagination .-btn[disabled] {
  opacity: 0.5;
  cursor: default;
}
.ReactTable .-pagination .-btn:not([disabled]):hover {
  background: #545cd8;
  color: #fff;
}
.ReactTable .-pagination .-previous,
.ReactTable .-pagination .-next {
  flex: 1 1;
  text-align: center;
}
.ReactTable .-pagination .-center {
  text-align: center;
  margin-bottom: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-around;
}
.ReactTable .-pagination .-totalPages {
  padding-left: 5px;
  font-weight: bold;
}
.ReactTable .-pagination .-pageInfo {
  display: inherit;
  margin: 3px 0 3px 10px;
  white-space: nowrap;
  height: 30px;
  line-height: 30px;
}
.ReactTable .-pagination .-pageJump {
  display: inline-block;
  margin: 0 5px;
}
.ReactTable .-pagination .-pageJump input {
  width: 70px;
  text-align: center;
}
.ReactTable .-pagination .-pageSizeOptions {
  margin: 3px 10px;
}
.ReactTable .rt-noData {
  display: block;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255, 255, 255, 0.8);
  transition: all 0.3s ease;
  z-index: 1;
  pointer-events: none;
  padding: 20px;
  color: rgba(0, 0, 0, 0.5);
}
.ReactTable .-loading {
  display: block;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  transition: all 0.3s ease;
  z-index: -1;
  opacity: 0;
  pointer-events: none;
}
.ReactTable .-loading > div {
  position: absolute;
  display: block;
  text-align: center;
  width: 100%;
  top: 50%;
  left: 0;
  font-size: 15px;
  color: #545cd8;
  transform: translateY(-52%);
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}
.ReactTable .-loading.-active {
  opacity: 1;
  z-index: 2;
  pointer-events: all;
}
.ReactTable .-loading.-active > div {
  transform: translateY(50%);
}
.ReactTable .rt-resizing .rt-th,
.ReactTable .rt-resizing .rt-td {
  transition: none !important;
  cursor: col-resize;
  -webkit-user-select: none;
          user-select: none;
}

.table thead th,
.table td {
  vertical-align: middle;
}

.table th .filter {
  margin-top: 0.375rem;
  height: auto;
  padding: 0.3rem 0.5rem;
}

.caret-4-asc,
.caret-4-desc {
  font-family: "Linearicons-Free";
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-feature-settings: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  margin-left: 0.375rem;
}

.table .sortable:hover .caret-4-asc,
.table .sortable:hover .caret-4-desc {
  color: #545cd8;
}

.table-lg th,
.table-lg td {
  padding: 1.1rem 0.825rem;
}

.rdt_Table {
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.rdt_TableCol {
  padding: 0.55rem;
  line-height: normal;
  position: relative;
  font-weight: 700;
  border-right: 1px solid #e9ecef;
  border-bottom: 1px solid #e9ecef;
  transition: box-shadow 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  box-shadow: inset 0 0 0 0 transparent;
  color: #545cd8;
}

.rdt_TableCell {
  border-right: 1px solid #e9ecef;
}

.rdt_TableRow:nth-child(odd) {
  background-color: #FFFFFF;
}

.rdt_TableRow:nth-child(even) {
  background-color: #f7f7f7;
}

.rdt_TableRow:hover {
  background-color: #e0f3ff;
}

@font-face {
  font-family: "Linearicons-Free";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_24___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_28___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
[class^=lnr-],
[class*=" lnr-"] {
  font-family: "Linearicons-Free";
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-feature-settings: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.lnr-home:before {
  content: "\\e800";
}

.lnr-apartment:before {
  content: "\\e801";
}

.lnr-pencil:before {
  content: "\\e802";
}

.lnr-magic-wand:before {
  content: "\\e803";
}

.lnr-drop:before {
  content: "\\e804";
}

.lnr-lighter:before {
  content: "\\e805";
}

.lnr-poop:before {
  content: "\\e806";
}

.lnr-sun:before {
  content: "\\e807";
}

.lnr-moon:before {
  content: "\\e808";
}

.lnr-cloud:before {
  content: "\\e809";
}

.lnr-cloud-upload:before {
  content: "\\e80a";
}

.lnr-cloud-download:before {
  content: "\\e80b";
}

.lnr-cloud-sync:before {
  content: "\\e80c";
}

.lnr-cloud-check:before {
  content: "\\e80d";
}

.lnr-database:before {
  content: "\\e80e";
}

.lnr-lock:before {
  content: "\\e80f";
}

.lnr-cog:before {
  content: "\\e810";
}

.lnr-trash:before {
  content: "\\e811";
}

.lnr-dice:before {
  content: "\\e812";
}

.lnr-heart:before {
  content: "\\e813";
}

.lnr-star:before {
  content: "\\e814";
}

.lnr-star-half:before {
  content: "\\e815";
}

.lnr-star-empty:before {
  content: "\\e816";
}

.lnr-flag:before {
  content: "\\e817";
}

.lnr-envelope:before {
  content: "\\e818";
}

.lnr-paperclip:before {
  content: "\\e819";
}

.lnr-inbox:before {
  content: "\\e81a";
}

.lnr-eye:before {
  content: "\\e81b";
}

.lnr-printer:before {
  content: "\\e81c";
}

.lnr-file-empty:before {
  content: "\\e81d";
}

.lnr-file-add:before {
  content: "\\e81e";
}

.lnr-enter:before {
  content: "\\e81f";
}

.lnr-exit:before {
  content: "\\e820";
}

.lnr-graduation-hat:before {
  content: "\\e821";
}

.lnr-license:before {
  content: "\\e822";
}

.lnr-music-note:before {
  content: "\\e823";
}

.lnr-film-play:before {
  content: "\\e824";
}

.lnr-camera-video:before {
  content: "\\e825";
}

.lnr-camera:before {
  content: "\\e826";
}

.lnr-picture:before {
  content: "\\e827";
}

.lnr-book:before {
  content: "\\e828";
}

.lnr-bookmark:before {
  content: "\\e829";
}

.lnr-user:before {
  content: "\\e82a";
}

.lnr-users:before {
  content: "\\e82b";
}

.lnr-shirt:before {
  content: "\\e82c";
}

.lnr-store:before {
  content: "\\e82d";
}

.lnr-cart:before {
  content: "\\e82e";
}

.lnr-tag:before {
  content: "\\e82f";
}

.lnr-phone-handset:before {
  content: "\\e830";
}

.lnr-phone:before {
  content: "\\e831";
}

.lnr-pushpin:before {
  content: "\\e832";
}

.lnr-map-marker:before {
  content: "\\e833";
}

.lnr-map:before {
  content: "\\e834";
}

.lnr-location:before {
  content: "\\e835";
}

.lnr-calendar-full:before {
  content: "\\e836";
}

.lnr-keyboard:before {
  content: "\\e837";
}

.lnr-spell-check:before {
  content: "\\e838";
}

.lnr-screen:before {
  content: "\\e839";
}

.lnr-smartphone:before {
  content: "\\e83a";
}

.lnr-tablet:before {
  content: "\\e83b";
}

.lnr-laptop:before {
  content: "\\e83c";
}

.lnr-laptop-phone:before {
  content: "\\e83d";
}

.lnr-power-switch:before {
  content: "\\e83e";
}

.lnr-bubble:before {
  content: "\\e83f";
}

.lnr-heart-pulse:before {
  content: "\\e840";
}

.lnr-construction:before {
  content: "\\e841";
}

.lnr-pie-chart:before {
  content: "\\e842";
}

.lnr-chart-bars:before {
  content: "\\e843";
}

.lnr-gift:before {
  content: "\\e844";
}

.lnr-diamond:before {
  content: "\\e845";
}

.lnr-linearicons:before {
  content: "\\e846";
}

.lnr-dinner:before {
  content: "\\e847";
}

.lnr-coffee-cup:before {
  content: "\\e848";
}

.lnr-leaf:before {
  content: "\\e849";
}

.lnr-paw:before {
  content: "\\e84a";
}

.lnr-rocket:before {
  content: "\\e84b";
}

.lnr-briefcase:before {
  content: "\\e84c";
}

.lnr-bus:before {
  content: "\\e84d";
}

.lnr-car:before {
  content: "\\e84e";
}

.lnr-train:before {
  content: "\\e84f";
}

.lnr-bicycle:before {
  content: "\\e850";
}

.lnr-wheelchair:before {
  content: "\\e851";
}

.lnr-select:before {
  content: "\\e852";
}

.lnr-earth:before {
  content: "\\e853";
}

.lnr-smile:before {
  content: "\\e854";
}

.lnr-sad:before {
  content: "\\e855";
}

.lnr-neutral:before {
  content: "\\e856";
}

.lnr-mustache:before {
  content: "\\e857";
}

.lnr-alarm:before {
  content: "\\e858";
}

.lnr-bullhorn:before {
  content: "\\e859";
}

.lnr-volume-high:before {
  content: "\\e85a";
}

.lnr-volume-medium:before {
  content: "\\e85b";
}

.lnr-volume-low:before {
  content: "\\e85c";
}

.lnr-volume:before {
  content: "\\e85d";
}

.lnr-mic:before {
  content: "\\e85e";
}

.lnr-hourglass:before {
  content: "\\e85f";
}

.lnr-undo:before {
  content: "\\e860";
}

.lnr-redo:before {
  content: "\\e861";
}

.lnr-sync:before {
  content: "\\e862";
}

.lnr-history:before {
  content: "\\e863";
}

.lnr-clock:before {
  content: "\\e864";
}

.lnr-download:before {
  content: "\\e865";
}

.lnr-upload:before {
  content: "\\e866";
}

.lnr-enter-down:before {
  content: "\\e867";
}

.lnr-exit-up:before {
  content: "\\e868";
}

.lnr-bug:before {
  content: "\\e869";
}

.lnr-code:before {
  content: "\\e86a";
}

.lnr-link:before {
  content: "\\e86b";
}

.lnr-unlink:before {
  content: "\\e86c";
}

.lnr-thumbs-up:before {
  content: "\\e86d";
}

.lnr-thumbs-down:before {
  content: "\\e86e";
}

.lnr-magnifier:before {
  content: "\\e86f";
}

.lnr-cross:before {
  content: "\\e870";
}

.lnr-menu:before {
  content: "\\e871";
}

.lnr-list:before {
  content: "\\e872";
}

.lnr-chevron-up:before, .caret-4-asc:before {
  content: "\\e873";
}

.lnr-chevron-down:before, .caret-4-desc:before {
  content: "\\e874";
}

.lnr-chevron-left:before {
  content: "\\e875";
}

.lnr-chevron-right:before {
  content: "\\e876";
}

.lnr-arrow-up:before {
  content: "\\e877";
}

.lnr-arrow-down:before {
  content: "\\e878";
}

.lnr-arrow-left:before {
  content: "\\e879";
}

.lnr-arrow-right:before {
  content: "\\e87a";
}

.lnr-move:before {
  content: "\\e87b";
}

.lnr-warning:before {
  content: "\\e87c";
}

.lnr-question-circle:before {
  content: "\\e87d";
}

.lnr-menu-circle:before {
  content: "\\e87e";
}

.lnr-checkmark-circle:before, .forms-wizard li.form-wizard-step-done em:before {
  content: "\\e87f";
}

.lnr-cross-circle:before {
  content: "\\e880";
}

.lnr-plus-circle:before {
  content: "\\e881";
}

.lnr-circle-minus:before {
  content: "\\e882";
}

.lnr-arrow-up-circle:before {
  content: "\\e883";
}

.lnr-arrow-down-circle:before {
  content: "\\e884";
}

.lnr-arrow-left-circle:before {
  content: "\\e885";
}

.lnr-arrow-right-circle:before {
  content: "\\e886";
}

.lnr-chevron-up-circle:before {
  content: "\\e887";
}

.lnr-chevron-down-circle:before {
  content: "\\e888";
}

.lnr-chevron-left-circle:before {
  content: "\\e889";
}

.lnr-chevron-right-circle:before {
  content: "\\e88a";
}

.lnr-crop:before {
  content: "\\e88b";
}

.lnr-frame-expand:before {
  content: "\\e88c";
}

.lnr-frame-contract:before {
  content: "\\e88d";
}

.lnr-layers:before {
  content: "\\e88e";
}

.lnr-funnel:before {
  content: "\\e88f";
}

.lnr-text-format:before {
  content: "\\e890";
}

.lnr-text-format-remove:before {
  content: "\\e891";
}

.lnr-text-size:before {
  content: "\\e892";
}

.lnr-bold:before {
  content: "\\e893";
}

.lnr-italic:before {
  content: "\\e894";
}

.lnr-underline:before {
  content: "\\e895";
}

.lnr-strikethrough:before {
  content: "\\e896";
}

.lnr-highlight:before {
  content: "\\e897";
}

.lnr-text-align-left:before {
  content: "\\e898";
}

.lnr-text-align-center:before {
  content: "\\e899";
}

.lnr-text-align-right:before {
  content: "\\e89a";
}

.lnr-text-align-justify:before {
  content: "\\e89b";
}

.lnr-line-spacing:before {
  content: "\\e89c";
}

.lnr-indent-increase:before {
  content: "\\e89d";
}

.lnr-indent-decrease:before {
  content: "\\e89e";
}

.lnr-pilcrow:before {
  content: "\\e89f";
}

.lnr-direction-ltr:before {
  content: "\\e8a0";
}

.lnr-direction-rtl:before {
  content: "\\e8a1";
}

.lnr-page-break:before {
  content: "\\e8a2";
}

.lnr-sort-alpha-asc:before {
  content: "\\e8a3";
}

.lnr-sort-amount-asc:before {
  content: "\\e8a4";
}

.lnr-hand:before {
  content: "\\e8a5";
}

.lnr-pointer-up:before {
  content: "\\e8a6";
}

.lnr-pointer-right:before {
  content: "\\e8a7";
}

.lnr-pointer-down:before {
  content: "\\e8a8";
}

.lnr-pointer-left:before {
  content: "\\e8a9";
}

/*
*  Licensing: http://www.pixeden.com/icon-fonts/stroke-7-icon-font-set
*/
@font-face {
  font-family: "Pe-icon-7-stroke";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_30___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_31___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_32___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_33___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
[class^=pe-7s-], [class*=" pe-7s-"] {
  display: inline-block;
  font-family: "Pe-icon-7-stroke";
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-feature-settings: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* HELPER CLASS
 * -------------------------- */
/* FA based classes */
/*! Modified from font-awesome helper CSS classes - PIXEDEN
 *  Font Awesome 4.0.3 by @davegandy - http://fontawesome.io - @fontawesome
 *  License - http://fontawesome.io/license (CSS: MIT License)
 */
/* makes the font 33% larger relative to the icon container */
.pe-lg {
  font-size: 1.1704rem;
  line-height: 0.75em;
  vertical-align: -15%;
}

.pe-2x {
  font-size: 1.76rem;
}

.pe-3x {
  font-size: 2.64rem;
}

.pe-4x {
  font-size: 3.52rem;
}

.pe-5x {
  font-size: 4.4rem;
}

.pe-fw {
  width: 1.2857142857em;
  text-align: center;
}

.pe-ul {
  padding-left: 0;
  margin-left: 2.1428571429em;
  list-style-type: none;
}
.pe-ul > li {
  position: relative;
}

.pe-li {
  position: absolute;
  left: -2.1428571429em;
  width: 2.1428571429em;
  top: 0.1428571429em;
  text-align: center;
}
.pe-li.pe-lg {
  left: -1.8571428571em;
}

.pe-border {
  padding: 0.2em 0.25em 0.15em;
  border: solid 0.08em #eeeeee;
  border-radius: 0.1em;
}

.pull-right {
  float: right;
}

.pe.pull-left {
  float: left;
  margin-right: 0.3em;
  margin-left: 0.3em;
}

.pe-spin {
  animation: spin 2s infinite linear;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(359deg);
  }
}
.pe-rotate-90 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);
  transform: rotate(90deg);
}

.pe-rotate-180 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
  transform: rotate(180deg);
}

.pe-rotate-270 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);
  transform: rotate(270deg);
}

.pe-flip-horizontal {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1);
  transform: scale(-1, 1);
}

.pe-flip-vertical {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1);
  transform: scale(1, -1);
}

.pe-stack {
  position: relative;
  display: inline-block;
  width: 2em;
  height: 2em;
  line-height: 2em;
  vertical-align: middle;
}

.pe-stack-1x,
.pe-stack-2x {
  position: absolute;
  left: 0;
  width: 100%;
  text-align: center;
}

.pe-stack-1x {
  line-height: inherit;
}

.pe-stack-2x {
  font-size: 2em;
}

.pe-inverse {
  color: #ffffff;
}

/* Custom classes / mods - PIXEDEN */
.pe-va {
  vertical-align: middle;
}

.pe-border {
  border: solid 0.08em #eaeaea;
}

.pe-7s-album:before {
  content: "\\e6aa";
}

.pe-7s-arc:before {
  content: "\\e6ab";
}

.pe-7s-back-2:before {
  content: "\\e6ac";
}

.pe-7s-bandaid:before {
  content: "\\e6ad";
}

.pe-7s-car:before {
  content: "\\e6ae";
}

.pe-7s-diamond:before {
  content: "\\e6af";
}

.pe-7s-door-lock:before {
  content: "\\e6b0";
}

.pe-7s-eyedropper:before {
  content: "\\e6b1";
}

.pe-7s-female:before {
  content: "\\e6b2";
}

.pe-7s-gym:before {
  content: "\\e6b3";
}

.pe-7s-hammer:before {
  content: "\\e6b4";
}

.pe-7s-headphones:before {
  content: "\\e6b5";
}

.pe-7s-helm:before {
  content: "\\e6b6";
}

.pe-7s-hourglass:before {
  content: "\\e6b7";
}

.pe-7s-leaf:before {
  content: "\\e6b8";
}

.pe-7s-magic-wand:before {
  content: "\\e6b9";
}

.pe-7s-male:before {
  content: "\\e6ba";
}

.pe-7s-map-2:before {
  content: "\\e6bb";
}

.pe-7s-next-2:before {
  content: "\\e6bc";
}

.pe-7s-paint-bucket:before {
  content: "\\e6bd";
}

.pe-7s-pendrive:before {
  content: "\\e6be";
}

.pe-7s-photo:before {
  content: "\\e6bf";
}

.pe-7s-piggy:before {
  content: "\\e6c0";
}

.pe-7s-plugin:before {
  content: "\\e6c1";
}

.pe-7s-refresh-2:before {
  content: "\\e6c2";
}

.pe-7s-rocket:before {
  content: "\\e6c3";
}

.pe-7s-settings:before {
  content: "\\e6c4";
}

.pe-7s-shield:before {
  content: "\\e6c5";
}

.pe-7s-smile:before {
  content: "\\e6c6";
}

.pe-7s-usb:before {
  content: "\\e6c7";
}

.pe-7s-vector:before {
  content: "\\e6c8";
}

.pe-7s-wine:before {
  content: "\\e6c9";
}

.pe-7s-cloud-upload:before {
  content: "\\e68a";
}

.pe-7s-cash:before {
  content: "\\e68c";
}

.pe-7s-close:before {
  content: "\\e680";
}

.pe-7s-bluetooth:before {
  content: "\\e68d";
}

.pe-7s-cloud-download:before {
  content: "\\e68b";
}

.pe-7s-way:before {
  content: "\\e68e";
}

.pe-7s-close-circle:before {
  content: "\\e681";
}

.pe-7s-id:before {
  content: "\\e68f";
}

.pe-7s-angle-up:before {
  content: "\\e682";
}

.pe-7s-wristwatch:before {
  content: "\\e690";
}

.pe-7s-angle-up-circle:before {
  content: "\\e683";
}

.pe-7s-world:before {
  content: "\\e691";
}

.pe-7s-angle-right:before {
  content: "\\e684";
}

.pe-7s-volume:before {
  content: "\\e692";
}

.pe-7s-angle-right-circle:before {
  content: "\\e685";
}

.pe-7s-users:before {
  content: "\\e693";
}

.pe-7s-angle-left:before {
  content: "\\e686";
}

.pe-7s-user-female:before {
  content: "\\e694";
}

.pe-7s-angle-left-circle:before {
  content: "\\e687";
}

.pe-7s-up-arrow:before {
  content: "\\e695";
}

.pe-7s-angle-down:before {
  content: "\\e688";
}

.pe-7s-switch:before {
  content: "\\e696";
}

.pe-7s-angle-down-circle:before {
  content: "\\e689";
}

.pe-7s-scissors:before {
  content: "\\e697";
}

.pe-7s-wallet:before {
  content: "\\e600";
}

.pe-7s-safe:before {
  content: "\\e698";
}

.pe-7s-volume2:before {
  content: "\\e601";
}

.pe-7s-volume1:before {
  content: "\\e602";
}

.pe-7s-voicemail:before {
  content: "\\e603";
}

.pe-7s-video:before {
  content: "\\e604";
}

.pe-7s-user:before {
  content: "\\e605";
}

.pe-7s-upload:before {
  content: "\\e606";
}

.pe-7s-unlock:before {
  content: "\\e607";
}

.pe-7s-umbrella:before {
  content: "\\e608";
}

.pe-7s-trash:before {
  content: "\\e609";
}

.pe-7s-tools:before {
  content: "\\e60a";
}

.pe-7s-timer:before {
  content: "\\e60b";
}

.pe-7s-ticket:before {
  content: "\\e60c";
}

.pe-7s-target:before {
  content: "\\e60d";
}

.pe-7s-sun:before {
  content: "\\e60e";
}

.pe-7s-study:before {
  content: "\\e60f";
}

.pe-7s-stopwatch:before {
  content: "\\e610";
}

.pe-7s-star:before {
  content: "\\e611";
}

.pe-7s-speaker:before {
  content: "\\e612";
}

.pe-7s-signal:before {
  content: "\\e613";
}

.pe-7s-shuffle:before {
  content: "\\e614";
}

.pe-7s-shopbag:before {
  content: "\\e615";
}

.pe-7s-share:before {
  content: "\\e616";
}

.pe-7s-server:before {
  content: "\\e617";
}

.pe-7s-search:before {
  content: "\\e618";
}

.pe-7s-film:before {
  content: "\\e6a5";
}

.pe-7s-science:before {
  content: "\\e619";
}

.pe-7s-disk:before {
  content: "\\e6a6";
}

.pe-7s-ribbon:before {
  content: "\\e61a";
}

.pe-7s-repeat:before {
  content: "\\e61b";
}

.pe-7s-refresh:before {
  content: "\\e61c";
}

.pe-7s-add-user:before {
  content: "\\e6a9";
}

.pe-7s-refresh-cloud:before {
  content: "\\e61d";
}

.pe-7s-paperclip:before {
  content: "\\e69c";
}

.pe-7s-radio:before {
  content: "\\e61e";
}

.pe-7s-note2:before {
  content: "\\e69d";
}

.pe-7s-print:before {
  content: "\\e61f";
}

.pe-7s-network:before {
  content: "\\e69e";
}

.pe-7s-prev:before {
  content: "\\e620";
}

.pe-7s-mute:before {
  content: "\\e69f";
}

.pe-7s-power:before {
  content: "\\e621";
}

.pe-7s-medal:before {
  content: "\\e6a0";
}

.pe-7s-portfolio:before {
  content: "\\e622";
}

.pe-7s-like2:before {
  content: "\\e6a1";
}

.pe-7s-plus:before {
  content: "\\e623";
}

.pe-7s-left-arrow:before {
  content: "\\e6a2";
}

.pe-7s-play:before {
  content: "\\e624";
}

.pe-7s-key:before {
  content: "\\e6a3";
}

.pe-7s-plane:before {
  content: "\\e625";
}

.pe-7s-joy:before {
  content: "\\e6a4";
}

.pe-7s-photo-gallery:before {
  content: "\\e626";
}

.pe-7s-pin:before {
  content: "\\e69b";
}

.pe-7s-phone:before {
  content: "\\e627";
}

.pe-7s-plug:before {
  content: "\\e69a";
}

.pe-7s-pen:before {
  content: "\\e628";
}

.pe-7s-right-arrow:before {
  content: "\\e699";
}

.pe-7s-paper-plane:before {
  content: "\\e629";
}

.pe-7s-delete-user:before {
  content: "\\e6a7";
}

.pe-7s-paint:before {
  content: "\\e62a";
}

.pe-7s-bottom-arrow:before {
  content: "\\e6a8";
}

.pe-7s-notebook:before {
  content: "\\e62b";
}

.pe-7s-note:before {
  content: "\\e62c";
}

.pe-7s-next:before {
  content: "\\e62d";
}

.pe-7s-news-paper:before {
  content: "\\e62e";
}

.pe-7s-musiclist:before {
  content: "\\e62f";
}

.pe-7s-music:before {
  content: "\\e630";
}

.pe-7s-mouse:before {
  content: "\\e631";
}

.pe-7s-more:before {
  content: "\\e632";
}

.pe-7s-moon:before {
  content: "\\e633";
}

.pe-7s-monitor:before {
  content: "\\e634";
}

.pe-7s-micro:before {
  content: "\\e635";
}

.pe-7s-menu:before {
  content: "\\e636";
}

.pe-7s-map:before {
  content: "\\e637";
}

.pe-7s-map-marker:before {
  content: "\\e638";
}

.pe-7s-mail:before {
  content: "\\e639";
}

.pe-7s-mail-open:before {
  content: "\\e63a";
}

.pe-7s-mail-open-file:before {
  content: "\\e63b";
}

.pe-7s-magnet:before {
  content: "\\e63c";
}

.pe-7s-loop:before {
  content: "\\e63d";
}

.pe-7s-look:before {
  content: "\\e63e";
}

.pe-7s-lock:before {
  content: "\\e63f";
}

.pe-7s-lintern:before {
  content: "\\e640";
}

.pe-7s-link:before {
  content: "\\e641";
}

.pe-7s-like:before {
  content: "\\e642";
}

.pe-7s-light:before {
  content: "\\e643";
}

.pe-7s-less:before {
  content: "\\e644";
}

.pe-7s-keypad:before {
  content: "\\e645";
}

.pe-7s-junk:before {
  content: "\\e646";
}

.pe-7s-info:before {
  content: "\\e647";
}

.pe-7s-home:before {
  content: "\\e648";
}

.pe-7s-help2:before {
  content: "\\e649";
}

.pe-7s-help1:before {
  content: "\\e64a";
}

.pe-7s-graph3:before {
  content: "\\e64b";
}

.pe-7s-graph2:before {
  content: "\\e64c";
}

.pe-7s-graph1:before {
  content: "\\e64d";
}

.pe-7s-graph:before {
  content: "\\e64e";
}

.pe-7s-global:before {
  content: "\\e64f";
}

.pe-7s-gleam:before {
  content: "\\e650";
}

.pe-7s-glasses:before {
  content: "\\e651";
}

.pe-7s-gift:before {
  content: "\\e652";
}

.pe-7s-folder:before {
  content: "\\e653";
}

.pe-7s-flag:before {
  content: "\\e654";
}

.pe-7s-filter:before {
  content: "\\e655";
}

.pe-7s-file:before {
  content: "\\e656";
}

.pe-7s-expand1:before {
  content: "\\e657";
}

.pe-7s-exapnd2:before {
  content: "\\e658";
}

.pe-7s-edit:before {
  content: "\\e659";
}

.pe-7s-drop:before {
  content: "\\e65a";
}

.pe-7s-drawer:before {
  content: "\\e65b";
}

.pe-7s-download:before {
  content: "\\e65c";
}

.pe-7s-display2:before {
  content: "\\e65d";
}

.pe-7s-display1:before {
  content: "\\e65e";
}

.pe-7s-diskette:before {
  content: "\\e65f";
}

.pe-7s-date:before {
  content: "\\e660";
}

.pe-7s-cup:before {
  content: "\\e661";
}

.pe-7s-culture:before {
  content: "\\e662";
}

.pe-7s-crop:before {
  content: "\\e663";
}

.pe-7s-credit:before {
  content: "\\e664";
}

.pe-7s-copy-file:before {
  content: "\\e665";
}

.pe-7s-config:before {
  content: "\\e666";
}

.pe-7s-compass:before {
  content: "\\e667";
}

.pe-7s-comment:before {
  content: "\\e668";
}

.pe-7s-coffee:before {
  content: "\\e669";
}

.pe-7s-cloud:before {
  content: "\\e66a";
}

.pe-7s-clock:before {
  content: "\\e66b";
}

.pe-7s-check:before {
  content: "\\e66c";
}

.pe-7s-chat:before {
  content: "\\e66d";
}

.pe-7s-cart:before {
  content: "\\e66e";
}

.pe-7s-camera:before {
  content: "\\e66f";
}

.pe-7s-call:before {
  content: "\\e670";
}

.pe-7s-calculator:before {
  content: "\\e671";
}

.pe-7s-browser:before {
  content: "\\e672";
}

.pe-7s-box2:before {
  content: "\\e673";
}

.pe-7s-box1:before {
  content: "\\e674";
}

.pe-7s-bookmarks:before {
  content: "\\e675";
}

.pe-7s-bicycle:before {
  content: "\\e676";
}

.pe-7s-bell:before {
  content: "\\e677";
}

.pe-7s-battery:before {
  content: "\\e678";
}

.pe-7s-ball:before {
  content: "\\e679";
}

.pe-7s-back:before {
  content: "\\e67a";
}

.pe-7s-attention:before {
  content: "\\e67b";
}

.pe-7s-anchor:before {
  content: "\\e67c";
}

.pe-7s-albums:before {
  content: "\\e67d";
}

.pe-7s-alarm:before {
  content: "\\e67e";
}

.pe-7s-airplay:before {
  content: "\\e67f";
}

.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle {
  margin-left: -6px;
  position: absolute;
}
.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle, .react-datepicker__year-read-view--down-arrow::before,
.react-datepicker__month-read-view--down-arrow::before,
.react-datepicker__month-year-read-view--down-arrow::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {
  box-sizing: content-box;
  position: absolute;
  border: 6px solid transparent;
  height: 0;
  width: 1px;
}
.react-datepicker__year-read-view--down-arrow::before,
.react-datepicker__month-read-view--down-arrow::before,
.react-datepicker__month-year-read-view--down-arrow::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {
  content: "";
  z-index: -1;
  border-width: 6px;
  left: -6px;
  border-bottom-color: #dee2e6;
}

.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle {
  top: 0;
  margin-top: -6px;
}
.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {
  border-top: none;
  border-bottom-color: #fff;
}
.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {
  top: -1px;
  border-bottom-color: #dee2e6;
}

.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle {
  bottom: 0;
  margin-bottom: -6px;
}
.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle, .react-datepicker__year-read-view--down-arrow::before,
.react-datepicker__month-read-view--down-arrow::before,
.react-datepicker__month-year-read-view--down-arrow::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before {
  border-bottom: none;
  border-top-color: #fff;
}
.react-datepicker__year-read-view--down-arrow::before,
.react-datepicker__month-read-view--down-arrow::before,
.react-datepicker__month-year-read-view--down-arrow::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before {
  bottom: -1px;
  border-top-color: #dee2e6;
}

.react-datepicker-wrapper {
  display: block;
  z-index: 10;
}

.react-datepicker {
  background-color: #fff;
  color: #495057;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  display: inline-block;
  position: relative;
  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);
}

.react-datepicker--time-only .react-datepicker__triangle {
  left: 35px;
}
.react-datepicker--time-only .react-datepicker__time-container {
  border-left: 0;
}
.react-datepicker--time-only .react-datepicker__time {
  border-radius: 0.3rem;
}
.react-datepicker--time-only .react-datepicker__time-box {
  border-radius: 0.3rem;
}

.react-datepicker__triangle {
  position: absolute;
  left: 50px;
}

.react-datepicker-popper {
  z-index: 102;
}
.react-datepicker-popper[data-placement^=bottom] {
  margin-top: 8px;
}
.react-datepicker-popper[data-placement^=top] {
  margin-bottom: 8px;
}
.react-datepicker-popper[data-placement^=right] {
  margin-left: 6px;
}
.react-datepicker-popper[data-placement^=right] .react-datepicker__triangle {
  left: auto;
  right: 42px;
}
.react-datepicker-popper[data-placement^=left] {
  margin-right: 6px;
}
.react-datepicker-popper[data-placement^=left] .react-datepicker__triangle {
  left: 42px;
  right: auto;
}

.react-datepicker__header {
  text-align: center;
  background-color: #fff;
  border-bottom: 1px solid #dee2e6;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
  padding-top: 10px;
  position: relative;
}
.react-datepicker__header--time {
  padding-bottom: 8px;
  padding-left: 5px;
  padding-right: 5px;
}

.react-datepicker__year-dropdown-container--select,
.react-datepicker__month-dropdown-container--select,
.react-datepicker__month-year-dropdown-container--select,
.react-datepicker__year-dropdown-container--scroll,
.react-datepicker__month-dropdown-container--scroll,
.react-datepicker__month-year-dropdown-container--scroll {
  display: inline-block;
  margin: 0 2px;
}

.react-datepicker__current-month,
.react-datepicker-time__header {
  margin-top: 0;
  color: #343a40;
  font-weight: bold;
  font-size: 0.968rem;
}

.react-datepicker-time__header {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.react-datepicker__navigation {
  background: none;
  line-height: 2rem;
  text-align: center;
  cursor: pointer;
  position: absolute;
  top: 15px;
  padding: 0;
  border: 0.35rem solid transparent;
  z-index: 1;
  height: 10px;
  width: 10px;
  text-indent: -999em;
  overflow: hidden;
}
.react-datepicker__navigation--previous {
  left: 10px;
  border-right-color: #ced4da;
}
.react-datepicker__navigation--previous:hover {
  border-right-color: rgb(176.9418604651, 186.5, 196.0581395349);
}
.react-datepicker__navigation--previous--disabled, .react-datepicker__navigation--previous--disabled:hover {
  border-right-color: rgb(191.4709302326, 199.25, 207.0290697674);
  cursor: default;
}
.react-datepicker__navigation--next {
  right: 10px;
  border-left-color: #ced4da;
}
.react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {
  right: 80px;
}
.react-datepicker__navigation--next:hover {
  border-left-color: rgb(176.9418604651, 186.5, 196.0581395349);
}
.react-datepicker__navigation--next--disabled, .react-datepicker__navigation--next--disabled:hover {
  border-left-color: rgb(191.4709302326, 199.25, 207.0290697674);
  cursor: default;
}
.react-datepicker__navigation--years {
  position: relative;
  top: 0;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.react-datepicker__navigation--years-previous {
  top: 4px;
  border-top-color: #ced4da;
}
.react-datepicker__navigation--years-previous:hover {
  border-top-color: rgb(176.9418604651, 186.5, 196.0581395349);
}
.react-datepicker__navigation--years-upcoming {
  top: -4px;
  border-bottom-color: #ced4da;
}
.react-datepicker__navigation--years-upcoming:hover {
  border-bottom-color: rgb(176.9418604651, 186.5, 196.0581395349);
}

.react-datepicker__month-container {
  float: left;
}

.react-datepicker__month {
  margin: 0.5rem;
  text-align: center;
}

.react-datepicker__time-container {
  float: right;
  border-left: 1px solid #dee2e6;
  width: 120px;
}
.react-datepicker__time-container--with-today-button {
  display: inline;
  border: 1px solid #aeaeae;
  border-radius: 0.3rem;
  position: absolute;
  right: -122px;
  top: 0;
}
.react-datepicker__time-container .react-datepicker__time {
  position: relative;
  background: white;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {
  width: 120px;
  overflow-x: hidden;
  margin: 0 auto;
  text-align: center;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list {
  list-style: none;
  margin: 0;
  padding: 0;
  height: calc(195px + 2rem / 2);
  overflow-y: scroll;
  width: 100%;
  box-sizing: content-box;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item {
  padding: 5px 10px;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover {
  cursor: pointer;
  background-color: #e0f3ff;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {
  background-color: theme-color("primary");
  color: #fff;
  font-weight: bold;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover {
  background-color: theme-color("primary");
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled {
  color: #ced4da;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled:hover {
  cursor: default;
  background-color: transparent;
}

.react-datepicker__week-number {
  color: #ced4da;
  display: inline-block;
  width: 2rem;
  line-height: 2rem;
  text-align: center;
  margin: 0.166rem;
}
.react-datepicker__week-number.react-datepicker__week-number--clickable {
  cursor: pointer;
}
.react-datepicker__week-number.react-datepicker__week-number--clickable:hover {
  border-radius: 0.25rem;
  background-color: #fff;
}

.react-datepicker__day-names {
  background: #f8f9fa;
  border-top: #dee2e6 solid 1px;
  margin-top: 10px;
}

.react-datepicker__day-names,
.react-datepicker__week {
  white-space: nowrap;
}

.react-datepicker__day-name,
.react-datepicker__day,
.react-datepicker__time-name {
  color: #495057;
  display: inline-block;
  width: 2rem;
  line-height: 2rem;
  text-align: center;
  margin: 0.166rem;
}

.react-datepicker__day {
  cursor: pointer;
  border-radius: 0.25rem;
}
.react-datepicker__day:hover {
  background-color: #545cd8;
  color: #fff;
}
.react-datepicker__day--today {
  font-weight: bold;
}
.react-datepicker__day--highlighted {
  border-radius: 0.25rem;
  background-color: #545cd8;
  color: #fff;
}
.react-datepicker__day--highlighted:hover {
  background-color: rgb(63.2357142857, 72.2071428571, 211.2642857143);
}
.react-datepicker__day--highlighted-custom-1 {
  color: #f7b924;
}
.react-datepicker__day--highlighted-custom-2 {
  color: #444054;
}
.react-datepicker__day--selected {
  background-color: #3ac47d;
  color: #fff;
}
.react-datepicker__day--selected:hover {
  background-color: #3ac47d;
  color: #fff;
}
.react-datepicker__day--in-selecting-range, .react-datepicker__day--in-range {
  background-color: #e0f3ff;
  color: rgb(29.7, 33.3, 36.9);
}
.react-datepicker__day--in-selecting-range:hover, .react-datepicker__day--in-range:hover {
  background-color: #e0f3ff;
  color: rgb(29.7, 33.3, 36.9);
}
.react-datepicker__day--keyboard-selected {
  border-radius: 0.25rem;
  background-color: rgb(96.811023622, 208.188976378, 150.8858267717);
  color: #fff;
}
.react-datepicker__day--keyboard-selected:hover {
  background-color: rgb(52.1771653543, 176.3228346457, 112.4507874016);
}
.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range) {
  background-color: #e0f3ff;
}
.react-datepicker__month--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range) {
  background-color: #3ac47d;
  color: #fff;
}
.react-datepicker__day--disabled {
  cursor: default;
  color: #ced4da;
}
.react-datepicker__day--disabled:hover {
  background-color: transparent;
  color: #ced4da;
}

.react-datepicker__day--selecting-range-start,
.react-datepicker__day--selecting-range-end {
  background-color: #3ac47d !important;
  color: #fff !important;
}

.react-datepicker__year-read-view,
.react-datepicker__month-read-view,
.react-datepicker__month-year-read-view {
  border: 1px solid transparent;
  border-radius: 0.25rem;
}
.react-datepicker__year-read-view:hover,
.react-datepicker__month-read-view:hover,
.react-datepicker__month-year-read-view:hover {
  cursor: pointer;
}
.react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow,
.react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view:hover .react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-year-read-view:hover .react-datepicker__month-read-view--down-arrow {
  border-top-color: rgb(176.9418604651, 186.5, 196.0581395349);
}
.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow {
  border-top-color: #ced4da;
  float: right;
  margin-left: 20px;
  top: 8px;
  position: relative;
  border-width: 0.35rem;
}

.react-datepicker__year-dropdown,
.react-datepicker__month-dropdown,
.react-datepicker__month-year-dropdown {
  background-color: #fff;
  position: absolute;
  width: 50%;
  left: 25%;
  top: 30px;
  z-index: 1;
  text-align: center;
  border-radius: 0.25rem;
  border: 1px solid #dee2e6;
}
.react-datepicker__year-dropdown:hover,
.react-datepicker__month-dropdown:hover,
.react-datepicker__month-year-dropdown:hover {
  cursor: pointer;
}
.react-datepicker__year-dropdown--scrollable,
.react-datepicker__month-dropdown--scrollable,
.react-datepicker__month-year-dropdown--scrollable {
  height: 150px;
  overflow-y: scroll;
}

.react-datepicker__year-option,
.react-datepicker__month-option,
.react-datepicker__month-year-option {
  line-height: 20px;
  width: 100%;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.react-datepicker__year-option:first-of-type,
.react-datepicker__month-option:first-of-type,
.react-datepicker__month-year-option:first-of-type {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.react-datepicker__year-option:last-of-type,
.react-datepicker__month-option:last-of-type,
.react-datepicker__month-year-option:last-of-type {
  -webkit-user-select: none;
  user-select: none;
  border-bottom-left-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.react-datepicker__year-option:hover,
.react-datepicker__month-option:hover,
.react-datepicker__month-year-option:hover {
  background-color: #ced4da;
}
.react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming,
.react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,
.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-upcoming {
  border-bottom-color: rgb(176.9418604651, 186.5, 196.0581395349);
}
.react-datepicker__year-option:hover .react-datepicker__navigation--years-previous,
.react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,
.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-previous {
  border-top-color: rgb(176.9418604651, 186.5, 196.0581395349);
}
.react-datepicker__year-option--selected,
.react-datepicker__month-option--selected,
.react-datepicker__month-year-option--selected {
  position: absolute;
  left: 15px;
}

.react-datepicker__close-icon {
  background-color: transparent;
  border: 0;
  cursor: pointer;
  outline: 0;
  padding: 0;
  vertical-align: middle;
  position: absolute;
  height: 16px;
  width: 16px;
  top: 25%;
  right: 7px;
}
.react-datepicker__close-icon::after {
  background-color: theme-color("primary");
  border-radius: 50%;
  bottom: 0;
  box-sizing: border-box;
  color: #fff;
  content: "×";
  cursor: pointer;
  font-size: 12px;
  height: 16px;
  width: 16px;
  line-height: 1;
  margin: -8px auto 0;
  padding: 2px;
  position: absolute;
  right: 0px;
  text-align: center;
}

.react-datepicker__today-button {
  background: #fff;
  border-top: 1px solid #dee2e6;
  cursor: pointer;
  text-align: center;
  font-weight: bold;
  padding: 5px 0;
  clear: left;
}

.react-datepicker__portal {
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 1040;
  background-color: rgba(0, 0, 0, 0.5);
  left: 0;
  top: 0;
  justify-content: center;
  align-items: center;
  display: flex;
}
.react-datepicker__portal .react-datepicker__day-name,
.react-datepicker__portal .react-datepicker__day,
.react-datepicker__portal .react-datepicker__time-name {
  width: 3rem;
  line-height: 3rem;
}
@media (max-width: 400px), (max-height: 550px) {
  .react-datepicker__portal .react-datepicker__day-name,
  .react-datepicker__portal .react-datepicker__day,
  .react-datepicker__portal .react-datepicker__time-name {
    width: 2rem;
    line-height: 2rem;
  }
}
.react-datepicker__portal .react-datepicker__current-month,
.react-datepicker__portal .react-datepicker-time__header {
  font-size: 1.584rem;
}
.react-datepicker__portal .react-datepicker__navigation {
  border: 0.63rem solid transparent;
  margin-top: 3px;
}
.react-datepicker__portal .react-datepicker__navigation--previous {
  border-right-color: #545cd8;
}
.react-datepicker__portal .react-datepicker__navigation--previous:hover {
  border-right-color: rgb(46.2428571429, 55.7285714286, 202.7571428571);
}
.react-datepicker__portal .react-datepicker__navigation--previous--disabled, .react-datepicker__portal .react-datepicker__navigation--previous--disabled:hover {
  border-right-color: rgb(191.4709302326, 199.25, 207.0290697674);
  cursor: default;
}
.react-datepicker__portal .react-datepicker__navigation--next {
  border-left-color: #545cd8;
}
.react-datepicker__portal .react-datepicker__navigation--next:hover {
  border-left-color: rgb(46.2428571429, 55.7285714286, 202.7571428571);
}
.react-datepicker__portal .react-datepicker__navigation--next--disabled, .react-datepicker__portal .react-datepicker__navigation--next--disabled:hover {
  border-left-color: rgb(191.4709302326, 199.25, 207.0290697674);
  cursor: default;
}

.rangeButtonSelectedStyle {
  background: #545cd8 !important;
}

.rangebuttonstyle {
  outline: none !important;
  color: #545cd8 !important;
}

.rc-slider-tooltip {
  z-index: 555;
}

.rc-tooltip.rc-tooltip-zoom-enter,
.rc-tooltip.rc-tooltip-zoom-leave {
  display: block;
}

.rc-tooltip-zoom-enter,
.rc-tooltip-zoom-appear {
  opacity: 0;
  animation-duration: 0.3s;
  animation-fill-mode: both;
  animation-timing-function: cubic-bezier(0.18, 0.89, 0.32, 1.28);
  animation-play-state: paused;
}

.rc-tooltip-zoom-leave {
  animation-duration: 0.3s;
  animation-fill-mode: both;
  animation-timing-function: cubic-bezier(0.6, -0.3, 0.74, 0.05);
  animation-play-state: paused;
}

.rc-tooltip-zoom-enter.rc-tooltip-zoom-enter-active,
.rc-tooltip-zoom-appear.rc-tooltip-zoom-appear-active {
  animation-name: rcToolTipZoomIn;
  animation-play-state: running;
}

.rc-tooltip-zoom-leave.rc-tooltip-zoom-leave-active {
  animation-name: rcToolTipZoomOut;
  animation-play-state: running;
}

@keyframes rcToolTipZoomIn {
  0% {
    opacity: 0;
    transform-origin: 50% 50%;
    transform: scale(0, 0);
  }
  100% {
    opacity: 1;
    transform-origin: 50% 50%;
    transform: scale(1, 1);
  }
}
@keyframes rcToolTipZoomOut {
  0% {
    opacity: 1;
    transform-origin: 50% 50%;
    transform: scale(1, 1);
  }
  100% {
    opacity: 0;
    transform-origin: 50% 50%;
    transform: scale(0, 0);
  }
}
.rc-tooltip {
  position: absolute;
  z-index: 1070;
  display: block;
  visibility: visible;
  font-size: 12px;
  line-height: 1.5;
  opacity: 0.9;
}

.rc-tooltip-hidden {
  display: none;
}

.rc-tooltip-placement-top,
.rc-tooltip-placement-topLeft,
.rc-tooltip-placement-topRight {
  padding: 5px 0 9px 0;
}

.rc-tooltip-placement-right,
.rc-tooltip-placement-rightTop,
.rc-tooltip-placement-rightBottom {
  padding: 0 5px 0 9px;
}

.rc-tooltip-placement-bottom,
.rc-tooltip-placement-bottomLeft,
.rc-tooltip-placement-bottomRight {
  padding: 9px 0 5px 0;
}

.rc-tooltip-placement-left,
.rc-tooltip-placement-leftTop,
.rc-tooltip-placement-leftBottom {
  padding: 0 9px 0 5px;
}

.rc-tooltip-inner {
  padding: 12px 14px;
  color: #fff;
  text-align: left;
  text-decoration: none;
  background-color: #343a40;
  border-radius: 6px;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.17);
  min-height: 34px;
  font-weight: bold;
}

.rc-tooltip-arrow {
  position: absolute;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
}

.rc-tooltip-placement-top .rc-tooltip-arrow,
.rc-tooltip-placement-topLeft .rc-tooltip-arrow,
.rc-tooltip-placement-topRight .rc-tooltip-arrow {
  bottom: 4px;
  margin-left: -5px;
  border-width: 5px 5px 0;
  border-top-color: #343a40;
}

.rc-tooltip-placement-top .rc-tooltip-arrow {
  left: 50%;
}

.rc-tooltip-placement-topLeft .rc-tooltip-arrow {
  left: 15%;
}

.rc-tooltip-placement-topRight .rc-tooltip-arrow {
  right: 15%;
}

.rc-tooltip-placement-right .rc-tooltip-arrow,
.rc-tooltip-placement-rightTop .rc-tooltip-arrow,
.rc-tooltip-placement-rightBottom .rc-tooltip-arrow {
  left: 4px;
  margin-top: -5px;
  border-width: 5px 5px 5px 0;
  border-right-color: #343a40;
}

.rc-tooltip-placement-right .rc-tooltip-arrow {
  top: 50%;
}

.rc-tooltip-placement-rightTop .rc-tooltip-arrow {
  top: 15%;
  margin-top: 0;
}

.rc-tooltip-placement-rightBottom .rc-tooltip-arrow {
  bottom: 15%;
}

.rc-tooltip-placement-left .rc-tooltip-arrow,
.rc-tooltip-placement-leftTop .rc-tooltip-arrow,
.rc-tooltip-placement-leftBottom .rc-tooltip-arrow {
  right: 4px;
  margin-top: -5px;
  border-width: 5px 0 5px 5px;
  border-left-color: #343a40;
}

.rc-tooltip-placement-left .rc-tooltip-arrow {
  top: 50%;
}

.rc-tooltip-placement-leftTop .rc-tooltip-arrow {
  top: 15%;
  margin-top: 0;
}

.rc-tooltip-placement-leftBottom .rc-tooltip-arrow {
  bottom: 15%;
}

.rc-tooltip-placement-bottom .rc-tooltip-arrow,
.rc-tooltip-placement-bottomLeft .rc-tooltip-arrow,
.rc-tooltip-placement-bottomRight .rc-tooltip-arrow {
  top: 4px;
  margin-left: -5px;
  border-width: 0 5px 5px;
  border-bottom-color: #343a40;
}

.rc-tooltip-placement-bottom .rc-tooltip-arrow {
  left: 50%;
}

.rc-tooltip-placement-bottomLeft .rc-tooltip-arrow {
  left: 15%;
}

.rc-tooltip-placement-bottomRight .rc-tooltip-arrow {
  right: 15%;
}

.rc-slider {
  position: relative;
  height: 20px;
  padding: 8px 0 0;
  width: 100%;
  border-radius: 0.25rem;
  touch-action: none;
  box-sizing: border-box;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.rc-slider-rail {
  position: absolute;
  width: 100%;
  background-color: #e9ecef;
  height: 4px;
  border-radius: 0.25rem;
}

.rc-slider-track {
  position: absolute;
  left: 0;
  height: 4px;
  border-radius: 0.25rem;
  background-color: #545cd8;
}

.rc-slider-handle {
  position: absolute;
  margin-left: -8px;
  margin-top: -6px;
  width: 16px;
  height: 16px;
  cursor: pointer;
  cursor: grab;
  border-radius: 50%;
  border: solid 2px #545cd8;
  background-color: #fff;
  touch-action: pan-x;
  transition: box-shadow 200ms;
}
.rc-slider-handle:focus {
  outline: none;
}
.rc-slider-handle:focus, .rc-slider-handle:active, .rc-slider-handle:hover {
  border-color: rgb(41.5071428571, 50.0214285714, 181.9928571429);
  box-shadow: 0 0.46875rem 2.1875rem rgba(84, 92, 216, 0.8), 0 0.125rem 0.5875rem rgba(84, 92, 216, 0.9);
}
.rc-slider-handle:active {
  cursor: grabbing;
}

.rc-slider-mark {
  position: absolute;
  top: 18px;
  left: 0;
  width: 100%;
  font-size: 12px;
}

.rc-slider-mark-text {
  position: absolute;
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  cursor: pointer;
  color: #6c757d;
}

.rc-slider-mark-text-active {
  color: #343a40;
}

.rc-slider-step {
  position: absolute;
  width: 100%;
  height: 4px;
  background: transparent;
}

.rc-slider-dot {
  position: absolute;
  bottom: -2px;
  margin-left: -4px;
  width: 8px;
  height: 8px;
  border: 2px solid #dee2e6;
  background-color: #fff;
  cursor: pointer;
  border-radius: 50%;
  vertical-align: middle;
}

.rc-slider-dot-active {
  border-color: #545cd8;
}

.rc-slider-disabled {
  background-color: #e9ecef;
}

.rc-slider-disabled .rc-slider-track {
  background-color: #ced4da;
}

.rc-slider-disabled .rc-slider-handle,
.rc-slider-disabled .rc-slider-dot {
  border-color: #ced4da;
  box-shadow: none;
  background-color: #fff;
  cursor: not-allowed;
}

.rc-slider-disabled .rc-slider-mark-text,
.rc-slider-disabled .rc-slider-dot {
  cursor: not-allowed !important;
}

.rc-slider-vertical {
  width: 14px;
  height: 100%;
  padding: 0 5px;
}

.rc-slider-vertical .rc-slider-rail {
  height: 100%;
  width: 4px;
}

.rc-slider-vertical .rc-slider-track {
  left: 5px;
  bottom: 0;
  width: 4px;
}

.rc-slider-vertical .rc-slider-handle {
  margin-left: -6px;
  margin-bottom: -7px;
  touch-action: pan-y;
}

.rc-slider-vertical .rc-slider-mark {
  top: 0;
  left: 18px;
  height: 100%;
}

.rc-slider-vertical .rc-slider-step {
  height: 100%;
  width: 4px;
}

.rc-slider-vertical .rc-slider-dot {
  left: 2px;
  margin-bottom: -4px;
}

.rc-slider-vertical .rc-slider-dot:first-child {
  margin-bottom: -4px;
}

.rc-slider-vertical .rc-slider-dot:last-child {
  margin-bottom: -4px;
}

.rc-slider-tooltip-zoom-down-enter,
.rc-slider-tooltip-zoom-down-appear {
  animation-duration: 0.3s;
  animation-fill-mode: both;
  display: block !important;
  animation-play-state: paused;
}

.rc-slider-tooltip-zoom-down-leave {
  animation-duration: 0.3s;
  animation-fill-mode: both;
  display: block !important;
  animation-play-state: paused;
}

.rc-slider-tooltip-zoom-down-enter.rc-slider-tooltip-zoom-down-enter-active,
.rc-slider-tooltip-zoom-down-appear.rc-slider-tooltip-zoom-down-appear-active {
  animation-name: rcSliderTooltipZoomDownIn;
  animation-play-state: running;
}

.rc-slider-tooltip-zoom-down-leave.rc-slider-tooltip-zoom-down-leave-active {
  animation-name: rcSliderTooltipZoomDownOut;
  animation-play-state: running;
}

.rc-slider-tooltip-zoom-down-enter,
.rc-slider-tooltip-zoom-down-appear {
  transform: scale(0, 0);
  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);
}

.rc-slider-tooltip-zoom-down-leave {
  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
}

@keyframes rcSliderTooltipZoomDownIn {
  0% {
    opacity: 0;
    transform-origin: 50% 100%;
    transform: scale(0, 0);
  }
  100% {
    transform-origin: 50% 100%;
    transform: scale(1, 1);
  }
}
@keyframes rcSliderTooltipZoomDownOut {
  0% {
    transform-origin: 50% 100%;
    transform: scale(1, 1);
  }
  100% {
    opacity: 0;
    transform-origin: 50% 100%;
    transform: scale(0, 0);
  }
}
.rc-slider-tooltip {
  position: absolute;
  left: -9999px;
  top: -9999px;
  visibility: visible;
  box-sizing: border-box;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.rc-slider-tooltip-hidden {
  display: none;
}

.rc-slider-tooltip-placement-top {
  padding: 4px 0 8px 0;
}

.rc-slider-tooltip-inner {
  padding: 0 8px;
  min-width: 28px;
  height: 28px;
  line-height: 28px;
  color: #fff;
  text-align: center;
  text-decoration: none;
  background-color: #212529;
  border-radius: 0.25rem;
  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);
  font-weight: bold;
}

.rc-slider-tooltip-arrow {
  position: absolute;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
}

.rc-slider-tooltip-placement-top .rc-slider-tooltip-arrow {
  bottom: 4px;
  left: 50%;
  margin-left: -4px;
  border-width: 4px 4px 0;
  border-top-color: #212529;
}

.rc-slider-primary .rc-slider-track {
  background-color: #545cd8;
}
.rc-slider-primary .rc-slider-handle {
  border-color: #545cd8;
  background-color: #fff;
}
.rc-slider-primary .rc-slider-handle:focus, .rc-slider-primary .rc-slider-handle:active, .rc-slider-primary .rc-slider-handle:hover {
  border-color: rgb(41.5071428571, 50.0214285714, 181.9928571429);
  box-shadow: 0 0.46875rem 2.1875rem rgba(84, 92, 216, 0.8), 0 0.125rem 0.5875rem rgba(84, 92, 216, 0.9);
}
.rc-slider-primary .rc-slider-dot-active {
  border-color: #545cd8;
}

.rc-slider-secondary .rc-slider-track {
  background-color: #6c757d;
}
.rc-slider-secondary .rc-slider-handle {
  border-color: #6c757d;
  background-color: #fff;
}
.rc-slider-secondary .rc-slider-handle:focus, .rc-slider-secondary .rc-slider-handle:active, .rc-slider-secondary .rc-slider-handle:hover {
  border-color: rgb(72.5407725322, 78.5858369099, 83.9592274678);
  box-shadow: 0 0.46875rem 2.1875rem rgba(108, 117, 125, 0.8), 0 0.125rem 0.5875rem rgba(108, 117, 125, 0.9);
}
.rc-slider-secondary .rc-slider-dot-active {
  border-color: #6c757d;
}

.rc-slider-success .rc-slider-track {
  background-color: #3ac47d;
}
.rc-slider-success .rc-slider-handle {
  border-color: #3ac47d;
  background-color: #fff;
}
.rc-slider-success .rc-slider-handle:focus, .rc-slider-success .rc-slider-handle:active, .rc-slider-success .rc-slider-handle:hover {
  border-color: rgb(40.531496063, 136.968503937, 87.3523622047);
  box-shadow: 0 0.46875rem 2.1875rem rgba(58, 196, 125, 0.8), 0 0.125rem 0.5875rem rgba(58, 196, 125, 0.9);
}
.rc-slider-success .rc-slider-dot-active {
  border-color: #3ac47d;
}

.rc-slider-info .rc-slider-track {
  background-color: #30b1ff;
}
.rc-slider-info .rc-slider-handle {
  border-color: #30b1ff;
  background-color: #fff;
}
.rc-slider-info .rc-slider-handle:focus, .rc-slider-info .rc-slider-handle:active, .rc-slider-info .rc-slider-handle:hover {
  border-color: rgb(0, 141.152173913, 226.5);
  box-shadow: 0 0.46875rem 2.1875rem rgba(48, 177, 255, 0.8), 0 0.125rem 0.5875rem rgba(48, 177, 255, 0.9);
}
.rc-slider-info .rc-slider-dot-active {
  border-color: #30b1ff;
}

.rc-slider-warning .rc-slider-track {
  background-color: #f7b924;
}
.rc-slider-warning .rc-slider-handle {
  border-color: #f7b924;
  background-color: #fff;
}
.rc-slider-warning .rc-slider-handle:focus, .rc-slider-warning .rc-slider-handle:active, .rc-slider-warning .rc-slider-handle:hover {
  border-color: rgb(199.2224669604, 142.8215859031, 7.2775330396);
  box-shadow: 0 0.46875rem 2.1875rem rgba(247, 185, 36, 0.8), 0 0.125rem 0.5875rem rgba(247, 185, 36, 0.9);
}
.rc-slider-warning .rc-slider-dot-active {
  border-color: #f7b924;
}

.rc-slider-danger .rc-slider-track {
  background-color: #d92550;
}
.rc-slider-danger .rc-slider-handle {
  border-color: #d92550;
  background-color: #fff;
}
.rc-slider-danger .rc-slider-handle:focus, .rc-slider-danger .rc-slider-handle:active, .rc-slider-danger .rc-slider-handle:hover {
  border-color: rgb(151.6437007874, 25.8562992126, 55.905511811);
  box-shadow: 0 0.46875rem 2.1875rem rgba(217, 37, 80, 0.8), 0 0.125rem 0.5875rem rgba(217, 37, 80, 0.9);
}
.rc-slider-danger .rc-slider-dot-active {
  border-color: #d92550;
}

.rc-slider-light .rc-slider-track {
  background-color: #eeeeee;
}
.rc-slider-light .rc-slider-handle {
  border-color: #eeeeee;
  background-color: #fff;
}
.rc-slider-light .rc-slider-handle:focus, .rc-slider-light .rc-slider-handle:active, .rc-slider-light .rc-slider-handle:hover {
  border-color: rgb(199.75, 199.75, 199.75);
  box-shadow: 0 0.46875rem 2.1875rem rgba(238, 238, 238, 0.8), 0 0.125rem 0.5875rem rgba(238, 238, 238, 0.9);
}
.rc-slider-light .rc-slider-dot-active {
  border-color: #eeeeee;
}

.rc-slider-dark .rc-slider-track {
  background-color: #343a40;
}
.rc-slider-dark .rc-slider-handle {
  border-color: #343a40;
  background-color: #fff;
}
.rc-slider-dark .rc-slider-handle:focus, .rc-slider-dark .rc-slider-handle:active, .rc-slider-dark .rc-slider-handle:hover {
  border-color: rgb(17.7068965517, 19.75, 21.7931034483);
  box-shadow: 0 0.46875rem 2.1875rem rgba(52, 58, 64, 0.8), 0 0.125rem 0.5875rem rgba(52, 58, 64, 0.9);
}
.rc-slider-dark .rc-slider-dot-active {
  border-color: #343a40;
}

.rc-slider-focus .rc-slider-track {
  background-color: #444054;
}
.rc-slider-focus .rc-slider-handle {
  border-color: #444054;
  background-color: #fff;
}
.rc-slider-focus .rc-slider-handle:focus, .rc-slider-focus .rc-slider-handle:active, .rc-slider-focus .rc-slider-handle:hover {
  border-color: rgb(32.8513513514, 30.9189189189, 40.5810810811);
  box-shadow: 0 0.46875rem 2.1875rem rgba(68, 64, 84, 0.8), 0 0.125rem 0.5875rem rgba(68, 64, 84, 0.9);
}
.rc-slider-focus .rc-slider-dot-active {
  border-color: #444054;
}

.rc-slider-alternate .rc-slider-track {
  background-color: #83588a;
}
.rc-slider-alternate .rc-slider-handle {
  border-color: #83588a;
  background-color: #fff;
}
.rc-slider-alternate .rc-slider-handle:focus, .rc-slider-alternate .rc-slider-handle:active, .rc-slider-alternate .rc-slider-handle:hover {
  border-color: rgb(86.657079646, 58.2123893805, 91.2876106195);
  box-shadow: 0 0.46875rem 2.1875rem rgba(131, 88, 138, 0.8), 0 0.125rem 0.5875rem rgba(131, 88, 138, 0.9);
}
.rc-slider-alternate .rc-slider-dot-active {
  border-color: #83588a;
}

.rc-slider-line .rc-slider-handle {
  border-radius: 0;
  border-width: 0 3px 0 0;
  margin-left: -8px;
  width: 10px;
  background-color: transparent;
  box-shadow: 0 0 0 transparent !important;
}

.rc-slider-square .rc-slider-handle {
  border-radius: 3px;
  border-widtH: 1px;
}
.rc-slider-square .rc-slider-handle:before {
  position: absolute;
  height: 8px;
  width: 4px;
  border: #adb5bd solid 1px;
  border-width: 0 1px;
  display: block;
  content: "";
  top: 50%;
  left: 50%;
  margin: -4px -2px;
}

.rc-slider-lg.rc-slider {
  height: 20px;
  padding: 8px 0 0;
}
.rc-slider-lg .rc-slider-rail {
  height: 4px;
}
.rc-slider-lg .rc-slider-track {
  height: 4px;
}
.rc-slider-lg .rc-slider-handle {
  margin-left: -10px;
  margin-top: -8px;
  width: 20px;
  height: 20px;
}
.rc-slider-lg.rc-slider-line .rc-slider-handle {
  margin-left: -8px;
  width: 10px;
}
.rc-slider-lg.rc-slider-square .rc-slider-handle:before {
  height: 10px;
  width: 6px;
  margin: -5px -3px;
}

.rc-slider-sm.rc-slider {
  height: 20px;
  padding: 8px 0 0;
}
.rc-slider-sm .rc-slider-rail {
  height: 4px;
}
.rc-slider-sm .rc-slider-track {
  height: 4px;
}
.rc-slider-sm .rc-slider-handle {
  margin-left: -6px;
  margin-top: -4px;
  width: 12px;
  height: 12px;
}
.rc-slider-sm.rc-slider-line .rc-slider-handle {
  margin-left: -8px;
  width: 10px;
}
.rc-slider-sm.rc-slider-square .rc-slider-handle:before {
  height: 6px;
  margin: -3px 0 0 -1px;
  border: 0;
  width: 2px;
  background: #adb5bd;
}

.rdw-option-wrapper {
  border: 1px solid #F1F1F1;
  padding: 5px;
  min-width: 25px;
  height: 20px;
  border-radius: 2px;
  margin: 0 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background: white;
  text-transform: capitalize;
}

.rdw-option-wrapper:hover {
  box-shadow: 1px 1px 0px #BFBDBD;
}

.rdw-option-wrapper:active {
  box-shadow: 1px 1px 0px #BFBDBD inset;
}

.rdw-option-active {
  box-shadow: 1px 1px 0px #BFBDBD inset;
}

.rdw-option-disabled {
  opacity: 0.3;
  cursor: default;
}

.rdw-dropdown-wrapper {
  height: 30px;
  background: white;
  cursor: pointer;
  border: 1px solid #F1F1F1;
  border-radius: 2px;
  margin: 0 3px;
  text-transform: capitalize;
  background: white;
}

.rdw-dropdown-wrapper:focus {
  outline: none;
}

.rdw-dropdown-wrapper:hover {
  box-shadow: 1px 1px 0px #BFBDBD;
  background-color: #FFFFFF;
}

.rdw-dropdown-wrapper:active {
  box-shadow: 1px 1px 0px #BFBDBD inset;
}

.rdw-dropdown-carettoopen {
  height: 0px;
  width: 0px;
  position: absolute;
  top: 35%;
  right: 10%;
  border-top: 6px solid black;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
}

.rdw-dropdown-carettoclose {
  height: 0px;
  width: 0px;
  position: absolute;
  top: 35%;
  right: 10%;
  border-bottom: 6px solid black;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
}

.rdw-dropdown-selectedtext {
  display: flex;
  position: relative;
  height: 100%;
  align-items: center;
  padding: 0 5px;
}

.rdw-dropdown-optionwrapper {
  z-index: 100;
  position: relative;
  border: 1px solid #F1F1F1;
  width: 98%;
  background: white;
  border-radius: 2px;
  margin: 0;
  padding: 0;
  max-height: 250px;
  overflow-y: scroll;
}

.rdw-dropdown-optionwrapper:hover {
  box-shadow: 1px 1px 0px #BFBDBD;
  background-color: #FFFFFF;
}

.rdw-dropdownoption-default {
  min-height: 25px;
  display: flex;
  align-items: center;
  padding: 0 5px;
}

.rdw-dropdownoption-highlighted {
  background: #F1F1F1;
}

.rdw-dropdownoption-active {
  background: #f5f5f5;
}

.rdw-dropdownoption-disabled {
  opacity: 0.3;
  cursor: default;
}

.rdw-inline-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.rdw-inline-dropdown {
  width: 50px;
}

.rdw-inline-dropdownoption {
  height: 40px;
  display: flex;
  justify-content: center;
}

.rdw-block-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.rdw-block-dropdown {
  width: 110px;
}

.rdw-fontsize-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.rdw-fontsize-dropdown {
  min-width: 40px;
}

.rdw-fontsize-option {
  display: flex;
  justify-content: center;
}

.rdw-fontfamily-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.rdw-fontfamily-dropdown {
  width: 115px;
}

.rdw-fontfamily-placeholder {
  white-space: nowrap;
  max-width: 90px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.rdw-fontfamily-optionwrapper {
  width: 140px;
}

.rdw-list-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.rdw-list-dropdown {
  width: 50px;
  z-index: 90;
}

.rdw-list-dropdownOption {
  height: 40px;
  display: flex;
  justify-content: center;
}

.rdw-text-align-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.rdw-text-align-dropdown {
  width: 50px;
  z-index: 90;
}

.rdw-text-align-dropdownOption {
  height: 40px;
  display: flex;
  justify-content: center;
}

.rdw-right-aligned-block {
  text-align: right;
}

.rdw-left-aligned-block {
  text-align: left !important;
}

.rdw-center-aligned-block {
  text-align: center !important;
}

.rdw-justify-aligned-block {
  text-align: justify !important;
}

.rdw-right-aligned-block > div {
  display: inline-block;
}

.rdw-left-aligned-block > div {
  display: inline-block;
}

.rdw-center-aligned-block > div {
  display: inline-block;
}

.rdw-justify-aligned-block > div {
  display: inline-block;
}

.rdw-colorpicker-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  position: relative;
}

.rdw-colorpicker-modal {
  position: absolute;
  top: 35px;
  left: 5px;
  display: flex;
  flex-direction: column;
  width: 175px;
  height: 175px;
  border: 1px solid #F1F1F1;
  padding: 15px;
  border-radius: 2px;
  z-index: 100;
  background: white;
  box-shadow: 3px 3px 5px #BFBDBD;
}

.rdw-colorpicker-modal-header {
  display: flex;
  padding-bottom: 5px;
}

.rdw-colorpicker-modal-style-label {
  font-size: 15px;
  width: 50%;
  text-align: center;
  cursor: pointer;
  padding: 0 10px 5px;
}

.rdw-colorpicker-modal-style-label-active {
  border-bottom: 2px solid #0a66b7;
}

.rdw-colorpicker-modal-options {
  margin: 5px auto;
  display: flex;
  width: 100%;
  height: 100%;
  flex-wrap: wrap;
  overflow: scroll;
}

.rdw-colorpicker-cube {
  width: 22px;
  height: 22px;
  border: 1px solid #F1F1F1;
}

.rdw-colorpicker-option {
  margin: 3px;
  padding: 0;
  min-height: 20px;
  border: none;
  width: 22px;
  height: 22px;
  min-width: 22px;
  box-shadow: 1px 2px 1px #BFBDBD inset;
}

.rdw-colorpicker-option:hover {
  box-shadow: 1px 2px 1px #BFBDBD;
}

.rdw-colorpicker-option:active {
  box-shadow: -1px -2px 1px #BFBDBD;
}

.rdw-colorpicker-option-active {
  box-shadow: 0px 0px 2px 2px #BFBDBD;
}

.rdw-link-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  position: relative;
}

.rdw-link-dropdown {
  width: 50px;
}

.rdw-link-dropdownOption {
  height: 40px;
  display: flex;
  justify-content: center;
}

.rdw-link-dropdownPlaceholder {
  margin-left: 8px;
}

.rdw-link-modal {
  position: absolute;
  top: 35px;
  left: 5px;
  display: flex;
  flex-direction: column;
  width: 235px;
  height: 205px;
  border: 1px solid #F1F1F1;
  padding: 15px;
  border-radius: 2px;
  z-index: 100;
  background: white;
  box-shadow: 3px 3px 5px #BFBDBD;
}

.rdw-link-modal-label {
  font-size: 15px;
}

.rdw-link-modal-input {
  margin-top: 5px;
  border-radius: 2px;
  border: 1px solid #F1F1F1;
  height: 25px;
  margin-bottom: 15px;
  padding: 0 5px;
}

.rdw-link-modal-input:focus {
  outline: none;
}

.rdw-link-modal-buttonsection {
  margin: 0 auto;
}

.rdw-link-modal-target-option {
  margin-bottom: 20px;
}

.rdw-link-modal-target-option > span {
  margin-left: 5px;
}

.rdw-link-modal-btn {
  margin-left: 10px;
  width: 75px;
  height: 30px;
  border: 1px solid #F1F1F1;
  border-radius: 2px;
  cursor: pointer;
  background: white;
  text-transform: capitalize;
}

.rdw-link-modal-btn:hover {
  box-shadow: 1px 1px 0px #BFBDBD;
}

.rdw-link-modal-btn:active {
  box-shadow: 1px 1px 0px #BFBDBD inset;
}

.rdw-link-modal-btn:focus {
  outline: none !important;
}

.rdw-link-modal-btn:disabled {
  background: #ece9e9;
}

.rdw-link-dropdownoption {
  height: 40px;
  display: flex;
  justify-content: center;
}

.rdw-history-dropdown {
  width: 50px;
}

.rdw-embedded-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  position: relative;
}

.rdw-embedded-modal {
  position: absolute;
  top: 35px;
  left: 5px;
  display: flex;
  flex-direction: column;
  width: 235px;
  height: 180px;
  border: 1px solid #F1F1F1;
  padding: 15px;
  border-radius: 2px;
  z-index: 100;
  background: white;
  justify-content: space-between;
  box-shadow: 3px 3px 5px #BFBDBD;
}

.rdw-embedded-modal-header {
  font-size: 15px;
  display: flex;
}

.rdw-embedded-modal-header-option {
  width: 50%;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.rdw-embedded-modal-header-label {
  width: 95px;
  border: 1px solid #f1f1f1;
  margin-top: 5px;
  background: #6EB8D4;
  border-bottom: 2px solid #0a66b7;
}

.rdw-embedded-modal-link-section {
  display: flex;
  flex-direction: column;
}

.rdw-embedded-modal-link-input {
  width: 88%;
  height: 35px;
  margin: 10px 0;
  border: 1px solid #F1F1F1;
  border-radius: 2px;
  font-size: 15px;
  padding: 0 5px;
}

.rdw-embedded-modal-link-input-wrapper {
  display: flex;
  align-items: center;
}

.rdw-embedded-modal-link-input:focus {
  outline: none;
}

.rdw-embedded-modal-btn-section {
  display: flex;
  justify-content: center;
}

.rdw-embedded-modal-btn {
  margin: 0 3px;
  width: 75px;
  height: 30px;
  border: 1px solid #F1F1F1;
  border-radius: 2px;
  cursor: pointer;
  background: white;
  text-transform: capitalize;
}

.rdw-embedded-modal-btn:hover {
  box-shadow: 1px 1px 0px #BFBDBD;
}

.rdw-embedded-modal-btn:active {
  box-shadow: 1px 1px 0px #BFBDBD inset;
}

.rdw-embedded-modal-btn:focus {
  outline: none !important;
}

.rdw-embedded-modal-btn:disabled {
  background: #ece9e9;
}

.rdw-embedded-modal-size {
  align-items: center;
  display: flex;
  margin: 8px 0;
  justify-content: space-between;
}

.rdw-embedded-modal-size-input {
  width: 80%;
  height: 20px;
  border: 1px solid #F1F1F1;
  border-radius: 2px;
  font-size: 12px;
}

.rdw-embedded-modal-size-input:focus {
  outline: none;
}

.rdw-emoji-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  position: relative;
}

.rdw-emoji-modal {
  overflow: auto;
  position: absolute;
  top: 35px;
  left: 5px;
  display: flex;
  flex-wrap: wrap;
  width: 235px;
  height: 180px;
  border: 1px solid #F1F1F1;
  padding: 15px;
  border-radius: 2px;
  z-index: 100;
  background: white;
  box-shadow: 3px 3px 5px #BFBDBD;
}

.rdw-emoji-icon {
  margin: 2.5px;
  height: 24px;
  width: 24px;
  cursor: pointer;
  font-size: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.rdw-spinner {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}

.rdw-spinner > div {
  width: 12px;
  height: 12px;
  background-color: #333;
  border-radius: 100%;
  display: inline-block;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}

.rdw-spinner .rdw-bounce1 {
  animation-delay: -0.32s;
}

.rdw-spinner .rdw-bounce2 {
  animation-delay: -0.16s;
}
@keyframes sk-bouncedelay {
  0%, 80%, 100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}
.rdw-image-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  position: relative;
}

.rdw-image-modal {
  position: absolute;
  top: 35px;
  left: 5px;
  display: flex;
  flex-direction: column;
  width: 235px;
  border: 1px solid #F1F1F1;
  padding: 15px;
  border-radius: 2px;
  z-index: 100;
  background: white;
  box-shadow: 3px 3px 5px #BFBDBD;
}

.rdw-image-modal-header {
  font-size: 15px;
  margin: 10px 0;
  display: flex;
}

.rdw-image-modal-header-option {
  width: 50%;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.rdw-image-modal-header-label {
  width: 80px;
  background: #f1f1f1;
  border: 1px solid #f1f1f1;
  margin-top: 5px;
}

.rdw-image-modal-header-label-highlighted {
  background: #6EB8D4;
  border-bottom: 2px solid #0a66b7;
}

.rdw-image-modal-upload-option {
  width: 100%;
  color: gray;
  cursor: pointer;
  display: flex;
  border: none;
  font-size: 15px;
  align-items: center;
  justify-content: center;
  background-color: #f1f1f1;
  outline: 2px dashed gray;
  outline-offset: -10px;
  margin: 10px 0;
  padding: 9px 0;
}

.rdw-image-modal-upload-option-highlighted {
  outline: 2px dashed #0a66b7;
}

.rdw-image-modal-upload-option-label {
  cursor: pointer;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px;
}

.rdw-image-modal-upload-option-label span {
  padding: 0 20px;
}

.rdw-image-modal-upload-option-image-preview {
  max-width: 100%;
  max-height: 200px;
}

.rdw-image-modal-upload-option-input {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}

.rdw-image-modal-url-section {
  display: flex;
  align-items: center;
}

.rdw-image-modal-url-input {
  width: 90%;
  height: 35px;
  margin: 15px 0 12px;
  border: 1px solid #F1F1F1;
  border-radius: 2px;
  font-size: 15px;
  padding: 0 5px;
}

.rdw-image-modal-btn-section {
  margin: 10px auto 0;
}

.rdw-image-modal-url-input:focus {
  outline: none;
}

.rdw-image-modal-btn {
  margin: 0 5px;
  width: 75px;
  height: 30px;
  border: 1px solid #F1F1F1;
  border-radius: 2px;
  cursor: pointer;
  background: white;
  text-transform: capitalize;
}

.rdw-image-modal-btn:hover {
  box-shadow: 1px 1px 0px #BFBDBD;
}

.rdw-image-modal-btn:active {
  box-shadow: 1px 1px 0px #BFBDBD inset;
}

.rdw-image-modal-btn:focus {
  outline: none !important;
}

.rdw-image-modal-btn:disabled {
  background: #ece9e9;
}

.rdw-image-modal-spinner {
  position: absolute;
  top: -3px;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.5;
}

.rdw-image-modal-alt-input {
  width: 70%;
  height: 20px;
  border: 1px solid #F1F1F1;
  border-radius: 2px;
  font-size: 12px;
  margin-left: 5px;
}

.rdw-image-modal-alt-input:focus {
  outline: none;
}

.rdw-image-modal-alt-lbl {
  font-size: 12px;
}

.rdw-image-modal-size {
  align-items: center;
  display: flex;
  margin: 8px 0;
  justify-content: space-between;
}

.rdw-image-modal-size-input {
  width: 40%;
  height: 20px;
  border: 1px solid #F1F1F1;
  border-radius: 2px;
  font-size: 12px;
}

.rdw-image-modal-size-input:focus {
  outline: none;
}

.rdw-image-mandatory-sign {
  color: red;
  margin-left: 3px;
  margin-right: 3px;
}

.rdw-remove-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  position: relative;
}

.rdw-history-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.rdw-history-dropdownoption {
  height: 40px;
  display: flex;
  justify-content: center;
}

.rdw-history-dropdown {
  width: 50px;
}

.rdw-link-decorator-wrapper {
  position: relative;
}

.rdw-link-decorator-icon {
  position: absolute;
  left: 40%;
  top: 0;
  cursor: pointer;
  background-color: white;
}

.rdw-mention-link {
  text-decoration: none;
  color: #1236ff;
  background-color: #f0fbff;
  padding: 1px 2px;
  border-radius: 2px;
}

.rdw-suggestion-wrapper {
  position: relative;
}

.rdw-suggestion-dropdown {
  position: absolute;
  display: flex;
  flex-direction: column;
  border: 1px solid #F1F1F1;
  min-width: 100px;
  max-height: 150px;
  overflow: auto;
  background: white;
  z-index: 100;
}

.rdw-suggestion-option {
  padding: 7px 5px;
  border-bottom: 1px solid #f1f1f1;
}

.rdw-suggestion-option-active {
  background-color: #F1F1F1;
}

.rdw-hashtag-link {
  text-decoration: none;
  color: #1236ff;
  background-color: #f0fbff;
  padding: 1px 2px;
  border-radius: 2px;
}

.rdw-image-alignment-options-popup {
  position: absolute;
  background: white;
  display: flex;
  padding: 5px 2px;
  border-radius: 2px;
  border: 1px solid #F1F1F1;
  width: 105px;
  cursor: pointer;
  z-index: 100;
}

.rdw-alignment-option-left {
  justify-content: flex-start;
}

.rdw-image-alignment-option {
  height: 15px;
  width: 15px;
  min-width: 15px;
}

.rdw-image-alignment {
  position: relative;
}

.rdw-image-imagewrapper {
  position: relative;
}

.rdw-image-center {
  display: flex;
  justify-content: center;
}

.rdw-image-left {
  display: flex;
}

.rdw-image-right {
  display: flex;
  justify-content: flex-end;
}

.rdw-image-alignment-options-popup-right {
  right: 0;
}

.rdw-editor-main {
  height: 100%;
  overflow: auto;
  box-sizing: border-box;
}

.rdw-editor-toolbar {
  padding: 6px 5px 0;
  border-radius: 2px;
  border: 1px solid #F1F1F1;
  display: flex;
  justify-content: flex-start;
  background: white;
  flex-wrap: wrap;
  font-size: 15px;
  margin-bottom: 5px;
  -webkit-user-select: none;
          user-select: none;
}

.public-DraftStyleDefault-block {
  margin: 1em 0;
}

.rdw-editor-wrapper:focus {
  outline: none;
}

.rdw-editor-wrapper {
  box-sizing: content-box;
}

.rdw-editor-main blockquote {
  border-left: 5px solid #f1f1f1;
  padding-left: 5px;
}

.rdw-editor-main pre {
  background: #f1f1f1;
  border-radius: 3px;
  padding: 1px 10px;
} /**
* Draft v0.9.1
*
* Copyright (c) 2013-present, Facebook, Inc.
* All rights reserved.
*
* This source code is licensed under the BSD-style license found in the
* LICENSE file in the root directory of this source tree. An additional grant
* of patent rights can be found in the PATENTS file in the same directory.
*/
.DraftEditor-editorContainer, .DraftEditor-root, .public-DraftEditor-content {
  height: inherit;
  text-align: left;
  text-align: initial;
}

.public-DraftEditor-content[contenteditable=true] {
  -webkit-user-modify: read-write-plaintext-only;
}

.DraftEditor-root {
  position: relative;
}

.DraftEditor-editorContainer {
  background-color: rgba(255, 255, 255, 0);
  border-left: 0.1px solid transparent;
  position: relative;
  z-index: 1;
}

.public-DraftEditor-block {
  position: relative;
}

.DraftEditor-alignLeft .public-DraftStyleDefault-block {
  text-align: left;
}

.DraftEditor-alignLeft .public-DraftEditorPlaceholder-root {
  left: 0;
  text-align: left;
}

.DraftEditor-alignCenter .public-DraftStyleDefault-block {
  text-align: center;
}

.DraftEditor-alignCenter .public-DraftEditorPlaceholder-root {
  margin: 0 auto;
  text-align: center;
  width: 100%;
}

.DraftEditor-alignRight .public-DraftStyleDefault-block {
  text-align: right;
}

.DraftEditor-alignRight .public-DraftEditorPlaceholder-root {
  right: 0;
  text-align: right;
}

.public-DraftEditorPlaceholder-root {
  color: #9197a3;
  position: absolute;
  z-index: 0;
}

.public-DraftEditorPlaceholder-hasFocus {
  color: #bdc1c9;
}

.DraftEditorPlaceholder-hidden {
  display: none;
}

.public-DraftStyleDefault-block {
  position: relative;
  white-space: pre-wrap;
}

.public-DraftStyleDefault-ltr {
  direction: ltr;
  text-align: left;
}

.public-DraftStyleDefault-rtl {
  direction: rtl;
  text-align: right;
}

.public-DraftStyleDefault-listLTR {
  direction: ltr;
}

.public-DraftStyleDefault-listRTL {
  direction: rtl;
}

.public-DraftStyleDefault-ol, .public-DraftStyleDefault-ul {
  margin: 16px 0;
  padding: 0;
}

.public-DraftStyleDefault-depth0.public-DraftStyleDefault-listLTR {
  margin-left: 1.5em;
}

.public-DraftStyleDefault-depth0.public-DraftStyleDefault-listRTL {
  margin-right: 1.5em;
}

.public-DraftStyleDefault-depth1.public-DraftStyleDefault-listLTR {
  margin-left: 3em;
}

.public-DraftStyleDefault-depth1.public-DraftStyleDefault-listRTL {
  margin-right: 3em;
}

.public-DraftStyleDefault-depth2.public-DraftStyleDefault-listLTR {
  margin-left: 4.5em;
}

.public-DraftStyleDefault-depth2.public-DraftStyleDefault-listRTL {
  margin-right: 4.5em;
}

.public-DraftStyleDefault-depth3.public-DraftStyleDefault-listLTR {
  margin-left: 6em;
}

.public-DraftStyleDefault-depth3.public-DraftStyleDefault-listRTL {
  margin-right: 6em;
}

.public-DraftStyleDefault-depth4.public-DraftStyleDefault-listLTR {
  margin-left: 7.5em;
}

.public-DraftStyleDefault-depth4.public-DraftStyleDefault-listRTL {
  margin-right: 7.5em;
}

.public-DraftStyleDefault-unorderedListItem {
  list-style-type: square;
  position: relative;
}

.public-DraftStyleDefault-unorderedListItem.public-DraftStyleDefault-depth0 {
  list-style-type: disc;
}

.public-DraftStyleDefault-unorderedListItem.public-DraftStyleDefault-depth1 {
  list-style-type: circle;
}

.public-DraftStyleDefault-orderedListItem {
  list-style-type: none;
  position: relative;
}

.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-listLTR:before {
  left: -36px;
  position: absolute;
  text-align: right;
  width: 30px;
}

.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-listRTL:before {
  position: absolute;
  right: -36px;
  text-align: left;
  width: 30px;
}

.public-DraftStyleDefault-orderedListItem:before {
  content: counter(ol0) ". ";
  counter-increment: ol0;
}

.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth1:before {
  content: counter(ol1) ". ";
  counter-increment: ol1;
}

.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth2:before {
  content: counter(ol2) ". ";
  counter-increment: ol2;
}

.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth3:before {
  content: counter(ol3) ". ";
  counter-increment: ol3;
}

.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth4:before {
  content: counter(ol4) ". ";
  counter-increment: ol4;
}

.public-DraftStyleDefault-depth0.public-DraftStyleDefault-reset {
  counter-reset: ol0;
}

.public-DraftStyleDefault-depth1.public-DraftStyleDefault-reset {
  counter-reset: ol1;
}

.public-DraftStyleDefault-depth2.public-DraftStyleDefault-reset {
  counter-reset: ol2;
}

.public-DraftStyleDefault-depth3.public-DraftStyleDefault-reset {
  counter-reset: ol3;
}

.public-DraftStyleDefault-depth4.public-DraftStyleDefault-reset {
  counter-reset: ol4;
}

.demo-editor {
  height: 275px !important;
  border: 1px solid #F1F1F1 !important;
  padding: 5px !important;
  border-radius: 2px !important;
}

.has-switch {
  border-radius: 30px;
  cursor: pointer;
  display: inline-block;
  line-height: 1.72222;
  overflow: hidden;
  position: relative;
  text-align: left;
  width: 60px;
  -webkit-user-select: none;
          user-select: none;
}

.has-switch.deactivate {
  opacity: 0.5;
  filter: alpha(opacity=50);
  cursor: default !important;
}

.has-switch.deactivate label,
.has-switch.deactivate span {
  cursor: default !important;
}

.has-switch > div {
  position: relative;
  top: 0;
  width: 100px;
}

.has-switch > div.switch-animate {
  transition: left 0.25s ease-out;
}

.has-switch > div.switch-off {
  left: -35px;
}

.has-switch > div.switch-on {
  left: 0;
}

.has-switch > div label {
  background-color: #FFFFFF;
  background: rgb(255, 255, 255);
  background: linear-gradient(to bottom, rgb(255, 255, 255) 0%, rgb(241, 241, 242) 100%);
  background-size: 150% 150%;
  box-shadow: 0 1px 1px #FFFFFF inset, 0 1px 1px rgba(0, 0, 0, 0.25);
  cursor: pointer;
}

.has-switch input[type=checkbox] {
  display: none;
}

.has-switch span {
  cursor: pointer;
  float: left;
  font-size: 11px;
  font-weight: 400;
  height: 24px;
  line-height: 15px;
  margin: 0;
  padding-bottom: 6px;
  padding-top: 5px;
  position: relative;
  text-align: center;
  text-indent: -10px;
  width: 50%;
  z-index: 1;
  transition: 0.25s ease-out;
}

.has-switch span.switch-left {
  background-color: #545cd8;
  border-left: 1px solid rgba(0, 0, 0, 0);
  border-radius: 30px 0 0 30px;
  color: #FFFFFF;
}

.has-switch .switch-off span.switch-left {
  background-color: #ced4da !important;
}

.has-switch span.switch-right {
  border-radius: 0 30px 30px 0;
  background-color: #545cd8;
  color: #ffffff;
  text-indent: 1px;
}

.has-switch .switch-off span.switch-right {
  background-color: #ced4da !important;
}

.has-switch label {
  border-radius: 12px;
  float: left;
  height: 22px;
  margin: 1px -13px;
  padding: 0;
  position: relative;
  vertical-align: middle;
  width: 22px;
  z-index: 10;
  transition: 0.25s ease-out;
}

.has-switch .switch-on .fa-check:before {
  margin-left: 10px;
}

.has-switch:hover .switch-on label {
  margin: 1px -17px;
  width: 26px;
}

.has-switch:hover .switch-off label {
  margin: 1px -13px;
  width: 26px;
}

.has-switch-sm.has-switch span {
  height: 18px;
  line-height: 18px;
  padding: 0;
}
.has-switch-sm.has-switch label {
  height: 16px;
  width: 16px;
  margin: 1px -8px;
}
.has-switch-sm.has-switch .switch-off label {
  margin: 1px -13px;
}
.has-switch-sm.has-switch:hover .switch-on label {
  margin: 1px -11px;
  width: 20px;
}
.has-switch-sm.has-switch:hover .switch-off label {
  margin: 1px -13px;
  width: 20px;
}

.dropzone-wrapper {
  width: 100%;
  border: #ced4da dashed 2px;
  border-radius: 0.3rem;
  display: flex;
  align-items: center;
  align-content: center;
  text-align: center;
  height: 230px;
  transition: all 0.2s;
}
.dropzone-wrapper:hover {
  border-color: #545cd8;
}
.dropzone-wrapper > div {
  width: 100%;
  height: 100%;
  outline: none !important;
  display: flex;
  align-items: center;
}
.dropzone-wrapper.dropzone-wrapper-lg {
  height: 300px;
}
.dropzone-wrapper.dropzone-wrapper-sm {
  height: 150px;
}
.dropzone-wrapper input {
  width: 100%;
  height: 100%;
}
.dropzone-wrapper .dropzone-content {
  margin: 0 auto;
  color: #6c757d;
}
.dropzone-wrapper[aria-disabled=true] {
  border-color: #dee2e6;
}
.dropzone-wrapper[aria-disabled=true] .dropzone-content {
  color: #ced4da;
}

.rbt {
  outline: none;
}
.rbt-menu {
  margin-bottom: 2px;
}
.rbt-menu > li a {
  overflow: hidden;
  text-overflow: ellipsis;
}
.rbt-menu > li a:focus {
  outline: none;
}
.rbt-menu-pagination-option {
  text-align: center;
}
.rbt .rbt-input-main::-ms-clear {
  display: none;
}
.rbt-input-multi {
  cursor: text;
  overflow: hidden;
  position: relative;
}
.rbt-input-multi.form-control[disabled] {
  background-color: #e9ecef;
  opacity: 1;
}
.rbt-input-multi input::-moz-placeholder {
  color: #6c757d;
  opacity: 1;
}
.rbt-input-multi input:-ms-input-placeholder {
  color: #6c757d;
}
.rbt-input-multi input::-webkit-input-placeholder {
  color: #6c757d;
}
.rbt-input-multi .rbt-input-wrapper {
  margin-top: 2px;
  overflow: hidden;
}
.rbt-input-multi .rbt-input-main {
  height: auto;
}
.rbt-input-multi .rbt-input-hint-container {
  display: inline-block;
}
.rbt-input-multi.input-lg .rbt-input-main, .rbt-input-multi.form-control-lg .rbt-input-main {
  height: auto;
}
.rbt-input-multi.input-sm .rbt-input-main, .rbt-input-multi.form-control-sm .rbt-input-main {
  height: auto;
}
.rbt-close {
  z-index: 1;
}
.rbt-close-lg {
  font-size: 24px;
}
.rbt-token {
  background-color: #e0f3ff;
  border: 0;
  border-radius: 0.25rem;
  color: #545cd8;
  display: inline-block;
  line-height: 1em;
  margin: 0 3px 3px 0;
  padding: 4px 7px;
  position: relative;
}
.rbt-token-disabled {
  background-color: #f8f9fa;
  color: #adb5bd;
  pointer-events: none;
}
.rbt-token-removeable {
  cursor: pointer;
  padding-right: 21px;
}
.rbt-token-active {
  background-color: #545cd8;
  color: #fff;
  outline: none;
  text-decoration: none;
}
.rbt-token .rbt-token-remove-button {
  bottom: 0;
  color: #495057;
  font-size: inherit;
  font-weight: normal;
  opacity: 1;
  outline: none;
  padding: 3px 7px;
  position: absolute;
  right: 0;
  text-shadow: none;
  top: -1px;
}
.rbt-loader {
  animation: loader-animation 600ms infinite linear;
  border: 1px solid #e0f3ff;
  border-radius: 50%;
  border-top-color: rgb(173, 223.2580645161, 255);
  display: block;
  height: 16px;
  width: 16px;
}
.rbt-loader-lg {
  height: 20px;
  width: 20px;
}
.rbt-aux {
  display: flex;
  align-items: center;
  bottom: 0;
  justify-content: center;
  pointer-events: none; /* Don't block clicks on the input */
  position: absolute;
  right: 0;
  top: 0;
  width: 34px;
}
.rbt-aux-lg {
  width: 46px;
}
.rbt-aux .rbt-close {
  margin-top: -1px;
  pointer-events: auto; /* Override pointer-events: none; above */
  background-color: transparent;
  border: none;
}
.has-aux .rbt-input {
  padding-right: 34px;
}
.rbt-highlight-text {
  background-color: inherit;
  color: inherit;
  font-weight: bold;
  padding: 0;
}

/* Input Groups */
.input-group > .rbt {
  flex: 1 1;
}
.input-group > .rbt .rbt-input-hint-container {
  display: flex;
}
.input-group > .rbt .rbt-input-hint {
  z-index: 5;
}
.input-group > .rbt .rbt-aux {
  z-index: 5;
}
.input-group > .rbt:not(:first-child) .form-control {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .rbt:not(:last-child) .form-control {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

@keyframes loader-animation {
  to {
    transform: rotate(1turn);
  }
}
.input-group > .rbt .rbt-input-hint-container {
  flex: 1 1;
  height: 100%;
}

.rbt-token-remove-button {
  background-color: transparent;
  border: none;
}

/* for debugging */
@keyframes react-widgets-autofill-start {
  from {
    /**/
  }
  to {
    /**/
  }
}
@keyframes react-widgets-autofill-cancel {
  from {
    /**/
  }
  to {
    /**/
  }
}
.rw-btn {
  padding: 0;
  margin: 0;
  border: none;
  color: inherit;
  box-shadow: none;
  background: none;
  font: inherit;
  line-height: inherit;
  touch-action: manipulation;
  outline: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-clip: padding-box;
  cursor: pointer;
}

.rw-btn:focus {
  outline: none;
}

.rw-btn:disabled, fieldset[disabled] .rw-btn, .rw-state-disabled .rw-btn, .rw-state-readonly .rw-btn {
  cursor: inherit;
}

fieldset[disabled] .rw-btn {
  pointer-events: none;
}

.rw-picker-caret,
.rw-picker-btn {
  color: #212529;
}

.rw-picker-btn:hover {
  background-color: #e9ecef;
}

.rw-picker-btn:active {
  background-color: #dee2e6;
}

.rw-picker-btn:disabled, fieldset[disabled] .rw-picker-btn {
  background-color: #e9ecef;
}

.rw-input-addon, .rw-input-addon.rw-picker-btn {
  border-left: #ced4da 1px solid;
}

[dir=rtl] .rw-input-addon, [dir=rtl] .rw-input-addon.rw-picker-btn {
  border-right: #ced4da 1px solid;
  border-left: none;
}

.rw-sr {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.rw-widget {
  border: none;
  color: #212529;
  font-size: 1em;
  font-family: inherit;
  outline: none;
  position: relative;
}

.rw-widget, .rw-widget *, .rw-widget:after, .rw-widget:before, .rw-widget *:after, .rw-widget *:before {
  box-sizing: border-box;
}

.rw-state-readonly,
.rw-state-disabled,
fieldset[disabled] .rw-widget {
  cursor: not-allowed;
}

.rw-widget-picker {
  display: grid;
  overflow: hidden;
  min-height: calc(1.5em + (0.75rem + 2px));
  background-color: #fff;
  border: #ced4da 1px solid;
  border-radius: 0.25rem;
  outline: none;
  grid-template: 1fr/1fr 1.9em;
  width: 100%;
}

.rw-widget-picker.rw-hide-caret {
  grid-template-columns: 1fr;
}

.rw-state-focus .rw-widget-picker {
  color: #495057;
  background-color: #fff;
  border-color: rgb(187.8214285714, 190.9642857143, 239.6785714286);
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);
  transition: box-shadow 0.15s ease-in-out;
}

.rw-state-focus .rw-widget-picker.rw-widget-input {
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25), inset 0 1px 2px rgba(0, 0, 0, 0.075);
}

.rw-input {
  padding: 0;
  margin: 0;
  border: none;
  color: inherit;
  box-shadow: none;
  background: none;
  font: inherit;
  line-height: inherit;
  touch-action: manipulation;
  outline: 0;
  padding: 0 0.75rem;
}

.rw-input:disabled {
  opacity: 1;
}

.rw-input[type=text]::-ms-clear {
  display: none;
}

.rw-input:disabled, .rw-input:read-only {
  cursor: inherit;
}

.rw-widget-input {
  color: #495057;
  background-color: #fff;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  background-clip: padding-box;
  width: inherit;
}

.rw-widget-input.rw-state-disabled, .rw-state-disabled .rw-widget-input, fieldset[disabled] .rw-widget-input {
  background-color: #e9ecef;
}

.rw-placeholder,
.rw-input::placeholder {
  color: #6c757d;
}

.rw-state-disabled .rw-placeholder,
.rw-state-disabled .rw-input::placeholder {
  color: #999;
}

.rw-detect-autofill {
  padding: 0;
  margin: 0;
  border: none;
  color: inherit;
  box-shadow: none;
  background: none;
  font: inherit;
  line-height: inherit;
  touch-action: manipulation;
  outline: 0;
}

.rw-detect-autofill:disabled {
  opacity: 1;
}

.rw-detect-autofill:-webkit-autofill {
  animation-name: react-widgets-autofill-start;
  animation-duration: 0.01ms;
}

.rw-detect-autofill:not(:-webkit-autofill) {
  animation-name: react-widgets-autofill-cancel;
  animation-duration: 0.01ms;
}

.rw-webkit-autofill .rw-widget-container,
.rw-input:-webkit-autofill {
  background-color: rgb(232, 240, 254) !important;
  background-image: none !important;
  color: rgb(0, 0, 0) !important;
}

.rw-list {
  font-size: 1em;
  overflow-x: visible;
  overflow-y: auto;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
}

.rw-list:focus {
  outline: none;
}

.rw-list-option, .rw-list-option-create {
  -webkit-user-select: none;
          user-select: none;
  color: #212529;
  cursor: pointer;
  border: 1px solid transparent;
  background-clip: padding-box;
}

.rw-list-option:hover, .rw-list-option-create:hover, [data-intent=keyboard] .rw-list-option.rw-state-focus:not(.rw-state-selected), [data-intent=keyboard] .rw-state-focus.rw-list-option-create:not(.rw-state-selected) {
  background-color: #e9ecef;
  border-color: #e9ecef;
}

.rw-list-option.rw-state-selected, .rw-state-selected.rw-list-option-create {
  background-color: #007bff;
  border-color: #007bff;
  color: #fff;
}

.rw-list-option.rw-state-disabled, .rw-state-disabled.rw-list-option-create {
  cursor: not-allowed;
  background-color: transparent;
  border-color: transparent;
  color: #dee2e6;
}

.rw-list-empty,
.rw-list-option,
.rw-list-option-create,
.rw-list-optgroup {
  padding: 0.25em 1.5em;
  outline: none;
}

.rw-list-empty {
  text-align: center;
  color: #ced4da;
}

.rw-list-optgroup {
  font-weight: bold;
  padding-top: 7px;
}

.rw-list-option-create {
  display: block;
  font-size: 1em;
  padding: 0.25em 1.5em;
}

.rw-listbox {
  border-radius: 4px;
  background-color: #fff;
  border: #ccc 1px solid;
}

.rw-listbox.rw-state-focus {
  color: #495057;
  background-color: #fff;
  border-color: rgb(187.8214285714, 190.9642857143, 239.6785714286);
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25), inset 0 1px 2px rgba(0, 0, 0, 0.075);
  transition: box-shadow 0.15s ease-in-out;
}

.rw-listbox.rw-state-disabled > *, fieldset[disabled] .rw-listbox > * {
  pointer-events: none;
}

.rw-listbox.rw-state-readonly > * {
  cursor: inherit;
}

.rw-popup-container {
  position: absolute;
  z-index: 1005;
  top: 100%;
  left: -1em;
  right: -1em;
  padding: 0 1em;
}

.rw-popup-container.rw-dropup {
  top: auto;
  bottom: 100%;
}

.rw-state-focus .rw-popup-container {
  z-index: 1006;
}

.rw-slide-transition {
  margin-bottom: 1em;
}

.rw-dropup > .rw-slide-transition {
  margin-bottom: 0;
  margin-top: 1em;
}

.rw-popup {
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  margin-top: 2px;
  border-radius: 4px;
  box-shadow: 0 0.5em 1em rgba(0, 0, 0, 0.175);
  border: #ccc 1px solid;
  background-clip: padding-box;
  background: #fff;
}

.rw-popup .rw-list {
  max-height: 250px;
}

.rw-dropup .rw-popup {
  margin-top: 0;
  margin-bottom: 2px;
  box-shadow: 0 0.5em 1em rgba(0, 0, 0, 0.175);
}

.rw-slide-transition {
  transition: transform 130ms, opacity 100ms;
}

.rw-slide-transition-entering {
  overflow: hidden;
}

.rw-slide-transition-entering .rw-slide-transition {
  transform: translateY(0);
  opacity: 1;
  transition-timing-function: ease-out;
}

.rw-slide-transition-exiting .rw-slide-transition {
  transition-timing-function: ease-in;
}

.rw-slide-transition-exiting,
.rw-slide-transition-exited {
  overflow: hidden;
}

.rw-slide-transition-exiting .rw-slide-transition,
.rw-slide-transition-exited .rw-slide-transition {
  opacity: 0;
  transform: translateY(-10%);
}

.rw-slide-transition-exiting.rw-dropup .rw-slide-transition,
.rw-slide-transition-exited.rw-dropup .rw-slide-transition {
  opacity: 0;
  transform: translateY(10%);
}

.rw-slide-transition-exited {
  display: none;
}

.rw-dropdown-list {
  width: 100%;
}

.rw-dropdownlist-search {
  padding: 0;
  margin: 0;
  border: none;
  color: inherit;
  box-shadow: none;
  background: none;
  font: inherit;
  line-height: inherit;
  touch-action: manipulation;
  outline: 0;
}

.rw-dropdownlist-search:disabled {
  opacity: 1;
}

.rw-dropdown-list-input {
  padding: 0 0.75rem;
  align-self: center;
  display: grid;
  min-width: 0;
  grid-template: 1fr/1fr;
}

.rw-dropdown-list-input > * {
  grid-area: 1/1;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

[dir=rtl] .rw-dropdown-list-input {
  padding-right: 0.75rem;
  padding-left: 0;
}

.rw-combobox-input {
  background-color: transparent;
  z-index: 1;
}

.rw-multiselect-input {
  padding: 0;
  margin: 0;
  border: none;
  color: inherit;
  box-shadow: none;
  background: none;
  font: inherit;
  line-height: inherit;
  touch-action: manipulation;
  outline: 0;
  height: calc(calc(1.5em + (0.75rem + 2px)) - 1px * 2);
  padding: 0 0.75rem;
  max-width: 100%;
}

.rw-multiselect-input:disabled {
  opacity: 1;
}

.rw-multiselect-input:disabled, .rw-multiselect-input:read-only {
  cursor: inherit;
}

.rw-multiselect-taglist {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  width: 100%;
  outline: none;
  cursor: text;
}

.rw-state-disabled .rw-multiselect-taglist {
  cursor: inherit;
}

.rw-multiselect-tag {
  display: inline-flex;
  margin-left: calc(calc(1.5em + (0.75rem + 2px)) * 0.115 - 1px);
  margin-top: calc(calc(1.5em + (0.75rem + 2px)) * 0.115 - 1px);
  min-height: calc(calc(1.5em + (0.75rem + 2px)) * 0.77);
  border-radius: 3px;
  background-color: #dee2e6;
  border: 1px solid #dee2e6;
  cursor: default;
  max-width: 100%;
  align-items: center;
  overflow: hidden;
}

.rw-multiselect-tag:focus {
  outline: none;
}

[dir=rtl] .rw-multiselect-tag {
  margin-left: 0;
  margin-right: calc(calc(1.5em + (0.75rem + 2px)) * 0.115 - 1px);
  padding: 0 0.35em 0 0.35em;
}

.rw-multiselect-tag.rw-state-focus {
  z-index: 1;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);
  transition: box-shadow 0.15s ease-in-out;
}

.rw-multiselect-tag.rw-state-disabled, fieldset[disabled] .rw-multiselect-tag {
  opacity: 0.65;
}

.rw-multiselect-tag-label {
  padding: 0 0.35em 0 0.35em;
}

.rw-multiselect-tag-btn {
  padding: 0;
  margin: 0;
  border: none;
  color: inherit;
  box-shadow: none;
  background: none;
  font: inherit;
  line-height: inherit;
  touch-action: manipulation;
  outline: 0;
  cursor: pointer;
  align-self: stretch;
  padding: 0 0.35em;
}

.rw-multiselect-tag-btn:focus {
  outline: none;
}

.rw-multiselect-tag-btn:disabled {
  cursor: inherit;
}

.rw-calendar-popup {
  right: auto;
  min-width: 0;
  width: 22em;
}

.rw-calendar {
  overflow: hidden;
}

.rw-calendar-contained {
  border-radius: 4px;
  background-color: #fff;
  border: #ccc 1px solid;
}

.rw-calendar-now {
  font-weight: bold;
}

.rw-calendar-header {
  display: flex;
  padding: 0.8em;
}

.rw-cell,
.rw-calendar-btn {
  background-clip: padding-box;
}

.rw-cell:focus,
.rw-calendar-btn:focus {
  z-index: 1;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);
  transition: box-shadow 0.15s ease-in-out;
}

[data-intent=mouse] .rw-cell:focus,
[data-intent=mouse] .rw-calendar-btn:focus {
  z-index: auto;
  box-shadow: none;
}

.rw-cell:disabled, .rw-cell.rw-state-disabled,
.rw-calendar-btn:disabled,
.rw-calendar-btn.rw-state-disabled {
  pointer-events: none;
  opacity: 0.35;
}

.rw-calendar-btn {
  line-height: 2em;
  border-radius: 4px;
}

.rw-calendar-btn:hover {
  background-color: #e9ecef;
}

.rw-calendar-btn:active {
  background-color: #dee2e6;
}

.rw-calendar-btn-left,
.rw-calendar-btn-today,
.rw-calendar-btn-right,
.rw-calendar-btn-view {
  padding: 0.3em 0.6em;
}

[dir=rtl] .rw-calendar-btn-left,
[dir=rtl] .rw-calendar-btn-right {
  transform: scale(-1, 1);
}

.rw-calendar-btn-view {
  font-weight: bold;
}

.rw-calendar-btn-view > :last-child {
  margin: 0 0.5em;
}

.rw-calendar-btn-view + * {
  margin-left: auto;
}

[dir=rtl] .rw-calendar-btn-view + * {
  margin-left: 0;
  margin-right: auto;
}

.rw-calendar-grid {
  display: table;
  outline: none;
  height: 14em;
  padding: 3px;
  table-layout: fixed;
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
  background-color: #fff;
}

.rw-calendar-head {
  display: table-header-group;
}

.rw-calendar-body {
  display: table-row-group;
}

.rw-calendar-row {
  display: table-row;
}

.rw-head-cell {
  display: table-cell;
  text-align: center;
  border-bottom: 1px solid #ced4da;
  padding: 0.25em;
}

.rw-cell {
  display: table-cell;
  color: #212529;
  vertical-align: middle;
  border-radius: 4px;
  cursor: pointer;
  line-height: normal;
  text-align: center;
  border: 1px solid transparent;
  padding: 0.25em;
  outline: none;
}

.rw-cell:hover {
  background-color: #e9ecef;
}

.rw-cell:active {
  background-color: #dee2e6;
}

.rw-cell.rw-state-selected {
  background-color: #007bff;
  border-color: #007bff;
  color: #fff;
}

.rw-calendar-month .rw-cell {
  text-align: center;
}

.rw-cell-off-range {
  color: #ced4da;
}

.rw-calendar-transition-group {
  position: relative;
  overflow: hidden;
}

.rw-calendar-transition {
  width: 100%;
  overflow: hidden;
  transition: transform 0.2s ease-in-out 0ms;
  transform: translate(0, 0);
}

@supports (transform-style: preserve-3d) {
  .rw-calendar-transition {
    transform: translate3d(0, 0, 0);
  }
}
.rw-calendar-transition-next {
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.rw-calendar-transition-top .rw-calendar-transition-next {
  transform: translate(0, -100%);
}

@supports (transform-style: preserve-3d) {
  .rw-calendar-transition-top .rw-calendar-transition-next {
    transform: translate3d(0, -100%, 0);
  }
}
.rw-calendar-transition-bottom .rw-calendar-transition-next {
  transform: translate(0, 100%);
}

@supports (transform-style: preserve-3d) {
  .rw-calendar-transition-bottom .rw-calendar-transition-next {
    transform: translate3d(0, 100%, 0);
  }
}
.rw-calendar-transition-right .rw-calendar-transition-next {
  transform: translate(-100%, 0);
}

@supports (transform-style: preserve-3d) {
  .rw-calendar-transition-right .rw-calendar-transition-next {
    transform: translate3d(-100%, 0, 0);
  }
}
.rw-calendar-transition-left .rw-calendar-transition-next {
  transform: translate(100%, 0);
}

@supports (transform-style: preserve-3d) {
  .rw-calendar-transition-left .rw-calendar-transition-next {
    transform: translate3d(100%, 0, 0);
  }
}
.rw-calendar-transition-next.rw-calendar-transition-active {
  transform: translate(0, 0);
}

@supports (transform-style: preserve-3d) {
  .rw-calendar-transition-next.rw-calendar-transition-active {
    transform: translate3d(0, 0, 0);
  }
}
.rw-calendar-transition-prev {
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  position: absolute;
  left: 0;
  top: 0;
}

.rw-calendar-transition-top .rw-calendar-transition-prev {
  transform: translate(0, 100%);
}

@supports (transform-style: preserve-3d) {
  .rw-calendar-transition-top .rw-calendar-transition-prev {
    transform: translate3d(0, 100%, 0);
  }
}
.rw-calendar-transition-bottom .rw-calendar-transition-prev {
  transform: translate(0, -100%);
}

@supports (transform-style: preserve-3d) {
  .rw-calendar-transition-bottom .rw-calendar-transition-prev {
    transform: translate3d(0, -100%, 0);
  }
}
.rw-calendar-transition-right .rw-calendar-transition-prev {
  transform: translate(100%, 0);
}

@supports (transform-style: preserve-3d) {
  .rw-calendar-transition-right .rw-calendar-transition-prev {
    transform: translate3d(100%, 0, 0);
  }
}
.rw-calendar-transition-left .rw-calendar-transition-prev {
  transform: translate(-100%, 0);
}

@supports (transform-style: preserve-3d) {
  .rw-calendar-transition-left .rw-calendar-transition-prev {
    transform: translate3d(-100%, 0, 0);
  }
}
.rw-popup {
  display: flex;
  flex-direction: column;
}

.rw-popup > .rw-time-input {
  align-self: center;
  margin: 1em 0;
}

.rw-time-input {
  display: inline-flex;
  min-height: calc(1.5em + (0.75rem + 2px));
  align-items: center;
  background-color: #fff;
  border: #ced4da 1px solid;
  border-radius: 0.25rem;
  outline: none;
  cursor: text;
}

.rw-time-part-input {
  padding: 0;
  margin: 0;
  border: none;
  color: inherit;
  box-shadow: none;
  background: none;
  font: inherit;
  line-height: inherit;
  touch-action: manipulation;
  outline: 0;
  padding: 0 0.5em;
}

.rw-time-part-input:disabled {
  opacity: 1;
}

.rw-time-part-input, .rw-time-part-input::placeholder {
  text-align: center;
}

.rw-time-part-meridiem {
  padding: 0;
  margin: 0;
  border: none;
  color: inherit;
  box-shadow: none;
  background: none;
  font: inherit;
  line-height: inherit;
  touch-action: manipulation;
  outline: 0;
  padding: 0 0.5em;
  text-transform: lowercase;
  font-feature-settings: "smcp";
  font-variant: small-caps;
}

.rw-time-part-meridiem :focus {
  outline: none;
}

.rw-time-input-clear {
  padding: 0 0.4em;
  outline: none;
  opacity: 0;
  margin-left: auto;
}

[dir=rtl] .rw-time-input-clear {
  margin-left: revert;
  margin-right: auto;
}

.rw-time-input:hover .rw-time-input-clear.rw-show, .rw-time-input.rw-state-focus .rw-time-input-clear.rw-show {
  opacity: 1;
}

.rw-number-picker-spinners {
  display: flex;
  flex-direction: column;
}

.rw-number-picker-spinners .rw-btn {
  flex: 1 1;
}

.ui-theme-settings {
  position: fixed;
  z-index: 155;
  right: -30px;
  top: 0;
  height: 100vh;
  transform: translate(500px);
  transition: all 0.2s;
  box-shadow: -0.46875rem 0 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), -0.9375rem 0 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), -0.25rem 0 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), -0.125rem 0 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);
}
.ui-theme-settings .btn-open-options {
  border-radius: 50px;
  position: absolute;
  left: -114px;
  bottom: 80px;
  padding: 0;
  height: 54px;
  line-height: 54px;
  width: 54px;
  text-align: center;
  display: block;
  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);
  margin-top: -27px;
}
.ui-theme-settings .btn-open-options svg {
  top: 50%;
  left: 50%;
  position: absolute;
  margin: -0.5em 0 0 -0.5em;
}
.ui-theme-settings .theme-settings__inner {
  background: #fff;
  width: 500px;
  height: 100vh;
  padding: 0;
}
.ui-theme-settings.settings-open {
  transform: translate(0);
  right: 0;
}
.ui-theme-settings .theme-settings-swatches {
  text-align: center;
}
.ui-theme-settings .theme-settings-swatches .swatch-holder-img {
  width: 72px;
  height: auto;
  border-radius: 3px;
}
.ui-theme-settings .theme-settings-swatches .swatch-holder-img img {
  width: 100%;
}
.ui-theme-settings .themeoptions-heading {
  font-size: 1.1rem;
  color: #495057;
  margin: 0;
  background: #f8f9fa;
  padding: 0.75rem 1.5rem;
  border-bottom: #dee2e6 solid 1px;
  border-top: #dee2e6 solid 1px;
  display: flex;
  align-items: center;
  align-content: center;
}
.ui-theme-settings .themeoptions-heading:first-child {
  border-top: 0;
}
.ui-theme-settings .list-group-item h5, .ui-theme-settings .list-group-item .h5 {
  color: #545cd8;
  font-size: 0.968rem;
  text-transform: uppercase;
  margin: 0;
  text-align: center;
}

.swatch-holder {
  width: 24px;
  height: 24px;
  line-height: 24px;
  margin: 5px 5px 0;
  transition: all 0.2s;
  opacity: 0.7;
  display: inline-block;
  border-radius: 30px;
}
.swatch-holder.active {
  border: #fff solid 2px;
  box-shadow: 0 0 0 5px #545cd8;
  opacity: 1;
}
.swatch-holder:hover {
  opacity: 1;
}

.swatch-holder-lg {
  width: 48px;
  height: 48px;
  line-height: 48px;
}

.font-icon-wrapper {
  text-align: center;
  border: #e9ecef solid 1px;
  border-radius: 0.25rem;
  margin: 0 0 10px;
  padding: 5px;
}
.font-icon-wrapper.font-icon-lg {
  float: left;
  padding: 10px;
  text-align: center;
  margin-right: 15px;
  min-width: 64px;
}
.font-icon-wrapper.font-icon-lg i {
  font-size: 2.2rem;
}
.font-icon-wrapper:hover {
  background: #f8f9fa;
  color: #545cd8;
}
.font-icon-wrapper:hover p {
  color: #6c757d;
}
.font-icon-wrapper i {
  font-size: 1.65rem;
}
.font-icon-wrapper p {
  color: #adb5bd;
  font-size: 0.8066666667rem;
  margin: 5px 0 0;
}

.btn-icon-vertical {
  min-width: 100px;
}

.card.mb-3 {
  margin-bottom: 1.5rem !important;
}

.demo-image-bg {
  height: 350px;
  margin-bottom: 1.5rem;
}

.loader-wrapper {
  width: 150px;
  height: 100px;
  float: left;
}

.slider-item {
  background: #dee2e6;
  border-radius: 0.25rem;
  color: #6c757d;
  font-size: 36px;
  padding: 0;
  position: relative;
  height: 150px;
  line-height: 150px;
  text-align: center;
  margin: 0 1.5rem;
  transition: all 0.2s;
}

.slick-center .slider-item {
  background: #adb5bd;
  color: #495057;
}

.after-img {
  max-width: 100%;
}

@media only screen and (max-width: 1320px) {
  .header-user-info {
    display: none;
  }
}
@media (max-width: 767.98px) {
  .app-main {
    display: block;
  }
  .dropdown-menu::before, .dropdown-menu::after {
    display: none;
  }
  .app-sidebar {
    flex: 0 0 280px !important;
    width: 280px !important;
    transform: translateX(-280px);
  }
  .app-sidebar .app-header__logo {
    display: none;
  }
  .sidebar-mobile-open .app-sidebar {
    transform: translateX(0);
  }
  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .app-sidebar__heading {
    text-indent: 0;
    text-indent: initial;
  }
  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .app-sidebar__heading::before {
    display: none;
  }
  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .metismenu-link {
    text-indent: 0;
    text-indent: initial;
    padding: 0 1.5rem 0 45px;
  }
  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .metismenu-icon {
    text-indent: 0;
    text-indent: initial;
    left: 5px;
    margin-left: 0;
  }
  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .metismenu-state-icon {
    visibility: visible;
  }
  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .metismenu-container.visible {
    padding: 0.5em 0 0 2rem;
  }
  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .metismenu-container.visible > .metismenu-item > .metismenu-link {
    height: 2.3em;
  }
  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .metismenu-container .metismenu-container .metismenu-link {
    padding-left: 1em;
  }
  .sidebar-mobile-open .app-sidebar .app-header__logo {
    width: auto !important;
  }
  .sidebar-mobile-open .app-sidebar .app-header__logo .logo-src {
    width: 97px !important;
    margin-left: auto;
    margin-right: 0;
  }
  .sidebar-mobile-open .fixed-sidebar .app-sidebar {
    height: 100%;
  }
  .sidebar-mobile-open .sidebar-mobile-overlay {
    display: block;
  }
  .app-main .app-main__outer {
    padding-left: 0 !important;
    width: auto;
  }
  .app-header {
    justify-content: space-between;
  }
  .app-header .app-header__logo {
    display: none;
    order: 2;
    background: transparent !important;
    border: 0 !important;
  }
  .app-header .app-header__content {
    visibility: hidden;
    opacity: 0;
    box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);
    position: absolute;
    left: 5%;
    width: 90%;
    top: 0;
    transition: all 0.2s;
    background: #fff;
    border-radius: 50px;
    padding: 0 10px;
    overflow: hidden;
  }
  .app-header .app-header__content .header-btn-lg {
    margin-left: 0.5rem;
    padding: 0 0.5rem;
  }
  .app-header .app-header__content .header-btn-lg .hamburger-box {
    margin-top: 5px;
  }
  .app-header .app-header__content .header-btn-lg + .header-btn-lg {
    display: none;
  }
  .app-header .app-header__content .app-header-left .nav {
    display: none;
  }
  .app-header .app-header__content.header-mobile-open {
    visibility: visible;
    opacity: 1;
    top: 80px;
  }
  .app-header .app-header__mobile-menu {
    display: flex;
    order: 1;
  }
  .app-header .app-header__menu {
    display: flex;
    order: 3;
  }
  .app-header.header-text-light .app-header__menu > span .btn, .app-header.header-text-light .app-header__menu > .btn {
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.1);
  }
  .app-header.header-text-light .header-mobile-open {
    background: #343a40;
  }
  .popover,
  .dropdown-menu {
    position: fixed !important;
    z-index: 50;
    left: 5% !important;
    top: 50% !important;
    width: 90% !important;
    transform: translateY(-50%) !important;
    min-width: 10px !important;
  }
  .popover .btn-icon-vertical .btn-icon-wrapper,
  .dropdown-menu .btn-icon-vertical .btn-icon-wrapper {
    display: none;
  }
  .popover {
    max-width: none;
    max-width: initial;
  }
  .popover .arrow {
    display: none !important;
  }
  .app-page-title {
    text-align: center;
  }
  .app-page-title .page-title-heading,
  .app-page-title .page-title-wrapper {
    margin: 0 auto;
    display: block;
  }
  .app-page-title .page-title-actions {
    margin: 0.75rem auto 0;
  }
  .app-page-title .page-title-actions .breadcrumb-item,
  .app-page-title .page-title-actions .breadcrumb,
  .app-page-title .page-title-subheading .breadcrumb-item,
  .app-page-title .page-title-subheading .breadcrumb {
    display: inline-block;
  }
  .app-footer .app-footer__inner .app-footer-right {
    display: none;
  }
  .app-footer .app-footer__inner .app-footer-left {
    width: 100%;
  }
  .app-footer .app-footer__inner .app-footer-left .footer-dots {
    margin: 0 auto;
  }
  .fixed-footer.closed-sidebar .app-footer .app-footer__inner {
    margin-left: 0 !important;
  }
  .widget-content .widget-numbers {
    font-size: 1.6rem;
    line-height: 1;
  }
  .slick-slider-sm .slick-slider {
    max-width: 650px !important;
  }
  .body-tabs.body-tabs-layout.body-tabs-big {
    display: block !important;
  }
  .body-tabs.body-tabs-layout.body-tabs-big .RRT__tab {
    display: inline-block !important;
    padding: 0 1.5rem !important;
  }
  .body-tabs.body-tabs-layout.body-tabs-big .RRT__showmore {
    margin-top: -20px;
  }
  .ReactTable .-pagination .-center {
    display: none;
  }
  .ReactTable .-pagination .-previous {
    padding-right: 3px;
  }
  .bg-transparent.list-group-item {
    border-color: transparent;
  }
  .tabs-lg-alternate.card-header > .nav .nav-item .widget-number {
    font-size: 1.5rem;
  }
  .page-title-head {
    display: block;
  }
}
@media (max-width: 767.98px) {
  .app-page-title .page-title-icon,
  .ui-theme-settings {
    display: none;
  }
  .card-header.responsive-center {
    display: block;
    text-align: center;
    height: auto;
    padding: 1.5rem;
  }
  .card-header.responsive-center .nav,
  .card-header.responsive-center .btn-actions-pane-right {
    margin: 0.75rem 0 0;
  }
  .card-header.responsive-center .nav .d-inline-block.ml-2,
  .card-header.responsive-center .btn-actions-pane-right .d-inline-block.ml-2 {
    width: 100% !important;
    text-align: left;
    margin: 0 !important;
  }
  .slick-slider-sm .slick-slider {
    max-width: 650px !important;
  }
}
@media (min-width: 992px) {
  .slick-slider-sm .slick-slider {
    max-width: 850px !important;
  }
}
@media (max-width: 991.98px) {
  .-hide-paging .-pagination .-center {
    display: none;
  }
}
@media (max-width: 575.98px) {
  .app-main .app-main__inner {
    padding: 15px 15px 0;
  }
  .mbg-3,
  body .card.mb-3 {
    margin-bottom: 0.75rem !important;
  }
  .app-page-title {
    padding: 0.75rem;
    margin: -0.75rem -0.75rem 1.5rem;
  }
  .body-tabs.body-tabs-layout {
    margin-left: -0.75rem;
    margin-right: -0.75rem;
    padding: 0 0.75rem;
  }
  .app-main .app-main__inner > .RRT__container > .RRT__panel {
    margin-top: 0.75rem;
  }
  .popover,
  .dropdown-menu {
    width: 80%;
    left: 10%;
  }
  body .card-header {
    height: auto;
    display: block;
    padding: 0.75rem 1.5rem;
    text-align: center;
  }
  body .card-header .btn-actions-pane-right {
    padding: 0.75rem 0 0;
  }
  body .card-header .actions-icon-btn {
    padding: 0;
  }
  .card-header.card-header-tab .card-header-title {
    display: inline-flex !important;
    line-height: 1;
  }
  .card-header.card-header-tab > .nav {
    margin: 0.75rem 0 -0.75rem;
    display: table !important;
    width: 100%;
  }
  .card-header.card-header-tab > .nav .nav-item {
    display: table-cell;
  }
  .header-icon {
    display: none;
  }
  .profile-responsive-sm .dropdown-menu-header .menu-header-content.btn-pane-right,
  .profile-responsive .dropdown-menu-header .menu-header-content.btn-pane-right {
    display: block;
    text-align: center;
  }
  .profile-responsive-sm .dropdown-menu-header .menu-header-content.btn-pane-right .avatar-icon-wrapper,
  .profile-responsive .dropdown-menu-header .menu-header-content.btn-pane-right .avatar-icon-wrapper {
    margin-right: 0 !important;
  }
  .profile-responsive-sm .dropdown-menu-header .menu-header-content.btn-pane-right .menu-header-btn-pane,
  .profile-responsive .dropdown-menu-header .menu-header-content.btn-pane-right .menu-header-btn-pane {
    margin-top: 1rem;
  }
  .slick-slider-sm .slick-slider .slick-prev {
    left: 0.75rem;
  }
  .slick-slider-sm .slick-slider .slick-next {
    right: 0.75rem;
  }
}
@media only screen and (min-width: 1200px) and (max-width: 1500px) {
  .profile-responsive .dropdown-menu-header .menu-header-content.btn-pane-right {
    display: block;
    text-align: center;
  }
  .profile-responsive .dropdown-menu-header .menu-header-content.btn-pane-right .avatar-icon-wrapper {
    margin-right: 0 !important;
  }
  .profile-responsive .dropdown-menu-header .menu-header-content.btn-pane-right .menu-header-btn-pane {
    margin-top: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/base.scss","webpack://./src/assets/themes/default/_variables.scss","webpack://./src/assets/components/bootstrap5/_root.scss","webpack://./src/assets/components/bootstrap5/_reboot.scss","webpack://./src/assets/components/bootstrap5/_variables.scss","webpack://./src/assets/components/bootstrap5/vendor/_rfs.scss","webpack://./src/assets/components/bootstrap5/mixins/_border-radius.scss","webpack://./src/assets/components/bootstrap5/_type.scss","webpack://./src/assets/components/bootstrap5/mixins/_lists.scss","webpack://./src/assets/components/bootstrap5/_images.scss","webpack://./src/assets/components/bootstrap5/mixins/_image.scss","webpack://./src/assets/components/bootstrap5/_containers.scss","webpack://./src/assets/components/bootstrap5/mixins/_container.scss","webpack://./src/assets/components/bootstrap5/mixins/_breakpoints.scss","webpack://./src/assets/components/bootstrap5/_grid.scss","webpack://./src/assets/components/bootstrap5/mixins/_grid.scss","webpack://./src/assets/components/bootstrap5/_tables.scss","webpack://./src/assets/components/bootstrap5/mixins/_table-variants.scss","webpack://./src/assets/components/bootstrap5/forms/_labels.scss","webpack://./src/assets/components/bootstrap5/forms/_form-text.scss","webpack://./src/assets/components/bootstrap5/forms/_form-control.scss","webpack://./src/assets/components/bootstrap5/mixins/_transition.scss","webpack://./src/assets/components/bootstrap5/mixins/_gradients.scss","webpack://./src/assets/components/bootstrap5/forms/_form-select.scss","webpack://./src/assets/components/bootstrap5/forms/_form-check.scss","webpack://./src/assets/components/bootstrap5/forms/_form-range.scss","webpack://./src/assets/components/bootstrap5/forms/_floating-labels.scss","webpack://./src/assets/components/bootstrap5/forms/_input-group.scss","webpack://./src/assets/components/bootstrap5/mixins/_forms.scss","webpack://./src/assets/components/bootstrap5/_buttons.scss","webpack://./src/assets/components/bootstrap5/mixins/_buttons.scss","webpack://./src/assets/components/bootstrap5/_transitions.scss","webpack://./src/assets/components/bootstrap5/_dropdown.scss","webpack://./src/assets/components/bootstrap5/mixins/_caret.scss","webpack://./src/assets/components/bootstrap5/_button-group.scss","webpack://./src/assets/components/bootstrap5/_nav.scss","webpack://./src/assets/components/bootstrap5/_navbar.scss","webpack://./src/assets/components/bootstrap5/_card.scss","webpack://./src/assets/components/bootstrap5/_accordion.scss","webpack://./src/assets/components/bootstrap5/_breadcrumb.scss","webpack://./src/assets/components/bootstrap5/_pagination.scss","webpack://./src/assets/components/bootstrap5/mixins/_pagination.scss","webpack://./src/assets/components/bootstrap5/_badge.scss","webpack://./src/assets/components/bootstrap5/_alert.scss","webpack://./src/assets/components/bootstrap5/mixins/_alert.scss","webpack://./src/assets/components/bootstrap5/_progress.scss","webpack://./src/assets/components/bootstrap5/_list-group.scss","webpack://./src/assets/components/bootstrap5/mixins/_list-group.scss","webpack://./src/assets/components/bootstrap5/_close.scss","webpack://./src/assets/components/bootstrap5/_toasts.scss","webpack://./src/assets/components/bootstrap5/_modal.scss","webpack://./src/assets/components/bootstrap5/_tooltip.scss","webpack://./src/assets/components/bootstrap5/mixins/_reset-text.scss","webpack://./src/assets/components/bootstrap5/_popover.scss","webpack://./src/assets/components/bootstrap5/_carousel.scss","webpack://./src/assets/components/bootstrap5/mixins/_clearfix.scss","webpack://./src/assets/components/bootstrap5/_spinners.scss","webpack://./src/assets/components/bootstrap5/_offcanvas.scss","webpack://./src/assets/components/bootstrap5/_jumbotron.scss","webpack://./src/assets/components/bootstrap5/helpers/_colored-links.scss","webpack://./src/assets/components/bootstrap5/helpers/_ratio.scss","webpack://./src/assets/components/bootstrap5/helpers/_position.scss","webpack://./src/assets/components/bootstrap5/helpers/_visually-hidden.scss","webpack://./src/assets/components/bootstrap5/mixins/_visually-hidden.scss","webpack://./src/assets/components/bootstrap5/helpers/_stretched-link.scss","webpack://./src/assets/components/bootstrap5/helpers/_text-truncation.scss","webpack://./src/assets/components/bootstrap5/mixins/_text-truncate.scss","webpack://./src/assets/components/bootstrap5/mixins/_utilities.scss","webpack://./src/assets/components/bootstrap5/utilities/_api.scss","webpack://./src/assets/layout/generic/_generic-base.scss","webpack://./src/assets/layout/generic/_animations.scss","webpack://./src/assets/layout/header/_header-base.scss","webpack://./src/assets/layout/_layout-variables.scss","webpack://./src/assets/layout/header/modifiers/_fixed-header.scss","webpack://./src/assets/layout/header/modifiers/_header-dots.scss","webpack://./src/assets/layout/header/modifiers/_header-megamenu.scss","webpack://./src/assets/layout/header/modifiers/_header-buttons.scss","webpack://./src/assets/layout/header/themes/_header-light.scss","webpack://./src/assets/layout/header/themes/_header-dark.scss","webpack://./src/assets/layout/sidebar/_sidebar-base.scss","webpack://./src/assets/layout/sidebar/modifiers/_navmenu-vertical.scss","webpack://./src/assets/layout/sidebar/themes/_sidebar-light.scss","webpack://./src/assets/layout/sidebar/themes/_sidebar-dark.scss","webpack://./src/assets/layout/sidebar/modifiers/_fixed-sidebar.scss","webpack://./src/assets/layout/sidebar/modifiers/_closed-sidebar.scss","webpack://./src/assets/layout/main/_main-base.scss","webpack://./src/assets/layout/main/themes/_main-white.scss","webpack://./src/assets/layout/main/themes/_main-gray.scss","webpack://./src/assets/layout/footer/_footer-base.scss","webpack://./src/assets/layout/footer/_fixed-footer.scss","webpack://./src/assets/layout/elements/page-title/_page-title-base.scss","webpack://./src/assets/layout/elements/search-box/_search-box.scss","webpack://./src/assets/utils/helpers/_opacity.scss","webpack://./src/assets/utils/helpers/_grayscale.scss","webpack://./src/assets/utils/_helpers.scss","webpack://./src/assets/utils/_backgrounds.scss","webpack://./node_modules/animate-sass/helpers/_base.scss","webpack://./node_modules/animate-sass/helpers/_mixins.scss","webpack://./node_modules/animate-sass/helpers/_settings.scss","webpack://./node_modules/animate-sass/animations/fade-enter/_fadeIn.scss","webpack://./node_modules/animate-sass/animations/fade-enter/_fadeInDown.scss","webpack://./node_modules/animate-sass/animations/fade-enter/_fadeInUp.scss","webpack://./node_modules/animate-sass/animations/fade-exit/_fadeOut.scss","webpack://./node_modules/animate-sass/animations/lightspeed/_lightSpeedIn.scss","webpack://./node_modules/animate-sass/animations/lightspeed/_lightSpeedOut.scss","webpack://./src/assets/utils/_comps-animations.scss","webpack://./src/assets/elements/_buttons.scss","webpack://./src/assets/elements/_dropdown.scss","webpack://./src/assets/elements/_navs.scss","webpack://./src/assets/elements/_badges.scss","webpack://./src/assets/elements/_cards.scss","webpack://./src/assets/elements/_tabs.scss","webpack://./src/assets/elements/_accordions.scss","webpack://./src/assets/elements/_modals.scss","webpack://./src/assets/elements/_loaders.scss","webpack://./node_modules/loaders.css/src/animations/ball-pulse.scss","webpack://./node_modules/loaders.css/src/_mixins.scss","webpack://./node_modules/loaders.css/src/animations/ball-pulse-sync.scss","webpack://./node_modules/loaders.css/src/animations/ball-scale.scss","webpack://./node_modules/loaders.css/src/animations/ball-rotate.scss","webpack://./node_modules/loaders.css/src/animations/ball-clip-rotate.scss","webpack://./node_modules/loaders.css/src/animations/ball-clip-rotate-pulse.scss","webpack://./node_modules/loaders.css/src/animations/ball-clip-rotate-multiple.scss","webpack://./node_modules/loaders.css/src/animations/ball-scale-ripple.scss","webpack://./node_modules/loaders.css/src/animations/ball-scale-ripple-multiple.scss","webpack://./node_modules/loaders.css/src/animations/ball-beat.scss","webpack://./node_modules/loaders.css/src/animations/ball-scale-multiple.scss","webpack://./node_modules/loaders.css/src/animations/ball-triangle-trace.scss","webpack://./node_modules/loaders.css/src/animations/ball-pulse-rise.scss","webpack://./node_modules/loaders.css/src/animations/ball-grid-beat.scss","webpack://./node_modules/loaders.css/src/animations/ball-grid-pulse.scss","webpack://./node_modules/loaders.css/src/animations/ball-spin-fade-loader.scss","webpack://./node_modules/loaders.css/src/animations/ball-spin-loader.scss","webpack://./node_modules/loaders.css/src/animations/ball-zig-zag.scss","webpack://./node_modules/loaders.css/src/animations/ball-zig-zag-deflect.scss","webpack://./node_modules/loaders.css/src/animations/line-scale.scss","webpack://./node_modules/loaders.css/src/animations/line-scale-random.scss","webpack://./node_modules/loaders.css/src/animations/line-scale-pulse-out.scss","webpack://./node_modules/loaders.css/src/animations/line-scale-pulse-out-rapid.scss","webpack://./node_modules/loaders.css/src/animations/line-spin-fade-loader.scss","webpack://./node_modules/loaders.css/src/animations/triangle-skew-spin.scss","webpack://./node_modules/loaders.css/src/animations/square-spin.scss","webpack://./node_modules/loaders.css/src/animations/pacman.scss","webpack://./node_modules/loaders.css/src/animations/cube-transition.scss","webpack://./node_modules/loaders.css/src/animations/semi-circle-spin.scss","webpack://./src/assets/elements/_progressbar.scss","webpack://./src/assets/elements/_timeline.scss","webpack://./src/assets/elements/listgroup.scss","webpack://./src/assets/elements/_forms.scss","webpack://./src/assets/elements/_pagination.scss","webpack://./src/assets/elements/_chat.scss","webpack://./src/assets/elements/_forms-wizard.scss","webpack://./src/assets/widgets/chart-boxes/_chart-boxes.scss","webpack://./src/assets/widgets/content-boxes/_content-boxes.scss","webpack://./src/assets/widgets/profile-boxes/_profile-boxes.scss","webpack://./src/assets/pages/_userpages.scss","webpack://./src/assets/applications/_applications-base.scss","webpack://./src/assets/applications/_chat.scss","webpack://./src/assets/applications/_responsive.scss","webpack://./src/assets/components/perfect-scrollbar/_perfect-scrollbar.scss","webpack://./src/assets/components/rc-tabs/_rc-tabs.scss","webpack://./src/assets/components/loading-buttons/_loading-buttons.scss","webpack://./src/assets/components/hamburgers/hamburgers.scss","webpack://./src/assets/components/hamburgers/_base.scss","webpack://./src/assets/components/hamburgers/types/_elastic.scss","webpack://./src/assets/components/drawer/_drawer.scss","webpack://./src/assets/components/notifications/_sweetalerts.scss","webpack://./src/assets/components/notifications/toastify/_toastContainer.scss","webpack://./src/assets/components/notifications/toastify/_variables.scss","webpack://./src/assets/components/notifications/toastify/_toast.scss","webpack://./src/assets/components/notifications/toastify/_closeButton.scss","webpack://./src/assets/components/notifications/toastify/_progressBar.scss","webpack://./src/assets/components/notifications/toastify/animations/_bounce.scss","webpack://./src/assets/components/notifications/toastify/animations/_zoom.scss","webpack://./src/assets/components/notifications/toastify/animations/_flip.scss","webpack://./src/assets/components/notifications/toastify/animations/_slide.scss","webpack://./src/assets/components/modals/_rodal.scss","webpack://./src/assets/components/progress-bar/_progress-bar.scss","webpack://./src/assets/components/slick-carousel/slick/_slick.scss","webpack://./src/assets/components/slick-carousel/slick/_slick-theme.scss","webpack://./src/assets/components/block-loading/_block-loading.scss","webpack://./src/assets/components/popovers-tooltips/_popovers-tooltips.scss","webpack://./src/assets/components/sticky-elements/_sticky-elements.scss","webpack://./src/assets/components/calendar/scss/_reset.scss","webpack://./src/assets/components/calendar/_calendar.scss","webpack://./src/assets/components/calendar/scss/_variables.scss","webpack://./src/assets/components/calendar/scss/_toolbar.scss","webpack://./src/assets/components/calendar/scss/_event.scss","webpack://./src/assets/components/calendar/scss/_month.scss","webpack://./src/assets/components/calendar/scss/_agenda.scss","webpack://./src/assets/components/calendar/scss/_time-column.scss","webpack://./src/assets/components/calendar/scss/_time-grid.scss","webpack://./src/assets/components/splitters/_splitters.scss","webpack://./src/assets/components/tree-view/_tree-view.scss","webpack://./src/assets/components/tables/_tables.scss","webpack://./src/assets/components/icons/_linearicons.scss","webpack://./node_modules/pe7-icon/dist/scss/pe-icon-7-stroke.scss","webpack://./node_modules/pe7-icon/dist/scss/_path.scss","webpack://./node_modules/pe7-icon/dist/scss/_core.scss","webpack://./node_modules/pe7-icon/dist/scss/_helper.scss","webpack://./node_modules/pe7-icon/dist/scss/_icons.scss","webpack://./node_modules/pe7-icon/dist/scss/_variables.scss","webpack://./src/assets/components/forms/datepicker/_mixins.scss","webpack://./src/assets/components/forms/datepicker/_variables.scss","webpack://./src/assets/components/forms/datepicker/_datepicker.scss","webpack://./src/assets/components/forms/rangeslider/_tooltip.scss","webpack://./src/assets/components/forms/rangeslider/_rangeslider.scss","webpack://./src/assets/components/forms/wysiwyg/_wysiwyg.scss","webpack://./src/assets/components/forms/toggle-switch/_switch.scss","webpack://./src/assets/components/forms/dropzone/_dropzone.scss","webpack://./src/assets/components/forms/typeahead/_typeahead.scss","webpack://./src/assets/components/forms/typeahead/_mixins.scss","webpack://./node_modules/react-widgets/scss/widget.scss","webpack://./node_modules/react-widgets/scss/mixins.scss","webpack://./node_modules/react-widgets/scss/variables.scss","webpack://./node_modules/react-widgets/scss/list.scss","webpack://./node_modules/react-widgets/scss/listbox.scss","webpack://./node_modules/react-widgets/scss/popup.scss","webpack://./node_modules/react-widgets/scss/dropdown-list.scss","webpack://./node_modules/react-widgets/scss/combobox.scss","webpack://./node_modules/react-widgets/scss/multiselect.scss","webpack://./node_modules/react-widgets/scss/calendar.scss","webpack://./node_modules/react-widgets/scss/date-picker.scss","webpack://./node_modules/react-widgets/scss/time-input.scss","webpack://./node_modules/react-widgets/scss/number-picker.scss","webpack://./src/assets/demo-ui/elements/_theme-options.scss","webpack://./src/assets/demo-ui/_demo.scss","webpack://./src/assets/layout/responsive/_responsive-base.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACgLd;EACE,qBA5FW;ADlFf;;AC6KE;EACE,qBA5FW;AD9Ef;;ACyKE;EACE,qBA5FW;AD1Ef;;ACqKE;EACE,qBA5FW;ADtEf;;ACiKE;EACE,qBA5FW;ADlEf;;AC6JE;EACE,qBA5FW;AD9Df;;ACyJE;EACE,qBA5FW;AD1Df;;ACqJE;EACE,qBA5FW;ADtDf;;ACiJE;EACE,qBA5FW;ADlDf;;AC6IE;EACE,qBA5FW;AD9Cf;;AEvCA;EAGI,kBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,kBAAA;EAAA,uBAAA;EAIA,qBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA,uBAAA;EAKF,qNAAA;EACA,yGAAA;EACA,yFAAA;AFsDF;;AGrDA;;;EAGE,sBAAA;AHwDF;;AG3CI;EAJJ;IAKM,uBAAA;EH+CJ;AACF;;AGnCA;EACE,SAAA;EACA,4MCsX4B;EDtX5B,sCCsX4B;EChIxB,kBALI;EF/OR,gBCgY4B;ED/X5B,gBCqY4B;EDpY5B,cF5BS;EE8BT,sBFzCQ;EE0CR,8BAAA;EACA,6CAAA;AHqCF;;AG5BA;EACE,cAAA;EACA,cCqb4B;EDpb5B,8BAAA;EACA,SAAA;EACA,aCob4B;AJrZ9B;;AG5BA;EACE,WC+R4B;AJhQ9B;;AGrBA;EACE,aAAA;EACA,qBC0X4B;EDvX5B,gBFCqB;EEArB,gBC0X4B;AJpW9B;;AGlBA;EE4MQ,kCAAA;ALtLR;AKoBI;EF1CJ;IEmNQ,iBAAA;ELzLN;AACF;;AGtBA;EEuMQ,mCAAA;AL7KR;AKWI;EFrCJ;IE8MQ,kBAAA;ELhLN;AACF;;AG1BA;EEkMQ,mCAAA;ALpKR;AKEI;EFhCJ;IEyMQ,kBAAA;ELvKN;AACF;;AG9BA;EE6LQ,mCAAA;AL3JR;AKPI;EF3BJ;IEoMQ,kBAAA;EL9JN;AACF;;AGlCA;EEoLM,iBALI;ALzIV;;AGjCA;EE+KM,kBALI;ALrIV;;AG1BA;EACE,aAAA;EACA,mBCyK0B;AJ5I5B;;AGlBA;;EAEE,yCAAA;UAAA,iCAAA;EACA,YAAA;EACA,sCAAA;UAAA,8BAAA;AHqBF;;AGfA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;AHkBF;;AGZA;;EAEE,kBAAA;AHeF;;AGZA;;;EAGE,aAAA;EACA,mBAAA;AHeF;;AGZA;;;;EAIE,gBAAA;AHeF;;AGZA;EACE,gBC6P4B;AJ9O9B;;AGVA;EACE,qBAAA;EACA,cAAA;AHaF;;AGPA;EACE,gBAAA;AHUF;;AGFA;;EAEE,mBCsO4B;AJjO9B;;AGGA;EEgFM,kBALI;AL1EV;;AGMA;EACE,cCkS4B;EDjS5B,yBCyS4B;AJ5S9B;;AGYA;;EAEE,kBAAA;EE4DI,iBALI;EFrDR,cAAA;EACA,wBAAA;AHTF;;AGYA;EAAM,eAAA;AHRN;;AGSA;EAAM,WAAA;AHLN;;AGUA;EACE,cFxMM;EEyMN,0BCyCwC;AJhD1C;AGSE;EACE,6BCwCsC;AJ/C1C;;AGkBE;EAEE,cAAA;EACA,qBAAA;AHhBJ;;AGuBA;;;;EAIE,iGCmJ4B;EDnJ5B,qCCmJ4B;ECjIxB,cALI;EFXR,+BAAA;EACA,2BAAA;AHpBF;;AG2BA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EEII,kBALI;ALtBV;AG4BE;EEDI,kBALI;EFQN,cAAA;EACA,kBAAA;AH1BJ;;AG8BA;EERM,kBALI;EFeR,cF7PK;EE8PL,qBAAA;AH3BF;AG8BE;EACE,cAAA;AH5BJ;;AGgCA;EACE,sBAAA;EEpBI,kBALI;EF2BR,WF3SM;EE4SN,yBFnSS;EKNP,qBAAA;AN6QJ;AG+BE;EACE,UAAA;EE3BE,cALI;EFkCN,gBCgH0B;AJ7I9B;;AGsCA;EACE,gBAAA;AHnCF;;AGyCA;;EAEE,sBAAA;AHtCF;;AG8CA;EACE,oBAAA;EACA,yBAAA;AH3CF;;AG8CA;EACE,mBC8K4B;ED7K5B,sBC6K4B;ED5K5B,cF9US;EE+UT,gBAAA;AH3CF;;AGkDA;EAEE,mBAAA;EACA,gCAAA;AHhDF;;AGmDA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;AHhDF;;AGwDA;EACE,qBAAA;AHrDF;;AG2DA;EAEE,gBAAA;AHzDF;;AGiEA;EACE,UAAA;AH9DF;;AGmEA;;;;;EAKE,SAAA;EACA,oBAAA;EE1HI,kBALI;EFiIR,oBAAA;AHhEF;;AGoEA;;EAEE,oBAAA;AHjEF;;AGsEA;EACE,eAAA;AHnEF;;AGsEA;EAGE,iBAAA;AHrEF;AGwEE;EACE,UAAA;AHtEJ;;AG6EA;EACE,aAAA;AH1EF;;AGkFA;;;;EAIE,0BAAA;AH/EF;AGkFI;;;;EACE,eAAA;AH7EN;;AGoFA;EACE,UAAA;EACA,kBAAA;AHjFF;;AGsFA;EACE,gBAAA;AHnFF;;AG6FA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;AH1FF;;AGkGA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,qBCG4B;EClNtB,iCAAA;EFkNN,oBAAA;AHhGF;AKpRI;EF6WJ;IEpMQ,iBAAA;EL+GN;AACF;AG6FE;EACE,WAAA;AH3FJ;;AGkGA;;;;;;;EAOE,UAAA;AH/FF;;AGkGA;EACE,YAAA;AH/FF;;AGwGA;EACE,oBAAA;EACA,6BAAA;AHrGF;;AG6GA;;;;;;;CAAA;AAWA;EACE,wBAAA;AH7GF;;AGkHA;EACE,UAAA;AH/GF;;AGqHA;EACE,aAAA;AHlHF;;AGiHA;EACE,aAAA;AHlHF;;AGwHA;EACE,aAAA;EACA,0BAAA;AHrHF;;AG0HA;EACE,qBAAA;AHvHF;;AG4HA;EACE,SAAA;AHzHF;;AGgIA;EACE,kBAAA;EACA,eAAA;AH7HF;;AGqIA;EACE,wBAAA;AHlIF;;AG0IA;EACE,wBAAA;AHvIF;;AOxcA;EFyQM,iBALI;EElQR,gBHyc4B;AJE9B;;AOtcE;EFsQM,iCAAA;EEpQJ,gBH4bkB;EG3blB,gBH6a0B;AJ4B9B;AKxWI;EEpGF;IF6QM,eAAA;ELmMN;AACF;;AOjdE;EFsQM,iCAAA;EEpQJ,gBH4bkB;EG3blB,gBH6a0B;AJuC9B;AKnXI;EEpGF;IF6QM,iBAAA;EL8MN;AACF;;AO5dE;EFsQM,iCAAA;EEpQJ,gBH4bkB;EG3blB,gBH6a0B;AJkD9B;AK9XI;EEpGF;IF6QM,eAAA;ELyNN;AACF;;AOveE;EFsQM,iCAAA;EEpQJ,gBH4bkB;EG3blB,gBH6a0B;AJ6D9B;AKzYI;EEpGF;IF6QM,iBAAA;ELoON;AACF;;AOlfE;EFsQM,iCAAA;EEpQJ,gBH4bkB;EG3blB,gBH6a0B;AJwE9B;AKpZI;EEpGF;IF6QM,eAAA;EL+ON;AACF;;AO7fE;EFsQM,iCAAA;EEpQJ,gBH4bkB;EG3blB,gBH6a0B;AJmF9B;AK/ZI;EEpGF;IF6QM,iBAAA;EL0PN;AACF;;AOlfA;ECrDE,eAAA;EACA,gBAAA;AR2iBF;;AOlfA;EC1DE,eAAA;EACA,gBAAA;ARgjBF;;AOpfA;EACE,qBAAA;APufF;AOrfE;EACE,oBHgc0B;AJuD9B;;AO7eA;EFsNM,kBALI;EE/MR,yBAAA;APgfF;;AO5eA;EACE,mBHmKO;EC4CH,iBALI;ALsSV;AO7eE;EACE,gBAAA;AP+eJ;;AO3eA;EACE,iBAAA;EACA,mBHyJO;EC4CH,kBALI;EE9LR,cN5ES;AD0jBX;AO5eE;EACE,aAAA;AP8eJ;;AS5kBA;ECIE,eAAA;EAGA,YAAA;AV0kBF;;AS3kBA;EACE,gBL2yCkC;EK1yClC,sBRHQ;EQIR,yBAAA;EHGE,sBAAA;EIRF,eAAA;EAGA,YAAA;AVmlBF;;ASrkBA;EAEE,qBAAA;ATukBF;;ASpkBA;EACE,qBAAA;EACA,cAAA;ATukBF;;ASpkBA;EJ+PM,kBALI;EIxPR,cRlBS;ADylBX;;AWzmBE;;;;;;;ECHA,WAAA;EACA,sBAAA;EAAA,0CAAA;EACA,qBAAA;EAAA,yCAAA;EACA,kBAAA;EACA,iBAAA;AZsnBF;;Aa9jBI;EF5CE;IACE,gBPoTe;EJ0TrB;AACF;AapkBI;EF5CE;IACE,gBPoTe;EJ+TrB;AACF;AazkBI;EF5CE;IACE,gBPoTe;EJoUrB;AACF;Aa9kBI;EF5CE;IACE,iBPoTe;EJyUrB;AACF;AanlBI;EF5CE;IACE,iBPoTe;EJ8UrB;AACF;AclpBE;ECAA,qBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,yCAAA;EACA,6CAAA;EACA,4CAAA;AfqpBF;AcxpBI;ECYF,cAAA;EACA,WAAA;EACA,eAAA;EACA,6CAAA;EACA,4CAAA;EACA,8BAAA;Af+oBF;;AehmBM;EACE,SAAA;AfmmBR;;AehmBM;EApCJ,cAAA;EACA,WAAA;AfwoBF;;Ae1nBE;EACE,cAAA;EACA,WAAA;Af6nBJ;;Ae/nBE;EACE,cAAA;EACA,UAAA;AfkoBJ;;AepoBE;EACE,cAAA;EACA,qBAAA;AfuoBJ;;AezoBE;EACE,cAAA;EACA,UAAA;Af4oBJ;;Ae9oBE;EACE,cAAA;EACA,UAAA;AfipBJ;;AenpBE;EACE,cAAA;EACA,qBAAA;AfspBJ;;AahpBI;EESE;IACE,SAAA;Ef2oBN;EexoBI;IApCJ,cAAA;IACA,WAAA;Ef+qBA;EejqBA;IACE,cAAA;IACA,WAAA;EfmqBF;EerqBA;IACE,cAAA;IACA,UAAA;EfuqBF;EezqBA;IACE,cAAA;IACA,qBAAA;Ef2qBF;Ee7qBA;IACE,cAAA;IACA,UAAA;Ef+qBF;EejrBA;IACE,cAAA;IACA,UAAA;EfmrBF;EerrBA;IACE,cAAA;IACA,qBAAA;EfurBF;AACF;AalrBI;EESE;IACE,SAAA;Ef4qBN;EezqBI;IApCJ,cAAA;IACA,WAAA;EfgtBA;EelsBA;IACE,cAAA;IACA,WAAA;EfosBF;EetsBA;IACE,cAAA;IACA,UAAA;EfwsBF;Ee1sBA;IACE,cAAA;IACA,qBAAA;Ef4sBF;Ee9sBA;IACE,cAAA;IACA,UAAA;EfgtBF;EeltBA;IACE,cAAA;IACA,UAAA;EfotBF;EettBA;IACE,cAAA;IACA,qBAAA;EfwtBF;AACF;AantBI;EESE;IACE,SAAA;Ef6sBN;Ee1sBI;IApCJ,cAAA;IACA,WAAA;EfivBA;EenuBA;IACE,cAAA;IACA,WAAA;EfquBF;EevuBA;IACE,cAAA;IACA,UAAA;EfyuBF;Ee3uBA;IACE,cAAA;IACA,qBAAA;Ef6uBF;Ee/uBA;IACE,cAAA;IACA,UAAA;EfivBF;EenvBA;IACE,cAAA;IACA,UAAA;EfqvBF;EevvBA;IACE,cAAA;IACA,qBAAA;EfyvBF;AACF;AapvBI;EESE;IACE,SAAA;Ef8uBN;Ee3uBI;IApCJ,cAAA;IACA,WAAA;EfkxBA;EepwBA;IACE,cAAA;IACA,WAAA;EfswBF;EexwBA;IACE,cAAA;IACA,UAAA;Ef0wBF;Ee5wBA;IACE,cAAA;IACA,qBAAA;Ef8wBF;EehxBA;IACE,cAAA;IACA,UAAA;EfkxBF;EepxBA;IACE,cAAA;IACA,UAAA;EfsxBF;EexxBA;IACE,cAAA;IACA,qBAAA;Ef0xBF;AACF;AarxBI;EESE;IACE,SAAA;Ef+wBN;Ee5wBI;IApCJ,cAAA;IACA,WAAA;EfmzBA;EeryBA;IACE,cAAA;IACA,WAAA;EfuyBF;EezyBA;IACE,cAAA;IACA,UAAA;Ef2yBF;Ee7yBA;IACE,cAAA;IACA,qBAAA;Ef+yBF;EejzBA;IACE,cAAA;IACA,UAAA;EfmzBF;EerzBA;IACE,cAAA;IACA,UAAA;EfuzBF;EezzBA;IACE,cAAA;IACA,qBAAA;Ef2zBF;AACF;AevxBM;EAtDJ,cAAA;EACA,WAAA;Afg1BF;;AerxBU;EAtEN,cAAA;EACA,kBAAA;Af+1BJ;;Ae1xBU;EAtEN,cAAA;EACA,mBAAA;Afo2BJ;;Ae/xBU;EAtEN,cAAA;EACA,UAAA;Afy2BJ;;AepyBU;EAtEN,cAAA;EACA,mBAAA;Af82BJ;;AezyBU;EAtEN,cAAA;EACA,mBAAA;Afm3BJ;;Ae9yBU;EAtEN,cAAA;EACA,UAAA;Afw3BJ;;AenzBU;EAtEN,cAAA;EACA,mBAAA;Af63BJ;;AexzBU;EAtEN,cAAA;EACA,mBAAA;Afk4BJ;;Ae7zBU;EAtEN,cAAA;EACA,UAAA;Afu4BJ;;Ael0BU;EAtEN,cAAA;EACA,mBAAA;Af44BJ;;Aev0BU;EAtEN,cAAA;EACA,mBAAA;Afi5BJ;;Ae50BU;EAtEN,cAAA;EACA,WAAA;Afs5BJ;;Aez0BY;EA9DV,wBAAA;Af24BF;;Ae70BY;EA9DV,yBAAA;Af+4BF;;Aej1BY;EA9DV,gBAAA;Afm5BF;;Aer1BY;EA9DV,yBAAA;Afu5BF;;Aez1BY;EA9DV,yBAAA;Af25BF;;Ae71BY;EA9DV,gBAAA;Af+5BF;;Aej2BY;EA9DV,yBAAA;Afm6BF;;Aer2BY;EA9DV,yBAAA;Afu6BF;;Aez2BY;EA9DV,gBAAA;Af26BF;;Ae72BY;EA9DV,yBAAA;Af+6BF;;Aej3BY;EA9DV,yBAAA;Afm7BF;;Ae12BQ;;EAEE,gBAAA;Af62BV;;Ae12BQ;;EAEE,gBAAA;Af62BV;;Aep3BQ;;EAEE,sBAAA;Afu3BV;;Aep3BQ;;EAEE,sBAAA;Afu3BV;;Ae93BQ;;EAEE,qBAAA;Afi4BV;;Ae93BQ;;EAEE,qBAAA;Afi4BV;;Aex4BQ;;EAEE,mBAAA;Af24BV;;Aex4BQ;;EAEE,mBAAA;Af24BV;;Ael5BQ;;EAEE,qBAAA;Afq5BV;;Ael5BQ;;EAEE,qBAAA;Afq5BV;;Ae55BQ;;EAEE,mBAAA;Af+5BV;;Ae55BQ;;EAEE,mBAAA;Af+5BV;;Aa99BI;EE+BE;IAtDJ,cAAA;IACA,WAAA;Ef0/BA;Ee/7BQ;IAtEN,cAAA;IACA,kBAAA;EfwgCF;Een8BQ;IAtEN,cAAA;IACA,mBAAA;Ef4gCF;Eev8BQ;IAtEN,cAAA;IACA,UAAA;EfghCF;Ee38BQ;IAtEN,cAAA;IACA,mBAAA;EfohCF;Ee/8BQ;IAtEN,cAAA;IACA,mBAAA;EfwhCF;Een9BQ;IAtEN,cAAA;IACA,UAAA;Ef4hCF;Eev9BQ;IAtEN,cAAA;IACA,mBAAA;EfgiCF;Ee39BQ;IAtEN,cAAA;IACA,mBAAA;EfoiCF;Ee/9BQ;IAtEN,cAAA;IACA,UAAA;EfwiCF;Een+BQ;IAtEN,cAAA;IACA,mBAAA;Ef4iCF;Eev+BQ;IAtEN,cAAA;IACA,mBAAA;EfgjCF;Ee3+BQ;IAtEN,cAAA;IACA,WAAA;EfojCF;Eev+BU;IA9DV,cAAA;EfwiCA;Ee1+BU;IA9DV,wBAAA;Ef2iCA;Ee7+BU;IA9DV,yBAAA;Ef8iCA;Eeh/BU;IA9DV,gBAAA;EfijCA;Een/BU;IA9DV,yBAAA;EfojCA;Eet/BU;IA9DV,yBAAA;EfujCA;Eez/BU;IA9DV,gBAAA;Ef0jCA;Ee5/BU;IA9DV,yBAAA;Ef6jCA;Ee//BU;IA9DV,yBAAA;EfgkCA;EelgCU;IA9DV,gBAAA;EfmkCA;EergCU;IA9DV,yBAAA;EfskCA;EexgCU;IA9DV,yBAAA;EfykCA;EehgCM;;IAEE,gBAAA;EfkgCR;Ee//BM;;IAEE,gBAAA;EfigCR;EexgCM;;IAEE,sBAAA;Ef0gCR;EevgCM;;IAEE,sBAAA;EfygCR;EehhCM;;IAEE,qBAAA;EfkhCR;Ee/gCM;;IAEE,qBAAA;EfihCR;EexhCM;;IAEE,mBAAA;Ef0hCR;EevhCM;;IAEE,mBAAA;EfyhCR;EehiCM;;IAEE,qBAAA;EfkiCR;Ee/hCM;;IAEE,qBAAA;EfiiCR;EexiCM;;IAEE,mBAAA;Ef0iCR;EeviCM;;IAEE,mBAAA;EfyiCR;AACF;AazmCI;EE+BE;IAtDJ,cAAA;IACA,WAAA;EfooCA;EezkCQ;IAtEN,cAAA;IACA,kBAAA;EfkpCF;Ee7kCQ;IAtEN,cAAA;IACA,mBAAA;EfspCF;EejlCQ;IAtEN,cAAA;IACA,UAAA;Ef0pCF;EerlCQ;IAtEN,cAAA;IACA,mBAAA;Ef8pCF;EezlCQ;IAtEN,cAAA;IACA,mBAAA;EfkqCF;Ee7lCQ;IAtEN,cAAA;IACA,UAAA;EfsqCF;EejmCQ;IAtEN,cAAA;IACA,mBAAA;Ef0qCF;EermCQ;IAtEN,cAAA;IACA,mBAAA;Ef8qCF;EezmCQ;IAtEN,cAAA;IACA,UAAA;EfkrCF;Ee7mCQ;IAtEN,cAAA;IACA,mBAAA;EfsrCF;EejnCQ;IAtEN,cAAA;IACA,mBAAA;Ef0rCF;EernCQ;IAtEN,cAAA;IACA,WAAA;Ef8rCF;EejnCU;IA9DV,cAAA;EfkrCA;EepnCU;IA9DV,wBAAA;EfqrCA;EevnCU;IA9DV,yBAAA;EfwrCA;Ee1nCU;IA9DV,gBAAA;Ef2rCA;Ee7nCU;IA9DV,yBAAA;Ef8rCA;EehoCU;IA9DV,yBAAA;EfisCA;EenoCU;IA9DV,gBAAA;EfosCA;EetoCU;IA9DV,yBAAA;EfusCA;EezoCU;IA9DV,yBAAA;Ef0sCA;Ee5oCU;IA9DV,gBAAA;Ef6sCA;Ee/oCU;IA9DV,yBAAA;EfgtCA;EelpCU;IA9DV,yBAAA;EfmtCA;Ee1oCM;;IAEE,gBAAA;Ef4oCR;EezoCM;;IAEE,gBAAA;Ef2oCR;EelpCM;;IAEE,sBAAA;EfopCR;EejpCM;;IAEE,sBAAA;EfmpCR;Ee1pCM;;IAEE,qBAAA;Ef4pCR;EezpCM;;IAEE,qBAAA;Ef2pCR;EelqCM;;IAEE,mBAAA;EfoqCR;EejqCM;;IAEE,mBAAA;EfmqCR;Ee1qCM;;IAEE,qBAAA;Ef4qCR;EezqCM;;IAEE,qBAAA;Ef2qCR;EelrCM;;IAEE,mBAAA;EforCR;EejrCM;;IAEE,mBAAA;EfmrCR;AACF;AanvCI;EE+BE;IAtDJ,cAAA;IACA,WAAA;Ef8wCA;EentCQ;IAtEN,cAAA;IACA,kBAAA;Ef4xCF;EevtCQ;IAtEN,cAAA;IACA,mBAAA;EfgyCF;Ee3tCQ;IAtEN,cAAA;IACA,UAAA;EfoyCF;Ee/tCQ;IAtEN,cAAA;IACA,mBAAA;EfwyCF;EenuCQ;IAtEN,cAAA;IACA,mBAAA;Ef4yCF;EevuCQ;IAtEN,cAAA;IACA,UAAA;EfgzCF;Ee3uCQ;IAtEN,cAAA;IACA,mBAAA;EfozCF;Ee/uCQ;IAtEN,cAAA;IACA,mBAAA;EfwzCF;EenvCQ;IAtEN,cAAA;IACA,UAAA;Ef4zCF;EevvCQ;IAtEN,cAAA;IACA,mBAAA;Efg0CF;Ee3vCQ;IAtEN,cAAA;IACA,mBAAA;Efo0CF;Ee/vCQ;IAtEN,cAAA;IACA,WAAA;Efw0CF;Ee3vCU;IA9DV,cAAA;Ef4zCA;Ee9vCU;IA9DV,wBAAA;Ef+zCA;EejwCU;IA9DV,yBAAA;Efk0CA;EepwCU;IA9DV,gBAAA;Efq0CA;EevwCU;IA9DV,yBAAA;Efw0CA;Ee1wCU;IA9DV,yBAAA;Ef20CA;Ee7wCU;IA9DV,gBAAA;Ef80CA;EehxCU;IA9DV,yBAAA;Efi1CA;EenxCU;IA9DV,yBAAA;Efo1CA;EetxCU;IA9DV,gBAAA;Efu1CA;EezxCU;IA9DV,yBAAA;Ef01CA;Ee5xCU;IA9DV,yBAAA;Ef61CA;EepxCM;;IAEE,gBAAA;EfsxCR;EenxCM;;IAEE,gBAAA;EfqxCR;Ee5xCM;;IAEE,sBAAA;Ef8xCR;Ee3xCM;;IAEE,sBAAA;Ef6xCR;EepyCM;;IAEE,qBAAA;EfsyCR;EenyCM;;IAEE,qBAAA;EfqyCR;Ee5yCM;;IAEE,mBAAA;Ef8yCR;Ee3yCM;;IAEE,mBAAA;Ef6yCR;EepzCM;;IAEE,qBAAA;EfszCR;EenzCM;;IAEE,qBAAA;EfqzCR;Ee5zCM;;IAEE,mBAAA;Ef8zCR;Ee3zCM;;IAEE,mBAAA;Ef6zCR;AACF;Aa73CI;EE+BE;IAtDJ,cAAA;IACA,WAAA;Efw5CA;Ee71CQ;IAtEN,cAAA;IACA,kBAAA;Efs6CF;Eej2CQ;IAtEN,cAAA;IACA,mBAAA;Ef06CF;Eer2CQ;IAtEN,cAAA;IACA,UAAA;Ef86CF;Eez2CQ;IAtEN,cAAA;IACA,mBAAA;Efk7CF;Ee72CQ;IAtEN,cAAA;IACA,mBAAA;Efs7CF;Eej3CQ;IAtEN,cAAA;IACA,UAAA;Ef07CF;Eer3CQ;IAtEN,cAAA;IACA,mBAAA;Ef87CF;Eez3CQ;IAtEN,cAAA;IACA,mBAAA;Efk8CF;Ee73CQ;IAtEN,cAAA;IACA,UAAA;Efs8CF;Eej4CQ;IAtEN,cAAA;IACA,mBAAA;Ef08CF;Eer4CQ;IAtEN,cAAA;IACA,mBAAA;Ef88CF;Eez4CQ;IAtEN,cAAA;IACA,WAAA;Efk9CF;Eer4CU;IA9DV,cAAA;Efs8CA;Eex4CU;IA9DV,wBAAA;Efy8CA;Ee34CU;IA9DV,yBAAA;Ef48CA;Ee94CU;IA9DV,gBAAA;Ef+8CA;Eej5CU;IA9DV,yBAAA;Efk9CA;Eep5CU;IA9DV,yBAAA;Efq9CA;Eev5CU;IA9DV,gBAAA;Efw9CA;Ee15CU;IA9DV,yBAAA;Ef29CA;Ee75CU;IA9DV,yBAAA;Ef89CA;Eeh6CU;IA9DV,gBAAA;Efi+CA;Een6CU;IA9DV,yBAAA;Efo+CA;Eet6CU;IA9DV,yBAAA;Efu+CA;Ee95CM;;IAEE,gBAAA;Efg6CR;Ee75CM;;IAEE,gBAAA;Ef+5CR;Eet6CM;;IAEE,sBAAA;Efw6CR;Eer6CM;;IAEE,sBAAA;Efu6CR;Ee96CM;;IAEE,qBAAA;Efg7CR;Ee76CM;;IAEE,qBAAA;Ef+6CR;Eet7CM;;IAEE,mBAAA;Efw7CR;Eer7CM;;IAEE,mBAAA;Efu7CR;Ee97CM;;IAEE,qBAAA;Efg8CR;Ee77CM;;IAEE,qBAAA;Ef+7CR;Eet8CM;;IAEE,mBAAA;Efw8CR;Eer8CM;;IAEE,mBAAA;Efu8CR;AACF;AavgDI;EE+BE;IAtDJ,cAAA;IACA,WAAA;EfkiDA;Eev+CQ;IAtEN,cAAA;IACA,kBAAA;EfgjDF;Ee3+CQ;IAtEN,cAAA;IACA,mBAAA;EfojDF;Ee/+CQ;IAtEN,cAAA;IACA,UAAA;EfwjDF;Een/CQ;IAtEN,cAAA;IACA,mBAAA;Ef4jDF;Eev/CQ;IAtEN,cAAA;IACA,mBAAA;EfgkDF;Ee3/CQ;IAtEN,cAAA;IACA,UAAA;EfokDF;Ee//CQ;IAtEN,cAAA;IACA,mBAAA;EfwkDF;EengDQ;IAtEN,cAAA;IACA,mBAAA;Ef4kDF;EevgDQ;IAtEN,cAAA;IACA,UAAA;EfglDF;Ee3gDQ;IAtEN,cAAA;IACA,mBAAA;EfolDF;Ee/gDQ;IAtEN,cAAA;IACA,mBAAA;EfwlDF;EenhDQ;IAtEN,cAAA;IACA,WAAA;Ef4lDF;Ee/gDU;IA9DV,cAAA;EfglDA;EelhDU;IA9DV,wBAAA;EfmlDA;EerhDU;IA9DV,yBAAA;EfslDA;EexhDU;IA9DV,gBAAA;EfylDA;Ee3hDU;IA9DV,yBAAA;Ef4lDA;Ee9hDU;IA9DV,yBAAA;Ef+lDA;EejiDU;IA9DV,gBAAA;EfkmDA;EepiDU;IA9DV,yBAAA;EfqmDA;EeviDU;IA9DV,yBAAA;EfwmDA;Ee1iDU;IA9DV,gBAAA;Ef2mDA;Ee7iDU;IA9DV,yBAAA;Ef8mDA;EehjDU;IA9DV,yBAAA;EfinDA;EexiDM;;IAEE,gBAAA;Ef0iDR;EeviDM;;IAEE,gBAAA;EfyiDR;EehjDM;;IAEE,sBAAA;EfkjDR;Ee/iDM;;IAEE,sBAAA;EfijDR;EexjDM;;IAEE,qBAAA;Ef0jDR;EevjDM;;IAEE,qBAAA;EfyjDR;EehkDM;;IAEE,mBAAA;EfkkDR;Ee/jDM;;IAEE,mBAAA;EfikDR;EexkDM;;IAEE,qBAAA;Ef0kDR;EevkDM;;IAEE,qBAAA;EfykDR;EehlDM;;IAEE,mBAAA;EfklDR;Ee/kDM;;IAEE,mBAAA;EfilDR;AACF;AgB5sDA;EACE,0BAAA;EACA,yCAAA;EACA,iCAAA;EACA,0CAAA;EACA,gCAAA;EACA,6BAAA;EACA,+BAAA;EACA,4BAAA;EAEA,WAAA;EACA,mBZ0OO;EYzOP,cfOS;EeNT,mBZogB4B;EYngB5B,qBAAA;AhB6sDF;AgBtsDE;EACE,sBAAA;EACA,oCAAA;EACA,wBZ4U0B;EY3U1B,wDAAA;AhBwsDJ;AgBrsDE;EACE,uBAAA;AhBusDJ;AgBpsDE;EACE,sBAAA;AhBssDJ;AgBlsDE;EACE,iCZqgB0B;AJ+rC9B;;AgB3rDA;EACE,iBAAA;AhB8rDF;;AgBprDE;EACE,wBAAA;AhBurDJ;;AgBxqDE;EACE,mBAAA;AhB2qDJ;AgBxqDI;EACE,mBAAA;AhB0qDN;;AgBnqDE;EACE,sBAAA;AhBsqDJ;;AgB7pDE;EACE,gDAAA;EACA,oCAAA;AhBgqDJ;;AgBxpDA;EACE,+CAAA;EACA,mCAAA;AhB2pDF;;AgBnpDE;EACE,8CAAA;EACA,kCAAA;AhBspDJ;;AiB9wDE;EAME,uCAAA;EACA,kDAAA;EACA,8BAAA;EACA,iDAAA;EACA,6BAAA;EACA,gDAAA;EACA,4BAAA;EAEA,WAbQ;EAcR,yCAAA;AjB2wDJ;;AiB1xDE;EAME,qCAAA;EACA,kDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,kDAAA;EACA,4BAAA;EAEA,WAbQ;EAcR,wCAAA;AjBuxDJ;;AiBtyDE;EAME,qCAAA;EACA,kDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,iDAAA;EACA,4BAAA;EAEA,WAbQ;EAcR,wCAAA;AjBmyDJ;;AiBlzDE;EAME,qCAAA;EACA,kDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,kDAAA;EACA,4BAAA;EAEA,WAbQ;EAcR,wCAAA;AjB+yDJ;;AiB9zDE;EAME,qCAAA;EACA,kDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,kDAAA;EACA,4BAAA;EAEA,WAbQ;EAcR,wCAAA;AjB2zDJ;;AiB10DE;EAME,qCAAA;EACA,+CAAA;EACA,8BAAA;EACA,8CAAA;EACA,6BAAA;EACA,iDAAA;EACA,4BAAA;EAEA,WAbQ;EAcR,sCAAA;AjBu0DJ;;AiBt1DE;EAME,sBAAA;EACA,+CAAA;EACA,8BAAA;EACA,8CAAA;EACA,6BAAA;EACA,gDAAA;EACA,4BAAA;EAEA,WAbQ;EAcR,sCAAA;AjBm1DJ;;AiBl2DE;EAME,sBAAA;EACA,+CAAA;EACA,8BAAA;EACA,2CAAA;EACA,6BAAA;EACA,gDAAA;EACA,4BAAA;EAEA,WAbQ;EAcR,mCAAA;AjB+1DJ;;AgB/tDI;EACE,gBAAA;EACA,iCAAA;AhBkuDN;;AazyDI;EGqEA;IACE,gBAAA;IACA,iCAAA;EhBwuDJ;AACF;AahzDI;EGqEA;IACE,gBAAA;IACA,iCAAA;EhB8uDJ;AACF;AatzDI;EGqEA;IACE,gBAAA;IACA,iCAAA;EhBovDJ;AACF;Aa5zDI;EGqEA;IACE,gBAAA;IACA,iCAAA;EhB0vDJ;AACF;Aal0DI;EGqEA;IACE,gBAAA;IACA,iCAAA;EhBgwDJ;AACF;AkBh5DA;EACE,qBd0pBsC;AJwvCxC;;AkBz4DA;EACE,iCAAA;EACA,oCAAA;EACA,gBAAA;EboRI,kBALI;Ea3QR,gBdka4B;AJw+C9B;;AkBt4DA;EACE,+BAAA;EACA,kCAAA;Eb0QI,iBALI;ALqoDV;;AkBt4DA;EACE,gCAAA;EACA,mCAAA;EboQI,mBALI;AL2oDV;;AmBv6DA;EACE,mBfkpBsC;EClXlC,kBALI;EcvRR,clBaS;AD25DX;;AoB76DA;EACE,cAAA;EACA,WAAA;EACA,yBAAA;Ef8RI,kBALI;EetRR,gBhBua4B;EgBta5B,gBhB4a4B;EgB3a5B,cnBWS;EmBVT,sBnBGM;EmBFN,4BAAA;EACA,yBAAA;EACA,wBAAA;UAAA,gBAAA;EdGE,sBAAA;EeHE,wEDMJ;ApB26DF;AqB76DM;EDhBN;ICiBQ,gBAAA;ErBg7DN;AACF;AoB96DE;EACE,gBAAA;ApBg7DJ;AoB96DI;EACE,eAAA;ApBg7DN;AoB36DE;EACE,cnBXO;EmBYP,sBnBnBI;EmBoBJ,iEnBsHuB;EmBrHvB,UAAA;EAKE,iDhByiB0B;AJg4ChC;AoBl6DE;EAEE,aAAA;ApBm6DJ;AoB/5DE;EACE,cnBlCO;EmBoCP,UAAA;ApBg6DJ;AoBx5DE;EAEE,yBnBlDO;EmBqDP,UAAA;ApBu5DJ;AoBn5DE;EACE,yBAAA;EACA,0BAAA;EACA,2BhB4f0B;UgB5f1B,0BhB4f0B;EgB3f1B,cnBxDO;EqBnBT,iDrByHqB;EmB5CnB,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,4BhBmR0B;EgBlR1B,gBAAA;ECtEE,6FDuEF;ECvEE,qFDuEF;ApBq5DJ;AoBj6DE;EACE,yBAAA;EACA,0BAAA;EACA,2BhB4f0B;UgB5f1B,0BhB4f0B;EgB3f1B,cnBxDO;EqBnBT,iDrByHqB;EmB5CnB,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,4BhBmR0B;EgBlR1B,gBAAA;ECtEE,qFDuEF;ApBq5DJ;AqBx9DM;EDuDJ;ICtDM,wBAAA;IAAA,gBAAA;ErB29DN;EoBr6DA;ICtDM,gBAAA;ErB29DN;AACF;AoBv5DE;EACE,sDhB6vB8B;AJ4pClC;AoB15DE;EACE,sDhB6vB8B;AJ4pClC;AoBt5DE;EACE,yBAAA;EACA,0BAAA;EACA,2BhBye0B;UgBze1B,0BhBye0B;EgBxe1B,cnB3EO;EqBnBT,iDrByHqB;EmBzBnB,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,4BhBgQ0B;EgB/P1B,gBAAA;ECzFE,6FD0FF;EC1FE,qFD0FF;ApBw5DJ;AqB9+DM;ED0EJ;ICzEM,wBAAA;IAAA,gBAAA;ErBi/DN;AACF;AoB15DE;EACE,sDhB0uB8B;AJkrClC;;AoBn5DA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBhB2T4B;EgB1T5B,cnBtGS;EmBuGT,6BAAA;EACA,yBAAA;EACA,mBAAA;ApBs5DF;AoBp5DE;EAEE,gBAAA;EACA,eAAA;ApBq5DJ;;AoB14DA;EACE,wChBkkBsC;EgBjkBtC,uBAAA;EfmJI,mBALI;EC7QN,qBAAA;AN8gEJ;AoB34DE;EACE,uBAAA;EACA,wBAAA;EACA,0BhB6b0B;UgB7b1B,yBhB6b0B;AJg9C9B;AoBh5DE;EACE,uBAAA;EACA,wBAAA;EACA,0BhB6b0B;UgB7b1B,yBhB6b0B;AJg9C9B;AoB14DE;EACE,uBAAA;EACA,wBAAA;EACA,0BhBub0B;UgBvb1B,yBhBub0B;AJq9C9B;;AoBx4DA;EACE,sChBgjBsC;EgB/iBtC,oBAAA;EfgII,iBALI;EC7QN,qBAAA;AN+hEJ;AoBz4DE;EACE,oBAAA;EACA,qBAAA;EACA,wBhB8a0B;UgB9a1B,uBhB8a0B;AJ69C9B;AoB94DE;EACE,oBAAA;EACA,qBAAA;EACA,wBhB8a0B;UgB9a1B,uBhB8a0B;AJ69C9B;AoBx4DE;EACE,oBAAA;EACA,qBAAA;EACA,wBhBwa0B;UgBxa1B,uBhBwa0B;AJk+C9B;;AoBl4DE;EACE,yChBuhBoC;AJ82CxC;AoBl4DE;EACE,wChBohBoC;AJg3CxC;AoBj4DE;EACE,sChBihBoC;AJk3CxC;;AoB93DA;EACE,eAAA;EACA,YAAA;EACA,iBhB8X4B;AJmgD9B;AoB/3DE;EACE,eAAA;ApBi4DJ;AoB93DE;EACE,aAAA;Ed/LA,sBAAA;ANgkEJ;AoB73DE;EACE,aAAA;EdpMA,sBAAA;ANokEJ;;AuBllEA;EACE,cAAA;EACA,WAAA;EACA,0CAAA;EAEA,uCAAA;ElB2RI,kBALI;EkBnRR,gBnBoa4B;EmBna5B,gBnBya4B;EmBxa5B,ctBQS;EsBPT,sBAAA;EACA,yDAAA;EACA,4BAAA;EACA,yCnBgxBkC;EmB/wBlC,0BnBgxBkC;EmB/wBlC,yBAAA;EjBFE,sBAAA;EeHE,wEEQJ;EACA,wBAAA;UAAA,gBAAA;AvBklEF;AqBvlEM;EEfN;IFgBQ,gBAAA;ErB0lEN;AACF;AuBrlEE;EACE,iEtB8HuB;EsB7HvB,UAAA;EAKE,iDnBixB4B;AJk0ClC;AuB/kEE;EAEE,sBnBkiB0B;EmBjiB1B,sBAAA;AvBglEJ;AuB7kEE;EAEE,yBtB5BO;AD0mEX;AuBzkEE;EACE,kBAAA;EACA,0BAAA;AvB2kEJ;;AuBvkEA;EACE,oBnB2hB4B;EmB1hB5B,uBnB0hB4B;EmBzhB5B,oBnB0hB4B;ECjTxB,mBALI;ALu2DV;;AuBvkEA;EACE,mBnBwhB4B;EmBvhB5B,sBnBuhB4B;EmBthB5B,kBnBuhB4B;ECrTxB,iBALI;AL82DV;;AwB1oEA;EACE,cAAA;EACA,mBpBqtBwC;EoBptBxC,mBpBqtBwC;EoBptBxC,uBpBqtBwC;AJw7C1C;AwB3oEE;EACE,WAAA;EACA,mBAAA;AxB6oEJ;;AwBzoEA;EACE,UpBysBwC;EoBxsBxC,WpBwsBwC;EoBvsBxC,kBAAA;EACA,mBAAA;EACA,sBvBLM;EuBMN,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,qCpB4sBwC;EoB3sBxC,wBAAA;UAAA,gBAAA;EACA,iCAAA;UAAA,yBAAA;AxB4oEF;AwBzoEE;ElBXE,qBAAA;ANupEJ;AwBxoEE;EAEE,kBpBmsBsC;AJs8C1C;AwBtoEE;EACE,uBpB0rBsC;AJ88C1C;AwBroEE;EACE,iEvB8GuB;EuB7GvB,UAAA;EACA,iDpBqiB4B;AJkmDhC;AwBpoEE;EACE,yBvBJI;EuBKJ,qBvBLI;AD2oER;AwBpoEI;EAII,yDAAA;AxBmoER;AwB/nEI;EAII,yDAAA;AxB8nER;AwBznEE;EACE,yBvBzBI;EuB0BJ,qBvB1BI;EuB+BF,yDAAA;AxBunEN;AwBnnEE;EACE,oBAAA;EACA,YAAA;EACA,YpBkqBuC;AJm9C3C;AwB9mEI;EACE,YpB0pBqC;AJs9C3C;;AwBlmEA;EACE,mBpBqpBgC;AJg9ClC;AwBnmEE;EACE,UpBipB8B;EoBhpB9B,mBAAA;EACA,yDAAA;EACA,gCAAA;ElB9FA,kBAAA;EeHE,iDGmGF;AxBqmEJ;AqBpsEM;EGyFJ;IHxFM,gBAAA;ErBusEN;AACF;AwBxmEI;EACE,yDAAA;AxB0mEN;AwBvmEI;EACE,iCpBgpB4B;EoB3oB1B,yDAAA;AxBqmER;;AwB/lEA;EACE,qBAAA;EACA,kBpBmnBgC;AJ++ClC;;AwB/lEA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;AxBkmEF;AwB9lEI;EACE,oBAAA;EACA,YAAA;EACA,apBuewB;AJynD9B;;AyB9uEA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,6BAAA;EACA,wBAAA;UAAA,gBAAA;AzBivEF;AyB/uEE;EACE,UAAA;AzBivEJ;AyB7uEI;EAA0B,iErB4zBa;AJo7C3C;AyB/uEI;EAA0B,iErB2zBa;AJu7C3C;AyB/uEE;EACE,SAAA;AzBivEJ;AyB9uEE;EACE,WrB6yBuC;EqB5yBvC,YrB4yBuC;EqB3yBvC,oBAAA;EHzBF,yBrB0CM;EwBfJ,SrB4yBuC;EExzBvC,mBAAA;EeHE,oHIkBF;EJlBE,4GIkBF;EACA,wBAAA;UAAA,gBAAA;AzB+uEJ;AqB9vEM;EIMJ;IJLM,wBAAA;IAAA,gBAAA;ErBiwEN;AACF;AyBlvEI;EHjCF,0ClB40ByC;AJ08C3C;AyBhvEE;EACE,WrBsxB8B;EqBrxB9B,crBsxB8B;EqBrxB9B,kBAAA;EACA,erBqxB8B;EqBpxB9B,yBxB5BO;EwB6BP,yBAAA;EnB7BA,mBAAA;ANgxEJ;AyB9uEE;EACE,WrBkxBuC;EqBjxBvC,YrBixBuC;EkBp0BzC,yBrB0CM;EwBWJ,SrBkxBuC;EExzBvC,mBAAA;EeHE,iHI4CF;EJ5CE,4GI4CF;EACA,gBAAA;AzB+uEJ;AqBxxEM;EIiCJ;IJhCM,qBAAA;IAAA,gBAAA;ErB2xEN;AACF;AyBlvEI;EH3DF,0ClB40ByC;AJo+C3C;AyBhvEE;EACE,WrB4vB8B;EqB3vB9B,crB4vB8B;EqB3vB9B,kBAAA;EACA,erB2vB8B;EqB1vB9B,yBxBtDO;EwBuDP,yBAAA;EnBvDA,mBAAA;AN0yEJ;AyB9uEE;EACE,oBAAA;AzBgvEJ;AyB9uEI;EACE,yBxB9DK;AD8yEX;AyB7uEI;EACE,yBxBlEK;ADizEX;;A0Bt0EA;EACE,kBAAA;A1By0EF;A0Bv0EE;;EAEE,0BtBu1B8B;EsBt1B9B,iBtBu1B8B;AJk/ClC;A0Bt0EE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,qBAAA;EACA,oBAAA;EACA,6BAAA;EACA,qBAAA;ELDE,gEKEF;A1Bw0EJ;AqBt0EM;EKXJ;ILYM,gBAAA;ErBy0EN;AACF;A0Bz0EE;EACE,qBAAA;A1B20EJ;A0Bz0EI;EACE,kBAAA;A1B20EN;A0Bx0EI;EAEE,qBtBi0B4B;EsBh0B5B,wBtBi0B4B;AJwgDlC;A0Bt0EI;EACE,qBtB4zB4B;EsB3zB5B,wBtB4zB4B;AJ4gDlC;A0Bp0EE;EACE,qBtBszB8B;EsBrzB9B,wBtBszB8B;AJghDlC;A0Bh0EI;;;EACE,atBgzB4B;EsB/yB5B,8DtBgzB4B;AJohDlC;A0B/zEI;EACE,atByyB4B;EsBxyB5B,8DtByyB4B;AJwhDlC;;A2Bv3EA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A3B03EF;A2Bx3EE;;EAEE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;A3B03EJ;A2Bt3EE;;EAEE,UAAA;A3Bw3EJ;A2Bl3EE;EACE,kBAAA;EACA,UAAA;A3Bo3EJ;A2Bl3EI;EACE,UAAA;A3Bo3EN;;A2Bz2EA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EtBsPI,kBALI;EsB/OR,gBvBgY4B;EuB/X5B,gBvBqY4B;EuBpY5B,c1B5BS;E0B6BT,kBAAA;EACA,mBAAA;EACA,iD1BuEqB;E0BtErB,yBAAA;ErBpCE,sBAAA;ANi5EJ;;A2Bn2EA;;;;EAIE,oBAAA;EtBgOI,iBALI;EC7QN,qBAAA;AN05EJ;;A2Bn2EA;;;;EAIE,uBAAA;EtBuNI,mBALI;EC7QN,qBAAA;ANm6EJ;;A2Bn2EA;;EAEE,mBAAA;A3Bs2EF;;A2Bz1EI;;ErB/DA,0BAAA;EACA,6BAAA;AN65EJ;A2Bx1EI;;ErBtEA,0BAAA;EACA,6BAAA;ANk6EJ;A2Bl1EE;EACE,iBAAA;ErBpEA,yBAAA;EACA,4BAAA;ANy5EJ;;A4Bl7EE;EACE,aAAA;EACA,WAAA;EACA,mBxB2nBoC;EClXlC,kBALI;EuBjQN,cxBw1BqB;AJ4lDzB;;A4Bj7EE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EvB4PE,mBALI;EuBpPN,WAvBc;EAwBd,yCAvBiB;EtBHjB,sBAAA;AN88EJ;;A4B/6EI;;;;EAEE,cAAA;A5Bo7EN;;A4Bl+EI;EAoDE,qBxB6zBmB;EwB1zBjB,oCxBipBgC;EwBhpBhC,yDAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;A5Bg7ER;A4B76EM;EACE,qBxBkzBiB;EwBjzBjB,kDA/Ca;A5B89ErB;;A4B/+EI;EAyEI,oCxB+nBgC;EwB9nBhC,kFAAA;A5B06ER;;A4Bp/EI;EAiFE,qBxBgyBmB;AJuoDzB;A4Bp6EQ;EAEE,uBxB4sB8B;EwB3sB9B,kGAAA;EACA,+DAAA;EACA,2EAAA;A5Bq6EV;A4Bj6EM;EACE,qBxBmxBiB;EwBlxBjB,kDA9Ea;A5Bi/ErB;;A4BlgFI;EAsGE,qBxB2wBmB;AJqpDzB;A4B95EM;EACE,yBxBwwBiB;AJwpDzB;A4B75EM;EACE,kDA5Fa;A5B2/ErB;A4B55EM;EACE,cxBgwBiB;AJ8pDzB;;A4Bz5EI;EACE,kBAAA;A5B45EN;;A4BnhFI;;;EA+HI,UAAA;A5B05ER;A4Bt5EM;;;EACE,UAAA;A5B05ER;;A4B3gFE;EACE,aAAA;EACA,WAAA;EACA,mBxB2nBoC;EClXlC,kBALI;EuBjQN,cxBw1BqB;AJqrDzB;;A4B1gFE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EvB4PE,mBALI;EuBpPN,WAvBc;EAwBd,wCAvBiB;EtBHjB,sBAAA;ANuiFJ;;A4BxgFI;;;;EAEE,cAAA;A5B6gFN;;A4B3jFI;EAoDE,qBxB6zBmB;EwB1zBjB,oCxBipBgC;EwBhpBhC,yDAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;A5BygFR;A4BtgFM;EACE,qBxBkzBiB;EwBjzBjB,iDA/Ca;A5BujFrB;;A4BxkFI;EAyEI,oCxB+nBgC;EwB9nBhC,kFAAA;A5BmgFR;;A4B7kFI;EAiFE,qBxBgyBmB;AJguDzB;A4B7/EQ;EAEE,uBxB4sB8B;EwB3sB9B,kGAAA;EACA,+DAAA;EACA,2EAAA;A5B8/EV;A4B1/EM;EACE,qBxBmxBiB;EwBlxBjB,iDA9Ea;A5B0kFrB;;A4B3lFI;EAsGE,qBxB2wBmB;AJ8uDzB;A4Bv/EM;EACE,yBxBwwBiB;AJivDzB;A4Bt/EM;EACE,iDA5Fa;A5BolFrB;A4Br/EM;EACE,cxBgwBiB;AJuvDzB;;A4Bl/EI;EACE,kBAAA;A5Bq/EN;;A4B5mFI;;;EAiII,UAAA;A5Bi/ER;A4B/+EM;;;EACE,UAAA;A5Bm/ER;;A6BznFA;EACE,qBAAA;EAEA,gBzB0a4B;EyBza5B,gBzB+a4B;EyB9a5B,c5BcS;E4BbT,kBAAA;EACA,qBAAA;EAEA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6BAAA;EACA,6BAAA;EC8GA,yBAAA;EzBsKI,kBALI;EC7QN,sBAAA;EeHE,qFQGJ;A7B4nFF;AqB3nFM;EQhBN;IRiBQ,gBAAA;ErB8nFN;AACF;A6B/nFE;EACE,c5BCO;ADgoFX;A6B7nFE;EAEE,UAAA;EACA,gB5BqEmB;ADyjFvB;A6BhnFE;EAGE,oBAAA;EACA,azB4kB0B;AJoiE9B;;A6BpmFE;ECvCA,WAXQ;ERLR,yBrBiFa;E6B/Db,qB7B+Da;ADglFf;A8B5oFE;EACE,WAdY;ERRd,wCQMmB;EAkBjB,oCAjBa;A9B+pFjB;A8B3oFE;EAEE,WArBY;ERRd,wCQMmB;EAyBjB,oCAxBa;EA6BX,qDAAA;A9BwoFN;A8BpoFE;EAKE,WAlCa;EAmCb,wCArCkB;EAwClB,qBAvCc;A9BuqFlB;A8B9nFI;EAKI,qDAAA;A9B4nFR;A8BvnFE;EAEE,WAjDe;EAkDf,yB7BiBW;E6BdX,qB7BcW;ADwmFf;;A6BloFE;ECvCA,WAXQ;ERLR,yBrBiFa;E6B/Db,qB7B+Da;AD8mFf;A8B1qFE;EACE,WAdY;ERRd,0CQMmB;EAkBjB,kCAjBa;A9B6rFjB;A8BzqFE;EAEE,WArBY;ERRd,0CQMmB;EAyBjB,kCAxBa;EA6BX,mDAAA;A9BsqFN;A8BlqFE;EAKE,WAlCa;EAmCb,sCArCkB;EAwClB,mCAvCc;A9BqsFlB;A8B5pFI;EAKI,mDAAA;A9B0pFR;A8BrpFE;EAEE,WAjDe;EAkDf,yB7BiBW;E6BdX,qB7BcW;ADsoFf;;A6BhqFE;ECvCA,WAXQ;ERLR,yBrBiFa;E6B/Db,qB7B+Da;AD4oFf;A8BxsFE;EACE,WAdY;ERRd,2CQMmB;EAkBjB,mCAjBa;A9B2tFjB;A8BvsFE;EAEE,WArBY;ERRd,2CQMmB;EAyBjB,mCAxBa;EA6BX,kDAAA;A9BosFN;A8BhsFE;EAKE,WAlCa;EAmCb,uCArCkB;EAwClB,mCAvCc;A9BmuFlB;A8B1rFI;EAKI,kDAAA;A9BwrFR;A8BnrFE;EAEE,WAjDe;EAkDf,yB7BiBW;E6BdX,qB7BcW;ADoqFf;;A6B9rFE;ECvCA,WAXQ;ERLR,yBrBiFa;E6B/Db,qB7B+Da;AD0qFf;A8BtuFE;EACE,WAdY;ERRd,wCQMmB;EAkBjB,mCAjBa;A9ByvFjB;A8BruFE;EAEE,WArBY;ERRd,wCQMmB;EAyBjB,mCAxBa;EA6BX,mDAAA;A9BkuFN;A8B9tFE;EAKE,WAlCa;EAmCb,uCArCkB;EAwClB,mCAvCc;A9BiwFlB;A8BxtFI;EAKI,mDAAA;A9BstFR;A8BjtFE;EAEE,WAjDe;EAkDf,yB7BiBW;E6BdX,qB7BcW;ADksFf;;A6B5tFE;ECvCA,WAXQ;ERLR,yBrBiFa;E6B/Db,qB7B+Da;ADwsFf;A8BpwFE;EACE,WAdY;ERRd,0CQMmB;EAkBjB,mCAjBa;A9BuxFjB;A8BnwFE;EAEE,WArBY;ERRd,0CQMmB;EAyBjB,mCAxBa;EA6BX,mDAAA;A9BgwFN;A8B5vFE;EAKE,WAlCa;EAmCb,uCArCkB;EAwClB,mCAvCc;A9B+xFlB;A8BtvFI;EAKI,mDAAA;A9BovFR;A8B/uFE;EAEE,WAjDe;EAkDf,yB7BiBW;E6BdX,qB7BcW;ADguFf;;A6B1vFE;ECvCA,WAXQ;ERLR,yBrBiFa;E6B/Db,qB7B+Da;ADsuFf;A8BlyFE;EACE,WAdY;ERRd,wCQMmB;EAkBjB,kCAjBa;A9BqzFjB;A8BjyFE;EAEE,WArBY;ERRd,wCQMmB;EAyBjB,kCAxBa;EA6BX,kDAAA;A9B8xFN;A8B1xFE;EAKE,WAlCa;EAmCb,sCArCkB;EAwClB,oCAvCc;A9B6zFlB;A8BpxFI;EAKI,kDAAA;A9BkxFR;A8B7wFE;EAEE,WAjDe;EAkDf,yB7BiBW;E6BdX,qB7BcW;AD8vFf;;A6BxxFE;ECvCA,WAXQ;ERLR,yBrBiFa;E6B/Db,qB7B+Da;ADowFf;A8Bh0FE;EACE,WAdY;ERRd,6CQMmB;EAkBjB,sCAjBa;A9Bm1FjB;A8B/zFE;EAEE,WArBY;ERRd,6CQMmB;EAyBjB,sCAxBa;EA6BX,kDAAA;A9B4zFN;A8BxzFE;EAKE,WAlCa;EAmCb,0CArCkB;EAwClB,sCAvCc;A9B21FlB;A8BlzFI;EAKI,kDAAA;A9BgzFR;A8B3yFE;EAEE,WAjDe;EAkDf,yB7BiBW;E6BdX,qB7BcW;AD4xFf;;A6BtzFE;ECvCA,WAXQ;ERLR,yBrBiFa;E6B/Db,qB7B+Da;ADkyFf;A8B91FE;EACE,WAdY;ERRd,uCQMmB;EAkBjB,mCAjBa;A9Bi3FjB;A8B71FE;EAEE,WArBY;ERRd,uCQMmB;EAyBjB,mCAxBa;EA6BX,kDAAA;A9B01FN;A8Bt1FE;EAKE,WAlCa;EAmCb,uCArCkB;EAwClB,+BAvCc;A9By3FlB;A8Bh1FI;EAKI,kDAAA;A9B80FR;A8Bz0FE;EAEE,WAjDe;EAkDf,yB7BiBW;E6BdX,qB7BcW;AD0zFf;;A6Bp1FE;ECvCA,WAXQ;ERLR,yBrBiFa;E6B/Db,qB7B+Da;ADg0Ff;A8B53FE;EACE,WAdY;ERRd,uCQMmB;EAkBjB,mCAjBa;A9B+4FjB;A8B33FE;EAEE,WArBY;ERRd,uCQMmB;EAyBjB,mCAxBa;EA6BX,mDAAA;A9Bw3FN;A8Bp3FE;EAKE,WAlCa;EAmCb,uCArCkB;EAwClB,qBAvCc;A9Bu5FlB;A8B92FI;EAKI,mDAAA;A9B42FR;A8Bv2FE;EAEE,WAjDe;EAkDf,yB7BiBW;E6BdX,qB7BcW;ADw1Ff;;A6Bl3FE;ECvCA,WAXQ;ERLR,yBrBiFa;E6B/Db,qB7B+Da;AD81Ff;A8B15FE;EACE,WAdY;ERRd,0CQMmB;EAkBjB,qCAjBa;A9B66FjB;A8Bz5FE;EAEE,WArBY;ERRd,0CQMmB;EAyBjB,qCAxBa;EA6BX,oDAAA;A9Bs5FN;A8Bl5FE;EAKE,WAlCa;EAmCb,yCArCkB;EAwClB,mCAvCc;A9Bq7FlB;A8B54FI;EAKI,oDAAA;A9B04FR;A8Br4FE;EAEE,WAjDe;EAkDf,yB7BiBW;E6BdX,qB7BcW;ADs3Ff;;A6B14FE;ECmBA,c7BCa;E6BAb,qBAAA;A9B23FF;A8Bz3FE;EACE,WATY;EAUZ,yB7BJW;E6BKX,qB7BLW;ADg4Ff;A8Bx3FE;EAEE,0CAAA;A9By3FJ;A8Bt3FE;EAKE,WArBa;EAsBb,yB7BnBW;E6BoBX,qB7BpBW;ADw4Ff;A8Bl3FI;EAKI,0CAAA;A9Bg3FR;A8B32FE;EAEE,c7BlCW;E6BmCX,6BAAA;A9B42FJ;;A6Bn6FE;ECmBA,c7BCa;E6BAb,qBAAA;A9Bo5FF;A8Bl5FE;EACE,WATY;EAUZ,yB7BJW;E6BKX,qB7BLW;ADy5Ff;A8Bj5FE;EAEE,4CAAA;A9Bk5FJ;A8B/4FE;EAKE,WArBa;EAsBb,yB7BnBW;E6BoBX,qB7BpBW;ADi6Ff;A8B34FI;EAKI,4CAAA;A9By4FR;A8Bp4FE;EAEE,c7BlCW;E6BmCX,6BAAA;A9Bq4FJ;;A6B57FE;ECmBA,c7BCa;E6BAb,qBAAA;A9B66FF;A8B36FE;EACE,WATY;EAUZ,yB7BJW;E6BKX,qB7BLW;ADk7Ff;A8B16FE;EAEE,2CAAA;A9B26FJ;A8Bx6FE;EAKE,WArBa;EAsBb,yB7BnBW;E6BoBX,qB7BpBW;AD07Ff;A8Bp6FI;EAKI,2CAAA;A9Bk6FR;A8B75FE;EAEE,c7BlCW;E6BmCX,6BAAA;A9B85FJ;;A6Br9FE;ECmBA,c7BCa;E6BAb,qBAAA;A9Bs8FF;A8Bp8FE;EACE,WATY;EAUZ,yB7BJW;E6BKX,qB7BLW;AD28Ff;A8Bn8FE;EAEE,2CAAA;A9Bo8FJ;A8Bj8FE;EAKE,WArBa;EAsBb,yB7BnBW;E6BoBX,qB7BpBW;ADm9Ff;A8B77FI;EAKI,2CAAA;A9B27FR;A8Bt7FE;EAEE,c7BlCW;E6BmCX,6BAAA;A9Bu7FJ;;A6B9+FE;ECmBA,c7BCa;E6BAb,qBAAA;A9B+9FF;A8B79FE;EACE,WATY;EAUZ,yB7BJW;E6BKX,qB7BLW;ADo+Ff;A8B59FE;EAEE,2CAAA;A9B69FJ;A8B19FE;EAKE,WArBa;EAsBb,yB7BnBW;E6BoBX,qB7BpBW;AD4+Ff;A8Bt9FI;EAKI,2CAAA;A9Bo9FR;A8B/8FE;EAEE,c7BlCW;E6BmCX,6BAAA;A9Bg9FJ;;A6BvgGE;ECmBA,c7BCa;E6BAb,qBAAA;A9Bw/FF;A8Bt/FE;EACE,WATY;EAUZ,yB7BJW;E6BKX,qB7BLW;AD6/Ff;A8Br/FE;EAEE,0CAAA;A9Bs/FJ;A8Bn/FE;EAKE,WArBa;EAsBb,yB7BnBW;E6BoBX,qB7BpBW;ADqgGf;A8B/+FI;EAKI,0CAAA;A9B6+FR;A8Bx+FE;EAEE,c7BlCW;E6BmCX,6BAAA;A9By+FJ;;A6BhiGE;ECmBA,c7BCa;E6BAb,qBAAA;A9BihGF;A8B/gGE;EACE,WATY;EAUZ,yB7BJW;E6BKX,qB7BLW;ADshGf;A8B9gGE;EAEE,4CAAA;A9B+gGJ;A8B5gGE;EAKE,WArBa;EAsBb,yB7BnBW;E6BoBX,qB7BpBW;AD8hGf;A8BxgGI;EAKI,4CAAA;A9BsgGR;A8BjgGE;EAEE,c7BlCW;E6BmCX,6BAAA;A9BkgGJ;;A6BzjGE;ECmBA,c7BCa;E6BAb,qBAAA;A9B0iGF;A8BxiGE;EACE,WATY;EAUZ,yB7BJW;E6BKX,qB7BLW;AD+iGf;A8BviGE;EAEE,yCAAA;A9BwiGJ;A8BriGE;EAKE,WArBa;EAsBb,yB7BnBW;E6BoBX,qB7BpBW;ADujGf;A8BjiGI;EAKI,yCAAA;A9B+hGR;A8B1hGE;EAEE,c7BlCW;E6BmCX,6BAAA;A9B2hGJ;;A6BllGE;ECmBA,c7BCa;E6BAb,qBAAA;A9BmkGF;A8BjkGE;EACE,WATY;EAUZ,yB7BJW;E6BKX,qB7BLW;ADwkGf;A8BhkGE;EAEE,yCAAA;A9BikGJ;A8B9jGE;EAKE,WArBa;EAsBb,yB7BnBW;E6BoBX,qB7BpBW;ADglGf;A8B1jGI;EAKI,yCAAA;A9BwjGR;A8BnjGE;EAEE,c7BlCW;E6BmCX,6BAAA;A9BojGJ;;A6B3mGE;ECmBA,c7BCa;E6BAb,qBAAA;A9B4lGF;A8B1lGE;EACE,WATY;EAUZ,yB7BJW;E6BKX,qB7BLW;ADimGf;A8BzlGE;EAEE,2CAAA;A9B0lGJ;A8BvlGE;EAKE,WArBa;EAsBb,yB7BnBW;E6BoBX,qB7BpBW;ADymGf;A8BnlGI;EAKI,2CAAA;A9BilGR;A8B5kGE;EAEE,c7BlCW;E6BmCX,6BAAA;A9B6kGJ;;A6BxnGA;EACE,gBzBmW4B;EyBlW5B,c5BjCM;E4BkCN,0BzBgNwC;AJ26F1C;A6BznGE;EACE,6BzB+MsC;AJ46F1C;A6BnnGE;EAEE,c5BvEO;AD2rGX;;A6BzmGA;ECuBE,oBAAA;EzBsKI,iBALI;EC7QN,qBAAA;ANosGJ;;A6B3mGA;ECmBE,uBAAA;EzBsKI,mBALI;EC7QN,qBAAA;AN0sGJ;;A+B7tGA;EVgBM,gCUfJ;A/BguGF;AqB7sGM;EUpBN;IVqBQ,gBAAA;ErBgtGN;AACF;A+BnuGE;EACE,UAAA;A/BquGJ;;A+B/tGE;EACE,aAAA;A/BkuGJ;;A+B9tGA;EACE,SAAA;EACA,gBAAA;EVDI,6BUEJ;A/BiuGF;AqB/tGM;EULN;IVMQ,gBAAA;ErBkuGN;AACF;;AgCvvGA;;;;EAIE,kBAAA;AhC0vGF;;AgCvvGA;EACE,mBAAA;AhC0vGF;AiCruGI;EACE,qBAAA;EACA,oB7BwWwB;E6BvWxB,uB7BsWwB;E6BrWxB,WAAA;EAhCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;AjCwwGF;AiCntGI;EACE,cAAA;AjCqtGN;;AgChwGA;EACE,kBAAA;EACA,a5Bu3BkC;E4Bt3BlC,aAAA;EACA,gB/BuFmB;E+BtFnB,kBAAA;EACA,SAAA;E3B+QI,kBALI;E2BxQR,c/BDS;E+BET,gBAAA;EACA,gBAAA;EACA,sB/BXM;E+BYN,4BAAA;EACA,qCAAA;E1BVE,sBAAA;AN8wGJ;AgChwGE;EACE,SAAA;EACA,OAAA;EACA,oB5B+7BgC;AJm0EpC;;AgCtvGI;EACE,oBAAA;AhCyvGN;AgCvvGM;EACE,WAAA;EACA,OAAA;AhCyvGR;;AgCrvGI;EACE,kBAAA;AhCwvGN;AgCtvGM;EACE,QAAA;EACA,UAAA;AhCwvGR;;AavvGI;EmBfA;IACE,oBAAA;EhC0wGJ;EgCxwGI;IACE,WAAA;IACA,OAAA;EhC0wGN;EgCtwGE;IACE,kBAAA;EhCwwGJ;EgCtwGI;IACE,QAAA;IACA,UAAA;EhCwwGN;AACF;AaxwGI;EmBfA;IACE,oBAAA;EhC0xGJ;EgCxxGI;IACE,WAAA;IACA,OAAA;EhC0xGN;EgCtxGE;IACE,kBAAA;EhCwxGJ;EgCtxGI;IACE,QAAA;IACA,UAAA;EhCwxGN;AACF;AaxxGI;EmBfA;IACE,oBAAA;EhC0yGJ;EgCxyGI;IACE,WAAA;IACA,OAAA;EhC0yGN;EgCtyGE;IACE,kBAAA;EhCwyGJ;EgCtyGI;IACE,QAAA;IACA,UAAA;EhCwyGN;AACF;AaxyGI;EmBfA;IACE,oBAAA;EhC0zGJ;EgCxzGI;IACE,WAAA;IACA,OAAA;EhC0zGN;EgCtzGE;IACE,kBAAA;EhCwzGJ;EgCtzGI;IACE,QAAA;IACA,UAAA;EhCwzGN;AACF;AaxzGI;EmBfA;IACE,oBAAA;EhC00GJ;EgCx0GI;IACE,WAAA;IACA,OAAA;EhC00GN;EgCt0GE;IACE,kBAAA;EhCw0GJ;EgCt0GI;IACE,QAAA;IACA,UAAA;EhCw0GN;AACF;AgC/zGE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,uB5Bu5BgC;AJ06EpC;AiC/2GI;EACE,qBAAA;EACA,oB7BwWwB;E6BvWxB,uB7BsWwB;E6BrWxB,WAAA;EAzBJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;AjC24GF;AiC71GI;EACE,cAAA;AjC+1GN;;AgCr0GE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,qB5By4BgC;AJ+7EpC;AiCp4GI;EACE,qBAAA;EACA,oB7BwWwB;E6BvWxB,uB7BsWwB;E6BrWxB,WAAA;EAlBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;AjCy5GF;AiCl3GI;EACE,cAAA;AjCo3GN;AgCh1GI;EACE,iBAAA;AhCk1GN;;AgC50GE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sB5Bw3BgC;AJu9EpC;AiC55GI;EACE,qBAAA;EACA,oB7BwWwB;E6BvWxB,uB7BsWwB;E6BrWxB,WAAA;AjC85GN;AiCn5GM;EACE,aAAA;AjCq5GR;AiCl5GM;EACE,qBAAA;EACA,qB7BqVsB;E6BpVtB,uB7BmVsB;E6BlVtB,WAAA;EA9BN,mCAAA;EACA,yBAAA;EACA,sCAAA;AjCm7GF;AiCl5GI;EACE,cAAA;AjCo5GN;AgC/1GI;EACE,iBAAA;AhCi2GN;;AgC11GA;EACE,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,yCAAA;AhC61GF;;AgCv1GA;EACE,cAAA;EACA,WAAA;EACA,oBAAA;EACA,WAAA;EACA,gB5B0S4B;E4BzS5B,c/B/GS;E+BgHT,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;AhC01GF;AgC50GE;EAEE,4B5Bm1BgC;EkB5+BlC,yBrBwGuB;AD+3GzB;AgCz0GE;EAEE,W/BpJI;E+BqJJ,qBAAA;EVjKF,yBrB0CM;ADk8GR;AgCv0GE;EAEE,c/BtJO;E+BuJP,oBAAA;EACA,6BAAA;AhCw0GJ;;AgCl0GA;EACE,cAAA;AhCq0GF;;AgCj0GA;EACE,cAAA;EACA,qB5Bk0BkC;E4Bj0BlC,gBAAA;E3B0GI,mBALI;E2BnGR,c/BvKS;E+BwKT,mBAAA;AhCo0GF;;AgCh0GA;EACE,cAAA;EACA,oBAAA;EACA,c/B5KS;AD++GX;;AgC/zGA;EACE,c/BvLS;E+BwLT,yB/BnLS;E+BoLT,iC5B2xBkC;AJuiFpC;AgC/zGE;EACE,c/B7LO;AD8/GX;AgC/zGI;EAEE,W/BpME;EqBZN,2ClBmgCkC;AJ8gFpC;AgC7zGI;EAEE,W/B1ME;EqBZN,yBrB0CM;AD2+GR;AgC3zGI;EAEE,c/B3MK;ADugHX;AgCxzGE;EACE,iC5BkwBgC;AJwjFpC;AgCvzGE;EACE,c/BtNO;AD+gHX;AgCtzGE;EACE,c/BxNO;ADghHX;;AkCpiHA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;AlCuiHF;AkCriHE;;EACE,kBAAA;EACA,cAAA;AlCwiHJ;AkCniHE;;;;;;;;;;;;EAME,UAAA;AlC2iHJ;;AkCtiHA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;AlCyiHF;AkCviHE;EACE,WAAA;AlCyiHJ;;AkCniHE;;EAEE,iBAAA;AlCsiHJ;AkCliHE;;E5BRE,0BAAA;EACA,6BAAA;AN8iHJ;AkC9hHE;;;E5BHE,yBAAA;EACA,4BAAA;ANsiHJ;;AkCjhHA;EACE,wBAAA;EACA,uBAAA;AlCohHF;AkClhHE;EAGE,cAAA;AlCkhHJ;AkC/gHE;EACE,eAAA;AlCihHJ;;AkC7gHA;EACE,uBAAA;EACA,sBAAA;AlCghHF;;AkC7gHA;EACE,sBAAA;EACA,qBAAA;AlCghHF;;AkC5/GA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;AlC+/GF;AkC7/GE;;EAEE,WAAA;AlC+/GJ;AkC5/GE;;EAEE,gBAAA;AlC8/GJ;AkC1/GE;;E5BvFE,6BAAA;EACA,4BAAA;ANqlHJ;AkC1/GE;;E5B1GE,yBAAA;EACA,0BAAA;ANwmHJ;;AmChoHA;EACE,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AnCmoHF;;AmChoHA;EACE,cAAA;EACA,oBAAA;EAGA,clC4BM;EkC3BN,qBAAA;EdHI,uGcIJ;AnCioHF;AqBjoHM;EcPN;IdQQ,gBAAA;ErBooHN;AACF;AmCpoHE;EAEE,6B/B0QsC;AJ23G1C;AmChoHE;EACE,clCRO;EkCSP,oBAAA;EACA,eAAA;AnCkoHJ;;AmC1nHA;EACE,gCAAA;AnC6nHF;AmC3nHE;EACE,mBAAA;EACA,gBAAA;EACA,6BAAA;E7BlBA,+BAAA;EACA,gCAAA;ANgpHJ;AmC5nHI;EAEE,qC/Bg3B8B;E+B92B9B,kBAAA;AnC4nHN;AmCznHI;EACE,clCnCK;EkCoCL,6BAAA;EACA,yBAAA;AnC2nHN;AmCvnHE;;EAEE,clC1CO;EkC2CP,sBlCtDM;EkCuDN,kC/Bm2BgC;AJsxFpC;AmCtnHE;EAEE,gBAAA;E7B5CA,yBAAA;EACA,0BAAA;ANoqHJ;;AmC9mHE;EACE,gBAAA;EACA,SAAA;E7BlEA,sBAAA;ANorHJ;AmC9mHE;;EAEE,WlC3EI;EqBZN,yBrB0CM;AD8pHR;;AmCvmHE;;EAEE,cAAA;EACA,kBAAA;AnC0mHJ;;AmCrmHE;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;AnCwmHJ;;AmClmHE;;EACE,WAAA;AnCsmHJ;;AmC7lHE;EACE,aAAA;AnCgmHJ;AmC9lHE;EACE,cAAA;AnCgmHJ;;AmC7lHA;EACE,yBAAA;AnCgmHF;;AoCztHA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBhC25BkC;EgCz5BlC,sBhCy5BkC;AJk0FpC;AoCptHE;;;;;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;ApC4tHJ;AoCxsHA;EACE,qBhCk4BkC;EgCj4BlC,wBhCi4BkC;EgCh4BlC,kBhCi4BkC;ECtpB9B,iBALI;E+BpOR,qBAAA;EACA,mBAAA;ApC0sHF;AoC7rHA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;ApC+rHF;AoC7rHE;EACE,gBAAA;EACA,eAAA;ApC+rHJ;AoC5rHE;EACE,gBAAA;ApC8rHJ;;AoCrrHA;EACE,mBhCszBkC;EgCrzBlC,sBhCqzBkC;AJm4FpC;;AoC5qHA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;ApC6qHF;;AoCzqHA;EACE,wBAAA;E/B6KI,iBALI;E+BtKR,cAAA;EACA,6BAAA;EACA,6BAAA;E9BzGE,sBAAA;EeHE,wCe8GJ;ApC4qHF;AqBtxHM;EemGN;IflGQ,gBAAA;ErByxHN;AACF;AoC/qHE;EACE,qBAAA;ApCirHJ;AoC9qHE;EACE,qBAAA;EACA,UAAA;EACA,mBAAA;ApCgrHJ;;AoC1qHA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;ApC6qHF;;AoC1qHA;EACE,gBAAA;EAAA,yCAAA;EACA,gBAAA;ApC6qHF;;AavwHI;EuBsGA;IAEI,iBAAA;IACA,2BAAA;EpCoqHN;EoClqHM;IACE,mBAAA;EpCoqHR;EoClqHQ;IACE,kBAAA;EpCoqHV;EoCjqHQ;IACE,qBhCkwBwB;IgCjwBxB,oBhCiwBwB;EJk6FlC;EoC/pHM;IACE,iBAAA;EpCiqHR;EoC9pHM;IACE,wBAAA;IACA,gBAAA;EpCgqHR;EoC7pHM;IACE,aAAA;EpC+pHR;AACF;AalyHI;EuBsGA;IAEI,iBAAA;IACA,2BAAA;EpC8rHN;EoC5rHM;IACE,mBAAA;EpC8rHR;EoC5rHQ;IACE,kBAAA;EpC8rHV;EoC3rHQ;IACE,qBhCkwBwB;IgCjwBxB,oBhCiwBwB;EJ47FlC;EoCzrHM;IACE,iBAAA;EpC2rHR;EoCxrHM;IACE,wBAAA;IACA,gBAAA;EpC0rHR;EoCvrHM;IACE,aAAA;EpCyrHR;AACF;Aa5zHI;EuBsGA;IAEI,iBAAA;IACA,2BAAA;EpCwtHN;EoCttHM;IACE,mBAAA;EpCwtHR;EoCttHQ;IACE,kBAAA;EpCwtHV;EoCrtHQ;IACE,qBhCkwBwB;IgCjwBxB,oBhCiwBwB;EJs9FlC;EoCntHM;IACE,iBAAA;EpCqtHR;EoCltHM;IACE,wBAAA;IACA,gBAAA;EpCotHR;EoCjtHM;IACE,aAAA;EpCmtHR;AACF;Aat1HI;EuBsGA;IAEI,iBAAA;IACA,2BAAA;EpCkvHN;EoChvHM;IACE,mBAAA;EpCkvHR;EoChvHQ;IACE,kBAAA;EpCkvHV;EoC/uHQ;IACE,qBhCkwBwB;IgCjwBxB,oBhCiwBwB;EJg/FlC;EoC7uHM;IACE,iBAAA;EpC+uHR;EoC5uHM;IACE,wBAAA;IACA,gBAAA;EpC8uHR;EoC3uHM;IACE,aAAA;EpC6uHR;AACF;Aah3HI;EuBsGA;IAEI,iBAAA;IACA,2BAAA;EpC4wHN;EoC1wHM;IACE,mBAAA;EpC4wHR;EoC1wHQ;IACE,kBAAA;EpC4wHV;EoCzwHQ;IACE,qBhCkwBwB;IgCjwBxB,oBhCiwBwB;EJ0gGlC;EoCvwHM;IACE,iBAAA;EpCywHR;EoCtwHM;IACE,wBAAA;IACA,gBAAA;EpCwwHR;EoCrwHM;IACE,aAAA;EpCuwHR;AACF;AoCpyHI;EAEI,iBAAA;EACA,2BAAA;ApCqyHR;AoCnyHQ;EACE,mBAAA;ApCqyHV;AoCnyHU;EACE,kBAAA;ApCqyHZ;AoClyHU;EACE,qBhCkwBwB;EgCjwBxB,oBhCiwBwB;AJmiGpC;AoChyHQ;EACE,iBAAA;ApCkyHV;AoC/xHQ;EACE,wBAAA;EACA,gBAAA;ApCiyHV;AoC9xHQ;EACE,aAAA;ApCgyHV;;AoCjxHE;EACE,yBhC8vBgC;AJshGpC;AoClxHI;EAEE,yBhC0vB8B;AJyhGpC;AoC9wHI;EACE,0BhCkvB8B;AJ8hGpC;AoC9wHM;EAEE,yBhC+uB4B;AJgiGpC;AoC5wHM;EACE,yBhC6uB4B;AJiiGpC;AoC1wHI;;EAEE,yBhCsuB8B;AJsiGpC;AoCxwHE;EACE,0BhC+tBgC;EgC9tBhC,gChCmuBgC;AJuiGpC;AoCvwHE;EACE,yDAAA;ApCywHJ;AoCtwHE;EACE,0BhCstBgC;AJkjGpC;AoCtwHI;;;EAGE,yBhCmtB8B;AJqjGpC;;AoCjwHE;EACE,WnCpPI;ADw/HR;AoClwHI;EAEE,WnCxPE;AD2/HR;AoC9vHI;EACE,gChCwrB8B;AJwkGpC;AoC9vHM;EAEE,gChCqrB4B;AJ0kGpC;AoC5vHM;EACE,gChCmrB4B;AJ2kGpC;AoC1vHI;;EAEE,WnC5QE;ADwgIR;AoCxvHE;EACE,gChCqqBgC;EgCpqBhC,sChCyqBgC;AJilGpC;AoCvvHE;EACE,0DAAA;ApCyvHJ;AoCtvHE;EACE,gChC4pBgC;AJ4lGpC;AoCvvHI;;;EAGE,WnC9RE;ADuhIR;;AqCniIA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EAEA,qBAAA;EACA,sBpCKM;EoCJN,2BAAA;EACA,2EAAA;E/BME,sBAAA;ANgiIJ;AqCniIE;EACE,eAAA;EACA,cAAA;ArCqiIJ;AqCliIE;EACE,mBAAA;EACA,sBAAA;ArCoiIJ;AqCliII;EACE,mBAAA;E/BEF,2CAAA;EACA,4CAAA;ANmiIJ;AqCliII;EACE,sBAAA;E/BWF,+CAAA;EACA,8CAAA;AN0hIJ;AqC/hIE;;EAEE,aAAA;ArCiiIJ;;AqC7hIA;EAGE,cAAA;EACA,kBAAA;ArC8hIF;;AqC1hIA;EACE,qBjCwgCkC;AJqhGpC;;AqC1hIA;EACE,oBAAA;EACA,gBAAA;ArC6hIF;;AqC1hIA;EACE,gBAAA;ArC6hIF;;AqCzhIE;EACE,qBAAA;ArC4hIJ;AqCzhIE;EACE,iBjCkLK;AJy2HT;;AqCnhIA;EACE,oBAAA;EACA,gBAAA;EAEA,sBpCnEM;EoCoEN,kFAAA;ArCqhIF;AqCnhIE;E/BnEE,0DAAA;ANylIJ;;AqCjhIA;EACE,oBAAA;EAEA,sBpC9EM;EoC+EN,+EAAA;ArCmhIF;AqCjhIE;E/B9EE,0DAAA;ANkmIJ;;AqC1gIA;EACE,qBAAA;EACA,sBAAA;EACA,oBAAA;EACA,gBAAA;ArC6gIF;;AqCngIA;EACE,qBAAA;EACA,oBAAA;ArCsgIF;;AqClgIA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,ajCoHO;EEtOL,kCAAA;ANwnIJ;;AqClgIA;;;EAGE,WAAA;ArCqgIF;;AqClgIA;;E/BnHI,2CAAA;EACA,4CAAA;AN0nIJ;;AqCngIA;;E/B1GI,+CAAA;EACA,8CAAA;ANknIJ;;AqC5/HE;EACE,sBjCw6BgC;AJulGpC;AalmII;EwB+FJ;IAQI,aAAA;IACA,mBAAA;ErC+/HF;EqC5/HE;IAEE,SAAA;IACA,gBAAA;ErC6/HJ;EqC3/HI;IACE,cAAA;IACA,cAAA;ErC6/HN;EqCx/HM;I/BnJJ,0BAAA;IACA,6BAAA;EN8oIF;EqCz/HQ;;IAGE,0BAAA;ErC0/HV;EqCx/HQ;;IAGE,6BAAA;ErCy/HV;EqCr/HM;I/BpJJ,yBAAA;IACA,4BAAA;EN4oIF;EqCt/HQ;;IAGE,yBAAA;ErCu/HV;EqCr/HQ;;IAGE,4BAAA;ErCs/HV;AACF;;AsCnsIA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;EjC4RI,kBALI;EiCrRR,crCYS;EqCXT,gBAAA;EACA,sBrCDQ;EqCER,SAAA;EhCKE,gBAAA;EgCHF,qBAAA;EjBAI,+GiBCJ;AtCssIF;AqBnsIM;EiBhBN;IjBiBQ,gBAAA;ErBssIN;AACF;AsCzsIE;EACE,6BlC8kCsC;EkC7kCtC,0ClC4kCsC;EkC3kCtC,+CAAA;AtC2sIJ;AsCzsII;EACE,0DAAA;EACA,0BlCilCoC;AJ0nG1C;AsCtsIE;EACE,cAAA;EACA,clCskCsC;EkCrkCtC,elCqkCsC;EkCpkCtC,iBAAA;EACA,WAAA;EACA,0DAAA;EACA,4BAAA;EACA,wBlCgkCsC;EiBvlCpC,sCiBwBF;AtCwsIJ;AqB5tIM;EiBWJ;IjBVM,gBAAA;ErB+tIN;AACF;AsC1sIE;EACE,UAAA;AtC4sIJ;AsCzsIE;EACE,UAAA;EACA,iErCyGuB;EqCxGvB,UAAA;EACA,gBrC+CmB;AD4pIvB;;AsCvsIA;EACE,gBAAA;AtC0sIF;;AsCvsIA;EACE,sBrChDQ;AD0vIV;AsCvsIE;EhCnCE,+BAAA;EACA,gCAAA;AN6uIJ;AsCxsII;EhCtCA,2CAAA;EACA,4CAAA;ANivIJ;AsCvsIE;EACE,aAAA;AtCysIJ;AsCrsIE;EhClCE,mCAAA;EACA,kCAAA;AN0uIJ;AsCrsIM;EhCtCF,+CAAA;EACA,8CAAA;AN8uIJ;AsCpsII;EhC3CA,mCAAA;EACA,kCAAA;ANkvIJ;;AsClsIA;EACE,qBAAA;AtCqsIF;;AsC5rIE;EACE,eAAA;AtC+rIJ;AsC5rIE;EACE,eAAA;EACA,cAAA;EhCxFA,gBAAA;ANuxIJ;AsC5rII;EAAgB,aAAA;AtC+rIpB;AsC9rII;EAAe,gBAAA;AtCisInB;AsC/rII;EhC9FA,gBAAA;ANgyIJ;;AuCnzIA;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,mBnC60CkC;EmC30ClC,gBAAA;AvCqzIF;;AuC9yIE;EACE,oBnCk0CgC;AJ++FpC;AuC/yII;EACE,WAAA;EACA,qBnC8zC8B;EmC7zC9B,ctCGK;EsCFL,yDAAA;EAAA,uFAAA;AvCizIN;AuC7yIE;EACE,ctCHO;ADkzIX;;AwCx0IA;EACE,aAAA;EhCGA,eAAA;EACA,gBAAA;ARy0IF;;AwCz0IA;EACE,kBAAA;EACA,cAAA;EACA,cvCsCM;EuCrCN,qBAAA;EACA,sBvCMM;EuCLN,yBAAA;EnBKI,qImBJJ;AxC40IF;AqBp0IM;EmBfN;InBgBQ,gBAAA;ErBu0IN;AACF;AwC/0IE;EACE,UAAA;EACA,6BpCkRsC;EoChRtC,yBAAA;EACA,qBAAA;AxCg1IJ;AwC70IE;EACE,UAAA;EACA,6BpC0QsC;EoCzQtC,yBvCPO;EuCQP,UpCygCgC;EoCxgChC,gBvCyE0B;ADswI9B;;AwC10IE;EACE,iBpC4/BgC;AJi1GpC;AwC10IE;EACE,UAAA;EACA,WvCtBI;EqBZN,yBrB0CM;EuCNJ,qBvCMI;ADs0IR;AwCz0IE;EACE,cvCtBO;EuCuBP,oBAAA;EACA,sBvC9BI;EuC+BJ,qBvC5BO;ADu2IX;;AyCt3IE;EACE,yBAAA;AzCy3IJ;;AyCl3IQ;EnCqCJ,+BAAA;EACA,kCAAA;ANi1IJ;AyCj3IQ;EnCiBJ,gCAAA;EACA,mCAAA;ANm2IJ;;AyCn4IE;EACE,uBAAA;EpCgSE,iBALI;AL4mIV;AyCh4IQ;EnCqCJ,8BAAA;EACA,iCAAA;AN81IJ;AyC93IQ;EnCiBJ,+BAAA;EACA,kCAAA;ANg3IJ;;AyCh5IE;EACE,uBAAA;EpCgSE,mBALI;ALynIV;AyC74IQ;EnCqCJ,8BAAA;EACA,iCAAA;AN22IJ;AyC34IQ;EnCiBJ,+BAAA;EACA,kCAAA;AN63IJ;;A0C55IA;EACE,qBAAA;EACA,sBAAA;ErC8RI,iBALI;EqCvRR,gBtCya4B;EsCxa5B,cAAA;EACA,WzCKM;EyCJN,kBAAA;EACA,mBAAA;EACA,wBAAA;EpCKE,sBAAA;AN25IJ;A0C35IE;EACE,aAAA;A1C65IJ;;A0Cx5IA;EACE,kBAAA;EACA,SAAA;A1C25IF;;A2Cl7IA;EACE,kBAAA;EACA,kBAAA;EACA,mBvCuvC8B;EuCtvC9B,6BAAA;ErCWE,sBAAA;AN26IJ;;A2Cj7IA;EAEE,cAAA;A3Cm7IF;;A2C/6IA;EACE,gBvC8Z4B;AJohI9B;;A2C16IA;EACE,mBvCwuC8B;AJqsGhC;A2C16IE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,qBAAA;A3C46IJ;;A2C75IE;EClDA,6BD8Cc;ErB5Cd,0CqB0CmB;EC1CnB,sCD2Ce;A3Cw6IjB;A4Cj9IE;EACE,gCAAA;A5Cm9IJ;;A2Ct6IE;EClDA,0BD8Cc;ErB5Cd,wCqB0CmB;EC1CnB,oCD2Ce;A3Ci7IjB;A4C19IE;EACE,4BAAA;A5C49IJ;;A2C/6IE;EClDA,2BD8Cc;ErB5Cd,wCqB0CmB;EC1CnB,oCD2Ce;A3C07IjB;A4Cn+IE;EACE,4BAAA;A5Cq+IJ;;A2Cx7IE;EClDA,4BD8Cc;ErB5Cd,wCqB0CmB;EC1CnB,oCD2Ce;A3Cm8IjB;A4C5+IE;EACE,+BAAA;A5C8+IJ;;A2Cj8IE;EClDA,0BDgDgB;ErB9ChB,wCqB0CmB;EC1CnB,oCD2Ce;A3C48IjB;A4Cr/IE;EACE,8BAAA;A5Cu/IJ;;A2C18IE;EClDA,2BD8Cc;ErB5Cd,wCqB0CmB;EC1CnB,sCD2Ce;A3Cq9IjB;A4C9/IE;EACE,+BAAA;A5CggJJ;;A2Cn9IE;EClDA,4BDgDgB;ErB9ChB,0CqB0CmB;EC1CnB,sCD2Ce;A3C89IjB;A4CvgJE;EACE,+BAAA;A5CygJJ;;A2C59IE;EClDA,4BD8Cc;ErB5Cd,0CqB0CmB;EC1CnB,sCD2Ce;A3Cu+IjB;A4ChhJE;EACE,+BAAA;A5CkhJJ;;A2Cr+IE;EClDA,4BD8Cc;ErB5Cd,0CqB0CmB;EC1CnB,sCD2Ce;A3Cg/IjB;A4CzhJE;EACE,+BAAA;A5C2hJJ;;A2C9+IE;EClDA,4BD8Cc;ErB5Cd,0CqB0CmB;EC1CnB,sCD2Ce;A3Cy/IjB;A4CliJE;EACE,+BAAA;A5CoiJJ;;A6CviJE;EACE;IAAK,2BzCuwC2B;EJoyGlC;AACF;A6CviJA;EACE,aAAA;EACA,YzCgwCkC;EyC/vClC,gBAAA;ExCwRI,kBALI;EwCjRR,yB5CGS;EKCP,sBAAA;ANsiJJ;;A6CriJA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,W5CTM;E4CUN,kBAAA;EACA,mBAAA;EACA,yB5CkBM;EoB9BF,2BwBaJ;A7CwiJF;AqBjjJM;EwBAN;IxBCQ,gBAAA;ErBojJN;AACF;;A6C1iJA;EvBYE,qMAAA;EuBVA,0BAAA;A7C6iJF;;A6CziJE;EACE,kDAAA;A7C4iJJ;A6CziJM;EAJJ;IAKM,eAAA;E7C4iJN;AACF;;A8CplJA;EACE,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;ExCSE,sBAAA;AN6kJJ;;A8CllJA;EACE,qBAAA;EACA,sBAAA;A9CqlJF;A8CnlJE;EAEE,oCAAA;EACA,0BAAA;A9ColJJ;;A8C1kJA;EACE,WAAA;EACA,c7CVS;E6CWT,mBAAA;A9C6kJF;A8C1kJE;EAEE,UAAA;EACA,c7CjBO;E6CkBP,qBAAA;EACA,yB7CzBO;ADomJX;A8CxkJE;EACE,c7CvBO;E6CwBP,yB7C7BO;ADumJX;;A8CjkJA;EACE,kBAAA;EACA,cAAA;EACA,oBAAA;EACA,c7CnCS;E6CoCT,qBAAA;EACA,sB7C9CM;E6C+CN,yCAAA;A9CokJF;A8ClkJE;ExCrCE,+BAAA;EACA,gCAAA;AN0mJJ;A8ClkJE;ExC3BE,mCAAA;EACA,kCAAA;ANgmJJ;A8ClkJE;EAEE,c7CrDO;E6CsDP,oBAAA;EACA,sB7C7DI;ADgoJR;A8C/jJE;EACE,UAAA;EACA,W7CnEI;E6CoEJ,yB7CtCI;E6CuCJ,qB7CvCI;ADwmJR;A8C9jJE;EACE,mBAAA;A9CgkJJ;A8C9jJI;EACE,gBAAA;EACA,qB1C2QwB;AJqzI9B;;A8CljJI;EACE,mBAAA;A9CqjJN;A8CljJQ;ExCrCJ,kCAAA;EAZA,0BAAA;ANumJJ;A8CjjJQ;ExCtDJ,gCAAA;EAYA,4BAAA;AN+lJJ;A8ChjJQ;EACE,aAAA;A9CkjJV;A8C/iJQ;EACE,qB1C0OoB;E0CzOpB,oBAAA;A9CijJV;A8C/iJU;EACE,iBAAA;EACA,sB1CqOkB;AJ40I9B;;AarnJI;EiC4CA;IACE,mBAAA;E9C6kJJ;E8C1kJM;IxCrCJ,kCAAA;IAZA,0BAAA;EN+nJF;E8CzkJM;IxCtDJ,gCAAA;IAYA,4BAAA;ENunJF;E8CxkJM;IACE,aAAA;E9C0kJR;E8CvkJM;IACE,qB1C0OoB;I0CzOpB,oBAAA;E9CykJR;E8CvkJQ;IACE,iBAAA;IACA,sB1CqOkB;EJo2I5B;AACF;Aa9oJI;EiC4CA;IACE,mBAAA;E9CqmJJ;E8ClmJM;IxCrCJ,kCAAA;IAZA,0BAAA;ENupJF;E8CjmJM;IxCtDJ,gCAAA;IAYA,4BAAA;EN+oJF;E8ChmJM;IACE,aAAA;E9CkmJR;E8C/lJM;IACE,qB1C0OoB;I0CzOpB,oBAAA;E9CimJR;E8C/lJQ;IACE,iBAAA;IACA,sB1CqOkB;EJ43I5B;AACF;AatqJI;EiC4CA;IACE,mBAAA;E9C6nJJ;E8C1nJM;IxCrCJ,kCAAA;IAZA,0BAAA;EN+qJF;E8CznJM;IxCtDJ,gCAAA;IAYA,4BAAA;ENuqJF;E8CxnJM;IACE,aAAA;E9C0nJR;E8CvnJM;IACE,qB1C0OoB;I0CzOpB,oBAAA;E9CynJR;E8CvnJQ;IACE,iBAAA;IACA,sB1CqOkB;EJo5I5B;AACF;Aa9rJI;EiC4CA;IACE,mBAAA;E9CqpJJ;E8ClpJM;IxCrCJ,kCAAA;IAZA,0BAAA;ENusJF;E8CjpJM;IxCtDJ,gCAAA;IAYA,4BAAA;EN+rJF;E8ChpJM;IACE,aAAA;E9CkpJR;E8C/oJM;IACE,qB1C0OoB;I0CzOpB,oBAAA;E9CipJR;E8C/oJQ;IACE,iBAAA;IACA,sB1CqOkB;EJ46I5B;AACF;AattJI;EiC4CA;IACE,mBAAA;E9C6qJJ;E8C1qJM;IxCrCJ,kCAAA;IAZA,0BAAA;EN+tJF;E8CzqJM;IxCtDJ,gCAAA;IAYA,4BAAA;ENutJF;E8CxqJM;IACE,aAAA;E9C0qJR;E8CvqJM;IACE,qB1C0OoB;I0CzOpB,oBAAA;E9CyqJR;E8CvqJQ;IACE,iBAAA;IACA,sB1CqOkB;EJo8I5B;AACF;A8C5pJA;ExC9HI,gBAAA;AN6xJJ;A8C5pJE;EACE,qBAAA;A9C8pJJ;A8C5pJI;EACE,sBAAA;A9C8pJN;;A+ClzJE;EACE,6BDiKyB;EChKzB,0CD+JsB;A9CspJ1B;A+ClzJM;EAEE,6BD2JqB;EC1JrB,6CAAA;A/CmzJR;A+ChzJM;EACE,WAAA;EACA,wCDqJqB;ECpJrB,oCDoJqB;A9C8pJ7B;;A+Ch0JE;EACE,0BDiKyB;EChKzB,wCD+JsB;A9CoqJ1B;A+Ch0JM;EAEE,0BD2JqB;EC1JrB,4CAAA;A/Ci0JR;A+C9zJM;EACE,WAAA;EACA,qCDqJqB;ECpJrB,iCDoJqB;A9C4qJ7B;;A+C90JE;EACE,2BDiKyB;EChKzB,wCD+JsB;A9CkrJ1B;A+C90JM;EAEE,2BD2JqB;EC1JrB,4CAAA;A/C+0JR;A+C50JM;EACE,WAAA;EACA,sCDqJqB;ECpJrB,kCDoJqB;A9C0rJ7B;;A+C51JE;EACE,4BDiKyB;EChKzB,wCD+JsB;A9CgsJ1B;A+C51JM;EAEE,4BD2JqB;EC1JrB,4CAAA;A/C61JR;A+C11JM;EACE,WAAA;EACA,uCDqJqB;ECpJrB,mCDoJqB;A9CwsJ7B;;A+C12JE;EACE,0BDmK2B;EClK3B,wCD+JsB;A9C8sJ1B;A+C12JM;EAEE,0BD6JuB;EC5JvB,4CAAA;A/C22JR;A+Cx2JM;EACE,WAAA;EACA,qCDuJuB;ECtJvB,iCDsJuB;A9CotJ/B;;A+Cx3JE;EACE,2BDiKyB;EChKzB,wCD+JsB;A9C4tJ1B;A+Cx3JM;EAEE,2BD2JqB;EC1JrB,0CAAA;A/Cy3JR;A+Ct3JM;EACE,WAAA;EACA,sCDqJqB;ECpJrB,kCDoJqB;A9CouJ7B;;A+Ct4JE;EACE,4BDmK2B;EClK3B,0CD+JsB;A9C0uJ1B;A+Ct4JM;EAEE,4BD6JuB;EC5JvB,6CAAA;A/Cu4JR;A+Cp4JM;EACE,WAAA;EACA,uCDuJuB;ECtJvB,mCDsJuB;A9CgvJ/B;;A+Cp5JE;EACE,4BDiKyB;EChKzB,0CD+JsB;A9CwvJ1B;A+Cp5JM;EAEE,4BD2JqB;EC1JrB,6CAAA;A/Cq5JR;A+Cl5JM;EACE,WAAA;EACA,uCDqJqB;ECpJrB,mCDoJqB;A9CgwJ7B;;A+Cl6JE;EACE,4BDiKyB;EChKzB,0CD+JsB;A9CswJ1B;A+Cl6JM;EAEE,4BD2JqB;EC1JrB,6CAAA;A/Cm6JR;A+Ch6JM;EACE,WAAA;EACA,uCDqJqB;ECpJrB,mCDoJqB;A9C8wJ7B;;A+Ch7JE;EACE,4BDiKyB;EChKzB,0CD+JsB;A9CoxJ1B;A+Ch7JM;EAEE,4BD2JqB;EC1JrB,6CAAA;A/Ci7JR;A+C96JM;EACE,WAAA;EACA,uCDqJqB;ECpJrB,mCDoJqB;A9C4xJ7B;;AgD77JA;EACE,uBAAA;EACA,U5C04C2B;E4Cz4C3B,W5Cy4C2B;E4Cx4C3B,sBAAA;EACA,W/CgBM;E+CfN,0FAAA;EACA,SAAA;E1COE,sBAAA;E0CLF,Y5C04C2B;AJsjH7B;AgD77JE;EACE,W/CQI;E+CPJ,qBAAA;EACA,a5Cq4CyB;AJ0jH7B;AgD57JE;EACE,UAAA;EACA,iD5C0jB4B;E4CzjB5B,U5Cg4CyB;AJ8jH7B;AgD37JE;EAEE,oBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,a5C03CyB;AJkkH7B;;AgDx7JA;EACE,kD5Cs3C2B;AJqkH7B;;AiDj+JA;EACE,Y7C6qCkC;E6C5qClC,eAAA;E5CmSI,mBALI;E4C3RR,oBAAA;EACA,2C7C6qCkC;E6C5qClC,4BAAA;EACA,oCAAA;EACA,6C7CmX4B;EEzW1B,sBAAA;AN09JJ;AiDj+JE;EACE,UAAA;AjDm+JJ;AiDh+JE;EACE,aAAA;AjDk+JJ;;AiD99JA;EACE,0BAAA;EAAA,kBAAA;EACA,eAAA;EACA,oBAAA;AjDi+JF;AiD/9JE;EACE,sB7CqUkB;AJ4pJtB;;AiD79JA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,chDbS;EgDcT,2C7CupCkC;E6CtpClC,4BAAA;EACA,4CAAA;E3CVE,2CAAA;EACA,4CAAA;AN2+JJ;AiD/9JE;EACE,uBAAA;EACA,oB7CooCgC;AJ61HpC;;AiD79JA;EACE,gB7C+nCkC;E6C9nClC,qBAAA;AjDg+JF;;AkD1gKA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a9Cm4BkC;E8Cl4BlC,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAGA,UAAA;AlD2gKF;;AkDpgKA;EACE,kBAAA;EACA,WAAA;EACA,c9CsrCkC;E8CprClC,oBAAA;AlDsgKF;AkDngKE;E7BlBI,mC6BmBF;EACA,8B9C4sCgC;AJyzHpC;AqBrhKM;E6BcJ;I7BbM,gBAAA;ErBwhKN;AACF;AkDxgKE;EACE,e9C0sCgC;AJg0HpC;AkDtgKE;EACE,sB9CusCgC;AJi0HpC;;AkDpgKA;EACE,yBAAA;AlDugKF;AkDrgKE;EACE,gBAAA;EACA,gBAAA;AlDugKJ;AkDpgKE;EACE,gBAAA;AlDsgKJ;;AkDlgKA;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;AlDqgKF;;AkDjgKA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAGA,oBAAA;EACA,sBjD5DM;EiD6DN,4BAAA;EACA,oCAAA;E5C3DE,qBAAA;E4C+DF,UAAA;AlDggKF;;AkD5/JA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a9CkzBkC;E8CjzBlC,YAAA;EACA,aAAA;EACA,sBjDnEM;ADkkKR;AkD5/JE;EAAS,UAAA;AlD+/JX;AkD9/JE;EAAS,Y9CioCyB;AJg4HpC;;AkD5/JA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,8BAAA;EACA,kB9C8nCkC;E8C7nClC,gCAAA;E5ChFE,0CAAA;EACA,2CAAA;ANglKJ;AkD9/JE;EACE,sBAAA;EACA,oCAAA;AlDggKJ;;AkD3/JA;EACE,gBAAA;EACA,gB9C+T4B;AJ+rJ9B;;AkDz/JA;EACE,kBAAA;EAGA,cAAA;EACA,a9CuHO;AJm4JT;;AkDt/JA;EACE,aAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,6BAAA;E5CnGE,8CAAA;EACA,6CAAA;AN6lKJ;AkDr/JE;EACE,eAAA;AlDu/JJ;;Aa5kKI;EqC4FF;IACE,gB9CglCgC;I8C/kChC,oBAAA;ElDo/JF;EkDj/JA;IACE,2BAAA;ElDm/JF;EkDh/JA;IACE,+BAAA;ElDk/JF;EkD3+JA;IAAY,gB9C+jCsB;EJ+6HlC;AACF;Aa5lKI;EqCiHF;;IAEE,gB9C2jCgC;EJm7HlC;AACF;AalmKI;EqCwHF;IAAY,iB9CujCsB;EJu7HlC;AACF;AkDt+JI;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;AlDw+JN;AkDt+JM;EACE,YAAA;EACA,SAAA;E5CrLJ,gBAAA;AN8pKJ;AkDr+JM;E5CzLF,gBAAA;ANiqKJ;AkDp+JM;EACE,gBAAA;AlDs+JR;AkDn+JM;E5CjMF,gBAAA;ANuqKJ;;Aa9mKI;EqCoHA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElD8/JJ;EkD5/JI;IACE,YAAA;IACA,SAAA;I5CrLJ,gBAAA;ENorKF;EkD3/JI;I5CzLF,gBAAA;ENurKF;EkD1/JI;IACE,gBAAA;ElD4/JN;EkDz/JI;I5CjMF,gBAAA;EN6rKF;AACF;AaroKI;EqCoHA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElDohKJ;EkDlhKI;IACE,YAAA;IACA,SAAA;I5CrLJ,gBAAA;EN0sKF;EkDjhKI;I5CzLF,gBAAA;EN6sKF;EkDhhKI;IACE,gBAAA;ElDkhKN;EkD/gKI;I5CjMF,gBAAA;ENmtKF;AACF;Aa3pKI;EqCoHA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElD0iKJ;EkDxiKI;IACE,YAAA;IACA,SAAA;I5CrLJ,gBAAA;ENguKF;EkDviKI;I5CzLF,gBAAA;ENmuKF;EkDtiKI;IACE,gBAAA;ElDwiKN;EkDriKI;I5CjMF,gBAAA;ENyuKF;AACF;AajrKI;EqCoHA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElDgkKJ;EkD9jKI;IACE,YAAA;IACA,SAAA;I5CrLJ,gBAAA;ENsvKF;EkD7jKI;I5CzLF,gBAAA;ENyvKF;EkD5jKI;IACE,gBAAA;ElD8jKN;EkD3jKI;I5CjMF,gBAAA;EN+vKF;AACF;AavsKI;EqCoHA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElDslKJ;EkDplKI;IACE,YAAA;IACA,SAAA;I5CrLJ,gBAAA;EN4wKF;EkDnlKI;I5CzLF,gBAAA;EN+wKF;EkDllKI;IACE,gBAAA;ElDolKN;EkDjlKI;I5CjMF,gBAAA;ENqxKF;AACF;AmDxyKA;EACE,kBAAA;EACA,a/C64BkC;E+C54BlC,cAAA;EACA,S/CunCkC;EgD3nClC,4MhDoa4B;EgDpa5B,sChDoa4B;EgDla5B,kBAAA;EACA,gBhD6a4B;EgD5a5B,gBhDkb4B;EgDjb5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;E/CsRI,mBALI;E8CrRR,qBAAA;EACA,UAAA;AnDozKF;AmDlzKE;EAAS,Y/C2mCyB;AJ0sIpC;AmDnzKE;EACE,kBAAA;EACA,cAAA;EACA,a/C2mCgC;E+C1mChC,c/C2mCgC;AJ0sIpC;AmDnzKI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AnDqzKN;;AmDhzKA;EACE,iBAAA;AnDmzKF;AmDjzKE;EACE,SAAA;AnDmzKJ;AmDjzKI;EACE,SAAA;EACA,6BAAA;EACA,sBlDdE;ADi0KR;;AmD9yKA;EACE,iBAAA;AnDizKF;AmD/yKE;EACE,OAAA;EACA,a/C6kCgC;E+C5kChC,c/C2kCgC;AJsuIpC;AmD/yKI;EACE,WAAA;EACA,oCAAA;EACA,wBlD9BE;AD+0KR;;AmD5yKA;EACE,iBAAA;AnD+yKF;AmD7yKE;EACE,MAAA;AnD+yKJ;AmD7yKI;EACE,YAAA;EACA,6BAAA;EACA,yBlD5CE;AD21KR;;AmD1yKA;EACE,iBAAA;AnD6yKF;AmD3yKE;EACE,QAAA;EACA,a/C+iCgC;E+C9iChC,c/C6iCgC;AJgwIpC;AmD3yKI;EACE,UAAA;EACA,oCAAA;EACA,uBlD5DE;ADy2KR;;AmDxxKA;EACE,gB/CygCkC;E+CxgClC,uBAAA;EACA,WlD9FM;EkD+FN,kBAAA;EACA,sBlDtFM;EKPJ,sBAAA;ANy3KJ;;AqD54KA;EACE,kBAAA;EACA,MAAA;EACA,wBAAA;EACA,ajD24BkC;EiD14BlC,cAAA;EACA,gBpDsIkB;EmD3IlB,4MhDoa4B;EgDpa5B,sChDoa4B;EgDla5B,kBAAA;EACA,gBhD6a4B;EgD5a5B,gBhDkb4B;EgDjb5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;E/CsRI,mBALI;EgDpRR,qBAAA;EACA,sBpDGM;EoDFN,4BAAA;EACA,2EAAA;E/CIE,qBAAA;ANs5KJ;AqDt5KE;EACE,kBAAA;EACA,cAAA;EACA,WjD6oCgC;EiD5oChC,cjD6oCgC;AJ2wIpC;AqDt5KI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;ArDu5KN;;AqDj5KE;EACE,2BAAA;ArDo5KJ;AqDl5KI;EACE,SAAA;EACA,6BAAA;EACA,2EjD4nC8B;AJwxIpC;AqDj5KI;EACE,WjDyTwB;EiDxTxB,6BAAA;EACA,sBpDjCE;ADo7KR;;AqD74KE;EACE,yBAAA;EACA,ajD2mCgC;EiD1mChC,YjDymCgC;AJuyIpC;AqD94KI;EACE,OAAA;EACA,oCAAA;EACA,6EjDwmC8B;AJwyIpC;AqD74KI;EACE,SjDqSwB;EiDpSxB,oCAAA;EACA,wBpDrDE;ADo8KR;;AqDz4KE;EACE,wBAAA;ArD44KJ;AqD14KI;EACE,MAAA;EACA,oCAAA;EACA,8EjDslC8B;AJszIpC;AqDz4KI;EACE,QjDmRwB;EiDlRxB,oCAAA;EACA,yBpDvEE;ADk9KR;AqDt4KE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,WjDkkCgC;EiDjkChC,oBAAA;EACA,WAAA;EACA,6BAAA;ArDw4KJ;;AqDn4KE;EACE,0BAAA;EACA,ajDyjCgC;EiDxjChC,YjDujCgC;AJ+0IpC;AqDp4KI;EACE,QAAA;EACA,oCAAA;EACA,4EjDsjC8B;AJg1IpC;AqDn4KI;EACE,UjDmPwB;EiDlPxB,oCAAA;EACA,uBpDvGE;AD4+KR;;AqDh3KA;EACE,oBAAA;EACA,gBAAA;EhDuJI,kBALI;EgD/IR,sBpDjIM;EoDkIN,kFAAA;E/CtHE,0CAAA;EACA,2CAAA;ANy+KJ;AqDj3KE;EACE,aAAA;ArDm3KJ;;AqD/2KA;EACE,kBAAA;EACA,cpDrIS;ADu/KX;;AsDjgLA;EACE,kBAAA;AtDogLF;;AsDjgLA;EACE,mBAAA;AtDogLF;;AsDjgLA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AtDogLF;AuD1hLE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AvD4hLJ;;AsDrgLA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,mCAAA;UAAA,2BAAA;EjClBI,sCiCmBJ;AtDwgLF;AqBvhLM;EiCQN;IjCPQ,gBAAA;ErB0hLN;AACF;;AsD1gLA;;;EAGE,cAAA;AtD6gLF;;AsD1gLA,qBAAA;AACA;;EAEE,2BAAA;AtD6gLF;;AsD1gLA;;EAEE,4BAAA;AtD6gLF;;AsD1gLA,mBAAA;AAQE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;AtDsgLJ;AsDngLE;;;EAGE,UAAA;EACA,UAAA;AtDqgLJ;AsDlgLE;;EAEE,UAAA;EACA,UAAA;EjC/DE,2BiCgEF;AtDogLJ;AqBhkLM;EiCwDJ;;IjCvDM,gBAAA;ErBokLN;AACF;;AsDjgLA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UlD2vCmC;EkD1vCnC,UAAA;EACA,WrDrFM;EqDsFN,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,YlDsvCmC;EiB/0C/B,8BiC0FJ;AtDmgLF;AqBzlLM;EiCqEN;;IjCpEQ,gBAAA;ErB6lLN;AACF;AsDtgLE;;;EAEE,WrD/FI;EqDgGJ,qBAAA;EACA,UAAA;EACA,YlD8uCiC;AJ2xIrC;;AsDtgLA;EACE,OAAA;AtDygLF;;AsDtgLA;EACE,QAAA;AtDygLF;;AsDpgLA;;EAEE,qBAAA;EACA,WlD+uCmC;EkD9uCnC,YlD8uCmC;EkD7uCnC,4BAAA;EACA,wBAAA;EACA,0BAAA;AtDugLF;;AsDpgLA;;;;;;;GAAA;AAQA;EACE,0DAAA;AtDugLF;;AsDrgLA;EACE,0DAAA;AtDwgLF;;AsDhgLA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EAEA,iBlDurCmC;EkDtrCnC,mBAAA;EACA,gBlDqrCmC;EkDprCnC,gBAAA;AtDkgLF;AsDhgLE;EACE,uBAAA;EACA,cAAA;EACA,WlDorCiC;EkDnrCjC,WlDorCiC;EkDnrCjC,UAAA;EACA,iBlDorCiC;EkDnrCjC,gBlDmrCiC;EkDlrCjC,mBAAA;EACA,eAAA;EACA,sBrDtKI;EqDuKJ,4BAAA;EACA,SAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YlD2qCiC;EiBv1C/B,6BiC6KF;AtDigLJ;AqB1qLM;EiCwJJ;IjCvJM,gBAAA;ErB6qLN;AACF;AsDngLE;EACE,UlDwqCiC;AJ61IrC;;AsD5/KA;EACE,kBAAA;EACA,UAAA;EACA,elDkqCmC;EkDjqCnC,SAAA;EACA,oBlD+pCmC;EkD9pCnC,uBlD8pCmC;EkD7pCnC,WrDjMM;EqDkMN,kBAAA;AtD+/KF;;AsDz/KE;;EAEE,gClDiqCiC;AJ21IrC;AsDz/KE;EACE,sBrDpMI;AD+rLR;AsDx/KE;EACE,WrDxMI;ADksLR;;AwDvtLA;EACE;IAAK,0CAAA;ExD2tLL;AACF;AwDxtLA;EACE,qBAAA;EACA,WpDs3CwB;EoDr3CxB,YpDq3CwB;EoDp3CxB,wBpDs3CwB;EoDr3CxB,iCAAA;EACA,+BAAA;EAEA,kBAAA;EACA,+CAAA;AxDytLF;;AwDttLA;EACE,WpDi3CwB;EoDh3CxB,YpDg3CwB;EoD/2CxB,mBpDi3CwB;AJw2I1B;;AwDjtLA;EACE;IACE,mBAAA;ExDotLF;EwDltLA;IACE,UAAA;IACA,eAAA;ExDotLF;AACF;AwDhtLA;EACE,qBAAA;EACA,WpDo1CwB;EoDn1CxB,YpDm1CwB;EoDl1CxB,wBpDo1CwB;EoDn1CxB,8BAAA;EAEA,kBAAA;EACA,UAAA;EACA,6CAAA;AxDitLF;;AwD9sLA;EACE,WpD+0CwB;EoD90CxB,YpD80CwB;AJm4I1B;;AwD7sLE;EACE;;IAEE,wBAAA;ExDgtLJ;AACF;AyDlxLA;EACE,eAAA;EACA,SAAA;EACA,arD04BkC;EqDz4BlC,aAAA;EACA,sBAAA;EACA,eAAA;EAEA,kBAAA;EACA,sBxDOM;EwDNN,4BAAA;EACA,UAAA;EpCKI,sCoCHJ;AzDkxLF;AqB3wLM;EoCpBN;IpCqBQ,gBAAA;ErB8wLN;AACF;;AyDpxLA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AzDuxLF;AyDrxLE;EACE,sBAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;AzDuxLJ;;AyDnxLA;EACE,gBAAA;EACA,gBrDuZ4B;AJ+3K9B;;AyDnxLA;EACE,YAAA;EACA,kBAAA;EACA,gBAAA;AzDsxLF;;AyDnxLA;EACE,MAAA;EACA,OAAA;EACA,YrDy3CkC;EqDx3ClC,0CAAA;EACA,4BAAA;AzDsxLF;;AyDnxLA;EACE,MAAA;EACA,QAAA;EACA,YrDi3CkC;EqDh3ClC,yCAAA;EACA,2BAAA;AzDsxLF;;AyDnxLA;EACE,MAAA;EACA,QAAA;EACA,OAAA;EACA,YrDy2CkC;EqDx2ClC,gBAAA;EACA,2CAAA;EACA,4BAAA;AzDsxLF;;AyDnxLA;EACE,QAAA;EACA,OAAA;EACA,YrDg2CkC;EqD/1ClC,gBAAA;EACA,wCAAA;EACA,2BAAA;AzDsxLF;;AyDnxLA;EACE,eAAA;AzDsxLF;;A0D/1LA;EACE,kBAAA;EACA,mBALkC;EAMlC,yBzDWS;EKCP,qBAAA;ANu1LJ;Aa3yLI;E6C3DJ;IAOI,kBAAA;E1Dm2LF;AACF;;A0Dh2LA;EACE,gBAAA;EACA,eAAA;EpDEE,gBAAA;ANk2LJ;;AuDn3LE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AvDs3LJ;;A2D13LE;EACE,c1DmFW;AD0yLf;A2D13LM;EAEE,6BAAA;A3D23LR;;A2Dj4LE;EACE,c1DmFW;ADizLf;A2Dj4LM;EAEE,2BAAA;A3Dk4LR;;A2Dx4LE;EACE,c1DmFW;ADwzLf;A2Dx4LM;EAEE,4BAAA;A3Dy4LR;;A2D/4LE;EACE,c1DmFW;AD+zLf;A2D/4LM;EAEE,4BAAA;A3Dg5LR;;A2Dt5LE;EACE,c1DmFW;ADs0Lf;A2Dt5LM;EAEE,4BAAA;A3Du5LR;;A2D75LE;EACE,c1DmFW;AD60Lf;A2D75LM;EAEE,2BAAA;A3D85LR;;A2Dp6LE;EACE,c1DmFW;ADo1Lf;A2Dp6LM;EAEE,+BAAA;A3Dq6LR;;A2D36LE;EACE,c1DmFW;AD21Lf;A2D36LM;EAEE,4BAAA;A3D46LR;;A2Dl7LE;EACE,c1DmFW;ADk2Lf;A2Dl7LM;EAEE,4BAAA;A3Dm7LR;;A2Dz7LE;EACE,c1DmFW;ADy2Lf;A2Dz7LM;EAEE,8BAAA;A3D07LR;;A4D/7LA;EACE,kBAAA;EACA,WAAA;A5Dk8LF;A4Dh8LE;EACE,cAAA;EACA,mCAAA;EACA,WAAA;A5Dk8LJ;A4D/7LE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;A5Di8LJ;;A4D57LE;EACE,uBAAA;A5D+7LJ;;A4Dh8LE;EACE,sBAAA;A5Dm8LJ;;A4Dp8LE;EACE,yBAAA;A5Du8LJ;;A4Dx8LE;EACE,iCAAA;A5D28LJ;;A6Dh+LA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,azDo4BkC;AJ+lKpC;;A6Dh+LA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,azD43BkC;AJumKpC;;A6D39LI;EACE,wBAAA;EAAA,gBAAA;EACA,MAAA;EACA,azDg3B8B;AJ8mKpC;;Aaz7LI;EgDxCA;IACE,wBAAA;IAAA,gBAAA;IACA,MAAA;IACA,azDg3B8B;EJqnKlC;AACF;Aaj8LI;EgDxCA;IACE,wBAAA;IAAA,gBAAA;IACA,MAAA;IACA,azDg3B8B;EJ4nKlC;AACF;Aax8LI;EgDxCA;IACE,wBAAA;IAAA,gBAAA;IACA,MAAA;IACA,azDg3B8B;EJmoKlC;AACF;Aa/8LI;EgDxCA;IACE,wBAAA;IAAA,gBAAA;IACA,MAAA;IACA,azDg3B8B;EJ0oKlC;AACF;Aat9LI;EgDxCA;IACE,wBAAA;IAAA,gBAAA;IACA,MAAA;IACA,azDg3B8B;EJipKlC;AACF;A8DxhMA;;ECIE,6BAAA;EACA,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;A/DwhMF;;AgEniME;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,U5D2RsC;E4D1RtC,WAAA;AhEsiMJ;;AiE9iMA;ECAE,gBAAA;EACA,uBAAA;EACA,mBAAA;AlEkjMF;;AmEvgMM;EAEI,mCAAA;AnEygMV;;AmE3gMM;EAEI,8BAAA;AnE6gMV;;AmE/gMM;EAEI,iCAAA;AnEihMV;;AmEnhMM;EAEI,iCAAA;AnEqhMV;;AmEvhMM;EAEI,sCAAA;AnEyhMV;;AmE3hMM;EAEI,mCAAA;AnE6hMV;;AmE/hMM;EAEI,sBAAA;AnEiiMV;;AmEniMM;EAEI,uBAAA;AnEqiMV;;AmEviMM;EAEI,sBAAA;AnEyiMV;;AmE3iMM;EAEI,yBAAA;AnE6iMV;;AmE/iMM;EAEI,2BAAA;AnEijMV;;AmEnjMM;EAEI,4BAAA;AnEqjMV;;AmEvjMM;EAEI,2BAAA;AnEyjMV;;AmE3jMM;EAEI,0BAAA;AnE6jMV;;AmE/jMM;EAEI,gCAAA;AnEikMV;;AmEnkMM;EAEI,yBAAA;AnEqkMV;;AmEvkMM;EAEI,wBAAA;AnEykMV;;AmE3kMM;EAEI,yBAAA;AnE6kMV;;AmE/kMM;EAEI,6BAAA;AnEilMV;;AmEnlMM;EAEI,8BAAA;AnEqlMV;;AmEvlMM;EAEI,wBAAA;AnEylMV;;AmE3lMM;EAEI,+BAAA;AnE6lMV;;AmE/lMM;EAEI,wBAAA;AnEimMV;;AmEnmMM;EAEI,wDAAA;AnEqmMV;;AmEvmMM;EAEI,8DAAA;AnEymMV;;AmE3mMM;EAEI,uDAAA;AnE6mMV;;AmE/mMM;EAEI,2BAAA;AnEinMV;;AmEnnMM;EAEI,2BAAA;AnEqnMV;;AmEvnMM;EAEI,6BAAA;AnEynMV;;AmE3nMM;EAEI,6BAAA;AnE6nMV;;AmE/nMM;EAEI,0BAAA;AnEioMV;;AmEnoMM;EAEI,mCAAA;EAAA,2BAAA;AnEqoMV;;AmEvoMM;EAEI,iBAAA;AnEyoMV;;AmE3oMM;EAEI,mBAAA;AnE6oMV;;AmE/oMM;EAEI,oBAAA;AnEipMV;;AmEnpMM;EAEI,oBAAA;AnEqpMV;;AmEvpMM;EAEI,sBAAA;AnEypMV;;AmE3pMM;EAEI,uBAAA;AnE6pMV;;AmE/pMM;EAEI,kBAAA;AnEiqMV;;AmEnqMM;EAEI,oBAAA;AnEqqMV;;AmEvqMM;EAEI,qBAAA;AnEyqMV;;AmE3qMM;EAEI,mBAAA;AnE6qMV;;AmE/qMM;EAEI,qBAAA;AnEirMV;;AmEnrMM;EAEI,sBAAA;AnEqrMV;;AmEvrMM;EAEI,2CAAA;AnEyrMV;;AmE3rMM;EAEI,sCAAA;AnE6rMV;;AmE/rMM;EAEI,sCAAA;AnEisMV;;AmEnsMM;EAEI,oCAAA;AnEqsMV;;AmEvsMM;EAEI,oBAAA;AnEysMV;;AmE3sMM;EAEI,wCAAA;AnE6sMV;;AmE/sMM;EAEI,wBAAA;AnEitMV;;AmEntMM;EAEI,0CAAA;AnEqtMV;;AmEvtMM;EAEI,0BAAA;AnEytMV;;AmE3tMM;EAEI,2CAAA;AnE6tMV;;AmE/tMM;EAEI,2BAAA;AnEiuMV;;AmEnuMM;EAEI,yCAAA;AnEquMV;;AmEvuMM;EAEI,yBAAA;AnEyuMV;;AmE3uMM;EAEI,gCAAA;AnE6uMV;;AmE/uMM;EAEI,gCAAA;AnEivMV;;AmEnvMM;EAEI,gCAAA;AnEqvMV;;AmEvvMM;EAEI,gCAAA;AnEyvMV;;AmE3vMM;EAEI,gCAAA;AnE6vMV;;AmE/vMM;EAEI,gCAAA;AnEiwMV;;AmEnwMM;EAEI,gCAAA;AnEqwMV;;AmEvwMM;EAEI,gCAAA;AnEywMV;;AmE3wMM;EAEI,gCAAA;AnE6wMV;;AmE/wMM;EAEI,gCAAA;AnEixMV;;AmEnxMM;EAEI,6BAAA;AnEqxMV;;AmEvxMM;EAEI,4BAAA;AnEyxMV;;AmE3xMM;EAEI,4BAAA;AnE6xMV;;AmE/xMM;EAEI,4BAAA;AnEiyMV;;AmEnyMM;EAEI,4BAAA;AnEqyMV;;AmEvyMM;EAEI,4BAAA;AnEyyMV;;AmE3yMM;EAEI,qBAAA;AnE6yMV;;AmE/yMM;EAEI,qBAAA;AnEizMV;;AmEnzMM;EAEI,qBAAA;AnEqzMV;;AmEvzMM;EAEI,sBAAA;AnEyzMV;;AmE3zMM;EAEI,sBAAA;AnE6zMV;;AmE/zMM;EAEI,0BAAA;AnEi0MV;;AmEn0MM;EAEI,uBAAA;AnEq0MV;;AmEv0MM;EAEI,2BAAA;AnEy0MV;;AmE30MM;EAEI,sBAAA;AnE60MV;;AmE/0MM;EAEI,sBAAA;AnEi1MV;;AmEn1MM;EAEI,sBAAA;AnEq1MV;;AmEv1MM;EAEI,uBAAA;AnEy1MV;;AmE31MM;EAEI,uBAAA;AnE61MV;;AmE/1MM;EAEI,2BAAA;AnEi2MV;;AmEn2MM;EAEI,wBAAA;AnEq2MV;;AmEv2MM;EAEI,4BAAA;AnEy2MV;;AmE32MM;EAEI,yBAAA;AnE62MV;;AmE/2MM;EAEI,8BAAA;AnEi3MV;;AmEn3MM;EAEI,iCAAA;AnEq3MV;;AmEv3MM;EAEI,sCAAA;AnEy3MV;;AmE33MM;EAEI,yCAAA;AnE63MV;;AmE/3MM;EAEI,uBAAA;AnEi4MV;;AmEn4MM;EAEI,uBAAA;AnEq4MV;;AmEv4MM;EAEI,yBAAA;AnEy4MV;;AmE34MM;EAEI,yBAAA;AnE64MV;;AmE/4MM;EAEI,0BAAA;AnEi5MV;;AmEn5MM;EAEI,4BAAA;AnEq5MV;;AmEv5MM;EAEI,kCAAA;AnEy5MV;;AmE35MM;EAEI,iBAAA;AnE65MV;;AmE/5MM;EAEI,uBAAA;AnEi6MV;;AmEn6MM;EAEI,sBAAA;AnEq6MV;;AmEv6MM;EAEI,oBAAA;AnEy6MV;;AmE36MM;EAEI,sBAAA;AnE66MV;;AmE/6MM;EAEI,oBAAA;AnEi7MV;;AmEn7MM;EAEI,sCAAA;AnEq7MV;;AmEv7MM;EAEI,oCAAA;AnEy7MV;;AmE37MM;EAEI,kCAAA;AnE67MV;;AmE/7MM;EAEI,yCAAA;AnEi8MV;;AmEn8MM;EAEI,wCAAA;AnEq8MV;;AmEv8MM;EAEI,wCAAA;AnEy8MV;;AmE38MM;EAEI,kCAAA;AnE68MV;;AmE/8MM;EAEI,gCAAA;AnEi9MV;;AmEn9MM;EAEI,8BAAA;AnEq9MV;;AmEv9MM;EAEI,gCAAA;AnEy9MV;;AmE39MM;EAEI,+BAAA;AnE69MV;;AmE/9MM;EAEI,oCAAA;AnEi+MV;;AmEn+MM;EAEI,kCAAA;AnEq+MV;;AmEv+MM;EAEI,gCAAA;AnEy+MV;;AmE3+MM;EAEI,uCAAA;AnE6+MV;;AmE/+MM;EAEI,sCAAA;AnEi/MV;;AmEn/MM;EAEI,iCAAA;AnEq/MV;;AmEv/MM;EAEI,2BAAA;AnEy/MV;;AmE3/MM;EAEI,iCAAA;AnE6/MV;;AmE//MM;EAEI,+BAAA;AnEigNV;;AmEngNM;EAEI,6BAAA;AnEqgNV;;AmEvgNM;EAEI,+BAAA;AnEygNV;;AmE3gNM;EAEI,8BAAA;AnE6gNV;;AmE/gNM;EAEI,oBAAA;AnEihNV;;AmEnhNM;EAEI,mBAAA;AnEqhNV;;AmEvhNM;EAEI,mBAAA;AnEyhNV;;AmE3hNM;EAEI,mBAAA;AnE6hNV;;AmE/hNM;EAEI,mBAAA;AnEiiNV;;AmEniNM;EAEI,mBAAA;AnEqiNV;;AmEviNM;EAEI,mBAAA;AnEyiNV;;AmE3iNM;EAEI,mBAAA;AnE6iNV;;AmE/iNM;EAEI,oBAAA;AnEijNV;;AmEnjNM;EAEI,0BAAA;AnEqjNV;;AmEvjNM;EAEI,yBAAA;AnEyjNV;;AmE3jNM;EAEI,uBAAA;AnE6jNV;;AmE/jNM;EAEI,yBAAA;AnEikNV;;AmEnkNM;EAEI,uBAAA;AnEqkNV;;AmEvkNM;EAEI,uBAAA;AnEykNV;;AmE3kNM;EAEI,0BAAA;EAAA,yBAAA;AnE8kNV;;AmEhlNM;EAEI,gCAAA;EAAA,+BAAA;AnEmlNV;;AmErlNM;EAEI,+BAAA;EAAA,8BAAA;AnEwlNV;;AmE1lNM;EAEI,6BAAA;EAAA,4BAAA;AnE6lNV;;AmE/lNM;EAEI,+BAAA;EAAA,8BAAA;AnEkmNV;;AmEpmNM;EAEI,6BAAA;EAAA,4BAAA;AnEumNV;;AmEzmNM;EAEI,6BAAA;EAAA,4BAAA;AnE4mNV;;AmE9mNM;EAEI,wBAAA;EAAA,2BAAA;AnEinNV;;AmEnnNM;EAEI,8BAAA;EAAA,iCAAA;AnEsnNV;;AmExnNM;EAEI,6BAAA;EAAA,gCAAA;AnE2nNV;;AmE7nNM;EAEI,2BAAA;EAAA,8BAAA;AnEgoNV;;AmEloNM;EAEI,6BAAA;EAAA,gCAAA;AnEqoNV;;AmEvoNM;EAEI,2BAAA;EAAA,8BAAA;AnE0oNV;;AmE5oNM;EAEI,2BAAA;EAAA,8BAAA;AnE+oNV;;AmEjpNM;EAEI,wBAAA;AnEmpNV;;AmErpNM;EAEI,8BAAA;AnEupNV;;AmEzpNM;EAEI,6BAAA;AnE2pNV;;AmE7pNM;EAEI,2BAAA;AnE+pNV;;AmEjqNM;EAEI,6BAAA;AnEmqNV;;AmErqNM;EAEI,2BAAA;AnEuqNV;;AmEzqNM;EAEI,2BAAA;AnE2qNV;;AmE7qNM;EAEI,0BAAA;AnE+qNV;;AmEjrNM;EAEI,gCAAA;AnEmrNV;;AmErrNM;EAEI,+BAAA;AnEurNV;;AmEzrNM;EAEI,6BAAA;AnE2rNV;;AmE7rNM;EAEI,+BAAA;AnE+rNV;;AmEjsNM;EAEI,6BAAA;AnEmsNV;;AmErsNM;EAEI,6BAAA;AnEusNV;;AmEzsNM;EAEI,2BAAA;AnE2sNV;;AmE7sNM;EAEI,iCAAA;AnE+sNV;;AmEjtNM;EAEI,gCAAA;AnEmtNV;;AmErtNM;EAEI,8BAAA;AnEutNV;;AmEztNM;EAEI,gCAAA;AnE2tNV;;AmE7tNM;EAEI,8BAAA;AnE+tNV;;AmEjuNM;EAEI,8BAAA;AnEmuNV;;AmEruNM;EAEI,yBAAA;AnEuuNV;;AmEzuNM;EAEI,+BAAA;AnE2uNV;;AmE7uNM;EAEI,8BAAA;AnE+uNV;;AmEjvNM;EAEI,4BAAA;AnEmvNV;;AmErvNM;EAEI,8BAAA;AnEuvNV;;AmEzvNM;EAEI,4BAAA;AnE2vNV;;AmE7vNM;EAEI,4BAAA;AnE+vNV;;AmEjwNM;EAEI,qBAAA;AnEmwNV;;AmErwNM;EAEI,2BAAA;AnEuwNV;;AmEzwNM;EAEI,0BAAA;AnE2wNV;;AmE7wNM;EAEI,wBAAA;AnE+wNV;;AmEjxNM;EAEI,0BAAA;AnEmxNV;;AmErxNM;EAEI,wBAAA;AnEuxNV;;AmEzxNM;EAEI,2BAAA;EAAA,0BAAA;AnE4xNV;;AmE9xNM;EAEI,iCAAA;EAAA,gCAAA;AnEiyNV;;AmEnyNM;EAEI,gCAAA;EAAA,+BAAA;AnEsyNV;;AmExyNM;EAEI,8BAAA;EAAA,6BAAA;AnE2yNV;;AmE7yNM;EAEI,gCAAA;EAAA,+BAAA;AnEgzNV;;AmElzNM;EAEI,8BAAA;EAAA,6BAAA;AnEqzNV;;AmEvzNM;EAEI,yBAAA;EAAA,4BAAA;AnE0zNV;;AmE5zNM;EAEI,+BAAA;EAAA,kCAAA;AnE+zNV;;AmEj0NM;EAEI,8BAAA;EAAA,iCAAA;AnEo0NV;;AmEt0NM;EAEI,4BAAA;EAAA,+BAAA;AnEy0NV;;AmE30NM;EAEI,8BAAA;EAAA,iCAAA;AnE80NV;;AmEh1NM;EAEI,4BAAA;EAAA,+BAAA;AnEm1NV;;AmEr1NM;EAEI,yBAAA;AnEu1NV;;AmEz1NM;EAEI,+BAAA;AnE21NV;;AmE71NM;EAEI,8BAAA;AnE+1NV;;AmEj2NM;EAEI,4BAAA;AnEm2NV;;AmEr2NM;EAEI,8BAAA;AnEu2NV;;AmEz2NM;EAEI,4BAAA;AnE22NV;;AmE72NM;EAEI,2BAAA;AnE+2NV;;AmEj3NM;EAEI,iCAAA;AnEm3NV;;AmEr3NM;EAEI,gCAAA;AnEu3NV;;AmEz3NM;EAEI,8BAAA;AnE23NV;;AmE73NM;EAEI,gCAAA;AnE+3NV;;AmEj4NM;EAEI,8BAAA;AnEm4NV;;AmEr4NM;EAEI,4BAAA;AnEu4NV;;AmEz4NM;EAEI,kCAAA;AnE24NV;;AmE74NM;EAEI,iCAAA;AnE+4NV;;AmEj5NM;EAEI,+BAAA;AnEm5NV;;AmEr5NM;EAEI,iCAAA;AnEu5NV;;AmEz5NM;EAEI,+BAAA;AnE25NV;;AmE75NM;EAEI,0BAAA;AnE+5NV;;AmEj6NM;EAEI,gCAAA;AnEm6NV;;AmEr6NM;EAEI,+BAAA;AnEu6NV;;AmEz6NM;EAEI,6BAAA;AnE26NV;;AmE76NM;EAEI,+BAAA;AnE+6NV;;AmEj7NM;EAEI,6BAAA;AnEm7NV;;AmEr7NM;EAEI,4GAAA;EAAA,gDAAA;AnEu7NV;;AmEz7NM;EAEI,6CAAA;AnE27NV;;AmE77NM;EAEI,8CAAA;AnE+7NV;;AmEj8NM;EAEI,8CAAA;AnEm8NV;;AmEr8NM;EAEI,8CAAA;AnEu8NV;;AmEz8NM;EAEI,4BAAA;AnE28NV;;AmE78NM;EAEI,6BAAA;AnE+8NV;;AmEj9NM;EAEI,6BAAA;AnEm9NV;;AmEr9NM;EAEI,6BAAA;AnEu9NV;;AmEz9NM;EAEI,2BAAA;AnE29NV;;AmE79NM;EAEI,+BAAA;AnE+9NV;;AmEj+NM;EAEI,2BAAA;AnEm+NV;;AmEr+NM;EAEI,2BAAA;AnEu+NV;;AmEz+NM;EAEI,8BAAA;AnE2+NV;;AmE7+NM;EAEI,yBAAA;AnE++NV;;AmEj/NM;EAEI,4BAAA;AnEm/NV;;AmEr/NM;EAEI,2BAAA;AnEu/NV;;AmEz/NM;EAEI,yBAAA;AnE2/NV;;AmE7/NM;EAEI,2BAAA;AnE+/NV;;AmEjgOM;EAEI,4BAAA;AnEmgOV;;AmErgOM;EAEI,6BAAA;AnEugOV;;AmEzgOM;EAEI,gCAAA;AnE2gOV;;AmE7gOM;EAEI,qCAAA;AnE+gOV;;AmEjhOM;EAEI,wCAAA;AnEmhOV;;AmErhOM;EAEI,oCAAA;AnEuhOV;;AmEzhOM;EAEI,oCAAA;AnE2hOV;;AmE7hOM;EAEI,qCAAA;AnE+hOV;;AmEjiOM;EAEI,8BAAA;AnEmiOV;;AmEriOM;EAEI,8BAAA;AnEuiOV;;AmE3iOQ,qBAAA;AAEF;EAEI,gCAAA;EAAA,iCAAA;AnE6iOV;;AmEjiOQ,mBAAA;AAdF;EAEI,yBAAA;AnEkjOV;;AmEpjOM;EAEI,yBAAA;AnEsjOV;;AmExjOM;EAEI,yBAAA;AnE0jOV;;AmE5jOM;EAEI,yBAAA;AnE8jOV;;AmEhkOM;EAEI,yBAAA;AnEkkOV;;AmEpkOM;EAEI,yBAAA;AnEskOV;;AmExkOM;EAEI,yBAAA;AnE0kOV;;AmE5kOM;EAEI,yBAAA;AnE8kOV;;AmEhlOM;EAEI,yBAAA;AnEklOV;;AmEplOM;EAEI,yBAAA;AnEslOV;;AmExlOM;EAEI,sBAAA;AnE0lOV;;AmE5lOM;EAEI,yBAAA;AnE8lOV;;AmEhmOM;EAEI,yBAAA;AnEkmOV;;AmEpmOM;EAEI,oCAAA;AnEsmOV;;AmExmOM;EAEI,0CAAA;AnE0mOV;;AmE5mOM;EAEI,yBAAA;AnE8mOV;;AmEhnOM;EAEI,oCAAA;AnEknOV;;AmEpnOM;EAEI,oCAAA;AnEsnOV;;AmExnOM;EAEI,oCAAA;AnE0nOV;;AmE5nOM;EAEI,oCAAA;AnE8nOV;;AmEhoOM;EAEI,oCAAA;AnEkoOV;;AmEpoOM;EAEI,oCAAA;AnEsoOV;;AmExoOM;EAEI,oCAAA;AnE0oOV;;AmE5oOM;EAEI,oCAAA;AnE8oOV;;AmEhpOM;EAEI,oCAAA;AnEkpOV;;AmEppOM;EAEI,oCAAA;AnEspOV;;AmExpOM;EAEI,iCAAA;AnE0pOV;;AmE5pOM;EAEI,iCAAA;AnE8pOV;;AmEhqOM;EAEI,wCAAA;AnEkqOV;;AmEpqOM;EAEI,uGAAA;EAAA,+CAAA;AnEsqOV;;AmExqOM;EAEI,mCAAA;UAAA,2BAAA;AnE0qOV;;AmE5qOM;EAEI,oCAAA;UAAA,4BAAA;AnE8qOV;;AmEhrOM;EAEI,oCAAA;UAAA,4BAAA;AnEkrOV;;AmEprOM;EAEI,+BAAA;AnEsrOV;;AmExrOM;EAEI,+BAAA;AnE0rOV;;AmE5rOM;EAEI,iCAAA;AnE8rOV;;AmEhsOM;EAEI,2BAAA;AnEksOV;;AmEpsOM;EAEI,gCAAA;AnEssOV;;AmExsOM;EAEI,iCAAA;AnE0sOV;;AmE5sOM;EAEI,gCAAA;AnE8sOV;;AmEhtOM;EAEI,6BAAA;AnEktOV;;AmEptOM;EAEI,+BAAA;AnEstOV;;AmExtOM;EAEI,0CAAA;EAAA,2CAAA;AnE2tOV;;AmE7tOM;EAEI,2CAAA;EAAA,8CAAA;AnEguOV;;AmEluOM;EAEI,8CAAA;EAAA,6CAAA;AnEquOV;;AmEvuOM;EAEI,6CAAA;EAAA,0CAAA;AnE0uOV;;AmE5uOM;EAEI,8BAAA;AnE8uOV;;AmEhvOM;EAEI,6BAAA;AnEkvOV;;AatuOI;EsDdE;IAEI,sBAAA;EnEuvOR;EmEzvOI;IAEI,uBAAA;EnE0vOR;EmE5vOI;IAEI,sBAAA;EnE6vOR;EmE/vOI;IAEI,0BAAA;EnEgwOR;EmElwOI;IAEI,gCAAA;EnEmwOR;EmErwOI;IAEI,yBAAA;EnEswOR;EmExwOI;IAEI,wBAAA;EnEywOR;EmE3wOI;IAEI,yBAAA;EnE4wOR;EmE9wOI;IAEI,6BAAA;EnE+wOR;EmEjxOI;IAEI,8BAAA;EnEkxOR;EmEpxOI;IAEI,wBAAA;EnEqxOR;EmEvxOI;IAEI,+BAAA;EnEwxOR;EmE1xOI;IAEI,wBAAA;EnE2xOR;EmE7xOI;IAEI,yBAAA;EnE8xOR;EmEhyOI;IAEI,8BAAA;EnEiyOR;EmEnyOI;IAEI,iCAAA;EnEoyOR;EmEtyOI;IAEI,sCAAA;EnEuyOR;EmEzyOI;IAEI,yCAAA;EnE0yOR;EmE5yOI;IAEI,uBAAA;EnE6yOR;EmE/yOI;IAEI,uBAAA;EnEgzOR;EmElzOI;IAEI,yBAAA;EnEmzOR;EmErzOI;IAEI,yBAAA;EnEszOR;EmExzOI;IAEI,0BAAA;EnEyzOR;EmE3zOI;IAEI,4BAAA;EnE4zOR;EmE9zOI;IAEI,kCAAA;EnE+zOR;EmEj0OI;IAEI,iBAAA;EnEk0OR;EmEp0OI;IAEI,uBAAA;EnEq0OR;EmEv0OI;IAEI,sBAAA;EnEw0OR;EmE10OI;IAEI,oBAAA;EnE20OR;EmE70OI;IAEI,sBAAA;EnE80OR;EmEh1OI;IAEI,oBAAA;EnEi1OR;EmEn1OI;IAEI,sCAAA;EnEo1OR;EmEt1OI;IAEI,oCAAA;EnEu1OR;EmEz1OI;IAEI,kCAAA;EnE01OR;EmE51OI;IAEI,yCAAA;EnE61OR;EmE/1OI;IAEI,wCAAA;EnEg2OR;EmEl2OI;IAEI,wCAAA;EnEm2OR;EmEr2OI;IAEI,kCAAA;EnEs2OR;EmEx2OI;IAEI,gCAAA;EnEy2OR;EmE32OI;IAEI,8BAAA;EnE42OR;EmE92OI;IAEI,gCAAA;EnE+2OR;EmEj3OI;IAEI,+BAAA;EnEk3OR;EmEp3OI;IAEI,oCAAA;EnEq3OR;EmEv3OI;IAEI,kCAAA;EnEw3OR;EmE13OI;IAEI,gCAAA;EnE23OR;EmE73OI;IAEI,uCAAA;EnE83OR;EmEh4OI;IAEI,sCAAA;EnEi4OR;EmEn4OI;IAEI,iCAAA;EnEo4OR;EmEt4OI;IAEI,2BAAA;EnEu4OR;EmEz4OI;IAEI,iCAAA;EnE04OR;EmE54OI;IAEI,+BAAA;EnE64OR;EmE/4OI;IAEI,6BAAA;EnEg5OR;EmEl5OI;IAEI,+BAAA;EnEm5OR;EmEr5OI;IAEI,8BAAA;EnEs5OR;EmEx5OI;IAEI,oBAAA;EnEy5OR;EmE35OI;IAEI,mBAAA;EnE45OR;EmE95OI;IAEI,mBAAA;EnE+5OR;EmEj6OI;IAEI,mBAAA;EnEk6OR;EmEp6OI;IAEI,mBAAA;EnEq6OR;EmEv6OI;IAEI,mBAAA;EnEw6OR;EmE16OI;IAEI,mBAAA;EnE26OR;EmE76OI;IAEI,mBAAA;EnE86OR;EmEh7OI;IAEI,oBAAA;EnEi7OR;EmEn7OI;IAEI,0BAAA;EnEo7OR;EmEt7OI;IAEI,yBAAA;EnEu7OR;EmEz7OI;IAEI,uBAAA;EnE07OR;EmE57OI;IAEI,yBAAA;EnE67OR;EmE/7OI;IAEI,uBAAA;EnEg8OR;EmEl8OI;IAEI,uBAAA;EnEm8OR;EmEr8OI;IAEI,0BAAA;IAAA,yBAAA;EnEu8OR;EmEz8OI;IAEI,gCAAA;IAAA,+BAAA;EnE28OR;EmE78OI;IAEI,+BAAA;IAAA,8BAAA;EnE+8OR;EmEj9OI;IAEI,6BAAA;IAAA,4BAAA;EnEm9OR;EmEr9OI;IAEI,+BAAA;IAAA,8BAAA;EnEu9OR;EmEz9OI;IAEI,6BAAA;IAAA,4BAAA;EnE29OR;EmE79OI;IAEI,6BAAA;IAAA,4BAAA;EnE+9OR;EmEj+OI;IAEI,wBAAA;IAAA,2BAAA;EnEm+OR;EmEr+OI;IAEI,8BAAA;IAAA,iCAAA;EnEu+OR;EmEz+OI;IAEI,6BAAA;IAAA,gCAAA;EnE2+OR;EmE7+OI;IAEI,2BAAA;IAAA,8BAAA;EnE++OR;EmEj/OI;IAEI,6BAAA;IAAA,gCAAA;EnEm/OR;EmEr/OI;IAEI,2BAAA;IAAA,8BAAA;EnEu/OR;EmEz/OI;IAEI,2BAAA;IAAA,8BAAA;EnE2/OR;EmE7/OI;IAEI,wBAAA;EnE8/OR;EmEhgPI;IAEI,8BAAA;EnEigPR;EmEngPI;IAEI,6BAAA;EnEogPR;EmEtgPI;IAEI,2BAAA;EnEugPR;EmEzgPI;IAEI,6BAAA;EnE0gPR;EmE5gPI;IAEI,2BAAA;EnE6gPR;EmE/gPI;IAEI,2BAAA;EnEghPR;EmElhPI;IAEI,0BAAA;EnEmhPR;EmErhPI;IAEI,gCAAA;EnEshPR;EmExhPI;IAEI,+BAAA;EnEyhPR;EmE3hPI;IAEI,6BAAA;EnE4hPR;EmE9hPI;IAEI,+BAAA;EnE+hPR;EmEjiPI;IAEI,6BAAA;EnEkiPR;EmEpiPI;IAEI,6BAAA;EnEqiPR;EmEviPI;IAEI,2BAAA;EnEwiPR;EmE1iPI;IAEI,iCAAA;EnE2iPR;EmE7iPI;IAEI,gCAAA;EnE8iPR;EmEhjPI;IAEI,8BAAA;EnEijPR;EmEnjPI;IAEI,gCAAA;EnEojPR;EmEtjPI;IAEI,8BAAA;EnEujPR;EmEzjPI;IAEI,8BAAA;EnE0jPR;EmE5jPI;IAEI,yBAAA;EnE6jPR;EmE/jPI;IAEI,+BAAA;EnEgkPR;EmElkPI;IAEI,8BAAA;EnEmkPR;EmErkPI;IAEI,4BAAA;EnEskPR;EmExkPI;IAEI,8BAAA;EnEykPR;EmE3kPI;IAEI,4BAAA;EnE4kPR;EmE9kPI;IAEI,4BAAA;EnE+kPR;EmEjlPI;IAEI,qBAAA;EnEklPR;EmEplPI;IAEI,2BAAA;EnEqlPR;EmEvlPI;IAEI,0BAAA;EnEwlPR;EmE1lPI;IAEI,wBAAA;EnE2lPR;EmE7lPI;IAEI,0BAAA;EnE8lPR;EmEhmPI;IAEI,wBAAA;EnEimPR;EmEnmPI;IAEI,2BAAA;IAAA,0BAAA;EnEqmPR;EmEvmPI;IAEI,iCAAA;IAAA,gCAAA;EnEymPR;EmE3mPI;IAEI,gCAAA;IAAA,+BAAA;EnE6mPR;EmE/mPI;IAEI,8BAAA;IAAA,6BAAA;EnEinPR;EmEnnPI;IAEI,gCAAA;IAAA,+BAAA;EnEqnPR;EmEvnPI;IAEI,8BAAA;IAAA,6BAAA;EnEynPR;EmE3nPI;IAEI,yBAAA;IAAA,4BAAA;EnE6nPR;EmE/nPI;IAEI,+BAAA;IAAA,kCAAA;EnEioPR;EmEnoPI;IAEI,8BAAA;IAAA,iCAAA;EnEqoPR;EmEvoPI;IAEI,4BAAA;IAAA,+BAAA;EnEyoPR;EmE3oPI;IAEI,8BAAA;IAAA,iCAAA;EnE6oPR;EmE/oPI;IAEI,4BAAA;IAAA,+BAAA;EnEipPR;EmEnpPI;IAEI,yBAAA;EnEopPR;EmEtpPI;IAEI,+BAAA;EnEupPR;EmEzpPI;IAEI,8BAAA;EnE0pPR;EmE5pPI;IAEI,4BAAA;EnE6pPR;EmE/pPI;IAEI,8BAAA;EnEgqPR;EmElqPI;IAEI,4BAAA;EnEmqPR;EmErqPI;IAEI,2BAAA;EnEsqPR;EmExqPI;IAEI,iCAAA;EnEyqPR;EmE3qPI;IAEI,gCAAA;EnE4qPR;EmE9qPI;IAEI,8BAAA;EnE+qPR;EmEjrPI;IAEI,gCAAA;EnEkrPR;EmEprPI;IAEI,8BAAA;EnEqrPR;EmEvrPI;IAEI,4BAAA;EnEwrPR;EmE1rPI;IAEI,kCAAA;EnE2rPR;EmE7rPI;IAEI,iCAAA;EnE8rPR;EmEhsPI;IAEI,+BAAA;EnEisPR;EmEnsPI;IAEI,iCAAA;EnEosPR;EmEtsPI;IAEI,+BAAA;EnEusPR;EmEzsPI;IAEI,0BAAA;EnE0sPR;EmE5sPI;IAEI,gCAAA;EnE6sPR;EmE/sPI;IAEI,+BAAA;EnEgtPR;EmEltPI;IAEI,6BAAA;EnEmtPR;EmErtPI;IAEI,+BAAA;EnEstPR;EmExtPI;IAEI,6BAAA;EnEytPR;EmE3tPI;IAEI,2BAAA;EnE4tPR;EmE9tPI;IAEI,4BAAA;EnE+tPR;EmEjuPI;IAEI,6BAAA;EnEkuPR;AACF;AavtPI;EsDdE;IAEI,sBAAA;EnEuuPR;EmEzuPI;IAEI,uBAAA;EnE0uPR;EmE5uPI;IAEI,sBAAA;EnE6uPR;EmE/uPI;IAEI,0BAAA;EnEgvPR;EmElvPI;IAEI,gCAAA;EnEmvPR;EmErvPI;IAEI,yBAAA;EnEsvPR;EmExvPI;IAEI,wBAAA;EnEyvPR;EmE3vPI;IAEI,yBAAA;EnE4vPR;EmE9vPI;IAEI,6BAAA;EnE+vPR;EmEjwPI;IAEI,8BAAA;EnEkwPR;EmEpwPI;IAEI,wBAAA;EnEqwPR;EmEvwPI;IAEI,+BAAA;EnEwwPR;EmE1wPI;IAEI,wBAAA;EnE2wPR;EmE7wPI;IAEI,yBAAA;EnE8wPR;EmEhxPI;IAEI,8BAAA;EnEixPR;EmEnxPI;IAEI,iCAAA;EnEoxPR;EmEtxPI;IAEI,sCAAA;EnEuxPR;EmEzxPI;IAEI,yCAAA;EnE0xPR;EmE5xPI;IAEI,uBAAA;EnE6xPR;EmE/xPI;IAEI,uBAAA;EnEgyPR;EmElyPI;IAEI,yBAAA;EnEmyPR;EmEryPI;IAEI,yBAAA;EnEsyPR;EmExyPI;IAEI,0BAAA;EnEyyPR;EmE3yPI;IAEI,4BAAA;EnE4yPR;EmE9yPI;IAEI,kCAAA;EnE+yPR;EmEjzPI;IAEI,iBAAA;EnEkzPR;EmEpzPI;IAEI,uBAAA;EnEqzPR;EmEvzPI;IAEI,sBAAA;EnEwzPR;EmE1zPI;IAEI,oBAAA;EnE2zPR;EmE7zPI;IAEI,sBAAA;EnE8zPR;EmEh0PI;IAEI,oBAAA;EnEi0PR;EmEn0PI;IAEI,sCAAA;EnEo0PR;EmEt0PI;IAEI,oCAAA;EnEu0PR;EmEz0PI;IAEI,kCAAA;EnE00PR;EmE50PI;IAEI,yCAAA;EnE60PR;EmE/0PI;IAEI,wCAAA;EnEg1PR;EmEl1PI;IAEI,wCAAA;EnEm1PR;EmEr1PI;IAEI,kCAAA;EnEs1PR;EmEx1PI;IAEI,gCAAA;EnEy1PR;EmE31PI;IAEI,8BAAA;EnE41PR;EmE91PI;IAEI,gCAAA;EnE+1PR;EmEj2PI;IAEI,+BAAA;EnEk2PR;EmEp2PI;IAEI,oCAAA;EnEq2PR;EmEv2PI;IAEI,kCAAA;EnEw2PR;EmE12PI;IAEI,gCAAA;EnE22PR;EmE72PI;IAEI,uCAAA;EnE82PR;EmEh3PI;IAEI,sCAAA;EnEi3PR;EmEn3PI;IAEI,iCAAA;EnEo3PR;EmEt3PI;IAEI,2BAAA;EnEu3PR;EmEz3PI;IAEI,iCAAA;EnE03PR;EmE53PI;IAEI,+BAAA;EnE63PR;EmE/3PI;IAEI,6BAAA;EnEg4PR;EmEl4PI;IAEI,+BAAA;EnEm4PR;EmEr4PI;IAEI,8BAAA;EnEs4PR;EmEx4PI;IAEI,oBAAA;EnEy4PR;EmE34PI;IAEI,mBAAA;EnE44PR;EmE94PI;IAEI,mBAAA;EnE+4PR;EmEj5PI;IAEI,mBAAA;EnEk5PR;EmEp5PI;IAEI,mBAAA;EnEq5PR;EmEv5PI;IAEI,mBAAA;EnEw5PR;EmE15PI;IAEI,mBAAA;EnE25PR;EmE75PI;IAEI,mBAAA;EnE85PR;EmEh6PI;IAEI,oBAAA;EnEi6PR;EmEn6PI;IAEI,0BAAA;EnEo6PR;EmEt6PI;IAEI,yBAAA;EnEu6PR;EmEz6PI;IAEI,uBAAA;EnE06PR;EmE56PI;IAEI,yBAAA;EnE66PR;EmE/6PI;IAEI,uBAAA;EnEg7PR;EmEl7PI;IAEI,uBAAA;EnEm7PR;EmEr7PI;IAEI,0BAAA;IAAA,yBAAA;EnEu7PR;EmEz7PI;IAEI,gCAAA;IAAA,+BAAA;EnE27PR;EmE77PI;IAEI,+BAAA;IAAA,8BAAA;EnE+7PR;EmEj8PI;IAEI,6BAAA;IAAA,4BAAA;EnEm8PR;EmEr8PI;IAEI,+BAAA;IAAA,8BAAA;EnEu8PR;EmEz8PI;IAEI,6BAAA;IAAA,4BAAA;EnE28PR;EmE78PI;IAEI,6BAAA;IAAA,4BAAA;EnE+8PR;EmEj9PI;IAEI,wBAAA;IAAA,2BAAA;EnEm9PR;EmEr9PI;IAEI,8BAAA;IAAA,iCAAA;EnEu9PR;EmEz9PI;IAEI,6BAAA;IAAA,gCAAA;EnE29PR;EmE79PI;IAEI,2BAAA;IAAA,8BAAA;EnE+9PR;EmEj+PI;IAEI,6BAAA;IAAA,gCAAA;EnEm+PR;EmEr+PI;IAEI,2BAAA;IAAA,8BAAA;EnEu+PR;EmEz+PI;IAEI,2BAAA;IAAA,8BAAA;EnE2+PR;EmE7+PI;IAEI,wBAAA;EnE8+PR;EmEh/PI;IAEI,8BAAA;EnEi/PR;EmEn/PI;IAEI,6BAAA;EnEo/PR;EmEt/PI;IAEI,2BAAA;EnEu/PR;EmEz/PI;IAEI,6BAAA;EnE0/PR;EmE5/PI;IAEI,2BAAA;EnE6/PR;EmE//PI;IAEI,2BAAA;EnEggQR;EmElgQI;IAEI,0BAAA;EnEmgQR;EmErgQI;IAEI,gCAAA;EnEsgQR;EmExgQI;IAEI,+BAAA;EnEygQR;EmE3gQI;IAEI,6BAAA;EnE4gQR;EmE9gQI;IAEI,+BAAA;EnE+gQR;EmEjhQI;IAEI,6BAAA;EnEkhQR;EmEphQI;IAEI,6BAAA;EnEqhQR;EmEvhQI;IAEI,2BAAA;EnEwhQR;EmE1hQI;IAEI,iCAAA;EnE2hQR;EmE7hQI;IAEI,gCAAA;EnE8hQR;EmEhiQI;IAEI,8BAAA;EnEiiQR;EmEniQI;IAEI,gCAAA;EnEoiQR;EmEtiQI;IAEI,8BAAA;EnEuiQR;EmEziQI;IAEI,8BAAA;EnE0iQR;EmE5iQI;IAEI,yBAAA;EnE6iQR;EmE/iQI;IAEI,+BAAA;EnEgjQR;EmEljQI;IAEI,8BAAA;EnEmjQR;EmErjQI;IAEI,4BAAA;EnEsjQR;EmExjQI;IAEI,8BAAA;EnEyjQR;EmE3jQI;IAEI,4BAAA;EnE4jQR;EmE9jQI;IAEI,4BAAA;EnE+jQR;EmEjkQI;IAEI,qBAAA;EnEkkQR;EmEpkQI;IAEI,2BAAA;EnEqkQR;EmEvkQI;IAEI,0BAAA;EnEwkQR;EmE1kQI;IAEI,wBAAA;EnE2kQR;EmE7kQI;IAEI,0BAAA;EnE8kQR;EmEhlQI;IAEI,wBAAA;EnEilQR;EmEnlQI;IAEI,2BAAA;IAAA,0BAAA;EnEqlQR;EmEvlQI;IAEI,iCAAA;IAAA,gCAAA;EnEylQR;EmE3lQI;IAEI,gCAAA;IAAA,+BAAA;EnE6lQR;EmE/lQI;IAEI,8BAAA;IAAA,6BAAA;EnEimQR;EmEnmQI;IAEI,gCAAA;IAAA,+BAAA;EnEqmQR;EmEvmQI;IAEI,8BAAA;IAAA,6BAAA;EnEymQR;EmE3mQI;IAEI,yBAAA;IAAA,4BAAA;EnE6mQR;EmE/mQI;IAEI,+BAAA;IAAA,kCAAA;EnEinQR;EmEnnQI;IAEI,8BAAA;IAAA,iCAAA;EnEqnQR;EmEvnQI;IAEI,4BAAA;IAAA,+BAAA;EnEynQR;EmE3nQI;IAEI,8BAAA;IAAA,iCAAA;EnE6nQR;EmE/nQI;IAEI,4BAAA;IAAA,+BAAA;EnEioQR;EmEnoQI;IAEI,yBAAA;EnEooQR;EmEtoQI;IAEI,+BAAA;EnEuoQR;EmEzoQI;IAEI,8BAAA;EnE0oQR;EmE5oQI;IAEI,4BAAA;EnE6oQR;EmE/oQI;IAEI,8BAAA;EnEgpQR;EmElpQI;IAEI,4BAAA;EnEmpQR;EmErpQI;IAEI,2BAAA;EnEspQR;EmExpQI;IAEI,iCAAA;EnEypQR;EmE3pQI;IAEI,gCAAA;EnE4pQR;EmE9pQI;IAEI,8BAAA;EnE+pQR;EmEjqQI;IAEI,gCAAA;EnEkqQR;EmEpqQI;IAEI,8BAAA;EnEqqQR;EmEvqQI;IAEI,4BAAA;EnEwqQR;EmE1qQI;IAEI,kCAAA;EnE2qQR;EmE7qQI;IAEI,iCAAA;EnE8qQR;EmEhrQI;IAEI,+BAAA;EnEirQR;EmEnrQI;IAEI,iCAAA;EnEorQR;EmEtrQI;IAEI,+BAAA;EnEurQR;EmEzrQI;IAEI,0BAAA;EnE0rQR;EmE5rQI;IAEI,gCAAA;EnE6rQR;EmE/rQI;IAEI,+BAAA;EnEgsQR;EmElsQI;IAEI,6BAAA;EnEmsQR;EmErsQI;IAEI,+BAAA;EnEssQR;EmExsQI;IAEI,6BAAA;EnEysQR;EmE3sQI;IAEI,2BAAA;EnE4sQR;EmE9sQI;IAEI,4BAAA;EnE+sQR;EmEjtQI;IAEI,6BAAA;EnEktQR;AACF;AavsQI;EsDdE;IAEI,sBAAA;EnEutQR;EmEztQI;IAEI,uBAAA;EnE0tQR;EmE5tQI;IAEI,sBAAA;EnE6tQR;EmE/tQI;IAEI,0BAAA;EnEguQR;EmEluQI;IAEI,gCAAA;EnEmuQR;EmEruQI;IAEI,yBAAA;EnEsuQR;EmExuQI;IAEI,wBAAA;EnEyuQR;EmE3uQI;IAEI,yBAAA;EnE4uQR;EmE9uQI;IAEI,6BAAA;EnE+uQR;EmEjvQI;IAEI,8BAAA;EnEkvQR;EmEpvQI;IAEI,wBAAA;EnEqvQR;EmEvvQI;IAEI,+BAAA;EnEwvQR;EmE1vQI;IAEI,wBAAA;EnE2vQR;EmE7vQI;IAEI,yBAAA;EnE8vQR;EmEhwQI;IAEI,8BAAA;EnEiwQR;EmEnwQI;IAEI,iCAAA;EnEowQR;EmEtwQI;IAEI,sCAAA;EnEuwQR;EmEzwQI;IAEI,yCAAA;EnE0wQR;EmE5wQI;IAEI,uBAAA;EnE6wQR;EmE/wQI;IAEI,uBAAA;EnEgxQR;EmElxQI;IAEI,yBAAA;EnEmxQR;EmErxQI;IAEI,yBAAA;EnEsxQR;EmExxQI;IAEI,0BAAA;EnEyxQR;EmE3xQI;IAEI,4BAAA;EnE4xQR;EmE9xQI;IAEI,kCAAA;EnE+xQR;EmEjyQI;IAEI,iBAAA;EnEkyQR;EmEpyQI;IAEI,uBAAA;EnEqyQR;EmEvyQI;IAEI,sBAAA;EnEwyQR;EmE1yQI;IAEI,oBAAA;EnE2yQR;EmE7yQI;IAEI,sBAAA;EnE8yQR;EmEhzQI;IAEI,oBAAA;EnEizQR;EmEnzQI;IAEI,sCAAA;EnEozQR;EmEtzQI;IAEI,oCAAA;EnEuzQR;EmEzzQI;IAEI,kCAAA;EnE0zQR;EmE5zQI;IAEI,yCAAA;EnE6zQR;EmE/zQI;IAEI,wCAAA;EnEg0QR;EmEl0QI;IAEI,wCAAA;EnEm0QR;EmEr0QI;IAEI,kCAAA;EnEs0QR;EmEx0QI;IAEI,gCAAA;EnEy0QR;EmE30QI;IAEI,8BAAA;EnE40QR;EmE90QI;IAEI,gCAAA;EnE+0QR;EmEj1QI;IAEI,+BAAA;EnEk1QR;EmEp1QI;IAEI,oCAAA;EnEq1QR;EmEv1QI;IAEI,kCAAA;EnEw1QR;EmE11QI;IAEI,gCAAA;EnE21QR;EmE71QI;IAEI,uCAAA;EnE81QR;EmEh2QI;IAEI,sCAAA;EnEi2QR;EmEn2QI;IAEI,iCAAA;EnEo2QR;EmEt2QI;IAEI,2BAAA;EnEu2QR;EmEz2QI;IAEI,iCAAA;EnE02QR;EmE52QI;IAEI,+BAAA;EnE62QR;EmE/2QI;IAEI,6BAAA;EnEg3QR;EmEl3QI;IAEI,+BAAA;EnEm3QR;EmEr3QI;IAEI,8BAAA;EnEs3QR;EmEx3QI;IAEI,oBAAA;EnEy3QR;EmE33QI;IAEI,mBAAA;EnE43QR;EmE93QI;IAEI,mBAAA;EnE+3QR;EmEj4QI;IAEI,mBAAA;EnEk4QR;EmEp4QI;IAEI,mBAAA;EnEq4QR;EmEv4QI;IAEI,mBAAA;EnEw4QR;EmE14QI;IAEI,mBAAA;EnE24QR;EmE74QI;IAEI,mBAAA;EnE84QR;EmEh5QI;IAEI,oBAAA;EnEi5QR;EmEn5QI;IAEI,0BAAA;EnEo5QR;EmEt5QI;IAEI,yBAAA;EnEu5QR;EmEz5QI;IAEI,uBAAA;EnE05QR;EmE55QI;IAEI,yBAAA;EnE65QR;EmE/5QI;IAEI,uBAAA;EnEg6QR;EmEl6QI;IAEI,uBAAA;EnEm6QR;EmEr6QI;IAEI,0BAAA;IAAA,yBAAA;EnEu6QR;EmEz6QI;IAEI,gCAAA;IAAA,+BAAA;EnE26QR;EmE76QI;IAEI,+BAAA;IAAA,8BAAA;EnE+6QR;EmEj7QI;IAEI,6BAAA;IAAA,4BAAA;EnEm7QR;EmEr7QI;IAEI,+BAAA;IAAA,8BAAA;EnEu7QR;EmEz7QI;IAEI,6BAAA;IAAA,4BAAA;EnE27QR;EmE77QI;IAEI,6BAAA;IAAA,4BAAA;EnE+7QR;EmEj8QI;IAEI,wBAAA;IAAA,2BAAA;EnEm8QR;EmEr8QI;IAEI,8BAAA;IAAA,iCAAA;EnEu8QR;EmEz8QI;IAEI,6BAAA;IAAA,gCAAA;EnE28QR;EmE78QI;IAEI,2BAAA;IAAA,8BAAA;EnE+8QR;EmEj9QI;IAEI,6BAAA;IAAA,gCAAA;EnEm9QR;EmEr9QI;IAEI,2BAAA;IAAA,8BAAA;EnEu9QR;EmEz9QI;IAEI,2BAAA;IAAA,8BAAA;EnE29QR;EmE79QI;IAEI,wBAAA;EnE89QR;EmEh+QI;IAEI,8BAAA;EnEi+QR;EmEn+QI;IAEI,6BAAA;EnEo+QR;EmEt+QI;IAEI,2BAAA;EnEu+QR;EmEz+QI;IAEI,6BAAA;EnE0+QR;EmE5+QI;IAEI,2BAAA;EnE6+QR;EmE/+QI;IAEI,2BAAA;EnEg/QR;EmEl/QI;IAEI,0BAAA;EnEm/QR;EmEr/QI;IAEI,gCAAA;EnEs/QR;EmEx/QI;IAEI,+BAAA;EnEy/QR;EmE3/QI;IAEI,6BAAA;EnE4/QR;EmE9/QI;IAEI,+BAAA;EnE+/QR;EmEjgRI;IAEI,6BAAA;EnEkgRR;EmEpgRI;IAEI,6BAAA;EnEqgRR;EmEvgRI;IAEI,2BAAA;EnEwgRR;EmE1gRI;IAEI,iCAAA;EnE2gRR;EmE7gRI;IAEI,gCAAA;EnE8gRR;EmEhhRI;IAEI,8BAAA;EnEihRR;EmEnhRI;IAEI,gCAAA;EnEohRR;EmEthRI;IAEI,8BAAA;EnEuhRR;EmEzhRI;IAEI,8BAAA;EnE0hRR;EmE5hRI;IAEI,yBAAA;EnE6hRR;EmE/hRI;IAEI,+BAAA;EnEgiRR;EmEliRI;IAEI,8BAAA;EnEmiRR;EmEriRI;IAEI,4BAAA;EnEsiRR;EmExiRI;IAEI,8BAAA;EnEyiRR;EmE3iRI;IAEI,4BAAA;EnE4iRR;EmE9iRI;IAEI,4BAAA;EnE+iRR;EmEjjRI;IAEI,qBAAA;EnEkjRR;EmEpjRI;IAEI,2BAAA;EnEqjRR;EmEvjRI;IAEI,0BAAA;EnEwjRR;EmE1jRI;IAEI,wBAAA;EnE2jRR;EmE7jRI;IAEI,0BAAA;EnE8jRR;EmEhkRI;IAEI,wBAAA;EnEikRR;EmEnkRI;IAEI,2BAAA;IAAA,0BAAA;EnEqkRR;EmEvkRI;IAEI,iCAAA;IAAA,gCAAA;EnEykRR;EmE3kRI;IAEI,gCAAA;IAAA,+BAAA;EnE6kRR;EmE/kRI;IAEI,8BAAA;IAAA,6BAAA;EnEilRR;EmEnlRI;IAEI,gCAAA;IAAA,+BAAA;EnEqlRR;EmEvlRI;IAEI,8BAAA;IAAA,6BAAA;EnEylRR;EmE3lRI;IAEI,yBAAA;IAAA,4BAAA;EnE6lRR;EmE/lRI;IAEI,+BAAA;IAAA,kCAAA;EnEimRR;EmEnmRI;IAEI,8BAAA;IAAA,iCAAA;EnEqmRR;EmEvmRI;IAEI,4BAAA;IAAA,+BAAA;EnEymRR;EmE3mRI;IAEI,8BAAA;IAAA,iCAAA;EnE6mRR;EmE/mRI;IAEI,4BAAA;IAAA,+BAAA;EnEinRR;EmEnnRI;IAEI,yBAAA;EnEonRR;EmEtnRI;IAEI,+BAAA;EnEunRR;EmEznRI;IAEI,8BAAA;EnE0nRR;EmE5nRI;IAEI,4BAAA;EnE6nRR;EmE/nRI;IAEI,8BAAA;EnEgoRR;EmEloRI;IAEI,4BAAA;EnEmoRR;EmEroRI;IAEI,2BAAA;EnEsoRR;EmExoRI;IAEI,iCAAA;EnEyoRR;EmE3oRI;IAEI,gCAAA;EnE4oRR;EmE9oRI;IAEI,8BAAA;EnE+oRR;EmEjpRI;IAEI,gCAAA;EnEkpRR;EmEppRI;IAEI,8BAAA;EnEqpRR;EmEvpRI;IAEI,4BAAA;EnEwpRR;EmE1pRI;IAEI,kCAAA;EnE2pRR;EmE7pRI;IAEI,iCAAA;EnE8pRR;EmEhqRI;IAEI,+BAAA;EnEiqRR;EmEnqRI;IAEI,iCAAA;EnEoqRR;EmEtqRI;IAEI,+BAAA;EnEuqRR;EmEzqRI;IAEI,0BAAA;EnE0qRR;EmE5qRI;IAEI,gCAAA;EnE6qRR;EmE/qRI;IAEI,+BAAA;EnEgrRR;EmElrRI;IAEI,6BAAA;EnEmrRR;EmErrRI;IAEI,+BAAA;EnEsrRR;EmExrRI;IAEI,6BAAA;EnEyrRR;EmE3rRI;IAEI,2BAAA;EnE4rRR;EmE9rRI;IAEI,4BAAA;EnE+rRR;EmEjsRI;IAEI,6BAAA;EnEksRR;AACF;AavrRI;EsDdE;IAEI,sBAAA;EnEusRR;EmEzsRI;IAEI,uBAAA;EnE0sRR;EmE5sRI;IAEI,sBAAA;EnE6sRR;EmE/sRI;IAEI,0BAAA;EnEgtRR;EmEltRI;IAEI,gCAAA;EnEmtRR;EmErtRI;IAEI,yBAAA;EnEstRR;EmExtRI;IAEI,wBAAA;EnEytRR;EmE3tRI;IAEI,yBAAA;EnE4tRR;EmE9tRI;IAEI,6BAAA;EnE+tRR;EmEjuRI;IAEI,8BAAA;EnEkuRR;EmEpuRI;IAEI,wBAAA;EnEquRR;EmEvuRI;IAEI,+BAAA;EnEwuRR;EmE1uRI;IAEI,wBAAA;EnE2uRR;EmE7uRI;IAEI,yBAAA;EnE8uRR;EmEhvRI;IAEI,8BAAA;EnEivRR;EmEnvRI;IAEI,iCAAA;EnEovRR;EmEtvRI;IAEI,sCAAA;EnEuvRR;EmEzvRI;IAEI,yCAAA;EnE0vRR;EmE5vRI;IAEI,uBAAA;EnE6vRR;EmE/vRI;IAEI,uBAAA;EnEgwRR;EmElwRI;IAEI,yBAAA;EnEmwRR;EmErwRI;IAEI,yBAAA;EnEswRR;EmExwRI;IAEI,0BAAA;EnEywRR;EmE3wRI;IAEI,4BAAA;EnE4wRR;EmE9wRI;IAEI,kCAAA;EnE+wRR;EmEjxRI;IAEI,iBAAA;EnEkxRR;EmEpxRI;IAEI,uBAAA;EnEqxRR;EmEvxRI;IAEI,sBAAA;EnEwxRR;EmE1xRI;IAEI,oBAAA;EnE2xRR;EmE7xRI;IAEI,sBAAA;EnE8xRR;EmEhyRI;IAEI,oBAAA;EnEiyRR;EmEnyRI;IAEI,sCAAA;EnEoyRR;EmEtyRI;IAEI,oCAAA;EnEuyRR;EmEzyRI;IAEI,kCAAA;EnE0yRR;EmE5yRI;IAEI,yCAAA;EnE6yRR;EmE/yRI;IAEI,wCAAA;EnEgzRR;EmElzRI;IAEI,wCAAA;EnEmzRR;EmErzRI;IAEI,kCAAA;EnEszRR;EmExzRI;IAEI,gCAAA;EnEyzRR;EmE3zRI;IAEI,8BAAA;EnE4zRR;EmE9zRI;IAEI,gCAAA;EnE+zRR;EmEj0RI;IAEI,+BAAA;EnEk0RR;EmEp0RI;IAEI,oCAAA;EnEq0RR;EmEv0RI;IAEI,kCAAA;EnEw0RR;EmE10RI;IAEI,gCAAA;EnE20RR;EmE70RI;IAEI,uCAAA;EnE80RR;EmEh1RI;IAEI,sCAAA;EnEi1RR;EmEn1RI;IAEI,iCAAA;EnEo1RR;EmEt1RI;IAEI,2BAAA;EnEu1RR;EmEz1RI;IAEI,iCAAA;EnE01RR;EmE51RI;IAEI,+BAAA;EnE61RR;EmE/1RI;IAEI,6BAAA;EnEg2RR;EmEl2RI;IAEI,+BAAA;EnEm2RR;EmEr2RI;IAEI,8BAAA;EnEs2RR;EmEx2RI;IAEI,oBAAA;EnEy2RR;EmE32RI;IAEI,mBAAA;EnE42RR;EmE92RI;IAEI,mBAAA;EnE+2RR;EmEj3RI;IAEI,mBAAA;EnEk3RR;EmEp3RI;IAEI,mBAAA;EnEq3RR;EmEv3RI;IAEI,mBAAA;EnEw3RR;EmE13RI;IAEI,mBAAA;EnE23RR;EmE73RI;IAEI,mBAAA;EnE83RR;EmEh4RI;IAEI,oBAAA;EnEi4RR;EmEn4RI;IAEI,0BAAA;EnEo4RR;EmEt4RI;IAEI,yBAAA;EnEu4RR;EmEz4RI;IAEI,uBAAA;EnE04RR;EmE54RI;IAEI,yBAAA;EnE64RR;EmE/4RI;IAEI,uBAAA;EnEg5RR;EmEl5RI;IAEI,uBAAA;EnEm5RR;EmEr5RI;IAEI,0BAAA;IAAA,yBAAA;EnEu5RR;EmEz5RI;IAEI,gCAAA;IAAA,+BAAA;EnE25RR;EmE75RI;IAEI,+BAAA;IAAA,8BAAA;EnE+5RR;EmEj6RI;IAEI,6BAAA;IAAA,4BAAA;EnEm6RR;EmEr6RI;IAEI,+BAAA;IAAA,8BAAA;EnEu6RR;EmEz6RI;IAEI,6BAAA;IAAA,4BAAA;EnE26RR;EmE76RI;IAEI,6BAAA;IAAA,4BAAA;EnE+6RR;EmEj7RI;IAEI,wBAAA;IAAA,2BAAA;EnEm7RR;EmEr7RI;IAEI,8BAAA;IAAA,iCAAA;EnEu7RR;EmEz7RI;IAEI,6BAAA;IAAA,gCAAA;EnE27RR;EmE77RI;IAEI,2BAAA;IAAA,8BAAA;EnE+7RR;EmEj8RI;IAEI,6BAAA;IAAA,gCAAA;EnEm8RR;EmEr8RI;IAEI,2BAAA;IAAA,8BAAA;EnEu8RR;EmEz8RI;IAEI,2BAAA;IAAA,8BAAA;EnE28RR;EmE78RI;IAEI,wBAAA;EnE88RR;EmEh9RI;IAEI,8BAAA;EnEi9RR;EmEn9RI;IAEI,6BAAA;EnEo9RR;EmEt9RI;IAEI,2BAAA;EnEu9RR;EmEz9RI;IAEI,6BAAA;EnE09RR;EmE59RI;IAEI,2BAAA;EnE69RR;EmE/9RI;IAEI,2BAAA;EnEg+RR;EmEl+RI;IAEI,0BAAA;EnEm+RR;EmEr+RI;IAEI,gCAAA;EnEs+RR;EmEx+RI;IAEI,+BAAA;EnEy+RR;EmE3+RI;IAEI,6BAAA;EnE4+RR;EmE9+RI;IAEI,+BAAA;EnE++RR;EmEj/RI;IAEI,6BAAA;EnEk/RR;EmEp/RI;IAEI,6BAAA;EnEq/RR;EmEv/RI;IAEI,2BAAA;EnEw/RR;EmE1/RI;IAEI,iCAAA;EnE2/RR;EmE7/RI;IAEI,gCAAA;EnE8/RR;EmEhgSI;IAEI,8BAAA;EnEigSR;EmEngSI;IAEI,gCAAA;EnEogSR;EmEtgSI;IAEI,8BAAA;EnEugSR;EmEzgSI;IAEI,8BAAA;EnE0gSR;EmE5gSI;IAEI,yBAAA;EnE6gSR;EmE/gSI;IAEI,+BAAA;EnEghSR;EmElhSI;IAEI,8BAAA;EnEmhSR;EmErhSI;IAEI,4BAAA;EnEshSR;EmExhSI;IAEI,8BAAA;EnEyhSR;EmE3hSI;IAEI,4BAAA;EnE4hSR;EmE9hSI;IAEI,4BAAA;EnE+hSR;EmEjiSI;IAEI,qBAAA;EnEkiSR;EmEpiSI;IAEI,2BAAA;EnEqiSR;EmEviSI;IAEI,0BAAA;EnEwiSR;EmE1iSI;IAEI,wBAAA;EnE2iSR;EmE7iSI;IAEI,0BAAA;EnE8iSR;EmEhjSI;IAEI,wBAAA;EnEijSR;EmEnjSI;IAEI,2BAAA;IAAA,0BAAA;EnEqjSR;EmEvjSI;IAEI,iCAAA;IAAA,gCAAA;EnEyjSR;EmE3jSI;IAEI,gCAAA;IAAA,+BAAA;EnE6jSR;EmE/jSI;IAEI,8BAAA;IAAA,6BAAA;EnEikSR;EmEnkSI;IAEI,gCAAA;IAAA,+BAAA;EnEqkSR;EmEvkSI;IAEI,8BAAA;IAAA,6BAAA;EnEykSR;EmE3kSI;IAEI,yBAAA;IAAA,4BAAA;EnE6kSR;EmE/kSI;IAEI,+BAAA;IAAA,kCAAA;EnEilSR;EmEnlSI;IAEI,8BAAA;IAAA,iCAAA;EnEqlSR;EmEvlSI;IAEI,4BAAA;IAAA,+BAAA;EnEylSR;EmE3lSI;IAEI,8BAAA;IAAA,iCAAA;EnE6lSR;EmE/lSI;IAEI,4BAAA;IAAA,+BAAA;EnEimSR;EmEnmSI;IAEI,yBAAA;EnEomSR;EmEtmSI;IAEI,+BAAA;EnEumSR;EmEzmSI;IAEI,8BAAA;EnE0mSR;EmE5mSI;IAEI,4BAAA;EnE6mSR;EmE/mSI;IAEI,8BAAA;EnEgnSR;EmElnSI;IAEI,4BAAA;EnEmnSR;EmErnSI;IAEI,2BAAA;EnEsnSR;EmExnSI;IAEI,iCAAA;EnEynSR;EmE3nSI;IAEI,gCAAA;EnE4nSR;EmE9nSI;IAEI,8BAAA;EnE+nSR;EmEjoSI;IAEI,gCAAA;EnEkoSR;EmEpoSI;IAEI,8BAAA;EnEqoSR;EmEvoSI;IAEI,4BAAA;EnEwoSR;EmE1oSI;IAEI,kCAAA;EnE2oSR;EmE7oSI;IAEI,iCAAA;EnE8oSR;EmEhpSI;IAEI,+BAAA;EnEipSR;EmEnpSI;IAEI,iCAAA;EnEopSR;EmEtpSI;IAEI,+BAAA;EnEupSR;EmEzpSI;IAEI,0BAAA;EnE0pSR;EmE5pSI;IAEI,gCAAA;EnE6pSR;EmE/pSI;IAEI,+BAAA;EnEgqSR;EmElqSI;IAEI,6BAAA;EnEmqSR;EmErqSI;IAEI,+BAAA;EnEsqSR;EmExqSI;IAEI,6BAAA;EnEyqSR;EmE3qSI;IAEI,2BAAA;EnE4qSR;EmE9qSI;IAEI,4BAAA;EnE+qSR;EmEjrSI;IAEI,6BAAA;EnEkrSR;AACF;AavqSI;EsDdE;IAEI,sBAAA;EnEurSR;EmEzrSI;IAEI,uBAAA;EnE0rSR;EmE5rSI;IAEI,sBAAA;EnE6rSR;EmE/rSI;IAEI,0BAAA;EnEgsSR;EmElsSI;IAEI,gCAAA;EnEmsSR;EmErsSI;IAEI,yBAAA;EnEssSR;EmExsSI;IAEI,wBAAA;EnEysSR;EmE3sSI;IAEI,yBAAA;EnE4sSR;EmE9sSI;IAEI,6BAAA;EnE+sSR;EmEjtSI;IAEI,8BAAA;EnEktSR;EmEptSI;IAEI,wBAAA;EnEqtSR;EmEvtSI;IAEI,+BAAA;EnEwtSR;EmE1tSI;IAEI,wBAAA;EnE2tSR;EmE7tSI;IAEI,yBAAA;EnE8tSR;EmEhuSI;IAEI,8BAAA;EnEiuSR;EmEnuSI;IAEI,iCAAA;EnEouSR;EmEtuSI;IAEI,sCAAA;EnEuuSR;EmEzuSI;IAEI,yCAAA;EnE0uSR;EmE5uSI;IAEI,uBAAA;EnE6uSR;EmE/uSI;IAEI,uBAAA;EnEgvSR;EmElvSI;IAEI,yBAAA;EnEmvSR;EmErvSI;IAEI,yBAAA;EnEsvSR;EmExvSI;IAEI,0BAAA;EnEyvSR;EmE3vSI;IAEI,4BAAA;EnE4vSR;EmE9vSI;IAEI,kCAAA;EnE+vSR;EmEjwSI;IAEI,iBAAA;EnEkwSR;EmEpwSI;IAEI,uBAAA;EnEqwSR;EmEvwSI;IAEI,sBAAA;EnEwwSR;EmE1wSI;IAEI,oBAAA;EnE2wSR;EmE7wSI;IAEI,sBAAA;EnE8wSR;EmEhxSI;IAEI,oBAAA;EnEixSR;EmEnxSI;IAEI,sCAAA;EnEoxSR;EmEtxSI;IAEI,oCAAA;EnEuxSR;EmEzxSI;IAEI,kCAAA;EnE0xSR;EmE5xSI;IAEI,yCAAA;EnE6xSR;EmE/xSI;IAEI,wCAAA;EnEgySR;EmElySI;IAEI,wCAAA;EnEmySR;EmErySI;IAEI,kCAAA;EnEsySR;EmExySI;IAEI,gCAAA;EnEyySR;EmE3ySI;IAEI,8BAAA;EnE4ySR;EmE9ySI;IAEI,gCAAA;EnE+ySR;EmEjzSI;IAEI,+BAAA;EnEkzSR;EmEpzSI;IAEI,oCAAA;EnEqzSR;EmEvzSI;IAEI,kCAAA;EnEwzSR;EmE1zSI;IAEI,gCAAA;EnE2zSR;EmE7zSI;IAEI,uCAAA;EnE8zSR;EmEh0SI;IAEI,sCAAA;EnEi0SR;EmEn0SI;IAEI,iCAAA;EnEo0SR;EmEt0SI;IAEI,2BAAA;EnEu0SR;EmEz0SI;IAEI,iCAAA;EnE00SR;EmE50SI;IAEI,+BAAA;EnE60SR;EmE/0SI;IAEI,6BAAA;EnEg1SR;EmEl1SI;IAEI,+BAAA;EnEm1SR;EmEr1SI;IAEI,8BAAA;EnEs1SR;EmEx1SI;IAEI,oBAAA;EnEy1SR;EmE31SI;IAEI,mBAAA;EnE41SR;EmE91SI;IAEI,mBAAA;EnE+1SR;EmEj2SI;IAEI,mBAAA;EnEk2SR;EmEp2SI;IAEI,mBAAA;EnEq2SR;EmEv2SI;IAEI,mBAAA;EnEw2SR;EmE12SI;IAEI,mBAAA;EnE22SR;EmE72SI;IAEI,mBAAA;EnE82SR;EmEh3SI;IAEI,oBAAA;EnEi3SR;EmEn3SI;IAEI,0BAAA;EnEo3SR;EmEt3SI;IAEI,yBAAA;EnEu3SR;EmEz3SI;IAEI,uBAAA;EnE03SR;EmE53SI;IAEI,yBAAA;EnE63SR;EmE/3SI;IAEI,uBAAA;EnEg4SR;EmEl4SI;IAEI,uBAAA;EnEm4SR;EmEr4SI;IAEI,0BAAA;IAAA,yBAAA;EnEu4SR;EmEz4SI;IAEI,gCAAA;IAAA,+BAAA;EnE24SR;EmE74SI;IAEI,+BAAA;IAAA,8BAAA;EnE+4SR;EmEj5SI;IAEI,6BAAA;IAAA,4BAAA;EnEm5SR;EmEr5SI;IAEI,+BAAA;IAAA,8BAAA;EnEu5SR;EmEz5SI;IAEI,6BAAA;IAAA,4BAAA;EnE25SR;EmE75SI;IAEI,6BAAA;IAAA,4BAAA;EnE+5SR;EmEj6SI;IAEI,wBAAA;IAAA,2BAAA;EnEm6SR;EmEr6SI;IAEI,8BAAA;IAAA,iCAAA;EnEu6SR;EmEz6SI;IAEI,6BAAA;IAAA,gCAAA;EnE26SR;EmE76SI;IAEI,2BAAA;IAAA,8BAAA;EnE+6SR;EmEj7SI;IAEI,6BAAA;IAAA,gCAAA;EnEm7SR;EmEr7SI;IAEI,2BAAA;IAAA,8BAAA;EnEu7SR;EmEz7SI;IAEI,2BAAA;IAAA,8BAAA;EnE27SR;EmE77SI;IAEI,wBAAA;EnE87SR;EmEh8SI;IAEI,8BAAA;EnEi8SR;EmEn8SI;IAEI,6BAAA;EnEo8SR;EmEt8SI;IAEI,2BAAA;EnEu8SR;EmEz8SI;IAEI,6BAAA;EnE08SR;EmE58SI;IAEI,2BAAA;EnE68SR;EmE/8SI;IAEI,2BAAA;EnEg9SR;EmEl9SI;IAEI,0BAAA;EnEm9SR;EmEr9SI;IAEI,gCAAA;EnEs9SR;EmEx9SI;IAEI,+BAAA;EnEy9SR;EmE39SI;IAEI,6BAAA;EnE49SR;EmE99SI;IAEI,+BAAA;EnE+9SR;EmEj+SI;IAEI,6BAAA;EnEk+SR;EmEp+SI;IAEI,6BAAA;EnEq+SR;EmEv+SI;IAEI,2BAAA;EnEw+SR;EmE1+SI;IAEI,iCAAA;EnE2+SR;EmE7+SI;IAEI,gCAAA;EnE8+SR;EmEh/SI;IAEI,8BAAA;EnEi/SR;EmEn/SI;IAEI,gCAAA;EnEo/SR;EmEt/SI;IAEI,8BAAA;EnEu/SR;EmEz/SI;IAEI,8BAAA;EnE0/SR;EmE5/SI;IAEI,yBAAA;EnE6/SR;EmE//SI;IAEI,+BAAA;EnEggTR;EmElgTI;IAEI,8BAAA;EnEmgTR;EmErgTI;IAEI,4BAAA;EnEsgTR;EmExgTI;IAEI,8BAAA;EnEygTR;EmE3gTI;IAEI,4BAAA;EnE4gTR;EmE9gTI;IAEI,4BAAA;EnE+gTR;EmEjhTI;IAEI,qBAAA;EnEkhTR;EmEphTI;IAEI,2BAAA;EnEqhTR;EmEvhTI;IAEI,0BAAA;EnEwhTR;EmE1hTI;IAEI,wBAAA;EnE2hTR;EmE7hTI;IAEI,0BAAA;EnE8hTR;EmEhiTI;IAEI,wBAAA;EnEiiTR;EmEniTI;IAEI,2BAAA;IAAA,0BAAA;EnEqiTR;EmEviTI;IAEI,iCAAA;IAAA,gCAAA;EnEyiTR;EmE3iTI;IAEI,gCAAA;IAAA,+BAAA;EnE6iTR;EmE/iTI;IAEI,8BAAA;IAAA,6BAAA;EnEijTR;EmEnjTI;IAEI,gCAAA;IAAA,+BAAA;EnEqjTR;EmEvjTI;IAEI,8BAAA;IAAA,6BAAA;EnEyjTR;EmE3jTI;IAEI,yBAAA;IAAA,4BAAA;EnE6jTR;EmE/jTI;IAEI,+BAAA;IAAA,kCAAA;EnEikTR;EmEnkTI;IAEI,8BAAA;IAAA,iCAAA;EnEqkTR;EmEvkTI;IAEI,4BAAA;IAAA,+BAAA;EnEykTR;EmE3kTI;IAEI,8BAAA;IAAA,iCAAA;EnE6kTR;EmE/kTI;IAEI,4BAAA;IAAA,+BAAA;EnEilTR;EmEnlTI;IAEI,yBAAA;EnEolTR;EmEtlTI;IAEI,+BAAA;EnEulTR;EmEzlTI;IAEI,8BAAA;EnE0lTR;EmE5lTI;IAEI,4BAAA;EnE6lTR;EmE/lTI;IAEI,8BAAA;EnEgmTR;EmElmTI;IAEI,4BAAA;EnEmmTR;EmErmTI;IAEI,2BAAA;EnEsmTR;EmExmTI;IAEI,iCAAA;EnEymTR;EmE3mTI;IAEI,gCAAA;EnE4mTR;EmE9mTI;IAEI,8BAAA;EnE+mTR;EmEjnTI;IAEI,gCAAA;EnEknTR;EmEpnTI;IAEI,8BAAA;EnEqnTR;EmEvnTI;IAEI,4BAAA;EnEwnTR;EmE1nTI;IAEI,kCAAA;EnE2nTR;EmE7nTI;IAEI,iCAAA;EnE8nTR;EmEhoTI;IAEI,+BAAA;EnEioTR;EmEnoTI;IAEI,iCAAA;EnEooTR;EmEtoTI;IAEI,+BAAA;EnEuoTR;EmEzoTI;IAEI,0BAAA;EnE0oTR;EmE5oTI;IAEI,gCAAA;EnE6oTR;EmE/oTI;IAEI,+BAAA;EnEgpTR;EmElpTI;IAEI,6BAAA;EnEmpTR;EmErpTI;IAEI,+BAAA;EnEspTR;EmExpTI;IAEI,6BAAA;EnEypTR;EmE3pTI;IAEI,2BAAA;EnE4pTR;EmE9pTI;IAEI,4BAAA;EnE+pTR;EmEjqTI;IAEI,6BAAA;EnEkqTR;AACF;AoEnsTA;ED8BM;IAEI,4BAAA;EnEuqTR;EmEzqTI;IAEI,6BAAA;EnE0qTR;EmE5qTI;IAEI,6BAAA;EnE6qTR;EmE/qTI;IAEI,6BAAA;EnEgrTR;AACF;AoE9rTA;EDWM;IAEI,0BAAA;EnEqrTR;EmEvrTI;IAEI,gCAAA;EnEwrTR;EmE1rTI;IAEI,yBAAA;EnE2rTR;EmE7rTI;IAEI,wBAAA;EnE8rTR;EmEhsTI;IAEI,yBAAA;EnEisTR;EmEnsTI;IAEI,6BAAA;EnEosTR;EmEtsTI;IAEI,8BAAA;EnEusTR;EmEzsTI;IAEI,wBAAA;EnE0sTR;EmE5sTI;IAEI,+BAAA;EnE6sTR;EmE/sTI;IAEI,wBAAA;EnEgtTR;AACF;AqElwTA;;;EAGE,wBAAA;ArEowTF;;AqEjwTA;EACE,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,SAAA;ArEowTF;;AsE9wTA;EACE,4BAAA;EACA,UAAA;AtEixTF;AsE/wTE;EACE,UAAA;EACA,wBAAA;EACA,2BAAA;AtEixTJ;;AsEpwTA;EACE,4BAAA;EACA,UAAA;AtEuwTF;AsErwTE;EACE,UAAA;EACA,wBAAA;EACA,2BAAA;AtEuwTJ;;AsEjwTA;EACE,4BAAA;EACA,UAAA;AtEowTF;AsElwTE;EACE,UAAA;EACA,wBAAA;EACA,2BAAA;AtEowTJ;;AuE5yTA;EACE,YCWgC;EDVhC,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,oBAAA;AvE+yTF;AuE7yTE;EACE,kUtEoGiB;AD2sTrB;AuE5yTE;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,SAAA;EACA,iBAAA;EACA,YCP8B;AxEqzTlC;AuE5yTI;EACE,aAAA;EACA,mBAAA;AvE8yTN;AuE3yTI;EACE,mBAAA;EACA,aAAA;EACA,iBAAA;AvE6yTN;AuExyTI;EAEE,mBAAA;AvEyyTN;AuEtyTI;EACE,iBtEoDS;ADovTf;;AuEnyTA;EACE,iBAAA;EACA,YCnCgC;EDoChC,YC1CgC;ED2ChC,aAAA;EACA,mBAAA;EACA,sBAAA;AvEsyTF;AuEpyTE;EACE,YC7C8B;ED8C9B,WC7C8B;ED8C9B,oDAAA;AvEsyTJ;;AuElyTA;;EAEE,aAAA;EACA,iBAAA;EACA,YCpDgC;EDqDhC,mBAAA;AvEqyTF;;AyEr2TE;EACE,eAAA;EACA,WAAA;EACA,MAAA;AzEw2TJ;AyEt2TI;EACE,mBAAA;AzEw2TN;AyEp2TE;EACE,iBAAA;AzEs2TJ;AyEj2TM;EACE,kBAAA;AzEm2TR;;AyE71TA;EACE,aAAA;EACA,mBAAA;AzEg2TF;;AyE71TA;EACE,aAAA;EACA,uBAAA;AzEg2TF;;A0E/3TA;EACE,iBAAA;EACA,aAAA;A1Ek4TF;A0Eh4TE;EACE,aAAA;EACA,qBAAA;A1Ek4TJ;A0E/3TE;EACE,SAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;A1Ei4TJ;A0E/3TI;EpECA,mBAAA;EoECE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;A1Ei4TN;A0E/3TM;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,uBAAA;A1Ei4TR;A0E53TI;EACE,YAAA;EACA,wBAAA;EpEnBF,mBAAA;ANk5TJ;A0E33TI;EACE,cAAA;A1E63TN;A0E13TI;EACE;IACE,UAAA;E1E43TN;AACF;A0Ez3TI;EACE,iBAAA;A1E23TN;A0Ex3TI;EACE,eAAA;A1E03TN;A0Ex3TM;EACE,YAAA;A1E03TR;A0Et3TI;EACE,QAAA;EACA,UAAA;EACA,SAAA;A1Ew3TN;;A2Er7TI;EACE,c1EeK;E0EdL,6BAAA;EACA,8BAAA;A3Ew7TN;A2Et7TM;EACE,gBAAA;A3Ew7TR;A2Er7TM;EACE,c1EQG;AD+6TX;A2Ep7TM;EACE,eAAA;A3Es7TR;;A4Ev8TA;EACE,qBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EAEA;;;;;;;;;IAAA;A5Ek9TF;A4Ev8TE;;;EAGE,mB3EFO;AD28TX;;A6E79TI;EACE,+BAAA;A7Eg+TN;A6E99TM;EACE,+BAAA;A7Eg+TR;A6E79TM;EACE,yBAAA;A7E+9TR;A6Ex9TQ;EACE,8BAAA;EACA,oBAAA;A7E09TV;A6Ev9TQ;EACE,+CAAA;EACA,oBAAA;EACA,UAAA;A7Ey9TV;A6Er9TU;EACE,+BAAA;A7Eu9TZ;A6Ep9TU;EACE,gDAAA;A7Es9TZ;A6El9TQ;EACE,yBAAA;A7Eo9TV;A6E98TQ;;;EAGE,+BAAA;A7Eg9TV;A6E58TU;EACE,2FAAA;A7E88TZ;A6Et8TQ;EACE,8BAAA;A7Ew8TV;A6Ep8TU;EAKE,0CAAA;A7Ek8TZ;A6E57TQ;EACE,oCAAA;A7E87TV;A6E57TU;EACE,+BAAA;A7E87TZ;A6E37TU;EACE,oCAAA;A7E67TZ;A6Et7TM;EACE,oCAAA;A7Ew7TR;A6El7TM;;;;;;;;EAIE,qDAAA;A7Ew7TR;A6Ep7TI;EACE,sCAAA;A7Es7TN;A6En7TI;;;EAGE,oCAAA;A7Eq7TN;A6Ej7TM;EACE,oDAAA;A7Em7TR;A6E96TM;;;EAGE,oCAAA;A7Eg7TR;;A8E7iUI;EACE,yBAAA;A9EgjUN;A8E9iUM;EACE,yBAAA;A9EgjUR;A8E7iUM;EACE,mBAAA;A9E+iUR;A8ExiUQ;EACE,wBAAA;EACA,oBAAA;A9E0iUV;A8EviUQ;EACE,yCAAA;EACA,oBAAA;EACA,UAAA;A9EyiUV;A8EriUU;EACE,yBAAA;A9EuiUZ;A8EpiUU;EACE,0CAAA;A9EsiUZ;A8EliUQ;EACE,yBAAA;A9EoiUV;A8E9hUQ;;;EAGE,yBAAA;A9EgiUV;A8EzhUQ;EACE,8BAAA;A9E2hUV;A8EthUQ;EACE,8BAAA;A9EwhUV;A8EthUU;EACE,yBAAA;A9EwhUZ;A8ErhUU;EACE,8BAAA;A9EuhUZ;A8EhhUM;EACE,8BAAA;A9EkhUR;A8E5gUM;;;;;;;;EAIE,+CAAA;A9EkhUR;A8E9gUI;EACE,gCAAA;A9EghUN;A8E7gUI;;;EAGE,8BAAA;A9E+gUN;A8E3gUM;EACE,oDAAA;A9E6gUR;;A+ElnUA;EACE,YPGgC;EOFhC,aAAA;EACA,WAAA;EACA,gBAAA;EACA,gBPDgC;EOEhC,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBPCgC;EOAhC,oBAAA;A/EqnUF;A+EnnUE;EACE,2BAAA;A/EqnUJ;A+ElnUE;EACE,WAAA;EACA,WAAA;A/EonUJ;A+EjnUE;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;A/EmnUJ;A+EhnUE;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,aAAA;EACA,WAAA;A/EknUJ;A+E/mUE;EACE,0CAAA;A/EinUJ;;A+E7mUA;EACE,yBAAA;EACA,iB9E2Ca;E8E1Cb,iBAAA;EACA,iBAAA;EACA,c9ERM;E8ESN,mBAAA;EACA,kBAAA;A/EgnUF;;A+E7mUA;EACE,aAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;A/EgnUF;;AgFlrUA;EACE,kBAAA;AhFqrUF;AgFnrUE;EACE,YAAA;EACA,oBAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;AhFqrUJ;AgFlrUE;;EAEE,SAAA;EACA,UAAA;EACA,kBAAA;AhForUJ;AgFlrUE;EACE,gBAAA;AhForUJ;AgFlrUI;EACE,UAAA;EACA,yBAAA;AhForUN;AgFjrUI;EACE,6EAAA;EACA,cAAA;EACA,mBAAA;EACA,cAAA;EACA,wBAAA;EACA,kBAAA;E1EhBF,sBAAA;E0EkBE,c/EbK;E+EcL,mBAAA;AhFmrUN;AgFjrUM;EACE,mB/EmEiB;E+ElEjB,qBAAA;AhFmrUR;AgFhrUQ;EACE,YAAA;AhFkrUV;AgF/qUQ;EACE,UAAA;AhFirUV;AgF7qUM;EACE,c/ETA;E+EUA,mB/EoDiB;AD2nUzB;AgF5qUM;EAEE,iBAAA;AhF6qUR;AgFzqUI;;EAEE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,iBAAA;EACA,iBAAA;EACA,YAAA;EACA,uBAAA;AhF2qUN;AgFxqUI;EACE,2BAAA;EACA,UAAA;EACA,QAAA;AhF0qUN;AgFxqUM;EACE,0BAAA;AhF0qUR;AgFtqUI;EACE,yBAAA;AhFwqUN;AgFtqUM;EACE,uBAAA;AhFwqUR;AgFtqUQ;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,mB/EOe;E+ENf,kBAAA;EACA,UAAA;EACA,MAAA;E1ErFN,mBAAA;AN8vUJ;AgFrqUQ;EACE,aAAA;EACA,kBAAA;EACA,c/EzFC;E+E0FD,eAAA;AhFuqUV;AgFrqUU;EACE,c/ErEJ;AD4uUR;AgFpqUU;EACE,aAAA;AhFsqUZ;AgFnqUU;EACE,c/E7EJ;E+E8EI,mB/EhBa;ADqrUzB;AgFhqUM;EACE,SAAA;EACA,gBAAA;AhFkqUR;AgF/pUM;EACE,iBAAA;AhFiqUR;;AiFryUE;EACE,0BAAA;AjFwyUJ;AiFtyUI;EACE,+BAAA;AjFwyUN;AiFtyUM;EACE,+CAAA;AjFwyUR;AiFlyUQ;EACE,+BAAA;AjFoyUV;AiFlyUU;EACE,yBAAA;EACA,oCAAA;AjFoyUZ;AiFjyUU;EACE,oCAAA;AjFmyUZ;AiF7xUY;EACE,+BAAA;AjF+xUd;AiF7xUc;EACE,oCAAA;EACA,+BAAA;AjF+xUhB;AiF5xUc;EACE,yBAAA;AjF8xUhB;AiFzxUY;EACE,oCAAA;AjF2xUd;AiFtxUQ;;EAEE,YAAA;AjFwxUV;AiFnxUI;EACE,oCAAA;AjFqxUN;AiFjxUM;EACE,oCAAA;AjFmxUR;AiF9wUM;EACE,oDAAA;AjFgxUR;AiF7wUM;;;EAGE,0CAAA;AjF+wUR;;AkFx1UE;EACE,0BAAA;AlF21UJ;AkFz1UI;EACE,yBAAA;AlF21UN;AkFz1UM;EACE,yCAAA;AlF21UR;AkFr1UQ;EACE,yBAAA;AlFu1UV;AkFr1UU;EACE,mBAAA;EACA,8BAAA;AlFu1UZ;AkFp1UU;EACE,8BAAA;AlFs1UZ;AkFh1UY;EACE,yBAAA;AlFk1Ud;AkFh1Uc;EACE,8BAAA;AlFk1UhB;AkF90UY;EACE,8BAAA;AlFg1Ud;AkF50UU;;EAEE,YAAA;AlF80UZ;AkFx0UI;EACE,8BAAA;AlF00UN;AkFt0UM;EACE,8BAAA;AlFw0UR;AkFl0UM;;;EAGE,oCAAA;AlFo0UR;;AmFp4UE;EACE,eAAA;EACA,aAAA;AnFu4UJ;AmFl4UI;EACE,UAAA;EACA,mBXJ4B;AxEw4UlC;AmF73UM;EACE,aAAA;AnF+3UR;AmFx3UM;EACE,aAAA;AnF03UR;AmFt3UI;EAEE,kBX1B4B;AxEi5UlC;AmFr3UM;EACE,aAAA;AnFu3UR;AmF32UM;EACE,iBXzC0B;AxEs5UlC;AmFx2UQ;EACE,WX/CwB;EWgDxB,UAAA;AnF02UV;AmFx2UU;EACE,aAAA;AnF02UZ;AmFv2UU;EACE,kBAAA;AnFy2UZ;;AoFp6UE;EACE,yBAAA;EACA,WZE8B;EYD9B,eZC8B;EYA9B,cAAA;EACA,WAAA;ApFu6UJ;AoFn6UM;EACE,mBAAA;ApFq6UR;AoFn6UQ;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,mBnFoFe;EmFnFf,gBAAA;ApFq6UV;AoFj6UM;EACE,mBAAA;EACA,UAAA;ApFm6UR;AoFh6UM;EACE,cAAA;EACA,SAAA;EACA,kBAAA;ApFk6UR;AoF/5UM;EACE,kBAAA;ApFi6UR;AoF75UQ;EACE,UAAA;ApF+5UV;AoF75UU;EACE,SAAA;ApF+5UZ;AoFz5UI;EACE,0BAAA;EACA,uBAAA;ApF25UN;AoFv5UQ;EACE,cAAA;EAAA,oBAAA;ApFy5UV;AoFx5UU;EACE,aAAA;ApF05UZ;AoFt5UQ;EACE,cAAA;EAAA,oBAAA;EACA,wBAAA;ApFw5UV;AoFr5UQ;EACE,cAAA;EAAA,oBAAA;EACA,SAAA;EACA,cAAA;ApFu5UV;AoFp5UQ;EACE,mBAAA;ApFs5UV;AoFl5UU;EACE,uBAAA;ApFo5UZ;AoFl5UY;EACE,aAAA;ApFo5Ud;AoF/4UY;EACE,iBAAA;ApFi5Ud;AoFr4UM;EACE,gBAAA;EACA,YAAA;EACA,4BAAA;EAAA,4BAAA;ApFu4UR;AoFn4UQ;EACE,kBAAA;EACA,YAAA;EACA,2BAAA;ApFq4UV;AoF73UM;EACE,WZpH0B;AxEm/UlC;AoF73UQ;EACE,aAAA;ApF+3UV;AoF53UQ;EACE,kBAAA;ApF83UV;AoFt3UI;EACE,kBZpI4B;AxE4/UlC;AoFl3UM;EACE,kBAAA;ApFo3UR;AoF52UM;;EACE,WAAA;EACA,aAAA;ApF+2UR;AoF72UQ;;EACE,aAAA;ApFg3UV;AoF12UM;EACE,aAAA;EACA,WZhK0B;EYiK1B,4BAAA;ApF42UR;AoF12UQ;EACE,yBAAA;EACA,cAAA;EACA,WAAA;ApF42UV;AoFz2UQ;EACE,aAAA;ApF22UV;AoFt2UQ;EACE,YZjLwB;AxEyhVlC;AoFt2UU;EACE,WZhLsB;EYiLtB,SAAA;ApFw2UZ;AoFj2UI;EACE,yBAAA;ApFm2UN;AoF91UI;EACE,yBAAA;ApFg2UN;;AqFviVA;EACE,UAAA;EACA,kBAAA;EACA,aAAA;ArF0iVF;AqFxiVE;EACE,SAAA;EACA,sBAAA;EACA,aAAA;EACA,WAAA;EACA,UAAA;ArF0iVJ;AqFviVE;EACE,wBAAA;EACA,SAAA;ArFyiVJ;AqFtiVM;EACE,kBjFkUsB;AJsuU9B;AqFpiVQ;EACE,mBAAA;ArFsiVV;;AqFzhVM;EACE,gBAAA;ArF4hVR;AqFzhVM;EACE,SAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;ArF2hVR;AqFzhVQ;EACE,iBAAA;ArF2hVV;AqFxhVQ;EACE,kBjF+1B0B;AJ2rTpC;AqFvhVQ;EACE,WpF5CF;ADqkVR;AqFthVQ;EACE,kBAAA;EACA,WAAA;EACA,UAAA;ArFwhVV;AqFthVU;EACE,YAAA;EACA,aAAA;E/EnDR,sBAAA;E+EqDQ,iIACQ;ArFuhVpB;;AsFnlVE;EACE,mBAVe;AtFgmVnB;AsFnlVE;EACE,mBAba;AtFkmVjB;AsFllVE;EACE,qCAAA;AtFolVJ;AsFjlVE;;EAEE,mBArBY;AtFwmVhB;AsF/kVI;EACE,oCAAA;AtFilVN;;AuFpmVE;EACE,mBAVe;AvFinVnB;AuFpmVE;EACE,mBAba;EAcb,+BAAA;AvFsmVJ;AuFnmVE;EACE,+BAAA;AvFqmVJ;AuFlmVE;;EAEE,mBAtBY;AvF0nVhB;AuFjmVE;EACE,6BAAA;AvFmmVJ;AuF/lVI;EACE,0CAAA;AvFimVN;AuF5lVI;EACE,+BApCe;AvFkoVrB;AuF1lVE;EACE,iBAAA;AvF4lVJ;AuFzlVE;EACE,0CAAA;AvF2lVJ;AuFvlVM;EACE,oBAAA;EACA,iBtFkCO;EsFjCP,mBAAA;EACA,gCAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AvFylVR;AuFvlVQ;EACE,kBAAA;EACA,WAAA;EACA,mBtFtBF;EK3BJ,mBAAA;EiFmDM,WAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;AvFylVV;AuFnlVE;EACE,yBAAA;AvFqlVJ;;AwFjqVA;EACE,YhBSgC;AxE2pVlC;AwFlqVE;EACE,2BAAA;EACA,YhBK8B;EgBJ9B,oBAAA;EAEA,aAAA;EACA,qBAAA;EACA,mBAAA;AxFmqVJ;AwFjqVI;EACE,aAAA;EACA,mBAAA;AxFmqVN;AwFhqVI;EACE,iBAAA;EACA,aAAA;AxFkqVN;;AwF3pVA;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;AxF8pVF;AwF5pVE;EACE,YAAA;EACA,gBAAA;EACA,UAAA;EACA,mBvFrBO;ADmrVX;;AwF1pVA;EACE,eAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,wBAAA;AxF6pVF;AwF3pVE;EACE,UAAA;AxF6pVJ;AwF3pVI;EACE,SAAA;EACA,kBAAA;AxF6pVN;AwFzpVE;EACE,iBAAA;AxF2pVJ;AwFxpVE;EACE,qBAAA;EACA,UAAA;AxF0pVJ;;AyFxtVE;EACE,eAAA;EACA,WAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;AzF2tVJ;AyFztVI;EACE,kBjBH4B;EiBI5B,0VAAA;AzF2tVN;AyFntVE;EACE,oBjBP8B;AxE4tVlC;AyFhtVM;EACE,4BAAA;AzFktVR;;A0FzuVA;EACE,etFoV4B;EsFnV5B,8BAAA;EACA,kBAAA;A1F4uVF;A0F1uVE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;A1F4uVJ;A0FzuVE;;EAEE,SAAA;EACA,UAAA;A1F2uVJ;A0FxuVE;EACE,iBtFya0B;EsFxa1B,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;A1F0uVJ;A0FvuVE;EACE,gBAAA;EACA,kBzF4Da;EyF3Db,YAAA;A1FyuVJ;A0FvuVI;EACE,UAAA;EACA,eAAA;EACA,uBAAA;A1FyuVN;A0FruVE;EACE,iBAAA;A1FuuVJ;A0FruVI;EACE,SAAA;EACA,UAAA;EACA,uBAAA;A1FuuVN;A0FnuVE;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,wBAAA;EACA,oBAAA;EACA,gBzF3CI;EyF4CJ,kUzFoDiB;EK7FjB,sBAAA;EoF2CA,WAAA;EACA,YAAA;A1FquVJ;A0FnuVI;EACE,YAAA;A1FquVN;A0FluVI;EACE,kBAAA;A1FouVN;A0FhuVE;EACE,4BAAA;A1FkuVJ;A0F/tVE;EAEE,8BAAA;EACA,gCAAA;A1FguVJ;A0F9tVE;EACE;IAEE,4BAAA;IACA,gCAAA;E1F+tVJ;AACF;A0F5tVE;EACE,SAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;A1F8tVJ;;A0FztVE;EpFlFE,mBAAA;AN+yVJ;;A0FxtVA;EACE,8BAAA;A1F2tVF;;A0FztVA;EACE;IACE,4BAAA;E1F4tVF;AACF;A0FttVE;EACE,oBAAA;EACA,qBAAA;EACA,iBAAA;EACA,aAAA;EACA,gCAAA;A1FwtVJ;;A2F70VA;EACE,kBAAA;EACA,6BAAA;A3Fg1VF;A2F90VE;EACE,YAPkB;EAQlB,WARkB;EASlB,gBAAA;EACA,kBAAA;EACA,gCAAA;A3Fg1VJ;A2F90VI;EACE,WAAA;EACA,sBAAA;EACA,UAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,uBAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,6BAAA;EACA,wDAAA;EACA,sBAAA;EACA,kB1F4DW;ADoxVjB;A2F70VI;EACE,WA/BgB;EAgChB,YAhCgB;EAiChB,YAAA;EACA,UAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;EACA,gCAAA;EACA,+BAAA;ErF1BF,mBAAA;AN02VJ;A2F70VM;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,sBAAA;EACA,kBAAA;EACA,wBAAA;EACA,yDAAA;A3F+0VR;A2F70VQ;EAEE,kBAAA;EACA,WAAA;A3F80VV;A2F30VQ;EACE,UAAA;EACA,YAAA;EACA,SAAA;EACA,SAAA;EACA,kBAAA;EACA,mB1FvBF;ADo2VR;A2F10VQ;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,MAAA;EACA,mBAAA;EACA,yBAAA;A3F40VV;A2Ft0VE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;EAEA,4DAAA;EACA,sBAAA;A3Fu0VJ;A2Fr0VI;EAEE,kBAAA;EACA,mB1FvDE;E0FwDF,kBAAA;A3Fs0VN;A2Fn0VI;EACE,UAAA;EACA,YAAA;EACA,SAAA;EACA,MAAA;A3Fq0VN;A2Fl0VI;EACE,WAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;A3Fo0VN;A2Fh0VE;EACE,YAAA;A3Fk0VJ;A2Fh0VI;EACE,YAAA;EACA,mBAAA;EACA,+BAAA;EACA,wDAAA;A3Fk0VN;A2Fh0VM;EACE,UAAA;EACA,6BAAA;A3Fk0VR;A2F/zVM;EACE,WAnIc;EAoId,YApIc;EAqId,SAAA;EACA,mBAAA;A3Fi0VR;A2F/zVQ;EACE,yBAAA;A3Fi0VV;A2F5zVI;EACE,WAAA;EACA,uBAAA;EAEA,wDAAA;EACA,sBAAA;A3F6zVN;A2F3zVM;EACE,qBAAA;A3F6zVR;A2FzzVI;EACE,UAAA;A3F2zVN;;A4Fv9VA;EACE,wBAAA;A5F09VF;;A4Fv9VA;EACE,wBAAA;A5F09VF;;A4Fv9VA;EACE,wBAAA;A5F09VF;;A4Fv9VA;EACE,wBAAA;A5F09VF;;A4Fv9VA;EACE,wBAAA;A5F09VF;;A4Fv9VA;EACE,wBAAA;A5F09VF;;A4Fv9VA;EACE,wBAAA;A5F09VF;;A4Fv9VA;EACE,wBAAA;A5F09VF;;A4Fv9VA;EACE,wBAAA;A5F09VF;;A4Fv9VA;EACE,uBAAA;A5F09VF;;A4Fv9VA;EACE,wBAAA;A5F09VF;;A4Fv9VA;EACE,uBAAA;A5F09VF;;A4Fv9VA;EACE,uBAAA;A5F09VF;;A4Fv9VA;EACE,uBAAA;A5F09VF;;A4Fv9VA;EACE,uBAAA;A5F09VF;;A4Fv9VA;EACE,uBAAA;A5F09VF;;A4Fv9VA;EACE,uBAAA;A5F09VF;;A4Fv9VA;EACE,uBAAA;A5F09VF;;A4Fv9VA;EACE,uBAAA;A5F09VF;;A4Fv9VA;EACE,qBAAA;A5F09VF;;A6FxiWA;EACE,gCAAA;A7F2iWF;;A6FxiWA;EACE,iCAAA;A7F2iWF;;A6FxiWA;EACE,iCAAA;A7F2iWF;;A6FxiWA;EACE,iCAAA;A7F2iWF;;A6FxiWA;EACE,iCAAA;A7F2iWF;;A6FxiWA;EACE,iCAAA;A7F2iWF;;A6FxiWA;EACE,iCAAA;A7F2iWF;;A6FxiWA;EACE,kCAAA;A7F2iWF;;A8FpkWA;EACE,0CAAA;A9FukWF;;A8FpkWA;EACE,2CAAA;A9FukWF;;A8FpkWA;EACE,6CAAA;A9FukWF;;A8FpkWA;EACE,8CAAA;A9FukWF;;A8FpkWA;EACE,2BAAA;A9FukWF;;A8FpkWA;EACE,0BAAA;A9FukWF;;A8FpkWA;ExFXI,sBAAA;ANmlWJ;;A8FlkWA;EACE,4BAAA;EACA,6BAAA;A9FqkWF;;A8FlkWA;EACE,cAAA;A9FqkWF;A8FnkWE;EACE,cAAA;A9FqkWJ;;A8FjkWA;EACE,cAAA;A9FokWF;;A8FjkWA;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;A9FokWF;;A8FhkWE;EACE,MAAA;EACA,UAAA;EACA,YAAA;A9FmkWJ;;A8F7jWA;EACE,6BAAA;EACA,oCAAA;EACA,qBAAA;EACA,4BAAA;A9FgkWF;;A8F3jWA;EACE,4BAAA;A9F8jWF;;A8F3jWA;EACE,4BAAA;A9F8jWF;;A8F3jWA;EACE,4BAAA;A9F8jWF;;A8FzjWA;EACE,wCAAA;A9F4jWF;;A8FvjWA;EACE,wBAAA;A9F0jWF;;A8FvjWA;EACE,uBAAA;A9F0jWF;;A8FvjWA;EACE,YAAA;A9F0jWF;;A8FvjWA;EACE,aAAA;A9F0jWF;;A8FvjWA;EACE,mBAAA;A9F0jWF;;A8FrjWA;EACE,6BAAA;A9FwjWF;;A8FrjWA;EACE,4BAAA;A9FwjWF;;A8FrjWA;EACE,4BAAA;A9FwjWF;;A8FrjWA;EACE,0BAAA;A9FwjWF;;A8FrjWA;EACE,UAAA;A9FwjWF;;A8FrjWA;EACE,cAAA;A9FwjWF;;A8FnjWA;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;A9FsjWF;;A8FnjWA;EACE,SAAA;A9FsjWF;;A8FjjWA;EACE,gB1F0FO;E0FzFP,mB1FyFO;E0FxFP,WAAA;EACA,gBAAA;EACA,mB7FjJS;ADqsWX;;A8FjjWA;EACE,aAAA;EAAA,gBAAA;A9FojWF;;A8F/iWA;EACE,eAAA;EACA,kBAAA;A9FkjWF;A8FhjWE;EACE,c7F1JO;E6F2JP,iB1F6Q0B;AJqyV9B;A8F/iWE;EACE,c7FjKO;E6FkKP,iB7F3FW;AD4oWf;;A8F3iWA;EACE,8BAAA;A9F8iWF;A8FliWA;EACE;IACE,6BAAA;E9F6iWF;E8F3iWA;IACE,2BAAA;E9F6iWF;AACF;A8FxiWA;EACE,WAAA;A9F0iWF;;A8FviWA;EACE,sBAAA;A9F0iWF;;A8FriWA;EACE,qB1FyH4B;AJ+6V9B;;A8FniWA;EACE,mBAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;A9FsiWF;A8FpiWE;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBAAA;A9FsiWJ;A8FniWE;EACE,gBAAA;EACA,cAAA;EACA,c7FlOO;E6FmOP,mBAAA;A9FqiWJ;A8FliWE;EACE,kBAAA;EACA,cAAA;A9FoiWJ;;A8FhiWA;EACE,sBAAA;A9FmiWF;;A8FhiWA;EACE,cAAA;A9FmiWF;;A8FhiWA;EACE,sCAAA;A9FmiWF;;A8FhiWA;EACE,gCAAA;A9FmiWF;;A8FhiWA;EACE,cAAA;A9FmiWF;;A8F/hWA;EACE,0BAAA;A9FkiWF;;A8F/hWA;EACE,WAAA;EACA,YAAA;A9FkiWF;;A+F7zWA;EACE,0FAAA;A/Fg0WF;;A+F7zWA;EACE,8EAAA;A/Fg0WF;;A+F7zWA;EACE,8EAAA;A/Fg0WF;;A+F7zWA;EACE,8EAAA;A/Fg0WF;;A+F7zWA;EACE,8EAAA;A/Fg0WF;;A+F7zWA;EACE,8EAAA;A/Fg0WF;;A+F7zWA;EACE,8EAAA;A/Fg0WF;;A+F7zWA;EACE,gFAAA;A/Fg0WF;;A+F7zWA;EACE,8EAAA;A/Fg0WF;;A+F7zWA;EACE,8EAAA;A/Fg0WF;;A+F7zWA;EACE,2GAAA;A/Fg0WF;;A+F7zWA;EACE,8EAAA;A/Fg0WF;;A+F7zWA;EACE,8EAAA;A/Fg0WF;;A+F7zWA;EACE,8EAAA;A/Fg0WF;;A+F7zWA;EACE,8EAAA;A/Fg0WF;;A+F7zWA;EACE,0GAAA;A/Fg0WF;;A+F7zWA;EACE,8EAAA;A/Fg0WF;;A+F7zWA;EACE,8EAAA;A/Fg0WF;;A+F7zWA;EACE,8EAAA;A/Fg0WF;;A+F7zWA;EACE,yEAAA;A/Fg0WF;;A+F7zWA;EACE,6EAAA;A/Fg0WF;;A+F7zWA;EACE,8EAAA;A/Fg0WF;;A+F7zWA;EACE,0FAAA;A/Fg0WF;;A+F7zWA;EACE,8KAAA;EACA,+BAAA;A/Fg0WF;;A+F7zWA;EACE,wEAAA;A/Fg0WF;;A+F7zWA;EACE,iFAAA;A/Fg0WF;;A+F7zWA;EACE,kCAAA;A/Fg0WF;;AgG36WA;;;;CAAA;AAMA;EACC,mCAAA;AhG66WD;;AgG16WA;ECII,4BAAA;EAAA,yBAAA;AjG66WJ;AgG76WC;EACE,mCENuB;AlGq7W1B;AgG56WC;ECJG,gCAAA;AjGo7WJ;AgG56WC;ECRG,mCAAA;AjGw7WJ;AgG36WC;ECbG,mCAAA;AjG47WJ;AiGv6WI;EEjCF;IAAI,UAAA;EnGq9WJ;EmGp9WA;IAAM,UAAA;EnGu9WN;AACF;AmGr9WC;EFQG,sBAAA;AjGi9WJ;AoGl9WC;EACC;IACC,UAAA;IACA,4BAAA;EpG+9WD;EoG59WA;IACC,UAAA;IACA,wBAAA;EpG89WD;AACF;AoG39WC;EHXG,0BAAA;AjG0+WJ;AqG3+WC;EACC;IACC,UAAA;IACA,2BAAA;ErGw/WD;EqGr/WA;IACC,UAAA;IACA,wBAAA;ErGu/WD;AACF;AqGp/WC;EJXG,wBAAA;AjGmgXJ;AiG9+WI;EKjCF;IAAI,UAAA;EtG4hXJ;EsG3hXA;IAAM,UAAA;EtG8hXN;AACF;AsG5hXC;ELQG,uBAAA;AjGwhXJ;AuG9hXC;EACC;IAAK,yCAAA;IAAmD,UAAA;EvGqjXxD;EuGpjXA;IAAM,wCAAA;IAAkD,UAAA;EvGwjXxD;EuGvjXA;IAAM,uCAAA;IAAqD,UAAA;EvG2jX3D;EuG1jXA;IAAO,qCAAA;IAAuC,UAAA;EvG8jX9C;AACF;AuG5jXC;ENDG,4BAAA;EAAA,mCAAA;AjGmkXJ;AwG3kXC;EACC;IAAK,qCAAA;IAAuC,UAAA;ExG0lX5C;EwGzlXA;IAAO,yCAAA;IAAmD,UAAA;ExG6lX1D;AACF;AwG3lXC;EPGG,6BAAA;EAAA,kCAAA;AjG8lXJ;;AyGnmXE;EACE,iEAAA;AzGsmXJ;;AyGjmXE;EACE,cAAA;EACA,iEAAA;AzGomXJ;;AyG/lXE;EACE,iEAAA;EACA,uBAAA;EACA,oBAAA;AzGkmXJ;;AyG9lXA;EACE;IACE,iBAAA;IACA,kBAAA;IACA,UAAA;EzGimXF;EyG/lXA;IACE,eAAA;IACA,mBAAA;IACA,UAAA;EzGimXF;AACF;AyG9lXA;EACE,oBAAA;AzGgmXF;;A0GroXA;EACE,iBAAA;A1GwoXF;;A0GpoXE;EACE,iBAAA;EACA,gBAAA;A1GuoXJ;A0GpoXE;EACE,iBAAA;A1GsoXJ;A0GnoXE;EpGFE,gBAAA;ANwoXJ;;A0GjoXA;EACE,iBAAA;EACA,gBAAA;A1GooXF;A0GhoXE;EpGiBE,4BAAA;EACA,+BAAA;EAfA,6BAAA;EACA,gCAAA;ANkoXJ;;A0G5nXA;EACE,oBAAA;A1G+nXF;;A0G1nXA;EACE,sBAAA;A1G6nXF;A0G1nXI;EACE,mBAAA;EACA,eAAA;A1G4nXN;A0GxnXE;EACE,oBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,sBAAA;EACA,sBAAA;EACA,qBAAA;A1G0nXJ;A0GvnXE;EACE,qBAAA;A1GynXJ;A0GrnXI;EACE,eAAA;A1GunXN;A0GlnXI;EACE,eAAA;A1GonXN;;A0G9mXE;EACE,cAAA;EACA,eAAA;A1GinXJ;;A0G3mXA;EACE,kBAAA;A1G8mXF;A0G5mXE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,0CAAA;EAGA,gBAAA;A1G8mXJ;A0G3mXE;EACE,WAAA;EACA,wCAAA;EACA,gCAAA;A1G6mXJ;A0GzmXI;EpGpEA,4BAAA;EACA,+BAAA;EAfA,6BAAA;EACA,gCAAA;ANgsXJ;;A0GtmXA;EACE,iBAAA;EACA,oBAAA;A1GymXF;A0GvmXE;EACE,cAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;A1GymXJ;A0GtmXE;EACE,qBAAA;A1GwmXJ;A0GpmXI;EACE,eAAA;A1GsmXN;A0GjmXI;EACE,eAAA;A1GmmXN;A0G5lXI;EACE,UAAA;A1G8lXN;A0GzlXI;EACE,oBAAA;A1G2lXN;A0GtlXI;EACE,+BAAA;A1GwlXN;A0GplXM;EACE,qBAAA;A1GslXR;A0G/kXQ;EACE,sBAAA;A1GilXV;;A0G1kXA;EACE,4BAAA;A1G6kXF;;A0GxkXA;EACE,czG9KS;EyG+KT,qBzGnLS;EyGoLT,sBAAA;A1G2kXF;A0GzkXE;EACE,yBAAA;EACA,6BAAA;A1G2kXJ;A0GzkXI;EACE,czG/JE;EyGgKF,mBzG7LK;ADwwXX;A0GvkXE;EAEE,czG9LO;EyG+LP,qBzGnMO;AD2wXX;A0GpkXI;EACE,gBAAA;A1GskXN;;A0G/jXI;EACE,gCAAA;EACA,gCAAA;EACA,2BAAA;EAAA,wBAAA;EACA,wBAAA;EACA,2BAAA;EACA,WzGvNE;ADyxXR;;A0G3jXA;EpG3NI,2BAAA;AN0xXJ;;A0GxjXE;E5EtHA,wBAAA;EzBsKI,iBALI;EC7QN,sBAAA;ANgyXJ;;A0GxjXE;E5E5HA,oBAAA;EzBsKI,iBALI;EC7QN,qBAAA;ANsyXJ;;A0GxjXE;E5ElIA,qBAAA;EzBsKI,iBALI;EC7QN,qBAAA;AN4yXJ;;A0GtjXE;EACE,kBAAA;EACA,QAAA;EACA,YAAA;A1GyjXJ;;A0GnjXI;EACE,MAAA;A1GsjXN;;A0GjjXA;EACE,+CAAA;A1GojXF;;A0G38WE;EA5BA,8GAAA;EACA,mEAuBQ;EAtBR,+DAsBQ;EArBR,mEAAA;A1G2+WF;A0Gz+WE;EAGE,uJAAA;EACA,mEAAA;EACA,+DAAA;A1Gy+WJ;A0Gt+WE;EAIE,8EAAA;EACA,0EAAA;A1Gq+WJ;A0Gx9WI;EACE,mGAAA;A1G09WN;A0Gx9WM;EACE,mGAAA;A1G09WR;;A0Gj+WE;EA5BA,6GAAA;EACA,kEAuBQ;EAtBR,8DAsBQ;EArBR,kEAAA;A1GigXF;A0G//WE;EAGE,uJAAA;EACA,kEAAA;EACA,8DAAA;A1G+/WJ;A0G5/WE;EAIE,6EAAA;EACA,yEAAA;A1G2/WJ;A0G9+WI;EACE,uGAAA;A1Gg/WN;A0G9+WM;EACE,uGAAA;A1Gg/WR;;A0Gv/WE;EA5BA,4GAAA;EACA,iEAuBQ;EAtBR,6DAsBQ;EArBR,kEAAA;A1GuhXF;A0GrhXE;EAGE,wJAAA;EACA,kEAAA;EACA,8DAAA;A1GqhXJ;A0GlhXE;EAIE,6EAAA;EACA,0EAAA;A1GihXJ;A0GpgXI;EACE,qGAAA;A1GsgXN;A0GpgXM;EACE,qGAAA;A1GsgXR;;A0G7gXE;EA5BA,yFAAA;EACA,8CAuBQ;EAtBR,0CAsBQ;EArBR,+CAAA;A1G6iXF;A0G3iXE;EAGE,gHAAA;EACA,+CAAA;EACA,2CAAA;A1G2iXJ;A0GxiXE;EAIE,0DAAA;EACA,oDAAA;A1GuiXJ;A0G1hXI;EACE,qGAAA;A1G4hXN;A0G1hXM;EACE,qGAAA;A1G4hXR;;A0GniXE;EA5BA,8GAAA;EACA,mEAuBQ;EAtBR,+DAsBQ;EArBR,mEAAA;A1GmkXF;A0GjkXE;EAGE,uJAAA;EACA,mEAAA;EACA,+DAAA;A1GikXJ;A0G9jXE;EAIE,8EAAA;EACA,0EAAA;A1G6jXJ;A0GhjXI;EACE,qGAAA;A1GkjXN;A0GhjXM;EACE,qGAAA;A1GkjXR;;A0GzjXE;EA5BA,6GAAA;EACA,kEAuBQ;EAtBR,8DAsBQ;EArBR,kEAAA;A1GylXF;A0GvlXE;EAGE,uJAAA;EACA,kEAAA;EACA,8DAAA;A1GulXJ;A0GplXE;EAIE,6EAAA;EACA,yEAAA;A1GmlXJ;A0GtkXI;EACE,mGAAA;A1GwkXN;A0GtkXM;EACE,mGAAA;A1GwkXR;;A0G/kXE;EA5BA,6GAAA;EACA,kEAuBQ;EAtBR,8DAsBQ;EArBR,gEAAA;A1G+mXF;A0G7mXE;EAGE,qJAAA;EACA,gEAAA;EACA,4DAAA;A1G6mXJ;A0G1mXE;EAIE,2EAAA;EACA,yEAAA;A1GymXJ;A0G5lXI;EACE,iGAAA;A1G8lXN;A0G5lXM;EACE,iGAAA;A1G8lXR;;A0GrmXE;EA5BA,4GAAA;EACA,iEAuBQ;EAtBR,6DAsBQ;EArBR,kEAAA;A1GqoXF;A0GnoXE;EAGE,uJAAA;EACA,kEAAA;EACA,8DAAA;A1GmoXJ;A0GhoXE;EAIE,6EAAA;EACA,yEAAA;A1G+nXJ;A0GlnXI;EACE,qGAAA;A1GonXN;A0GlnXM;EACE,qGAAA;A1GonXR;;A0G3nXE;EA5BA,wFAAA;EACA,6CAuBQ;EAtBR,yCAsBQ;EArBR,6CAAA;A1G2pXF;A0GzpXE;EAGE,wGAAA;EACA,6CAAA;EACA,yCAAA;A1GypXJ;A0GtpXE;EAIE,wDAAA;EACA,gCAAA;A1GqpXJ;A0GxoXI;EACE,uGAAA;A1G0oXN;A0GxoXM;EACE,uGAAA;A1G0oXR;;A0GjpXE;EA5BA,qGAAA;EACA,0DAuBQ;EAtBR,sDAsBQ;EArBR,uBAAA;A1GirXF;A0G/qXE;EAGE,oIAAA;EACA,uBAAA;EACA,mBAAA;A1G+qXJ;A0G5qXE;EAIE,kCAAA;EACA,yDAAA;A1G2qXJ;A0G9pXI;EACE,iGAAA;A1GgqXN;A0G9pXM;EACE,iGAAA;A1GgqXR;;A0GzpXE;EACE,0CAAA;A1G4pXJ;;A0GhpXE;E5EzYA,WAXQ;ERLR,yBrBiFa;E6B/Db,qB7B+Da;AD89Xf;A8B1hYE;EACE,WAdY;ERRd,wCQMmB;EAkBjB,oCAjBa;A9B6iYjB;A8BzhYE;EAEE,WArBY;ERRd,wCQMmB;EAyBjB,oCAxBa;EA6BX,qDAAA;A9BshYN;A8BlhYE;EAKE,WAlCa;EAmCb,wCArCkB;EAwClB,qBAvCc;A9BqjYlB;A8B5gYI;EAKI,qDAAA;A9B0gYR;A8BrgYE;EAEE,WAjDe;EAkDf,yB7BiBW;E6BdX,qB7BcW;ADs/Xf;A0G3qXI;EACE,mGAAA;A1G6qXN;A0G3qXM;EACE,mGAAA;A1G6qXR;;A0GprXE;E5EzYA,WAXQ;ERLR,yBrBiFa;E6B/Db,qB7B+Da;ADkgYf;A8B9jYE;EACE,WAdY;ERRd,0CQMmB;EAkBjB,kCAjBa;A9BilYjB;A8B7jYE;EAEE,WArBY;ERRd,0CQMmB;EAyBjB,kCAxBa;EA6BX,mDAAA;A9B0jYN;A8BtjYE;EAKE,WAlCa;EAmCb,sCArCkB;EAwClB,mCAvCc;A9BylYlB;A8BhjYI;EAKI,mDAAA;A9B8iYR;A8BziYE;EAEE,WAjDe;EAkDf,yB7BiBW;E6BdX,qB7BcW;AD0hYf;A0G/sXI;EACE,uGAAA;A1GitXN;A0G/sXM;EACE,uGAAA;A1GitXR;;A0GxtXE;E5EzYA,WAXQ;ERLR,yBrBiFa;E6B/Db,qB7B+Da;ADsiYf;A8BlmYE;EACE,WAdY;ERRd,2CQMmB;EAkBjB,mCAjBa;A9BqnYjB;A8BjmYE;EAEE,WArBY;ERRd,2CQMmB;EAyBjB,mCAxBa;EA6BX,kDAAA;A9B8lYN;A8B1lYE;EAKE,WAlCa;EAmCb,uCArCkB;EAwClB,mCAvCc;A9B6nYlB;A8BplYI;EAKI,kDAAA;A9BklYR;A8B7kYE;EAEE,WAjDe;EAkDf,yB7BiBW;E6BdX,qB7BcW;AD8jYf;A0GnvXI;EACE,qGAAA;A1GqvXN;A0GnvXM;EACE,qGAAA;A1GqvXR;;A0G5vXE;E5EzYA,WAXQ;ERLR,yBrBiFa;E6B/Db,qB7B+Da;AD0kYf;A8BtoYE;EACE,WAdY;ERRd,wCQMmB;EAkBjB,mCAjBa;A9BypYjB;A8BroYE;EAEE,WArBY;ERRd,wCQMmB;EAyBjB,mCAxBa;EA6BX,mDAAA;A9BkoYN;A8B9nYE;EAKE,WAlCa;EAmCb,uCArCkB;EAwClB,mCAvCc;A9BiqYlB;A8BxnYI;EAKI,mDAAA;A9BsnYR;A8BjnYE;EAEE,WAjDe;EAkDf,yB7BiBW;E6BdX,qB7BcW;ADkmYf;A0GvxXI;EACE,qGAAA;A1GyxXN;A0GvxXM;EACE,qGAAA;A1GyxXR;;A0GhyXE;E5EzYA,WAXQ;ERLR,yBrBiFa;E6B/Db,qB7B+Da;AD8mYf;A8B1qYE;EACE,WAdY;ERRd,0CQMmB;EAkBjB,mCAjBa;A9B6rYjB;A8BzqYE;EAEE,WArBY;ERRd,0CQMmB;EAyBjB,mCAxBa;EA6BX,mDAAA;A9BsqYN;A8BlqYE;EAKE,WAlCa;EAmCb,uCArCkB;EAwClB,mCAvCc;A9BqsYlB;A8B5pYI;EAKI,mDAAA;A9B0pYR;A8BrpYE;EAEE,WAjDe;EAkDf,yB7BiBW;E6BdX,qB7BcW;ADsoYf;A0G3zXI;EACE,qGAAA;A1G6zXN;A0G3zXM;EACE,qGAAA;A1G6zXR;;A0Gp0XE;E5EzYA,WAXQ;ERLR,yBrBiFa;E6B/Db,qB7B+Da;ADkpYf;A8B9sYE;EACE,WAdY;ERRd,wCQMmB;EAkBjB,kCAjBa;A9BiuYjB;A8B7sYE;EAEE,WArBY;ERRd,wCQMmB;EAyBjB,kCAxBa;EA6BX,kDAAA;A9B0sYN;A8BtsYE;EAKE,WAlCa;EAmCb,sCArCkB;EAwClB,oCAvCc;A9ByuYlB;A8BhsYI;EAKI,kDAAA;A9B8rYR;A8BzrYE;EAEE,WAjDe;EAkDf,yB7BiBW;E6BdX,qB7BcW;AD0qYf;A0G/1XI;EACE,mGAAA;A1Gi2XN;A0G/1XM;EACE,mGAAA;A1Gi2XR;;A0Gx2XE;E5EzYA,WAXQ;ERLR,yBrBiFa;E6B/Db,qB7B+Da;ADsrYf;A8BlvYE;EACE,WAdY;ERRd,6CQMmB;EAkBjB,sCAjBa;A9BqwYjB;A8BjvYE;EAEE,WArBY;ERRd,6CQMmB;EAyBjB,sCAxBa;EA6BX,kDAAA;A9B8uYN;A8B1uYE;EAKE,WAlCa;EAmCb,0CArCkB;EAwClB,sCAvCc;A9B6wYlB;A8BpuYI;EAKI,kDAAA;A9BkuYR;A8B7tYE;EAEE,WAjDe;EAkDf,yB7BiBW;E6BdX,qB7BcW;AD8sYf;A0Gn4XI;EACE,uGAAA;A1Gq4XN;A0Gn4XM;EACE,uGAAA;A1Gq4XR;;A0G54XE;E5EzYA,WAXQ;ERLR,yBrBiFa;E6B/Db,qB7B+Da;AD0tYf;A8BtxYE;EACE,WAdY;ERRd,uCQMmB;EAkBjB,mCAjBa;A9ByyYjB;A8BrxYE;EAEE,WArBY;ERRd,uCQMmB;EAyBjB,mCAxBa;EA6BX,kDAAA;A9BkxYN;A8B9wYE;EAKE,WAlCa;EAmCb,uCArCkB;EAwClB,+BAvCc;A9BizYlB;A8BxwYI;EAKI,kDAAA;A9BswYR;A8BjwYE;EAEE,WAjDe;EAkDf,yB7BiBW;E6BdX,qB7BcW;ADkvYf;A0Gv6XI;EACE,iGAAA;A1Gy6XN;A0Gv6XM;EACE,iGAAA;A1Gy6XR;;A0Gh7XE;E5EzYA,WAXQ;ERLR,yBrBiFa;E6B/Db,qB7B+Da;AD8vYf;A8B1zYE;EACE,WAdY;ERRd,uCQMmB;EAkBjB,mCAjBa;A9B60YjB;A8BzzYE;EAEE,WArBY;ERRd,uCQMmB;EAyBjB,mCAxBa;EA6BX,mDAAA;A9BszYN;A8BlzYE;EAKE,WAlCa;EAmCb,uCArCkB;EAwClB,qBAvCc;A9Bq1YlB;A8B5yYI;EAKI,mDAAA;A9B0yYR;A8BryYE;EAEE,WAjDe;EAkDf,yB7BiBW;E6BdX,qB7BcW;ADsxYf;A0G38XI;EACE,iGAAA;A1G68XN;A0G38XM;EACE,iGAAA;A1G68XR;;A0Gp9XE;E5EzYA,WAXQ;ERLR,yBrBiFa;E6B/Db,qB7B+Da;ADkyYf;A8B91YE;EACE,WAdY;ERRd,0CQMmB;EAkBjB,qCAjBa;A9Bi3YjB;A8B71YE;EAEE,WArBY;ERRd,0CQMmB;EAyBjB,qCAxBa;EA6BX,oDAAA;A9B01YN;A8Bt1YE;EAKE,WAlCa;EAmCb,yCArCkB;EAwClB,mCAvCc;A9By3YlB;A8Bh1YI;EAKI,oDAAA;A9B80YR;A8Bz0YE;EAEE,WAjDe;EAkDf,yB7BiBW;E6BdX,qB7BcW;AD0zYf;A0G/+XI;EACE,qGAAA;A1Gi/XN;A0G/+XM;EACE,qGAAA;A1Gi/XR;;A0Gz+XI;EACE,mGAAA;A1G4+XN;;A0G7+XI;EACE,uGAAA;A1Gg/XN;;A0Gj/XI;EACE,qGAAA;A1Go/XN;;A0Gr/XI;EACE,qGAAA;A1Gw/XN;;A0Gz/XI;EACE,qGAAA;A1G4/XN;;A0G7/XI;EACE,mGAAA;A1GggYN;;A0GjgYI;EACE,uGAAA;A1GogYN;;A0GrgYI;EACE,iGAAA;A1GwgYN;;A0GzgYI;EACE,iGAAA;A1G4gYN;;A0G7gYI;EACE,qGAAA;A1GghYN;;A0G1gYE;E5E/VA,c7BCa;E6BAb,qBAAA;A9B62YF;A8B32YE;EACE,WATY;EAUZ,yB7BJW;E6BKX,qB7BLW;ADk3Yf;A8B12YE;EAEE,0CAAA;A9B22YJ;A8Bx2YE;EAKE,WArBa;EAsBb,yB7BnBW;E6BoBX,qB7BpBW;AD03Yf;A8Bp2YI;EAKI,0CAAA;A9Bk2YR;A8B71YE;EAEE,c7BlCW;E6BmCX,6BAAA;A9B81YJ;A0GhiYI;EACE,mGAAA;A1GkiYN;A0GhiYM;EAIE,mGAAA;A1G+hYR;A0G5hYM;EACE,oDAAA;A1G8hYR;;A0G5iYE;E5E/VA,c7BCa;E6BAb,qBAAA;A9B+4YF;A8B74YE;EACE,WATY;EAUZ,yB7BJW;E6BKX,qB7BLW;ADo5Yf;A8B54YE;EAEE,4CAAA;A9B64YJ;A8B14YE;EAKE,WArBa;EAsBb,yB7BnBW;E6BoBX,qB7BpBW;AD45Yf;A8Bt4YI;EAKI,4CAAA;A9Bo4YR;A8B/3YE;EAEE,c7BlCW;E6BmCX,6BAAA;A9Bg4YJ;A0GlkYI;EACE,uGAAA;A1GokYN;A0GlkYM;EAIE,uGAAA;A1GikYR;A0G9jYM;EACE,sDAAA;A1GgkYR;;A0G9kYE;E5E/VA,c7BCa;E6BAb,qBAAA;A9Bi7YF;A8B/6YE;EACE,WATY;EAUZ,yB7BJW;E6BKX,qB7BLW;ADs7Yf;A8B96YE;EAEE,2CAAA;A9B+6YJ;A8B56YE;EAKE,WArBa;EAsBb,yB7BnBW;E6BoBX,qB7BpBW;AD87Yf;A8Bx6YI;EAKI,2CAAA;A9Bs6YR;A8Bj6YE;EAEE,c7BlCW;E6BmCX,6BAAA;A9Bk6YJ;A0GpmYI;EACE,qGAAA;A1GsmYN;A0GpmYM;EAIE,qGAAA;A1GmmYR;A0GhmYM;EACE,qDAAA;A1GkmYR;;A0GhnYE;E5E/VA,c7BCa;E6BAb,qBAAA;A9Bm9YF;A8Bj9YE;EACE,WATY;EAUZ,yB7BJW;E6BKX,qB7BLW;ADw9Yf;A8Bh9YE;EAEE,2CAAA;A9Bi9YJ;A8B98YE;EAKE,WArBa;EAsBb,yB7BnBW;E6BoBX,qB7BpBW;ADg+Yf;A8B18YI;EAKI,2CAAA;A9Bw8YR;A8Bn8YE;EAEE,c7BlCW;E6BmCX,6BAAA;A9Bo8YJ;A0GtoYI;EACE,qGAAA;A1GwoYN;A0GtoYM;EAIE,qGAAA;A1GqoYR;A0GloYM;EACE,qDAAA;A1GooYR;;A0GlpYE;E5E/VA,c7BCa;E6BAb,qBAAA;A9Bq/YF;A8Bn/YE;EACE,WATY;EAUZ,yB7BJW;E6BKX,qB7BLW;AD0/Yf;A8Bl/YE;EAEE,2CAAA;A9Bm/YJ;A8Bh/YE;EAKE,WArBa;EAsBb,yB7BnBW;E6BoBX,qB7BpBW;ADkgZf;A8B5+YI;EAKI,2CAAA;A9B0+YR;A8Br+YE;EAEE,c7BlCW;E6BmCX,6BAAA;A9Bs+YJ;A0GxqYI;EACE,qGAAA;A1G0qYN;A0GxqYM;EAIE,qGAAA;A1GuqYR;A0GpqYM;EACE,qDAAA;A1GsqYR;;A0GprYE;E5E/VA,c7BCa;E6BAb,qBAAA;A9BuhZF;A8BrhZE;EACE,WATY;EAUZ,yB7BJW;E6BKX,qB7BLW;AD4hZf;A8BphZE;EAEE,0CAAA;A9BqhZJ;A8BlhZE;EAKE,WArBa;EAsBb,yB7BnBW;E6BoBX,qB7BpBW;ADoiZf;A8B9gZI;EAKI,0CAAA;A9B4gZR;A8BvgZE;EAEE,c7BlCW;E6BmCX,6BAAA;A9BwgZJ;A0G1sYI;EACE,mGAAA;A1G4sYN;A0G1sYM;EAIE,mGAAA;A1GysYR;A0GtsYM;EACE,oDAAA;A1GwsYR;;A0GttYE;E5E/VA,c7BCa;E6BAb,qBAAA;A9ByjZF;A8BvjZE;EACE,WATY;EAUZ,yB7BJW;E6BKX,qB7BLW;AD8jZf;A8BtjZE;EAEE,4CAAA;A9BujZJ;A8BpjZE;EAKE,WArBa;EAsBb,yB7BnBW;E6BoBX,qB7BpBW;ADskZf;A8BhjZI;EAKI,4CAAA;A9B8iZR;A8BziZE;EAEE,c7BlCW;E6BmCX,6BAAA;A9B0iZJ;A0G5uYI;EACE,uGAAA;A1G8uYN;A0G5uYM;EAIE,uGAAA;A1G2uYR;A0GxuYM;EACE,sDAAA;A1G0uYR;;A0GxvYE;E5E/VA,c7BCa;E6BAb,qBAAA;A9B2lZF;A8BzlZE;EACE,WATY;EAUZ,yB7BJW;E6BKX,qB7BLW;ADgmZf;A8BxlZE;EAEE,yCAAA;A9BylZJ;A8BtlZE;EAKE,WArBa;EAsBb,yB7BnBW;E6BoBX,qB7BpBW;ADwmZf;A8BllZI;EAKI,yCAAA;A9BglZR;A8B3kZE;EAEE,c7BlCW;E6BmCX,6BAAA;A9B4kZJ;A0G9wYI;EACE,iGAAA;A1GgxYN;A0G9wYM;EAIE,iGAAA;A1G6wYR;A0G1wYM;EACE,mDAAA;A1G4wYR;;A0G1xYE;E5E/VA,c7BCa;E6BAb,qBAAA;A9B6nZF;A8B3nZE;EACE,WATY;EAUZ,yB7BJW;E6BKX,qB7BLW;ADkoZf;A8B1nZE;EAEE,yCAAA;A9B2nZJ;A8BxnZE;EAKE,WArBa;EAsBb,yB7BnBW;E6BoBX,qB7BpBW;AD0oZf;A8BpnZI;EAKI,yCAAA;A9BknZR;A8B7mZE;EAEE,c7BlCW;E6BmCX,6BAAA;A9B8mZJ;A0GhzYI;EACE,iGAAA;A1GkzYN;A0GhzYM;EAIE,iGAAA;A1G+yYR;A0G5yYM;EACE,mDAAA;A1G8yYR;;A0G5zYE;E5E/VA,c7BCa;E6BAb,qBAAA;A9B+pZF;A8B7pZE;EACE,WATY;EAUZ,yB7BJW;E6BKX,qB7BLW;ADoqZf;A8B5pZE;EAEE,2CAAA;A9B6pZJ;A8B1pZE;EAKE,WArBa;EAsBb,yB7BnBW;E6BoBX,qB7BpBW;AD4qZf;A8BtpZI;EAKI,2CAAA;A9BopZR;A8B/oZE;EAEE,c7BlCW;E6BmCX,6BAAA;A9BgpZJ;A0Gl1YI;EACE,qGAAA;A1Go1YN;A0Gl1YM;EAIE,qGAAA;A1Gi1YR;A0G90YM;EACE,qDAAA;A1Gg1YR;;A0G10YA;EACE,kBAAA;ErFxbI,qFqFybJ;A1G60YF;AqBlwZM;EqFmbN;IrFlbQ,gBAAA;ErBqwZN;AACF;;A0G/0YA;EACE,sCAAA;A1Gk1YF;;A0G/0YA;EACE,cAAA;A1Gk1YF;;A2G/xZA;EACE,kUAAA;EAIA,kB1GkFe;E0GhFf,gBvGw9BkC;AJs0XpC;A2G5xZE;EACE,mBAAA;A3G8xZJ;A2G3xZE;EACE,yBAAA;EACA,0BAAA;EACA,c1G0BI;E0GzBJ,iBAAA;A3G6xZJ;A2G1xZE;EACE,kB1GkEa;E0GjEb,aAAA;EACA,mBAAA;EACA,uDAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;A3G4xZJ;A2G1xZI;EACE,eAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;A3G4xZN;A2GxxZM;EACE,YAAA;A3G0xZR;A2GrxZE;EACE,kUAAA;A3GuxZJ;;A2GhxZA;ErGtCI,mBAAA;EqGwCF,gB1GmDmB;ADguZrB;A2GjxZE;ErG1CE,mBAAA;AN8zZJ;A2GhxZE;EACE,qBAAA;EACA,sBAAA;A3GkxZJ;A2G/wZE;EACE,qBAAA;EACA,sBAAA;ErG5CA,4BAAA;EACA,6BAAA;AN8zZJ;A2G/wZE;;ErGhDE,4BAAA;EACA,6BAAA;ANm0ZJ;;A2G5wZI;EACE,gBAAA;EACA,c1GxCE;ADuzZR;;A2GxwZI;EACE,mB1GhDE;E0GiDF,W1G/EE;AD01ZR;;A2GrwZE;EACE,gBAAA;A3GwwZJ;A2GrwZE;EACE,gBAAA;A3GuwZJ;;A2GhwZE;;;ErGrFE,+BAAA;EACA,gCAAA;AN21ZJ;;A2GhwZA;EACE,W1GzGM;E0G0GN,oBAAA;EACA,sB1GbmB;E0GcnB,kBAAA;EACA,UAAA;A3GmwZF;A2GjwZE;EACE,mBAAA;EACA,sBAAA;EACA,kBAAA;A3GmwZJ;A2GhwZE;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;A3GkwZJ;A2G/vZE;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;A3GiwZJ;A2G/vZI;EACE,oBAAA;A3GiwZN;A2G9vZI;EACE,oBAAA;EACA,qBAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;A3GgwZN;A2G9vZM;EACE,kBAAA;A3GgwZR;A2G5vZI;EACE,gBAAA;EACA,kBAAA;A3G8vZN;A2G1vZE;EACE,oBAAA;A3G4vZJ;;A2GxvZA;EACE,gBAAA;EACA,iBvG2Q4B;EuG1Q5B,SAAA;A3G2vZF;;A2GxvZA;EACE,0MvG4O4B;EuG5O5B,oCvG4O4B;EuG3O5B,eAAA;EACA,YAAA;A3G2vZF;;A2GvvZE;EACE,uBAAA;EACA,YAAA;A3G0vZJ;A2GxvZI;EACE,gB1GtFe;ADg1ZrB;A2GtvZE;EACE,+BAAA;A3GwvZJ;A2GtvZI;EACE,UAAA;A3GwvZN;;A2GhvZE;EACE,kBAAA;EACA,QAAA;EACA,YAAA;EACA,gBAAA;A3GmvZJ;;A2G9uZE;EACE,cAAA;A3GivZJ;;A2G3uZI;EACE,MAAA;A3G8uZN;;A2GzuZA;EACE,+CAAA;A3G4uZF;;A2GruZE;EAEE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,SAAA;EACA,wBAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;EACA,UAAA;A3GuuZJ;A2GpuZE;EACE,gB1GjPI;E0GkPJ,UAAA;A3GsuZJ;A2GnuZE;EACE,SAAA;EACA,+BvGguBgC;EuG/tBhC,UAAA;A3GquZJ;A2GjuZI;EAEE,SAAA;EACA,YAAA;A3GkuZN;A2G/tZI;EACE,YAAA;A3GiuZN;A2G5tZI;EAEE,UAAA;EACA,WAAA;EACA,QAAA;A3G6tZN;A2G1tZI;EACE,QAAA;EACA,WAAA;A3G4tZN;A2GvtZI;EAEE,WAAA;EACA,UAAA;EACA,QAAA;A3GwtZN;A2GrtZI;EACE,QAAA;EACA,UAAA;A3GutZN;A2GltZI;EAEE,UAAA;EACA,UAAA;A3GmtZN;A2GhtZI;EACE,UAAA;A3GktZN;A2G7sZI;EAEE,aAAA;A3G8sZN;;A2GvsZA;EACE,YAAA;EACA,avGlFO;AJ4xZT;A2GxsZE;EACE,oBAAA;EACA,kB1GpPa;E0GqPb,cAAA;EACA,mBAAA;A3G0sZJ;A2GvsZE;EACE,gBAAA;A3GysZJ;;A2GrsZA;EACE,YAAA;A3GwsZF;;A2GnsZA;EACE,SAAA;EACA,2BAAA;EACA,6BAAA;EACA,uBAAA;ErGhVE,gBAAA;EqGkVF,qBAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,mCAAA;A3GssZF;A2GpsZE;EAEE,aAAA;A3GqsZJ;;A4G9iaE;EACE,mBAAA;A5GijaJ;;A4G7iaA;EACE,aAAA;EACA,mBAAA;EACA,uDAAA;EACA,eAAA;A5GgjaF;A4G9iaE;EACE,c3G6BI;E2G5BJ,eAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;A5GgjaJ;A4G7iaE;EACE,c3GHO;ADkjaX;A4G7iaI;EACE,YAAA;EACA,c3GgBE;AD+haR;A4GziaI;EACE,YAAA;A5G2iaN;;A4GriaE;EACE,yBAAA;EACA,0BAAA;EACA,c3GxBO;E2GyBP,iBAAA;EACA,oBAAA;A5GwiaJ;A4GriaE;EACE,oBAAA;A5GuiaJ;A4GpiaE;EACE,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,mB3GxCO;AD8kaX;;A4GjiaE;EACE,gBAAA;A5GoiaJ;;A4G7haI;EAEE,W3G1DE;ADylaR;A4G7haM;EACE,W3G7DA;E2G8DA,YAAA;A5G+haR;A4G3haI;EACE,yBAAA;A5G6haN;;A4GphaE;EACE,6BAAA;EACA,gCAAA;A5GuhaJ;A4GrhaI;EACE,UAAA;A5GuhaN;A4GjhaI;EACE,sBAAA;A5GmhaN;A4GhhaI;EACE,uBAAA;A5GkhaN;A4G/gaI;EACE,qBAAA;A5GihaN;A4G7gaE;EACE,sBAAA;A5G+gaJ;A4GxgaM;EACE,sBAAA;A5G0gaR;A4GvgaM;EACE,uBAAA;A5GygaR;A4GtgaM;EACE,qBAAA;A5GwgaR;A4GngaE;EACE,cAAA;EACA,SAAA;EACA,eAAA;A5GqgaJ;;A6G1oaA;EACE,iBAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;A7G6oaF;;A6G1oaA;EACE,gBAAA;A7G6oaF;;A6G1oaA;EACE,mBAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,6BAAA;EvGLE,mBAAA;EuGOF,cAAA;A7G6oaF;;A6G1oaA;EACE,WAAA;EACA,YAAA;A7G6oaF;;A6G1oaA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;A7G6oaF;A6G3oaE;EACE,WAAA;EACA,WAAA;EACA,YAAA;EvGvBA,sBAAA;EuGyBA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,qBAAA;EACA,gB5GhCI;AD6qaR;;A6GzoaA;EACE,UAAA;EACA,WAAA;A7G4oaF;;A6GxoaE;EACE,gBAAA;A7G2oaJ;A6GxoaE;EACE,kBAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;A7G0oaJ;A6GxoaI;EACE,WAAA;EACA,YAAA;A7G0oaN;A6GvoaI;EACE,UAAA;EACA,WAAA;EACA,iBAAA;A7GyoaN;A6GroaE;EACE,SAAA;EACA,WAAA;A7GuoaJ;;A6GloaE;EACE,QAAA;EACA,UAAA;A7GqoaJ;A6GloaE;EACE,QAAA;EACA,UAAA;A7GooaJ;A6GjoaE;EACE,SAAA;EACA,WAAA;A7GmoaJ;A6GhoaE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;A7GkoaJ;;A6G9naA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;A7GioaF;;A6G5naA;EACE,qBAAA;EACA,oBAAA;EACA,kBAAA;A7G+naF;A6G7naE;EACE,kBAAA;EACA,WAAA;EACA,SAAA;A7G+naJ;A6G7naI;EACE,cAAA;A7G+naN;A6G5naI;EACE,SAAA;EACA,WAAA;EACA,YAAA;A7G8naN;A6G1naE;EACE,WAAA;EACA,YAAA;EACA,sBAAA;A7G4naJ;A6G1naI;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,MAAA;EACA,QAAA;A7G4naN;A6G1naM;EACE,SAAA;EACA,QAAA;EACA,SAAA;A7G4naR;;A6GpnaE;EACE,mB5GxDqB;E4GyDrB,sEAAA;EACA,c5GxHI;E4GyHJ,kBAAA;EACA,YAAA;A7GunaJ;A6GrnaI;EACE,kBAAA;EACA,sBAAA;EACA,kBzGiRwB;EyGhRxB,cAAA;EACA,YAAA;A7GunaN;A6GnnaE;EACE,eAAA;A7GqnaJ;A6GnnaI;EACE,UAAA;A7GqnaN;;A6G7maI;EACE,YAAA;A7GgnaN;;A6G3maA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,UAAA;EvGvLE,mBAAA;ANsyaJ;A6G5maE;EvG1LE,iCAAA;ANyyaJ;;A6GzmaE;EACE,WAAA;EACA,YAAA;A7G4maJ;A6GxmaI;EACE,kBzGkOwB;AJw4Z9B;;A6GpmaE;EACE,WAAA;EACA,YAAA;A7GumaJ;A6GnmaI;EACE,kBzGsNwB;AJ+4Z9B;;A6G/laE;EACE,WAAA;EACA,YAAA;A7GkmaJ;A6G9laI;EACE,iB5GxJS;ADwvaf;;A6G1laE;EACE,WAAA;EACA,YAAA;EACA,0BAAA;A7G6laJ;A6GzlaI;EACE,iBAAA;EACA,kB5GxKW;ADmwajB;A6GtlaI;EACE,mBAAA;A7GwlaN;;A6GnlaA;EACE,sBAAA;EACA,gBAAA;A7GslaF;A6GplaE;EACE,WAAA;EACA,YAAA;A7GslaJ;;A6GjlaE;EACE,UAAA;EACA,kBAAA;A7GolaJ;A6GllaI;EACE,UAAA;A7GolaN;A6GjlaI;EACE,kBAAA;A7GmlaN;A6GjlaI;EACE,kBAAA;A7GmlaN;A6GjlaI;EACE,kBAAA;A7GmlaN;A6GjlaI;EACE,kBAAA;A7GmlaN;A6GhlaI;EAEE,yBAAA;A7GilaN;A6GljaA;EACE,oCAAA;EACA,2CAAA;EACA,kBAAA;A7G2kaF;A6GzkaE;EAEE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EAEA,WAAA;EACA,YAAA;EACA,kBAAA;EAEA,gEAAA;EACA,2CAAA;A7GwkaJ;A6GrkaE;EACE,8BAAA;EACA,gCAAA;A7GukaJ;;A8Gz6aA;EACE,kU7G2GmB;E6G1GnB,eAAA;EACA,oBAAA;A9G46aF;A8G16aE;EACE,SAAA;A9G46aJ;A8G16aI;ExGgBA,+BAAA;EACA,gCAAA;AN65aJ;A8Gv6aI;;;EAEE,oCAAA;EACA,+BAAA;A9G06aN;A8Gr6aI;;EAEE,yBAAA;A9Gu6aN;A8Gn6aE;EACE,aAAA;EACA,mBAAA;A9Gq6aJ;;A8Gj6aA;EACE,iBAAA;EACA,mBAAA;A9Go6aF;;A8Gj6aA;EACE,kBAAA;A9Go6aF;;A8Gh6aE;EACE,eAAA;EACA,gBAAA;EAQA,c7GpCO;ADg8aX;A8Gl6aI;EACE,iBAAA;EACA,WAAA;EACA,kBAAA;A9Go6aN;A8G/5aI;EACE,c7GhBE;ADi7aR;;A8G55aA;;EAEE,yBAAA;EACA,6DAAA;EACA,iBAAA;EACA,kB7GmBe;AD44ajB;;A8G55aA;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,cAAA;EACA,iBAAA;EACA,qBAAA;EACA,cAAA;A9G+5aF;A8G75aE;EACE,SAAA;EACA,UAAA;EACA,YAAA;A9G+5aJ;A8G55aE;EACE,cAAA;A9G85aJ;A8G15aI;EACE,WAAA;EACA,iBAAA;A9G45aN;A8Gz5aI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;A9G25aN;A8Gv5aE;EACE,kBAAA;EACA,oBAAA;A9Gy5aJ;A8Gt5aE;EACE,oBAAA;EACA,YAAA;EACA,WAAA;A9Gw5aJ;A8Gt5aI;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;A9Gw5aN;A8Gr5aI;EACE,oBAAA;EACA,WAAA;EACA,cAAA;EACA,c7GzGK;ADggbX;A8Gr5aM;EACE,WAAA;ExGhHJ,mBAAA;EwGkHI,mB7GvFA;E6GwFA,oBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,OAAA;EACA,YAAA;EACA,UAAA;A9Gu5aR;A8Gp5aM;EACE,c7GlGA;ADw/aR;A8Gn5aM;EACE,c7GtGA;AD2/aR;A8Gn5aQ;EACE,UAAA;A9Gq5aV;A8G74aM;EACE,mBAAA;EACA,UAAA;EACA,UAAA;EACA,QAAA;A9G+4aR;A8G14aQ;EACE,mBAAA;A9G44aV;;A8Gr4aA;EACE,6BAAA;EACA,iBAAA;A9Gw4aF;;A8Gp4aE;EACE,kUAAA;A9Gu4aJ;;A8G/3aE;EACE,kUAAA;A9Gk4aJ;;A8G33aA;EACE,mB1GiDO;E0GhDP,mB7G5Ga;E6G6Gb,8DAAA;A9G83aF;;A8G13aE;EACE,sMAAA;A9G63aJ;;A8G93aE;EACE,8MAAA;A9Gi4aJ;;A8Gl4aE;EACE,0MAAA;A9Gq4aJ;;A8Gt4aE;EACE,0MAAA;A9Gy4aJ;;A8G14aE;EACE,0MAAA;A9G64aJ;;A8G94aE;EACE,sMAAA;A9Gi5aJ;;A8Gl5aE;EACE,8MAAA;A9Gq5aJ;;A8Gt5aE;EACE,kMAAA;A9Gy5aJ;;A8G15aE;EACE,kMAAA;A9G65aJ;;A8G95aE;EACE,0MAAA;A9Gi6aJ;;A8Gx5aA;EACE,kBAAA;EACA,YAAA;A9G25aF;;A8Gt5aI;EACE,kU7GhHe;ADygbrB;;A+GrnbA;;EAEE,mB3GmPO;AJq4aT;;A+GrnbA;EACE,iBAAA;A/GwnbF;A+GtnbE;EACE,eAAA;A/GwnbJ;;A+GjnbI;EACE,yBAAA;A/GonbN;A+GjnbI;EACE,c9GqBE;AD8lbR;;A+G3mbI;EACE,yBAAA;A/G8mbN;A+G3mbI;EACE,mB9GQE;ADqmbR;A+G3mbM;EACE,sBAAA;A/G6mbR;;A+GrmbA;EACE,kBAAA;A/GwmbF;;A+GrmbA;EACE,aAAA;EACA,eAAA;EACA,kBAAA;A/GwmbF;;A+GrmbA;EACE,sBAAA;A/GwmbF;;A+GrmbA;EACE,eAAA;EACA,UAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;A/GwmbF;A+GtmbE;EACE,c9GzBI;ADiobR;A+GrmbE;EACE,UAAA;A/GumbJ;;A+GnmbA;EACE,c9GlCM;ADwobR;;A+GnmbA;EACE,YAAA;EACA,mBAAA;A/GsmbF;;A+GnmbA;EACE,UAAA;A/GsmbF;;A+GnmbA;EACE,kBAAA;A/GsmbF;;A+GnmbA;EACE,kBAAA;A/GsmbF;;A+GnmbA;EACE,kBAAA;EACA,eAAA;EACA,YAAA;EACA,UAAA;A/GsmbF;;A+GhmbE;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;EAEA,cAAA;EACA,aAAA;EzGjGA,mBAAA;EyGmGA,yBAAA;EACA,UAAA;A/GkmbJ;A+GhmbI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;EACA,YAAA;EACA,iBAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,c9GrFE;ADurbR;A+GhmbM;EACE,c9G7GG;AD+sbX;A+G/lbM;EACE,W9G1HA;AD2tbR;A+G/lbQ;EACE,W9G7HF;AD8tbR;A+G5lbI;EACE,uBAAA;EACA,qBAAA;EAEA,sBAAA;EACA,kBAAA;EACA,eAAA;A/G6lbN;A+G3lbM;EACE,kBAAA;EACA,WAAA;EACA,gB9G7IA;E8G8IA,WAAA;EACA,YAAA;EACA,OAAA;EACA,UAAA;EzG9IJ,mBAAA;AN4ubJ;A+G1lbM;EACE,uBAAA;EACA,gBAAA;EzGpJJ,mBAAA;EyGsJI,6BAAA;A/G4lbR;A+GzlbM;EACE,iBAAA;A/G2lbR;;A+GnlbA;EACE,gB3GmEO;AJmhbT;;A+G9kbA;EzG3KI,sBAAA;EyG6KF,mB9GlJM;E8GmJN,eAAA;EACA,UAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,a3G8I4B;E2G7I5B,QAAA;EACA,iBAAA;EACA,iBAAA;A/GilbF;A+G/kbE;EACE,aAAA;A/GilbJ;;A+G5kbA;EACE,kBAAA;EACA,UAAA;EACA,W9GzMM;E8G0MN,WAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;A/G+kbF;;A+G5kbA;EACE,iIAAA;A/G+kbF;;A+G1kbA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,aAAA;EACA,gB9GhImB;E8GiInB,kBAAA;EACA,oBAAA;EACA,kB9GnJe;E8GoJf,c9GxNS;E8GyNT,gBAAA;EACA,gBAAA;EACA,sB9GlOM;E8GmON,4BAAA;EACA,qCAAA;EzGjOE,sBAAA;EyGmOF,kU9GtImB;ADmtbrB;A+G3kbE;EACE,cAAA;EACA,WAAA;EACA,oBAAA;EACA,WAAA;EACA,gB3GoL0B;E2GnL1B,c9GrOO;E8GsOP,mBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;EACA,SAAA;A/G6kbJ;A+G3kbI;EAEE,uCAAA;EACA,qBAAA;EACA,mB9G7JmB;ADyubzB;;A+GvkbA;EACE,cAAA;A/G0kbF;A+GxkbE;EACE,c9GpOI;AD8ybR;;A+GpkbA;EACE,WAAA;A/GukbF;;A+GpkbA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,yB9GnPM;EK3BJ,mBAAA;EyGgRF,yDAAA;EACA,UAAA;A/GukbF;;A+GnkbE;EACE,kBAAA;A/GskbJ;A+GpkbI;EACE,eAAA;EACA,mBAAA;A/GskbN;A+GpkbM;EACE,oBAAA;EACA,gBAAA;A/GskbR;A+GjkbE;EACE,qCAAA;EACA,oBAAA;A/GmkbJ;A+GhkbE;EACE,a3GnEK;E2GoEL,SAAA;A/GkkbJ;A+G7jbI;EACE,+BAAA;A/G+jbN;A+G7jbM;EACE,W9GtTA;ADq3bR;A+G3jbI;EACE,W9G3TE;ADw3bR;A+G1jbI;EACE,+DAAA;A/G4jbN;;A+GtjbE;EACE,uBAAA;EACA,kBAAA;EACA,UAAA;A/GyjbJ;A+GvjbI;EACE,gBAAA;EACA,YAAA;EACA,6BAAA;A/GyjbN;A+GrjbE;EACE,kBAAA;EACA,WvC7V8B;EuC8V9B,UAAA;A/GujbJ;A+GpjbE;EACE,sBAAA;A/GsjbJ;A+GnjbE;EACE,W9G5VI;ADi5bR;A+GljbE;EACE,YAAA;EACA,aAAA;EzG9VA,sBAAA;EyGgWA,iIAAA;A/GojbJ;;A+G7ibE;EACE,aAAA;A/GgjbJ;A+G7ibE;EACE,QAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;A/G+ibJ;A+G5ibE;EACE,YAAA;A/G8ibJ;;A+G1ibA;EACE,gCAAA;A/G6ibF;A+G3ibE;EACE,qBAAA;EACA,mBAAA;EACA,kB9GrTa;ADk2bjB;A+GzibI;EACE,+BAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;A/G2ibN;A+GxibI;EACE,WAAA;EACA,gBAAA;A/G0ibN;;A+GnibE;;EACE,SAAA;EACA,UAAA;EACA,kBAAA;A/GuibJ;A+GribI;;;EAEE,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,2FAAA;EACA,oHAAA;A/GwibN;A+GribI;;EACE,SAAA;EACA,SAAA;EAEA,yFAAA;EACA,oHAAA;A/GuibN;;A+G/hbE;EACE,UAAA;EACA,YAAA;A/GkibJ;A+GhibI;EACE,kB3GdwB;E2GexB,gBAAA;A/GkibN;A+G/hbI;EACE,gBAAA;EACA,YAAA;EACA,oBAAA;A/GiibN;A+G9hbI;EACE,SAAA;A/GgibN;A+G9hbM;EACE,iBAAA;EACA,+BAAA;EACA,mB9GzcG;ADy+bX;A+G9hbQ;EACE,gB9G7cF;AD6+bR;A+G/hbU;EACE,W9GrcJ;E8GscI,YAAA;A/GiibZ;A+G7hbQ;EACE,gB9GrdF;E8GsdE,gBAAA;A/G+hbV;A+G5hbQ;EACE,gB9G1dF;ADw/bR;A+G5hbU;EACE,W9GndJ;E8GodI,YAAA;A/G8hbZ;A+GxhbQ;EACE,eAAA;A/G0hbV;;AgH7gcA;E1GiBI,sBAAA;E0GfF,yBAAA;AhHghcF;AgH9gcE;EACE,+BAAA;AhHghcJ;AgH9gcI;EACE,aAAA;EACA,YAAA;AhHghcN;AgH9gcM;;;EAGE,qBAAA;AhHghcR;AgH5gcQ;EACE,SAAA;AhH8gcV;AgHzgcI;EACE,oCAAA;AhH2gcN;AgHzgcM;EACE,4B/GZG;ADuhcX;;AiHvicA;;EAEE,mBhHaS;AD6hcX;;AiHvicA;E3GmCI,mCAAA;EACA,kCAAA;ANwgcJ;;AiHxicA;EACE,4LhH6GsB;EKtGpB,sBAAA;ANqicJ;;AkHthcA;;EAAA;AC9BA;EACE;IACE,mBAAA;IACA,UAAA;EnH0jcF;EmHxjcA;IACE,qBAAA;IACA,YAAA;EnH0jcF;EmHxjcA;IACE,mBAAA;IACA,UAAA;EnH0jcF;AACF;AmHpjcI;EACE,0EAAA;AnHsjcN;AmHvjcI;EACE,0EAAA;AnHyjcN;AmH1jcI;EACE,0EAAA;AnH4jcN;AmH7jcI;EACE,sEAAA;AnH+jcN;AmHvjcE;EC9BA,yBnH6CM;EmHnCN,WFVU;EEWV,YFXU;EEYV,mBAAA;EACA,WFZO;EEGP,yBAAA;ED8BE,qBAAA;AnH4jcJ;;AqHzlcA;EACE;IACE,2BAAA;ErH4lcF;EqH1lcA;IACE,4BAAA;ErH4lcF;EqH1lcA;IACE,wBAAA;ErH4lcF;AACF;AqHvlcI;EACE,2DAAA;ArHylcN;AqH1lcI;EACE,2DAAA;ArH4lcN;AqH7lcI;EACE,2DAAA;ArH+lcN;AqHhmcI;EACE,uDAAA;ArHkmcN;AqH1lcE;ED5BA,yBnH6CM;EmHnCN,WFVU;EEWV,YFXU;EEYV,mBAAA;EACA,WFZO;EEGP,yBAAA;EC4BE,qBAAA;ArH+lcJ;;AsH7ncA;EACE;IACE,mBAAA;EtHgocF;EsH9ncA;IACE,mBAAA;IACA,UAAA;EtHgocF;AACF;AsH3ncE;EFdA,yBnH6CM;EmHnCN,WFVU;EEWV,YFXU;EEYV,mBAAA;EACA,WFZO;EEGP,yBAAA;EEcE,qBAAA;EACA,YAAA;EACA,WAAA;EACA,gDAAA;AtHgocJ;;AuHnpcA;EACE;IACE,uBAAA;EvHspcF;EuHppcA;IACE,yBAAA;EvHspcF;EuHppcA;IACE,yBAAA;EvHspcF;AACF;AuHnpcA;EACE,kBAAA;AvHqpcF;AuHnpcE;EHjBA,yBnH6CM;EmHnCN,WFVU;EEWV,YFXU;EEYV,mBAAA;EACA,WFZO;EEGP,yBAAA;EGiBE,kBAAA;AvHwpcJ;AuHtpcI;EACE,qEAAA;AvHwpcN;AuHrpcI;EH3BF,yBnH6CM;EmHnCN,WFVU;EEWV,YFXU;EEYV,mBAAA;EACA,WFZO;EK6BH,WAAA;EACA,kBAAA;EACA,YAAA;AvH0pcN;AuHvpcI;EACE,QAAA;EACA,WAAA;AvHypcN;AuHtpcI;EACE,QAAA;EACA,UAAA;AvHwpcN;;AwHhscA;EACE;IACE,gCAAA;ExHmscF;EwHjscA;IACE,oCAAA;ExHmscF;EwHjscA;IACC,kCAAA;ExHmscD;AACF;AwH9rcE;EJhBA,yBnH6CM;EmHnCN,WFVU;EEWV,YFXU;EEYV,mBAAA;EACA,WFZO;EEGP,yBAAA;EIgBE,yBAAA;EACA,gCAAA;EACA,YAAA;EACA,WAAA;EACA,kCAAA;EACA,qBAAA;EACA,0CAAA;AxHmscJ;;AyH3tcA;EACE;IACE,gCAAA;EzH8tcF;EyH5tcA;IACE,oCAAA;EzH8tcF;EyH5tcA;IACC,kCAAA;EzH8tcD;AACF;AyH3tcA;EACE;IACE,qBAAA;EzH6tcF;EyH3tcA;IACE,mBAAA;EzH6tcF;AACF;AyH1tcA;EACE,kBAAA;EACA,4BAAA;AzH4tcF;AyH1tcE;ELvBA,yBAAA;EK0BE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;AzH2tcJ;AyHztcI;EACE,mBxHSE;EwHRF,YAAA;EACA,WAAA;EACA,QAAA;EACA,UAAA;EACA,mEAAA;AzH2tcN;AyHxtcI;EACE,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,uBAAA;EACA,iBAAA;EACA,qDAAA;EACA,oEAAA;EACA,sBAAA;AzH0tcN;;A0H/wcA;EACE;IACE,gCAAA;E1HkxcF;E0HhxcA;IACE,oCAAA;E1HkxcF;E0HhxcA;IACC,kCAAA;E1HkxcD;AACF;A0H/wcA;EACE,kBAAA;A1HixcF;A0H/wcE;ENbA,yBAAA;EMgBE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EACA,gCAAA;EACA,6BAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,4CAAA;A1HgxcJ;A0H9wcI;EACE,qBAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;EACA,qDAAA;EACA,4BAAA;A1HgxcN;;A2HrzcA;EACE;IACE,qBAAA;IACA,UAAA;E3HwzcF;E2HtzcA;IACE,mBAAA;IACA,YAAA;E3HwzcF;E2HtzcA;IACE,UAAA;E3HwzcF;AACF;A2HnzcE;EPdA,yBAAA;EOiBE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,+EAAA;A3HozcJ;;A4Hx0cA;EACE;IACE,qBAAA;IACA,UAAA;E5H20cF;E4Hz0cA;IACE,mBAAA;IACA,YAAA;E5H20cF;E4Hz0cA;IACE,UAAA;E5H20cF;AACF;A4Hh0cA;EAGE,kBAAA;EACA,4BAAA;A5Hg0cF;A4H10cI;EACE,sBAAA;A5H40cN;A4H70cI;EACE,sBAAA;A5H+0cN;A4Hh1cI;EACE,sBAAA;A5Hk1cN;A4Hn1cI;EACE,sBAAA;A5Hq1cN;A4H10cE;ER7BA,yBAAA;EQgCE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WApCG;EAqCH,YArCG;EAsCH,mBAAA;EACA,yBAAA;EACA,2FAAA;A5H20cJ;;A6Hp3cA;EACE;IACE,YAAA;IACA,sBAAA;E7Hu3cF;E6Hr3cA;IACE,UAAA;IACA,mBAAA;E7Hu3cF;AACF;A6Hl3cE;ETfA,yBnH6CM;EmHnCN,WFVU;EEWV,YFXU;EEYV,mBAAA;EACA,WFZO;EEGP,yBAAA;ESeE,qBAAA;EACA,4CAAA;A7Hu3cJ;A6Hr3cI;EACE,kCAAA;A7Hu3cN;;A8Hz4cA;EACE;IACE,mBAAA;IACA,UAAA;E9H44cF;E8H14cA;IACE,UAAA;E9H44cF;E8H14cA;IACE,mBAAA;IACA,UAAA;E9H44cF;AACF;A8Hj4cA;EAGE,kBAAA;EACA,4BAAA;A9Hi4cF;A8H34cI;EACE,sBAAA;A9H64cN;A8H94cI;EACE,sBAAA;A9Hg5cN;A8Hr4cE;EVjCA,yBnH6CM;EmHnCN,WFVU;EEWV,YFXU;EEYV,mBAAA;EACA,WFZO;EEGP,yBAAA;EUiCE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;EACA,WAvCG;EAwCH,YAxCG;EAyCH,oDAAA;A9H04cJ;;A+Hl7cA;EACE;IACE,iCAAA;E/Hq7cF;E+Hn7cA;IACE,+BAAA;E/Hq7cF;E+Hn7cA;IACE,8BAAA;E/Hq7cF;AACF;A+Hl7cA;EACE;IACE,gCAAA;E/Ho7cF;E+Hl7cA;IACE,iCAAA;E/Ho7cF;E+Hl7cA;IACE,8BAAA;E/Ho7cF;AACF;A+Hj7cA;EACE;IACE,gCAAA;E/Hm7cF;E+Hj7cA;IACE,kCAAA;E/Hm7cF;E+Hj7cA;IACE,8BAAA;E/Hm7cF;AACF;A+Hl6cA;EACE,kBAAA;EAEA,wDAAA;A/Hm6cF;A+Hh7cI;EACE,oCAAA;EACA,kBAAA;EACA,sBAAA;EACA,sCAAA;EACA,mCAAA;A/Hk7cN;A+Hv7cI;EACE,oCAAA;EACA,kBAAA;EACA,sBAAA;EACA,sCAAA;EACA,mCAAA;A/Hy7cN;A+H97cI;EACE,oCAAA;EACA,kBAAA;EACA,sBAAA;EACA,sCAAA;EACA,mCAAA;A/Hg8cN;A+Ht7cE;EXvDA,yBAAA;EW0DE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;A/Hu7cJ;A+Hr7cI;EACE,SAnEG;A/H0/cT;A+Hp7cI;EACE,UAAA;A/Hs7cN;A+Hn7cI;EACE,SA3EG;EA4EH,UA5EG;A/HigdT;;AgI//cA;EACE;IACE,qBAAA;EhIkgdF;EgIhgdA;IACE,4BAAA;EhIkgdF;EgIhgdA;IACE,qBAAA;EhIkgdF;EgIhgdA;IACE,2BAAA;EhIkgdF;EgIhgdA;IACE,wBAAA;IACA,mBAAA;EhIkgdF;AACF;AgI//cA;EACE;IACE,qBAAA;EhIigdF;EgI//cA;IACE,2BAAA;EhIigdF;EgI//cA;IACE,qBAAA;EhIigdF;EgI//cA;IACE,4BAAA;EhIigdF;EgI//cA;IACE,wBAAA;IACA,sBAAA;EhIigdF;AACF;AgI5/cE;EZ5CA,yBnH6CM;EmHnCN,WFVU;EEWV,YFXU;EEYV,mBAAA;EACA,WFZO;EEGP,yBAAA;EY4CE,qBAAA;EACA,sBAAA;EACA,6DAAA;EACA,mCAAA;EACA,kBAAA;AhIigdJ;AgI//cI;EACE,oCAAA;AhIigdN;AgI9/cI;EACE,mCAAA;AhIggdN;;AiIzjdA;EACE;IACE,YAAA;EjI4jdF;EiI1jdA;IACE,UAAA;EjI4jdF;AACF;AiI/idA;EAEE,WAAA;AjIgjdF;AiI1jdI;EACE,sBAAA;EACA,yBAAA;AjI4jdN;AiI9jdI;EACE,sBAAA;EACA,yBAAA;AjIgkdN;AiIlkdI;EACE,sBAAA;EACA,wBAAA;AjIokdN;AiItkdI;EACE,sBAAA;EACA,wBAAA;AjIwkdN;AiI1kdI;EACE,sBAAA;EACA,yBAAA;AjI4kdN;AiI9kdI;EACE,sBAAA;EACA,yBAAA;AjIgldN;AiIlldI;EACE,sBAAA;EACA,wBAAA;AjIoldN;AiItldI;EACE,qBAAA;EACA,yBAAA;AjIwldN;AiI1ldI;EACE,sBAAA;EACA,yBAAA;AjI4ldN;AiIlldE;EbzBA,yBnH6CM;EmHnCN,WFVU;EEWV,YFXU;EEYV,mBAAA;EACA,WFZO;EEGP,yBAAA;EayBE,qBAAA;EACA,WAAA;EACA,8BAAA;EACA,mCAAA;EACA,kBAAA;AjIuldJ;;AkItndA;EACE;IACE,mBAAA;ElIyndF;EkIvndA;IACE,qBAAA;IACA,YAAA;ElIyndF;EkIvndA;IACE,mBAAA;IACA,UAAA;ElIyndF;AACF;AkI5mdA;EAEE,WAAA;AlI6mdF;AkIvndI;EACE,sBAAA;EACA,yBAAA;AlIyndN;AkI3ndI;EACE,sBAAA;EACA,yBAAA;AlI6ndN;AkI/ndI;EACE,sBAAA;EACA,yBAAA;AlIiodN;AkInodI;EACE,qBAAA;EACA,yBAAA;AlIqodN;AkIvodI;EACE,sBAAA;EACA,sBAAA;AlIyodN;AkI3odI;EACE,sBAAA;EACA,yBAAA;AlI6odN;AkI/odI;EACE,sBAAA;EACA,yBAAA;AlIipdN;AkInpdI;EACE,sBAAA;EACA,yBAAA;AlIqpdN;AkIvpdI;EACE,sBAAA;EACA,yBAAA;AlIypdN;AkI/odE;Ed9BA,yBnH6CM;EmHnCN,WFVU;EEWV,YFXU;EEYV,mBAAA;EACA,WFZO;EEGP,yBAAA;Ec8BE,qBAAA;EACA,WAAA;EACA,+BAAA;EACA,mCAAA;EACA,kBAAA;AlIopdJ;;AmIrrdA;EACE;IACE,YAAA;IACA,qBAAA;EnIwrdF;EmItrdA;IACE,UAAA;IACA,mBAAA;EnIwrdF;AACF;AmIhpdA;EAGE,kBAAA;EACA,UAAA;EACA,WAAA;AnIgpdF;AmIxrdI;EAKI,SApBC;EAqBD,OAAA;EAwBF,0DAAA;AnI+pdN;AmI7rdI;EAQI,oBANQ;EAOR,qBAPQ;EA4BV,0DAAA;AnIoqdN;AmIlsdI;EAWI,MAAA;EACA,UA3BC;EA6CH,0DAAA;AnIyqdN;AmIvsdI;EAcI,qBAAA;EACA,qBAbQ;EA4BV,yDAAA;AnI8qdN;AmI5sdI;EAiBI,UAAA;EACA,OAAA;EAYF,0DAAA;AnImrdN;AmIjtdI;EAoBI,qBAAA;EACA,sBAAA;EASF,0DAAA;AnIwrdN;AmIttdI;EAuBI,MAAA;EACA,WAAA;EAMF,0DAAA;AnI6rdN;AmI3tdI;EA0BI,oBAxBQ;EAyBR,sBAAA;EAGF,0DAAA;AnIksdN;AmItrdE;Ef5DA,yBnH6CM;EmHnCN,WFVU;EEWV,YFXU;EEYV,mBAAA;EACA,WFZO;EEGP,yBAAA;Ee4DE,kBAAA;AnI2rdJ;;AoIvvdA;EACE;IACE,YAAA;EpI0vdF;EoIxvdA;IACE,UAAA;EpI0vdF;AACF;AoIltdA;EAEE,kBAAA;ApImtdF;AoIxvdI;EAKI,SAlBC;EAmBD,OAAA;EAwBF,mDAAA;ApI+tdN;AoI7vdI;EAQI,oBANQ;EAOR,qBAPQ;EA4BV,mDAAA;ApIoudN;AoIlwdI;EAWI,MAAA;EACA,UAzBC;EA2CH,mDAAA;ApIyudN;AoIvwdI;EAcI,qBAAA;EACA,qBAbQ;EA4BV,mDAAA;ApI8udN;AoI5wdI;EAiBI,UAAA;EACA,OAAA;EAYF,mDAAA;ApImvdN;AoIjxdI;EAoBI,qBAAA;EACA,sBAAA;EASF,mDAAA;ApIwvdN;AoItxdI;EAuBI,MAAA;EACA,WAAA;EAMF,mDAAA;ApI6vdN;AoI3xdI;EA0BI,oBAxBQ;EAyBR,sBAAA;EAGF,mDAAA;ApIkwdN;AoIzvdE;EhBlDA,yBAAA;EgBqDE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;ApI0vdJ;;AqInzdA;EACE;IACE,kCAAA;ErIszdF;EqIpzdA;IACE,iCAAA;ErIszdF;EqIpzdA;IACE,0BAAA;ErIszdF;AACF;AqInzdA;EACE;IACE,gCAAA;ErIqzdF;EqInzdA;IACE,iCAAA;ErIqzdF;EqInzdA;IACE,0BAAA;ErIqzdF;AACF;AqIlzdA;EACE,kBAAA;EACA,kCAAA;ArIozdF;AqIlzdE;EjBhCA,yBnH6CM;EmHnCN,WFVU;EEWV,YFXU;EEYV,mBAAA;EACA,WFZO;EEGP,yBAAA;EiBgCE,kBAAA;EACA,iBAAA;EACA,QAAA;EACA,UAAA;ArIuzdJ;AqIrzdI;EACE,2CAAA;ArIuzdN;AqIpzdI;EACE,2CAAA;ArIszdN;;AsIh2dA;EACE;IACE,kCAAA;EtIm2dF;EsIj2dA;IACE,iCAAA;EtIm2dF;EsIj2dA;IACE,0BAAA;EtIm2dF;EsIj2dA;IACE,iCAAA;EtIm2dF;EsIj2dA;IACE,kCAAA;EtIm2dF;EsIj2dA;IACE,0BAAA;EtIm2dF;AACF;AsIh2dA;EACE;IACE,gCAAA;EtIk2dF;EsIh2dA;IACE,iCAAA;EtIk2dF;EsIh2dA;IACE,0BAAA;EtIk2dF;EsIh2dA;IACE,iCAAA;EtIk2dF;EsIh2dA;IACE,gCAAA;EtIk2dF;EsIh2dA;IACE,0BAAA;EtIk2dF;AACF;AsI/1dA;EACE,kBAAA;EACA,kCAAA;AtIi2dF;AsI/1dE;ElBlDA,yBnH6CM;EmHnCN,WFVU;EEWV,YFXU;EEYV,mBAAA;EACA,WFZO;EEGP,yBAAA;EkBkDE,kBAAA;EACA,iBAAA;EACA,QAAA;EACA,UAAA;AtIo2dJ;AsIl2dI;EACE,mDAAA;AtIo2dN;AsIj2dI;EACE,mDAAA;AtIm2dN;;AkH32dA;;EAAA;AqBrDA;EACE;IACE,oBAAA;EvIs6dF;EuIp6dA;IACE,sBAAA;EvIs6dF;EuIp6dA;IACE,oBAAA;EvIs6dF;AACF;AuIj6dI;EACE,2EAAA;AvIm6dN;AuIp6dI;EACE,2EAAA;AvIs6dN;AuIv6dI;EACE,2EAAA;AvIy6dN;AuI16dI;EACE,2EAAA;AvI46dN;AuI76dI;EACE,wEAAA;AvI+6dN;AuIv6dE;EnB1BA,yBnH6CM;EmH1BN,UFhBW;EEiBX,YFlBY;EEmBZ,kBAAA;EACA,WFrBO;EEGP,yBAAA;EmB0BE,qBAAA;AvI46dJ;;AwIx8dA;EACE;IACE,mBAAA;ExI28dF;EwIz8dA;IAEE,qBAAA;ExI08dF;EwIx8dA;IACE,mBAAA;ExI08dF;AACF;AwIr8dI;EACE,sBAAA;EACA,yBAAA;AxIu8dN;AwIz8dI;EACE,sBAAA;EACA,yBAAA;AxI28dN;AwI78dI;EACE,qBAAA;EACA,yBAAA;AxI+8dN;AwIj9dI;EACE,sBAAA;EACA,yBAAA;AxIm9dN;AwI38dE;EpB3BA,yBnH6CM;EmH1BN,UFhBW;EEiBX,YFlBY;EEmBZ,kBAAA;EACA,WFrBO;EEGP,yBAAA;EoB2BE,qBAAA;EACA,gCAAA;EACA,mCAAA;EACA,kBAAA;AxIg9dJ;;AyI/+dA;EACE;IACE,oBAAA;EzIk/dF;EyIh/dA;IACE,sBAAA;EzIk/dF;EyIh/dA;IACE,oBAAA;EzIk/dF;AACF;AyI7+dE;ErBjBA,yBnH6CM;EmH1BN,UFhBW;EEiBX,YFlBY;EEmBZ,kBAAA;EACA,WFrBO;EEGP,yBAAA;EqBiBE,qBAAA;EACA,wFAAA;AzIk/dJ;AyIh/dI;EACE,iCAAA;AzIk/dN;AyI/+dI;EACE,iCAAA;AzIi/dN;;A0I5geA;EACE;IACE,oBAAA;E1I+geF;E0I7geA;IACE,sBAAA;E1I+geF;E0I7geA;IACE,oBAAA;E1I+geF;AACF;A0I1geE;EtBhBA,yBnH6CM;EmH1BN,UFhBW;EEiBX,YFlBY;EEmBZ,kBAAA;EACA,WFrBO;EEGP,yBAAA;EsBgBE,qBAAA;EACA,sBAAA;EACA,8FAAA;A1I+geJ;A0I7geI;EACE,kCAAA;A1I+geN;A0I5geI;EACE,8BAAA;A1I8geN;;A2ItieA;EACE;IACE,YAAA;E3IyieF;E2IvieA;IACE,UAAA;E3IyieF;AACF;A2I3/dA;EAEE,kBAAA;EACA,UAAA;EACA,UAAA;A3I4/dF;A2IzieI;EAKI,SAlBC;EAmBD,OAAA;EA8BF,iEAAA;A3I0geN;A2I9ieI;EAQI,oBANQ;EAOR,qBAPQ;EAQR,yBAAA;EA0BF,iEAAA;A3IgheN;A2IpjeI;EAYI,MAAA;EACA,UA1BC;EA2BD,wBAAA;EAsBF,gEAAA;A3IsheN;A2I1jeI;EAgBI,qBAAA;EACA,qBAfQ;EAgBR,wBAAA;EAkBF,iEAAA;A3I4heN;A2IhkeI;EAoBI,UAAA;EACA,OAAA;EAeF,iEAAA;A3IiieN;A2IrkeI;EAuBI,qBAAA;EACA,sBAAA;EACA,yBAAA;EAWF,iEAAA;A3IuieN;A2I3keI;EA2BI,MAAA;EACA,WAAA;EACA,wBAAA;EAOF,iEAAA;A3I6ieN;A2IjleI;EA+BI,oBA7BQ;EA8BR,sBAAA;EACA,wBAAA;EAGF,6DAAA;A3ImjeN;A2IxieE;EvB/DA,yBnH6CM;EmH1BN,UFhBW;EEiBX,YFlBY;EEmBZ,kBAAA;EACA,WFrBO;EEGP,yBAAA;EuB+DE,kBAAA;EACA,UAAA;EACA,YAAA;A3I6ieJ;;AkHjjeA;;EAAA;A0B7DA;EACE;IACE,wDAAA;E5IoneF;E4IlneA;IACE,6DAAA;E5IoneF;E4IlneA;IACE,wDAAA;E5IoneF;E4IlneA;IACE,mDAAA;E5IoneF;AACF;A4I/meE;ExBjBA,yBAAA;EwBoBE,QAAA;EACA,SAAA;EACA,mCAAA;EACA,oCAAA;EACA,iCAAA;EACA,gFAAA;A5IgneJ;;A6I3oeA;EACE;IACE,wDAAA;E7I8oeF;E6I5oeA;IACE,6DAAA;E7I8oeF;E6I5oeA;IACE,wDAAA;E7I8oeF;E6I5oeA;IACE,mDAAA;E7I8oeF;AACF;A6IzoeE;EzBfA,yBAAA;EyBkBE,WAAA;EACA,YAAA;EACA,mB5IqBI;E4IpBJ,yEAAA;A7I0oeJ;;A8I9peA;EACI;IACK,yBAAA;E9IiqeP;E8I/peE;IACK,yBAAA;E9IiqeP;E8I/peE;IACK,yBAAA;E9IiqeP;AACF;A8I9peA;EACI;IACK,wBAAA;E9IgqeP;E8I9peE;IACK,uBAAA;E9IgqeP;E8I9peE;IACK,wBAAA;E9IgqeP;AACF;A8InpeA;EACE;IACE,YAAA;E9IqpeF;E8InpeA;IACE,qCAAA;E9IqpeF;AACF;A8I1oeA;EAGE,kBAAA;A9I0oeF;A8InpeI;EACE,iDAAA;A9IqpeN;A8ItpeI;EACE,iDAAA;A9IwpeN;A8IzpeI;EACE,iDAAA;A9I2peN;A8I5peI;EACE,6CAAA;A9I8peN;A8IppeE;EA/BE,UAAA;EACA,WAAA;EACA,oCAAA;EACA,8BAAA;EACA,+BAAA;EACA,iCAAA;EACA,mBAjCG;EA4DH,iDAAA;EACA,kBAAA;EACA,WAAA;A9I4peJ;A8IzpeE;EAtCE,UAAA;EACA,WAAA;EACA,oCAAA;EACA,8BAAA;EACA,+BAAA;EACA,iCAAA;EACA,mBAjCG;EAmEH,mDAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;A9IiqeJ;A8I9peE;;;;E1B5EA,yBnH6CM;EmHnCN,WFVU;EEWV,YFXU;EEYV,mBAAA;EACA,WFZO;E4BiFL,WAAA;EACA,YAAA;EAEA,kBAAA;EACA,gCAAA;EACA,SAAA;EACA,UAAA;A9IkqeJ;;A+IrveA;EACE;IACE,qDAAA;E/IwveF;E+ItveA;IACE,gDAAA;E/IwveF;E+ItveA;IACE,sDAAA;E/IwveF;E+ItveA;IACE,0BAAA;E/IwveF;AACF;A+IrveA;EACE,kBAAA;EACA,kCAAA;A/IuveF;A+IrveE;E3BpBA,yBAAA;E2BuBE,WAxBG;EAyBH,YAzBG;EA0BH,kBAAA;EACA,SAAA;EACA,UAAA;EACA,yB9IaI;E8IZJ,uDAAA;A/IsveJ;A+IpveI;EACE,sBAAA;A/IsveN;;AgJrxeA;EACE;IACE,uBAAA;EhJwxeF;EgJtxeA;IACE,yBAAA;EhJwxeF;EgJtxeA;IACE,yBAAA;EhJwxeF;AACF;AgJrxeA;EACE,kBAAA;EACA,WAjBK;EAkBL,YAlBK;EAmBL,gBAAA;AhJuxeF;AgJrxeE;EACE,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,8CAAA;EACA,6FAAA;EACA,WAAA;EACA,YAAA;AhJuxeJ;;AiJjzeI;E3I8BA,gCAAA;EACA,mCAAA;ANuxeJ;AiJjzeE;EACE,cAAA;AjJmzeJ;AiJhzeE;EACE,cAAA;AjJkzeJ;AiJ/yeE;E3ICE,mBAAA;ANizeJ;;AiJ3yeE;;EAEE,kBAAA;AjJ8yeJ;AiJ5yeI;;EACE,WAAA;EACA,UAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,gBhJrBE;EgJsBF,2CAAA;AjJ+yeN;;AiJ1yeA;EACE;IACE,YAAA;IACA,QAAA;EjJ6yeF;EiJ3yeA;IACE,UAAA;IACA,WAAA;EjJ6yeF;AACF;AkJ91eA;EACE,WAAA;EACA,kBAAA;EACA,sBAAA;AlJg2eF;AkJ91eE;EACE,WAAA;EACA,cAAA;EACA,WAAA;AlJg2eJ;AkJ71eE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,mBjJFO;EKCP,sBAAA;ANi2eJ;;AkJ31eA;EACE,kBAAA;EACA,gBAAA;AlJ81eF;AkJ51eE;EACE,WAAA;EACA,cAAA;EACA,WAAA;AlJ81eJ;AkJ31eE;EACE,gBAAA;AlJ61eJ;;AkJz1eA;EACE,kBAAA;EACA,iBAAA;EACA,iBjJmDa;ADyyef;AkJ11eE;EACE,WAAA;EACA,cAAA;EACA,WAAA;AlJ41eJ;AkJz1eE;EACE,iBjJ0CW;EiJzCX,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AlJ21eJ;AkJx1eE;EACE,cjJtCO;EiJuCP,kBAAA;AlJ01eJ;AkJv1eE;EACE,cAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,mBAAA;EACA,iBAAA;EACA,cjJlDO;EiJmDP,0BAAA;EACA,mBAAA;AlJy1eJ;;AkJr1eA;EACE,kBAAA;EACA,MAAA;EACA,UAAA;AlJw1eF;AkJt1eE;EACE,0BAAA;AlJw1eJ;;AkJp1eA;EACE,eAAA;EACA,gBAAA;AlJu1eF;AkJr1eE;EACE,aAAA;AlJu1eJ;;AkJl1eE;EACE,UAAA;AlJq1eJ;AkJl1eE;EACE,iBAAA;AlJo1eJ;AkJj1eE;EACE,SAAA;AlJm1eJ;;AkJ/0eA;EACE,iBAAA;AlJk1eF;AkJh1eE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,mBjJtGO;EKCP,sBAAA;ANw7eJ;AkJ/0eE;EACE,mB9I4HK;AJqteT;AkJ90eE;EACE,iBAAA;AlJg1eJ;AkJ70eE;EACE,WAAA;EACA,YAAA;EACA,OAAA;EACA,SAAA;AlJ+0eJ;AkJ70eI;EACE,WAAA;EACA,YAAA;EACA,gBjJ7HE;EKGJ,mBAAA;E4I4HE,iBAAA;EACA,mBAAA;EACA,0BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;AlJ+0eN;AkJ70eM;EACE,cAAA;EACA,iBAAA;EACA,cAAA;AlJ+0eR;AkJ50eM;EACE,cAAA;AlJ80eR;;AkJt0eA;EACE,iBAAA;AlJy0eF;AkJv0eE;EACE,kBAAA;AlJy0eJ;AkJt0eE;EACE,mBAAA;EACA,0BAAA;EACA,UAAA;AlJw0eJ;AkJr0eE;EACE,YAAA;EACA,WAAA;EACA,mBjJpKO;EiJqKP,kBAAA;EACA,SAAA;EACA,QAAA;EACA,cAAA;E5IvKA,mBAAA;AN++eJ;AkJr0eI;EACE,WAAA;EACA,kBAAA;EACA,gBjJhLE;EiJiLF,SAAA;EACA,QAAA;EACA,qBAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;E5InLF,mBAAA;AN2/eJ;AkJn0eE;EACE,oBAAA;AlJq0eJ;;AkJ/zeI;EACE,mBjJ9HS;ADg8ef;;AkJn0eI;EACE,mBjJ9HS;ADo8ef;;AkJv0eI;EACE,mBjJ9HS;ADw8ef;;AkJ30eI;EACE,mBjJ9HS;AD48ef;;AkJ/0eI;EACE,mBjJ9HS;ADg9ef;;AkJn1eI;EACE,mBjJ9HS;ADo9ef;;AkJv1eI;EACE,mBjJ9HS;ADw9ef;;AkJ31eI;EACE,mBjJ9HS;AD49ef;;AkJ/1eI;EACE,mBjJ9HS;ADg+ef;;AkJn2eI;EACE,mBjJ9HS;ADo+ef;;AkJ11eA;EACE,kBAAA;AlJ61eF;;AkJ11eA;EACE,mBAAA;EACA,2BAAA;AlJ61eF;AkJxzeA;EACE;IACE,UAAA;IAKA,qBAAA;ElJq1eF;EkJl1eA;IACE,UAAA;IAKA,qBAAA;ElJo1eF;EkJj1eA;IAKE,mBAAA;ElJm1eF;AACF;AkJ/0eA;EACE,kBAAA;AlJi1eF;;AkJ90eA;EACE,mBAAA;EAGA,2BAAA;AlJi1eF;;AkJ90eA;EACE;IAGE,mCAAA;ElJi1eF;AACF;AkJ70eA;EACE;IACE,mBAAA;IAGA,mCAAA;ElJ+0eF;AACF;AkJzyeA;EACE;IACE,UAAA;IAKA,6BAAA;ElJq0eF;EkJl0eA;IACE,UAAA;IAKA,2BAAA;ElJo0eF;EkJj0eA;IAKE,wBAAA;ElJm0eF;AACF;AkJ7xeA;EACE;IACE,UAAA;IAKA,4BAAA;ElJyzeF;EkJtzeA;IACE,UAAA;IAKA,4BAAA;ElJwzeF;EkJrzeA;IAKE,wBAAA;ElJuzeF;AACF;AmJjvfE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;E7IWA,qBAAA;E6ITA,YAAA;EACA,QAAA;EACA,YAAA;EACA,wBAAA;AnJmvfJ;AmJ9ufM;EACE,YAAA;AnJgvfR;AmJ3ufE;;EAEE,mBAAA;AnJ6ufJ;;AmJzufA;EACE,aAAA;AnJ4ufF;;AmJxufE;EACE,SAAA;EACA,0BAAA;AnJ2ufJ;;AmJtufE;EACE,SAAA;EACA,qBAAA;AnJyufJ;;AoJ/wfM;E9I2CF,yBAAA;EACA,4BAAA;EAfA,2CAAA;EACA,8CAAA;ANwvfJ;AoJ/wfE;EACE,kBAAA;EACA,cAAA;EACA,SAAA;ApJixfJ;AoJ9wfM;E9IgBF,0BAAA;EACA,6BAAA;ANiwfJ;;AoJxwfI;EACE,kBAAA;EACA,cAAA;EACA,SAAA;ApJ2wfN;AoJvwfE;EACE,kBAAA;EACA,cAAA;EACA,SAAA;ApJywfJ;AoJvwfI;E9IQA,yBAAA;EACA,4BAAA;ANkwfJ;;AoJnwfA;EACE,kBnJyCe;EmJxCf,iBAAA;ApJswfF;;AoJjwfA;EACE,iBnJmCa;EmJlCb,SAAA;EACA,cnJbM;ADixfR;AoJlwfE;EACE,cnJxCO;EmJyCP,mBAAA;EACA,kBnJ2Ba;ADyufjB;;AoJjwfA;EACE,mBAAA;EACE,kBAAA;EACA,cAAA;ApJowfJ;;AoJjwfA;EACE,wBAAA;EACA,qBAAA;ApJowfF;;AqJr0fI;EACE,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,iBAAA;EAEA,cpJ8BE;EoJ7BF,sBpJDE;EoJEF,yBAAA;ArJu0fN;AqJr0fM;EACE,UAAA;EACA,6BjJ4QkC;EiJ3QlC,qBAAA;EACA,yBpJNG;EoJOH,qBpJNG;AD60fX;AqJp0fM;EACE,UAAA;EACA,UjJqgC4B;EiJpgC5B,gBpJqEsB;ADiwf9B;AqJl0fM;EACE,eAAA;ArJo0fR;AqJ/zfM;EACE,cAAA;E/IOJ,+BAAA;EACA,kCAAA;AN2zfJ;AqJ9zfM;E/IZF,gCAAA;EACA,mCAAA;AN60fJ;AqJ7zfI;EACE,UAAA;EACA,WpJtCE;EoJuCF,yBpJTE;EoJUF,qBpJVE;ADy0fR;AqJ7zfM;EACE,WpJ3CA;AD02fR;AqJ3zfI;EACE,cpJ1CK;EoJ2CL,oBAAA;EAEA,YAAA;EACA,sBpJpDE;EoJqDF,qBpJlDK;AD82fX;;AqJpzfE;E/I1DE,8BAAA;E+I4DA,gBAAA;ArJuzfJ;;AsJl4fA;EACE,aAAA;EACA,WAAA;EACA,gBAAA;AtJq4fF;AsJn4fE;EACE,cAAA;AtJq4fJ;AsJl4fE;EACE,6BAAA;EACA,kBAAA;EACA,UAAA;EACA,mBrJ2FqB;EqJ1FrB,SAAA;EACA,uBAAA;EhJAA,mBAAA;EgJEA,+BlJgW0B;EkJ/V1B,SAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AtJo4fJ;AsJl4fI;EACE,gBAAA;EACA,mBAAA;EACA,mB9EzB4B;E8E0B5B,cAAA;AtJo4fN;AsJh4fE;EACE,iBAAA;AtJk4fJ;AsJh4fI;EhJpBA,mBAAA;EgJsBE,4BAAA;EACA,gClJ2UwB;EkJ1UxB,iBAAA;AtJk4fN;AsJh4fM;EACE,iBAAA;EACA,oB9EzC0B;E8E0C1B,cAAA;AtJk4fR;;AuJ96fA;EACE,SAAA;EACA,UAAA;EACA,qBAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;EjJSE,sBAAA;ANy6fJ;AuJ/6fE;EACE,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,ctJCO;EsJAP,kBAAA;AvJi7fJ;AuJ/6fI;EAEE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,iBAAA;EACA,UAAA;EACA,WAAA;EACA,mBtJZK;EsJaL,UAAA;EACA,oBAAA;AvJg7fN;AuJ76fI;EACE,SAAA;AvJ+6fN;AuJ56fI;EACE,OAAA;AvJ86fN;AuJ16fM;EjJIF,4BAAA;EACA,+BAAA;ANy6fJ;AuJx6fM;EjJhBF,6BAAA;EACA,gCAAA;AN27fJ;AuJv6fI;EACE,kBAAA;EACA,kBnJoYwB;EmJnYxB,mBtJvCK;EsJwCL,WtJ5CE;EsJ6CF,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EjJ9CF,mBAAA;EiJgDE,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;AvJy6fN;AuJt6fI;EACE,ctJpDK;AD49fX;AuJv6fM;EACE,mBtJ/BA;ADw8fR;AuJt6fM;EACE,mBtJnCA;AD28fR;AuJn6fM;EACE,+BAAA;EAEA,mBtJnCA;EsJoCA,gBAAA;AvJo6fR;AuJn6fQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AvJq6fV;AuJj6fM;EAEE,mBtJjDA;ADm9fR;AuJ95fI;EACE,ctJtFK;ADs/fX;;AuJt5fI;EACE,kBtJ5BW;ADq7fjB;AuJv5fM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,mBAAA;AvJy5fR;;AuJj5fE;EACE,cAAA;EACA,UAAA;EACA,WAAA;EACA,0BAAA;AvJo5fJ;AuJl5fI;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,qBAAA;EjJhIF,qBAAA;EiJkIE,oBAAA;AvJo5fN;AuJl5fM;EAEE,aAAA;AvJm5fR;AuJh5fM;EACE,qBAAA;AvJk5fR;AuJ/4fM;EACE,mBtJ/IG;ADgigBX;AuJ94fM;EACE,mBtJvHA;EsJwHA,WtJtJA;ADsigBR;AuJ94fQ;EACE,oCAAA;AvJg5fV;AuJ14fE;EACE,UAAA;EACA,cAAA;AvJ44fJ;;AuJz4fA;EAEI;IACE,cAAA;IACA,UAAA;IACA,WAAA;IACA,0BAAA;EvJ24fJ;EuJz4fI;IACE,gBAAA;IACA,aAAA;IACA,mBAAA;IACA,yBAAA;IACA,gBAAA;IACA,qBAAA;IjJ/KJ,qBAAA;IiJiLI,oBAAA;EvJ24fN;EuJz4fM;IAEE,aAAA;EvJ04fR;EuJv4fM;IACE,qBAAA;EvJy4fR;EuJt4fM;IACE,mBtJ9LC;EDskgBT;EuJr4fM;IACE,mBtJtKF;IsJuKE,WtJrMF;ED4kgBN;EuJr4fQ;IACE,oCAAA;EvJu4fV;EuJj4fE;IACE,UAAA;IACA,cAAA;EvJm4fJ;AACF;AwJ5lgBA;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;AxJ8lgBF;;AwJ3lgBA;EACE,kBAAA;EACA,apJyOO;EoJxOP,kBAAA;AxJ8lgBF;AwJ5lgBE;EACE,YAAA;EACA,gBAAA;AxJ8lgBJ;AwJ3lgBE;EACE,eAAA;EACA,kBpJ+NK;AJ83fT;AwJ3lgBI;EACE,iBvJiES;AD4hgBf;AwJzlgBE;EACE,kBAAA;EACA,UAAA;AxJ2lgBJ;AwJxlgBE;EACE,yBAAA;AxJ0lgBJ;AwJxlgBI;EACE,gBAAA;AxJ0lgBN;AwJtlgBE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;ElJVA,mCAAA;EACA,kCAAA;EkJWA,gBAAA;AxJylgBJ;AwJtlgBE;EACE,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;EACA,iBAAA;AxJwlgBJ;AwJtlgBI;EAGE,mBAAA;AxJslgBN;AwJllgBE;EACE,mBAAA;EACA,cAAA;EACA,YAAA;AxJolgBJ;AwJllgBI;EACE,aAAA;AxJolgBN;AwJjlgBI;EACE,kBAAA;AxJmlgBN;AwJ/kgBE;EACE,gBAAA;AxJilgBJ;AwJ9kgBE;EACE,oBAAA;AxJglgBJ;AwJ9kgBI;EACE,WAAA;EACA,sBAAA;EACA,iUAAA;EAIA,eAAA;EACA,gBvJpFE;ADiqgBR;AwJzkgBE;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;AxJ2kgBJ;AwJzkgBI;EACE,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,YAAA;AxJ2kgBN;AwJvkgBE;EACE,gBpJkIK;AJu8fT;AwJvkgBI;EACE,kBAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;AxJykgBN;AwJvkgBM;EACE,mBAAA;AxJykgBR;AwJtkgBM;ElJvGF,yBAAA;EACA,0BAAA;EAaA,mCAAA;EACA,kCAAA;ANoqgBJ;AwJxkgBQ;EACE,kCpJ6OoB;AJ61f9B;AwJnkgBE;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBpJsGK;AJ+9fT;AwJnkgBI;EACE,gBAAA;AxJqkgBN;AwJlkgBI;EACE,SAAA;AxJokgBN;AwJjkgBI;EACE,aAAA;AxJmkgBN;AwJ/jgBE;EACE,mBAAA;EACA,mBAAA;AxJikgBJ;AwJ/jgBI;EACE,eAAA;EACA,kBAAA;AxJikgBN;AwJ9jgBI;EACE,cAAA;AxJgkgBN;AwJ7jgBI;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,SAAA;EACA,kBAAA;AxJ+jgBN;AwJ7jgBM;EACE,aAAA;AxJ+jgBR;AwJ5jgBM;EACE,sBAAA;AxJ8jgBR;AwJ1jgBI;EACE,WAAA;AxJ4jgBN;AwJxjgBE;EACE,mBAAA;AxJ0jgBJ;AwJvjgBE;EACE,kBAAA;EACA,UAAA;EACA,gBAAA;AxJyjgBJ;;AwJrjgBA;EACE,kBAAA;EACA,WpJwCO;EoJvCP,SpJuCO;EoJtCP,WAAA;AxJwjgBF;AwJtjgBE;EACE,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,YAAA;AxJwjgBJ;;AwJhjgBM;;EACE,UAAA;AxJojgBR;;AwJ3igBM;EACE,gBvJ5NA;EKGJ,sBAAA;ANwwgBJ;;AwJvigBA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EAEA,kBAAA;EACA,gBAAA;AxJyigBF;AwJvigBE;EACE,iBAAA;EACA,mBAAA;AxJyigBJ;AwJtigBE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;AxJwigBJ;AwJtigBI;EACE,aAAA;AxJwigBN;AwJnigBE;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;AxJqigBJ;AwJnigBI;EACE,gBAAA;AxJqigBN;AwJjigBE;EACE,WAAA;EACA,eAAA;AxJmigBJ;;AwJ9hgBE;EACE,aAAA;EACA,qBAAA;EACA,qBAAA;EACA,gBAAA;AxJiigBJ;AwJ3hgBI;EACE,iBAAA;AxJ6hgBN;AwJ1hgBI;EACE,mBAAA;AxJ4hgBN;AwJxhgBM;EACE,gBAAA;AxJ0hgBR;AwJrhgBE;EACE,aAAA;EACA,SAAA;EACA,sBAAA;EACA,eAAA;AxJuhgBJ;AwJrhgBI;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AxJuhgBN;AwJphgBI;EACE,aAAA;AxJshgBN;;AwJ/ggBA;EACE,oCAAA;AxJkhgBF;;AwJ7ggBA;EACE,kBAAA;AxJghgBF;AwJ9ggBE;EACE,kBvJ7Pa;EuJ8Pb,iBAAA;EACA,YAAA;EACA,yBAAA;EACA,+BAAA;AxJghgBJ;AwJ7ggBE;EACE,cAAA;AxJ+ggBJ;;AwJ3ggBA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AxJ8ggBF;AwJ5ggBE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;AxJ8ggBJ;;AwJ1ggBA;EACE,iBAAA;AxJ6ggBF;;AyJz3gBA;EACE,arJgPO;EqJ/OP,mBAAA;EACA,mBAAA;AzJ43gBF;AyJ13gBE;EACE,aAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;AzJ43gBJ;AyJv3gBI;EACE,YAAA;EACA,iBAAA;AzJy3gBN;AyJt3gBI;EACE,YAAA;AzJw3gBN;AyJp3gBE;EACE,iBAAA;AzJs3gBJ;AyJn3gBE;EACE,iBAAA;EACA,iBAAA;EACA,cAAA;AzJq3gBJ;AyJl3gBE;EACE,aAAA;EACA,SAAA;EACA,sBAAA;AzJo3gBJ;AyJj3gBE;EACE,gBrJwMK;AJ2qgBT;AyJj3gBI;EACE,2BAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;AzJm3gBN;AyJ72gBM;EACE,iBAAA;AzJ+2gBR;AyJz2gBI;EACE,kBAAA;EACA,UAAA;EACA,wBAAA;AzJ22gBN;AyJr2gBM;EACE,mBAAA;EACA,UAAA;AzJu2gBR;;A0Jn7gBA;EACE,kBAAA;EACA,gBAAA;A1Js7gBF;A0Jp7gBE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;A1Js7gBJ;A0Jn7gBE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;A1Jq7gBJ;A0Jh7gBI;EACE,alFzB4B;AxE28gBlC;A0Jh7gBM;EACE,mBAAA;A1Jk7gBR;A0J/6gBM;EACE,kBAAA;A1Ji7gBR;A0J76gBI;EACE,kBAAA;A1J+6gBN;A0J76gBM;EACE,WzJ7BA;EyJ8BA,UAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iBzJ0CO;ADq4gBf;A0J76gBQ;EACE,oCAAA;A1J+6gBV;;A2Jl+gBA;EACE,YnFQgC;EmFPhC,WnFQgC;EmFPhC,oDAAA;A3Jq+gBF;;A2Jl+gBA;EACE,YnFEgC;EmFDhC,WnFEgC;EmFDhC,oDAAA;A3Jq+gBF;;A2Jj+gBE;EACE,mBnFX8B;AxE++gBlC;A2Jj+gBE;EACE,qBnFd8B;EmFe9B,mBAAA;A3Jm+gBJ;A2Jj+gBI;EACE,YAAA;A3Jm+gBN;A2Jh+gBI;EACE,iB1JgES;ADk6gBf;;A2J79gBA;EACE,eAAA;EACA,kBAAA;EACA,QAAA;EACA,kBAAA;A3Jg+gBF;;A2J79gBA;EACE,eAAA;EACA,kBAAA;EACA,UAAA;A3Jg+gBF;;A2J79gBA;EACE,mDAAA;A3Jg+gBF;;A2J79gBA;EACE,uBAAA;A3Jg+gBF;;A2J79gBA;EACE,oBAAA;A3Jg+gBF;A2J99gBE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;A3Jg+gBJ;A2J79gBE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;A3J+9gBJ;A2J79gBI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;A3J+9gBN;A2J59gBI;EACE,WAAA;EACA,YAAA;A3J89gBN;A2J59gBM;EACE,gBAAA;A3J89gBR;A2J39gBM;EACE,yBAAA;EACA,qBAAA;A3J69gBR;;A2Jt9gBE;EACE,yBAAA;EACA,8BAAA;EACA,gBAAA;A3Jy9gBJ;A2Jt9gBE;EACE,6BAAA;A3Jw9gBJ;A2Jt9gBI;EACE,yBAAA;EACA,WAAA;A3Jw9gBN;A2Jr9gBQ;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;A3Ju9gBV;A2Jh9gBQ;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;A3Jk9gBV;A2Jh9gBU;EACE,kBAAA;A3Jk9gBZ;A2J78gBM;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;A3J+8gBR;A2J78gBQ;EACE,WAAA;A3J+8gBV;A2J18gBI;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;A3J48gBN;A2Jz8gBE;EACE,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,eAAA;EACA,wCAAA;A3J28gBJ;A2Jz8gBI;EACE,gBAAA;EACA,6BAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;A3J28gBN;A2Jz8gBM;EACE,sBAAA;EACA,gBAAA;A3J28gBR;A2J18gBQ;EACE,gBAAA;A3J48gBV;A2Jx8gBM;EACE,4BAAA;EACA,+BAAA;EACA,yBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;A3J08gBR;A2Jt8gBI;EACE,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;A3Jw8gBN;A2Jt8gBM;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,0DAAA;EACA,wBAAA;EACA,4BAAA;EACA,WAAA;EACA,YAAA;A3Jw8gBR;A2Jr8gBM;EACE,6BAAA;A3Ju8gBR;A2Jp8gBM;EACE,WAAA;EACA,WAAA;EACA,gBAAA;A3Js8gBR;A2Jr8gBQ;EAEE,gBAAA;A3Js8gBV;A2Jl8gBI;EACE,6BAAA;A3Jo8gBN;A2Jh8gBE;EACE,uBAAA;EACA,gBAAA;EACA,SAAA;A3Jk8gBJ;A2J/7gBE;EACE,kBAAA;A3Ji8gBJ;A2J97gBE;EACE,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;A3Jg8gBJ;;A2J37gBE;EACE,gBAAA;A3J87gBJ;A2J77gBI;EACE,aAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;A3J+7gBN;A2J97gBM;EAEE,gBAAA;A3J+7gBR;A2J57gBI;EACE,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;A3J87gBN;A2J17gBQ;;EAEE,kBAAA;A3J47gBV;A2Jv7gBI;EACE,yBAAA;EACA,8BAAA;EACA,gBAAA;EACA,mBAAA;A3Jy7gBN;A2Jt7gBE;EACE,kBAAA;EACA,mBAAA;A3Jw7gBJ;A2Jt7gBE;EACE,kBAAA;EACA,mBAAA;A3Jw7gBJ;A2Jt7gBE;EACE,uBAAA;A3Jw7gBJ;A2Jv7gBI;EACE,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;A3Jy7gBN;A2Jv7gBM;EACE,yBAAA;EACA,yBAAA;EACA,yBAAA;A3Jy7gBR;A2Jt7gBM;EACE,yBAAA;A3Jw7gBR;A2Jn7gBI;EACE,iBAAA;A3Jq7gBN;;A2Jh7gBA;EACE,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;A3Jm7gBF;;A2Jh7gBA;EACE,mBAAA;A3Jm7gBF;;A2Jh7gBA;EACE,wCAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;A3Jm7gBF;;A2Jh7gBA;EACE,iBAAA;A3Jm7gBF;;A2J/6gBA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,iBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,4CAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;A3Jk7gBF;A2Jj7gBE;EAZF;IAaI,sBAAA;E3Jo7gBF;AACF;A2Jn7gBE;EACE,kCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;A3Jq7gBJ;A2Jn7gBE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,SAAA;EACA,cAAA;A3Jq7gBJ;A2Jp7gBI;EAPF;IAQI,cAAA;E3Ju7gBJ;AACF;A2Jt7gBI;EACE,kCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;A3Jw7gBN;A2Jt7gBI;EAEE,6BAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;A3Ju7gBN;A2Jt7gBM;EACE,sBAAA;EACA,gBAAA;A3Jw7gBR;A2Jv7gBQ;EACE,gBAAA;A3Jy7gBV;A2Jr7gBM;EACE,4BAAA;EACA,+BAAA;EACA,yBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;A3Ju7gBR;A2Jp7gBI;EAEE,cAAA;A3Jq7gBN;;A2J96gBA;EACE,qBAAA;A3Ji7gBF;;A4J/0hBM;EACE,WAAA;EACA,WAAA;A5Jk1hBR;A4J70hBE;EACE,WAAA;EACA,epFjB8B;EoFkB9B,gBAAA;EAQA,gCAAA;A5Jw0hBJ;A4J90hBI;EACE,SAAA;EACA,UAAA;EACA,uBAAA;A5Jg1hBN;A4J10hBE;EACE,epF9B8B;AxE02hBlC;A4J10hBI;EtJnBA,qBAAA;ANg2hBJ;A4Jx0hBE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;A5J00hBJ;A4Jx0hBI;EACE,SAAA;EACA,aAAA;A5J00hBN;A4Jx0hBM;EACE,+BAAA;EACA,gBAAA;EACA,SAAA;A5J00hBR;A4Jv0hBM;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;A5Jy0hBR;A4Jt0hBM;EACE,aAAA;EACA,mBAAA;A5Jw0hBR;A4Jr0hBM;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;A5Ju0hBR;A4Jp0hBM;EACE,epFzE0B;EoF0E1B,6BAAA;A5Js0hBR;A4Jl0hBI;EACE,YAjF8B;EAkF9B,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,SAAA;EACA,kBAAA;A5Jo0hBN;A4Jl0hBM;EACE,mBAAA;A5Jo0hBR;A4Jj0hBM;EACE,+BAAA;EACA,gBAAA;EACA,mB3JpFG;E2JqFH,SAAA;EACA,+BAAA;EACA,8BAAA;A5Jm0hBR;A4Jh0hBM;;EAEE,mB3J5FG;AD85hBX;A4J9zhBI;EACE,WA7G8B;A5J66hBpC;A4J5zhBE;EACE,WAAA;EACA,YAlHgC;A5Jg7hBpC;;A4JzzhBE;EACE,6BAAA;A5J4zhBJ;A4J1zhBI;EACE,8BAAA;A5J4zhBN;;A6Jx7hBI;EACE,YAL0B;EAM1B,eAAA;A7J27hBN;A6Jv7hBE;EACE,iBzJmb0B;AJsghB9B;A6Jv7hBI;EACE,kB5J4EW;AD62hBjB;A6Jr7hBE;EACE,erFd8B;AxEq8hBlC;;Aa/3hBI;EgJhDI;IACE,mBAAA;E7Jm7hBR;AACF;A4Jr0hBA;EACE,aAAA;EACA,sBAAA;A5Ju0hBF;;Aaz4hBI;EiJzEF;IACE,wBAAA;E9Js9hBF;E8Jn9hBA;IACE,cAAA;E9Jq9hBF;E8Jh9hBE;IACE,yBAAA;E9Jk9hBJ;AACF;A+Jj+hBA;;EAAA;AAGA;EACE,2BAAA;EACA,qBAAA;EACA,kBAAA;A/Jm+hBF;;A+Jh+hBA;;EAAA;AAGA;EACE,wBAAA;EACA,UAAA;EACA,6DAAA;EACA,YAAA;EACA,mDAAA;EACA,SAAA;EACA,mCAAA;EACA,kBAAA;EACA,UAAA;A/Jm+hBF;;A+Jh+hBA;EACE,aAAA;EACA,UAAA;EACA,6DAAA;EACA,WAAA;EACA,mDAAA;EACA,QAAA;EACA,mCAAA;EACA,kBAAA;EzJbE,mBAAA;EyJeF,UAAA;A/Jm+hBF;;A+Jh+hBA;;EAEE,cAAA;EACA,6BAAA;A/Jm+hBF;;A+Jh+hBA;;;;;;EAME,YAAA;A/Jm+hBF;;A+Jh+hBA;;;;EAIE,oCAAA;EACA,YAAA;A/Jm+hBF;;A+Jh+hBA;;EAAA;AAGA;EACE,oCAAA;EACA,kBAAA;EACA,iEAAA;EACA,WAAA;EACA,2CAAA;EACA,WAAA;EACA,mCAAA;EACA,kBAAA;A/Jm+hBF;;A+Jh+hBA;EACE,oCAAA;EACA,kBAAA;EACA,gEAAA;EACA,UAAA;EACA,0CAAA;EACA,UAAA;EACA,mCAAA;EACA,kBAAA;A/Jm+hBF;;A+Jh+hBA;;EAEE,qCAAA;EACA,YAAA;A/Jm+hBF;;A+Jh+hBA;;EAEE,qCAAA;EACA,WAAA;A/Jm+hBF;;A+Jh+hBA,gBAAA;AACA;EACE;IACE,yBAAA;E/Jm+hBF;AACF;A+Jh+hBA;EACE;IACE,yBAAA;E/Jk+hBF;AACF;A+J/9hBA;EACE,kBAAA;EACA,YAAA;A/Ji+hBF;;A+J59hBA;EACE,kBAAA;EACA,aAAA;A/J+9hBF;;A+J59hBA;EACE,aAAA;EACA,kBAAA;A/J+9hBF;;A+J59hBA;EACE,aAAA;EACA,kBAAA;A/J+9hBF;;A+J59hBA;EACE,aAAA;EACA,kBAAA;A/J+9hBF;;A+J59hBA;EACE,aAAA;EACA,kBAAA;A/J+9hBF;;A+J59hBA;EACE,gBAAA;EACA,WAAA;EACA,eAAA;A/J+9hBF;;A+J59hBA;EACE,kBAAA;A/J+9hBF;A+J79hBE;EAEE,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,cvFvJ8B;EuFwJ9B,kBAAA;EACA,WAAA;EACA,WAAA;EACA,2FAAA;EACA,oHAAA;A/J89hBJ;A+J39hBE;EACE,SAAA;EACA,SAAA;EAEA,yFAAA;EACA,oHAAA;A/J49hBJ;;AgKnoiBA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;AhKsoiBF;;AgKnoiBA;;EAEE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,OAAA;EACA,yBAAA;AhKsoiBF;;AgKnoiBA;EACE,aAAA;E1JJE,sBAAA;E0JMF,iIACQ;AhKqoiBV;;AgKhoiBA;EACE,yDAAA;AhKmoiBF;;AgKhoiBA;;EAEE,yBAAA;EAGA,iBAAA;EACA,UAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;EACA,6BAAA;EACA,kBAAA;AhKmoiBF;;AgKhoiBA;;EAEE,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EAAA,oBAAA;EACA,oBAAA;EACA,wBAAA;EACA,kBAAA;EACA,oBAAA;EACA,2BAAA;EACA,oBAAA;EACA,uBAAA;AhKmoiBF;;AgKhoiBA;;EAEE,cAAA;AhKmoiBF;;AgKhoiBA;EACE,eAAA;EACA,c/JjDS;ADoriBX;;AgKhoiBA;EACE,gBAAA;AhKmoiBF;;AgKhoiBA;EACE,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;EACA,qBAAA;AhKmoiBF;AgKjoiBE;EACE,UAAA;EACA,kBAAA;AhKmoiBJ;;AgK/niBA;EACE,yDAAA;AhKkoiBF;;AgK/niBA;;EAEE,cAAA;EACA,YAAA;AhKkoiBF;;AgK/niBA;EACE,WAAA;AhKkoiBF;;AgK/niBA;EACE,sBAAA;EACA,kBAAA;EACA,cAAA;EACA,qDAAA;EACA,iBAAA;EACA,eAAA;AhKkoiBF;;AgK/niBA;EACE,c/JzEM;AD2siBR;;AgK/niBA;;EAEE,W/J5GM;E+J6GN,eAAA;EACA,wBAAA;AhKkoiBF;;AgK/niBA;EACE,eAAA;EACA,c/J5GS;AD8uiBX;;AgK/niBA;EACE,c/JhHS;ADkviBX;;AgK/niBA;EACE,OAAA;AhKkoiBF;;AgK/niBA;EACE,gBAAA;AhKkoiBF;;AgK/niBA;EACE,0JAAA;EAEA,aAAA;EACA,sBAAA;AhKkoiBF;;AgK/niBA;EAEE,cAAA;AhKkoiBF;;AgK/niBA;EACE,0BAAA;EACA,gBAAA;AhKkoiBF;;AgK/niBA;;;EAGE,aAAA;AhKkoiBF;;AgK/niBA;EACE,UAAA;EACA,WAAA;EACA,YAAA;AhKkoiBF;;AgK9niBA;EACE,UAAA;EACA,WAAA;EACA,YAAA;AhKioiBF;;AgK9niBA;EACE,WAAA;AhKioiBF;;AgK9niBA;EACE,kBAAA;EACA,mBAAA;AhKioiBF;;AgK9niBA;EACE,cAAA;AhKioiBF;;AgK9niBA;EACE,kBAAA;EACA,OAAA;AhKioiBF;;AgK9niBA;EAEE,aAAA;EAEA,SAAA;EACA,WAAA;AhKioiBF;;AgK9niBA;EAEE,aAAA;EAEA,cAAA;EACA,eAAA;EACA,cAAA;EAEA,uBAAA;AhKioiBF;;AgK9niBA;EACE,WAAA;EACA,uBAAA;AhKioiBF;;AgK9niBA;EAEE,mBAAA;AhKioiBF;;AgK9niBA;EACE,WAAA;AhKioiBF;;AgK9niBA;EACE,UAAA;AhKioiBF;;AgK9niBA;EACE,YAAA;AhKioiBF;;AgK9niBA;EACE,OAAA;AhKioiBF;;AgK9niBA;EACE,YAAA;AhKioiBF;;AgK9niBA;;EAEE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,MAAA;EACA,kBAAA;EACA,UAAA;EACA,iDAAA;AhKioiBF;;AgK9niBA;EACE,UAAA;EACA,WAAA;EACA,YAAA;AhKioiBF;;AgK9niBA;EACE,YAAA;EACA,SAAA;EACA,OAAA;EACA,mB/JhOM;ADi2iBR;;AgK9niBA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;AhKioiBF;;AgK9niBA;EACE,SAAA;EACA,iBAAA;AhKioiBF;;AiK35iBA;;;;;;EAAA;AASA;;EAAA;AASA;;EAAA;AAYA;;EAAA;AAIA;EACE;IACE,aAAA,EAAA,oBAAA;EjK44iBF;EiK14iBA;IACE,UAAA;EjK44iBF;AACF;AiKx4iBA;;EAAA;AAIA;EACE,kBAAA;AjKy4iBF;;AiKr4iBA,sBAAA;AACA;EACE,kBAAA;EACA,UAAA;EACA,qBAAA;EACA,WA3CY;EA4CZ,QAAA;EACA,aAAA;EACA,UAAA;EACA,oBAAA;AjKw4iBF;;AiKr4iBA,iBAAA;AACA;EACE,kBAAA;EACA,UAAA;AjKw4iBF;;AiKp4iBE;EACE,2BAAA;AjKu4iBJ;AiKp4iBE;EACE,2BAAA;AjKs4iBJ;;AiKl4iBA,iBAAA;AACA;EACE,kBAAA;EACA,QAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,8BAAA;EACA,aAAA;EAlEA,sCAAA;AjKw8iBF;;AiKl4iBA;EACE,cAAA;AjKq4iBF;;AiKj4iBA;;EAAA;AAIA;;;EA/EE,uEAAA;AjKq9iBF;;AiKh4iBA;;;;;;EArFE,oCAAA;AjK89iBF;;AiK/3iBA;;EAAA;AAKE;EACE,WAAA;AjKg4iBJ;AiK73iBE;EAEE,YAAA;AjK83iBJ;AiK33iBE;EACE,mBAAA;AjK63iBJ;AiK33iBI;EACE,UAAA;AjK63iBN;AiK13iBI;EAEE,mBAAA;AjK23iBN;;AiKr3iBA;;EAAA;AAKE;EACE,UAAA;AjKs3iBJ;AiKn3iBE;EAEE,SAAA;AjKo3iBJ;AiKj3iBE;EACE,kBAAA;AjKm3iBJ;AiKj3iBI;EACE,UAAA;AjKm3iBN;AiKh3iBI;EAEE,kBAAA;AjKi3iBN;;AiK32iBA;;EAAA;AAIA;EACE,gBAAA;AjK62iBF;AiK32iBE;EACE,UAAA;EACA,SAAA;EACA,cAAA;AjK62iBJ;AiK12iBE;EACE,iBAAA;AjK42iBJ;AiK12iBI;EACE,UAAA;EACA,SAAA;EACA,aAAA;AjK42iBN;AiKz2iBI;EAEE,iBAAA;AjK02iBN;AiKx2iBM;EACE,QAAA;AjK02iBR;;AiKn2iBA;;EAAA;AAIA;EACE,gBAAA;AjKq2iBF;AiKn2iBE;EACE,SAAA;EACA,SAAA;EACA,cAAA;AjKq2iBJ;AiKl2iBE;EAEE,SAAA;AjKm2iBJ;AiKh2iBE;EACE,oBAAA;AjKk2iBJ;AiKh2iBI;EACE,UAAA;AjKk2iBN;AiK/1iBI;EAEE,oBAAA;AjKg2iBN;;AiK11iBA;;EAAA;AAGA;EACE,gBAAA;AjK61iBF;AiK31iBE;EACE,kBAAA;AjK61iBJ;AiK31iBE;EACE,UAAA;EACA,cAAA;AjK61iBJ;AiKz1iBI;EACE,UAAA;EACA,WAAA;AjK21iBN;AiKz1iBI;EACE,UAAA;EACA,SAAA;AjK21iBN;;AiKr1iBA;;EAAA;AAGA;EACE,gBAAA;AjKw1iBF;AiKt1iBE;EACE,kBAAA;AjKw1iBJ;AiKt1iBE;EACE,WAAA;EACA,cAAA;EACA,UAAA;AjKw1iBJ;AiKt1iBI;EACE,WAAA;AjKw1iBN;AiKn1iBI;EACE,UAAA;EACA,UAAA;AjKq1iBN;AiKn1iBI;EACE,UAAA;EACA,SAAA;AjKq1iBN;;AiK/0iBA;;EAAA;AAGA;EACE,gBAAA;AjKk1iBF;AiKh1iBE;EACE,kBAAA;AjKk1iBJ;AiKh1iBE;EACE,SAAA;EACA,cAAA;EACA,eAAA;AjKk1iBJ;AiK90iBI;EACE,UAAA;EACA,SAAA;AjKg1iBN;AiK90iBI;EACE,UAAA;EACA,aAAA;AjKg1iBN;;AiK10iBA;;EAAA;AAGA;EACE,gBAAA;AjK60iBF;AiK30iBE;EACE,kBAAA;AjK60iBJ;AiK30iBE;EACE,SAAA;EACA,cAAA;EACA,gBAAA;AjK60iBJ;AiKz0iBI;EACE,UAAA;EACA,QAAA;AjK20iBN;AiKz0iBI;EACE,UAAA;EACA,aAAA;AjK20iBN;;AiKr0iBA;;EAAA;AAIA;EACE,gBAAA;AjKu0iBF;;AiKr0iBA;EACE,SAAA;EACA,iBAhWY;EAYZ,qBAsVoB;AjKu0iBtB;;AiKr0iBA;EACE,kBAAA;EACA,qBAAA;AjKw0iBF;;AiKr0iBA;EACE,UAAA;EA9VA,qBAgWoB;AjKu0iBtB;;AiKr0iBA;EACE,UAAA;EACA,cAAA;EApWA,eAsWoB;AjKu0iBtB;;AiKn0iBA;;EAAA;AAIA;EACE,gBAAA;AjKq0iBF;;AiKn0iBA;EACE,SAAA;EACA,kBAAA;EAnXA,qBAqXoB;AjKq0iBtB;;AiKn0iBA;EACE,kBAAA;EACA,qBAAA;AjKs0iBF;;AiKn0iBA;EACE,UAAA;EA7XA,qBA+XoB;AjKq0iBtB;;AiKn0iBA;EACE,UAAA;EACA,cAAA;EAnYA,eAqYoB;AjKq0iBtB;;AiKj0iBA;;EAAA;AAIA;EACE,gBAAA;EACA,YAAA;AjKm0iBF;;AiKj0iBA;EACE,SAAA;EACA,cAAA;AjKo0iBF;;AiKj0iBA;EACE,kBAAA;EACA,WAAA;AjKo0iBF;;AiKl0iBA;EACE,UAAA;AjKq0iBF;;AiKn0iBA;EACE,UAAA;AjKs0iBF;;AiKj0iBA;;EAAA;AAIA;EACE,gBAAA;EACA,YAAA;EAEA,+CAAA;AjKk0iBF;;AiKh0iBA;EACE,SAAA;EACA,cAAA;AjKm0iBF;;AiKh0iBA;EACE,kBAAA;EACA,WAAA;EAEA,+CAAA;EACA,iDAAA;AjKk0iBF;;AiKh0iBA;EACE,UAAA;AjKm0iBF;;AiKj0iBA;EACE,UAAA;AjKo0iBF;;AiKh0iBA;EACE,oBAAA;AjKm0iBF;;AkK/xjBA;;;;;;EAAA;ACGA;EACE,gBAAA;EACA,qBAAA;EACA,eAAA;EAEA,oCAAA;EACA,0BAAA;EACA,kCAAA;EAGA,aAAA;EACA,cAAA;EACA,oBAAA;EACA,6BAAA;EACA,SAAA;EACA,SAAA;EACA,iBAAA;AnKmyjBF;AmKjyjBE;EAKI,YDT2B;AlKwyjBjC;AmK1xjBI;EAKI,YDnByB;AlK2yjBjC;AmKpxjBI;;;EAGE,yBlKEE;ADoxjBR;;AmKjxjBA;EACE,WDrC+B;ECsC/B,YAAA;EACA,qBAAA;EACA,kBAAA;AnKoxjBF;;AmKjxjBA;EACE,cAAA;EACA,QAAA;EACA,gBAAA;AnKoxjBF;AmKlxjBE;EAGE,WDnD6B;ECoD7B,WDnD6B;ECoD7B,yBlKpBI;EkKqBJ,mBDlD6B;ECmD7B,kBAAA;EACA,8BAAA;EACA,0BAAA;EACA,gCAAA;AnKkxjBJ;AmK/wjBE;EAEE,WAAA;EACA,cAAA;AnKgxjBJ;AmK7wjBE;EACE,SAAA;AnK+wjBJ;AmK5wjBE;EACE,YAAA;AnK8wjBJ;;AoKh2jBE;;EAAA;AAIE;EACE,QAAA;EACA,2BAAA;EACA,kEAAA;ApKk2jBN;AoKh2jBM;EACE,QAAA;EACA,sCAAA;ApKk2jBR;AoK/1jBM;EACE,SAAA;EACA,mEAAA;ApKi2jBR;AoK51jBM;EAGE,gDAAA;EACA,wBAAA;ApK41jBR;AoK11jBQ;EACE,oBAAA;EACA,UAAA;ApK41jBV;AoKz1jBQ;EACE,mDAAA;EACA,wBAAA;ApK21jBV;;AqK53jBA;EACE,gBpKWM;EoKVN,kBAAA;EACA,e7FDgC;AxEg4jBlC;AqK73jBE;EACE,mBpKmFW;EoKlFX,cpKYO;EoKXP,SAAA;EACA,mBpKIO;EoKHP,uBAAA;EACA,gCAAA;EACA,6BAAA;ArK+3jBJ;AqK73jBI;EACE,aAAA;ArK+3jBN;AqK33jBE;EACE,e7FlB8B;AxE+4jBlC;AqK13jBE;EACE,aAAA;ArK43jBJ;;AqKx3jBA;E/JbI,mBAAA;E+JeF,gBpKlBM;EoKmBN,eAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,mDjKsV4B;EiKrV5B,WAAA;ArK23jBF;AqKz3jBE;EACE,eAAA;ArK23jBJ;;AsKpqjBA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EAEA,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;EACA,uBAAA;AtKuqjBF;AsKrqjBE;EACE,qBrK3NE;ADk4jBN;AsKrqjBI;EACE,kBAAA;EACA,cAAA;AtKuqjBN;AsKpqjBI;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,yBrKtOA;EqKuOA,cAAA;EACA,SAAA;EACA,kBAAA;AtKsqjBN;AsKpqjBM;EAEE,wBAAA;EACA,UAAA;AtKsqjBR;AsKnqjBM;EAEE,yBAAA;EACA,WAAA;AtKqqjBR;AsKhqjBE;EACE,qBrKxPK;AD05jBT;AsKhqjBI;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,SAAA;EAEA,kBAAA;EACA,iBAAA;EACA,yBrKnQG;ADq6jBT;AsK/pjBI;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EAEA,kBAAA;EACA,iBAAA;EACA,SAAA;EACA,YAAA;EACA,yBrK/QG;ADg7jBT;AsK7pjBE;EACE,qBrKjRG;ADg7jBP;AsK7pjBI;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBrK5RC;AD27jBP;AsK5pjBI;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,SAAA;EACA,yBrKvSC;ADq8jBP;AsK1pjBE;EACE,qBrK9SI;AD08jBR;AsK1pjBI;EAEE,WAAA;EAEA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,gBrK9VE;EqKgWF,wBAAA;AtK2pjBN;AsKxpjBI;EAEE,8BAAA;EACA,SAAA;EACA,WAAA;EAEA,yBAAA;EAEA,2BAAA;AtK0pjBN;AsKvpjBI;EAEE,8BAAA;EACA,UAAA;EACA,UAAA;EAEA,yBAAA;EAEA,wBAAA;AtKypjBN;AsKtpjBI;EACE,WAAA;EACA,YAAA;EACA,0CAAA;EAEA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;AtKwpjBN;AsKrpjBI;EACE,UAAA;EACA,YAAA;EACA,sBrK1YE;EqK2YF,kBAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;EAEA,yBAAA;AtKupjBN;AsKppjBI;EACE,WAAA;EACA,yBrK/WE;EqKgXF,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;AtKspjBN;AsKppjBM;EACE,WAAA;EACA,UAAA;EACA,SAAA;EAEA,wBAAA;AtKspjBR;AsKnpjBM;EACE,WAAA;EACA,UAAA;EACA,SAAA;EAEA,yBAAA;AtKqpjBR;AsKhpjBE;EACE,wBAAA;EACA,gBAAA;EACA,YAAA;EACA,kCAAA;EACA,4BAAA;AtKkpjBJ;AsKz7iBA;EACE;IACE,QAAA;IACA,SAAA;IACA,SAAA;EtKu9iBF;EsKr9iBA;IACE,QAAA;IACA,SAAA;IACA,SAAA;EtKu9iBF;EsKr9iBA;IACE,WAAA;IACA,UAAA;IACA,SAAA;EtKu9iBF;EsKr9iBA;IACE,WAAA;IACA,UAAA;IACA,SAAA;EtKu9iBF;EsKr9iBA;IACE,WAAA;IACA,UAAA;IACA,SAAA;EtKu9iBF;AACF;AsK77iBA;EACE;IACE,QAAA;IACA,WAAA;IACA,SAAA;EtKq9iBF;EsKn9iBA;IACE,QAAA;IACA,WAAA;IACA,SAAA;EtKq9iBF;EsKn9iBA;IACE,WAAA;IACA,QAAA;IACA,SAAA;EtKq9iBF;EsKn9iBA;IACE,WAAA;IACA,UAAA;IACA,SAAA;EtKq9iBF;AACF;AsK56iBA;EAEE,kCAAA;AtK86iBF;;AsK36iBA;EAEE,mCAAA;AtK86iBF;;AsK36iBA;EAEE,0CAAA;AtK86iBF;;AsKrwiBA,iBAAA;AACA;EACE,6BAAA;AtKwwiBF;;AsKpwiBA;EACE,gCAAA;AtKuwiBF;;AsKnwiBA;EACE,iCAAA;AtKswiBF;;AuKhtkBA;EACI,aCcS;EDbT,eAAA;EACA,UAAA;EACA,YCLa;EDMb,sBAAA;EACA,WtKQI;AD2skBR;AuKltkBI;EACI,SnK+OC;EmK9OD,UnK8OC;AJs+jBT;AuKltkBI;EACI,SnK2OC;EmK1OD,SAAA;EACA,mBAAA;AvKotkBR;AuKltkBI;EACI,SnKsOC;EmKrOD,WnKqOC;AJ++jBT;AuKltkBI;EACI,YnKkOC;EmKjOD,UnKiOC;AJm/jBT;AuKltkBI;EACI,YnK8NC;EmK7ND,SAAA;EACA,mBAAA;AvKotkBR;AuKltkBI;EACI,YnKyNC;EmKxND,WnKwNC;AJ4/jBT;;AuKhtkBA;EACI;IACI,YAAA;IACA,UAAA;IACA,OAAA;IACA,SAAA;EvKmtkBN;EuKltkBM;IAGI,MAAA;EvKktkBV;EuKhtkBM;IAGI,SAAA;EvKgtkBV;EuK9skBM;IACE,QAAA;IACA,UAAA;IAAA,aAAA;EvKgtkBR;AACF;AyKtwkBA;EACI,kBAAA;EACA,gBDDkB;ECElB,sBAAA;EACA,mBAAA;EACA,arKkPK;EEtOL,sBAAA;EmKVA,kUxKuGiB;EwKtGjB,aAAA;EACA,8BAAA;EACA,iBDRkB;ECSlB,gBAAA;EACA,uBDEa;ECDb,eAAA;EACA,cAAA;AzKwwkBJ;AyKvwkBI;EACI,cAAA;AzKywkBR;AyKvwkBI;EACI,gBDdW;ECeX,cxKCG;EAmJT,sMAAA;ADsnkBF;AyKvwkBI;EACI,mBxK8BD;EAkHL,0MAAA;AD0nkBF;AyKvwkBI;EACI,mBxKwBA;EAoHN,0MAAA;AD8nkBF;AyKvwkBI;EACI,mBxKmBC;EAqHP,0MAAA;ADkokBF;AyKvwkBI;EACI,mBxKaF;EAuHJ,sMAAA;ADsokBF;AyKvwkBI;EACI,cAAA;EACA,mBAAA;AzKywkBR;;AyKrwkBA;EACE;IACE,gBAAA;EzKwwkBF;AACF;A0K1zkBA;EACE,WzKeM;EyKdN,eAAA;EACA,uBAAA;EACA,aAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;A1K4zkBF;A0K3zkBE;EACE,WAAA;EACA,YAAA;A1K6zkBJ;A0K1zkBE;EAEE,UAAA;A1K2zkBJ;;A2K/0kBA;EACE;IACE,UAAA;E3Kk1kBF;E2Kh1kBA;IACE,QAAA;E3Kk1kBF;AACF;A2K/0kBA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,QAAA;EACA,WAAA;EACA,aHEW;EGDX,2CAAA;EACA,0CAAA;ErKEE,sBAAA;ANg1kBJ;A2K/0kBE;EACE,QAAA;EACA,UAAA;EAAA,aAAA;A3Ki1kBJ;A2K/0kBE;EACE,mB1KqBI;AD4zkBR;A4Kt2kBA;EACI;IAJA,8DAAA;E5K62kBF;E4Kl2kBE;IACI,UAAA;IACA,oCAAA;E5Ko2kBN;E4Kl2kBE;IACI,UAAA;IACA,mCAAA;E5Ko2kBN;E4Kl2kBE;IACI,kCAAA;E5Ko2kBN;E4Kl2kBE;IACI,kCAAA;E5Ko2kBN;E4Kl2kBE;IACI,eAAA;E5Ko2kBN;AACF;A4Kj2kBA;EACI;IACI,UAAA;IACA,mCAAA;E5Km2kBN;E4Kj2kBE;IACI,UAAA;IACA,oCAAA;E5Km2kBN;AACF;A4Kh2kBA;EACI;IA1CA,8DAAA;E5K64kBF;E4K51kBE;IACI,UAAA;IACA,qCAAA;E5K81kBN;E4K51kBE;IACI,UAAA;IACA,kCAAA;E5K81kBN;E4K51kBE;IACI,mCAAA;E5K81kBN;E4K51kBE;IACI,iCAAA;E5K81kBN;E4K51kBE;IACI,eAAA;E5K81kBN;AACF;A4K31kBA;EACI;IACI,UAAA;IACA,kCAAA;E5K61kBN;E4K31kBE;IACI,UAAA;IACA,qCAAA;E5K61kBN;AACF;A4K11kBA;EACI;IAhFA,8DAAA;E5K66kBF;E4Kt1kBE;IACI,UAAA;IACA,oCAAA;E5Kw1kBN;E4Kt1kBE;IACI,UAAA;IACA,mCAAA;E5Kw1kBN;E4Kt1kBE;IACI,kCAAA;E5Kw1kBN;E4Kt1kBE;IACI,kCAAA;E5Kw1kBN;E4Kt1kBE;IACI,+BAAA;E5Kw1kBN;AACF;A4Kr1kBA;EACI;IACI,mCAAA;E5Ku1kBN;E4Kr1kBE;IAEI,UAAA;IACA,kCAAA;E5Ks1kBN;E4Kp1kBE;IACI,UAAA;IACA,qCAAA;E5Ks1kBN;AACF;A4Kn1kBA;EACI;IA1HA,8DAAA;E5Kg9kBF;E4K/0kBE;IACI,UAAA;IACA,qCAAA;E5Ki1kBN;E4K/0kBE;IACI,UAAA;IACA,kCAAA;E5Ki1kBN;E4K/0kBE;IACI,mCAAA;E5Ki1kBN;E4K/0kBE;IACI,iCAAA;E5Ki1kBN;E4K/0kBE;IACI,eAAA;E5Ki1kBN;AACF;A4K90kBA;EACI;IACI,kCAAA;E5Kg1kBN;E4K90kBE;IAEI,UAAA;IACA,mCAAA;E5K+0kBN;E4K70kBE;IACI,UAAA;IACA,oCAAA;E5K+0kBN;AACF;A4K30kBI;EAEI,sCAAA;A5K40kBR;A4K10kBI;EAEI,uCAAA;A5K20kBR;A4Kz0kBI;EACI,sCAAA;A5K20kBR;A4Kz0kBI;EACI,oCAAA;A5K20kBR;;A4Kt0kBI;EAEI,uCAAA;A5Kw0kBR;A4Kt0kBI;EAEI,wCAAA;A5Ku0kBR;A4Kr0kBI;EACI,qCAAA;A5Ku0kBR;A4Kr0kBI;EACI,uCAAA;A5Ku0kBR;;A6KzglBA;EACI;IACI,UAAA;IACA,iCAAA;E7K4glBN;E6K1glBE;IACI,UAAA;E7K4glBN;AACF;A6KzglBA;EACI;IACI,UAAA;E7K2glBN;E6KzglBE;IACI,UAAA;IACA,iCAAA;E7K2glBN;E6KzglBE;IACI,UAAA;E7K2glBN;AACF;A6KxglBA;EACI,gCAAA;A7K0glBJ;;A6KvglBA;EACI,iCAAA;A7K0glBJ;;A8KtilBA;EACI;IACI,sDAAA;IACA,kCAAA;IACA,UAAA;E9KyilBN;E8KvilBE;IACI,uDAAA;IACA,kCAAA;E9KyilBN;E8KvilBE;IACI,sDAAA;IACA,UAAA;E9KyilBN;E8KvilBE;IACI,sDAAA;E9KyilBN;E8KvilBE;IACI,6BAAA;E9KyilBN;AACF;A8KtilBA;EACI;IACI,6BAAA;E9KwilBN;E8KtilBE;IACI,uDAAA;IACA,UAAA;E9KwilBN;E8KtilBE;IACI,sDAAA;IACA,UAAA;E9KwilBN;AACF;A8KrilBA;EACI,gCAAA;A9KuilBJ;;A8KpilBA;EACI,iCAAA;A9KuilBJ;;A+K5klBA;EACI;IACI,kCAAA;IACA,mBAAA;E/K+klBN;E+K7klBE;IARA,+BAAA;E/KwllBF;AACF;A+K5klBA;EACI;IACI,mCAAA;IACA,mBAAA;E/K8klBN;E+K5klBE;IAlBA,+BAAA;E/KimlBF;AACF;A+K3klBA;EACI;IACI,kCAAA;IACA,mBAAA;E/K6klBN;E+K3klBE;IA5BA,+BAAA;E/K0mlBF;AACF;A+K1klBA;EACI;IACI,mCAAA;IACA,mBAAA;E/K4klBN;E+K1klBE;IAtCA,+BAAA;E/KmnlBF;AACF;A+KzklBA;EACI;IA5CA,+BAAA;E/KwnlBF;E+KzklBE;IACI,kBAAA;IACA,kCAAA;E/K2klBN;AACF;A+KxklBA;EACI;IAtDA,+BAAA;E/KiolBF;E+KxklBE;IACI,kBAAA;IACA,mCAAA;E/K0klBN;AACF;A+KvklBA;EACI;IAhEA,+BAAA;E/K0olBF;E+KvklBE;IACI,kBAAA;IACA,mCAAA;E/KyklBN;AACF;A+KtklBA;EACI;IA1EA,+BAAA;E/KmplBF;E+KtklBE;IACI,kBAAA;IACA,oCAAA;E/KwklBN;AACF;A+KpklBI;EAEI,qCAAA;A/KqklBR;A+KnklBI;EAEI,sCAAA;A/KoklBR;A+KlklBI;EACI,qCAAA;A/KoklBR;A+KlklBI;EACI,mCAAA;A/KoklBR;;A+K/jlBI;EAEI,sCAAA;A/KiklBR;A+K/jlBI;EAEI,uCAAA;A/KgklBR;A+K9jlBI;EACI,oCAAA;A/KgklBR;A+K9jlBI;EACI,sCAAA;A/KgklBR;;AgLlrlBA,oBAAA;AACA;;EAEE,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AhLqrlBF;;AgLlrlBA;EACE,eAAA;AhLqrlBF;;AgLlrlBA,eAAA;AACA;EACE,kBAAA;EACA,sB/KSM;E+KRN,Y5KgtCkC;AJq+iBpC;;AgLlrlBA,iBAAA;AACA;EACE,kBAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,gB/KbM;E+KcN,4L/K2FsB;EKtGpB,sBAAA;E0KaF,uBAAA;AhLqrlBF;;AgLlrlBA;EACE,aAAA;AhLqrlBF;;AgLlrlBA,uBAAA;AACA;EACE,kBAAA;EACA,eAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;AhLqrlBF;;AgLlrlBA;;EAEE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,OAAA;EACA,gBAAA;EACA,mB/KrCS;E+KsCT,mBAAA;EACA,2BAAA;AhLqrlBF;;AgLlrlBA;EACE,wBAAA;AhLqrlBF;;AgLlrlBA;EACE,yBAAA;AhLqrlBF;;AgLlrlBA;;EAEE,mB/KjDS;ADsulBX;;AgLlrlBA,eAAA;AAEA;EACE;IACE,UAAA;EhLorlBF;AACF;AgLjrlBA;EACE,wCAAA;AhLmrlBF;;AgLhrlBA;EACE;IACE,UAAA;EhLmrlBF;AACF;AgLhrlBA;EACE,yCAAA;AhLkrlBF;;AgL/qlBA;EACE;IACE,iCAAA;EhLkrlBF;AACF;AgL/qlBA;EACE,6DAAA;AhLirlBF;;AgL9qlBA;EACE;IACE,iCAAA;EhLirlBF;AACF;AgL9qlBA;EACE,gCAAA;AhLgrlBF;;AgL7qlBA;EACE;IACE,oCAAA;EhLgrlBF;AACF;AgL7qlBA;EACE,kEAAA;AhL+qlBF;;AgL5qlBA;EACE;IACE,oCAAA;EhL+qlBF;AACF;AgL5qlBA;EACE,qCAAA;AhL8qlBF;;AgL3qlBA,oBAAA;AAEA;EACE;IACE,oCAAA;EhL6qlBF;AACF;AgL1qlBA;EACE,kEAAA;AhL4qlBF;;AgLzqlBA;EACE;IACE,oCAAA;EhL4qlBF;AACF;AgLzqlBA;EACE,qCAAA;AhL2qlBF;;AgLxqlBA,qBAAA;AAEA;EACE;IACE,mCAAA;EhL0qlBF;AACF;AgLvqlBA;EACE,mEAAA;AhLyqlBF;;AgLtqlBA;EACE;IACE,mCAAA;EhLyqlBF;AACF;AgLtqlBA;EACE,sCAAA;AhLwqlBF;;AgLrqlBA,kBAAA;AAEA;EACE;IACE,mCAAA;EhLuqlBF;AACF;AgLpqlBA;EACE,gEAAA;AhLsqlBF;;AgLnqlBA;EACE;IACE,mCAAA;EhLsqlBF;AACF;AgLnqlBA;EACE,mCAAA;AhLqqlBF;;AgLlqlBA,eAAA;AAEA;EACE;IACE,sDAAA;EhLoqlBF;EgLlqlBA;IACE,uDAAA;EhLoqlBF;EgLlqlBA;IACE,6BAAA;EhLoqlBF;AACF;AgLjqlBA;EACE,wCAAA;EACA,+CAAA;UAAA,uCAAA;AhLmqlBF;;AgLhqlBA;EACE;IACE,6BAAA;EhLmqlBF;EgLjqlBA;IACE,uDAAA;EhLmqlBF;EgLjqlBA;IACE,sDAAA;EhLmqlBF;AACF;AgLhqlBA;EACE,gCAAA;EACA,+CAAA;UAAA,uCAAA;AhLkqlBF;;AgL/plBA,iBAAA;AAEA;EACE;IACE,4DAAA;EhLiqlBF;AACF;AgL9plBA;EACE,kCAAA;EACA,wBAAA;AhLgqlBF;;AgL7plBA;EACE;IACE,2DAAA;EhLgqlBF;AACF;AgL7plBA;EACE,kCAAA;EACA,wBAAA;AhL+plBF;;AgL5plBA,eAAA;AAEA;EACE;IACE,2BAAA;EhL8plBF;AACF;AgL3plBA;EACE,6DAAA;AhL6plBF;;AgL1plBA;EACE;IACE,8BAAA;EhL6plBF;EgL3plBA;IACE,6BAAA;EhL6plBF;AACF;AgL1plBA;EACE,gCAAA;AhL4plBF;;AiL17lBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AjL67lBF;;AiL17lBA;EACE,aAAA;EACA,mBAAA;EAEA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;AjL67lBF;;AiL17lBA;EAEE,aAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EAEA,mBAAA;EAEA,uBAAA;EACA,qCAAA;AjL67lBF;;AiL17lBA;EACE,UAAA;EACA,WAAA;AjL67lBF;;AiL17lBA;EACE,kBAAA;EACA,qBAAA;EACA,sBAAA;AjL67lBF;;AiL17lBA;EACE,WAAA;EACA,oBAAA;EACA,yBAAA;EACA,sBAAA;AjL67lBF;;AiL17lBA;EACE,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,2BAAA;AjL67lBF;;AiL17lBA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,mBAAA;EACA,gBAAA;EACA,gEAAA;EACA,WAAA;EACA,UAAA;AjL67lBF;;AiL17lBA;EACE;IACE,QAAA;IACA,YAAA;EjL67lBF;EiL37lBA;IACE,QAAA;IACA,YAAA;EjL67lBF;EiL37lBA;IACE,WAAA;IACA,UAAA;EjL67lBF;AACF;AiL17lBA;EACE,qBAAA;AjL47lBF;;AkLlhmBA,WAAA;AAEA;EACE,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,2BAAA;EACA,yBAAA;EAIA,iBAAA;EAEA,mBAAA;EACA,wCAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AlLohmBF;;AkLhhmBE;EACE,gBAAA;AlLmhmBJ;AkLjhmBI;EACE,WAAA;AlLmhmBN;AkLhhmBI;EACE,YAAA;AlLkhmBN;;AkL5gmBE;EACE,gBAAA;EACA,cAAA;AlL+gmBJ;;AkL1gmBE;EACE,UAAA;EACA,mBjLEI;EiLDJ,sBAAA;AlL6gmBJ;AkL1gmBE;EACE,WAAA;AlL4gmBJ;AkLxgmBE;EACE,YAAA;AlL0gmBJ;AkLrgmBI;EACE,UAAA;AlLugmBN;;AkLlgmBA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;AlLqgmBF;AkLngmBE;EACE,aAAA;AlLqgmBJ;AkLlgmBE;EACE,eAAA;EACA,YAAA;AlLogmBJ;;AkLhgmBA;;EAME,+BAAA;AlLmgmBF;;AkLhgmBA;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AlLmgmBF;AkLjgmBE;EAEE,WAAA;EACA,cAAA;AlLkgmBJ;AkL//lBE;EACE,WAAA;AlLigmBJ;AkL9/lBE;EACE,kBAAA;AlLggmBJ;;AkL5/lBA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EAWA,aAAA;AlLq/lBF;AkL//lBE;EACE,YAAA;AlLigmBJ;AkL//lBE;EACE,cAAA;AlLigmBJ;AkL//lBE;EACE,aAAA;AlLigmBJ;AkL5/lBE;EACE,oBAAA;AlL8/lBJ;AkL3/lBE;EACE,cAAA;AlL6/lBJ;AkL1/lBE;EACE,kBAAA;AlL4/lBJ;AkLz/lBE;EACE,cAAA;EACA,YAAA;EACA,6BAAA;AlL2/lBJ;;AkLv/lBA;EACE,aAAA;AlL0/lBF;;AmLjomBA,WAAA;AAEA;;EAEE,kBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,clLFS;EkLGT,QAAA;EACA,6BAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,kUlLkFmB;EkLjFnB,oBAAA;EACA,+BAAA;E7KbE,mBAAA;E6KeF,gBlLlBM;EkLmBN,UAAA;EACA,gBAAA;AnLmomBF;AmLjomBE;;EACE,eAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;AnLoomBJ;AmLjomBE;;;EACE,aAAA;EACA,4C/K+U0B;E+K9U1B,clLFI;ADuomBR;AmLlomBE;;EACE,aAvCuB;AnL4qmB3B;;AmLjomBA;EACE,OAAA;AnLoomBF;AmLnomBE;EACE,gBAlDmB;AnLurmBvB;;AmLhomBA;EACE,QAAA;AnLmomBF;AmLlomBE;EACE,gBA3DmB;AnL+rmBvB;;AmLhomBA,SAAA;AAEA;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,WAAA;AnLkomBF;AmLjomBE;EACE,kBAAA;EACA,qBAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;EACA,oBAAA;AnLmomBJ;AmLjomBI;EACE,SAAA;EACA,uBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,mBlLjDE;EkLkDF,eAAA;EACA,kBAAA;E7K9EF,mBAAA;E6KgFE,kBAAA;AnLmomBN;AmLjomBM;EACE,WAAA;EACA,kBAAA;EACA,gBlLxFA;EkLyFA,SAAA;EACA,QAAA;EACA,qBAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;E7K3FJ,mBAAA;AN+tmBJ;AmL/nmBI;EACE,qBAAA;AnLiomBN;;AmL5nmBA;EACE,qBAAA;AnL+nmBF;;AmL3nmBE;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;AnL8nmBJ;AmL3nmBE;EACE,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;AnL6nmBJ;AmL3nmBI;EACE,kB/K6SwB;E+K5SxB,mBAAA;EACA,qB3G/I4B;AxE4wmBlC;AmL1nmBI;EACE,kBlL3DW;EkL4DX,YAAA;AnL4nmBN;;AmLpnmBE;EACE,kBAAA;EACA,YAAA;AnLunmBJ;AmLrnmBI;EACE,qCAAA;AnLunmBN;AmLnnmBE;;EAEE,uBAAA;EACA,WlL3JI;EkL4JJ,+BAAA;AnLqnmBJ;AmLnnmBI;;EACE,qCAAA;AnLsnmBN;AmLlnmBE;EACE,WAAA;AnLonmBJ;AmLjnmBE;EACE,UAAA;AnLmnmBJ;AmLhnmBE;EACE,WlL5KI;AD8xmBR;;AoL9ymBA;EACE,kBAAA;ApLizmBF;;AoL9ymBA;EACE,qBAAA;EACA,UAAA;EACA,cAAA;EACA,cAAA;ApLizmBF;;AoL9ymBA;EACE,kBAAA;EACA,eAAA;ApLizmBF;;AoL9ymBA;EACE,kBAAA;EACA,aAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;ApLizmBF;;AoL9ymBA;EACE,aAAA;ApLizmBF;;AoL9ymBA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,uBAAA;ApLizmBF;;AoL9ymBA;EACE,kBAAA;EACA,QAAA;EACA,OAAA;EACA,WAAA;EACA,QAAA;EACA,kBAAA;EACA,2BAAA;EACA,cAAA;ApLizmBF;;AoL9ymBA;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;ApLgzmBF;;AoL5ymBE;EACE,wBAAA;ApL+ymBJ;;AqLz2mBA;EACE,kUpLyGmB;ADmwmBrB;AqL12mBE;EACE,oBAAA;EACA,YAAA;ArL42mBJ;AqL12mBI;EACE,ajL2OG;AJiomBT;AqLx2mBM;EACE,mBjLsOC;AJoomBT;AqLr2mBE;EACE,+BAAA;ArLu2mBJ;AqLr2mBI;EACE,UAAA;ArLu2mBN;AqLl2mBI;E/KLA,8BAAA;EACA,+BAAA;E+KME,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;ArLq2mBN;;AqL/1mBE;EACE,eAAA;EAAA,kBAAA;ArLk2mBJ;;AqL51mBI;EACE,wBAAA;ArL+1mBN;;AqLz1mBE;EACE,oCAAA;ArL41mBJ;;AqL71mBE;EACE,oCAAA;ArLg2mBJ;;AqLj2mBE;EACE,oCAAA;ArLo2mBJ;;AqLr2mBE;EACE,oCAAA;ArLw2mBJ;;AqLz2mBE;EACE,oCAAA;ArL42mBJ;;AqL72mBE;EACE,oCAAA;ArLg3mBJ;;AqLj3mBE;EACE,oCAAA;ArLo3mBJ;;AqLr3mBE;EACE,oCAAA;ArLw3mBJ;;AqLz3mBE;EACE,oCAAA;ArL43mBJ;;AqL73mBE;EACE,oCAAA;ArLg4mBJ;;AqLv3mBE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;ArL03mBJ;AqLx3mBI;EACE,aAAA;E/K9CF,8BAAA;EACA,+BAAA;E+K+CE,gBAAA;ArL23mBN;AqLz3mBM;EACE,iBAAA;ArL23mBR;AqLx3mBM;EACE,yBAAA;ArL03mBR;AqLr3mBE;EACE,gBAAA;ArLu3mBJ;AqLp3mBE;EACE,gBAAA;ArLs3mBJ;AqLn3mBE;EACE,gBAAA;ArLq3mBJ;;AqLj3mBA;EACE,SAAA;ArLo3mBF;AqLl3mBE;EACE,aAAA;ArLo3mBJ;AqLj3mBE;EACE,oCAAA;EACA,gBAAA;EACA,yBAAA;ArLm3mBJ;AqLj3mBI;EACE,aAAA;ArLm3mBN;AqL/2mBE;EACE,+BAAA;ArLi3mBJ;AqL72mBI;EACE,yBAAA;ArL+2mBN;AqL52mBI;EACE,yBAAA;ArL82mBN;;AqLr2mBI;EACE,gBpL1HE;EoL2HF,cpLnHK;EoLoHL,kUpL5Be;EoL6Bf,2EAAA;ArLw2mBN;AqLr2mBI;EACE,aAAA;ArLu2mBN;;AsLt/mBA;EACE,mBAAA;EACA,gBAAA;EACA,kBAAA;AtLy/mBF;AsLx/mBE;EACE,UAAA;AtL0/mBJ;;AuLjgnBA;EACE,cAAA;EACA,aAAA;EACA,SAAA;AvLognBF;;AuLjgnBA;EACE,iBAAA;EACA,oBAAA;EACA,0BAAA;EACA,eAAA;AvLognBF;;AuLjgnBA;EACE,mBAAA;AvLognBF;;AuLjgnBA;EACE,SAAA;EACA,UAAA;AvLognBF;;AwLnhnBA;EACE,sBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;EACE,SAAA;EACA,iBAAA;AxLshnBJ;;AwLnhnBA;;;EAGE,mBAAA;AxLshnBF;;AwLnhnBA;EACE,gBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;AxLshnBF;;AwLnhnBA;EACE,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AxLshnBF;;AwLnhnBA;EACE,cAAA;AxLshnBF;;AwLnhnBA;EACE,+BCtCmB;AzL4jnBrB;;AwLnhnBA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,SAAA;EACA,2BAAA;AxLshnBF;AwLnhnBI;EACE,cAAA;EACA,qBAAA;AxLqhnBN;;AwLhhnBA;EACE,kBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,UAAA;AxLmhnBF;;AwLhhnBA;EACE,yBvLoCuB;AD++mBzB;;A0LplnBA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;A1LulnBF;A0LrlnBE;EACE,WAAA;EACA,eAAA;EACA,kBAAA;A1LulnBJ;A0LplnBE;EACE,WzLJI;EyLKJ,qBAAA;EACA,SAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBzLqBI;EyLpBJ,yBAAA;EACA,sBAAA;EACA,sBtLyV0B;EsLxV1B,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,0BAAA;EACA,kBAAA;A1LslnBJ;A0LplnBI;EAEE,sBAAA;EACA,gDAAA;EACA,mEAnCc;EAoCd,+DAnCU;A1LwnnBhB;A0LnlnBM;EAEE,WzL5BA;EyL6BA,mEAAA;EACA,+DAAA;A1LolnBR;A0LhlnBI;EACE,WzLnCE;EyLoCF,mEAhDc;EAiDd,+DAhDU;A1LkonBhB;A0L/knBI;EACE,WzLzCE;EyL0CF,mEAtDc;EAuDd,+DAtDU;A1LuonBhB;;A0L5knBA;EACE,qBAAA;EACA,mBAAA;A1L+knBF;A0L7knBE;EACE,0BAAA;EACA,6BAAA;A1L+knBJ;A0L5knBE;EACE,yBAAA;EACA,4BAAA;A1L8knBJ;A0L3knBE;EACE,kBAAA;EACA,yBAAA;EACA,4BAAA;A1L6knBJ;A0L1knBE;EACE,kBAAA;EACA,0BAAA;EACA,6BAAA;A1L4knBJ;A0LzknBE;EACE,gBAAA;A1L2knBJ;A0LxknBE;EACE,iBAAA;A1L0knBJ;A0LvknBE;EACE,cAAA;EACA,kBAAA;A1LyknBJ;A0LtknBE;EAEE,iBAAA;A1LuknBJ;;A2L9qnBA;EACE,eAAA;EACA,iBvL+9BkC;EuL99BlC,yB1LyCM;E0LxCN,sBvL+W4B;EuL9W5B,W1LSM;ADwqnBR;A2L/qnBE;EACE,mEAAA;A3LirnBJ;;A2L7qnBA;EAEE,cAAA;A3L+qnBF;;A2L5qnBA;EACE,kDAAA;A3L+qnBF;;A2L5qnBA;EACE,yBAAA;EACA,4BAAA;A3L+qnBF;;A2L7qnBA;EACE,0BAAA;EACA,6BAAA;A3LgrnBF;;A2L5qnBA;EACE,yBAAA;EACA,0BAAA;A3L+qnBF;;A2L7qnBA;EACE,4BAAA;EACA,6BAAA;A3LgrnBF;;A4LptnBA;EACE,aAAA;EACA,mBAAA;A5LutnBF;;A4LptnBA;EACE,sBAAA;A5LutnBF;A4LhtnBA;EACE,oCHHwB;AzLqtnB1B;;A4L9snBA;EAEE,0CAAA;EACA,UHFa;EGGb,iBAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;A5LgtnBF;;A4L7snBA;EACE,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;UAAA,iBAAA;EAEA,YAAA;A5L+snBF;A4L7snBE;EACE,gCAAA;A5L+snBJ;A4L5snBE;EACE,8BAAA;A5L8snBJ;A4L3snBE;EACE,oBAAA;EACA,+BAAA;A5L6snBJ;;A4LzsnBA;EACE,aAAA;EACA,mBAAA;A5L4snBF;;A4LzsnBA;EACE,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EAEA,YAAA;A5L2snBF;A4LzsnBE;EACE,6BAAA;A5L2snBJ;;A4LvsnBA;EACE,kBAAA;EACA,iBAAA;EACA,SAAA;A5L0snBF;A4LxsnBE;EACE,iBAAA;A5L0snBJ;A4LtsnBI;EACE,cAAA;EACA,qBAAA;A5LwsnBN;;A4LnsnBA;EAEE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;A5LqsnBF;;A4LlsnBA;EACA,SAAA;A5LqsnBA;A4LpsnBE;EACE,8BAAA;A5LssnBJ;A4LnsnBE;EACE,oBAAA;EACA,+BAAA;A5LqsnBJ;;A4LjsnBA;EACI,mB3LjGO;ADqynBX;;A4LjsnBA;EACE,kBAAA;EACA,UAAA;EACA,yBAAA;EACA,sBAAA;EACA,0CAAA;EACA,aAAA;A5LosnBF;A4LlsnBE;EACE,eAAA;A5LosnBJ;;A4LhsnBA;EACE,gCAAA;EACA,6BAAA;EACA,iBAAA;A5LmsnBF;;A6Lv0nBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;A7L00nBF;A6Lx0nBE;EACE,WAAA;EACA,yBAAA;A7L00nBJ;A6Lx0nBI;EACE,iBAAA;EACA,mBAAA;A7L00nBN;A6Lt0nBI;EACE,kBAAA;EACA,mBAAA;EACA,yBAAA;A7Lw0nBN;A6Lr0nBI;EACE,8BAAA;A7Lu0nBN;A6Ln0nBM;EACE,oBAAA;EACA,+BAAA;A7Lq0nBR;A6Lj0nBI;EACE,6BAAA;A7Lm0nBN;A6Lh0nBI;EACE,gBAAA;EACA,gBAAA;EACA,gCAAA;A7Lk0nBN;A6Lh0nBM;EACE,iBAAA;A7Lk0nBR;;A6L5znBA;EACE,yBAAA;A7L+znBF;A6L7znBE;EACE,aAAA;A7L+znBJ;A6L7znBE;EACE,aAAA;A7L+znBJ;;A6L3znBA;;EAEE,mBAAA;A7L8znBF;;A6LzznBA;EACE,WAAA;A7L4znBF;;A8L93nBA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;A9Li4nBF;A8L/3nBE;EACE,SAAA;A9Li4nBJ;;A8L53nBA;EACE,gCAAA;EACA,gBAAA;EACA,aAAA;EACA,wBAAA;A9L+3nBF;;A8L53nBA;;EAEE,UAAA;A9L+3nBF;;A8L53nBA;EACE,cAAA;A9L+3nBF;;A8L53nBA;EACE,kBAAA;A9L+3nBF;A8L73nBE;EACE,mEAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;A9L+3nBJ;A8L53nBE;EACE,UAAA;EACA,kBAAA;EACA,WAAA;A9L83nBJ;A8L33nBE;EACE,WAAA;EACA,SAAA;EACA,qBAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;A9L63nBJ;A8L13nBE;EACE,2BAAA;A9L43nBJ;;A8Lx3nBA;EACE,SAAA;A9L23nBF;A8Lz3nBE;EACE,iBAAA;A9L23nBJ;;A8Lv3nBA;EACE,kBAAA;A9L03nBF;;A8Lv3nBA;EACE,kBAAA;EACA,UAAA;A9L03nBF;;A+Ln8nBA;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,oCNMwB;EMLxB,aNIqB;EMHrB,cAAA;EACA,YAAA;A/Ls8nBF;;A+Ln8nBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;A/Ls8nBF;A+Lp8nBE;EACE,mBAAA;A/Ls8nBJ;A+Ln8nBE;EACE,WAAA;EACA,kBAAA;A/Lq8nBJ;A+Ll8nBE;EACE,kBAAA;EACA,UAAA;A/Lo8nBJ;A+Lj8nBE;EACE,gBAAA;A/Lm8nBJ;;A+L97nBA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;A/Li8nBF;A+L/7nBE;EACE,+BAAA;A/Li8nBJ;A+L97nBE;EACE,qBAAA;EACA,8BAAA;A/Lg8nBJ;A+L77nBE;EACE,8BAAA;A/L+7nBJ;A+L57nBE;EACE,oBAAA;EACA,+BAAA;A/L87nBJ;A+L37nBE;EACE,gCAAA;A/L67nBJ;A+L17nBE;EACE,UAAA;A/L47nBJ;A+Lz7nBE;EACE,WAAA;A/L27nBJ;;A+Lv7nBA;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,WAAA;EACA,6BAAA;EACA,gBAAA;EACA,kBAAA;A/L07nBF;A+Lx7nBE;EACE,UAAA;A/L07nBJ;A+Lv7nBE;EACE,8BAAA;A/Ly7nBJ;A+Lt7nBE;EACE,oBAAA;EACA,+BAAA;A/Lw7nBJ;A+Lr7nBE;EACE,WAAA;EACA,yBAAA;UAAA,iBAAA;A/Lu7nBJ;;A+Ln7nBA;EACE,kBAAA;EACA,UAAA;EACA,OAAA;EACA,WAAA;EAEA,yB9LzDM;E8L0DN,oBAAA;A/Lq7nBF;A+Ln7nBE;EACE,cAAA;EAEA,kBAAA;EACA,UAAA;EACA,SAAA;EAEA,YAAA;EACA,yB9LpEI;E8LsEJ,kBAAA;EACA,UAAA;EACA,WAAA;A/Lk7nBJ;A+L/6nBE;EACE,OAAA;EACA,WAAA;A/Li7nBJ;;AgMljoBA;EACE,kCAAA;E1LgBE,mBAAA;ANsioBJ;AgMnjoBE;EAGE,oCAAA;AhMmjoBJ;AgMhjoBE;EACE,yB/LKO;AD6ioBX;AgM/ioBE;EACE,gCAAA;AhMijoBJ;;AiMlkoBA;;EAAA;AAGA;EACE,yBAAA;AjMqkoBF;;AiMlkoBA;EACE,4BAAA;AjMqkoBF;;AiMlkoBA;EACE,cAAA;AjMqkoBF;;AiMlkoBA;EACE,aAAA;AjMqkoBF;;AiMlkoBA;EACE,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AjMqkoBF;;AiMlkoBA;EACE,iBAAA;AjMqkoBF;;AiMlkoBA;EACE,kBAAA;EACA,MAAA;EACA,SAAA;AjMqkoBF;;AiMlkoBA;;;;+EAAA;AAKA;;EAEE,YAAA;EACA,kBAAA;EACA,qBAAA;AjMqkoBF;;AiMlkoBA;EACE,kBAAA;EACA,MAAA;AjMqkoBF;;AiMlkoBA;;;;EAIE,kBAAA;EACA,WAAA;EACA,uBAAA;AjMqkoBF;;AiMlkoBA;;;;;;EAAA;AAOA;EACE,WAAA;EACA,QAAA;EACA,QAAA;EACA,UAAA;AjMqkoBF;;AiMlkoBA;EACE,OAAA;EACA,WAAA;EAAA,cAAA;AjMqkoBF;;AiMlkoBA;;;EAGE,UAAA;EACA,SAAA;EACA,MAAA;EACA,YAAA;AjMqkoBF;;AiMlkoBA;;;EAGE,UAAA;EACA,UAAA;EAAA,aAAA;AjMqkoBF;;AiMlkoBA;EACE,WAAA;AjMqkoBF;;AiMlkoBA;EACE,SAAA;EACA,SAAA;EACA,WAAA;AjMqkoBF;;AiMlkoBA;+EAAA;AAEA;EACE,UAAA;AjMqkoBF;;AiMnkoBA;EACE,kBAAA;EACA,WAAA;EACA,yBhMrEM;EgMsEN,UAAA;EACA,iBAAA;EACA,SAAA;EACA,MAAA;EACA,YAAA;AjMskoBF;;AiMnkoBA;EACE,cAAA;EAAA,oBAAA;EACA,kBAAA;EACA,UAAA;EAAA,aAAA;EACA,UAAA;AjMskoBF;;AiMnkoBA;EACE;IACE,0BAAA;IACA,UAAA;EjMskoBF;EiMpkoBA;IACE,6BAAA;IACA,UAAA;EjMskoBF;EiMpkoBA;IACE,6BAAA;IACA,UAAA;EjMskoBF;EiMpkoBA;IACE,8BAAA;IACA,UAAA;EjMskoBF;AACF;AiMpkoBA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,iBAAA;EACA,SAAA;EACA,MAAA;EACA,kCAAA;EACA,mCAAA;EACA,2BAAA;EACA,8CAAA;AjMskoBF;;AiMnkoBA;EACE,cAAA;EAAA,oBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EAAA,aAAA;AjMskoBF;;AiMnkoBA;;;;;;EAAA;AAOA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,6BAAA;EACA,8BAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,QAAA;EACA,sBAAA;AjMskoBF;;AiMnkoBA;EACE,+BAAA;EACA,iBAAA;EACA,OAAA;EACA,WAAA;EAAA,cAAA;AjMskoBF;;AiMnkoBA;;;;;;EAAA;AAOA;EACE,UAAA;AjMskoBF;;AiMpkoBA;EACE,WAAA;EACA,kBAAA;EACA,gCAAA;EACA,8BAAA;EACA,sBAAA;EACA,wBAAA;EACA,MAAA;EACA,WAAA;EACA,sBAAA;AjMukoBF;;AiMpkoBA;EACE,+BAAA;EACA,iBAAA;EACA,UAAA;EACA,WAAA;EAAA,cAAA;AjMukoBF;;AiMpkoBA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,iBAAA;EACA,kCAAA;EACA,qCAAA;EACA,+BAAA;AjMukoBF;;AiMpkoBA;EACE,OAAA;EACA,WAAA;EAAA,cAAA;EACA,gCAAA;EACA,iBAAA;AjMukoBF;;AiMpkoBA;EACE,yBAAA;EACA,YAAA;EACA,sBAAA;AjMukoBF;;AiMpkoBA;EACE,yBAAA;AjMukoBF;;AiMpkoBA;EACE,YAAA;EACA,mBAAA;EACA,aAAA;AjMukoBF;;AiMrkoBA;EACE,sBAAA;AjMwkoBF;;AiMrkoBA;;EAAA;AAGA;;EAEE,uBAAA;EACA,2BAAA;EACA,wBAAA;AjMwkoBF;;AiMtkoBA;;EAEE,qBAAA;AjMykoBF;;AiMvkoBA;;EAEE,2BAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;AjM0koBF;;AiMvkoBA;;EAAA;AAGA;EACE,yBAAA;AjM0koBF;;AiMvkoBA;;EAAA;AAGA;EACE,0BAAA;AjM0koBF;;AiMvkoBA;;EAAA;AAGA;EACE,0BAAA;AjM0koBF;;AiMvkoBA;;;;;EAKE,qBAAA;EACA,sBAAA;AjM0koBF;;AiMvkoBA;EACE,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;AjM0koBF;;AiMvkoBA;EACE,kBAAA;EACA,8BAAA;EACA,qBAAA;AjM0koBF;;AiMvkoBA;EACE,8BAAA;AjM0koBF;;AiMvkoBA;EACE,+BAAA;EACA,8BAAA;AjM0koBF;;AiMvkoBA;EACE,cAAA;EACA,mBAAA;AjM0koBF;;AiMxkoBA;EACE,kBAAA;EACA,sBAAA;AjM2koBF;;AiMxkoBA;EACE,cAAA;EACA,aAAA;AjM2koBF;;AiMxkoBA;;EAEE,YAAA;EACA,WAAA;EACA,6EAAA;EAGA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;AjMykoBF;;AiMtkoBA;EACE,eAAA;EACA,mBhMxWS;ADi7oBX;;AiMtkoBA;EACE;IAGE,UAAA;EjMukoBF;EiMrkoBA;IACE,UAAA;EjMukoBF;AACF;AiMpkoBA;EACE,UAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;AjMskoBF;;AiMnkoBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;AjMskoBF;;AiMnkoBA;EACE,QAAA;EACA,UAAA;EAAA,aAAA;AjMskoBF;;AiMnkoBA;EACE,WAAA;EACA,cAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,sBhMlZM;EgMmZN,kBAAA;EACA,oDAAA;AjMskoBF;;AiMpkoBA;EACE,uBAAA;AjMukoBF;;AiMrkoBA;EACE,yBAAA;AjMwkoBF;;AiMtkoBA;;EAEE,uBAAA;AjMykoBF;;AiMvkoBA;EACE,wBAAA;AjM0koBF;;AiMxkoBA;EACE,yBAAA;AjM2koBF;;AiMzkoBA;;EAEE,uBAAA;AjM4koBF;;AiM1koBA;EACE,wBAAA;AjM6koBF;;AiM3koBA;EACE,yBAAA;AjM8koBF;;AiM5koBA;;EAEE,uBAAA;AjM+koBF;;AiM7koBA;EACE,wBAAA;AjMgloBF;;AiM9koBA;EACE,yBAAA;AjMiloBF;;AiM/koBA;;EAEE,uBAAA;AjMkloBF;;AiMhloBA;EACE,yBAAA;AjMmloBF;;AiMjloBA;EACE,yBAAA;AjMoloBF;;AiMlloBA;;EAEE,uBAAA;AjMqloBF;;AiMnloBA;EACE,yBAAA;AjMsloBF;;AiMploBA;EACE,yBAAA;AjMuloBF;;AiMrloBA;;EAEE,uBAAA;AjMwloBF;;AiMtloBA;EACE,yBAAA;AjMyloBF;;AiMvloBA;EACE,yBAAA;AjM0loBF;;AiMxloBA;;EAEE,oBAAA;AjM2loBF;;AiMxloBA;EACE,iBAAA;AjM2loBF;;AiMxloBA;EACE,cAAA;EACA,cAAA;EACA,cAAA;AjM2loBF;;AiMxloBA;EACE,cAAA;EACA,cAAA;AjM2loBF;;AiMxloBA;;EAEE,wBAAA;UAAA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,0BAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,QAAA;EACA,gCAAA;EACA,eAAA;AjM2loBF;;AiMzloBA;;EAEE,+BAAA;AjM4loBF;;AiM1loBA;;EAEE,aAAA;EACA,+CAAA;AjM6loBF;;AiM3loBA;;EAEE,qBAAA;EACA,YAAA;EACA,WAAA;AjM8loBF;;AiM3loBA;EACE,0EAAA;AjM8loBF;;AiMzloBA;EACE,0EAAA;AjM4loBF;;AiMvloBA;;EAAA;AAGA;EACE,YAAA;EACA,qBAAA;EACA,kBAAA;AjM0loBF;;AiMxloBA;EACE,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,YAAA;AjM2loBF;;AiMxloBA;EACE,UAAA;EACA,UAAA;EAAA,aAAA;AjM2loBF;;AiMxloBA;EACE,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;AjM2loBF;;AiMzloBA;;EAEE,sBAAA;AjM4loBF;;AiM1loBA;EACE,0BAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;AjM6loBF;;AiM1loBA;;EAAA;AAGA;;EAEE,uBAAA;EACA,2BAAA;EACA,wBAAA;AjM6loBF;;AiM3loBA;;EAEE,qBAAA;AjM8loBF;;AiM5loBA;;EAEE,2BAAA;EACA,mBAAA;AjM+loBF;;AiM5loBA;;EAAA;AAGA;EACE,yBAAA;AjM+loBF;;AiM5loBA,6BAAA;AAQA,uBAAA;AAQA,wBAAA;AAQA;EACE,gBAAA;EACA,yBAAA;EAGA,aAAA;EAIA,mBAAA;EAGA,mBAAA;AjM0koBF;;AiMxkoBA;EAGE,aAAA;EAIA,mBAAA;EAGA,mBAAA;AjM2koBF;;AiMxkoBA;EACE,qBAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AjM2koBF;;AiMxkoBA;;EAEE,kBAAA;EACA,cAAA;AjM2koBF;;AiMzkoBA;EACE,uBAAA;EACA,mBAAA;AjM4koBF;;AiMzkoBA;;EAEE,iBAAA;AjM4koBF;;AiM1koBA;EACE,eAAA;AjM6koBF;;AiM1koBA;EAGE,aAAA;EAGA,mBAAA;AjM6koBF;;AiM3koBA;EAGE,cAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;AjM8koBF;;AiM3koBA,uBAAA;ACxsBA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,oCAAA;AlMuxpBF;AkMrxpBE;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,WAAA;EACA,yBAAA;EACA,cAAA;AlMuxpBJ;AkMpxpBE;;;;EAIE,cAAA;EACA,WAAA;EACA,cjMDO;EiMEP,sBjMTI;EiMUJ,4BAAA;EACA,yBAAA;EAEA,oC9LsrBoC;E8LrrBpC,uBAAA;E5LXA,qBAAA;E4LgBE,sB9LkVwB;E6J9V5B,mFAAA;AjK+xpBF;AkM3wpBI;;;;EACE,6BAAA;EACA,SAAA;AlMgxpBN;AkM1wpBI;;;;EACE,cjM9BK;EiM+BL,UAAA;AlM+wpBN;AkM5wpBI;;;;;;;EAEE,yBjMxCK;EiMyCL,UAAA;AlMmxpBN;AkM/wpBE;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;UAAA,iBAAA;AlMixpBJ;AkM/wpBI;EACE,+BAAA;EACA,gCAAA;AlMixpBN;AkM/wpBM;;EAEE,ejM6DgB;EiM5DhB,cjMtDG;ADu0pBX;AkM/wpBQ;;EACE,cjMzDC;AD20pBX;AkM/wpBQ;;EACE,UAAA;AlMkxpBV;AkM5wpBI;EACE,gCAAA;EACA,mBjM1EK;ADw1pBX;AkM5wpBM;EACE,+BAAA;AlM8wpBR;AkM3wpBM;EACE,4CAAA;AlM6wpBR;AkMzwpBI;EACE,kBAAA;AlM2wpBN;AkMxwpBI;;EAEE,gBjM2Be;EiM1Bf,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,+BAAA;EACA,gCAAA;EACA,mEAAA;EACA,qCAAA;EACA,cjMtEE;ADg1pBR;AkMxwpBM;;EACE,wDAAA;AlM2wpBR;AkMvwpBI;;EAEE,mCAAA;AlMywpBN;AkMtwpBI;;EAEE,oCAAA;AlMwwpBN;AkMrwpBI;;EAEE,eAAA;AlMuwpBN;AkMpwpBI;;EAEE,eAAA;AlMswpBN;AkMnwpBI;EACE,iBAAA;AlMqwpBN;AkMlwpBI;EACE,gBAAA;AlMowpBN;AkMjwpBI;EACE,gBAAA;EACA,uBAAA;AlMmwpBN;AkMhwpBI;EACE,2BAAA;AlMkwpBN;AkM/vpBI;;EAEE,UAAA;EACA,QAAA;EACA,yBAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,oBAAA;AlMiwpBN;AkM9vpBI;EACE,oCAAA;EACA,uBjM9JE;EiM+JF,iBAAA;EACA,gBAAA;AlMgwpBN;AkM7vpBI;EACE,oCAAA;EACA,0BAAA;EACA,kBAAA;EACA,iBAAA;AlM+vpBN;AkM3vpBE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;AlM6vpBJ;AkM3vpBI;EACE,gCAAA;AlM6vpBN;AkM1vpBI;EACE,gBAAA;AlM4vpBN;AkMzvpBI;EACE,+BAAA;EACA,mBAAA;EACA,qBAAA;EACA,aAAA;AlM2vpBN;AkMzvpBM;EACE,WAAA;EACA,6BAAA;EACA,2BAAA;E5L/LJ,qBAAA;AN27pBJ;AkMzvpBQ;EACE,gBAAA;EACA,iEjM7DiB;EiM8DjB,aAAA;AlM2vpBV;AkMtvpBI;EACE,eAAA;AlMwvpBN;AkMrvpBI;EACE,eAAA;EACA,mBAAA;AlMuvpBN;AkMnvpBE;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;AlMqvpBJ;AkMlvpBE;EACE,cAAA;EACA,oBAAA;AlMovpBJ;AkMjvpBE;;EAEE,SAAA;EACA,uBAAA;EACA,gBjMhHiB;EiMkHjB,qBAAA;EACA,uDAAA;AlMkvpBJ;AkMhvpBI;;EACE,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,oBAAA;EACA,qBAAA;AlMmvpBN;AkM/upBE;EACE,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AlMivpBJ;AkMhvpBI;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,+CAAA;EACA,qCAAA;EACA,sCAAA;EACA,wCAAA;EACA,4DAAA;EACA,eAAA;AlMkvpBN;AkMhvpBI;EACE,0CAAA;AlMkvpBN;AkM9upBE;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AlMgvpBJ;AkM7upBE;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,0CAAA;AlM+upBJ;AkM7upBI;EACE,+BAAA;AlM+upBN;AkM9upBM;EACE,eAAA;AlMgvpBR;AkM3upBE;EACE,+BAAA;AlM6upBJ;AkMzupBI;EACE,2CAAA;AlM2upBN;AkMxupBI;EACE,4CAAA;AlM0upBN;AkMtupBE;EACE,mBjMzNqB;ADi8pBzB;AkMrupBE;EACE,UAAA;EACA,aAAA;EACA,8BAAA;EACA,oBAAA;EACA,eAAA;EACA,YAAA;EACA,wCAAA;AlMuupBJ;AkMrupBI;EACE,wBAAA;UAAA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,sB9L8BwB;E8L7BxB,YAAA;EACA,cAAA;EACA,cjM5SE;EiM6SF,mBjM1UK;EiM2UL,yBAAA;EACA,eAAA;EACA,aAAA;EACA,iBAAA;AlMuupBN;AkMpupBI;EACE,YAAA;EACA,eAAA;AlMsupBN;AkMnupBI;EACE,mBjM1TE;EiM2TF,WjMzVE;AD8jqBR;AkMlupBI;;EAEE,SAAA;EACA,kBAAA;AlMoupBN;AkMjupBI;EACE,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,6BAAA;AlMmupBN;AkMhupBI;EACE,iBAAA;EACA,iBAAA;AlMkupBN;AkM/tpBI;EACE,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;AlMiupBN;AkM9tpBI;EACE,qBAAA;EACA,aAAA;AlMgupBN;AkM7tpBI;EACE,WAAA;EACA,kBAAA;AlM+tpBN;AkM5tpBI;EACE,gBAAA;AlM8tpBN;AkM1tpBE;EACE,cAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,oCAAA;EACA,yBAAA;EACA,UAAA;EACA,oBAAA;EACA,aAAA;EACA,yBAAA;AlM4tpBJ;AkMztpBE;EACE,cAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,oCAAA;EACA,yBAAA;EACA,WAAA;EACA,UAAA;EACA,oBAAA;AlM2tpBJ;AkMxtpBE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,OAAA;EACA,eAAA;EACA,cjM9YI;EiM+YJ,2BAAA;EACA,yDAAA;AlM0tpBJ;AkMvtpBE;EACE,UAAA;EACA,UAAA;EACA,mBAAA;AlMytpBJ;AkMttpBE;EACE,0BAAA;AlMwtpBJ;AkMrtpBE;;EAEE,2BAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;AlMutpBJ;;AkMltpBA;;EAEE,sBAAA;AlMqtpBF;;AkMjtpBE;EACE,oBAAA;EACA,YAAA;EACA,sBAAA;AlMotpBJ;;AkMhtpBA;;EAEE,+BAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EAAA,oBAAA;EACA,oBAAA;EACA,cAAA;EACA,qBAAA;AlMmtpBF;;AkM/spBE;;EAEE,cjMlcI;ADopqBR;;AkMnspBE;;EAEE,wBAAA;AlMsspBJ;;AkMhspBA;EACE,oCAAA;AlMmspBF;;AkMhspBA;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+BAAA;EACA,gCAAA;EACA,mEAAA;EACA,qCAAA;EACA,cAAA;AlMmspBF;;AkMhspBA;EACE,+BAAA;AlMmspBF;;AkMhspBA;EACE,yBAAA;AlMmspBF;;AkMjspBA;EACE,yBAAA;AlMospBF;;AkMjspBA;EACE,yBjMvbuB;AD2nqBzB;;AmMnuqBA;EACE,+BAAA;EACA,6CAAA;EACA,iTAAA;EAKA,mBAAA;EACA,kBAAA;AnMkuqBF;AmM/tqBA;;EAEE,+BAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EAAA,oBAAA;EACA,oBAAA;EACA,cAAA;EAEA,sCAAA;EACA,mCAAA;EACA,kCAAA;AnMguqBF;;AmM7tqBA;EACE,gBAAA;AnMguqBF;;AmM9tqBA;EACE,gBAAA;AnMiuqBF;;AmM/tqBA;EACE,gBAAA;AnMkuqBF;;AmMhuqBA;EACE,gBAAA;AnMmuqBF;;AmMjuqBA;EACE,gBAAA;AnMouqBF;;AmMluqBA;EACE,gBAAA;AnMquqBF;;AmMnuqBA;EACE,gBAAA;AnMsuqBF;;AmMpuqBA;EACE,gBAAA;AnMuuqBF;;AmMruqBA;EACE,gBAAA;AnMwuqBF;;AmMtuqBA;EACE,gBAAA;AnMyuqBF;;AmMvuqBA;EACE,gBAAA;AnM0uqBF;;AmMxuqBA;EACE,gBAAA;AnM2uqBF;;AmMzuqBA;EACE,gBAAA;AnM4uqBF;;AmM1uqBA;EACE,gBAAA;AnM6uqBF;;AmM3uqBA;EACE,gBAAA;AnM8uqBF;;AmM5uqBA;EACE,gBAAA;AnM+uqBF;;AmM7uqBA;EACE,gBAAA;AnMgvqBF;;AmM9uqBA;EACE,gBAAA;AnMivqBF;;AmM/uqBA;EACE,gBAAA;AnMkvqBF;;AmMhvqBA;EACE,gBAAA;AnMmvqBF;;AmMjvqBA;EACE,gBAAA;AnMovqBF;;AmMlvqBA;EACE,gBAAA;AnMqvqBF;;AmMnvqBA;EACE,gBAAA;AnMsvqBF;;AmMpvqBA;EACE,gBAAA;AnMuvqBF;;AmMrvqBA;EACE,gBAAA;AnMwvqBF;;AmMtvqBA;EACE,gBAAA;AnMyvqBF;;AmMvvqBA;EACE,gBAAA;AnM0vqBF;;AmMxvqBA;EACE,gBAAA;AnM2vqBF;;AmMzvqBA;EACE,gBAAA;AnM4vqBF;;AmM1vqBA;EACE,gBAAA;AnM6vqBF;;AmM3vqBA;EACE,gBAAA;AnM8vqBF;;AmM5vqBA;EACE,gBAAA;AnM+vqBF;;AmM7vqBA;EACE,gBAAA;AnMgwqBF;;AmM9vqBA;EACE,gBAAA;AnMiwqBF;;AmM/vqBA;EACE,gBAAA;AnMkwqBF;;AmMhwqBA;EACE,gBAAA;AnMmwqBF;;AmMjwqBA;EACE,gBAAA;AnMowqBF;;AmMlwqBA;EACE,gBAAA;AnMqwqBF;;AmMnwqBA;EACE,gBAAA;AnMswqBF;;AmMpwqBA;EACE,gBAAA;AnMuwqBF;;AmMrwqBA;EACE,gBAAA;AnMwwqBF;;AmMtwqBA;EACE,gBAAA;AnMywqBF;;AmMvwqBA;EACE,gBAAA;AnM0wqBF;;AmMxwqBA;EACE,gBAAA;AnM2wqBF;;AmMzwqBA;EACE,gBAAA;AnM4wqBF;;AmM1wqBA;EACE,gBAAA;AnM6wqBF;;AmM3wqBA;EACE,gBAAA;AnM8wqBF;;AmM5wqBA;EACE,gBAAA;AnM+wqBF;;AmM7wqBA;EACE,gBAAA;AnMgxqBF;;AmM9wqBA;EACE,gBAAA;AnMixqBF;;AmM/wqBA;EACE,gBAAA;AnMkxqBF;;AmMhxqBA;EACE,gBAAA;AnMmxqBF;;AmMjxqBA;EACE,gBAAA;AnMoxqBF;;AmMlxqBA;EACE,gBAAA;AnMqxqBF;;AmMnxqBA;EACE,gBAAA;AnMsxqBF;;AmMpxqBA;EACE,gBAAA;AnMuxqBF;;AmMrxqBA;EACE,gBAAA;AnMwxqBF;;AmMtxqBA;EACE,gBAAA;AnMyxqBF;;AmMvxqBA;EACE,gBAAA;AnM0xqBF;;AmMxxqBA;EACE,gBAAA;AnM2xqBF;;AmMzxqBA;EACE,gBAAA;AnM4xqBF;;AmM1xqBA;EACE,gBAAA;AnM6xqBF;;AmM3xqBA;EACE,gBAAA;AnM8xqBF;;AmM5xqBA;EACE,gBAAA;AnM+xqBF;;AmM7xqBA;EACE,gBAAA;AnMgyqBF;;AmM9xqBA;EACE,gBAAA;AnMiyqBF;;AmM/xqBA;EACE,gBAAA;AnMkyqBF;;AmMhyqBA;EACE,gBAAA;AnMmyqBF;;AmMjyqBA;EACE,gBAAA;AnMoyqBF;;AmMlyqBA;EACE,gBAAA;AnMqyqBF;;AmMnyqBA;EACE,gBAAA;AnMsyqBF;;AmMpyqBA;EACE,gBAAA;AnMuyqBF;;AmMryqBA;EACE,gBAAA;AnMwyqBF;;AmMtyqBA;EACE,gBAAA;AnMyyqBF;;AmMvyqBA;EACE,gBAAA;AnM0yqBF;;AmMxyqBA;EACE,gBAAA;AnM2yqBF;;AmMzyqBA;EACE,gBAAA;AnM4yqBF;;AmM1yqBA;EACE,gBAAA;AnM6yqBF;;AmM3yqBA;EACE,gBAAA;AnM8yqBF;;AmM5yqBA;EACE,gBAAA;AnM+yqBF;;AmM7yqBA;EACE,gBAAA;AnMgzqBF;;AmM9yqBA;EACE,gBAAA;AnMizqBF;;AmM/yqBA;EACE,gBAAA;AnMkzqBF;;AmMhzqBA;EACE,gBAAA;AnMmzqBF;;AmMjzqBA;EACE,gBAAA;AnMozqBF;;AmMlzqBA;EACE,gBAAA;AnMqzqBF;;AmMnzqBA;EACE,gBAAA;AnMszqBF;;AmMpzqBA;EACE,gBAAA;AnMuzqBF;;AmMrzqBA;EACE,gBAAA;AnMwzqBF;;AmMtzqBA;EACE,gBAAA;AnMyzqBF;;AmMvzqBA;EACE,gBAAA;AnM0zqBF;;AmMxzqBA;EACE,gBAAA;AnM2zqBF;;AmMzzqBA;EACE,gBAAA;AnM4zqBF;;AmM1zqBA;EACE,gBAAA;AnM6zqBF;;AmM3zqBA;EACE,gBAAA;AnM8zqBF;;AmM5zqBA;EACE,gBAAA;AnM+zqBF;;AmM7zqBA;EACE,gBAAA;AnMg0qBF;;AmM9zqBA;EACE,gBAAA;AnMi0qBF;;AmM/zqBA;EACE,gBAAA;AnMk0qBF;;AmMh0qBA;EACE,gBAAA;AnMm0qBF;;AmMj0qBA;EACE,gBAAA;AnMo0qBF;;AmMl0qBA;EACE,gBAAA;AnMq0qBF;;AmMn0qBA;EACE,gBAAA;AnMs0qBF;;AmMp0qBA;EACE,gBAAA;AnMu0qBF;;AmMr0qBA;EACE,gBAAA;AnMw0qBF;;AmMt0qBA;EACE,gBAAA;AnMy0qBF;;AmMv0qBA;EACE,gBAAA;AnM00qBF;;AmMx0qBA;EACE,gBAAA;AnM20qBF;;AmMz0qBA;EACE,gBAAA;AnM40qBF;;AmM10qBA;EACE,gBAAA;AnM60qBF;;AmM30qBA;EACE,gBAAA;AnM80qBF;;AmM50qBA;EACE,gBAAA;AnM+0qBF;;AmM70qBA;EACE,gBAAA;AnMg1qBF;;AmM90qBA;EACE,gBAAA;AnMi1qBF;;AmM/0qBA;EACE,gBAAA;AnMk1qBF;;AmMh1qBA;EACE,gBAAA;AnMm1qBF;;AmMj1qBA;EACE,gBAAA;AnMo1qBF;;AmMl1qBA;EACE,gBAAA;AnMq1qBF;;AmMn1qBA;EACE,gBAAA;AnMs1qBF;;AmMp1qBA;EACE,gBAAA;AnMu1qBF;;AmMr1qBA;EACE,gBAAA;AnMw1qBF;;AmMt1qBA;EACE,gBAAA;AnMy1qBF;;AmMv1qBA;EACE,gBAAA;AnM01qBF;;AmMx1qBA;EACE,gBAAA;AnM21qBF;;AmMz1qBA;EACE,gBAAA;AnM41qBF;;AmM11qBA;EACE,gBAAA;AnM61qBF;;AmM31qBA;EACE,gBAAA;AnM81qBF;;AmM51qBA;EACE,gBAAA;AnM+1qBF;;AmM71qBA;EACE,gBAAA;AnMg2qBF;;AmM91qBA;EACE,gBAAA;AnMi2qBF;;AmM/1qBA;EACE,gBAAA;AnMk2qBF;;AmMh2qBA;EACE,gBAAA;AnMm2qBF;;AmMj2qBA;EACE,gBAAA;AnMo2qBF;;AmMl2qBA;EACE,gBAAA;AnMq2qBF;;AmMn2qBA;EACE,gBAAA;AnMs2qBF;;AmMp2qBA;EACE,gBAAA;AnMu2qBF;;AmMr2qBA;EACE,gBAAA;AnMw2qBF;;AmMt2qBA;EACE,gBAAA;AnMy2qBF;;AmMv2qBA;EACE,gBAAA;AnM02qBF;;AmMx2qBA;EACE,gBAAA;AnM22qBF;;AmMz2qBA;EACE,gBAAA;AnM42qBF;;AmM12qBA;EACE,gBAAA;AnM62qBF;;AmM32qBA;EACE,gBAAA;AnM82qBF;;AmM52qBA;EACE,gBAAA;AnM+2qBF;;AmM72qBA;EACE,gBAAA;AnMg3qBF;;AmM92qBA;EACE,gBAAA;AnMi3qBF;;AmM/2qBA;EACE,gBAAA;AnMk3qBF;;AmMh3qBA;EACE,gBAAA;AnMm3qBF;;AmMj3qBA;EACE,gBAAA;AnMo3qBF;;AmMl3qBA;EACE,gBAAA;AnMq3qBF;;AmMn3qBA;EACE,gBAAA;AnMs3qBF;;AmMp3qBA;EACE,gBAAA;AnMu3qBF;;AmMr3qBA;EACE,gBAAA;AnMw3qBF;;AmMt3qBA;EACE,gBAAA;AnMy3qBF;;AmMv3qBA;EACE,gBAAA;AnM03qBF;;AmMx3qBA;EACE,gBAAA;AnM23qBF;;AmMz3qBA;EACE,gBAAA;AnM43qBF;;AmM13qBA;EACE,gBAAA;AnM63qBF;;AmM33qBA;EACE,gBAAA;AnM83qBF;;AmM53qBA;EACE,gBAAA;AnM+3qBF;;AmM73qBA;EACE,gBAAA;AnMg4qBF;;AmM93qBA;EACE,gBAAA;AnMi4qBF;;AmM/3qBA;EACE,gBAAA;AnMk4qBF;;AmMh4qBA;EACE,gBAAA;AnMm4qBF;;AmMj4qBA;EACE,gBAAA;AnMo4qBF;;AmMl4qBA;EACE,gBAAA;AnMq4qBF;;AmMn4qBA;EACE,gBAAA;AnMs4qBF;;AmMp4qBA;EACE,gBAAA;AnMu4qBF;;AmMr4qBA;EACE,gBAAA;AnMw4qBF;;AmMt4qBA;EACE,gBAAA;AnMy4qBF;;AoMp6rBA;;CAAA;ACAA;EACC,+BAAA;EACA,6CAAA;EACA,uPAAA;EAIA,mBAAA;EACA,kBAAA;ArMu6rBD;AsM/6rBA;EACC,qBAAA;EACA,+BAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EAAA,oBAAA;EACA,oBAAA;EACA,cAAA;EAEA,sCAAA;EACA,mCAAA;EACA,kCAAA;AtMg7rBD;;AuM37rBA;+BAAA;AAGA,qBAAA;AAEA;;;EAAA;AAKA,6DAAA;AACA;EACE,oBAAA;EACA,mBAAA;EACA,oBAAA;AvM27rBF;;AuMx7rBA;EACE,kBAAA;AvM27rBF;;AuMx7rBA;EACE,kBAAA;AvM27rBF;;AuMx7rBA;EACE,kBAAA;AvM27rBF;;AuMx7rBA;EACE,iBAAA;AvM27rBF;;AuMx7rBA;EACE,qBAAA;EACA,kBAAA;AvM27rBF;;AuMx7rBA;EACE,eAAA;EACA,2BAAA;EACA,qBAAA;AvM27rBF;AuMz7rBE;EACE,kBAAA;AvM27rBJ;;AuMv7rBA;EACE,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;AvM07rBF;AuMx7rBE;EACE,qBAAA;AvM07rBJ;;AuMt7rBA;EACE,4BAAA;EACA,4BAAA;EACA,oBAAA;AvMy7rBF;;AuMt7rBA;EACE,YAAA;AvMy7rBF;;AuMr7rBE;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;AvMw7rBJ;;AuMp7rBA;EACE,kCAAA;AvMu7rBF;;AuMp7rBA;EACE;IACE,uBAAA;EvMu7rBF;EuMr7rBA;IACE,yBAAA;EvMu7rBF;AACF;AuMp7rBA;EACE,gEAAA;EACA,wBAAA;AvMs7rBF;;AuMn7rBA;EACE,gEAAA;EACA,yBAAA;AvMs7rBF;;AuMn7rBA;EACE,gEAAA;EACA,yBAAA;AvMs7rBF;;AuMn7rBA;EACE,0EAAA;EACA,uBAAA;AvMs7rBF;;AuMn7rBA;EACE,0EAAA;EACA,uBAAA;AvMs7rBF;;AuMn7rBA;EACE,kBAAA;EACA,qBAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;AvMs7rBF;;AuMn7rBA;;EAEE,kBAAA;EACA,OAAA;EACA,WAAA;EACA,kBAAA;AvMs7rBF;;AuMn7rBA;EACE,oBAAA;AvMs7rBF;;AuMn7rBA;EACE,cAAA;AvMs7rBF;;AuMn7rBA;EACE,cAAA;AvMs7rBF;;AuMn7rBA,oCAAA;AACA;EACE,sBAAA;AvMs7rBF;;AuMn7rBA;EACE,4BAAA;AvMs7rBF;;AwM9ksBA;EACE,gBCGe;AzM8ksBjB;;AwM9ksBA;EACE,gBAAA;AxMilsBF;;AwM/ksBA;EACE,gBCFgB;AzMolsBlB;;AwMhlsBA;EACE,gBCJiB;AzMulsBnB;;AwMjlsBA;EACE,gBCNa;AzM0lsBf;;AwMllsBA;EACE,gBCRiB;AzM6lsBnB;;AwMnlsBA;EACE,gBCVmB;AzMgmsBrB;;AwMplsBA;EACE,gBCZoB;AzMmmsBtB;;AwMrlsBA;EACE,gBCdgB;AzMsmsBlB;;AwMtlsBA;EACE,gBChBa;AzMymsBf;;AwMvlsBA;EACE,gBClBgB;AzM4msBlB;;AwMxlsBA;EACE,gBCpBoB;AzM+msBtB;;AwMzlsBA;EACE,gBCtBc;AzMknsBhB;;AwM1lsBA;EACE,gBCxBmB;AzMqnsBrB;;AwM3lsBA;EACE,gBC1Bc;AzMwnsBhB;;AwM5lsBA;EACE,gBC5BoB;AzM2nsBtB;;AwM7lsBA;EACE,gBC9Bc;AzM8nsBhB;;AwM9lsBA;EACE,gBChCe;AzMiosBjB;;AwM/lsBA;EACE,gBClCgB;AzMoosBlB;;AwMhmsBA;EACE,gBCpCsB;AzMuosBxB;;AwMjmsBA;EACE,gBCtCkB;AzM0osBpB;;AwMlmsBA;EACE,gBCxCe;AzM6osBjB;;AwMnmsBA;EACE,gBC1Ce;AzMgpsBjB;;AwMpmsBA;EACE,gBC5CgB;AzMmpsBlB;;AwMrmsBA;EACE,gBC9CmB;AzMspsBrB;;AwMtmsBA;EACE,gBChDgB;AzMypsBlB;;AwMvmsBA;EACE,gBClDkB;AzM4psBpB;;AwMxmsBA;EACE,gBCpDgB;AzM+psBlB;;AwMzmsBA;EACE,gBCtDe;AzMkqsBjB;;AwM1msBA;EACE,gBCxDa;AzMqqsBf;;AwM3msBA;EACE,gBC1DgB;AzMwqsBlB;;AwM5msBA;EACE,gBC5Dc;AzM2qsBhB;;AwM7msBA;EACE,gBC9DsB;AzM8qsBxB;;AwM9msBA;EACE,gBChEc;AzMirsBhB;;AwM/msBA;EACE,gBClEe;AzMorsBjB;;AwMhnsBA;EACE,gBCpEmB;AzMursBrB;;AwMjnsBA;EACE,gBCtEwB;AzM0rsB1B;;AwMlnsBA;EACE,gBCxEa;AzM6rsBf;;AwMnnsBA;EACE,gBC1EsB;AzMgssBxB;;AwMpnsBA;EACE,gBC5EY;AzMmssBd;;AwMrnsBA;EACE,gBC9EkB;AzMsssBpB;;AwMtnsBA;EACE,gBChFoB;AzMyssBtB;;AwMvnsBA;EACE,gBClFyB;AzM4ssB3B;;AwMxnsBA;EACE,gBCpFe;AzM+ssBjB;;AwMznsBA;EACE,gBCtFqB;AzMktsBvB;;AwM1nsBA;EACE,gBCxFgB;AzMqtsBlB;;AwM3nsBA;EACE,gBC1F4B;AzMwtsB9B;;AwM5nsBA;EACE,gBC5Fe;AzM2tsBjB;;AwM7nsBA;EACE,gBC9FoB;AzM8tsBtB;;AwM9nsBA;EACE,gBChGqB;AzMiusBvB;;AwM/nsBA;EACE,gBClG2B;AzMousB7B;;AwMhosBA;EACE,gBCpGkB;AzMuusBpB;;AwMjosBA;EACE,gBCtGoB;AzM0usBtB;;AwMlosBA;EACE,gBCxGgB;AzM6usBlB;;AwMnosBA;EACE,gBC1G2B;AzMgvsB7B;;AwMposBA;EACE,gBC5GkB;AzMmvsBpB;;AwMrosBA;EACE,gBC9GgB;AzMsvsBlB;;AwMtosBA;EACE,gBChHc;AzMyvsBhB;;AwMvosBA;EACE,gBClHiB;AzM4vsBnB;;AwMxosBA;EACE,gBCpHiB;AzM+vsBnB;;AwMzosBA;EACE,gBCtHmB;AzMkwsBrB;;AwM1osBA;EACE,gBCxHe;AzMqwsBjB;;AwM3osBA;EACE,gBC1Hc;AzMwwsBhB;;AwM5osBA;EACE,gBC5HgB;AzM2wsBlB;;AwM7osBA;EACE,gBC9HgB;AzM8wsBlB;;AwM9osBA;EACE,gBChIkB;AzMixsBpB;;AwM/osBA;EACE,gBClIe;AzMoxsBjB;;AwMhpsBA;EACE,gBCpIe;AzMuxsBjB;;AwMjpsBA;EACE,gBCtIe;AzM0xsBjB;;AwMlpsBA;EACE,gBCxIgB;AzM6xsBlB;;AwMnpsBA;EACE,gBC1IgB;AzMgysBlB;;AwMppsBA;EACE,gBC5Ia;AzMmysBf;;AwMrpsBA;EACE,gBC9Ie;AzMsysBjB;;AwMtpsBA;EACE,gBChJmB;AzMyysBrB;;AwMvpsBA;EACE,gBClJc;AzM4ysBhB;;AwMxpsBA;EACE,gBCpJiB;AzM+ysBnB;;AwMzpsBA;EACE,gBCtJgB;AzMkzsBlB;;AwM1psBA;EACE,gBCxJiB;AzMqzsBnB;;AwM3psBA;EACE,gBC1JiB;AzMwzsBnB;;AwM5psBA;EACE,gBC5Je;AzM2zsBjB;;AwM7psBA;EACE,gBC9JgB;AzM8zsBlB;;AwM9psBA;EACE,gBChKgB;AzMi0sBlB;;AwM/psBA;EACE,gBClKc;AzMo0sBhB;;AwMhqsBA;EACE,gBCpKiB;AzMu0sBnB;;AwMjqsBA;EACE,gBCtKc;AzM00sBhB;;AwMlqsBA;EACE,gBCxKgB;AzM60sBlB;;AwMnqsBA;EACE,gBC1KgB;AzMg1sBlB;;AwMpqsBA;EACE,gBC5KiB;AzMm1sBnB;;AwMrqsBA;EACE,gBC9KkB;AzMs1sBpB;;AwMtqsBA;EACE,gBChLuB;AzMy1sBzB;;AwMvqsBA;EACE,gBClLmB;AzM41sBrB;;AwMxqsBA;EACE,gBCpLe;AzM+1sBjB;;AwMzqsBA;EACE,gBCtLe;AzMk2sBjB;;AwM1qsBA;EACE,gBCxLe;AzMq2sBjB;;AwM3qsBA;EACE,gBC1LiB;AzMw2sBnB;;AwM5qsBA;EACE,gBC5Lc;AzM22sBhB;;AwM7qsBA;EACE,gBC9Lc;AzM82sBhB;;AwM9qsBA;EACE,gBChMe;AzMi3sBjB;;AwM/qsBA;EACE,gBClMe;AzMo3sBjB;;AwMhrsBA;EACE,gBCpMmB;AzMu3sBrB;;AwMjrsBA;EACE,gBCtMe;AzM03sBjB;;AwMlrsBA;EACE,gBCxMc;AzM63sBhB;;AwMnrsBA;EACE,gBC1MoB;AzMg4sBtB;;AwMprsBA;EACE,gBC5Mc;AzMm4sBhB;;AwMrrsBA;EACE,gBC9Ma;AzMs4sBf;;AwMtrsBA;EACE,gBChNe;AzMy4sBjB;;AwMvrsBA;EACE,gBClNa;AzM44sBf;;AwMxrsBA;EACE,gBCpNuB;AzM+4sBzB;;AwMzrsBA;EACE,gBCtNa;AzMk5sBf;;AwM1rsBA;EACE,gBCxNe;AzMq5sBjB;;AwM3rsBA;EACE,gBC1Nc;AzMw5sBhB;;AwM5rsBA;EACE,gBC5Na;AzM25sBf;;AwM7rsBA;EACE,gBC9NqB;AzM85sBvB;;AwM9rsBA;EACE,gBChOqB;AzMi6sBvB;;AwM/rsBA;EACE,gBClOqB;AzMo6sBvB;;AwMhssBA;EACE,gBCpOe;AzMu6sBjB;;AwMjssBA;EACE,gBCtOsB;AzM06sBxB;;AwMlssBA;EACE,gBCxOkB;AzM66sBpB;;AwMnssBA;EACE,gBC1Oc;AzMg7sBhB;;AwMpssBA;EACE,gBC5Oc;AzMm7sBhB;;AwMrssBA;EACE,gBC9OoB;AzMs7sBtB;;AwMtssBA;EACE,gBChPmB;AzMy7sBrB;;AwMvssBA;EACE,gBClPe;AzM47sBjB;;AwMxssBA;EACE,gBCpPe;AzM+7sBjB;;AwMzssBA;EACE,gBCtPc;AzMk8sBhB;;AwM1ssBA;EACE,gBCxPc;AzMq8sBhB;;AwM3ssBA;EACE,gBC1PiB;AzMw8sBnB;;AwM5ssBA;EACE,gBC5Pe;AzM28sBjB;;AwM7ssBA;EACE,gBC9Pc;AzM88sBhB;;AwM9ssBA;EACE,gBChQa;AzMi9sBf;;AwM/ssBA;EACE,gBClQoB;AzMo9sBtB;;AwMhtsBA;EACE,gBCpQc;AzMu9sBhB;;AwMjtsBA;EACE,gBCtQmB;AzM09sBrB;;AwMltsBA;EACE,gBCxQwB;AzM69sB1B;;AwMntsBA;EACE,gBC1QgB;AzMg+sBlB;;AwMptsBA;EACE,gBC5Qc;AzMm+sBhB;;AwMrtsBA;EACE,gBC9Qc;AzMs+sBhB;;AwMttsBA;EACE,gBChRc;AzMy+sBhB;;AwMvtsBA;EACE,gBClRiB;AzM4+sBnB;;AwMxtsBA;EACE,gBCpRc;AzM++sBhB;;AwMztsBA;EACE,gBCtRc;AzMk/sBhB;;AwM1tsBA;EACE,gBCxRe;AzMq/sBjB;;AwM3tsBA;EACE,gBC1Rc;AzMw/sBhB;;AwM5tsBA;EACE,gBC5RgB;AzM2/sBlB;;AwM7tsBA;EACE,gBC9Rc;AzM8/sBhB;;AwM9tsBA;EACE,gBChSc;AzMigtBhB;;AwM/tsBA;EACE,gBClSc;AzMogtBhB;;AwMhusBA;EACE,gBCpSe;AzMugtBjB;;AwMjusBA;EACE,gBCtSe;AzM0gtBjB;;AwMlusBA;EACE,gBCxSgB;AzM6gtBlB;;AwMnusBA;EACE,gBC1SgB;AzMghtBlB;;AwMpusBA;EACE,gBC5SgB;AzMmhtBlB;;AwMrusBA;EACE,gBC9Se;AzMshtBjB;;AwMtusBA;EACE,gBChTgB;AzMyhtBlB;;AwMvusBA;EACE,gBClTe;AzM4htBjB;;AwMxusBA;EACE,gBCpTiB;AzM+htBnB;;AwMzusBA;EACE,gBCtTc;AzMkitBhB;;AwM1usBA;EACE,gBCxTgB;AzMqitBlB;;AwM3usBA;EACE,gBC1Tc;AzMwitBhB;;AwM5usBA;EACE,gBC5TgB;AzM2itBlB;;AwM7usBA;EACE,gBC9Tc;AzM8itBhB;;AwM9usBA;EACE,gBChUiB;AzMijtBnB;;AwM/usBA;EACE,gBClUiB;AzMojtBnB;;AwMhvsBA;EACE,gBCpUc;AzMujtBhB;;AwMjvsBA;EACE,gBCtUc;AzM0jtBhB;;AwMlvsBA;EACE,gBCxUgB;AzM6jtBlB;;AwMnvsBA;EACE,gBC1UkB;AzMgktBpB;;AwMpvsBA;EACE,gBC5UkB;AzMmktBpB;;AwMrvsBA;EACE,gBC9UkB;AzMsktBpB;;AwMtvsBA;EACE,gBChVkB;AzMyktBpB;;AwMvvsBA;EACE,gBClVc;AzM4ktBhB;;AwMxvsBA;EACE,gBCpVa;AzM+ktBf;;AwMzvsBA;EACE,gBCtViB;AzMkltBnB;;AwM1vsBA;EACE,gBCxVc;AzMqltBhB;;AwM3vsBA;EACE,gBC1VgB;AzMwltBlB;;AwM5vsBA;EACE,gBC5VmB;AzM2ltBrB;;AwM7vsBA;EACE,gBC9VgB;AzM8ltBlB;;AwM9vsBA;EACE,gBChWiB;AzMimtBnB;;AwM/vsBA;EACE,gBClWiB;AzMomtBnB;;AwMhwsBA;EACE,gBCpWgB;AzMumtBlB;;AwMjwsBA;EACE,gBCtWe;AzM0mtBjB;;AwMlwsBA;EACE,gBCxWe;AzM6mtBjB;;AwMnwsBA;EACE,gBC1We;AzMgntBjB;;AwMpwsBA;EACE,gBC5Wc;AzMmntBhB;;AwMrwsBA;EACE,gBC9Wc;AzMsntBhB;;AwMtwsBA;EACE,gBChXgB;AzMyntBlB;;AwMvwsBA;EACE,gBClXc;AzM4ntBhB;;AwMxwsBA;EACE,gBCpXoB;AzM+ntBtB;;AwMzwsBA;EACE,gBCtXiB;AzMkotBnB;;AwM1wsBA;EACE,gBCxXc;AzMqotBhB;;AwM3wsBA;EACE,gBC1Xc;AzMwotBhB;;AwM5wsBA;EACE,gBC5XmB;AzM2otBrB;;AwM7wsBA;EACE,gBC9XiB;AzM8otBnB;;AwM9wsBA;EACE,gBChYc;AzMiptBhB;;AwM/wsBA;EACE,gBClYiB;AzMoptBnB;;AwMhxsBA;EACE,gBCpYc;AzMuptBhB;;AwMjxsBA;EACE,gBCtYc;AzM0ptBhB;;AwMlxsBA;EACE,gBCxYmB;AzM6ptBrB;;AwMnxsBA;EACE,gBC1YgB;AzMgqtBlB;;AwMpxsBA;EACE,gBC5YgB;AzMmqtBlB;;AwMrxsBA;EACE,gBC9Ye;AzMsqtBjB;;AwMtxsBA;EACE,gBChZiB;AzMyqtBnB;;A0Mt3tBA;;;EACE,iBAAA;EACA,kBAAA;A1M23tBF;A0Mz3tBE;;;;;EAEE,uBAAA;EACA,kBAAA;EACA,6BAAA;EAEA,SAAA;EACA,UAAA;A1M63tBJ;A0M13tBE;;;EACE,WAAA;EACA,WAAA;EACA,iBCEwB;EDAxB,UAAA;EACA,4BzMDO;AD83tBX;;A0Mz3tBA;EAGE,MAAA;EACA,gBAAA;A1M03tBF;A0Mx3tBE;EAEE,gBAAA;EACA,yBzMjBI;AD04tBR;A0Mt3tBE;EACE,SAAA;EACA,4BzMnBO;AD24tBX;;A0Mp3tBA;;;EAGE,SAAA;EACA,mBAAA;A1Mu3tBF;A0Mr3tBE;;;;;EAEE,mBAAA;EACA,sBAAA;A1M03tBJ;A0Mv3tBE;;;EACE,YAAA;EACA,yBzMrCO;ADg6tBX;;A4Mh7tBA;EACE,cAAA;EACA,WAAA;A5Mm7tBF;;A4Mh7tBA;EACE,sB3MOM;E2MNN,c3MaS;E2MZT,yBAAA;EACA,sBxMyW4B;EwMxW5B,qBAAA;EACA,kBAAA;EAEA,kU3MgGmB;ADk1tBrB;;A4M96tBE;EACE,UAAA;A5Mi7tBJ;A4M96tBE;EACE,cAAA;A5Mg7tBJ;A4M76tBE;EACE,qBAAA;A5M+6tBJ;A4M56tBE;EACE,qBAAA;A5M86tBJ;;A4M16tBA;EACE,kBAAA;EACA,UAAA;A5M66tBF;;A4M16tBA;EACE,YAAA;A5M66tBF;A4M36tBE;EACE,eAAA;A5M66tBJ;A4Mt6tBE;EACE,kBAAA;A5Mw6tBJ;A4Mj6tBE;EACE,gBD3CwB;A3M88tB5B;A4Mj6tBI;EACE,UAAA;EACA,WAAA;A5Mm6tBN;A4M/5tBE;EACE,iBDpDwB;A3Mq9tB5B;A4M/5tBI;EACE,UAAA;EACA,WAAA;A5Mi6tBN;;A4M55tBA;EACE,kBAAA;EACA,sB3MlEM;E2MmEN,gCAAA;EACA,+BxMiS4B;EwMhS5B,gCxMgS4B;EwM/R5B,iBAAA;EACA,kBAAA;A5M+5tBF;A4M75tBE;EACE,mBAAA;EACA,iBAAA;EACA,kBAAA;A5M+5tBJ;;A4M35tBA;;;;;;EAME,qBAAA;EACA,aAAA;A5M85tBF;;A4M35tBA;;EAEE,aAAA;EACA,c3MrFS;E2MsFT,iBAAA;EACA,mBAAA;A5M85tBF;;A4M35tBA;EACE,uBAAA;EACA,mBAAA;EACA,gBAAA;A5M85tBF;;A4M35tBA;EACE,gBAAA;EACA,iBD1GsB;EC2GtB,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,iCAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;A5M85tBF;A4M55tBE;EACE,UAAA;EACA,2B3MrHO;ADmhuBX;A4M55tBI;EACE,8DAAA;A5M85tBN;A4M35tBI;EAEE,+DDxIkC;ECyIlC,eAAA;A5M45tBN;A4Mx5tBE;EACE,WAAA;EACA,0B3MpIO;AD8huBX;A4Mz5tBI;EACE,WAAA;A5M25tBN;A4Mx5tBI;EACE,6DAAA;A5M05tBN;A4Mv5tBI;EAEE,8DD1JkC;EC2JlC,eAAA;A5Mw5tBN;A4Mp5tBE;EACE,kBAAA;EACA,MAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;A5Ms5tBJ;A4Mp5tBI;EACE,QAAA;EACA,yB3M7JK;ADmjuBX;A4Mp5tBM;EACE,4DAAA;A5Ms5tBR;A4Ml5tBI;EACE,SAAA;EACA,4B3MtKK;AD0juBX;A4Ml5tBM;EACE,+DAAA;A5Mo5tBR;;A4M94tBA;EACE,WAAA;A5Mi5tBF;;A4M94tBA;EACE,cDvLmB;ECwLnB,kBAAA;A5Mi5tBF;;A4M94tBA;EACE,YAAA;EACA,8BAAA;EACA,YAAA;A5Mi5tBF;A4M/4tBE;EACE,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,aAAA;EACA,MAAA;A5Mi5tBJ;A4M94tBE;EACE,kBAAA;EACA,iBAAA;A5Mg5tBJ;A4M94tBI;EACE,YAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;A5Mg5tBN;A4M/4tBM;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,8BAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;A5Mi5tBR;A4M/4tBQ;EACE,iBAAA;A5Mi5tBV;A4Mh5tBU;EACE,eAAA;EACA,yB3MpIa;ADshuBzB;A4Mh5tBU;EACE,wCD7OiB;EC8OjB,W3MpOJ;E2MqOI,iBAAA;A5Mk5tBZ;A4Mj5tBY;EACE,wCDjPe;A3MoouB7B;A4Mh5tBU;EACE,c3MvOD;ADynuBX;A4Mh5tBY;EACE,eAAA;EACA,6BAAA;A5Mk5tBd;;A4Mz4tBA;EACE,c3MrPS;E2MsPT,qBAAA;EACA,WD3PsB;EC4PtB,iBD5PsB;EC6PtB,kBAAA;EACA,gBDjQuB;A3M6ouBzB;A4M34tBE;EACE,eAAA;A5M64tBJ;A4M54tBI;EACE,sBxMmGwB;EwMlGxB,sB3MnQE;ADipuBR;;A4Mz4tBA;EACE,mB3MxQS;E2MyQT,6BAAA;EACA,gBAAA;A5M44tBF;;A4Mz4tBA;;EAEE,mBAAA;A5M44tBF;;A4Mz4tBA;;;EAGE,c3M/QS;E2MgRT,qBAAA;EACA,WDxRsB;ECyRtB,iBDzRsB;EC0RtB,kBAAA;EACA,gBD9RuB;A3M0quBzB;;A4Mz4tBA;EACE,eAAA;EtM5RE,sBAAA;ANyquBJ;A4M14tBE;EACE,yB3MrQI;E2MsQJ,W3MpSI;ADgruBR;A4Mz4tBE;EACE,iBAAA;A5M24tBJ;A4Mx4tBE;EACE,sBxMyD0B;EwMxD1B,yB3M/QI;E2MgRJ,W3M9SI;ADwruBR;A4Mx4tBI;EACE,mEAAA;A5M04tBN;A4Mv4tBI;EACE,c3MhRG;ADypuBT;A4Mt4tBI;EACE,c3MzRG;ADiquBT;A4Mp4tBE;EACE,yB3MxRI;E2MyRJ,W3M/TI;ADqsuBR;A4Mp4tBI;EACE,yB3M5RE;E2M6RF,W3MnUE;ADysuBR;A4Ml4tBE;EAEE,yB3M7OqB;E2M8OrB,4BxMspBgC;AJ6usBpC;A4Mj4tBI;EACE,yB3MjPmB;E2MkPnB,4BxMkpB8B;AJivsBpC;A4M93tBE;EACE,sBxMiB0B;EwMhB1B,kEAAA;EACA,W3MtVI;ADstuBR;A4M93tBI;EACE,oEAAA;A5Mg4tBN;A4M53tBE;EACE,yB3MlQqB;ADgouBzB;A4M13tBI;EACE,yB3M7TE;E2M8TF,W3MpWE;ADguuBR;A4Mx3tBE;EACE,eAAA;EACA,c3MtWO;ADguuBX;A4Mx3tBI;EACE,6BAAA;EACA,c3M1WK;ADouuBX;;A4Mp3tBA;;EAEE,oCAAA;EACA,sBAAA;A5Mu3tBF;;A4Mp3tBA;;;EAGE,6BAAA;EACA,sBxMzB4B;AJg5tB9B;A4Mr3tBE;;;EACE,eAAA;A5My3tBJ;A4Mv3tBI;;;;;;EAEE,4DAAA;A5M63tBN;A4Mz3tBE;;;EAEE,yB3MvYO;E2MwYP,YAAA;EACA,iBAAA;EACA,QAAA;EACA,kBAAA;EACA,qBD9Y0B;A3M0wuB9B;;A4Mx3tBA;;;EAGE,sB3MvZM;E2MwZN,kBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,sBxMzD4B;EwM0D5B,yBAAA;A5M23tBF;A4Mz3tBE;;;EACE,eAAA;A5M63tBJ;A4M13tBE;;;EACE,aAAA;EACA,kBAAA;A5M83tBJ;;A4M13tBA;;;EAGE,iBAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;A5M63tBF;A4M33tBE;;;EACE,+BxMhF0B;EwMiF1B,gCxMjF0B;AJg9tB9B;A4M53tBE;;;EACE,yBAAA;EAGA,iBAAA;EACA,kCxMzF0B;EwM0F1B,mCxM1F0B;AJ09tB9B;A4M73tBE;;;EACE,yB3M/bO;ADg0uBX;A4M/3tBI;;;EACE,+DAAA;A5Mm4tBN;A4Mh4tBI;;;EACE,4DAAA;A5Mo4tBN;A4Mh4tBE;;;EACE,kBAAA;EACA,UAAA;A5Mo4tBJ;;A4Mh4tBA;EACE,6BAAA;EACA,SAAA;EACA,eAAA;EACA,UAAA;EACA,UAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,QAAA;EACA,UAAA;A5Mm4tBF;A4Mj4tBE;EACE,wCD5eyB;EC6ezB,kBAAA;EACA,SAAA;EACA,sBAAA;EACA,W3MteI;E2MueJ,YAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;A5Mm4tBJ;;A4M/3tBA;EACE,gB3MtfM;E2MufN,6BAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;A5Mk4tBF;;A4M/3tBA;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,axMyXkC;EwMxXlC,oCAAA;EACA,OAAA;EACA,MAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;A5Mk4tBF;A4Mh4tBE;;;EAGE,WAAA;EACA,iBAAA;A5Mk4tBJ;A4M93tBE;EACE;;;IAGE,WAAA;IACA,iBAAA;E5Mg4tBJ;AACF;A4M73tBE;;EAEE,mBAAA;A5M+3tBJ;A4M53tBE;EACE,iCAAA;EACA,eAAA;A5M83tBJ;A4M33tBE;EACE,2B3MzgBI;ADs4uBR;A4M33tBI;EACE,qEAAA;A5M63tBN;A4M13tBI;EAEE,+DDtjBkC;ECujBlC,eAAA;A5M23tBN;A4Mv3tBE;EACE,0B3MvhBI;ADg5uBR;A4Mv3tBI;EACE,oEAAA;A5My3tBN;A4Mt3tBI;EAEE,8DDpkBkC;ECqkBlC,eAAA;A5Mu3tBN;;A4Ml3tBA;EACE,8BAAA;A5Mq3tBF;;A4Ml3tBA;EACE,wBAAA;EACA,yBAAA;A5Mq3tBF;;A6M98uBA;EACE,YAAA;A7Mi9uBF;;A6M98uBA;;EAEE,cAAA;A7Mi9uBF;;A6M98uBA;;EAEE,UAAA;EACA,wBAAA;EACA,yBAAA;EACA,+DAAA;EACA,4BAAA;A7Mi9uBF;;A6M98uBA;EACE,wBAAA;EACA,yBAAA;EACA,8DAAA;EACA,4BAAA;A7Mi9uBF;;A6M98uBA;;EAEE,+BAAA;EACA,6BAAA;A7Mi9uBF;;A6M98uBA;EACE,gCAAA;EACA,6BAAA;A7Mi9uBF;;A6M98uBA;EACE;IACE,UAAA;IACA,yBAAA;IACA,sBAAA;E7Mi9uBF;E6M/8uBA;IACE,UAAA;IACA,yBAAA;IACA,sBAAA;E7Mi9uBF;AACF;A6M98uBA;EACE;IACE,UAAA;IACA,yBAAA;IACA,sBAAA;E7Mg9uBF;E6M98uBA;IACE,UAAA;IACA,yBAAA;IACA,sBAAA;E7Mg9uBF;AACF;A6M78uBA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;A7M+8uBF;;A6M58uBA;EACE,aAAA;A7M+8uBF;;A6M58uBA;;;EAGE,oBAAA;A7M+8uBF;;A6M58uBA;;;EAGE,oBAAA;A7M+8uBF;;A6M58uBA;;;EAGE,oBAAA;A7M+8uBF;;A6M58uBA;;;EAGE,oBAAA;A7M+8uBF;;A6M58uBA;EACE,kBAAA;EACA,W5MtFM;E4MuFN,gBAAA;EACA,qBAAA;EACA,yB5MjFS;E4MkFT,kBAAA;EACA,uCAAA;EACA,gBAAA;EACA,iBAAA;A7M+8uBF;;A6M58uBA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;A7M+8uBF;;A6M58uBA;;;EAGE,WAAA;EACA,iBAAA;EACA,uBAAA;EACA,yB5MtGS;ADqjvBX;;A6M58uBA;EACE,SAAA;A7M+8uBF;;A6M58uBA;EACE,SAAA;A7M+8uBF;;A6M58uBA;EACE,UAAA;A7M+8uBF;;A6M58uBA;;;EAGE,SAAA;EACA,gBAAA;EACA,2BAAA;EACA,2B5M3HS;AD0kvBX;;A6M58uBA;EACE,QAAA;A7M+8uBF;;A6M58uBA;EACE,QAAA;EACA,aAAA;A7M+8uBF;;A6M58uBA;EACE,WAAA;A7M+8uBF;;A6M58uBA;;;EAGE,UAAA;EACA,gBAAA;EACA,2BAAA;EACA,0B5MjJS;ADgmvBX;;A6M58uBA;EACE,QAAA;A7M+8uBF;;A6M58uBA;EACE,QAAA;EACA,aAAA;A7M+8uBF;;A6M58uBA;EACE,WAAA;A7M+8uBF;;A6M58uBA;;;EAGE,QAAA;EACA,iBAAA;EACA,uBAAA;EACA,4B5MvKS;ADsnvBX;;A6M58uBA;EACE,SAAA;A7M+8uBF;;A6M58uBA;EACE,SAAA;A7M+8uBF;;A6M58uBA;EACE,UAAA;A7M+8uBF;;A8MxpvBA;EACE,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;ExMaE,sBAAA;EwMVF,kBAAA;EACA,sBAAA;EACA,6CAAA;A9M2pvBF;;A8MxpvBA;EACE,kBAAA;EACA,WAAA;EACA,yB7MCS;E6MAT,WAAA;ExMCE,sBAAA;AN2pvBJ;;A8MxpvBA;EACE,kBAAA;EACA,OAAA;EACA,WAAA;ExMNE,sBAAA;EwMQF,yB7MmBM;ADwovBR;;A8MxpvBA;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EAEA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,sB7MzBM;E6M2BN,mBAAA;EACA,4BAAA;A9M2pvBF;A8MzpvBE;EACE,aAAA;A9M2pvBJ;A8MxpvBE;EAGE,+DAAA;EACA,sGAAA;A9MwpvBJ;A8MppvBE;EAEE,gBAAA;A9MspvBJ;;A8MlpvBA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,eAAA;A9MqpvBF;;A8MlpvBA;EACE,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,c7MxDS;AD6svBX;;A8MlpvBA;EACE,c7M1DS;AD+svBX;;A8MlpvBA;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,uBAAA;A9MqpvBF;;A8MlpvBA;EACE,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,sB7MnFM;E6MoFN,eAAA;EACA,kBAAA;EACA,sBAAA;A9MqpvBF;;A8MlpvBA;EACE,qB7M5DM;ADitvBR;;A8MlpvBA;EACE,yB7M5FS;ADivvBX;;A8MlpvBA;EACE,yB7M9FS;ADmvvBX;;A8MlpvBA;;EAEE,qB7MnGS;E6MoGT,gBAAA;EACA,sB7MzGM;E6M0GN,mBAAA;A9MqpvBF;;A8MlpvBA;;EAEE,8BAAA;A9MqpvBF;;A8MlpvBA;EACE,WAAA;EACA,YAAA;EACA,cAAA;A9MqpvBF;;A8MlpvBA;EACE,YAAA;EACA,UAAA;A9MqpvBF;;A8MlpvBA;EACE,SAAA;EACA,SAAA;EACA,UAAA;A9MqpvBF;;A8MlpvBA;EACE,iBAAA;EACA,mBAAA;EAEA,mBAAA;A9MqpvBF;;A8MlpvBA;EACE,MAAA;EACA,UAAA;EACA,YAAA;A9MqpvBF;;A8MlpvBA;EACE,YAAA;EACA,UAAA;A9MqpvBF;;A8MlpvBA;EACE,SAAA;EACA,mBAAA;A9MqpvBF;;A8MlpvBA;EACE,mBAAA;A9MqpvBF;;A8MlpvBA;EACE,mBAAA;A9MqpvBF;;A8MlpvBA;;EAEE,wBAAA;EACA,yBAAA;EACA,yBAAA;EACA,4BAAA;A9MqpvBF;;A8MlpvBA;EACE,wBAAA;EACA,yBAAA;EACA,yBAAA;EACA,4BAAA;A9MqpvBF;;A8MlpvBA;;EAEE,yCAAA;EACA,6BAAA;A9MqpvBF;;A8MlpvBA;EACE,0CAAA;EACA,6BAAA;A9MqpvBF;;A8MlpvBA;;EAEE,sBAAA;EACA,yDAAA;A9MqpvBF;;A8MlpvBA;EACE,iEAAA;A9MqpvBF;;A8MlpvBA;EACE;IACE,UAAA;IACA,0BAAA;IACA,sBAAA;E9MqpvBF;E8MnpvBA;IACE,0BAAA;IACA,sBAAA;E9MqpvBF;AACF;A8MlpvBA;EACE;IACE,0BAAA;IACA,sBAAA;E9MopvBF;E8MlpvBA;IACE,UAAA;IACA,0BAAA;IACA,sBAAA;E9MopvBF;AACF;A8MjpvBA;EACE,kBAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;EACA,6CAAA;A9MmpvBF;;A8MhpvBA;EACE,aAAA;A9MmpvBF;;A8MhpvBA;EACE,oBAAA;A9MmpvBF;;A8MhpvBA;EACE,cAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,W7MpPM;E6MqPN,kBAAA;EACA,qBAAA;EACA,yB7M9OS;EKNP,sBAAA;EwMsPF,kU7MzJmB;E6M0JnB,iBAAA;A9MmpvBF;;A8MhpvBA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;A9MmpvBF;;A8MhpvBA;EACE,WAAA;EACA,SAAA;EACA,iBAAA;EACA,uBAAA;EACA,yB7MjQS;ADo5vBX;;A8M5ovBI;EACE,yB7M7MS;AD41vBf;A8M5ovBI;EACE,qB7MjNS;E6MkNT,sB7MvRE;ADq6vBR;A8M5ovBM;EAGE,+DAAA;EACA,sGAAA;A9M4ovBR;A8MvovBI;EACE,qB7M9NS;ADu2vBf;;A8M3pvBI;EACE,yB7M7MS;AD22vBf;A8M3pvBI;EACE,qB7MjNS;E6MkNT,sB7MvRE;ADo7vBR;A8M3pvBM;EAGE,8DAAA;EACA,0GAAA;A9M2pvBR;A8MtpvBI;EACE,qB7M9NS;ADs3vBf;;A8M1qvBI;EACE,yB7M7MS;AD03vBf;A8M1qvBI;EACE,qB7MjNS;E6MkNT,sB7MvRE;ADm8vBR;A8M1qvBM;EAGE,6DAAA;EACA,wGAAA;A9M0qvBR;A8MrqvBI;EACE,qB7M9NS;ADq4vBf;;A8MzrvBI;EACE,yB7M7MS;ADy4vBf;A8MzrvBI;EACE,qB7MjNS;E6MkNT,sB7MvRE;ADk9vBR;A8MzrvBM;EAGE,0CAAA;EACA,wGAAA;A9MyrvBR;A8MprvBI;EACE,qB7M9NS;ADo5vBf;;A8MxsvBI;EACE,yB7M7MS;ADw5vBf;A8MxsvBI;EACE,qB7MjNS;E6MkNT,sB7MvRE;ADi+vBR;A8MxsvBM;EAGE,+DAAA;EACA,wGAAA;A9MwsvBR;A8MnsvBI;EACE,qB7M9NS;ADm6vBf;;A8MvtvBI;EACE,yB7M7MS;ADu6vBf;A8MvtvBI;EACE,qB7MjNS;E6MkNT,sB7MvRE;ADg/vBR;A8MvtvBM;EAGE,8DAAA;EACA,sGAAA;A9MutvBR;A8MltvBI;EACE,qB7M9NS;ADk7vBf;;A8MtuvBI;EACE,yB7M7MS;ADs7vBf;A8MtuvBI;EACE,qB7MjNS;E6MkNT,sB7MvRE;AD+/vBR;A8MtuvBM;EAGE,yCAAA;EACA,0GAAA;A9MsuvBR;A8MjuvBI;EACE,qB7M9NS;ADi8vBf;;A8MrvvBI;EACE,yB7M7MS;ADq8vBf;A8MrvvBI;EACE,qB7MjNS;E6MkNT,sB7MvRE;AD8gwBR;A8MrvvBM;EAGE,sDAAA;EACA,oGAAA;A9MqvvBR;A8MhvvBI;EACE,qB7M9NS;ADg9vBf;;A8MpwvBI;EACE,yB7M7MS;ADo9vBf;A8MpwvBI;EACE,qB7MjNS;E6MkNT,sB7MvRE;AD6hwBR;A8MpwvBM;EAGE,8DAAA;EACA,oGAAA;A9MowvBR;A8M/vvBI;EACE,qB7M9NS;AD+9vBf;;A8MnxvBI;EACE,yB7M7MS;ADm+vBf;A8MnxvBI;EACE,qB7MjNS;E6MkNT,sB7MvRE;AD4iwBR;A8MnxvBM;EAGE,6DAAA;EACA,wGAAA;A9MmxvBR;A8M9wvBI;EACE,qB7M9NS;AD8+vBf;;A8MxwvBE;ExMxSE,gBAAA;EwM0SA,uBAAA;EACA,iBAAA;EACA,WAAA;EACA,6BAAA;EACA,wCAAA;A9M2wvBJ;;A8MtwvBE;ExMnTE,kBAAA;EwMqTA,iBAAA;A9MywvBJ;A8MvwvBI;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,iBAAA;A9MywvBN;;A8MjwvBE;EACE,YAAA;EACA,gBAAA;A9MowvBJ;A8MjwvBE;EACE,WAAA;A9MmwvBJ;A8MhwvBE;EACE,WAAA;A9MkwvBJ;A8M/vvBE;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;A9MiwvBJ;A8M7vvBI;EACE,iBAAA;EACA,WAAA;A9M+vvBN;A8MzvvBM;EACE,YAAA;EACA,UAAA;EACA,iBAAA;A9M2vvBR;;A8MnvvBE;EACE,YAAA;EACA,gBAAA;A9MsvvBJ;A8MnvvBE;EACE,WAAA;A9MqvvBJ;A8MlvvBE;EACE,WAAA;A9MovvBJ;A8MjvvBE;EACE,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;A9MmvvBJ;A8M/uvBI;EACE,iBAAA;EACA,WAAA;A9MivvBN;A8M3uvBM;EACE,WAAA;EACA,qBAAA;EACA,SAAA;EACA,UAAA;EACA,mB7MjZG;AD8nwBX;;A+MnpwBA;EACE,yBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;A/MspwBF;;A+MppwBA;EACE,+BAAA;A/MupwBF;;A+MrpwBA;EACE,qCAAA;A/MwpwBF;;A+MtpwBA;EACE,qCAAA;A/MypwBF;;A+MvpwBA;EACE,YAAA;EACA,eAAA;A/M0pwBF;;A+MxpwBA;EACE,YAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,0BAAA;EACA,iBAAA;A/M2pwBF;;A+MzpwBA;EACE,aAAA;A/M4pwBF;;A+M1pwBA;EACE,+BAAA;EACA,yBAAA;A/M6pwBF;;A+M3pwBA;EACE,qCAAA;A/M8pwBF;;A+M5pwBA;EACE,WAAA;EACA,UAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,2BAAA;EACA,kCAAA;EACA,mCAAA;A/M+pwBF;;A+M7pwBA;EACE,WAAA;EACA,UAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,8BAAA;EACA,kCAAA;EACA,mCAAA;A/MgqwBF;;A+M9pwBA;EACE,aAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;A/MiqwBF;;A+M/pwBA;EACE,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;A/MkqwBF;;A+MhqwBA;EACE,+BAAA;EACA,yBAAA;A/MmqwBF;;A+MjqwBA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;A/MoqwBF;;A+MlqwBA;EACE,mBAAA;A/MqqwBF;;A+MnqwBA;EACE,mBAAA;A/MsqwBF;;A+MpqwBA;EACE,YAAA;EACA,eAAA;A/MuqwBF;;A+MrqwBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;A/MwqwBF;;A+MtqwBA;EACE,WAAA;A/MyqwBF;;A+MvqwBA;EACE,YAAA;EACA,aAAA;EACA,uBAAA;A/M0qwBF;;A+MxqwBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;A/M2qwBF;;A+MzqwBA;EACE,YAAA;A/M4qwBF;;A+M1qwBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;A/M6qwBF;;A+M3qwBA;EACE,eAAA;A/M8qwBF;;A+M5qwBA;EACE,aAAA;EACA,uBAAA;A/M+qwBF;;A+M7qwBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;A/MgrwBF;;A+M9qwBA;EACE,YAAA;A/MirwBF;;A+M/qwBA;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;A/MkrwBF;;A+MhrwBA;EACE,YAAA;A/MmrwBF;;A+MjrwBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;A/MorwBF;;A+MlrwBA;EACE,WAAA;EACA,WAAA;A/MqrwBF;;A+MnrwBA;EACE,YAAA;EACA,aAAA;EACA,uBAAA;A/MsrwBF;;A+MprwBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;A/MurwBF;;A+MrrwBA;EACE,WAAA;EACA,WAAA;A/MwrwBF;;A+MtrwBA;EACE,YAAA;EACA,aAAA;EACA,uBAAA;A/MyrwBF;;A+MvrwBA;EACE,iBAAA;A/M0rwBF;;A+MxrwBA;EACE,2BAAA;A/M2rwBF;;A+MzrwBA;EACE,6BAAA;A/M4rwBF;;A+M1rwBA;EACE,8BAAA;A/M6rwBF;;A+M3rwBA;EACE,qBAAA;A/M8rwBF;;A+M5rwBA;EACE,qBAAA;A/M+rwBF;;A+M7rwBA;EACE,qBAAA;A/MgswBF;;A+M9rwBA;EACE,qBAAA;A/MiswBF;;A+M/rwBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;A/MkswBF;;A+MhswBA;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,+BAAA;A/MmswBF;;A+MjswBA;EACE,aAAA;EACA,mBAAA;A/MoswBF;;A+MlswBA;EACE,eAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;A/MqswBF;;A+MnswBA;EACE,gCAAA;A/MsswBF;;A+MpswBA;EACE,gBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;A/MuswBF;;A+MrswBA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;A/MwswBF;;A+MtswBA;EACE,WAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,qCAAA;A/MyswBF;;A+MvswBA;EACE,+BAAA;A/M0swBF;;A+MxswBA;EACE,iCAAA;A/M2swBF;;A+MzswBA;EACE,mCAAA;A/M4swBF;;A+M1swBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;A/M6swBF;;A+M3swBA;EACE,WAAA;A/M8swBF;;A+M5swBA;EACE,YAAA;EACA,aAAA;EACA,uBAAA;A/M+swBF;;A+M7swBA;EACE,gBAAA;A/MgtwBF;;A+M9swBA;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,+BAAA;A/MitwBF;;A+M/swBA;EACE,eAAA;A/MktwBF;;A+MhtwBA;EACE,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;A/MmtwBF;;A+MjtwBA;EACE,aAAA;A/MotwBF;;A+MltwBA;EACE,cAAA;A/MqtwBF;;A+MntwBA;EACE,mBAAA;A/MstwBF;;A+MptwBA;EACE,gBAAA;A/MutwBF;;A+MrtwBA;EACE,iBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;A/MwtwBF;;A+MttwBA;EACE,+BAAA;A/MytwBF;;A+MvtwBA;EACE,qCAAA;A/M0twBF;;A+MxtwBA;EACE,wBAAA;A/M2twBF;;A+MztwBA;EACE,mBAAA;A/M4twBF;;A+M1twBA;EACE,YAAA;EACA,aAAA;EACA,uBAAA;A/M6twBF;;A+M3twBA;EACE,WAAA;A/M8twBF;;A+M5twBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;A/M+twBF;;A+M7twBA;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,8BAAA;EACA,+BAAA;A/MguwBF;;A+M9twBA;EACE,eAAA;EACA,aAAA;A/MiuwBF;;A+M/twBA;EACE,UAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;A/MkuwBF;;A+MhuwBA;EACE,WAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;EACA,gCAAA;A/MmuwBF;;A+MjuwBA;EACE,aAAA;EACA,sBAAA;A/MouwBF;;A+MluwBA;EACE,UAAA;EACA,YAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;A/MquwBF;;A+MnuwBA;EACE,aAAA;EACA,mBAAA;A/MsuwBF;;A+MpuwBA;EACE,aAAA;A/MuuwBF;;A+MruwBA;EACE,aAAA;EACA,uBAAA;A/MwuwBF;;A+MtuwBA;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;A/MyuwBF;;A+MvuwBA;EACE,+BAAA;A/M0uwBF;;A+MxuwBA;EACE,qCAAA;A/M2uwBF;;A+MzuwBA;EACE,wBAAA;A/M4uwBF;;A+M1uwBA;EACE,mBAAA;A/M6uwBF;;A+M3uwBA;EACE,mBAAA;EACA,aAAA;EACA,aAAA;EACA,8BAAA;A/M8uwBF;;A+M5uwBA;EACE,UAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;A/M+uwBF;;A+M7uwBA;EACE,aAAA;A/MgvwBF;;A+M9uwBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;A/MivwBF;;A+M/uwBA;EACE,cAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,aAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,+BAAA;A/MkvwBF;;A+MhvwBA;EACE,aAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;A/MmvwBF;;A+MjvwBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;A/MovwBF;;A+MlvwBA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EAEA,mBAAA;EACA,qBAAA;EAEA,wDAAA;A/MovwBF;;A+MlvwBA;EAEE,uBAAA;A/MqvwBF;;A+MnvwBA;EAEE,uBAAA;A/MsvwBF;A+MhvwBA;EACE;IAEE,mBAAA;E/M2vwBF;E+M1vwBE;IAEA,mBAAA;E/M4vwBF;AACF;A+M1vwBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;A/M4vwBF;;A+M1vwBA;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,+BAAA;A/M6vwBF;;A+M3vwBA;EACE,eAAA;EACA,cAAA;EACA,aAAA;A/M8vwBF;;A+M5vwBA;EACE,UAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;A/M+vwBF;;A+M7vwBA;EACE,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;A/MgwwBF;;A+M9vwBA;EACE,mBAAA;EACA,gCAAA;A/MiwwBF;;A+M/vwBA;EACE,WAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,wBAAA;EACA,qBAAA;EACA,cAAA;EACA,cAAA;A/MkwwBF;;A+MhwwBA;EACE,2BAAA;A/MmwwBF;;A+MjwwBA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;A/MowwBF;;A+MlwwBA;EACE,eAAA;A/MqwwBF;;A+MnwwBA;EACE,eAAA;EACA,iBAAA;A/MswwBF;;A+MpwwBA;EACC,YAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;A/MuwwBD;;A+MrwwBA;EACE,aAAA;EACA,mBAAA;A/MwwwBF;;A+MtwwBA;EACE,UAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;A/MywwBF;;A+MvwwBA;EACE,mBAAA;A/M0wwBF;;A+MxwwBA;EACE,aAAA;A/M2wwBF;;A+MzwwBA;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;A/M4wwBF;;A+M1wwBA;EACE,+BAAA;A/M6wwBF;;A+M3wwBA;EACE,qCAAA;A/M8wwBF;;A+M5wwBA;EACE,wBAAA;A/M+wwBF;;A+M7wwBA;EACE,mBAAA;A/MgxwBF;;A+M9wwBA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;A/MixwBF;;A+M/wwBA;EACE,UAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;A/MkxwBF;;A+MhxwBA;EACE,aAAA;A/MmxwBF;;A+MjxwBA;EACE,eAAA;A/MoxwBF;;A+MlxwBA;EACE,mBAAA;EACA,aAAA;EACA,aAAA;EACA,8BAAA;A/MqxwBF;;A+MnxwBA;EACE,UAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;A/MsxwBF;;A+MpxwBA;EACE,aAAA;A/MuxwBF;;A+MrxwBA;EACE,UAAA;EACA,gBAAA;EACA,iBAAA;A/MwxwBF;;A+MtxwBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;A/MyxwBF;;A+MvxwBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;A/M0xwBF;;A+MxxwBA;EACE,YAAA;EACA,aAAA;EACA,uBAAA;A/M2xwBF;;A+MzxwBA;EACE,WAAA;A/M4xwBF;;A+M1xwBA;EACE,kBAAA;A/M6xwBF;;A+M3xwBA;EACE,kBAAA;EACA,SAAA;EACA,MAAA;EACA,eAAA;EACA,uBAAA;A/M8xwBF;;A+M5xwBA;EACE,qBAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;A/M+xwBF;;A+M7xwBA;EACE,kBAAA;A/MgywBF;;A+M9xwBA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,YAAA;A/MiywBF;;A+M/xwBA;EACE,gBAAA;EACA,gCAAA;A/MkywBF;;A+MhywBA;EACE,yBAAA;A/MmywBF;;A+MjywBA;EACE,qBAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;A/MoywBF;;A+MlywBA;EACE,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;A/MqywBF;;A+MnywBA;EACE,2BAAA;A/MsywBF;;A+MpywBA;EACE,YAAA;EACA,WAAA;EACA,eAAA;A/MuywBF;;A+MrywBA;EACE,kBAAA;A/MwywBF;;A+MtywBA;EACE,kBAAA;A/MyywBF;;A+MvywBA;EACE,aAAA;EACA,uBAAA;A/M0ywBF;;A+MxywBA;EACE,aAAA;A/M2ywBF;;A+MzywBA;EACE,aAAA;EACA,yBAAA;A/M4ywBF;;A+M1ywBA;EACE,QAAA;A/M6ywBF;;A+M3ywBA;EACE,YAAA;EACA,cAAA;EACA,sBAAA;A/M8ywBF;;A+M5ywBA;EACE,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,2BAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;A/M+ywBF;;A+M7ywBA;EACE,aAAA;A/MgzwBF;;A+M9ywBA;EACE,aAAA;A/MizwBF;;A+M/ywBA;EACE,uBAAA;A/MkzwBF;;A+MhzwBA;EACE,8BAAA;EACA,iBAAA;A/MmzwBF;;A+MjzwBA;EACE,mBAAA;EACA,kBAAA;EACA,iBAAA;A/MozwBF,E+MnzwBC;;;;;;;;;CAAA;AAUD;EAA2E,eAAA;EAAe,gBAAA;EAAA,mBAAA;A/MszwB1F;;A+MtzwB6G;EAAkD,8CAAA;A/M0zwB/J;;A+M1zwB6M;EAAkB,kBAAA;A/M8zwB/N;;A+M9zwBiP;EAA6B,wCAAA;EAAqC,oCAAA;EAAmC,kBAAA;EAAkB,UAAA;A/Mq0wBxW;;A+Mr0wBkX;EAA0B,kBAAA;A/My0wB5Y;;A+Mz0wB8Z;EAAuD,gBAAA;A/M60wBrd;;A+M70wBqe;EAA2D,OAAA;EAAO,gBAAA;A/Mk1wBviB;;A+Ml1wBujB;EAAyD,kBAAA;A/Ms1wBhnB;;A+Mt1wBkoB;EAA6D,cAAA;EAAc,kBAAA;EAAkB,WAAA;A/M41wB/tB;;A+M51wB0uB;EAAwD,iBAAA;A/Mg2wBlyB;;A+Mh2wBmzB;EAA4D,QAAA;EAAQ,iBAAA;A/Mq2wBv3B;;A+Mr2wBw4B;EAAoC,cAAA;EAAc,kBAAA;EAAkB,UAAA;A/M22wB58B;;A+M32wBs9B;EAAwC,cAAA;A/M+2wB9/B;;A+M/2wB4gC;EAA+B,aAAA;A/Mm3wB3iC;;A+Mn3wBwjC;EAAgC,kBAAA;EAAkB,qBAAA;A/Mw3wB1mC;;A+Mx3wB+nC;EAA8B,cAAA;EAAc,gBAAA;A/M63wB3qC;;A+M73wB2rC;EAA8B,cAAA;EAAc,iBAAA;A/Mk4wBvuC;;A+Ml4wBwvC;EAAkC,cAAA;A/Ms4wB1xC;;A+Mt4wBwyC;EAAkC,cAAA;A/M04wB10C;;A+M14wBw1C;EAA0D,cAAA;EAAc,UAAA;A/M+4wBh6C;;A+M/4wB06C;EAAkE,kBAAA;A/Mm5wB5+C;;A+Mn5wB8/C;EAAkE,mBAAA;A/Mu5wBhkD;;A+Mv5wBmlD;EAAkE,gBAAA;A/M25wBrpD;;A+M35wBqqD;EAAkE,iBAAA;A/M+5wBvuD;;A+M/5wBwvD;EAAkE,kBAAA;A/Mm6wB1zD;;A+Mn6wB40D;EAAkE,mBAAA;A/Mu6wB94D;;A+Mv6wBi6D;EAAkE,gBAAA;A/M26wBn+D;;A+M36wBm/D;EAAkE,iBAAA;A/M+6wBrjE;;A+M/6wBskE;EAAkE,kBAAA;A/Mm7wBxoE;;A+Mn7wB0pE;EAAkE,mBAAA;A/Mu7wB5tE;;A+Mv7wB+uE;EAA4C,uBAAA;EAAuB,kBAAA;A/M47wBlzE;;A+M57wBo0E;EAA4E,qBAAA;A/Mg8wBh5E;;A+Mh8wBq6E;EAA4E,uBAAA;A/Mo8wBj/E;;A+Mp8wBwgF;EAA0C,qBAAA;EAAqB,kBAAA;A/My8wBvkF;;A+Mz8wBylF;EAAkF,WAAA;EAAW,kBAAA;EAAkB,iBAAA;EAAiB,WAAA;A/Mg9wBztF;;A+Mh9wBouF;EAAkF,kBAAA;EAAkB,YAAA;EAAY,gBAAA;EAAgB,WAAA;A/Mu9wBp2F;;A+Mv9wB+2F;EAAiD,0BAAA;EAA0B,sBAAA;A/M49wB17F;;A+M59wBg9F;EAAiF,0BAAA;EAA0B,sBAAA;A/Mi+wB3jG;;A+Mj+wBilG;EAAiF,0BAAA;EAA0B,sBAAA;A/Ms+wB5rG;;A+Mt+wBktG;EAAiF,0BAAA;EAA0B,sBAAA;A/M2+wB7zG;;A+M3+wBm1G;EAAiF,0BAAA;EAA0B,sBAAA;A/Mg/wB97G;;A+Mh/wBo9G;EAAgE,kBAAA;A/Mo/wBphH;;A+Mp/wBsiH;EAAgE,kBAAA;A/Mw/wBtmH;;A+Mx/wBwnH;EAAgE,kBAAA;A/M4/wBxrH;;A+M5/wB0sH;EAAgE,kBAAA;A/MggxB1wH;;A+MhgxB4xH;EAAgE,kBAAA;A/MogxB51H;;A+MlgxBA;EACE,wBAAA;EACA,oCAAA;EACA,uBAAA;EACA,6BAAA;A/MqgxBF;;AgNz1yBA;EACE,mBAAA;EACA,eAAA;EACA,qBAAA;EACA,oBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;UAAA,iBAAA;AhN41yBF;;AgNz1yBA;EACE,YAAA;EACA,yBAAA;EACA,0BAAA;AhN41yBF;;AgN11yBA;;EAEE,0BAAA;AhN61yBF;;AgN31yBA;EACE,kBAAA;EACA,MAAA;EACA,YAAA;AhN81yBF;;AgN51yBA;EACE,+BAAA;AhN+1yBF;;AgN71yBA;EACE,WAAA;AhNg2yBF;;AgN71yBA;EACE,OAAA;AhNg2yBF;;AgNv1yBA;EACE,yBAAA;EANA,8BAOwB;EANxB,sFAAA;EACA,0BAAA;EAOA,kEAAA;EACA,eAAA;AhN21yBF;;AgNz1yBA;EACE,aAAA;AhN41yBF;;AgN11yBA;EACE,eAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,0BAAA;AhN61yBF;;AgN31yBA;EACE,yB/M5BM;E+M6BN,uCAAA;EACA,4BAAA;EACA,cAAA;AhN81yBF;;AgN51yBA;EACE,oCAAA;AhN+1yBF;;AgN71yBA;EACE,4BAAA;EACA,yB/MtCM;E+MuCN,cAAA;EACA,gBAAA;AhNg2yBF;;AgN91yBA;EACE,oCAAA;AhNi2yBF;;AgN91yBA;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,WAAA;EAEA,0BAAA;AhNi2yBF;;AgN/1yBA;EACE,iBAAA;AhNk2yBF;;AgNh2yBA;EACE,iBAAA;EACA,WAAA;AhNm2yBF;;AgNj2yBA;EACE,iBAAA;EACA,WAAA;AhNo2yBF;;AgN71yBI;EACE,YAAA;EACA,iBAAA;EACA,UAAA;AhNg2yBN;AgN91yBI;EACE,YAAA;EACA,WAAA;EACA,gBAAA;AhNg2yBN;AgN51yBM;EACE,iBAAA;AhN81yBR;AgNz1yBM;EACE,iBAAA;EACA,WAAA;AhN21yBR;AgNx1yBM;EACE,iBAAA;EACA,WAAA;AhN01yBR;;AiN1+yBA;EACE,WAAA;EACA,0BAAA;E3MeE,qBAAA;E2MbF,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,aAAA;EACA,oBAAA;AjN6+yBF;AiN3+yBE;EACE,qBhNgCI;AD68yBR;AiN1+yBE;EACE,WAAA;EACA,YAAA;EACA,wBAAA;EACA,aAAA;EACA,mBAAA;AjN4+yBJ;AiNz+yBE;EACE,aAAA;AjN2+yBJ;AiNx+yBE;EACE,aAAA;AjN0+yBJ;AiNv+yBE;EACE,WAAA;EACA,YAAA;AjNy+yBJ;AiNt+yBE;EACE,cAAA;EACA,chNlBO;AD0/yBX;AiNr+yBE;EACE,qBhNzBO;ADggzBX;AiNr+yBI;EACE,chN3BK;ADkgzBX;;AkNphzBA;EACE,aAAA;AlNuhzBF;AkNrhzBE;EACE,kBAAA;AlNuhzBJ;AkNrhzBI;EACE,gBAAA;EACA,uBAAA;AlNuhzBN;AkNrhzBM;EACE,aAAA;AlNuhzBR;AkNnhzBI;EACE,kBAAA;AlNqhzBN;AkNhhzBE;EACE,aAAA;AlNkhzBJ;AkN/gzBE;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;AlNihzBJ;AkN9gzBI;EACE,yBAAA;EACA,UAAA;AlNghzBN;AmN9gzBE;EACE,cDCuB;ECAvB,UAAA;AnNghzBJ;AmN5gzBE;EACE,cDLuB;AlNmhzB3B;AmN1gzBE;EACE,cDVuB;AlNshzB3B;AkNnhzBI;EACE,eAAA;EACA,gBAAA;AlNqhzBN;AkNlhzBI;EACE,YAAA;AlNohzBN;AkNjhzBI;EACE,qBAAA;AlNmhzBN;AkN7gzBQ;EACE,YAAA;AlN+gzBV;AkN1gzBQ;EACE,YAAA;AlN4gzBV;AkNtgzBE;EACE,UAAA;AlNwgzBJ;AkNtgzBI;EACE,eAAA;AlNwgzBN;AkNpgzBE;EACE,yBjN4BqB;EiN3BrB,SAAA;E5M9DA,sBAAA;E4MgEA,cjNrCI;EiNsCJ,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AlNsgzBJ;AkNpgzBI;EACE,yBjN1EK;EiN2EL,cjNvEK;EiNwEL,oBAAA;AlNsgzBN;AkNngzBI;EACE,eAAA;EACA,mBAAA;AlNqgzBN;AkNlgzBI;EACE,yBjNxDE;EiNyDF,WjNvFE;EiNwFF,aAAA;EACA,qBAAA;AlNogzBN;AkNjgzBI;EACE,SAAA;EACA,cjNvFK;EiNwFL,kBAAA;EACA,mBAAA;EACA,UAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,SAAA;AlNmgzBN;AkN//yBE;ECvHA,iDDwHqB;EACnB,yBAAA;EACA,kBAAA;EACA,+CAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;AlNmgzBJ;AkNjgzBI;EACE,YAAA;EACA,WAAA;AlNmgzBN;AkN//yBE;EClHA,aAAA;EDoHE,mBAAA;EACA,SAAA;EACA,uBAAA;EACA,oBAAA,EAAA,oCAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,WAAA;AlNqgzBJ;AkNngzBI;EACE,WAAA;AlNqgzBN;AkNlgzBI;EACE,gBAAA;EACA,oBAAA,EAAA,yCAAA;EACA,6BAAA;EACA,YAAA;AlNogzBN;AkNhgzBE;EACE,mBAAA;AlNkgzBJ;AkN//yBE;EACE,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,UAAA;AlNigzBJ;;AkN7/yBA,iBAAA;AACA;EC9IE,SD+Ic;AlNogzBhB;AkNlgzBE;ECzJA,aAAA;AnNkqzBF;AkNrgzBE;EAEE,UAAA;AlNsgzBJ;AkNngzBE;EAEE,UAAA;AlNogzBJ;AkNjgzBE;EACE,yBAAA;EACA,4BAAA;AlNmgzBJ;AkNhgzBE;EACE,0BAAA;EACA,6BAAA;AlNkgzBJ;;AkN9/yBA;EACE;IACE,wBAAA;ElNigzBF;AACF;AkNv/yBE;ECvLA,SDwLgB;EACd,YAAA;AlNkgzBJ;;AkN9/yBA;EACE,6BAAA;EACA,YAAA;AlNigzBF;;AoN9tzBA,kBAAA;AAKA;EACE;IACE,GAAA;EpN6tzBF;EoN3tzBA;IACE,GAAA;EpN6tzBF;AACF;AoN1tzBA;EACE;IACE,GAAA;EpN4tzBF;EoN1tzBA;IACE,GAAA;EpN4tzBF;AACF;AoNztzBA;ECiBE,UAAA;EACA,SAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,oBAAA;EAEA,0BAAA;EACA,UAAA;EDxBA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,4BEcuB;EFbvB,eAAA;ApNouzBF;;AoNluzBE;EACE,aAAA;ApNquzBJ;;AoNluzBE;EAKE,eAAA;ApNiuzBJ;;AoN9tzBE;EACE,oBAAA;ApNiuzBJ;;AoN3tzBA;;EAEE,cnN9BS;AD4vzBX;;AoNltzBE;EAEE,yBnNnDO;ADuwzBX;;AoNltzBE;EAEE,yBnNtDO;AD0wzBX;;AoNjtzBE;EAEE,yBnN5DO;AD+wzBX;;AoN7szBE;EAEE,8BAAA;ApN+szBJ;;AoN7szBI;EACE,+BAAA;EACA,iBAAA;ApNgtzBN;;AoN3szBA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,SAAA;ApN8szBF;;AoN3szBA;EACE,YAAA;EACA,cnNnFS;EmNqFT,cEpFiB;EFqFjB,oBEpFmB;EFqFnB,aAAA;EACA,kBAAA;ApN6szBF;;AoN3szBE;EAME,sBAAA;ApNyszBJ;;AoNrszBA;;;EAGE,mBAAA;ApNwszBF;;AoNrszBA;EACE,aAAA;EACA,gBAAA;EACA,yChN4kBsC;EgN3kBtC,sBnNvHM;EmNwHN,yBAAA;EACA,sBhN4O4B;EgN3O5B,aAAA;EACA,4BAAA;EAEA,WAAA;ApNuszBF;;AoNrszBE;EACE,0BAAA;ApNwszBJ;;AoNrszBE;EACE,cnN7HO;EmN8HP,sBnNrII;EmNsIJ,iEnNIuB;EmNHvB,6CE7GsB;EF8GtB,wCAAA;ApNwszBJ;;AoNtszBI;EAEI,mFAAA;ApNwszBR;;AoNlszBA;ECxHE,UAAA;EACA,SAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,oBAAA;EAEA,0BAAA;EACA,UAAA;EDkHA,kBAAA;ApN6szBF;;AqNzzzBE;EAIE,UAAA;ArNyzzBJ;;AoN/szBE;EACE,aAAA;ApNktzBJ;;AoN/szBE;EAGE,eAAA;ApNgtzBJ;;AoN1szBA;EACE,cnN/JS;EmNgKT,sBnNvKM;EmNwKN,gDhNuM4B;EgNtM5B,4BE5IuB;EF6IvB,cAAA;ApN6szBF;;AoN1szBE;EAIE,yBnN/KO;ADy3zBX;;AoNrszBA;;EAEE,cnNlLS;AD03zBX;;AoNtszBE;;EACE,WEnH+B;AtN6zzBnC;;AoNrszBA;ECtKE,UAAA;EACA,SAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,oBAAA;EAEA,0BAAA;EACA,UAAA;ArN+2zBF;;AqNz2zBE;EAIE,UAAA;ArNy2zBJ;;AoNltzBA;EACE,4CAAA;EACA,0BAAA;ApNqtzBF;;AoNltzBA;EACE,6CAAA;EACA,0BAAA;ApNqtzBF;;AoNltzBA;;EAEE,+CAAA;EACA,iCAAA;EACA,8BAAA;ApNqtzBF;;AuNx5zBE;EAEE,cDRe;ECSf,mBAAA;EACA,gBAAA;EACA,kBAjCQ;EAkCR,qBAlCQ;AvN47zBZ;;AuNx5zBI;EACE,aAAA;AvN25zBN;;AuNv5zBE;EACE,yBAAA;UAAA,iBAAA;EACA,ctNtBO;EsNuBP,eAAA;EACA,6BAAA;EACA,4BDLqB;AtN+5zBzB;;AuNx5zBI;EAEE,yBtNpCK;EsNqCL,qBtNrCK;AD+7zBX;;AuNt5zBI;EACE,yBA9CQ;EA+CR,qBA/CQ;EAgDR,WA9CW;AvNu8zBjB;;AuNt5zBI;EACE,mBAAA;EACA,6BAjDQ;EAkDR,yBAjDkB;EAkDlB,ctNlDK;AD28zBX;;AuNr5zBE;;;;EAGE,qBAAA;EACA,aAAA;AvNy5zBJ;;AuNt5zBE;EACE,kBAAA;EACA,ctN9DO;ADu9zBX;;AuNt5zBE;EAEE,iBA1DmB;EA2DnB,gBAAA;AvNw5zBJ;;AuNr5zBE;EAGE,cAAA;EACA,cDrEe;ECsEf,qBAAA;AvNs5zBJ;;AwNn/zBE;EACE,kBFyBmB;EExBnB,sBF0BQ;EEzBR,sBAAA;AxNs/zBJ;;AwNp/zBI;EACE,cvNcK;EuNbL,sBvNME;EuNLF,iEvN+IqB;EuN9IrB,mFAAA;EACA,wCAAA;AxNu/zBN;;AwNp/zBI;EAEE,oBAAA;AxNs/zBN;;AwNn/zBI;EACE,eAAA;AxNs/zBN;;AyN7/zBE;EACE,kBAAA;EACA,aANK;EAOL,SAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;AzNgg0BJ;;AyN9/zBI;EACE,SAAA;EACA,YAAA;AzNig0BN;;AyN9/zBI;EACE,aAjBW;AzNkh0BjB;;AyN7/zBE;EAGE,kBA7BgB;AzN2h0BpB;;AyN3/zBI;EACE,gBAAA;EACA,eAlCc;AzNgi0BpB;;AyN1/zBE;EACE,cAAA;EACA,iCAAA;EACA,eA9CY;EA+CZ,kBHpBmB;EGqBnB,4CA1CS;EA2CT,sBAAA;EACA,4BHPqB;EGQrB,gBHtBQ;AtNmh0BZ;;AyN3/zBI;EACE,iBArDO;AzNmj0Bb;;AyN3/zBI;EACE,aAAA;EACA,kBA3DU;EA4DV,4CArDU;AzNmj0BhB;;AyN1/zBE;EACE,0CAAA;AzN6/zBJ;;AyN1/zBE;EACE,gBAAA;AzN6/zBJ;;AyN3/zBI;EACE,wBAAA;EACA,UAAA;EACA,oCAAA;AzN8/zBN;;AyNz/zBI;EACE,mCAAA;AzN4/zBN;;AyNx/zBE;;EAEE,gBAAA;AzN2/zBJ;;AyNz/zBI;;EACE,UAAA;EACA,2BAAA;AzN6/zBN;;AyN1/zBI;;EACE,UAAA;EACA,0BAAA;AzN8/zBN;;AyN1/zBE;EACE,aAAA;AzN6/zBJ;;A0N/l0BE;EACE,WAAA;A1Nkm0BJ;;A0N/l0BE;ELkCA,UAAA;EACA,SAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,oBAAA;EAEA,0BAAA;EACA,UAAA;ArNik0BF;;AqN3j0BE;EAIE,UAAA;ArN2j0BJ;;A0Nzm0BE;EACE,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;A1N4m0BJ;;A0N1m0BI;EACE,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;A1N6m0BN;;A0N1m0BI;EACE,sBtN2iBwB;EsN1iBxB,eAAA;A1N6m0BN;;A2N5o0BE;EACE,6BAAA;EACA,UAAA;A3N+o0BJ;;A4N7m0BE;EPKA,UAAA;EACA,SAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,oBAAA;EAEA,0BAAA;EACA,UAAA;EOXE,qDAAA;EACA,kBAAA;EACA,eAAA;A5Nwn0BJ;;AqNzm0BE;EAIE,UAAA;ArNym0BJ;;A4N1n0BI;EAGE,eAAA;A5N2n0BN;;A4Nvn0BE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;A5N0n0BJ;;A4Nxn0BI;EACE,eAAA;A5N2n0BN;;A4Nvn0BE;EACE,oBAAA;EAEA,8DAxDS;EAyDT,6DAzDS;EA0DT,sDAvDS;EAwDT,kBAvDgB;EAwDhB,yB3NrDO;E2NsDP,yBAAA;EAEA,eAAA;EACA,eAAA;EACA,mBAAA;EAGA,gBAAA;A5Nsn0BJ;;A4Npn0BI;EACE,aAAA;A5Nun0BN;;A4Npn0BI;EACE,cAAA;EACA,+DA5EO;EA6EP,0BAAA;A5Nun0BN;;A4Npn0BI;EPnEF,UAAA;EACA,6CCgBwB;EDfxB,wCAAA;ArN2r0BF;;A4Ntn0BI;EAEE,aAAA;A5Nwn0BN;;A4Npn0BE;EACE,0BAAA;A5Nun0BJ;;A4Npn0BE;EPhEA,UAAA;EACA,SAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,oBAAA;EAEA,0BAAA;EACA,UAAA;EOyDE,eAAA;EACA,mBAAA;EAEA,iBAAA;A5N+n0BJ;;A4N/m0BI;EACE,aAAA;A5Nkn0BN;;A4N/m0BI;EACE,eAAA;A5Nkn0BN;;A6Nps0BE;EACE,WAAA;EACA,YAAA;EACA,WAAA;A7Nus0BJ;;A6Nps0BE;EACE,gBAAA;A7Nus0BJ;;A6Nps0BE;EACE,kBPjCmB;EOkCnB,sBPhCQ;EOiCR,sBAAA;A7Nus0BJ;;A6Nps0BE;EACE,iBAAA;A7Nus0BJ;;A6Nrs0BE;EACE,aAAA;EACA,cAAA;A7Nws0BJ;;A6Nrs0BE;;EAEE,4BPhCqB;AtNwu0BzB;;AqNtv0BE;;EANA,UAAA;EACA,6CCgBwB;EDfxB,wCAAA;ArNiw0BF;;AqN1v0BI;;EACE,aAAA;EACA,gBAAA;ArN8v0BN;;A6Nht0BI;;;EAEE,oBAAA;EACA,aAAA;A7Not0BN;;A6Nht0BE;EACE,gBAAA;EACA,kBP9DmB;AtNix0BvB;;A6Nht0BI;EACE,yB5N7EK;ADgy0BX;;A6Njt0BI;EACE,yB5N/EK;ADmy0BX;;A6Nht0BE;;;;EAIE,oBAAA;A7Nmt0BJ;;A6N9s0BI;;EACE,uBAAA;A7Nkt0BN;;A6N/s0BE;EACE,iBAAA;A7Nkt0BJ;;A6Nht0BI;EACE,eAAA;A7Nmt0BN;;A6Nht0BI;EACE,iBAAA;A7Nmt0BN;;A6Njt0BM;EACE,cAAA;EACA,kBAAA;A7Not0BR;;A6N/s0BE;EACE,cAAA;EACA,aAAA;EACA,YAAA;EACA,YPhGiB;EOiGjB,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,WAAA;EACA,sBP9GQ;AtNg00BZ;;A6Nht0BE;EACE,2BAAA;A7Nmt0BJ;;A6Njt0BE;EACE,wBAAA;A7Not0BJ;;A6Njt0BE;EACE,kBAAA;A7Not0BJ;;A6Njt0BE;EACE,mBAAA;EACA,kBApIS;EAqIT,gCAAA;EACA,eArIW;A7Ny10Bf;;A6Njt0BE;EACE,mBAAA;EACA,c5N1IO;E4N2IP,sBAAA;EAEA,kBPzImB;EO0InB,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAlJW;EAmJX,aAAA;A7Nmt0BJ;;A6Njt0BI;EACE,yB5N7JK;ADi30BX;;A6Nlt0BI;EACE,yB5N/JK;ADo30BX;;A6Nlt0BI;EACE,yBNxKQ;EMyKR,qBNzKQ;EM0KR,WNxKW;AvN630BjB;;A6Nlt0BI;EACE,kBApKO;A7Ny30Bb;;A6Njt0BE;EACE,c5N7KO;ADi40BX;;A6Njt0BE;EACE,kBAAA;EACA,gBAAA;A7Not0BJ;;A6Njt0BE;EACE,WAAA;EACA,gBAAA;EACA,0CAAA;EAjKF,0BAAA;A7Ns30BF;;A6Np30BE;EA4JA;IA3JE,+BAAA;E7Nw30BF;AACF;A6Nvt0BE;EACE,mCAAA;EACA,2BAAA;A7Nyt0BJ;;A6Nvt0BI;EAzKF,8BAAA;A7No40BF;;A6Nl40BE;EAuKE;IAtKA,mCAAA;E7Ns40BF;AACF;A6N9t0BI;EA5KF,6BAAA;A7N640BF;;A6N340BE;EA0KE;IAzKA,kCAAA;E7N+40BF;AACF;A6Npu0BI;EA/KF,8BAAA;A7Ns50BF;;A6Np50BE;EA6KE;IA5KA,mCAAA;E7Nw50BF;AACF;A6N1u0BI;EAlLF,6BAAA;A7N+50BF;;A6N750BE;EAgLE;IA/KA,kCAAA;E7Ni60BF;AACF;A6N/u0BI;EAtLF,0BAAA;A7Nw60BF;;A6Nt60BE;EAoLE;IAnLA,+BAAA;E7N060BF;AACF;A6Nnv0BE;EACE,mCAAA;EACA,2BAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;A7Nqv0BJ;;A6Nnv0BI;EAlMF,6BAAA;A7Ny70BF;;A6Nv70BE;EAgME;IA/LA,kCAAA;E7N270BF;AACF;A6N1v0BI;EArMF,8BAAA;A7Nk80BF;;A6Nh80BE;EAmME;IAlMA,mCAAA;E7No80BF;AACF;A6Nhw0BI;EAxMF,6BAAA;A7N280BF;;A6Nz80BE;EAsME;IArMA,kCAAA;E7N680BF;AACF;A6Ntw0BI;EA3MF,8BAAA;A7No90BF;;A6Nl90BE;EAyME;IAxMA,mCAAA;E7Ns90BF;AACF;A8Npg1BE;EACE,aAAA;EACA,sBAAA;A9Nsg1BJ;;A8Npg1BI;EACE,kBAAA;EACA,aAAA;A9Nug1BN;;A+N1g1BE;EACE,oBAAA;EACA,yC3N4sBoC;E2N3sBpC,mBAAA;EACA,sB9NQI;E8NPJ,yBAAA;EACA,sB3N2W0B;E2N1W1B,aAAA;EACA,YAAA;A/N6g1BJ;;A+N1g1BE;EV2BA,UAAA;EACA,SAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,oBAAA;EAEA,0BAAA;EACA,UAAA;EUjCE,gBAAA;A/Nqh1BJ;;AqN9+0BE;EAIE,UAAA;ArN8+0BJ;;A+Nth1BI;EAEE,kBAAA;A/Nwh1BN;;A+Nph1BE;EVcA,UAAA;EACA,SAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,oBAAA;EAEA,0BAAA;EACA,UAAA;EUrBE,gBAAA;EACA,yBAAA;EACA,6BAAA;EAAA,wBAAA;A/Ngi1BJ;;A+N9h1BI;EACE,aAAA;A/Nii1BN;;A+N7h1BE;EACE,gBAAA;EACA,aAAA;EACA,UAAA;EACA,iBAAA;A/Ngi1BJ;;A+N9h1BI;EACE,mBAAA;EACA,kBAAA;A/Nii1BN;;A+N9h1BI;EAEE,UAAA;A/Ngi1BN;;AgOll1BE;EACE,aAAA;EACA,sBAAA;AhOql1BJ;;AgOnl1BI;EACE,SAAA;AhOsl1BN;;AiOtl1BA;EACE,eAAA;EACA,YAAA;EACA,YAAA;EACA,MAAA;EACA,aAAA;EACA,2BAAA;EACA,oBAAA;EACA,sUAAA;AjOyl1BF;AiOpl1BE;E3NFE,mBAAA;E2NIA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,kUhOgFiB;EgO/EjB,iBAAA;AjOsl1BJ;AiOpl1BI;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,yBAAA;AjOsl1BN;AiOll1BE;EACE,gBhO5BI;EgO6BJ,YAvCkB;EAwClB,aAAA;EACA,UAAA;AjOol1BJ;AiOjl1BE;EACE,uBAAA;EACA,QAAA;AjOml1BJ;AiOhl1BE;EACE,kBAAA;AjOkl1BJ;AiOhl1BI;EACE,WAAA;EACA,YAAA;E3NzCF,kBAAA;AN4n1BJ;AiOhl1BM;EACE,WAAA;AjOkl1BR;AiO7k1BE;EACE,iBhOsBW;EgOrBX,chOhDO;EgOiDP,SAAA;EACA,mBhOxDO;EgOyDP,uBAAA;EACA,gCAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;AjO+k1BJ;AiO7k1BI;EACE,aAAA;AjO+k1BN;AiO1k1BI;EACE,chO1CE;EgO2CF,mBhOIS;EgOHT,yBAAA;EACA,SAAA;EACA,kBAAA;AjO4k1BN;;AiOvk1BA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,oBAAA;EACA,YAAA;EACA,qBAAA;E3NrFE,mBAAA;ANgq1BJ;AiOxk1BE;EACE,sBAAA;EACA,6BAAA;EACA,UAAA;AjO0k1BJ;AiOvk1BE;EACE,UAAA;AjOyk1BJ;;AiOrk1BA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AjOwk1BF;;AkOzr1BA;EACE,kBAAA;EACA,yBAAA;E5NSE,sBAAA;E4NPF,gBAAA;EACA,YAAA;AlO4r1BF;AkO1r1BE;EACE,WAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AlO4r1BJ;AkO1r1BI;EACE,iB9NoawB;AJwx0B9B;AkOxr1BE;EACE,mBjOXO;EiOYP,cjOiBI;ADyq1BR;AkOxr1BI;EACE,cjOVK;ADos1BX;AkOtr1BE;EACE,kBAAA;AlOwr1BJ;AkOrr1BE;EACE,cjOpBO;EiOqBP,0BAAA;EACA,eAAA;AlOur1BJ;;AkOnr1BA;EACE,gBAAA;AlOsr1BF;;AkOnr1BA;EACE,gCAAA;AlOsr1BF;;AkOjr1BA;EACE,aAAA;EACA,qB9N8R4B;AJs50B9B;;AkO/q1BA;EACE,YAAA;EACA,aAAA;EACA,WAAA;AlOkr1BF;;AkO7q1BA;EACE,mBjOtDS;EKAP,sBAAA;E4NwDF,cjOrDS;EiOsDT,eAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;AlOgr1BF;;AkO5q1BE;EACE,mBjOnEO;EiOoEP,cjOlEO;ADiv1BX;;AkOzq1BA;EACE,eAAA;AlO4q1BF;;AmOxw1BA;EACE;IACE,aAAA;EnO2w1BF;AACF;Aats1BI;EsNhEF;IACE,cAAA;EnOyw1BF;EmOrw1BE;IAEE,aAAA;EnOsw1BJ;EmOlw1BA;IACE,0BAAA;IACA,uBAAA;IACA,6BAAA;EnOow1BF;EmOlw1BE;IACE,aAAA;EnOow1BJ;EmO9v1BE;IAEE,wBAAA;EnO+v1BJ;EmO3v1BM;IACE,cAAA;IAAA,oBAAA;EnO6v1BR;EmO3v1BQ;IACE,aAAA;EnO6v1BV;EmOzv1BM;IACE,cAAA;IAAA,oBAAA;IACA,wBAAA;EnO2v1BR;EmOxv1BM;IACE,cAAA;IAAA,oBAAA;IACA,SAAA;IACA,cAAA;EnO0v1BR;EmOvv1BM;IACE,mBAAA;EnOyv1BR;EmOrv1BQ;IACE,uBAAA;EnOuv1BV;EmOrv1BU;IACE,aAAA;EnOuv1BZ;EmOlv1BU;IACE,iBAAA;EnOov1BZ;EmO9u1BI;IACE,sBAAA;EnOgv1BN;EmO9u1BM;IACE,sBAAA;IACA,iBAAA;IACA,eAAA;EnOgv1BR;EmO3u1BE;IACE,YAAA;EnO6u1BJ;EmO1u1BE;IACE,cAAA;EnO4u1BJ;EmOtu1BE;IACE,0BAAA;IACA,WAAA;EnOwu1BJ;EmOpu1BA;IACE,8BAAA;EnOsu1BF;EmOpu1BE;IACE,aAAA;IACA,QAAA;IACA,kCAAA;IACA,oBAAA;EnOsu1BJ;EmOnu1BE;IACE,kBAAA;IACA,UAAA;IACA,kUlOVe;IkOWf,kBAAA;IACA,QAAA;IACA,UAAA;IACA,MAAA;IACA,oBAAA;IACA,gBlOhHE;IKGJ,mBAAA;I6N+GE,eAAA;IACA,gBAAA;EnOqu1BJ;EmOnu1BI;IACE,mBAAA;IACA,iBAAA;EnOqu1BN;EmOnu1BM;IACE,eAAA;EnOqu1BR;EmOlu1BM;IACE,aAAA;EnOou1BR;EmO/t1BM;IACE,aAAA;EnOiu1BR;EmO7t1BI;IACE,mBAAA;IACA,UAAA;IACA,SAAA;EnO+t1BN;EmO3t1BE;IACE,aAAA;IACA,QAAA;EnO6t1BJ;EmO1t1BE;IACE,aAAA;IACA,QAAA;EnO4t1BJ;EmOvt1BM;IAEE,oCAAA;IACA,sCAAA;EnOwt1BR;EmOpt1BI;IACE,mBlO3JG;EDi31BT;EmOht1BA;;IAEE,0BAAA;IACA,WAAA;IACA,mBAAA;IACA,mBAAA;IACA,qBAAA;IACA,sCAAA;IACA,0BAAA;EnOkt1BF;EmOht1BE;;IACE,aAAA;EnOmt1BJ;EmO9s1BA;IACE,eAAA;IAAA,kBAAA;EnOgt1BF;EmO9s1BE;IACE,wBAAA;EnOgt1BJ;EmO5s1BA;IACE,kBAAA;EnO8s1BF;EmO5s1BE;;IAEE,cAAA;IACA,cAAA;EnO8s1BJ;EmO3s1BE;IACE,sBAAA;EnO6s1BJ;EmOxs1BI;;;;IAEE,qBAAA;EnO4s1BN;EmOps1BE;IACE,aAAA;EnOss1BJ;EmOns1BE;IACE,WAAA;EnOqs1BJ;EmOns1BI;IACE,cAAA;EnOqs1BN;EmO7r1BM;IACE,yBAAA;EnO+r1BR;EmOtr1BE;IACE,iBAAA;IACA,cAAA;EnOwr1BJ;EmOnr1BE;IACE,2BAAA;EnOqr1BJ;EmOhr1BE;IACE,yBAAA;EnOkr1BJ;EmOhr1BI;IACE,gCAAA;IACA,4BAAA;EnOkr1BN;EmO/q1BI;IACE,iBAAA;EnOir1BN;EmO3q1BE;IACE,aAAA;EnO6q1BJ;EmO1q1BE;IACE,kBAAA;EnO4q1BJ;EmOxq1BA;IACE,yBAAA;EnO0q1BF;EmOpq1BI;IACE,iBAAA;EnOsq1BN;EmOjq1BA;IACE,cAAA;EnOmq1BF;AACF;Aa/41BI;EsNiPF;;IAEE,aAAA;EnOiq1BF;EmO7p1BE;IACE,cAAA;IACA,kBAAA;IACA,YAAA;IACA,e3JjU4B;ExEg+1BhC;EmO7p1BI;;IAEE,mBAAA;EnO+p1BN;EmO7p1BM;;IACE,sBAAA;IACA,gBAAA;IACA,oBAAA;EnOgq1BR;EmOzp1BE;IACE,2BAAA;EnO2p1BJ;AACF;Aar71BI;EsNiSA;IACE,2BAAA;EnOup1BJ;AACF;Aa761BI;EsN4RF;IACE,aAAA;EnOop1BF;AACF;Aal71BI;EsNkSF;IACE,oBAAA;EnOmp1BF;EmOhp1BA;;IAEE,iCAAA;EnOkp1BF;EmO/o1BA;IACE,gBAAA;IACA,gCAAA;EnOip1BF;EmO9o1BA;IACE,qBAAA;IACA,sBAAA;IACA,kBAAA;EnOgp1BF;EmO7o1BA;IACE,mBAAA;EnO+o1BF;EmO5o1BA;;IAEE,UAAA;IACA,SAAA;EnO8o1BF;EmO3o1BA;IACE,YAAA;IACA,cAAA;IACA,uBAAA;IACA,kBAAA;EnO6o1BF;EmO3o1BE;IACE,oBAAA;EnO6o1BJ;EmO1o1BE;IACE,UAAA;EnO4o1BJ;EmOto1BI;IACE,+BAAA;IACA,cAAA;EnOwo1BN;EmOro1BI;IACE,0BAAA;IACA,yBAAA;IACA,WAAA;EnOuo1BN;EmOro1BM;IACE,mBAAA;EnOuo1BR;EmOjo1BA;IACE,aAAA;EnOmo1BF;EmO9n1BE;;IACE,cAAA;IACA,kBAAA;EnOio1BJ;EmO/n1BI;;IACE,0BAAA;EnOko1BN;EmO/n1BI;;IACE,gBAAA;EnOko1BN;EmO7n1BA;IACE,aAAA;EnO+n1BF;EmO5n1BA;IACE,cAAA;EnO8n1BF;AACF;AmO3n1BA;EAEI;IACE,cAAA;IACA,kBAAA;EnO4n1BJ;EmO1n1BI;IACE,0BAAA;EnO4n1BN;EmOzn1BI;IACE,gBAAA;EnO2n1BN;AACF","sourcesContent":["@charset \"UTF-8\";\n.border-primary {\n  border-color: #545cd8;\n}\n\n.border-secondary {\n  border-color: #6c757d;\n}\n\n.border-success {\n  border-color: #3ac47d;\n}\n\n.border-info {\n  border-color: #30b1ff;\n}\n\n.border-warning {\n  border-color: #f7b924;\n}\n\n.border-danger {\n  border-color: #d92550;\n}\n\n.border-light {\n  border-color: #eeeeee;\n}\n\n.border-dark {\n  border-color: #343a40;\n}\n\n.border-focus {\n  border-color: #444054;\n}\n\n.border-alternate {\n  border-color: #83588a;\n}\n\n:root {\n  --bs-blue: #86c6fb;\n  --bs-indigo: #444054;\n  --bs-purple: #83588a;\n  --bs-pink: #f65ca2;\n  --bs-red: #d92550;\n  --bs-orange: #fd7e14;\n  --bs-yellow: #f7b924;\n  --bs-green: #3ac47d;\n  --bs-teal: #16E0BD;\n  --bs-cyan: #30b1ff;\n  --bs-white: #fff;\n  --bs-gray: #6c757d;\n  --bs-gray-dark: #343a40;\n  --bs-primary: #545cd8;\n  --bs-secondary: #6c757d;\n  --bs-success: #3ac47d;\n  --bs-info: #30b1ff;\n  --bs-warning: #f7b924;\n  --bs-danger: #d92550;\n  --bs-light: #eeeeee;\n  --bs-dark: #343a40;\n  --bs-focus: #444054;\n  --bs-alternate: #83588a;\n  --bs-font-sans-serif: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  :root {\n    scroll-behavior: smooth;\n  }\n}\n\nbody {\n  margin: 0;\n  font-family: var(--bs-font-sans-serif);\n  font-size: 0.88rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  background-color: #fff;\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\nhr {\n  margin: 1rem 0;\n  color: inherit;\n  background-color: currentColor;\n  border: 0;\n  opacity: 0.25;\n}\n\nhr:not([size]) {\n  height: 1px;\n}\n\nh6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n  font-weight: 400;\n  line-height: 1.2;\n}\n\nh1, .h1 {\n  font-size: calc(1.345rem + 1.14vw);\n}\n@media (min-width: 1200px) {\n  h1, .h1 {\n    font-size: 2.2rem;\n  }\n}\n\nh2, .h2 {\n  font-size: calc(1.301rem + 0.612vw);\n}\n@media (min-width: 1200px) {\n  h2, .h2 {\n    font-size: 1.76rem;\n  }\n}\n\nh3, .h3 {\n  font-size: calc(1.279rem + 0.348vw);\n}\n@media (min-width: 1200px) {\n  h3, .h3 {\n    font-size: 1.54rem;\n  }\n}\n\nh4, .h4 {\n  font-size: calc(1.257rem + 0.084vw);\n}\n@media (min-width: 1200px) {\n  h4, .h4 {\n    font-size: 1.32rem;\n  }\n}\n\nh5, .h5 {\n  font-size: 1.1rem;\n}\n\nh6, .h6 {\n  font-size: 0.88rem;\n}\n\np {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nabbr[title],\nabbr[data-bs-original-title] {\n  text-decoration: underline dotted;\n  cursor: help;\n  text-decoration-skip-ink: none;\n}\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: 700;\n}\n\ndd {\n  margin-bottom: 0.5rem;\n  margin-left: 0;\n}\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\nsmall, .small {\n  font-size: 0.875em;\n}\n\nmark, .mark {\n  padding: 0.2em;\n  background-color: #fcf8e3;\n}\n\nsub,\nsup {\n  position: relative;\n  font-size: 0.75em;\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\na {\n  color: #545cd8;\n  text-decoration: underline;\n}\na:hover {\n  color: rgb(67.2, 73.6, 172.8);\n}\n\na:not([href]):not([class]), a:not([href]):not([class]):hover {\n  color: inherit;\n  text-decoration: none;\n}\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: var(--bs-font-monospace);\n  font-size: 1em;\n  direction: ltr /* rtl:ignore */;\n  unicode-bidi: bidi-override;\n}\n\npre {\n  display: block;\n  margin-top: 0;\n  margin-bottom: 1rem;\n  overflow: auto;\n  font-size: 0.875em;\n}\npre code {\n  font-size: inherit;\n  color: inherit;\n  word-break: normal;\n}\n\ncode {\n  font-size: 0.875em;\n  color: #f65ca2;\n  word-wrap: break-word;\n}\na > code {\n  color: inherit;\n}\n\nkbd {\n  padding: 0.2rem 0.4rem;\n  font-size: 0.875em;\n  color: #fff;\n  background-color: #212529;\n  border-radius: 0.2rem;\n}\nkbd kbd {\n  padding: 0;\n  font-size: 1em;\n  font-weight: 700;\n}\n\nfigure {\n  margin: 0 0 1rem;\n}\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  color: #6c757d;\n  text-align: left;\n}\n\nth {\n  text-align: inherit;\n  text-align: -webkit-match-parent;\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\nlabel {\n  display: inline-block;\n}\n\nbutton {\n  border-radius: 0;\n}\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n\nbutton,\nselect {\n  text-transform: none;\n}\n\n[role=button] {\n  cursor: pointer;\n}\n\nselect {\n  word-wrap: normal;\n}\nselect:disabled {\n  opacity: 1;\n}\n\n[list]::-webkit-calendar-picker-indicator {\n  display: none;\n}\n\nbutton,\n[type=button],\n[type=reset],\n[type=submit] {\n  -webkit-appearance: button;\n}\nbutton:not(:disabled),\n[type=button]:not(:disabled),\n[type=reset]:not(:disabled),\n[type=submit]:not(:disabled) {\n  cursor: pointer;\n}\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ntextarea {\n  resize: vertical;\n}\n\nfieldset {\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\nlegend {\n  float: left;\n  width: 100%;\n  padding: 0;\n  margin-bottom: 0.5rem;\n  font-size: calc(1.275rem + 0.3vw);\n  line-height: inherit;\n}\n@media (min-width: 1200px) {\n  legend {\n    font-size: 1.5rem;\n  }\n}\nlegend + * {\n  clear: left;\n}\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n[type=search] {\n  outline-offset: -2px;\n  -webkit-appearance: textfield;\n}\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n::file-selector-button {\n  font: inherit;\n}\n\n::-webkit-file-upload-button {\n  font: inherit;\n  -webkit-appearance: button;\n}\n\noutput {\n  display: inline-block;\n}\n\niframe {\n  border: 0;\n}\n\nsummary {\n  display: list-item;\n  cursor: pointer;\n}\n\nprogress {\n  vertical-align: baseline;\n}\n\n[hidden] {\n  display: none !important;\n}\n\n.lead {\n  font-size: 1.1rem;\n  font-weight: 300;\n}\n\n.display-1 {\n  font-size: calc(1.625rem + 4.5vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-1 {\n    font-size: 5rem;\n  }\n}\n\n.display-2 {\n  font-size: calc(1.575rem + 3.9vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-2 {\n    font-size: 4.5rem;\n  }\n}\n\n.display-3 {\n  font-size: calc(1.525rem + 3.3vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-3 {\n    font-size: 4rem;\n  }\n}\n\n.display-4 {\n  font-size: calc(1.475rem + 2.7vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-4 {\n    font-size: 3.5rem;\n  }\n}\n\n.display-5 {\n  font-size: calc(1.425rem + 2.1vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-5 {\n    font-size: 3rem;\n  }\n}\n\n.display-6 {\n  font-size: calc(1.375rem + 1.5vw);\n  font-weight: 300;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-6 {\n    font-size: 2.5rem;\n  }\n}\n\n.list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline-item {\n  display: inline-block;\n}\n.list-inline-item:not(:last-child) {\n  margin-right: 0.5rem;\n}\n\n.initialism {\n  font-size: 0.875em;\n  text-transform: uppercase;\n}\n\n.blockquote {\n  margin-bottom: 1rem;\n  font-size: 1.1rem;\n}\n.blockquote > :last-child {\n  margin-bottom: 0;\n}\n\n.blockquote-footer {\n  margin-top: -1rem;\n  margin-bottom: 1rem;\n  font-size: 0.875em;\n  color: #6c757d;\n}\n.blockquote-footer::before {\n  content: \"— \";\n}\n\n.img-fluid {\n  max-width: 100%;\n  height: auto;\n}\n\n.img-thumbnail {\n  padding: 0.25rem;\n  background-color: #fff;\n  border: 1px solid #dee2e6;\n  border-radius: 0.25rem;\n  max-width: 100%;\n  height: auto;\n}\n\n.figure {\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: 0.5rem;\n  line-height: 1;\n}\n\n.figure-caption {\n  font-size: 0.875em;\n  color: #6c757d;\n}\n\n.container, .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .body-tabs.body-tabs-layout.body-tabs-big,\n.container-fluid,\n.container-xxl,\n.container-xl,\n.container-lg,\n.container-md,\n.container-sm {\n  width: 100%;\n  padding-right: var(--bs-gutter-x, 0.75rem);\n  padding-left: var(--bs-gutter-x, 0.75rem);\n  margin-right: auto;\n  margin-left: auto;\n}\n\n@media (min-width: 576px) {\n  .container-sm, .container, .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .body-tabs.body-tabs-layout.body-tabs-big {\n    max-width: 540px;\n  }\n}\n@media (min-width: 768px) {\n  .container-md, .container-sm, .container, .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .body-tabs.body-tabs-layout.body-tabs-big {\n    max-width: 720px;\n  }\n}\n@media (min-width: 992px) {\n  .container-lg, .container-md, .container-sm, .container, .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .body-tabs.body-tabs-layout.body-tabs-big {\n    max-width: 960px;\n  }\n}\n@media (min-width: 1200px) {\n  .container-xl, .container-lg, .container-md, .container-sm, .container, .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .body-tabs.body-tabs-layout.body-tabs-big {\n    max-width: 1140px;\n  }\n}\n@media (min-width: 1400px) {\n  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container, .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .body-tabs.body-tabs-layout.body-tabs-big {\n    max-width: 1320px;\n  }\n}\n.row {\n  --bs-gutter-x: 1.5rem;\n  --bs-gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: calc(var(--bs-gutter-y) * -1);\n  margin-right: calc(var(--bs-gutter-x) * -0.5);\n  margin-left: calc(var(--bs-gutter-x) * -0.5);\n}\n.row > * {\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%;\n  padding-right: calc(var(--bs-gutter-x) * 0.5);\n  padding-left: calc(var(--bs-gutter-x) * 0.5);\n  margin-top: var(--bs-gutter-y);\n}\n\n.col {\n  flex: 1 0 0%;\n}\n\n.row-cols-auto > * {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n.row-cols-1 > * {\n  flex: 0 0 auto;\n  width: 100%;\n}\n\n.row-cols-2 > * {\n  flex: 0 0 auto;\n  width: 50%;\n}\n\n.row-cols-3 > * {\n  flex: 0 0 auto;\n  width: 33.3333333333%;\n}\n\n.row-cols-4 > * {\n  flex: 0 0 auto;\n  width: 25%;\n}\n\n.row-cols-5 > * {\n  flex: 0 0 auto;\n  width: 20%;\n}\n\n.row-cols-6 > * {\n  flex: 0 0 auto;\n  width: 16.6666666667%;\n}\n\n@media (min-width: 576px) {\n  .col-sm {\n    flex: 1 0 0%;\n  }\n  .row-cols-sm-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-sm-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-sm-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-sm-3 > * {\n    flex: 0 0 auto;\n    width: 33.3333333333%;\n  }\n  .row-cols-sm-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-sm-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-sm-6 > * {\n    flex: 0 0 auto;\n    width: 16.6666666667%;\n  }\n}\n@media (min-width: 768px) {\n  .col-md {\n    flex: 1 0 0%;\n  }\n  .row-cols-md-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-md-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-md-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-md-3 > * {\n    flex: 0 0 auto;\n    width: 33.3333333333%;\n  }\n  .row-cols-md-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-md-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-md-6 > * {\n    flex: 0 0 auto;\n    width: 16.6666666667%;\n  }\n}\n@media (min-width: 992px) {\n  .col-lg {\n    flex: 1 0 0%;\n  }\n  .row-cols-lg-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-lg-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-lg-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-lg-3 > * {\n    flex: 0 0 auto;\n    width: 33.3333333333%;\n  }\n  .row-cols-lg-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-lg-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-lg-6 > * {\n    flex: 0 0 auto;\n    width: 16.6666666667%;\n  }\n}\n@media (min-width: 1200px) {\n  .col-xl {\n    flex: 1 0 0%;\n  }\n  .row-cols-xl-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-xl-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-xl-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-xl-3 > * {\n    flex: 0 0 auto;\n    width: 33.3333333333%;\n  }\n  .row-cols-xl-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-xl-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-xl-6 > * {\n    flex: 0 0 auto;\n    width: 16.6666666667%;\n  }\n}\n@media (min-width: 1400px) {\n  .col-xxl {\n    flex: 1 0 0%;\n  }\n  .row-cols-xxl-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-xxl-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-xxl-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-xxl-3 > * {\n    flex: 0 0 auto;\n    width: 33.3333333333%;\n  }\n  .row-cols-xxl-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-xxl-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-xxl-6 > * {\n    flex: 0 0 auto;\n    width: 16.6666666667%;\n  }\n}\n.col-auto {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n.col-1 {\n  flex: 0 0 auto;\n  width: 8.33333333%;\n}\n\n.col-2 {\n  flex: 0 0 auto;\n  width: 16.66666667%;\n}\n\n.col-3 {\n  flex: 0 0 auto;\n  width: 25%;\n}\n\n.col-4 {\n  flex: 0 0 auto;\n  width: 33.33333333%;\n}\n\n.col-5 {\n  flex: 0 0 auto;\n  width: 41.66666667%;\n}\n\n.col-6 {\n  flex: 0 0 auto;\n  width: 50%;\n}\n\n.col-7 {\n  flex: 0 0 auto;\n  width: 58.33333333%;\n}\n\n.col-8 {\n  flex: 0 0 auto;\n  width: 66.66666667%;\n}\n\n.col-9 {\n  flex: 0 0 auto;\n  width: 75%;\n}\n\n.col-10 {\n  flex: 0 0 auto;\n  width: 83.33333333%;\n}\n\n.col-11 {\n  flex: 0 0 auto;\n  width: 91.66666667%;\n}\n\n.col-12 {\n  flex: 0 0 auto;\n  width: 100%;\n}\n\n.offset-1 {\n  margin-left: 8.33333333%;\n}\n\n.offset-2 {\n  margin-left: 16.66666667%;\n}\n\n.offset-3 {\n  margin-left: 25%;\n}\n\n.offset-4 {\n  margin-left: 33.33333333%;\n}\n\n.offset-5 {\n  margin-left: 41.66666667%;\n}\n\n.offset-6 {\n  margin-left: 50%;\n}\n\n.offset-7 {\n  margin-left: 58.33333333%;\n}\n\n.offset-8 {\n  margin-left: 66.66666667%;\n}\n\n.offset-9 {\n  margin-left: 75%;\n}\n\n.offset-10 {\n  margin-left: 83.33333333%;\n}\n\n.offset-11 {\n  margin-left: 91.66666667%;\n}\n\n.g-0,\n.gx-0 {\n  --bs-gutter-x: 0;\n}\n\n.g-0,\n.gy-0 {\n  --bs-gutter-y: 0;\n}\n\n.g-1,\n.gx-1 {\n  --bs-gutter-x: 0.25rem;\n}\n\n.g-1,\n.gy-1 {\n  --bs-gutter-y: 0.25rem;\n}\n\n.g-2,\n.gx-2 {\n  --bs-gutter-x: 0.5rem;\n}\n\n.g-2,\n.gy-2 {\n  --bs-gutter-y: 0.5rem;\n}\n\n.g-3,\n.gx-3 {\n  --bs-gutter-x: 1rem;\n}\n\n.g-3,\n.gy-3 {\n  --bs-gutter-y: 1rem;\n}\n\n.g-4,\n.gx-4 {\n  --bs-gutter-x: 1.5rem;\n}\n\n.g-4,\n.gy-4 {\n  --bs-gutter-y: 1.5rem;\n}\n\n.g-5,\n.gx-5 {\n  --bs-gutter-x: 3rem;\n}\n\n.g-5,\n.gy-5 {\n  --bs-gutter-y: 3rem;\n}\n\n@media (min-width: 576px) {\n  .col-sm-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-sm-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-sm-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-sm-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-sm-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-sm-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-sm-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-sm-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-sm-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-sm-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-sm-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-sm-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-sm-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-sm-0 {\n    margin-left: 0;\n  }\n  .offset-sm-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-sm-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-sm-3 {\n    margin-left: 25%;\n  }\n  .offset-sm-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-sm-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-sm-6 {\n    margin-left: 50%;\n  }\n  .offset-sm-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-sm-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-sm-9 {\n    margin-left: 75%;\n  }\n  .offset-sm-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-sm-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-sm-0,\n  .gx-sm-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-sm-0,\n  .gy-sm-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-sm-1,\n  .gx-sm-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-sm-1,\n  .gy-sm-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-sm-2,\n  .gx-sm-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-sm-2,\n  .gy-sm-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-sm-3,\n  .gx-sm-3 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-sm-3,\n  .gy-sm-3 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-sm-4,\n  .gx-sm-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-sm-4,\n  .gy-sm-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-sm-5,\n  .gx-sm-5 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-sm-5,\n  .gy-sm-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n@media (min-width: 768px) {\n  .col-md-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-md-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-md-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-md-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-md-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-md-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-md-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-md-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-md-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-md-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-md-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-md-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-md-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-md-0 {\n    margin-left: 0;\n  }\n  .offset-md-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-md-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-md-3 {\n    margin-left: 25%;\n  }\n  .offset-md-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-md-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-md-6 {\n    margin-left: 50%;\n  }\n  .offset-md-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-md-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-md-9 {\n    margin-left: 75%;\n  }\n  .offset-md-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-md-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-md-0,\n  .gx-md-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-md-0,\n  .gy-md-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-md-1,\n  .gx-md-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-md-1,\n  .gy-md-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-md-2,\n  .gx-md-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-md-2,\n  .gy-md-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-md-3,\n  .gx-md-3 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-md-3,\n  .gy-md-3 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-md-4,\n  .gx-md-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-md-4,\n  .gy-md-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-md-5,\n  .gx-md-5 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-md-5,\n  .gy-md-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n@media (min-width: 992px) {\n  .col-lg-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-lg-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-lg-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-lg-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-lg-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-lg-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-lg-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-lg-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-lg-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-lg-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-lg-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-lg-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-lg-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-lg-0 {\n    margin-left: 0;\n  }\n  .offset-lg-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-lg-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-lg-3 {\n    margin-left: 25%;\n  }\n  .offset-lg-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-lg-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-lg-6 {\n    margin-left: 50%;\n  }\n  .offset-lg-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-lg-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-lg-9 {\n    margin-left: 75%;\n  }\n  .offset-lg-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-lg-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-lg-0,\n  .gx-lg-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-lg-0,\n  .gy-lg-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-lg-1,\n  .gx-lg-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-lg-1,\n  .gy-lg-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-lg-2,\n  .gx-lg-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-lg-2,\n  .gy-lg-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-lg-3,\n  .gx-lg-3 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-lg-3,\n  .gy-lg-3 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-lg-4,\n  .gx-lg-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-lg-4,\n  .gy-lg-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-lg-5,\n  .gx-lg-5 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-lg-5,\n  .gy-lg-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n@media (min-width: 1200px) {\n  .col-xl-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-xl-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-xl-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xl-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-xl-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-xl-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-xl-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-xl-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-xl-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-xl-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-xl-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-xl-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-xl-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-xl-0 {\n    margin-left: 0;\n  }\n  .offset-xl-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-xl-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-xl-3 {\n    margin-left: 25%;\n  }\n  .offset-xl-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-xl-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-xl-6 {\n    margin-left: 50%;\n  }\n  .offset-xl-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-xl-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-xl-9 {\n    margin-left: 75%;\n  }\n  .offset-xl-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-xl-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-xl-0,\n  .gx-xl-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-xl-0,\n  .gy-xl-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-xl-1,\n  .gx-xl-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-xl-1,\n  .gy-xl-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-xl-2,\n  .gx-xl-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-xl-2,\n  .gy-xl-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-xl-3,\n  .gx-xl-3 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-xl-3,\n  .gy-xl-3 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-xl-4,\n  .gx-xl-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-xl-4,\n  .gy-xl-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-xl-5,\n  .gx-xl-5 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-xl-5,\n  .gy-xl-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n@media (min-width: 1400px) {\n  .col-xxl-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-xxl-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-xxl-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xxl-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-xxl-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-xxl-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-xxl-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-xxl-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-xxl-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-xxl-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-xxl-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-xxl-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-xxl-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-xxl-0 {\n    margin-left: 0;\n  }\n  .offset-xxl-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-xxl-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-xxl-3 {\n    margin-left: 25%;\n  }\n  .offset-xxl-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-xxl-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-xxl-6 {\n    margin-left: 50%;\n  }\n  .offset-xxl-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-xxl-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-xxl-9 {\n    margin-left: 75%;\n  }\n  .offset-xxl-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-xxl-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-xxl-0,\n  .gx-xxl-0 {\n    --bs-gutter-x: 0;\n  }\n  .g-xxl-0,\n  .gy-xxl-0 {\n    --bs-gutter-y: 0;\n  }\n  .g-xxl-1,\n  .gx-xxl-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-xxl-1,\n  .gy-xxl-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-xxl-2,\n  .gx-xxl-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-xxl-2,\n  .gy-xxl-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-xxl-3,\n  .gx-xxl-3 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-xxl-3,\n  .gy-xxl-3 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-xxl-4,\n  .gx-xxl-4 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-xxl-4,\n  .gy-xxl-4 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-xxl-5,\n  .gx-xxl-5 {\n    --bs-gutter-x: 3rem;\n  }\n  .g-xxl-5,\n  .gy-xxl-5 {\n    --bs-gutter-y: 3rem;\n  }\n}\n.table {\n  --bs-table-bg: transparent;\n  --bs-table-accent-bg: rgba(0, 0, 0, 0.03);\n  --bs-table-striped-color: #495057;\n  --bs-table-striped-bg: rgba(0, 0, 0, 0.05);\n  --bs-table-active-color: #495057;\n  --bs-table-active-bg: #e0f3ff;\n  --bs-table-hover-color: #495057;\n  --bs-table-hover-bg: #e0f3ff;\n  width: 100%;\n  margin-bottom: 1rem;\n  color: #495057;\n  vertical-align: top;\n  border-color: #e9ecef;\n}\n.table > :not(caption) > * > * {\n  padding: 0.5rem 0.5rem;\n  background-color: var(--bs-table-bg);\n  border-bottom-width: 1px;\n  box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);\n}\n.table > tbody {\n  vertical-align: inherit;\n}\n.table > thead {\n  vertical-align: bottom;\n}\n.table > :not(:last-child) > :last-child > * {\n  border-bottom-color: currentColor;\n}\n\n.caption-top {\n  caption-side: top;\n}\n\n.table-sm > :not(caption) > * > * {\n  padding: 0.25rem 0.25rem;\n}\n\n.table-bordered > :not(caption) > * {\n  border-width: 1px 0;\n}\n.table-bordered > :not(caption) > * > * {\n  border-width: 0 1px;\n}\n\n.table-borderless > :not(caption) > * > * {\n  border-bottom-width: 0;\n}\n\n.table-striped > tbody > tr:nth-of-type(odd) {\n  --bs-table-accent-bg: var(--bs-table-striped-bg);\n  color: var(--bs-table-striped-color);\n}\n\n.table-active {\n  --bs-table-accent-bg: var(--bs-table-active-bg);\n  color: var(--bs-table-active-color);\n}\n\n.table-hover > tbody > tr:hover {\n  --bs-table-accent-bg: var(--bs-table-hover-bg);\n  color: var(--bs-table-hover-color);\n}\n\n.table-primary {\n  --bs-table-bg: rgb(220.8, 222.4, 247.2);\n  --bs-table-striped-bg: rgb(209.76, 211.28, 234.84);\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: rgb(198.72, 200.16, 222.48);\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: rgb(204.24, 205.72, 228.66);\n  --bs-table-hover-color: #000;\n  color: #000;\n  border-color: rgb(198.72, 200.16, 222.48);\n}\n\n.table-secondary {\n  --bs-table-bg: rgb(225.6, 227.4, 229);\n  --bs-table-striped-bg: rgb(214.32, 216.03, 217.55);\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: rgb(203.04, 204.66, 206.1);\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: rgb(208.68, 210.345, 211.825);\n  --bs-table-hover-color: #000;\n  color: #000;\n  border-color: rgb(203.04, 204.66, 206.1);\n}\n\n.table-success {\n  --bs-table-bg: rgb(215.6, 243.2, 229);\n  --bs-table-striped-bg: rgb(204.82, 231.04, 217.55);\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: rgb(194.04, 218.88, 206.1);\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: rgb(199.43, 224.96, 211.825);\n  --bs-table-hover-color: #000;\n  color: #000;\n  border-color: rgb(194.04, 218.88, 206.1);\n}\n\n.table-info {\n  --bs-table-bg: rgb(213.6, 239.4, 255);\n  --bs-table-striped-bg: rgb(202.92, 227.43, 242.25);\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: rgb(192.24, 215.46, 229.5);\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: rgb(197.58, 221.445, 235.875);\n  --bs-table-hover-color: #000;\n  color: #000;\n  border-color: rgb(192.24, 215.46, 229.5);\n}\n\n.table-warning {\n  --bs-table-bg: rgb(253.4, 241, 211.2);\n  --bs-table-striped-bg: rgb(240.73, 228.95, 200.64);\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: rgb(228.06, 216.9, 190.08);\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: rgb(234.395, 222.925, 195.36);\n  --bs-table-hover-color: #000;\n  color: #000;\n  border-color: rgb(228.06, 216.9, 190.08);\n}\n\n.table-danger {\n  --bs-table-bg: rgb(247.4, 211.4, 220);\n  --bs-table-striped-bg: rgb(235.03, 200.83, 209);\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: rgb(222.66, 190.26, 198);\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: rgb(228.845, 195.545, 203.5);\n  --bs-table-hover-color: #000;\n  color: #000;\n  border-color: rgb(222.66, 190.26, 198);\n}\n\n.table-light {\n  --bs-table-bg: #eeeeee;\n  --bs-table-striped-bg: rgb(226.1, 226.1, 226.1);\n  --bs-table-striped-color: #000;\n  --bs-table-active-bg: rgb(214.2, 214.2, 214.2);\n  --bs-table-active-color: #000;\n  --bs-table-hover-bg: rgb(220.15, 220.15, 220.15);\n  --bs-table-hover-color: #000;\n  color: #000;\n  border-color: rgb(214.2, 214.2, 214.2);\n}\n\n.table-dark {\n  --bs-table-bg: #343a40;\n  --bs-table-striped-bg: rgb(62.15, 67.85, 73.55);\n  --bs-table-striped-color: #fff;\n  --bs-table-active-bg: rgb(72.3, 77.7, 83.1);\n  --bs-table-active-color: #fff;\n  --bs-table-hover-bg: rgb(67.225, 72.775, 78.325);\n  --bs-table-hover-color: #fff;\n  color: #fff;\n  border-color: rgb(72.3, 77.7, 83.1);\n}\n\n.table-responsive {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n@media (max-width: 575.98px) {\n  .table-responsive-sm {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 767.98px) {\n  .table-responsive-md {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 991.98px) {\n  .table-responsive-lg {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 1199.98px) {\n  .table-responsive-xl {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 1399.98px) {\n  .table-responsive-xxl {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n.form-label {\n  margin-bottom: 0.5rem;\n}\n\n.col-form-label {\n  padding-top: calc(0.375rem + 1px);\n  padding-bottom: calc(0.375rem + 1px);\n  margin-bottom: 0;\n  font-size: inherit;\n  line-height: 1.5;\n}\n\n.col-form-label-lg {\n  padding-top: calc(0.5rem + 1px);\n  padding-bottom: calc(0.5rem + 1px);\n  font-size: 1.1rem;\n}\n\n.col-form-label-sm {\n  padding-top: calc(0.25rem + 1px);\n  padding-bottom: calc(0.25rem + 1px);\n  font-size: 0.968rem;\n}\n\n.form-text {\n  margin-top: 0.25rem;\n  font-size: 0.875em;\n  color: #6c757d;\n}\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: 0.375rem 0.75rem;\n  font-size: 0.88rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #ced4da;\n  appearance: none;\n  border-radius: 0.25rem;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-control {\n    transition: none;\n  }\n}\n.form-control[type=file] {\n  overflow: hidden;\n}\n.form-control[type=file]:not(:disabled):not([readonly]) {\n  cursor: pointer;\n}\n.form-control:focus {\n  color: #495057;\n  background-color: #fff;\n  border-color: rgb(187.8214285714, 190.9642857143, 239.6785714286);\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgba(84, 92, 216, 0.25);\n}\n.form-control::-webkit-date-and-time-value {\n  height: 1.5em;\n}\n.form-control::placeholder {\n  color: #6c757d;\n  opacity: 1;\n}\n.form-control:disabled, .form-control[readonly] {\n  background-color: #e9ecef;\n  opacity: 1;\n}\n.form-control::file-selector-button {\n  padding: 0.375rem 0.75rem;\n  margin: -0.375rem -0.75rem;\n  margin-inline-end: 0.75rem;\n  color: #495057;\n  background-color: rgb(239.3, 248.9225806452, 255);\n  pointer-events: none;\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n  border-inline-end-width: 1px;\n  border-radius: 0;\n  transition: color 0.15s, background-color 0.15s, border-color 0.15s, box-shadow 0.15s;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-control::file-selector-button {\n    transition: none;\n  }\n}\n.form-control:hover:not(:disabled):not([readonly])::file-selector-button {\n  background-color: rgb(227.335, 236.4764516129, 242.25);\n}\n.form-control::-webkit-file-upload-button {\n  padding: 0.375rem 0.75rem;\n  margin: -0.375rem -0.75rem;\n  margin-inline-end: 0.75rem;\n  color: #495057;\n  background-color: rgb(239.3, 248.9225806452, 255);\n  pointer-events: none;\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n  border-inline-end-width: 1px;\n  border-radius: 0;\n  transition: color 0.15s, background-color 0.15s, border-color 0.15s, box-shadow 0.15s;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-control::-webkit-file-upload-button {\n    transition: none;\n  }\n}\n.form-control:hover:not(:disabled):not([readonly])::-webkit-file-upload-button {\n  background-color: rgb(227.335, 236.4764516129, 242.25);\n}\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: 0.375rem 0;\n  margin-bottom: 0;\n  line-height: 1.5;\n  color: #495057;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: 1px 0;\n}\n.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.form-control-sm {\n  min-height: calc(1.5em + (0.5rem + 2px));\n  padding: 0.25rem 0.5rem;\n  font-size: 0.968rem;\n  border-radius: 0.2rem;\n}\n.form-control-sm::file-selector-button {\n  padding: 0.25rem 0.5rem;\n  margin: -0.25rem -0.5rem;\n  margin-inline-end: 0.5rem;\n}\n.form-control-sm::-webkit-file-upload-button {\n  padding: 0.25rem 0.5rem;\n  margin: -0.25rem -0.5rem;\n  margin-inline-end: 0.5rem;\n}\n\n.form-control-lg {\n  min-height: calc(1.5em + (1rem + 2px));\n  padding: 0.5rem 1rem;\n  font-size: 1.1rem;\n  border-radius: 0.3rem;\n}\n.form-control-lg::file-selector-button {\n  padding: 0.5rem 1rem;\n  margin: -0.5rem -1rem;\n  margin-inline-end: 1rem;\n}\n.form-control-lg::-webkit-file-upload-button {\n  padding: 0.5rem 1rem;\n  margin: -0.5rem -1rem;\n  margin-inline-end: 1rem;\n}\n\ntextarea.form-control {\n  min-height: calc(1.5em + (0.75rem + 2px));\n}\ntextarea.form-control-sm {\n  min-height: calc(1.5em + (0.5rem + 2px));\n}\ntextarea.form-control-lg {\n  min-height: calc(1.5em + (1rem + 2px));\n}\n\n.form-control-color {\n  max-width: 3rem;\n  height: auto;\n  padding: 0.375rem;\n}\n.form-control-color:not(:disabled):not([readonly]) {\n  cursor: pointer;\n}\n.form-control-color::-moz-color-swatch {\n  height: 1.5em;\n  border-radius: 0.25rem;\n}\n.form-control-color::-webkit-color-swatch {\n  height: 1.5em;\n  border-radius: 0.25rem;\n}\n\n.form-select {\n  display: block;\n  width: 100%;\n  padding: 0.375rem 2.25rem 0.375rem 0.75rem;\n  -moz-padding-start: calc(0.75rem - 3px);\n  font-size: 0.88rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  background-color: #fff;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right 0.75rem center;\n  background-size: 16px 12px;\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  appearance: none;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-select {\n    transition: none;\n  }\n}\n.form-select:focus {\n  border-color: rgb(187.8214285714, 190.9642857143, 239.6785714286);\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgba(84, 92, 216, 0.25);\n}\n.form-select[multiple], .form-select[size]:not([size=\"1\"]) {\n  padding-right: 0.75rem;\n  background-image: none;\n}\n.form-select:disabled {\n  background-color: #e9ecef;\n}\n.form-select:-moz-focusring {\n  color: transparent;\n  text-shadow: 0 0 0 #495057;\n}\n\n.form-select-sm {\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n  padding-left: 0.5rem;\n  font-size: 0.968rem;\n}\n\n.form-select-lg {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  padding-left: 1rem;\n  font-size: 1.1rem;\n}\n\n.form-check {\n  display: block;\n  min-height: 1.32rem;\n  padding-left: 1.5em;\n  margin-bottom: 0.125rem;\n}\n.form-check .form-check-input {\n  float: left;\n  margin-left: -1.5em;\n}\n\n.form-check-input {\n  width: 1em;\n  height: 1em;\n  margin-top: 0.25em;\n  vertical-align: top;\n  background-color: #fff;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: 1px solid rgba(0, 0, 0, 0.25);\n  appearance: none;\n  print-color-adjust: exact;\n}\n.form-check-input[type=checkbox] {\n  border-radius: 0.25em;\n}\n.form-check-input[type=radio] {\n  border-radius: 50%;\n}\n.form-check-input:active {\n  filter: brightness(90%);\n}\n.form-check-input:focus {\n  border-color: rgb(187.8214285714, 190.9642857143, 239.6785714286);\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgba(84, 92, 216, 0.25);\n}\n.form-check-input:checked {\n  background-color: #545cd8;\n  border-color: #545cd8;\n}\n.form-check-input:checked[type=checkbox] {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/%3e%3c/svg%3e\");\n}\n.form-check-input:checked[type=radio] {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23fff'/%3e%3c/svg%3e\");\n}\n.form-check-input[type=checkbox]:indeterminate {\n  background-color: #545cd8;\n  border-color: #545cd8;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3e%3c/svg%3e\");\n}\n.form-check-input:disabled {\n  pointer-events: none;\n  filter: none;\n  opacity: 0.5;\n}\n.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {\n  opacity: 0.5;\n}\n\n.form-switch {\n  padding-left: 2.5em;\n}\n.form-switch .form-check-input {\n  width: 2em;\n  margin-left: -2.5em;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%280, 0, 0, 0.25%29'/%3e%3c/svg%3e\");\n  background-position: left center;\n  border-radius: 2em;\n  transition: background-position 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-switch .form-check-input {\n    transition: none;\n  }\n}\n.form-switch .form-check-input:focus {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgb%28187.8214285714, 190.9642857143, 239.6785714286%29'/%3e%3c/svg%3e\");\n}\n.form-switch .form-check-input:checked {\n  background-position: right center;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\");\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: 1rem;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n}\n.btn-check[disabled] + .btn, .btn-check:disabled + .btn {\n  pointer-events: none;\n  filter: none;\n  opacity: 0.65;\n}\n\n.form-range {\n  width: 100%;\n  height: 1.5rem;\n  padding: 0;\n  background-color: transparent;\n  appearance: none;\n}\n.form-range:focus {\n  outline: 0;\n}\n.form-range:focus::-webkit-slider-thumb {\n  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(84, 92, 216, 0.25);\n}\n.form-range:focus::-moz-range-thumb {\n  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(84, 92, 216, 0.25);\n}\n.form-range::-moz-focus-outer {\n  border: 0;\n}\n.form-range::-webkit-slider-thumb {\n  width: 1rem;\n  height: 1rem;\n  margin-top: -0.25rem;\n  background-color: #545cd8;\n  border: 0;\n  border-radius: 1rem;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  appearance: none;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-range::-webkit-slider-thumb {\n    transition: none;\n  }\n}\n.form-range::-webkit-slider-thumb:active {\n  background-color: rgb(203.7, 206.1, 243.3);\n}\n.form-range::-webkit-slider-runnable-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: #dee2e6;\n  border-color: transparent;\n  border-radius: 1rem;\n}\n.form-range::-moz-range-thumb {\n  width: 1rem;\n  height: 1rem;\n  background-color: #545cd8;\n  border: 0;\n  border-radius: 1rem;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  appearance: none;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-range::-moz-range-thumb {\n    transition: none;\n  }\n}\n.form-range::-moz-range-thumb:active {\n  background-color: rgb(203.7, 206.1, 243.3);\n}\n.form-range::-moz-range-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: #dee2e6;\n  border-color: transparent;\n  border-radius: 1rem;\n}\n.form-range:disabled {\n  pointer-events: none;\n}\n.form-range:disabled::-webkit-slider-thumb {\n  background-color: #adb5bd;\n}\n.form-range:disabled::-moz-range-thumb {\n  background-color: #adb5bd;\n}\n\n.form-floating {\n  position: relative;\n}\n.form-floating > .form-control,\n.form-floating > .form-select {\n  height: calc(3.5rem + 2px);\n  line-height: 1.25;\n}\n.form-floating > label {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  padding: 1rem 0.75rem;\n  pointer-events: none;\n  border: 1px solid transparent;\n  transform-origin: 0 0;\n  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-floating > label {\n    transition: none;\n  }\n}\n.form-floating > .form-control {\n  padding: 1rem 0.75rem;\n}\n.form-floating > .form-control::placeholder {\n  color: transparent;\n}\n.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown) {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-control:-webkit-autofill {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-select {\n  padding-top: 1.625rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-control:focus ~ label,\n.form-floating > .form-control:not(:placeholder-shown) ~ label,\n.form-floating > .form-select ~ label {\n  opacity: 0.65;\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n.form-floating > .form-control:-webkit-autofill ~ label {\n  opacity: 0.65;\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  width: 100%;\n}\n.input-group > .form-control,\n.input-group > .form-select {\n  position: relative;\n  flex: 1 1 auto;\n  width: 1%;\n  min-width: 0;\n}\n.input-group > .form-control:focus,\n.input-group > .form-select:focus {\n  z-index: 3;\n}\n.input-group .btn {\n  position: relative;\n  z-index: 2;\n}\n.input-group .btn:focus {\n  z-index: 3;\n}\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: 0.375rem 0.75rem;\n  font-size: 0.88rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  text-align: center;\n  white-space: nowrap;\n  background-color: rgb(239.3, 248.9225806452, 255);\n  border: 1px solid #ced4da;\n  border-radius: 0.25rem;\n}\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: 0.5rem 1rem;\n  font-size: 1.1rem;\n  border-radius: 0.3rem;\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.968rem;\n  border-radius: 0.2rem;\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: 3rem;\n}\n\n.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu),\n.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu),\n.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {\n  margin-left: -1px;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.valid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 0.875em;\n  color: #3ac47d;\n}\n\n.valid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.25rem 0.5rem;\n  margin-top: 0.1rem;\n  font-size: 0.968rem;\n  color: #000;\n  background-color: rgba(58, 196, 125, 0.9);\n  border-radius: 0.25rem;\n}\n\n.was-validated :valid ~ .valid-feedback,\n.was-validated :valid ~ .valid-tooltip,\n.is-valid ~ .valid-feedback,\n.is-valid ~ .valid-tooltip {\n  display: block;\n}\n\n.was-validated .form-control:valid, .form-control.is-valid {\n  border-color: #3ac47d;\n  padding-right: calc(1.5em + 0.75rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%233ac47d' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.1875rem) center;\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n.was-validated .form-control:valid:focus, .form-control.is-valid:focus {\n  border-color: #3ac47d;\n  box-shadow: 0 0 0 0.25rem rgba(58, 196, 125, 0.25);\n}\n\n.was-validated textarea.form-control:valid, textarea.form-control.is-valid {\n  padding-right: calc(1.5em + 0.75rem);\n  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);\n}\n\n.was-validated .form-select:valid, .form-select.is-valid {\n  border-color: #3ac47d;\n}\n.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size=\"1\"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size=\"1\"] {\n  padding-right: 4.125rem;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e\"), url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%233ac47d' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n  background-position: right 0.75rem center, center right 2.25rem;\n  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n.was-validated .form-select:valid:focus, .form-select.is-valid:focus {\n  border-color: #3ac47d;\n  box-shadow: 0 0 0 0.25rem rgba(58, 196, 125, 0.25);\n}\n\n.was-validated .form-check-input:valid, .form-check-input.is-valid {\n  border-color: #3ac47d;\n}\n.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {\n  background-color: #3ac47d;\n}\n.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {\n  box-shadow: 0 0 0 0.25rem rgba(58, 196, 125, 0.25);\n}\n.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {\n  color: #3ac47d;\n}\n\n.form-check-inline .form-check-input ~ .valid-feedback {\n  margin-left: 0.5em;\n}\n\n.was-validated .input-group .form-control:valid, .input-group .form-control.is-valid,\n.was-validated .input-group .form-select:valid,\n.input-group .form-select.is-valid {\n  z-index: 1;\n}\n.was-validated .input-group .form-control:valid:focus, .input-group .form-control.is-valid:focus,\n.was-validated .input-group .form-select:valid:focus,\n.input-group .form-select.is-valid:focus {\n  z-index: 3;\n}\n\n.invalid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 0.875em;\n  color: #d92550;\n}\n\n.invalid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.25rem 0.5rem;\n  margin-top: 0.1rem;\n  font-size: 0.968rem;\n  color: #fff;\n  background-color: rgba(217, 37, 80, 0.9);\n  border-radius: 0.25rem;\n}\n\n.was-validated :invalid ~ .invalid-feedback,\n.was-validated :invalid ~ .invalid-tooltip,\n.is-invalid ~ .invalid-feedback,\n.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n\n.was-validated .form-control:invalid, .form-control.is-invalid {\n  border-color: #d92550;\n  padding-right: calc(1.5em + 0.75rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23d92550'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23d92550' stroke='none'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.1875rem) center;\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {\n  border-color: #d92550;\n  box-shadow: 0 0 0 0.25rem rgba(217, 37, 80, 0.25);\n}\n\n.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {\n  padding-right: calc(1.5em + 0.75rem);\n  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);\n}\n\n.was-validated .form-select:invalid, .form-select.is-invalid {\n  border-color: #d92550;\n}\n.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size=\"1\"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size=\"1\"] {\n  padding-right: 4.125rem;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e\"), url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23d92550'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23d92550' stroke='none'/%3e%3c/svg%3e\");\n  background-position: right 0.75rem center, center right 2.25rem;\n  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {\n  border-color: #d92550;\n  box-shadow: 0 0 0 0.25rem rgba(217, 37, 80, 0.25);\n}\n\n.was-validated .form-check-input:invalid, .form-check-input.is-invalid {\n  border-color: #d92550;\n}\n.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {\n  background-color: #d92550;\n}\n.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {\n  box-shadow: 0 0 0 0.25rem rgba(217, 37, 80, 0.25);\n}\n.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {\n  color: #d92550;\n}\n\n.form-check-inline .form-check-input ~ .invalid-feedback {\n  margin-left: 0.5em;\n}\n\n.was-validated .input-group .form-control:invalid, .input-group .form-control.is-invalid,\n.was-validated .input-group .form-select:invalid,\n.input-group .form-select.is-invalid {\n  z-index: 2;\n}\n.was-validated .input-group .form-control:invalid:focus, .input-group .form-control.is-invalid:focus,\n.was-validated .input-group .form-select:invalid:focus,\n.input-group .form-select.is-invalid:focus {\n  z-index: 3;\n}\n\n.btn {\n  display: inline-block;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  text-align: center;\n  text-decoration: none;\n  vertical-align: middle;\n  cursor: pointer;\n  user-select: none;\n  background-color: transparent;\n  border: 1px solid transparent;\n  padding: 0.375rem 0.75rem;\n  font-size: 0.88rem;\n  border-radius: 0.25rem;\n  transition: color 0.15s, background-color 0.15s, border-color 0.15s, box-shadow 0.15s;\n}\n@media (prefers-reduced-motion: reduce) {\n  .btn {\n    transition: none;\n  }\n}\n.btn:hover {\n  color: #495057;\n}\n.btn-check:focus + .btn, .btn:focus {\n  outline: 0;\n  box-shadow: none;\n}\n.btn:disabled, .btn.disabled, fieldset:disabled .btn {\n  pointer-events: none;\n  opacity: 0.65;\n}\n\n.btn-primary {\n  color: #fff;\n  background-color: #545cd8;\n  border-color: #545cd8;\n}\n.btn-primary:hover {\n  color: #fff;\n  background-color: rgb(71.4, 78.2, 183.6);\n  border-color: rgb(67.2, 73.6, 172.8);\n}\n.btn-check:focus + .btn-primary, .btn-primary:focus {\n  color: #fff;\n  background-color: rgb(71.4, 78.2, 183.6);\n  border-color: rgb(67.2, 73.6, 172.8);\n  box-shadow: 0 0 0 0 rgba(109.65, 116.45, 221.85, 0.5);\n}\n.btn-check:checked + .btn-primary, .btn-check:active + .btn-primary, .btn-primary:active, .btn-primary.active, .show > .btn-primary.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(67.2, 73.6, 172.8);\n  border-color: #3f45a2;\n}\n.btn-check:checked + .btn-primary:focus, .btn-check:active + .btn-primary:focus, .btn-primary:active:focus, .btn-primary.active:focus, .show > .btn-primary.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(109.65, 116.45, 221.85, 0.5);\n}\n.btn-primary:disabled, .btn-primary.disabled {\n  color: #fff;\n  background-color: #545cd8;\n  border-color: #545cd8;\n}\n\n.btn-secondary {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-secondary:hover {\n  color: #fff;\n  background-color: rgb(91.8, 99.45, 106.25);\n  border-color: rgb(86.4, 93.6, 100);\n}\n.btn-check:focus + .btn-secondary, .btn-secondary:focus {\n  color: #fff;\n  background-color: rgb(91.8, 99.45, 106.25);\n  border-color: rgb(86.4, 93.6, 100);\n  box-shadow: 0 0 0 0 rgba(130.05, 137.7, 144.5, 0.5);\n}\n.btn-check:checked + .btn-secondary, .btn-check:active + .btn-secondary, .btn-secondary:active, .btn-secondary.active, .show > .btn-secondary.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(86.4, 93.6, 100);\n  border-color: rgb(81, 87.75, 93.75);\n}\n.btn-check:checked + .btn-secondary:focus, .btn-check:active + .btn-secondary:focus, .btn-secondary:active:focus, .btn-secondary.active:focus, .show > .btn-secondary.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(130.05, 137.7, 144.5, 0.5);\n}\n.btn-secondary:disabled, .btn-secondary.disabled {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n\n.btn-success {\n  color: #000;\n  background-color: #3ac47d;\n  border-color: #3ac47d;\n}\n.btn-success:hover {\n  color: #000;\n  background-color: rgb(87.55, 204.85, 144.5);\n  border-color: rgb(77.7, 201.9, 138);\n}\n.btn-check:focus + .btn-success, .btn-success:focus {\n  color: #000;\n  background-color: rgb(87.55, 204.85, 144.5);\n  border-color: rgb(77.7, 201.9, 138);\n  box-shadow: 0 0 0 0 rgba(49.3, 166.6, 106.25, 0.5);\n}\n.btn-check:checked + .btn-success, .btn-check:active + .btn-success, .btn-success:active, .btn-success.active, .show > .btn-success.dropdown-toggle {\n  color: #000;\n  background-color: rgb(97.4, 207.8, 151);\n  border-color: rgb(77.7, 201.9, 138);\n}\n.btn-check:checked + .btn-success:focus, .btn-check:active + .btn-success:focus, .btn-success:active:focus, .btn-success.active:focus, .show > .btn-success.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(49.3, 166.6, 106.25, 0.5);\n}\n.btn-success:disabled, .btn-success.disabled {\n  color: #000;\n  background-color: #3ac47d;\n  border-color: #3ac47d;\n}\n\n.btn-info {\n  color: #000;\n  background-color: #30b1ff;\n  border-color: #30b1ff;\n}\n.btn-info:hover {\n  color: #000;\n  background-color: rgb(79.05, 188.7, 255);\n  border-color: rgb(68.7, 184.8, 255);\n}\n.btn-check:focus + .btn-info, .btn-info:focus {\n  color: #000;\n  background-color: rgb(79.05, 188.7, 255);\n  border-color: rgb(68.7, 184.8, 255);\n  box-shadow: 0 0 0 0 rgba(40.8, 150.45, 216.75, 0.5);\n}\n.btn-check:checked + .btn-info, .btn-check:active + .btn-info, .btn-info:active, .btn-info.active, .show > .btn-info.dropdown-toggle {\n  color: #000;\n  background-color: rgb(89.4, 192.6, 255);\n  border-color: rgb(68.7, 184.8, 255);\n}\n.btn-check:checked + .btn-info:focus, .btn-check:active + .btn-info:focus, .btn-info:active:focus, .btn-info.active:focus, .show > .btn-info.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(40.8, 150.45, 216.75, 0.5);\n}\n.btn-info:disabled, .btn-info.disabled {\n  color: #000;\n  background-color: #30b1ff;\n  border-color: #30b1ff;\n}\n\n.btn-warning {\n  color: #000;\n  background-color: #f7b924;\n  border-color: #f7b924;\n}\n.btn-warning:hover {\n  color: #000;\n  background-color: rgb(248.2, 195.5, 68.85);\n  border-color: rgb(247.8, 192, 57.9);\n}\n.btn-check:focus + .btn-warning, .btn-warning:focus {\n  color: #000;\n  background-color: rgb(248.2, 195.5, 68.85);\n  border-color: rgb(247.8, 192, 57.9);\n  box-shadow: 0 0 0 0 rgba(209.95, 157.25, 30.6, 0.5);\n}\n.btn-check:checked + .btn-warning, .btn-check:active + .btn-warning, .btn-warning:active, .btn-warning.active, .show > .btn-warning.dropdown-toggle {\n  color: #000;\n  background-color: rgb(248.6, 199, 79.8);\n  border-color: rgb(247.8, 192, 57.9);\n}\n.btn-check:checked + .btn-warning:focus, .btn-check:active + .btn-warning:focus, .btn-warning:active:focus, .btn-warning.active:focus, .show > .btn-warning.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(209.95, 157.25, 30.6, 0.5);\n}\n.btn-warning:disabled, .btn-warning.disabled {\n  color: #000;\n  background-color: #f7b924;\n  border-color: #f7b924;\n}\n\n.btn-danger {\n  color: #fff;\n  background-color: #d92550;\n  border-color: #d92550;\n}\n.btn-danger:hover {\n  color: #fff;\n  background-color: rgb(184.45, 31.45, 68);\n  border-color: rgb(173.6, 29.6, 64);\n}\n.btn-check:focus + .btn-danger, .btn-danger:focus {\n  color: #fff;\n  background-color: rgb(184.45, 31.45, 68);\n  border-color: rgb(173.6, 29.6, 64);\n  box-shadow: 0 0 0 0 rgba(222.7, 69.7, 106.25, 0.5);\n}\n.btn-check:checked + .btn-danger, .btn-check:active + .btn-danger, .btn-danger:active, .btn-danger.active, .show > .btn-danger.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(173.6, 29.6, 64);\n  border-color: rgb(162.75, 27.75, 60);\n}\n.btn-check:checked + .btn-danger:focus, .btn-check:active + .btn-danger:focus, .btn-danger:active:focus, .btn-danger.active:focus, .show > .btn-danger.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(222.7, 69.7, 106.25, 0.5);\n}\n.btn-danger:disabled, .btn-danger.disabled {\n  color: #fff;\n  background-color: #d92550;\n  border-color: #d92550;\n}\n\n.btn-light {\n  color: #000;\n  background-color: #eeeeee;\n  border-color: #eeeeee;\n}\n.btn-light:hover {\n  color: #000;\n  background-color: rgb(240.55, 240.55, 240.55);\n  border-color: rgb(239.7, 239.7, 239.7);\n}\n.btn-check:focus + .btn-light, .btn-light:focus {\n  color: #000;\n  background-color: rgb(240.55, 240.55, 240.55);\n  border-color: rgb(239.7, 239.7, 239.7);\n  box-shadow: 0 0 0 0 rgba(202.3, 202.3, 202.3, 0.5);\n}\n.btn-check:checked + .btn-light, .btn-check:active + .btn-light, .btn-light:active, .btn-light.active, .show > .btn-light.dropdown-toggle {\n  color: #000;\n  background-color: rgb(241.4, 241.4, 241.4);\n  border-color: rgb(239.7, 239.7, 239.7);\n}\n.btn-check:checked + .btn-light:focus, .btn-check:active + .btn-light:focus, .btn-light:active:focus, .btn-light.active:focus, .show > .btn-light.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(202.3, 202.3, 202.3, 0.5);\n}\n.btn-light:disabled, .btn-light.disabled {\n  color: #000;\n  background-color: #eeeeee;\n  border-color: #eeeeee;\n}\n\n.btn-dark {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #343a40;\n}\n.btn-dark:hover {\n  color: #fff;\n  background-color: rgb(44.2, 49.3, 54.4);\n  border-color: rgb(41.6, 46.4, 51.2);\n}\n.btn-check:focus + .btn-dark, .btn-dark:focus {\n  color: #fff;\n  background-color: rgb(44.2, 49.3, 54.4);\n  border-color: rgb(41.6, 46.4, 51.2);\n  box-shadow: 0 0 0 0 rgba(82.45, 87.55, 92.65, 0.5);\n}\n.btn-check:checked + .btn-dark, .btn-check:active + .btn-dark, .btn-dark:active, .btn-dark.active, .show > .btn-dark.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(41.6, 46.4, 51.2);\n  border-color: rgb(39, 43.5, 48);\n}\n.btn-check:checked + .btn-dark:focus, .btn-check:active + .btn-dark:focus, .btn-dark:active:focus, .btn-dark.active:focus, .show > .btn-dark.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(82.45, 87.55, 92.65, 0.5);\n}\n.btn-dark:disabled, .btn-dark.disabled {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #343a40;\n}\n\n.btn-focus {\n  color: #fff;\n  background-color: #444054;\n  border-color: #444054;\n}\n.btn-focus:hover {\n  color: #fff;\n  background-color: rgb(57.8, 54.4, 71.4);\n  border-color: rgb(54.4, 51.2, 67.2);\n}\n.btn-check:focus + .btn-focus, .btn-focus:focus {\n  color: #fff;\n  background-color: rgb(57.8, 54.4, 71.4);\n  border-color: rgb(54.4, 51.2, 67.2);\n  box-shadow: 0 0 0 0 rgba(96.05, 92.65, 109.65, 0.5);\n}\n.btn-check:checked + .btn-focus, .btn-check:active + .btn-focus, .btn-focus:active, .btn-focus.active, .show > .btn-focus.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(54.4, 51.2, 67.2);\n  border-color: #33303f;\n}\n.btn-check:checked + .btn-focus:focus, .btn-check:active + .btn-focus:focus, .btn-focus:active:focus, .btn-focus.active:focus, .show > .btn-focus.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(96.05, 92.65, 109.65, 0.5);\n}\n.btn-focus:disabled, .btn-focus.disabled {\n  color: #fff;\n  background-color: #444054;\n  border-color: #444054;\n}\n\n.btn-alternate {\n  color: #fff;\n  background-color: #83588a;\n  border-color: #83588a;\n}\n.btn-alternate:hover {\n  color: #fff;\n  background-color: rgb(111.35, 74.8, 117.3);\n  border-color: rgb(104.8, 70.4, 110.4);\n}\n.btn-check:focus + .btn-alternate, .btn-alternate:focus {\n  color: #fff;\n  background-color: rgb(111.35, 74.8, 117.3);\n  border-color: rgb(104.8, 70.4, 110.4);\n  box-shadow: 0 0 0 0 rgba(149.6, 113.05, 155.55, 0.5);\n}\n.btn-check:checked + .btn-alternate, .btn-check:active + .btn-alternate, .btn-alternate:active, .btn-alternate.active, .show > .btn-alternate.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(104.8, 70.4, 110.4);\n  border-color: rgb(98.25, 66, 103.5);\n}\n.btn-check:checked + .btn-alternate:focus, .btn-check:active + .btn-alternate:focus, .btn-alternate:active:focus, .btn-alternate.active:focus, .show > .btn-alternate.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(149.6, 113.05, 155.55, 0.5);\n}\n.btn-alternate:disabled, .btn-alternate.disabled {\n  color: #fff;\n  background-color: #83588a;\n  border-color: #83588a;\n}\n\n.btn-outline-primary {\n  color: #545cd8;\n  border-color: #545cd8;\n}\n.btn-outline-primary:hover {\n  color: #fff;\n  background-color: #545cd8;\n  border-color: #545cd8;\n}\n.btn-check:focus + .btn-outline-primary, .btn-outline-primary:focus {\n  box-shadow: 0 0 0 0 rgba(84, 92, 216, 0.5);\n}\n.btn-check:checked + .btn-outline-primary, .btn-check:active + .btn-outline-primary, .btn-outline-primary:active, .btn-outline-primary.active, .btn-outline-primary.dropdown-toggle.show {\n  color: #fff;\n  background-color: #545cd8;\n  border-color: #545cd8;\n}\n.btn-check:checked + .btn-outline-primary:focus, .btn-check:active + .btn-outline-primary:focus, .btn-outline-primary:active:focus, .btn-outline-primary.active:focus, .btn-outline-primary.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(84, 92, 216, 0.5);\n}\n.btn-outline-primary:disabled, .btn-outline-primary.disabled {\n  color: #545cd8;\n  background-color: transparent;\n}\n\n.btn-outline-secondary {\n  color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-outline-secondary:hover {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-check:focus + .btn-outline-secondary, .btn-outline-secondary:focus {\n  box-shadow: 0 0 0 0 rgba(108, 117, 125, 0.5);\n}\n.btn-check:checked + .btn-outline-secondary, .btn-check:active + .btn-outline-secondary, .btn-outline-secondary:active, .btn-outline-secondary.active, .btn-outline-secondary.dropdown-toggle.show {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-check:checked + .btn-outline-secondary:focus, .btn-check:active + .btn-outline-secondary:focus, .btn-outline-secondary:active:focus, .btn-outline-secondary.active:focus, .btn-outline-secondary.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(108, 117, 125, 0.5);\n}\n.btn-outline-secondary:disabled, .btn-outline-secondary.disabled {\n  color: #6c757d;\n  background-color: transparent;\n}\n\n.btn-outline-success {\n  color: #3ac47d;\n  border-color: #3ac47d;\n}\n.btn-outline-success:hover {\n  color: #000;\n  background-color: #3ac47d;\n  border-color: #3ac47d;\n}\n.btn-check:focus + .btn-outline-success, .btn-outline-success:focus {\n  box-shadow: 0 0 0 0 rgba(58, 196, 125, 0.5);\n}\n.btn-check:checked + .btn-outline-success, .btn-check:active + .btn-outline-success, .btn-outline-success:active, .btn-outline-success.active, .btn-outline-success.dropdown-toggle.show {\n  color: #000;\n  background-color: #3ac47d;\n  border-color: #3ac47d;\n}\n.btn-check:checked + .btn-outline-success:focus, .btn-check:active + .btn-outline-success:focus, .btn-outline-success:active:focus, .btn-outline-success.active:focus, .btn-outline-success.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(58, 196, 125, 0.5);\n}\n.btn-outline-success:disabled, .btn-outline-success.disabled {\n  color: #3ac47d;\n  background-color: transparent;\n}\n\n.btn-outline-info {\n  color: #30b1ff;\n  border-color: #30b1ff;\n}\n.btn-outline-info:hover {\n  color: #000;\n  background-color: #30b1ff;\n  border-color: #30b1ff;\n}\n.btn-check:focus + .btn-outline-info, .btn-outline-info:focus {\n  box-shadow: 0 0 0 0 rgba(48, 177, 255, 0.5);\n}\n.btn-check:checked + .btn-outline-info, .btn-check:active + .btn-outline-info, .btn-outline-info:active, .btn-outline-info.active, .btn-outline-info.dropdown-toggle.show {\n  color: #000;\n  background-color: #30b1ff;\n  border-color: #30b1ff;\n}\n.btn-check:checked + .btn-outline-info:focus, .btn-check:active + .btn-outline-info:focus, .btn-outline-info:active:focus, .btn-outline-info.active:focus, .btn-outline-info.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(48, 177, 255, 0.5);\n}\n.btn-outline-info:disabled, .btn-outline-info.disabled {\n  color: #30b1ff;\n  background-color: transparent;\n}\n\n.btn-outline-warning {\n  color: #f7b924;\n  border-color: #f7b924;\n}\n.btn-outline-warning:hover {\n  color: #000;\n  background-color: #f7b924;\n  border-color: #f7b924;\n}\n.btn-check:focus + .btn-outline-warning, .btn-outline-warning:focus {\n  box-shadow: 0 0 0 0 rgba(247, 185, 36, 0.5);\n}\n.btn-check:checked + .btn-outline-warning, .btn-check:active + .btn-outline-warning, .btn-outline-warning:active, .btn-outline-warning.active, .btn-outline-warning.dropdown-toggle.show {\n  color: #000;\n  background-color: #f7b924;\n  border-color: #f7b924;\n}\n.btn-check:checked + .btn-outline-warning:focus, .btn-check:active + .btn-outline-warning:focus, .btn-outline-warning:active:focus, .btn-outline-warning.active:focus, .btn-outline-warning.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(247, 185, 36, 0.5);\n}\n.btn-outline-warning:disabled, .btn-outline-warning.disabled {\n  color: #f7b924;\n  background-color: transparent;\n}\n\n.btn-outline-danger {\n  color: #d92550;\n  border-color: #d92550;\n}\n.btn-outline-danger:hover {\n  color: #fff;\n  background-color: #d92550;\n  border-color: #d92550;\n}\n.btn-check:focus + .btn-outline-danger, .btn-outline-danger:focus {\n  box-shadow: 0 0 0 0 rgba(217, 37, 80, 0.5);\n}\n.btn-check:checked + .btn-outline-danger, .btn-check:active + .btn-outline-danger, .btn-outline-danger:active, .btn-outline-danger.active, .btn-outline-danger.dropdown-toggle.show {\n  color: #fff;\n  background-color: #d92550;\n  border-color: #d92550;\n}\n.btn-check:checked + .btn-outline-danger:focus, .btn-check:active + .btn-outline-danger:focus, .btn-outline-danger:active:focus, .btn-outline-danger.active:focus, .btn-outline-danger.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(217, 37, 80, 0.5);\n}\n.btn-outline-danger:disabled, .btn-outline-danger.disabled {\n  color: #d92550;\n  background-color: transparent;\n}\n\n.btn-outline-light {\n  color: #eeeeee;\n  border-color: #eeeeee;\n}\n.btn-outline-light:hover {\n  color: #000;\n  background-color: #eeeeee;\n  border-color: #eeeeee;\n}\n.btn-check:focus + .btn-outline-light, .btn-outline-light:focus {\n  box-shadow: 0 0 0 0 rgba(238, 238, 238, 0.5);\n}\n.btn-check:checked + .btn-outline-light, .btn-check:active + .btn-outline-light, .btn-outline-light:active, .btn-outline-light.active, .btn-outline-light.dropdown-toggle.show {\n  color: #000;\n  background-color: #eeeeee;\n  border-color: #eeeeee;\n}\n.btn-check:checked + .btn-outline-light:focus, .btn-check:active + .btn-outline-light:focus, .btn-outline-light:active:focus, .btn-outline-light.active:focus, .btn-outline-light.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(238, 238, 238, 0.5);\n}\n.btn-outline-light:disabled, .btn-outline-light.disabled {\n  color: #eeeeee;\n  background-color: transparent;\n}\n\n.btn-outline-dark {\n  color: #343a40;\n  border-color: #343a40;\n}\n.btn-outline-dark:hover {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #343a40;\n}\n.btn-check:focus + .btn-outline-dark, .btn-outline-dark:focus {\n  box-shadow: 0 0 0 0 rgba(52, 58, 64, 0.5);\n}\n.btn-check:checked + .btn-outline-dark, .btn-check:active + .btn-outline-dark, .btn-outline-dark:active, .btn-outline-dark.active, .btn-outline-dark.dropdown-toggle.show {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #343a40;\n}\n.btn-check:checked + .btn-outline-dark:focus, .btn-check:active + .btn-outline-dark:focus, .btn-outline-dark:active:focus, .btn-outline-dark.active:focus, .btn-outline-dark.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(52, 58, 64, 0.5);\n}\n.btn-outline-dark:disabled, .btn-outline-dark.disabled {\n  color: #343a40;\n  background-color: transparent;\n}\n\n.btn-outline-focus {\n  color: #444054;\n  border-color: #444054;\n}\n.btn-outline-focus:hover {\n  color: #fff;\n  background-color: #444054;\n  border-color: #444054;\n}\n.btn-check:focus + .btn-outline-focus, .btn-outline-focus:focus {\n  box-shadow: 0 0 0 0 rgba(68, 64, 84, 0.5);\n}\n.btn-check:checked + .btn-outline-focus, .btn-check:active + .btn-outline-focus, .btn-outline-focus:active, .btn-outline-focus.active, .btn-outline-focus.dropdown-toggle.show {\n  color: #fff;\n  background-color: #444054;\n  border-color: #444054;\n}\n.btn-check:checked + .btn-outline-focus:focus, .btn-check:active + .btn-outline-focus:focus, .btn-outline-focus:active:focus, .btn-outline-focus.active:focus, .btn-outline-focus.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(68, 64, 84, 0.5);\n}\n.btn-outline-focus:disabled, .btn-outline-focus.disabled {\n  color: #444054;\n  background-color: transparent;\n}\n\n.btn-outline-alternate {\n  color: #83588a;\n  border-color: #83588a;\n}\n.btn-outline-alternate:hover {\n  color: #fff;\n  background-color: #83588a;\n  border-color: #83588a;\n}\n.btn-check:focus + .btn-outline-alternate, .btn-outline-alternate:focus {\n  box-shadow: 0 0 0 0 rgba(131, 88, 138, 0.5);\n}\n.btn-check:checked + .btn-outline-alternate, .btn-check:active + .btn-outline-alternate, .btn-outline-alternate:active, .btn-outline-alternate.active, .btn-outline-alternate.dropdown-toggle.show {\n  color: #fff;\n  background-color: #83588a;\n  border-color: #83588a;\n}\n.btn-check:checked + .btn-outline-alternate:focus, .btn-check:active + .btn-outline-alternate:focus, .btn-outline-alternate:active:focus, .btn-outline-alternate.active:focus, .btn-outline-alternate.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(131, 88, 138, 0.5);\n}\n.btn-outline-alternate:disabled, .btn-outline-alternate.disabled {\n  color: #83588a;\n  background-color: transparent;\n}\n\n.btn-link {\n  font-weight: 400;\n  color: #545cd8;\n  text-decoration: underline;\n}\n.btn-link:hover {\n  color: rgb(67.2, 73.6, 172.8);\n}\n.btn-link:disabled, .btn-link.disabled {\n  color: #6c757d;\n}\n\n.btn-lg, .btn-group-lg > .btn {\n  padding: 0.5rem 1rem;\n  font-size: 1.1rem;\n  border-radius: 0.3rem;\n}\n\n.btn-sm, .btn-group-sm > .btn {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.968rem;\n  border-radius: 0.2rem;\n}\n\n.fade {\n  transition: opacity 0.15s linear;\n}\n@media (prefers-reduced-motion: reduce) {\n  .fade {\n    transition: none;\n  }\n}\n.fade:not(.show) {\n  opacity: 0;\n}\n\n.collapse:not(.show) {\n  display: none;\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  transition: height 0.35s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .collapsing {\n    transition: none;\n  }\n}\n\n.dropup,\n.dropend,\n.dropdown,\n.dropstart {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n}\n.dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0;\n  border-left: 0.3em solid transparent;\n}\n.dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropdown-menu {\n  position: absolute;\n  z-index: 1000;\n  display: none;\n  min-width: 15rem;\n  padding: 0.65rem 0;\n  margin: 0;\n  font-size: 0.88rem;\n  color: #495057;\n  text-align: left;\n  list-style: none;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.25rem;\n}\n.dropdown-menu[data-bs-popper] {\n  top: 100%;\n  left: 0;\n  margin-top: 0.125rem;\n}\n\n.dropdown-menu-start {\n  --bs-position: start;\n}\n.dropdown-menu-start[data-bs-popper] {\n  right: auto;\n  left: 0;\n}\n\n.dropdown-menu-end {\n  --bs-position: end;\n}\n.dropdown-menu-end[data-bs-popper] {\n  right: 0;\n  left: auto;\n}\n\n@media (min-width: 576px) {\n  .dropdown-menu-sm-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-sm-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-sm-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-sm-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 768px) {\n  .dropdown-menu-md-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-md-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-md-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-md-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 992px) {\n  .dropdown-menu-lg-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-lg-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-lg-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-lg-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 1200px) {\n  .dropdown-menu-xl-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-xl-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-xl-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-xl-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 1400px) {\n  .dropdown-menu-xxl-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-xxl-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-xxl-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-xxl-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n.dropup .dropdown-menu[data-bs-popper] {\n  top: auto;\n  bottom: 100%;\n  margin-top: 0;\n  margin-bottom: 0.125rem;\n}\n.dropup .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0.3em solid;\n  border-left: 0.3em solid transparent;\n}\n.dropup .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropend .dropdown-menu[data-bs-popper] {\n  top: 0;\n  right: auto;\n  left: 100%;\n  margin-top: 0;\n  margin-left: 0.125rem;\n}\n.dropend .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0;\n  border-bottom: 0.3em solid transparent;\n  border-left: 0.3em solid;\n}\n.dropend .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n.dropend .dropdown-toggle::after {\n  vertical-align: 0;\n}\n\n.dropstart .dropdown-menu[data-bs-popper] {\n  top: 0;\n  right: 100%;\n  left: auto;\n  margin-top: 0;\n  margin-right: 0.125rem;\n}\n.dropstart .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n}\n.dropstart .dropdown-toggle::after {\n  display: none;\n}\n.dropstart .dropdown-toggle::before {\n  display: inline-block;\n  margin-right: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0.3em solid;\n  border-bottom: 0.3em solid transparent;\n}\n.dropstart .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n.dropstart .dropdown-toggle::before {\n  vertical-align: 0;\n}\n\n.dropdown-divider {\n  height: 0;\n  margin: 0.5rem 0;\n  overflow: hidden;\n  border-top: 1px solid rgba(0, 0, 0, 0.15);\n}\n\n.dropdown-item {\n  display: block;\n  width: 100%;\n  padding: 0.4rem 1rem;\n  clear: both;\n  font-weight: 400;\n  color: #212529;\n  text-align: inherit;\n  text-decoration: none;\n  white-space: nowrap;\n  background-color: transparent;\n  border: 0;\n}\n.dropdown-item:hover, .dropdown-item:focus {\n  color: rgb(29.7, 33.3, 36.9);\n  background-color: #e0f3ff;\n}\n.dropdown-item.active, .dropdown-item:active {\n  color: #fff;\n  text-decoration: none;\n  background-color: #545cd8;\n}\n.dropdown-item.disabled, .dropdown-item:disabled {\n  color: #adb5bd;\n  pointer-events: none;\n  background-color: transparent;\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n.dropdown-header {\n  display: block;\n  padding: 0.65rem 1rem;\n  margin-bottom: 0;\n  font-size: 0.968rem;\n  color: #6c757d;\n  white-space: nowrap;\n}\n\n.dropdown-item-text {\n  display: block;\n  padding: 0.4rem 1rem;\n  color: #212529;\n}\n\n.dropdown-menu-dark {\n  color: #dee2e6;\n  background-color: #343a40;\n  border-color: rgba(0, 0, 0, 0.15);\n}\n.dropdown-menu-dark .dropdown-item {\n  color: #dee2e6;\n}\n.dropdown-menu-dark .dropdown-item:hover, .dropdown-menu-dark .dropdown-item:focus {\n  color: #fff;\n  background-color: rgba(255, 255, 255, 0.15);\n}\n.dropdown-menu-dark .dropdown-item.active, .dropdown-menu-dark .dropdown-item:active {\n  color: #fff;\n  background-color: #545cd8;\n}\n.dropdown-menu-dark .dropdown-item.disabled, .dropdown-menu-dark .dropdown-item:disabled {\n  color: #adb5bd;\n}\n.dropdown-menu-dark .dropdown-divider {\n  border-color: rgba(0, 0, 0, 0.15);\n}\n.dropdown-menu-dark .dropdown-item-text {\n  color: #dee2e6;\n}\n.dropdown-menu-dark .dropdown-header {\n  color: #adb5bd;\n}\n\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle;\n}\n.btn-group > .btn,\n.btn-group-vertical > .btn {\n  position: relative;\n  flex: 1 1 auto;\n}\n.btn-group > .btn-check:checked + .btn,\n.btn-group > .btn-check:focus + .btn,\n.btn-group > .btn:hover,\n.btn-group > .btn:focus,\n.btn-group > .btn:active,\n.btn-group > .btn.active,\n.btn-group-vertical > .btn-check:checked + .btn,\n.btn-group-vertical > .btn-check:focus + .btn,\n.btn-group-vertical > .btn:hover,\n.btn-group-vertical > .btn:focus,\n.btn-group-vertical > .btn:active,\n.btn-group-vertical > .btn.active {\n  z-index: 1;\n}\n\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n}\n.btn-toolbar .input-group {\n  width: auto;\n}\n\n.btn-group > .btn:not(:first-child),\n.btn-group > .btn-group:not(:first-child) {\n  margin-left: -1px;\n}\n.btn-group > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group > .btn-group:not(:last-child) > .btn {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.btn-group > .btn:nth-child(n+3),\n.btn-group > :not(.btn-check) + .btn,\n.btn-group > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.dropdown-toggle-split {\n  padding-right: 0.5625rem;\n  padding-left: 0.5625rem;\n}\n.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {\n  margin-left: 0;\n}\n.dropstart .dropdown-toggle-split::before {\n  margin-right: 0;\n}\n\n.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {\n  padding-right: 0.375rem;\n  padding-left: 0.375rem;\n}\n\n.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {\n  padding-right: 0.75rem;\n  padding-left: 0.75rem;\n}\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n}\n.btn-group-vertical > .btn,\n.btn-group-vertical > .btn-group {\n  width: 100%;\n}\n.btn-group-vertical > .btn:not(:first-child),\n.btn-group-vertical > .btn-group:not(:first-child) {\n  margin-top: -1px;\n}\n.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group-vertical > .btn-group:not(:last-child) > .btn {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.btn-group-vertical > .btn ~ .btn,\n.btn-group-vertical > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.nav {\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: 0.5rem 1rem;\n  color: #545cd8;\n  text-decoration: none;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .nav-link {\n    transition: none;\n  }\n}\n.nav-link:hover, .nav-link:focus {\n  color: rgb(67.2, 73.6, 172.8);\n}\n.nav-link.disabled {\n  color: #6c757d;\n  pointer-events: none;\n  cursor: default;\n}\n\n.nav-tabs {\n  border-bottom: 1px solid #dee2e6;\n}\n.nav-tabs .nav-link {\n  margin-bottom: -1px;\n  background: none;\n  border: 1px solid transparent;\n  border-top-left-radius: 0.25rem;\n  border-top-right-radius: 0.25rem;\n}\n.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {\n  border-color: #e9ecef #e9ecef #dee2e6;\n  isolation: isolate;\n}\n.nav-tabs .nav-link.disabled {\n  color: #6c757d;\n  background-color: transparent;\n  border-color: transparent;\n}\n.nav-tabs .nav-link.active,\n.nav-tabs .nav-item.show .nav-link {\n  color: #495057;\n  background-color: #fff;\n  border-color: #dee2e6 #dee2e6 #fff;\n}\n.nav-tabs .dropdown-menu {\n  margin-top: -1px;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.nav-pills .nav-link {\n  background: none;\n  border: 0;\n  border-radius: 0.25rem;\n}\n.nav-pills .nav-link.active,\n.nav-pills .show > .nav-link {\n  color: #fff;\n  background-color: #545cd8;\n}\n\n.nav-fill > .nav-link,\n.nav-fill .nav-item {\n  flex: 1 1 auto;\n  text-align: center;\n}\n\n.nav-justified > .nav-link,\n.nav-justified .nav-item {\n  flex-basis: 0;\n  flex-grow: 1;\n  text-align: center;\n}\n\n.nav-fill .nav-item .nav-link,\n.nav-justified .nav-item .nav-link {\n  width: 100%;\n}\n\n.tab-content > .tab-pane {\n  display: none;\n}\n.tab-content > .active {\n  display: block;\n}\n\n.err-select {\n  border: 1px solid #d92550;\n}\n\n.navbar {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n.navbar > .container, .navbar > .body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper, .navbar > .body-tabs.body-tabs-layout.body-tabs-big,\n.navbar > .container-fluid,\n.navbar > .container-sm,\n.navbar > .container-md,\n.navbar > .container-lg,\n.navbar > .container-xl,\n.navbar > .container-xxl {\n  display: flex;\n  flex-wrap: inherit;\n  align-items: center;\n  justify-content: space-between;\n}\n.navbar-brand {\n  padding-top: 0.335rem;\n  padding-bottom: 0.335rem;\n  margin-right: 1rem;\n  font-size: 1.1rem;\n  text-decoration: none;\n  white-space: nowrap;\n}\n.navbar-nav {\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n.navbar-nav .nav-link {\n  padding-right: 0;\n  padding-left: 0;\n}\n.navbar-nav .dropdown-menu {\n  position: static;\n}\n\n.navbar-text {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  align-items: center;\n}\n\n.navbar-toggler {\n  padding: 0.25rem 0.75rem;\n  font-size: 1.1rem;\n  line-height: 1;\n  background-color: transparent;\n  border: 1px solid transparent;\n  border-radius: 0.25rem;\n  transition: box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .navbar-toggler {\n    transition: none;\n  }\n}\n.navbar-toggler:hover {\n  text-decoration: none;\n}\n.navbar-toggler:focus {\n  text-decoration: none;\n  outline: 0;\n  box-shadow: 0 0 0 0;\n}\n\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--bs-scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n@media (min-width: 576px) {\n  .navbar-expand-sm {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-sm .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-sm .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-sm .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n  .navbar-expand-sm .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-sm .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-sm .navbar-toggler {\n    display: none;\n  }\n}\n@media (min-width: 768px) {\n  .navbar-expand-md {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-md .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-md .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-md .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n  .navbar-expand-md .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-md .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-md .navbar-toggler {\n    display: none;\n  }\n}\n@media (min-width: 992px) {\n  .navbar-expand-lg {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-lg .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-lg .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-lg .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n  .navbar-expand-lg .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-lg .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-lg .navbar-toggler {\n    display: none;\n  }\n}\n@media (min-width: 1200px) {\n  .navbar-expand-xl {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-xl .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-xl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-xl .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n  .navbar-expand-xl .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-xl .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-xl .navbar-toggler {\n    display: none;\n  }\n}\n@media (min-width: 1400px) {\n  .navbar-expand-xxl {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-xxl .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-xxl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-xxl .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n  .navbar-expand-xxl .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-xxl .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-xxl .navbar-toggler {\n    display: none;\n  }\n}\n.navbar-expand {\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n}\n.navbar-expand .navbar-nav {\n  flex-direction: row;\n}\n.navbar-expand .navbar-nav .dropdown-menu {\n  position: absolute;\n}\n.navbar-expand .navbar-nav .nav-link {\n  padding-right: 0.5rem;\n  padding-left: 0.5rem;\n}\n.navbar-expand .navbar-nav-scroll {\n  overflow: visible;\n}\n.navbar-expand .navbar-collapse {\n  display: flex !important;\n  flex-basis: auto;\n}\n.navbar-expand .navbar-toggler {\n  display: none;\n}\n\n.navbar-light .navbar-brand {\n  color: rgba(0, 0, 0, 0.9);\n}\n.navbar-light .navbar-brand:hover, .navbar-light .navbar-brand:focus {\n  color: rgba(0, 0, 0, 0.9);\n}\n.navbar-light .navbar-nav .nav-link {\n  color: rgba(0, 0, 0, 0.55);\n}\n.navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {\n  color: rgba(0, 0, 0, 0.7);\n}\n.navbar-light .navbar-nav .nav-link.disabled {\n  color: rgba(0, 0, 0, 0.3);\n}\n.navbar-light .navbar-nav .show > .nav-link,\n.navbar-light .navbar-nav .nav-link.active {\n  color: rgba(0, 0, 0, 0.9);\n}\n.navbar-light .navbar-toggler {\n  color: rgba(0, 0, 0, 0.55);\n  border-color: rgba(0, 0, 0, 0.1);\n}\n.navbar-light .navbar-toggler-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%280, 0, 0, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n.navbar-light .navbar-text {\n  color: rgba(0, 0, 0, 0.55);\n}\n.navbar-light .navbar-text a,\n.navbar-light .navbar-text a:hover,\n.navbar-light .navbar-text a:focus {\n  color: rgba(0, 0, 0, 0.9);\n}\n\n.navbar-dark .navbar-brand {\n  color: #fff;\n}\n.navbar-dark .navbar-brand:hover, .navbar-dark .navbar-brand:focus {\n  color: #fff;\n}\n.navbar-dark .navbar-nav .nav-link {\n  color: rgba(255, 255, 255, 0.55);\n}\n.navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link:focus {\n  color: rgba(255, 255, 255, 0.75);\n}\n.navbar-dark .navbar-nav .nav-link.disabled {\n  color: rgba(255, 255, 255, 0.25);\n}\n.navbar-dark .navbar-nav .show > .nav-link,\n.navbar-dark .navbar-nav .nav-link.active {\n  color: #fff;\n}\n.navbar-dark .navbar-toggler {\n  color: rgba(255, 255, 255, 0.55);\n  border-color: rgba(255, 255, 255, 0.1);\n}\n.navbar-dark .navbar-toggler-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n.navbar-dark .navbar-text {\n  color: rgba(255, 255, 255, 0.55);\n}\n.navbar-dark .navbar-text a,\n.navbar-dark .navbar-text a:hover,\n.navbar-dark .navbar-text a:focus {\n  color: #fff;\n}\n\n.card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  word-wrap: break-word;\n  background-color: #fff;\n  background-clip: border-box;\n  border: 1px solid rgba(32.0357142857, 38.6071428571, 140.4642857143, 0.125);\n  border-radius: 0.25rem;\n}\n.card > hr {\n  margin-right: 0;\n  margin-left: 0;\n}\n.card > .list-group {\n  border-top: inherit;\n  border-bottom: inherit;\n}\n.card > .list-group:first-child {\n  border-top-width: 0;\n  border-top-left-radius: calc(0.25rem - 1px);\n  border-top-right-radius: calc(0.25rem - 1px);\n}\n.card > .list-group:last-child {\n  border-bottom-width: 0;\n  border-bottom-right-radius: calc(0.25rem - 1px);\n  border-bottom-left-radius: calc(0.25rem - 1px);\n}\n.card > .card-header + .list-group,\n.card > .list-group + .card-footer {\n  border-top: 0;\n}\n\n.card-body {\n  flex: 1 1 auto;\n  padding: 1rem 1rem;\n}\n\n.card-title {\n  margin-bottom: 0.5rem;\n}\n\n.card-subtitle {\n  margin-top: -0.25rem;\n  margin-bottom: 0;\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link:hover {\n  text-decoration: none;\n}\n.card-link + .card-link {\n  margin-left: 1rem;\n}\n\n.card-header {\n  padding: 0.5rem 1rem;\n  margin-bottom: 0;\n  background-color: #fff;\n  border-bottom: 1px solid rgba(32.0357142857, 38.6071428571, 140.4642857143, 0.125);\n}\n.card-header:first-child {\n  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;\n}\n\n.card-footer {\n  padding: 0.5rem 1rem;\n  background-color: #fff;\n  border-top: 1px solid rgba(32.0357142857, 38.6071428571, 140.4642857143, 0.125);\n}\n.card-footer:last-child {\n  border-radius: 0 0 calc(0.25rem - 1px) calc(0.25rem - 1px);\n}\n\n.card-header-tabs {\n  margin-right: -0.5rem;\n  margin-bottom: -0.5rem;\n  margin-left: -0.5rem;\n  border-bottom: 0;\n}\n\n.card-header-pills {\n  margin-right: -0.5rem;\n  margin-left: -0.5rem;\n}\n\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: 1rem;\n  border-radius: calc(0.25rem - 1px);\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%;\n}\n\n.card-img,\n.card-img-top {\n  border-top-left-radius: calc(0.25rem - 1px);\n  border-top-right-radius: calc(0.25rem - 1px);\n}\n\n.card-img,\n.card-img-bottom {\n  border-bottom-right-radius: calc(0.25rem - 1px);\n  border-bottom-left-radius: calc(0.25rem - 1px);\n}\n\n.card-group > .card {\n  margin-bottom: 0.75rem;\n}\n@media (min-width: 576px) {\n  .card-group {\n    display: flex;\n    flex-flow: row wrap;\n  }\n  .card-group > .card {\n    flex: 1 0 0%;\n    margin-bottom: 0;\n  }\n  .card-group > .card + .card {\n    margin-left: 0;\n    border-left: 0;\n  }\n  .card-group > .card:not(:last-child) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n  .card-group > .card:not(:last-child) .card-img-top,\n  .card-group > .card:not(:last-child) .card-header {\n    border-top-right-radius: 0;\n  }\n  .card-group > .card:not(:last-child) .card-img-bottom,\n  .card-group > .card:not(:last-child) .card-footer {\n    border-bottom-right-radius: 0;\n  }\n  .card-group > .card:not(:first-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .card-group > .card:not(:first-child) .card-img-top,\n  .card-group > .card:not(:first-child) .card-header {\n    border-top-left-radius: 0;\n  }\n  .card-group > .card:not(:first-child) .card-img-bottom,\n  .card-group > .card:not(:first-child) .card-footer {\n    border-bottom-left-radius: 0;\n  }\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 1rem 1.25rem;\n  font-size: 0.88rem;\n  color: #495057;\n  text-align: left;\n  background-color: #fff;\n  border: 0;\n  border-radius: 0;\n  overflow-anchor: none;\n  transition: color 0.15s, background-color 0.15s, border-color 0.15s, box-shadow 0.15s, border-radius 0.15s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .accordion-button {\n    transition: none;\n  }\n}\n.accordion-button:not(.collapsed) {\n  color: rgb(75.6, 82.8, 194.4);\n  background-color: rgb(237.9, 238.7, 251.1);\n  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.125);\n}\n.accordion-button:not(.collapsed)::after {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='rgb%2875.6, 82.8, 194.4%29'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n  transform: rotate(-180deg);\n}\n.accordion-button::after {\n  flex-shrink: 0;\n  width: 1.25rem;\n  height: 1.25rem;\n  margin-left: auto;\n  content: \"\";\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23495057'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-size: 1.25rem;\n  transition: transform 0.2s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .accordion-button::after {\n    transition: none;\n  }\n}\n.accordion-button:hover {\n  z-index: 2;\n}\n.accordion-button:focus {\n  z-index: 3;\n  border-color: rgb(187.8214285714, 190.9642857143, 239.6785714286);\n  outline: 0;\n  box-shadow: none;\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  background-color: #fff;\n}\n.accordion-item:first-of-type {\n  border-top-left-radius: 0.25rem;\n  border-top-right-radius: 0.25rem;\n}\n.accordion-item:first-of-type .accordion-button {\n  border-top-left-radius: calc(0.25rem - 1px);\n  border-top-right-radius: calc(0.25rem - 1px);\n}\n.accordion-item:not(:first-of-type) {\n  border-top: 0;\n}\n.accordion-item:last-of-type {\n  border-bottom-right-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n.accordion-item:last-of-type .accordion-button.collapsed {\n  border-bottom-right-radius: calc(0.25rem - 1px);\n  border-bottom-left-radius: calc(0.25rem - 1px);\n}\n.accordion-item:last-of-type .accordion-collapse {\n  border-bottom-right-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n\n.accordion-body {\n  padding: 1rem 1.25rem;\n}\n\n.accordion-flush .accordion-collapse {\n  border-width: 0;\n}\n.accordion-flush .accordion-item {\n  border-right: 0;\n  border-left: 0;\n  border-radius: 0;\n}\n.accordion-flush .accordion-item:first-child {\n  border-top: 0;\n}\n.accordion-flush .accordion-item:last-child {\n  border-bottom: 0;\n}\n.accordion-flush .accordion-item .accordion-button {\n  border-radius: 0;\n}\n\n.breadcrumb {\n  display: flex;\n  flex-wrap: wrap;\n  padding: 0 0;\n  margin-bottom: 1rem;\n  list-style: none;\n}\n\n.breadcrumb-item + .breadcrumb-item {\n  padding-left: 0.5rem;\n}\n.breadcrumb-item + .breadcrumb-item::before {\n  float: left;\n  padding-right: 0.5rem;\n  color: #6c757d;\n  content: var(--bs-breadcrumb-divider, \"/\") /* rtl: var(--bs-breadcrumb-divider, \"/\") */;\n}\n.breadcrumb-item.active {\n  color: #6c757d;\n}\n\n.pagination {\n  display: flex;\n  padding-left: 0;\n  list-style: none;\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  color: #545cd8;\n  text-decoration: none;\n  background-color: #fff;\n  border: 1px solid #dee2e6;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .page-link {\n    transition: none;\n  }\n}\n.page-link:hover {\n  z-index: 2;\n  color: rgb(67.2, 73.6, 172.8);\n  background-color: #e9ecef;\n  border-color: #dee2e6;\n}\n.page-link:focus {\n  z-index: 3;\n  color: rgb(67.2, 73.6, 172.8);\n  background-color: #e9ecef;\n  outline: 0;\n  box-shadow: none;\n}\n\n.page-item:not(:first-child) .page-link, .pagination .page-number:not(:first-child) .page-link {\n  margin-left: -1px;\n}\n.page-item.active .page-link, .pagination .active.page-number .page-link {\n  z-index: 3;\n  color: #fff;\n  background-color: #545cd8;\n  border-color: #545cd8;\n}\n.page-item.disabled .page-link, .pagination .disabled.page-number .page-link {\n  color: #6c757d;\n  pointer-events: none;\n  background-color: #fff;\n  border-color: #dee2e6;\n}\n\n.page-link {\n  padding: 0.375rem 0.75rem;\n}\n\n.page-item:first-child .page-link, .pagination .page-number:first-child .page-link {\n  border-top-left-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n.page-item:last-child .page-link, .pagination .page-number:last-child .page-link {\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n}\n\n.pagination-lg .page-link {\n  padding: 0.75rem 1.5rem;\n  font-size: 1.1rem;\n}\n.pagination-lg .page-item:first-child .page-link, .pagination-lg .pagination .page-number:first-child .page-link, .pagination .pagination-lg .page-number:first-child .page-link {\n  border-top-left-radius: 0.3rem;\n  border-bottom-left-radius: 0.3rem;\n}\n.pagination-lg .page-item:last-child .page-link, .pagination-lg .pagination .page-number:last-child .page-link, .pagination .pagination-lg .page-number:last-child .page-link {\n  border-top-right-radius: 0.3rem;\n  border-bottom-right-radius: 0.3rem;\n}\n\n.pagination-sm .page-link {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.968rem;\n}\n.pagination-sm .page-item:first-child .page-link, .pagination-sm .pagination .page-number:first-child .page-link, .pagination .pagination-sm .page-number:first-child .page-link {\n  border-top-left-radius: 0.2rem;\n  border-bottom-left-radius: 0.2rem;\n}\n.pagination-sm .page-item:last-child .page-link, .pagination-sm .pagination .page-number:last-child .page-link, .pagination .pagination-sm .page-number:last-child .page-link {\n  border-top-right-radius: 0.2rem;\n  border-bottom-right-radius: 0.2rem;\n}\n\n.badge {\n  display: inline-block;\n  padding: 0.35em 0.65em;\n  font-size: 0.75em;\n  font-weight: 700;\n  line-height: 1;\n  color: #fff;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: 0.25rem;\n}\n.badge:empty {\n  display: none;\n}\n\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n.alert {\n  position: relative;\n  padding: 1rem 1rem;\n  margin-bottom: 1rem;\n  border: 1px solid transparent;\n  border-radius: 0.25rem;\n}\n\n.alert-heading {\n  color: inherit;\n}\n\n.alert-link {\n  font-weight: 700;\n}\n\n.alert-dismissible {\n  padding-right: 3rem;\n}\n.alert-dismissible .btn-close {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 2;\n  padding: 1.25rem 1rem;\n}\n\n.alert-primary {\n  color: rgb(50.4, 55.2, 129.6);\n  background-color: rgb(220.8, 222.4, 247.2);\n  border-color: rgb(203.7, 206.1, 243.3);\n}\n.alert-primary .alert-link {\n  color: rgb(40.32, 44.16, 103.68);\n}\n\n.alert-secondary {\n  color: rgb(64.8, 70.2, 75);\n  background-color: rgb(225.6, 227.4, 229);\n  border-color: rgb(210.9, 213.6, 216);\n}\n.alert-secondary .alert-link {\n  color: rgb(51.84, 56.16, 60);\n}\n\n.alert-success {\n  color: rgb(34.8, 117.6, 75);\n  background-color: rgb(215.6, 243.2, 229);\n  border-color: rgb(195.9, 237.3, 216);\n}\n.alert-success .alert-link {\n  color: rgb(27.84, 94.08, 60);\n}\n\n.alert-info {\n  color: rgb(28.8, 106.2, 153);\n  background-color: rgb(213.6, 239.4, 255);\n  border-color: rgb(192.9, 231.6, 255);\n}\n.alert-info .alert-link {\n  color: rgb(23.04, 84.96, 122.4);\n}\n\n.alert-warning {\n  color: rgb(98.8, 74, 14.4);\n  background-color: rgb(253.4, 241, 211.2);\n  border-color: rgb(252.6, 234, 189.3);\n}\n.alert-warning .alert-link {\n  color: rgb(79.04, 59.2, 11.52);\n}\n\n.alert-danger {\n  color: rgb(130.2, 22.2, 48);\n  background-color: rgb(247.4, 211.4, 220);\n  border-color: rgb(243.6, 189.6, 202.5);\n}\n.alert-danger .alert-link {\n  color: rgb(104.16, 17.76, 38.4);\n}\n\n.alert-light {\n  color: rgb(95.2, 95.2, 95.2);\n  background-color: rgb(251.6, 251.6, 251.6);\n  border-color: rgb(249.9, 249.9, 249.9);\n}\n.alert-light .alert-link {\n  color: rgb(76.16, 76.16, 76.16);\n}\n\n.alert-dark {\n  color: rgb(31.2, 34.8, 38.4);\n  background-color: rgb(214.4, 215.6, 216.8);\n  border-color: rgb(194.1, 195.9, 197.7);\n}\n.alert-dark .alert-link {\n  color: rgb(24.96, 27.84, 30.72);\n}\n\n.alert-focus {\n  color: rgb(40.8, 38.4, 50.4);\n  background-color: rgb(217.6, 216.8, 220.8);\n  border-color: rgb(198.9, 197.7, 203.7);\n}\n.alert-focus .alert-link {\n  color: rgb(32.64, 30.72, 40.32);\n}\n\n.alert-alternate {\n  color: rgb(78.6, 52.8, 82.8);\n  background-color: rgb(230.2, 221.6, 231.6);\n  border-color: rgb(217.8, 204.9, 219.9);\n}\n.alert-alternate .alert-link {\n  color: rgb(62.88, 42.24, 66.24);\n}\n\n@keyframes progress-bar-stripes {\n  0% {\n    background-position-x: 1rem;\n  }\n}\n.progress {\n  display: flex;\n  height: 1rem;\n  overflow: hidden;\n  font-size: 0.66rem;\n  background-color: #e9ecef;\n  border-radius: 0.25rem;\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: #fff;\n  text-align: center;\n  white-space: nowrap;\n  background-color: #545cd8;\n  transition: width 0.6s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar {\n    transition: none;\n  }\n}\n\n.progress-bar-striped {\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-size: 1rem 1rem;\n}\n\n.progress-bar-animated {\n  animation: 1s linear infinite progress-bar-stripes;\n}\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar-animated {\n    animation: none;\n  }\n}\n\n.list-group {\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  border-radius: 0.25rem;\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n}\n.list-group-numbered > li::before {\n  content: counters(section, \".\") \". \";\n  counter-increment: section;\n}\n\n.list-group-item-action {\n  width: 100%;\n  color: #495057;\n  text-align: inherit;\n}\n.list-group-item-action:hover, .list-group-item-action:focus {\n  z-index: 1;\n  color: #495057;\n  text-decoration: none;\n  background-color: #f8f9fa;\n}\n.list-group-item-action:active {\n  color: #495057;\n  background-color: #e9ecef;\n}\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: 0.5rem 1rem;\n  color: #212529;\n  text-decoration: none;\n  background-color: #fff;\n  border: 1px solid rgba(84, 92, 216, 0.08);\n}\n.list-group-item:first-child {\n  border-top-left-radius: inherit;\n  border-top-right-radius: inherit;\n}\n.list-group-item:last-child {\n  border-bottom-right-radius: inherit;\n  border-bottom-left-radius: inherit;\n}\n.list-group-item.disabled, .list-group-item:disabled {\n  color: #6c757d;\n  pointer-events: none;\n  background-color: #fff;\n}\n.list-group-item.active {\n  z-index: 2;\n  color: #fff;\n  background-color: #545cd8;\n  border-color: #545cd8;\n}\n.list-group-item + .list-group-item {\n  border-top-width: 0;\n}\n.list-group-item + .list-group-item.active {\n  margin-top: -1px;\n  border-top-width: 1px;\n}\n\n.list-group-horizontal {\n  flex-direction: row;\n}\n.list-group-horizontal > .list-group-item:first-child {\n  border-bottom-left-radius: 0.25rem;\n  border-top-right-radius: 0;\n}\n.list-group-horizontal > .list-group-item:last-child {\n  border-top-right-radius: 0.25rem;\n  border-bottom-left-radius: 0;\n}\n.list-group-horizontal > .list-group-item.active {\n  margin-top: 0;\n}\n.list-group-horizontal > .list-group-item + .list-group-item {\n  border-top-width: 1px;\n  border-left-width: 0;\n}\n.list-group-horizontal > .list-group-item + .list-group-item.active {\n  margin-left: -1px;\n  border-left-width: 1px;\n}\n\n@media (min-width: 576px) {\n  .list-group-horizontal-sm {\n    flex-direction: row;\n  }\n  .list-group-horizontal-sm > .list-group-item:first-child {\n    border-bottom-left-radius: 0.25rem;\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item:last-child {\n    border-top-right-radius: 0.25rem;\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item + .list-group-item {\n    border-top-width: 1px;\n    border-left-width: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {\n    margin-left: -1px;\n    border-left-width: 1px;\n  }\n}\n@media (min-width: 768px) {\n  .list-group-horizontal-md {\n    flex-direction: row;\n  }\n  .list-group-horizontal-md > .list-group-item:first-child {\n    border-bottom-left-radius: 0.25rem;\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-md > .list-group-item:last-child {\n    border-top-right-radius: 0.25rem;\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-md > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-md > .list-group-item + .list-group-item {\n    border-top-width: 1px;\n    border-left-width: 0;\n  }\n  .list-group-horizontal-md > .list-group-item + .list-group-item.active {\n    margin-left: -1px;\n    border-left-width: 1px;\n  }\n}\n@media (min-width: 992px) {\n  .list-group-horizontal-lg {\n    flex-direction: row;\n  }\n  .list-group-horizontal-lg > .list-group-item:first-child {\n    border-bottom-left-radius: 0.25rem;\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item:last-child {\n    border-top-right-radius: 0.25rem;\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item + .list-group-item {\n    border-top-width: 1px;\n    border-left-width: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {\n    margin-left: -1px;\n    border-left-width: 1px;\n  }\n}\n@media (min-width: 1200px) {\n  .list-group-horizontal-xl {\n    flex-direction: row;\n  }\n  .list-group-horizontal-xl > .list-group-item:first-child {\n    border-bottom-left-radius: 0.25rem;\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item:last-child {\n    border-top-right-radius: 0.25rem;\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item + .list-group-item {\n    border-top-width: 1px;\n    border-left-width: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {\n    margin-left: -1px;\n    border-left-width: 1px;\n  }\n}\n@media (min-width: 1400px) {\n  .list-group-horizontal-xxl {\n    flex-direction: row;\n  }\n  .list-group-horizontal-xxl > .list-group-item:first-child {\n    border-bottom-left-radius: 0.25rem;\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item:last-child {\n    border-top-right-radius: 0.25rem;\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item + .list-group-item {\n    border-top-width: 1px;\n    border-left-width: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {\n    margin-left: -1px;\n    border-left-width: 1px;\n  }\n}\n.list-group-flush {\n  border-radius: 0;\n}\n.list-group-flush > .list-group-item {\n  border-width: 0 0 1px;\n}\n.list-group-flush > .list-group-item:last-child {\n  border-bottom-width: 0;\n}\n\n.list-group-item-primary {\n  color: rgb(50.4, 55.2, 129.6);\n  background-color: rgb(220.8, 222.4, 247.2);\n}\n.list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {\n  color: rgb(50.4, 55.2, 129.6);\n  background-color: rgb(198.72, 200.16, 222.48);\n}\n.list-group-item-primary.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(50.4, 55.2, 129.6);\n  border-color: rgb(50.4, 55.2, 129.6);\n}\n\n.list-group-item-secondary {\n  color: rgb(64.8, 70.2, 75);\n  background-color: rgb(225.6, 227.4, 229);\n}\n.list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {\n  color: rgb(64.8, 70.2, 75);\n  background-color: rgb(203.04, 204.66, 206.1);\n}\n.list-group-item-secondary.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(64.8, 70.2, 75);\n  border-color: rgb(64.8, 70.2, 75);\n}\n\n.list-group-item-success {\n  color: rgb(34.8, 117.6, 75);\n  background-color: rgb(215.6, 243.2, 229);\n}\n.list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {\n  color: rgb(34.8, 117.6, 75);\n  background-color: rgb(194.04, 218.88, 206.1);\n}\n.list-group-item-success.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(34.8, 117.6, 75);\n  border-color: rgb(34.8, 117.6, 75);\n}\n\n.list-group-item-info {\n  color: rgb(28.8, 106.2, 153);\n  background-color: rgb(213.6, 239.4, 255);\n}\n.list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {\n  color: rgb(28.8, 106.2, 153);\n  background-color: rgb(192.24, 215.46, 229.5);\n}\n.list-group-item-info.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(28.8, 106.2, 153);\n  border-color: rgb(28.8, 106.2, 153);\n}\n\n.list-group-item-warning {\n  color: rgb(98.8, 74, 14.4);\n  background-color: rgb(253.4, 241, 211.2);\n}\n.list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {\n  color: rgb(98.8, 74, 14.4);\n  background-color: rgb(228.06, 216.9, 190.08);\n}\n.list-group-item-warning.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(98.8, 74, 14.4);\n  border-color: rgb(98.8, 74, 14.4);\n}\n\n.list-group-item-danger {\n  color: rgb(130.2, 22.2, 48);\n  background-color: rgb(247.4, 211.4, 220);\n}\n.list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {\n  color: rgb(130.2, 22.2, 48);\n  background-color: rgb(222.66, 190.26, 198);\n}\n.list-group-item-danger.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(130.2, 22.2, 48);\n  border-color: rgb(130.2, 22.2, 48);\n}\n\n.list-group-item-light {\n  color: rgb(95.2, 95.2, 95.2);\n  background-color: rgb(251.6, 251.6, 251.6);\n}\n.list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {\n  color: rgb(95.2, 95.2, 95.2);\n  background-color: rgb(226.44, 226.44, 226.44);\n}\n.list-group-item-light.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(95.2, 95.2, 95.2);\n  border-color: rgb(95.2, 95.2, 95.2);\n}\n\n.list-group-item-dark {\n  color: rgb(31.2, 34.8, 38.4);\n  background-color: rgb(214.4, 215.6, 216.8);\n}\n.list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {\n  color: rgb(31.2, 34.8, 38.4);\n  background-color: rgb(192.96, 194.04, 195.12);\n}\n.list-group-item-dark.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(31.2, 34.8, 38.4);\n  border-color: rgb(31.2, 34.8, 38.4);\n}\n\n.list-group-item-focus {\n  color: rgb(40.8, 38.4, 50.4);\n  background-color: rgb(217.6, 216.8, 220.8);\n}\n.list-group-item-focus.list-group-item-action:hover, .list-group-item-focus.list-group-item-action:focus {\n  color: rgb(40.8, 38.4, 50.4);\n  background-color: rgb(195.84, 195.12, 198.72);\n}\n.list-group-item-focus.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(40.8, 38.4, 50.4);\n  border-color: rgb(40.8, 38.4, 50.4);\n}\n\n.list-group-item-alternate {\n  color: rgb(78.6, 52.8, 82.8);\n  background-color: rgb(230.2, 221.6, 231.6);\n}\n.list-group-item-alternate.list-group-item-action:hover, .list-group-item-alternate.list-group-item-action:focus {\n  color: rgb(78.6, 52.8, 82.8);\n  background-color: rgb(207.18, 199.44, 208.44);\n}\n.list-group-item-alternate.list-group-item-action.active {\n  color: #fff;\n  background-color: rgb(78.6, 52.8, 82.8);\n  border-color: rgb(78.6, 52.8, 82.8);\n}\n\n.btn-close {\n  box-sizing: content-box;\n  width: 1em;\n  height: 1em;\n  padding: 0.25em 0.25em;\n  color: #000;\n  background: transparent url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000'%3e%3cpath d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/%3e%3c/svg%3e\") center/1em auto no-repeat;\n  border: 0;\n  border-radius: 0.25rem;\n  opacity: 0.5;\n}\n.btn-close:hover {\n  color: #000;\n  text-decoration: none;\n  opacity: 0.75;\n}\n.btn-close:focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgba(84, 92, 216, 0.25);\n  opacity: 1;\n}\n.btn-close:disabled, .btn-close.disabled {\n  pointer-events: none;\n  user-select: none;\n  opacity: 0.25;\n}\n\n.btn-close-white {\n  filter: invert(1) grayscale(100%) brightness(200%);\n}\n\n.toast {\n  width: 350px;\n  max-width: 100%;\n  font-size: 0.875rem;\n  pointer-events: auto;\n  background-color: rgba(255, 255, 255, 0.85);\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n  border-radius: 0.25rem;\n}\n.toast:not(.showing):not(.show) {\n  opacity: 0;\n}\n.toast.hide {\n  display: none;\n}\n\n.toast-container {\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n}\n.toast-container > :not(:last-child) {\n  margin-bottom: 0.75rem;\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: 0.5rem 0.75rem;\n  color: #6c757d;\n  background-color: rgba(255, 255, 255, 0.85);\n  background-clip: padding-box;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n  border-top-left-radius: calc(0.25rem - 1px);\n  border-top-right-radius: calc(0.25rem - 1px);\n}\n.toast-header .btn-close {\n  margin-right: -0.375rem;\n  margin-left: 0.75rem;\n}\n\n.toast-body {\n  padding: 0.75rem;\n  word-wrap: break-word;\n}\n\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1060;\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  outline: 0;\n}\n\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: 0.5rem;\n  pointer-events: none;\n}\n.modal.fade .modal-dialog {\n  transition: transform 0.3s ease-out;\n  transform: translate(0, -50px);\n}\n@media (prefers-reduced-motion: reduce) {\n  .modal.fade .modal-dialog {\n    transition: none;\n  }\n}\n.modal.show .modal-dialog {\n  transform: none;\n}\n.modal.modal-static .modal-dialog {\n  transform: scale(1.02);\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - 1rem);\n}\n.modal-dialog-scrollable .modal-content {\n  max-height: 100%;\n  overflow: hidden;\n}\n.modal-dialog-scrollable .modal-body {\n  overflow-y: auto;\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - 1rem);\n}\n\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  pointer-events: auto;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-radius: 0.3rem;\n  outline: 0;\n}\n\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1040;\n  width: 100vw;\n  height: 100vh;\n  background-color: #000;\n}\n.modal-backdrop.fade {\n  opacity: 0;\n}\n.modal-backdrop.show {\n  opacity: 0.5;\n}\n\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem 1rem;\n  border-bottom: 1px solid #dee2e6;\n  border-top-left-radius: calc(0.3rem - 1px);\n  border-top-right-radius: calc(0.3rem - 1px);\n}\n.modal-header .btn-close {\n  padding: 0.5rem 0.5rem;\n  margin: -0.5rem -0.5rem -0.5rem auto;\n}\n\n.modal-title {\n  margin-bottom: 0;\n  line-height: 1.5;\n}\n\n.modal-body {\n  position: relative;\n  flex: 1 1 auto;\n  padding: 1rem;\n}\n\n.modal-footer {\n  display: flex;\n  flex-wrap: wrap;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 0.75rem;\n  border-top: 1px solid #dee2e6;\n  border-bottom-right-radius: calc(0.3rem - 1px);\n  border-bottom-left-radius: calc(0.3rem - 1px);\n}\n.modal-footer > * {\n  margin: 0.25rem;\n}\n\n@media (min-width: 576px) {\n  .modal-dialog {\n    max-width: 500px;\n    margin: 1.75rem auto;\n  }\n  .modal-dialog-scrollable {\n    height: calc(100% - 3.5rem);\n  }\n  .modal-dialog-centered {\n    min-height: calc(100% - 3.5rem);\n  }\n  .modal-sm {\n    max-width: 300px;\n  }\n}\n@media (min-width: 992px) {\n  .modal-lg,\n  .modal-xl {\n    max-width: 800px;\n  }\n}\n@media (min-width: 1200px) {\n  .modal-xl {\n    max-width: 1140px;\n  }\n}\n.modal-fullscreen {\n  width: 100vw;\n  max-width: none;\n  height: 100%;\n  margin: 0;\n}\n.modal-fullscreen .modal-content {\n  height: 100%;\n  border: 0;\n  border-radius: 0;\n}\n.modal-fullscreen .modal-header {\n  border-radius: 0;\n}\n.modal-fullscreen .modal-body {\n  overflow-y: auto;\n}\n.modal-fullscreen .modal-footer {\n  border-radius: 0;\n}\n\n@media (max-width: 575.98px) {\n  .modal-fullscreen-sm-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-sm-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-sm-down .modal-header {\n    border-radius: 0;\n  }\n  .modal-fullscreen-sm-down .modal-body {\n    overflow-y: auto;\n  }\n  .modal-fullscreen-sm-down .modal-footer {\n    border-radius: 0;\n  }\n}\n@media (max-width: 767.98px) {\n  .modal-fullscreen-md-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-md-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-md-down .modal-header {\n    border-radius: 0;\n  }\n  .modal-fullscreen-md-down .modal-body {\n    overflow-y: auto;\n  }\n  .modal-fullscreen-md-down .modal-footer {\n    border-radius: 0;\n  }\n}\n@media (max-width: 991.98px) {\n  .modal-fullscreen-lg-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-lg-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-lg-down .modal-header {\n    border-radius: 0;\n  }\n  .modal-fullscreen-lg-down .modal-body {\n    overflow-y: auto;\n  }\n  .modal-fullscreen-lg-down .modal-footer {\n    border-radius: 0;\n  }\n}\n@media (max-width: 1199.98px) {\n  .modal-fullscreen-xl-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-xl-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-xl-down .modal-header {\n    border-radius: 0;\n  }\n  .modal-fullscreen-xl-down .modal-body {\n    overflow-y: auto;\n  }\n  .modal-fullscreen-xl-down .modal-footer {\n    border-radius: 0;\n  }\n}\n@media (max-width: 1399.98px) {\n  .modal-fullscreen-xxl-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-header {\n    border-radius: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-body {\n    overflow-y: auto;\n  }\n  .modal-fullscreen-xxl-down .modal-footer {\n    border-radius: 0;\n  }\n}\n.tooltip {\n  position: absolute;\n  z-index: 1080;\n  display: block;\n  margin: 0;\n  font-family: var(--bs-font-sans-serif);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  white-space: normal;\n  line-break: auto;\n  font-size: 0.968rem;\n  word-wrap: break-word;\n  opacity: 0;\n}\n.tooltip.show {\n  opacity: 0.9;\n}\n.tooltip .tooltip-arrow {\n  position: absolute;\n  display: block;\n  width: 0.8rem;\n  height: 0.4rem;\n}\n.tooltip .tooltip-arrow::before {\n  position: absolute;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n}\n\n.bs-tooltip-top, .bs-tooltip-auto[data-popper-placement^=top] {\n  padding: 0.4rem 0;\n}\n.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {\n  bottom: 0;\n}\n.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {\n  top: -1px;\n  border-width: 0.4rem 0.4rem 0;\n  border-top-color: #000;\n}\n\n.bs-tooltip-end, .bs-tooltip-auto[data-popper-placement^=right] {\n  padding: 0 0.4rem;\n}\n.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {\n  left: 0;\n  width: 0.4rem;\n  height: 0.8rem;\n}\n.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {\n  right: -1px;\n  border-width: 0.4rem 0.4rem 0.4rem 0;\n  border-right-color: #000;\n}\n\n.bs-tooltip-bottom, .bs-tooltip-auto[data-popper-placement^=bottom] {\n  padding: 0.4rem 0;\n}\n.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {\n  top: 0;\n}\n.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {\n  bottom: -1px;\n  border-width: 0 0.4rem 0.4rem;\n  border-bottom-color: #000;\n}\n\n.bs-tooltip-start, .bs-tooltip-auto[data-popper-placement^=left] {\n  padding: 0 0.4rem;\n}\n.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {\n  right: 0;\n  width: 0.4rem;\n  height: 0.8rem;\n}\n.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {\n  left: -1px;\n  border-width: 0.4rem 0 0.4rem 0.4rem;\n  border-left-color: #000;\n}\n\n.tooltip-inner {\n  max-width: 200px;\n  padding: 0.25rem 0.5rem;\n  color: #fff;\n  text-align: center;\n  background-color: #000;\n  border-radius: 0.25rem;\n}\n\n.popover {\n  position: absolute;\n  top: 0;\n  left: 0 /* rtl:ignore */;\n  z-index: 1070;\n  display: block;\n  max-width: 320px;\n  font-family: var(--bs-font-sans-serif);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  white-space: normal;\n  line-break: auto;\n  font-size: 0.968rem;\n  word-wrap: break-word;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(32.0357142857, 38.6071428571, 140.4642857143, 0.125);\n  border-radius: 0.3rem;\n}\n.popover .popover-arrow {\n  position: absolute;\n  display: block;\n  width: 1rem;\n  height: 0.5rem;\n}\n.popover .popover-arrow::before, .popover .popover-arrow::after {\n  position: absolute;\n  display: block;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n}\n\n.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {\n  bottom: calc(-0.5rem - 1px);\n}\n.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {\n  bottom: 0;\n  border-width: 0.5rem 0.5rem 0;\n  border-top-color: rgba(32.0357142857, 38.6071428571, 140.4642857143, 0.175);\n}\n.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {\n  bottom: 1px;\n  border-width: 0.5rem 0.5rem 0;\n  border-top-color: #fff;\n}\n\n.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {\n  left: calc(-0.5rem - 1px);\n  width: 0.5rem;\n  height: 1rem;\n}\n.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {\n  left: 0;\n  border-width: 0.5rem 0.5rem 0.5rem 0;\n  border-right-color: rgba(32.0357142857, 38.6071428571, 140.4642857143, 0.175);\n}\n.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {\n  left: 1px;\n  border-width: 0.5rem 0.5rem 0.5rem 0;\n  border-right-color: #fff;\n}\n\n.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {\n  top: calc(-0.5rem - 1px);\n}\n.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {\n  top: 0;\n  border-width: 0 0.5rem 0.5rem 0.5rem;\n  border-bottom-color: rgba(32.0357142857, 38.6071428571, 140.4642857143, 0.175);\n}\n.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {\n  top: 1px;\n  border-width: 0 0.5rem 0.5rem 0.5rem;\n  border-bottom-color: #fff;\n}\n.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  display: block;\n  width: 1rem;\n  margin-left: -0.5rem;\n  content: \"\";\n  border-bottom: 1px solid #fff;\n}\n\n.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {\n  right: calc(-0.5rem - 1px);\n  width: 0.5rem;\n  height: 1rem;\n}\n.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {\n  right: 0;\n  border-width: 0.5rem 0 0.5rem 0.5rem;\n  border-left-color: rgba(32.0357142857, 38.6071428571, 140.4642857143, 0.175);\n}\n.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {\n  right: 1px;\n  border-width: 0.5rem 0 0.5rem 0.5rem;\n  border-left-color: #fff;\n}\n\n.popover-header {\n  padding: 0.5rem 1rem;\n  margin-bottom: 0;\n  font-size: 0.88rem;\n  background-color: #fff;\n  border-bottom: 1px solid rgba(32.0357142857, 38.6071428571, 140.4642857143, 0.125);\n  border-top-left-radius: calc(0.3rem - 1px);\n  border-top-right-radius: calc(0.3rem - 1px);\n}\n.popover-header:empty {\n  display: none;\n}\n\n.popover-body {\n  padding: 1rem 1rem;\n  color: #495057;\n}\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n}\n.carousel-inner::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  transition: transform 0.6s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-item {\n    transition: none;\n  }\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n/* rtl:begin:ignore */\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n/* rtl:end:ignore */\n.carousel-fade .carousel-item {\n  opacity: 0;\n  transition-property: opacity;\n  transform: none;\n}\n.carousel-fade .carousel-item.active,\n.carousel-fade .carousel-item-next.carousel-item-start,\n.carousel-fade .carousel-item-prev.carousel-item-end {\n  z-index: 1;\n  opacity: 1;\n}\n.carousel-fade .active.carousel-item-start,\n.carousel-fade .active.carousel-item-end {\n  z-index: 0;\n  opacity: 0;\n  transition: opacity 0s 0.6s;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-fade .active.carousel-item-start,\n  .carousel-fade .active.carousel-item-end {\n    transition: none;\n  }\n}\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 15%;\n  padding: 0;\n  color: #fff;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: 0.5;\n  transition: opacity 0.15s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-control-prev,\n  .carousel-control-next {\n    transition: none;\n  }\n}\n.carousel-control-prev:hover, .carousel-control-prev:focus,\n.carousel-control-next:hover,\n.carousel-control-next:focus {\n  color: #fff;\n  text-decoration: none;\n  outline: 0;\n  opacity: 0.9;\n}\n\n.carousel-control-prev {\n  left: 0;\n}\n\n.carousel-control-next {\n  right: 0;\n}\n\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n/* rtl:options: {\n  \"autoRename\": true,\n  \"stringMap\":[ {\n    \"name\"    : \"prev-next\",\n    \"search\"  : \"prev\",\n    \"replace\" : \"next\"\n  } ]\n} */\n.carousel-control-prev-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e\");\n}\n\n.carousel-control-next-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n}\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  margin-right: 15%;\n  margin-bottom: 1rem;\n  margin-left: 15%;\n  list-style: none;\n}\n.carousel-indicators [data-bs-target] {\n  box-sizing: content-box;\n  flex: 0 1 auto;\n  width: 30px;\n  height: 3px;\n  padding: 0;\n  margin-right: 3px;\n  margin-left: 3px;\n  text-indent: -999px;\n  cursor: pointer;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 0;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  opacity: 0.5;\n  transition: opacity 0.6s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-indicators [data-bs-target] {\n    transition: none;\n  }\n}\n.carousel-indicators .active {\n  opacity: 1;\n}\n\n.carousel-caption {\n  position: absolute;\n  right: 15%;\n  bottom: 1.25rem;\n  left: 15%;\n  padding-top: 1.25rem;\n  padding-bottom: 1.25rem;\n  color: #fff;\n  text-align: center;\n}\n\n.carousel-dark .carousel-control-prev-icon,\n.carousel-dark .carousel-control-next-icon {\n  filter: invert(1) grayscale(100);\n}\n.carousel-dark .carousel-indicators [data-bs-target] {\n  background-color: #000;\n}\n.carousel-dark .carousel-caption {\n  color: #000;\n}\n\n@keyframes spinner-border {\n  to {\n    transform: rotate(360deg) /* rtl:ignore */;\n  }\n}\n.spinner-border {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  vertical-align: -0.125em;\n  border: 0.25em solid currentColor;\n  border-right-color: transparent;\n  border-radius: 50%;\n  animation: 0.75s linear infinite spinner-border;\n}\n\n.spinner-border-sm {\n  width: 1rem;\n  height: 1rem;\n  border-width: 0.2em;\n}\n\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n.spinner-grow {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  vertical-align: -0.125em;\n  background-color: currentColor;\n  border-radius: 50%;\n  opacity: 0;\n  animation: 0.75s linear infinite spinner-grow;\n}\n\n.spinner-grow-sm {\n  width: 1rem;\n  height: 1rem;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .spinner-border,\n  .spinner-grow {\n    animation-duration: 1.5s;\n  }\n}\n.offcanvas {\n  position: fixed;\n  bottom: 0;\n  z-index: 1050;\n  display: flex;\n  flex-direction: column;\n  max-width: 100%;\n  visibility: hidden;\n  background-color: #fff;\n  background-clip: padding-box;\n  outline: 0;\n  transition: transform 0.3s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .offcanvas {\n    transition: none;\n  }\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem 1rem;\n}\n.offcanvas-header .btn-close {\n  padding: 0.5rem 0.5rem;\n  margin-top: -0.5rem;\n  margin-right: -0.5rem;\n  margin-bottom: -0.5rem;\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: 1.5;\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: 1rem 1rem;\n  overflow-y: auto;\n}\n\n.offcanvas-start {\n  top: 0;\n  left: 0;\n  width: 400px;\n  border-right: 1px solid rgba(0, 0, 0, 0.2);\n  transform: translateX(-100%);\n}\n\n.offcanvas-end {\n  top: 0;\n  right: 0;\n  width: 400px;\n  border-left: 1px solid rgba(0, 0, 0, 0.2);\n  transform: translateX(100%);\n}\n\n.offcanvas-top {\n  top: 0;\n  right: 0;\n  left: 0;\n  height: 30vh;\n  max-height: 100%;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.2);\n  transform: translateY(-100%);\n}\n\n.offcanvas-bottom {\n  right: 0;\n  left: 0;\n  height: 30vh;\n  max-height: 100%;\n  border-top: 1px solid rgba(0, 0, 0, 0.2);\n  transform: translateY(100%);\n}\n\n.offcanvas.show {\n  transform: none;\n}\n\n.jumbotron {\n  padding: 2rem 1rem;\n  margin-bottom: 2rem;\n  background-color: #e9ecef;\n  border-radius: 0.3rem;\n}\n@media (min-width: 576px) {\n  .jumbotron {\n    padding: 4rem 2rem;\n  }\n}\n\n.jumbotron-fluid {\n  padding-right: 0;\n  padding-left: 0;\n  border-radius: 0;\n}\n\n.clearfix::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.link-primary {\n  color: #545cd8;\n}\n.link-primary:hover, .link-primary:focus {\n  color: rgb(67.2, 73.6, 172.8);\n}\n\n.link-secondary {\n  color: #6c757d;\n}\n.link-secondary:hover, .link-secondary:focus {\n  color: rgb(86.4, 93.6, 100);\n}\n\n.link-success {\n  color: #3ac47d;\n}\n.link-success:hover, .link-success:focus {\n  color: rgb(97.4, 207.8, 151);\n}\n\n.link-info {\n  color: #30b1ff;\n}\n.link-info:hover, .link-info:focus {\n  color: rgb(89.4, 192.6, 255);\n}\n\n.link-warning {\n  color: #f7b924;\n}\n.link-warning:hover, .link-warning:focus {\n  color: rgb(248.6, 199, 79.8);\n}\n\n.link-danger {\n  color: #d92550;\n}\n.link-danger:hover, .link-danger:focus {\n  color: rgb(173.6, 29.6, 64);\n}\n\n.link-light {\n  color: #eeeeee;\n}\n.link-light:hover, .link-light:focus {\n  color: rgb(241.4, 241.4, 241.4);\n}\n\n.link-dark {\n  color: #343a40;\n}\n.link-dark:hover, .link-dark:focus {\n  color: rgb(41.6, 46.4, 51.2);\n}\n\n.link-focus {\n  color: #444054;\n}\n.link-focus:hover, .link-focus:focus {\n  color: rgb(54.4, 51.2, 67.2);\n}\n\n.link-alternate {\n  color: #83588a;\n}\n.link-alternate:hover, .link-alternate:focus {\n  color: rgb(104.8, 70.4, 110.4);\n}\n\n.ratio {\n  position: relative;\n  width: 100%;\n}\n.ratio::before {\n  display: block;\n  padding-top: var(--bs-aspect-ratio);\n  content: \"\";\n}\n.ratio > * {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.ratio-1x1 {\n  --bs-aspect-ratio: 100%;\n}\n\n.ratio-4x3 {\n  --bs-aspect-ratio: 75%;\n}\n\n.ratio-16x9 {\n  --bs-aspect-ratio: 56.25%;\n}\n\n.ratio-21x9 {\n  --bs-aspect-ratio: 42.8571428571%;\n}\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.sticky-top {\n  position: sticky;\n  top: 0;\n  z-index: 1020;\n}\n\n@media (min-width: 576px) {\n  .sticky-sm-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 768px) {\n  .sticky-md-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 992px) {\n  .sticky-lg-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 1200px) {\n  .sticky-xl-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 1400px) {\n  .sticky-xxl-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n}\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n\n.stretched-link::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  content: \"\";\n}\n\n.text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.align-baseline {\n  vertical-align: baseline !important;\n}\n\n.align-top {\n  vertical-align: top !important;\n}\n\n.align-middle {\n  vertical-align: middle !important;\n}\n\n.align-bottom {\n  vertical-align: bottom !important;\n}\n\n.align-text-bottom {\n  vertical-align: text-bottom !important;\n}\n\n.align-text-top {\n  vertical-align: text-top !important;\n}\n\n.float-start {\n  float: left !important;\n}\n\n.float-end {\n  float: right !important;\n}\n\n.float-none {\n  float: none !important;\n}\n\n.overflow-auto {\n  overflow: auto !important;\n}\n\n.overflow-hidden {\n  overflow: hidden !important;\n}\n\n.overflow-visible {\n  overflow: visible !important;\n}\n\n.overflow-scroll {\n  overflow: scroll !important;\n}\n\n.d-inline {\n  display: inline !important;\n}\n\n.d-inline-block {\n  display: inline-block !important;\n}\n\n.d-block {\n  display: block !important;\n}\n\n.d-grid {\n  display: grid !important;\n}\n\n.d-table {\n  display: table !important;\n}\n\n.d-table-row {\n  display: table-row !important;\n}\n\n.d-table-cell {\n  display: table-cell !important;\n}\n\n.d-flex {\n  display: flex !important;\n}\n\n.d-inline-flex {\n  display: inline-flex !important;\n}\n\n.d-none {\n  display: none !important;\n}\n\n.shadow {\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;\n}\n\n.shadow-sm {\n  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;\n}\n\n.shadow-lg {\n  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;\n}\n\n.shadow-none {\n  box-shadow: none !important;\n}\n\n.position-static {\n  position: static !important;\n}\n\n.position-relative {\n  position: relative !important;\n}\n\n.position-absolute {\n  position: absolute !important;\n}\n\n.position-fixed {\n  position: fixed !important;\n}\n\n.position-sticky {\n  position: sticky !important;\n}\n\n.top-0 {\n  top: 0 !important;\n}\n\n.top-50 {\n  top: 50% !important;\n}\n\n.top-100 {\n  top: 100% !important;\n}\n\n.bottom-0 {\n  bottom: 0 !important;\n}\n\n.bottom-50 {\n  bottom: 50% !important;\n}\n\n.bottom-100 {\n  bottom: 100% !important;\n}\n\n.start-0 {\n  left: 0 !important;\n}\n\n.start-50 {\n  left: 50% !important;\n}\n\n.start-100 {\n  left: 100% !important;\n}\n\n.end-0 {\n  right: 0 !important;\n}\n\n.end-50 {\n  right: 50% !important;\n}\n\n.end-100 {\n  right: 100% !important;\n}\n\n.translate-middle {\n  transform: translate(-50%, -50%) !important;\n}\n\n.translate-middle-x {\n  transform: translateX(-50%) !important;\n}\n\n.translate-middle-y {\n  transform: translateY(-50%) !important;\n}\n\n.border {\n  border: 1px solid #dee2e6 !important;\n}\n\n.border-0 {\n  border: 0 !important;\n}\n\n.border-top {\n  border-top: 1px solid #dee2e6 !important;\n}\n\n.border-top-0 {\n  border-top: 0 !important;\n}\n\n.border-end {\n  border-right: 1px solid #dee2e6 !important;\n}\n\n.border-end-0 {\n  border-right: 0 !important;\n}\n\n.border-bottom {\n  border-bottom: 1px solid #dee2e6 !important;\n}\n\n.border-bottom-0 {\n  border-bottom: 0 !important;\n}\n\n.border-start {\n  border-left: 1px solid #dee2e6 !important;\n}\n\n.border-start-0 {\n  border-left: 0 !important;\n}\n\n.border-primary {\n  border-color: #545cd8 !important;\n}\n\n.border-secondary {\n  border-color: #6c757d !important;\n}\n\n.border-success {\n  border-color: #3ac47d !important;\n}\n\n.border-info {\n  border-color: #30b1ff !important;\n}\n\n.border-warning {\n  border-color: #f7b924 !important;\n}\n\n.border-danger {\n  border-color: #d92550 !important;\n}\n\n.border-light {\n  border-color: #eeeeee !important;\n}\n\n.border-dark {\n  border-color: #343a40 !important;\n}\n\n.border-focus {\n  border-color: #444054 !important;\n}\n\n.border-alternate {\n  border-color: #83588a !important;\n}\n\n.border-white {\n  border-color: #fff !important;\n}\n\n.border-1 {\n  border-width: 1px !important;\n}\n\n.border-2 {\n  border-width: 2px !important;\n}\n\n.border-3 {\n  border-width: 3px !important;\n}\n\n.border-4 {\n  border-width: 4px !important;\n}\n\n.border-5 {\n  border-width: 5px !important;\n}\n\n.w-25 {\n  width: 25% !important;\n}\n\n.w-50 {\n  width: 50% !important;\n}\n\n.w-75 {\n  width: 75% !important;\n}\n\n.w-100 {\n  width: 100% !important;\n}\n\n.w-auto {\n  width: auto !important;\n}\n\n.mw-100 {\n  max-width: 100% !important;\n}\n\n.vw-100 {\n  width: 100vw !important;\n}\n\n.min-vw-100 {\n  min-width: 100vw !important;\n}\n\n.h-25 {\n  height: 25% !important;\n}\n\n.h-50 {\n  height: 50% !important;\n}\n\n.h-75 {\n  height: 75% !important;\n}\n\n.h-100 {\n  height: 100% !important;\n}\n\n.h-auto {\n  height: auto !important;\n}\n\n.mh-100 {\n  max-height: 100% !important;\n}\n\n.vh-100 {\n  height: 100vh !important;\n}\n\n.min-vh-100 {\n  min-height: 100vh !important;\n}\n\n.flex-fill {\n  flex: 1 1 auto !important;\n}\n\n.flex-row {\n  flex-direction: row !important;\n}\n\n.flex-column {\n  flex-direction: column !important;\n}\n\n.flex-row-reverse {\n  flex-direction: row-reverse !important;\n}\n\n.flex-column-reverse {\n  flex-direction: column-reverse !important;\n}\n\n.flex-grow-0 {\n  flex-grow: 0 !important;\n}\n\n.flex-grow-1 {\n  flex-grow: 1 !important;\n}\n\n.flex-shrink-0 {\n  flex-shrink: 0 !important;\n}\n\n.flex-shrink-1 {\n  flex-shrink: 1 !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n.flex-nowrap {\n  flex-wrap: nowrap !important;\n}\n\n.flex-wrap-reverse {\n  flex-wrap: wrap-reverse !important;\n}\n\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-1 {\n  gap: 0.25rem !important;\n}\n\n.gap-2 {\n  gap: 0.5rem !important;\n}\n\n.gap-3 {\n  gap: 1rem !important;\n}\n\n.gap-4 {\n  gap: 1.5rem !important;\n}\n\n.gap-5 {\n  gap: 3rem !important;\n}\n\n.justify-content-start {\n  justify-content: flex-start !important;\n}\n\n.justify-content-end {\n  justify-content: flex-end !important;\n}\n\n.justify-content-center {\n  justify-content: center !important;\n}\n\n.justify-content-between {\n  justify-content: space-between !important;\n}\n\n.justify-content-around {\n  justify-content: space-around !important;\n}\n\n.justify-content-evenly {\n  justify-content: space-evenly !important;\n}\n\n.align-items-start {\n  align-items: flex-start !important;\n}\n\n.align-items-end {\n  align-items: flex-end !important;\n}\n\n.align-items-center {\n  align-items: center !important;\n}\n\n.align-items-baseline {\n  align-items: baseline !important;\n}\n\n.align-items-stretch {\n  align-items: stretch !important;\n}\n\n.align-content-start {\n  align-content: flex-start !important;\n}\n\n.align-content-end {\n  align-content: flex-end !important;\n}\n\n.align-content-center {\n  align-content: center !important;\n}\n\n.align-content-between {\n  align-content: space-between !important;\n}\n\n.align-content-around {\n  align-content: space-around !important;\n}\n\n.align-content-stretch {\n  align-content: stretch !important;\n}\n\n.align-self-auto {\n  align-self: auto !important;\n}\n\n.align-self-start {\n  align-self: flex-start !important;\n}\n\n.align-self-end {\n  align-self: flex-end !important;\n}\n\n.align-self-center {\n  align-self: center !important;\n}\n\n.align-self-baseline {\n  align-self: baseline !important;\n}\n\n.align-self-stretch {\n  align-self: stretch !important;\n}\n\n.order-first {\n  order: -1 !important;\n}\n\n.order-0 {\n  order: 0 !important;\n}\n\n.order-1 {\n  order: 1 !important;\n}\n\n.order-2 {\n  order: 2 !important;\n}\n\n.order-3 {\n  order: 3 !important;\n}\n\n.order-4 {\n  order: 4 !important;\n}\n\n.order-5 {\n  order: 5 !important;\n}\n\n.order-last {\n  order: 6 !important;\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.m-1 {\n  margin: 0.25rem !important;\n}\n\n.m-2 {\n  margin: 0.5rem !important;\n}\n\n.m-3 {\n  margin: 1rem !important;\n}\n\n.m-4 {\n  margin: 1.5rem !important;\n}\n\n.m-5 {\n  margin: 3rem !important;\n}\n\n.m-auto {\n  margin: auto !important;\n}\n\n.mx-0 {\n  margin-right: 0 !important;\n  margin-left: 0 !important;\n}\n\n.mx-1 {\n  margin-right: 0.25rem !important;\n  margin-left: 0.25rem !important;\n}\n\n.mx-2 {\n  margin-right: 0.5rem !important;\n  margin-left: 0.5rem !important;\n}\n\n.mx-3 {\n  margin-right: 1rem !important;\n  margin-left: 1rem !important;\n}\n\n.mx-4 {\n  margin-right: 1.5rem !important;\n  margin-left: 1.5rem !important;\n}\n\n.mx-5 {\n  margin-right: 3rem !important;\n  margin-left: 3rem !important;\n}\n\n.mx-auto {\n  margin-right: auto !important;\n  margin-left: auto !important;\n}\n\n.my-0 {\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n}\n\n.my-1 {\n  margin-top: 0.25rem !important;\n  margin-bottom: 0.25rem !important;\n}\n\n.my-2 {\n  margin-top: 0.5rem !important;\n  margin-bottom: 0.5rem !important;\n}\n\n.my-3 {\n  margin-top: 1rem !important;\n  margin-bottom: 1rem !important;\n}\n\n.my-4 {\n  margin-top: 1.5rem !important;\n  margin-bottom: 1.5rem !important;\n}\n\n.my-5 {\n  margin-top: 3rem !important;\n  margin-bottom: 3rem !important;\n}\n\n.my-auto {\n  margin-top: auto !important;\n  margin-bottom: auto !important;\n}\n\n.mt-0 {\n  margin-top: 0 !important;\n}\n\n.mt-1 {\n  margin-top: 0.25rem !important;\n}\n\n.mt-2 {\n  margin-top: 0.5rem !important;\n}\n\n.mt-3 {\n  margin-top: 1rem !important;\n}\n\n.mt-4 {\n  margin-top: 1.5rem !important;\n}\n\n.mt-5 {\n  margin-top: 3rem !important;\n}\n\n.mt-auto {\n  margin-top: auto !important;\n}\n\n.me-0 {\n  margin-right: 0 !important;\n}\n\n.me-1 {\n  margin-right: 0.25rem !important;\n}\n\n.me-2 {\n  margin-right: 0.5rem !important;\n}\n\n.me-3 {\n  margin-right: 1rem !important;\n}\n\n.me-4 {\n  margin-right: 1.5rem !important;\n}\n\n.me-5 {\n  margin-right: 3rem !important;\n}\n\n.me-auto {\n  margin-right: auto !important;\n}\n\n.mb-0 {\n  margin-bottom: 0 !important;\n}\n\n.mb-1 {\n  margin-bottom: 0.25rem !important;\n}\n\n.mb-2 {\n  margin-bottom: 0.5rem !important;\n}\n\n.mb-3 {\n  margin-bottom: 1rem !important;\n}\n\n.mb-4 {\n  margin-bottom: 1.5rem !important;\n}\n\n.mb-5 {\n  margin-bottom: 3rem !important;\n}\n\n.mb-auto {\n  margin-bottom: auto !important;\n}\n\n.ms-0 {\n  margin-left: 0 !important;\n}\n\n.ms-1 {\n  margin-left: 0.25rem !important;\n}\n\n.ms-2 {\n  margin-left: 0.5rem !important;\n}\n\n.ms-3 {\n  margin-left: 1rem !important;\n}\n\n.ms-4 {\n  margin-left: 1.5rem !important;\n}\n\n.ms-5 {\n  margin-left: 3rem !important;\n}\n\n.ms-auto {\n  margin-left: auto !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.p-1 {\n  padding: 0.25rem !important;\n}\n\n.p-2 {\n  padding: 0.5rem !important;\n}\n\n.p-3 {\n  padding: 1rem !important;\n}\n\n.p-4 {\n  padding: 1.5rem !important;\n}\n\n.p-5 {\n  padding: 3rem !important;\n}\n\n.px-0 {\n  padding-right: 0 !important;\n  padding-left: 0 !important;\n}\n\n.px-1 {\n  padding-right: 0.25rem !important;\n  padding-left: 0.25rem !important;\n}\n\n.px-2 {\n  padding-right: 0.5rem !important;\n  padding-left: 0.5rem !important;\n}\n\n.px-3 {\n  padding-right: 1rem !important;\n  padding-left: 1rem !important;\n}\n\n.px-4 {\n  padding-right: 1.5rem !important;\n  padding-left: 1.5rem !important;\n}\n\n.px-5 {\n  padding-right: 3rem !important;\n  padding-left: 3rem !important;\n}\n\n.py-0 {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n\n.py-1 {\n  padding-top: 0.25rem !important;\n  padding-bottom: 0.25rem !important;\n}\n\n.py-2 {\n  padding-top: 0.5rem !important;\n  padding-bottom: 0.5rem !important;\n}\n\n.py-3 {\n  padding-top: 1rem !important;\n  padding-bottom: 1rem !important;\n}\n\n.py-4 {\n  padding-top: 1.5rem !important;\n  padding-bottom: 1.5rem !important;\n}\n\n.py-5 {\n  padding-top: 3rem !important;\n  padding-bottom: 3rem !important;\n}\n\n.pt-0 {\n  padding-top: 0 !important;\n}\n\n.pt-1 {\n  padding-top: 0.25rem !important;\n}\n\n.pt-2 {\n  padding-top: 0.5rem !important;\n}\n\n.pt-3 {\n  padding-top: 1rem !important;\n}\n\n.pt-4 {\n  padding-top: 1.5rem !important;\n}\n\n.pt-5 {\n  padding-top: 3rem !important;\n}\n\n.pe-0 {\n  padding-right: 0 !important;\n}\n\n.pe-1 {\n  padding-right: 0.25rem !important;\n}\n\n.pe-2 {\n  padding-right: 0.5rem !important;\n}\n\n.pe-3 {\n  padding-right: 1rem !important;\n}\n\n.pe-4 {\n  padding-right: 1.5rem !important;\n}\n\n.pe-5 {\n  padding-right: 3rem !important;\n}\n\n.pb-0 {\n  padding-bottom: 0 !important;\n}\n\n.pb-1 {\n  padding-bottom: 0.25rem !important;\n}\n\n.pb-2 {\n  padding-bottom: 0.5rem !important;\n}\n\n.pb-3 {\n  padding-bottom: 1rem !important;\n}\n\n.pb-4 {\n  padding-bottom: 1.5rem !important;\n}\n\n.pb-5 {\n  padding-bottom: 3rem !important;\n}\n\n.ps-0 {\n  padding-left: 0 !important;\n}\n\n.ps-1 {\n  padding-left: 0.25rem !important;\n}\n\n.ps-2 {\n  padding-left: 0.5rem !important;\n}\n\n.ps-3 {\n  padding-left: 1rem !important;\n}\n\n.ps-4 {\n  padding-left: 1.5rem !important;\n}\n\n.ps-5 {\n  padding-left: 3rem !important;\n}\n\n.font-monospace {\n  font-family: var(--bs-font-monospace) !important;\n}\n\n.fs-1 {\n  font-size: calc(1.345rem + 1.14vw) !important;\n}\n\n.fs-2 {\n  font-size: calc(1.301rem + 0.612vw) !important;\n}\n\n.fs-3 {\n  font-size: calc(1.279rem + 0.348vw) !important;\n}\n\n.fs-4 {\n  font-size: calc(1.257rem + 0.084vw) !important;\n}\n\n.fs-5 {\n  font-size: 1.1rem !important;\n}\n\n.fs-6 {\n  font-size: 0.88rem !important;\n}\n\n.fst-italic {\n  font-style: italic !important;\n}\n\n.fst-normal {\n  font-style: normal !important;\n}\n\n.fw-light {\n  font-weight: 300 !important;\n}\n\n.fw-lighter {\n  font-weight: lighter !important;\n}\n\n.fw-normal {\n  font-weight: 400 !important;\n}\n\n.fw-bold {\n  font-weight: 700 !important;\n}\n\n.fw-bolder {\n  font-weight: bolder !important;\n}\n\n.lh-1 {\n  line-height: 1 !important;\n}\n\n.lh-sm {\n  line-height: 1.25 !important;\n}\n\n.lh-base {\n  line-height: 1.5 !important;\n}\n\n.lh-lg {\n  line-height: 2 !important;\n}\n\n.text-start {\n  text-align: left !important;\n}\n\n.text-end {\n  text-align: right !important;\n}\n\n.text-center {\n  text-align: center !important;\n}\n\n.text-decoration-none {\n  text-decoration: none !important;\n}\n\n.text-decoration-underline {\n  text-decoration: underline !important;\n}\n\n.text-decoration-line-through {\n  text-decoration: line-through !important;\n}\n\n.text-lowercase {\n  text-transform: lowercase !important;\n}\n\n.text-uppercase {\n  text-transform: uppercase !important;\n}\n\n.text-capitalize {\n  text-transform: capitalize !important;\n}\n\n.text-wrap {\n  white-space: normal !important;\n}\n\n.text-nowrap {\n  white-space: nowrap !important;\n}\n\n/* rtl:begin:remove */\n.text-break {\n  word-wrap: break-word !important;\n  word-break: break-word !important;\n}\n\n/* rtl:end:remove */\n.text-primary {\n  color: #545cd8 !important;\n}\n\n.text-secondary {\n  color: #6c757d !important;\n}\n\n.text-success {\n  color: #3ac47d !important;\n}\n\n.text-info {\n  color: #30b1ff !important;\n}\n\n.text-warning {\n  color: #f7b924 !important;\n}\n\n.text-danger {\n  color: #d92550 !important;\n}\n\n.text-light {\n  color: #eeeeee !important;\n}\n\n.text-dark {\n  color: #343a40 !important;\n}\n\n.text-focus {\n  color: #444054 !important;\n}\n\n.text-alternate {\n  color: #83588a !important;\n}\n\n.text-white {\n  color: #fff !important;\n}\n\n.text-body {\n  color: #495057 !important;\n}\n\n.text-muted {\n  color: #6c757d !important;\n}\n\n.text-black-50 {\n  color: rgba(0, 0, 0, 0.5) !important;\n}\n\n.text-white-50 {\n  color: rgba(255, 255, 255, 0.5) !important;\n}\n\n.text-reset {\n  color: inherit !important;\n}\n\n.bg-primary {\n  background-color: #545cd8 !important;\n}\n\n.bg-secondary {\n  background-color: #6c757d !important;\n}\n\n.bg-success {\n  background-color: #3ac47d !important;\n}\n\n.bg-info {\n  background-color: #30b1ff !important;\n}\n\n.bg-warning {\n  background-color: #f7b924 !important;\n}\n\n.bg-danger {\n  background-color: #d92550 !important;\n}\n\n.bg-light {\n  background-color: #eeeeee !important;\n}\n\n.bg-dark {\n  background-color: #343a40 !important;\n}\n\n.bg-focus {\n  background-color: #444054 !important;\n}\n\n.bg-alternate {\n  background-color: #83588a !important;\n}\n\n.bg-body {\n  background-color: #fff !important;\n}\n\n.bg-white {\n  background-color: #fff !important;\n}\n\n.bg-transparent {\n  background-color: transparent !important;\n}\n\n.bg-gradient {\n  background-image: var(--bs-gradient) !important;\n}\n\n.user-select-all {\n  user-select: all !important;\n}\n\n.user-select-auto {\n  user-select: auto !important;\n}\n\n.user-select-none {\n  user-select: none !important;\n}\n\n.pe-none {\n  pointer-events: none !important;\n}\n\n.pe-auto {\n  pointer-events: auto !important;\n}\n\n.rounded {\n  border-radius: 0.25rem !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n\n.rounded-1 {\n  border-radius: 0.2rem !important;\n}\n\n.rounded-2 {\n  border-radius: 0.25rem !important;\n}\n\n.rounded-3 {\n  border-radius: 0.3rem !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-pill {\n  border-radius: 50rem !important;\n}\n\n.rounded-top {\n  border-top-left-radius: 0.25rem !important;\n  border-top-right-radius: 0.25rem !important;\n}\n\n.rounded-end {\n  border-top-right-radius: 0.25rem !important;\n  border-bottom-right-radius: 0.25rem !important;\n}\n\n.rounded-bottom {\n  border-bottom-right-radius: 0.25rem !important;\n  border-bottom-left-radius: 0.25rem !important;\n}\n\n.rounded-start {\n  border-bottom-left-radius: 0.25rem !important;\n  border-top-left-radius: 0.25rem !important;\n}\n\n.visible {\n  visibility: visible !important;\n}\n\n.invisible {\n  visibility: hidden !important;\n}\n\n@media (min-width: 576px) {\n  .float-sm-start {\n    float: left !important;\n  }\n  .float-sm-end {\n    float: right !important;\n  }\n  .float-sm-none {\n    float: none !important;\n  }\n  .d-sm-inline {\n    display: inline !important;\n  }\n  .d-sm-inline-block {\n    display: inline-block !important;\n  }\n  .d-sm-block {\n    display: block !important;\n  }\n  .d-sm-grid {\n    display: grid !important;\n  }\n  .d-sm-table {\n    display: table !important;\n  }\n  .d-sm-table-row {\n    display: table-row !important;\n  }\n  .d-sm-table-cell {\n    display: table-cell !important;\n  }\n  .d-sm-flex {\n    display: flex !important;\n  }\n  .d-sm-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-sm-none {\n    display: none !important;\n  }\n  .flex-sm-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-sm-row {\n    flex-direction: row !important;\n  }\n  .flex-sm-column {\n    flex-direction: column !important;\n  }\n  .flex-sm-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-sm-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-sm-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-sm-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-sm-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-sm-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-sm-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-sm-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-sm-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .gap-sm-0 {\n    gap: 0 !important;\n  }\n  .gap-sm-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-sm-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-sm-3 {\n    gap: 1rem !important;\n  }\n  .gap-sm-4 {\n    gap: 1.5rem !important;\n  }\n  .gap-sm-5 {\n    gap: 3rem !important;\n  }\n  .justify-content-sm-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-sm-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-sm-center {\n    justify-content: center !important;\n  }\n  .justify-content-sm-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-sm-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-sm-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-sm-start {\n    align-items: flex-start !important;\n  }\n  .align-items-sm-end {\n    align-items: flex-end !important;\n  }\n  .align-items-sm-center {\n    align-items: center !important;\n  }\n  .align-items-sm-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-sm-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-sm-start {\n    align-content: flex-start !important;\n  }\n  .align-content-sm-end {\n    align-content: flex-end !important;\n  }\n  .align-content-sm-center {\n    align-content: center !important;\n  }\n  .align-content-sm-between {\n    align-content: space-between !important;\n  }\n  .align-content-sm-around {\n    align-content: space-around !important;\n  }\n  .align-content-sm-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-sm-auto {\n    align-self: auto !important;\n  }\n  .align-self-sm-start {\n    align-self: flex-start !important;\n  }\n  .align-self-sm-end {\n    align-self: flex-end !important;\n  }\n  .align-self-sm-center {\n    align-self: center !important;\n  }\n  .align-self-sm-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-sm-stretch {\n    align-self: stretch !important;\n  }\n  .order-sm-first {\n    order: -1 !important;\n  }\n  .order-sm-0 {\n    order: 0 !important;\n  }\n  .order-sm-1 {\n    order: 1 !important;\n  }\n  .order-sm-2 {\n    order: 2 !important;\n  }\n  .order-sm-3 {\n    order: 3 !important;\n  }\n  .order-sm-4 {\n    order: 4 !important;\n  }\n  .order-sm-5 {\n    order: 5 !important;\n  }\n  .order-sm-last {\n    order: 6 !important;\n  }\n  .m-sm-0 {\n    margin: 0 !important;\n  }\n  .m-sm-1 {\n    margin: 0.25rem !important;\n  }\n  .m-sm-2 {\n    margin: 0.5rem !important;\n  }\n  .m-sm-3 {\n    margin: 1rem !important;\n  }\n  .m-sm-4 {\n    margin: 1.5rem !important;\n  }\n  .m-sm-5 {\n    margin: 3rem !important;\n  }\n  .m-sm-auto {\n    margin: auto !important;\n  }\n  .mx-sm-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-sm-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-sm-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-sm-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-sm-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-sm-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-sm-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-sm-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-sm-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-sm-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-sm-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-sm-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-sm-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-sm-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-sm-0 {\n    margin-top: 0 !important;\n  }\n  .mt-sm-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-sm-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-sm-3 {\n    margin-top: 1rem !important;\n  }\n  .mt-sm-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-sm-5 {\n    margin-top: 3rem !important;\n  }\n  .mt-sm-auto {\n    margin-top: auto !important;\n  }\n  .me-sm-0 {\n    margin-right: 0 !important;\n  }\n  .me-sm-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-sm-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-sm-3 {\n    margin-right: 1rem !important;\n  }\n  .me-sm-4 {\n    margin-right: 1.5rem !important;\n  }\n  .me-sm-5 {\n    margin-right: 3rem !important;\n  }\n  .me-sm-auto {\n    margin-right: auto !important;\n  }\n  .mb-sm-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-sm-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-sm-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-sm-3 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-sm-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-sm-5 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-sm-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-sm-0 {\n    margin-left: 0 !important;\n  }\n  .ms-sm-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-sm-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-sm-3 {\n    margin-left: 1rem !important;\n  }\n  .ms-sm-4 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-sm-5 {\n    margin-left: 3rem !important;\n  }\n  .ms-sm-auto {\n    margin-left: auto !important;\n  }\n  .p-sm-0 {\n    padding: 0 !important;\n  }\n  .p-sm-1 {\n    padding: 0.25rem !important;\n  }\n  .p-sm-2 {\n    padding: 0.5rem !important;\n  }\n  .p-sm-3 {\n    padding: 1rem !important;\n  }\n  .p-sm-4 {\n    padding: 1.5rem !important;\n  }\n  .p-sm-5 {\n    padding: 3rem !important;\n  }\n  .px-sm-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-sm-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-sm-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-sm-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-sm-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-sm-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .py-sm-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-sm-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-sm-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-sm-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-sm-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-sm-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .pt-sm-0 {\n    padding-top: 0 !important;\n  }\n  .pt-sm-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-sm-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-sm-3 {\n    padding-top: 1rem !important;\n  }\n  .pt-sm-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-sm-5 {\n    padding-top: 3rem !important;\n  }\n  .pe-sm-0 {\n    padding-right: 0 !important;\n  }\n  .pe-sm-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-sm-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-sm-3 {\n    padding-right: 1rem !important;\n  }\n  .pe-sm-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-sm-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-sm-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-sm-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-sm-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-sm-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-sm-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-sm-5 {\n    padding-bottom: 3rem !important;\n  }\n  .ps-sm-0 {\n    padding-left: 0 !important;\n  }\n  .ps-sm-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-sm-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-sm-3 {\n    padding-left: 1rem !important;\n  }\n  .ps-sm-4 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-sm-5 {\n    padding-left: 3rem !important;\n  }\n  .text-sm-start {\n    text-align: left !important;\n  }\n  .text-sm-end {\n    text-align: right !important;\n  }\n  .text-sm-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 768px) {\n  .float-md-start {\n    float: left !important;\n  }\n  .float-md-end {\n    float: right !important;\n  }\n  .float-md-none {\n    float: none !important;\n  }\n  .d-md-inline {\n    display: inline !important;\n  }\n  .d-md-inline-block {\n    display: inline-block !important;\n  }\n  .d-md-block {\n    display: block !important;\n  }\n  .d-md-grid {\n    display: grid !important;\n  }\n  .d-md-table {\n    display: table !important;\n  }\n  .d-md-table-row {\n    display: table-row !important;\n  }\n  .d-md-table-cell {\n    display: table-cell !important;\n  }\n  .d-md-flex {\n    display: flex !important;\n  }\n  .d-md-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-md-none {\n    display: none !important;\n  }\n  .flex-md-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-md-row {\n    flex-direction: row !important;\n  }\n  .flex-md-column {\n    flex-direction: column !important;\n  }\n  .flex-md-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-md-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-md-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-md-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-md-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-md-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-md-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-md-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-md-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .gap-md-0 {\n    gap: 0 !important;\n  }\n  .gap-md-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-md-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-md-3 {\n    gap: 1rem !important;\n  }\n  .gap-md-4 {\n    gap: 1.5rem !important;\n  }\n  .gap-md-5 {\n    gap: 3rem !important;\n  }\n  .justify-content-md-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-md-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-md-center {\n    justify-content: center !important;\n  }\n  .justify-content-md-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-md-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-md-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-md-start {\n    align-items: flex-start !important;\n  }\n  .align-items-md-end {\n    align-items: flex-end !important;\n  }\n  .align-items-md-center {\n    align-items: center !important;\n  }\n  .align-items-md-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-md-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-md-start {\n    align-content: flex-start !important;\n  }\n  .align-content-md-end {\n    align-content: flex-end !important;\n  }\n  .align-content-md-center {\n    align-content: center !important;\n  }\n  .align-content-md-between {\n    align-content: space-between !important;\n  }\n  .align-content-md-around {\n    align-content: space-around !important;\n  }\n  .align-content-md-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-md-auto {\n    align-self: auto !important;\n  }\n  .align-self-md-start {\n    align-self: flex-start !important;\n  }\n  .align-self-md-end {\n    align-self: flex-end !important;\n  }\n  .align-self-md-center {\n    align-self: center !important;\n  }\n  .align-self-md-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-md-stretch {\n    align-self: stretch !important;\n  }\n  .order-md-first {\n    order: -1 !important;\n  }\n  .order-md-0 {\n    order: 0 !important;\n  }\n  .order-md-1 {\n    order: 1 !important;\n  }\n  .order-md-2 {\n    order: 2 !important;\n  }\n  .order-md-3 {\n    order: 3 !important;\n  }\n  .order-md-4 {\n    order: 4 !important;\n  }\n  .order-md-5 {\n    order: 5 !important;\n  }\n  .order-md-last {\n    order: 6 !important;\n  }\n  .m-md-0 {\n    margin: 0 !important;\n  }\n  .m-md-1 {\n    margin: 0.25rem !important;\n  }\n  .m-md-2 {\n    margin: 0.5rem !important;\n  }\n  .m-md-3 {\n    margin: 1rem !important;\n  }\n  .m-md-4 {\n    margin: 1.5rem !important;\n  }\n  .m-md-5 {\n    margin: 3rem !important;\n  }\n  .m-md-auto {\n    margin: auto !important;\n  }\n  .mx-md-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-md-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-md-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-md-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-md-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-md-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-md-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-md-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-md-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-md-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-md-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-md-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-md-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-md-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-md-0 {\n    margin-top: 0 !important;\n  }\n  .mt-md-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-md-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-md-3 {\n    margin-top: 1rem !important;\n  }\n  .mt-md-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-md-5 {\n    margin-top: 3rem !important;\n  }\n  .mt-md-auto {\n    margin-top: auto !important;\n  }\n  .me-md-0 {\n    margin-right: 0 !important;\n  }\n  .me-md-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-md-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-md-3 {\n    margin-right: 1rem !important;\n  }\n  .me-md-4 {\n    margin-right: 1.5rem !important;\n  }\n  .me-md-5 {\n    margin-right: 3rem !important;\n  }\n  .me-md-auto {\n    margin-right: auto !important;\n  }\n  .mb-md-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-md-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-md-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-md-3 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-md-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-md-5 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-md-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-md-0 {\n    margin-left: 0 !important;\n  }\n  .ms-md-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-md-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-md-3 {\n    margin-left: 1rem !important;\n  }\n  .ms-md-4 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-md-5 {\n    margin-left: 3rem !important;\n  }\n  .ms-md-auto {\n    margin-left: auto !important;\n  }\n  .p-md-0 {\n    padding: 0 !important;\n  }\n  .p-md-1 {\n    padding: 0.25rem !important;\n  }\n  .p-md-2 {\n    padding: 0.5rem !important;\n  }\n  .p-md-3 {\n    padding: 1rem !important;\n  }\n  .p-md-4 {\n    padding: 1.5rem !important;\n  }\n  .p-md-5 {\n    padding: 3rem !important;\n  }\n  .px-md-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-md-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-md-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-md-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-md-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-md-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .py-md-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-md-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-md-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-md-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-md-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-md-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .pt-md-0 {\n    padding-top: 0 !important;\n  }\n  .pt-md-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-md-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-md-3 {\n    padding-top: 1rem !important;\n  }\n  .pt-md-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-md-5 {\n    padding-top: 3rem !important;\n  }\n  .pe-md-0 {\n    padding-right: 0 !important;\n  }\n  .pe-md-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-md-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-md-3 {\n    padding-right: 1rem !important;\n  }\n  .pe-md-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-md-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-md-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-md-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-md-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-md-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-md-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-md-5 {\n    padding-bottom: 3rem !important;\n  }\n  .ps-md-0 {\n    padding-left: 0 !important;\n  }\n  .ps-md-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-md-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-md-3 {\n    padding-left: 1rem !important;\n  }\n  .ps-md-4 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-md-5 {\n    padding-left: 3rem !important;\n  }\n  .text-md-start {\n    text-align: left !important;\n  }\n  .text-md-end {\n    text-align: right !important;\n  }\n  .text-md-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 992px) {\n  .float-lg-start {\n    float: left !important;\n  }\n  .float-lg-end {\n    float: right !important;\n  }\n  .float-lg-none {\n    float: none !important;\n  }\n  .d-lg-inline {\n    display: inline !important;\n  }\n  .d-lg-inline-block {\n    display: inline-block !important;\n  }\n  .d-lg-block {\n    display: block !important;\n  }\n  .d-lg-grid {\n    display: grid !important;\n  }\n  .d-lg-table {\n    display: table !important;\n  }\n  .d-lg-table-row {\n    display: table-row !important;\n  }\n  .d-lg-table-cell {\n    display: table-cell !important;\n  }\n  .d-lg-flex {\n    display: flex !important;\n  }\n  .d-lg-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-lg-none {\n    display: none !important;\n  }\n  .flex-lg-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-lg-row {\n    flex-direction: row !important;\n  }\n  .flex-lg-column {\n    flex-direction: column !important;\n  }\n  .flex-lg-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-lg-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-lg-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-lg-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-lg-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-lg-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-lg-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-lg-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-lg-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .gap-lg-0 {\n    gap: 0 !important;\n  }\n  .gap-lg-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-lg-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-lg-3 {\n    gap: 1rem !important;\n  }\n  .gap-lg-4 {\n    gap: 1.5rem !important;\n  }\n  .gap-lg-5 {\n    gap: 3rem !important;\n  }\n  .justify-content-lg-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-lg-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-lg-center {\n    justify-content: center !important;\n  }\n  .justify-content-lg-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-lg-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-lg-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-lg-start {\n    align-items: flex-start !important;\n  }\n  .align-items-lg-end {\n    align-items: flex-end !important;\n  }\n  .align-items-lg-center {\n    align-items: center !important;\n  }\n  .align-items-lg-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-lg-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-lg-start {\n    align-content: flex-start !important;\n  }\n  .align-content-lg-end {\n    align-content: flex-end !important;\n  }\n  .align-content-lg-center {\n    align-content: center !important;\n  }\n  .align-content-lg-between {\n    align-content: space-between !important;\n  }\n  .align-content-lg-around {\n    align-content: space-around !important;\n  }\n  .align-content-lg-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-lg-auto {\n    align-self: auto !important;\n  }\n  .align-self-lg-start {\n    align-self: flex-start !important;\n  }\n  .align-self-lg-end {\n    align-self: flex-end !important;\n  }\n  .align-self-lg-center {\n    align-self: center !important;\n  }\n  .align-self-lg-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-lg-stretch {\n    align-self: stretch !important;\n  }\n  .order-lg-first {\n    order: -1 !important;\n  }\n  .order-lg-0 {\n    order: 0 !important;\n  }\n  .order-lg-1 {\n    order: 1 !important;\n  }\n  .order-lg-2 {\n    order: 2 !important;\n  }\n  .order-lg-3 {\n    order: 3 !important;\n  }\n  .order-lg-4 {\n    order: 4 !important;\n  }\n  .order-lg-5 {\n    order: 5 !important;\n  }\n  .order-lg-last {\n    order: 6 !important;\n  }\n  .m-lg-0 {\n    margin: 0 !important;\n  }\n  .m-lg-1 {\n    margin: 0.25rem !important;\n  }\n  .m-lg-2 {\n    margin: 0.5rem !important;\n  }\n  .m-lg-3 {\n    margin: 1rem !important;\n  }\n  .m-lg-4 {\n    margin: 1.5rem !important;\n  }\n  .m-lg-5 {\n    margin: 3rem !important;\n  }\n  .m-lg-auto {\n    margin: auto !important;\n  }\n  .mx-lg-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-lg-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-lg-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-lg-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-lg-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-lg-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-lg-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-lg-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-lg-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-lg-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-lg-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-lg-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-lg-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-lg-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-lg-0 {\n    margin-top: 0 !important;\n  }\n  .mt-lg-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-lg-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-lg-3 {\n    margin-top: 1rem !important;\n  }\n  .mt-lg-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-lg-5 {\n    margin-top: 3rem !important;\n  }\n  .mt-lg-auto {\n    margin-top: auto !important;\n  }\n  .me-lg-0 {\n    margin-right: 0 !important;\n  }\n  .me-lg-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-lg-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-lg-3 {\n    margin-right: 1rem !important;\n  }\n  .me-lg-4 {\n    margin-right: 1.5rem !important;\n  }\n  .me-lg-5 {\n    margin-right: 3rem !important;\n  }\n  .me-lg-auto {\n    margin-right: auto !important;\n  }\n  .mb-lg-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-lg-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-lg-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-lg-3 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-lg-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-lg-5 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-lg-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-lg-0 {\n    margin-left: 0 !important;\n  }\n  .ms-lg-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-lg-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-lg-3 {\n    margin-left: 1rem !important;\n  }\n  .ms-lg-4 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-lg-5 {\n    margin-left: 3rem !important;\n  }\n  .ms-lg-auto {\n    margin-left: auto !important;\n  }\n  .p-lg-0 {\n    padding: 0 !important;\n  }\n  .p-lg-1 {\n    padding: 0.25rem !important;\n  }\n  .p-lg-2 {\n    padding: 0.5rem !important;\n  }\n  .p-lg-3 {\n    padding: 1rem !important;\n  }\n  .p-lg-4 {\n    padding: 1.5rem !important;\n  }\n  .p-lg-5 {\n    padding: 3rem !important;\n  }\n  .px-lg-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-lg-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-lg-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-lg-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-lg-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-lg-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .py-lg-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-lg-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-lg-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-lg-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-lg-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-lg-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .pt-lg-0 {\n    padding-top: 0 !important;\n  }\n  .pt-lg-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-lg-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-lg-3 {\n    padding-top: 1rem !important;\n  }\n  .pt-lg-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-lg-5 {\n    padding-top: 3rem !important;\n  }\n  .pe-lg-0 {\n    padding-right: 0 !important;\n  }\n  .pe-lg-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-lg-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-lg-3 {\n    padding-right: 1rem !important;\n  }\n  .pe-lg-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-lg-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-lg-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-lg-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-lg-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-lg-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-lg-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-lg-5 {\n    padding-bottom: 3rem !important;\n  }\n  .ps-lg-0 {\n    padding-left: 0 !important;\n  }\n  .ps-lg-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-lg-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-lg-3 {\n    padding-left: 1rem !important;\n  }\n  .ps-lg-4 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-lg-5 {\n    padding-left: 3rem !important;\n  }\n  .text-lg-start {\n    text-align: left !important;\n  }\n  .text-lg-end {\n    text-align: right !important;\n  }\n  .text-lg-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1200px) {\n  .float-xl-start {\n    float: left !important;\n  }\n  .float-xl-end {\n    float: right !important;\n  }\n  .float-xl-none {\n    float: none !important;\n  }\n  .d-xl-inline {\n    display: inline !important;\n  }\n  .d-xl-inline-block {\n    display: inline-block !important;\n  }\n  .d-xl-block {\n    display: block !important;\n  }\n  .d-xl-grid {\n    display: grid !important;\n  }\n  .d-xl-table {\n    display: table !important;\n  }\n  .d-xl-table-row {\n    display: table-row !important;\n  }\n  .d-xl-table-cell {\n    display: table-cell !important;\n  }\n  .d-xl-flex {\n    display: flex !important;\n  }\n  .d-xl-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-xl-none {\n    display: none !important;\n  }\n  .flex-xl-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-xl-row {\n    flex-direction: row !important;\n  }\n  .flex-xl-column {\n    flex-direction: column !important;\n  }\n  .flex-xl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-xl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-xl-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-xl-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-xl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-xl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-xl-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-xl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-xl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .gap-xl-0 {\n    gap: 0 !important;\n  }\n  .gap-xl-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-xl-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-xl-3 {\n    gap: 1rem !important;\n  }\n  .gap-xl-4 {\n    gap: 1.5rem !important;\n  }\n  .gap-xl-5 {\n    gap: 3rem !important;\n  }\n  .justify-content-xl-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-xl-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-xl-center {\n    justify-content: center !important;\n  }\n  .justify-content-xl-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-xl-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-xl-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-xl-start {\n    align-items: flex-start !important;\n  }\n  .align-items-xl-end {\n    align-items: flex-end !important;\n  }\n  .align-items-xl-center {\n    align-items: center !important;\n  }\n  .align-items-xl-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-xl-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-xl-start {\n    align-content: flex-start !important;\n  }\n  .align-content-xl-end {\n    align-content: flex-end !important;\n  }\n  .align-content-xl-center {\n    align-content: center !important;\n  }\n  .align-content-xl-between {\n    align-content: space-between !important;\n  }\n  .align-content-xl-around {\n    align-content: space-around !important;\n  }\n  .align-content-xl-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-xl-auto {\n    align-self: auto !important;\n  }\n  .align-self-xl-start {\n    align-self: flex-start !important;\n  }\n  .align-self-xl-end {\n    align-self: flex-end !important;\n  }\n  .align-self-xl-center {\n    align-self: center !important;\n  }\n  .align-self-xl-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-xl-stretch {\n    align-self: stretch !important;\n  }\n  .order-xl-first {\n    order: -1 !important;\n  }\n  .order-xl-0 {\n    order: 0 !important;\n  }\n  .order-xl-1 {\n    order: 1 !important;\n  }\n  .order-xl-2 {\n    order: 2 !important;\n  }\n  .order-xl-3 {\n    order: 3 !important;\n  }\n  .order-xl-4 {\n    order: 4 !important;\n  }\n  .order-xl-5 {\n    order: 5 !important;\n  }\n  .order-xl-last {\n    order: 6 !important;\n  }\n  .m-xl-0 {\n    margin: 0 !important;\n  }\n  .m-xl-1 {\n    margin: 0.25rem !important;\n  }\n  .m-xl-2 {\n    margin: 0.5rem !important;\n  }\n  .m-xl-3 {\n    margin: 1rem !important;\n  }\n  .m-xl-4 {\n    margin: 1.5rem !important;\n  }\n  .m-xl-5 {\n    margin: 3rem !important;\n  }\n  .m-xl-auto {\n    margin: auto !important;\n  }\n  .mx-xl-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-xl-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-xl-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-xl-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-xl-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-xl-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-xl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-xl-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-xl-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-xl-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-xl-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-xl-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-xl-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-xl-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-xl-0 {\n    margin-top: 0 !important;\n  }\n  .mt-xl-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-xl-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-xl-3 {\n    margin-top: 1rem !important;\n  }\n  .mt-xl-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-xl-5 {\n    margin-top: 3rem !important;\n  }\n  .mt-xl-auto {\n    margin-top: auto !important;\n  }\n  .me-xl-0 {\n    margin-right: 0 !important;\n  }\n  .me-xl-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-xl-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-xl-3 {\n    margin-right: 1rem !important;\n  }\n  .me-xl-4 {\n    margin-right: 1.5rem !important;\n  }\n  .me-xl-5 {\n    margin-right: 3rem !important;\n  }\n  .me-xl-auto {\n    margin-right: auto !important;\n  }\n  .mb-xl-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-xl-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-xl-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-xl-3 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-xl-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-xl-5 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-xl-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-xl-0 {\n    margin-left: 0 !important;\n  }\n  .ms-xl-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-xl-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-xl-3 {\n    margin-left: 1rem !important;\n  }\n  .ms-xl-4 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-xl-5 {\n    margin-left: 3rem !important;\n  }\n  .ms-xl-auto {\n    margin-left: auto !important;\n  }\n  .p-xl-0 {\n    padding: 0 !important;\n  }\n  .p-xl-1 {\n    padding: 0.25rem !important;\n  }\n  .p-xl-2 {\n    padding: 0.5rem !important;\n  }\n  .p-xl-3 {\n    padding: 1rem !important;\n  }\n  .p-xl-4 {\n    padding: 1.5rem !important;\n  }\n  .p-xl-5 {\n    padding: 3rem !important;\n  }\n  .px-xl-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-xl-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-xl-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-xl-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-xl-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-xl-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .py-xl-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-xl-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-xl-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-xl-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-xl-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-xl-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .pt-xl-0 {\n    padding-top: 0 !important;\n  }\n  .pt-xl-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-xl-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-xl-3 {\n    padding-top: 1rem !important;\n  }\n  .pt-xl-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-xl-5 {\n    padding-top: 3rem !important;\n  }\n  .pe-xl-0 {\n    padding-right: 0 !important;\n  }\n  .pe-xl-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-xl-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-xl-3 {\n    padding-right: 1rem !important;\n  }\n  .pe-xl-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-xl-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-xl-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-xl-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-xl-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-xl-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-xl-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-xl-5 {\n    padding-bottom: 3rem !important;\n  }\n  .ps-xl-0 {\n    padding-left: 0 !important;\n  }\n  .ps-xl-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-xl-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-xl-3 {\n    padding-left: 1rem !important;\n  }\n  .ps-xl-4 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-xl-5 {\n    padding-left: 3rem !important;\n  }\n  .text-xl-start {\n    text-align: left !important;\n  }\n  .text-xl-end {\n    text-align: right !important;\n  }\n  .text-xl-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1400px) {\n  .float-xxl-start {\n    float: left !important;\n  }\n  .float-xxl-end {\n    float: right !important;\n  }\n  .float-xxl-none {\n    float: none !important;\n  }\n  .d-xxl-inline {\n    display: inline !important;\n  }\n  .d-xxl-inline-block {\n    display: inline-block !important;\n  }\n  .d-xxl-block {\n    display: block !important;\n  }\n  .d-xxl-grid {\n    display: grid !important;\n  }\n  .d-xxl-table {\n    display: table !important;\n  }\n  .d-xxl-table-row {\n    display: table-row !important;\n  }\n  .d-xxl-table-cell {\n    display: table-cell !important;\n  }\n  .d-xxl-flex {\n    display: flex !important;\n  }\n  .d-xxl-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-xxl-none {\n    display: none !important;\n  }\n  .flex-xxl-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-xxl-row {\n    flex-direction: row !important;\n  }\n  .flex-xxl-column {\n    flex-direction: column !important;\n  }\n  .flex-xxl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-xxl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-xxl-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-xxl-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-xxl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-xxl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-xxl-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-xxl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-xxl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .gap-xxl-0 {\n    gap: 0 !important;\n  }\n  .gap-xxl-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-xxl-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-xxl-3 {\n    gap: 1rem !important;\n  }\n  .gap-xxl-4 {\n    gap: 1.5rem !important;\n  }\n  .gap-xxl-5 {\n    gap: 3rem !important;\n  }\n  .justify-content-xxl-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-xxl-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-xxl-center {\n    justify-content: center !important;\n  }\n  .justify-content-xxl-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-xxl-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-xxl-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-xxl-start {\n    align-items: flex-start !important;\n  }\n  .align-items-xxl-end {\n    align-items: flex-end !important;\n  }\n  .align-items-xxl-center {\n    align-items: center !important;\n  }\n  .align-items-xxl-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-xxl-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-xxl-start {\n    align-content: flex-start !important;\n  }\n  .align-content-xxl-end {\n    align-content: flex-end !important;\n  }\n  .align-content-xxl-center {\n    align-content: center !important;\n  }\n  .align-content-xxl-between {\n    align-content: space-between !important;\n  }\n  .align-content-xxl-around {\n    align-content: space-around !important;\n  }\n  .align-content-xxl-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-xxl-auto {\n    align-self: auto !important;\n  }\n  .align-self-xxl-start {\n    align-self: flex-start !important;\n  }\n  .align-self-xxl-end {\n    align-self: flex-end !important;\n  }\n  .align-self-xxl-center {\n    align-self: center !important;\n  }\n  .align-self-xxl-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-xxl-stretch {\n    align-self: stretch !important;\n  }\n  .order-xxl-first {\n    order: -1 !important;\n  }\n  .order-xxl-0 {\n    order: 0 !important;\n  }\n  .order-xxl-1 {\n    order: 1 !important;\n  }\n  .order-xxl-2 {\n    order: 2 !important;\n  }\n  .order-xxl-3 {\n    order: 3 !important;\n  }\n  .order-xxl-4 {\n    order: 4 !important;\n  }\n  .order-xxl-5 {\n    order: 5 !important;\n  }\n  .order-xxl-last {\n    order: 6 !important;\n  }\n  .m-xxl-0 {\n    margin: 0 !important;\n  }\n  .m-xxl-1 {\n    margin: 0.25rem !important;\n  }\n  .m-xxl-2 {\n    margin: 0.5rem !important;\n  }\n  .m-xxl-3 {\n    margin: 1rem !important;\n  }\n  .m-xxl-4 {\n    margin: 1.5rem !important;\n  }\n  .m-xxl-5 {\n    margin: 3rem !important;\n  }\n  .m-xxl-auto {\n    margin: auto !important;\n  }\n  .mx-xxl-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-xxl-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-xxl-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-xxl-3 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-xxl-4 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-xxl-5 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-xxl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-xxl-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-xxl-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-xxl-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-xxl-3 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-xxl-4 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-xxl-5 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-xxl-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-xxl-0 {\n    margin-top: 0 !important;\n  }\n  .mt-xxl-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-xxl-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-xxl-3 {\n    margin-top: 1rem !important;\n  }\n  .mt-xxl-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-xxl-5 {\n    margin-top: 3rem !important;\n  }\n  .mt-xxl-auto {\n    margin-top: auto !important;\n  }\n  .me-xxl-0 {\n    margin-right: 0 !important;\n  }\n  .me-xxl-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-xxl-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-xxl-3 {\n    margin-right: 1rem !important;\n  }\n  .me-xxl-4 {\n    margin-right: 1.5rem !important;\n  }\n  .me-xxl-5 {\n    margin-right: 3rem !important;\n  }\n  .me-xxl-auto {\n    margin-right: auto !important;\n  }\n  .mb-xxl-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-xxl-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-xxl-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-xxl-3 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-xxl-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-xxl-5 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-xxl-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-xxl-0 {\n    margin-left: 0 !important;\n  }\n  .ms-xxl-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-xxl-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-xxl-3 {\n    margin-left: 1rem !important;\n  }\n  .ms-xxl-4 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-xxl-5 {\n    margin-left: 3rem !important;\n  }\n  .ms-xxl-auto {\n    margin-left: auto !important;\n  }\n  .p-xxl-0 {\n    padding: 0 !important;\n  }\n  .p-xxl-1 {\n    padding: 0.25rem !important;\n  }\n  .p-xxl-2 {\n    padding: 0.5rem !important;\n  }\n  .p-xxl-3 {\n    padding: 1rem !important;\n  }\n  .p-xxl-4 {\n    padding: 1.5rem !important;\n  }\n  .p-xxl-5 {\n    padding: 3rem !important;\n  }\n  .px-xxl-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-xxl-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-xxl-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-xxl-3 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-xxl-4 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-xxl-5 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .py-xxl-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-xxl-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-xxl-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-xxl-3 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-xxl-4 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-xxl-5 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .pt-xxl-0 {\n    padding-top: 0 !important;\n  }\n  .pt-xxl-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-xxl-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-xxl-3 {\n    padding-top: 1rem !important;\n  }\n  .pt-xxl-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-xxl-5 {\n    padding-top: 3rem !important;\n  }\n  .pe-xxl-0 {\n    padding-right: 0 !important;\n  }\n  .pe-xxl-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-xxl-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-xxl-3 {\n    padding-right: 1rem !important;\n  }\n  .pe-xxl-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-xxl-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-xxl-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-xxl-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-xxl-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-xxl-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-xxl-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-xxl-5 {\n    padding-bottom: 3rem !important;\n  }\n  .ps-xxl-0 {\n    padding-left: 0 !important;\n  }\n  .ps-xxl-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-xxl-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-xxl-3 {\n    padding-left: 1rem !important;\n  }\n  .ps-xxl-4 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-xxl-5 {\n    padding-left: 3rem !important;\n  }\n  .text-xxl-start {\n    text-align: left !important;\n  }\n  .text-xxl-end {\n    text-align: right !important;\n  }\n  .text-xxl-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1200px) {\n  .fs-1 {\n    font-size: 2.2rem !important;\n  }\n  .fs-2 {\n    font-size: 1.76rem !important;\n  }\n  .fs-3 {\n    font-size: 1.54rem !important;\n  }\n  .fs-4 {\n    font-size: 1.32rem !important;\n  }\n}\n@media print {\n  .d-print-inline {\n    display: inline !important;\n  }\n  .d-print-inline-block {\n    display: inline-block !important;\n  }\n  .d-print-block {\n    display: block !important;\n  }\n  .d-print-grid {\n    display: grid !important;\n  }\n  .d-print-table {\n    display: table !important;\n  }\n  .d-print-table-row {\n    display: table-row !important;\n  }\n  .d-print-table-cell {\n    display: table-cell !important;\n  }\n  .d-print-flex {\n    display: flex !important;\n  }\n  .d-print-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-print-none {\n    display: none !important;\n  }\n}\na,\nbutton,\n.btn {\n  outline: none !important;\n}\n\n.app-container {\n  display: flex;\n  min-height: 100vh;\n  flex-direction: column;\n  margin: 0;\n}\n\n.SidebarAnimation-appear {\n  transform: translateX(-30px);\n  opacity: 0;\n}\n.SidebarAnimation-appear.SidebarAnimation-appear-active {\n  opacity: 1;\n  transform: translateX(0);\n  transition: all 0.4s linear;\n}\n\n.HeaderAnimation-appear {\n  transform: translateY(-30px);\n  opacity: 0;\n}\n.HeaderAnimation-appear.HeaderAnimation-appear-active {\n  opacity: 1;\n  transform: translateY(0);\n  transition: all 0.4s linear;\n}\n\n.MainAnimation-appear {\n  transform: translateY(-30px);\n  opacity: 0;\n}\n.MainAnimation-appear.MainAnimation-appear-active {\n  opacity: 1;\n  transform: translateY(0);\n  transition: all 0.4s linear;\n}\n\n.app-header {\n  height: 60px;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  position: relative;\n  z-index: 10;\n  transition: all 0.2s;\n}\n.app-header.header-shadow {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);\n}\n.app-header .app-header__content {\n  display: flex;\n  align-items: center;\n  align-content: center;\n  flex: 1;\n  padding: 0 1.5rem;\n  height: 60px;\n}\n.app-header .app-header__content .app-header-left {\n  display: flex;\n  align-items: center;\n}\n.app-header .app-header__content .app-header-right {\n  align-items: center;\n  display: flex;\n  margin-left: auto;\n}\n.app-header .header-user-info > .widget-heading, .app-header .header-user-info > .widget-subheading {\n  white-space: nowrap;\n}\n.app-header .header-user-info > .widget-subheading {\n  font-size: 0.8rem;\n}\n\n.app-header__logo {\n  padding: 0 1.5rem;\n  height: 60px;\n  width: 280px;\n  display: flex;\n  align-items: center;\n  transition: width 0.2s;\n}\n.app-header__logo .logo-src {\n  height: 23px;\n  width: 97px;\n  background: url(\"../../../assets/utils/images/Arkos_color_logo 1.svg\");\n}\n\n.app-header__menu,\n.app-header__mobile-menu {\n  display: none;\n  padding: 0 1.5rem;\n  height: 60px;\n  align-items: center;\n}\n\n.fixed-header .app-header {\n  position: fixed;\n  width: 100%;\n  top: 0;\n}\n.fixed-header .app-header .app-header__logo {\n  visibility: visible;\n}\n.fixed-header .app-main {\n  padding-top: 60px;\n}\n.fixed-header:not(.fixed-sidebar):not(.closed-sidebar) .app-sidebar .app-header__logo {\n  visibility: hidden;\n}\n\n.check-align-center {\n  display: flex;\n  align-items: center;\n}\n\n.check-column-center {\n  display: flex;\n  justify-content: center;\n}\n\n.header-dots {\n  margin-left: auto;\n  display: flex;\n}\n.header-dots > .dropdown {\n  display: flex;\n  align-content: center;\n}\n.header-dots .icon-wrapper-alt {\n  margin: 0;\n  height: 44px;\n  width: 44px;\n  text-align: center;\n  overflow: visible;\n}\n.header-dots .icon-wrapper-alt .language-icon {\n  border-radius: 30px;\n  position: relative;\n  z-index: 4;\n  width: 28px;\n  height: 28px;\n  overflow: hidden;\n  margin: 0 auto;\n}\n.header-dots .icon-wrapper-alt .language-icon img {\n  position: relative;\n  top: 50%;\n  left: 50%;\n  margin: -22px 0 0 -20px;\n}\n.header-dots .icon-wrapper-alt .icon-wrapper-bg {\n  opacity: 0.1;\n  transition: opacity 0.2s;\n  border-radius: 40px;\n}\n.header-dots .icon-wrapper-alt svg {\n  margin: 0 auto;\n}\n@-moz-document url-prefix() {\n  .header-dots .icon-wrapper-alt svg {\n    width: 50%;\n  }\n}\n.header-dots .icon-wrapper-alt i {\n  font-size: 1.3rem;\n}\n.header-dots .icon-wrapper-alt:hover {\n  cursor: pointer;\n}\n.header-dots .icon-wrapper-alt:hover .icon-wrapper-bg {\n  opacity: 0.2;\n}\n.header-dots .icon-wrapper-alt .badge-dot {\n  top: 1px;\n  right: 1px;\n  border: 0;\n}\n\n.header-megamenu.nav > li > .nav-link {\n  color: #6c757d;\n  padding-left: 0.6666666667rem;\n  padding-right: 0.6666666667rem;\n}\n.header-megamenu.nav > li > .nav-link .rounded-pill {\n  padding: 5px 7px;\n}\n.header-megamenu.nav > li > .nav-link:hover {\n  color: #343a40;\n}\n.header-megamenu.nav > li > .nav-link svg {\n  margin-top: 1px;\n}\n\n.header-btn-lg {\n  padding: 0 0 0 1.5rem;\n  margin-left: 1.5rem;\n  display: flex;\n  align-items: center;\n  position: relative;\n  /*&::before {\n    position: absolute;\n    left: -1px;\n    top: 50%;\n    background: $border-color;\n    width: 1px;\n    height: 30px;\n    margin-top: -15px;\n    content: '';\n  }*/\n}\n.header-btn-lg .hamburger-inner,\n.header-btn-lg .hamburger-inner::before,\n.header-btn-lg .hamburger-inner::after {\n  background: #6c757d;\n}\n\n.app-header.header-text-light .app-header-left > .nav > li > .nav-link {\n  color: rgba(255, 255, 255, 0.7);\n}\n.app-header.header-text-light .app-header-left > .nav > li > .nav-link .nav-link-icon {\n  color: rgba(255, 255, 255, 0.8);\n}\n.app-header.header-text-light .app-header-left > .nav > li > .nav-link:hover {\n  color: rgb(255, 255, 255);\n}\n.app-header.header-text-light .app-header-right .icon-wrapper-alt svg {\n  fill: rgba(255, 255, 255, 0.7);\n  transition: all 0.2s;\n}\n.app-header.header-text-light .app-header-right .icon-wrapper-alt .icon-wrapper-bg {\n  background: rgba(255, 255, 255, 0.1) !important;\n  transition: all 0.2s;\n  opacity: 1;\n}\n.app-header.header-text-light .app-header-right .icon-wrapper-alt:hover svg {\n  fill: rgba(255, 255, 255, 0.95);\n}\n.app-header.header-text-light .app-header-right .icon-wrapper-alt:hover .icon-wrapper-bg {\n  background: rgba(255, 255, 255, 0.15) !important;\n}\n.app-header.header-text-light .app-header-right .icon-wrapper-alt .badge-dot {\n  border-color: transparent;\n}\n.app-header.header-text-light .app-header-right > .header-btn-lg .widget-content-left .btn-group > .btn-link,\n.app-header.header-text-light .app-header-right > .header-btn-lg .widget-heading,\n.app-header.header-text-light .app-header-right > .header-btn-lg .widget-subheading {\n  color: rgba(255, 255, 255, 0.8);\n}\n.app-header.header-text-light .app-header-right > .header-btn-lg .header-user-info > .btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(0, 0, 0, 0.1), 0 0.0625rem 0.125rem rgba(0, 0, 0, 0.2);\n}\n.app-header.header-text-light .search-wrapper .input-holder .search-icon {\n  background: rgba(0, 0, 0, 0.1);\n}\n.app-header.header-text-light .search-wrapper .input-holder .search-input::placeholder, .app-header.header-text-light .search-wrapper .input-holder .search-input::-webkit-input-placeholder, .app-header.header-text-light .search-wrapper .input-holder .search-input:-ms-input-placeholder, .app-header.header-text-light .search-wrapper .input-holder .search-input:-moz-placeholder, .app-header.header-text-light .search-wrapper .input-holder .search-input::-moz-placeholder {\n  color: rgba(255, 255, 255, 0.5) !important;\n}\n.app-header.header-text-light .search-wrapper.active .input-holder {\n  background: rgba(255, 255, 255, 0.1);\n}\n.app-header.header-text-light .search-wrapper.active .input-holder .search-input {\n  color: rgba(255, 255, 255, 0.8);\n}\n.app-header.header-text-light .search-wrapper.active .input-holder .search-icon {\n  background: rgba(255, 255, 255, 0.1);\n}\n.app-header.header-text-light .header-btn-lg::before {\n  background: rgba(255, 255, 255, 0.2);\n}\n.app-header.header-text-light .header-btn-lg .hamburger-inner,\n.app-header.header-text-light .header-btn-lg .hamburger.is-active .hamburger-inner,\n.app-header.header-text-light .header-btn-lg .hamburger-inner::before,\n.app-header.header-text-light .header-btn-lg .hamburger-inner::after,\n.app-header.header-text-light .header__pane .hamburger-inner,\n.app-header.header-text-light .header__pane .hamburger.is-active .hamburger-inner,\n.app-header.header-text-light .header__pane .hamburger-inner::before,\n.app-header.header-text-light .header__pane .hamburger-inner::after {\n  background-color: rgba(255, 255, 255, 0.8) !important;\n}\n.app-header.header-text-light .search-wrapper .input-holder .search-icon span::after {\n  border-color: rgba(255, 255, 255, 0.8);\n}\n.app-header.header-text-light .search-wrapper .close::before,\n.app-header.header-text-light .search-wrapper .close::after,\n.app-header.header-text-light .search-wrapper .input-holder .search-icon span::before {\n  background: rgba(255, 255, 255, 0.8);\n}\n.app-header.header-text-light .app-header__logo .logo-src {\n  background: url(\"../../../../assets/utils/images/Arkos_color_logo 1.svg\");\n}\n.app-header.header-text-light .app-header__mobile-menu .hamburger-inner,\n.app-header.header-text-light .app-header__mobile-menu .hamburger-inner::before,\n.app-header.header-text-light .app-header__mobile-menu .hamburger-inner::after {\n  background: rgba(255, 255, 255, 0.9);\n}\n\n.app-header.header-text-dark .app-header-left > .nav > li > .nav-link {\n  color: rgba(0, 0, 0, 0.7);\n}\n.app-header.header-text-dark .app-header-left > .nav > li > .nav-link .nav-link-icon {\n  color: rgba(0, 0, 0, 0.8);\n}\n.app-header.header-text-dark .app-header-left > .nav > li > .nav-link:hover {\n  color: rgb(0, 0, 0);\n}\n.app-header.header-text-dark .app-header-right .icon-wrapper-alt svg {\n  fill: rgba(0, 0, 0, 0.7);\n  transition: all 0.2s;\n}\n.app-header.header-text-dark .app-header-right .icon-wrapper-alt .icon-wrapper-bg {\n  background: rgba(0, 0, 0, 0.1) !important;\n  transition: all 0.2s;\n  opacity: 1;\n}\n.app-header.header-text-dark .app-header-right .icon-wrapper-alt:hover svg {\n  fill: rgba(0, 0, 0, 0.95);\n}\n.app-header.header-text-dark .app-header-right .icon-wrapper-alt:hover .icon-wrapper-bg {\n  background: rgba(0, 0, 0, 0.15) !important;\n}\n.app-header.header-text-dark .app-header-right .icon-wrapper-alt .badge-dot {\n  border-color: transparent;\n}\n.app-header.header-text-dark .app-header-right .widget-content-left > .btn-group > .btn-link,\n.app-header.header-text-dark .app-header-right .widget-content-left .widget-heading,\n.app-header.header-text-dark .app-header-right .widget-content-left .widget-subheading {\n  color: rgba(0, 0, 0, 0.8);\n}\n.app-header.header-text-dark .search-wrapper .input-holder .search-icon {\n  background: rgba(0, 0, 0, 0.1);\n}\n.app-header.header-text-dark .search-wrapper.active .input-holder {\n  background: rgba(0, 0, 0, 0.1);\n}\n.app-header.header-text-dark .search-wrapper.active .input-holder .search-input {\n  color: rgba(0, 0, 0, 0.8);\n}\n.app-header.header-text-dark .search-wrapper.active .input-holder .search-icon {\n  background: rgba(0, 0, 0, 0.1);\n}\n.app-header.header-text-dark .header-btn-lg::before {\n  background: rgba(0, 0, 0, 0.2);\n}\n.app-header.header-text-dark .header-btn-lg .hamburger-inner,\n.app-header.header-text-dark .header-btn-lg .hamburger.is-active .hamburger-inner,\n.app-header.header-text-dark .header-btn-lg .hamburger-inner::before,\n.app-header.header-text-dark .header-btn-lg .hamburger-inner::after,\n.app-header.header-text-dark .header__pane .hamburger-inner,\n.app-header.header-text-dark .header__pane .hamburger.is-active .hamburger-inner,\n.app-header.header-text-dark .header__pane .hamburger-inner::before,\n.app-header.header-text-dark .header__pane .hamburger-inner::after {\n  background-color: rgba(0, 0, 0, 0.8) !important;\n}\n.app-header.header-text-dark .search-wrapper .input-holder .search-icon span::after {\n  border-color: rgba(0, 0, 0, 0.8);\n}\n.app-header.header-text-dark .search-wrapper .close::before,\n.app-header.header-text-dark .search-wrapper .close::after,\n.app-header.header-text-dark .search-wrapper .input-holder .search-icon span::before {\n  background: rgba(0, 0, 0, 0.8);\n}\n.app-header.header-text-dark .app-header__logo .logo-src {\n  background: url(\"../../../../assets/utils/images/arkosLogo.png\");\n}\n\n.app-sidebar {\n  width: 280px;\n  display: flex;\n  z-index: 11;\n  overflow: hidden;\n  min-width: 280px;\n  position: relative;\n  flex: 0 0 280px;\n  margin-top: -60px;\n  padding-top: 60px;\n  transition: all 0.2s;\n}\n.app-sidebar .app-sidebar__inner {\n  padding: 10px 1.5rem 1.5rem;\n}\n.app-sidebar .scrollbar-container {\n  z-index: 15;\n  width: 100%;\n}\n.app-sidebar .app-sidebar-bg {\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n  width: 100%;\n  opacity: 0.05;\n  background-size: cover;\n  z-index: 10;\n}\n.app-sidebar .app-header__logo {\n  position: absolute;\n  left: 0;\n  top: 0;\n  display: none;\n  z-index: 11;\n}\n.app-sidebar.sidebar-shadow {\n  box-shadow: 7px 0 60px rgba(0, 0, 0, 0.05);\n}\n\n.app-sidebar__heading {\n  text-transform: uppercase;\n  font-size: 0.8rem;\n  margin: 0.75rem 0;\n  font-weight: bold;\n  color: #545cd8;\n  white-space: nowrap;\n  position: relative;\n}\n\n.sidebar-mobile-overlay {\n  display: none;\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  background: #333;\n  opacity: 0.6;\n  left: 0;\n  top: 0;\n  z-index: 12;\n}\n\n.vertical-nav-menu {\n  position: relative;\n}\n.vertical-nav-menu::after {\n  content: \" \";\n  pointer-events: none;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  top: 0;\n}\n.vertical-nav-menu .metismenu-container,\n.vertical-nav-menu .metismenu-item {\n  margin: 0;\n  padding: 0;\n  position: relative;\n}\n.vertical-nav-menu .metismenu-container {\n  list-style: none;\n}\n.vertical-nav-menu .metismenu-container:before {\n  opacity: 0;\n  transition: opacity 300ms;\n}\n.vertical-nav-menu .metismenu-container .metismenu-link {\n  transition: transform 0.2s, height 300ms, color 300ms, background-color 300ms;\n  display: block;\n  line-height: 2.5rem;\n  height: 2.5rem;\n  padding: 0 1.5rem 0 45px;\n  position: relative;\n  border-radius: 0.25rem;\n  color: #343a40;\n  white-space: nowrap;\n}\n.vertical-nav-menu .metismenu-container .metismenu-link:hover {\n  background: #e0f3ff;\n  text-decoration: none;\n}\n.vertical-nav-menu .metismenu-container .metismenu-link:hover i.metismenu-icon {\n  opacity: 0.6;\n}\n.vertical-nav-menu .metismenu-container .metismenu-link:hover i.metismenu-state-icon {\n  opacity: 1;\n}\n.vertical-nav-menu .metismenu-container .metismenu-link.active {\n  color: #545cd8;\n  background: #e0f3ff;\n}\n.vertical-nav-menu .metismenu-container .metismenu-link.has-active-child, .vertical-nav-menu .metismenu-container .metismenu-link.active {\n  font-weight: bold;\n}\n.vertical-nav-menu .metismenu-container i.metismenu-state-icon,\n.vertical-nav-menu .metismenu-container i.metismenu-icon {\n  text-align: center;\n  width: 34px;\n  height: 34px;\n  line-height: 34px;\n  position: absolute;\n  left: 5px;\n  top: 50%;\n  margin-top: -17px;\n  font-size: 1.5rem;\n  opacity: 0.3;\n  transition: color 300ms;\n}\n.vertical-nav-menu .metismenu-container i.metismenu-state-icon {\n  transition: transform 300ms;\n  left: auto;\n  right: 0;\n}\n.vertical-nav-menu .metismenu-container i.metismenu-state-icon.rotate-minus-90 {\n  transform: rotate(-180deg);\n}\n.vertical-nav-menu .metismenu-container .metismenu-container {\n  transition: padding 300ms;\n}\n.vertical-nav-menu .metismenu-container .metismenu-container.visible {\n  padding: 0.5em 0 0 2rem;\n}\n.vertical-nav-menu .metismenu-container .metismenu-container.visible:before {\n  content: \"\";\n  height: 100%;\n  opacity: 1;\n  width: 3px;\n  background: #e0f3ff;\n  position: absolute;\n  left: 20px;\n  top: 0;\n  border-radius: 15px;\n}\n.vertical-nav-menu .metismenu-container .metismenu-container.visible > .metismenu-item > .metismenu-link {\n  height: 2.3em;\n  line-height: 2.3em;\n  color: #6c757d;\n  margin: 0 0 3px;\n}\n.vertical-nav-menu .metismenu-container .metismenu-container.visible > .metismenu-item > .metismenu-link:hover {\n  color: #545cd8;\n}\n.vertical-nav-menu .metismenu-container .metismenu-container.visible > .metismenu-item > .metismenu-link .metismenu-icon {\n  display: none;\n}\n.vertical-nav-menu .metismenu-container .metismenu-container.visible > .metismenu-item > .metismenu-link.active {\n  color: #545cd8;\n  background: #e0f3ff;\n}\n.vertical-nav-menu .metismenu-container .metismenu-container .metismenu-item > .metismenu-link {\n  height: 0;\n  overflow: hidden;\n}\n.vertical-nav-menu .metismenu-container .metismenu-container .metismenu-link {\n  padding-left: 1em;\n}\n\n.app-sidebar.sidebar-text-light {\n  border-right: 0 !important;\n}\n.app-sidebar.sidebar-text-light .app-sidebar__heading {\n  color: rgba(255, 255, 255, 0.6);\n}\n.app-sidebar.sidebar-text-light .app-sidebar__heading::before {\n  background: rgba(255, 255, 255, 0.2) !important;\n}\n.app-sidebar.sidebar-text-light .metismenu .metismenu-container .metismenu-link {\n  color: rgba(255, 255, 255, 0.7);\n}\n.app-sidebar.sidebar-text-light .metismenu .metismenu-container .metismenu-link:hover {\n  color: rgb(255, 255, 255);\n  background: rgba(255, 255, 255, 0.1);\n}\n.app-sidebar.sidebar-text-light .metismenu .metismenu-container .metismenu-link.active {\n  background: rgba(255, 255, 255, 0.1);\n}\n.app-sidebar.sidebar-text-light .metismenu .metismenu-container.metismenu-container.visible .metismenu-item > .metismenu-link {\n  color: rgba(255, 255, 255, 0.6);\n}\n.app-sidebar.sidebar-text-light .metismenu .metismenu-container.metismenu-container.visible .metismenu-item > .metismenu-link.active {\n  background: rgba(255, 255, 255, 0.1);\n  color: rgba(255, 255, 255, 0.8);\n}\n.app-sidebar.sidebar-text-light .metismenu .metismenu-container.metismenu-container.visible .metismenu-item > .metismenu-link:hover {\n  color: rgb(255, 255, 255);\n}\n.app-sidebar.sidebar-text-light .metismenu .metismenu-container.metismenu-container.visible::before {\n  background: rgba(255, 255, 255, 0.3);\n}\n.app-sidebar.sidebar-text-light .metismenu .metismenu-container i.metismenu-state-icon,\n.app-sidebar.sidebar-text-light .metismenu .metismenu-container i.metismenu-icon {\n  opacity: 0.5;\n}\n.app-sidebar.sidebar-text-light .ps__thumb-y {\n  background: rgba(255, 255, 255, 0.3);\n}\n.app-sidebar.sidebar-text-light .ps__rail-y:hover .ps__thumb-y {\n  background: rgba(255, 255, 255, 0.2);\n}\n.app-sidebar.sidebar-text-light .app-header__logo .logo-src {\n  background: url(\"../../../../assets/utils/images/arkosLogo.png\");\n}\n.app-sidebar.sidebar-text-light .app-header__logo .hamburger-inner,\n.app-sidebar.sidebar-text-light .app-header__logo .hamburger-inner::before,\n.app-sidebar.sidebar-text-light .app-header__logo .hamburger-inner::after {\n  background-color: rgba(255, 255, 255, 0.8);\n}\n\n.app-sidebar.sidebar-text-dark {\n  border-right: 0 !important;\n}\n.app-sidebar.sidebar-text-dark .app-sidebar__heading {\n  color: rgba(0, 0, 0, 0.6);\n}\n.app-sidebar.sidebar-text-dark .app-sidebar__heading::before {\n  background: rgba(0, 0, 0, 0.5) !important;\n}\n.app-sidebar.sidebar-text-dark .metismenu .metismenu-container .metismenu-link {\n  color: rgba(0, 0, 0, 0.7);\n}\n.app-sidebar.sidebar-text-dark .metismenu .metismenu-container .metismenu-link:hover {\n  color: rgb(0, 0, 0);\n  background: rgba(0, 0, 0, 0.1);\n}\n.app-sidebar.sidebar-text-dark .metismenu .metismenu-container .metismenu-link.active {\n  background: rgba(0, 0, 0, 0.1);\n}\n.app-sidebar.sidebar-text-dark .metismenu .metismenu-container.metismenu-container.visible .metismenu-item > .metismenu-link {\n  color: rgba(0, 0, 0, 0.6);\n}\n.app-sidebar.sidebar-text-dark .metismenu .metismenu-container.metismenu-container.visible .metismenu-item > .metismenu-link.active {\n  background: rgba(0, 0, 0, 0.1);\n}\n.app-sidebar.sidebar-text-dark .metismenu .metismenu-container.metismenu-container.visible::before {\n  background: rgba(0, 0, 0, 0.3);\n}\n.app-sidebar.sidebar-text-dark .metismenu .metismenu-container.metismenu-container i.metismenu-state-icon,\n.app-sidebar.sidebar-text-dark .metismenu .metismenu-container.metismenu-container i.metismenu-icon {\n  opacity: 0.5;\n}\n.app-sidebar.sidebar-text-dark .ps__thumb-y {\n  background: rgba(0, 0, 0, 0.3);\n}\n.app-sidebar.sidebar-text-dark .ps__rail-y:hover .ps__thumb-y {\n  background: rgba(0, 0, 0, 0.2);\n}\n.app-sidebar.sidebar-text-dark .app-header__logo .hamburger-inner,\n.app-sidebar.sidebar-text-dark .app-header__logo .hamburger-inner::before,\n.app-sidebar.sidebar-text-dark .app-header__logo .hamburger-inner::after {\n  background-color: rgba(0, 0, 0, 0.8);\n}\n\n.fixed-sidebar .app-sidebar {\n  position: fixed;\n  height: 100vh;\n}\n.fixed-sidebar .app-main .app-main__outer {\n  z-index: 9;\n  padding-left: 280px;\n}\n.fixed-sidebar.fixed-header .app-sidebar .app-header__logo {\n  display: none;\n}\n.fixed-sidebar:not(.fixed-header) .app-sidebar .app-header__logo {\n  display: flex;\n}\n.fixed-sidebar:not(.fixed-header) .app-header {\n  margin-left: 280px;\n}\n.fixed-sidebar:not(.fixed-header) .app-header .app-header__logo {\n  display: none;\n}\n.fixed-sidebar.closed-sidebar:not(.fixed-header) .app-header {\n  margin-left: 80px;\n}\n.fixed-sidebar.closed-sidebar:not(.fixed-header) .app-sidebar .app-header__logo {\n  width: 80px;\n  padding: 0;\n}\n.fixed-sidebar.closed-sidebar:not(.fixed-header) .app-sidebar .app-header__logo .logo-src {\n  display: none;\n}\n.fixed-sidebar.closed-sidebar:not(.fixed-header) .app-sidebar .app-header__logo .header__pane {\n  margin-right: auto;\n}\n\n.closed-sidebar .app-sidebar {\n  transition: all 0.3s ease;\n  width: 80px;\n  min-width: 80px;\n  flex: 0 0 80px;\n  z-index: 13;\n}\n.closed-sidebar .app-sidebar .app-sidebar__inner .app-sidebar__heading {\n  text-indent: -999em;\n}\n.closed-sidebar .app-sidebar .app-sidebar__inner .app-sidebar__heading::before {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 0;\n  width: 100%;\n  height: 1px;\n  background: #e0f3ff;\n  text-indent: 1px;\n}\n.closed-sidebar .app-sidebar .app-sidebar__inner .metismenu-link {\n  text-indent: -99rem;\n  padding: 0;\n}\n.closed-sidebar .app-sidebar .app-sidebar__inner .metismenu-icon {\n  text-indent: 0;\n  left: 50%;\n  margin-left: -17px;\n}\n.closed-sidebar .app-sidebar .app-sidebar__inner .metismenu-state-icon {\n  visibility: hidden;\n}\n.closed-sidebar .app-sidebar .app-sidebar__inner .metismenu-container.visible {\n  padding: 0;\n}\n.closed-sidebar .app-sidebar .app-sidebar__inner .metismenu-container.visible > .metismenu-item > .metismenu-link {\n  height: 0;\n}\n.closed-sidebar .app-sidebar:hover {\n  flex: 0 0 280px !important;\n  width: 280px !important;\n}\n.closed-sidebar .app-sidebar:hover .app-sidebar__inner .app-sidebar__heading {\n  text-indent: initial;\n}\n.closed-sidebar .app-sidebar:hover .app-sidebar__inner .app-sidebar__heading::before {\n  display: none;\n}\n.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-link {\n  text-indent: initial;\n  padding: 0 1.5rem 0 45px;\n}\n.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-icon {\n  text-indent: initial;\n  left: 5px;\n  margin-left: 0;\n}\n.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-state-icon {\n  visibility: visible;\n}\n.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-container.visible {\n  padding: 0.5em 0 0 2rem;\n}\n.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-container.visible > .metismenu-item > .metismenu-link {\n  height: 2.3em;\n}\n.closed-sidebar .app-sidebar:hover .app-sidebar__inner .metismenu-container .metismenu-container .metismenu-link {\n  padding-left: 1em;\n}\n.closed-sidebar:not(.sidebar-mobile-open) .app-sidebar .scrollbar-container {\n  position: static;\n  height: auto;\n  overflow: initial !important;\n}\n.closed-sidebar:not(.sidebar-mobile-open) .app-sidebar:hover .scrollbar-container {\n  position: absolute;\n  height: 100%;\n  overflow: hidden !important;\n}\n.closed-sidebar:not(.closed-sidebar-mobile) .app-header .app-header__logo {\n  width: 80px;\n}\n.closed-sidebar:not(.closed-sidebar-mobile) .app-header .app-header__logo .logo-src {\n  display: none;\n}\n.closed-sidebar:not(.closed-sidebar-mobile) .app-header .app-header__logo .header__pane {\n  margin-right: auto;\n}\n.closed-sidebar.fixed-sidebar .app-main__outer {\n  padding-left: 80px;\n}\n.closed-sidebar.fixed-header:not(.fixed-sidebar) .app-sidebar .app-header__logo {\n  visibility: hidden;\n}\n.closed-sidebar.closed-sidebar-mobile .app-sidebar .app-header__logo,\n.closed-sidebar.closed-sidebar-mobile .app-header .app-header__logo {\n  width: auto;\n  display: flex;\n}\n.closed-sidebar.closed-sidebar-mobile .app-sidebar .app-header__logo .header__pane,\n.closed-sidebar.closed-sidebar-mobile .app-header .app-header__logo .header__pane {\n  display: none;\n}\n.closed-sidebar.closed-sidebar-mobile .app-sidebar .app-header__logo {\n  display: flex;\n  width: 80px;\n  padding: 0 1.5rem !important;\n}\n.closed-sidebar.closed-sidebar-mobile .app-sidebar .app-header__logo .logo-src {\n  display: block !important;\n  margin: 0 auto;\n  width: 21px;\n}\n.closed-sidebar.closed-sidebar-mobile .app-sidebar .app-header__logo .header__pane {\n  display: none;\n}\n.closed-sidebar.closed-sidebar-mobile .app-sidebar:hover .app-header__logo {\n  width: 280px;\n}\n.closed-sidebar.closed-sidebar-mobile .app-sidebar:hover .app-header__logo .logo-src {\n  width: 97px;\n  margin: 0;\n}\n.closed-sidebar.closed-sidebar-mobile .app-header {\n  margin-left: 0 !important;\n}\n.closed-sidebar.fixed-footer .app-footer__inner {\n  margin-left: 0 !important;\n}\n\n.app-main {\n  z-index: 8;\n  position: relative;\n  display: flex;\n}\n.app-main .app-main__outer {\n  flex: 1;\n  flex-direction: column;\n  display: flex;\n  z-index: 12;\n  width: 1px;\n}\n.app-main .app-main__inner {\n  padding: 1.5rem 1.5rem 0;\n  flex: 1;\n}\n.app-main .app-main__inner > .RRT__container > .RRT__panel {\n  margin-top: 1.5rem;\n}\n.app-main .app-main__inner > .RRT__container > .body-tabs-layout .RRT__tab {\n  margin-top: -0.5rem;\n}\n\n.body-tabs-shadow-btn .app-main__inner > .RRT__container > .RRT__panel {\n  margin-top: 1rem;\n}\n.body-tabs-shadow-btn .app-main__inner > .RRT__container .body-tabs-layout {\n  border: 0;\n  background: transparent;\n  position: relative;\n  z-index: 7;\n}\n.body-tabs-shadow-btn .app-main__inner > .RRT__container .body-tabs-layout .RRT__showmore {\n  margin-top: -13px;\n}\n.body-tabs-shadow-btn .app-main__inner > .RRT__container .body-tabs-layout .RRT__tab {\n  margin-top: 0.5rem;\n}\n.body-tabs-shadow-btn .app-main__inner > .RRT__container .body-tabs-layout .RRT__tab--selected {\n  color: #fff;\n}\n.body-tabs-shadow-btn .app-main__inner > .RRT__container .body-tabs-layout + .RRT__inkbar-wrapper {\n  position: absolute;\n  top: 1.1rem;\n  z-index: 5;\n}\n.body-tabs-shadow-btn .app-main__inner > .RRT__container .body-tabs-layout + .RRT__inkbar-wrapper .RRT__inkbar {\n  height: 35px;\n  margin-top: 0;\n  border-radius: 0.25rem;\n  box-shadow: 0 16px 26px -10px rgba(84, 92, 216, 0.56), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(84, 92, 216, 0.2);\n}\n\n.app-theme-white.app-container {\n  background: #f1f4f6;\n}\n.app-theme-white .app-sidebar {\n  background: #ffffff;\n}\n.app-theme-white .app-page-title {\n  background: rgba(255, 255, 255, 0.55);\n}\n.app-theme-white .app-footer .app-footer__inner,\n.app-theme-white .app-header {\n  background: #fafbfc;\n}\n.app-theme-white.fixed-header .app-header__logo {\n  background: rgba(250, 251, 252, 0.1);\n}\n\n.app-theme-gray.app-container {\n  background: #ffffff;\n}\n.app-theme-gray .app-sidebar {\n  background: #ffffff;\n  border-right: #dee2e6 solid 1px;\n}\n.app-theme-gray .app-page-title {\n  background: rgba(0, 0, 0, 0.03);\n}\n.app-theme-gray .app-footer,\n.app-theme-gray .app-header {\n  background: #f8f9fa;\n}\n.app-theme-gray .app-footer {\n  border-top: #dee2e6 solid 1px;\n}\n.app-theme-gray .app-header .app-header__logo {\n  border-right: rgba(0, 0, 0, 0.1) solid 1px;\n}\n.app-theme-gray.fixed-header .app-header__logo {\n  background: rgba(0, 0, 0, 0.03);\n}\n.app-theme-gray .card {\n  border-width: 1px;\n}\n.app-theme-gray .main-card {\n  box-shadow: 0 0 0 0 transparent !important;\n}\n.app-theme-gray .main-card > .card-body > .card-title {\n  text-transform: none;\n  font-size: 1.1rem;\n  font-weight: normal;\n  border-bottom: #dee2e6 solid 1px;\n  position: relative;\n  padding: 0 0 1.5rem;\n  margin: 0 0 1.5rem;\n}\n.app-theme-gray .main-card > .card-body > .card-title::before {\n  position: absolute;\n  width: 40px;\n  background: #545cd8;\n  border-radius: 30px;\n  height: 5px;\n  left: 0;\n  bottom: -2px;\n  content: \"\";\n}\n.app-theme-gray .app-inner-layout__sidebar {\n  border-left: 0 !important;\n}\n\n.app-footer {\n  height: 60px;\n}\n.app-footer .app-footer__inner {\n  padding: 0 1.5rem 0 0.75rem;\n  height: 60px;\n  transition: all 0.2s;\n  display: flex;\n  align-content: center;\n  align-items: center;\n}\n.app-footer .app-footer__inner .app-footer-left {\n  display: flex;\n  align-items: center;\n}\n.app-footer .app-footer__inner .app-footer-right {\n  margin-left: auto;\n  display: flex;\n}\n\n.footer-dots {\n  display: flex;\n  align-items: center;\n  align-content: center;\n}\n.footer-dots .dots-separator {\n  height: 40px;\n  margin: 0 0.6rem;\n  width: 1px;\n  background: #e9ecef;\n}\n\n.dot-btn-wrapper {\n  padding: 0.5rem;\n  position: relative;\n  display: flex;\n  opacity: 0.7;\n  transition: opacity 0.2s;\n}\n.dot-btn-wrapper .badge-abs {\n  right: 50%;\n}\n.dot-btn-wrapper .badge-abs.badge-dot-sm {\n  top: -2px;\n  margin-right: -3px;\n}\n.dot-btn-wrapper .dot-btn-icon {\n  font-size: 1.8rem;\n}\n.dot-btn-wrapper:hover {\n  text-decoration: none;\n  opacity: 1;\n}\n\n.fixed-footer .app-footer {\n  position: fixed;\n  width: 100%;\n  bottom: 0;\n  left: 0;\n  z-index: 7;\n}\n.fixed-footer .app-footer .app-footer__inner {\n  margin-left: 280px;\n  box-shadow: 0.3rem -0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.02), 0.3rem -0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.02), 0.3rem -0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.04), 0.3rem -0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.02);\n}\n.fixed-footer .app-main .app-main__outer {\n  padding-bottom: 60px;\n}\n.fixed-footer.closed-sidebar .app-footer .app-footer__inner {\n  margin-left: 80px !important;\n}\n\n.app-page-title {\n  padding: 1.5rem;\n  margin: -1.5rem -1.5rem 1.5rem;\n  position: relative;\n}\n.app-page-title .page-title-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n.app-page-title .page-title-heading,\n.app-page-title .page-title-subheading {\n  margin: 0;\n  padding: 0;\n}\n.app-page-title .page-title-heading {\n  font-size: 1.1rem;\n  font-weight: 400;\n  display: flex;\n  align-content: center;\n  align-items: center;\n}\n.app-page-title .page-title-subheading {\n  padding: 3px 0 0;\n  font-size: 0.88rem;\n  opacity: 0.6;\n}\n.app-page-title .page-title-subheading .breadcrumb {\n  padding: 0;\n  margin: 3px 0 0;\n  background: transparent;\n}\n.app-page-title .page-title-actions {\n  margin-left: auto;\n}\n.app-page-title .page-title-actions .breadcrumb {\n  margin: 0;\n  padding: 0;\n  background: transparent;\n}\n.app-page-title .page-title-icon {\n  font-size: 2rem;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  text-align: center;\n  padding: 0.8333333333rem;\n  margin: 0 1.5rem 0 0;\n  background: #fff;\n  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);\n  border-radius: 0.25rem;\n  width: 60px;\n  height: 60px;\n}\n.app-page-title .page-title-icon i {\n  margin: auto;\n}\n.app-page-title .page-title-icon.rounded-circle {\n  margin: 0 1rem 0 0;\n}\n.app-page-title + .RRT__container {\n  margin-top: -1.1538461538rem;\n}\n.app-page-title + .rc-tabs {\n  max-width: calc(100vw - 322px);\n  margin: -1.5rem -0.75rem 1.95rem;\n}\n@media only screen and (max-width: 812px) and (min-width: 360px) {\n  .app-page-title + .rc-tabs {\n    max-width: calc(100vw - 0px);\n    margin: -1.5rem -0.75rem 1.95rem;\n  }\n}\n.app-page-title.app-page-title-simple {\n  margin: 0;\n  background: none !important;\n  padding-left: 0;\n  padding-right: 0;\n  padding-top: 0;\n}\n\n.page-title-icon-rounded .page-title-icon {\n  border-radius: 50px;\n}\n\n.closed-sidebar .rc-tabs {\n  max-width: calc(100vw - 140px);\n}\n\n@media only screen and (max-width: 812px) and (min-width: 360px) {\n  .closed-sidebar .rc-tabs {\n    max-width: calc(100vw - 0px);\n  }\n}\n.body-tabs.body-tabs-layout {\n  margin-left: -1.5rem;\n  margin-right: -1.5rem;\n  padding: 0 1.5rem;\n  border-top: 0;\n  border-bottom: #dee2e6 solid 1px;\n}\n\n.search-wrapper {\n  position: relative;\n  margin-right: 0.6666666667rem;\n}\n.search-wrapper .input-holder {\n  height: 42px;\n  width: 42px;\n  overflow: hidden;\n  position: relative;\n  transition: all 0.3s ease-in-out;\n}\n.search-wrapper .input-holder .search-input {\n  width: 100%;\n  padding: 0 70px 0 20px;\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  background: transparent;\n  box-sizing: border-box;\n  border: none;\n  outline: none;\n  transform: translate(0, 60px);\n  transition: all 0.3s cubic-bezier(0, 0.105, 0.035, 1.57);\n  transition-delay: 0.3s;\n  font-size: 0.88rem;\n}\n.search-wrapper .input-holder .search-icon {\n  width: 42px;\n  height: 42px;\n  border: none;\n  padding: 0;\n  outline: none;\n  position: relative;\n  z-index: 2;\n  float: right;\n  cursor: pointer;\n  transition: all 0.3s ease-in-out;\n  background: rgba(0, 0, 0, 0.06);\n  border-radius: 30px;\n}\n.search-wrapper .input-holder .search-icon span {\n  width: 22px;\n  height: 22px;\n  display: inline-block;\n  vertical-align: middle;\n  position: relative;\n  transform: rotate(45deg);\n  transition: all 0.4s cubic-bezier(0.65, -0.6, 0.24, 1.65);\n}\n.search-wrapper .input-holder .search-icon span::before, .search-wrapper .input-holder .search-icon span::after {\n  position: absolute;\n  content: \"\";\n}\n.search-wrapper .input-holder .search-icon span::before {\n  width: 4px;\n  height: 11px;\n  left: 9px;\n  top: 13px;\n  border-radius: 2px;\n  background: #545cd8;\n}\n.search-wrapper .input-holder .search-icon span::after {\n  width: 14px;\n  height: 14px;\n  left: 4px;\n  top: 0;\n  border-radius: 16px;\n  border: 2px solid #545cd8;\n}\n.search-wrapper .btn-close {\n  position: absolute;\n  z-index: 1;\n  top: 50%;\n  left: 0;\n  width: 20px;\n  height: 20px;\n  margin-top: -10px;\n  cursor: pointer;\n  opacity: 0 !important;\n  transition: all 0.2s cubic-bezier(0.285, -0.45, 0.935, 0.11);\n  transition-delay: 0.1s;\n}\n.search-wrapper .btn-close::before, .search-wrapper .btn-close::after {\n  position: absolute;\n  background: #545cd8;\n  border-radius: 2px;\n}\n.search-wrapper .btn-close::before {\n  width: 2px;\n  height: 20px;\n  left: 9px;\n  top: 0;\n}\n.search-wrapper .btn-close::after {\n  width: 20px;\n  height: 2px;\n  left: 0;\n  top: 9px;\n}\n.search-wrapper.active {\n  width: 330px;\n}\n.search-wrapper.active .input-holder {\n  width: 290px;\n  border-radius: 50px;\n  background: rgba(0, 0, 0, 0.05);\n  transition: all 0.5s cubic-bezier(0, 0.105, 0.035, 1.57);\n}\n.search-wrapper.active .input-holder .search-input {\n  opacity: 1;\n  transform: translate(0, 11px);\n}\n.search-wrapper.active .input-holder .search-icon {\n  width: 42px;\n  height: 42px;\n  margin: 0;\n  border-radius: 30px;\n}\n.search-wrapper.active .input-holder .search-icon span {\n  transform: rotate(-45deg);\n}\n.search-wrapper.active .btn-close {\n  left: 300px;\n  opacity: 0.6 !important;\n  transition: all 0.6s cubic-bezier(0, 0.105, 0.035, 1.57);\n  transition-delay: 0.5s;\n}\n.search-wrapper.active .btn-close:hover {\n  opacity: 1 !important;\n}\n.search-wrapper.active + .header-megamenu {\n  opacity: 0;\n}\n\n.opacity-01 {\n  opacity: 0.01 !important;\n}\n\n.opacity-02 {\n  opacity: 0.02 !important;\n}\n\n.opacity-03 {\n  opacity: 0.03 !important;\n}\n\n.opacity-04 {\n  opacity: 0.04 !important;\n}\n\n.opacity-05 {\n  opacity: 0.05 !important;\n}\n\n.opacity-06 {\n  opacity: 0.06 !important;\n}\n\n.opacity-07 {\n  opacity: 0.07 !important;\n}\n\n.opacity-08 {\n  opacity: 0.08 !important;\n}\n\n.opacity-09 {\n  opacity: 0.09 !important;\n}\n\n.opacity-1 {\n  opacity: 0.1 !important;\n}\n\n.opacity-15 {\n  opacity: 0.15 !important;\n}\n\n.opacity-2 {\n  opacity: 0.2 !important;\n}\n\n.opacity-3 {\n  opacity: 0.3 !important;\n}\n\n.opacity-4 {\n  opacity: 0.4 !important;\n}\n\n.opacity-5 {\n  opacity: 0.5 !important;\n}\n\n.opacity-6 {\n  opacity: 0.6 !important;\n}\n\n.opacity-7 {\n  opacity: 0.7 !important;\n}\n\n.opacity-8 {\n  opacity: 0.8 !important;\n}\n\n.opacity-9 {\n  opacity: 0.9 !important;\n}\n\n.opacity-10 {\n  opacity: 1 !important;\n}\n\n.filter-grayscale-5 {\n  filter: grayscale(5%) !important;\n}\n\n.filter-grayscale-10 {\n  filter: grayscale(10%) !important;\n}\n\n.filter-grayscale-20 {\n  filter: grayscale(20%) !important;\n}\n\n.filter-grayscale-30 {\n  filter: grayscale(30%) !important;\n}\n\n.filter-grayscale-40 {\n  filter: grayscale(40%) !important;\n}\n\n.filter-grayscale-50 {\n  filter: grayscale(50%) !important;\n}\n\n.filter-grayscale-80 {\n  filter: grayscale(80%) !important;\n}\n\n.filter-grayscale-100 {\n  filter: grayscale(100%) !important;\n}\n\n.br-tl {\n  border-top-left-radius: 0.25rem !important;\n}\n\n.br-tr {\n  border-top-right-radius: 0.25rem !important;\n}\n\n.br-bl {\n  border-bottom-left-radius: 0.25rem !important;\n}\n\n.br-br {\n  border-bottom-right-radius: 0.25rem !important;\n}\n\n.b-radius-0 {\n  border-radius: 0 !important;\n}\n\n.rm-border {\n  border-width: 0 !important;\n}\n\n.br-a {\n  border-radius: 0.25rem;\n}\n\n.margin-h-center {\n  margin-left: auto !important;\n  margin-right: auto !important;\n}\n\n.center-svg {\n  margin: 0 auto;\n}\n.center-svg svg {\n  margin: 0 auto;\n}\n\n.apexcharts-canvas {\n  margin: 0 auto;\n}\n\n.apexcharts-donut {\n  display: flex;\n  align-items: center;\n  align-content: center;\n}\n\n.alert-dismissible .close {\n  top: 0;\n  right: 5px;\n  padding: 5px;\n}\n\n.icon-gradient {\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  text-fill-color: transparent;\n}\n\n.font-size-xlg {\n  font-size: 1.3rem !important;\n}\n\n.font-size-md {\n  font-size: 0.9rem !important;\n}\n\n.font-size-lg {\n  font-size: 1.1rem !important;\n}\n\n.no-shadow {\n  box-shadow: 0 0 0 transparent !important;\n}\n\n.h-100 {\n  height: 100vh !important;\n}\n\n.he-auto {\n  height: auto !important;\n}\n\n.he-100 {\n  height: 100%;\n}\n\n.h-sm {\n  height: 150px;\n}\n\n.text-nowrap {\n  white-space: nowrap;\n}\n\n.fsize-1 {\n  font-size: 0.95rem !important;\n}\n\n.fsize-2 {\n  font-size: 1.3rem !important;\n}\n\n.fsize-3 {\n  font-size: 1.6rem !important;\n}\n\n.fsize-4 {\n  font-size: 2rem !important;\n}\n\n.z-index-6 {\n  z-index: 6;\n}\n\n.line-height-1 {\n  line-height: 1;\n}\n\n.center-elem {\n  display: flex;\n  align-items: center;\n  align-content: center;\n}\n\n.flex2 {\n  flex: 2;\n}\n\n.divider {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n  height: 1px;\n  overflow: hidden;\n  background: #e9ecef;\n}\n\n.list-group-item:hover {\n  z-index: initial;\n}\n\n.no-results {\n  padding: 1.5rem;\n  text-align: center;\n}\n.no-results .results-title {\n  color: #495057;\n  font-size: 1.1rem;\n}\n.no-results .results-subtitle {\n  color: #adb5bd;\n  font-size: 1.1rem;\n}\n\n.bg-animation {\n  animation: bg-pan-left 8s both;\n}\n\n@-webkit-keyframes bg-pan-left {\n  0% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n}\n@keyframes bg-pan-left {\n  0% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n}\n.w-100 {\n  width: 100%;\n}\n\n.mb--2 {\n  margin-bottom: -1.5rem;\n}\n\n.mbg-3 {\n  margin-bottom: 1.5rem;\n}\n\n.loader-container {\n  align-items: center;\n  display: flex;\n  height: 100vh;\n  justify-content: center;\n  width: 100vw;\n  text-align: center;\n  line-height: 1.6rem;\n}\n.loader-container .loader-container-inner {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  padding: 0 1.5rem;\n}\n.loader-container small, .loader-container .small {\n  margin: 10px 0 0;\n  display: block;\n  color: #6c757d;\n  font-weight: normal;\n}\n.loader-container h3, .loader-container .h3 {\n  text-align: center;\n  display: block;\n}\n\n.btn-info, .btn-success {\n  color: #fff !important;\n}\n\n.bg-warning {\n  color: #212529;\n}\n\n.list-group-item {\n  border: 1px solid rgba(0, 0, 0, 0.125);\n}\n\n.btn-link, a {\n  text-decoration: none !important;\n}\n\n.bg-light {\n  color: #212529;\n}\n\n.table {\n  --bs-table-accent-bg: none;\n}\n\n.form-check-input-custom {\n  width: 1rem;\n  height: 1rem;\n}\n\n.bg-warm-flame {\n  background-image: linear-gradient(45deg, #ff9a9e 0%, #fad0c4 99%, #fad0c4 100%) !important;\n}\n\n.bg-night-fade {\n  background-image: linear-gradient(to top, #a18cd1 0%, #fbc2eb 100%) !important;\n}\n\n.bg-sunny-morning {\n  background-image: linear-gradient(120deg, #f6d365 0%, #fda085 100%) !important;\n}\n\n.bg-tempting-azure {\n  background-image: linear-gradient(120deg, #84fab0 0%, #8fd3f4 100%) !important;\n}\n\n.bg-amy-crisp {\n  background-image: linear-gradient(120deg, #a6c0fe 0%, #f68084 100%) !important;\n}\n\n.bg-heavy-rain {\n  background-image: linear-gradient(to top, #cfd9df 0%, #e2ebf0 100%) !important;\n}\n\n.bg-mean-fruit {\n  background-image: linear-gradient(120deg, #fccb90 0%, #d57eeb 100%) !important;\n}\n\n.bg-malibu-beach {\n  background-image: linear-gradient(to right, #4facfe 0%, #00f2fe 100%) !important;\n}\n\n.bg-deep-blue {\n  background-image: linear-gradient(120deg, #e0c3fc 0%, #8ec5fc 100%) !important;\n}\n\n.bg-ripe-malin {\n  background-image: linear-gradient(120deg, #f093fb 0%, #f5576c 100%) !important;\n}\n\n.bg-arielle-smile {\n  background-image: radial-gradient(circle 248px at center, #16d9e3 0%, #30c7ec 47%, #46aef7 100%) !important;\n}\n\n.bg-plum-plate {\n  background-image: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;\n}\n\n.bg-happy-fisher {\n  background-image: linear-gradient(120deg, #89f7fe 0%, #66a6ff 100%) !important;\n}\n\n.bg-happy-itmeo {\n  background-image: linear-gradient(180deg, #2af598 0%, #009efd 100%) !important;\n}\n\n.bg-mixed-hopes {\n  background-image: linear-gradient(to top, #c471f5 0%, #fa71cd 100%) !important;\n}\n\n.bg-strong-bliss {\n  background-image: linear-gradient(to right, #f78ca0 0%, #f9748f 19%, #fd868c 60%, #fe9a8b 100%) !important;\n}\n\n.bg-grow-early {\n  background-image: linear-gradient(to top, #0ba360 0%, #3cba92 100%) !important;\n}\n\n.bg-love-kiss {\n  background-image: linear-gradient(to top, #ff0844 0%, #ffb199 100%) !important;\n}\n\n.bg-premium-dark {\n  background-image: linear-gradient(to right, #434343 0%, black 100%) !important;\n}\n\n.bg-happy-green {\n  background-image: linear-gradient(to bottom, #00b09b, #96c93d) !important;\n}\n\n.bg-vicious-stance {\n  background-image: linear-gradient(60deg, #29323c 0%, #485563 100%) !important;\n}\n\n.bg-midnight-bloom {\n  background-image: linear-gradient(-20deg, #2b5876 0%, #4e4376 100%) !important;\n}\n\n.bg-night-sky {\n  background-image: linear-gradient(to top, #1e3c72 0%, #1e3c72 1%, #2a5298 100%) !important;\n}\n\n.bg-slick-carbon {\n  background-image: linear-gradient(to bottom, #323232 0%, #3F3F3F 40%, #1C1C1C 150%), linear-gradient(to top, rgba(255, 255, 255, 0.4) 0%, rgba(0, 0, 0, 0.25) 200%) !important;\n  background-blend-mode: multiply;\n}\n\n.bg-royal {\n  background-image: linear-gradient(to right, #141e30, #243b55) !important;\n}\n\n.bg-asteroid {\n  background-image: linear-gradient(to right, #0f2027, #203a43, #2c5364) !important;\n}\n\n.bg-transparent {\n  background: transparent !important;\n}\n\n/*!\nAnimate.css - http://daneden.me/animate\nLicensed under the MIT license - http://opensource.org/licenses/MIT\nCopyright (c) 2015 Daniel Eden\n*/\nbody {\n  -webkit-backface-visibility: hidden;\n}\n\n.animated, .TabsAnimation-appear {\n  -webkit-animation-duration: calc(1s);\n  animation-duration: calc(1s);\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n.animated.infinite, .infinite.TabsAnimation-appear {\n  animation-iteration-count: infinite;\n}\n.animated.hinge, .hinge.TabsAnimation-appear {\n  -webkit-animation-duration: calc(1s * 2);\n  animation-duration: calc(1s * 2);\n}\n.animated.bounceIn, .bounceIn.TabsAnimation-appear, .animated.bounceOut, .bounceOut.TabsAnimation-appear {\n  -webkit-animation-duration: calc(1s * 0.75);\n  animation-duration: calc(1s * 0.75);\n}\n.animated.flipOutX, .flipOutX.TabsAnimation-appear, .animated.flipOutY, .flipOutY.TabsAnimation-appear {\n  -webkit-animation-duration: calc(1s * 0.75);\n  animation-duration: calc(1s * 0.75);\n}\n\n@-webkit-keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n.fadeIn {\n  -webkit-animation-name: fadeIn;\n  animation-name: fadeIn;\n}\n\n@-webkit-keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(-20px);\n  }\n  100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n  }\n}\n@keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n.fadeInDown {\n  -webkit-animation-name: fadeInDown;\n  animation-name: fadeInDown;\n}\n\n@-webkit-keyframes fadeInUp {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateY(20px);\n  }\n  100% {\n    opacity: 1;\n    -webkit-transform: translateY(0);\n  }\n}\n@keyframes fadeInUp {\n  0% {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n.fadeInUp, .TabsAnimation-appear {\n  -webkit-animation-name: fadeInUp;\n  animation-name: fadeInUp;\n}\n\n@-webkit-keyframes fadeOut {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n@keyframes fadeOut {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n.fadeOut {\n  -webkit-animation-name: fadeOut;\n  animation-name: fadeOut;\n}\n\n@-webkit-keyframes lightSpeedIn {\n  0% {\n    -webkit-transform: translateX(100%) skewX(-30deg);\n    opacity: 0;\n  }\n  60% {\n    -webkit-transform: translateX(-20%) skewX(30deg);\n    opacity: 1;\n  }\n  80% {\n    -webkit-transform: translateX(0%) skewX(-15deg);\n    opacity: 1;\n  }\n  100% {\n    -webkit-transform: translateX(0%) skewX(0deg);\n    opacity: 1;\n  }\n}\n@keyframes lightSpeedIn {\n  0% {\n    transform: translateX(100%) skewX(-30deg);\n    opacity: 0;\n  }\n  60% {\n    transform: translateX(-20%) skewX(30deg);\n    opacity: 1;\n  }\n  80% {\n    transform: translateX(0%) skewX(-15deg);\n    opacity: 1;\n  }\n  100% {\n    transform: translateX(0%) skewX(0deg);\n    opacity: 1;\n  }\n}\n.lightSpeedIn {\n  -webkit-animation-name: lightSpeedIn;\n  animation-name: lightSpeedIn;\n  -webkit-animation-timing-function: ease-out;\n  animation-timing-function: ease-out;\n}\n\n@-webkit-keyframes lightSpeedOut {\n  0% {\n    -webkit-transform: translateX(0%) skewX(0deg);\n    opacity: 1;\n  }\n  100% {\n    -webkit-transform: translateX(100%) skewX(-30deg);\n    opacity: 0;\n  }\n}\n@keyframes lightSpeedOut {\n  0% {\n    transform: translateX(0%) skewX(0deg);\n    opacity: 1;\n  }\n  100% {\n    transform: translateX(100%) skewX(-30deg);\n    opacity: 0;\n  }\n}\n.lightSpeedOut {\n  -webkit-animation-name: lightSpeedOut;\n  animation-name: lightSpeedOut;\n  -webkit-animation-timing-function: ease-in;\n  animation-timing-function: ease-in;\n}\n\n.dropdown-menu.show {\n  animation: fade-in2 0.2s cubic-bezier(0.39, 0.575, 0.565, 1) both;\n}\n\n.popover.show {\n  display: block;\n  animation: fade-in2 0.2s cubic-bezier(0.39, 0.575, 0.565, 1) both;\n}\n\n.dropdown-menu[data-placement^=top].show {\n  animation: fade-in3 0.2s cubic-bezier(0.39, 0.575, 0.565, 1) both;\n  bottom: auto !important;\n  top: auto !important;\n}\n\n@keyframes fade-in2 {\n  0% {\n    margin-top: -50px;\n    visibility: hidden;\n    opacity: 0;\n  }\n  100% {\n    margin-top: 0px;\n    visibility: visible;\n    opacity: 1;\n  }\n}\n.form-control {\n  transition: all 0.2s;\n}\n\n.btn-outline-2x {\n  border-width: 2px;\n}\n\n.btn-group .btn {\n  font-size: 0.8rem;\n  font-weight: 500;\n}\n.btn-group .btn-outline-2x + .btn-outline-2x {\n  margin-left: -2px;\n}\n.btn-group .btn-square {\n  border-radius: 0;\n}\n\n.btn {\n  font-size: 0.8rem;\n  font-weight: 500;\n}\n.btn.btn-pill.btn-wide, .btn.btn-pill {\n  border-top-left-radius: 50px;\n  border-bottom-left-radius: 50px;\n  border-top-right-radius: 50px;\n  border-bottom-right-radius: 50px;\n}\n\n.btn-dashed {\n  border-style: dashed;\n}\n\n.btn-icon {\n  vertical-align: bottom;\n}\n.btn-icon.btn-icon-right .btn-icon-wrapper {\n  margin-left: 0.5rem;\n  margin-right: 0;\n}\n.btn-icon .btn-icon-wrapper {\n  margin-right: 0.5rem;\n  margin-left: 0;\n  margin-top: 0;\n  font-size: 17px;\n  vertical-align: middle;\n  transition: color 0.1s;\n  display: inline-block;\n}\n.btn-icon.btn-link {\n  text-decoration: none;\n}\n.btn-icon.btn-lg:not(.btn-block) .btn-icon-wrapper, .btn-group-lg > .btn-icon.btn:not(.btn-block) .btn-icon-wrapper {\n  font-size: 25px;\n}\n.btn-icon.btn-sm:not(.btn-block) .btn-icon-wrapper, .btn-group-sm > .btn-icon.btn:not(.btn-block) .btn-icon-wrapper {\n  font-size: 16px;\n}\n\n.btn-icon-only .btn-icon-wrapper {\n  margin-left: 0;\n  margin-right: 0;\n}\n\n.btn-hover-shine {\n  position: relative;\n}\n.btn-hover-shine:after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 0;\n  height: 100%;\n  background-color: rgba(255, 255, 255, 0.4);\n  -webkit-transition: none;\n  -moz-transition: none;\n  transition: none;\n}\n.btn-hover-shine:hover:after {\n  width: 120%;\n  background-color: rgba(255, 255, 255, 0);\n  transition: all 0.4s ease-in-out;\n}\n.btn-hover-shine.btn-pill::after {\n  border-top-left-radius: 50px;\n  border-bottom-left-radius: 50px;\n  border-top-right-radius: 50px;\n  border-bottom-right-radius: 50px;\n}\n\n.btn-icon-vertical {\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n.btn-icon-vertical .btn-icon-wrapper {\n  display: block;\n  font-size: 200%;\n  margin: 5px 0;\n  opacity: 0.6;\n}\n.btn-icon-vertical.btn-link {\n  text-decoration: none;\n}\n.btn-icon-vertical.btn-lg:not(.btn-block) .btn-icon-wrapper, .btn-group-lg > .btn-icon-vertical.btn:not(.btn-block) .btn-icon-wrapper {\n  font-size: 25px;\n}\n.btn-icon-vertical.btn-sm:not(.btn-block) .btn-icon-wrapper, .btn-group-sm > .btn-icon-vertical.btn:not(.btn-block) .btn-icon-wrapper {\n  font-size: 16px;\n}\n.btn-icon-vertical:active .btn-icon-wrapper, .btn-icon-vertical.active .btn-icon-wrapper, .btn-icon-vertical:hover .btn-icon-wrapper {\n  opacity: 1;\n}\n.btn-icon-vertical.btn-icon-bottom .btn-icon-wrapper {\n  margin: 0.2rem 0 5px;\n}\n.btn-icon-vertical.btn-transition-text .btn-icon-wrapper {\n  transition: all 0.2s !important;\n}\n.btn-icon-vertical.btn-transition-text:hover .btn-icon-wrapper {\n  transform: scale(1.3);\n}\n.btn-icon-vertical.btn-transition-text.btn-transition-alt:hover .btn-icon-wrapper {\n  color: #fff !important;\n}\n\n.btn-icon-lg {\n  font-size: 2.2rem !important;\n}\n\n.btn-transition {\n  color: #6c757d;\n  border-color: #e9ecef;\n  background-color: none;\n}\n.btn-transition.btn-outline-link {\n  border-color: transparent;\n  background-color: transparent;\n}\n.btn-transition.btn-outline-link:hover {\n  color: #545cd8;\n  background: #f8f9fa;\n}\n.btn-transition.disabled, .btn-transition:disabled {\n  color: #6c757d;\n  border-color: #e9ecef;\n}\n.btn-transition:hover .btn-icon-wrapper {\n  transition: none;\n}\n\n.btn-transition-alt:hover .icon-gradient {\n  -webkit-background-clip: initial;\n  -webkit-text-fill-color: initial;\n  background-clip: initial;\n  text-fill-color: initial;\n  background: none !important;\n  color: #fff;\n}\n\n.btn-square {\n  border-radius: 0 !important;\n}\n\n.btn.btn-wide {\n  padding: 0.375rem 1.5rem;\n  font-size: 0.8rem;\n  border-radius: 0.25rem;\n}\n\n.btn-lg.btn-wide, .btn-group-lg > .btn-wide.btn {\n  padding: 0.5rem 2rem;\n  font-size: 1.1rem;\n  border-radius: 0.3rem;\n}\n\n.btn-sm.btn-wide, .btn-group-sm > .btn-wide.btn {\n  padding: 0.25rem 1rem;\n  font-size: 0.8rem;\n  border-radius: 0.2rem;\n}\n\n.dropdown-toggle::after {\n  position: relative;\n  top: 2px;\n  opacity: 0.8;\n}\n\n.dropright .dropdown-toggle::after {\n  top: 0;\n}\n\n.dropdown-toggle-split {\n  border-left: rgba(255, 255, 255, 0.1) solid 1px;\n}\n\n.btn-gradient-primary {\n  background-image: linear-gradient(140deg, rgb(41.5071428571, 50.0214285714, 181.9928571429) -30%, #545cd8 90%);\n  background-color: rgb(41.5071428571, 50.0214285714, 181.9928571429);\n  border-color: rgb(41.5071428571, 50.0214285714, 181.9928571429);\n  color: color-yiq(rgb(32.0357142857, 38.6071428571, 140.4642857143));\n}\n.btn-gradient-primary.active, .btn-gradient-primary:active, .btn-gradient-primary:not(:disabled):not(.disabled):hover {\n  background-image: linear-gradient(120deg, rgb(38.6657142857, 46.5971428571, 169.5342857143) 0%, rgb(71.5414285714, 80.1242857143, 213.1585714286) 100%);\n  color: color-yiq(rgb(32.0357142857, 38.6071428571, 140.4642857143));\n  border-color: rgb(32.0357142857, 38.6071428571, 140.4642857143);\n}\n.btn-gradient-primary:focus, .btn-gradient-primary.focus, .btn-gradient-primary:active, .btn-gradient-primary.active {\n  color: color-yiq(rgb(32.0357142857, 38.6071428571, 140.4642857143)) !important;\n  border-color: rgb(36.7714285714, 44.3142857143, 161.2285714286) !important;\n}\n.btn-gradient-primary.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(84, 92, 216, 0.4), 0 0.0625rem 0.125rem rgba(84, 92, 216, 0.5);\n}\n.btn-gradient-primary.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(84, 92, 216, 0.5), 0 0.0625rem 0.125rem rgba(84, 92, 216, 0.6);\n}\n\n.btn-gradient-secondary {\n  background-image: linear-gradient(140deg, rgb(72.5407725322, 78.5858369099, 83.9592274678) -30%, #6c757d 90%);\n  background-color: rgb(72.5407725322, 78.5858369099, 83.9592274678);\n  border-color: rgb(72.5407725322, 78.5858369099, 83.9592274678);\n  color: color-yiq(rgb(48.9012875536, 52.9763948498, 56.5987124464));\n}\n.btn-gradient-secondary.active, .btn-gradient-secondary:active, .btn-gradient-secondary:not(:disabled):not(.disabled):hover {\n  background-image: linear-gradient(120deg, rgb(65.4489270386, 70.9030042918, 75.7510729614) 0%, rgb(100.9081545064, 109.317167382, 116.7918454936) 100%);\n  color: color-yiq(rgb(48.9012875536, 52.9763948498, 56.5987124464));\n  border-color: rgb(48.9012875536, 52.9763948498, 56.5987124464);\n}\n.btn-gradient-secondary:focus, .btn-gradient-secondary.focus, .btn-gradient-secondary:active, .btn-gradient-secondary.active {\n  color: color-yiq(rgb(48.9012875536, 52.9763948498, 56.5987124464)) !important;\n  border-color: rgb(60.7210300429, 65.7811158798, 70.2789699571) !important;\n}\n.btn-gradient-secondary.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(108, 117, 125, 0.4), 0 0.0625rem 0.125rem rgba(108, 117, 125, 0.5);\n}\n.btn-gradient-secondary.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(108, 117, 125, 0.5), 0 0.0625rem 0.125rem rgba(108, 117, 125, 0.6);\n}\n\n.btn-gradient-success {\n  background-image: linear-gradient(140deg, rgb(40.531496063, 136.968503937, 87.3523622047) -30%, #3ac47d 90%);\n  background-color: rgb(40.531496063, 136.968503937, 87.3523622047);\n  border-color: rgb(40.531496063, 136.968503937, 87.3523622047);\n  color: color-yiq(rgb(28.8858267717, 97.6141732283, 62.2539370079));\n}\n.btn-gradient-success.active, .btn-gradient-success:active, .btn-gradient-success:not(:disabled):not(.disabled):hover {\n  background-image: linear-gradient(120deg, rgb(37.0377952756, 125.1622047244, 79.8228346457) 0%, rgb(54.5062992126, 184.1937007874, 117.4704724409) 100%);\n  color: color-yiq(rgb(28.8858267717, 97.6141732283, 62.2539370079));\n  border-color: rgb(28.8858267717, 97.6141732283, 62.2539370079);\n}\n.btn-gradient-success:focus, .btn-gradient-success.focus, .btn-gradient-success:active, .btn-gradient-success.active {\n  color: color-yiq(rgb(28.8858267717, 97.6141732283, 62.2539370079)) !important;\n  border-color: rgb(34.7086614173, 117.2913385827, 74.8031496063) !important;\n}\n.btn-gradient-success.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(58, 196, 125, 0.4), 0 0.0625rem 0.125rem rgba(58, 196, 125, 0.5);\n}\n.btn-gradient-success.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(58, 196, 125, 0.5), 0 0.0625rem 0.125rem rgba(58, 196, 125, 0.6);\n}\n\n.btn-gradient-info {\n  background-image: linear-gradient(140deg, rgb(0, 141.152173913, 226.5) -30%, #30b1ff 90%);\n  background-color: rgb(0, 141.152173913, 226.5);\n  border-color: rgb(0, 141.152173913, 226.5);\n  color: color-yiq(rgb(0, 109.3695652174, 175.5));\n}\n.btn-gradient-info.active, .btn-gradient-info:active, .btn-gradient-info:not(:disabled):not(.disabled):hover {\n  background-image: linear-gradient(120deg, rgb(0, 131.6173913043, 211.2) 0%, rgb(32.7, 171.2347826087, 255) 100%);\n  color: color-yiq(rgb(0, 109.3695652174, 175.5));\n  border-color: rgb(0, 109.3695652174, 175.5);\n}\n.btn-gradient-info:focus, .btn-gradient-info.focus, .btn-gradient-info:active, .btn-gradient-info.active {\n  color: color-yiq(rgb(0, 109.3695652174, 175.5)) !important;\n  border-color: rgb(0, 125.2608695652, 201) !important;\n}\n.btn-gradient-info.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(48, 177, 255, 0.4), 0 0.0625rem 0.125rem rgba(48, 177, 255, 0.5);\n}\n.btn-gradient-info.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(48, 177, 255, 0.5), 0 0.0625rem 0.125rem rgba(48, 177, 255, 0.6);\n}\n\n.btn-gradient-warning {\n  background-image: linear-gradient(140deg, rgb(199.2224669604, 142.8215859031, 7.2775330396) -30%, #f7b924 90%);\n  background-color: rgb(199.2224669604, 142.8215859031, 7.2775330396);\n  border-color: rgb(199.2224669604, 142.8215859031, 7.2775330396);\n  color: color-yiq(rgb(150.0198237885, 107.5484581498, 5.4801762115));\n}\n.btn-gradient-warning.active, .btn-gradient-warning:active, .btn-gradient-warning:not(:disabled):not(.disabled):hover {\n  background-image: linear-gradient(120deg, rgb(184.4616740088, 132.2396475771, 6.7383259912) 0%, rgb(246.4607929515, 180.281938326, 21.2392070485) 100%);\n  color: color-yiq(rgb(150.0198237885, 107.5484581498, 5.4801762115));\n  border-color: rgb(150.0198237885, 107.5484581498, 5.4801762115);\n}\n.btn-gradient-warning:focus, .btn-gradient-warning.focus, .btn-gradient-warning:active, .btn-gradient-warning.active {\n  color: color-yiq(rgb(150.0198237885, 107.5484581498, 5.4801762115)) !important;\n  border-color: rgb(174.6211453744, 125.1850220264, 6.3788546256) !important;\n}\n.btn-gradient-warning.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(247, 185, 36, 0.4), 0 0.0625rem 0.125rem rgba(247, 185, 36, 0.5);\n}\n.btn-gradient-warning.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(247, 185, 36, 0.5), 0 0.0625rem 0.125rem rgba(247, 185, 36, 0.6);\n}\n\n.btn-gradient-danger {\n  background-image: linear-gradient(140deg, rgb(151.6437007874, 25.8562992126, 55.905511811) -30%, #d92550 90%);\n  background-color: rgb(151.6437007874, 25.8562992126, 55.905511811);\n  border-color: rgb(151.6437007874, 25.8562992126, 55.905511811);\n  color: color-yiq(rgb(108.0728346457, 18.4271653543, 39.842519685));\n}\n.btn-gradient-danger.active, .btn-gradient-danger:active, .btn-gradient-danger:not(:disabled):not(.disabled):hover {\n  background-image: linear-gradient(120deg, rgb(138.5724409449, 23.6275590551, 51.0866141732) 0%, rgb(203.9287401575, 34.7712598425, 75.1811023622) 100%);\n  color: color-yiq(rgb(108.0728346457, 18.4271653543, 39.842519685));\n  border-color: rgb(108.0728346457, 18.4271653543, 39.842519685);\n}\n.btn-gradient-danger:focus, .btn-gradient-danger.focus, .btn-gradient-danger:active, .btn-gradient-danger.active {\n  color: color-yiq(rgb(108.0728346457, 18.4271653543, 39.842519685)) !important;\n  border-color: rgb(129.8582677165, 22.1417322835, 47.874015748) !important;\n}\n.btn-gradient-danger.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(217, 37, 80, 0.4), 0 0.0625rem 0.125rem rgba(217, 37, 80, 0.5);\n}\n.btn-gradient-danger.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(217, 37, 80, 0.5), 0 0.0625rem 0.125rem rgba(217, 37, 80, 0.6);\n}\n\n.btn-gradient-focus {\n  background-image: linear-gradient(140deg, rgb(32.8513513514, 30.9189189189, 40.5810810811) -30%, #444054 90%);\n  background-color: rgb(32.8513513514, 30.9189189189, 40.5810810811);\n  border-color: rgb(32.8513513514, 30.9189189189, 40.5810810811);\n  color: color-yiq(rgb(9.4189189189, 8.8648648649, 11.6351351351));\n}\n.btn-gradient-focus.active, .btn-gradient-focus:active, .btn-gradient-focus:not(:disabled):not(.disabled):hover {\n  background-image: linear-gradient(120deg, rgb(25.8216216216, 24.3027027027, 31.8972972973) 0%, rgb(60.9702702703, 57.3837837838, 75.3162162162) 100%);\n  color: color-yiq(rgb(9.4189189189, 8.8648648649, 11.6351351351));\n  border-color: rgb(9.4189189189, 8.8648648649, 11.6351351351);\n}\n.btn-gradient-focus:focus, .btn-gradient-focus.focus, .btn-gradient-focus:active, .btn-gradient-focus.active {\n  color: color-yiq(rgb(9.4189189189, 8.8648648649, 11.6351351351)) !important;\n  border-color: rgb(21.1351351351, 19.8918918919, 26.1081081081) !important;\n}\n.btn-gradient-focus.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(68, 64, 84, 0.4), 0 0.0625rem 0.125rem rgba(68, 64, 84, 0.5);\n}\n.btn-gradient-focus.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(68, 64, 84, 0.5), 0 0.0625rem 0.125rem rgba(68, 64, 84, 0.6);\n}\n\n.btn-gradient-alternate {\n  background-image: linear-gradient(140deg, rgb(86.657079646, 58.2123893805, 91.2876106195) -30%, #83588a 90%);\n  background-color: rgb(86.657079646, 58.2123893805, 91.2876106195);\n  border-color: rgb(86.657079646, 58.2123893805, 91.2876106195);\n  color: color-yiq(rgb(57.0951327434, 38.3539823009, 60.1460176991));\n}\n.btn-gradient-alternate.active, .btn-gradient-alternate:active, .btn-gradient-alternate:not(:disabled):not(.disabled):hover {\n  background-image: linear-gradient(120deg, rgb(77.7884955752, 52.2548672566, 81.9451327434) 0%, rgb(122.1314159292, 82.0424778761, 128.6575221239) 100%);\n  color: color-yiq(rgb(57.0951327434, 38.3539823009, 60.1460176991));\n  border-color: rgb(57.0951327434, 38.3539823009, 60.1460176991);\n}\n.btn-gradient-alternate:focus, .btn-gradient-alternate.focus, .btn-gradient-alternate:active, .btn-gradient-alternate.active {\n  color: color-yiq(rgb(57.0951327434, 38.3539823009, 60.1460176991)) !important;\n  border-color: rgb(71.8761061947, 48.2831858407, 75.7168141593) !important;\n}\n.btn-gradient-alternate.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(131, 88, 138, 0.4), 0 0.0625rem 0.125rem rgba(131, 88, 138, 0.5);\n}\n.btn-gradient-alternate.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(131, 88, 138, 0.5), 0 0.0625rem 0.125rem rgba(131, 88, 138, 0.6);\n}\n\n.btn-gradient-light {\n  background-image: linear-gradient(140deg, rgb(199.75, 199.75, 199.75) -30%, #eeeeee 90%);\n  background-color: rgb(199.75, 199.75, 199.75);\n  border-color: rgb(199.75, 199.75, 199.75);\n  color: color-yiq(rgb(174.25, 174.25, 174.25));\n}\n.btn-gradient-light.active, .btn-gradient-light:active, .btn-gradient-light:not(:disabled):not(.disabled):hover {\n  background-image: linear-gradient(120deg, rgb(192.1, 192.1, 192.1) 0%, rgb(230.35, 230.35, 230.35) 100%);\n  color: color-yiq(rgb(174.25, 174.25, 174.25));\n  border-color: rgb(174.25, 174.25, 174.25);\n}\n.btn-gradient-light:focus, .btn-gradient-light.focus, .btn-gradient-light:active, .btn-gradient-light.active {\n  color: color-yiq(rgb(174.25, 174.25, 174.25)) !important;\n  border-color: #bbbbbb !important;\n}\n.btn-gradient-light.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(238, 238, 238, 0.4), 0 0.0625rem 0.125rem rgba(238, 238, 238, 0.5);\n}\n.btn-gradient-light.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(238, 238, 238, 0.5), 0 0.0625rem 0.125rem rgba(238, 238, 238, 0.6);\n}\n\n.btn-gradient-dark {\n  background-image: linear-gradient(140deg, rgb(17.7068965517, 19.75, 21.7931034483) -30%, #343a40 90%);\n  background-color: rgb(17.7068965517, 19.75, 21.7931034483);\n  border-color: rgb(17.7068965517, 19.75, 21.7931034483);\n  color: color-yiq(black);\n}\n.btn-gradient-dark.active, .btn-gradient-dark:active, .btn-gradient-dark:not(:disabled):not(.disabled):hover {\n  background-image: linear-gradient(120deg, rgb(10.8482758621, 12.1, 13.3517241379) 0%, rgb(45.1413793103, 50.35, 55.5586206897) 100%);\n  color: color-yiq(black);\n  border-color: black;\n}\n.btn-gradient-dark:focus, .btn-gradient-dark.focus, .btn-gradient-dark:active, .btn-gradient-dark.active {\n  color: color-yiq(black) !important;\n  border-color: rgb(6.275862069, 7, 7.724137931) !important;\n}\n.btn-gradient-dark.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(52, 58, 64, 0.4), 0 0.0625rem 0.125rem rgba(52, 58, 64, 0.5);\n}\n.btn-gradient-dark.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(52, 58, 64, 0.5), 0 0.0625rem 0.125rem rgba(52, 58, 64, 0.6);\n}\n\n.btn-shadow.active {\n  box-shadow: 0 0 0 0 transparent !important;\n}\n\n.btn-primary {\n  color: #fff;\n  background-color: #545cd8;\n  border-color: #545cd8;\n}\n.btn-primary:hover {\n  color: #fff;\n  background-color: rgb(71.4, 78.2, 183.6);\n  border-color: rgb(67.2, 73.6, 172.8);\n}\n.btn-check:focus + .btn-primary, .btn-primary:focus {\n  color: #fff;\n  background-color: rgb(71.4, 78.2, 183.6);\n  border-color: rgb(67.2, 73.6, 172.8);\n  box-shadow: 0 0 0 0 rgba(109.65, 116.45, 221.85, 0.5);\n}\n.btn-check:checked + .btn-primary, .btn-check:active + .btn-primary, .btn-primary:active, .btn-primary.active, .show > .btn-primary.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(67.2, 73.6, 172.8);\n  border-color: #3f45a2;\n}\n.btn-check:checked + .btn-primary:focus, .btn-check:active + .btn-primary:focus, .btn-primary:active:focus, .btn-primary.active:focus, .show > .btn-primary.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(109.65, 116.45, 221.85, 0.5);\n}\n.btn-primary:disabled, .btn-primary.disabled {\n  color: #fff;\n  background-color: #545cd8;\n  border-color: #545cd8;\n}\n.btn-primary.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(84, 92, 216, 0.4), 0 0.0625rem 0.125rem rgba(84, 92, 216, 0.5);\n}\n.btn-primary.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(84, 92, 216, 0.5), 0 0.0625rem 0.125rem rgba(84, 92, 216, 0.6);\n}\n\n.btn-secondary {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-secondary:hover {\n  color: #fff;\n  background-color: rgb(91.8, 99.45, 106.25);\n  border-color: rgb(86.4, 93.6, 100);\n}\n.btn-check:focus + .btn-secondary, .btn-secondary:focus {\n  color: #fff;\n  background-color: rgb(91.8, 99.45, 106.25);\n  border-color: rgb(86.4, 93.6, 100);\n  box-shadow: 0 0 0 0 rgba(130.05, 137.7, 144.5, 0.5);\n}\n.btn-check:checked + .btn-secondary, .btn-check:active + .btn-secondary, .btn-secondary:active, .btn-secondary.active, .show > .btn-secondary.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(86.4, 93.6, 100);\n  border-color: rgb(81, 87.75, 93.75);\n}\n.btn-check:checked + .btn-secondary:focus, .btn-check:active + .btn-secondary:focus, .btn-secondary:active:focus, .btn-secondary.active:focus, .show > .btn-secondary.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(130.05, 137.7, 144.5, 0.5);\n}\n.btn-secondary:disabled, .btn-secondary.disabled {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-secondary.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(108, 117, 125, 0.4), 0 0.0625rem 0.125rem rgba(108, 117, 125, 0.5);\n}\n.btn-secondary.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(108, 117, 125, 0.5), 0 0.0625rem 0.125rem rgba(108, 117, 125, 0.6);\n}\n\n.btn-success {\n  color: #000;\n  background-color: #3ac47d;\n  border-color: #3ac47d;\n}\n.btn-success:hover {\n  color: #000;\n  background-color: rgb(87.55, 204.85, 144.5);\n  border-color: rgb(77.7, 201.9, 138);\n}\n.btn-check:focus + .btn-success, .btn-success:focus {\n  color: #000;\n  background-color: rgb(87.55, 204.85, 144.5);\n  border-color: rgb(77.7, 201.9, 138);\n  box-shadow: 0 0 0 0 rgba(49.3, 166.6, 106.25, 0.5);\n}\n.btn-check:checked + .btn-success, .btn-check:active + .btn-success, .btn-success:active, .btn-success.active, .show > .btn-success.dropdown-toggle {\n  color: #000;\n  background-color: rgb(97.4, 207.8, 151);\n  border-color: rgb(77.7, 201.9, 138);\n}\n.btn-check:checked + .btn-success:focus, .btn-check:active + .btn-success:focus, .btn-success:active:focus, .btn-success.active:focus, .show > .btn-success.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(49.3, 166.6, 106.25, 0.5);\n}\n.btn-success:disabled, .btn-success.disabled {\n  color: #000;\n  background-color: #3ac47d;\n  border-color: #3ac47d;\n}\n.btn-success.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(58, 196, 125, 0.4), 0 0.0625rem 0.125rem rgba(58, 196, 125, 0.5);\n}\n.btn-success.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(58, 196, 125, 0.5), 0 0.0625rem 0.125rem rgba(58, 196, 125, 0.6);\n}\n\n.btn-info {\n  color: #000;\n  background-color: #30b1ff;\n  border-color: #30b1ff;\n}\n.btn-info:hover {\n  color: #000;\n  background-color: rgb(79.05, 188.7, 255);\n  border-color: rgb(68.7, 184.8, 255);\n}\n.btn-check:focus + .btn-info, .btn-info:focus {\n  color: #000;\n  background-color: rgb(79.05, 188.7, 255);\n  border-color: rgb(68.7, 184.8, 255);\n  box-shadow: 0 0 0 0 rgba(40.8, 150.45, 216.75, 0.5);\n}\n.btn-check:checked + .btn-info, .btn-check:active + .btn-info, .btn-info:active, .btn-info.active, .show > .btn-info.dropdown-toggle {\n  color: #000;\n  background-color: rgb(89.4, 192.6, 255);\n  border-color: rgb(68.7, 184.8, 255);\n}\n.btn-check:checked + .btn-info:focus, .btn-check:active + .btn-info:focus, .btn-info:active:focus, .btn-info.active:focus, .show > .btn-info.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(40.8, 150.45, 216.75, 0.5);\n}\n.btn-info:disabled, .btn-info.disabled {\n  color: #000;\n  background-color: #30b1ff;\n  border-color: #30b1ff;\n}\n.btn-info.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(48, 177, 255, 0.4), 0 0.0625rem 0.125rem rgba(48, 177, 255, 0.5);\n}\n.btn-info.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(48, 177, 255, 0.5), 0 0.0625rem 0.125rem rgba(48, 177, 255, 0.6);\n}\n\n.btn-warning {\n  color: #000;\n  background-color: #f7b924;\n  border-color: #f7b924;\n}\n.btn-warning:hover {\n  color: #000;\n  background-color: rgb(248.2, 195.5, 68.85);\n  border-color: rgb(247.8, 192, 57.9);\n}\n.btn-check:focus + .btn-warning, .btn-warning:focus {\n  color: #000;\n  background-color: rgb(248.2, 195.5, 68.85);\n  border-color: rgb(247.8, 192, 57.9);\n  box-shadow: 0 0 0 0 rgba(209.95, 157.25, 30.6, 0.5);\n}\n.btn-check:checked + .btn-warning, .btn-check:active + .btn-warning, .btn-warning:active, .btn-warning.active, .show > .btn-warning.dropdown-toggle {\n  color: #000;\n  background-color: rgb(248.6, 199, 79.8);\n  border-color: rgb(247.8, 192, 57.9);\n}\n.btn-check:checked + .btn-warning:focus, .btn-check:active + .btn-warning:focus, .btn-warning:active:focus, .btn-warning.active:focus, .show > .btn-warning.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(209.95, 157.25, 30.6, 0.5);\n}\n.btn-warning:disabled, .btn-warning.disabled {\n  color: #000;\n  background-color: #f7b924;\n  border-color: #f7b924;\n}\n.btn-warning.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(247, 185, 36, 0.4), 0 0.0625rem 0.125rem rgba(247, 185, 36, 0.5);\n}\n.btn-warning.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(247, 185, 36, 0.5), 0 0.0625rem 0.125rem rgba(247, 185, 36, 0.6);\n}\n\n.btn-danger {\n  color: #fff;\n  background-color: #d92550;\n  border-color: #d92550;\n}\n.btn-danger:hover {\n  color: #fff;\n  background-color: rgb(184.45, 31.45, 68);\n  border-color: rgb(173.6, 29.6, 64);\n}\n.btn-check:focus + .btn-danger, .btn-danger:focus {\n  color: #fff;\n  background-color: rgb(184.45, 31.45, 68);\n  border-color: rgb(173.6, 29.6, 64);\n  box-shadow: 0 0 0 0 rgba(222.7, 69.7, 106.25, 0.5);\n}\n.btn-check:checked + .btn-danger, .btn-check:active + .btn-danger, .btn-danger:active, .btn-danger.active, .show > .btn-danger.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(173.6, 29.6, 64);\n  border-color: rgb(162.75, 27.75, 60);\n}\n.btn-check:checked + .btn-danger:focus, .btn-check:active + .btn-danger:focus, .btn-danger:active:focus, .btn-danger.active:focus, .show > .btn-danger.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(222.7, 69.7, 106.25, 0.5);\n}\n.btn-danger:disabled, .btn-danger.disabled {\n  color: #fff;\n  background-color: #d92550;\n  border-color: #d92550;\n}\n.btn-danger.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(217, 37, 80, 0.4), 0 0.0625rem 0.125rem rgba(217, 37, 80, 0.5);\n}\n.btn-danger.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(217, 37, 80, 0.5), 0 0.0625rem 0.125rem rgba(217, 37, 80, 0.6);\n}\n\n.btn-light {\n  color: #000;\n  background-color: #eeeeee;\n  border-color: #eeeeee;\n}\n.btn-light:hover {\n  color: #000;\n  background-color: rgb(240.55, 240.55, 240.55);\n  border-color: rgb(239.7, 239.7, 239.7);\n}\n.btn-check:focus + .btn-light, .btn-light:focus {\n  color: #000;\n  background-color: rgb(240.55, 240.55, 240.55);\n  border-color: rgb(239.7, 239.7, 239.7);\n  box-shadow: 0 0 0 0 rgba(202.3, 202.3, 202.3, 0.5);\n}\n.btn-check:checked + .btn-light, .btn-check:active + .btn-light, .btn-light:active, .btn-light.active, .show > .btn-light.dropdown-toggle {\n  color: #000;\n  background-color: rgb(241.4, 241.4, 241.4);\n  border-color: rgb(239.7, 239.7, 239.7);\n}\n.btn-check:checked + .btn-light:focus, .btn-check:active + .btn-light:focus, .btn-light:active:focus, .btn-light.active:focus, .show > .btn-light.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(202.3, 202.3, 202.3, 0.5);\n}\n.btn-light:disabled, .btn-light.disabled {\n  color: #000;\n  background-color: #eeeeee;\n  border-color: #eeeeee;\n}\n.btn-light.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(238, 238, 238, 0.4), 0 0.0625rem 0.125rem rgba(238, 238, 238, 0.5);\n}\n.btn-light.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(238, 238, 238, 0.5), 0 0.0625rem 0.125rem rgba(238, 238, 238, 0.6);\n}\n\n.btn-dark {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #343a40;\n}\n.btn-dark:hover {\n  color: #fff;\n  background-color: rgb(44.2, 49.3, 54.4);\n  border-color: rgb(41.6, 46.4, 51.2);\n}\n.btn-check:focus + .btn-dark, .btn-dark:focus {\n  color: #fff;\n  background-color: rgb(44.2, 49.3, 54.4);\n  border-color: rgb(41.6, 46.4, 51.2);\n  box-shadow: 0 0 0 0 rgba(82.45, 87.55, 92.65, 0.5);\n}\n.btn-check:checked + .btn-dark, .btn-check:active + .btn-dark, .btn-dark:active, .btn-dark.active, .show > .btn-dark.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(41.6, 46.4, 51.2);\n  border-color: rgb(39, 43.5, 48);\n}\n.btn-check:checked + .btn-dark:focus, .btn-check:active + .btn-dark:focus, .btn-dark:active:focus, .btn-dark.active:focus, .show > .btn-dark.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(82.45, 87.55, 92.65, 0.5);\n}\n.btn-dark:disabled, .btn-dark.disabled {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #343a40;\n}\n.btn-dark.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(52, 58, 64, 0.4), 0 0.0625rem 0.125rem rgba(52, 58, 64, 0.5);\n}\n.btn-dark.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(52, 58, 64, 0.5), 0 0.0625rem 0.125rem rgba(52, 58, 64, 0.6);\n}\n\n.btn-focus {\n  color: #fff;\n  background-color: #444054;\n  border-color: #444054;\n}\n.btn-focus:hover {\n  color: #fff;\n  background-color: rgb(57.8, 54.4, 71.4);\n  border-color: rgb(54.4, 51.2, 67.2);\n}\n.btn-check:focus + .btn-focus, .btn-focus:focus {\n  color: #fff;\n  background-color: rgb(57.8, 54.4, 71.4);\n  border-color: rgb(54.4, 51.2, 67.2);\n  box-shadow: 0 0 0 0 rgba(96.05, 92.65, 109.65, 0.5);\n}\n.btn-check:checked + .btn-focus, .btn-check:active + .btn-focus, .btn-focus:active, .btn-focus.active, .show > .btn-focus.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(54.4, 51.2, 67.2);\n  border-color: #33303f;\n}\n.btn-check:checked + .btn-focus:focus, .btn-check:active + .btn-focus:focus, .btn-focus:active:focus, .btn-focus.active:focus, .show > .btn-focus.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(96.05, 92.65, 109.65, 0.5);\n}\n.btn-focus:disabled, .btn-focus.disabled {\n  color: #fff;\n  background-color: #444054;\n  border-color: #444054;\n}\n.btn-focus.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(68, 64, 84, 0.4), 0 0.0625rem 0.125rem rgba(68, 64, 84, 0.5);\n}\n.btn-focus.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(68, 64, 84, 0.5), 0 0.0625rem 0.125rem rgba(68, 64, 84, 0.6);\n}\n\n.btn-alternate {\n  color: #fff;\n  background-color: #83588a;\n  border-color: #83588a;\n}\n.btn-alternate:hover {\n  color: #fff;\n  background-color: rgb(111.35, 74.8, 117.3);\n  border-color: rgb(104.8, 70.4, 110.4);\n}\n.btn-check:focus + .btn-alternate, .btn-alternate:focus {\n  color: #fff;\n  background-color: rgb(111.35, 74.8, 117.3);\n  border-color: rgb(104.8, 70.4, 110.4);\n  box-shadow: 0 0 0 0 rgba(149.6, 113.05, 155.55, 0.5);\n}\n.btn-check:checked + .btn-alternate, .btn-check:active + .btn-alternate, .btn-alternate:active, .btn-alternate.active, .show > .btn-alternate.dropdown-toggle {\n  color: #fff;\n  background-color: rgb(104.8, 70.4, 110.4);\n  border-color: rgb(98.25, 66, 103.5);\n}\n.btn-check:checked + .btn-alternate:focus, .btn-check:active + .btn-alternate:focus, .btn-alternate:active:focus, .btn-alternate.active:focus, .show > .btn-alternate.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 rgba(149.6, 113.05, 155.55, 0.5);\n}\n.btn-alternate:disabled, .btn-alternate.disabled {\n  color: #fff;\n  background-color: #83588a;\n  border-color: #83588a;\n}\n.btn-alternate.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(131, 88, 138, 0.4), 0 0.0625rem 0.125rem rgba(131, 88, 138, 0.5);\n}\n.btn-alternate.btn-shadow:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(131, 88, 138, 0.5), 0 0.0625rem 0.125rem rgba(131, 88, 138, 0.6);\n}\n\n.btn-shadow-primary:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(84, 92, 216, 0.4), 0 0.0625rem 0.125rem rgba(84, 92, 216, 0.5);\n}\n\n.btn-shadow-secondary:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(108, 117, 125, 0.4), 0 0.0625rem 0.125rem rgba(108, 117, 125, 0.5);\n}\n\n.btn-shadow-success:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(58, 196, 125, 0.4), 0 0.0625rem 0.125rem rgba(58, 196, 125, 0.5);\n}\n\n.btn-shadow-info:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(48, 177, 255, 0.4), 0 0.0625rem 0.125rem rgba(48, 177, 255, 0.5);\n}\n\n.btn-shadow-warning:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(247, 185, 36, 0.4), 0 0.0625rem 0.125rem rgba(247, 185, 36, 0.5);\n}\n\n.btn-shadow-danger:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(217, 37, 80, 0.4), 0 0.0625rem 0.125rem rgba(217, 37, 80, 0.5);\n}\n\n.btn-shadow-light:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(238, 238, 238, 0.4), 0 0.0625rem 0.125rem rgba(238, 238, 238, 0.5);\n}\n\n.btn-shadow-dark:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(52, 58, 64, 0.4), 0 0.0625rem 0.125rem rgba(52, 58, 64, 0.5);\n}\n\n.btn-shadow-focus:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(68, 64, 84, 0.4), 0 0.0625rem 0.125rem rgba(68, 64, 84, 0.5);\n}\n\n.btn-shadow-alternate:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(131, 88, 138, 0.4), 0 0.0625rem 0.125rem rgba(131, 88, 138, 0.5);\n}\n\n.btn-outline-primary {\n  color: #545cd8;\n  border-color: #545cd8;\n}\n.btn-outline-primary:hover {\n  color: #fff;\n  background-color: #545cd8;\n  border-color: #545cd8;\n}\n.btn-check:focus + .btn-outline-primary, .btn-outline-primary:focus {\n  box-shadow: 0 0 0 0 rgba(84, 92, 216, 0.5);\n}\n.btn-check:checked + .btn-outline-primary, .btn-check:active + .btn-outline-primary, .btn-outline-primary:active, .btn-outline-primary.active, .btn-outline-primary.dropdown-toggle.show {\n  color: #fff;\n  background-color: #545cd8;\n  border-color: #545cd8;\n}\n.btn-check:checked + .btn-outline-primary:focus, .btn-check:active + .btn-outline-primary:focus, .btn-outline-primary:active:focus, .btn-outline-primary.active:focus, .btn-outline-primary.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(84, 92, 216, 0.5);\n}\n.btn-outline-primary:disabled, .btn-outline-primary.disabled {\n  color: #545cd8;\n  background-color: transparent;\n}\n.btn-outline-primary.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(84, 92, 216, 0.4), 0 0.0625rem 0.125rem rgba(84, 92, 216, 0.5);\n}\n.btn-outline-primary.btn-shadow.active:hover, .btn-outline-primary.btn-shadow.disabled:hover, .btn-outline-primary.btn-shadow:active:hover, .btn-outline-primary.btn-shadow:disabled:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(84, 92, 216, 0.5), 0 0.0625rem 0.125rem rgba(84, 92, 216, 0.6);\n}\n.btn-outline-primary.btn-shadow:hover {\n  box-shadow: 0px 5px 15px 2px rgba(84, 92, 216, 0.19);\n}\n\n.btn-outline-secondary {\n  color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-outline-secondary:hover {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-check:focus + .btn-outline-secondary, .btn-outline-secondary:focus {\n  box-shadow: 0 0 0 0 rgba(108, 117, 125, 0.5);\n}\n.btn-check:checked + .btn-outline-secondary, .btn-check:active + .btn-outline-secondary, .btn-outline-secondary:active, .btn-outline-secondary.active, .btn-outline-secondary.dropdown-toggle.show {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-check:checked + .btn-outline-secondary:focus, .btn-check:active + .btn-outline-secondary:focus, .btn-outline-secondary:active:focus, .btn-outline-secondary.active:focus, .btn-outline-secondary.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(108, 117, 125, 0.5);\n}\n.btn-outline-secondary:disabled, .btn-outline-secondary.disabled {\n  color: #6c757d;\n  background-color: transparent;\n}\n.btn-outline-secondary.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(108, 117, 125, 0.4), 0 0.0625rem 0.125rem rgba(108, 117, 125, 0.5);\n}\n.btn-outline-secondary.btn-shadow.active:hover, .btn-outline-secondary.btn-shadow.disabled:hover, .btn-outline-secondary.btn-shadow:active:hover, .btn-outline-secondary.btn-shadow:disabled:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(108, 117, 125, 0.5), 0 0.0625rem 0.125rem rgba(108, 117, 125, 0.6);\n}\n.btn-outline-secondary.btn-shadow:hover {\n  box-shadow: 0px 5px 15px 2px rgba(108, 117, 125, 0.19);\n}\n\n.btn-outline-success {\n  color: #3ac47d;\n  border-color: #3ac47d;\n}\n.btn-outline-success:hover {\n  color: #000;\n  background-color: #3ac47d;\n  border-color: #3ac47d;\n}\n.btn-check:focus + .btn-outline-success, .btn-outline-success:focus {\n  box-shadow: 0 0 0 0 rgba(58, 196, 125, 0.5);\n}\n.btn-check:checked + .btn-outline-success, .btn-check:active + .btn-outline-success, .btn-outline-success:active, .btn-outline-success.active, .btn-outline-success.dropdown-toggle.show {\n  color: #000;\n  background-color: #3ac47d;\n  border-color: #3ac47d;\n}\n.btn-check:checked + .btn-outline-success:focus, .btn-check:active + .btn-outline-success:focus, .btn-outline-success:active:focus, .btn-outline-success.active:focus, .btn-outline-success.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(58, 196, 125, 0.5);\n}\n.btn-outline-success:disabled, .btn-outline-success.disabled {\n  color: #3ac47d;\n  background-color: transparent;\n}\n.btn-outline-success.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(58, 196, 125, 0.4), 0 0.0625rem 0.125rem rgba(58, 196, 125, 0.5);\n}\n.btn-outline-success.btn-shadow.active:hover, .btn-outline-success.btn-shadow.disabled:hover, .btn-outline-success.btn-shadow:active:hover, .btn-outline-success.btn-shadow:disabled:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(58, 196, 125, 0.5), 0 0.0625rem 0.125rem rgba(58, 196, 125, 0.6);\n}\n.btn-outline-success.btn-shadow:hover {\n  box-shadow: 0px 5px 15px 2px rgba(58, 196, 125, 0.19);\n}\n\n.btn-outline-info {\n  color: #30b1ff;\n  border-color: #30b1ff;\n}\n.btn-outline-info:hover {\n  color: #000;\n  background-color: #30b1ff;\n  border-color: #30b1ff;\n}\n.btn-check:focus + .btn-outline-info, .btn-outline-info:focus {\n  box-shadow: 0 0 0 0 rgba(48, 177, 255, 0.5);\n}\n.btn-check:checked + .btn-outline-info, .btn-check:active + .btn-outline-info, .btn-outline-info:active, .btn-outline-info.active, .btn-outline-info.dropdown-toggle.show {\n  color: #000;\n  background-color: #30b1ff;\n  border-color: #30b1ff;\n}\n.btn-check:checked + .btn-outline-info:focus, .btn-check:active + .btn-outline-info:focus, .btn-outline-info:active:focus, .btn-outline-info.active:focus, .btn-outline-info.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(48, 177, 255, 0.5);\n}\n.btn-outline-info:disabled, .btn-outline-info.disabled {\n  color: #30b1ff;\n  background-color: transparent;\n}\n.btn-outline-info.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(48, 177, 255, 0.4), 0 0.0625rem 0.125rem rgba(48, 177, 255, 0.5);\n}\n.btn-outline-info.btn-shadow.active:hover, .btn-outline-info.btn-shadow.disabled:hover, .btn-outline-info.btn-shadow:active:hover, .btn-outline-info.btn-shadow:disabled:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(48, 177, 255, 0.5), 0 0.0625rem 0.125rem rgba(48, 177, 255, 0.6);\n}\n.btn-outline-info.btn-shadow:hover {\n  box-shadow: 0px 5px 15px 2px rgba(48, 177, 255, 0.19);\n}\n\n.btn-outline-warning {\n  color: #f7b924;\n  border-color: #f7b924;\n}\n.btn-outline-warning:hover {\n  color: #000;\n  background-color: #f7b924;\n  border-color: #f7b924;\n}\n.btn-check:focus + .btn-outline-warning, .btn-outline-warning:focus {\n  box-shadow: 0 0 0 0 rgba(247, 185, 36, 0.5);\n}\n.btn-check:checked + .btn-outline-warning, .btn-check:active + .btn-outline-warning, .btn-outline-warning:active, .btn-outline-warning.active, .btn-outline-warning.dropdown-toggle.show {\n  color: #000;\n  background-color: #f7b924;\n  border-color: #f7b924;\n}\n.btn-check:checked + .btn-outline-warning:focus, .btn-check:active + .btn-outline-warning:focus, .btn-outline-warning:active:focus, .btn-outline-warning.active:focus, .btn-outline-warning.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(247, 185, 36, 0.5);\n}\n.btn-outline-warning:disabled, .btn-outline-warning.disabled {\n  color: #f7b924;\n  background-color: transparent;\n}\n.btn-outline-warning.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(247, 185, 36, 0.4), 0 0.0625rem 0.125rem rgba(247, 185, 36, 0.5);\n}\n.btn-outline-warning.btn-shadow.active:hover, .btn-outline-warning.btn-shadow.disabled:hover, .btn-outline-warning.btn-shadow:active:hover, .btn-outline-warning.btn-shadow:disabled:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(247, 185, 36, 0.5), 0 0.0625rem 0.125rem rgba(247, 185, 36, 0.6);\n}\n.btn-outline-warning.btn-shadow:hover {\n  box-shadow: 0px 5px 15px 2px rgba(247, 185, 36, 0.19);\n}\n\n.btn-outline-danger {\n  color: #d92550;\n  border-color: #d92550;\n}\n.btn-outline-danger:hover {\n  color: #fff;\n  background-color: #d92550;\n  border-color: #d92550;\n}\n.btn-check:focus + .btn-outline-danger, .btn-outline-danger:focus {\n  box-shadow: 0 0 0 0 rgba(217, 37, 80, 0.5);\n}\n.btn-check:checked + .btn-outline-danger, .btn-check:active + .btn-outline-danger, .btn-outline-danger:active, .btn-outline-danger.active, .btn-outline-danger.dropdown-toggle.show {\n  color: #fff;\n  background-color: #d92550;\n  border-color: #d92550;\n}\n.btn-check:checked + .btn-outline-danger:focus, .btn-check:active + .btn-outline-danger:focus, .btn-outline-danger:active:focus, .btn-outline-danger.active:focus, .btn-outline-danger.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(217, 37, 80, 0.5);\n}\n.btn-outline-danger:disabled, .btn-outline-danger.disabled {\n  color: #d92550;\n  background-color: transparent;\n}\n.btn-outline-danger.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(217, 37, 80, 0.4), 0 0.0625rem 0.125rem rgba(217, 37, 80, 0.5);\n}\n.btn-outline-danger.btn-shadow.active:hover, .btn-outline-danger.btn-shadow.disabled:hover, .btn-outline-danger.btn-shadow:active:hover, .btn-outline-danger.btn-shadow:disabled:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(217, 37, 80, 0.5), 0 0.0625rem 0.125rem rgba(217, 37, 80, 0.6);\n}\n.btn-outline-danger.btn-shadow:hover {\n  box-shadow: 0px 5px 15px 2px rgba(217, 37, 80, 0.19);\n}\n\n.btn-outline-light {\n  color: #eeeeee;\n  border-color: #eeeeee;\n}\n.btn-outline-light:hover {\n  color: #000;\n  background-color: #eeeeee;\n  border-color: #eeeeee;\n}\n.btn-check:focus + .btn-outline-light, .btn-outline-light:focus {\n  box-shadow: 0 0 0 0 rgba(238, 238, 238, 0.5);\n}\n.btn-check:checked + .btn-outline-light, .btn-check:active + .btn-outline-light, .btn-outline-light:active, .btn-outline-light.active, .btn-outline-light.dropdown-toggle.show {\n  color: #000;\n  background-color: #eeeeee;\n  border-color: #eeeeee;\n}\n.btn-check:checked + .btn-outline-light:focus, .btn-check:active + .btn-outline-light:focus, .btn-outline-light:active:focus, .btn-outline-light.active:focus, .btn-outline-light.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(238, 238, 238, 0.5);\n}\n.btn-outline-light:disabled, .btn-outline-light.disabled {\n  color: #eeeeee;\n  background-color: transparent;\n}\n.btn-outline-light.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(238, 238, 238, 0.4), 0 0.0625rem 0.125rem rgba(238, 238, 238, 0.5);\n}\n.btn-outline-light.btn-shadow.active:hover, .btn-outline-light.btn-shadow.disabled:hover, .btn-outline-light.btn-shadow:active:hover, .btn-outline-light.btn-shadow:disabled:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(238, 238, 238, 0.5), 0 0.0625rem 0.125rem rgba(238, 238, 238, 0.6);\n}\n.btn-outline-light.btn-shadow:hover {\n  box-shadow: 0px 5px 15px 2px rgba(238, 238, 238, 0.19);\n}\n\n.btn-outline-dark {\n  color: #343a40;\n  border-color: #343a40;\n}\n.btn-outline-dark:hover {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #343a40;\n}\n.btn-check:focus + .btn-outline-dark, .btn-outline-dark:focus {\n  box-shadow: 0 0 0 0 rgba(52, 58, 64, 0.5);\n}\n.btn-check:checked + .btn-outline-dark, .btn-check:active + .btn-outline-dark, .btn-outline-dark:active, .btn-outline-dark.active, .btn-outline-dark.dropdown-toggle.show {\n  color: #fff;\n  background-color: #343a40;\n  border-color: #343a40;\n}\n.btn-check:checked + .btn-outline-dark:focus, .btn-check:active + .btn-outline-dark:focus, .btn-outline-dark:active:focus, .btn-outline-dark.active:focus, .btn-outline-dark.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(52, 58, 64, 0.5);\n}\n.btn-outline-dark:disabled, .btn-outline-dark.disabled {\n  color: #343a40;\n  background-color: transparent;\n}\n.btn-outline-dark.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(52, 58, 64, 0.4), 0 0.0625rem 0.125rem rgba(52, 58, 64, 0.5);\n}\n.btn-outline-dark.btn-shadow.active:hover, .btn-outline-dark.btn-shadow.disabled:hover, .btn-outline-dark.btn-shadow:active:hover, .btn-outline-dark.btn-shadow:disabled:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(52, 58, 64, 0.5), 0 0.0625rem 0.125rem rgba(52, 58, 64, 0.6);\n}\n.btn-outline-dark.btn-shadow:hover {\n  box-shadow: 0px 5px 15px 2px rgba(52, 58, 64, 0.19);\n}\n\n.btn-outline-focus {\n  color: #444054;\n  border-color: #444054;\n}\n.btn-outline-focus:hover {\n  color: #fff;\n  background-color: #444054;\n  border-color: #444054;\n}\n.btn-check:focus + .btn-outline-focus, .btn-outline-focus:focus {\n  box-shadow: 0 0 0 0 rgba(68, 64, 84, 0.5);\n}\n.btn-check:checked + .btn-outline-focus, .btn-check:active + .btn-outline-focus, .btn-outline-focus:active, .btn-outline-focus.active, .btn-outline-focus.dropdown-toggle.show {\n  color: #fff;\n  background-color: #444054;\n  border-color: #444054;\n}\n.btn-check:checked + .btn-outline-focus:focus, .btn-check:active + .btn-outline-focus:focus, .btn-outline-focus:active:focus, .btn-outline-focus.active:focus, .btn-outline-focus.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(68, 64, 84, 0.5);\n}\n.btn-outline-focus:disabled, .btn-outline-focus.disabled {\n  color: #444054;\n  background-color: transparent;\n}\n.btn-outline-focus.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(68, 64, 84, 0.4), 0 0.0625rem 0.125rem rgba(68, 64, 84, 0.5);\n}\n.btn-outline-focus.btn-shadow.active:hover, .btn-outline-focus.btn-shadow.disabled:hover, .btn-outline-focus.btn-shadow:active:hover, .btn-outline-focus.btn-shadow:disabled:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(68, 64, 84, 0.5), 0 0.0625rem 0.125rem rgba(68, 64, 84, 0.6);\n}\n.btn-outline-focus.btn-shadow:hover {\n  box-shadow: 0px 5px 15px 2px rgba(68, 64, 84, 0.19);\n}\n\n.btn-outline-alternate {\n  color: #83588a;\n  border-color: #83588a;\n}\n.btn-outline-alternate:hover {\n  color: #fff;\n  background-color: #83588a;\n  border-color: #83588a;\n}\n.btn-check:focus + .btn-outline-alternate, .btn-outline-alternate:focus {\n  box-shadow: 0 0 0 0 rgba(131, 88, 138, 0.5);\n}\n.btn-check:checked + .btn-outline-alternate, .btn-check:active + .btn-outline-alternate, .btn-outline-alternate:active, .btn-outline-alternate.active, .btn-outline-alternate.dropdown-toggle.show {\n  color: #fff;\n  background-color: #83588a;\n  border-color: #83588a;\n}\n.btn-check:checked + .btn-outline-alternate:focus, .btn-check:active + .btn-outline-alternate:focus, .btn-outline-alternate:active:focus, .btn-outline-alternate.active:focus, .btn-outline-alternate.dropdown-toggle.show:focus {\n  box-shadow: 0 0 0 0 rgba(131, 88, 138, 0.5);\n}\n.btn-outline-alternate:disabled, .btn-outline-alternate.disabled {\n  color: #83588a;\n  background-color: transparent;\n}\n.btn-outline-alternate.btn-shadow {\n  box-shadow: 0 0.125rem 0.625rem rgba(131, 88, 138, 0.4), 0 0.0625rem 0.125rem rgba(131, 88, 138, 0.5);\n}\n.btn-outline-alternate.btn-shadow.active:hover, .btn-outline-alternate.btn-shadow.disabled:hover, .btn-outline-alternate.btn-shadow:active:hover, .btn-outline-alternate.btn-shadow:disabled:hover {\n  box-shadow: 0 0.125rem 0.625rem rgba(131, 88, 138, 0.5), 0 0.0625rem 0.125rem rgba(131, 88, 138, 0.6);\n}\n.btn-outline-alternate.btn-shadow:hover {\n  box-shadow: 0px 5px 15px 2px rgba(131, 88, 138, 0.19);\n}\n\n.btn {\n  position: relative;\n  transition: color 0.15s, background-color 0.15s, border-color 0.15s, box-shadow 0.15s;\n}\n@media (prefers-reduced-motion: reduce) {\n  .btn {\n    transition: none;\n  }\n}\n\n.btn-light {\n  border-color: rgb(219.5, 219.5, 219.5);\n}\n\n.btn-outline-light {\n  color: #8f8f8f;\n}\n\n.dropdown-menu {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);\n  font-size: 0.88rem;\n  margin: 0.125rem;\n}\n.dropdown-menu.dropdown-menu-right {\n  right: 0 !important;\n}\n.dropdown-menu .dropdown-header {\n  text-transform: uppercase;\n  font-size: 0.7333333333rem;\n  color: #545cd8;\n  font-weight: bold;\n}\n.dropdown-menu .dropdown-item {\n  font-size: 0.88rem;\n  display: flex;\n  align-items: center;\n  transition: background-color 0.3s ease, color 0.3s ease;\n  cursor: pointer;\n  z-index: 6;\n  position: relative;\n}\n.dropdown-menu .dropdown-item .dropdown-icon {\n  font-size: 1rem;\n  margin-right: 0.325rem;\n  width: 30px;\n  text-align: center;\n  opacity: 0.3;\n  margin-left: -10px;\n}\n.dropdown-menu .dropdown-item:hover .dropdown-icon {\n  opacity: 0.7;\n}\n.dropdown-menu.dropdown-menu-shadow {\n  box-shadow: 0 0.66875rem 2.3875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 1.1375rem 1.60625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.45rem 0.73125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.325rem 0.3875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);\n}\n\n.dropdown-menu-rounded {\n  border-radius: 10px;\n  padding: 0.65rem;\n}\n.dropdown-menu-rounded .dropdown-item {\n  border-radius: 30px;\n}\n.dropdown-menu-rounded .dropdown-divider {\n  margin-left: -0.65rem;\n  margin-right: -0.65rem;\n}\n.dropdown-menu-rounded .dropdown-menu-header {\n  margin-left: -0.65rem;\n  margin-right: -0.65rem;\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n}\n.dropdown-menu-rounded .menu-header-image,\n.dropdown-menu-rounded .dropdown-menu-header-inner {\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n}\n\n.dropdown-menu-hover-link .dropdown-item:hover {\n  background: none;\n  color: #545cd8;\n}\n\n.dropdown-menu-hover-primary .dropdown-item:hover {\n  background: #545cd8;\n  color: #fff;\n}\n\n.dropdown-menu.dropdown-menu-lg {\n  min-width: 22rem;\n}\n.dropdown-menu.dropdown-menu-xl {\n  min-width: 25rem;\n}\n\n.dropdown-menu .dropdown-menu-header,\n.dropdown-menu .menu-header-image,\n.dropdown-menu .dropdown-menu-header-inner {\n  border-top-left-radius: 0.25rem;\n  border-top-right-radius: 0.25rem;\n}\n\n.dropdown-menu-header {\n  color: #fff;\n  margin-top: -0.65rem;\n  margin-bottom: 0.65rem;\n  position: relative;\n  z-index: 6;\n}\n.dropdown-menu-header .dropdown-menu-header-inner {\n  margin: -1px -1px 0;\n  padding: 1.5rem 0.5rem;\n  position: relative;\n}\n.dropdown-menu-header .menu-header-image {\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n  width: 100%;\n  z-index: 8;\n  opacity: 0.25;\n  filter: grayscale(80%);\n  background-size: cover;\n}\n.dropdown-menu-header .menu-header-content {\n  text-align: center;\n  position: relative;\n  z-index: 10;\n}\n.dropdown-menu-header .menu-header-content.text-start {\n  padding-left: 0.5rem;\n}\n.dropdown-menu-header .menu-header-content.btn-pane-right {\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  display: flex;\n  align-content: center;\n  align-items: center;\n  text-align: left;\n}\n.dropdown-menu-header .menu-header-content.btn-pane-right .menu-header-btn-pane {\n  margin: 0 0 0 auto;\n}\n.dropdown-menu-header .menu-header-content .menu-header-btn-pane {\n  margin-top: 10px;\n  margin-bottom: 3px;\n}\n.dropdown-menu-header + .grid-menu {\n  margin-top: -0.65rem;\n}\n\n.menu-header-title {\n  font-weight: 500;\n  font-size: 1.1rem;\n  margin: 0;\n}\n\n.menu-header-subtitle {\n  font-size: var(--bs-font-sans-serif);\n  margin: 5px 0 0;\n  opacity: 0.8;\n}\n\n.dropdown-menu .grid-menu {\n  margin-bottom: -0.65rem;\n  padding: 1px;\n}\n.dropdown-menu .grid-menu [class*=col-] {\n  padding: 0.65rem;\n}\n.dropdown-menu .grid-menu-xl {\n  margin-bottom: -0.4814814815rem;\n}\n.dropdown-menu .grid-menu-xl [class*=col-] {\n  padding: 0;\n}\n\n.dropdown-toggle::after {\n  position: relative;\n  top: 2px;\n  opacity: 0.8;\n  margin-left: 5px;\n}\n\n.dropdown-toggle-split::after {\n  margin-left: 0;\n}\n\n.dropright .dropdown-toggle::after {\n  top: 0;\n}\n\n.dropdown-toggle-split {\n  border-left: rgba(255, 255, 255, 0.1) solid 2px;\n}\n\n.dropdown-menu::before, .dropdown-menu::after {\n  position: absolute;\n  width: 14px;\n  height: 14px;\n  left: 5px;\n  top: -5px;\n  transform: rotate(45deg);\n  border-radius: 4px;\n  content: \"\";\n  display: block;\n  z-index: 5;\n}\n.dropdown-menu::before {\n  background: #fff;\n  z-index: 5;\n}\n.dropdown-menu::after {\n  top: -6px;\n  background: rgba(0, 0, 0, 0.15);\n  z-index: 4;\n}\n.dropdown-menu[data-placement=top-start]::before, .dropdown-menu[data-placement=top-start]::after {\n  top: auto;\n  bottom: -5px;\n}\n.dropdown-menu[data-placement=top-start]::after {\n  bottom: -6px;\n}\n.dropdown-menu[data-placement=left-start]::before, .dropdown-menu[data-placement=left-start]::after {\n  left: auto;\n  right: -5px;\n  top: 5px;\n}\n.dropdown-menu[data-placement=left-start]::after {\n  top: 5px;\n  right: -6px;\n}\n.dropdown-menu[data-placement=right-start]::before, .dropdown-menu[data-placement=right-start]::after {\n  right: auto;\n  left: -5px;\n  top: 5px;\n}\n.dropdown-menu[data-placement=right-start]::after {\n  top: 5px;\n  left: -6px;\n}\n.dropdown-menu.dropdown-menu-right::before, .dropdown-menu.dropdown-menu-right::after {\n  left: auto;\n  right: 6px;\n}\n.dropdown-menu.dropdown-menu-right::after {\n  right: 6px;\n}\n.dropdown-menu.rm-pointers::before, .dropdown-menu.rm-pointers::after {\n  display: none;\n}\n\n.dropdown-mega-menu {\n  width: 56rem;\n  padding: 1rem;\n}\n.dropdown-mega-menu .nav-item.nav-item-header {\n  text-transform: none;\n  font-size: 0.88rem;\n  padding-top: 0;\n  font-weight: normal;\n}\n.dropdown-mega-menu .grid-menu {\n  margin-bottom: 0;\n}\n\n.dropdown-mega-menu-sm {\n  width: 40rem;\n}\n\nbody .dropdown-menu.dropdown-menu-inline {\n  border: 0;\n  position: static !important;\n  box-shadow: 0 0 0 transparent;\n  background: transparent;\n  border-radius: 0;\n  display: inline-block;\n  float: none;\n  left: 0 !important;\n  top: 0 !important;\n  width: 100% !important;\n  transform: translateY(0) !important;\n}\nbody .dropdown-menu.dropdown-menu-inline::before, body .dropdown-menu.dropdown-menu-inline::after {\n  display: none;\n}\n\n.nav-item .nav-link {\n  font-weight: normal;\n}\n\n.nav-link {\n  display: flex;\n  align-items: center;\n  transition: background-color 0.3s ease, color 0.3s ease;\n  cursor: pointer;\n}\n.nav-link .nav-link-icon {\n  color: #545cd8;\n  font-size: 1rem;\n  width: 30px;\n  text-align: center;\n  opacity: 0.45;\n  margin-left: -10px;\n}\n.nav-link:hover {\n  color: #495057;\n}\n.nav-link:hover .nav-link-icon {\n  opacity: 0.9;\n  color: #545cd8;\n}\n.nav-link:disabled .nav-link-icon, .nav-link.disabled .nav-link-icon {\n  opacity: 0.3;\n}\n\n.nav-item.nav-item-header {\n  text-transform: uppercase;\n  font-size: 0.7333333333rem;\n  color: #6c757d;\n  font-weight: bold;\n  padding: 0.5rem 1rem;\n}\n.nav-item.nav-item-btn {\n  padding: 0.5rem 1rem;\n}\n.nav-item.nav-item-divider {\n  margin: 0.5rem 0;\n  height: 1px;\n  overflow: hidden;\n  background: #dee2e6;\n}\n\n.nav .badge {\n  margin-left: 8px;\n}\n\n.nav-pills .nav-link.active, .nav-pills .nav-link.active:hover {\n  color: #fff;\n}\n.nav-pills .nav-link.active .nav-link-icon, .nav-pills .nav-link.active:hover .nav-link-icon {\n  color: #fff;\n  opacity: 0.8;\n}\n.nav-pills .nav-link:hover {\n  color: #495057 !important;\n}\n\n.grid-menu [class*=col-] {\n  border-right: #dee2e6 solid 0;\n  border-bottom: #dee2e6 solid 1px;\n}\n.grid-menu [class*=col-]:hover {\n  z-index: 5;\n}\n.grid-menu [class*=col-]:nth-last-child(-n+2) {\n  border-bottom-width: 0;\n}\n.grid-menu [class*=col-]:nth-child(1n) {\n  border-right-width: 1px;\n}\n.grid-menu [class*=col-]:nth-child(2n) {\n  border-right-width: 0;\n}\n.grid-menu [class*=col-]:nth-last-child(-n+1) {\n  border-bottom-width: 0;\n}\n.grid-menu.grid-menu-3col [class*=col-]:nth-last-child(-n+3) {\n  border-bottom-width: 0;\n}\n.grid-menu.grid-menu-3col [class*=col-]:nth-child(2n) {\n  border-right-width: 1px;\n}\n.grid-menu.grid-menu-3col [class*=col-]:nth-child(3n) {\n  border-right-width: 0;\n}\n.grid-menu .btn {\n  display: block;\n  border: 0;\n  min-width: 100%;\n}\n\n.badge {\n  font-weight: bold;\n  text-transform: uppercase;\n  padding: 5px 10px;\n  min-width: 19px;\n}\n\n.badge-light {\n  background: #fff;\n}\n\n.badge-dot {\n  text-indent: -999em;\n  padding: 0;\n  width: 8px;\n  height: 8px;\n  border: transparent solid 1px;\n  border-radius: 30px;\n  min-width: 2px;\n}\n\n.badge-dot-lg {\n  width: 10px;\n  height: 10px;\n}\n\n.badge-dot-xl {\n  width: 18px;\n  height: 18px;\n  position: relative;\n}\n.badge-dot-xl::before {\n  content: \"\";\n  width: 10px;\n  height: 10px;\n  border-radius: 0.25rem;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  margin: -5px 0 0 -5px;\n  background: #fff;\n}\n\n.badge-dot-sm {\n  width: 6px;\n  height: 6px;\n}\n\n.btn .badge {\n  margin-left: 8px;\n}\n.btn .badge-dot {\n  position: absolute;\n  border: #fff solid 2px;\n  top: -5px;\n  right: -5px;\n  width: 11px;\n  height: 11px;\n}\n.btn .badge-dot.badge-dot-lg {\n  width: 14px;\n  height: 14px;\n}\n.btn .badge-dot.badge-dot-sm {\n  width: 8px;\n  height: 8px;\n  border-width: 1px;\n}\n.btn .badge-dot-inside {\n  top: 10px;\n  right: 10px;\n}\n\n.btn-sm .badge-dot-sm, .btn-group-sm > .btn .badge-dot-sm {\n  top: 1px;\n  right: 4px;\n}\n.btn-sm .badge-dot, .btn-group-sm > .btn .badge-dot {\n  top: 0px;\n  right: 2px;\n}\n.btn-sm .badge-dot-lg, .btn-group-sm > .btn .badge-dot-lg {\n  top: -3px;\n  right: -2px;\n}\n.btn-sm .rounded-pill, .btn-group-sm > .btn .rounded-pill {\n  position: absolute;\n  top: -4px;\n  right: -4px;\n}\n\n.badge-abs {\n  position: absolute;\n  right: -3px;\n  top: -3px;\n}\n\n.avatar-icon-wrapper {\n  display: inline-block;\n  margin-right: 0.1rem;\n  position: relative;\n}\n.avatar-icon-wrapper .badge {\n  position: absolute;\n  right: -2px;\n  top: -2px;\n}\n.avatar-icon-wrapper .badge:empty {\n  display: block;\n}\n.avatar-icon-wrapper .badge.badge-bottom {\n  top: auto;\n  right: -2px;\n  bottom: -2px;\n}\n.avatar-icon-wrapper .badge-dot {\n  width: 10px;\n  height: 10px;\n  border: #fff solid 2px;\n}\n.avatar-icon-wrapper .badge-dot.badge-dot-lg {\n  width: 14px;\n  height: 14px;\n  border: #fff solid 2px;\n  top: 0;\n  right: 0;\n}\n.avatar-icon-wrapper .badge-dot.badge-dot-lg.badge-bottom {\n  top: auto;\n  right: 0;\n  bottom: 0;\n}\n\n.avatar-icon-add .avatar-icon {\n  background: #e0f3ff;\n  border: rgb(146.2928571429, 151.3785714286, 230.2071428571) dashed 1px;\n  color: #545cd8;\n  text-align: center;\n  opacity: 0.6;\n}\n.avatar-icon-add .avatar-icon i {\n  font-style: normal;\n  vertical-align: middle;\n  font-size: 1.32rem;\n  display: block;\n  height: 100%;\n}\n.avatar-icon-add:hover {\n  cursor: pointer;\n}\n.avatar-icon-add:hover .avatar-icon {\n  opacity: 1;\n}\n\na.avatar-icon-wrapper:hover .avatar-icon {\n  opacity: 0.8;\n}\n\n.avatar-icon {\n  display: block;\n  width: 44px;\n  height: 44px;\n  transition: all 0.2s;\n  opacity: 1;\n  border-radius: 50px;\n}\n.avatar-icon.rounded {\n  border-radius: 0.39rem !important;\n}\n\n.avatar-icon-xl .avatar-icon {\n  width: 64px;\n  height: 64px;\n}\n.avatar-icon-xl.avatar-icon-add i {\n  font-size: 1.76rem;\n}\n\n.avatar-icon-lg .avatar-icon {\n  width: 54px;\n  height: 54px;\n}\n.avatar-icon-lg.avatar-icon-add i {\n  font-size: 1.54rem;\n}\n\n.avatar-icon-sm .avatar-icon {\n  width: 34px;\n  height: 34px;\n}\n.avatar-icon-sm.avatar-icon-add i {\n  font-size: 1.1rem;\n}\n\n.avatar-icon-xs .avatar-icon {\n  width: 26px;\n  height: 26px;\n  transition: transform 0.2s;\n}\n.avatar-icon-xs.avatar-icon-add i {\n  line-height: 26px;\n  font-size: 0.88rem;\n}\n.avatar-icon-xs:hover .avatar-icon {\n  transform: scale(2);\n}\n\n.avatar-icon {\n  border: #fff solid 3px;\n  overflow: hidden;\n}\n.avatar-icon img {\n  width: 100%;\n  height: 100%;\n}\n\n.avatar-wrapper-overlap .avatar-icon-wrapper {\n  z-index: 5;\n  margin-left: -18px;\n}\n.avatar-wrapper-overlap .avatar-icon-wrapper:hover {\n  z-index: 7;\n}\n.avatar-wrapper-overlap .avatar-icon-wrapper.avatar-icon-xl {\n  margin-left: -30px;\n}\n.avatar-wrapper-overlap .avatar-icon-wrapper.avatar-icon-lg {\n  margin-left: -24px;\n}\n.avatar-wrapper-overlap .avatar-icon-wrapper.avatar-icon-sm {\n  margin-left: -14px;\n}\n.avatar-wrapper-overlap .avatar-icon-wrapper.avatar-icon-xs {\n  margin-left: -10px;\n}\n.avatar-wrapper-overlap .avatar-icon-wrapper.avatar-icon-add, .avatar-wrapper-overlap .avatar-icon-wrapper:first-child {\n  margin-left: 0 !important;\n}\n\n@-webkit-keyframes sploosh {\n  0% {\n    box-shadow: 0 0 0 0px rgba(51, 51, 51, 0.2);\n  }\n  100% {\n    box-shadow: 0 0 0 8px rgba(51, 51, 51, 0);\n  }\n}\n@-webkit-keyframes pulse {\n  0% {\n    -webkit-transform: scale(1);\n  }\n  16.5% {\n    -webkit-transform: scale(1.2);\n  }\n  33% {\n    -webkit-transform: scale(1.1);\n  }\n  100% {\n    -webkit-transform: scale(1);\n  }\n}\n.badge-pulse {\n  -webkit-animation: pulse 2s ease-out;\n  -webkit-animation-iteration-count: infinite;\n  position: relative;\n}\n.badge-pulse::before, .badge-pulse::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  border: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  -webkit-animation: sploosh 2s cubic-bezier(0.165, 0.84, 0.44, 1);\n  -webkit-animation-iteration-count: infinite;\n}\n.badge-pulse::after {\n  -webkit-animation-delay: 0.33s;\n  -webkit-animation-duration: 2.2s;\n}\n\n.card {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);\n  border-width: 0;\n  transition: all 0.2s;\n}\n.card > .dropdown-menu-header {\n  margin: 0;\n}\n.card > .dropdown-menu-header .dropdown-menu-header-inner {\n  border-top-left-radius: 0.25rem;\n  border-top-right-radius: 0.25rem;\n}\n.card.text-dark.text-white .card-footer,\n.card.text-dark.text-white .card-header, .card.text-white .card-footer,\n.card.text-white .card-header {\n  background: rgba(255, 255, 255, 0.1);\n  color: rgba(255, 255, 255, 0.9);\n}\n.card.text-dark.text-white .card-footer,\n.card.text-dark.text-white .card-header {\n  color: rgba(0, 0, 0, 0.9);\n}\n.card .card-footer {\n  display: flex;\n  align-items: center;\n}\n\n.btn-actions-pane-right {\n  margin-left: auto;\n  white-space: nowrap;\n}\n\n.btn-actions-pane-left {\n  margin-right: auto;\n}\n\n.actions-icon-btn .btn-icon-only {\n  padding-left: 0;\n  padding-right: 0;\n  color: #495057;\n}\n.actions-icon-btn .btn-icon-only .btn-icon-wrapper {\n  font-size: 1.3rem;\n  width: 30px;\n  text-align: center;\n}\n.actions-icon-btn .btn-icon-only:hover {\n  color: #545cd8;\n}\n\n.card-header,\n.card-title {\n  text-transform: uppercase;\n  color: rgba(17.8285714286, 21.4857142857, 78.1714285714, 0.7);\n  font-weight: bold;\n  font-size: 0.88rem;\n}\n\n.card-header {\n  display: flex;\n  align-items: center;\n  border-bottom-width: 1px;\n  padding-top: 0;\n  padding-bottom: 0;\n  padding-right: 0.5rem;\n  height: 3.5rem;\n}\n.card-header.no-border {\n  border: 0;\n  padding: 0;\n  height: auto;\n}\n.card-header .menu-header-subtitle {\n  display: block;\n}\n.card-header.card-header-tab .nav {\n  width: auto;\n  margin-left: auto;\n}\n.card-header.card-header-tab .card-header-title {\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n}\n.card-header .header-icon {\n  font-size: 1.65rem;\n  margin-right: 0.5rem;\n}\n.card-header > .nav {\n  margin-left: -0.5rem;\n  height: 100%;\n  width: 100%;\n}\n.card-header > .nav .nav-item {\n  position: relative;\n  height: 100%;\n  display: flex;\n  align-items: center;\n}\n.card-header > .nav .nav-link {\n  text-transform: none;\n  width: 100%;\n  display: block;\n  color: #495057;\n}\n.card-header > .nav .nav-link::before {\n  content: \"\";\n  border-radius: 15px;\n  background: #545cd8;\n  transition: all 0.2s;\n  height: 4px;\n  width: 100%;\n  position: absolute;\n  left: 0;\n  bottom: -2px;\n  opacity: 0;\n}\n.card-header > .nav .nav-link:hover {\n  color: #545cd8;\n}\n.card-header > .nav .nav-link.active {\n  color: #545cd8;\n}\n.card-header > .nav .nav-link.active::before {\n  opacity: 1;\n}\n.card-header.card-header-tab-animation .nav .nav-link::before {\n  transform: scale(0);\n  opacity: 1;\n  width: 90%;\n  left: 5%;\n}\n.card-header.card-header-tab-animation .nav .nav-link.active::before, .card-header.card-header-tab-animation .nav .nav-link:hover::before {\n  transform: scale(1);\n}\n\n.card-border {\n  box-shadow: 0 0 0 transparent;\n  border-width: 1px;\n}\n\n.card-hover-shadow:hover {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);\n}\n\n.card-hover-shadow-2x:hover {\n  box-shadow: 0 0.66875rem 2.3875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 1.1375rem 1.60625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.45rem 0.73125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.325rem 0.3875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);\n}\n\n.card-subtitle {\n  margin-bottom: 1rem;\n  font-size: 0.968rem;\n  color: rgba(17.8285714286, 21.4857142857, 78.1714285714, 0.55);\n}\n\n.card-shadow-primary {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(84, 92, 216, 0.03), 0 0.9375rem 1.40625rem rgba(84, 92, 216, 0.03), 0 0.25rem 0.53125rem rgba(84, 92, 216, 0.05), 0 0.125rem 0.1875rem rgba(84, 92, 216, 0.03);\n}\n\n.card-shadow-secondary {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(108, 117, 125, 0.03), 0 0.9375rem 1.40625rem rgba(108, 117, 125, 0.03), 0 0.25rem 0.53125rem rgba(108, 117, 125, 0.05), 0 0.125rem 0.1875rem rgba(108, 117, 125, 0.03);\n}\n\n.card-shadow-success {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(58, 196, 125, 0.03), 0 0.9375rem 1.40625rem rgba(58, 196, 125, 0.03), 0 0.25rem 0.53125rem rgba(58, 196, 125, 0.05), 0 0.125rem 0.1875rem rgba(58, 196, 125, 0.03);\n}\n\n.card-shadow-info {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(48, 177, 255, 0.03), 0 0.9375rem 1.40625rem rgba(48, 177, 255, 0.03), 0 0.25rem 0.53125rem rgba(48, 177, 255, 0.05), 0 0.125rem 0.1875rem rgba(48, 177, 255, 0.03);\n}\n\n.card-shadow-warning {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(247, 185, 36, 0.03), 0 0.9375rem 1.40625rem rgba(247, 185, 36, 0.03), 0 0.25rem 0.53125rem rgba(247, 185, 36, 0.05), 0 0.125rem 0.1875rem rgba(247, 185, 36, 0.03);\n}\n\n.card-shadow-danger {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(217, 37, 80, 0.03), 0 0.9375rem 1.40625rem rgba(217, 37, 80, 0.03), 0 0.25rem 0.53125rem rgba(217, 37, 80, 0.05), 0 0.125rem 0.1875rem rgba(217, 37, 80, 0.03);\n}\n\n.card-shadow-light {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(238, 238, 238, 0.03), 0 0.9375rem 1.40625rem rgba(238, 238, 238, 0.03), 0 0.25rem 0.53125rem rgba(238, 238, 238, 0.05), 0 0.125rem 0.1875rem rgba(238, 238, 238, 0.03);\n}\n\n.card-shadow-dark {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(52, 58, 64, 0.03), 0 0.9375rem 1.40625rem rgba(52, 58, 64, 0.03), 0 0.25rem 0.53125rem rgba(52, 58, 64, 0.05), 0 0.125rem 0.1875rem rgba(52, 58, 64, 0.03);\n}\n\n.card-shadow-focus {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(68, 64, 84, 0.03), 0 0.9375rem 1.40625rem rgba(68, 64, 84, 0.03), 0 0.25rem 0.53125rem rgba(68, 64, 84, 0.05), 0 0.125rem 0.1875rem rgba(68, 64, 84, 0.03);\n}\n\n.card-shadow-alternate {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(131, 88, 138, 0.03), 0 0.9375rem 1.40625rem rgba(131, 88, 138, 0.03), 0 0.25rem 0.53125rem rgba(131, 88, 138, 0.05), 0 0.125rem 0.1875rem rgba(131, 88, 138, 0.03);\n}\n\n.card-header-lg {\n  padding: 2rem 2rem;\n  height: auto;\n}\n\n.sticky-active-class .sticky-inner-wrapper > div {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);\n}\n\n.nav-pills,\n.nav-tabs {\n  margin-bottom: 1rem;\n}\n\n.nav-link {\n  font-weight: bold;\n}\n.nav-link:hover {\n  cursor: pointer;\n}\n\n.nav-tabs .nav-link:hover {\n  color: #545cd8 !important;\n}\n.nav-tabs .nav-link.active {\n  color: #545cd8;\n}\n\n.nav-pills .nav-link:hover {\n  color: #545cd8 !important;\n}\n.nav-pills .nav-link.active {\n  background: #545cd8;\n}\n.nav-pills .nav-link.active:hover {\n  color: #fff !important;\n}\n\n.RRT__container {\n  position: relative;\n}\n\n.RRT__tabs {\n  display: flex;\n  flex-wrap: wrap;\n  position: relative;\n}\n\n.RRT__accordion {\n  flex-direction: column;\n}\n\n.RRT__tab {\n  cursor: pointer;\n  z-index: 1;\n  white-space: nowrap;\n  padding: 0.5rem 1rem;\n  transition: all 0.2s;\n}\n.RRT__tab:hover {\n  color: #545cd8;\n}\n.RRT__tab:focus {\n  outline: 0;\n}\n\n.RRT__tab--selected {\n  color: #545cd8;\n}\n\n.RRT__tab--disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.RRT__tab:focus {\n  z-index: 2;\n}\n\n.RRT__tab--selected .RRT__removable {\n  position: relative;\n}\n\n.RRT__tab--selected .RRT__removable-text {\n  margin-right: 10px;\n}\n\n.RRT__tab--selected .RRT__removable-icon {\n  position: absolute;\n  font-size: 18px;\n  right: 0.5em;\n  top: 0.2em;\n}\n\n.body-tabs.body-tabs-layout.body-tabs-big {\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  margin: 0 auto;\n  padding: 10px;\n  border-radius: 50px;\n  border: #e9ecef solid 1px;\n  z-index: 7;\n}\n.body-tabs.body-tabs-layout.body-tabs-big .RRT__tab {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 300;\n  padding: 0;\n  height: 50px;\n  line-height: 50px;\n  flex: 1;\n  text-align: center;\n  position: relative;\n  color: #545cd8;\n}\n.body-tabs.body-tabs-layout.body-tabs-big .RRT__tab:hover {\n  color: #212529;\n}\n.body-tabs.body-tabs-layout.body-tabs-big .RRT__tab.RRT__tab--selected {\n  color: #fff;\n}\n.body-tabs.body-tabs-layout.body-tabs-big .RRT__tab.RRT__tab--selected:hover {\n  color: #fff;\n}\n.body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper {\n  height: 70px !important;\n  top: -70px !important;\n  margin: 0 auto -3.4rem;\n  position: relative;\n  padding: 0 10px;\n}\n.body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper::before {\n  position: absolute;\n  content: \"\";\n  background: #fff;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: -11px;\n  border-radius: 50px;\n}\n.body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper .RRT__inkbar {\n  height: 50px !important;\n  margin-top: 10px;\n  border-radius: 50px;\n  box-shadow: 0 0 0 transparent;\n}\n.body-tabs.body-tabs-layout.body-tabs-big + .RRT__inkbar-wrapper + .RRT__panel {\n  margin-top: -1rem;\n}\n\n.RRT__panel {\n  margin-top: 1rem;\n}\n\n.RRT__showmore {\n  border-radius: 0.25rem;\n  background: #545cd8;\n  cursor: pointer;\n  z-index: 1;\n  white-space: nowrap;\n  font-weight: bold;\n  width: 36px;\n  text-align: center;\n  height: 36px;\n  display: block;\n  margin-left: 15px;\n  position: absolute;\n  right: 1.5rem;\n  top: 50%;\n  margin-top: -18px;\n  font-size: 1.4rem;\n}\n.RRT__showmore:focus {\n  outline: none;\n}\n\n.RRT__showmore-label {\n  position: relative;\n  z-index: 1;\n  color: #fff;\n  width: 36px;\n  text-align: center;\n  height: 36px;\n  line-height: 24px;\n}\n\n.RRT__showmore--selected {\n  box-shadow: 0 16px 26px -10px rgba(84, 92, 216, 0.56), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(84, 92, 216, 0.2);\n}\n\n.RRT__showmore-list {\n  position: absolute;\n  right: -1px;\n  top: 100%;\n  display: none;\n  min-width: 15rem;\n  padding: 0.65rem 0;\n  margin: 0.125rem 0 0;\n  font-size: 0.88rem;\n  color: #495057;\n  text-align: left;\n  list-style: none;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.25rem;\n  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);\n}\n.RRT__showmore-list .RRT__tab {\n  display: block;\n  width: 100%;\n  padding: 0.4rem 1rem;\n  clear: both;\n  font-weight: 400;\n  color: #212529;\n  text-align: inherit;\n  white-space: nowrap;\n  background-color: transparent;\n  border: 0;\n  margin: 0;\n}\n.RRT__showmore-list .RRT__tab:hover, .RRT__showmore-list .RRT__tab.RRT__tab--selected {\n  color: rgb(29.7, 33.3, 36.9) !important;\n  text-decoration: none;\n  background: #e0f3ff;\n}\n\n.RRT__showmore-list--opened {\n  display: block;\n}\n.RRT__showmore-list--opened .RRT__tab--selected {\n  color: #545cd8;\n}\n\n.RRT__inkbar-wrapper {\n  width: 100%;\n}\n\n.RRT__inkbar {\n  position: relative;\n  bottom: 0;\n  height: 3px;\n  margin-top: -3px;\n  background-color: #545cd8;\n  border-radius: 15px;\n  transition: all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1) 0s;\n  z-index: 2;\n}\n\n.card-tabs .card-header {\n  padding: 0 1.25rem;\n}\n.card-tabs .card-header.RRT__tabs {\n  cursor: pointer;\n  font-weight: normal;\n}\n.card-tabs .card-header.RRT__tabs .RRT__tab {\n  text-transform: none;\n  line-height: 1.3;\n}\n.card-tabs .RRT__inkbar-wrapper {\n  width: calc(100% - 1.5rem) !important;\n  margin-left: 1.25rem;\n}\n.card-tabs .RRT__panel {\n  padding: 1rem;\n  margin: 0;\n}\n.card-tabs.text-white .RRT__tab {\n  color: rgba(255, 255, 255, 0.6);\n}\n.card-tabs.text-white .RRT__tab:hover {\n  color: #fff;\n}\n.card-tabs.text-white .RRT__tab--selected {\n  color: #fff;\n}\n.card-tabs.text-white .RRT__inkbar {\n  background: rgb(250.1142857143, 250.3428571429, 253.8857142857);\n}\n\n.card-tabs-animated .RRT__container > .RRT__tabs {\n  background: transparent;\n  position: relative;\n  z-index: 7;\n}\n.card-tabs-animated .RRT__container > .RRT__tabs.card-header {\n  border-bottom: 0;\n  height: auto;\n  padding: 1.5rem 1.5rem 0.5rem;\n}\n.card-tabs-animated .RRT__inkbar-wrapper {\n  position: absolute;\n  top: 1.5rem;\n  z-index: 5;\n}\n.card-tabs-animated .RRT__tab {\n  padding: 0.5rem 1.2rem;\n}\n.card-tabs-animated .RRT__tab--selected {\n  color: #fff;\n}\n.card-tabs-animated .RRT__inkbar {\n  height: 35px;\n  margin-top: 0;\n  border-radius: 0.25rem;\n  box-shadow: 0 16px 26px -10px rgba(84, 92, 216, 0.56), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(84, 92, 216, 0.2);\n}\n\n.card-tabs-animated-inner .RRT__tabs {\n  padding: 0 5%;\n}\n.card-tabs-animated-inner .RRT__inkbar-wrapper {\n  left: 5%;\n  width: 90%;\n  height: 36px;\n  top: 14px;\n}\n.card-tabs-animated-inner .RRT__inkbar {\n  height: 36px;\n}\n\n.body-tabs {\n  border-bottom: #dee2e6 solid 2px;\n}\n.body-tabs > .RRT__tab {\n  padding: 1rem 1.25rem;\n  font-weight: normal;\n  font-size: 0.88rem;\n}\n.body-tabs.body-tabs-alt > .RRT__tab {\n  padding: 1.3636363636rem 0.5rem;\n  font-weight: normal;\n  font-size: 0.86rem;\n  width: 33%;\n  text-align: center;\n}\n.body-tabs.body-tabs-alt .RRT__inkbar {\n  height: 2px;\n  margin-top: -2px;\n}\n\n.popover .RRT__panel,\n.dropdown-menu .RRT__panel {\n  margin: 0;\n  padding: 0;\n  position: relative;\n}\n.popover .RRT__panel::after, .popover .RRT__panel::before,\n.dropdown-menu .RRT__panel::after,\n.dropdown-menu .RRT__panel::before {\n  width: 100%;\n  bottom: auto;\n  top: 0;\n  left: 0;\n  height: 20px;\n  position: absolute;\n  z-index: 10;\n  content: \"\";\n  background: linear-gradient(to bottom, rgb(255, 255, 255) 20%, rgba(255, 255, 255, 0) 100%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#ffffff\", endColorstr=\"#00ffffff\", GradientType=0);\n}\n.popover .RRT__panel::after,\n.dropdown-menu .RRT__panel::after {\n  bottom: 0;\n  top: auto;\n  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgb(255, 255, 255) 80%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#00ffffff\", endColorstr=\"#ffffff\", GradientType=0);\n}\n\n.tabs-lg-alternate.card-header {\n  padding: 0;\n  height: auto;\n}\n.tabs-lg-alternate.card-header .widget-number {\n  font-size: 1.76rem;\n  font-weight: 300;\n}\n.tabs-lg-alternate.card-header .tab-subheading {\n  padding: 5px 0 0;\n  opacity: 0.6;\n  transition: all 0.2s;\n}\n.tabs-lg-alternate.card-header > .nav {\n  margin: 0;\n}\n.tabs-lg-alternate.card-header > .nav .nav-link {\n  padding: 1.5rem 0;\n  border-right: #e9ecef solid 1px;\n  background: #f8f9fa;\n}\n.tabs-lg-alternate.card-header > .nav .nav-link:hover {\n  background: #fff;\n}\n.tabs-lg-alternate.card-header > .nav .nav-link:hover .tab-subheading {\n  color: #000;\n  opacity: 0.9;\n}\n.tabs-lg-alternate.card-header > .nav .nav-link::before {\n  background: #fff;\n  border-radius: 0;\n}\n.tabs-lg-alternate.card-header > .nav .nav-link.active {\n  background: #fff;\n}\n.tabs-lg-alternate.card-header > .nav .nav-link.active .tab-subheading {\n  color: #000;\n  opacity: 0.9;\n}\n.tabs-lg-alternate.card-header > .nav .nav-item:last-child .nav-link {\n  border-right: 0;\n}\n\n.accordion-wrapper {\n  border-radius: 0.25rem;\n  border: #e9ecef solid 1px;\n}\n.accordion-wrapper > .card {\n  box-shadow: 0 0 0 0 transparent;\n}\n.accordion-wrapper > .card > .card-header {\n  padding: 1rem;\n  height: auto;\n}\n.accordion-wrapper > .card > .card-header .btn:active,\n.accordion-wrapper > .card > .card-header .btn:focus,\n.accordion-wrapper > .card > .card-header .btn:hover {\n  text-decoration: none;\n}\n.accordion-wrapper > .card > .card-header .form-heading p {\n  margin: 0;\n}\n.accordion-wrapper > .card .collapse {\n  border-bottom: transparent solid 1px;\n}\n.accordion-wrapper > .card .collapse.show {\n  border-bottom-color: #e9ecef;\n}\n\n.modal-header,\n.modal-footer {\n  background: #f8f9fa;\n}\n\n.modal-footer {\n  border-bottom-right-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n\n.modal-dialog {\n  box-shadow: 0 0.76875rem 2.4875rem rgba(52, 58, 64, 0.3), 0 1.3375rem 1.70625rem rgba(52, 58, 64, 0.3), 0 0.55rem 0.53125rem rgba(0, 0, 0, 0.05), 0 0.225rem 0.4375rem rgba(52, 58, 64, 0.3);\n  border-radius: 0.25rem;\n}\n\n/**\n * Dots\n */\n@keyframes scale {\n  0% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  45% {\n    transform: scale(0.1);\n    opacity: 0.7;\n  }\n  80% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n.ball-pulse > div:nth-child(0) {\n  animation: scale 0.75s -0.36s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n}\n.ball-pulse > div:nth-child(1) {\n  animation: scale 0.75s -0.24s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n}\n.ball-pulse > div:nth-child(2) {\n  animation: scale 0.75s -0.12s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n}\n.ball-pulse > div:nth-child(3) {\n  animation: scale 0.75s 0s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n}\n.ball-pulse > div {\n  background-color: #545cd8;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  animation-fill-mode: both;\n  display: inline-block;\n}\n\n@keyframes ball-pulse-sync {\n  33% {\n    transform: translateY(10px);\n  }\n  66% {\n    transform: translateY(-10px);\n  }\n  100% {\n    transform: translateY(0);\n  }\n}\n.ball-pulse-sync > div:nth-child(0) {\n  animation: ball-pulse-sync 0.6s -0.21s infinite ease-in-out;\n}\n.ball-pulse-sync > div:nth-child(1) {\n  animation: ball-pulse-sync 0.6s -0.14s infinite ease-in-out;\n}\n.ball-pulse-sync > div:nth-child(2) {\n  animation: ball-pulse-sync 0.6s -0.07s infinite ease-in-out;\n}\n.ball-pulse-sync > div:nth-child(3) {\n  animation: ball-pulse-sync 0.6s 0s infinite ease-in-out;\n}\n.ball-pulse-sync > div {\n  background-color: #545cd8;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  animation-fill-mode: both;\n  display: inline-block;\n}\n\n@keyframes ball-scale {\n  0% {\n    transform: scale(0);\n  }\n  100% {\n    transform: scale(1);\n    opacity: 0;\n  }\n}\n.ball-scale > div {\n  background-color: #545cd8;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  animation-fill-mode: both;\n  display: inline-block;\n  height: 60px;\n  width: 60px;\n  animation: ball-scale 1s 0s ease-in-out infinite;\n}\n\n@keyframes rotate {\n  0% {\n    transform: rotate(0deg);\n  }\n  50% {\n    transform: rotate(180deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.ball-rotate {\n  position: relative;\n}\n.ball-rotate > div {\n  background-color: #545cd8;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  animation-fill-mode: both;\n  position: relative;\n}\n.ball-rotate > div:first-child {\n  animation: rotate 1s 0s cubic-bezier(0.7, -0.13, 0.22, 0.86) infinite;\n}\n.ball-rotate > div:before, .ball-rotate > div:after {\n  background-color: #545cd8;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  content: \"\";\n  position: absolute;\n  opacity: 0.8;\n}\n.ball-rotate > div:before {\n  top: 0px;\n  left: -28px;\n}\n.ball-rotate > div:after {\n  top: 0px;\n  left: 25px;\n}\n\n@keyframes rotate {\n  0% {\n    transform: rotate(0deg) scale(1);\n  }\n  50% {\n    transform: rotate(180deg) scale(0.6);\n  }\n  100% {\n    transform: rotate(360deg) scale(1);\n  }\n}\n.ball-clip-rotate > div {\n  background-color: #545cd8;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  animation-fill-mode: both;\n  border: 2px solid #545cd8;\n  border-bottom-color: transparent;\n  height: 25px;\n  width: 25px;\n  background: transparent !important;\n  display: inline-block;\n  animation: rotate 0.75s 0s linear infinite;\n}\n\n@keyframes rotate {\n  0% {\n    transform: rotate(0deg) scale(1);\n  }\n  50% {\n    transform: rotate(180deg) scale(0.6);\n  }\n  100% {\n    transform: rotate(360deg) scale(1);\n  }\n}\n@keyframes scale {\n  30% {\n    transform: scale(0.3);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n.ball-clip-rotate-pulse {\n  position: relative;\n  transform: translateY(-15px);\n}\n.ball-clip-rotate-pulse > div {\n  animation-fill-mode: both;\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  border-radius: 100%;\n}\n.ball-clip-rotate-pulse > div:first-child {\n  background: #545cd8;\n  height: 16px;\n  width: 16px;\n  top: 7px;\n  left: -7px;\n  animation: scale 1s 0s cubic-bezier(0.09, 0.57, 0.49, 0.9) infinite;\n}\n.ball-clip-rotate-pulse > div:last-child {\n  position: absolute;\n  border: 2px solid #545cd8;\n  width: 30px;\n  height: 30px;\n  left: -16px;\n  top: -2px;\n  background: transparent;\n  border: 2px solid;\n  border-color: #545cd8 transparent #545cd8 transparent;\n  animation: rotate 1s 0s cubic-bezier(0.09, 0.57, 0.49, 0.9) infinite;\n  animation-duration: 1s;\n}\n\n@keyframes rotate {\n  0% {\n    transform: rotate(0deg) scale(1);\n  }\n  50% {\n    transform: rotate(180deg) scale(0.6);\n  }\n  100% {\n    transform: rotate(360deg) scale(1);\n  }\n}\n.ball-clip-rotate-multiple {\n  position: relative;\n}\n.ball-clip-rotate-multiple > div {\n  animation-fill-mode: both;\n  position: absolute;\n  left: -20px;\n  top: -20px;\n  border: 2px solid #545cd8;\n  border-bottom-color: transparent;\n  border-top-color: transparent;\n  border-radius: 100%;\n  height: 35px;\n  width: 35px;\n  animation: rotate 1s 0s ease-in-out infinite;\n}\n.ball-clip-rotate-multiple > div:last-child {\n  display: inline-block;\n  top: -10px;\n  left: -10px;\n  width: 15px;\n  height: 15px;\n  animation-duration: 0.5s;\n  border-color: #545cd8 transparent #545cd8 transparent;\n  animation-direction: reverse;\n}\n\n@keyframes ball-scale-ripple {\n  0% {\n    transform: scale(0.1);\n    opacity: 1;\n  }\n  70% {\n    transform: scale(1);\n    opacity: 0.7;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n.ball-scale-ripple > div {\n  animation-fill-mode: both;\n  height: 50px;\n  width: 50px;\n  border-radius: 100%;\n  border: 2px solid #545cd8;\n  animation: ball-scale-ripple 1s 0s infinite cubic-bezier(0.21, 0.53, 0.56, 0.8);\n}\n\n@keyframes ball-scale-ripple-multiple {\n  0% {\n    transform: scale(0.1);\n    opacity: 1;\n  }\n  70% {\n    transform: scale(1);\n    opacity: 0.7;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n.ball-scale-ripple-multiple {\n  position: relative;\n  transform: translateY(-25px);\n}\n.ball-scale-ripple-multiple > div:nth-child(0) {\n  animation-delay: -0.8s;\n}\n.ball-scale-ripple-multiple > div:nth-child(1) {\n  animation-delay: -0.6s;\n}\n.ball-scale-ripple-multiple > div:nth-child(2) {\n  animation-delay: -0.4s;\n}\n.ball-scale-ripple-multiple > div:nth-child(3) {\n  animation-delay: -0.2s;\n}\n.ball-scale-ripple-multiple > div {\n  animation-fill-mode: both;\n  position: absolute;\n  top: -2px;\n  left: -26px;\n  width: 50px;\n  height: 50px;\n  border-radius: 100%;\n  border: 2px solid #545cd8;\n  animation: ball-scale-ripple-multiple 1.25s 0s infinite cubic-bezier(0.21, 0.53, 0.56, 0.8);\n}\n\n@keyframes ball-beat {\n  50% {\n    opacity: 0.2;\n    transform: scale(0.75);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n.ball-beat > div {\n  background-color: #545cd8;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  animation-fill-mode: both;\n  display: inline-block;\n  animation: ball-beat 0.7s 0s infinite linear;\n}\n.ball-beat > div:nth-child(2n-1) {\n  animation-delay: -0.35s !important;\n}\n\n@keyframes ball-scale-multiple {\n  0% {\n    transform: scale(0);\n    opacity: 0;\n  }\n  5% {\n    opacity: 1;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 0;\n  }\n}\n.ball-scale-multiple {\n  position: relative;\n  transform: translateY(-30px);\n}\n.ball-scale-multiple > div:nth-child(2) {\n  animation-delay: -0.4s;\n}\n.ball-scale-multiple > div:nth-child(3) {\n  animation-delay: -0.2s;\n}\n.ball-scale-multiple > div {\n  background-color: #545cd8;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  animation-fill-mode: both;\n  position: absolute;\n  left: -30px;\n  top: 0px;\n  opacity: 0;\n  margin: 0;\n  width: 60px;\n  height: 60px;\n  animation: ball-scale-multiple 1s 0s linear infinite;\n}\n\n@keyframes ball-triangle-path-1 {\n  33% {\n    transform: translate(25px, -50px);\n  }\n  66% {\n    transform: translate(50px, 0px);\n  }\n  100% {\n    transform: translate(0px, 0px);\n  }\n}\n@keyframes ball-triangle-path-2 {\n  33% {\n    transform: translate(25px, 50px);\n  }\n  66% {\n    transform: translate(-25px, 50px);\n  }\n  100% {\n    transform: translate(0px, 0px);\n  }\n}\n@keyframes ball-triangle-path-3 {\n  33% {\n    transform: translate(-50px, 0px);\n  }\n  66% {\n    transform: translate(-25px, -50px);\n  }\n  100% {\n    transform: translate(0px, 0px);\n  }\n}\n.ball-triangle-path {\n  position: relative;\n  transform: translate(-29.9940011998px, -37.5093773443px);\n}\n.ball-triangle-path > div:nth-child(1) {\n  animation-name: ball-triangle-path-1;\n  animation-delay: 0;\n  animation-duration: 2s;\n  animation-timing-function: ease-in-out;\n  animation-iteration-count: infinite;\n}\n.ball-triangle-path > div:nth-child(2) {\n  animation-name: ball-triangle-path-2;\n  animation-delay: 0;\n  animation-duration: 2s;\n  animation-timing-function: ease-in-out;\n  animation-iteration-count: infinite;\n}\n.ball-triangle-path > div:nth-child(3) {\n  animation-name: ball-triangle-path-3;\n  animation-delay: 0;\n  animation-duration: 2s;\n  animation-timing-function: ease-in-out;\n  animation-iteration-count: infinite;\n}\n.ball-triangle-path > div {\n  animation-fill-mode: both;\n  position: absolute;\n  width: 10px;\n  height: 10px;\n  border-radius: 100%;\n  border: 1px solid #545cd8;\n}\n.ball-triangle-path > div:nth-of-type(1) {\n  top: 50px;\n}\n.ball-triangle-path > div:nth-of-type(2) {\n  left: 25px;\n}\n.ball-triangle-path > div:nth-of-type(3) {\n  top: 50px;\n  left: 50px;\n}\n\n@keyframes ball-pulse-rise-even {\n  0% {\n    transform: scale(1.1);\n  }\n  25% {\n    transform: translateY(-30px);\n  }\n  50% {\n    transform: scale(0.4);\n  }\n  75% {\n    transform: translateY(30px);\n  }\n  100% {\n    transform: translateY(0);\n    transform: scale(1);\n  }\n}\n@keyframes ball-pulse-rise-odd {\n  0% {\n    transform: scale(0.4);\n  }\n  25% {\n    transform: translateY(30px);\n  }\n  50% {\n    transform: scale(1.1);\n  }\n  75% {\n    transform: translateY(-30px);\n  }\n  100% {\n    transform: translateY(0);\n    transform: scale(0.75);\n  }\n}\n.ball-pulse-rise > div {\n  background-color: #545cd8;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  animation-fill-mode: both;\n  display: inline-block;\n  animation-duration: 1s;\n  animation-timing-function: cubic-bezier(0.15, 0.46, 0.9, 0.6);\n  animation-iteration-count: infinite;\n  animation-delay: 0;\n}\n.ball-pulse-rise > div:nth-child(2n) {\n  animation-name: ball-pulse-rise-even;\n}\n.ball-pulse-rise > div:nth-child(2n-1) {\n  animation-name: ball-pulse-rise-odd;\n}\n\n@keyframes ball-grid-beat {\n  50% {\n    opacity: 0.7;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n.ball-grid-beat {\n  width: 57px;\n}\n.ball-grid-beat > div:nth-child(1) {\n  animation-delay: 0.05s;\n  animation-duration: 1.54s;\n}\n.ball-grid-beat > div:nth-child(2) {\n  animation-delay: 0.36s;\n  animation-duration: 1.29s;\n}\n.ball-grid-beat > div:nth-child(3) {\n  animation-delay: 0.03s;\n  animation-duration: 1.4s;\n}\n.ball-grid-beat > div:nth-child(4) {\n  animation-delay: 0.08s;\n  animation-duration: 0.8s;\n}\n.ball-grid-beat > div:nth-child(5) {\n  animation-delay: 0.22s;\n  animation-duration: 0.72s;\n}\n.ball-grid-beat > div:nth-child(6) {\n  animation-delay: 0.06s;\n  animation-duration: 1.15s;\n}\n.ball-grid-beat > div:nth-child(7) {\n  animation-delay: 0.75s;\n  animation-duration: 0.7s;\n}\n.ball-grid-beat > div:nth-child(8) {\n  animation-delay: 0.8s;\n  animation-duration: 0.67s;\n}\n.ball-grid-beat > div:nth-child(9) {\n  animation-delay: 0.73s;\n  animation-duration: 0.77s;\n}\n.ball-grid-beat > div {\n  background-color: #545cd8;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  animation-fill-mode: both;\n  display: inline-block;\n  float: left;\n  animation-name: ball-grid-beat;\n  animation-iteration-count: infinite;\n  animation-delay: 0;\n}\n\n@keyframes ball-grid-pulse {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(0.5);\n    opacity: 0.7;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n.ball-grid-pulse {\n  width: 57px;\n}\n.ball-grid-pulse > div:nth-child(1) {\n  animation-delay: 0.45s;\n  animation-duration: 1.33s;\n}\n.ball-grid-pulse > div:nth-child(2) {\n  animation-delay: 0.63s;\n  animation-duration: 1.13s;\n}\n.ball-grid-pulse > div:nth-child(3) {\n  animation-delay: 0.21s;\n  animation-duration: 1.45s;\n}\n.ball-grid-pulse > div:nth-child(4) {\n  animation-delay: 0.5s;\n  animation-duration: 0.77s;\n}\n.ball-grid-pulse > div:nth-child(5) {\n  animation-delay: 0.17s;\n  animation-duration: 1s;\n}\n.ball-grid-pulse > div:nth-child(6) {\n  animation-delay: 0.79s;\n  animation-duration: 1.31s;\n}\n.ball-grid-pulse > div:nth-child(7) {\n  animation-delay: 0.29s;\n  animation-duration: 1.24s;\n}\n.ball-grid-pulse > div:nth-child(8) {\n  animation-delay: 0.59s;\n  animation-duration: 1.55s;\n}\n.ball-grid-pulse > div:nth-child(9) {\n  animation-delay: 0.17s;\n  animation-duration: 1.56s;\n}\n.ball-grid-pulse > div {\n  background-color: #545cd8;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  animation-fill-mode: both;\n  display: inline-block;\n  float: left;\n  animation-name: ball-grid-pulse;\n  animation-iteration-count: infinite;\n  animation-delay: 0;\n}\n\n@keyframes ball-spin-fade-loader {\n  50% {\n    opacity: 0.3;\n    transform: scale(0.4);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n.ball-spin-fade-loader {\n  position: relative;\n  top: -10px;\n  left: -10px;\n}\n.ball-spin-fade-loader > div:nth-child(1) {\n  top: 25px;\n  left: 0;\n  animation: ball-spin-fade-loader 1s -0.96s infinite linear;\n}\n.ball-spin-fade-loader > div:nth-child(2) {\n  top: 17.0454545455px;\n  left: 17.0454545455px;\n  animation: ball-spin-fade-loader 1s -0.84s infinite linear;\n}\n.ball-spin-fade-loader > div:nth-child(3) {\n  top: 0;\n  left: 25px;\n  animation: ball-spin-fade-loader 1s -0.72s infinite linear;\n}\n.ball-spin-fade-loader > div:nth-child(4) {\n  top: -17.0454545455px;\n  left: 17.0454545455px;\n  animation: ball-spin-fade-loader 1s -0.6s infinite linear;\n}\n.ball-spin-fade-loader > div:nth-child(5) {\n  top: -25px;\n  left: 0;\n  animation: ball-spin-fade-loader 1s -0.48s infinite linear;\n}\n.ball-spin-fade-loader > div:nth-child(6) {\n  top: -17.0454545455px;\n  left: -17.0454545455px;\n  animation: ball-spin-fade-loader 1s -0.36s infinite linear;\n}\n.ball-spin-fade-loader > div:nth-child(7) {\n  top: 0;\n  left: -25px;\n  animation: ball-spin-fade-loader 1s -0.24s infinite linear;\n}\n.ball-spin-fade-loader > div:nth-child(8) {\n  top: 17.0454545455px;\n  left: -17.0454545455px;\n  animation: ball-spin-fade-loader 1s -0.12s infinite linear;\n}\n.ball-spin-fade-loader > div {\n  background-color: #545cd8;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  animation-fill-mode: both;\n  position: absolute;\n}\n\n@keyframes ball-spin-loader {\n  75% {\n    opacity: 0.2;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n.ball-spin-loader {\n  position: relative;\n}\n.ball-spin-loader > span:nth-child(1) {\n  top: 45px;\n  left: 0;\n  animation: ball-spin-loader 2s 0.9s infinite linear;\n}\n.ball-spin-loader > span:nth-child(2) {\n  top: 30.6818181818px;\n  left: 30.6818181818px;\n  animation: ball-spin-loader 2s 1.8s infinite linear;\n}\n.ball-spin-loader > span:nth-child(3) {\n  top: 0;\n  left: 45px;\n  animation: ball-spin-loader 2s 2.7s infinite linear;\n}\n.ball-spin-loader > span:nth-child(4) {\n  top: -30.6818181818px;\n  left: 30.6818181818px;\n  animation: ball-spin-loader 2s 3.6s infinite linear;\n}\n.ball-spin-loader > span:nth-child(5) {\n  top: -45px;\n  left: 0;\n  animation: ball-spin-loader 2s 4.5s infinite linear;\n}\n.ball-spin-loader > span:nth-child(6) {\n  top: -30.6818181818px;\n  left: -30.6818181818px;\n  animation: ball-spin-loader 2s 5.4s infinite linear;\n}\n.ball-spin-loader > span:nth-child(7) {\n  top: 0;\n  left: -45px;\n  animation: ball-spin-loader 2s 6.3s infinite linear;\n}\n.ball-spin-loader > span:nth-child(8) {\n  top: 30.6818181818px;\n  left: -30.6818181818px;\n  animation: ball-spin-loader 2s 7.2s infinite linear;\n}\n.ball-spin-loader > div {\n  animation-fill-mode: both;\n  position: absolute;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  background: green;\n}\n\n@keyframes ball-zig {\n  33% {\n    transform: translate(-15px, -30px);\n  }\n  66% {\n    transform: translate(15px, -30px);\n  }\n  100% {\n    transform: translate(0, 0);\n  }\n}\n@keyframes ball-zag {\n  33% {\n    transform: translate(15px, 30px);\n  }\n  66% {\n    transform: translate(-15px, 30px);\n  }\n  100% {\n    transform: translate(0, 0);\n  }\n}\n.ball-zig-zag {\n  position: relative;\n  transform: translate(-15px, -15px);\n}\n.ball-zig-zag > div {\n  background-color: #545cd8;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  animation-fill-mode: both;\n  position: absolute;\n  margin-left: 15px;\n  top: 4px;\n  left: -7px;\n}\n.ball-zig-zag > div:first-child {\n  animation: ball-zig 0.7s 0s infinite linear;\n}\n.ball-zig-zag > div:last-child {\n  animation: ball-zag 0.7s 0s infinite linear;\n}\n\n@keyframes ball-zig-deflect {\n  17% {\n    transform: translate(-15px, -30px);\n  }\n  34% {\n    transform: translate(15px, -30px);\n  }\n  50% {\n    transform: translate(0, 0);\n  }\n  67% {\n    transform: translate(15px, -30px);\n  }\n  84% {\n    transform: translate(-15px, -30px);\n  }\n  100% {\n    transform: translate(0, 0);\n  }\n}\n@keyframes ball-zag-deflect {\n  17% {\n    transform: translate(15px, 30px);\n  }\n  34% {\n    transform: translate(-15px, 30px);\n  }\n  50% {\n    transform: translate(0, 0);\n  }\n  67% {\n    transform: translate(-15px, 30px);\n  }\n  84% {\n    transform: translate(15px, 30px);\n  }\n  100% {\n    transform: translate(0, 0);\n  }\n}\n.ball-zig-zag-deflect {\n  position: relative;\n  transform: translate(-15px, -15px);\n}\n.ball-zig-zag-deflect > div {\n  background-color: #545cd8;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  animation-fill-mode: both;\n  position: absolute;\n  margin-left: 15px;\n  top: 4px;\n  left: -7px;\n}\n.ball-zig-zag-deflect > div:first-child {\n  animation: ball-zig-deflect 1.5s 0s infinite linear;\n}\n.ball-zig-zag-deflect > div:last-child {\n  animation: ball-zag-deflect 1.5s 0s infinite linear;\n}\n\n/**\n * Lines\n */\n@keyframes line-scale {\n  0% {\n    transform: scaley(1);\n  }\n  50% {\n    transform: scaley(0.4);\n  }\n  100% {\n    transform: scaley(1);\n  }\n}\n.line-scale > div:nth-child(1) {\n  animation: line-scale 1s -0.4s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n}\n.line-scale > div:nth-child(2) {\n  animation: line-scale 1s -0.3s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n}\n.line-scale > div:nth-child(3) {\n  animation: line-scale 1s -0.2s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n}\n.line-scale > div:nth-child(4) {\n  animation: line-scale 1s -0.1s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n}\n.line-scale > div:nth-child(5) {\n  animation: line-scale 1s 0s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n}\n.line-scale > div {\n  background-color: #545cd8;\n  width: 4px;\n  height: 35px;\n  border-radius: 2px;\n  margin: 2px;\n  animation-fill-mode: both;\n  display: inline-block;\n}\n\n@keyframes line-scale-party {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(0.5);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n.line-scale-party > div:nth-child(1) {\n  animation-delay: 0.55s;\n  animation-duration: 0.91s;\n}\n.line-scale-party > div:nth-child(2) {\n  animation-delay: 0.78s;\n  animation-duration: 1.01s;\n}\n.line-scale-party > div:nth-child(3) {\n  animation-delay: 0.8s;\n  animation-duration: 0.94s;\n}\n.line-scale-party > div:nth-child(4) {\n  animation-delay: 0.42s;\n  animation-duration: 0.39s;\n}\n.line-scale-party > div {\n  background-color: #545cd8;\n  width: 4px;\n  height: 35px;\n  border-radius: 2px;\n  margin: 2px;\n  animation-fill-mode: both;\n  display: inline-block;\n  animation-name: line-scale-party;\n  animation-iteration-count: infinite;\n  animation-delay: 0;\n}\n\n@keyframes line-scale-pulse-out {\n  0% {\n    transform: scaley(1);\n  }\n  50% {\n    transform: scaley(0.4);\n  }\n  100% {\n    transform: scaley(1);\n  }\n}\n.line-scale-pulse-out > div {\n  background-color: #545cd8;\n  width: 4px;\n  height: 35px;\n  border-radius: 2px;\n  margin: 2px;\n  animation-fill-mode: both;\n  display: inline-block;\n  animation: line-scale-pulse-out 0.9s -0.6s infinite cubic-bezier(0.85, 0.25, 0.37, 0.85);\n}\n.line-scale-pulse-out > div:nth-child(2), .line-scale-pulse-out > div:nth-child(4) {\n  animation-delay: -0.4s !important;\n}\n.line-scale-pulse-out > div:nth-child(1), .line-scale-pulse-out > div:nth-child(5) {\n  animation-delay: -0.2s !important;\n}\n\n@keyframes line-scale-pulse-out-rapid {\n  0% {\n    transform: scaley(1);\n  }\n  80% {\n    transform: scaley(0.3);\n  }\n  90% {\n    transform: scaley(1);\n  }\n}\n.line-scale-pulse-out-rapid > div {\n  background-color: #545cd8;\n  width: 4px;\n  height: 35px;\n  border-radius: 2px;\n  margin: 2px;\n  animation-fill-mode: both;\n  display: inline-block;\n  vertical-align: middle;\n  animation: line-scale-pulse-out-rapid 0.9s -0.5s infinite cubic-bezier(0.11, 0.49, 0.38, 0.78);\n}\n.line-scale-pulse-out-rapid > div:nth-child(2), .line-scale-pulse-out-rapid > div:nth-child(4) {\n  animation-delay: -0.25s !important;\n}\n.line-scale-pulse-out-rapid > div:nth-child(1), .line-scale-pulse-out-rapid > div:nth-child(5) {\n  animation-delay: 0s !important;\n}\n\n@keyframes line-spin-fade-loader {\n  50% {\n    opacity: 0.3;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n.line-spin-fade-loader {\n  position: relative;\n  top: -10px;\n  left: -4px;\n}\n.line-spin-fade-loader > div:nth-child(1) {\n  top: 20px;\n  left: 0;\n  animation: line-spin-fade-loader 1.2s -0.84s infinite ease-in-out;\n}\n.line-spin-fade-loader > div:nth-child(2) {\n  top: 13.6363636364px;\n  left: 13.6363636364px;\n  transform: rotate(-45deg);\n  animation: line-spin-fade-loader 1.2s -0.72s infinite ease-in-out;\n}\n.line-spin-fade-loader > div:nth-child(3) {\n  top: 0;\n  left: 20px;\n  transform: rotate(90deg);\n  animation: line-spin-fade-loader 1.2s -0.6s infinite ease-in-out;\n}\n.line-spin-fade-loader > div:nth-child(4) {\n  top: -13.6363636364px;\n  left: 13.6363636364px;\n  transform: rotate(45deg);\n  animation: line-spin-fade-loader 1.2s -0.48s infinite ease-in-out;\n}\n.line-spin-fade-loader > div:nth-child(5) {\n  top: -20px;\n  left: 0;\n  animation: line-spin-fade-loader 1.2s -0.36s infinite ease-in-out;\n}\n.line-spin-fade-loader > div:nth-child(6) {\n  top: -13.6363636364px;\n  left: -13.6363636364px;\n  transform: rotate(-45deg);\n  animation: line-spin-fade-loader 1.2s -0.24s infinite ease-in-out;\n}\n.line-spin-fade-loader > div:nth-child(7) {\n  top: 0;\n  left: -20px;\n  transform: rotate(90deg);\n  animation: line-spin-fade-loader 1.2s -0.12s infinite ease-in-out;\n}\n.line-spin-fade-loader > div:nth-child(8) {\n  top: 13.6363636364px;\n  left: -13.6363636364px;\n  transform: rotate(45deg);\n  animation: line-spin-fade-loader 1.2s 0s infinite ease-in-out;\n}\n.line-spin-fade-loader > div {\n  background-color: #545cd8;\n  width: 4px;\n  height: 35px;\n  border-radius: 2px;\n  margin: 2px;\n  animation-fill-mode: both;\n  position: absolute;\n  width: 5px;\n  height: 15px;\n}\n\n/**\n * Misc\n */\n@keyframes triangle-skew-spin {\n  25% {\n    transform: perspective(100px) rotateX(180deg) rotateY(0);\n  }\n  50% {\n    transform: perspective(100px) rotateX(180deg) rotateY(180deg);\n  }\n  75% {\n    transform: perspective(100px) rotateX(0) rotateY(180deg);\n  }\n  100% {\n    transform: perspective(100px) rotateX(0) rotateY(0);\n  }\n}\n.triangle-skew-spin > div {\n  animation-fill-mode: both;\n  width: 0;\n  height: 0;\n  border-left: 20px solid transparent;\n  border-right: 20px solid transparent;\n  border-bottom: 20px solid #545cd8;\n  animation: triangle-skew-spin 3s 0s cubic-bezier(0.09, 0.57, 0.49, 0.9) infinite;\n}\n\n@keyframes square-spin {\n  25% {\n    transform: perspective(100px) rotateX(180deg) rotateY(0);\n  }\n  50% {\n    transform: perspective(100px) rotateX(180deg) rotateY(180deg);\n  }\n  75% {\n    transform: perspective(100px) rotateX(0) rotateY(180deg);\n  }\n  100% {\n    transform: perspective(100px) rotateX(0) rotateY(0);\n  }\n}\n.square-spin > div {\n  animation-fill-mode: both;\n  width: 50px;\n  height: 50px;\n  background: #545cd8;\n  animation: square-spin 3s 0s cubic-bezier(0.09, 0.57, 0.49, 0.9) infinite;\n}\n\n@keyframes rotate_pacman_half_up {\n  0% {\n    transform: rotate(270deg);\n  }\n  50% {\n    transform: rotate(360deg);\n  }\n  100% {\n    transform: rotate(270deg);\n  }\n}\n@keyframes rotate_pacman_half_down {\n  0% {\n    transform: rotate(90deg);\n  }\n  50% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(90deg);\n  }\n}\n@keyframes pacman-balls {\n  75% {\n    opacity: 0.7;\n  }\n  100% {\n    transform: translate(-100px, -6.25px);\n  }\n}\n.pacman {\n  position: relative;\n}\n.pacman > div:nth-child(2) {\n  animation: pacman-balls 1s -0.99s infinite linear;\n}\n.pacman > div:nth-child(3) {\n  animation: pacman-balls 1s -0.66s infinite linear;\n}\n.pacman > div:nth-child(4) {\n  animation: pacman-balls 1s -0.33s infinite linear;\n}\n.pacman > div:nth-child(5) {\n  animation: pacman-balls 1s 0s infinite linear;\n}\n.pacman > div:first-of-type {\n  width: 0px;\n  height: 0px;\n  border-right: 25px solid transparent;\n  border-top: 25px solid #545cd8;\n  border-left: 25px solid #545cd8;\n  border-bottom: 25px solid #545cd8;\n  border-radius: 25px;\n  animation: rotate_pacman_half_up 0.5s 0s infinite;\n  position: relative;\n  left: -30px;\n}\n.pacman > div:nth-child(2) {\n  width: 0px;\n  height: 0px;\n  border-right: 25px solid transparent;\n  border-top: 25px solid #545cd8;\n  border-left: 25px solid #545cd8;\n  border-bottom: 25px solid #545cd8;\n  border-radius: 25px;\n  animation: rotate_pacman_half_down 0.5s 0s infinite;\n  margin-top: -50px;\n  position: relative;\n  left: -30px;\n}\n.pacman > div:nth-child(3),\n.pacman > div:nth-child(4),\n.pacman > div:nth-child(5),\n.pacman > div:nth-child(6) {\n  background-color: #545cd8;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  width: 10px;\n  height: 10px;\n  position: absolute;\n  transform: translate(0, -6.25px);\n  top: 25px;\n  left: 70px;\n}\n\n@keyframes cube-transition {\n  25% {\n    transform: translateX(50px) scale(0.5) rotate(-90deg);\n  }\n  50% {\n    transform: translate(50px, 50px) rotate(-180deg);\n  }\n  75% {\n    transform: translateY(50px) scale(0.5) rotate(-270deg);\n  }\n  100% {\n    transform: rotate(-360deg);\n  }\n}\n.cube-transition {\n  position: relative;\n  transform: translate(-25px, -25px);\n}\n.cube-transition > div {\n  animation-fill-mode: both;\n  width: 10px;\n  height: 10px;\n  position: absolute;\n  top: -5px;\n  left: -5px;\n  background-color: #545cd8;\n  animation: cube-transition 1.6s 0s infinite ease-in-out;\n}\n.cube-transition > div:last-child {\n  animation-delay: -0.8s;\n}\n\n@keyframes spin-rotate {\n  0% {\n    transform: rotate(0deg);\n  }\n  50% {\n    transform: rotate(180deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.semi-circle-spin {\n  position: relative;\n  width: 35px;\n  height: 35px;\n  overflow: hidden;\n}\n.semi-circle-spin > div {\n  position: absolute;\n  border-width: 0px;\n  border-radius: 100%;\n  animation: spin-rotate 0.6s 0s infinite linear;\n  background-image: linear-gradient(transparent 0%, transparent 70%, #545cd8 30%, #545cd8 100%);\n  width: 100%;\n  height: 100%;\n}\n\n.progress .progress-bar:last-child {\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n}\n.progress.progress-bar-sm {\n  height: 0.5rem;\n}\n.progress.progress-bar-xs {\n  height: 0.3rem;\n}\n.progress.progress-bar-rounded {\n  border-radius: 30px;\n}\n\n.progress-bar-animated-alt.progress-bar,\n.progress-bar-animated-alt .progress-bar {\n  position: relative;\n}\n.progress-bar-animated-alt.progress-bar::after,\n.progress-bar-animated-alt .progress-bar::after {\n  content: \"\";\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: #fff;\n  animation: progress-active 2s ease infinite;\n}\n\n@keyframes progress-active {\n  0% {\n    opacity: 0.4;\n    width: 0;\n  }\n  100% {\n    opacity: 0;\n    width: 100%;\n  }\n}\n.vertical-timeline {\n  width: 100%;\n  position: relative;\n  padding: 1.5rem 0 1rem;\n}\n.vertical-timeline::after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n.vertical-timeline::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 67px;\n  height: 100%;\n  width: 4px;\n  background: #e9ecef;\n  border-radius: 0.25rem;\n}\n\n.vertical-timeline-element {\n  position: relative;\n  margin: 0 0 1rem;\n}\n.vertical-timeline-element:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n.vertical-timeline-element:last-child {\n  margin-bottom: 0;\n}\n\n.vertical-timeline-element-content {\n  position: relative;\n  margin-left: 90px;\n  font-size: 0.8rem;\n}\n.vertical-timeline-element-content:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n.vertical-timeline-element-content .timeline-title {\n  font-size: 0.8rem;\n  text-transform: uppercase;\n  margin: 0 0 0.5rem;\n  padding: 2px 0 0;\n  font-weight: bold;\n}\n.vertical-timeline-element-content p {\n  color: #6c757d;\n  margin: 0 0 0.5rem;\n}\n.vertical-timeline-element-content .vertical-timeline-element-date {\n  display: block;\n  position: absolute;\n  left: -90px;\n  top: 0;\n  padding-right: 10px;\n  text-align: right;\n  color: #adb5bd;\n  font-size: 0.7619047619rem;\n  white-space: nowrap;\n}\n\n.vertical-timeline-element-icon {\n  position: absolute;\n  top: 0;\n  left: 60px;\n}\n.vertical-timeline-element-icon .badge-dot-xl {\n  box-shadow: 0 0 0 5px #fff;\n}\n\n.vertical-timeline-element--no-children .vertical-timeline-element-content {\n  background: 0 0;\n  box-shadow: none;\n}\n.vertical-timeline-element--no-children .vertical-timeline-element-content::before {\n  display: none;\n}\n\n.vertical-without-time::before {\n  left: 11px;\n}\n.vertical-without-time .vertical-timeline-element-content {\n  margin-left: 36px;\n}\n.vertical-without-time .vertical-timeline-element-icon {\n  left: 4px;\n}\n\n.vertical-time-icons {\n  padding: 2rem 0 0;\n}\n.vertical-time-icons::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 14px;\n  height: 100%;\n  width: 6px;\n  background: #e9ecef;\n  border-radius: 0.25rem;\n}\n.vertical-time-icons .vertical-timeline-element {\n  margin-bottom: 1rem;\n}\n.vertical-time-icons .vertical-timeline-element-content {\n  margin-left: 50px;\n}\n.vertical-time-icons .vertical-timeline-element-icon {\n  width: 34px;\n  height: 34px;\n  left: 0;\n  top: -7px;\n}\n.vertical-time-icons .vertical-timeline-element-icon .timeline-icon {\n  width: 34px;\n  height: 34px;\n  background: #fff;\n  border-radius: 50px;\n  border-width: 2px;\n  border-style: solid;\n  box-shadow: 0 0 0 5px #fff;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  align-content: center;\n}\n.vertical-time-icons .vertical-timeline-element-icon .timeline-icon i {\n  display: block;\n  font-size: 1.1rem;\n  margin: 0 auto;\n}\n.vertical-time-icons .vertical-timeline-element-icon .timeline-icon svg {\n  margin: 0 auto;\n}\n\n.vertical-time-simple {\n  padding: 0.5rem 0;\n}\n.vertical-time-simple .vertical-timeline-element {\n  margin: 0 0 0.5rem;\n}\n.vertical-time-simple .timeline-title {\n  font-weight: normal;\n  font-size: 0.9166666667rem;\n  padding: 0;\n}\n.vertical-time-simple .vertical-timeline-element-icon {\n  height: 14px;\n  width: 14px;\n  background: #e9ecef;\n  position: absolute;\n  left: 6px;\n  top: 2px;\n  display: block;\n  border-radius: 20px;\n}\n.vertical-time-simple .vertical-timeline-element-icon::after {\n  content: \"\";\n  position: absolute;\n  background: #fff;\n  left: 50%;\n  top: 50%;\n  margin: -4px 0 0 -4px;\n  display: block;\n  width: 8px;\n  height: 8px;\n  border-radius: 20px;\n}\n.vertical-time-simple .timeline-title {\n  text-transform: none;\n}\n\n.dot-primary .vertical-timeline-element-icon {\n  background: #545cd8;\n}\n\n.dot-secondary .vertical-timeline-element-icon {\n  background: #6c757d;\n}\n\n.dot-success .vertical-timeline-element-icon {\n  background: #3ac47d;\n}\n\n.dot-info .vertical-timeline-element-icon {\n  background: #30b1ff;\n}\n\n.dot-warning .vertical-timeline-element-icon {\n  background: #f7b924;\n}\n\n.dot-danger .vertical-timeline-element-icon {\n  background: #d92550;\n}\n\n.dot-light .vertical-timeline-element-icon {\n  background: #eeeeee;\n}\n\n.dot-dark .vertical-timeline-element-icon {\n  background: #343a40;\n}\n\n.dot-focus .vertical-timeline-element-icon {\n  background: #444054;\n}\n\n.dot-alternate .vertical-timeline-element-icon {\n  background: #83588a;\n}\n\n.vertical-timeline--animate .vertical-timeline-element-icon.is-hidden {\n  visibility: hidden;\n}\n\n.vertical-timeline--animate .vertical-timeline-element-icon.bounce-in {\n  visibility: visible;\n  animation: cd-bounce-1 0.8s;\n}\n\n@-webkit-keyframes cd-bounce-1 {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale(0.5);\n  }\n  60% {\n    opacity: 1;\n    -webkit-transform: scale(1.2);\n  }\n  100% {\n    -webkit-transform: scale(1);\n  }\n}\n@-moz-keyframes cd-bounce-1 {\n  0% {\n    opacity: 0;\n    -moz-transform: scale(0.5);\n  }\n  60% {\n    opacity: 1;\n    -moz-transform: scale(1.2);\n  }\n  100% {\n    -moz-transform: scale(1);\n  }\n}\n@keyframes cd-bounce-1 {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale(0.5);\n    -moz-transform: scale(0.5);\n    -ms-transform: scale(0.5);\n    -o-transform: scale(0.5);\n    transform: scale(0.5);\n  }\n  60% {\n    opacity: 1;\n    -webkit-transform: scale(1.2);\n    -moz-transform: scale(1.2);\n    -ms-transform: scale(1.2);\n    -o-transform: scale(1.2);\n    transform: scale(1.2);\n  }\n  100% {\n    -webkit-transform: scale(1);\n    -moz-transform: scale(1);\n    -ms-transform: scale(1);\n    -o-transform: scale(1);\n    transform: scale(1);\n  }\n}\n.vertical-timeline--animate .vertical-timeline-element-content.is-hidden {\n  visibility: hidden;\n}\n\n.vertical-timeline--animate .vertical-timeline-element-content.bounce-in {\n  visibility: visible;\n  -webkit-animation: cd-bounce-2 0.6s;\n  -moz-animation: cd-bounce-2 0.6s;\n  animation: cd-bounce-2 0.6s;\n}\n\n@media only screen and (min-width: 1170px) {\n  .vertical-timeline--two-columns.vertical-timeline--animate .vertical-timeline-element.vertical-timeline-element--right .vertical-timeline-element-content.bounce-in, .vertical-timeline--two-columns.vertical-timeline--animate .vertical-timeline-element:nth-child(even):not(.vertical-timeline-element--left) .vertical-timeline-element-content.bounce-in {\n    -webkit-animation: cd-bounce-2-inverse 0.6s;\n    -moz-animation: cd-bounce-2-inverse 0.6s;\n    animation: cd-bounce-2-inverse 0.6s;\n  }\n}\n@media only screen and (max-width: 1169px) {\n  .vertical-timeline--animate .vertical-timeline-element-content.bounce-in {\n    visibility: visible;\n    -webkit-animation: cd-bounce-2-inverse 0.6s;\n    -moz-animation: cd-bounce-2-inverse 0.6s;\n    animation: cd-bounce-2-inverse 0.6s;\n  }\n}\n@-webkit-keyframes cd-bounce-2 {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateX(-100px);\n  }\n  60% {\n    opacity: 1;\n    -webkit-transform: translateX(20px);\n  }\n  100% {\n    -webkit-transform: translateX(0);\n  }\n}\n@-moz-keyframes cd-bounce-2 {\n  0% {\n    opacity: 0;\n    -moz-transform: translateX(-100px);\n  }\n  60% {\n    opacity: 1;\n    -moz-transform: translateX(20px);\n  }\n  100% {\n    -moz-transform: translateX(0);\n  }\n}\n@keyframes cd-bounce-2 {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateX(-100px);\n    -moz-transform: translateX(-100px);\n    -ms-transform: translateX(-100px);\n    -o-transform: translateX(-100px);\n    transform: translateX(-100px);\n  }\n  60% {\n    opacity: 1;\n    -webkit-transform: translateX(20px);\n    -moz-transform: translateX(20px);\n    -ms-transform: translateX(20px);\n    -o-transform: translateX(20px);\n    transform: translateX(20px);\n  }\n  100% {\n    -webkit-transform: translateX(0);\n    -moz-transform: translateX(0);\n    -ms-transform: translateX(0);\n    -o-transform: translateX(0);\n    transform: translateX(0);\n  }\n}\n@-webkit-keyframes cd-bounce-2-inverse {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateX(100px);\n  }\n  60% {\n    opacity: 1;\n    -webkit-transform: translateX(-20px);\n  }\n  100% {\n    -webkit-transform: translateX(0);\n  }\n}\n@-moz-keyframes cd-bounce-2-inverse {\n  0% {\n    opacity: 0;\n    -moz-transform: translateX(100px);\n  }\n  60% {\n    opacity: 1;\n    -moz-transform: translateX(-20px);\n  }\n  100% {\n    -moz-transform: translateX(0);\n  }\n}\n@keyframes cd-bounce-2-inverse {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateX(100px);\n    -moz-transform: translateX(100px);\n    -ms-transform: translateX(100px);\n    -o-transform: translateX(100px);\n    transform: translateX(100px);\n  }\n  60% {\n    opacity: 1;\n    -webkit-transform: translateX(-20px);\n    -moz-transform: translateX(-20px);\n    -ms-transform: translateX(-20px);\n    -o-transform: translateX(-20px);\n    transform: translateX(-20px);\n  }\n  100% {\n    -webkit-transform: translateX(0);\n    -moz-transform: translateX(0);\n    -ms-transform: translateX(0);\n    -o-transform: translateX(0);\n    transform: translateX(0);\n  }\n}\n.todo-list-wrapper .todo-indicator {\n  position: absolute;\n  width: 4px;\n  height: 60%;\n  border-radius: 0.3rem;\n  left: 0.5rem;\n  top: 20%;\n  opacity: 0.6;\n  transition: opacity 0.2s;\n}\n.todo-list-wrapper .list-group-item:hover .todo-indicator {\n  opacity: 0.9;\n}\n.todo-list-wrapper .custom-control,\n.todo-list-wrapper input[checkbox] {\n  margin-left: 0.5rem;\n}\n\n.list-group-flush + .card-footer {\n  border-top: 0;\n}\n\n.rm-list-borders .list-group-item {\n  border: 0;\n  padding: 0.6666666667rem 0;\n}\n\n.rm-list-borders-scroll .list-group-item {\n  border: 0;\n  padding-right: 1.5rem;\n}\n\n.input-group .input-group-prepend div:not([class]) .react-datepicker__input-container .form-control, .input-group .input-group-prepend + div .react-datepicker__input-container .form-control {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  border-top-right-radius: 0.25rem !important;\n  border-bottom-right-radius: 0.25rem !important;\n}\n.input-group > div:not([class]) {\n  position: relative;\n  flex: 1 1 auto;\n  width: 1%;\n}\n.input-group > div:not([class]) .react-datepicker__input-container .form-control {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.input-group .input-group-prepend + div {\n  position: relative;\n  flex: 1 1 auto;\n  width: 1%;\n}\n.input-group > .react-datepicker-wrapper {\n  position: relative;\n  flex: 1 1 auto;\n  width: 1%;\n}\n.input-group > .react-datepicker-wrapper > .react-datepicker__input-container > .form-control {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\nlegend {\n  font-size: 0.88rem;\n  font-weight: bold;\n}\n\n.form-heading {\n  font-size: 1.1rem;\n  margin: 0;\n  color: #545cd8;\n}\n.form-heading p {\n  color: #6c757d;\n  padding: 0.3rem 0 0;\n  font-size: 0.88rem;\n}\n\n.customPassErr {\n  margin-top: 0.25rem;\n  font-size: 0.875em;\n  color: #d92550;\n}\n\n.custom-select {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n}\n\n.pagination li a {\n  position: relative;\n  display: block;\n  padding: 0.375rem 0.75rem;\n  margin-left: -1px;\n  color: #545cd8;\n  background-color: #fff;\n  border: 1px solid #dee2e6;\n}\n.pagination li a:hover {\n  z-index: 2;\n  color: rgb(67.2, 73.6, 172.8);\n  text-decoration: none;\n  background-color: #e9ecef;\n  border-color: #dee2e6;\n}\n.pagination li a:focus {\n  z-index: 2;\n  outline: 0;\n  box-shadow: none;\n}\n.pagination li a:not(:disabled):not(.disabled) {\n  cursor: pointer;\n}\n.pagination li:first-child a {\n  margin-left: 0;\n  border-top-left-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n.pagination li:last-child a {\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n}\n.pagination li.active a {\n  z-index: 1;\n  color: #fff;\n  background-color: #545cd8;\n  border-color: #545cd8;\n}\n.pagination li.active a:hover {\n  color: #fff;\n}\n.pagination li.disabled a {\n  color: #6c757d;\n  pointer-events: none;\n  cursor: auto;\n  background-color: #fff;\n  border-color: #dee2e6;\n}\n\n.pagination-rounded li a {\n  border-radius: 50px !important;\n  margin: 0 0.3rem;\n}\n\n.chat-box-wrapper {\n  display: flex;\n  clear: both;\n  padding: 0.75rem;\n}\n.chat-box-wrapper + .chat-box-wrapper {\n  padding-top: 0;\n}\n.chat-box-wrapper .chat-box {\n  box-shadow: 0 0 0 transparent;\n  position: relative;\n  opacity: 1;\n  background: #e0f3ff;\n  border: 0;\n  padding: 0.75rem 1.5rem;\n  border-radius: 30px;\n  border-top-left-radius: 0.25rem;\n  flex: 1;\n  display: flex;\n  max-width: 50%;\n  min-width: 100%;\n  text-align: left;\n}\n.chat-box-wrapper .chat-box + small, .chat-box-wrapper .chat-box + .small {\n  text-align: left;\n  padding: 0.5rem 0 0;\n  margin-left: 1.5rem;\n  display: block;\n}\n.chat-box-wrapper.chat-box-wrapper-right {\n  text-align: right;\n}\n.chat-box-wrapper.chat-box-wrapper-right .chat-box {\n  border-radius: 30px;\n  border-top-left-radius: 30px;\n  border-top-right-radius: 0.25rem;\n  margin-left: auto;\n}\n.chat-box-wrapper.chat-box-wrapper-right .chat-box + small, .chat-box-wrapper.chat-box-wrapper-right .chat-box + .small {\n  text-align: right;\n  margin-right: 1.5rem;\n  margin-left: 0;\n}\n\n.forms-wizard {\n  margin: 0;\n  padding: 0;\n  list-style-type: none;\n  width: 100%;\n  display: table;\n  table-layout: fixed;\n  border-radius: 0.25rem;\n}\n.forms-wizard li {\n  display: table-cell;\n  vertical-align: middle;\n  text-align: center;\n  cursor: pointer;\n  font-size: 1rem;\n  padding: 1rem 0;\n  color: #adb5bd;\n  position: relative;\n}\n.forms-wizard li::after, .forms-wizard li::before {\n  position: absolute;\n  height: 4px;\n  top: 50%;\n  margin-top: -1rem;\n  width: 50%;\n  content: \"\";\n  background: #dee2e6;\n  z-index: 5;\n  transition: all 0.2s;\n}\n.forms-wizard li::after {\n  left: 50%;\n}\n.forms-wizard li::before {\n  left: 0;\n}\n.forms-wizard li:first-child::before {\n  border-top-left-radius: 20px;\n  border-bottom-left-radius: 20px;\n}\n.forms-wizard li:last-child::after {\n  border-top-right-radius: 20px;\n  border-bottom-right-radius: 20px;\n}\n.forms-wizard li em {\n  font-style: normal;\n  font-size: 1.32rem;\n  background: #ced4da;\n  color: #fff;\n  text-align: center;\n  padding: 0;\n  width: 40px;\n  height: 40px;\n  line-height: 40px;\n  border-radius: 50px;\n  display: block;\n  margin: 0 auto 0.5rem;\n  position: relative;\n  z-index: 7;\n  transition: all 0.2s;\n}\n.forms-wizard li.form-wizard-step-doing {\n  color: #495057;\n}\n.forms-wizard li.form-wizard-step-doing em {\n  background: #545cd8;\n}\n.forms-wizard li.form-wizard-step-doing::before {\n  background: #545cd8;\n}\n.forms-wizard li.form-wizard-step-done em {\n  font-family: \"Linearicons-Free\";\n  background: #3ac47d;\n  overflow: hidden;\n}\n.forms-wizard li.form-wizard-step-done em::before {\n  width: 42px;\n  height: 42px;\n  font-size: 1.2rem;\n  line-height: 40px;\n  text-align: center;\n  display: block;\n}\n.forms-wizard li.form-wizard-step-done::after, .forms-wizard li.form-wizard-step-done::before {\n  background: #3ac47d;\n}\n.forms-wizard li:hover {\n  color: #6c757d;\n}\n\n.forms-wizard-alt .forms-wizard li {\n  font-size: 0.88rem;\n}\n.forms-wizard-alt .forms-wizard li em {\n  width: 14px;\n  height: 14px;\n  line-height: 14px;\n  text-indent: -999rem;\n  border: #fff solid 2px;\n  margin: -7px auto 0;\n}\n\n.forms-wizard-vertical .forms-wizard {\n  display: block;\n  width: 30%;\n  float: left;\n  padding: 0 1.5rem 1.5rem 0;\n}\n.forms-wizard-vertical .forms-wizard li {\n  text-align: left;\n  display: flex;\n  align-items: center;\n  align-content: flex-start;\n  padding: 0.75rem;\n  margin-bottom: 0.5rem;\n  border-radius: 0.3rem;\n  transition: all 0.2s;\n}\n.forms-wizard-vertical .forms-wizard li::before, .forms-wizard-vertical .forms-wizard li::after {\n  display: none;\n}\n.forms-wizard-vertical .forms-wizard li em {\n  margin: 0 0.75rem 0 0;\n}\n.forms-wizard-vertical .forms-wizard li:hover {\n  background: #e9ecef;\n}\n.forms-wizard-vertical .forms-wizard li.form-wizard-step-doing {\n  background: #545cd8;\n  color: #fff;\n}\n.forms-wizard-vertical .forms-wizard li.form-wizard-step-doing em {\n  background: rgba(255, 255, 255, 0.2);\n}\n.forms-wizard-vertical .form-wizard-content {\n  width: 70%;\n  overflow: auto;\n}\n\n@media screen and (min-width: 360px) and (max-width: 812px) {\n  .forms-wizard-vertical .forms-wizard {\n    display: block;\n    width: 50%;\n    float: left;\n    padding: 0 1.5rem 1.5rem 0;\n  }\n  .forms-wizard-vertical .forms-wizard li {\n    text-align: left;\n    display: flex;\n    align-items: center;\n    align-content: flex-start;\n    padding: 0.75rem;\n    margin-bottom: 0.5rem;\n    border-radius: 0.3rem;\n    transition: all 0.2s;\n  }\n  .forms-wizard-vertical .forms-wizard li::before, .forms-wizard-vertical .forms-wizard li::after {\n    display: none;\n  }\n  .forms-wizard-vertical .forms-wizard li em {\n    margin: 0 0.75rem 0 0;\n  }\n  .forms-wizard-vertical .forms-wizard li:hover {\n    background: #e9ecef;\n  }\n  .forms-wizard-vertical .forms-wizard li.form-wizard-step-doing {\n    background: #545cd8;\n    color: #fff;\n  }\n  .forms-wizard-vertical .forms-wizard li.form-wizard-step-doing em {\n    background: rgba(255, 255, 255, 0.2);\n  }\n  .forms-wizard-vertical .form-wizard-content {\n    width: 50%;\n    overflow: auto;\n  }\n}\n.icon-wrapper {\n  display: flex;\n  align-content: center;\n  align-items: center;\n}\n\n.widget-chart {\n  text-align: center;\n  padding: 1rem;\n  position: relative;\n}\n.widget-chart .progress-sub-label {\n  opacity: 0.8;\n  padding: 5px 0 0;\n}\n.widget-chart .progress-circle-wrapper {\n  min-width: 68px;\n  margin-right: 1rem;\n}\n.widget-chart .progress-circle-wrapper .react-sweet-progress-symbol {\n  font-size: 0.8rem;\n}\n.widget-chart .widget-chart-content {\n  position: relative;\n  z-index: 5;\n}\n.widget-chart .widget-chart-content-lg {\n  padding: 2rem 0 1rem 2rem;\n}\n.widget-chart .widget-chart-content-lg .widget-numbers {\n  margin-bottom: 0;\n}\n.widget-chart .widget-chart-wrapper {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  opacity: 0.25;\n  z-index: 6;\n  border-bottom-right-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n  overflow: hidden;\n}\n.widget-chart .widget-numbers {\n  font-weight: bold;\n  font-size: 2.5rem;\n  display: block;\n  line-height: 1;\n  margin: 1rem auto;\n}\n.widget-chart .widget-numbers + .widget-chart-flex, .widget-chart .widget-numbers + .widget-description, .widget-chart .widget-numbers + .widget-subheading {\n  margin-top: -0.5rem;\n}\n.widget-chart .widget-subheading {\n  margin: -0.5rem 0 0;\n  display: block;\n  opacity: 0.6;\n}\n.widget-chart .widget-subheading:first-child {\n  margin-top: 0;\n}\n.widget-chart .widget-subheading + .widget-numbers {\n  margin-top: 0.5rem;\n}\n.widget-chart .widget-description {\n  margin: 1rem 0 0;\n}\n.widget-chart.widget-chart-hover {\n  transition: all 0.2s;\n}\n.widget-chart.widget-chart-hover:hover {\n  z-index: 15;\n  transform: scale(1.15);\n  box-shadow: 0 0.46875rem 4.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.9375rem 2.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.25rem 1.3125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.06), 0 0.125rem 1.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.06);\n  cursor: pointer;\n  background: #fff;\n}\n.widget-chart .widget-chart-actions {\n  position: absolute;\n  right: 0.5rem;\n  top: 0.5rem;\n  z-index: 12;\n}\n.widget-chart .widget-chart-actions .btn-link {\n  font-size: 1.1rem;\n  padding-top: 0;\n  padding-bottom: 0;\n  opacity: 0.6;\n}\n.widget-chart .widget-progress-wrapper {\n  margin-top: 1rem;\n}\n.widget-chart .widget-progress-wrapper.progress-wrapper-bottom {\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n}\n.widget-chart .widget-progress-wrapper.progress-wrapper-bottom .progress {\n  margin: 0 -1px -1px;\n}\n.widget-chart .widget-progress-wrapper.progress-wrapper-bottom .progress {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n.widget-chart .widget-progress-wrapper.progress-wrapper-bottom .progress .progress-bar {\n  border-bottom-left-radius: 0.25rem;\n}\n.widget-chart .widget-chart-flex {\n  display: flex;\n  align-items: center;\n  align-content: center;\n  margin-bottom: 1rem;\n}\n.widget-chart .widget-chart-flex:last-child {\n  margin-bottom: 0;\n}\n.widget-chart .widget-chart-flex .widget-subheading {\n  margin: 0;\n}\n.widget-chart .widget-chart-flex .widget-description {\n  margin-top: 0;\n}\n.widget-chart.text-start {\n  flex-direction: row;\n  align-items: center;\n}\n.widget-chart.text-start .icon-wrapper {\n  min-width: 54px;\n  margin: 0 1rem 0 0;\n}\n.widget-chart.text-start .widget-numbers {\n  margin-left: 0;\n}\n.widget-chart.text-start .widget-chart-content {\n  display: flex;\n  flex-direction: column;\n  align-content: center;\n  flex: 1;\n  position: relative;\n}\n.widget-chart.text-start .widget-chart-content > .widget-numbers:first-child {\n  margin-top: 0;\n}\n.widget-chart.text-start .widget-chart-content .widget-description {\n  align-self: flex-start;\n}\n.widget-chart.text-start .widget-chart-wrapper {\n  height: 35%;\n}\n.widget-chart.widget-chart-left {\n  padding-bottom: 15%;\n}\n.widget-chart .chart-wrapper-relative {\n  position: relative;\n  opacity: 1;\n  margin-top: 1rem;\n}\n\n.widget-chart-actions {\n  position: absolute;\n  right: 1rem;\n  top: 1rem;\n  z-index: 12;\n}\n.widget-chart-actions .btn-link {\n  font-size: 1.1rem;\n  padding-top: 0;\n  padding-bottom: 0;\n  opacity: 0.6;\n}\n\n.widget-chart:hover .widget-chart-actions .btn-link,\n.widget-content:hover .widget-chart-actions .btn-link {\n  opacity: 1;\n}\n\n.grid-menu .widget-chart.widget-chart-hover:hover {\n  background: #fff;\n  border-radius: 0.25rem;\n}\n\n.icon-wrapper {\n  width: 54px;\n  height: 54px;\n  margin: 0 auto;\n  position: relative;\n  overflow: hidden;\n}\n.icon-wrapper[class*=border-] {\n  border-width: 1px;\n  border-style: solid;\n}\n.icon-wrapper .icon-wrapper-bg {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  z-index: 3;\n  opacity: 0.2;\n}\n.icon-wrapper .icon-wrapper-bg.bg-light {\n  opacity: 0.08;\n}\n.icon-wrapper i {\n  margin: 0 auto;\n  font-size: 1.7rem;\n  position: relative;\n  z-index: 5;\n}\n.icon-wrapper i:before {\n  margin-top: -3px;\n}\n.icon-wrapper .progress-circle-wrapper {\n  width: 100%;\n  margin-right: 0;\n}\n\n.widget-chart2 .widget-chart-flex {\n  display: flex;\n  align-items: baseline;\n  align-content: center;\n  margin-bottom: 0;\n}\n.widget-chart2 .widget-chart-flex .widget-subtitle {\n  margin-left: auto;\n}\n.widget-chart2 .widget-chart-flex .widget-numbers {\n  font-weight: normal;\n}\n.widget-chart2 .widget-chart-flex + .widget-chart-flex .widget-numbers {\n  margin-bottom: 0;\n}\n.widget-chart2 .widget-chat-wrapper-outer {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  max-width: 100%;\n}\n.widget-chart2 .widget-chat-wrapper-outer .widget-chart-wrapper {\n  height: 70px;\n  opacity: 0.8;\n  position: relative;\n  margin: 1rem auto -0.5rem;\n}\n.widget-chart2 .widget-chat-wrapper-outer .widget-chart-wrapper-lg {\n  height: 130px;\n}\n\n.card-btm-border {\n  border-bottom: transparent solid 4px;\n}\n\n.progress-box {\n  text-align: center;\n}\n.progress-box h4, .progress-box .h4 {\n  font-size: 0.88rem;\n  font-weight: bold;\n  opacity: 0.6;\n  text-transform: uppercase;\n  padding-bottom: 0.3333333333rem;\n}\n.progress-box svg {\n  margin: 0 auto;\n}\n\n.svg-bg {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  opacity: 0.1;\n}\n.svg-bg svg {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n\n.widget-numbers-sm {\n  font-size: 1.5rem;\n}\n\n.widget-content {\n  padding: 1rem;\n  flex-direction: row;\n  align-items: center;\n}\n.widget-content .widget-content-wrapper {\n  display: flex;\n  flex: 1;\n  position: relative;\n  align-items: center;\n}\n.widget-content .widget-content-left .widget-heading {\n  opacity: 0.8;\n  font-weight: bold;\n}\n.widget-content .widget-content-left .widget-subheading {\n  opacity: 0.5;\n}\n.widget-content .widget-content-right {\n  margin-left: auto;\n}\n.widget-content .widget-numbers {\n  font-weight: bold;\n  font-size: 1.8rem;\n  display: block;\n}\n.widget-content .widget-content-outer {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n}\n.widget-content .widget-progress-wrapper {\n  margin-top: 1rem;\n}\n.widget-content .widget-progress-wrapper .progress-sub-label {\n  margin-top: 0.3333333333rem;\n  opacity: 0.5;\n  display: flex;\n  align-content: center;\n  align-items: center;\n}\n.widget-content .widget-progress-wrapper .progress-sub-label .sub-label-right {\n  margin-left: auto;\n}\n.widget-content .widget-content-right.widget-content-actions {\n  visibility: hidden;\n  opacity: 0;\n  transition: opacity 0.2s;\n}\n.widget-content:hover .widget-content-right.widget-content-actions {\n  visibility: visible;\n  opacity: 1;\n}\n\n.profile-block {\n  position: relative;\n  overflow: hidden;\n}\n.profile-block .profile-blur {\n  width: 100%;\n  height: 100%;\n  filter: blur(5px);\n  transform: scale(1.8);\n  position: absolute;\n  left: -25%;\n  top: -25%;\n}\n.profile-block .profile-inner {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  opacity: 0.5;\n  left: 0;\n  top: 0;\n}\n.profile-block .dropdown-menu-header .menu-header-content {\n  padding: 3rem;\n}\n.profile-block .dropdown-menu-header .menu-header-content .menu-header-title {\n  margin: 0.75rem 0 0;\n}\n.profile-block .dropdown-menu-header .menu-header-content .menu-header-subtitle {\n  margin: 0.5rem 0 0;\n}\n.profile-block .dropdown-menu-header .menu-header-btn-pane {\n  margin: 0.5rem 0 0;\n}\n.profile-block .dropdown-menu-header .menu-header-btn-pane .btn-icon {\n  color: #fff;\n  padding: 0;\n  width: 44px;\n  height: 44px;\n  line-height: 37px;\n  font-size: 1.1rem;\n}\n.profile-block .dropdown-menu-header .menu-header-btn-pane .btn-icon:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.app-logo {\n  height: 23px;\n  width: 97px;\n  background: url(\"../../assets/utils/images/Arkos_color_logo 1.svg\");\n}\n\n.app-logo-inverse {\n  height: 23px;\n  width: 97px;\n  background: url(\"../../assets/utils/images/Arkos_white_logo 1.svg\");\n}\n\n.app-login-box .app-logo {\n  margin-bottom: 3rem;\n}\n.app-login-box h4, .app-login-box .h4 {\n  margin-bottom: 1.5rem;\n  font-weight: normal;\n}\n.app-login-box h4 div, .app-login-box .h4 div {\n  opacity: 0.6;\n}\n.app-login-box h4 span, .app-login-box .h4 span {\n  font-size: 1.1rem;\n}\n\nspan.ps-menu-label i {\n  font-size: 24px;\n  position: relative;\n  top: 5px;\n  margin-right: 16px;\n}\n\ni.pe {\n  font-size: 24px;\n  position: relative;\n  right: 5px;\n}\n\n.css-dip3t8 {\n  background-color: rgba(249, 249, 249, 0) !important;\n}\n\n.css-1wvake5 {\n  border: none !important;\n}\n\n.page-heading-sections {\n  padding-bottom: 19px;\n}\n.page-heading-sections h2, .page-heading-sections .h2 {\n  margin-bottom: 0px;\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 36px;\n  color: #1d1d1d;\n}\n.page-heading-sections .form-check {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 11px;\n}\n.page-heading-sections .form-check label.form-check-label {\n  font-weight: 400;\n  font-size: 15px;\n  line-height: 22px;\n  color: #3f3f3f;\n}\n.page-heading-sections .form-check input.form-check-input {\n  width: 20px;\n  height: 20px;\n}\n.page-heading-sections .form-check input.form-check-input:focus {\n  box-shadow: none;\n}\n.page-heading-sections .form-check input.form-check-input:checked {\n  background-color: #545cd8;\n  border-color: #545cd8;\n}\n\n.formula-page .rounded-3 {\n  border: 1px solid #cacaca;\n  border-radius: 10px !important;\n  margin-top: 30px;\n}\n.formula-page table {\n  margin-bottom: 0px !important;\n}\n.formula-page table thead {\n  background-color: #545cd8;\n  color: #fff;\n}\n.formula-page table thead tr th {\n  text-align: center;\n  padding: 17px 34px;\n  font-weight: 500;\n  font-size: 15px;\n  line-height: 22px;\n  color: #ffffff;\n}\n.formula-page table tbody tr td {\n  text-align: center;\n  font-weight: 400;\n  font-size: 15px;\n  line-height: 22px;\n  color: #1d1d1d;\n  padding: 10px;\n}\n.formula-page table tbody tr td a {\n  padding-left: 10px;\n}\n.formula-page table tbody .input-group {\n  border: 1px solid #c8c8c8;\n  border-radius: 4px;\n  max-width: 172px;\n  margin: 0px !important;\n}\n.formula-page table tbody .input-group .form-control {\n  border: 0px;\n}\n.formula-page table button {\n  background: #545cd8;\n  border-color: #545cd8;\n  color: #1d1d1d;\n  font-size: 15px;\n}\n.formula-page .foot-form {\n  background: #f4f4f4;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 27px 34px;\n  gap: 10px;\n  flex-wrap: wrap;\n  border-top: 1px solid #e7e7e7 !important;\n}\n.formula-page .foot-form .auto-generate {\n  min-width: 172px;\n  margin-bottom: 0px !important;\n  border: 1px solid #c8c8c8;\n  border-radius: 4px;\n  max-width: 20%;\n}\n.formula-page .foot-form .auto-generate .form-control {\n  border: 0px !important;\n  box-shadow: none;\n}\n.formula-page .foot-form .auto-generate .form-control:hover {\n  box-shadow: none;\n}\n.formula-page .foot-form .auto-generate span {\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  background-color: #f2f2f2;\n  padding: 5px 10px;\n  width: 35px;\n  height: 35px;\n  text-align: center;\n}\n.formula-page .foot-form .search-items {\n  position: relative;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  min-width: 200px;\n  padding-left: 30px;\n  background: #fff;\n  max-width: 20%;\n  flex-shrink: 1;\n}\n.formula-page .foot-form .search-items::before {\n  content: \"\";\n  display: block;\n  position: absolute;\n  left: 15px;\n  top: 9px;\n  background-image: url(../../assets/demo-ui/images/search-icons.png);\n  background-size: contain;\n  background-repeat: no-repeat;\n  width: 17px;\n  height: 17px;\n}\n.formula-page .foot-form .search-items .mb-3 {\n  margin-bottom: 0px !important;\n}\n.formula-page .foot-form .search-items select.form-select {\n  border: 0px;\n  margin: 0px;\n  box-shadow: none;\n}\n.formula-page .foot-form .search-items select.form-select:focus, .formula-page .foot-form .search-items select.form-select:hover {\n  box-shadow: none;\n}\n.formula-page .foot-form .btn {\n  padding: 10px 25px !important;\n}\n.formula-page .editbtns {\n  background: transparent;\n  box-shadow: none;\n  border: 0;\n}\n.formula-page .delet-icon {\n  text-align: center;\n}\n.formula-page span.tags {\n  padding: 5px 21px;\n  border-radius: 50px;\n  background: #dddddd;\n  font-size: 13px;\n  margin-left: 20px;\n}\n\n.equation-modal .modal-content {\n  min-width: 700px;\n}\n.equation-modal .modal-content textarea {\n  height: 200px;\n  resize: none;\n  box-shadow: none;\n  margin-bottom: 24px;\n}\n.equation-modal .modal-content textarea:hover, .equation-modal .modal-content textarea:focus {\n  box-shadow: none;\n}\n.equation-modal .modal-content .search-input {\n  background: #ffffff;\n  border: 1px solid #1d1d1d;\n  border-radius: 50px;\n  color: #1d1d1d;\n  font-family: \"Poppins\";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 21px;\n  padding: 11px 24px;\n  box-shadow: none;\n}\n.equation-modal .modal-content table tr td,\n.equation-modal .modal-content table tr th {\n  padding: 10px 20px;\n}\n.equation-modal .modal-content .rounded-3 {\n  border: 1px solid #cacaca;\n  border-radius: 10px !important;\n  margin-top: 16px;\n  margin-bottom: 50px;\n}\n.equation-modal .modal-head {\n  padding-left: 30px;\n  padding-right: 30px;\n}\n.equation-modal .modal-body {\n  padding-left: 30px;\n  padding-right: 30px;\n}\n.equation-modal .modal-footer {\n  padding: 26px 30px 50px;\n}\n.equation-modal .modal-footer button {\n  border-radius: 50px;\n  font-size: 15px;\n  padding: 9px 25px;\n  width: 100px;\n}\n.equation-modal .modal-footer button .btn-secondary-1 {\n  border: 1px solid #1d1d1d;\n  color: #1d1d1d !important;\n  background-color: #ffffff;\n}\n.equation-modal .modal-footer button .btn-secondary {\n  background-color: #1d1d1d;\n}\n.equation-modal.twocol .modal-dialog {\n  max-width: 1000px;\n}\n\n.foot-save-btn {\n  border-radius: 50px;\n  font-size: 15px;\n  padding: 9px 40px;\n  width: 142px;\n}\n\n.listing-table {\n  margin-bottom: 30px;\n}\n\n.equation-box {\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  padding: 16px;\n  border-radius: 8px;\n  background-color: #fff;\n}\n\n.equation-box .text-primary {\n  font-weight: bold;\n}\n\n.formula_acceptance {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex-wrap: nowrap;\n  gap: 18px;\n  padding: 27px 35px;\n  background: #ffffff;\n  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.12);\n  border-radius: 10px;\n  margin-bottom: 36px;\n  margin-top: 30px;\n}\n@media (max-width: 767px) {\n  .formula_acceptance {\n    flex-direction: column;\n  }\n}\n.formula_acceptance label {\n  font-family: \"Poppins\", sans-serif;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 27px;\n  color: #1d1d1d;\n  margin-right: 45px;\n}\n.formula_acceptance .data-field {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 14px;\n  min-width: 40%;\n}\n@media (max-width: 992px) {\n  .formula_acceptance .data-field {\n    min-width: 30%;\n  }\n}\n.formula_acceptance .data-field span {\n  font-family: \"Poppins\", sans-serif;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 21px;\n  color: #5e5e5e;\n}\n.formula_acceptance .data-field .auto-generate {\n  margin-bottom: 0px !important;\n  border: 1px solid #c8c8c8;\n  border-radius: 4px;\n  display: flex;\n  flex-wrap: nowrap;\n}\n.formula_acceptance .data-field .auto-generate .form-control {\n  border: 0px !important;\n  box-shadow: none;\n}\n.formula_acceptance .data-field .auto-generate .form-control:hover {\n  box-shadow: none;\n}\n.formula_acceptance .data-field .auto-generate span {\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  background-color: #f2f2f2;\n  padding: 5px 10px;\n  width: 35px;\n  height: 35px;\n  text-align: center;\n}\n.formula_acceptance .data-field input {\n  flex-shrink: 1;\n}\n\n.filter-search header {\n  padding: 0 !important;\n}\n\n.app-inner-layout.rm-sidebar .app-inner-layout__wrapper .app-inner-layout__content {\n  width: auto;\n  float: none;\n}\n.app-inner-layout .app-inner-layout__header {\n  width: 100%;\n  padding: 1.5rem;\n  text-align: left;\n  border-bottom: #e9ecef solid 1px;\n}\n.app-inner-layout .app-inner-layout__header .app-page-title {\n  margin: 0;\n  padding: 0;\n  background: transparent;\n}\n.app-inner-layout .app-inner-layout__header-boxed {\n  padding: 1.5rem;\n}\n.app-inner-layout .app-inner-layout__header-boxed .app-inner-layout__header {\n  border-radius: 0.3rem;\n}\n.app-inner-layout .app-inner-layout__wrapper {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  min-height: 100vh;\n}\n.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__content {\n  flex: 1;\n  display: flex;\n}\n.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__content.card {\n  box-shadow: 0 0 0 0 transparent;\n  border-radius: 0;\n  border: 0;\n}\n.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__content .app-inner-layout__top-pane {\n  display: flex;\n  align-content: center;\n  align-items: center;\n  text-align: left;\n  padding: 0.75rem 1.5rem;\n}\n.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__content .pane-left {\n  display: flex;\n  align-items: center;\n}\n.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__content .pane-right {\n  display: flex;\n  align-items: center;\n  margin-left: auto;\n}\n.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__content .app-inner-layout__bottom-pane {\n  padding: 1.5rem;\n  border-top: #e9ecef solid 1px;\n}\n.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__sidebar {\n  width: 270px;\n  list-style: none;\n  text-align: left;\n  order: -1;\n  flex: 0 0 270px;\n  display: flex;\n  margin: 0;\n  position: relative;\n}\n.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__sidebar .dropdown-item {\n  white-space: normal;\n}\n.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__sidebar.card {\n  box-shadow: 0 0 0 0 transparent;\n  border-radius: 0;\n  background: #f8f9fa;\n  border: 0;\n  border-right: #e9ecef solid 1px;\n  border-left: #e9ecef solid 1px;\n}\n.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__sidebar .app-inner-layout__sidebar-footer,\n.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__sidebar .app-inner-layout__sidebar-header {\n  background: #f8f9fa;\n}\n.app-inner-layout .app-inner-layout__wrapper .app-inner-layout__aside {\n  width: 60px;\n}\n.app-inner-layout .app-inner-layout__footer {\n  width: 100%;\n  height: 50px;\n}\n\n.app-wrapper-footer .app-footer {\n  border-top: #e9ecef solid 1px;\n}\n.app-wrapper-footer .app-footer .app-footer__inner {\n  border-left: #e9ecef solid 1px;\n}\n\n.chat-layout.app-inner-layout .app-inner-layout__sidebar {\n  width: 360px;\n  flex: 0 0 360px;\n}\n.chat-layout .app-inner-layout__top-pane h4, .chat-layout .app-inner-layout__top-pane .h4 {\n  font-size: 1.1rem;\n}\n.chat-layout .app-inner-layout__top-pane h4 div, .chat-layout .app-inner-layout__top-pane .h4 div {\n  font-size: 0.88rem;\n}\n.chat-layout .chat-box-wrapper {\n  padding: 1.5rem;\n}\n\n@media (max-width: 991.98px) {\n  .chat-layout.app-inner-layout .app-inner-layout__sidebar .widget-content .widget-content-left .widget-subheading {\n    white-space: normal;\n  }\n}\n.mobile-app-menu-btn {\n  display: none;\n  margin: 3px 1.5rem 0 0;\n}\n\n@media (max-width: 767.98px) {\n  .app-inner-layout__sidebar {\n    display: none !important;\n  }\n  .mobile-app-menu-btn {\n    display: block;\n  }\n  .open-mobile-menu .app-inner-layout__sidebar {\n    display: block !important;\n  }\n}\n/*\n * Container style\n */\n.ps {\n  overflow: hidden !important;\n  overflow-anchor: none;\n  touch-action: auto;\n}\n\n/*\n * Scrollbar rail styles\n */\n.ps__rail-x {\n  display: none !important;\n  opacity: 0;\n  transition: background-color 0.2s linear, opacity 0.2s linear;\n  height: 15px;\n  /* there must be 'bottom' or 'top' for ps__rail-x */\n  bottom: 0;\n  /* please don't change 'position' */\n  position: absolute;\n  z-index: 7;\n}\n\n.ps__rail-y {\n  display: none;\n  opacity: 0;\n  transition: background-color 0.2s linear, opacity 0.2s linear;\n  width: 15px;\n  /* there must be 'right' or 'left' for ps__rail-y */\n  right: 0;\n  /* please don't change 'position' */\n  position: absolute;\n  border-radius: 50px;\n  z-index: 7;\n}\n\n.ps--active-x > .ps__rail-x,\n.ps--active-y > .ps__rail-y {\n  display: block;\n  background-color: transparent;\n}\n\n.ps:hover > .ps__rail-x,\n.ps:hover > .ps__rail-y,\n.ps--focus > .ps__rail-x,\n.ps--focus > .ps__rail-y,\n.ps--scrolling-x > .ps__rail-x,\n.ps--scrolling-y > .ps__rail-y {\n  opacity: 0.6;\n}\n\n.ps__rail-x:hover,\n.ps__rail-y:hover,\n.ps__rail-x:focus,\n.ps__rail-y:focus {\n  background-color: rgba(0, 0, 0, 0.1);\n  opacity: 0.9;\n}\n\n/*\n * Scrollbar thumb styles\n */\n.ps__thumb-x {\n  background-color: rgba(0, 0, 0, 0.1);\n  border-radius: 6px;\n  transition: background-color 0.2s linear, height 0.2s ease-in-out;\n  height: 6px;\n  /* there must be 'bottom' for ps__thumb-x */\n  bottom: 2px;\n  /* please don't change 'position' */\n  position: absolute;\n}\n\n.ps__thumb-y {\n  background-color: rgba(0, 0, 0, 0.1);\n  border-radius: 6px;\n  transition: background-color 0.2s linear, width 0.2s ease-in-out;\n  width: 6px;\n  /* there must be 'right' for ps__thumb-y */\n  right: 2px;\n  /* please don't change 'position' */\n  position: absolute;\n}\n\n.ps__rail-x:hover > .ps__thumb-x,\n.ps__rail-x:focus > .ps__thumb-x {\n  background-color: rgba(0, 0, 0, 0.12);\n  height: 11px;\n}\n\n.ps__rail-y:hover > .ps__thumb-y,\n.ps__rail-y:focus > .ps__thumb-y {\n  background-color: rgba(0, 0, 0, 0.12);\n  width: 11px;\n}\n\n/* MS supports */\n@supports (-ms-overflow-style: none) {\n  .ps {\n    overflow: auto !important;\n  }\n}\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  .ps {\n    overflow: auto !important;\n  }\n}\n.scrollbar-container {\n  position: relative;\n  height: 100%;\n}\n\n.scroll-area {\n  overflow-x: hidden;\n  height: 400px;\n}\n\n.scroll-area-xs {\n  height: 150px;\n  overflow-x: hidden;\n}\n\n.scroll-area-sm {\n  height: 200px;\n  overflow-x: hidden;\n}\n\n.scroll-area-md {\n  height: 300px;\n  overflow-x: hidden;\n}\n\n.scroll-area-lg {\n  height: 400px;\n  overflow-x: hidden;\n}\n\n.scroll-area-x {\n  overflow-x: auto;\n  width: 100%;\n  max-width: 100%;\n}\n\n.shadow-overflow {\n  position: relative;\n}\n.shadow-overflow::after, .shadow-overflow::before {\n  width: 100%;\n  bottom: auto;\n  top: 0;\n  left: 0;\n  height: 1.5rem;\n  position: absolute;\n  z-index: 10;\n  content: \"\";\n  background: linear-gradient(to bottom, rgb(255, 255, 255) 20%, rgba(255, 255, 255, 0) 100%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#ffffff\", endColorstr=\"#00ffffff\", GradientType=0);\n}\n.shadow-overflow::after {\n  bottom: 0;\n  top: auto;\n  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgb(255, 255, 255) 80%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#00ffffff\", endColorstr=\"#ffffff\", GradientType=0);\n}\n\n.rc-tabs {\n  box-sizing: border-box;\n  position: relative;\n  overflow: hidden;\n}\n\n.rc-tabs-bar,\n.rc-tabs-nav-container {\n  font-size: 14px;\n  line-height: 1.5;\n  box-sizing: border-box;\n  overflow: hidden;\n  position: relative;\n  white-space: nowrap;\n  outline: none;\n  zoom: 1;\n  transition: padding 0.45s;\n}\n\n.rc-tabs-ink-bar {\n  margin-top: 0;\n  border-radius: 0.25rem;\n  box-shadow: 0 16px 26px -10px rgba(84, 92, 216, 0.56), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(84, 92, 216, 0.2);\n}\n\n.rc-tabs-ink-bar-animated {\n  transition: all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1) 0s;\n}\n\n.rc-tabs-tab-prev,\n.rc-tabs-tab-next {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  z-index: 1;\n  line-height: 36px;\n  cursor: pointer;\n  border: none;\n  background-color: transparent;\n  position: absolute;\n}\n\n.rc-tabs-tab-prev-icon,\n.rc-tabs-tab-next-icon {\n  position: relative;\n  display: inline-block;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  line-height: inherit;\n  vertical-align: baseline;\n  text-align: center;\n  text-transform: none;\n  font-smoothing: antialiased;\n  text-stroke-width: 0;\n  font-family: sans-serif;\n}\n\n.rc-tabs-tab-prev-icon:before,\n.rc-tabs-tab-next-icon:before {\n  display: block;\n}\n\n.rc-tabs-tab-btn-disabled {\n  cursor: default;\n  color: #495057;\n}\n\n.rc-tabs-nav-wrap {\n  overflow: hidden;\n}\n\n.rc-tabs-nav {\n  box-sizing: border-box;\n  padding-left: 0;\n  position: relative;\n  margin: 0;\n  float: left;\n  list-style: none;\n  display: inline-block;\n  transform-origin: 0 0;\n}\n.rc-tabs-nav > div:first-child {\n  z-index: 5;\n  position: relative;\n}\n\n.rc-tabs-nav-animated {\n  transition: transform 0.5s cubic-bezier(0.35, 0, 0.25, 1);\n}\n\n.rc-tabs-nav:before,\n.rc-tabs-nav:after {\n  display: table;\n  content: \" \";\n}\n\n.rc-tabs-nav:after {\n  clear: both;\n}\n\n.rc-tabs-tab {\n  box-sizing: border-box;\n  position: relative;\n  display: block;\n  transition: color 0.3s cubic-bezier(0.35, 0, 0.25, 1);\n  padding: 8px 20px;\n  cursor: pointer;\n}\n\n.rc-tabs-tab:hover {\n  color: #545cd8;\n}\n\n.rc-tabs-tab-active,\n.rc-tabs-tab-active:hover {\n  color: #fff;\n  cursor: default;\n  transform: translateZ(0);\n}\n\n.rc-tabs-tab-disabled {\n  cursor: default;\n  color: #495057;\n}\n\n.rc-tabs-tab-disabled:hover {\n  color: #495057;\n}\n\n.rc-tabs-content {\n  zoom: 1;\n}\n\n.rc-tabs-content .rc-tabs-tabpane {\n  overflow: hidden;\n}\n\n.rc-tabs-content-animated {\n  transition: transform 0.3s cubic-bezier(0.35, 0, 0.25, 1), margin-left 0.3s cubic-bezier(0.35, 0, 0.25, 1), margin-top 0.3s cubic-bezier(0.35, 0, 0.25, 1);\n  display: -ms-flexbox;\n  display: flex;\n  will-change: transform;\n}\n\n.rc-tabs-content-animated .rc-tabs-tabpane {\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n}\n\n.no-flexbox .rc-tabs-content {\n  transform: none !important;\n  overflow: hidden;\n}\n\n.no-csstransitions .rc-tabs-tabpane-inactive,\n.no-flexbox .rc-tabs-tabpane-inactive,\n.rc-tabs-content-no-animated .rc-tabs-tabpane-inactive {\n  display: none;\n}\n\n.rc-tabs-bottom .rc-tabs-tab-arrow-show {\n  opacity: 1;\n  width: 100%;\n  height: 35px;\n}\n\n.rc-tabs-top .rc-tabs-tab-arrow-show {\n  opacity: 1;\n  width: 100%;\n  height: 35px;\n}\n\n.rc-tabs-top .rc-tabs-content {\n  width: 100%;\n}\n\n.rc-tabs-top .rc-tabs-nav-container-scrolling {\n  padding-left: 35px;\n  padding-right: 35px;\n}\n\n.rc-tabs-top .rc-tabs-nav-scroll {\n  width: 99999px;\n}\n\n.rc-tabs-top .rc-tabs-nav-swipe {\n  position: relative;\n  left: 0;\n}\n\n.rc-tabs-top .rc-tabs-nav-swipe .rc-tabs-nav {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex: 1;\n  flex: 1;\n  width: 100%;\n}\n\n.rc-tabs-top .rc-tabs-nav-swipe .rc-tabs-nav .rc-tabs-tab {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n  margin-right: 0;\n  padding: 8px 0;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n.rc-tabs-top .rc-tabs-nav-wrap {\n  width: 100%;\n  padding: 1.5rem 0.75rem;\n}\n\n.rc-tabs-top .rc-tabs-content-animated {\n  -ms-flex-direction: row;\n  flex-direction: row;\n}\n\n.rc-tabs-top .rc-tabs-content-animated .rc-tabs-tabpane {\n  width: 100%;\n}\n\n.rc-tabs-top .rc-tabs-tab-next {\n  right: 2px;\n}\n\n.rc-tabs-top .rc-tabs-tab-next-icon:before {\n  content: \">\";\n}\n\n.rc-tabs-top .rc-tabs-tab-prev {\n  left: 0;\n}\n\n.rc-tabs-top .rc-tabs-tab-prev-icon:before {\n  content: \"<\";\n}\n\n.rc-tabs-top .rc-tabs-tab-prev,\n.rc-tabs-top .rc-tabs-tab-next {\n  margin-right: -2px;\n  width: 0;\n  height: 0;\n  top: 0;\n  text-align: center;\n  opacity: 0;\n  transition: width 0.3s, height 0.3s, opacity 0.3s;\n}\n\n.rc-tabs-top .rc-tabs-tab-arrow-show {\n  opacity: 1;\n  width: 35px;\n  height: 100%;\n}\n\n.rc-tabs-top .rc-tabs-ink-bar {\n  height: 35px;\n  bottom: 0;\n  left: 0;\n  background: #545cd8;\n}\n\n.rc-tabs-top .rc-tabs-tab {\n  float: left;\n  height: 100%;\n  line-height: 1.3;\n  margin-right: 0.75rem;\n}\n\n.rc-tabs-top .rc-tabs-tabpane-inactive {\n  height: 0;\n  overflow: visible;\n}\n\n/*!\n * Ladda\n * http://lab.hakim.se/ladda\n * MIT licensed\n *\n * Copyright (C) 2018 Hakim El Hattab, http://hakim.se\n */\n/*************************************\n * CONFIG\n */\n/*************************************\n * MIXINS\n */\n/*************************************\n * Opacity animation for spin.js\n */\n@keyframes ladda-spinner-line-fade {\n  0%, 100% {\n    opacity: 0.22; /* minimum opacity */\n  }\n  1% {\n    opacity: 1;\n  }\n}\n/*************************************\n * BUTTON BASE\n */\n.ladda-button {\n  position: relative;\n}\n\n/* Spinner animation */\n.ladda-button .ladda-spinner {\n  position: absolute;\n  z-index: 2;\n  display: inline-block;\n  width: 32px;\n  top: 50%;\n  margin-top: 0;\n  opacity: 0;\n  pointer-events: none;\n}\n\n/* Button label */\n.ladda-button .ladda-label {\n  position: relative;\n  z-index: 3;\n}\n\n[class*=btn-outline-] .ladda-spinner div div div {\n  background: #000 !important;\n}\n[class*=btn-outline-].ladda-button .ladda-label {\n  transition: none !important;\n}\n\n/* Progress bar */\n.ladda-button .ladda-progress {\n  position: absolute;\n  width: 0;\n  height: 100%;\n  left: 0;\n  top: 0;\n  background: rgba(0, 0, 0, 0.2);\n  display: none;\n  transition: 0.1s linear all !important;\n}\n\n.ladda-button[data-loading] .ladda-progress {\n  display: block;\n}\n\n/*************************************\n * EASING\n */\n.ladda-button,\n.ladda-button .ladda-spinner,\n.ladda-button .ladda-label {\n  transition: 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) all !important;\n}\n\n.ladda-button[data-style=zoom-in],\n.ladda-button[data-style=zoom-in] .ladda-spinner,\n.ladda-button[data-style=zoom-in] .ladda-label,\n.ladda-button[data-style=zoom-out],\n.ladda-button[data-style=zoom-out] .ladda-spinner,\n.ladda-button[data-style=zoom-out] .ladda-label {\n  transition: 0.3s ease all !important;\n}\n\n/*************************************\n * EXPAND RIGHT\n */\n.ladda-button[data-style=expand-right] .ladda-spinner {\n  right: -6px;\n}\n.ladda-button[data-style=expand-right][data-size=s] .ladda-spinner, .ladda-button[data-style=expand-right][data-size=xs] .ladda-spinner {\n  right: -12px;\n}\n.ladda-button[data-style=expand-right][data-loading] {\n  padding-right: 56px;\n}\n.ladda-button[data-style=expand-right][data-loading] .ladda-spinner {\n  opacity: 1;\n}\n.ladda-button[data-style=expand-right][data-loading][data-size=s], .ladda-button[data-style=expand-right][data-loading][data-size=xs] {\n  padding-right: 40px;\n}\n\n/*************************************\n * EXPAND LEFT\n */\n.ladda-button[data-style=expand-left] .ladda-spinner {\n  left: 26px;\n}\n.ladda-button[data-style=expand-left][data-size=s] .ladda-spinner, .ladda-button[data-style=expand-left][data-size=xs] .ladda-spinner {\n  left: 4px;\n}\n.ladda-button[data-style=expand-left][data-loading] {\n  padding-left: 56px;\n}\n.ladda-button[data-style=expand-left][data-loading] .ladda-spinner {\n  opacity: 1;\n}\n.ladda-button[data-style=expand-left][data-loading][data-size=s], .ladda-button[data-style=expand-left][data-loading][data-size=xs] {\n  padding-left: 40px;\n}\n\n/*************************************\n * EXPAND UP\n */\n.ladda-button[data-style=expand-up] {\n  overflow: hidden;\n}\n.ladda-button[data-style=expand-up] .ladda-spinner {\n  top: -32px;\n  left: 50%;\n  margin-left: 0;\n}\n.ladda-button[data-style=expand-up][data-loading] {\n  padding-top: 54px;\n}\n.ladda-button[data-style=expand-up][data-loading] .ladda-spinner {\n  opacity: 1;\n  top: 26px;\n  margin-top: 0;\n}\n.ladda-button[data-style=expand-up][data-loading][data-size=s], .ladda-button[data-style=expand-up][data-loading][data-size=xs] {\n  padding-top: 32px;\n}\n.ladda-button[data-style=expand-up][data-loading][data-size=s] .ladda-spinner, .ladda-button[data-style=expand-up][data-loading][data-size=xs] .ladda-spinner {\n  top: 4px;\n}\n\n/*************************************\n * EXPAND DOWN\n */\n.ladda-button[data-style=expand-down] {\n  overflow: hidden;\n}\n.ladda-button[data-style=expand-down] .ladda-spinner {\n  top: 52px;\n  left: 50%;\n  margin-left: 0;\n}\n.ladda-button[data-style=expand-down][data-size=s] .ladda-spinner, .ladda-button[data-style=expand-down][data-size=xs] .ladda-spinner {\n  top: 40px;\n}\n.ladda-button[data-style=expand-down][data-loading] {\n  padding-bottom: 54px;\n}\n.ladda-button[data-style=expand-down][data-loading] .ladda-spinner {\n  opacity: 1;\n}\n.ladda-button[data-style=expand-down][data-loading][data-size=s], .ladda-button[data-style=expand-down][data-loading][data-size=xs] {\n  padding-bottom: 32px;\n}\n\n/*************************************\n * SLIDE LEFT\n */\n.ladda-button[data-style=slide-left] {\n  overflow: hidden;\n}\n.ladda-button[data-style=slide-left] .ladda-label {\n  position: relative;\n}\n.ladda-button[data-style=slide-left] .ladda-spinner {\n  left: 100%;\n  margin-left: 0;\n}\n.ladda-button[data-style=slide-left][data-loading] .ladda-label {\n  opacity: 0;\n  left: -100%;\n}\n.ladda-button[data-style=slide-left][data-loading] .ladda-spinner {\n  opacity: 1;\n  left: 50%;\n}\n\n/*************************************\n * SLIDE RIGHT\n */\n.ladda-button[data-style=slide-right] {\n  overflow: hidden;\n}\n.ladda-button[data-style=slide-right] .ladda-label {\n  position: relative;\n}\n.ladda-button[data-style=slide-right] .ladda-spinner {\n  right: 100%;\n  margin-left: 0;\n  left: 16px;\n}\n[dir=rtl] .ladda-button[data-style=slide-right] .ladda-spinner {\n  right: auto;\n}\n.ladda-button[data-style=slide-right][data-loading] .ladda-label {\n  opacity: 0;\n  left: 100%;\n}\n.ladda-button[data-style=slide-right][data-loading] .ladda-spinner {\n  opacity: 1;\n  left: 50%;\n}\n\n/*************************************\n * SLIDE UP\n */\n.ladda-button[data-style=slide-up] {\n  overflow: hidden;\n}\n.ladda-button[data-style=slide-up] .ladda-label {\n  position: relative;\n}\n.ladda-button[data-style=slide-up] .ladda-spinner {\n  left: 50%;\n  margin-left: 0;\n  margin-top: 1em;\n}\n.ladda-button[data-style=slide-up][data-loading] .ladda-label {\n  opacity: 0;\n  top: -1em;\n}\n.ladda-button[data-style=slide-up][data-loading] .ladda-spinner {\n  opacity: 1;\n  margin-top: 0;\n}\n\n/*************************************\n * SLIDE DOWN\n */\n.ladda-button[data-style=slide-down] {\n  overflow: hidden;\n}\n.ladda-button[data-style=slide-down] .ladda-label {\n  position: relative;\n}\n.ladda-button[data-style=slide-down] .ladda-spinner {\n  left: 50%;\n  margin-left: 0;\n  margin-top: -2em;\n}\n.ladda-button[data-style=slide-down][data-loading] .ladda-label {\n  opacity: 0;\n  top: 1em;\n}\n.ladda-button[data-style=slide-down][data-loading] .ladda-spinner {\n  opacity: 1;\n  margin-top: 0;\n}\n\n/*************************************\n * ZOOM-OUT\n */\n.ladda-button[data-style=zoom-out] {\n  overflow: hidden;\n}\n\n.ladda-button[data-style=zoom-out] .ladda-spinner {\n  left: 50%;\n  margin-left: 32px;\n  transform: scale(2.5);\n}\n\n.ladda-button[data-style=zoom-out] .ladda-label {\n  position: relative;\n  display: inline-block;\n}\n\n.ladda-button[data-style=zoom-out][data-loading] .ladda-label {\n  opacity: 0;\n  transform: scale(0.5);\n}\n\n.ladda-button[data-style=zoom-out][data-loading] .ladda-spinner {\n  opacity: 1;\n  margin-left: 0;\n  transform: none;\n}\n\n/*************************************\n * ZOOM-IN\n */\n.ladda-button[data-style=zoom-in] {\n  overflow: hidden;\n}\n\n.ladda-button[data-style=zoom-in] .ladda-spinner {\n  left: 50%;\n  margin-left: -16px;\n  transform: scale(0.2);\n}\n\n.ladda-button[data-style=zoom-in] .ladda-label {\n  position: relative;\n  display: inline-block;\n}\n\n.ladda-button[data-style=zoom-in][data-loading] .ladda-label {\n  opacity: 0;\n  transform: scale(2.2);\n}\n\n.ladda-button[data-style=zoom-in][data-loading] .ladda-spinner {\n  opacity: 1;\n  margin-left: 0;\n  transform: none;\n}\n\n/*************************************\n * CONTRACT\n */\n.ladda-button[data-style=contract] {\n  overflow: hidden;\n  width: 100px;\n}\n\n.ladda-button[data-style=contract] .ladda-spinner {\n  left: 50%;\n  margin-left: 0;\n}\n\n.ladda-button[data-style=contract][data-loading] {\n  border-radius: 50%;\n  width: 52px;\n}\n\n.ladda-button[data-style=contract][data-loading] .ladda-label {\n  opacity: 0;\n}\n\n.ladda-button[data-style=contract][data-loading] .ladda-spinner {\n  opacity: 1;\n}\n\n/*************************************\n * OVERLAY\n */\n.ladda-button[data-style=contract-overlay] {\n  overflow: hidden;\n  width: 100px;\n  box-shadow: 0px 0px 0px 2000px rgba(0, 0, 0, 0);\n}\n\n.ladda-button[data-style=contract-overlay] .ladda-spinner {\n  left: 50%;\n  margin-left: 0;\n}\n\n.ladda-button[data-style=contract-overlay][data-loading] {\n  border-radius: 50%;\n  width: 52px;\n  /*outline: 10000px solid rgba( 0, 0, 0, 0.5 );*/\n  box-shadow: 0px 0px 0px 2000px rgba(0, 0, 0, 0.8);\n}\n\n.ladda-button[data-style=contract-overlay][data-loading] .ladda-label {\n  opacity: 0;\n}\n\n.ladda-button[data-style=contract-overlay][data-loading] .ladda-spinner {\n  opacity: 1;\n}\n\n[dir=rtl] .ladda-spinner > div {\n  left: 25% !important;\n}\n\n/*!\n * Hamburgers\n * @description Tasty CSS-animated hamburgers\n * @author Jonathan Suh @jonsuh\n * @site https://jonsuh.com/hamburgers\n * @link https://github.com/jonsuh/hamburgers\n */\n.hamburger {\n  padding: 0px 0px;\n  display: inline-block;\n  cursor: pointer;\n  transition-property: opacity, filter;\n  transition-duration: 0.15s;\n  transition-timing-function: linear;\n  font: inherit;\n  color: inherit;\n  text-transform: none;\n  background-color: transparent;\n  border: 0;\n  margin: 0;\n  overflow: visible;\n}\n.hamburger:hover {\n  opacity: 0.7;\n}\n.hamburger.is-active:hover {\n  opacity: 0.7;\n}\n.hamburger.is-active .hamburger-inner,\n.hamburger.is-active .hamburger-inner::before,\n.hamburger.is-active .hamburger-inner::after {\n  background-color: #545cd8;\n}\n\n.hamburger-box {\n  width: 24px;\n  height: 14px;\n  display: inline-block;\n  position: relative;\n}\n\n.hamburger-inner {\n  display: block;\n  top: 50%;\n  margin-top: -1px;\n}\n.hamburger-inner, .hamburger-inner::before, .hamburger-inner::after {\n  width: 24px;\n  height: 2px;\n  background-color: #545cd8;\n  border-radius: 10px;\n  position: absolute;\n  transition-property: transform;\n  transition-duration: 0.15s;\n  transition-timing-function: ease;\n}\n.hamburger-inner::before, .hamburger-inner::after {\n  content: \"\";\n  display: block;\n}\n.hamburger-inner::before {\n  top: -6px;\n}\n.hamburger-inner::after {\n  bottom: -6px;\n}\n\n/*\n * Elastic\n */\n.hamburger--elastic .hamburger-inner {\n  top: 1px;\n  transition-duration: 0.275s;\n  transition-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);\n}\n.hamburger--elastic .hamburger-inner::before {\n  top: 6px;\n  transition: opacity 0.125s 0.275s ease;\n}\n.hamburger--elastic .hamburger-inner::after {\n  top: 12px;\n  transition: transform 0.275s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n}\n.hamburger--elastic.is-active .hamburger-inner {\n  transform: translate3d(0, 6px, 0) rotate(135deg);\n  transition-delay: 0.075s;\n}\n.hamburger--elastic.is-active .hamburger-inner::before {\n  transition-delay: 0s;\n  opacity: 0;\n}\n.hamburger--elastic.is-active .hamburger-inner::after {\n  transform: translate3d(0, -12px, 0) rotate(-270deg);\n  transition-delay: 0.075s;\n}\n\n.drawer-content-wrapper {\n  background: #fff;\n  position: relative;\n  padding: 1.5rem;\n}\n.drawer-content-wrapper .drawer-heading {\n  font-size: 0.968rem;\n  color: #495057;\n  margin: 0;\n  background: #f8f9fa;\n  padding: 0.75rem 1.5rem;\n  border-bottom: #dee2e6 solid 1px;\n  border-top: #dee2e6 solid 1px;\n}\n.drawer-content-wrapper .drawer-heading:first-child {\n  border-top: 0;\n}\n.drawer-content-wrapper .drawer-section {\n  padding: 1.5rem;\n}\n.drawer-content-wrapper > .app-sidebar__heading:first-child {\n  margin-top: 0;\n}\n\n.drawer-nav-btn {\n  border-radius: 30px;\n  background: #fff;\n  position: fixed;\n  right: 0.75rem;\n  top: 0.75rem;\n  padding: 0.5rem;\n  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);\n  z-index: 20;\n}\n.drawer-nav-btn .hamburger {\n  margin-top: 4px;\n}\n\n.sa-icon {\n  width: 80px;\n  height: 80px;\n  border: 4px solid #dee2e6;\n  -webkit-border-radius: 40px;\n  border-radius: 50%;\n  margin: 20px auto;\n  padding: 0;\n  position: relative;\n  box-sizing: content-box;\n}\n.sa-icon.sa-error {\n  border-color: #d92550;\n}\n.sa-icon.sa-error .sa-x-mark {\n  position: relative;\n  display: block;\n}\n.sa-icon.sa-error .sa-line {\n  position: absolute;\n  height: 5px;\n  width: 47px;\n  background-color: #d92550;\n  display: block;\n  top: 37px;\n  border-radius: 2px;\n}\n.sa-icon.sa-error .sa-line.sa-left {\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg);\n  left: 17px;\n}\n.sa-icon.sa-error .sa-line.sa-right {\n  -webkit-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n  right: 16px;\n}\n.sa-icon.sa-warning {\n  border-color: #f7b924;\n}\n.sa-icon.sa-warning .sa-body {\n  position: absolute;\n  width: 5px;\n  height: 47px;\n  left: 50%;\n  top: 10px;\n  -webkit-border-radius: 2px;\n  border-radius: 2px;\n  margin-left: -2px;\n  background-color: #f7b924;\n}\n.sa-icon.sa-warning .sa-dot {\n  position: absolute;\n  width: 7px;\n  height: 7px;\n  -webkit-border-radius: 50%;\n  border-radius: 50%;\n  margin-left: -3px;\n  left: 50%;\n  bottom: 10px;\n  background-color: #f7b924;\n}\n.sa-icon.sa-info {\n  border-color: #30b1ff;\n}\n.sa-icon.sa-info::before {\n  content: \"\";\n  position: absolute;\n  width: 5px;\n  height: 29px;\n  left: 50%;\n  bottom: 17px;\n  border-radius: 2px;\n  margin-left: -2px;\n  background-color: #30b1ff;\n}\n.sa-icon.sa-info::after {\n  content: \"\";\n  position: absolute;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  margin-left: -3px;\n  top: 19px;\n  background-color: #30b1ff;\n}\n.sa-icon.sa-success {\n  border-color: #3ac47d;\n}\n.sa-icon.sa-success::before, .sa-icon.sa-success::after {\n  content: \"\";\n  -webkit-border-radius: 40px;\n  border-radius: 50%;\n  position: absolute;\n  width: 60px;\n  height: 120px;\n  background: #fff;\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n.sa-icon.sa-success::before {\n  -webkit-border-radius: 120px 0 0 120px;\n  border-radius: 120px 0 0 120px;\n  top: -7px;\n  left: -33px;\n  -webkit-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n  -webkit-transform-origin: 60px 60px;\n  transform-origin: 60px 60px;\n}\n.sa-icon.sa-success::after {\n  -webkit-border-radius: 0 120px 120px 0;\n  border-radius: 0 120px 120px 0;\n  top: -11px;\n  left: 30px;\n  -webkit-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n  -webkit-transform-origin: 0 60px;\n  transform-origin: 0 60px;\n}\n.sa-icon.sa-success .sa-placeholder {\n  width: 80px;\n  height: 80px;\n  border: 4px solid rgba(165, 220, 134, 0.2);\n  -webkit-border-radius: 40px;\n  border-radius: 40px;\n  border-radius: 50%;\n  box-sizing: content-box;\n  position: absolute;\n  left: -4px;\n  top: -4px;\n  z-index: 2;\n}\n.sa-icon.sa-success .sa-fix {\n  width: 5px;\n  height: 90px;\n  background-color: #fff;\n  position: absolute;\n  left: 28px;\n  top: 8px;\n  z-index: 1;\n  -webkit-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n}\n.sa-icon.sa-success .sa-line {\n  height: 5px;\n  background-color: #3ac47d;\n  display: block;\n  border-radius: 2px;\n  position: absolute;\n  z-index: 2;\n}\n.sa-icon.sa-success .sa-line.sa-tip {\n  width: 25px;\n  left: 14px;\n  top: 46px;\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n.sa-icon.sa-success .sa-line.sa-long {\n  width: 47px;\n  right: 8px;\n  top: 38px;\n  -webkit-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n}\n.sa-icon.sa-custom {\n  background-size: contain;\n  border-radius: 0;\n  border: none;\n  background-position: center center;\n  background-repeat: no-repeat;\n}\n\n@-webkit-keyframes animateSuccessTip {\n  0% {\n    width: 0;\n    left: 1px;\n    top: 19px;\n  }\n  54% {\n    width: 0;\n    left: 1px;\n    top: 19px;\n  }\n  70% {\n    width: 50px;\n    left: -8px;\n    top: 37px;\n  }\n  84% {\n    width: 17px;\n    left: 21px;\n    top: 48px;\n  }\n  100% {\n    width: 25px;\n    left: 14px;\n    top: 45px;\n  }\n}\n@keyframes animateSuccessTip {\n  0% {\n    width: 0;\n    left: 1px;\n    top: 19px;\n  }\n  54% {\n    width: 0;\n    left: 1px;\n    top: 19px;\n  }\n  70% {\n    width: 50px;\n    left: -8px;\n    top: 37px;\n  }\n  84% {\n    width: 17px;\n    left: 21px;\n    top: 48px;\n  }\n  100% {\n    width: 25px;\n    left: 14px;\n    top: 45px;\n  }\n}\n@-webkit-keyframes animateSuccessLong {\n  0% {\n    width: 0;\n    right: 46px;\n    top: 54px;\n  }\n  65% {\n    width: 0;\n    right: 46px;\n    top: 54px;\n  }\n  84% {\n    width: 55px;\n    right: 0;\n    top: 35px;\n  }\n  100% {\n    width: 47px;\n    right: 8px;\n    top: 38px;\n  }\n}\n@keyframes animateSuccessLong {\n  0% {\n    width: 0;\n    right: 46px;\n    top: 54px;\n  }\n  65% {\n    width: 0;\n    right: 46px;\n    top: 54px;\n  }\n  84% {\n    width: 55px;\n    right: 0;\n    top: 35px;\n  }\n  100% {\n    width: 47px;\n    right: 8px;\n    top: 38px;\n  }\n}\n.animateSuccessTip {\n  -webkit-animation: animateSuccessTip 0.75s;\n  animation: animateSuccessTip 0.75s;\n}\n\n.animateSuccessLong {\n  -webkit-animation: animateSuccessLong 0.75s;\n  animation: animateSuccessLong 0.75s;\n}\n\n.sa-icon.sa-success.animate::after {\n  -webkit-animation: rotatePlaceholder 4.25s ease-in;\n  animation: rotatePlaceholder 4.25s ease-in;\n}\n\n/* Success icon */\n.sweet-alert .sa-icon.sa-success {\n  border-color: transparent \\9 ;\n}\n\n.sweet-alert .sa-icon.sa-success .sa-line.sa-tip {\n  -ms-transform: rotate(45deg) \\9 ;\n}\n\n.sweet-alert .sa-icon.sa-sucsuccesscess .sa-line.sa-long {\n  -ms-transform: rotate(-45deg) \\9 ;\n}\n\n.Toastify__toast-container {\n  z-index: 9999;\n  position: fixed;\n  padding: 0;\n  width: 320px;\n  box-sizing: border-box;\n  color: #fff;\n}\n.Toastify__toast-container--top-left {\n  top: 1rem;\n  left: 1rem;\n}\n.Toastify__toast-container--top-center {\n  top: 1rem;\n  left: 50%;\n  margin-left: -160px;\n}\n.Toastify__toast-container--top-right {\n  top: 1rem;\n  right: 1rem;\n}\n.Toastify__toast-container--bottom-left {\n  bottom: 1rem;\n  left: 1rem;\n}\n.Toastify__toast-container--bottom-center {\n  bottom: 1rem;\n  left: 50%;\n  margin-left: -160px;\n}\n.Toastify__toast-container--bottom-right {\n  bottom: 1rem;\n  right: 1rem;\n}\n\n@media only screen and (max-width : 480px) {\n  .Toastify__toast-container {\n    width: 100vw;\n    padding: 0;\n    left: 0;\n    margin: 0;\n  }\n  .Toastify__toast-container--top-left, .Toastify__toast-container--top-center, .Toastify__toast-container--top-right {\n    top: 0;\n  }\n  .Toastify__toast-container--bottom-left, .Toastify__toast-container--bottom-center, .Toastify__toast-container--bottom-right {\n    bottom: 0;\n  }\n  .Toastify__toast-container--rtl {\n    right: 0;\n    left: initial;\n  }\n}\n.Toastify__toast {\n  position: relative;\n  min-height: 54px;\n  box-sizing: border-box;\n  margin-bottom: 1rem;\n  padding: 1rem;\n  border-radius: 0.25rem;\n  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);\n  display: flex;\n  justify-content: space-between;\n  max-height: 800px;\n  overflow: hidden;\n  font-family: sans-serif;\n  cursor: pointer;\n  direction: ltr;\n}\n.Toastify__toast--rtl {\n  direction: rtl;\n}\n.Toastify__toast--default {\n  background: #fff;\n  color: #495057;\n  box-shadow: 0 0.66875rem 2.3875rem rgba(84, 92, 216, 0.03), 0 1.1375rem 1.60625rem rgba(84, 92, 216, 0.03), 0 0.45rem 0.73125rem rgba(84, 92, 216, 0.05), 0 0.325rem 0.3875rem rgba(84, 92, 216, 0.03);\n}\n.Toastify__toast--info {\n  background: #30b1ff;\n  box-shadow: 0 0.66875rem 2.3875rem rgba(48, 177, 255, 0.03), 0 1.1375rem 1.60625rem rgba(48, 177, 255, 0.03), 0 0.45rem 0.73125rem rgba(48, 177, 255, 0.05), 0 0.325rem 0.3875rem rgba(48, 177, 255, 0.03);\n}\n.Toastify__toast--success {\n  background: #3ac47d;\n  box-shadow: 0 0.66875rem 2.3875rem rgba(58, 196, 125, 0.03), 0 1.1375rem 1.60625rem rgba(58, 196, 125, 0.03), 0 0.45rem 0.73125rem rgba(58, 196, 125, 0.05), 0 0.325rem 0.3875rem rgba(58, 196, 125, 0.03);\n}\n.Toastify__toast--warning {\n  background: #f7b924;\n  box-shadow: 0 0.66875rem 2.3875rem rgba(247, 185, 36, 0.03), 0 1.1375rem 1.60625rem rgba(247, 185, 36, 0.03), 0 0.45rem 0.73125rem rgba(247, 185, 36, 0.05), 0 0.325rem 0.3875rem rgba(247, 185, 36, 0.03);\n}\n.Toastify__toast--error {\n  background: #d92550;\n  box-shadow: 0 0.66875rem 2.3875rem rgba(217, 37, 80, 0.03), 0 1.1375rem 1.60625rem rgba(217, 37, 80, 0.03), 0 0.45rem 0.73125rem rgba(217, 37, 80, 0.05), 0 0.325rem 0.3875rem rgba(217, 37, 80, 0.03);\n}\n.Toastify__toast-body {\n  margin: auto 0;\n  padding: 0 0 0.4rem;\n}\n\n@media only screen and (max-width : 480px) {\n  .Toastify__toast {\n    margin-bottom: 0;\n  }\n}\n.Toastify__close-button {\n  color: #fff;\n  font-size: 14px;\n  background: transparent;\n  outline: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  opacity: 0.7;\n  transition: 0.3s ease;\n  position: absolute;\n  top: 5px;\n  right: 9px;\n}\n.Toastify__close-button--default {\n  color: #000;\n  opacity: 0.3;\n}\n.Toastify__close-button:hover, .Toastify__close-button:focus {\n  opacity: 1;\n}\n\n@keyframes Toastify__trackProgress {\n  0% {\n    width: 96%;\n  }\n  100% {\n    width: 0;\n  }\n}\n.Toastify__progress-bar {\n  position: absolute;\n  bottom: 9%;\n  left: 2%;\n  width: 0;\n  height: 5px;\n  z-index: 9999;\n  animation: Toastify__trackProgress linear 1;\n  background-color: rgba(255, 255, 255, 0.3);\n  border-radius: 0.25rem;\n}\n.Toastify__progress-bar--rtl {\n  right: 0;\n  left: initial;\n}\n.Toastify__progress-bar--default {\n  background: #545cd8;\n}\n@keyframes Toastify__bounceInRight {\n  from, 60%, 75%, 90%, to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n  from {\n    opacity: 0;\n    transform: translate3d(3000px, 0, 0);\n  }\n  60% {\n    opacity: 1;\n    transform: translate3d(-25px, 0, 0);\n  }\n  75% {\n    transform: translate3d(10px, 0, 0);\n  }\n  90% {\n    transform: translate3d(-5px, 0, 0);\n  }\n  to {\n    transform: none;\n  }\n}\n@keyframes Toastify__bounceOutRight {\n  20% {\n    opacity: 1;\n    transform: translate3d(-20px, 0, 0);\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(2000px, 0, 0);\n  }\n}\n@keyframes Toastify__bounceInLeft {\n  from, 60%, 75%, 90%, to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n  0% {\n    opacity: 0;\n    transform: translate3d(-3000px, 0, 0);\n  }\n  60% {\n    opacity: 1;\n    transform: translate3d(25px, 0, 0);\n  }\n  75% {\n    transform: translate3d(-10px, 0, 0);\n  }\n  90% {\n    transform: translate3d(5px, 0, 0);\n  }\n  to {\n    transform: none;\n  }\n}\n@keyframes Toastify__bounceOutLeft {\n  20% {\n    opacity: 1;\n    transform: translate3d(20px, 0, 0);\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(-2000px, 0, 0);\n  }\n}\n@keyframes Toastify__bounceInUp {\n  from, 60%, 75%, 90%, to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n  from {\n    opacity: 0;\n    transform: translate3d(0, 3000px, 0);\n  }\n  60% {\n    opacity: 1;\n    transform: translate3d(0, -20px, 0);\n  }\n  75% {\n    transform: translate3d(0, 10px, 0);\n  }\n  90% {\n    transform: translate3d(0, -5px, 0);\n  }\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n}\n@keyframes Toastify__bounceOutUp {\n  20% {\n    transform: translate3d(0, -10px, 0);\n  }\n  40%, 45% {\n    opacity: 1;\n    transform: translate3d(0, 20px, 0);\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(0, -2000px, 0);\n  }\n}\n@keyframes Toastify__bounceInDown {\n  from, 60%, 75%, 90%, to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n  0% {\n    opacity: 0;\n    transform: translate3d(0, -3000px, 0);\n  }\n  60% {\n    opacity: 1;\n    transform: translate3d(0, 25px, 0);\n  }\n  75% {\n    transform: translate3d(0, -10px, 0);\n  }\n  90% {\n    transform: translate3d(0, 5px, 0);\n  }\n  to {\n    transform: none;\n  }\n}\n@keyframes Toastify__bounceOutDown {\n  20% {\n    transform: translate3d(0, 10px, 0);\n  }\n  40%, 45% {\n    opacity: 1;\n    transform: translate3d(0, -20px, 0);\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(0, 2000px, 0);\n  }\n}\n.Toastify__bounce-enter--top-left, .Toastify__bounce-enter--bottom-left {\n  animation-name: Toastify__bounceInLeft;\n}\n.Toastify__bounce-enter--top-right, .Toastify__bounce-enter--bottom-right {\n  animation-name: Toastify__bounceInRight;\n}\n.Toastify__bounce-enter--top-center {\n  animation-name: Toastify__bounceInDown;\n}\n.Toastify__bounce-enter--bottom-center {\n  animation-name: Toastify__bounceInUp;\n}\n\n.Toastify__bounce-exit--top-left, .Toastify__bounce-exit--bottom-left {\n  animation-name: Toastify__bounceOutLeft;\n}\n.Toastify__bounce-exit--top-right, .Toastify__bounce-exit--bottom-right {\n  animation-name: Toastify__bounceOutRight;\n}\n.Toastify__bounce-exit--top-center {\n  animation-name: Toastify__bounceOutUp;\n}\n.Toastify__bounce-exit--bottom-center {\n  animation-name: Toastify__bounceOutDown;\n}\n\n@keyframes Toastify__zoomIn {\n  from {\n    opacity: 0;\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n  50% {\n    opacity: 1;\n  }\n}\n@keyframes Toastify__zoomOut {\n  from {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0;\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n  to {\n    opacity: 0;\n  }\n}\n.Toastify__zoom-enter {\n  animation-name: Toastify__zoomIn;\n}\n\n.Toastify__zoom-exit {\n  animation-name: Toastify__zoomOut;\n}\n\n@keyframes Toastify__flipIn {\n  from {\n    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n    animation-timing-function: ease-in;\n    opacity: 0;\n  }\n  40% {\n    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n    animation-timing-function: ease-in;\n  }\n  60% {\n    transform: perspective(400px) rotate3d(1, 0, 0, 10deg);\n    opacity: 1;\n  }\n  80% {\n    transform: perspective(400px) rotate3d(1, 0, 0, -5deg);\n  }\n  to {\n    transform: perspective(400px);\n  }\n}\n@keyframes Toastify__flipOut {\n  from {\n    transform: perspective(400px);\n  }\n  30% {\n    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n    opacity: 1;\n  }\n  to {\n    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n    opacity: 0;\n  }\n}\n.Toastify__flip-enter {\n  animation-name: Toastify__flipIn;\n}\n\n.Toastify__flip-exit {\n  animation-name: Toastify__flipOut;\n}\n\n@keyframes Toastify__slideInRight {\n  from {\n    transform: translate3d(110%, 0, 0);\n    visibility: visible;\n  }\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n}\n@keyframes Toastify__slideInLeft {\n  from {\n    transform: translate3d(-110%, 0, 0);\n    visibility: visible;\n  }\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n}\n@keyframes Toastify__slideInUp {\n  from {\n    transform: translate3d(0, 110%, 0);\n    visibility: visible;\n  }\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n}\n@keyframes Toastify__slideInDown {\n  from {\n    transform: translate3d(0, -110%, 0);\n    visibility: visible;\n  }\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n}\n@keyframes Toastify__slideOutRight {\n  from {\n    transform: translate3d(0, 0, 0);\n  }\n  to {\n    visibility: hidden;\n    transform: translate3d(110%, 0, 0);\n  }\n}\n@keyframes Toastify__slideOutLeft {\n  from {\n    transform: translate3d(0, 0, 0);\n  }\n  to {\n    visibility: hidden;\n    transform: translate3d(-110%, 0, 0);\n  }\n}\n@keyframes Toastify__slideOutDown {\n  from {\n    transform: translate3d(0, 0, 0);\n  }\n  to {\n    visibility: hidden;\n    transform: translate3d(0, 500px, 0);\n  }\n}\n@keyframes Toastify__slideOutUp {\n  from {\n    transform: translate3d(0, 0, 0);\n  }\n  to {\n    visibility: hidden;\n    transform: translate3d(0, -500px, 0);\n  }\n}\n.Toastify__slide-enter--top-left, .Toastify__slide-enter--bottom-left {\n  animation-name: Toastify__slideInLeft;\n}\n.Toastify__slide-enter--top-right, .Toastify__slide-enter--bottom-right {\n  animation-name: Toastify__slideInRight;\n}\n.Toastify__slide-enter--top-center {\n  animation-name: Toastify__slideInDown;\n}\n.Toastify__slide-enter--bottom-center {\n  animation-name: Toastify__slideInUp;\n}\n\n.Toastify__slide-exit--top-left, .Toastify__slide-exit--bottom-left {\n  animation-name: Toastify__slideOutLeft;\n}\n.Toastify__slide-exit--top-right, .Toastify__slide-exit--bottom-right {\n  animation-name: Toastify__slideOutRight;\n}\n.Toastify__slide-exit--top-center {\n  animation-name: Toastify__slideOutUp;\n}\n.Toastify__slide-exit--bottom-center {\n  animation-name: Toastify__slideOutDown;\n}\n\n/* -- container -- */\n.rodal,\n.rodal-mask {\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 100;\n}\n\n.rodal {\n  position: fixed;\n}\n\n/* -- mask -- */\n.rodal-mask {\n  position: absolute;\n  background-color: #000;\n  opacity: 0.5;\n}\n\n/* -- dialog -- */\n.rodal-dialog {\n  position: absolute;\n  top: 10%;\n  left: 0;\n  right: 0;\n  margin: auto;\n  z-index: 101;\n  background: #fff;\n  box-shadow: 0 0.76875rem 2.4875rem rgba(52, 58, 64, 0.3), 0 1.3375rem 1.70625rem rgba(52, 58, 64, 0.3), 0 0.55rem 0.53125rem rgba(0, 0, 0, 0.05), 0 0.225rem 0.4375rem rgba(52, 58, 64, 0.3);\n  border-radius: 0.25rem;\n  height: auto !important;\n}\n\n.rodal-dialog:focus {\n  outline: none;\n}\n\n/* -- close button -- */\n.rodal-close {\n  position: absolute;\n  cursor: pointer;\n  top: 16px;\n  right: 16px;\n  width: 16px;\n  height: 16px;\n}\n\n.rodal-close:before,\n.rodal-close:after {\n  position: absolute;\n  content: \"\";\n  height: 2px;\n  width: 100%;\n  top: 50%;\n  left: 0;\n  margin-top: -1px;\n  background: #adb5bd;\n  border-radius: 100%;\n  transition: background 0.2s;\n}\n\n.rodal-close:before {\n  transform: rotate(45deg);\n}\n\n.rodal-close:after {\n  transform: rotate(-45deg);\n}\n\n.rodal-close:hover:before,\n.rodal-close:hover:after {\n  background: #343a40;\n}\n\n/* -- fade -- */\n@keyframes rodal-fade-enter {\n  from {\n    opacity: 0;\n  }\n}\n.rodal-fade-enter {\n  animation: rodal-fade-enter both ease-in;\n}\n\n@keyframes rodal-fade-leave {\n  to {\n    opacity: 0;\n  }\n}\n.rodal-fade-leave {\n  animation: rodal-fade-leave both ease-out;\n}\n\n@keyframes rodal-zoom-enter {\n  from {\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n}\n.rodal-zoom-enter {\n  animation: rodal-zoom-enter both cubic-bezier(0.4, 0, 0, 1.5);\n}\n\n@keyframes rodal-zoom-leave {\n  to {\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n}\n.rodal-zoom-leave {\n  animation: rodal-zoom-leave both;\n}\n\n@keyframes rodal-slideDown-enter {\n  from {\n    transform: translate3d(0, -100px, 0);\n  }\n}\n.rodal-slideDown-enter {\n  animation: rodal-slideDown-enter both cubic-bezier(0.4, 0, 0, 1.5);\n}\n\n@keyframes rodal-slideDown-leave {\n  to {\n    transform: translate3d(0, -100px, 0);\n  }\n}\n.rodal-slideDown-leave {\n  animation: rodal-slideDown-leave both;\n}\n\n/* -- slideLeft -- */\n@keyframes rodal-slideLeft-enter {\n  from {\n    transform: translate3d(-150px, 0, 0);\n  }\n}\n.rodal-slideLeft-enter {\n  animation: rodal-slideLeft-enter both cubic-bezier(0.4, 0, 0, 1.5);\n}\n\n@keyframes rodal-slideLeft-leave {\n  to {\n    transform: translate3d(-150px, 0, 0);\n  }\n}\n.rodal-slideLeft-leave {\n  animation: rodal-slideLeft-leave both;\n}\n\n/* -- slideRight -- */\n@keyframes rodal-slideRight-enter {\n  from {\n    transform: translate3d(150px, 0, 0);\n  }\n}\n.rodal-slideRight-enter {\n  animation: rodal-slideRight-enter both cubic-bezier(0.4, 0, 0, 1.5);\n}\n\n@keyframes rodal-slideRight-leave {\n  to {\n    transform: translate3d(150px, 0, 0);\n  }\n}\n.rodal-slideRight-leave {\n  animation: rodal-slideRight-leave both;\n}\n\n/* -- slideUp -- */\n@keyframes rodal-slideUp-enter {\n  from {\n    transform: translate3d(0, 100px, 0);\n  }\n}\n.rodal-slideUp-enter {\n  animation: rodal-slideUp-enter both cubic-bezier(0.4, 0, 0, 1.5);\n}\n\n@keyframes rodal-slideUp-leave {\n  to {\n    transform: translate3d(0, 100px, 0);\n  }\n}\n.rodal-slideUp-leave {\n  animation: rodal-slideUp-leave both;\n}\n\n/* -- flip -- */\n@keyframes rodal-flip-enter {\n  from {\n    transform: perspective(400px) rotate3d(1, 0, 0, 60deg);\n  }\n  70% {\n    transform: perspective(400px) rotate3d(1, 0, 0, -15deg);\n  }\n  to {\n    transform: perspective(400px);\n  }\n}\n.rodal-flip-enter {\n  animation: rodal-flip-enter both ease-in;\n  backface-visibility: visible !important;\n}\n\n@keyframes rodal-flip-leave {\n  from {\n    transform: perspective(400px);\n  }\n  30% {\n    transform: perspective(400px) rotate3d(1, 0, 0, -15deg);\n  }\n  to {\n    transform: perspective(400px) rotate3d(1, 0, 0, 45deg);\n  }\n}\n.rodal-flip-leave {\n  animation: rodal-flip-leave both;\n  backface-visibility: visible !important;\n}\n\n/* -- rotate -- */\n@keyframes rodal-rotate-enter {\n  from {\n    transform: rotate3d(0, 0, 1, -180deg) scale3d(0.3, 0.3, 0.3);\n  }\n}\n.rodal-rotate-enter {\n  animation: rodal-rotate-enter both;\n  transform-origin: center;\n}\n\n@keyframes rodal-rotate-leave {\n  to {\n    transform: rotate3d(0, 0, 1, 180deg) scale3d(0.3, 0.3, 0.3);\n  }\n}\n.rodal-rotate-leave {\n  animation: rodal-rotate-leave both;\n  transform-origin: center;\n}\n\n/* -- door -- */\n@keyframes rodal-door-enter {\n  from {\n    transform: scale3d(0, 1, 1);\n  }\n}\n.rodal-door-enter {\n  animation: rodal-door-enter both cubic-bezier(0.4, 0, 0, 1.5);\n}\n\n@keyframes rodal-door-leave {\n  60% {\n    transform: scale3d(0.01, 1, 1);\n  }\n  to {\n    transform: scale3d(0, 1, 0.1);\n  }\n}\n.rodal-door-leave {\n  animation: rodal-door-leave both;\n}\n\n.react-sweet-progress {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.react-sweet-progress-symbol {\n  display: flex;\n  align-items: center;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n  width: 35px;\n  height: 20px;\n  padding-left: 10px;\n  color: rgba(0, 0, 0, 0.7);\n  font-weight: 200;\n}\n\n.react-sweet-progress-symbol-absolute {\n  display: -ms-flexbox;\n  display: flex;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  transform: translate3d(-50%, -50%, 0);\n}\n\n.react-sweet-progress-symbol-absolute .react-sweet-progress-symbol {\n  padding: 0;\n  width: 100%;\n}\n\n.react-sweet-progress-circle-outer {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.react-sweet-progress-line {\n  width: 100%;\n  border-radius: 100px;\n  background-color: #efefef;\n  vertical-align: middle;\n}\n\n.react-sweet-progress-line-inner {\n  position: relative;\n  min-height: 10px;\n  border-radius: 100px;\n  transition: width 0.3s ease;\n}\n\n.react-sweet-progress-line-inner-status-active:before {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  border-radius: 10px;\n  background: #fff;\n  animation: active-anim 2s cubic-bezier(0.25, 1, 0.6, 1) infinite;\n  content: \"\";\n  opacity: 0;\n}\n\n@keyframes active-anim {\n  0% {\n    width: 0;\n    opacity: 0.1;\n  }\n  20% {\n    width: 0;\n    opacity: 0.5;\n  }\n  to {\n    width: 100%;\n    opacity: 0;\n  }\n}\n.react-sweet-progress-circle path {\n  stroke-linecap: round;\n}\n\n/* Slider */\n.slick-slider {\n  position: relative;\n  display: block;\n  box-sizing: border-box;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -ms-touch-action: pan-y;\n  touch-action: pan-y;\n  -webkit-tap-highlight-color: transparent;\n  max-width: 1400px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.slick-slider-sm .slick-slider {\n  max-width: 450px;\n}\n.slick-slider-sm .slick-slider .slick-prev {\n  left: -20px;\n}\n.slick-slider-sm .slick-slider .slick-next {\n  right: -20px;\n}\n\n.slick-slider-md .slick-slider {\n  max-width: 650px;\n  margin: 0 auto;\n}\n\n.slick-slider-hover .slick-arrow {\n  opacity: 0;\n  background: #545cd8;\n  color: #fff !important;\n}\n.slick-slider-hover .slick-prev {\n  left: -30px;\n}\n.slick-slider-hover .slick-next {\n  right: -30px;\n}\n.slick-slider-hover:hover .slick-arrow {\n  opacity: 1;\n}\n\n.slick-list {\n  position: relative;\n  overflow: hidden;\n  display: block;\n  margin: 0;\n  padding: 0;\n}\n.slick-list:focus {\n  outline: none;\n}\n.slick-list.dragging {\n  cursor: pointer;\n  cursor: hand;\n}\n\n.slick-slider .slick-track,\n.slick-slider .slick-list {\n  -webkit-transform: translate3d(0, 0, 0);\n  -moz-transform: translate3d(0, 0, 0);\n  -ms-transform: translate3d(0, 0, 0);\n  -o-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0);\n}\n\n.slick-track {\n  position: relative;\n  left: 0;\n  top: 0;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n.slick-track:before, .slick-track:after {\n  content: \"\";\n  display: table;\n}\n.slick-track:after {\n  clear: both;\n}\n.slick-loading .slick-track {\n  visibility: hidden;\n}\n\n.slick-slide {\n  float: left;\n  height: 100%;\n  min-height: 1px;\n  display: none;\n}\n[dir=rtl] .slick-slide {\n  float: right;\n}\n.slick-slide img {\n  display: block;\n}\n.slick-slide.slick-loading img {\n  display: none;\n}\n.slick-slide.dragging img {\n  pointer-events: none;\n}\n.slick-initialized .slick-slide {\n  display: block;\n}\n.slick-loading .slick-slide {\n  visibility: hidden;\n}\n.slick-vertical .slick-slide {\n  display: block;\n  height: auto;\n  border: 1px solid transparent;\n}\n\n.slick-arrow.slick-hidden {\n  display: none;\n}\n\n/* Arrows */\n.slick-prev,\n.slick-next {\n  position: absolute;\n  display: block;\n  height: 40px;\n  width: 40px;\n  cursor: pointer;\n  color: #6c757d;\n  top: 50%;\n  transform: translate(0, -80%);\n  padding: 0;\n  border: none;\n  outline: none;\n  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);\n  transition: all 0.2s;\n  font-family: \"Pe-icon-7-stroke\";\n  border-radius: 50px;\n  background: #fff;\n  z-index: 6;\n  overflow: hidden;\n}\n.slick-prev::before,\n.slick-next::before {\n  font-size: 35px;\n  height: 40px;\n  line-height: 40px;\n  width: 40px;\n}\n.slick-prev:hover, .slick-prev:focus,\n.slick-next:hover,\n.slick-next:focus {\n  outline: none;\n  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175);\n  color: #545cd8;\n}\n.slick-prev.slick-disabled:before,\n.slick-next.slick-disabled:before {\n  opacity: 0.25;\n}\n\n.slick-prev {\n  left: 0;\n}\n.slick-prev:before {\n  content: \"\\e686\";\n}\n\n.slick-next {\n  right: 0;\n}\n.slick-next:before {\n  content: \"\\e684\";\n}\n\n/* Dots */\n.slick-dots {\n  list-style: none;\n  display: block;\n  text-align: center;\n  padding: 0;\n  margin: 0.75rem 0 0;\n  width: 100%;\n}\n.slick-dots li {\n  position: relative;\n  display: inline-block;\n  padding: 0;\n  margin: 0 5px;\n  cursor: pointer;\n  transform: scale(0.8);\n  transition: all 0.2s;\n}\n.slick-dots li button {\n  border: 0;\n  background: transparent;\n  display: block;\n  height: 14px;\n  width: 14px;\n  background: #545cd8;\n  cursor: pointer;\n  position: relative;\n  border-radius: 20px;\n  color: transparent;\n}\n.slick-dots li button::before {\n  content: \"\";\n  position: absolute;\n  background: #fff;\n  left: 50%;\n  top: 50%;\n  margin: -4px 0 0 -4px;\n  display: block;\n  width: 8px;\n  height: 8px;\n  border-radius: 20px;\n}\n.slick-dots li.slick-active {\n  transform: scale(1.2);\n}\n\n.slick-center {\n  transform: scale(1.1);\n}\n\n.slick-slider .slide-img-bg {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background-size: cover;\n  opacity: 0.4;\n  z-index: 10;\n}\n.slick-slider .slider-content {\n  position: relative;\n  z-index: 15;\n  text-align: center;\n  margin: 0 6rem;\n}\n.slick-slider .slider-content h3, .slick-slider .slider-content .h3 {\n  font-size: 1.54rem;\n  font-weight: normal;\n  margin-bottom: 1.5rem;\n}\n.slick-slider .slider-content p {\n  font-size: 0.88rem;\n  opacity: 0.7;\n}\n\n.slider-light .slick-dots {\n  position: absolute;\n  bottom: 10px;\n}\n.slider-light .slick-dots li button {\n  background: rgba(255, 255, 255, 0.25);\n}\n.slider-light .slick-prev,\n.slider-light .slick-next {\n  background: transparent;\n  color: #fff;\n  box-shadow: 0 0 0 0 transparent;\n}\n.slider-light .slick-prev:hover,\n.slider-light .slick-next:hover {\n  background: rgba(255, 255, 255, 0.15);\n}\n.slider-light .slick-next {\n  right: 15px;\n}\n.slider-light .slick-prev {\n  left: 15px;\n}\n.slider-light .slider-content {\n  color: #fff;\n}\n\n.loading-indicator {\n  text-align: center;\n}\n\n.loading-bullet {\n  display: inline-block;\n  opacity: 0;\n  font-size: 2em;\n  color: #02a17c;\n}\n\n.block-ui {\n  position: relative;\n  min-height: 3em;\n}\n\n.block-ui-container {\n  position: absolute;\n  z-index: 1010;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  height: 100%;\n  min-height: 2em;\n  cursor: wait;\n  overflow: hidden;\n}\n\n.block-ui-container:focus {\n  outline: none;\n}\n\n.block-ui-overlay {\n  width: 100%;\n  height: 100%;\n  opacity: 0.5;\n  filter: alpha(opacity=50);\n  background-color: white;\n}\n\n.block-ui-message-container {\n  position: absolute;\n  top: 50%;\n  left: 0;\n  width: 100%;\n  right: 0;\n  text-align: center;\n  transform: translateY(-50%);\n  z-index: 10001;\n}\n\n.block-ui-message {\n  color: #333;\n  background: none;\n  z-index: 1011;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.block-overlay-dark .block-ui-overlay {\n  background: rgb(0, 0, 0);\n}\n\n.popover {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);\n}\n.popover .grid-menu {\n  margin-bottom: -1rem;\n  padding: 1px;\n}\n.popover .grid-menu [class*=col-] {\n  padding: 1rem;\n}\n.popover .grid-menu + .nav .nav-item-btn {\n  margin-bottom: 1rem;\n}\n.popover .grid-menu-xl {\n  margin-bottom: -0.7407407407rem;\n}\n.popover .grid-menu-xl [class*=col-] {\n  padding: 0;\n}\n.popover .popover-inner .dropdown-menu-header {\n  border-top-left-radius: 0.3rem;\n  border-top-right-radius: 0.3rem;\n  overflow: hidden;\n  margin-top: -1px;\n  margin-left: -1px;\n  margin-right: -1px;\n}\n\n.rm-max-width > .popover {\n  max-width: initial;\n}\n\n.rm-pointers > .popover .arrow {\n  display: none !important;\n}\n\n.popover-primary {\n  background-color: #545cd8 !important;\n}\n\n.popover-secondary {\n  background-color: #6c757d !important;\n}\n\n.popover-success {\n  background-color: #3ac47d !important;\n}\n\n.popover-info {\n  background-color: #30b1ff !important;\n}\n\n.popover-warning {\n  background-color: #f7b924 !important;\n}\n\n.popover-danger {\n  background-color: #d92550 !important;\n}\n\n.popover-light {\n  background-color: #eeeeee !important;\n}\n\n.popover-dark {\n  background-color: #343a40 !important;\n}\n\n.popover-focus {\n  background-color: #444054 !important;\n}\n\n.popover-alternate {\n  background-color: #83588a !important;\n}\n\n.popover-custom .popover-body {\n  padding-top: 0;\n  padding-left: 0;\n  padding-right: 0;\n}\n.popover-custom .popover-body .dropdown-menu-header {\n  margin-top: 0;\n  border-top-left-radius: 0.3rem;\n  border-top-right-radius: 0.3rem;\n  overflow: hidden;\n}\n.popover-custom .popover-body .dropdown-menu-header .menu-header-content {\n  padding: 0 1.5rem;\n}\n.popover-custom .popover-body .dropdown-menu-header .dropdown-menu-header-inner.bg-light {\n  color: rgba(0, 0, 0, 0.8);\n}\n.popover-custom.popover-custom-lg {\n  min-width: 22rem;\n}\n.popover-custom.popover-custom-xl {\n  min-width: 25rem;\n}\n.popover-custom.popover-custom-sm {\n  min-width: 15rem;\n}\n\n.popover-bg {\n  border: 0;\n}\n.popover-bg .arrow {\n  display: none;\n}\n.popover-bg .popover-header {\n  background: rgba(255, 255, 255, 0.1);\n  border-bottom: 0;\n  color: rgb(255, 255, 255);\n}\n.popover-bg .popover-header::before {\n  display: none;\n}\n.popover-bg .popover-body {\n  color: rgba(255, 255, 255, 0.7);\n}\n.popover-bg.text-dark .popover-header {\n  color: rgba(0, 0, 0, 0.8);\n}\n.popover-bg.text-dark .popover-body {\n  color: rgba(0, 0, 0, 0.7);\n}\n\n.tooltip-light > .tooltip .tooltip-inner {\n  background: #fff;\n  color: #343a40;\n  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);\n  border: rgba(32.0357142857, 38.6071428571, 140.4642857143, 0.125) solid 1px;\n}\n.tooltip-light > .tooltip .arrow {\n  display: none;\n}\n\n.scrollable-block {\n  margin-bottom: 50px;\n  overflow: hidden;\n  position: relative;\n}\n.scrollable-block .sticky {\n  z-index: 2;\n}\n\n.rbc-btn {\n  color: inherit;\n  font: inherit;\n  margin: 0;\n}\n\nbutton.rbc-btn {\n  overflow: visible;\n  text-transform: none;\n  -webkit-appearance: button;\n  cursor: pointer;\n}\n\nbutton[disabled].rbc-btn {\n  cursor: not-allowed;\n}\n\nbutton.rbc-input::-moz-focus-inner {\n  border: 0;\n  padding: 0;\n}\n\n.rbc-calendar {\n  box-sizing: border-box;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  flex: 1 1;\n  min-height: 580px;\n}\n\n.rbc-calendar *,\n.rbc-calendar *:before,\n.rbc-calendar *:after {\n  box-sizing: inherit;\n}\n\n.rbc-abs-full, .rbc-row-bg {\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n\n.rbc-ellipsis, .rbc-show-more, .rbc-row-segment .rbc-event-content, .rbc-event-label {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rbc-rtl {\n  direction: rtl;\n}\n\n.rbc-off-range {\n  color: rgb(178.5, 178.5, 178.5);\n}\n\n.rbc-header {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding: 0 3px;\n  text-align: center;\n  vertical-align: middle;\n  font-weight: bold;\n  font-size: 90%;\n  min-height: 0;\n  flex: 1 0;\n  flex-basis: auto !important;\n}\n.rbc-header > a, .rbc-header > a:active, .rbc-header > a:visited {\n  color: inherit;\n  text-decoration: none;\n}\n\n.rbc-row-content {\n  position: relative;\n  user-select: none;\n  z-index: 4;\n}\n\n.rbc-today {\n  background-color: #e0f3ff;\n}\n\n.rbc-toolbar {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n  font-size: 16px;\n}\n.rbc-toolbar .rbc-toolbar-label {\n  width: 100%;\n  padding: 0 10px;\n  text-align: center;\n}\n.rbc-toolbar button {\n  color: #fff;\n  display: inline-block;\n  margin: 0;\n  text-align: center;\n  vertical-align: middle;\n  background: #545cd8;\n  border: 1px solid #545cd8;\n  padding: 0.375rem 1rem;\n  border-radius: 0.25rem;\n  line-height: normal;\n  white-space: nowrap;\n  font-weight: bold;\n  text-transform: capitalize;\n  font-size: 0.88rem;\n}\n.rbc-toolbar button:active, .rbc-toolbar button.rbc-active {\n  background-image: none;\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  background-color: rgb(46.2428571429, 55.7285714286, 202.7571428571);\n  border-color: rgb(44.3485714286, 53.4457142857, 194.4514285714);\n}\n.rbc-toolbar button:active:hover, .rbc-toolbar button:active:focus, .rbc-toolbar button.rbc-active:hover, .rbc-toolbar button.rbc-active:focus {\n  color: #fff;\n  background-color: rgb(39.6128571429, 47.7385714286, 173.6871428571);\n  border-color: rgb(32.0357142857, 38.6071428571, 140.4642857143);\n}\n.rbc-toolbar button:focus {\n  color: #fff;\n  background-color: rgb(46.2428571429, 55.7285714286, 202.7571428571);\n  border-color: rgb(44.3485714286, 53.4457142857, 194.4514285714);\n}\n.rbc-toolbar button:hover {\n  color: #fff;\n  background-color: rgb(46.2428571429, 55.7285714286, 202.7571428571);\n  border-color: rgb(44.3485714286, 53.4457142857, 194.4514285714);\n}\n\n.rbc-btn-group {\n  display: inline-block;\n  white-space: nowrap;\n}\n.rbc-btn-group > button:first-child:not(:last-child) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.rbc-btn-group > button:last-child:not(:first-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.rbc-rtl .rbc-btn-group > button:first-child:not(:last-child) {\n  border-radius: 4px;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.rbc-rtl .rbc-btn-group > button:last-child:not(:first-child) {\n  border-radius: 4px;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.rbc-btn-group > button:not(:first-child):not(:last-child) {\n  border-radius: 0;\n}\n.rbc-btn-group button + button {\n  margin-left: -1px;\n}\n.rbc-rtl .rbc-btn-group button + button {\n  margin-left: 0;\n  margin-right: -1px;\n}\n.rbc-btn-group + .rbc-btn-group, .rbc-btn-group + button {\n  margin-left: 10px;\n}\n\n.rbc-event {\n  cursor: pointer;\n  padding: 0.125rem;\n  background-color: #545cd8;\n  border-radius: 0.25rem;\n  color: #fff;\n}\n.rbc-event.rbc-selected {\n  background-color: rgb(46.2428571429, 55.7285714286, 202.7571428571);\n}\n\n.rbc-event-label {\n  font-size: 80%;\n}\n\n.rbc-event-overlaps {\n  box-shadow: -1px 1px 5px 0px rgba(51, 51, 51, 0.5);\n}\n\n.rbc-event-continues-prior {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.rbc-event-continues-after {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.rbc-event-continues-earlier {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.rbc-event-continues-later {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.rbc-row {\n  display: flex;\n  flex-direction: row;\n}\n\n.rbc-row-segment {\n  padding: 0 1px 1px 1px;\n}\n.rbc-selected-cell {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\n.rbc-show-more {\n  background-color: rgba(255, 255, 255, 0.3);\n  z-index: 4;\n  font-weight: bold;\n  font-size: 85%;\n  height: auto;\n  line-height: normal;\n  white-space: nowrap;\n}\n\n.rbc-month-view {\n  position: relative;\n  border: 1px solid #e9ecef;\n  display: flex;\n  flex-direction: column;\n  flex: 1 0 0;\n  width: 100%;\n  user-select: none;\n  height: 100%;\n}\n.rbc-month-view .rbc-header {\n  border-bottom: 1px solid #e9ecef;\n}\n.rbc-month-view .rbc-header + .rbc-header {\n  border-left: 1px solid #e9ecef;\n}\n.rbc-rtl .rbc-month-view .rbc-header + .rbc-header {\n  border-left-width: 0;\n  border-right: 1px solid #e9ecef;\n}\n\n.rbc-month-header {\n  display: flex;\n  flex-direction: row;\n}\n\n.rbc-month-row {\n  display: flex;\n  position: relative;\n  flex-direction: column;\n  flex: 1 0 0;\n  overflow: hidden;\n  height: 100%;\n}\n.rbc-month-row + .rbc-month-row {\n  border-top: 1px solid #e9ecef;\n}\n\n.rbc-date-cell {\n  padding-right: 5px;\n  text-align: right;\n  flex: 1 1;\n}\n.rbc-date-cell.rbc-now {\n  font-weight: bold;\n}\n.rbc-date-cell > a, .rbc-date-cell > a:active, .rbc-date-cell > a:visited {\n  color: inherit;\n  text-decoration: none;\n}\n\n.rbc-row-bg {\n  display: flex;\n  flex-direction: row;\n  flex: 1 0 0;\n  overflow: hidden;\n}\n\n.rbc-day-bg {\n  flex: 1 0;\n}\n.rbc-day-bg + .rbc-day-bg {\n  border-left: 1px solid #e9ecef;\n}\n.rbc-rtl .rbc-day-bg + .rbc-day-bg {\n  border-left-width: 0;\n  border-right: 1px solid #e9ecef;\n}\n\n.rbc-off-range-bg {\n  background: #f8f9fa;\n}\n\n.rbc-overlay {\n  position: absolute;\n  z-index: 5;\n  border: 1px solid #e5e5e5;\n  background-color: #fff;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);\n  padding: 10px;\n}\n.rbc-overlay > * + * {\n  margin-top: 1px;\n}\n\n.rbc-overlay-header {\n  border-bottom: 1px solid #e5e5e5;\n  margin: -10px -10px 5px -10px;\n  padding: 2px 10px;\n}\n\n.rbc-agenda-view {\n  display: flex;\n  flex-direction: column;\n  flex: 1 0 0;\n  overflow: auto;\n}\n.rbc-agenda-view table {\n  width: 100%;\n  border: 1px solid #e9ecef;\n}\n.rbc-agenda-view table tbody > tr > td {\n  padding: 5px 10px;\n  vertical-align: top;\n}\n.rbc-agenda-view table .rbc-agenda-time-cell {\n  padding-left: 15px;\n  padding-right: 15px;\n  text-transform: lowercase;\n}\n.rbc-agenda-view table tbody > tr > td + td {\n  border-left: 1px solid #e9ecef;\n}\n.rbc-rtl .rbc-agenda-view table tbody > tr > td + td {\n  border-left-width: 0;\n  border-right: 1px solid #e9ecef;\n}\n.rbc-agenda-view table tbody > tr + tr {\n  border-top: 1px solid #e9ecef;\n}\n.rbc-agenda-view table thead > tr > th {\n  padding: 3px 5px;\n  text-align: left;\n  border-bottom: 1px solid #e9ecef;\n}\n.rbc-rtl .rbc-agenda-view table thead > tr > th {\n  text-align: right;\n}\n\n.rbc-agenda-time-cell {\n  text-transform: lowercase;\n}\n.rbc-agenda-time-cell .rbc-continues-after:after {\n  content: \" »\";\n}\n.rbc-agenda-time-cell .rbc-continues-prior:before {\n  content: \"« \";\n}\n\n.rbc-agenda-date-cell,\n.rbc-agenda-time-cell {\n  white-space: nowrap;\n}\n\n.rbc-agenda-event-cell {\n  width: 100%;\n}\n\n.rbc-time-column {\n  display: flex;\n  flex-direction: column;\n  min-height: 100%;\n}\n.rbc-time-column .rbc-timeslot-group {\n  flex: 1;\n}\n\n.rbc-timeslot-group {\n  border-bottom: 1px solid #e9ecef;\n  min-height: 40px;\n  display: flex;\n  flex-flow: column nowrap;\n}\n\n.rbc-time-gutter,\n.rbc-header-gutter {\n  flex: none;\n}\n\n.rbc-label {\n  padding: 0 5px;\n}\n\n.rbc-day-slot {\n  position: relative;\n}\n.rbc-day-slot .rbc-event {\n  border: 1px solid rgb(46.2428571429, 55.7285714286, 202.7571428571);\n  display: flex;\n  max-height: 100%;\n  flex-flow: column wrap;\n  align-items: flex-start;\n  overflow: hidden;\n}\n.rbc-day-slot .rbc-event-label {\n  flex: none;\n  padding-right: 5px;\n  width: auto;\n}\n.rbc-day-slot .rbc-event-content {\n  width: 100%;\n  flex: 1 1 0;\n  word-wrap: break-word;\n  line-height: 1;\n  height: 100%;\n  min-height: 1em;\n}\n.rbc-day-slot .rbc-time-slot {\n  border-top: 1px solid white;\n}\n\n.rbc-time-slot {\n  flex: 1 0 0;\n}\n.rbc-time-slot.rbc-now {\n  font-weight: bold;\n}\n\n.rbc-day-header {\n  text-align: center;\n}\n\n.rbc-day-slot .rbc-event {\n  position: absolute;\n  z-index: 2;\n}\n\n.rbc-slot-selection {\n  z-index: 10;\n  position: absolute;\n  cursor: default;\n  background-color: rgba(0, 0, 0, 0.5);\n  color: #white;\n  font-size: 75%;\n  padding: 3px;\n}\n\n.rbc-time-view {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  width: 100%;\n  border: 1px solid #e9ecef;\n  min-height: 0;\n}\n.rbc-time-view .rbc-time-gutter {\n  white-space: nowrap;\n}\n.rbc-time-view .rbc-allday-cell {\n  width: 100%;\n  position: relative;\n}\n.rbc-time-view .rbc-allday-events {\n  position: relative;\n  z-index: 4;\n}\n.rbc-time-view .rbc-row {\n  min-height: 20px;\n}\n\n.rbc-time-header {\n  display: flex;\n  flex: 0 0 auto;\n  flex-direction: column;\n}\n.rbc-time-header.rbc-overflowing {\n  border-right: 1px solid #e9ecef;\n}\n.rbc-rtl .rbc-time-header.rbc-overflowing {\n  border-right-width: 0;\n  border-left: 1px solid #e9ecef;\n}\n.rbc-time-header > .rbc-row > * + * {\n  border-left: 1px solid #e9ecef;\n}\n.rbc-rtl .rbc-time-header > .rbc-row > * + * {\n  border-left-width: 0;\n  border-right: 1px solid #e9ecef;\n}\n.rbc-time-header > .rbc-row:first-child {\n  border-bottom: 1px solid #e9ecef;\n}\n.rbc-time-header .rbc-gutter-cell {\n  flex: none;\n}\n.rbc-time-header > .rbc-gutter-cell + * {\n  width: 100%;\n}\n\n.rbc-time-content {\n  display: flex;\n  flex: 1 0 0%;\n  align-items: flex-start;\n  width: 100%;\n  border-top: 2px solid #e9ecef;\n  overflow-y: auto;\n  position: relative;\n}\n.rbc-time-content > .rbc-time-gutter {\n  flex: none;\n}\n.rbc-time-content > * + * > * {\n  border-left: 1px solid #e9ecef;\n}\n.rbc-rtl .rbc-time-content > * + * > * {\n  border-left-width: 0;\n  border-right: 1px solid #e9ecef;\n}\n.rbc-time-content > .rbc-day-slot {\n  width: 100%;\n  user-select: none;\n}\n\n.rbc-current-time-indicator {\n  position: absolute;\n  z-index: 1;\n  left: 0;\n  height: 1px;\n  background-color: #3ac47d;\n  pointer-events: none;\n}\n.rbc-current-time-indicator::before {\n  display: block;\n  position: absolute;\n  left: -3px;\n  top: -3px;\n  content: \" \";\n  background-color: #3ac47d;\n  border-radius: 50%;\n  width: 8px;\n  height: 8px;\n}\n.rbc-rtl .rbc-current-time-indicator::before {\n  left: 0;\n  right: -3px;\n}\n\n.handle-bar {\n  background: transparent !important;\n  border-radius: 30px;\n}\n.handle-bar:active, .handle-bar:hover, .handle-bar.handle-bar_clone {\n  background-color: #e9ecef !important;\n}\n.handle-bar.resize-not-allowed:hover {\n  background-color: #e9ecef;\n}\n.handle-bar .handle-bar_drag {\n  border-color: #545cd8 !important;\n}\n\n/**\n * Extra class applied to VirtualScroll through className prop\n */\n.rst__virtualScrollOverride {\n  overflow: auto !important;\n}\n\n.ReactVirtualized__Grid__innerScrollContainer {\n  overflow: visible !important;\n}\n\n.rst__rtl .ReactVirtualized__Grid__innerScrollContainer {\n  direction: rtl;\n}\n\n.ReactVirtualized__Grid {\n  outline: none;\n}\n\n.rst__node {\n  min-width: 100%;\n  white-space: nowrap;\n  position: relative;\n  text-align: left;\n}\n\n.rst__node.rst__rtl {\n  text-align: right;\n}\n\n.rst__nodeContent {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n}\n\n/* ==========================================================================\n   Scaffold\n\n    Line-overlaid blocks used for showing the tree structure\n   ========================================================================== */\n.rst__lineBlock,\n.rst__absoluteLineBlock {\n  height: 100%;\n  position: relative;\n  display: inline-block;\n}\n\n.rst__absoluteLineBlock {\n  position: absolute;\n  top: 0;\n}\n\n.rst__lineHalfHorizontalRight::before,\n.rst__lineFullVertical::after,\n.rst__lineHalfVerticalTop::after,\n.rst__lineHalfVerticalBottom::after {\n  position: absolute;\n  content: \"\";\n  background-color: black;\n}\n\n/**\n * +-----+\n * |     |\n * |  +--+\n * |     |\n * +-----+\n */\n.rst__lineHalfHorizontalRight::before {\n  height: 1px;\n  top: 50%;\n  right: 0;\n  width: 50%;\n}\n\n.rst__rtl.rst__lineHalfHorizontalRight::before {\n  left: 0;\n  right: initial;\n}\n\n.rst__lineFullVertical::after,\n.rst__lineHalfVerticalTop::after,\n.rst__lineHalfVerticalBottom::after {\n  width: 1px;\n  left: 50%;\n  top: 0;\n  height: 100%;\n}\n\n.rst__rtl.rst__lineFullVertical::after,\n.rst__rtl.rst__lineHalfVerticalTop::after,\n.rst__rtl.rst__lineHalfVerticalBottom::after {\n  right: 50%;\n  left: initial;\n}\n\n.rst__lineHalfVerticalTop::after {\n  height: 50%;\n}\n\n.rst__lineHalfVerticalBottom::after {\n  top: auto;\n  bottom: 0;\n  height: 50%;\n}\n\n/* Highlight line for pointing to dragged row destination\n   ========================================================================== */\n.rst__highlightLineVertical {\n  z-index: 3;\n}\n\n.rst__highlightLineVertical::before {\n  position: absolute;\n  content: \"\";\n  background-color: #545cd8;\n  width: 8px;\n  margin-left: -4px;\n  left: 50%;\n  top: 0;\n  height: 100%;\n}\n\n.rst__rtl.rst__highlightLineVertical::before {\n  margin-left: initial;\n  margin-right: -4px;\n  left: initial;\n  right: 50%;\n}\n\n@keyframes arrow-pulse {\n  0% {\n    transform: translate(0, 0);\n    opacity: 0;\n  }\n  30% {\n    transform: translate(0, 300%);\n    opacity: 1;\n  }\n  70% {\n    transform: translate(0, 700%);\n    opacity: 1;\n  }\n  100% {\n    transform: translate(0, 1000%);\n    opacity: 0;\n  }\n}\n.rst__highlightLineVertical::after {\n  content: \"\";\n  position: absolute;\n  height: 0;\n  margin-left: -4px;\n  left: 50%;\n  top: 0;\n  border-left: 4px solid transparent;\n  border-right: 4px solid transparent;\n  border-top: 4px solid white;\n  animation: arrow-pulse 1s infinite linear both;\n}\n\n.rst__rtl.rst__highlightLineVertical::after {\n  margin-left: initial;\n  margin-right: -4px;\n  right: 50%;\n  left: initial;\n}\n\n/**\n * +-----+\n * |     |\n * |  +--+\n * |  |  |\n * +--+--+\n */\n.rst__highlightTopLeftCorner::before {\n  z-index: 3;\n  content: \"\";\n  position: absolute;\n  border-top: solid 8px #545cd8;\n  border-left: solid 8px #545cd8;\n  box-sizing: border-box;\n  height: calc(50% + 4px);\n  top: 50%;\n  margin-top: -4px;\n  right: 0;\n  width: calc(50% + 4px);\n}\n\n.rst__rtl.rst__highlightTopLeftCorner::before {\n  border-right: solid 8px #545cd8;\n  border-left: none;\n  left: 0;\n  right: initial;\n}\n\n/**\n * +--+--+\n * |  |  |\n * |  |  |\n * |  +->|\n * +-----+\n */\n.rst__highlightBottomLeftCorner {\n  z-index: 3;\n}\n\n.rst__highlightBottomLeftCorner::before {\n  content: \"\";\n  position: absolute;\n  border-bottom: solid 8px #545cd8;\n  border-left: solid 8px #545cd8;\n  box-sizing: border-box;\n  height: calc(100% + 4px);\n  top: 0;\n  right: 12px;\n  width: calc(50% - 8px);\n}\n\n.rst__rtl.rst__highlightBottomLeftCorner::before {\n  border-right: solid 8px #545cd8;\n  border-left: none;\n  left: 12px;\n  right: initial;\n}\n\n.rst__highlightBottomLeftCorner::after {\n  content: \"\";\n  position: absolute;\n  height: 0;\n  right: 0;\n  top: 100%;\n  margin-top: -12px;\n  border-top: 12px solid transparent;\n  border-bottom: 12px solid transparent;\n  border-left: 12px solid #545cd8;\n}\n\n.rst__rtl.rst__highlightBottomLeftCorner::after {\n  left: 0;\n  right: initial;\n  border-right: 12px solid #545cd8;\n  border-left: none;\n}\n\n.rst__rowWrapper {\n  padding: 10px 10px 10px 0;\n  height: 100%;\n  box-sizing: border-box;\n}\n\n.rst__rtl.rst__rowWrapper {\n  padding: 10px 0 10px 10px;\n}\n\n.rst__row {\n  height: 100%;\n  white-space: nowrap;\n  display: flex;\n}\n\n.rst__row > * {\n  box-sizing: border-box;\n}\n\n/**\n * The outline of where the element will go if dropped, displayed while dragging\n */\n.rst__rowLandingPad,\n.rst__rowCancelPad {\n  border: none !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n.rst__rowLandingPad > *,\n.rst__rowCancelPad > * {\n  opacity: 0 !important;\n}\n\n.rst__rowLandingPad::before,\n.rst__rowCancelPad::before {\n  background-color: lightblue;\n  border: 1px dashed #fff;\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: -1;\n}\n\n/**\n * Alternate appearance of the landing pad when the dragged location is invalid\n */\n.rst__rowCancelPad::before {\n  background-color: #e6a8ad;\n}\n\n/**\n * Nodes matching the search conditions are highlighted\n */\n.rst__rowSearchMatch {\n  outline: solid 3px #0080ff;\n}\n\n/**\n * The node that matches the search conditions and is currently focused\n */\n.rst__rowSearchFocus {\n  outline: solid 3px #fc6421;\n}\n\n.rst__rowContents,\n.rst__rowLabel,\n.rst__rowToolbar,\n.rst__moveHandle,\n.rst__toolbarButton {\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.rst__rowContents {\n  position: relative;\n  height: 100%;\n  border: solid #dee2e6 1px;\n  border-left: none;\n  padding: 0 5px 0 10px;\n  border-radius: 2px;\n  min-width: 230px;\n  flex: 1 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-color: white;\n}\n\n.rst__rtl.rst__rowContents {\n  border-right: none;\n  border-left: solid #dee2e6 1px;\n  padding: 0 10px 0 5px;\n}\n\n.rst__rowContentsDragDisabled {\n  border-left: solid #dee2e6 1px;\n}\n\n.rst__rtl.rst__rowContentsDragDisabled {\n  border-right: solid #dee2e6 1px;\n  border-left: solid #dee2e6 1px;\n}\n\n.rst__rowLabel {\n  flex: 0 1 auto;\n  padding-right: 20px;\n}\n\n.rst__rtl.rst__rowLabel {\n  padding-left: 20px;\n  padding-right: inherit;\n}\n\n.rst__rowToolbar {\n  flex: 0 1 auto;\n  display: flex;\n}\n\n.rst__moveHandle,\n.rst__loadingHandle {\n  height: 100%;\n  width: 44px;\n  background: #e9ecef url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MiIgaGVpZ2h0PSI0MiI+PGcgc3Ryb2tlPSIjRkZGIiBzdHJva2Utd2lkdGg9IjIuOSIgPjxwYXRoIGQ9Ik0xNCAxNS43aDE0LjQiLz48cGF0aCBkPSJNMTQgMjEuNGgxNC40Ii8+PHBhdGggZD0iTTE0IDI3LjFoMTQuNCIvPjwvZz4KPC9zdmc+\") no-repeat center;\n  border: solid #aaa 1px;\n  cursor: move;\n  border-radius: 1px;\n  z-index: 1;\n}\n\n.rst__loadingHandle {\n  cursor: default;\n  background: #e9ecef;\n}\n\n@keyframes pointFade {\n  0%, 19.999%, 100% {\n    opacity: 0;\n  }\n  20% {\n    opacity: 1;\n  }\n}\n.rst__loadingCircle {\n  width: 80%;\n  height: 80%;\n  margin: 10%;\n  position: relative;\n}\n\n.rst__loadingCirclePoint {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n\n.rst__rtl.rst__loadingCirclePoint {\n  right: 0;\n  left: initial;\n}\n\n.rst__loadingCirclePoint::before {\n  content: \"\";\n  display: block;\n  margin: 0 auto;\n  width: 11%;\n  height: 30%;\n  background-color: #fff;\n  border-radius: 30%;\n  animation: pointFade 800ms infinite ease-in-out both;\n}\n\n.rst__loadingCirclePoint:nth-of-type(1) {\n  transform: rotate(0deg);\n}\n\n.rst__loadingCirclePoint:nth-of-type(7) {\n  transform: rotate(180deg);\n}\n\n.rst__loadingCirclePoint:nth-of-type(1)::before,\n.rst__loadingCirclePoint:nth-of-type(7)::before {\n  animation-delay: -800ms;\n}\n\n.rst__loadingCirclePoint:nth-of-type(2) {\n  transform: rotate(30deg);\n}\n\n.rst__loadingCirclePoint:nth-of-type(8) {\n  transform: rotate(210deg);\n}\n\n.rst__loadingCirclePoint:nth-of-type(2)::before,\n.rst__loadingCirclePoint:nth-of-type(8)::before {\n  animation-delay: -666ms;\n}\n\n.rst__loadingCirclePoint:nth-of-type(3) {\n  transform: rotate(60deg);\n}\n\n.rst__loadingCirclePoint:nth-of-type(9) {\n  transform: rotate(240deg);\n}\n\n.rst__loadingCirclePoint:nth-of-type(3)::before,\n.rst__loadingCirclePoint:nth-of-type(9)::before {\n  animation-delay: -533ms;\n}\n\n.rst__loadingCirclePoint:nth-of-type(4) {\n  transform: rotate(90deg);\n}\n\n.rst__loadingCirclePoint:nth-of-type(10) {\n  transform: rotate(270deg);\n}\n\n.rst__loadingCirclePoint:nth-of-type(4)::before,\n.rst__loadingCirclePoint:nth-of-type(10)::before {\n  animation-delay: -400ms;\n}\n\n.rst__loadingCirclePoint:nth-of-type(5) {\n  transform: rotate(120deg);\n}\n\n.rst__loadingCirclePoint:nth-of-type(11) {\n  transform: rotate(300deg);\n}\n\n.rst__loadingCirclePoint:nth-of-type(5)::before,\n.rst__loadingCirclePoint:nth-of-type(11)::before {\n  animation-delay: -266ms;\n}\n\n.rst__loadingCirclePoint:nth-of-type(6) {\n  transform: rotate(150deg);\n}\n\n.rst__loadingCirclePoint:nth-of-type(12) {\n  transform: rotate(330deg);\n}\n\n.rst__loadingCirclePoint:nth-of-type(6)::before,\n.rst__loadingCirclePoint:nth-of-type(12)::before {\n  animation-delay: -133ms;\n}\n\n.rst__loadingCirclePoint:nth-of-type(7) {\n  transform: rotate(180deg);\n}\n\n.rst__loadingCirclePoint:nth-of-type(13) {\n  transform: rotate(360deg);\n}\n\n.rst__loadingCirclePoint:nth-of-type(7)::before,\n.rst__loadingCirclePoint:nth-of-type(13)::before {\n  animation-delay: 0ms;\n}\n\n.rst__rowTitle {\n  font-weight: bold;\n}\n\n.rst__rowTitleWithSubtitle {\n  font-size: 85%;\n  display: block;\n  height: 0.8rem;\n}\n\n.rst__rowSubtitle {\n  font-size: 70%;\n  line-height: 1;\n}\n\n.rst__collapseButton,\n.rst__expandButton {\n  appearance: none;\n  border: none;\n  position: absolute;\n  border-radius: 100%;\n  box-shadow: 0 0 0 1px #000;\n  width: 16px;\n  height: 16px;\n  padding: 0;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  cursor: pointer;\n}\n\n.rst__rtl.rst__collapseButton,\n.rst__rtl.rst__expandButton {\n  transform: translate(50%, -50%);\n}\n\n.rst__collapseButton:focus,\n.rst__expandButton:focus {\n  outline: none;\n  box-shadow: 0 0 0 1px #000, 0 0 1px 3px #83bef9;\n}\n\n.rst__collapseButton:hover:not(:active),\n.rst__expandButton:hover:not(:active) {\n  background-size: 24px;\n  height: 20px;\n  width: 20px;\n}\n\n.rst__collapseButton {\n  background: #fff url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCI+PGNpcmNsZSBjeD0iOSIgY3k9IjkiIHI9IjgiIGZpbGw9IiNGRkYiLz48ZyBzdHJva2U9IiM5ODk4OTgiIHN0cm9rZS13aWR0aD0iMS45IiA+PHBhdGggZD0iTTQuNSA5aDkiLz48L2c+Cjwvc3ZnPg==\") no-repeat center;\n}\n\n.rst__expandButton {\n  background: #fff url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCI+PGNpcmNsZSBjeD0iOSIgY3k9IjkiIHI9IjgiIGZpbGw9IiNGRkYiLz48ZyBzdHJva2U9IiM5ODk4OTgiIHN0cm9rZS13aWR0aD0iMS45IiA+PHBhdGggZD0iTTQuNSA5aDkiLz48cGF0aCBkPSJNOSA0LjV2OSIvPjwvZz4KPC9zdmc+\") no-repeat center;\n}\n\n/**\n * Line for under a node with children\n */\n.rst__lineChildren {\n  height: 100%;\n  display: inline-block;\n  position: absolute;\n}\n\n.rst__lineChildren::after {\n  content: \"\";\n  position: absolute;\n  background-color: black;\n  width: 1px;\n  left: 50%;\n  bottom: 0;\n  height: 10px;\n}\n\n.rst__rtl.rst__lineChildren::after {\n  right: 50%;\n  left: initial;\n}\n\n.rst__placeholder {\n  position: relative;\n  height: 68px;\n  max-width: 300px;\n  padding: 10px;\n}\n\n.rst__placeholder,\n.rst__placeholder > * {\n  box-sizing: border-box;\n}\n\n.rst__placeholder::before {\n  border: 3px dashed #e9ecef;\n  content: \"\";\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  bottom: 5px;\n  left: 5px;\n  z-index: -1;\n}\n\n/**\n * The outline of where the element will go if dropped, displayed while dragging\n */\n.rst__placeholderLandingPad,\n.rst__placeholderCancelPad {\n  border: none !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n.rst__placeholderLandingPad *,\n.rst__placeholderCancelPad * {\n  opacity: 0 !important;\n}\n\n.rst__placeholderLandingPad::before,\n.rst__placeholderCancelPad::before {\n  background-color: lightblue;\n  border-color: white;\n}\n\n/**\n * Alternate appearance of the landing pad when the dragged location is invalid\n */\n.rst__placeholderCancelPad::before {\n  background-color: #e6a8ad;\n}\n\n/* Collection default theme */\n/* Grid default theme */\n/* Table default theme */\n.ReactVirtualized__Table__headerRow {\n  font-weight: 700;\n  text-transform: uppercase;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.ReactVirtualized__Table__row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.ReactVirtualized__Table__headerTruncatedText {\n  display: inline-block;\n  max-width: 100%;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.ReactVirtualized__Table__headerColumn,\n.ReactVirtualized__Table__rowColumn {\n  margin-right: 10px;\n  min-width: 0px;\n}\n\n.ReactVirtualized__Table__rowColumn {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.ReactVirtualized__Table__headerColumn:first-of-type,\n.ReactVirtualized__Table__rowColumn:first-of-type {\n  margin-left: 10px;\n}\n\n.ReactVirtualized__Table__sortableHeaderColumn {\n  cursor: pointer;\n}\n\n.ReactVirtualized__Table__sortableHeaderIconContainer {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.ReactVirtualized__Table__sortableHeaderIcon {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 24px;\n  flex: 0 0 24px;\n  height: 1em;\n  width: 1em;\n  fill: currentColor;\n}\n\n/* List default theme */\n.ReactTable {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n}\n.ReactTable .rt-table {\n  flex: auto 1;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  width: 100%;\n  border-collapse: collapse;\n  overflow: auto;\n}\n.ReactTable .-pagination input,\n.ReactTable .-pagination select,\n.ReactTable .rt-thead.-filters input,\n.ReactTable .rt-thead.-filters select {\n  display: block;\n  width: 100%;\n  color: #495057;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #ced4da;\n  height: calc(1.5em + (0.5rem + 2px));\n  padding: 0.25rem 0.5rem;\n  border-radius: 0.2rem;\n  border-radius: 0.25rem;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;\n}\n.ReactTable .-pagination input::-ms-expand,\n.ReactTable .-pagination select::-ms-expand,\n.ReactTable .rt-thead.-filters input::-ms-expand,\n.ReactTable .rt-thead.-filters select::-ms-expand {\n  background-color: transparent;\n  border: 0;\n}\n.ReactTable .-pagination input::placeholder,\n.ReactTable .-pagination select::placeholder,\n.ReactTable .rt-thead.-filters input::placeholder,\n.ReactTable .rt-thead.-filters select::placeholder {\n  color: #6c757d;\n  opacity: 1;\n}\n.ReactTable .-pagination input:disabled, .ReactTable .-pagination input[readonly],\n.ReactTable .-pagination select:disabled,\n.ReactTable .-pagination select[readonly],\n.ReactTable .rt-thead.-filters input:disabled,\n.ReactTable .rt-thead.-filters input[readonly],\n.ReactTable .rt-thead.-filters select:disabled,\n.ReactTable .rt-thead.-filters select[readonly] {\n  background-color: #e9ecef;\n  opacity: 1;\n}\n.ReactTable .rt-thead {\n  flex: 1 0 auto;\n  display: flex;\n  flex-direction: column;\n  user-select: none;\n}\n.ReactTable .rt-thead.-headerGroups {\n  background: rgba(0, 0, 0, 0.03);\n  border-bottom: 1px solid #e9ecef;\n}\n.ReactTable .rt-thead.-headerGroups .rt-th,\n.ReactTable .rt-thead.-headerGroups .rt-td {\n  padding: 0.3rem;\n  color: #6c757d;\n}\n.ReactTable .rt-thead.-headerGroups .rt-th:hover,\n.ReactTable .rt-thead.-headerGroups .rt-td:hover {\n  color: #6c757d;\n}\n.ReactTable .rt-thead.-headerGroups .rt-th:empty,\n.ReactTable .rt-thead.-headerGroups .rt-td:empty {\n  padding: 0;\n}\n.ReactTable .rt-thead.-filters {\n  border-bottom: 1px solid #e9ecef;\n  background: #f8f9fa;\n}\n.ReactTable .rt-thead.-filters .rt-th {\n  border-right: 1px solid #e9ecef;\n}\n.ReactTable .rt-thead.-filters.-header {\n  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.15);\n}\n.ReactTable .rt-thead .rt-tr {\n  text-align: center;\n}\n.ReactTable .rt-thead .rt-th,\n.ReactTable .rt-thead .rt-td {\n  padding: 0.55rem;\n  line-height: normal;\n  position: relative;\n  font-weight: bold;\n  border-right: 1px solid #e9ecef;\n  border-bottom: 1px solid #e9ecef;\n  transition: box-shadow 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  box-shadow: inset 0 0 0 0 transparent;\n  color: #545cd8;\n}\n.ReactTable .rt-thead .rt-th:hover,\n.ReactTable .rt-thead .rt-td:hover {\n  color: rgb(41.5071428571, 50.0214285714, 181.9928571429);\n}\n.ReactTable .rt-thead .rt-th.-sort-asc,\n.ReactTable .rt-thead .rt-td.-sort-asc {\n  box-shadow: inset 0 3px 0 0 #545cd8;\n}\n.ReactTable .rt-thead .rt-th.-sort-desc,\n.ReactTable .rt-thead .rt-td.-sort-desc {\n  box-shadow: inset 0 -3px 0 0 #545cd8;\n}\n.ReactTable .rt-thead .rt-th.-cursor-pointer,\n.ReactTable .rt-thead .rt-td.-cursor-pointer {\n  cursor: pointer;\n}\n.ReactTable .rt-thead .rt-th:last-child,\n.ReactTable .rt-thead .rt-td:last-child {\n  border-right: 0;\n}\n.ReactTable .rt-thead .rt-resizable-header {\n  overflow: visible;\n}\n.ReactTable .rt-thead .rt-resizable-header:last-child {\n  overflow: hidden;\n}\n.ReactTable .rt-thead .rt-resizable-header-content {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.ReactTable .rt-thead .rt-header-pivot {\n  border-right-color: #f7f7f7;\n}\n.ReactTable .rt-thead .rt-header-pivot:after,\n.ReactTable .rt-thead .rt-header-pivot:before {\n  left: 100%;\n  top: 50%;\n  border: solid transparent;\n  content: \" \";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none;\n}\n.ReactTable .rt-thead .rt-header-pivot:after {\n  border-color: rgba(255, 255, 255, 0);\n  border-left-color: #fff;\n  border-width: 8px;\n  margin-top: -8px;\n}\n.ReactTable .rt-thead .rt-header-pivot:before {\n  border-color: rgba(102, 102, 102, 0);\n  border-left-color: #f7f7f7;\n  border-width: 10px;\n  margin-top: -10px;\n}\n.ReactTable .rt-tbody {\n  flex: 99999 1 auto;\n  display: flex;\n  flex-direction: column;\n  overflow: auto;\n}\n.ReactTable .rt-tbody .rt-tr-group {\n  border-bottom: solid 1px #e9ecef;\n}\n.ReactTable .rt-tbody .rt-tr-group:last-child {\n  border-bottom: 0;\n}\n.ReactTable .rt-tbody .rt-td {\n  border-right: 1px solid #e9ecef;\n  align-items: center;\n  align-content: center;\n  display: flex;\n}\n.ReactTable .rt-tbody .rt-td [contenteditable=true] {\n  width: 100%;\n  border: 1px solid transparent;\n  background: #fff !important;\n  border-radius: 0.2rem;\n}\n.ReactTable .rt-tbody .rt-td [contenteditable=true]:focus {\n  padding: 3px 5px;\n  border-color: rgb(187.8214285714, 190.9642857143, 239.6785714286);\n  outline: none;\n}\n.ReactTable .rt-tbody .rt-td:last-child {\n  border-right: 0;\n}\n.ReactTable .rt-tbody .rt-expandable {\n  cursor: pointer;\n  text-overflow: clip;\n}\n.ReactTable .rt-tr-group {\n  flex: 1 0 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n}\n.ReactTable .rt-tr {\n  flex: 1 0 auto;\n  display: inline-flex;\n}\n.ReactTable .rt-th,\n.ReactTable .rt-td {\n  flex: 1 0 0;\n  text-overflow: ellipsis;\n  padding: 0.55rem;\n  transition: 0.3s ease;\n  transition-property: width, min-width, padding, opacity;\n}\n.ReactTable .rt-th.-hidden,\n.ReactTable .rt-td.-hidden {\n  width: 0 !important;\n  min-width: 0 !important;\n  padding: 0 !important;\n  border: 0 !important;\n  opacity: 0 !important;\n}\n.ReactTable .rt-expander {\n  display: inline-block;\n  position: relative;\n  color: transparent;\n  margin: 0 10px 0 0;\n}\n.ReactTable .rt-expander:after {\n  content: \"\";\n  position: absolute;\n  width: 0;\n  height: 0;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%) rotate(-90deg);\n  border-left: 5.04px solid transparent;\n  border-right: 5.04px solid transparent;\n  border-top: 7px solid rgba(0, 0, 0, 0.8);\n  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  cursor: pointer;\n}\n.ReactTable .rt-expander.-open:after {\n  transform: translate(-50%, -50%) rotate(0);\n}\n.ReactTable .rt-resizer {\n  display: inline-block;\n  position: absolute;\n  width: 36px;\n  top: 0;\n  bottom: 0;\n  right: -18px;\n  cursor: col-resize;\n  z-index: 10;\n}\n.ReactTable .rt-tfoot {\n  flex: 1 0 auto;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);\n}\n.ReactTable .rt-tfoot .rt-td {\n  border-right: 1px solid #e9ecef;\n}\n.ReactTable .rt-tfoot .rt-td:last-child {\n  border-right: 0;\n}\n.ReactTable.-striped .rt-tr.-odd {\n  background: rgba(0, 0, 0, 0.03);\n}\n.ReactTable.-fixed .-header {\n  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.07);\n}\n.ReactTable.-fixed .pagination-bottom {\n  box-shadow: 0 -2px 7px 0 rgba(0, 0, 0, 0.07);\n}\n.ReactTable.-highlight .rt-tbody .rt-tr:not(.-padRow):hover {\n  background: #e0f3ff;\n}\n.ReactTable .-pagination {\n  z-index: 1;\n  display: flex;\n  justify-content: space-between;\n  align-items: stretch;\n  flex-wrap: wrap;\n  padding: 3px;\n  border-top: 2px solid rgba(0, 0, 0, 0.1);\n}\n.ReactTable .-pagination .-btn {\n  appearance: none;\n  display: block;\n  width: 100%;\n  height: 100%;\n  border: 0;\n  border-radius: 0.25rem;\n  padding: 6px;\n  font-size: 1em;\n  color: #545cd8;\n  background: #f8f9fa;\n  transition: all 0.2s ease;\n  cursor: pointer;\n  outline: none;\n  font-weight: bold;\n}\n.ReactTable .-pagination .-btn[disabled] {\n  opacity: 0.5;\n  cursor: default;\n}\n.ReactTable .-pagination .-btn:not([disabled]):hover {\n  background: #545cd8;\n  color: #fff;\n}\n.ReactTable .-pagination .-previous,\n.ReactTable .-pagination .-next {\n  flex: 1;\n  text-align: center;\n}\n.ReactTable .-pagination .-center {\n  text-align: center;\n  margin-bottom: 0;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-around;\n}\n.ReactTable .-pagination .-totalPages {\n  padding-left: 5px;\n  font-weight: bold;\n}\n.ReactTable .-pagination .-pageInfo {\n  display: inherit;\n  margin: 3px 0 3px 10px;\n  white-space: nowrap;\n  height: 30px;\n  line-height: 30px;\n}\n.ReactTable .-pagination .-pageJump {\n  display: inline-block;\n  margin: 0 5px;\n}\n.ReactTable .-pagination .-pageJump input {\n  width: 70px;\n  text-align: center;\n}\n.ReactTable .-pagination .-pageSizeOptions {\n  margin: 3px 10px;\n}\n.ReactTable .rt-noData {\n  display: block;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  background: rgba(255, 255, 255, 0.8);\n  transition: all 0.3s ease;\n  z-index: 1;\n  pointer-events: none;\n  padding: 20px;\n  color: rgba(0, 0, 0, 0.5);\n}\n.ReactTable .-loading {\n  display: block;\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background: rgba(255, 255, 255, 0.8);\n  transition: all 0.3s ease;\n  z-index: -1;\n  opacity: 0;\n  pointer-events: none;\n}\n.ReactTable .-loading > div {\n  position: absolute;\n  display: block;\n  text-align: center;\n  width: 100%;\n  top: 50%;\n  left: 0;\n  font-size: 15px;\n  color: #545cd8;\n  transform: translateY(-52%);\n  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n}\n.ReactTable .-loading.-active {\n  opacity: 1;\n  z-index: 2;\n  pointer-events: all;\n}\n.ReactTable .-loading.-active > div {\n  transform: translateY(50%);\n}\n.ReactTable .rt-resizing .rt-th,\n.ReactTable .rt-resizing .rt-td {\n  transition: none !important;\n  cursor: col-resize;\n  user-select: none;\n}\n\n.table thead th,\n.table td {\n  vertical-align: middle;\n}\n\n.table th .filter {\n  margin-top: 0.375rem;\n  height: auto;\n  padding: 0.3rem 0.5rem;\n}\n\n.caret-4-asc,\n.caret-4-desc {\n  font-family: \"Linearicons-Free\";\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  margin-left: 0.375rem;\n}\n\n.table .sortable:hover .caret-4-asc,\n.table .sortable:hover .caret-4-desc {\n  color: #545cd8;\n}\n\n.table-lg th,\n.table-lg td {\n  padding: 1.1rem 0.825rem;\n}\n\n.rdt_Table {\n  border: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.rdt_TableCol {\n  padding: 0.55rem;\n  line-height: normal;\n  position: relative;\n  font-weight: 700;\n  border-right: 1px solid #e9ecef;\n  border-bottom: 1px solid #e9ecef;\n  transition: box-shadow 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  box-shadow: inset 0 0 0 0 transparent;\n  color: #545cd8;\n}\n\n.rdt_TableCell {\n  border-right: 1px solid #e9ecef;\n}\n\n.rdt_TableRow:nth-child(odd) {\n  background-color: #FFFFFF;\n}\n\n.rdt_TableRow:nth-child(even) {\n  background-color: #f7f7f7;\n}\n\n.rdt_TableRow:hover {\n  background-color: #e0f3ff;\n}\n\n@font-face {\n  font-family: \"Linearicons-Free\";\n  src: url(\"linearicons/Linearicons-Free.eot?w118d\");\n  src: url(\"linearicons/Linearicons-Free.eot?#iefixw118d\") format(\"embedded-opentype\"), url(\"linearicons/Linearicons-Free.woff2?w118d\") format(\"woff2\"), url(\"linearicons/Linearicons-Free.woff?w118d\") format(\"woff\"), url(\"linearicons/Linearicons-Free.ttf?w118d\") format(\"truetype\"), url(\"linearicons/Linearicons-Free.svg?w118d#Linearicons-Free\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n}\n[class^=lnr-],\n[class*=\" lnr-\"] {\n  font-family: \"Linearicons-Free\";\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.lnr-home:before {\n  content: \"\\e800\";\n}\n\n.lnr-apartment:before {\n  content: \"\\e801\";\n}\n\n.lnr-pencil:before {\n  content: \"\\e802\";\n}\n\n.lnr-magic-wand:before {\n  content: \"\\e803\";\n}\n\n.lnr-drop:before {\n  content: \"\\e804\";\n}\n\n.lnr-lighter:before {\n  content: \"\\e805\";\n}\n\n.lnr-poop:before {\n  content: \"\\e806\";\n}\n\n.lnr-sun:before {\n  content: \"\\e807\";\n}\n\n.lnr-moon:before {\n  content: \"\\e808\";\n}\n\n.lnr-cloud:before {\n  content: \"\\e809\";\n}\n\n.lnr-cloud-upload:before {\n  content: \"\\e80a\";\n}\n\n.lnr-cloud-download:before {\n  content: \"\\e80b\";\n}\n\n.lnr-cloud-sync:before {\n  content: \"\\e80c\";\n}\n\n.lnr-cloud-check:before {\n  content: \"\\e80d\";\n}\n\n.lnr-database:before {\n  content: \"\\e80e\";\n}\n\n.lnr-lock:before {\n  content: \"\\e80f\";\n}\n\n.lnr-cog:before {\n  content: \"\\e810\";\n}\n\n.lnr-trash:before {\n  content: \"\\e811\";\n}\n\n.lnr-dice:before {\n  content: \"\\e812\";\n}\n\n.lnr-heart:before {\n  content: \"\\e813\";\n}\n\n.lnr-star:before {\n  content: \"\\e814\";\n}\n\n.lnr-star-half:before {\n  content: \"\\e815\";\n}\n\n.lnr-star-empty:before {\n  content: \"\\e816\";\n}\n\n.lnr-flag:before {\n  content: \"\\e817\";\n}\n\n.lnr-envelope:before {\n  content: \"\\e818\";\n}\n\n.lnr-paperclip:before {\n  content: \"\\e819\";\n}\n\n.lnr-inbox:before {\n  content: \"\\e81a\";\n}\n\n.lnr-eye:before {\n  content: \"\\e81b\";\n}\n\n.lnr-printer:before {\n  content: \"\\e81c\";\n}\n\n.lnr-file-empty:before {\n  content: \"\\e81d\";\n}\n\n.lnr-file-add:before {\n  content: \"\\e81e\";\n}\n\n.lnr-enter:before {\n  content: \"\\e81f\";\n}\n\n.lnr-exit:before {\n  content: \"\\e820\";\n}\n\n.lnr-graduation-hat:before {\n  content: \"\\e821\";\n}\n\n.lnr-license:before {\n  content: \"\\e822\";\n}\n\n.lnr-music-note:before {\n  content: \"\\e823\";\n}\n\n.lnr-film-play:before {\n  content: \"\\e824\";\n}\n\n.lnr-camera-video:before {\n  content: \"\\e825\";\n}\n\n.lnr-camera:before {\n  content: \"\\e826\";\n}\n\n.lnr-picture:before {\n  content: \"\\e827\";\n}\n\n.lnr-book:before {\n  content: \"\\e828\";\n}\n\n.lnr-bookmark:before {\n  content: \"\\e829\";\n}\n\n.lnr-user:before {\n  content: \"\\e82a\";\n}\n\n.lnr-users:before {\n  content: \"\\e82b\";\n}\n\n.lnr-shirt:before {\n  content: \"\\e82c\";\n}\n\n.lnr-store:before {\n  content: \"\\e82d\";\n}\n\n.lnr-cart:before {\n  content: \"\\e82e\";\n}\n\n.lnr-tag:before {\n  content: \"\\e82f\";\n}\n\n.lnr-phone-handset:before {\n  content: \"\\e830\";\n}\n\n.lnr-phone:before {\n  content: \"\\e831\";\n}\n\n.lnr-pushpin:before {\n  content: \"\\e832\";\n}\n\n.lnr-map-marker:before {\n  content: \"\\e833\";\n}\n\n.lnr-map:before {\n  content: \"\\e834\";\n}\n\n.lnr-location:before {\n  content: \"\\e835\";\n}\n\n.lnr-calendar-full:before {\n  content: \"\\e836\";\n}\n\n.lnr-keyboard:before {\n  content: \"\\e837\";\n}\n\n.lnr-spell-check:before {\n  content: \"\\e838\";\n}\n\n.lnr-screen:before {\n  content: \"\\e839\";\n}\n\n.lnr-smartphone:before {\n  content: \"\\e83a\";\n}\n\n.lnr-tablet:before {\n  content: \"\\e83b\";\n}\n\n.lnr-laptop:before {\n  content: \"\\e83c\";\n}\n\n.lnr-laptop-phone:before {\n  content: \"\\e83d\";\n}\n\n.lnr-power-switch:before {\n  content: \"\\e83e\";\n}\n\n.lnr-bubble:before {\n  content: \"\\e83f\";\n}\n\n.lnr-heart-pulse:before {\n  content: \"\\e840\";\n}\n\n.lnr-construction:before {\n  content: \"\\e841\";\n}\n\n.lnr-pie-chart:before {\n  content: \"\\e842\";\n}\n\n.lnr-chart-bars:before {\n  content: \"\\e843\";\n}\n\n.lnr-gift:before {\n  content: \"\\e844\";\n}\n\n.lnr-diamond:before {\n  content: \"\\e845\";\n}\n\n.lnr-linearicons:before {\n  content: \"\\e846\";\n}\n\n.lnr-dinner:before {\n  content: \"\\e847\";\n}\n\n.lnr-coffee-cup:before {\n  content: \"\\e848\";\n}\n\n.lnr-leaf:before {\n  content: \"\\e849\";\n}\n\n.lnr-paw:before {\n  content: \"\\e84a\";\n}\n\n.lnr-rocket:before {\n  content: \"\\e84b\";\n}\n\n.lnr-briefcase:before {\n  content: \"\\e84c\";\n}\n\n.lnr-bus:before {\n  content: \"\\e84d\";\n}\n\n.lnr-car:before {\n  content: \"\\e84e\";\n}\n\n.lnr-train:before {\n  content: \"\\e84f\";\n}\n\n.lnr-bicycle:before {\n  content: \"\\e850\";\n}\n\n.lnr-wheelchair:before {\n  content: \"\\e851\";\n}\n\n.lnr-select:before {\n  content: \"\\e852\";\n}\n\n.lnr-earth:before {\n  content: \"\\e853\";\n}\n\n.lnr-smile:before {\n  content: \"\\e854\";\n}\n\n.lnr-sad:before {\n  content: \"\\e855\";\n}\n\n.lnr-neutral:before {\n  content: \"\\e856\";\n}\n\n.lnr-mustache:before {\n  content: \"\\e857\";\n}\n\n.lnr-alarm:before {\n  content: \"\\e858\";\n}\n\n.lnr-bullhorn:before {\n  content: \"\\e859\";\n}\n\n.lnr-volume-high:before {\n  content: \"\\e85a\";\n}\n\n.lnr-volume-medium:before {\n  content: \"\\e85b\";\n}\n\n.lnr-volume-low:before {\n  content: \"\\e85c\";\n}\n\n.lnr-volume:before {\n  content: \"\\e85d\";\n}\n\n.lnr-mic:before {\n  content: \"\\e85e\";\n}\n\n.lnr-hourglass:before {\n  content: \"\\e85f\";\n}\n\n.lnr-undo:before {\n  content: \"\\e860\";\n}\n\n.lnr-redo:before {\n  content: \"\\e861\";\n}\n\n.lnr-sync:before {\n  content: \"\\e862\";\n}\n\n.lnr-history:before {\n  content: \"\\e863\";\n}\n\n.lnr-clock:before {\n  content: \"\\e864\";\n}\n\n.lnr-download:before {\n  content: \"\\e865\";\n}\n\n.lnr-upload:before {\n  content: \"\\e866\";\n}\n\n.lnr-enter-down:before {\n  content: \"\\e867\";\n}\n\n.lnr-exit-up:before {\n  content: \"\\e868\";\n}\n\n.lnr-bug:before {\n  content: \"\\e869\";\n}\n\n.lnr-code:before {\n  content: \"\\e86a\";\n}\n\n.lnr-link:before {\n  content: \"\\e86b\";\n}\n\n.lnr-unlink:before {\n  content: \"\\e86c\";\n}\n\n.lnr-thumbs-up:before {\n  content: \"\\e86d\";\n}\n\n.lnr-thumbs-down:before {\n  content: \"\\e86e\";\n}\n\n.lnr-magnifier:before {\n  content: \"\\e86f\";\n}\n\n.lnr-cross:before {\n  content: \"\\e870\";\n}\n\n.lnr-menu:before {\n  content: \"\\e871\";\n}\n\n.lnr-list:before {\n  content: \"\\e872\";\n}\n\n.lnr-chevron-up:before, .caret-4-asc:before {\n  content: \"\\e873\";\n}\n\n.lnr-chevron-down:before, .caret-4-desc:before {\n  content: \"\\e874\";\n}\n\n.lnr-chevron-left:before {\n  content: \"\\e875\";\n}\n\n.lnr-chevron-right:before {\n  content: \"\\e876\";\n}\n\n.lnr-arrow-up:before {\n  content: \"\\e877\";\n}\n\n.lnr-arrow-down:before {\n  content: \"\\e878\";\n}\n\n.lnr-arrow-left:before {\n  content: \"\\e879\";\n}\n\n.lnr-arrow-right:before {\n  content: \"\\e87a\";\n}\n\n.lnr-move:before {\n  content: \"\\e87b\";\n}\n\n.lnr-warning:before {\n  content: \"\\e87c\";\n}\n\n.lnr-question-circle:before {\n  content: \"\\e87d\";\n}\n\n.lnr-menu-circle:before {\n  content: \"\\e87e\";\n}\n\n.lnr-checkmark-circle:before, .forms-wizard li.form-wizard-step-done em:before {\n  content: \"\\e87f\";\n}\n\n.lnr-cross-circle:before {\n  content: \"\\e880\";\n}\n\n.lnr-plus-circle:before {\n  content: \"\\e881\";\n}\n\n.lnr-circle-minus:before {\n  content: \"\\e882\";\n}\n\n.lnr-arrow-up-circle:before {\n  content: \"\\e883\";\n}\n\n.lnr-arrow-down-circle:before {\n  content: \"\\e884\";\n}\n\n.lnr-arrow-left-circle:before {\n  content: \"\\e885\";\n}\n\n.lnr-arrow-right-circle:before {\n  content: \"\\e886\";\n}\n\n.lnr-chevron-up-circle:before {\n  content: \"\\e887\";\n}\n\n.lnr-chevron-down-circle:before {\n  content: \"\\e888\";\n}\n\n.lnr-chevron-left-circle:before {\n  content: \"\\e889\";\n}\n\n.lnr-chevron-right-circle:before {\n  content: \"\\e88a\";\n}\n\n.lnr-crop:before {\n  content: \"\\e88b\";\n}\n\n.lnr-frame-expand:before {\n  content: \"\\e88c\";\n}\n\n.lnr-frame-contract:before {\n  content: \"\\e88d\";\n}\n\n.lnr-layers:before {\n  content: \"\\e88e\";\n}\n\n.lnr-funnel:before {\n  content: \"\\e88f\";\n}\n\n.lnr-text-format:before {\n  content: \"\\e890\";\n}\n\n.lnr-text-format-remove:before {\n  content: \"\\e891\";\n}\n\n.lnr-text-size:before {\n  content: \"\\e892\";\n}\n\n.lnr-bold:before {\n  content: \"\\e893\";\n}\n\n.lnr-italic:before {\n  content: \"\\e894\";\n}\n\n.lnr-underline:before {\n  content: \"\\e895\";\n}\n\n.lnr-strikethrough:before {\n  content: \"\\e896\";\n}\n\n.lnr-highlight:before {\n  content: \"\\e897\";\n}\n\n.lnr-text-align-left:before {\n  content: \"\\e898\";\n}\n\n.lnr-text-align-center:before {\n  content: \"\\e899\";\n}\n\n.lnr-text-align-right:before {\n  content: \"\\e89a\";\n}\n\n.lnr-text-align-justify:before {\n  content: \"\\e89b\";\n}\n\n.lnr-line-spacing:before {\n  content: \"\\e89c\";\n}\n\n.lnr-indent-increase:before {\n  content: \"\\e89d\";\n}\n\n.lnr-indent-decrease:before {\n  content: \"\\e89e\";\n}\n\n.lnr-pilcrow:before {\n  content: \"\\e89f\";\n}\n\n.lnr-direction-ltr:before {\n  content: \"\\e8a0\";\n}\n\n.lnr-direction-rtl:before {\n  content: \"\\e8a1\";\n}\n\n.lnr-page-break:before {\n  content: \"\\e8a2\";\n}\n\n.lnr-sort-alpha-asc:before {\n  content: \"\\e8a3\";\n}\n\n.lnr-sort-amount-asc:before {\n  content: \"\\e8a4\";\n}\n\n.lnr-hand:before {\n  content: \"\\e8a5\";\n}\n\n.lnr-pointer-up:before {\n  content: \"\\e8a6\";\n}\n\n.lnr-pointer-right:before {\n  content: \"\\e8a7\";\n}\n\n.lnr-pointer-down:before {\n  content: \"\\e8a8\";\n}\n\n.lnr-pointer-left:before {\n  content: \"\\e8a9\";\n}\n\n/*\n*  Licensing: http://www.pixeden.com/icon-fonts/stroke-7-icon-font-set\n*/\n@font-face {\n  font-family: \"Pe-icon-7-stroke\";\n  src: url(\"~pe7-icon/dist/fonts/Pe-icon-7-stroke.eot?d7yf1v\");\n  src: url(\"~pe7-icon/dist/fonts/Pe-icon-7-stroke.eot?#iefixd7yf1v\") format(\"embedded-opentype\"), url(\"~pe7-icon/dist/fonts/Pe-icon-7-stroke.woff?d7yf1v\") format(\"woff\"), url(\"~pe7-icon/dist/fonts/Pe-icon-7-stroke.ttf?d7yf1v\") format(\"truetype\"), url(\"~pe7-icon/dist/fonts/Pe-icon-7-stroke.svg?d7yf1v#Pe-icon-7-stroke\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n}\n[class^=pe-7s-], [class*=\" pe-7s-\"] {\n  display: inline-block;\n  font-family: \"Pe-icon-7-stroke\";\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/* HELPER CLASS\n * -------------------------- */\n/* FA based classes */\n/*! Modified from font-awesome helper CSS classes - PIXEDEN\n *  Font Awesome 4.0.3 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (CSS: MIT License)\n */\n/* makes the font 33% larger relative to the icon container */\n.pe-lg {\n  font-size: 1.1704rem;\n  line-height: 0.75em;\n  vertical-align: -15%;\n}\n\n.pe-2x {\n  font-size: 1.76rem;\n}\n\n.pe-3x {\n  font-size: 2.64rem;\n}\n\n.pe-4x {\n  font-size: 3.52rem;\n}\n\n.pe-5x {\n  font-size: 4.4rem;\n}\n\n.pe-fw {\n  width: 1.2857142857em;\n  text-align: center;\n}\n\n.pe-ul {\n  padding-left: 0;\n  margin-left: 2.1428571429em;\n  list-style-type: none;\n}\n.pe-ul > li {\n  position: relative;\n}\n\n.pe-li {\n  position: absolute;\n  left: -2.1428571429em;\n  width: 2.1428571429em;\n  top: 0.1428571429em;\n  text-align: center;\n}\n.pe-li.pe-lg {\n  left: -1.8571428571em;\n}\n\n.pe-border {\n  padding: 0.2em 0.25em 0.15em;\n  border: solid 0.08em #eeeeee;\n  border-radius: 0.1em;\n}\n\n.pull-right {\n  float: right;\n}\n\n.pe.pull-left {\n  float: left;\n  margin-right: 0.3em;\n  margin-left: 0.3em;\n}\n\n.pe-spin {\n  animation: spin 2s infinite linear;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(359deg);\n  }\n}\n.pe-rotate-90 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);\n  transform: rotate(90deg);\n}\n\n.pe-rotate-180 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n  transform: rotate(180deg);\n}\n\n.pe-rotate-270 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);\n  transform: rotate(270deg);\n}\n\n.pe-flip-horizontal {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1);\n  transform: scale(-1, 1);\n}\n\n.pe-flip-vertical {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1);\n  transform: scale(1, -1);\n}\n\n.pe-stack {\n  position: relative;\n  display: inline-block;\n  width: 2em;\n  height: 2em;\n  line-height: 2em;\n  vertical-align: middle;\n}\n\n.pe-stack-1x,\n.pe-stack-2x {\n  position: absolute;\n  left: 0;\n  width: 100%;\n  text-align: center;\n}\n\n.pe-stack-1x {\n  line-height: inherit;\n}\n\n.pe-stack-2x {\n  font-size: 2em;\n}\n\n.pe-inverse {\n  color: #ffffff;\n}\n\n/* Custom classes / mods - PIXEDEN */\n.pe-va {\n  vertical-align: middle;\n}\n\n.pe-border {\n  border: solid 0.08em #eaeaea;\n}\n\n.pe-7s-album:before {\n  content: \"\\e6aa\";\n}\n\n.pe-7s-arc:before {\n  content: \"\\e6ab\";\n}\n\n.pe-7s-back-2:before {\n  content: \"\\e6ac\";\n}\n\n.pe-7s-bandaid:before {\n  content: \"\\e6ad\";\n}\n\n.pe-7s-car:before {\n  content: \"\\e6ae\";\n}\n\n.pe-7s-diamond:before {\n  content: \"\\e6af\";\n}\n\n.pe-7s-door-lock:before {\n  content: \"\\e6b0\";\n}\n\n.pe-7s-eyedropper:before {\n  content: \"\\e6b1\";\n}\n\n.pe-7s-female:before {\n  content: \"\\e6b2\";\n}\n\n.pe-7s-gym:before {\n  content: \"\\e6b3\";\n}\n\n.pe-7s-hammer:before {\n  content: \"\\e6b4\";\n}\n\n.pe-7s-headphones:before {\n  content: \"\\e6b5\";\n}\n\n.pe-7s-helm:before {\n  content: \"\\e6b6\";\n}\n\n.pe-7s-hourglass:before {\n  content: \"\\e6b7\";\n}\n\n.pe-7s-leaf:before {\n  content: \"\\e6b8\";\n}\n\n.pe-7s-magic-wand:before {\n  content: \"\\e6b9\";\n}\n\n.pe-7s-male:before {\n  content: \"\\e6ba\";\n}\n\n.pe-7s-map-2:before {\n  content: \"\\e6bb\";\n}\n\n.pe-7s-next-2:before {\n  content: \"\\e6bc\";\n}\n\n.pe-7s-paint-bucket:before {\n  content: \"\\e6bd\";\n}\n\n.pe-7s-pendrive:before {\n  content: \"\\e6be\";\n}\n\n.pe-7s-photo:before {\n  content: \"\\e6bf\";\n}\n\n.pe-7s-piggy:before {\n  content: \"\\e6c0\";\n}\n\n.pe-7s-plugin:before {\n  content: \"\\e6c1\";\n}\n\n.pe-7s-refresh-2:before {\n  content: \"\\e6c2\";\n}\n\n.pe-7s-rocket:before {\n  content: \"\\e6c3\";\n}\n\n.pe-7s-settings:before {\n  content: \"\\e6c4\";\n}\n\n.pe-7s-shield:before {\n  content: \"\\e6c5\";\n}\n\n.pe-7s-smile:before {\n  content: \"\\e6c6\";\n}\n\n.pe-7s-usb:before {\n  content: \"\\e6c7\";\n}\n\n.pe-7s-vector:before {\n  content: \"\\e6c8\";\n}\n\n.pe-7s-wine:before {\n  content: \"\\e6c9\";\n}\n\n.pe-7s-cloud-upload:before {\n  content: \"\\e68a\";\n}\n\n.pe-7s-cash:before {\n  content: \"\\e68c\";\n}\n\n.pe-7s-close:before {\n  content: \"\\e680\";\n}\n\n.pe-7s-bluetooth:before {\n  content: \"\\e68d\";\n}\n\n.pe-7s-cloud-download:before {\n  content: \"\\e68b\";\n}\n\n.pe-7s-way:before {\n  content: \"\\e68e\";\n}\n\n.pe-7s-close-circle:before {\n  content: \"\\e681\";\n}\n\n.pe-7s-id:before {\n  content: \"\\e68f\";\n}\n\n.pe-7s-angle-up:before {\n  content: \"\\e682\";\n}\n\n.pe-7s-wristwatch:before {\n  content: \"\\e690\";\n}\n\n.pe-7s-angle-up-circle:before {\n  content: \"\\e683\";\n}\n\n.pe-7s-world:before {\n  content: \"\\e691\";\n}\n\n.pe-7s-angle-right:before {\n  content: \"\\e684\";\n}\n\n.pe-7s-volume:before {\n  content: \"\\e692\";\n}\n\n.pe-7s-angle-right-circle:before {\n  content: \"\\e685\";\n}\n\n.pe-7s-users:before {\n  content: \"\\e693\";\n}\n\n.pe-7s-angle-left:before {\n  content: \"\\e686\";\n}\n\n.pe-7s-user-female:before {\n  content: \"\\e694\";\n}\n\n.pe-7s-angle-left-circle:before {\n  content: \"\\e687\";\n}\n\n.pe-7s-up-arrow:before {\n  content: \"\\e695\";\n}\n\n.pe-7s-angle-down:before {\n  content: \"\\e688\";\n}\n\n.pe-7s-switch:before {\n  content: \"\\e696\";\n}\n\n.pe-7s-angle-down-circle:before {\n  content: \"\\e689\";\n}\n\n.pe-7s-scissors:before {\n  content: \"\\e697\";\n}\n\n.pe-7s-wallet:before {\n  content: \"\\e600\";\n}\n\n.pe-7s-safe:before {\n  content: \"\\e698\";\n}\n\n.pe-7s-volume2:before {\n  content: \"\\e601\";\n}\n\n.pe-7s-volume1:before {\n  content: \"\\e602\";\n}\n\n.pe-7s-voicemail:before {\n  content: \"\\e603\";\n}\n\n.pe-7s-video:before {\n  content: \"\\e604\";\n}\n\n.pe-7s-user:before {\n  content: \"\\e605\";\n}\n\n.pe-7s-upload:before {\n  content: \"\\e606\";\n}\n\n.pe-7s-unlock:before {\n  content: \"\\e607\";\n}\n\n.pe-7s-umbrella:before {\n  content: \"\\e608\";\n}\n\n.pe-7s-trash:before {\n  content: \"\\e609\";\n}\n\n.pe-7s-tools:before {\n  content: \"\\e60a\";\n}\n\n.pe-7s-timer:before {\n  content: \"\\e60b\";\n}\n\n.pe-7s-ticket:before {\n  content: \"\\e60c\";\n}\n\n.pe-7s-target:before {\n  content: \"\\e60d\";\n}\n\n.pe-7s-sun:before {\n  content: \"\\e60e\";\n}\n\n.pe-7s-study:before {\n  content: \"\\e60f\";\n}\n\n.pe-7s-stopwatch:before {\n  content: \"\\e610\";\n}\n\n.pe-7s-star:before {\n  content: \"\\e611\";\n}\n\n.pe-7s-speaker:before {\n  content: \"\\e612\";\n}\n\n.pe-7s-signal:before {\n  content: \"\\e613\";\n}\n\n.pe-7s-shuffle:before {\n  content: \"\\e614\";\n}\n\n.pe-7s-shopbag:before {\n  content: \"\\e615\";\n}\n\n.pe-7s-share:before {\n  content: \"\\e616\";\n}\n\n.pe-7s-server:before {\n  content: \"\\e617\";\n}\n\n.pe-7s-search:before {\n  content: \"\\e618\";\n}\n\n.pe-7s-film:before {\n  content: \"\\e6a5\";\n}\n\n.pe-7s-science:before {\n  content: \"\\e619\";\n}\n\n.pe-7s-disk:before {\n  content: \"\\e6a6\";\n}\n\n.pe-7s-ribbon:before {\n  content: \"\\e61a\";\n}\n\n.pe-7s-repeat:before {\n  content: \"\\e61b\";\n}\n\n.pe-7s-refresh:before {\n  content: \"\\e61c\";\n}\n\n.pe-7s-add-user:before {\n  content: \"\\e6a9\";\n}\n\n.pe-7s-refresh-cloud:before {\n  content: \"\\e61d\";\n}\n\n.pe-7s-paperclip:before {\n  content: \"\\e69c\";\n}\n\n.pe-7s-radio:before {\n  content: \"\\e61e\";\n}\n\n.pe-7s-note2:before {\n  content: \"\\e69d\";\n}\n\n.pe-7s-print:before {\n  content: \"\\e61f\";\n}\n\n.pe-7s-network:before {\n  content: \"\\e69e\";\n}\n\n.pe-7s-prev:before {\n  content: \"\\e620\";\n}\n\n.pe-7s-mute:before {\n  content: \"\\e69f\";\n}\n\n.pe-7s-power:before {\n  content: \"\\e621\";\n}\n\n.pe-7s-medal:before {\n  content: \"\\e6a0\";\n}\n\n.pe-7s-portfolio:before {\n  content: \"\\e622\";\n}\n\n.pe-7s-like2:before {\n  content: \"\\e6a1\";\n}\n\n.pe-7s-plus:before {\n  content: \"\\e623\";\n}\n\n.pe-7s-left-arrow:before {\n  content: \"\\e6a2\";\n}\n\n.pe-7s-play:before {\n  content: \"\\e624\";\n}\n\n.pe-7s-key:before {\n  content: \"\\e6a3\";\n}\n\n.pe-7s-plane:before {\n  content: \"\\e625\";\n}\n\n.pe-7s-joy:before {\n  content: \"\\e6a4\";\n}\n\n.pe-7s-photo-gallery:before {\n  content: \"\\e626\";\n}\n\n.pe-7s-pin:before {\n  content: \"\\e69b\";\n}\n\n.pe-7s-phone:before {\n  content: \"\\e627\";\n}\n\n.pe-7s-plug:before {\n  content: \"\\e69a\";\n}\n\n.pe-7s-pen:before {\n  content: \"\\e628\";\n}\n\n.pe-7s-right-arrow:before {\n  content: \"\\e699\";\n}\n\n.pe-7s-paper-plane:before {\n  content: \"\\e629\";\n}\n\n.pe-7s-delete-user:before {\n  content: \"\\e6a7\";\n}\n\n.pe-7s-paint:before {\n  content: \"\\e62a\";\n}\n\n.pe-7s-bottom-arrow:before {\n  content: \"\\e6a8\";\n}\n\n.pe-7s-notebook:before {\n  content: \"\\e62b\";\n}\n\n.pe-7s-note:before {\n  content: \"\\e62c\";\n}\n\n.pe-7s-next:before {\n  content: \"\\e62d\";\n}\n\n.pe-7s-news-paper:before {\n  content: \"\\e62e\";\n}\n\n.pe-7s-musiclist:before {\n  content: \"\\e62f\";\n}\n\n.pe-7s-music:before {\n  content: \"\\e630\";\n}\n\n.pe-7s-mouse:before {\n  content: \"\\e631\";\n}\n\n.pe-7s-more:before {\n  content: \"\\e632\";\n}\n\n.pe-7s-moon:before {\n  content: \"\\e633\";\n}\n\n.pe-7s-monitor:before {\n  content: \"\\e634\";\n}\n\n.pe-7s-micro:before {\n  content: \"\\e635\";\n}\n\n.pe-7s-menu:before {\n  content: \"\\e636\";\n}\n\n.pe-7s-map:before {\n  content: \"\\e637\";\n}\n\n.pe-7s-map-marker:before {\n  content: \"\\e638\";\n}\n\n.pe-7s-mail:before {\n  content: \"\\e639\";\n}\n\n.pe-7s-mail-open:before {\n  content: \"\\e63a\";\n}\n\n.pe-7s-mail-open-file:before {\n  content: \"\\e63b\";\n}\n\n.pe-7s-magnet:before {\n  content: \"\\e63c\";\n}\n\n.pe-7s-loop:before {\n  content: \"\\e63d\";\n}\n\n.pe-7s-look:before {\n  content: \"\\e63e\";\n}\n\n.pe-7s-lock:before {\n  content: \"\\e63f\";\n}\n\n.pe-7s-lintern:before {\n  content: \"\\e640\";\n}\n\n.pe-7s-link:before {\n  content: \"\\e641\";\n}\n\n.pe-7s-like:before {\n  content: \"\\e642\";\n}\n\n.pe-7s-light:before {\n  content: \"\\e643\";\n}\n\n.pe-7s-less:before {\n  content: \"\\e644\";\n}\n\n.pe-7s-keypad:before {\n  content: \"\\e645\";\n}\n\n.pe-7s-junk:before {\n  content: \"\\e646\";\n}\n\n.pe-7s-info:before {\n  content: \"\\e647\";\n}\n\n.pe-7s-home:before {\n  content: \"\\e648\";\n}\n\n.pe-7s-help2:before {\n  content: \"\\e649\";\n}\n\n.pe-7s-help1:before {\n  content: \"\\e64a\";\n}\n\n.pe-7s-graph3:before {\n  content: \"\\e64b\";\n}\n\n.pe-7s-graph2:before {\n  content: \"\\e64c\";\n}\n\n.pe-7s-graph1:before {\n  content: \"\\e64d\";\n}\n\n.pe-7s-graph:before {\n  content: \"\\e64e\";\n}\n\n.pe-7s-global:before {\n  content: \"\\e64f\";\n}\n\n.pe-7s-gleam:before {\n  content: \"\\e650\";\n}\n\n.pe-7s-glasses:before {\n  content: \"\\e651\";\n}\n\n.pe-7s-gift:before {\n  content: \"\\e652\";\n}\n\n.pe-7s-folder:before {\n  content: \"\\e653\";\n}\n\n.pe-7s-flag:before {\n  content: \"\\e654\";\n}\n\n.pe-7s-filter:before {\n  content: \"\\e655\";\n}\n\n.pe-7s-file:before {\n  content: \"\\e656\";\n}\n\n.pe-7s-expand1:before {\n  content: \"\\e657\";\n}\n\n.pe-7s-exapnd2:before {\n  content: \"\\e658\";\n}\n\n.pe-7s-edit:before {\n  content: \"\\e659\";\n}\n\n.pe-7s-drop:before {\n  content: \"\\e65a\";\n}\n\n.pe-7s-drawer:before {\n  content: \"\\e65b\";\n}\n\n.pe-7s-download:before {\n  content: \"\\e65c\";\n}\n\n.pe-7s-display2:before {\n  content: \"\\e65d\";\n}\n\n.pe-7s-display1:before {\n  content: \"\\e65e\";\n}\n\n.pe-7s-diskette:before {\n  content: \"\\e65f\";\n}\n\n.pe-7s-date:before {\n  content: \"\\e660\";\n}\n\n.pe-7s-cup:before {\n  content: \"\\e661\";\n}\n\n.pe-7s-culture:before {\n  content: \"\\e662\";\n}\n\n.pe-7s-crop:before {\n  content: \"\\e663\";\n}\n\n.pe-7s-credit:before {\n  content: \"\\e664\";\n}\n\n.pe-7s-copy-file:before {\n  content: \"\\e665\";\n}\n\n.pe-7s-config:before {\n  content: \"\\e666\";\n}\n\n.pe-7s-compass:before {\n  content: \"\\e667\";\n}\n\n.pe-7s-comment:before {\n  content: \"\\e668\";\n}\n\n.pe-7s-coffee:before {\n  content: \"\\e669\";\n}\n\n.pe-7s-cloud:before {\n  content: \"\\e66a\";\n}\n\n.pe-7s-clock:before {\n  content: \"\\e66b\";\n}\n\n.pe-7s-check:before {\n  content: \"\\e66c\";\n}\n\n.pe-7s-chat:before {\n  content: \"\\e66d\";\n}\n\n.pe-7s-cart:before {\n  content: \"\\e66e\";\n}\n\n.pe-7s-camera:before {\n  content: \"\\e66f\";\n}\n\n.pe-7s-call:before {\n  content: \"\\e670\";\n}\n\n.pe-7s-calculator:before {\n  content: \"\\e671\";\n}\n\n.pe-7s-browser:before {\n  content: \"\\e672\";\n}\n\n.pe-7s-box2:before {\n  content: \"\\e673\";\n}\n\n.pe-7s-box1:before {\n  content: \"\\e674\";\n}\n\n.pe-7s-bookmarks:before {\n  content: \"\\e675\";\n}\n\n.pe-7s-bicycle:before {\n  content: \"\\e676\";\n}\n\n.pe-7s-bell:before {\n  content: \"\\e677\";\n}\n\n.pe-7s-battery:before {\n  content: \"\\e678\";\n}\n\n.pe-7s-ball:before {\n  content: \"\\e679\";\n}\n\n.pe-7s-back:before {\n  content: \"\\e67a\";\n}\n\n.pe-7s-attention:before {\n  content: \"\\e67b\";\n}\n\n.pe-7s-anchor:before {\n  content: \"\\e67c\";\n}\n\n.pe-7s-albums:before {\n  content: \"\\e67d\";\n}\n\n.pe-7s-alarm:before {\n  content: \"\\e67e\";\n}\n\n.pe-7s-airplay:before {\n  content: \"\\e67f\";\n}\n\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle {\n  margin-left: -6px;\n  position: absolute;\n}\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle, .react-datepicker__year-read-view--down-arrow::before,\n.react-datepicker__month-read-view--down-arrow::before,\n.react-datepicker__month-year-read-view--down-arrow::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {\n  box-sizing: content-box;\n  position: absolute;\n  border: 6px solid transparent;\n  height: 0;\n  width: 1px;\n}\n.react-datepicker__year-read-view--down-arrow::before,\n.react-datepicker__month-read-view--down-arrow::before,\n.react-datepicker__month-year-read-view--down-arrow::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {\n  content: \"\";\n  z-index: -1;\n  border-width: 6px;\n  left: -6px;\n  border-bottom-color: #dee2e6;\n}\n\n.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle {\n  top: 0;\n  margin-top: -6px;\n}\n.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {\n  border-top: none;\n  border-bottom-color: #fff;\n}\n.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {\n  top: -1px;\n  border-bottom-color: #dee2e6;\n}\n\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle {\n  bottom: 0;\n  margin-bottom: -6px;\n}\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle, .react-datepicker__year-read-view--down-arrow::before,\n.react-datepicker__month-read-view--down-arrow::before,\n.react-datepicker__month-year-read-view--down-arrow::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before {\n  border-bottom: none;\n  border-top-color: #fff;\n}\n.react-datepicker__year-read-view--down-arrow::before,\n.react-datepicker__month-read-view--down-arrow::before,\n.react-datepicker__month-year-read-view--down-arrow::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before {\n  bottom: -1px;\n  border-top-color: #dee2e6;\n}\n\n.react-datepicker-wrapper {\n  display: block;\n  z-index: 10;\n}\n\n.react-datepicker {\n  background-color: #fff;\n  color: #495057;\n  border: 1px solid #dee2e6;\n  border-radius: 0.25rem;\n  display: inline-block;\n  position: relative;\n  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);\n}\n\n.react-datepicker--time-only .react-datepicker__triangle {\n  left: 35px;\n}\n.react-datepicker--time-only .react-datepicker__time-container {\n  border-left: 0;\n}\n.react-datepicker--time-only .react-datepicker__time {\n  border-radius: 0.3rem;\n}\n.react-datepicker--time-only .react-datepicker__time-box {\n  border-radius: 0.3rem;\n}\n\n.react-datepicker__triangle {\n  position: absolute;\n  left: 50px;\n}\n\n.react-datepicker-popper {\n  z-index: 102;\n}\n.react-datepicker-popper[data-placement^=bottom] {\n  margin-top: 8px;\n}\n.react-datepicker-popper[data-placement^=top] {\n  margin-bottom: 8px;\n}\n.react-datepicker-popper[data-placement^=right] {\n  margin-left: 6px;\n}\n.react-datepicker-popper[data-placement^=right] .react-datepicker__triangle {\n  left: auto;\n  right: 42px;\n}\n.react-datepicker-popper[data-placement^=left] {\n  margin-right: 6px;\n}\n.react-datepicker-popper[data-placement^=left] .react-datepicker__triangle {\n  left: 42px;\n  right: auto;\n}\n\n.react-datepicker__header {\n  text-align: center;\n  background-color: #fff;\n  border-bottom: 1px solid #dee2e6;\n  border-top-left-radius: 0.25rem;\n  border-top-right-radius: 0.25rem;\n  padding-top: 10px;\n  position: relative;\n}\n.react-datepicker__header--time {\n  padding-bottom: 8px;\n  padding-left: 5px;\n  padding-right: 5px;\n}\n\n.react-datepicker__year-dropdown-container--select,\n.react-datepicker__month-dropdown-container--select,\n.react-datepicker__month-year-dropdown-container--select,\n.react-datepicker__year-dropdown-container--scroll,\n.react-datepicker__month-dropdown-container--scroll,\n.react-datepicker__month-year-dropdown-container--scroll {\n  display: inline-block;\n  margin: 0 2px;\n}\n\n.react-datepicker__current-month,\n.react-datepicker-time__header {\n  margin-top: 0;\n  color: #343a40;\n  font-weight: bold;\n  font-size: 0.968rem;\n}\n\n.react-datepicker-time__header {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.react-datepicker__navigation {\n  background: none;\n  line-height: 2rem;\n  text-align: center;\n  cursor: pointer;\n  position: absolute;\n  top: 15px;\n  padding: 0;\n  border: 0.35rem solid transparent;\n  z-index: 1;\n  height: 10px;\n  width: 10px;\n  text-indent: -999em;\n  overflow: hidden;\n}\n.react-datepicker__navigation--previous {\n  left: 10px;\n  border-right-color: #ced4da;\n}\n.react-datepicker__navigation--previous:hover {\n  border-right-color: rgb(176.9418604651, 186.5, 196.0581395349);\n}\n.react-datepicker__navigation--previous--disabled, .react-datepicker__navigation--previous--disabled:hover {\n  border-right-color: rgb(191.4709302326, 199.25, 207.0290697674);\n  cursor: default;\n}\n.react-datepicker__navigation--next {\n  right: 10px;\n  border-left-color: #ced4da;\n}\n.react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {\n  right: 80px;\n}\n.react-datepicker__navigation--next:hover {\n  border-left-color: rgb(176.9418604651, 186.5, 196.0581395349);\n}\n.react-datepicker__navigation--next--disabled, .react-datepicker__navigation--next--disabled:hover {\n  border-left-color: rgb(191.4709302326, 199.25, 207.0290697674);\n  cursor: default;\n}\n.react-datepicker__navigation--years {\n  position: relative;\n  top: 0;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n.react-datepicker__navigation--years-previous {\n  top: 4px;\n  border-top-color: #ced4da;\n}\n.react-datepicker__navigation--years-previous:hover {\n  border-top-color: rgb(176.9418604651, 186.5, 196.0581395349);\n}\n.react-datepicker__navigation--years-upcoming {\n  top: -4px;\n  border-bottom-color: #ced4da;\n}\n.react-datepicker__navigation--years-upcoming:hover {\n  border-bottom-color: rgb(176.9418604651, 186.5, 196.0581395349);\n}\n\n.react-datepicker__month-container {\n  float: left;\n}\n\n.react-datepicker__month {\n  margin: 0.5rem;\n  text-align: center;\n}\n\n.react-datepicker__time-container {\n  float: right;\n  border-left: 1px solid #dee2e6;\n  width: 120px;\n}\n.react-datepicker__time-container--with-today-button {\n  display: inline;\n  border: 1px solid #aeaeae;\n  border-radius: 0.3rem;\n  position: absolute;\n  right: -122px;\n  top: 0;\n}\n.react-datepicker__time-container .react-datepicker__time {\n  position: relative;\n  background: white;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {\n  width: 120px;\n  overflow-x: hidden;\n  margin: 0 auto;\n  text-align: center;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  height: calc(195px + 2rem / 2);\n  overflow-y: scroll;\n  width: 100%;\n  box-sizing: content-box;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item {\n  padding: 5px 10px;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover {\n  cursor: pointer;\n  background-color: #e0f3ff;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {\n  background-color: theme-color(\"primary\");\n  color: #fff;\n  font-weight: bold;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover {\n  background-color: theme-color(\"primary\");\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled {\n  color: #ced4da;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled:hover {\n  cursor: default;\n  background-color: transparent;\n}\n\n.react-datepicker__week-number {\n  color: #ced4da;\n  display: inline-block;\n  width: 2rem;\n  line-height: 2rem;\n  text-align: center;\n  margin: 0.166rem;\n}\n.react-datepicker__week-number.react-datepicker__week-number--clickable {\n  cursor: pointer;\n}\n.react-datepicker__week-number.react-datepicker__week-number--clickable:hover {\n  border-radius: 0.25rem;\n  background-color: #fff;\n}\n\n.react-datepicker__day-names {\n  background: #f8f9fa;\n  border-top: #dee2e6 solid 1px;\n  margin-top: 10px;\n}\n\n.react-datepicker__day-names,\n.react-datepicker__week {\n  white-space: nowrap;\n}\n\n.react-datepicker__day-name,\n.react-datepicker__day,\n.react-datepicker__time-name {\n  color: #495057;\n  display: inline-block;\n  width: 2rem;\n  line-height: 2rem;\n  text-align: center;\n  margin: 0.166rem;\n}\n\n.react-datepicker__day {\n  cursor: pointer;\n  border-radius: 0.25rem;\n}\n.react-datepicker__day:hover {\n  background-color: #545cd8;\n  color: #fff;\n}\n.react-datepicker__day--today {\n  font-weight: bold;\n}\n.react-datepicker__day--highlighted {\n  border-radius: 0.25rem;\n  background-color: #545cd8;\n  color: #fff;\n}\n.react-datepicker__day--highlighted:hover {\n  background-color: rgb(63.2357142857, 72.2071428571, 211.2642857143);\n}\n.react-datepicker__day--highlighted-custom-1 {\n  color: #f7b924;\n}\n.react-datepicker__day--highlighted-custom-2 {\n  color: #444054;\n}\n.react-datepicker__day--selected {\n  background-color: #3ac47d;\n  color: #fff;\n}\n.react-datepicker__day--selected:hover {\n  background-color: #3ac47d;\n  color: #fff;\n}\n.react-datepicker__day--in-selecting-range, .react-datepicker__day--in-range {\n  background-color: #e0f3ff;\n  color: rgb(29.7, 33.3, 36.9);\n}\n.react-datepicker__day--in-selecting-range:hover, .react-datepicker__day--in-range:hover {\n  background-color: #e0f3ff;\n  color: rgb(29.7, 33.3, 36.9);\n}\n.react-datepicker__day--keyboard-selected {\n  border-radius: 0.25rem;\n  background-color: rgb(96.811023622, 208.188976378, 150.8858267717);\n  color: #fff;\n}\n.react-datepicker__day--keyboard-selected:hover {\n  background-color: rgb(52.1771653543, 176.3228346457, 112.4507874016);\n}\n.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range) {\n  background-color: #e0f3ff;\n}\n.react-datepicker__month--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range) {\n  background-color: #3ac47d;\n  color: #fff;\n}\n.react-datepicker__day--disabled {\n  cursor: default;\n  color: #ced4da;\n}\n.react-datepicker__day--disabled:hover {\n  background-color: transparent;\n  color: #ced4da;\n}\n\n.react-datepicker__day--selecting-range-start,\n.react-datepicker__day--selecting-range-end {\n  background-color: #3ac47d !important;\n  color: #fff !important;\n}\n\n.react-datepicker__year-read-view,\n.react-datepicker__month-read-view,\n.react-datepicker__month-year-read-view {\n  border: 1px solid transparent;\n  border-radius: 0.25rem;\n}\n.react-datepicker__year-read-view:hover,\n.react-datepicker__month-read-view:hover,\n.react-datepicker__month-year-read-view:hover {\n  cursor: pointer;\n}\n.react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-year-read-view:hover .react-datepicker__month-read-view--down-arrow {\n  border-top-color: rgb(176.9418604651, 186.5, 196.0581395349);\n}\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow {\n  border-top-color: #ced4da;\n  float: right;\n  margin-left: 20px;\n  top: 8px;\n  position: relative;\n  border-width: 0.35rem;\n}\n\n.react-datepicker__year-dropdown,\n.react-datepicker__month-dropdown,\n.react-datepicker__month-year-dropdown {\n  background-color: #fff;\n  position: absolute;\n  width: 50%;\n  left: 25%;\n  top: 30px;\n  z-index: 1;\n  text-align: center;\n  border-radius: 0.25rem;\n  border: 1px solid #dee2e6;\n}\n.react-datepicker__year-dropdown:hover,\n.react-datepicker__month-dropdown:hover,\n.react-datepicker__month-year-dropdown:hover {\n  cursor: pointer;\n}\n.react-datepicker__year-dropdown--scrollable,\n.react-datepicker__month-dropdown--scrollable,\n.react-datepicker__month-year-dropdown--scrollable {\n  height: 150px;\n  overflow-y: scroll;\n}\n\n.react-datepicker__year-option,\n.react-datepicker__month-option,\n.react-datepicker__month-year-option {\n  line-height: 20px;\n  width: 100%;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n.react-datepicker__year-option:first-of-type,\n.react-datepicker__month-option:first-of-type,\n.react-datepicker__month-year-option:first-of-type {\n  border-top-left-radius: 0.25rem;\n  border-top-right-radius: 0.25rem;\n}\n.react-datepicker__year-option:last-of-type,\n.react-datepicker__month-option:last-of-type,\n.react-datepicker__month-year-option:last-of-type {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  border-bottom-left-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n}\n.react-datepicker__year-option:hover,\n.react-datepicker__month-option:hover,\n.react-datepicker__month-year-option:hover {\n  background-color: #ced4da;\n}\n.react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming,\n.react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,\n.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-upcoming {\n  border-bottom-color: rgb(176.9418604651, 186.5, 196.0581395349);\n}\n.react-datepicker__year-option:hover .react-datepicker__navigation--years-previous,\n.react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,\n.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-previous {\n  border-top-color: rgb(176.9418604651, 186.5, 196.0581395349);\n}\n.react-datepicker__year-option--selected,\n.react-datepicker__month-option--selected,\n.react-datepicker__month-year-option--selected {\n  position: absolute;\n  left: 15px;\n}\n\n.react-datepicker__close-icon {\n  background-color: transparent;\n  border: 0;\n  cursor: pointer;\n  outline: 0;\n  padding: 0;\n  vertical-align: middle;\n  position: absolute;\n  height: 16px;\n  width: 16px;\n  top: 25%;\n  right: 7px;\n}\n.react-datepicker__close-icon::after {\n  background-color: theme-color(\"primary\");\n  border-radius: 50%;\n  bottom: 0;\n  box-sizing: border-box;\n  color: #fff;\n  content: \"×\";\n  cursor: pointer;\n  font-size: 12px;\n  height: 16px;\n  width: 16px;\n  line-height: 1;\n  margin: -8px auto 0;\n  padding: 2px;\n  position: absolute;\n  right: 0px;\n  text-align: center;\n}\n\n.react-datepicker__today-button {\n  background: #fff;\n  border-top: 1px solid #dee2e6;\n  cursor: pointer;\n  text-align: center;\n  font-weight: bold;\n  padding: 5px 0;\n  clear: left;\n}\n\n.react-datepicker__portal {\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  z-index: 1040;\n  background-color: rgba(0, 0, 0, 0.5);\n  left: 0;\n  top: 0;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n}\n.react-datepicker__portal .react-datepicker__day-name,\n.react-datepicker__portal .react-datepicker__day,\n.react-datepicker__portal .react-datepicker__time-name {\n  width: 3rem;\n  line-height: 3rem;\n}\n@media (max-width: 400px), (max-height: 550px) {\n  .react-datepicker__portal .react-datepicker__day-name,\n  .react-datepicker__portal .react-datepicker__day,\n  .react-datepicker__portal .react-datepicker__time-name {\n    width: 2rem;\n    line-height: 2rem;\n  }\n}\n.react-datepicker__portal .react-datepicker__current-month,\n.react-datepicker__portal .react-datepicker-time__header {\n  font-size: 1.584rem;\n}\n.react-datepicker__portal .react-datepicker__navigation {\n  border: 0.63rem solid transparent;\n  margin-top: 3px;\n}\n.react-datepicker__portal .react-datepicker__navigation--previous {\n  border-right-color: #545cd8;\n}\n.react-datepicker__portal .react-datepicker__navigation--previous:hover {\n  border-right-color: rgb(46.2428571429, 55.7285714286, 202.7571428571);\n}\n.react-datepicker__portal .react-datepicker__navigation--previous--disabled, .react-datepicker__portal .react-datepicker__navigation--previous--disabled:hover {\n  border-right-color: rgb(191.4709302326, 199.25, 207.0290697674);\n  cursor: default;\n}\n.react-datepicker__portal .react-datepicker__navigation--next {\n  border-left-color: #545cd8;\n}\n.react-datepicker__portal .react-datepicker__navigation--next:hover {\n  border-left-color: rgb(46.2428571429, 55.7285714286, 202.7571428571);\n}\n.react-datepicker__portal .react-datepicker__navigation--next--disabled, .react-datepicker__portal .react-datepicker__navigation--next--disabled:hover {\n  border-left-color: rgb(191.4709302326, 199.25, 207.0290697674);\n  cursor: default;\n}\n\n.rangeButtonSelectedStyle {\n  background: #545cd8 !important;\n}\n\n.rangebuttonstyle {\n  outline: none !important;\n  color: #545cd8 !important;\n}\n\n.rc-slider-tooltip {\n  z-index: 555;\n}\n\n.rc-tooltip.rc-tooltip-zoom-enter,\n.rc-tooltip.rc-tooltip-zoom-leave {\n  display: block;\n}\n\n.rc-tooltip-zoom-enter,\n.rc-tooltip-zoom-appear {\n  opacity: 0;\n  animation-duration: 0.3s;\n  animation-fill-mode: both;\n  animation-timing-function: cubic-bezier(0.18, 0.89, 0.32, 1.28);\n  animation-play-state: paused;\n}\n\n.rc-tooltip-zoom-leave {\n  animation-duration: 0.3s;\n  animation-fill-mode: both;\n  animation-timing-function: cubic-bezier(0.6, -0.3, 0.74, 0.05);\n  animation-play-state: paused;\n}\n\n.rc-tooltip-zoom-enter.rc-tooltip-zoom-enter-active,\n.rc-tooltip-zoom-appear.rc-tooltip-zoom-appear-active {\n  animation-name: rcToolTipZoomIn;\n  animation-play-state: running;\n}\n\n.rc-tooltip-zoom-leave.rc-tooltip-zoom-leave-active {\n  animation-name: rcToolTipZoomOut;\n  animation-play-state: running;\n}\n\n@keyframes rcToolTipZoomIn {\n  0% {\n    opacity: 0;\n    transform-origin: 50% 50%;\n    transform: scale(0, 0);\n  }\n  100% {\n    opacity: 1;\n    transform-origin: 50% 50%;\n    transform: scale(1, 1);\n  }\n}\n@keyframes rcToolTipZoomOut {\n  0% {\n    opacity: 1;\n    transform-origin: 50% 50%;\n    transform: scale(1, 1);\n  }\n  100% {\n    opacity: 0;\n    transform-origin: 50% 50%;\n    transform: scale(0, 0);\n  }\n}\n.rc-tooltip {\n  position: absolute;\n  z-index: 1070;\n  display: block;\n  visibility: visible;\n  font-size: 12px;\n  line-height: 1.5;\n  opacity: 0.9;\n}\n\n.rc-tooltip-hidden {\n  display: none;\n}\n\n.rc-tooltip-placement-top,\n.rc-tooltip-placement-topLeft,\n.rc-tooltip-placement-topRight {\n  padding: 5px 0 9px 0;\n}\n\n.rc-tooltip-placement-right,\n.rc-tooltip-placement-rightTop,\n.rc-tooltip-placement-rightBottom {\n  padding: 0 5px 0 9px;\n}\n\n.rc-tooltip-placement-bottom,\n.rc-tooltip-placement-bottomLeft,\n.rc-tooltip-placement-bottomRight {\n  padding: 9px 0 5px 0;\n}\n\n.rc-tooltip-placement-left,\n.rc-tooltip-placement-leftTop,\n.rc-tooltip-placement-leftBottom {\n  padding: 0 9px 0 5px;\n}\n\n.rc-tooltip-inner {\n  padding: 12px 14px;\n  color: #fff;\n  text-align: left;\n  text-decoration: none;\n  background-color: #343a40;\n  border-radius: 6px;\n  box-shadow: 0 0 4px rgba(0, 0, 0, 0.17);\n  min-height: 34px;\n  font-weight: bold;\n}\n\n.rc-tooltip-arrow {\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-color: transparent;\n  border-style: solid;\n}\n\n.rc-tooltip-placement-top .rc-tooltip-arrow,\n.rc-tooltip-placement-topLeft .rc-tooltip-arrow,\n.rc-tooltip-placement-topRight .rc-tooltip-arrow {\n  bottom: 4px;\n  margin-left: -5px;\n  border-width: 5px 5px 0;\n  border-top-color: #343a40;\n}\n\n.rc-tooltip-placement-top .rc-tooltip-arrow {\n  left: 50%;\n}\n\n.rc-tooltip-placement-topLeft .rc-tooltip-arrow {\n  left: 15%;\n}\n\n.rc-tooltip-placement-topRight .rc-tooltip-arrow {\n  right: 15%;\n}\n\n.rc-tooltip-placement-right .rc-tooltip-arrow,\n.rc-tooltip-placement-rightTop .rc-tooltip-arrow,\n.rc-tooltip-placement-rightBottom .rc-tooltip-arrow {\n  left: 4px;\n  margin-top: -5px;\n  border-width: 5px 5px 5px 0;\n  border-right-color: #343a40;\n}\n\n.rc-tooltip-placement-right .rc-tooltip-arrow {\n  top: 50%;\n}\n\n.rc-tooltip-placement-rightTop .rc-tooltip-arrow {\n  top: 15%;\n  margin-top: 0;\n}\n\n.rc-tooltip-placement-rightBottom .rc-tooltip-arrow {\n  bottom: 15%;\n}\n\n.rc-tooltip-placement-left .rc-tooltip-arrow,\n.rc-tooltip-placement-leftTop .rc-tooltip-arrow,\n.rc-tooltip-placement-leftBottom .rc-tooltip-arrow {\n  right: 4px;\n  margin-top: -5px;\n  border-width: 5px 0 5px 5px;\n  border-left-color: #343a40;\n}\n\n.rc-tooltip-placement-left .rc-tooltip-arrow {\n  top: 50%;\n}\n\n.rc-tooltip-placement-leftTop .rc-tooltip-arrow {\n  top: 15%;\n  margin-top: 0;\n}\n\n.rc-tooltip-placement-leftBottom .rc-tooltip-arrow {\n  bottom: 15%;\n}\n\n.rc-tooltip-placement-bottom .rc-tooltip-arrow,\n.rc-tooltip-placement-bottomLeft .rc-tooltip-arrow,\n.rc-tooltip-placement-bottomRight .rc-tooltip-arrow {\n  top: 4px;\n  margin-left: -5px;\n  border-width: 0 5px 5px;\n  border-bottom-color: #343a40;\n}\n\n.rc-tooltip-placement-bottom .rc-tooltip-arrow {\n  left: 50%;\n}\n\n.rc-tooltip-placement-bottomLeft .rc-tooltip-arrow {\n  left: 15%;\n}\n\n.rc-tooltip-placement-bottomRight .rc-tooltip-arrow {\n  right: 15%;\n}\n\n.rc-slider {\n  position: relative;\n  height: 20px;\n  padding: 8px 0 0;\n  width: 100%;\n  border-radius: 0.25rem;\n  -ms-touch-action: none;\n  touch-action: none;\n  box-sizing: border-box;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.rc-slider-rail {\n  position: absolute;\n  width: 100%;\n  background-color: #e9ecef;\n  height: 4px;\n  border-radius: 0.25rem;\n}\n\n.rc-slider-track {\n  position: absolute;\n  left: 0;\n  height: 4px;\n  border-radius: 0.25rem;\n  background-color: #545cd8;\n}\n\n.rc-slider-handle {\n  position: absolute;\n  margin-left: -8px;\n  margin-top: -6px;\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n  cursor: -webkit-grab;\n  cursor: grab;\n  border-radius: 50%;\n  border: solid 2px #545cd8;\n  background-color: #fff;\n  -ms-touch-action: pan-x;\n  touch-action: pan-x;\n  transition: box-shadow 200ms;\n}\n.rc-slider-handle:focus {\n  outline: none;\n}\n.rc-slider-handle:focus, .rc-slider-handle:active, .rc-slider-handle:hover {\n  border-color: rgb(41.5071428571, 50.0214285714, 181.9928571429);\n  box-shadow: 0 0.46875rem 2.1875rem rgba(84, 92, 216, 0.8), 0 0.125rem 0.5875rem rgba(84, 92, 216, 0.9);\n}\n.rc-slider-handle:active {\n  cursor: -webkit-grabbing;\n  cursor: grabbing;\n}\n\n.rc-slider-mark {\n  position: absolute;\n  top: 18px;\n  left: 0;\n  width: 100%;\n  font-size: 12px;\n}\n\n.rc-slider-mark-text {\n  position: absolute;\n  display: inline-block;\n  vertical-align: middle;\n  text-align: center;\n  cursor: pointer;\n  color: #6c757d;\n}\n\n.rc-slider-mark-text-active {\n  color: #343a40;\n}\n\n.rc-slider-step {\n  position: absolute;\n  width: 100%;\n  height: 4px;\n  background: transparent;\n}\n\n.rc-slider-dot {\n  position: absolute;\n  bottom: -2px;\n  margin-left: -4px;\n  width: 8px;\n  height: 8px;\n  border: 2px solid #dee2e6;\n  background-color: #fff;\n  cursor: pointer;\n  border-radius: 50%;\n  vertical-align: middle;\n}\n\n.rc-slider-dot-active {\n  border-color: #545cd8;\n}\n\n.rc-slider-disabled {\n  background-color: #e9ecef;\n}\n\n.rc-slider-disabled .rc-slider-track {\n  background-color: #ced4da;\n}\n\n.rc-slider-disabled .rc-slider-handle,\n.rc-slider-disabled .rc-slider-dot {\n  border-color: #ced4da;\n  box-shadow: none;\n  background-color: #fff;\n  cursor: not-allowed;\n}\n\n.rc-slider-disabled .rc-slider-mark-text,\n.rc-slider-disabled .rc-slider-dot {\n  cursor: not-allowed !important;\n}\n\n.rc-slider-vertical {\n  width: 14px;\n  height: 100%;\n  padding: 0 5px;\n}\n\n.rc-slider-vertical .rc-slider-rail {\n  height: 100%;\n  width: 4px;\n}\n\n.rc-slider-vertical .rc-slider-track {\n  left: 5px;\n  bottom: 0;\n  width: 4px;\n}\n\n.rc-slider-vertical .rc-slider-handle {\n  margin-left: -6px;\n  margin-bottom: -7px;\n  -ms-touch-action: pan-y;\n  touch-action: pan-y;\n}\n\n.rc-slider-vertical .rc-slider-mark {\n  top: 0;\n  left: 18px;\n  height: 100%;\n}\n\n.rc-slider-vertical .rc-slider-step {\n  height: 100%;\n  width: 4px;\n}\n\n.rc-slider-vertical .rc-slider-dot {\n  left: 2px;\n  margin-bottom: -4px;\n}\n\n.rc-slider-vertical .rc-slider-dot:first-child {\n  margin-bottom: -4px;\n}\n\n.rc-slider-vertical .rc-slider-dot:last-child {\n  margin-bottom: -4px;\n}\n\n.rc-slider-tooltip-zoom-down-enter,\n.rc-slider-tooltip-zoom-down-appear {\n  animation-duration: 0.3s;\n  animation-fill-mode: both;\n  display: block !important;\n  animation-play-state: paused;\n}\n\n.rc-slider-tooltip-zoom-down-leave {\n  animation-duration: 0.3s;\n  animation-fill-mode: both;\n  display: block !important;\n  animation-play-state: paused;\n}\n\n.rc-slider-tooltip-zoom-down-enter.rc-slider-tooltip-zoom-down-enter-active,\n.rc-slider-tooltip-zoom-down-appear.rc-slider-tooltip-zoom-down-appear-active {\n  animation-name: rcSliderTooltipZoomDownIn;\n  animation-play-state: running;\n}\n\n.rc-slider-tooltip-zoom-down-leave.rc-slider-tooltip-zoom-down-leave-active {\n  animation-name: rcSliderTooltipZoomDownOut;\n  animation-play-state: running;\n}\n\n.rc-slider-tooltip-zoom-down-enter,\n.rc-slider-tooltip-zoom-down-appear {\n  transform: scale(0, 0);\n  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\n}\n\n.rc-slider-tooltip-zoom-down-leave {\n  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n}\n\n@keyframes rcSliderTooltipZoomDownIn {\n  0% {\n    opacity: 0;\n    transform-origin: 50% 100%;\n    transform: scale(0, 0);\n  }\n  100% {\n    transform-origin: 50% 100%;\n    transform: scale(1, 1);\n  }\n}\n@keyframes rcSliderTooltipZoomDownOut {\n  0% {\n    transform-origin: 50% 100%;\n    transform: scale(1, 1);\n  }\n  100% {\n    opacity: 0;\n    transform-origin: 50% 100%;\n    transform: scale(0, 0);\n  }\n}\n.rc-slider-tooltip {\n  position: absolute;\n  left: -9999px;\n  top: -9999px;\n  visibility: visible;\n  box-sizing: border-box;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.rc-slider-tooltip-hidden {\n  display: none;\n}\n\n.rc-slider-tooltip-placement-top {\n  padding: 4px 0 8px 0;\n}\n\n.rc-slider-tooltip-inner {\n  padding: 0 8px;\n  min-width: 28px;\n  height: 28px;\n  line-height: 28px;\n  color: #fff;\n  text-align: center;\n  text-decoration: none;\n  background-color: #212529;\n  border-radius: 0.25rem;\n  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);\n  font-weight: bold;\n}\n\n.rc-slider-tooltip-arrow {\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-color: transparent;\n  border-style: solid;\n}\n\n.rc-slider-tooltip-placement-top .rc-slider-tooltip-arrow {\n  bottom: 4px;\n  left: 50%;\n  margin-left: -4px;\n  border-width: 4px 4px 0;\n  border-top-color: #212529;\n}\n\n.rc-slider-primary .rc-slider-track {\n  background-color: #545cd8;\n}\n.rc-slider-primary .rc-slider-handle {\n  border-color: #545cd8;\n  background-color: #fff;\n}\n.rc-slider-primary .rc-slider-handle:focus, .rc-slider-primary .rc-slider-handle:active, .rc-slider-primary .rc-slider-handle:hover {\n  border-color: rgb(41.5071428571, 50.0214285714, 181.9928571429);\n  box-shadow: 0 0.46875rem 2.1875rem rgba(84, 92, 216, 0.8), 0 0.125rem 0.5875rem rgba(84, 92, 216, 0.9);\n}\n.rc-slider-primary .rc-slider-dot-active {\n  border-color: #545cd8;\n}\n\n.rc-slider-secondary .rc-slider-track {\n  background-color: #6c757d;\n}\n.rc-slider-secondary .rc-slider-handle {\n  border-color: #6c757d;\n  background-color: #fff;\n}\n.rc-slider-secondary .rc-slider-handle:focus, .rc-slider-secondary .rc-slider-handle:active, .rc-slider-secondary .rc-slider-handle:hover {\n  border-color: rgb(72.5407725322, 78.5858369099, 83.9592274678);\n  box-shadow: 0 0.46875rem 2.1875rem rgba(108, 117, 125, 0.8), 0 0.125rem 0.5875rem rgba(108, 117, 125, 0.9);\n}\n.rc-slider-secondary .rc-slider-dot-active {\n  border-color: #6c757d;\n}\n\n.rc-slider-success .rc-slider-track {\n  background-color: #3ac47d;\n}\n.rc-slider-success .rc-slider-handle {\n  border-color: #3ac47d;\n  background-color: #fff;\n}\n.rc-slider-success .rc-slider-handle:focus, .rc-slider-success .rc-slider-handle:active, .rc-slider-success .rc-slider-handle:hover {\n  border-color: rgb(40.531496063, 136.968503937, 87.3523622047);\n  box-shadow: 0 0.46875rem 2.1875rem rgba(58, 196, 125, 0.8), 0 0.125rem 0.5875rem rgba(58, 196, 125, 0.9);\n}\n.rc-slider-success .rc-slider-dot-active {\n  border-color: #3ac47d;\n}\n\n.rc-slider-info .rc-slider-track {\n  background-color: #30b1ff;\n}\n.rc-slider-info .rc-slider-handle {\n  border-color: #30b1ff;\n  background-color: #fff;\n}\n.rc-slider-info .rc-slider-handle:focus, .rc-slider-info .rc-slider-handle:active, .rc-slider-info .rc-slider-handle:hover {\n  border-color: rgb(0, 141.152173913, 226.5);\n  box-shadow: 0 0.46875rem 2.1875rem rgba(48, 177, 255, 0.8), 0 0.125rem 0.5875rem rgba(48, 177, 255, 0.9);\n}\n.rc-slider-info .rc-slider-dot-active {\n  border-color: #30b1ff;\n}\n\n.rc-slider-warning .rc-slider-track {\n  background-color: #f7b924;\n}\n.rc-slider-warning .rc-slider-handle {\n  border-color: #f7b924;\n  background-color: #fff;\n}\n.rc-slider-warning .rc-slider-handle:focus, .rc-slider-warning .rc-slider-handle:active, .rc-slider-warning .rc-slider-handle:hover {\n  border-color: rgb(199.2224669604, 142.8215859031, 7.2775330396);\n  box-shadow: 0 0.46875rem 2.1875rem rgba(247, 185, 36, 0.8), 0 0.125rem 0.5875rem rgba(247, 185, 36, 0.9);\n}\n.rc-slider-warning .rc-slider-dot-active {\n  border-color: #f7b924;\n}\n\n.rc-slider-danger .rc-slider-track {\n  background-color: #d92550;\n}\n.rc-slider-danger .rc-slider-handle {\n  border-color: #d92550;\n  background-color: #fff;\n}\n.rc-slider-danger .rc-slider-handle:focus, .rc-slider-danger .rc-slider-handle:active, .rc-slider-danger .rc-slider-handle:hover {\n  border-color: rgb(151.6437007874, 25.8562992126, 55.905511811);\n  box-shadow: 0 0.46875rem 2.1875rem rgba(217, 37, 80, 0.8), 0 0.125rem 0.5875rem rgba(217, 37, 80, 0.9);\n}\n.rc-slider-danger .rc-slider-dot-active {\n  border-color: #d92550;\n}\n\n.rc-slider-light .rc-slider-track {\n  background-color: #eeeeee;\n}\n.rc-slider-light .rc-slider-handle {\n  border-color: #eeeeee;\n  background-color: #fff;\n}\n.rc-slider-light .rc-slider-handle:focus, .rc-slider-light .rc-slider-handle:active, .rc-slider-light .rc-slider-handle:hover {\n  border-color: rgb(199.75, 199.75, 199.75);\n  box-shadow: 0 0.46875rem 2.1875rem rgba(238, 238, 238, 0.8), 0 0.125rem 0.5875rem rgba(238, 238, 238, 0.9);\n}\n.rc-slider-light .rc-slider-dot-active {\n  border-color: #eeeeee;\n}\n\n.rc-slider-dark .rc-slider-track {\n  background-color: #343a40;\n}\n.rc-slider-dark .rc-slider-handle {\n  border-color: #343a40;\n  background-color: #fff;\n}\n.rc-slider-dark .rc-slider-handle:focus, .rc-slider-dark .rc-slider-handle:active, .rc-slider-dark .rc-slider-handle:hover {\n  border-color: rgb(17.7068965517, 19.75, 21.7931034483);\n  box-shadow: 0 0.46875rem 2.1875rem rgba(52, 58, 64, 0.8), 0 0.125rem 0.5875rem rgba(52, 58, 64, 0.9);\n}\n.rc-slider-dark .rc-slider-dot-active {\n  border-color: #343a40;\n}\n\n.rc-slider-focus .rc-slider-track {\n  background-color: #444054;\n}\n.rc-slider-focus .rc-slider-handle {\n  border-color: #444054;\n  background-color: #fff;\n}\n.rc-slider-focus .rc-slider-handle:focus, .rc-slider-focus .rc-slider-handle:active, .rc-slider-focus .rc-slider-handle:hover {\n  border-color: rgb(32.8513513514, 30.9189189189, 40.5810810811);\n  box-shadow: 0 0.46875rem 2.1875rem rgba(68, 64, 84, 0.8), 0 0.125rem 0.5875rem rgba(68, 64, 84, 0.9);\n}\n.rc-slider-focus .rc-slider-dot-active {\n  border-color: #444054;\n}\n\n.rc-slider-alternate .rc-slider-track {\n  background-color: #83588a;\n}\n.rc-slider-alternate .rc-slider-handle {\n  border-color: #83588a;\n  background-color: #fff;\n}\n.rc-slider-alternate .rc-slider-handle:focus, .rc-slider-alternate .rc-slider-handle:active, .rc-slider-alternate .rc-slider-handle:hover {\n  border-color: rgb(86.657079646, 58.2123893805, 91.2876106195);\n  box-shadow: 0 0.46875rem 2.1875rem rgba(131, 88, 138, 0.8), 0 0.125rem 0.5875rem rgba(131, 88, 138, 0.9);\n}\n.rc-slider-alternate .rc-slider-dot-active {\n  border-color: #83588a;\n}\n\n.rc-slider-line .rc-slider-handle {\n  border-radius: 0;\n  border-width: 0 3px 0 0;\n  margin-left: -8px;\n  width: 10px;\n  background-color: transparent;\n  box-shadow: 0 0 0 transparent !important;\n}\n\n.rc-slider-square .rc-slider-handle {\n  border-radius: 3px;\n  border-widtH: 1px;\n}\n.rc-slider-square .rc-slider-handle:before {\n  position: absolute;\n  height: 8px;\n  width: 4px;\n  border: #adb5bd solid 1px;\n  border-width: 0 1px;\n  display: block;\n  content: \"\";\n  top: 50%;\n  left: 50%;\n  margin: -4px -2px;\n}\n\n.rc-slider-lg.rc-slider {\n  height: 20px;\n  padding: 8px 0 0;\n}\n.rc-slider-lg .rc-slider-rail {\n  height: 4px;\n}\n.rc-slider-lg .rc-slider-track {\n  height: 4px;\n}\n.rc-slider-lg .rc-slider-handle {\n  margin-left: -10px;\n  margin-top: -8px;\n  width: 20px;\n  height: 20px;\n}\n.rc-slider-lg.rc-slider-line .rc-slider-handle {\n  margin-left: -8px;\n  width: 10px;\n}\n.rc-slider-lg.rc-slider-square .rc-slider-handle:before {\n  height: 10px;\n  width: 6px;\n  margin: -5px -3px;\n}\n\n.rc-slider-sm.rc-slider {\n  height: 20px;\n  padding: 8px 0 0;\n}\n.rc-slider-sm .rc-slider-rail {\n  height: 4px;\n}\n.rc-slider-sm .rc-slider-track {\n  height: 4px;\n}\n.rc-slider-sm .rc-slider-handle {\n  margin-left: -6px;\n  margin-top: -4px;\n  width: 12px;\n  height: 12px;\n}\n.rc-slider-sm.rc-slider-line .rc-slider-handle {\n  margin-left: -8px;\n  width: 10px;\n}\n.rc-slider-sm.rc-slider-square .rc-slider-handle:before {\n  height: 6px;\n  margin: -3px 0 0 -1px;\n  border: 0;\n  width: 2px;\n  background: #adb5bd;\n}\n\n.rdw-option-wrapper {\n  border: 1px solid #F1F1F1;\n  padding: 5px;\n  min-width: 25px;\n  height: 20px;\n  border-radius: 2px;\n  margin: 0 4px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  background: white;\n  text-transform: capitalize;\n}\n\n.rdw-option-wrapper:hover {\n  box-shadow: 1px 1px 0px #BFBDBD;\n}\n\n.rdw-option-wrapper:active {\n  box-shadow: 1px 1px 0px #BFBDBD inset;\n}\n\n.rdw-option-active {\n  box-shadow: 1px 1px 0px #BFBDBD inset;\n}\n\n.rdw-option-disabled {\n  opacity: 0.3;\n  cursor: default;\n}\n\n.rdw-dropdown-wrapper {\n  height: 30px;\n  background: white;\n  cursor: pointer;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  margin: 0 3px;\n  text-transform: capitalize;\n  background: white;\n}\n\n.rdw-dropdown-wrapper:focus {\n  outline: none;\n}\n\n.rdw-dropdown-wrapper:hover {\n  box-shadow: 1px 1px 0px #BFBDBD;\n  background-color: #FFFFFF;\n}\n\n.rdw-dropdown-wrapper:active {\n  box-shadow: 1px 1px 0px #BFBDBD inset;\n}\n\n.rdw-dropdown-carettoopen {\n  height: 0px;\n  width: 0px;\n  position: absolute;\n  top: 35%;\n  right: 10%;\n  border-top: 6px solid black;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n}\n\n.rdw-dropdown-carettoclose {\n  height: 0px;\n  width: 0px;\n  position: absolute;\n  top: 35%;\n  right: 10%;\n  border-bottom: 6px solid black;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n}\n\n.rdw-dropdown-selectedtext {\n  display: flex;\n  position: relative;\n  height: 100%;\n  align-items: center;\n  padding: 0 5px;\n}\n\n.rdw-dropdown-optionwrapper {\n  z-index: 100;\n  position: relative;\n  border: 1px solid #F1F1F1;\n  width: 98%;\n  background: white;\n  border-radius: 2px;\n  margin: 0;\n  padding: 0;\n  max-height: 250px;\n  overflow-y: scroll;\n}\n\n.rdw-dropdown-optionwrapper:hover {\n  box-shadow: 1px 1px 0px #BFBDBD;\n  background-color: #FFFFFF;\n}\n\n.rdw-dropdownoption-default {\n  min-height: 25px;\n  display: flex;\n  align-items: center;\n  padding: 0 5px;\n}\n\n.rdw-dropdownoption-highlighted {\n  background: #F1F1F1;\n}\n\n.rdw-dropdownoption-active {\n  background: #f5f5f5;\n}\n\n.rdw-dropdownoption-disabled {\n  opacity: 0.3;\n  cursor: default;\n}\n\n.rdw-inline-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n}\n\n.rdw-inline-dropdown {\n  width: 50px;\n}\n\n.rdw-inline-dropdownoption {\n  height: 40px;\n  display: flex;\n  justify-content: center;\n}\n\n.rdw-block-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n}\n\n.rdw-block-dropdown {\n  width: 110px;\n}\n\n.rdw-fontsize-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n}\n\n.rdw-fontsize-dropdown {\n  min-width: 40px;\n}\n\n.rdw-fontsize-option {\n  display: flex;\n  justify-content: center;\n}\n\n.rdw-fontfamily-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n}\n\n.rdw-fontfamily-dropdown {\n  width: 115px;\n}\n\n.rdw-fontfamily-placeholder {\n  white-space: nowrap;\n  max-width: 90px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.rdw-fontfamily-optionwrapper {\n  width: 140px;\n}\n\n.rdw-list-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n}\n\n.rdw-list-dropdown {\n  width: 50px;\n  z-index: 90;\n}\n\n.rdw-list-dropdownOption {\n  height: 40px;\n  display: flex;\n  justify-content: center;\n}\n\n.rdw-text-align-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n}\n\n.rdw-text-align-dropdown {\n  width: 50px;\n  z-index: 90;\n}\n\n.rdw-text-align-dropdownOption {\n  height: 40px;\n  display: flex;\n  justify-content: center;\n}\n\n.rdw-right-aligned-block {\n  text-align: right;\n}\n\n.rdw-left-aligned-block {\n  text-align: left !important;\n}\n\n.rdw-center-aligned-block {\n  text-align: center !important;\n}\n\n.rdw-justify-aligned-block {\n  text-align: justify !important;\n}\n\n.rdw-right-aligned-block > div {\n  display: inline-block;\n}\n\n.rdw-left-aligned-block > div {\n  display: inline-block;\n}\n\n.rdw-center-aligned-block > div {\n  display: inline-block;\n}\n\n.rdw-justify-aligned-block > div {\n  display: inline-block;\n}\n\n.rdw-colorpicker-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n  position: relative;\n}\n\n.rdw-colorpicker-modal {\n  position: absolute;\n  top: 35px;\n  left: 5px;\n  display: flex;\n  flex-direction: column;\n  width: 175px;\n  height: 175px;\n  border: 1px solid #F1F1F1;\n  padding: 15px;\n  border-radius: 2px;\n  z-index: 100;\n  background: white;\n  box-shadow: 3px 3px 5px #BFBDBD;\n}\n\n.rdw-colorpicker-modal-header {\n  display: flex;\n  padding-bottom: 5px;\n}\n\n.rdw-colorpicker-modal-style-label {\n  font-size: 15px;\n  width: 50%;\n  text-align: center;\n  cursor: pointer;\n  padding: 0 10px 5px;\n}\n\n.rdw-colorpicker-modal-style-label-active {\n  border-bottom: 2px solid #0a66b7;\n}\n\n.rdw-colorpicker-modal-options {\n  margin: 5px auto;\n  display: flex;\n  width: 100%;\n  height: 100%;\n  flex-wrap: wrap;\n  overflow: scroll;\n}\n\n.rdw-colorpicker-cube {\n  width: 22px;\n  height: 22px;\n  border: 1px solid #F1F1F1;\n}\n\n.rdw-colorpicker-option {\n  margin: 3px;\n  padding: 0;\n  min-height: 20px;\n  border: none;\n  width: 22px;\n  height: 22px;\n  min-width: 22px;\n  box-shadow: 1px 2px 1px #BFBDBD inset;\n}\n\n.rdw-colorpicker-option:hover {\n  box-shadow: 1px 2px 1px #BFBDBD;\n}\n\n.rdw-colorpicker-option:active {\n  box-shadow: -1px -2px 1px #BFBDBD;\n}\n\n.rdw-colorpicker-option-active {\n  box-shadow: 0px 0px 2px 2px #BFBDBD;\n}\n\n.rdw-link-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n  position: relative;\n}\n\n.rdw-link-dropdown {\n  width: 50px;\n}\n\n.rdw-link-dropdownOption {\n  height: 40px;\n  display: flex;\n  justify-content: center;\n}\n\n.rdw-link-dropdownPlaceholder {\n  margin-left: 8px;\n}\n\n.rdw-link-modal {\n  position: absolute;\n  top: 35px;\n  left: 5px;\n  display: flex;\n  flex-direction: column;\n  width: 235px;\n  height: 205px;\n  border: 1px solid #F1F1F1;\n  padding: 15px;\n  border-radius: 2px;\n  z-index: 100;\n  background: white;\n  box-shadow: 3px 3px 5px #BFBDBD;\n}\n\n.rdw-link-modal-label {\n  font-size: 15px;\n}\n\n.rdw-link-modal-input {\n  margin-top: 5px;\n  border-radius: 2px;\n  border: 1px solid #F1F1F1;\n  height: 25px;\n  margin-bottom: 15px;\n  padding: 0 5px;\n}\n\n.rdw-link-modal-input:focus {\n  outline: none;\n}\n\n.rdw-link-modal-buttonsection {\n  margin: 0 auto;\n}\n\n.rdw-link-modal-target-option {\n  margin-bottom: 20px;\n}\n\n.rdw-link-modal-target-option > span {\n  margin-left: 5px;\n}\n\n.rdw-link-modal-btn {\n  margin-left: 10px;\n  width: 75px;\n  height: 30px;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  cursor: pointer;\n  background: white;\n  text-transform: capitalize;\n}\n\n.rdw-link-modal-btn:hover {\n  box-shadow: 1px 1px 0px #BFBDBD;\n}\n\n.rdw-link-modal-btn:active {\n  box-shadow: 1px 1px 0px #BFBDBD inset;\n}\n\n.rdw-link-modal-btn:focus {\n  outline: none !important;\n}\n\n.rdw-link-modal-btn:disabled {\n  background: #ece9e9;\n}\n\n.rdw-link-dropdownoption {\n  height: 40px;\n  display: flex;\n  justify-content: center;\n}\n\n.rdw-history-dropdown {\n  width: 50px;\n}\n\n.rdw-embedded-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n  position: relative;\n}\n\n.rdw-embedded-modal {\n  position: absolute;\n  top: 35px;\n  left: 5px;\n  display: flex;\n  flex-direction: column;\n  width: 235px;\n  height: 180px;\n  border: 1px solid #F1F1F1;\n  padding: 15px;\n  border-radius: 2px;\n  z-index: 100;\n  background: white;\n  justify-content: space-between;\n  box-shadow: 3px 3px 5px #BFBDBD;\n}\n\n.rdw-embedded-modal-header {\n  font-size: 15px;\n  display: flex;\n}\n\n.rdw-embedded-modal-header-option {\n  width: 50%;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n\n.rdw-embedded-modal-header-label {\n  width: 95px;\n  border: 1px solid #f1f1f1;\n  margin-top: 5px;\n  background: #6EB8D4;\n  border-bottom: 2px solid #0a66b7;\n}\n\n.rdw-embedded-modal-link-section {\n  display: flex;\n  flex-direction: column;\n}\n\n.rdw-embedded-modal-link-input {\n  width: 88%;\n  height: 35px;\n  margin: 10px 0;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  font-size: 15px;\n  padding: 0 5px;\n}\n\n.rdw-embedded-modal-link-input-wrapper {\n  display: flex;\n  align-items: center;\n}\n\n.rdw-embedded-modal-link-input:focus {\n  outline: none;\n}\n\n.rdw-embedded-modal-btn-section {\n  display: flex;\n  justify-content: center;\n}\n\n.rdw-embedded-modal-btn {\n  margin: 0 3px;\n  width: 75px;\n  height: 30px;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  cursor: pointer;\n  background: white;\n  text-transform: capitalize;\n}\n\n.rdw-embedded-modal-btn:hover {\n  box-shadow: 1px 1px 0px #BFBDBD;\n}\n\n.rdw-embedded-modal-btn:active {\n  box-shadow: 1px 1px 0px #BFBDBD inset;\n}\n\n.rdw-embedded-modal-btn:focus {\n  outline: none !important;\n}\n\n.rdw-embedded-modal-btn:disabled {\n  background: #ece9e9;\n}\n\n.rdw-embedded-modal-size {\n  align-items: center;\n  display: flex;\n  margin: 8px 0;\n  justify-content: space-between;\n}\n\n.rdw-embedded-modal-size-input {\n  width: 80%;\n  height: 20px;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  font-size: 12px;\n}\n\n.rdw-embedded-modal-size-input:focus {\n  outline: none;\n}\n\n.rdw-emoji-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n  position: relative;\n}\n\n.rdw-emoji-modal {\n  overflow: auto;\n  position: absolute;\n  top: 35px;\n  left: 5px;\n  display: flex;\n  flex-wrap: wrap;\n  width: 235px;\n  height: 180px;\n  border: 1px solid #F1F1F1;\n  padding: 15px;\n  border-radius: 2px;\n  z-index: 100;\n  background: white;\n  box-shadow: 3px 3px 5px #BFBDBD;\n}\n\n.rdw-emoji-icon {\n  margin: 2.5px;\n  height: 24px;\n  width: 24px;\n  cursor: pointer;\n  font-size: 22px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.rdw-spinner {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  width: 100%;\n}\n\n.rdw-spinner > div {\n  width: 12px;\n  height: 12px;\n  background-color: #333;\n  border-radius: 100%;\n  display: inline-block;\n  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n  animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n}\n\n.rdw-spinner .rdw-bounce1 {\n  -webkit-animation-delay: -0.32s;\n  animation-delay: -0.32s;\n}\n\n.rdw-spinner .rdw-bounce2 {\n  -webkit-animation-delay: -0.16s;\n  animation-delay: -0.16s;\n}\n\n@-webkit-keyframes sk-bouncedelay {\n  0%, 80%, 100% {\n    -webkit-transform: scale(0);\n  }\n  40% {\n    -webkit-transform: scale(1);\n  }\n}\n@keyframes sk-bouncedelay {\n  0%, 80%, 100% {\n    -webkit-transform: scale(0);\n    transform: scale(0);\n  }\n  40% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n}\n.rdw-image-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n  position: relative;\n}\n\n.rdw-image-modal {\n  position: absolute;\n  top: 35px;\n  left: 5px;\n  display: flex;\n  flex-direction: column;\n  width: 235px;\n  border: 1px solid #F1F1F1;\n  padding: 15px;\n  border-radius: 2px;\n  z-index: 100;\n  background: white;\n  box-shadow: 3px 3px 5px #BFBDBD;\n}\n\n.rdw-image-modal-header {\n  font-size: 15px;\n  margin: 10px 0;\n  display: flex;\n}\n\n.rdw-image-modal-header-option {\n  width: 50%;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n\n.rdw-image-modal-header-label {\n  width: 80px;\n  background: #f1f1f1;\n  border: 1px solid #f1f1f1;\n  margin-top: 5px;\n}\n\n.rdw-image-modal-header-label-highlighted {\n  background: #6EB8D4;\n  border-bottom: 2px solid #0a66b7;\n}\n\n.rdw-image-modal-upload-option {\n  width: 100%;\n  color: gray;\n  cursor: pointer;\n  display: flex;\n  border: none;\n  font-size: 15px;\n  align-items: center;\n  justify-content: center;\n  background-color: #f1f1f1;\n  outline: 2px dashed gray;\n  outline-offset: -10px;\n  margin: 10px 0;\n  padding: 9px 0;\n}\n\n.rdw-image-modal-upload-option-highlighted {\n  outline: 2px dashed #0a66b7;\n}\n\n.rdw-image-modal-upload-option-label {\n  cursor: pointer;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 15px;\n}\n\n.rdw-image-modal-upload-option-label span {\n  padding: 0 20px;\n}\n\n.rdw-image-modal-upload-option-image-preview {\n  max-width: 100%;\n  max-height: 200px;\n}\n\n.rdw-image-modal-upload-option-input {\n  width: 0.1px;\n  height: 0.1px;\n  opacity: 0;\n  overflow: hidden;\n  position: absolute;\n  z-index: -1;\n}\n\n.rdw-image-modal-url-section {\n  display: flex;\n  align-items: center;\n}\n\n.rdw-image-modal-url-input {\n  width: 90%;\n  height: 35px;\n  margin: 15px 0 12px;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  font-size: 15px;\n  padding: 0 5px;\n}\n\n.rdw-image-modal-btn-section {\n  margin: 10px auto 0;\n}\n\n.rdw-image-modal-url-input:focus {\n  outline: none;\n}\n\n.rdw-image-modal-btn {\n  margin: 0 5px;\n  width: 75px;\n  height: 30px;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  cursor: pointer;\n  background: white;\n  text-transform: capitalize;\n}\n\n.rdw-image-modal-btn:hover {\n  box-shadow: 1px 1px 0px #BFBDBD;\n}\n\n.rdw-image-modal-btn:active {\n  box-shadow: 1px 1px 0px #BFBDBD inset;\n}\n\n.rdw-image-modal-btn:focus {\n  outline: none !important;\n}\n\n.rdw-image-modal-btn:disabled {\n  background: #ece9e9;\n}\n\n.rdw-image-modal-spinner {\n  position: absolute;\n  top: -3px;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0.5;\n}\n\n.rdw-image-modal-alt-input {\n  width: 70%;\n  height: 20px;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  font-size: 12px;\n  margin-left: 5px;\n}\n\n.rdw-image-modal-alt-input:focus {\n  outline: none;\n}\n\n.rdw-image-modal-alt-lbl {\n  font-size: 12px;\n}\n\n.rdw-image-modal-size {\n  align-items: center;\n  display: flex;\n  margin: 8px 0;\n  justify-content: space-between;\n}\n\n.rdw-image-modal-size-input {\n  width: 40%;\n  height: 20px;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  font-size: 12px;\n}\n\n.rdw-image-modal-size-input:focus {\n  outline: none;\n}\n\n.rdw-image-mandatory-sign {\n  color: red;\n  margin-left: 3px;\n  margin-right: 3px;\n}\n\n.rdw-remove-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n  position: relative;\n}\n\n.rdw-history-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n}\n\n.rdw-history-dropdownoption {\n  height: 40px;\n  display: flex;\n  justify-content: center;\n}\n\n.rdw-history-dropdown {\n  width: 50px;\n}\n\n.rdw-link-decorator-wrapper {\n  position: relative;\n}\n\n.rdw-link-decorator-icon {\n  position: absolute;\n  left: 40%;\n  top: 0;\n  cursor: pointer;\n  background-color: white;\n}\n\n.rdw-mention-link {\n  text-decoration: none;\n  color: #1236ff;\n  background-color: #f0fbff;\n  padding: 1px 2px;\n  border-radius: 2px;\n}\n\n.rdw-suggestion-wrapper {\n  position: relative;\n}\n\n.rdw-suggestion-dropdown {\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #F1F1F1;\n  min-width: 100px;\n  max-height: 150px;\n  overflow: auto;\n  background: white;\n  z-index: 100;\n}\n\n.rdw-suggestion-option {\n  padding: 7px 5px;\n  border-bottom: 1px solid #f1f1f1;\n}\n\n.rdw-suggestion-option-active {\n  background-color: #F1F1F1;\n}\n\n.rdw-hashtag-link {\n  text-decoration: none;\n  color: #1236ff;\n  background-color: #f0fbff;\n  padding: 1px 2px;\n  border-radius: 2px;\n}\n\n.rdw-image-alignment-options-popup {\n  position: absolute;\n  background: white;\n  display: flex;\n  padding: 5px 2px;\n  border-radius: 2px;\n  border: 1px solid #F1F1F1;\n  width: 105px;\n  cursor: pointer;\n  z-index: 100;\n}\n\n.rdw-alignment-option-left {\n  justify-content: flex-start;\n}\n\n.rdw-image-alignment-option {\n  height: 15px;\n  width: 15px;\n  min-width: 15px;\n}\n\n.rdw-image-alignment {\n  position: relative;\n}\n\n.rdw-image-imagewrapper {\n  position: relative;\n}\n\n.rdw-image-center {\n  display: flex;\n  justify-content: center;\n}\n\n.rdw-image-left {\n  display: flex;\n}\n\n.rdw-image-right {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.rdw-image-alignment-options-popup-right {\n  right: 0;\n}\n\n.rdw-editor-main {\n  height: 100%;\n  overflow: auto;\n  box-sizing: border-box;\n}\n\n.rdw-editor-toolbar {\n  padding: 6px 5px 0;\n  border-radius: 2px;\n  border: 1px solid #F1F1F1;\n  display: flex;\n  justify-content: flex-start;\n  background: white;\n  flex-wrap: wrap;\n  font-size: 15px;\n  margin-bottom: 5px;\n  user-select: none;\n}\n\n.public-DraftStyleDefault-block {\n  margin: 1em 0;\n}\n\n.rdw-editor-wrapper:focus {\n  outline: none;\n}\n\n.rdw-editor-wrapper {\n  box-sizing: content-box;\n}\n\n.rdw-editor-main blockquote {\n  border-left: 5px solid #f1f1f1;\n  padding-left: 5px;\n}\n\n.rdw-editor-main pre {\n  background: #f1f1f1;\n  border-radius: 3px;\n  padding: 1px 10px;\n} /**\n* Draft v0.9.1\n*\n* Copyright (c) 2013-present, Facebook, Inc.\n* All rights reserved.\n*\n* This source code is licensed under the BSD-style license found in the\n* LICENSE file in the root directory of this source tree. An additional grant\n* of patent rights can be found in the PATENTS file in the same directory.\n*/\n.DraftEditor-editorContainer, .DraftEditor-root, .public-DraftEditor-content {\n  height: inherit;\n  text-align: initial;\n}\n\n.public-DraftEditor-content[contenteditable=true] {\n  -webkit-user-modify: read-write-plaintext-only;\n}\n\n.DraftEditor-root {\n  position: relative;\n}\n\n.DraftEditor-editorContainer {\n  background-color: rgba(255, 255, 255, 0);\n  border-left: 0.1px solid transparent;\n  position: relative;\n  z-index: 1;\n}\n\n.public-DraftEditor-block {\n  position: relative;\n}\n\n.DraftEditor-alignLeft .public-DraftStyleDefault-block {\n  text-align: left;\n}\n\n.DraftEditor-alignLeft .public-DraftEditorPlaceholder-root {\n  left: 0;\n  text-align: left;\n}\n\n.DraftEditor-alignCenter .public-DraftStyleDefault-block {\n  text-align: center;\n}\n\n.DraftEditor-alignCenter .public-DraftEditorPlaceholder-root {\n  margin: 0 auto;\n  text-align: center;\n  width: 100%;\n}\n\n.DraftEditor-alignRight .public-DraftStyleDefault-block {\n  text-align: right;\n}\n\n.DraftEditor-alignRight .public-DraftEditorPlaceholder-root {\n  right: 0;\n  text-align: right;\n}\n\n.public-DraftEditorPlaceholder-root {\n  color: #9197a3;\n  position: absolute;\n  z-index: 0;\n}\n\n.public-DraftEditorPlaceholder-hasFocus {\n  color: #bdc1c9;\n}\n\n.DraftEditorPlaceholder-hidden {\n  display: none;\n}\n\n.public-DraftStyleDefault-block {\n  position: relative;\n  white-space: pre-wrap;\n}\n\n.public-DraftStyleDefault-ltr {\n  direction: ltr;\n  text-align: left;\n}\n\n.public-DraftStyleDefault-rtl {\n  direction: rtl;\n  text-align: right;\n}\n\n.public-DraftStyleDefault-listLTR {\n  direction: ltr;\n}\n\n.public-DraftStyleDefault-listRTL {\n  direction: rtl;\n}\n\n.public-DraftStyleDefault-ol, .public-DraftStyleDefault-ul {\n  margin: 16px 0;\n  padding: 0;\n}\n\n.public-DraftStyleDefault-depth0.public-DraftStyleDefault-listLTR {\n  margin-left: 1.5em;\n}\n\n.public-DraftStyleDefault-depth0.public-DraftStyleDefault-listRTL {\n  margin-right: 1.5em;\n}\n\n.public-DraftStyleDefault-depth1.public-DraftStyleDefault-listLTR {\n  margin-left: 3em;\n}\n\n.public-DraftStyleDefault-depth1.public-DraftStyleDefault-listRTL {\n  margin-right: 3em;\n}\n\n.public-DraftStyleDefault-depth2.public-DraftStyleDefault-listLTR {\n  margin-left: 4.5em;\n}\n\n.public-DraftStyleDefault-depth2.public-DraftStyleDefault-listRTL {\n  margin-right: 4.5em;\n}\n\n.public-DraftStyleDefault-depth3.public-DraftStyleDefault-listLTR {\n  margin-left: 6em;\n}\n\n.public-DraftStyleDefault-depth3.public-DraftStyleDefault-listRTL {\n  margin-right: 6em;\n}\n\n.public-DraftStyleDefault-depth4.public-DraftStyleDefault-listLTR {\n  margin-left: 7.5em;\n}\n\n.public-DraftStyleDefault-depth4.public-DraftStyleDefault-listRTL {\n  margin-right: 7.5em;\n}\n\n.public-DraftStyleDefault-unorderedListItem {\n  list-style-type: square;\n  position: relative;\n}\n\n.public-DraftStyleDefault-unorderedListItem.public-DraftStyleDefault-depth0 {\n  list-style-type: disc;\n}\n\n.public-DraftStyleDefault-unorderedListItem.public-DraftStyleDefault-depth1 {\n  list-style-type: circle;\n}\n\n.public-DraftStyleDefault-orderedListItem {\n  list-style-type: none;\n  position: relative;\n}\n\n.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-listLTR:before {\n  left: -36px;\n  position: absolute;\n  text-align: right;\n  width: 30px;\n}\n\n.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-listRTL:before {\n  position: absolute;\n  right: -36px;\n  text-align: left;\n  width: 30px;\n}\n\n.public-DraftStyleDefault-orderedListItem:before {\n  content: counter(ol0) \". \";\n  counter-increment: ol0;\n}\n\n.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth1:before {\n  content: counter(ol1) \". \";\n  counter-increment: ol1;\n}\n\n.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth2:before {\n  content: counter(ol2) \". \";\n  counter-increment: ol2;\n}\n\n.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth3:before {\n  content: counter(ol3) \". \";\n  counter-increment: ol3;\n}\n\n.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth4:before {\n  content: counter(ol4) \". \";\n  counter-increment: ol4;\n}\n\n.public-DraftStyleDefault-depth0.public-DraftStyleDefault-reset {\n  counter-reset: ol0;\n}\n\n.public-DraftStyleDefault-depth1.public-DraftStyleDefault-reset {\n  counter-reset: ol1;\n}\n\n.public-DraftStyleDefault-depth2.public-DraftStyleDefault-reset {\n  counter-reset: ol2;\n}\n\n.public-DraftStyleDefault-depth3.public-DraftStyleDefault-reset {\n  counter-reset: ol3;\n}\n\n.public-DraftStyleDefault-depth4.public-DraftStyleDefault-reset {\n  counter-reset: ol4;\n}\n\n.demo-editor {\n  height: 275px !important;\n  border: 1px solid #F1F1F1 !important;\n  padding: 5px !important;\n  border-radius: 2px !important;\n}\n\n.has-switch {\n  border-radius: 30px;\n  cursor: pointer;\n  display: inline-block;\n  line-height: 1.72222;\n  overflow: hidden;\n  position: relative;\n  text-align: left;\n  width: 60px;\n  user-select: none;\n}\n\n.has-switch.deactivate {\n  opacity: 0.5;\n  filter: alpha(opacity=50);\n  cursor: default !important;\n}\n\n.has-switch.deactivate label,\n.has-switch.deactivate span {\n  cursor: default !important;\n}\n\n.has-switch > div {\n  position: relative;\n  top: 0;\n  width: 100px;\n}\n\n.has-switch > div.switch-animate {\n  transition: left 0.25s ease-out;\n}\n\n.has-switch > div.switch-off {\n  left: -35px;\n}\n\n.has-switch > div.switch-on {\n  left: 0;\n}\n\n.has-switch > div label {\n  background-color: #FFFFFF;\n  background: rgb(255, 255, 255);\n  background: linear-gradient(to bottom, rgb(255, 255, 255) 0%, rgb(241, 241, 242) 100%);\n  background-size: 150% 150%;\n  box-shadow: 0 1px 1px #FFFFFF inset, 0 1px 1px rgba(0, 0, 0, 0.25);\n  cursor: pointer;\n}\n\n.has-switch input[type=checkbox] {\n  display: none;\n}\n\n.has-switch span {\n  cursor: pointer;\n  float: left;\n  font-size: 11px;\n  font-weight: 400;\n  height: 24px;\n  line-height: 15px;\n  margin: 0;\n  padding-bottom: 6px;\n  padding-top: 5px;\n  position: relative;\n  text-align: center;\n  text-indent: -10px;\n  width: 50%;\n  z-index: 1;\n  transition: 0.25s ease-out;\n}\n\n.has-switch span.switch-left {\n  background-color: #545cd8;\n  border-left: 1px solid rgba(0, 0, 0, 0);\n  border-radius: 30px 0 0 30px;\n  color: #FFFFFF;\n}\n\n.has-switch .switch-off span.switch-left {\n  background-color: #ced4da !important;\n}\n\n.has-switch span.switch-right {\n  border-radius: 0 30px 30px 0;\n  background-color: #545cd8;\n  color: #ffffff;\n  text-indent: 1px;\n}\n\n.has-switch .switch-off span.switch-right {\n  background-color: #ced4da !important;\n}\n\n.has-switch label {\n  border-radius: 12px;\n  float: left;\n  height: 22px;\n  margin: 1px -13px;\n  padding: 0;\n  position: relative;\n  vertical-align: middle;\n  width: 22px;\n  z-index: 10;\n  -webkit-transition: 0.25s ease-out;\n  transition: 0.25s ease-out;\n}\n\n.has-switch .switch-on .fa-check:before {\n  margin-left: 10px;\n}\n\n.has-switch:hover .switch-on label {\n  margin: 1px -17px;\n  width: 26px;\n}\n\n.has-switch:hover .switch-off label {\n  margin: 1px -13px;\n  width: 26px;\n}\n\n.has-switch-sm.has-switch span {\n  height: 18px;\n  line-height: 18px;\n  padding: 0;\n}\n.has-switch-sm.has-switch label {\n  height: 16px;\n  width: 16px;\n  margin: 1px -8px;\n}\n.has-switch-sm.has-switch .switch-off label {\n  margin: 1px -13px;\n}\n.has-switch-sm.has-switch:hover .switch-on label {\n  margin: 1px -11px;\n  width: 20px;\n}\n.has-switch-sm.has-switch:hover .switch-off label {\n  margin: 1px -13px;\n  width: 20px;\n}\n\n.dropzone-wrapper {\n  width: 100%;\n  border: #ced4da dashed 2px;\n  border-radius: 0.3rem;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  text-align: center;\n  height: 230px;\n  transition: all 0.2s;\n}\n.dropzone-wrapper:hover {\n  border-color: #545cd8;\n}\n.dropzone-wrapper > div {\n  width: 100%;\n  height: 100%;\n  outline: none !important;\n  display: flex;\n  align-items: center;\n}\n.dropzone-wrapper.dropzone-wrapper-lg {\n  height: 300px;\n}\n.dropzone-wrapper.dropzone-wrapper-sm {\n  height: 150px;\n}\n.dropzone-wrapper input {\n  width: 100%;\n  height: 100%;\n}\n.dropzone-wrapper .dropzone-content {\n  margin: 0 auto;\n  color: #6c757d;\n}\n.dropzone-wrapper[aria-disabled=true] {\n  border-color: #dee2e6;\n}\n.dropzone-wrapper[aria-disabled=true] .dropzone-content {\n  color: #ced4da;\n}\n\n.rbt {\n  outline: none;\n}\n.rbt-menu {\n  margin-bottom: 2px;\n}\n.rbt-menu > li a {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.rbt-menu > li a:focus {\n  outline: none;\n}\n.rbt-menu-pagination-option {\n  text-align: center;\n}\n.rbt .rbt-input-main::-ms-clear {\n  display: none;\n}\n.rbt-input-multi {\n  cursor: text;\n  overflow: hidden;\n  position: relative;\n}\n.rbt-input-multi.form-control[disabled] {\n  background-color: #e9ecef;\n  opacity: 1;\n}\n.rbt-input-multi input::-moz-placeholder {\n  color: #6c757d;\n  opacity: 1;\n}\n.rbt-input-multi input:-ms-input-placeholder {\n  color: #6c757d;\n}\n.rbt-input-multi input::-webkit-input-placeholder {\n  color: #6c757d;\n}\n.rbt-input-multi .rbt-input-wrapper {\n  margin-top: 2px;\n  overflow: hidden;\n}\n.rbt-input-multi .rbt-input-main {\n  height: auto;\n}\n.rbt-input-multi .rbt-input-hint-container {\n  display: inline-block;\n}\n.rbt-input-multi.input-lg .rbt-input-main, .rbt-input-multi.form-control-lg .rbt-input-main {\n  height: auto;\n}\n.rbt-input-multi.input-sm .rbt-input-main, .rbt-input-multi.form-control-sm .rbt-input-main {\n  height: auto;\n}\n.rbt-close {\n  z-index: 1;\n}\n.rbt-close-lg {\n  font-size: 24px;\n}\n.rbt-token {\n  background-color: #e0f3ff;\n  border: 0;\n  border-radius: 0.25rem;\n  color: #545cd8;\n  display: inline-block;\n  line-height: 1em;\n  margin: 0 3px 3px 0;\n  padding: 4px 7px;\n  position: relative;\n}\n.rbt-token-disabled {\n  background-color: #f8f9fa;\n  color: #adb5bd;\n  pointer-events: none;\n}\n.rbt-token-removeable {\n  cursor: pointer;\n  padding-right: 21px;\n}\n.rbt-token-active {\n  background-color: #545cd8;\n  color: #fff;\n  outline: none;\n  text-decoration: none;\n}\n.rbt-token .rbt-token-remove-button {\n  bottom: 0;\n  color: #495057;\n  font-size: inherit;\n  font-weight: normal;\n  opacity: 1;\n  outline: none;\n  padding: 3px 7px;\n  position: absolute;\n  right: 0;\n  text-shadow: none;\n  top: -1px;\n}\n.rbt-loader {\n  -webkit-animation: loader-animation 600ms infinite linear;\n  -o-animation: loader-animation 600ms infinite linear;\n  animation: loader-animation 600ms infinite linear;\n  border: 1px solid #e0f3ff;\n  border-radius: 50%;\n  border-top-color: rgb(173, 223.2580645161, 255);\n  display: block;\n  height: 16px;\n  width: 16px;\n}\n.rbt-loader-lg {\n  height: 20px;\n  width: 20px;\n}\n.rbt-aux {\n  display: -webkit-box;\n  display: -moz-box;\n  display: -ms-flexbox;\n  display: -webkit-flex;\n  display: flex;\n  align-items: center;\n  bottom: 0;\n  justify-content: center;\n  pointer-events: none; /* Don't block clicks on the input */\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 34px;\n}\n.rbt-aux-lg {\n  width: 46px;\n}\n.rbt-aux .rbt-close {\n  margin-top: -1px;\n  pointer-events: auto; /* Override pointer-events: none; above */\n  background-color: transparent;\n  border: none;\n}\n.has-aux .rbt-input {\n  padding-right: 34px;\n}\n.rbt-highlight-text {\n  background-color: inherit;\n  color: inherit;\n  font-weight: bold;\n  padding: 0;\n}\n\n/* Input Groups */\n.input-group > .rbt {\n  -webkit-box-flex: 1;\n  -moz-box-flex: 1;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n.input-group > .rbt .rbt-input-hint-container {\n  display: -webkit-box;\n  display: -moz-box;\n  display: -ms-flexbox;\n  display: -webkit-flex;\n  display: flex;\n}\n.input-group > .rbt .rbt-input-hint {\n  z-index: 5;\n}\n.input-group > .rbt .rbt-aux {\n  z-index: 5;\n}\n.input-group > .rbt:not(:first-child) .form-control {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.input-group > .rbt:not(:last-child) .form-control {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n@keyframes loader-animation {\n  to {\n    transform: rotate(1turn);\n  }\n}\n@-webkit-keyframes loader-animation {\n  to {\n    -webkit-transform: rotate(1turn);\n  }\n}\n.input-group > .rbt .rbt-input-hint-container {\n  -webkit-box-flex: 1;\n  -moz-box-flex: 1;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  height: 100%;\n}\n\n.rbt-token-remove-button {\n  background-color: transparent;\n  border: none;\n}\n\n/* for debugging */\n@keyframes react-widgets-autofill-start {\n  from {\n    /**/\n  }\n  to {\n    /**/\n  }\n}\n@keyframes react-widgets-autofill-cancel {\n  from {\n    /**/\n  }\n  to {\n    /**/\n  }\n}\n.rw-btn {\n  padding: 0;\n  margin: 0;\n  border: none;\n  color: inherit;\n  box-shadow: none;\n  background: none;\n  font: inherit;\n  line-height: inherit;\n  -ms-touch-action: manipulation;\n  touch-action: manipulation;\n  outline: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background-clip: padding-box;\n  cursor: pointer;\n}\n\n.rw-btn:focus {\n  outline: none;\n}\n\n.rw-btn:disabled, fieldset[disabled] .rw-btn, .rw-state-disabled .rw-btn, .rw-state-readonly .rw-btn {\n  cursor: inherit;\n}\n\nfieldset[disabled] .rw-btn {\n  pointer-events: none;\n}\n\n.rw-picker-caret,\n.rw-picker-btn {\n  color: #212529;\n}\n\n.rw-picker-btn:hover {\n  background-color: #e9ecef;\n}\n\n.rw-picker-btn:active {\n  background-color: #dee2e6;\n}\n\n.rw-picker-btn:disabled, fieldset[disabled] .rw-picker-btn {\n  background-color: #e9ecef;\n}\n\n.rw-input-addon, .rw-input-addon.rw-picker-btn {\n  border-left: #ced4da 1px solid;\n}\n\n[dir=rtl] .rw-input-addon, [dir=rtl] .rw-input-addon.rw-picker-btn {\n  border-right: #ced4da 1px solid;\n  border-left: none;\n}\n\n.rw-sr {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n}\n\n.rw-widget {\n  border: none;\n  color: #212529;\n  font-size: 1em;\n  font-family: inherit;\n  outline: none;\n  position: relative;\n}\n\n.rw-widget, .rw-widget *, .rw-widget:after, .rw-widget:before, .rw-widget *:after, .rw-widget *:before {\n  box-sizing: border-box;\n}\n\n.rw-state-readonly,\n.rw-state-disabled,\nfieldset[disabled] .rw-widget {\n  cursor: not-allowed;\n}\n\n.rw-widget-picker {\n  display: grid;\n  overflow: hidden;\n  min-height: calc(1.5em + (0.75rem + 2px));\n  background-color: #fff;\n  border: #ced4da 1px solid;\n  border-radius: 0.25rem;\n  outline: none;\n  grid-template: 1fr/1fr 1.9em;\n  width: 100%;\n}\n\n.rw-widget-picker.rw-hide-caret {\n  grid-template-columns: 1fr;\n}\n\n.rw-state-focus .rw-widget-picker {\n  color: #495057;\n  background-color: #fff;\n  border-color: rgb(187.8214285714, 190.9642857143, 239.6785714286);\n  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);\n  transition: box-shadow 0.15s ease-in-out;\n}\n\n.rw-state-focus .rw-widget-picker.rw-widget-input {\n  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25), inset 0 1px 2px rgba(0, 0, 0, 0.075);\n}\n\n.rw-input {\n  padding: 0;\n  margin: 0;\n  border: none;\n  color: inherit;\n  box-shadow: none;\n  background: none;\n  font: inherit;\n  line-height: inherit;\n  -ms-touch-action: manipulation;\n  touch-action: manipulation;\n  outline: 0;\n  padding: 0 0.75rem;\n}\n\n.rw-input:disabled {\n  opacity: 1;\n}\n\n.rw-input[type=text]::-ms-clear {\n  display: none;\n}\n\n.rw-input:disabled, .rw-input:read-only {\n  cursor: inherit;\n}\n\n.rw-widget-input {\n  color: #495057;\n  background-color: #fff;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);\n  background-clip: padding-box;\n  width: inherit;\n}\n\n.rw-widget-input.rw-state-disabled, .rw-state-disabled .rw-widget-input, fieldset[disabled] .rw-widget-input {\n  background-color: #e9ecef;\n}\n\n.rw-placeholder,\n.rw-input::placeholder {\n  color: #6c757d;\n}\n\n.rw-state-disabled .rw-placeholder,\n.rw-state-disabled .rw-input::placeholder {\n  color: #999;\n}\n\n.rw-detect-autofill {\n  padding: 0;\n  margin: 0;\n  border: none;\n  color: inherit;\n  box-shadow: none;\n  background: none;\n  font: inherit;\n  line-height: inherit;\n  -ms-touch-action: manipulation;\n  touch-action: manipulation;\n  outline: 0;\n}\n\n.rw-detect-autofill:disabled {\n  opacity: 1;\n}\n\n.rw-detect-autofill:-webkit-autofill {\n  animation-name: react-widgets-autofill-start;\n  animation-duration: 0.01ms;\n}\n\n.rw-detect-autofill:not(:-webkit-autofill) {\n  animation-name: react-widgets-autofill-cancel;\n  animation-duration: 0.01ms;\n}\n\n.rw-webkit-autofill .rw-widget-container,\n.rw-input:-webkit-autofill {\n  background-color: rgb(232, 240, 254) !important;\n  background-image: none !important;\n  color: rgb(0, 0, 0) !important;\n}\n\n.rw-list {\n  font-size: 1em;\n  overflow-x: visible;\n  overflow-y: auto;\n  padding-top: 0.5em;\n  padding-bottom: 0.5em;\n}\n\n.rw-list:focus {\n  outline: none;\n}\n\n.rw-list-option, .rw-list-option-create {\n  user-select: none;\n  color: #212529;\n  cursor: pointer;\n  border: 1px solid transparent;\n  background-clip: padding-box;\n}\n\n.rw-list-option:hover, .rw-list-option-create:hover, [data-intent=keyboard] .rw-list-option.rw-state-focus:not(.rw-state-selected), [data-intent=keyboard] .rw-state-focus.rw-list-option-create:not(.rw-state-selected) {\n  background-color: #e9ecef;\n  border-color: #e9ecef;\n}\n\n.rw-list-option.rw-state-selected, .rw-state-selected.rw-list-option-create {\n  background-color: #007bff;\n  border-color: #007bff;\n  color: #fff;\n}\n\n.rw-list-option.rw-state-disabled, .rw-state-disabled.rw-list-option-create {\n  cursor: not-allowed;\n  background-color: transparent;\n  border-color: transparent;\n  color: #dee2e6;\n}\n\n.rw-list-empty,\n.rw-list-option,\n.rw-list-option-create,\n.rw-list-optgroup {\n  padding: 0.25em 1.5em;\n  outline: none;\n}\n\n.rw-list-empty {\n  text-align: center;\n  color: #ced4da;\n}\n\n.rw-list-optgroup {\n  font-weight: bold;\n  padding-top: 7px;\n}\n\n.rw-list-option-create {\n  display: block;\n  font-size: 1em;\n  padding: 0.25em 1.5em;\n}\n\n.rw-listbox {\n  border-radius: 4px;\n  background-color: #fff;\n  border: #ccc 1px solid;\n}\n\n.rw-listbox.rw-state-focus {\n  color: #495057;\n  background-color: #fff;\n  border-color: rgb(187.8214285714, 190.9642857143, 239.6785714286);\n  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25), inset 0 1px 2px rgba(0, 0, 0, 0.075);\n  transition: box-shadow 0.15s ease-in-out;\n}\n\n.rw-listbox.rw-state-disabled > *, fieldset[disabled] .rw-listbox > * {\n  pointer-events: none;\n}\n\n.rw-listbox.rw-state-readonly > * {\n  cursor: inherit;\n}\n\n.rw-popup-container {\n  position: absolute;\n  z-index: 1005;\n  top: 100%;\n  left: -1em;\n  right: -1em;\n  padding: 0 1em;\n}\n\n.rw-popup-container.rw-dropup {\n  top: auto;\n  bottom: 100%;\n}\n\n.rw-state-focus .rw-popup-container {\n  z-index: 1006;\n}\n\n.rw-slide-transition {\n  margin-bottom: 1em;\n}\n\n.rw-dropup > .rw-slide-transition {\n  margin-bottom: 0;\n  margin-top: 1em;\n}\n\n.rw-popup {\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n  margin-top: 2px;\n  border-radius: 4px;\n  box-shadow: 0 0.5em 1em rgba(0, 0, 0, 0.175);\n  border: #ccc 1px solid;\n  background-clip: padding-box;\n  background: #fff;\n}\n\n.rw-popup .rw-list {\n  max-height: 250px;\n}\n\n.rw-dropup .rw-popup {\n  margin-top: 0;\n  margin-bottom: 2px;\n  box-shadow: 0 0.5em 1em rgba(0, 0, 0, 0.175);\n}\n\n.rw-slide-transition {\n  transition: transform 130ms, opacity 100ms;\n}\n\n.rw-slide-transition-entering {\n  overflow: hidden;\n}\n\n.rw-slide-transition-entering .rw-slide-transition {\n  transform: translateY(0);\n  opacity: 1;\n  transition-timing-function: ease-out;\n}\n\n.rw-slide-transition-exiting .rw-slide-transition {\n  transition-timing-function: ease-in;\n}\n\n.rw-slide-transition-exiting,\n.rw-slide-transition-exited {\n  overflow: hidden;\n}\n\n.rw-slide-transition-exiting .rw-slide-transition,\n.rw-slide-transition-exited .rw-slide-transition {\n  opacity: 0;\n  transform: translateY(-10%);\n}\n\n.rw-slide-transition-exiting.rw-dropup .rw-slide-transition,\n.rw-slide-transition-exited.rw-dropup .rw-slide-transition {\n  opacity: 0;\n  transform: translateY(10%);\n}\n\n.rw-slide-transition-exited {\n  display: none;\n}\n\n.rw-dropdown-list {\n  width: 100%;\n}\n\n.rw-dropdownlist-search {\n  padding: 0;\n  margin: 0;\n  border: none;\n  color: inherit;\n  box-shadow: none;\n  background: none;\n  font: inherit;\n  line-height: inherit;\n  -ms-touch-action: manipulation;\n  touch-action: manipulation;\n  outline: 0;\n}\n\n.rw-dropdownlist-search:disabled {\n  opacity: 1;\n}\n\n.rw-dropdown-list-input {\n  padding: 0 0.75rem;\n  align-self: center;\n  display: grid;\n  min-width: 0;\n  grid-template: 1fr/1fr;\n}\n\n.rw-dropdown-list-input > * {\n  grid-area: 1/1;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n[dir=rtl] .rw-dropdown-list-input {\n  padding-right: 0.75rem;\n  padding-left: 0;\n}\n\n.rw-combobox-input {\n  background-color: transparent;\n  z-index: 1;\n}\n\n.rw-multiselect-input {\n  padding: 0;\n  margin: 0;\n  border: none;\n  color: inherit;\n  box-shadow: none;\n  background: none;\n  font: inherit;\n  line-height: inherit;\n  -ms-touch-action: manipulation;\n  touch-action: manipulation;\n  outline: 0;\n  height: calc(calc(1.5em + (0.75rem + 2px)) - 1px * 2);\n  padding: 0 0.75rem;\n  max-width: 100%;\n}\n\n.rw-multiselect-input:disabled {\n  opacity: 1;\n}\n\n.rw-multiselect-input:disabled, .rw-multiselect-input:read-only {\n  cursor: inherit;\n}\n\n.rw-multiselect-taglist {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  width: 100%;\n  outline: none;\n  cursor: text;\n}\n\n.rw-state-disabled .rw-multiselect-taglist {\n  cursor: unset;\n}\n\n.rw-multiselect-tag {\n  display: inline-flex;\n  margin-left: calc(calc(1.5em + (0.75rem + 2px)) * 0.115 - 1px);\n  margin-top: calc(calc(1.5em + (0.75rem + 2px)) * 0.115 - 1px);\n  min-height: calc(calc(1.5em + (0.75rem + 2px)) * 0.77);\n  border-radius: 3px;\n  background-color: #dee2e6;\n  border: 1px solid #dee2e6;\n  cursor: default;\n  max-width: 100%;\n  align-items: center;\n  overflow: hidden;\n}\n\n.rw-multiselect-tag:focus {\n  outline: none;\n}\n\n[dir=rtl] .rw-multiselect-tag {\n  margin-left: 0;\n  margin-right: calc(calc(1.5em + (0.75rem + 2px)) * 0.115 - 1px);\n  padding: 0 0.35em 0 0.35em;\n}\n\n.rw-multiselect-tag.rw-state-focus {\n  z-index: 1;\n  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);\n  transition: box-shadow 0.15s ease-in-out;\n}\n\n.rw-multiselect-tag.rw-state-disabled, fieldset[disabled] .rw-multiselect-tag {\n  opacity: 0.65;\n}\n\n.rw-multiselect-tag-label {\n  padding: 0 0.35em 0 0.35em;\n}\n\n.rw-multiselect-tag-btn {\n  padding: 0;\n  margin: 0;\n  border: none;\n  color: inherit;\n  box-shadow: none;\n  background: none;\n  font: inherit;\n  line-height: inherit;\n  -ms-touch-action: manipulation;\n  touch-action: manipulation;\n  outline: 0;\n  cursor: pointer;\n  align-self: stretch;\n  padding: 0 0.35em;\n}\n\n.rw-multiselect-tag-btn:focus {\n  outline: none;\n}\n\n.rw-multiselect-tag-btn:disabled {\n  cursor: inherit;\n}\n\n.rw-calendar-popup {\n  right: auto;\n  min-width: 0;\n  width: 22em;\n}\n\n.rw-calendar {\n  overflow: hidden;\n}\n\n.rw-calendar-contained {\n  border-radius: 4px;\n  background-color: #fff;\n  border: #ccc 1px solid;\n}\n\n.rw-calendar-now {\n  font-weight: bold;\n}\n\n.rw-calendar-header {\n  display: flex;\n  padding: 0.8em;\n}\n\n.rw-cell,\n.rw-calendar-btn {\n  background-clip: padding-box;\n}\n\n.rw-cell:focus,\n.rw-calendar-btn:focus {\n  z-index: 1;\n  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);\n  transition: box-shadow 0.15s ease-in-out;\n}\n\n[data-intent=mouse] .rw-cell:focus,\n[data-intent=mouse] .rw-calendar-btn:focus {\n  z-index: auto;\n  box-shadow: none;\n}\n\n.rw-cell:disabled, .rw-cell.rw-state-disabled,\n.rw-calendar-btn:disabled,\n.rw-calendar-btn.rw-state-disabled {\n  pointer-events: none;\n  opacity: 0.35;\n}\n\n.rw-calendar-btn {\n  line-height: 2em;\n  border-radius: 4px;\n}\n\n.rw-calendar-btn:hover {\n  background-color: #e9ecef;\n}\n\n.rw-calendar-btn:active {\n  background-color: #dee2e6;\n}\n\n.rw-calendar-btn-left,\n.rw-calendar-btn-today,\n.rw-calendar-btn-right,\n.rw-calendar-btn-view {\n  padding: 0.3em 0.6em;\n}\n\n[dir=rtl] .rw-calendar-btn-left,\n[dir=rtl] .rw-calendar-btn-right {\n  transform: scale(-1, 1);\n}\n\n.rw-calendar-btn-view {\n  font-weight: bold;\n}\n\n.rw-calendar-btn-view > :last-child {\n  margin: 0 0.5em;\n}\n\n.rw-calendar-btn-view + * {\n  margin-left: auto;\n}\n\n[dir=rtl] .rw-calendar-btn-view + * {\n  margin-left: 0;\n  margin-right: auto;\n}\n\n.rw-calendar-grid {\n  display: table;\n  outline: none;\n  height: 14em;\n  padding: 3px;\n  table-layout: fixed;\n  border-collapse: separate;\n  border-spacing: 0;\n  width: 100%;\n  background-color: #fff;\n}\n\n.rw-calendar-head {\n  display: table-header-group;\n}\n\n.rw-calendar-body {\n  display: table-row-group;\n}\n\n.rw-calendar-row {\n  display: table-row;\n}\n\n.rw-head-cell {\n  display: table-cell;\n  text-align: center;\n  border-bottom: 1px solid #ced4da;\n  padding: 0.25em;\n}\n\n.rw-cell {\n  display: table-cell;\n  color: #212529;\n  vertical-align: middle;\n  border-radius: 4px;\n  cursor: pointer;\n  line-height: normal;\n  text-align: center;\n  border: 1px solid transparent;\n  padding: 0.25em;\n  outline: none;\n}\n\n.rw-cell:hover {\n  background-color: #e9ecef;\n}\n\n.rw-cell:active {\n  background-color: #dee2e6;\n}\n\n.rw-cell.rw-state-selected {\n  background-color: #007bff;\n  border-color: #007bff;\n  color: #fff;\n}\n\n.rw-calendar-month .rw-cell {\n  text-align: center;\n}\n\n.rw-cell-off-range {\n  color: #ced4da;\n}\n\n.rw-calendar-transition-group {\n  position: relative;\n  overflow: hidden;\n}\n\n.rw-calendar-transition {\n  width: 100%;\n  overflow: hidden;\n  transition: transform 0.2s ease-in-out 0ms;\n  transform: translate(0, 0);\n}\n\n@supports (transform-style: preserve-3d) {\n  .rw-calendar-transition {\n    transform: translate3d(0, 0, 0);\n  }\n}\n.rw-calendar-transition-next {\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n}\n\n.rw-calendar-transition-top .rw-calendar-transition-next {\n  transform: translate(0, -100%);\n}\n\n@supports (transform-style: preserve-3d) {\n  .rw-calendar-transition-top .rw-calendar-transition-next {\n    transform: translate3d(0, -100%, 0);\n  }\n}\n.rw-calendar-transition-bottom .rw-calendar-transition-next {\n  transform: translate(0, 100%);\n}\n\n@supports (transform-style: preserve-3d) {\n  .rw-calendar-transition-bottom .rw-calendar-transition-next {\n    transform: translate3d(0, 100%, 0);\n  }\n}\n.rw-calendar-transition-right .rw-calendar-transition-next {\n  transform: translate(-100%, 0);\n}\n\n@supports (transform-style: preserve-3d) {\n  .rw-calendar-transition-right .rw-calendar-transition-next {\n    transform: translate3d(-100%, 0, 0);\n  }\n}\n.rw-calendar-transition-left .rw-calendar-transition-next {\n  transform: translate(100%, 0);\n}\n\n@supports (transform-style: preserve-3d) {\n  .rw-calendar-transition-left .rw-calendar-transition-next {\n    transform: translate3d(100%, 0, 0);\n  }\n}\n.rw-calendar-transition-next.rw-calendar-transition-active {\n  transform: translate(0, 0);\n}\n\n@supports (transform-style: preserve-3d) {\n  .rw-calendar-transition-next.rw-calendar-transition-active {\n    transform: translate3d(0, 0, 0);\n  }\n}\n.rw-calendar-transition-prev {\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n\n.rw-calendar-transition-top .rw-calendar-transition-prev {\n  transform: translate(0, 100%);\n}\n\n@supports (transform-style: preserve-3d) {\n  .rw-calendar-transition-top .rw-calendar-transition-prev {\n    transform: translate3d(0, 100%, 0);\n  }\n}\n.rw-calendar-transition-bottom .rw-calendar-transition-prev {\n  transform: translate(0, -100%);\n}\n\n@supports (transform-style: preserve-3d) {\n  .rw-calendar-transition-bottom .rw-calendar-transition-prev {\n    transform: translate3d(0, -100%, 0);\n  }\n}\n.rw-calendar-transition-right .rw-calendar-transition-prev {\n  transform: translate(100%, 0);\n}\n\n@supports (transform-style: preserve-3d) {\n  .rw-calendar-transition-right .rw-calendar-transition-prev {\n    transform: translate3d(100%, 0, 0);\n  }\n}\n.rw-calendar-transition-left .rw-calendar-transition-prev {\n  transform: translate(-100%, 0);\n}\n\n@supports (transform-style: preserve-3d) {\n  .rw-calendar-transition-left .rw-calendar-transition-prev {\n    transform: translate3d(-100%, 0, 0);\n  }\n}\n.rw-popup {\n  display: flex;\n  flex-direction: column;\n}\n\n.rw-popup > .rw-time-input {\n  align-self: center;\n  margin: 1em 0;\n}\n\n.rw-time-input {\n  display: inline-flex;\n  min-height: calc(1.5em + (0.75rem + 2px));\n  align-items: center;\n  background-color: #fff;\n  border: #ced4da 1px solid;\n  border-radius: 0.25rem;\n  outline: none;\n  cursor: text;\n}\n\n.rw-time-part-input {\n  padding: 0;\n  margin: 0;\n  border: none;\n  color: inherit;\n  box-shadow: none;\n  background: none;\n  font: inherit;\n  line-height: inherit;\n  -ms-touch-action: manipulation;\n  touch-action: manipulation;\n  outline: 0;\n  padding: 0 0.5em;\n}\n\n.rw-time-part-input:disabled {\n  opacity: 1;\n}\n\n.rw-time-part-input, .rw-time-part-input::placeholder {\n  text-align: center;\n}\n\n.rw-time-part-meridiem {\n  padding: 0;\n  margin: 0;\n  border: none;\n  color: inherit;\n  box-shadow: none;\n  background: none;\n  font: inherit;\n  line-height: inherit;\n  -ms-touch-action: manipulation;\n  touch-action: manipulation;\n  outline: 0;\n  padding: 0 0.5em;\n  text-transform: lowercase;\n  font-variant: small-caps;\n}\n\n.rw-time-part-meridiem :focus {\n  outline: none;\n}\n\n.rw-time-input-clear {\n  padding: 0 0.4em;\n  outline: none;\n  opacity: 0;\n  margin-left: auto;\n}\n\n[dir=rtl] .rw-time-input-clear {\n  margin-left: revert;\n  margin-right: auto;\n}\n\n.rw-time-input:hover .rw-time-input-clear.rw-show, .rw-time-input.rw-state-focus .rw-time-input-clear.rw-show {\n  opacity: 1;\n}\n\n.rw-number-picker-spinners {\n  display: flex;\n  flex-direction: column;\n}\n\n.rw-number-picker-spinners .rw-btn {\n  flex: 1 1 0;\n}\n\n.ui-theme-settings {\n  position: fixed;\n  z-index: 155;\n  right: -30px;\n  top: 0;\n  height: 100vh;\n  transform: translate(500px);\n  transition: all 0.2s;\n  box-shadow: -0.46875rem 0 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), -0.9375rem 0 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), -0.25rem 0 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), -0.125rem 0 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);\n}\n.ui-theme-settings .btn-open-options {\n  border-radius: 50px;\n  position: absolute;\n  left: -114px;\n  bottom: 80px;\n  padding: 0;\n  height: 54px;\n  line-height: 54px;\n  width: 54px;\n  text-align: center;\n  display: block;\n  box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);\n  margin-top: -27px;\n}\n.ui-theme-settings .btn-open-options svg {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  margin: -0.5em 0 0 -0.5em;\n}\n.ui-theme-settings .theme-settings__inner {\n  background: #fff;\n  width: 500px;\n  height: 100vh;\n  padding: 0;\n}\n.ui-theme-settings.settings-open {\n  transform: translate(0);\n  right: 0;\n}\n.ui-theme-settings .theme-settings-swatches {\n  text-align: center;\n}\n.ui-theme-settings .theme-settings-swatches .swatch-holder-img {\n  width: 72px;\n  height: auto;\n  border-radius: 3px;\n}\n.ui-theme-settings .theme-settings-swatches .swatch-holder-img img {\n  width: 100%;\n}\n.ui-theme-settings .themeoptions-heading {\n  font-size: 1.1rem;\n  color: #495057;\n  margin: 0;\n  background: #f8f9fa;\n  padding: 0.75rem 1.5rem;\n  border-bottom: #dee2e6 solid 1px;\n  border-top: #dee2e6 solid 1px;\n  display: flex;\n  align-items: center;\n  align-content: center;\n}\n.ui-theme-settings .themeoptions-heading:first-child {\n  border-top: 0;\n}\n.ui-theme-settings .list-group-item h5, .ui-theme-settings .list-group-item .h5 {\n  color: #545cd8;\n  font-size: 0.968rem;\n  text-transform: uppercase;\n  margin: 0;\n  text-align: center;\n}\n\n.swatch-holder {\n  width: 24px;\n  height: 24px;\n  line-height: 24px;\n  margin: 5px 5px 0;\n  transition: all 0.2s;\n  opacity: 0.7;\n  display: inline-block;\n  border-radius: 30px;\n}\n.swatch-holder.active {\n  border: #fff solid 2px;\n  box-shadow: 0 0 0 5px #545cd8;\n  opacity: 1;\n}\n.swatch-holder:hover {\n  opacity: 1;\n}\n\n.swatch-holder-lg {\n  width: 48px;\n  height: 48px;\n  line-height: 48px;\n}\n\n.font-icon-wrapper {\n  text-align: center;\n  border: #e9ecef solid 1px;\n  border-radius: 0.25rem;\n  margin: 0 0 10px;\n  padding: 5px;\n}\n.font-icon-wrapper.font-icon-lg {\n  float: left;\n  padding: 10px;\n  text-align: center;\n  margin-right: 15px;\n  min-width: 64px;\n}\n.font-icon-wrapper.font-icon-lg i {\n  font-size: 2.2rem;\n}\n.font-icon-wrapper:hover {\n  background: #f8f9fa;\n  color: #545cd8;\n}\n.font-icon-wrapper:hover p {\n  color: #6c757d;\n}\n.font-icon-wrapper i {\n  font-size: 1.65rem;\n}\n.font-icon-wrapper p {\n  color: #adb5bd;\n  font-size: 0.8066666667rem;\n  margin: 5px 0 0;\n}\n\n.btn-icon-vertical {\n  min-width: 100px;\n}\n\n.card.mb-3 {\n  margin-bottom: 1.5rem !important;\n}\n\n.demo-image-bg {\n  height: 350px;\n  margin-bottom: 1.5rem;\n}\n\n.loader-wrapper {\n  width: 150px;\n  height: 100px;\n  float: left;\n}\n\n.slider-item {\n  background: #dee2e6;\n  border-radius: 0.25rem;\n  color: #6c757d;\n  font-size: 36px;\n  padding: 0;\n  position: relative;\n  height: 150px;\n  line-height: 150px;\n  text-align: center;\n  margin: 0 1.5rem;\n  transition: all 0.2s;\n}\n\n.slick-center .slider-item {\n  background: #adb5bd;\n  color: #495057;\n}\n\n.after-img {\n  max-width: 100%;\n}\n\n@media only screen and (max-width: 1320px) {\n  .header-user-info {\n    display: none;\n  }\n}\n@media (max-width: 767.98px) {\n  .app-main {\n    display: block;\n  }\n  .dropdown-menu::before, .dropdown-menu::after {\n    display: none;\n  }\n  .app-sidebar {\n    flex: 0 0 280px !important;\n    width: 280px !important;\n    transform: translateX(-280px);\n  }\n  .app-sidebar .app-header__logo {\n    display: none;\n  }\n  .sidebar-mobile-open .app-sidebar {\n    transform: translateX(0);\n  }\n  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .app-sidebar__heading {\n    text-indent: initial;\n  }\n  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .app-sidebar__heading::before {\n    display: none;\n  }\n  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .metismenu-link {\n    text-indent: initial;\n    padding: 0 1.5rem 0 45px;\n  }\n  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .metismenu-icon {\n    text-indent: initial;\n    left: 5px;\n    margin-left: 0;\n  }\n  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .metismenu-state-icon {\n    visibility: visible;\n  }\n  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .metismenu-container.visible {\n    padding: 0.5em 0 0 2rem;\n  }\n  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .metismenu-container.visible > .metismenu-item > .metismenu-link {\n    height: 2.3em;\n  }\n  .sidebar-mobile-open .app-sidebar .app-sidebar__inner .metismenu-container .metismenu-container .metismenu-link {\n    padding-left: 1em;\n  }\n  .sidebar-mobile-open .app-sidebar .app-header__logo {\n    width: auto !important;\n  }\n  .sidebar-mobile-open .app-sidebar .app-header__logo .logo-src {\n    width: 97px !important;\n    margin-left: auto;\n    margin-right: 0;\n  }\n  .sidebar-mobile-open .fixed-sidebar .app-sidebar {\n    height: 100%;\n  }\n  .sidebar-mobile-open .sidebar-mobile-overlay {\n    display: block;\n  }\n  .app-main .app-main__outer {\n    padding-left: 0 !important;\n    width: auto;\n  }\n  .app-header {\n    justify-content: space-between;\n  }\n  .app-header .app-header__logo {\n    display: none;\n    order: 2;\n    background: transparent !important;\n    border: 0 !important;\n  }\n  .app-header .app-header__content {\n    visibility: hidden;\n    opacity: 0;\n    box-shadow: 0 0.46875rem 2.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.9375rem 1.40625rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03), 0 0.25rem 0.53125rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.05), 0 0.125rem 0.1875rem rgba(8.3571428571, 10.0714285714, 36.6428571429, 0.03);\n    position: absolute;\n    left: 5%;\n    width: 90%;\n    top: 0;\n    transition: all 0.2s;\n    background: #fff;\n    border-radius: 50px;\n    padding: 0 10px;\n    overflow: hidden;\n  }\n  .app-header .app-header__content .header-btn-lg {\n    margin-left: 0.5rem;\n    padding: 0 0.5rem;\n  }\n  .app-header .app-header__content .header-btn-lg .hamburger-box {\n    margin-top: 5px;\n  }\n  .app-header .app-header__content .header-btn-lg + .header-btn-lg {\n    display: none;\n  }\n  .app-header .app-header__content .app-header-left .nav {\n    display: none;\n  }\n  .app-header .app-header__content.header-mobile-open {\n    visibility: visible;\n    opacity: 1;\n    top: 80px;\n  }\n  .app-header .app-header__mobile-menu {\n    display: flex;\n    order: 1;\n  }\n  .app-header .app-header__menu {\n    display: flex;\n    order: 3;\n  }\n  .app-header.header-text-light .app-header__menu > span .btn, .app-header.header-text-light .app-header__menu > .btn {\n    background: rgba(255, 255, 255, 0.1);\n    border-color: rgba(255, 255, 255, 0.1);\n  }\n  .app-header.header-text-light .header-mobile-open {\n    background: #343a40;\n  }\n  .popover,\n  .dropdown-menu {\n    position: fixed !important;\n    z-index: 50;\n    left: 5% !important;\n    top: 50% !important;\n    width: 90% !important;\n    transform: translateY(-50%) !important;\n    min-width: 10px !important;\n  }\n  .popover .btn-icon-vertical .btn-icon-wrapper,\n  .dropdown-menu .btn-icon-vertical .btn-icon-wrapper {\n    display: none;\n  }\n  .popover {\n    max-width: initial;\n  }\n  .popover .arrow {\n    display: none !important;\n  }\n  .app-page-title {\n    text-align: center;\n  }\n  .app-page-title .page-title-heading,\n  .app-page-title .page-title-wrapper {\n    margin: 0 auto;\n    display: block;\n  }\n  .app-page-title .page-title-actions {\n    margin: 0.75rem auto 0;\n  }\n  .app-page-title .page-title-actions .breadcrumb-item,\n  .app-page-title .page-title-actions .breadcrumb,\n  .app-page-title .page-title-subheading .breadcrumb-item,\n  .app-page-title .page-title-subheading .breadcrumb {\n    display: inline-block;\n  }\n  .app-footer .app-footer__inner .app-footer-right {\n    display: none;\n  }\n  .app-footer .app-footer__inner .app-footer-left {\n    width: 100%;\n  }\n  .app-footer .app-footer__inner .app-footer-left .footer-dots {\n    margin: 0 auto;\n  }\n  .fixed-footer.closed-sidebar .app-footer .app-footer__inner {\n    margin-left: 0 !important;\n  }\n  .widget-content .widget-numbers {\n    font-size: 1.6rem;\n    line-height: 1;\n  }\n  .slick-slider-sm .slick-slider {\n    max-width: 650px !important;\n  }\n  .body-tabs.body-tabs-layout.body-tabs-big {\n    display: block !important;\n  }\n  .body-tabs.body-tabs-layout.body-tabs-big .RRT__tab {\n    display: inline-block !important;\n    padding: 0 1.5rem !important;\n  }\n  .body-tabs.body-tabs-layout.body-tabs-big .RRT__showmore {\n    margin-top: -20px;\n  }\n  .ReactTable .-pagination .-center {\n    display: none;\n  }\n  .ReactTable .-pagination .-previous {\n    padding-right: 3px;\n  }\n  .bg-transparent.list-group-item {\n    border-color: transparent;\n  }\n  .tabs-lg-alternate.card-header > .nav .nav-item .widget-number {\n    font-size: 1.5rem;\n  }\n  .page-title-head {\n    display: block;\n  }\n}\n@media (max-width: 767.98px) {\n  .app-page-title .page-title-icon,\n  .ui-theme-settings {\n    display: none;\n  }\n  .card-header.responsive-center {\n    display: block;\n    text-align: center;\n    height: auto;\n    padding: 1.5rem;\n  }\n  .card-header.responsive-center .nav,\n  .card-header.responsive-center .btn-actions-pane-right {\n    margin: 0.75rem 0 0;\n  }\n  .card-header.responsive-center .nav .d-inline-block.ml-2,\n  .card-header.responsive-center .btn-actions-pane-right .d-inline-block.ml-2 {\n    width: 100% !important;\n    text-align: left;\n    margin: 0 !important;\n  }\n  .slick-slider-sm .slick-slider {\n    max-width: 650px !important;\n  }\n}\n@media (min-width: 992px) {\n  .slick-slider-sm .slick-slider {\n    max-width: 850px !important;\n  }\n}\n@media (max-width: 991.98px) {\n  .-hide-paging .-pagination .-center {\n    display: none;\n  }\n}\n@media (max-width: 575.98px) {\n  .app-main .app-main__inner {\n    padding: 15px 15px 0;\n  }\n  .mbg-3,\n  body .card.mb-3 {\n    margin-bottom: 0.75rem !important;\n  }\n  .app-page-title {\n    padding: 0.75rem;\n    margin: -0.75rem -0.75rem 1.5rem;\n  }\n  .body-tabs.body-tabs-layout {\n    margin-left: -0.75rem;\n    margin-right: -0.75rem;\n    padding: 0 0.75rem;\n  }\n  .app-main .app-main__inner > .RRT__container > .RRT__panel {\n    margin-top: 0.75rem;\n  }\n  .popover,\n  .dropdown-menu {\n    width: 80%;\n    left: 10%;\n  }\n  body .card-header {\n    height: auto;\n    display: block;\n    padding: 0.75rem 1.5rem;\n    text-align: center;\n  }\n  body .card-header .btn-actions-pane-right {\n    padding: 0.75rem 0 0;\n  }\n  body .card-header .actions-icon-btn {\n    padding: 0;\n  }\n  .card-header.card-header-tab .card-header-title {\n    display: inline-flex !important;\n    line-height: 1;\n  }\n  .card-header.card-header-tab > .nav {\n    margin: 0.75rem 0 -0.75rem;\n    display: table !important;\n    width: 100%;\n  }\n  .card-header.card-header-tab > .nav .nav-item {\n    display: table-cell;\n  }\n  .header-icon {\n    display: none;\n  }\n  .profile-responsive-sm .dropdown-menu-header .menu-header-content.btn-pane-right,\n  .profile-responsive .dropdown-menu-header .menu-header-content.btn-pane-right {\n    display: block;\n    text-align: center;\n  }\n  .profile-responsive-sm .dropdown-menu-header .menu-header-content.btn-pane-right .avatar-icon-wrapper,\n  .profile-responsive .dropdown-menu-header .menu-header-content.btn-pane-right .avatar-icon-wrapper {\n    margin-right: 0 !important;\n  }\n  .profile-responsive-sm .dropdown-menu-header .menu-header-content.btn-pane-right .menu-header-btn-pane,\n  .profile-responsive .dropdown-menu-header .menu-header-content.btn-pane-right .menu-header-btn-pane {\n    margin-top: 1rem;\n  }\n  .slick-slider-sm .slick-slider .slick-prev {\n    left: 0.75rem;\n  }\n  .slick-slider-sm .slick-slider .slick-next {\n    right: 0.75rem;\n  }\n}\n@media only screen and (min-width: 1200px) and (max-width: 1500px) {\n  .profile-responsive .dropdown-menu-header .menu-header-content.btn-pane-right {\n    display: block;\n    text-align: center;\n  }\n  .profile-responsive .dropdown-menu-header .menu-header-content.btn-pane-right .avatar-icon-wrapper {\n    margin-right: 0 !important;\n  }\n  .profile-responsive .dropdown-menu-header .menu-header-content.btn-pane-right .menu-header-btn-pane {\n    margin-top: 1rem;\n  }\n}","// GENERIC\n\n@use \"sass:math\";\n\n$enable-caret: true;\n$enable-rounded: true;\n$enable-shadows: false;\n$enable-gradients: false;\n$enable-transitions: true;\n$enable-grid-classes: true;\n$enable-print-styles: false;\n\n$body-bg: #fff;\n\n// Colors\n\n$white: #fff;\n$gray-100: #f8f9fa;\n$gray-200: #e9ecef;\n$gray-300: #dee2e6;\n$gray-400: #ced4da;\n$gray-500: #adb5bd;\n$gray-600: #6c757d;\n$gray-700: #495057;\n$gray-800: #343a40;\n$gray-900: #212529;\n$black: #000;\n\n$grays: ();\n\n$grays: map-merge(\n                (\n                        \"100\": $gray-100,\n                        \"200\": $gray-200,\n                        \"300\": $gray-300,\n                        \"400\": $gray-400,\n                        \"500\": $gray-500,\n                        \"600\": $gray-600,\n                        \"700\": $gray-700,\n                        \"800\": $gray-800,\n                        \"900\": $gray-900\n                ),\n                $grays\n);\n\n//--#{$color}\n$brand: #545cd8;\n$blue: #86c6fb;\n$indigo: #444054;\n$purple: #83588a;\n$pink: #f65ca2;\n$red: #d92550;\n$orange: #fd7e14;\n$yellow: #f7b924;\n$green: #3ac47d;\n$teal: #16E0BD;\n$cyan: #30b1ff;\n$blue-light: #eeeeee;\n\n$primary: $brand;\n$secondary: $gray-600;\n$success: $green;\n$info: $cyan;\n$warning: $yellow;\n$danger: $red;\n$light: $blue-light;\n$dark: $gray-800;\n$focus: $indigo;\n$alt: $purple;\n\n$theme-colors: ();\n\n$custom-colors: (\n  \"primary\": $primary,\n  \"secondary\": $secondary,\n  \"success\": $success,\n  \"info\": $info,\n  \"warning\": $warning,\n  \"danger\": $danger,\n  \"light\": $light,\n  \"dark\": $dark,\n  \"focus\": $focus,\n  \"alternate\": $alt\n);\n\n$theme-colors: map-merge( $theme-colors, $custom-colors);\n\n// BOOTSTRAP OVERWRITES\n\n$headings-font-weight: 400;\n\n$font-size-base: 0.88rem;\n$font-size-lg: ($font-size-base * 1.25);\n$font-size-sm: ($font-size-base * 1.1);\n$font-size-xs: math.div($font-size-base, 1.1);\n\n$btn-transition: color .15s, background-color .15s, border-color .15s, box-shadow .15s;\n$btn-focus-width: 0;\n$btn-focus-box-shadow: none;\n\n$pagination-focus-box-shadow: none;\n\n$body-color: $gray-700;\n\n$card-cap-bg: $white;\n$card-border-color: rgba(darken($primary, 25%), .125);\n\n$dropdown-min-width: 15rem;\n$dropdown-link-hover-bg: #e0f3ff;\n$dropdown-item-padding-y: .4rem;\n$dropdown-padding-y: .65rem;\n\n$box-shadow-default: 0 0.46875rem 2.1875rem rgba(darken($primary, 50%), .03), 0 0.9375rem 1.40625rem rgba(darken($primary, 50%), .03), 0 0.25rem 0.53125rem rgba(darken($primary, 50%), .05), 0 0.125rem 0.1875rem rgba(darken($primary, 50%), .03);\n\n$box-shadow-default-right: 0.46875rem 0 2.1875rem rgba(darken($primary, 50%), .03),\n0.9375rem 0 1.40625rem rgba(darken($primary, 50%), .03),\n0.25rem 0 0.53125rem rgba(darken($primary, 50%), .05),\n0.125rem 0 0.1875rem rgba(darken($primary, 50%), .03);\n\n$box-shadow-default-inverse: 0 -0.46875rem 2.1875rem rgba(darken($primary, 50%), .03), 0 -0.9375rem 1.40625rem rgba(darken($primary, 50%), .03), 0 -0.25rem 0.53125rem rgba(darken($primary, 50%), .05), 0 -0.125rem 0.1875rem rgba(darken($primary, 50%), .03);\n\n$box-shadow-lg-default: 0 0.76875rem 2.4875rem rgba($gray-800, .3), 0 1.3375rem 1.70625rem rgba($gray-800, .3), 0 0.55rem 0.53125rem rgba(darken($gray-800, 50%), .05), 0 0.225rem 0.4375rem rgba($gray-800, .3);\n\n$form-check-input-margin-y: 0.3rem;\n\n$input-group-addon-bg: lighten($dropdown-link-hover-bg, 3%);\n\n// Tables\n\n$table-accent-bg: rgba($black, .03);\n$table-hover-bg: $dropdown-link-hover-bg;\n$table-active-bg: $table-hover-bg;\n$table-border-color: $gray-200;\n$table-head-bg: $gray-100;\n$table-head-color: $gray-600;\n$table-cell-padding: .55rem;\n$table-cell-padding-sm: .3rem;\n\n// Popovers\n\n$popover-max-width: 320px;\n$popover-box-shadow: $box-shadow-default;\n$popover-border-color: $card-border-color;\n$popover-header-bg: $white;\n\n// Color Modifiers\n\n$link-color: $primary;\n$component-active-bg: $primary;\n$custom-control-indicator-checked-disabled-bg: rgba($primary, .5);\n$form-feedback-valid-color: $success;\n$form-feedback-invalid-color: $danger;\n$progress-bar-bg: $primary;\n$input-btn-focus-color: rgba($component-active-bg, .25);\n$input-focus-border-color: lighten($component-active-bg, 25%);\n$custom-control-indicator-checked-bg: $component-active-bg;\n$custom-control-indicator-active-bg: lighten($component-active-bg, 35%);\n$custom-checkbox-indicator-indeterminate-bg: $component-active-bg;\n$custom-range-thumb-bg: $component-active-bg;\n$custom-range-thumb-active-bg: lighten($component-active-bg, 35%);\n$dropdown-link-active-bg: $component-active-bg;\n$nav-pills-link-active-bg: $component-active-bg;\n$pagination-active-bg: $component-active-bg;\n$list-group-active-bg: $component-active-bg;\n\n$list-group-border-color: rgba($primary, .08) !default;\n\n// Mixins\n\n@mixin box-shadow-architect($shadow) {\n  box-shadow: 0 0.66875rem 2.3875rem rgba($shadow, .03), 0 1.1375rem 1.60625rem rgba($shadow, .03), 0 0.45rem 0.73125rem rgba($shadow, .05), 0 0.325rem 0.3875rem rgba($shadow, .03);\n}\n\n// Border\n\n@each $color, $value in $theme-colors {\n  .border-#{$color} {\n    border-color: $value;\n  }\n}\n\n// List Group\n\n// @each $color, $value in $theme-colors {\n//   @include list-group-item-variant($color, theme-color-level($color, -9), theme-color-level($color, 6));\n// }\n\n// // Background\n\n// @each $color, $value in $theme-colors {\n//   @include bg-variant(\".bg-#{$color}\", $value);\n// }\n\n@if $enable-gradients {\n  @each $color, $value in $theme-colors {\n    @include bg-gradient-variant(\".bg-gradient-#{$color}\", $value);\n  }\n}",":root {\n  // Custom variable values only support SassScript inside `#{}`.\n  @each $color, $value in $colors {\n    --#{$variable-prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$variable-prefix}#{$color}: #{$value};\n  }\n\n  // Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$variable-prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$variable-prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$variable-prefix}gradient: #{$gradient};\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  font-size: $font-size-root;\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\nbody {\n  margin: 0; // 1\n  font-family: $font-family-base;\n  @include font-size($font-size-base);\n  font-weight: $font-weight-base;\n  line-height: $line-height-base;\n  color: $body-color;\n  text-align: $body-text-align;\n  background-color: $body-bg; // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n// 2. Set correct height and prevent the `size` attribute to make the `hr` look like an input field\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  background-color: currentColor;\n  border: 0;\n  opacity: $hr-opacity;\n}\n\nhr:not([size]) {\n  height: $hr-height; // 2\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: $headings-color;\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Duplicate behavior to the data-bs-* attribute for our tooltip plugin\n// 2. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 3. Add explicit cursor to indicate changed behavior.\n// 4. Prevent the text-decoration to be skipped.\n\nabbr[title],\nabbr[data-bs-original-title] { // 1\n  text-decoration: underline dotted; // 2\n  cursor: help; // 3\n  text-decoration-skip-ink: none; // 4\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  background-color: $mark-bg;\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: $link-color;\n  text-decoration: $link-decoration;\n\n  &:hover {\n    color: $link-hover-color;\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n  direction: ltr #{\"/* rtl:ignore */\"};\n  unicode-bidi: bidi-override;\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: $code-color;\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow in Chrome from inputs built with datalists.\n// See https://stackoverflow.com/a/54997118\n\n[list]::-webkit-calendar-picker-indicator {\n  display: none;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  @include font-size($legend-font-size);\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. Correct the outline style in Safari.\n// 2. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n\n[type=\"search\"] {\n  outline-offset: -2px; // 1\n  -webkit-appearance: textfield; // 2\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// Inherit font family and line height for file input buttons\n\n::file-selector-button {\n  font: inherit;\n}\n\n// 1. Change font properties to `inherit`\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::-webkit-file-upload-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black !default;\n$color-contrast-light:     $white !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n// fusv-enable\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs- !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n\n$negative-spacers: if($enable-negative-margins, negativify-map($spacers), null) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-bg:                   $white !default;\n$body-color:                $gray-900 !default;\n$body-text-align:           null !default;\n\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n$gutters: $spacers !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width * .5 !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n\n$border-color:                $gray-300 !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .25rem !default;\n$border-radius-sm:            .2rem !default;\n$border-radius-lg:            .3rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$variable-prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$variable-prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              null !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$sub-sup-font-size:           .75em !default;\n\n$text-muted:                  $gray-600 !default;\n\n$initialism-font-size:        $small-font-size !default;\n\n$blockquote-margin-y:         $spacer !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n$blockquote-footer-color:     $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n$hr-height:                   $border-width !default;\n$hr-opacity:                  .25 !default;\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$mark-padding:                .2em !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$nested-kbd-font-weight:      $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-bg:                     #fcf8e3 !default;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 $body-color !default;\n$table-bg:                    transparent !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba($black, $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba($black, $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba($black, $table-hover-bg-factor) !default;\n\n$table-border-factor:         .1 !default;\n$table-border-width:          $border-width !default;\n$table-border-color:          $border-color !default;\n\n$table-striped-order:         odd !default;\n\n$table-group-separator-color: currentColor !default;\n\n$table-caption-color:         $text-muted !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         .25rem !default;\n$input-btn-focus-color-opacity: .25 !default;\n$input-btn-focus-color:         rgba($component-active-bg, $input-btn-focus-color-opacity) !default;\n$input-btn-focus-blur:          0 !default;\n$input-btn-focus-box-shadow:    0 0 $input-btn-focus-blur $input-btn-focus-width $input-btn-focus-color !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      $border-width !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              $link-color !default;\n$btn-link-hover-color:        $link-hover-color !default;\n$btn-link-disabled-color:     $gray-600 !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           $border-radius !default;\n$btn-border-radius-sm:        $border-radius-sm !default;\n$btn-border-radius-lg:        $border-radius-lg !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       $text-muted !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              $white !default;\n$input-disabled-bg:                     $gray-200 !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           $body-color !default;\n$input-border-color:                    $gray-400 !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      $box-shadow-inset !default;\n\n$input-border-radius:                   $border-radius !default;\n$input-border-radius-sm:                $border-radius-sm !default;\n$input-border-radius-lg:                $border-radius-lg !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               $gray-600 !default;\n$input-plaintext-color:                 $body-color !default;\n\n$input-height-border:                   $input-border-width * 2 !default;\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 1px solid rgba($black, .25) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $input-btn-focus-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba(0, 0, 0, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  $gray-200 !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $gray-200 !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $border-radius !default;\n$form-select-box-shadow:          $box-shadow-inset !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             $gray-300 !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     $box-shadow-inset !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             $gray-500 !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             $input-group-addon-bg !default;\n$form-file-button-hover-bg:       shade-color($form-file-button-bg, 5%) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:            add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:       1.25 !default;\n$form-floating-padding-x:         $input-padding-x !default;\n$form-floating-padding-y:         1rem !default;\n$form-floating-input-padding-t:   1.625rem !default;\n$form-floating-input-padding-b:   .625rem !default;\n$form-floating-label-opacity:     .65 !default;\n$form-floating-label-transform:   scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-transition:        opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": $form-feedback-valid-color,\n    \"icon\": $form-feedback-icon-valid\n  ),\n  \"invalid\": (\n    \"color\": $form-feedback-invalid-color,\n    \"icon\": $form-feedback-icon-invalid\n  )\n) !default;\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-modal-backdrop:             1040 !default;\n$zindex-offcanvas:                  1050 !default;\n$zindex-modal:                      1060 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n// scss-docs-end zindex-stack\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    $link-color !default;\n$nav-link-hover-color:              $link-hover-color !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           $gray-600 !default;\n\n$nav-tabs-border-color:             $gray-300 !default;\n$nav-tabs-border-width:             $border-width !default;\n$nav-tabs-border-radius:            $border-radius !default;\n$nav-tabs-link-hover-border-color:  $gray-200 $gray-200 $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        $gray-700 !default;\n$nav-tabs-link-active-bg:           $body-bg !default;\n$nav-tabs-link-active-border-color: $gray-300 $gray-300 $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           $border-radius !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-theme-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n\n$navbar-light-color:                rgba($black, .55) !default;\n$navbar-light-hover-color:          rgba($black, .7) !default;\n$navbar-light-active-color:         rgba($black, .9) !default;\n$navbar-light-disabled-color:       rgba($black, .3) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba($black, .1) !default;\n\n$navbar-light-brand-color:                $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:          $navbar-light-active-color !default;\n$navbar-dark-brand-color:                 $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:           $navbar-dark-active-color !default;\n// scss-docs-end navbar-theme-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    $body-color !default;\n$dropdown-bg:                       $white !default;\n$dropdown-border-color:             rgba($black, .15) !default;\n$dropdown-border-radius:            $border-radius !default;\n$dropdown-border-width:             $border-width !default;\n$dropdown-inner-border-radius:      subtract($dropdown-border-radius, $dropdown-border-width) !default;\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               $box-shadow !default;\n\n$dropdown-link-color:               $gray-900 !default;\n$dropdown-link-hover-color:         shade-color($gray-900, 10%) !default;\n$dropdown-link-hover-bg:            $gray-200 !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      $gray-500 !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding:           $dropdown-padding-y $dropdown-item-padding-x !default;\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $white !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-color:                  $link-color !default;\n$pagination-bg:                     $white !default;\n$pagination-border-width:           $border-width !default;\n$pagination-border-radius:          $border-radius !default;\n$pagination-margin-start:           -$pagination-border-width !default;\n$pagination-border-color:           $gray-300 !default;\n\n$pagination-focus-color:            $link-hover-color !default;\n$pagination-focus-bg:               $gray-200 !default;\n$pagination-focus-box-shadow:       $input-btn-focus-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            $link-hover-color !default;\n$pagination-hover-bg:               $gray-200 !default;\n$pagination-hover-border-color:     $gray-300 !default;\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $pagination-active-bg !default;\n\n$pagination-disabled-color:         $gray-600 !default;\n$pagination-disabled-bg:            $white !default;\n$pagination-disabled-border-color:  $gray-300 !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       $border-radius-sm !default;\n$pagination-border-radius-lg:       $border-radius-lg !default;\n// scss-docs-end pagination-variables\n\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-border-width:                 $border-width !default;\n$card-border-radius:                $border-radius !default;\n$card-border-color:                 rgba($black, .125) !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba($black, .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           $white !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         $body-color !default;\n$accordion-bg:                            $body-bg !default;\n$accordion-border-width:                  $border-width !default;\n$accordion-border-color:                  rgba($black, .125) !default;\n$accordion-border-radius:                 $border-radius !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  $accordion-color !default;\n$accordion-button-bg:                     $accordion-bg !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              tint-color($component-active-bg, 90%) !default;\n$accordion-button-active-color:           shade-color($primary, 10%) !default;\n\n$accordion-button-focus-border-color:     $input-focus-border-color !default;\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $accordion-color !default;\n$accordion-icon-active-color:             $accordion-button-active-color !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     $white !default;\n$tooltip-bg:                        $black !default;\n$tooltip-border-radius:             $border-radius !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    0 !default;\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n$tooltip-arrow-color:               $tooltip-bg !default;\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        $white !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              $border-width !default;\n$popover-border-color:              rgba($black, .2) !default;\n$popover-border-radius:             $border-radius-lg !default;\n$popover-inner-border-radius:       subtract($popover-border-radius, $popover-border-width) !default;\n$popover-box-shadow:                $box-shadow !default;\n\n$popover-header-bg:                 shade-color($popover-bg, 6%) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                $body-color !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n$popover-arrow-color:               $popover-bg !default;\n\n$popover-arrow-outer-color:         fade-in($popover-border-color, .05) !default;\n// scss-docs-end popover-variables\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba($white, .85) !default;\n$toast-border-width:                1px !default;\n$toast-border-color:                rgba(0, 0, 0, .1) !default;\n$toast-border-radius:               $border-radius !default;\n$toast-box-shadow:                  $box-shadow !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                $gray-600 !default;\n$toast-header-background-color:     rgba($white, .85) !default;\n$toast-header-border-color:         rgba(0, 0, 0, .05) !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $white !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               $border-radius !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  $white !default;\n$modal-content-border-color:        rgba($black, .2) !default;\n$modal-content-border-width:        $border-width !default;\n$modal-content-border-radius:       $border-radius-lg !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       $box-shadow-sm !default;\n$modal-content-box-shadow-sm-up:    $box-shadow !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n$modal-header-border-color:         $border-color !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           $border-radius !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            $border-width !default;\n$alert-bg-scale:                -80% !default;\n$alert-border-scale:            -70% !default;\n$alert-color-scale:             40% !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       $gray-200 !default;\n$progress-border-radius:            $border-radius !default;\n$progress-box-shadow:               $box-shadow-inset !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   $primary !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  $gray-900 !default;\n$list-group-bg:                     $white !default;\n$list-group-border-color:           rgba($black, .125) !default;\n$list-group-border-width:           $border-width !default;\n$list-group-border-radius:          $border-radius !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n$list-group-item-bg-scale:          -80% !default;\n$list-group-item-color-scale:       40% !default;\n\n$list-group-hover-bg:               $gray-100 !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         $gray-600 !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           $gray-700 !default;\n$list-group-action-hover-color:     $list-group-action-color !default;\n\n$list-group-action-active-color:    $body-color !default;\n$list-group-action-active-bg:       $gray-200 !default;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      $body-bg !default;\n$thumbnail-border-width:            $border-width !default;\n$thumbnail-border-color:            $gray-300 !default;\n$thumbnail-border-radius:           $border-radius !default;\n$thumbnail-box-shadow:              $box-shadow-sm !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              $gray-600 !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          $gray-600 !default;\n$breadcrumb-active-color:           $gray-600 !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n\n$carousel-dark-indicator-active-bg:  $black !default;\n$carousel-dark-caption-color:        $black !default;\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default;\n// scss-docs-end carousel-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $black !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/></svg>\") !default;\n$btn-close-focus-shadow:     $input-btn-focus-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default;\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                $modal-content-bg !default;\n$offcanvas-color:                   $modal-content-color !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .2rem !default;\n$kbd-padding-x:                     .4rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         $white !default;\n$kbd-bg:                            $gray-900 !default;\n\n$pre-color:                         null !default;\n","// stylelint-disable property-blacklist, scss/dollar-variable-default\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  }\n  @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: '';\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + ' 0';\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + ' ' + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + ' ' + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      }\n      @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + ' ' + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: '';\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + ' 0';\n    }\n\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + ' ' + $value;\n      }\n\n      @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + ' ' +  if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + ' calc(' + $min-width + if($value < 0, ' - ', ' + ') + $variable-width + ')';\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluidVal: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluidVal {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluidVal);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule {\n        #{$property}: if($rfs-mode == max-media-query, $fluidVal, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    @include font-size($font-size);\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-grid-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  width: 100%;\n  padding-right: var(--#{$variable-prefix}gutter-x, #{$gutter});\n  padding-left: var(--#{$variable-prefix}gutter-x, #{$gutter});\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$variable-prefix}gutter-x: #{$gutter};\n  --#{$variable-prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: calc(var(--#{$variable-prefix}gutter-y) * -1); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(var(--#{$variable-prefix}gutter-x) * -.5); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(var(--#{$variable-prefix}gutter-x) * -.5); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready($gutter: $grid-gutter-width) {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$variable-prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$variable-prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$variable-prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// numberof columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: divide(100%, $count);\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    // .row-cols defaults must all appear before .col overrides so they can be overridden.\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0%; // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n    }\n  }\n\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$variable-prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$variable-prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  --#{$variable-prefix}table-bg: #{$table-bg};\n  --#{$variable-prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$variable-prefix}table-striped-color: #{$table-striped-color};\n  --#{$variable-prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$variable-prefix}table-active-color: #{$table-active-color};\n  --#{$variable-prefix}table-active-bg: #{$table-active-bg};\n  --#{$variable-prefix}table-hover-color: #{$table-hover-color};\n  --#{$variable-prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  color: $table-color;\n  vertical-align: $table-cell-vertical-align;\n  border-color: $table-border-color;\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    background-color: var(--#{$variable-prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$variable-prefix}table-accent-bg);\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n\n  // Highlight border color between thead, tbody and tfoot.\n  > :not(:last-child) > :last-child > * {\n    border-bottom-color: $table-group-separator-color;\n  }\n}\n\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefor we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) {\n    --#{$variable-prefix}table-accent-bg: var(--#{$variable-prefix}table-striped-bg);\n    color: var(--#{$variable-prefix}table-striped-color);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$variable-prefix}table-accent-bg: var(--#{$variable-prefix}table-active-bg);\n  color: var(--#{$variable-prefix}table-active-color);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover {\n    --#{$variable-prefix}table-accent-bg: var(--#{$variable-prefix}table-hover-bg);\n    color: var(--#{$variable-prefix}table-hover-color);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n\n    --#{$variable-prefix}table-bg: #{$background};\n    --#{$variable-prefix}table-striped-bg: #{$striped-bg};\n    --#{$variable-prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$variable-prefix}table-active-bg: #{$active-bg};\n    --#{$variable-prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$variable-prefix}table-hover-bg: #{$hover-bg};\n    --#{$variable-prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: $color;\n    border-color: mix($color, $background, percentage($table-border-factor));\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  // Add some height to date inputs on iOS\n  // https://github.com/twbs/bootstrap/issues/23307\n  // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n  &::-webkit-date-and-time-value {\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled and read-only inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled,\n  &[readonly] {\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n\n  &::-webkit-file-upload-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::-webkit-file-upload-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n\n  &::-webkit-file-upload-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n\n  &::-webkit-file-upload-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  max-width: 3rem;\n  height: auto; // Override fixed browser height\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n    @include border-radius($input-border-radius);\n  }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$variable-prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  display: block;\n  width: 100%;\n  padding: $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x;\n  // stylelint-disable-next-line property-no-vendor-prefix\n  -moz-padding-start: subtract($form-select-padding-x, 3px); // See https://github.com/twbs/bootstrap/issues/32636\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  background-color: $form-select-bg;\n  background-image: escape-svg($form-select-indicator);\n  background-repeat: no-repeat;\n  background-position: $form-select-bg-position;\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n  appearance: none;\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-right: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  padding-left: $form-select-padding-x-sm;\n  @include font-size($form-select-font-size-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  padding-left: $form-select-padding-x-lg;\n  @include font-size($form-select-font-size-lg);\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-left: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: left;\n    margin-left: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-input {\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  background-color: $form-check-input-bg;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  appearance: none;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: $form-check-input-checked-bg-color;\n    border-color: $form-check-input-checked-border-color;\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        background-image: escape-svg($form-check-input-checked-bg-image), var(--#{$variable-prefix}gradient);\n      } @else {\n        background-image: escape-svg($form-check-input-checked-bg-image);\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        background-image: escape-svg($form-check-radio-checked-bg-image), var(--#{$variable-prefix}gradient);\n      } @else {\n        background-image: escape-svg($form-check-radio-checked-bg-image);\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      background-image: escape-svg($form-check-input-indeterminate-bg-image), var(--#{$variable-prefix}gradient);\n    } @else {\n      background-image: escape-svg($form-check-input-indeterminate-bg-image);\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: $form-check-label-color;\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-left: $form-switch-padding-start;\n\n  .form-check-input {\n    width: $form-switch-width;\n    margin-left: $form-switch-padding-start * -1;\n    background-image: escape-svg($form-switch-bg-image);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      background-image: escape-svg($form-switch-focus-bg-image);\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        background-image: escape-svg($form-switch-checked-bg-image), var(--#{$variable-prefix}gradient);\n      } @else {\n        background-image: escape-svg($form-switch-checked-bg-image);\n      }\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  background-color: transparent;\n  appearance: none;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-select {\n    height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  // stylelint-disable no-duplicate-selectors\n  > .form-control {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-select {\n    ~ label {\n      opacity: $form-floating-label-opacity;\n      transform: $form-floating-label-transform;\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      opacity: $form-floating-label-opacity;\n      transform: $form-floating-label-transform;\n    }\n  }\n  // stylelint-enable no-duplicate-selectors\n}\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus {\n    z-index: 3;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 3;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu),\n    > .dropdown-toggle:nth-last-child(n + 3) {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu),\n    > .dropdown-toggle:nth-last-child(n + 4) {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    margin-left: -$input-border-width;\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity)\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          padding-right: $form-select-feedback-icon-padding-end;\n          background-image: escape-svg($form-select-indicator), escape-svg($icon);\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-left: .5em;\n    }\n  }\n\n  .input-group .form-control,\n  .input-group .form-select {\n    @include form-validation-state-selector($state) {\n      @if $state == \"valid\" {\n        z-index: 1;\n      } @else if $state == \"invalid\" {\n        z-index: 2;\n      }\n      &:focus {\n        z-index: 3;\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  display: inline-block;\n  font-family: $btn-font-family;\n  font-weight: $btn-font-weight;\n  line-height: $btn-line-height;\n  color: $body-color;\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  background-color: transparent;\n  border: $btn-border-width solid transparent;\n  @include button-size($btn-padding-y, $btn-padding-x, $btn-font-size, $btn-border-radius);\n  @include transition($btn-transition);\n\n  &:hover {\n    color: $body-color;\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  .btn-check:focus + &,\n  &:focus {\n    outline: 0;\n    box-shadow: $btn-focus-box-shadow;\n  }\n\n  .btn-check:checked + &,\n  .btn-check:active + &,\n  &:active,\n  &.active {\n    @include box-shadow($btn-active-box-shadow);\n\n    &:focus {\n      @include box-shadow($btn-focus-box-shadow, $btn-active-box-shadow);\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    pointer-events: none;\n    opacity: $btn-disabled-opacity;\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  font-weight: $font-weight-normal;\n  color: $btn-link-color;\n  text-decoration: $link-decoration;\n\n  &:hover {\n    color: $btn-link-hover-color;\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:disabled,\n  &.disabled {\n    color: $btn-link-disabled-color;\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  color: $color;\n  @include gradient-bg($background);\n  border-color: $border;\n  @include box-shadow($btn-box-shadow);\n\n  &:hover {\n    color: $hover-color;\n    @include gradient-bg($hover-background);\n    border-color: $hover-border;\n  }\n\n  .btn-check:focus + &,\n  &:focus {\n    color: $hover-color;\n    @include gradient-bg($hover-background);\n    border-color: $hover-border;\n    @if $enable-shadows {\n      @include box-shadow($btn-box-shadow, 0 0 0 $btn-focus-width rgba(mix($color, $border, 15%), .5));\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: 0 0 0 $btn-focus-width rgba(mix($color, $border, 15%), .5);\n    }\n  }\n\n  .btn-check:checked + &,\n  .btn-check:active + &,\n  &:active,\n  &.active,\n  .show > &.dropdown-toggle {\n    color: $active-color;\n    background-color: $active-background;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: $active-border;\n\n    &:focus {\n      @if $enable-shadows {\n        @include box-shadow($btn-active-box-shadow, 0 0 0 $btn-focus-width rgba(mix($color, $border, 15%), .5));\n      } @else {\n        // Avoid using mixin so we can pass custom focus shadow properly\n        box-shadow: 0 0 0 $btn-focus-width rgba(mix($color, $border, 15%), .5);\n      }\n    }\n  }\n\n  &:disabled,\n  &.disabled {\n    color: $disabled-color;\n    background-color: $disabled-background;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: $disabled-border;\n  }\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  color: $color;\n  border-color: $color;\n\n  &:hover {\n    color: $color-hover;\n    background-color: $active-background;\n    border-color: $active-border;\n  }\n\n  .btn-check:focus + &,\n  &:focus {\n    box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n  }\n\n  .btn-check:checked + &,\n  .btn-check:active + &,\n  &:active,\n  &.active,\n  &.dropdown-toggle.show {\n    color: $active-color;\n    background-color: $active-background;\n    border-color: $active-border;\n\n    &:focus {\n      @if $enable-shadows {\n        @include box-shadow($btn-active-box-shadow, 0 0 0 $btn-focus-width rgba($color, .5));\n      } @else {\n        // Avoid using mixin so we can pass custom focus shadow properly\n        box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n      }\n    }\n  }\n\n  &:disabled,\n  &.disabled {\n    color: $color;\n    background-color: transparent;\n  }\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  padding: $padding-y $padding-x;\n  @include font-size($font-size);\n  // Manually declare to provide an override to the browser default\n  @include border-radius($border-radius, 0);\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  position: absolute;\n  z-index: $zindex-dropdown;\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: $dropdown-min-width;\n  padding: $dropdown-padding-y $dropdown-padding-x;\n  margin: 0; // Override default margin of ul\n  @include font-size($dropdown-font-size);\n  color: $dropdown-color;\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: $dropdown-bg;\n  background-clip: padding-box;\n  border: $dropdown-border-width solid $dropdown-border-color;\n  @include border-radius($dropdown-border-radius);\n  @include box-shadow($dropdown-box-shadow);\n\n  &[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: $dropdown-spacer;\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `bs-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --bs-position: start;\n\n      &[data-bs-popper] {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --bs-position: end;\n\n      &[data-bs-popper] {\n        right: 0;\n        left: auto;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: $dropdown-divider-margin-y 0;\n  overflow: hidden;\n  border-top: 1px solid $dropdown-divider-bg;\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: $dropdown-link-color;\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n\n  // Prevent dropdown overflow if there's no padding\n  // See https://github.com/twbs/bootstrap/pull/27703\n  @if $dropdown-padding-y == 0 {\n    &:first-child {\n      @include border-top-radius($dropdown-inner-border-radius);\n    }\n\n    &:last-child {\n      @include border-bottom-radius($dropdown-inner-border-radius);\n    }\n  }\n\n  &:hover,\n  &:focus {\n    color: $dropdown-link-hover-color;\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg($dropdown-link-hover-bg);\n  }\n\n  &.active,\n  &:active {\n    color: $dropdown-link-active-color;\n    text-decoration: none;\n    @include gradient-bg($dropdown-link-active-bg);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $dropdown-link-disabled-color;\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: $dropdown-header-padding;\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: $dropdown-header-color;\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n  color: $dropdown-link-color;\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  color: $dropdown-dark-color;\n  background-color: $dropdown-dark-bg;\n  border-color: $dropdown-dark-border-color;\n  @include box-shadow($dropdown-dark-box-shadow);\n\n  .dropdown-item {\n    color: $dropdown-dark-link-color;\n\n    &:hover,\n    &:focus {\n      color: $dropdown-dark-link-hover-color;\n      @include gradient-bg($dropdown-dark-link-hover-bg);\n    }\n\n    &.active,\n    &:active {\n      color: $dropdown-dark-link-active-color;\n      @include gradient-bg($dropdown-dark-link-active-bg);\n    }\n\n    &.disabled,\n    &:disabled {\n      color: $dropdown-dark-link-disabled-color;\n    }\n  }\n\n  .dropdown-divider {\n    border-color: $dropdown-dark-divider-bg;\n  }\n\n  .dropdown-item-text {\n    color: $dropdown-dark-link-color;\n  }\n\n  .dropdown-header {\n    color: $dropdown-dark-header-color;\n  }\n}\n","// scss-docs-start caret-mixins\n@mixin caret-down {\n  border-top: $caret-width solid;\n  border-right: $caret-width solid transparent;\n  border-bottom: 0;\n  border-left: $caret-width solid transparent;\n}\n\n@mixin caret-up {\n  border-top: 0;\n  border-right: $caret-width solid transparent;\n  border-bottom: $caret-width solid;\n  border-left: $caret-width solid transparent;\n}\n\n@mixin caret-end {\n  border-top: $caret-width solid transparent;\n  border-right: 0;\n  border-bottom: $caret-width solid transparent;\n  border-left: $caret-width solid;\n}\n\n@mixin caret-start {\n  border-top: $caret-width solid transparent;\n  border-right: $caret-width solid;\n  border-bottom: $caret-width solid transparent;\n}\n\n@mixin caret($direction: down) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $caret-spacing;\n      vertical-align: $caret-vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down();\n      } @else if $direction == up {\n        @include caret-up();\n      } @else if $direction == end {\n        @include caret-end();\n      }\n    }\n\n    @if $direction == start {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $caret-spacing;\n        vertical-align: $caret-vertical-align;\n        content: \"\";\n        @include caret-start();\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n// scss-docs-end caret-mixins\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  // Prevent double borders when buttons are next to each other\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-left: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn ~ .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: $nav-link-padding-y $nav-link-padding-x;\n  @include font-size($nav-link-font-size);\n  font-weight: $nav-link-font-weight;\n  color: $nav-link-color;\n  text-decoration: if($link-decoration == none, null, none);\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: $nav-link-hover-color;\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  // Disabled state lightens text\n  &.disabled {\n    color: $nav-link-disabled-color;\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  border-bottom: $nav-tabs-border-width solid $nav-tabs-border-color;\n\n  .nav-link {\n    margin-bottom: -$nav-tabs-border-width;\n    background: none;\n    border: $nav-tabs-border-width solid transparent;\n    @include border-top-radius($nav-tabs-border-radius);\n\n    &:hover,\n    &:focus {\n      border-color: $nav-tabs-link-hover-border-color;\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n    }\n\n    &.disabled {\n      color: $nav-link-disabled-color;\n      background-color: transparent;\n      border-color: transparent;\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: $nav-tabs-link-active-color;\n    background-color: $nav-tabs-link-active-bg;\n    border-color: $nav-tabs-link-active-border-color;\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: -$nav-tabs-border-width;\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n//\n// Pills\n//\n\n.nav-pills {\n  .nav-link {\n    background: none;\n    border: 0;\n    @include border-radius($nav-pills-border-radius);\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: $nav-pills-link-active-color;\n    @include gradient-bg($nav-pills-link-active-bg);\n  }\n}\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n.err-select {\n  border: 1px solid #d92550;\n}\n","// Contents\n//\n// Navbar\n// Navbar brand\n// Navbar nav\n// Navbar text\n// Responsive navbar\n// Navbar position\n// Navbar themes\n\n\n// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding-top: $navbar-padding-y;\n  padding-right: $navbar-padding-x; // default: null\n  padding-bottom: $navbar-padding-y;\n  padding-left: $navbar-padding-x; // default: null\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: $navbar-brand-padding-y;\n  padding-bottom: $navbar-brand-padding-y;\n  margin-right: $navbar-brand-margin-end;\n  @include font-size($navbar-brand-font-size);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: $navbar-toggler-padding-y $navbar-toggler-padding-x;\n  @include font-size($navbar-toggler-font-size);\n  line-height: 1;\n  background-color: transparent; // remove default button style\n  border: $border-width solid transparent; // remove default button style\n  @include border-radius($navbar-toggler-border-radius);\n  @include transition($navbar-toggler-transition);\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 $navbar-toggler-focus-width;\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$variable-prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: $navbar-nav-link-padding-x;\n            padding-left: $navbar-nav-link-padding-x;\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n// Dark links against a light background\n.navbar-light {\n  .navbar-brand {\n    color: $navbar-light-brand-color;\n\n    &:hover,\n    &:focus {\n      color: $navbar-light-brand-hover-color;\n    }\n  }\n\n  .navbar-nav {\n    .nav-link {\n      color: $navbar-light-color;\n\n      &:hover,\n      &:focus {\n        color: $navbar-light-hover-color;\n      }\n\n      &.disabled {\n        color: $navbar-light-disabled-color;\n      }\n    }\n\n    .show > .nav-link,\n    .nav-link.active {\n      color: $navbar-light-active-color;\n    }\n  }\n\n  .navbar-toggler {\n    color: $navbar-light-color;\n    border-color: $navbar-light-toggler-border-color;\n  }\n\n  .navbar-toggler-icon {\n    background-image: escape-svg($navbar-light-toggler-icon-bg);\n  }\n\n  .navbar-text {\n    color: $navbar-light-color;\n\n    a,\n    a:hover,\n    a:focus  {\n      color: $navbar-light-active-color;\n    }\n  }\n}\n\n// White links against a dark background\n.navbar-dark {\n  .navbar-brand {\n    color: $navbar-dark-brand-color;\n\n    &:hover,\n    &:focus {\n      color: $navbar-dark-brand-hover-color;\n    }\n  }\n\n  .navbar-nav {\n    .nav-link {\n      color: $navbar-dark-color;\n\n      &:hover,\n      &:focus {\n        color: $navbar-dark-hover-color;\n      }\n\n      &.disabled {\n        color: $navbar-dark-disabled-color;\n      }\n    }\n\n    .show > .nav-link,\n    .nav-link.active {\n      color: $navbar-dark-active-color;\n    }\n  }\n\n  .navbar-toggler {\n    color: $navbar-dark-color;\n    border-color: $navbar-dark-toggler-border-color;\n  }\n\n  .navbar-toggler-icon {\n    background-image: escape-svg($navbar-dark-toggler-icon-bg);\n  }\n\n  .navbar-text {\n    color: $navbar-dark-color;\n    a,\n    a:hover,\n    a:focus {\n      color: $navbar-dark-active-color;\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: $card-height;\n  word-wrap: break-word;\n  background-color: $card-bg;\n  background-clip: border-box;\n  border: $card-border-width solid $card-border-color;\n  @include border-radius($card-border-radius);\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius($card-inner-border-radius);\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius($card-inner-border-radius);\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: $card-spacer-y $card-spacer-x;\n  color: $card-color;\n}\n\n.card-title {\n  margin-bottom: $card-title-spacer-y;\n}\n\n.card-subtitle {\n  margin-top: -$card-title-spacer-y * .5;\n  margin-bottom: 0;\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: none;\n  }\n\n  + .card-link {\n    margin-left: $card-spacer-x;\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: $card-cap-padding-y $card-cap-padding-x;\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: $card-cap-color;\n  background-color: $card-cap-bg;\n  border-bottom: $card-border-width solid $card-border-color;\n\n  &:first-child {\n    @include border-radius($card-inner-border-radius $card-inner-border-radius 0 0);\n  }\n}\n\n.card-footer {\n  padding: $card-cap-padding-y $card-cap-padding-x;\n  color: $card-cap-color;\n  background-color: $card-cap-bg;\n  border-top: $card-border-width solid $card-border-color;\n\n  &:last-child {\n    @include border-radius(0 0 $card-inner-border-radius $card-inner-border-radius);\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: -$card-cap-padding-x * .5;\n  margin-bottom: -$card-cap-padding-y;\n  margin-left: -$card-cap-padding-x * .5;\n  border-bottom: 0;\n\n  @if $nav-tabs-link-active-bg != $card-bg {\n    .nav-link.active {\n      background-color: $card-bg;\n      border-bottom-color: $card-bg;\n    }\n  }\n}\n\n.card-header-pills {\n  margin-right: -$card-cap-padding-x * .5;\n  margin-left: -$card-cap-padding-x * .5;\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: $card-img-overlay-padding;\n  @include border-radius($card-inner-border-radius);\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius($card-inner-border-radius);\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius($card-inner-border-radius);\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: $card-group-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: $accordion-button-padding-y $accordion-button-padding-x;\n  @include font-size($font-size-base);\n  color: $accordion-button-color;\n  text-align: left; // Reset button style\n  background-color: $accordion-button-bg;\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition($accordion-transition);\n\n  &:not(.collapsed) {\n    color: $accordion-button-active-color;\n    background-color: $accordion-button-active-bg;\n    box-shadow: inset 0 ($accordion-border-width * -1) 0 $accordion-border-color;\n\n    &::after {\n      background-image: escape-svg($accordion-button-active-icon);\n      transform: $accordion-icon-transform;\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: $accordion-icon-width;\n    height: $accordion-icon-width;\n    margin-left: auto;\n    content: \"\";\n    background-image: escape-svg($accordion-button-icon);\n    background-repeat: no-repeat;\n    background-size: $accordion-icon-width;\n    @include transition($accordion-icon-transition);\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    border-color: $accordion-button-focus-border-color;\n    outline: 0;\n    box-shadow: $accordion-button-focus-box-shadow;\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  background-color: $accordion-bg;\n  // border: $accordion-border-width solid $accordion-border-color;\n\n  &:first-of-type {\n    @include border-top-radius($accordion-border-radius);\n\n    .accordion-button {\n      @include border-top-radius($accordion-inner-border-radius);\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius($accordion-border-radius);\n\n    .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius($accordion-inner-border-radius);\n      }\n    }\n\n    .accordion-collapse {\n      @include border-bottom-radius($accordion-border-radius);\n    }\n  }\n}\n\n.accordion-body {\n  padding: $accordion-body-padding-y $accordion-body-padding-x;\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  .accordion-collapse {\n    border-width: 0;\n  }\n\n  .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    .accordion-button {\n      @include border-radius(0);\n    }\n  }\n}\n",".breadcrumb {\n  display: flex;\n  flex-wrap: wrap;\n  padding: $breadcrumb-padding-y $breadcrumb-padding-x;\n  margin-bottom: $breadcrumb-margin-bottom;\n  @include font-size($breadcrumb-font-size);\n  list-style: none;\n  background-color: $breadcrumb-bg;\n  @include border-radius($breadcrumb-border-radius);\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: $breadcrumb-item-padding-x;\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: $breadcrumb-item-padding-x;\n      color: $breadcrumb-divider-color;\n      content: var(--#{$variable-prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)) #{\"/* rtl:\"} var(--#{$variable-prefix}breadcrumb-divider, escape-svg($breadcrumb-divider-flipped)) #{\"*/\"};\n    }\n  }\n\n  &.active {\n    color: $breadcrumb-active-color;\n  }\n}\n",".pagination {\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  color: $pagination-color;\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: $pagination-bg;\n  border: $pagination-border-width solid $pagination-border-color;\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: $pagination-hover-color;\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: $pagination-hover-bg;\n    border-color: $pagination-hover-border-color;\n  }\n\n  &:focus {\n    z-index: 3;\n    color: $pagination-focus-color;\n    background-color: $pagination-focus-bg;\n    outline: $pagination-focus-outline;\n    box-shadow: $pagination-focus-box-shadow;\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  &.active .page-link {\n    z-index: 3;\n    color: $pagination-active-color;\n    @include gradient-bg($pagination-active-bg);\n    border-color: $pagination-active-border-color;\n  }\n\n  &.disabled .page-link {\n    color: $pagination-disabled-color;\n    pointer-events: none;\n    background-color: $pagination-disabled-bg;\n    border-color: $pagination-disabled-border-color;\n  }\n}\n\n\n//\n// Sizing\n//\n@include pagination-size($pagination-padding-y, $pagination-padding-x, null, $pagination-border-radius);\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  .page-link {\n    padding: $padding-y $padding-x;\n    @include font-size($font-size);\n  }\n\n  .page-item {\n    @if $pagination-margin-start == (-$pagination-border-width) {\n      &:first-child {\n        .page-link {\n          @include border-start-radius($border-radius);\n        }\n      }\n\n      &:last-child {\n        .page-link {\n          @include border-end-radius($border-radius);\n        }\n      }\n    } @else {\n      //Add border-radius to all pageLinks in case they have left margin\n      .page-link {\n        @include border-radius($border-radius);\n      }\n    }\n  }\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  display: inline-block;\n  padding: $badge-padding-y $badge-padding-x;\n  @include font-size($badge-font-size);\n  font-weight: $badge-font-weight;\n  line-height: 1;\n  color: $badge-color;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius($badge-border-radius);\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n","//\n// Base styles\n//\n\n.alert {\n  position: relative;\n  padding: $alert-padding-y $alert-padding-x;\n  margin-bottom: $alert-margin-bottom;\n  border: $alert-border-width solid transparent;\n  @include border-radius($alert-border-radius);\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert.\n\n@each $state, $value in $theme-colors {\n  $alert-background: shift-color($value, $alert-bg-scale);\n  $alert-border: shift-color($value, $alert-border-scale);\n  $alert-color: shift-color($value, $alert-color-scale);\n  @if (contrast-ratio($alert-background, $alert-color) < $min-contrast-ratio) {\n    $alert-color: mix($value, color-contrast($alert-background), abs($alert-color-scale));\n  }\n  .alert-#{$state} {\n    @include alert-variant($alert-background, $alert-border, $alert-color);\n  }\n}\n// scss-docs-end alert-modifiers\n","// scss-docs-start alert-variant-mixin\n@mixin alert-variant($background, $border, $color) {\n  color: $color;\n  @include gradient-bg($background);\n  border-color: $border;\n\n  .alert-link {\n    color: shade-color($color, 20%);\n  }\n}\n// scss-docs-end alert-variant-mixin\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: $progress-height; }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress {\n  display: flex;\n  height: $progress-height;\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size($progress-font-size);\n  background-color: $progress-bg;\n  @include border-radius($progress-border-radius);\n  @include box-shadow($progress-box-shadow);\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: $progress-bar-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $progress-bar-bg;\n  @include transition($progress-bar-transition);\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: $progress-height $progress-height;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius($list-group-border-radius);\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > li::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: $list-group-action-color;\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  &:hover,\n  &:focus {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: $list-group-action-hover-color;\n    text-decoration: none;\n    background-color: $list-group-hover-bg;\n  }\n\n  &:active {\n    color: $list-group-action-active-color;\n    background-color: $list-group-action-active-bg;\n  }\n}\n\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: $list-group-item-padding-y $list-group-item-padding-x;\n  color: $list-group-color;\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: $list-group-bg;\n  border: $list-group-border-width solid $list-group-border-color;\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $list-group-disabled-color;\n    pointer-events: none;\n    background-color: $list-group-disabled-bg;\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: $list-group-active-color;\n    background-color: $list-group-active-bg;\n    border-color: $list-group-active-border-color;\n  }\n\n  & + & {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: -$list-group-border-width;\n      border-top-width: $list-group-border-width;\n    }\n  }\n}\n\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child {\n          @include border-bottom-start-radius($list-group-border-radius);\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child {\n          @include border-top-end-radius($list-group-border-radius);\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: $list-group-border-width;\n          border-left-width: 0;\n\n          &.active {\n            margin-left: -$list-group-border-width;\n            border-left-width: $list-group-border-width;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 $list-group-border-width;\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state, $value in $theme-colors {\n  $list-group-variant-bg: shift-color($value, $list-group-item-bg-scale);\n  $list-group-variant-color: shift-color($value, $list-group-item-color-scale);\n  @if (contrast-ratio($list-group-variant-bg, $list-group-variant-color) < $min-contrast-ratio) {\n    $list-group-variant-color: mix($value, color-contrast($list-group-variant-bg), abs($list-group-item-color-scale));\n  }\n\n  @include list-group-item-variant($state, $list-group-variant-bg, $list-group-variant-color);\n}\n// scss-docs-end list-group-modifiers\n","// List Groups\n\n// scss-docs-start list-group-mixin\n@mixin list-group-item-variant($state, $background, $color) {\n  .list-group-item-#{$state} {\n    color: $color;\n    background-color: $background;\n\n    &.list-group-item-action {\n      &:hover,\n      &:focus {\n        color: $color;\n        background-color: shade-color($background, 10%);\n      }\n\n      &.active {\n        color: $white;\n        background-color: $color;\n        border-color: $color;\n      }\n    }\n  }\n}\n// scss-docs-end list-group-mixin\n","// transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: $btn-close-color;\n  background: transparent escape-svg($btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: $btn-close-opacity;\n\n  // Override <a>'s hover style\n  &:hover {\n    color: $btn-close-color;\n    text-decoration: none;\n    opacity: $btn-close-hover-opacity;\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: $btn-close-focus-shadow;\n    opacity: $btn-close-focus-opacity;\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: $btn-close-disabled-opacity;\n  }\n}\n\n.btn-close-white {\n  filter: $btn-close-white-filter;\n}\n",".toast {\n  width: $toast-max-width;\n  max-width: 100%;\n  @include font-size($toast-font-size);\n  color: $toast-color;\n  pointer-events: auto;\n  background-color: $toast-background-color;\n  background-clip: padding-box;\n  border: $toast-border-width solid $toast-border-color;\n  box-shadow: $toast-box-shadow;\n  @include border-radius($toast-border-radius);\n\n  &:not(.showing):not(.show) {\n    opacity: 0;\n  }\n\n  &.hide {\n    display: none;\n  }\n}\n\n.toast-container {\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: $toast-spacing;\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: $toast-padding-y $toast-padding-x;\n  color: $toast-header-color;\n  background-color: $toast-header-background-color;\n  background-clip: padding-box;\n  border-bottom: $toast-border-width solid $toast-header-border-color;\n  @include border-top-radius(subtract($toast-border-radius, $toast-border-width));\n\n  .btn-close {\n    margin-right: $toast-padding-x * -.5;\n    margin-left: $toast-padding-x;\n  }\n}\n\n.toast-body {\n  padding: $toast-padding-x; // apply to both vertical and horizontal\n  word-wrap: break-word;\n}\n","// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex-modal;\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: $modal-dialog-margin;\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: subtract(100%, $modal-dialog-margin * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: subtract(100%, $modal-dialog-margin * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: $modal-content-color;\n  pointer-events: auto;\n  background-color: $modal-content-bg;\n  background-clip: padding-box;\n  border: $modal-content-border-width solid $modal-content-border-color;\n  @include border-radius($modal-content-border-radius);\n  @include box-shadow($modal-content-box-shadow-xs);\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex-modal-backdrop;\n  width: 100vw;\n  height: 100vh;\n  background-color: $modal-backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $modal-backdrop-opacity; }\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends\n  padding: $modal-header-padding;\n  border-bottom: $modal-header-border-width solid $modal-header-border-color;\n  @include border-top-radius($modal-content-inner-border-radius);\n\n  .btn-close {\n    padding: ($modal-header-padding-y * .5) ($modal-header-padding-x * .5);\n    margin: ($modal-header-padding-y * -.5) ($modal-header-padding-x * -.5) ($modal-header-padding-y * -.5) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: $modal-title-line-height;\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: $modal-inner-padding;\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-wrap: wrap;\n  flex-shrink: 0;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: $modal-inner-padding - $modal-footer-margin-between * .5;\n  border-top: $modal-footer-border-width solid $modal-footer-border-color;\n  @include border-bottom-radius($modal-content-inner-border-radius);\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: $modal-footer-margin-between * .5;\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: $modal-md;\n    margin: $modal-dialog-margin-y-sm-up auto;\n  }\n\n  .modal-dialog-scrollable {\n    height: subtract(100%, $modal-dialog-margin-y-sm-up * 2);\n  }\n\n  .modal-dialog-centered {\n    min-height: subtract(100%, $modal-dialog-margin-y-sm-up * 2);\n  }\n\n  .modal-content {\n    @include box-shadow($modal-content-box-shadow-sm-up);\n  }\n\n  .modal-sm { max-width: $modal-sm; }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    max-width: $modal-lg;\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl { max-width: $modal-xl; }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n\n      .modal-footer {\n        @include border-radius(0);\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Base class\n.tooltip {\n  position: absolute;\n  z-index: $zindex-tooltip;\n  display: block;\n  margin: $tooltip-margin;\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size($tooltip-font-size);\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: $tooltip-opacity; }\n\n  .tooltip-arrow {\n    position: absolute;\n    display: block;\n    width: $tooltip-arrow-width;\n    height: $tooltip-arrow-height;\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top {\n  padding: $tooltip-arrow-height 0;\n\n  .tooltip-arrow {\n    bottom: 0;\n\n    &::before {\n      top: -1px;\n      border-width: $tooltip-arrow-height ($tooltip-arrow-width * .5) 0;\n      border-top-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-end {\n  padding: 0 $tooltip-arrow-height;\n\n  .tooltip-arrow {\n    left: 0;\n    width: $tooltip-arrow-height;\n    height: $tooltip-arrow-width;\n\n    &::before {\n      right: -1px;\n      border-width: ($tooltip-arrow-width * .5) $tooltip-arrow-height ($tooltip-arrow-width * .5) 0;\n      border-right-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-bottom {\n  padding: $tooltip-arrow-height 0;\n\n  .tooltip-arrow {\n    top: 0;\n\n    &::before {\n      bottom: -1px;\n      border-width: 0 ($tooltip-arrow-width * .5) $tooltip-arrow-height;\n      border-bottom-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-start {\n  padding: 0 $tooltip-arrow-height;\n\n  .tooltip-arrow {\n    right: 0;\n    width: $tooltip-arrow-height;\n    height: $tooltip-arrow-width;\n\n    &::before {\n      left: -1px;\n      border-width: ($tooltip-arrow-width * .5) 0 ($tooltip-arrow-width * .5) $tooltip-arrow-height;\n      border-left-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: $tooltip-max-width;\n  padding: $tooltip-padding-y $tooltip-padding-x;\n  color: $tooltip-color;\n  text-align: center;\n  background-color: $tooltip-bg;\n  @include border-radius($tooltip-border-radius);\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  white-space: normal;\n  line-break: auto;\n}\n",".popover {\n  position: absolute;\n  top: 0;\n  left: 0 #{\"/* rtl:ignore */\"};\n  z-index: $zindex-popover;\n  display: block;\n  max-width: $popover-max-width;\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size($popover-font-size);\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: $popover-bg;\n  background-clip: padding-box;\n  border: $popover-border-width solid $popover-border-color;\n  @include border-radius($popover-border-radius);\n  @include box-shadow($popover-box-shadow);\n\n  .popover-arrow {\n    position: absolute;\n    display: block;\n    width: $popover-arrow-width;\n    height: $popover-arrow-height;\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: subtract(-$popover-arrow-height, $popover-border-width);\n\n    &::before {\n      bottom: 0;\n      border-width: $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-top-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      bottom: $popover-border-width;\n      border-width: $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-top-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-end {\n  > .popover-arrow {\n    left: subtract(-$popover-arrow-height, $popover-border-width);\n    width: $popover-arrow-height;\n    height: $popover-arrow-width;\n\n    &::before {\n      left: 0;\n      border-width: ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-right-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      left: $popover-border-width;\n      border-width: ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-right-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: subtract(-$popover-arrow-height, $popover-border-width);\n\n    &::before {\n      top: 0;\n      border-width: 0 ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5);\n      border-bottom-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      top: $popover-border-width;\n      border-width: 0 ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5);\n      border-bottom-color: $popover-arrow-color;\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: $popover-arrow-width;\n    margin-left: -$popover-arrow-width * .5;\n    content: \"\";\n    border-bottom: $popover-border-width solid $popover-header-bg;\n  }\n}\n\n.bs-popover-start {\n  > .popover-arrow {\n    right: subtract(-$popover-arrow-height, $popover-border-width);\n    width: $popover-arrow-height;\n    height: $popover-arrow-width;\n\n    &::before {\n      right: 0;\n      border-width: ($popover-arrow-width * .5) 0 ($popover-arrow-width * .5) $popover-arrow-height;\n      border-left-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      right: $popover-border-width;\n      border-width: ($popover-arrow-width * .5) 0 ($popover-arrow-width * .5) $popover-arrow-height;\n      border-left-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: $popover-header-padding-y $popover-header-padding-x;\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size($font-size-base);\n  color: $popover-header-color;\n  background-color: $popover-header-bg;\n  border-bottom: $popover-border-width solid $popover-border-color;\n  @include border-top-radius($popover-inner-border-radius);\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: $popover-body-padding-y $popover-body-padding-x;\n  color: $popover-body-color;\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n/* rtl:begin:ignore */\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n/* rtl:end:ignore */\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n/* rtl:options: {\n  \"autoRename\": true,\n  \"stringMap\":[ {\n    \"name\"    : \"prev-next\",\n    \"search\"  : \"prev\",\n    \"replace\" : \"next\"\n  } ]\n} */\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg);\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg);\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-bs-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n  list-style: none;\n\n  [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n\n// Dark mode carousel\n\n.carousel-dark {\n  .carousel-control-prev-icon,\n  .carousel-control-next-icon {\n    filter: $carousel-dark-control-icon-filter;\n  }\n\n  .carousel-indicators [data-bs-target] {\n    background-color: $carousel-dark-indicator-active-bg;\n  }\n\n  .carousel-caption {\n    color: $carousel-dark-caption-color;\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","//\n// Rotating border\n//\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  display: inline-block;\n  width: $spinner-width;\n  height: $spinner-height;\n  vertical-align: $spinner-vertical-align;\n  border: $spinner-border-width solid currentColor;\n  border-right-color: transparent;\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: $spinner-animation-speed linear infinite spinner-border;\n}\n\n.spinner-border-sm {\n  width: $spinner-width-sm;\n  height: $spinner-height-sm;\n  border-width: $spinner-border-width-sm;\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  display: inline-block;\n  width: $spinner-width;\n  height: $spinner-height;\n  vertical-align: $spinner-vertical-align;\n  background-color: currentColor;\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  opacity: 0;\n  animation: $spinner-animation-speed linear infinite spinner-grow;\n}\n\n.spinner-grow-sm {\n  width: $spinner-width-sm;\n  height: $spinner-height-sm;\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      animation-duration: $spinner-animation-speed * 2;\n    }\n  }\n}\n",".offcanvas {\n  position: fixed;\n  bottom: 0;\n  z-index: $zindex-offcanvas;\n  display: flex;\n  flex-direction: column;\n  max-width: 100%;\n  color: $offcanvas-color;\n  visibility: hidden;\n  background-color: $offcanvas-bg-color;\n  background-clip: padding-box;\n  outline: 0;\n  @include box-shadow($offcanvas-box-shadow);\n  @include transition(transform $offcanvas-transition-duration ease-in-out);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: $offcanvas-padding-y $offcanvas-padding-x;\n\n  .btn-close {\n    padding: ($offcanvas-padding-y * .5) ($offcanvas-padding-x * .5);\n    margin-top: $offcanvas-padding-y * -.5;\n    margin-right: $offcanvas-padding-x * -.5;\n    margin-bottom: $offcanvas-padding-y * -.5;\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: $offcanvas-title-line-height;\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: $offcanvas-padding-y $offcanvas-padding-x;\n  overflow-y: auto;\n}\n\n.offcanvas-start {\n  top: 0;\n  left: 0;\n  width: $offcanvas-horizontal-width;\n  border-right: $offcanvas-border-width solid $offcanvas-border-color;\n  transform: translateX(-100%);\n}\n\n.offcanvas-end {\n  top: 0;\n  right: 0;\n  width: $offcanvas-horizontal-width;\n  border-left: $offcanvas-border-width solid $offcanvas-border-color;\n  transform: translateX(100%);\n}\n\n.offcanvas-top {\n  top: 0;\n  right: 0;\n  left: 0;\n  height: $offcanvas-vertical-height;\n  max-height: 100%;\n  border-bottom: $offcanvas-border-width solid $offcanvas-border-color;\n  transform: translateY(-100%);\n}\n\n.offcanvas-bottom {\n  right: 0;\n  left: 0;\n  height: $offcanvas-vertical-height;\n  max-height: 100%;\n  border-top: $offcanvas-border-width solid $offcanvas-border-color;\n  transform: translateY(100%);\n}\n\n.offcanvas.show {\n  transform: none;\n}\n","$gray-200: #e9ecef !default;\n$jumbotron-padding:                 2rem !default;\n$jumbotron-bg:                      $gray-200 !default;\n\n.jumbotron {\n  padding: $jumbotron-padding ($jumbotron-padding * 0.5);\n  margin-bottom: $jumbotron-padding;\n  background-color: $jumbotron-bg;\n  @include border-radius($border-radius-lg);\n\n  @include media-breakpoint-up(sm) {\n    padding: ($jumbotron-padding * 2) $jumbotron-padding;\n  }\n}\n\n.jumbotron-fluid {\n  padding-right: 0;\n  padding-left: 0;\n  @include border-radius(0);\n}\n","@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: $value;\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage));\n      }\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$variable-prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$variable-prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://hugogiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix, $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (eg. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n      .#{$property-class + $infix + $property-class-modifier} {\n        @each $property in $properties {\n          #{$property}: $value if($enable-important-utilities, !important, null);\n        }\n      }\n\n      @each $pseudo in $state {\n        .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n          @each $property in $properties {\n            #{$property}: $value if($enable-important-utilities, !important, null);\n          }\n        }\n      }\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n","// General\n\na,\nbutton,\n.btn {\n  outline: none !important;\n}\n\n.app-container {\n  display: flex;\n  min-height: 100vh;\n  flex-direction: column;\n  margin: 0;\n}","// Sidebar Animation\n\n.SidebarAnimation-appear {\n  transform: translateX(-30px);\n  opacity: 0;\n\n  &.SidebarAnimation-appear-active {\n    opacity: 1;\n    transform: translateX(0);\n    transition: all .4s linear;\n  }\n}\n\n// Tabs Animation\n\n.TabsAnimation-appear {\n  @extend .animated;\n  @extend .fadeInUp;\n}\n\n// Header Animation\n\n.HeaderAnimation-appear {\n  transform: translateY(-30px);\n  opacity: 0;\n\n  &.HeaderAnimation-appear-active {\n    opacity: 1;\n    transform: translateY(0);\n    transition: all .4s linear;\n  }\n}\n\n// Main Animation\n\n.MainAnimation-appear {\n  transform: translateY(-30px);\n  opacity: 0;\n\n  &.MainAnimation-appear-active {\n    opacity: 1;\n    transform: translateY(0);\n    transition: all .4s linear;\n  }\n}","// Header Base\n\n.app-header {\n  height: $app-header-height;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  position: relative;\n  z-index: 10;\n  transition: all .2s;\n\n  &.header-shadow {\n    box-shadow: $box-shadow-default;\n  }\n\n  .app-header__content {\n    display: flex;\n    align-items: center;\n    align-content: center;\n    flex: 1;\n    padding: 0 $layout-spacer-x;\n    height: $app-header-height;\n\n    .app-header-left {\n      display: flex;\n      align-items: center;\n    }\n\n    .app-header-right {\n      align-items: center;\n      display: flex;\n      margin-left: auto;\n    }\n  }\n\n  .header-user-info {\n    & > .widget-heading,\n    & > .widget-subheading {\n      white-space: nowrap;\n    }\n\n    & > .widget-subheading {\n      font-size: $font-size-xs;\n    }\n  }\n}\n\n.app-header__logo {\n  padding: 0 $layout-spacer-x;\n  height: $app-header-height;\n  width: $app-sidebar-width;\n  display: flex;\n  align-items: center;\n  transition: width .2s;\n\n  .logo-src {\n    height: $logo-height;\n    width: $logo-width;\n    background: url('../../../assets/utils/images/Arkos_color_logo\\ 1.svg');\n  }\n}\n\n.app-header__menu,\n.app-header__mobile-menu {\n  display: none;\n  padding: 0 $layout-spacer-x;\n  height: $app-header-height;\n  align-items: center;\n}\n\n// Header Modifiers\n\n@import \"modifiers/fixed-header\";\n@import \"modifiers/header-dots\";\n@import \"modifiers/header-megamenu\";\n@import \"modifiers/header-buttons\";\n//@import \"modifiers/header-horizontal\";\n\n// Header Themes\n\n@import \"themes/header-light\";\n@import \"themes/header-dark\";\n//@import \"themes/header-inverted\";","// Variables\n\n$spacer-lg                      : 3rem;\n$spacer-sm                      : 1.5rem;\n\n$layout-spacer-lg               : 3rem;\n$layout-spacer-x                : 1.5rem;\n\n$app-sidebar-width              : 280px;\n$app-sidebar-width-collapsed    : 80px;\n\n$logo-height                    : 23px;\n$logo-width                     : 97px;\n\n$app-header-height              : 60px;","// Fixed Header\n\n.fixed-header {\n  .app-header {\n    position: fixed;\n    width: 100%;\n    top: 0;\n\n    .app-header__logo {\n      visibility: visible;\n    }\n  }\n\n  .app-main {\n    padding-top: $app-header-height;\n  }\n\n  &:not(.fixed-sidebar):not(.closed-sidebar) {\n    .app-sidebar {\n      .app-header__logo {\n        visibility: hidden;\n      }\n    }\n  }\n}\n\n.check-align-center{\n  display: flex;\n  align-items: center;\n}\n\n.check-column-center{\n  display: flex;\n  justify-content: center;\n}","// Header Dots\n\n.header-dots {\n  margin-left: auto;\n  display: flex;\n\n  & > .dropdown {\n    display: flex;\n    align-content: center;\n  }\n\n  .icon-wrapper-alt {\n    margin: 0;\n    height: 44px;\n    width: 44px;\n    text-align: center;\n    overflow: visible;\n\n    .language-icon {\n      @include border-radius(30px);\n      position: relative;\n      z-index: 4;\n      width: 28px;\n      height: 28px;\n      overflow: hidden;\n      margin: 0 auto;\n\n      img {\n        position: relative;\n        top: 50%;\n        left: 50%;\n        margin: -22px 0 0 -20px;\n      }\n\n    }\n\n    .icon-wrapper-bg {\n      opacity: .1;\n      transition: opacity .2s;\n      @include border-radius(40px);\n    }\n\n    svg {\n      margin: 0 auto;\n    }\n\n    @-moz-document url-prefix() {\n      svg {\n        width: 50%;\n      }\n    }\n\n    i {\n      font-size: 1.3rem;\n    }\n\n    &:hover {\n      cursor: pointer;\n\n      .icon-wrapper-bg {\n        opacity: .2;\n      }\n    }\n\n    .badge-dot {\n      top: 1px;\n      right: 1px;\n      border: 0;\n    }\n  }\n}","// Header Mega Menu\n\n@use \"sass:math\";\n\n.header-megamenu {\n  &.nav {\n    & > li > .nav-link {\n      color: $gray-600;\n      padding-left: math.div($nav-link-padding-x, 1.5);\n      padding-right: math.div($nav-link-padding-x, 1.5);\n\n      .rounded-pill {\n        padding: 5px 7px;\n      }\n\n      &:hover {\n        color: $gray-800;\n      }\n\n      svg {\n        margin-top: 1px;\n      }\n    }\n  }\n}","\n// Header Buttons\n\n.header-btn-lg {\n  padding: 0 0 0 ($layout-spacer-x);\n  margin-left: ($layout-spacer-x);\n  display: flex;\n  align-items: center;\n  position: relative;\n\n  /*&::before {\n    position: absolute;\n    left: -1px;\n    top: 50%;\n    background: $border-color;\n    width: 1px;\n    height: 30px;\n    margin-top: -15px;\n    content: '';\n  }*/\n\n  .hamburger-inner,\n  .hamburger-inner::before,\n  .hamburger-inner::after {\n    background: $gray-600;\n  }\n\n}","// Header Light\n\n.app-header {\n  &.header-text-light {\n    .app-header-left > .nav > li > .nav-link {\n      color: rgba(255, 255, 255, .7);\n\n      .nav-link-icon {\n        color: rgba(255, 255, 255, .8);\n      }\n\n      &:hover {\n        color: rgba(255, 255, 255, 1);\n      }\n    }\n\n    .app-header-right {\n      .icon-wrapper-alt {\n\n        svg {\n          fill: rgba(255, 255, 255, .7);\n          transition: all .2s;\n        }\n\n        .icon-wrapper-bg {\n          background: rgba(255, 255, 255, .1) !important;\n          transition: all .2s;\n          opacity: 1;\n        }\n\n        &:hover {\n          svg {\n            fill: rgba(255, 255, 255, .95);\n          }\n\n          .icon-wrapper-bg {\n            background: rgba(255, 255, 255, .15) !important;\n          }\n        }\n\n        .badge-dot {\n          border-color: transparent;\n        }\n      }\n\n      & > .header-btn-lg {\n\n        & .widget-content-left .btn-group > .btn-link,\n        .widget-heading,\n        .widget-subheading {\n          color: rgba(255, 255, 255, .8);\n        }\n\n        .header-user-info {\n          & > .btn-shadow {\n            box-shadow: 0 0.125rem 0.625rem rgba(0, 0, 0, .1), 0 0.0625rem 0.125rem rgba(0, 0, 0, .2);\n          }\n        }\n      }\n    }\n\n    .search-wrapper {\n      .input-holder {\n        .search-icon {\n          background: rgba(0, 0, 0, .1);\n        }\n\n        .search-input {\n          &::placeholder,\n          &::-webkit-input-placeholder,\n          &:-ms-input-placeholder,\n          &:-moz-placeholder,\n          &::-moz-placeholder {\n            color: rgba(255, 255, 255, .5) !important;\n          }\n        }\n      }\n\n      &.active {\n        .input-holder {\n          background: rgba(255, 255, 255, .1);\n\n          .search-input {\n            color: rgba(255, 255, 255, .8);\n          }\n\n          .search-icon {\n            background: rgba(255, 255, 255, .1);\n          }\n        }\n      }\n    }\n\n    .header-btn-lg {\n      &::before {\n        background: rgba(255, 255, 255, .2);\n      }\n    }\n\n    .header-btn-lg,\n    .header__pane {\n      .hamburger-inner,\n      .hamburger.is-active .hamburger-inner,\n      .hamburger-inner::before,\n      .hamburger-inner::after {\n        background-color: rgba(255, 255, 255, .8) !important;\n      }\n    }\n\n    .search-wrapper .input-holder .search-icon span::after {\n      border-color: rgba(255, 255, 255, .8);\n    }\n\n    .search-wrapper .close::before,\n    .search-wrapper .close::after,\n    .search-wrapper .input-holder .search-icon span::before {\n      background: rgba(255, 255, 255, .8);\n    }\n\n    .app-header__logo {\n      .logo-src {\n        background: url('../../../../assets/utils/images/Arkos_color_logo\\ 1.svg');\n      }\n    }\n\n    .app-header__mobile-menu {\n      .hamburger-inner,\n      .hamburger-inner::before,\n      .hamburger-inner::after {\n        background: rgba(255, 255, 255, .9);\n      }\n    }\n\n  }\n\n}","// Header Dark\n\n.app-header {\n  &.header-text-dark {\n    .app-header-left > .nav > li > .nav-link {\n      color: rgba(0,0,0,.7);\n\n      .nav-link-icon {\n        color: rgba(0, 0, 0, .8);\n      }\n\n      &:hover {\n        color: rgba(0,0,0,1);\n      }\n    }\n\n    .app-header-right {\n      .icon-wrapper-alt {\n\n        svg {\n          fill: rgba(0,0,0,.7);\n          transition: all .2s;\n        }\n\n        .icon-wrapper-bg {\n          background: rgba(0,0,0,.1) !important;\n          transition: all .2s;\n          opacity: 1;\n        }\n\n        &:hover {\n          svg {\n            fill: rgba(0,0,0,.95);\n          }\n\n          .icon-wrapper-bg {\n            background: rgba(0,0,0,.15) !important;\n          }\n        }\n\n        .badge-dot {\n          border-color: transparent;\n        }\n      }\n\n      .widget-content-left {\n\n        & > .btn-group > .btn-link,\n        .widget-heading,\n        .widget-subheading {\n          color: rgba(0,0,0,.8);\n        }\n      }\n    }\n\n    .search-wrapper {\n      .input-holder {\n        .search-icon {\n          background: rgba(0,0,0,.1);\n        }\n      }\n\n      &.active {\n        .input-holder {\n          background: rgba(0,0,0,.1);\n\n          .search-input {\n            color: rgba(0,0,0,.8);\n          }\n\n          .search-icon {\n            background: rgba(0,0,0,.1);\n          }\n        }\n      }\n    }\n\n    .header-btn-lg {\n      &::before {\n        background: rgba(0,0,0,.2);\n      }\n    }\n\n    .header-btn-lg,\n    .header__pane {\n      .hamburger-inner,\n      .hamburger.is-active .hamburger-inner,\n      .hamburger-inner::before,\n      .hamburger-inner::after {\n        background-color: rgba(0, 0, 0, .8) !important;\n      }\n    }\n\n    .search-wrapper .input-holder .search-icon span::after {\n      border-color: rgba(0, 0, 0, .8);\n    }\n\n    .search-wrapper .close::before,\n    .search-wrapper .close::after,\n    .search-wrapper .input-holder .search-icon span::before {\n      background: rgba(0, 0, 0, .8);\n    }\n\n    .app-header__logo {\n      .logo-src {\n        background: url('../../../../assets/utils/images/arkosLogo.png');\n      }\n    }\n\n  }\n\n\n}","// Sidebar Base\n\n@use \"sass:math\";\n\n.app-sidebar {\n  width: $app-sidebar-width;\n  display: flex;\n  z-index: 11;\n  overflow: hidden;\n  min-width: $app-sidebar-width;\n  position: relative;\n  flex: 0 0 $app-sidebar-width;\n  margin-top: -$app-header-height;\n  padding-top: $app-header-height;\n  transition: all .2s;\n\n  .app-sidebar__inner {\n    padding: 10px ($layout-spacer-x) $layout-spacer-x;\n  }\n\n  .scrollbar-container {\n    z-index: 15;\n    width: 100%;\n  }\n\n  .app-sidebar-bg {\n    position: absolute;\n    left: 0;\n    top: 0;\n    height: 100%;\n    width: 100%;\n    opacity: 0.05;\n    background-size: cover;\n    z-index: 10;\n  }\n\n  .app-header__logo {\n    position: absolute;\n    left: 0;\n    top: 0;\n    display: none;\n    z-index: 11;\n  }\n\n  &.sidebar-shadow {\n    box-shadow: 7px 0 60px rgba(0, 0, 0, 0.05);\n  }\n}\n\n.app-sidebar__heading {\n  text-transform: uppercase;\n  font-size: $font-size-xs;\n  margin: math.div($layout-spacer-x, 2) 0;\n  font-weight: bold;\n  color: $primary;\n  white-space: nowrap;\n  position: relative;\n}\n\n.sidebar-mobile-overlay {\n  display: none;\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  background: #333;\n  opacity: .6;\n  left: 0;\n  top: 0;\n  z-index: 12;\n}\n\n// Sidebar Components\n\n@import \"modifiers/navmenu-vertical\";\n\n// Sidebar Modifiers\n\n@import \"themes/sidebar-light\";\n@import \"themes/sidebar-dark\";\n//@import \"themes/sidebar-inverted\";\n\n\n@import \"modifiers/fixed-sidebar\";\n@import \"modifiers/closed-sidebar\";\n","// Navigation Menu Vertical\n\n.vertical-nav-menu {\n  position: relative;\n\n  &::after {\n    content: \" \";\n    pointer-events: none;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    top: 0;\n  }\n\n  .metismenu-container,\n  .metismenu-item {\n    margin: 0;\n    padding: 0;\n    position: relative;\n  }\n  .metismenu-container {\n    list-style: none;\n\n    &:before {\n      opacity: 0;\n      transition: opacity 300ms;\n    }\n\n    .metismenu-link {\n      transition: transform .2s, height 300ms, color 300ms, background-color 300ms;\n      display: block;\n      line-height: 2.5rem;\n      height: 2.5rem;\n      padding: 0 $layout-spacer-x 0 45px;\n      position: relative;\n      @include border-radius($border-radius);\n      color: $gray-800;\n      white-space: nowrap;\n\n      &:hover {\n        background: $dropdown-link-hover-bg;\n        text-decoration: none;\n        //transform: scale(1.02);\n\n        i.metismenu-icon {\n          opacity: .6;\n        }\n\n        i.metismenu-state-icon {\n          opacity: 1;\n        }\n      }\n\n      &.active {\n        color: $primary;\n        background: $dropdown-link-hover-bg;\n      }\n\n      &.has-active-child,\n      &.active {\n        font-weight: bold;\n      }\n    }\n\n    i.metismenu-state-icon,\n    i.metismenu-icon {\n      text-align: center;\n      width: 34px;\n      height: 34px;\n      line-height: 34px;\n      position: absolute;\n      left: 5px;\n      top: 50%;\n      margin-top: -17px;\n      font-size: 1.5rem;\n      opacity: .3;\n      transition: color 300ms;\n    }\n\n    i.metismenu-state-icon {\n      transition: transform 300ms;\n      left: auto;\n      right: 0;\n\n      &.rotate-minus-90 {\n        transform: rotate(-180deg);\n      }\n    }\n\n    .metismenu-container {\n      transition: padding 300ms;\n\n      &.visible {\n        padding: .5em 0 0 2rem;\n\n        &:before {\n          content: '';\n          height: 100%;\n          opacity: 1;\n          width: 3px;\n          background: $dropdown-link-hover-bg;\n          position: absolute;\n          left: 20px;\n          top: 0;\n          @include border-radius(15px);\n        }\n\n        & > .metismenu-item > .metismenu-link {\n          height: 2.3em;\n          line-height: 2.3em;\n          color: $gray-600;\n          margin: 0 0 3px;\n\n          &:hover {\n            color: $primary;\n          }\n\n          .metismenu-icon {\n            display: none;\n          }\n\n          &.active {\n            color: $primary;\n            background: $dropdown-link-hover-bg;\n          }\n        }\n      }\n\n      .metismenu-item > .metismenu-link {\n        height: 0;\n        overflow: hidden;\n      }\n\n      .metismenu-link {\n        padding-left: 1em;\n      }\n    }\n  }\n}\n","// Sidebar Light\n\n.app-sidebar {\n  &.sidebar-text-light {\n    border-right: 0 !important;\n\n    .app-sidebar__heading {\n      color: rgba(255, 255, 255, .6);\n\n      &::before {\n        background: rgba(255, 255, 255, 0.2) !important;\n      }\n    }\n\n    .metismenu {\n      .metismenu-container {\n        .metismenu-link {\n          color: rgba(255, 255, 255, .7);\n\n          &:hover {\n            color: rgba(255, 255, 255, 1);\n            background: rgba(255, 255, 255, .1);\n          }\n\n          &.active {\n            background: rgba(255, 255, 255, .1);\n          }\n        }\n\n        &.metismenu-container {\n          &.visible {\n            .metismenu-item > .metismenu-link {\n              color: rgba(255, 255, 255, .6);\n\n              &.active {\n                background: rgba(255, 255, 255, .1);\n                color: rgba(255, 255, 255, .8);\n              }\n\n              &:hover {\n                color: rgba(255, 255, 255, 1);\n              }\n\n            }\n\n            &::before {\n              background: rgba(255, 255, 255, .3);\n            }\n          }\n        }\n\n        i.metismenu-state-icon,\n        i.metismenu-icon {\n          opacity: .5;\n        }\n      }\n    }\n\n    .ps__thumb-y {\n      background: rgba(255, 255, 255, .3);\n    }\n\n    .ps__rail-y:hover {\n      .ps__thumb-y {\n        background: rgba(255, 255, 255, .2);\n      }\n    }\n\n    .app-header__logo {\n      .logo-src {\n        background: url('../../../../assets/utils/images/arkosLogo.png');\n      }\n\n      .hamburger-inner,\n      .hamburger-inner::before,\n      .hamburger-inner::after {\n        background-color: rgba(255, 255, 255, .8);\n      }\n    }\n  }\n}","// Sidebar Light\n\n.app-sidebar {\n  &.sidebar-text-dark {\n    border-right: 0 !important;\n\n    .app-sidebar__heading {\n      color: rgba(0, 0, 0, .6);\n\n      &::before {\n        background: rgba(0, 0, 0, 0.5) !important;\n      }\n    }\n\n    .metismenu {\n      .metismenu-container {\n        .metismenu-link {\n          color: rgba(0, 0, 0, .7);\n\n          &:hover {\n            color: rgba(0, 0, 0, 1);\n            background: rgba(0, 0, 0, .1);\n          }\n\n          &.active {\n            background: rgba(0, 0, 0, .1);\n          }\n        }\n\n        &.metismenu-container {\n          &.visible {\n            .metismenu-item > .metismenu-link {\n              color: rgba(0, 0, 0, .6);\n\n              &.active {\n                background: rgba(0, 0, 0, .1);\n              }\n            }\n\n            &::before {\n              background: rgba(0, 0, 0, .3);\n            }\n          }\n\n          i.metismenu-state-icon,\n          i.metismenu-icon {\n            opacity: .5;\n          }\n        }\n      }\n    }\n\n    .ps__thumb-y {\n      background: rgba(0, 0, 0, .3);\n    }\n\n    .ps__rail-y:hover {\n      .ps__thumb-y {\n        background: rgba(0, 0, 0, .2);\n      }\n    }\n\n    .app-header__logo {\n\n      .hamburger-inner,\n      .hamburger-inner::before,\n      .hamburger-inner::after {\n        background-color: rgba(0, 0, 0, .8);\n      }\n    }\n  }\n}","// Fixed Sidebar\n\n.fixed-sidebar {\n  .app-sidebar {\n    position: fixed;\n    height: 100vh;\n  }\n\n  .app-main {\n\n    .app-main__outer {\n      z-index: 9;\n      padding-left: $app-sidebar-width;\n    }\n\n  }\n\n  &.fixed-header {\n    .app-sidebar {\n      .app-header__logo {\n        display: none;\n      }\n    }\n  }\n\n  &:not(.fixed-header) {\n    .app-sidebar {\n      .app-header__logo {\n        display: flex;\n      }\n    }\n\n    .app-header {\n\n      margin-left: $app-sidebar-width;\n\n      .app-header__logo {\n        display: none;\n      }\n    }\n\n    .app-main {\n      //z-index: 12;\n    }\n  }\n\n  &.closed-sidebar {\n    &:not(.fixed-header) {\n\n      .app-header {\n        margin-left: $app-sidebar-width-collapsed;\n      }\n\n      .app-sidebar {\n\n        .app-header__logo {\n          width: $app-sidebar-width-collapsed;\n          padding: 0;\n\n          .logo-src {\n            display: none;\n          }\n\n          .header__pane {\n            margin-right: auto;\n          }\n        }\n      }\n    }\n  }\n}","// Closed Sidebar\n\n// Sidebar Menu Hover\n\n.closed-sidebar {\n  .app-sidebar {\n    transition: all .3s ease;\n    width: $app-sidebar-width-collapsed;\n    min-width: $app-sidebar-width-collapsed;\n    flex: 0 0 $app-sidebar-width-collapsed;\n    z-index: 13;\n\n    .app-sidebar__inner {\n\n      .app-sidebar__heading {\n        text-indent: -999em;\n\n        &::before {\n          content: '';\n          position: absolute;\n          top: 50%;\n          left: 0;\n          width: 100%;\n          height: 1px;\n          background: $dropdown-link-hover-bg;\n          text-indent: 1px;\n        }\n      }\n\n      .metismenu-link {\n        text-indent: -99rem;\n        padding: 0;\n      }\n\n      .metismenu-icon {\n        text-indent: 0;\n        left: 50%;\n        margin-left: -17px;\n      }\n\n      .metismenu-state-icon {\n        visibility: hidden;\n      }\n\n      .metismenu-container {\n        &.visible {\n          padding: 0;\n\n          & > .metismenu-item > .metismenu-link {\n            height: 0;\n          }\n        }\n      }\n    }\n\n    &:hover {\n      flex: 0 0 $app-sidebar-width !important;\n      width: $app-sidebar-width !important;\n\n      .app-sidebar__inner {\n\n        .app-sidebar__heading {\n          text-indent: initial;\n          &::before {\n            display: none;\n          }\n        }\n\n        .metismenu-link {\n          text-indent: initial;\n          padding: 0 $layout-spacer-x 0 45px;\n        }\n\n        .metismenu-icon {\n          text-indent: initial;\n          left: 5px;\n          margin-left: 0;\n        }\n\n        .metismenu-state-icon {\n          visibility: visible;\n        }\n\n        .metismenu-container {\n          &.visible {\n            padding: .5em 0 0 2rem;\n\n            & > .metismenu-item > .metismenu-link {\n              height: 2.3em;\n            }\n          }\n\n          .metismenu-container {\n            .metismenu-link {\n              padding-left: 1em;\n            }\n          }\n\n        }\n      }\n    }\n  }\n\n  &:not(.sidebar-mobile-open) {\n\n    .app-sidebar {\n      .scrollbar-container {\n        position: static;\n        height: auto;\n        overflow: initial !important;\n      }\n\n      &:hover {\n        .scrollbar-container {\n          position: absolute;\n          height: 100%;\n          overflow: hidden !important;\n        }\n      }\n    }\n  }\n\n  &:not(.closed-sidebar-mobile) {\n    .app-header {\n      .app-header__logo {\n        width: $app-sidebar-width-collapsed;\n\n        .logo-src {\n          display: none;\n        }\n\n        .header__pane {\n          margin-right: auto;\n        }\n      }\n    }\n\n  }\n\n  &.fixed-sidebar {\n    .app-main__outer {\n      padding-left: $app-sidebar-width-collapsed;\n    }\n  }\n\n  &.fixed-header:not(.fixed-sidebar) {\n    .app-sidebar {\n      .app-header__logo {\n        visibility: hidden;\n      }\n    }\n  }\n\n  &.closed-sidebar-mobile {\n    .app-sidebar,\n    .app-header {\n      .app-header__logo {\n        width: auto;\n        display: flex;\n\n        .header__pane {\n          display: none;\n        }\n      }\n    }\n\n    .app-sidebar {\n      .app-header__logo {\n        display: flex;\n        width: $app-sidebar-width-collapsed;\n        padding: 0 $layout-spacer-x !important;\n\n        .logo-src {\n          display: block !important;\n          margin: 0 auto;\n          width: $logo-width - 76;\n        }\n\n        .header__pane {\n          display: none;\n        }\n      }\n\n      &:hover {\n        .app-header__logo {\n          width: $app-sidebar-width;\n\n          .logo-src {\n            width: $logo-width;\n            margin: 0;\n\n          }\n        }\n      }\n    }\n\n    .app-header {\n      margin-left: 0 !important;\n    }\n  }\n\n  &.fixed-footer {\n    .app-footer__inner {\n      margin-left: 0 !important;\n    }\n  }\n}","// Main Base\n\n@use \"sass:math\";\n\n.app-main {\n  z-index: 8;\n  position: relative;\n  display: flex;\n\n  .app-main__outer {\n    flex: 1;\n    flex-direction: column;\n    display: flex;\n    z-index: 12;\n    width: 1px;\n  }\n\n  .app-main__inner {\n    padding: $grid-gutter-width $grid-gutter-width 0;\n    flex: 1;\n\n    & > .RRT__container {\n      & > .RRT__panel {\n        margin-top: $grid-gutter-width;\n      }\n\n      & > .body-tabs-layout {\n        .RRT__tab {\n          margin-top: (-(math.div($layout-spacer-x, 3)));\n        }\n      }\n    }\n  }\n}\n\n// Alternate Section Tabs\n\n.body-tabs-shadow-btn {\n\n  .app-main__inner {\n    & > .RRT__container {\n      & > .RRT__panel {\n        margin-top: math.div($grid-gutter-width, 1.5);\n      }\n\n      .body-tabs-layout {\n        border: 0;\n        background: transparent;\n        position: relative;\n        z-index: 7;\n\n        .RRT__showmore {\n          margin-top: -13px;\n        }\n\n        .RRT__tab {\n          margin-top: $nav-link-padding-y;\n        }\n\n        .RRT__tab--selected {\n          color: $white;\n        }\n\n        & + .RRT__inkbar-wrapper {\n          position: absolute;\n          top: ($nav-link-padding-y * 2.2);\n          z-index: 5;\n\n          .RRT__inkbar {\n            height: 35px;\n            margin-top: 0;\n            @include border-radius($border-radius);\n            box-shadow:\n                    0 16px 26px -10px rgba($primary, 0.56),\n                    0 4px 25px 0px rgba(0, 0, 0, 0.12),\n                    0 8px 10px -5px rgba($primary, 0.2);\n          }\n        }\n      }\n    }\n  }\n\n\n}\n\n// Themes\n\n@import \"themes/main-white\";\n@import \"themes/main-gray\";\n//@import \"themes/main-inverted-blue\";\n//@import \"themes/main-inverted-black\";\n","// Theme White\n\n// Variables\n\n$app-container-bg: #f1f4f6;\n$app-sidebar-bg: #ffffff;\n$app-header-bg: #fafbfc;\n$app-header-logo-bg: rgba(255, 255, 255, .9);\n\n// Content\n\n.app-theme-white {\n\n  &.app-container {\n    background: $app-container-bg;\n  }\n\n  .app-sidebar {\n    background: $app-sidebar-bg;\n  }\n\n  .app-page-title {\n    background: rgba(255, 255, 255, .55);\n  }\n\n  .app-footer .app-footer__inner,\n  .app-header {\n    background: $app-header-bg;\n  }\n\n  &.fixed-header {\n    .app-header__logo {\n      background: rgba($app-header-bg, .1);\n    }\n  }\n\n}","// Theme Gray\n\n// Variables\n\n$app-container-bg: #ffffff;\n$app-sidebar-bg: #ffffff;\n$app-header-bg: #f8f9fa;\n$app-header-logo-bg: rgba(0, 0, 0, .03);\n\n// Content\n\n.app-theme-gray {\n\n  &.app-container {\n    background: $app-container-bg;\n  }\n\n  .app-sidebar {\n    background: $app-sidebar-bg;\n    border-right: $gray-300 solid 1px;\n  }\n\n  .app-page-title {\n    background: rgba(0, 0, 0, .03);\n  }\n\n  .app-footer,\n  .app-header {\n    background: $app-header-bg;\n  }\n\n  .app-footer {\n    border-top: $gray-300 solid 1px;\n  }\n\n  .app-header {\n    .app-header__logo {\n      border-right: rgba(0, 0, 0, .1) solid 1px;\n    }\n  }\n\n  &.fixed-header {\n    .app-header__logo {\n      background: $app-header-logo-bg;\n    }\n  }\n\n  .card {\n    border-width: 1px;\n  }\n\n  .main-card {\n    box-shadow: 0 0 0 0 transparent !important;\n\n    & > .card-body {\n\n      & > .card-title {\n        text-transform: none;\n        font-size: $font-size-lg;\n        font-weight: normal;\n        border-bottom: $gray-300 solid 1px;\n        position: relative;\n        padding: 0 0 ($card-spacer-y * 1.5);\n        margin: 0 0 ($card-spacer-y * 1.5);\n\n        &::before {\n          position: absolute;\n          width: 40px;\n          background: $primary;\n          @include border-radius(30px);\n          height: 5px;\n          left: 0;\n          bottom: -2px;\n          content: \"\";\n        }\n      }\n    }\n  }\n\n  .app-inner-layout__sidebar {\n    border-left: 0 !important;\n  }\n\n}\n","// Footer base\n\n@use \"sass:math\";\n\n.app-footer {\n  height: $app-header-height;\n\n  .app-footer__inner {\n    padding: 0 $layout-spacer-x 0 math.div($layout-spacer-x, 2);\n    height: $app-header-height;\n    transition: all .2s;\n\n    display: flex;\n    align-content: center;\n    align-items: center;\n\n    .app-footer-left {\n      display: flex;\n      align-items: center;\n    }\n\n    .app-footer-right {\n      margin-left: auto;\n      display: flex;\n    }\n  }\n}\n\n// Footer Dots Section\n\n.footer-dots {\n  display: flex;\n  align-items: center;\n  align-content: center;\n\n  .dots-separator {\n    height: 40px;\n    margin: 0 math.div($layout-spacer-x, 2.5);\n    width: 1px;\n    background: $gray-200;\n  }\n}\n\n.dot-btn-wrapper {\n  padding: .5rem;\n  position: relative;\n  display: flex;\n  opacity: .7;\n  transition: opacity .2s;\n\n  .badge-abs {\n    right: 50%;\n\n    &.badge-dot-sm {\n      top: -2px;\n      margin-right: -3px;\n    }\n  }\n\n  .dot-btn-icon {\n    font-size: 1.8rem;\n  }\n\n  &:hover {\n    text-decoration: none;\n    opacity: 1;\n  }\n}\n\n// Footer Modifiers\n\n@import \"fixed-footer\";\n","// Fixed Header\n\n.fixed-footer {\n  .app-footer {\n    position: fixed;\n    width: 100%;\n    bottom: 0;\n    left: 0;\n    z-index: 7;\n\n    .app-footer__inner {\n      margin-left: $app-sidebar-width;\n      box-shadow: 0.3rem -0.46875rem 2.1875rem rgba(darken($primary, 50%), .02),\n      0.3rem -0.9375rem 1.40625rem rgba(darken($primary, 50%), .02),\n      0.3rem -0.25rem 0.53125rem rgba(darken($primary, 50%), .04),\n      0.3rem -0.125rem 0.1875rem rgba(darken($primary, 50%), .02);\n\n    }\n  }\n\n  .app-main .app-main__outer {\n    padding-bottom: $app-header-height;\n  }\n\n  &.closed-sidebar {\n    .app-footer {\n      .app-footer__inner {\n        margin-left: $app-sidebar-width-collapsed !important;\n      }\n    }\n  }\n\n}\n","// Page title\n\n@use \"sass:math\";\n\n.app-page-title {\n  padding: $grid-gutter-width;\n  margin: (-$grid-gutter-width) (-$grid-gutter-width) ($grid-gutter-width);\n  position: relative;\n\n  .page-title-wrapper {\n    position: relative;\n    display: flex;\n    align-items: center;\n  }\n\n  .page-title-heading,\n  .page-title-subheading {\n    margin: 0;\n    padding: 0;\n  }\n\n  .page-title-heading {\n    font-size: $h5-font-size;\n    font-weight: 400;\n    display: flex;\n    align-content: center;\n    align-items: center;\n  }\n\n  .page-title-subheading {\n    padding: 3px 0 0;\n    font-size: $font-size-base;\n    opacity: .6;\n\n    .breadcrumb {\n      padding: 0;\n      margin: 3px 0 0;\n      background: transparent;\n    }\n  }\n\n  .page-title-actions {\n    margin-left: auto;\n\n    .breadcrumb {\n      margin: 0;\n      padding: 0;\n      background: transparent;\n    }\n  }\n\n  .page-title-icon {\n    font-size: 2rem;\n    display: flex;\n    align-items: center;\n    align-content: center;\n    text-align: center;\n    padding: math.div($layout-spacer-x, 1.8);\n    margin: 0 ($grid-gutter-width) 0 0;\n    background: $white;\n    box-shadow: $box-shadow-default;\n    @include border-radius($border-radius);\n    width: 60px;\n    height: 60px;\n\n    i {\n      margin: auto;\n    }\n\n    &.rounded-circle {\n      margin: 0 math.div($grid-gutter-width, 1.5) 0 0;\n    }\n  }\n\n  & + .RRT__container {\n    margin-top: -(math.div($grid-gutter-width, 1.3));\n  }\n\n  & + .rc-tabs {\n    // to fix width issue in firefox\n    max-width: calc(100vw - 322px);\n    margin: (-($grid-gutter-width)) (-(math.div($grid-gutter-width, 2))) (($grid-gutter-width * 1.3));\n  }\n  @media only screen and (max-width: 812px) and (min-width: 360px)  {\n    & + .rc-tabs {\n      // to fix width issue in firefox\n      max-width: calc(100vw - 0px);\n      margin: (-($grid-gutter-width)) (-(math.div($grid-gutter-width, 2))) (($grid-gutter-width * 1.3));\n    }\n  }\n\n  &.app-page-title-simple {\n    margin: 0;\n    background: none !important;\n    padding-left: 0;\n    padding-right: 0;\n    padding-top: 0;\n  }\n}\n\n.page-title-icon-rounded {\n  .page-title-icon {\n    @include border-radius(50px);\n  }\n}\n\n.closed-sidebar .rc-tabs{\n  max-width: calc(100vw - 140px);\n}\n@media only screen and (max-width: 812px) and (min-width: 360px)  {\n  .closed-sidebar .rc-tabs{\n    max-width: calc(100vw - 0px);\n  }\n}\n\n// Body Tabs\n\n.body-tabs {\n  &.body-tabs-layout {\n    margin-left: -($grid-gutter-width);\n    margin-right: -($grid-gutter-width);\n    padding: 0 $grid-gutter-width;\n    border-top: 0;\n    border-bottom: $gray-300 solid 1px;\n  }\n}\n","// Search Box\n\n@use \"sass:math\";\n\n$search-box-size:     42px;\n\n.search-wrapper {\n  position: relative;\n  margin-right: math.div($nav-link-padding-x, 1.5);\n\n  .input-holder {\n    height: $search-box-size;\n    width: $search-box-size;\n    overflow: hidden;\n    position: relative;\n    transition: all 0.3s ease-in-out;\n\n    .search-input {\n      width: 100%;\n      padding: 0 70px 0 20px;\n      opacity: 0;\n      position: absolute;\n      top: 0;\n      left: 0;\n      background: transparent;\n      box-sizing: border-box;\n      border: none;\n      outline: none;\n      transform: translate(0, 60px);\n      transition: all .3s cubic-bezier(0.000, 0.105, 0.035, 1.570);\n      transition-delay: 0.3s;\n      font-size: $font-size-base;\n    }\n\n    .search-icon {\n      width: $search-box-size;\n      height: $search-box-size;\n      border: none;\n      padding: 0;\n      outline: none;\n      position: relative;\n      z-index: 2;\n      float: right;\n      cursor: pointer;\n      transition: all 0.3s ease-in-out;\n      background: rgba(0,0,0,.06);\n      @include border-radius(30px);\n\n      span {\n        width: 22px;\n        height: 22px;\n        display: inline-block;\n        vertical-align: middle;\n        position: relative;\n        transform: rotate(45deg);\n        transition: all .4s cubic-bezier(0.650, -0.600, 0.240, 1.650);\n\n        &::before,\n        &::after {\n          position: absolute;\n          content: '';\n        }\n\n        &::before {\n          width: 4px;\n          height: 11px;\n          left: 9px;\n          top: 13px;\n          border-radius: 2px;\n          background: $primary;\n        }\n\n        &::after {\n          width: 14px;\n          height: 14px;\n          left: 4px;\n          top: 0;\n          border-radius: 16px;\n          border: 2px solid $primary;\n        }\n      }\n    }\n  }\n\n  .btn-close {\n    position: absolute;\n    z-index: 1;\n    top: 50%;\n    left: 0;\n    width: 20px;\n    height: 20px;\n    margin-top: -10px;\n    cursor: pointer;\n    opacity: 0 !important;\n    // transform: rotate(-180deg);\n    transition: all .2s cubic-bezier(0.285, -0.450, 0.935, 0.110);\n    transition-delay: 0.1s;\n\n    &::before,\n    &::after {\n      position: absolute;\n      background: $primary;\n      border-radius: 2px;\n    }\n\n    &::before {\n      width: 2px;\n      height: 20px;\n      left: 9px;\n      top: 0;\n    }\n\n    &::after {\n      width: 20px;\n      height: 2px;\n      left: 0;\n      top: 9px;\n    }\n  }\n\n  &.active {\n    width: 330px;\n\n    .input-holder {\n      width: 290px;\n      border-radius: 50px;\n      background: rgba(0, 0, 0, 0.05);\n      transition: all .5s cubic-bezier(0.000, 0.105, 0.035, 1.570);\n\n      .search-input {\n        opacity: 1;\n        transform: translate(0, 11px);\n      }\n\n      .search-icon {\n        width: $search-box-size;\n        height: $search-box-size;\n        margin: 0;\n        border-radius: 30px;\n\n        span {\n          transform: rotate(-45deg);\n        }\n      }\n    }\n\n    .btn-close {\n      left: 300px;\n      opacity: .6 !important;\n      // transform: rotate(45deg);\n      transition: all .6s cubic-bezier(0.000, 0.105, 0.035, 1.570);\n      transition-delay: 0.5s;\n\n      &:hover {\n        opacity: 1 !important;\n      }\n    }\n\n    & + .header-megamenu {\n      opacity: 0;\n    }\n\n  }\n}","\n// Opacity\n\n.opacity-01 {\n  opacity: .01 !important;\n}\n\n.opacity-02 {\n  opacity: .02 !important;\n}\n\n.opacity-03 {\n  opacity: .03 !important;\n}\n\n.opacity-04 {\n  opacity: .04 !important;\n}\n\n.opacity-05 {\n  opacity: .05 !important;\n}\n\n.opacity-06 {\n  opacity: .06 !important;\n}\n\n.opacity-07 {\n  opacity: .07 !important;\n}\n\n.opacity-08 {\n  opacity: .08 !important;\n}\n\n.opacity-09 {\n  opacity: .09 !important;\n}\n\n.opacity-1 {\n  opacity: .1 !important;\n}\n\n.opacity-15 {\n  opacity: .15 !important;\n}\n\n.opacity-2 {\n  opacity: .2 !important;\n}\n\n.opacity-3 {\n  opacity: .3 !important;\n}\n\n.opacity-4 {\n  opacity: .4 !important;\n}\n\n.opacity-5 {\n  opacity: .5 !important;\n}\n\n.opacity-6 {\n  opacity: .6 !important;\n}\n\n.opacity-7 {\n  opacity: .7 !important;\n}\n\n.opacity-8 {\n  opacity: .8 !important;\n}\n\n.opacity-9 {\n  opacity: .9 !important;\n}\n\n.opacity-10 {\n  opacity: 1 !important;\n}","// Grayscale Filter\n\n.filter-grayscale-5 {\n  filter: grayscale(5%) !important;\n}\n\n.filter-grayscale-10 {\n  filter: grayscale(10%) !important;\n}\n\n.filter-grayscale-20 {\n  filter: grayscale(20%) !important;\n}\n\n.filter-grayscale-30 {\n  filter: grayscale(30%) !important;\n}\n\n.filter-grayscale-40 {\n  filter: grayscale(40%) !important;\n}\n\n.filter-grayscale-50 {\n  filter: grayscale(50%) !important;\n}\n\n.filter-grayscale-80 {\n  filter: grayscale(80%) !important;\n}\n\n.filter-grayscale-100 {\n  filter: grayscale(100%) !important;\n}","// Helpers imports\n@import \"helpers/opacity\";\n@import \"helpers/grayscale\";\n\n// Resets\n\n.br-tl {\n  border-top-left-radius: $border-radius !important;\n}\n\n.br-tr {\n  border-top-right-radius: $border-radius !important;\n}\n\n.br-bl {\n  border-bottom-left-radius: $border-radius !important;\n}\n\n.br-br {\n  border-bottom-right-radius: $border-radius !important;\n}\n\n.b-radius-0 {\n  border-radius: 0 !important;\n}\n\n.rm-border {\n  border-width: 0 !important;\n}\n\n.br-a {\n  @include border-radius($border-radius);\n}\n\n// Center Elements\n\n.margin-h-center {\n  margin-left: auto !important;\n  margin-right: auto !important;\n}\n\n.center-svg {\n  margin: 0 auto;\n\n  svg {\n    margin: 0 auto;\n  }\n}\n\n.apexcharts-canvas {\n  margin: 0 auto;\n}\n\n.apexcharts-donut {\n  display: flex;\n  align-items: center;\n  align-content: center;\n}\n\n.alert-dismissible {\n  .close {\n    top: 0;\n    right: 5px;\n    padding: 5px;\n  }\n}\n\n// Gradient Icons\n\n.icon-gradient {\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  text-fill-color: transparent;\n}\n\n// Font sizes\n\n.font-size-xlg {\n  font-size: 1.3rem !important;\n}\n\n.font-size-md {\n  font-size: .9rem !important;\n}\n\n.font-size-lg {\n  font-size: 1.1rem !important;\n}\n\n// No Shadow\n\n.no-shadow {\n  box-shadow: 0 0 0 transparent !important;\n}\n\n// Layout\n\n.h-100 {\n  height: 100vh !important;\n}\n\n.he-auto {\n  height: auto !important;\n}\n\n.he-100 {\n  height: 100%;\n}\n\n.h-sm {\n  height: 150px;\n}\n\n.text-nowrap {\n  white-space: nowrap;\n}\n\n// Font size\n\n.fsize-1 {\n  font-size: .95rem !important;\n}\n\n.fsize-2 {\n  font-size: 1.3rem !important;\n}\n\n.fsize-3 {\n  font-size: 1.6rem !important;\n}\n\n.fsize-4 {\n  font-size: 2rem !important;\n}\n\n.z-index-6 {\n  z-index: 6;\n}\n\n.line-height-1 {\n  line-height: 1;\n}\n\n// Center element\n\n.center-elem {\n  display: flex;\n  align-items: center;\n  align-content: center;\n}\n\n.flex2 {\n  flex: 2;\n}\n\n// Divider\n\n.divider {\n  margin-top: $spacer;\n  margin-bottom: $spacer;\n  height: 1px;\n  overflow: hidden;\n  background: $gray-200;\n}\n\n.list-group-item:hover {\n  z-index: initial;\n}\n\n// No Results\n\n.no-results {\n  padding: ($spacer * 1.5);\n  text-align: center;\n\n  .results-title {\n    color: $gray-700;\n    font-size: $h5-font-size;\n  }\n\n  .results-subtitle {\n    color: $gray-500;\n    font-size: $font-size-lg;\n  }\n}\n\n// Background Color Animation\n\n.bg-animation {\n  animation: bg-pan-left 8s both;\n}\n\n@-webkit-keyframes bg-pan-left {\n  0% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n}\n\n@keyframes bg-pan-left {\n  0% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n}\n\n// Width 100%\n\n.w-100 {\n  width: 100%;\n}\n\n.mb--2 {\n  margin-bottom: -1.5rem;\n}\n\n// Margins\n\n.mbg-3 {\n  margin-bottom: $grid-gutter-width;\n}\n\n// Loader\n\n.loader-container {\n  align-items: center;\n  display: flex;\n  height: 100vh;\n  justify-content: center;\n  width: 100vw;\n  text-align: center;\n  line-height: 1.6rem;\n\n  .loader-container-inner {\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    padding: 0 $layout-spacer-x;\n  }\n\n  small {\n    margin: 10px 0 0;\n    display: block;\n    color: $gray-600;\n    font-weight: normal;\n  }\n\n  h3 {\n    text-align: center;\n    display: block;\n  }\n}\n\n.btn-info, .btn-success {\n  color:#fff !important;\n}\n\n.bg-warning {\n  color: #212529;\n}\n\n.list-group-item {\n  border: 1px solid rgba(0,0,0,0.125);\n}\n\n.btn-link, a {\n  text-decoration: none !important;\n}\n\n.bg-light {\n  color: #212529;\n  // background: #fff;\n}\n\n.table {\n  --bs-table-accent-bg: none;\n}\n\n.form-check-input-custom {\n  width: 1rem;\n  height: 1rem;\n}","// Gradients\n\n.bg-warm-flame {\n  background-image: linear-gradient(45deg, #ff9a9e 0%, #fad0c4 99%, #fad0c4 100%) !important;\n}\n\n.bg-night-fade {\n  background-image: linear-gradient(to top, #a18cd1 0%, #fbc2eb 100%) !important;\n}\n\n.bg-sunny-morning {\n  background-image: linear-gradient(120deg, #f6d365 0%, #fda085 100%) !important;\n}\n\n.bg-tempting-azure {\n  background-image: linear-gradient(120deg, #84fab0 0%, #8fd3f4 100%) !important;\n}\n\n.bg-amy-crisp {\n  background-image: linear-gradient(120deg, #a6c0fe 0%, #f68084 100%) !important;\n}\n\n.bg-heavy-rain {\n  background-image: linear-gradient(to top, #cfd9df 0%, #e2ebf0 100%) !important;\n}\n\n.bg-mean-fruit {\n  background-image: linear-gradient(120deg, #fccb90 0%, #d57eeb 100%) !important;\n}\n\n.bg-malibu-beach {\n  background-image: linear-gradient(to right, #4facfe 0%, #00f2fe 100%) !important;\n}\n\n.bg-deep-blue {\n  background-image: linear-gradient(120deg, #e0c3fc 0%, #8ec5fc 100%) !important;\n}\n\n.bg-ripe-malin {\n  background-image: linear-gradient(120deg, #f093fb 0%, #f5576c 100%) !important;\n}\n\n.bg-arielle-smile {\n  background-image: radial-gradient(circle 248px at center, #16d9e3 0%, #30c7ec 47%, #46aef7 100%) !important;\n}\n\n.bg-plum-plate {\n  background-image: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;\n}\n\n.bg-happy-fisher {\n  background-image: linear-gradient(120deg, #89f7fe 0%, #66a6ff 100%) !important;\n}\n\n.bg-happy-itmeo {\n  background-image: linear-gradient(180deg, #2af598 0%, #009efd 100%) !important;\n}\n\n.bg-mixed-hopes {\n  background-image: linear-gradient(to top, #c471f5 0%, #fa71cd 100%) !important;\n}\n\n.bg-strong-bliss {\n  background-image: linear-gradient(to right, #f78ca0 0%, #f9748f 19%, #fd868c 60%, #fe9a8b 100%) !important;\n}\n\n.bg-grow-early {\n  background-image: linear-gradient(to top, #0ba360 0%, #3cba92 100%) !important;\n}\n\n.bg-love-kiss {\n  background-image: linear-gradient(to top, #ff0844 0%, #ffb199 100%) !important;\n}\n\n.bg-premium-dark {\n  background-image: linear-gradient(to right, #434343 0%, black 100%) !important;\n}\n\n.bg-happy-green {\n  background-image: linear-gradient(to bottom, #00b09b, #96c93d) !important;\n}\n\n.bg-vicious-stance {\n  background-image: linear-gradient(60deg, #29323c 0%, #485563 100%) !important;\n}\n\n.bg-midnight-bloom {\n  background-image: linear-gradient(-20deg, #2b5876 0%, #4e4376 100%) !important;\n}\n\n.bg-night-sky {\n  background-image: linear-gradient(to top, #1e3c72 0%, #1e3c72 1%, #2a5298 100%) !important;\n}\n\n.bg-slick-carbon {\n  background-image: linear-gradient(to bottom, #323232 0%, #3F3F3F 40%, #1C1C1C 150%), linear-gradient(to top, rgba(255,255,255,0.40) 0%, rgba(0,0,0,0.25) 200%) !important;\n  background-blend-mode: multiply;\n}\n\n.bg-royal {\n  background-image: linear-gradient(to right, #141e30, #243b55) !important;\n}\n\n.bg-asteroid {\n  background-image: linear-gradient(to right, #0f2027, #203a43, #2c5364) !important;\n}\n\n.bg-transparent {\n  background: transparent !important;\n}","@charset \"UTF-8\";\n/*!\nAnimate.css - http://daneden.me/animate\nLicensed under the MIT license - http://opensource.org/licenses/MIT\nCopyright (c) 2015 Daniel Eden\n*/\n\nbody {\n\t-webkit-backface-visibility: hidden; // Addresses a small issue in webkit: https://css-tricks.com/almanac/properties/b/backface-visibility/\n}\n\n.animated {\n  \t@include animate-prefixer(animation-duration, calc( #{$base-duration} ) );\n  \t@include animate-prefixer(animation-fill-mode, $base-fill-mode);\n\n\t&.infinite {\n\t  animation-iteration-count: $base-iteration-count;\n\t}\n\n\t&.hinge {\n\t  @include animate-prefixer(animation-duration, calc( #{$base-duration} * 2 ) );\n\t}\n\n\t&.bounceIn,\n\t&.bounceOut {\n\t  @include animate-prefixer(animation-duration, calc( #{$base-duration} * 0.75 ) );\n\t}\n\n\t&.flipOutX,\n\t&.flipOutY {\n\t  @include animate-prefixer(animation-duration, calc( #{$base-duration} * 0.75 ) );\n\t}\n}","///////////////////////////////////////////////////////////////////\n// Sass Mixins which will be used by the modules                 //\n///////////////////////////////////////////////////////////////////\n\n//===============================================================//\n//          Automatically add vendor prefixes in one hit         //\n//===============================================================//\n//      .fadeIn {                                                //\n//          @include animate-prefixer(animation, 'fadeIn');        //\n//      }                                                        //\n//===============================================================//\n//                                                               //\n//===============================================================//\n@mixin animate-prefixer($property, $value...) {\n    -webkit-#{$property}: unquote('#{$value}');\n    #{$property}: unquote('#{$value}');\n}\n//===============================================================//\n// Generate keyframes animations with vendor prefixes in one hit //\n//===============================================================//\n//      .fadeIn {                                                //\n//          @include animate-prefixer(animation, fadeIn);        //\n//      }                                                        //\n//      @include animate-keyframe(fadeIn) {                      //\n//          0% {opacity: 0;}                                     //\n//          100% {opacity: 1;}                                   //\n//      }                                                        //\n//===============================================================//\n// Courtesy of @integralist: (twitter.com)                       //\n//===============================================================//\n\n@mixin animate-keyframe($animation-name) {\n    @-webkit-keyframes #{$animation-name} {\n        @content;\n    }\n\n    @keyframes #{$animation-name} {\n        @content;\n    }\n}\n","/////////////////////////////////////////////////////////\n// Animation Default Settings                          //\n/////////////////////////////////////////////////////////\n\n\n// Base module settings\n$base-duration\t\t\t\t\t: 1s !default;           // used in 1-base module\n$base-origin \t\t\t\t\t: top center !default;\n$base-degrees \t\t\t\t\t: 30deg !default;        // used in lightspeed & special modules\n$base-fill-mode\t\t\t\t\t: both !default;\n$base-iteration-count\t\t\t: infinite !default;\n\n$base-timing-function-in\t\t: ease-in !default;\n$base-timing-function-out\t\t: ease-out !default;\n$base-timing-function-in-out\t: ease-in-out !default;\n\n$base-distance\t\t\t\t\t: 10px !default; \t\t// used in fade, shake and bounce modules\n$base-distance-big\t\t\t\t: 1000px !default;       // used in fadeBig and bounce modules\n\n\n// Rotate module settings\n$rotate-degrees \t\t\t\t: 90deg !default;\n$rotate-degrees-max \t\t\t: 200deg !default;\n$rotate-origin \t\t\t\t\t: center center !default;\n\n// Flipper module settings\n$flipper-perspective\t\t\t: 400px !default;\n$flipper-translate \t\t\t\t: 150px !default;\n$flipper-degrees \t\t\t\t: 10deg !default;\n$flipper-degrees-max \t\t\t: 90deg !default;\n\n\n// Hinge module settings\n$hinge-origin \t\t\t\t\t: top left !default;\n$hinge-degrees-max \t\t\t\t: 80deg !default;\n$hinge-translate \t\t\t\t: 700px !default;\n\n\n//==================================================================================================//\n// Module loading                                                                                   //\n//==================================================================================================//\n// To include an animation module in the compiled css file, simply set it's attribute below to true //\n// (all modules set to false will not be included)                                                  //\n// The idea here is to only load the animations you want to use on a per project basis              //\n// This helps keep the compiled css file at its leanest                                             //\n//==================================================================================================//\n// Hugely influenced and inspired by @csswizardry's inuit.css _vars.scss file                       //\n//==================================================================================================//\n\n$use-all                    :   false !default; // all animations status\n$use-fade               :   $use-all !default; // all fades\n$use-bounce             :   $use-all !default; // all bounces\n$use-rotate             :   $use-all !default; // all rotates\n$use-slide              :   $use-all !default; // all slide animations\n$use-flipers            :   $use-all !default; // all flip animations\n$use-light-speed        :   $use-all !default; // all light speed animations\n$use-attention-seekers  :   $use-all !default; // all attention seeker animations\n$use-special            :   $use-all !default; // all special animations\n$use-zoom               :   $use-all !default; // all zoom animations\n// Fade Enter\n$use-fade-in            :   $use-fade !default;\n$use-fadeIn \t\t\t:\t$use-fade-in !default;\n$use-fadeInUp \t\t\t:\t$use-fade-in !default;\n$use-fadeInUpBig \t\t:\t$use-fade-in !default;\n$use-fadeInDown \t\t:\t$use-fade-in !default;\n$use-fadeInDownBig \t\t:\t$use-fade-in !default;\n$use-fadeInLeft \t\t:\t$use-fade-in !default;\n$use-fadeInLeftBig \t\t:\t$use-fade-in !default;\n$use-fadeInRight \t\t:\t$use-fade-in !default;\n$use-fadeInRightBig \t:\t$use-fade-in !default;\n\n\n// Fade Exit\n$use-fade-out           :   $use-fade !default;\n$use-fadeOut\t\t\t:   $use-fade-out !default;\n$use-fadeOutUp\t\t\t:\t$use-fade-out !default;\n$use-fadeOutUpBig   \t:\t$use-fade-out !default;\n$use-fadeOutDown\t\t:\t$use-fade-out !default;\n$use-fadeOutDownBig \t:\t$use-fade-out !default;\n$use-fadeOutLeft\t\t:\t$use-fade-out !default;\n$use-fadeOutLeftBig \t:\t$use-fade-out !default;\n$use-fadeOutRight\t\t:\t$use-fade-out !default;\n$use-fadeOutRightBig\t:\t$use-fade-out !default;\n\n\n// Bounce Enter\n$use-bounce-in          :   $use-bounce !default;\n$use-bounceIn\t\t\t:\t$use-bounce-in !default;\n$use-bounceInUp\t\t\t: \t$use-bounce-in !default;\n$use-bounceInDown \t\t: \t$use-bounce-in !default;\n$use-bounceInLeft \t\t: \t$use-bounce-in !default;\n$use-bounceInRight \t\t: \t$use-bounce-in !default;\n\n\n// Bounce Exit\n$use-bounce-out         :   $use-bounce !default;\n$use-bounceOut\t\t\t:\t$use-bounce-out !default;\n$use-bounceOutUp\t\t: \t$use-bounce-out !default;\n$use-bounceOutDown \t\t: \t$use-bounce-out !default;\n$use-bounceOutLeft \t\t: \t$use-bounce-out !default;\n$use-bounceOutRight \t: \t$use-bounce-out !default;\n\n\n\n// Rotate Enter\n$use-rotate-in          :   $use-rotate !default;\n$use-rotateIn \t\t\t:\t$use-rotate-in !default;\n$use-rotateInUpLeft \t: \t$use-rotate-in !default;\n$use-rotateInUpRight \t: \t$use-rotate-in !default;\n$use-rotateInDownLeft \t: \t$use-rotate-in !default;\n$use-rotateInDownRight \t: \t$use-rotate-in !default;\n\n\n// Rotate Exit\n$use-rotate-out         :   $use-rotate !default;\n$use-rotateOut \t\t\t:\t$use-rotate-out !default;\n$use-rotateOutUpLeft \t: \t$use-rotate-out !default;\n$use-rotateOutUpRight \t: \t$use-rotate-out !default;\n$use-rotateOutDownLeft \t: \t$use-rotate-out !default;\n$use-rotateOutDownRight : \t$use-rotate-out !default;\n\n\n// Slide Enter\n$use-slide-in           :   $use-slide !default;\n$use-slideIn\t\t\t:   $use-slide-in !default;\n$use-slideInUp\t\t\t:   $use-slide-in !default;\n$use-slideInDown\t\t:   $use-slide-in !default;\n$use-slideInLeft\t\t:   $use-slide-in !default;\n$use-slideInRight\t\t:   $use-slide-in !default;\n\n// Slide Exit\n$use-slide-out          :   $use-slide !default;\n$use-slideOut\t\t\t:   $use-slide-out !default;\n$use-slideOutUp\t\t\t:   $use-slide-out !default;\n$use-slideOutDown\t\t:   $use-slide-out !default;\n$use-slideOutLeft\t\t:   $use-slide-out !default;\n$use-slideOutRight\t\t:   $use-slide-out !default;\n\n// Flippers\n$use-flip\t\t\t\t:\t$use-flipers !default;\n$use-flipInX\t\t\t:\t$use-flipers !default;\n$use-flipInY\t\t\t:\t$use-flipers !default;\n$use-flipOutX\t\t\t:\t$use-flipers !default;\n$use-flipOutY\t\t\t:\t$use-flipers !default;\n\n\n// Lightspeed\n$use-lightSpeedIn \t\t:\t$use-light-speed !default;\n$use-lightSpeedOut \t\t:\t$use-light-speed !default;\n\n\n// Attention Seekers\n$use-bounce\t\t\t\t:\t$use-attention-seekers !default;\n$use-flash\t\t\t\t:\t$use-attention-seekers !default;\n$use-pulse\t\t\t\t:\t$use-attention-seekers !default;\n$use-wiggle\t\t\t\t:\t$use-attention-seekers !default;\n$use-swing\t\t\t\t:\t$use-attention-seekers !default;\n$use-shake\t\t\t\t:\t$use-attention-seekers !default;\n$use-tada\t\t\t\t:\t$use-attention-seekers !default;\n$use-wobble\t\t\t\t:\t$use-attention-seekers !default;\n\n\n// Special\n$use-hinge\t\t\t\t:\t$use-special !default;\n$use-rollIn\t\t\t\t: \t$use-special !default;\n$use-rollOut \t\t\t:\t$use-special !default;\n\n\n// Zoom In\n$use-zoom-in            :   $use-zoom !default;\n$use-zoomIn \t\t\t:\t$use-zoom-in !default;\n$use-zoomInDown \t\t:\t$use-zoom-in !default;\n$use-zoomInLeft \t\t:\t$use-zoom-in !default;\n$use-zoomInRight \t\t:\t$use-zoom-in !default;\n$use-zoomInUp \t\t\t:\t$use-zoom-in !default;\n\n\n// Zoom Out\n$use-zoom-out           :   $use-zoom !default;\n$use-zoomOut\t\t\t:\t$use-zoom-out !default;\n$use-zoomOutDown\t\t:\t$use-zoom-out !default;\n$use-zoomOutLeft\t\t:\t$use-zoom-out !default;\n$use-zoomOutRight\t\t:\t$use-zoom-out !default;\n$use-zoomOutUp\t\t\t:\t$use-zoom-out !default;\n","@if $use-fadeIn == true {\n\n\t@include animate-keyframe(fadeIn) {\n\t\t0% {opacity: 0;}\n\t\t100% {opacity: 1;}\n\t}\n\n\t.fadeIn {\n\t\t@include animate-prefixer(animation-name, fadeIn);\n\t}\n\n}\n","@if $use-fadeInDown == true {\n\n\t@-webkit-keyframes fadeInDown {\n\t\t0% {\n\t\t\topacity: 0;\n\t\t\t-webkit-transform: translateY(-$base-distance * 2);\n\t\t}\n\n\t\t100% {\n\t\t\topacity: 1;\n\t\t\t-webkit-transform: translateY(0);\n\t\t}\n\t}\n\n\t@keyframes fadeInDown {\n\t\t0% {\n\t\t\topacity: 0;\n\t\t\ttransform: translateY(-$base-distance * 2);\n\t\t}\n\n\t\t100% {\n\t\t\topacity: 1;\n\t\t\ttransform: translateY(0);\n\t\t}\n\t}\n\n\t.fadeInDown {\n\t\t@include animate-prefixer(animation-name, fadeInDown);\n\t}\n\n}\n","@if $use-fadeInUp == true {\n\n\t@-webkit-keyframes fadeInUp {\n\t\t0% {\n\t\t\topacity: 0;\n\t\t\t-webkit-transform: translateY($base-distance * 2);\n\t\t}\n\n\t\t100% {\n\t\t\topacity: 1;\n\t\t\t-webkit-transform: translateY(0);\n\t\t}\n\t}\n\n\t@keyframes fadeInUp {\n\t\t0% {\n\t\t\topacity: 0;\n\t\t\ttransform: translateY($base-distance * 2);\n\t\t}\n\n\t\t100% {\n\t\t\topacity: 1;\n\t\t\ttransform: translateY(0);\n\t\t}\n\t}\n\n\t.fadeInUp {\n\t\t@include animate-prefixer(animation-name, fadeInUp);\n\t}\n\n}\n","@if $use-fadeOut == true {\n\n\t@include animate-keyframe(fadeOut) {\n\t\t0% {opacity: 1;}\n\t\t100% {opacity: 0;}\n\t}\n\n\t.fadeOut {\n\t\t@include animate-prefixer(animation-name, fadeOut);\n\t}\n\n}\n","@if $use-lightSpeedIn == true {\n\n\t@-webkit-keyframes lightSpeedIn {\n\t\t0% { -webkit-transform: translateX(100%) skewX(-$base-degrees); opacity: 0; }\n\t\t60% { -webkit-transform: translateX(-20%) skewX($base-degrees); opacity: 1; }\n\t\t80% { -webkit-transform: translateX(0%) skewX(-$base-degrees / 2); opacity: 1; }\n\t\t100% { -webkit-transform: translateX(0%) skewX(0deg); opacity: 1; }\n\t}\n\n\t@keyframes lightSpeedIn {\n\t\t0% { transform: translateX(100%) skewX(-$base-degrees); opacity: 0; }\n\t\t60% { transform: translateX(-20%) skewX($base-degrees); opacity: 1; }\n\t\t80% { transform: translateX(0%) skewX(-$base-degrees / 2); opacity: 1; }\n\t\t100% { transform: translateX(0%) skewX(0deg); opacity: 1; }\n\t}\n\n\t.lightSpeedIn {\n\t\t@include animate-prefixer(animation-name, lightSpeedIn);\n\t\t@include animate-prefixer(animation-timing-function, $base-timing-function-out);\n\t}\n\n}\n","@if $use-lightSpeedOut == true {\n\n\t@-webkit-keyframes lightSpeedOut {\n\t\t0% { -webkit-transform: translateX(0%) skewX(0deg); opacity: 1; }\n\t\t100% { -webkit-transform: translateX(100%) skewX(-$base-degrees); opacity: 0; }\n\t}\n\n\t@keyframes lightSpeedOut {\n\t\t0% { transform: translateX(0%) skewX(0deg); opacity: 1; }\n\t\t100% { transform: translateX(100%) skewX(-$base-degrees); opacity: 0; }\n\t}\n\n\t.lightSpeedOut {\n\t\t@include animate-prefixer(animation-name, lightSpeedOut);\n\t\t@include animate-prefixer(animation-timing-function, $base-timing-function-in);\n\t}\n}\n","// Common Comps Animations\n\n\n$base-duration\t\t\t\t\t: .2s;\n$base-distance                  : 10px;\n$base-fill-mode\t\t\t\t\t: both;\n\n// Dropdown Animation\n\n.dropdown-menu {\n  &.show {\n    animation: fade-in2 .2s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;\n  }\n}\n\n.popover {\n  &.show {\n    display: block;\n    animation: fade-in2 .2s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;\n  }\n}\n\n.dropdown-menu {\n  &[data-placement^=\"top\"].show {\n    animation: fade-in3 .2s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;\n    bottom: auto !important;\n    top: auto !important;\n  }\n}\n\n@keyframes fade-in2 {\n  0% {\n    margin-top: -50px;\n    visibility: hidden;\n    opacity: 0;\n  }\n  100% {\n    margin-top: 0px;\n    visibility: visible;\n    opacity: 1;\n  }\n}\n\n.form-control {\n  transition: all .2s;\n}\n","// Buttons\n\n// 2x Outline Border\n$btn-block-spacing-y:         .5rem !default;\n\n@use \"sass:math\";\n\n.btn-outline-2x {\n  border-width: 2px;\n}\n\n.btn-group {\n  .btn {\n    font-size: 0.8rem;\n    font-weight: 500;\n  }\n\n  .btn-outline-2x + .btn-outline-2x {\n    margin-left: -2px;\n  }\n\n  .btn-square {\n    @include border-radius(0);\n  }\n}\n\n.btn {\n  font-size: 0.8rem;\n  font-weight: 500;\n\n  // Pills Buttons\n\n  &.btn-pill.btn-wide,\n  &.btn-pill {\n    @include border-start-radius(50px);\n    @include border-end-radius(50px);\n  }\n\n}\n\n// Dashed Border\n\n.btn-dashed {\n  border-style: dashed;\n}\n\n// Icon Buttons\n\n.btn-icon {\n  vertical-align: bottom;\n\n  &.btn-icon-right {\n    .btn-icon-wrapper {\n      margin-left: math.div($spacer, 2);\n      margin-right: 0;\n    }\n  }\n\n  .btn-icon-wrapper {\n    margin-right: math.div($spacer, 2);\n    margin-left: 0;\n    margin-top: 0;\n    font-size: 17px;\n    vertical-align: middle;\n    transition: color .1s;\n    display: inline-block;\n  }\n\n  &.btn-link {\n    text-decoration: none;\n  }\n\n  &.btn-lg:not(.btn-block) {\n    .btn-icon-wrapper {\n      font-size: 25px;\n    }\n  }\n\n  &.btn-sm:not(.btn-block) {\n    .btn-icon-wrapper {\n      font-size: 16px;\n    }\n  }\n}\n\n.btn-icon-only {\n  .btn-icon-wrapper {\n    margin-left: 0;\n    margin-right: 0;\n  }\n}\n\n// Hover Shine {\n\n.btn-hover-shine {\n  position: relative;\n\n  &:after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 0;\n    height: 100%;\n    background-color: rgba(255, 255, 255, 0.4);\n    -webkit-transition: none;\n    -moz-transition: none;\n    transition: none;\n  }\n\n  &:hover:after {\n    width: 120%;\n    background-color: rgba(255, 255, 255, 0);\n    transition: all 0.4s ease-in-out;\n  }\n\n  &.btn-pill {\n    &::after {\n      @include border-start-radius(50px);\n      @include border-end-radius(50px);\n    }\n  }\n}\n\n// Vertical Icons {\n\n.btn-icon-vertical {\n  padding-top: ($btn-block-spacing-y * 2);\n  padding-bottom: ($btn-block-spacing-y * 2);\n\n  .btn-icon-wrapper {\n    display: block;\n    font-size: 200%;\n    margin: 5px 0;\n    opacity: .6;\n  }\n\n  &.btn-link {\n    text-decoration: none;\n  }\n\n  &.btn-lg:not(.btn-block) {\n    .btn-icon-wrapper {\n      font-size: 25px;\n    }\n  }\n\n  &.btn-sm:not(.btn-block) {\n    .btn-icon-wrapper {\n      font-size: 16px;\n    }\n  }\n\n  &:active,\n  &.active,\n  &:hover {\n    .btn-icon-wrapper {\n      opacity: 1;\n    }\n  }\n\n  &.btn-icon-bottom {\n    .btn-icon-wrapper {\n      margin: math.div($spacer, 5) 0 5px;\n    }\n  }\n\n  &.btn-transition-text {\n    .btn-icon-wrapper {\n      transition: all .2s !important;\n    }\n\n    &:hover {\n      .btn-icon-wrapper {\n        transform: scale(1.3);\n      }\n    }\n\n    &.btn-transition-alt {\n\n      &:hover {\n        .btn-icon-wrapper {\n          color: $white !important;\n        }\n      }\n    }\n  }\n}\n\n.btn-icon-lg {\n  font-size: $h1-font-size !important;\n}\n\n// Buttons Transitions\n\n.btn-transition {\n  color: $gray-600;\n  border-color: $gray-200;\n  background-color: none;\n\n  &.btn-outline-link {\n    border-color: transparent;\n    background-color: transparent;\n\n    &:hover {\n      color: $primary;\n      background: $gray-100;\n    }\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $gray-600;\n    border-color: $gray-200;\n  }\n\n  &:hover {\n    .btn-icon-wrapper {\n      transition: none;\n    }\n  }\n}\n\n.btn-transition-alt {\n  &:hover {\n    .icon-gradient {\n      -webkit-background-clip: initial;\n      -webkit-text-fill-color: initial;\n      background-clip: initial;\n      text-fill-color: initial;\n      background: none !important;\n      color: $white;\n    }\n  }\n}\n\n// Square Buttons\n\n.btn-square {\n  @include border-radius(0 !important);\n}\n\n// Wide buttons\n\n.btn {\n  &.btn-wide {\n    @include button-size($btn-padding-y, ($btn-padding-x * 2), $font-size-xs, $btn-border-radius);\n  }\n}\n\n.btn-lg {\n  &.btn-wide {\n    @include button-size($btn-padding-y-lg, ($btn-padding-x-lg * 2), $font-size-lg,  $btn-border-radius-lg);\n  }\n}\n\n.btn-sm {\n  &.btn-wide {\n    @include button-size($btn-padding-y-sm, ($btn-padding-x-sm * 2), $font-size-xs, $btn-border-radius-sm);\n  }\n}\n\n// Dropdown toggle\n\n.dropdown-toggle {\n  &::after {\n    position: relative;\n    top: 2px;\n    opacity: .8;\n  }\n}\n\n.dropright {\n  .dropdown-toggle {\n    &::after {\n      top: 0;\n    }\n  }\n}\n\n.dropdown-toggle-split {\n  border-left: rgba(255, 255, 255, .1) solid 1px;\n}\n\n// Buttons Gradients\n\n$btn-gradients: ();\n\n$gradient-primary: $brand;\n$gradient-secondary: $gray-600;\n$gradient-success: $green;\n$gradient-info: $cyan;\n$gradient-warning: $yellow;\n$gradient-danger: $red;\n$gradient-light: $blue-light;\n$gradient-dark: $gray-800;\n$gradient-focus: $indigo;\n$gradient-alt: $purple;\n\n$gradinet-percent: 15%;\n\n$btn-gradients: map_merge(\n                (\n                        \"primary\": (\n                                darken($gradient-primary, $gradinet-percent), // color-start\n                                $gradient-primary, // color-end\n                                0%, // gr-start\n                        ),\n                        \"secondary\": (\n                                darken($gradient-secondary, $gradinet-percent), // color-start\n                                $gradient-secondary, // color-end\n                                0%, // gr-start\n                        ),\n                        \"success\": (\n                                darken($gradient-success, $gradinet-percent), // color-start\n                                $gradient-success, // color-end\n                                0%, // gr-start\n                        ),\n                        \"info\": (\n                                darken($gradient-info, $gradinet-percent), // color-start\n                                $gradient-info, // color-end\n                                0%, // gr-start\n                        ),\n                        \"warning\": (\n                                darken($gradient-warning, $gradinet-percent), // color-start\n                                $gradient-warning, // color-end\n                                0%, // gr-start\n                        ),\n                        \"danger\": (\n                                darken($gradient-danger, $gradinet-percent), // color-start\n                                $gradient-danger, // color-end\n                                0%, // gr-start\n                        ),\n                        \"focus\": (\n                                darken($gradient-focus, $gradinet-percent), // color-start\n                                $gradient-focus, // color-end\n                                0%, // gr-start\n                        ),\n                        \"alternate\": (\n                                darken($gradient-alt, $gradinet-percent), // color-start\n                                $gradient-alt, // color-end\n                                0%, // gr-start\n                        ),\n                        \"light\": (\n                                darken($gradient-light, $gradinet-percent), // color-start\n                                $gradient-light, // color-end\n                                0%, // gr-start\n                        ),\n                        \"dark\": (\n                                darken($gradient-dark, $gradinet-percent), // color-start\n                                $gradient-dark, // color-end\n                                0%, // gr-start\n                        ),\n                ),\n                $btn-gradients\n);\n\n@mixin btn-grad-variant($color-start, $color-end, $gr-start) {\n  background-image: linear-gradient(140deg, $color-start -30%, $color-end 90%);\n  background-color: $color-start;\n  border-color: $color-start;\n  color: color-yiq(darken($color-start, 10%));\n\n  &.active,\n  &:active,\n  &:not(:disabled):not(.disabled):hover {\n    background-image: linear-gradient(120deg, darken($color-start, 3%) 0%, darken($color-end, 3%) 100%);\n    color: color-yiq(darken($color-start, 10%));\n    border-color: darken($color-start, 10%);\n  }\n\n  &:focus,\n  &.focus,\n  &:active,\n  &.active {\n    color: color-yiq(darken($color-start, 10%)) !important;\n    border-color: darken($color-end, 20%) !important;\n  }\n\n}\n\n@each $grad, $colors in $btn-gradients {\n  $color: nth($colors, 1);\n  $color1: nth($colors, 2);\n  $color2: nth($colors, 3);\n\n  .btn-gradient-#{$grad} {\n    @include btn-grad-variant($color, $color1, $color2);\n\n    &.btn-shadow {\n      box-shadow: 0 0.125rem 0.625rem rgba($color1, .4), 0 0.0625rem 0.125rem rgba($color1, .5);\n\n      &:hover {\n        box-shadow: 0 0.125rem 0.625rem rgba($color1, .5), 0 0.0625rem 0.125rem rgba($color1, .6);\n      }\n    }\n  }\n}\n\n.btn-shadow {\n  &.active {\n    box-shadow: 0 0 0 0 transparent !important;\n  }\n}\n\n// Links\n\n$link-color: $primary;\n$link-hover-color: darken($link-color, 15%);\n\n// Generate Buttons\n\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @include button-variant($value, $value);\n\n    &.btn-shadow {\n      box-shadow: 0 0.125rem 0.625rem rgba($value, .4), 0 0.0625rem 0.125rem rgba($value, .5);\n\n      &:hover {\n        box-shadow: 0 0.125rem 0.625rem rgba($value, .5), 0 0.0625rem 0.125rem rgba($value, .6);\n      }\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-shadow-#{$color} {\n    &:hover {\n      box-shadow: 0 0.125rem 0.625rem rgba($value, .4), 0 0.0625rem 0.125rem rgba($value, .5);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n\n    &.btn-shadow {\n      box-shadow: 0 0.125rem 0.625rem rgba($value, .4), 0 0.0625rem 0.125rem rgba($value, .5);\n\n      &.active:hover,\n      &.disabled:hover,\n      &:active:hover,\n      &:disabled:hover {\n        box-shadow: 0 0.125rem 0.625rem rgba($value, .5), 0 0.0625rem 0.125rem rgba($value, .6);\n      }\n\n      &:hover {\n        box-shadow: (0px 5px 15px 2px rgba($value, 0.19));\n      }\n    }\n  }\n}\n\n.btn {\n  position: relative;\n  @include transition($btn-transition);\n}\n\n.btn-light {\n  border-color: darken(#f5f5f5, 10%);\n}\n\n.btn-outline-light {\n  color: darken(#f5f5f5, 40%);\n}","// Dropdown\n\n@use \"sass:math\";\n\n.dropdown-menu {\n  box-shadow: 0 0.46875rem 2.1875rem rgba(darken($primary, 50%), .03),\n  0 0.9375rem 1.40625rem rgba(darken($primary, 50%), .03),\n  0 0.25rem 0.53125rem rgba(darken($primary, 50%), .05),\n  0 0.125rem 0.1875rem rgba(darken($primary, 50%), .03);\n  font-size: $font-size-base;\n\n  margin: $dropdown-spacer;\n\n  &.dropdown-menu-right {\n    right: 0 !important;\n  }\n\n  .dropdown-header {\n    text-transform: uppercase;\n    font-size: math.div($font-size-base, 1.2);\n    color: $primary;\n    font-weight: bold;\n  }\n\n  .dropdown-item {\n    font-size: $font-size-base;\n    display: flex;\n    align-items: center;\n    transition: background-color 0.3s ease, color 0.3s ease;\n    cursor: pointer;\n    z-index: 6;\n    position: relative;\n\n    .dropdown-icon {\n      font-size: 1rem;\n      margin-right: math.div($dropdown-padding-y, 2);\n      width: 30px;\n      text-align: center;\n      opacity: .3;\n      margin-left: -10px;\n    }\n\n    &:hover {\n      .dropdown-icon {\n        opacity: .7;\n      }\n    }\n  }\n\n  &.dropdown-menu-shadow {\n    box-shadow: 0 0.66875rem 2.3875rem rgba(darken($primary, 50%), .03),\n    0 1.1375rem 1.60625rem rgba(darken($primary, 50%), .03),\n    0 0.45rem 0.73125rem rgba(darken($primary, 50%), .05),\n    0 0.325rem 0.3875rem rgba(darken($primary, 50%), .03);\n  }\n}\n\n.dropdown-menu-rounded {\n  @include border-radius(10px);\n  padding: $dropdown-padding-y;\n\n  .dropdown-item {\n    @include border-radius(30px);\n  }\n\n  .dropdown-divider {\n    margin-left: -$dropdown-padding-y;\n    margin-right: -$dropdown-padding-y;\n  }\n\n  .dropdown-menu-header {\n    margin-left: -$dropdown-padding-y;\n    margin-right: -$dropdown-padding-y;\n    @include border-top-radius(10px);\n  }\n\n  .menu-header-image,\n  .dropdown-menu-header-inner {\n    @include border-top-radius(10px);\n  }\n}\n\n.dropdown-menu-hover-link {\n  .dropdown-item {\n    &:hover {\n      background: none;\n      color: $primary;\n    }\n  }\n}\n\n.dropdown-menu-hover-primary {\n  .dropdown-item {\n    &:hover {\n      background: $primary;\n      color: $white;\n    }\n  }\n}\n\n.dropdown-menu {\n  &.dropdown-menu-lg {\n    min-width: 22rem;\n  }\n\n  &.dropdown-menu-xl {\n    min-width: 25rem;\n  }\n}\n\n// Dropdown header\n\n.dropdown-menu {\n  .dropdown-menu-header,\n  .menu-header-image,\n  .dropdown-menu-header-inner {\n    @include border-top-radius($dropdown-border-radius);\n  }\n}\n\n.dropdown-menu-header {\n  color: $white;\n  margin-top: -$dropdown-padding-y;\n  margin-bottom: $dropdown-padding-y;\n  position: relative;\n  z-index: 6;\n\n  .dropdown-menu-header-inner {\n    margin: -1px -1px 0;\n    padding: ($spacer * 1.5) math.div($spacer, 2);\n    position: relative;\n  }\n\n  .menu-header-image {\n    position: absolute;\n    left: 0;\n    top: 0;\n    height: 100%;\n    width: 100%;\n    z-index: 8;\n    opacity: .25;\n    filter: grayscale(80%);\n    background-size: cover;\n  }\n\n  .menu-header-content {\n    text-align: center;\n    position: relative;\n    z-index: 10;\n\n    &.text-start {\n      padding-left: math.div($spacer, 2);\n    }\n\n    &.btn-pane-right {\n      padding-left: math.div($spacer, 2);\n      padding-right: math.div($spacer, 2);\n      display: flex;\n      align-content: center;\n      align-items: center;\n      text-align: left;\n\n      .menu-header-btn-pane {\n        margin: 0 0 0 auto;\n      }\n    }\n\n    .menu-header-btn-pane {\n      margin-top: 10px;\n      margin-bottom: 3px;\n    }\n  }\n\n  & + .grid-menu {\n    margin-top: -$dropdown-padding-y;\n  }\n}\n\n.menu-header-title {\n  font-weight: 500;\n  font-size: $h5-font-size;\n  margin: 0;\n}\n\n.menu-header-subtitle {\n  font-size: $font-family-base;\n  margin: 5px 0 0;\n  opacity: .8;\n}\n\n.dropdown-menu {\n  .grid-menu {\n    margin-bottom: -$dropdown-padding-y;\n    padding: 1px;\n\n    [class*=\"col-\"] {\n      padding: $dropdown-padding-y;\n    }\n  }\n\n  .grid-menu-xl {\n    margin-bottom: -(math.div($dropdown-padding-y, 1.35));\n\n    [class*=\"col-\"] {\n      padding: 0;\n    }\n  }\n}\n\n// Dropdown toggle\n\n.dropdown-toggle {\n  &::after {\n    position: relative;\n    top: 2px;\n    opacity: .8;\n    margin-left: 5px;\n  }\n}\n\n.dropdown-toggle-split {\n  &::after {\n    margin-left: 0;\n  }\n}\n\n.dropright {\n  .dropdown-toggle {\n    &::after {\n      top: 0;\n    }\n  }\n}\n\n.dropdown-toggle-split {\n  border-left: rgba(255, 255, 255, .1) solid 2px;\n}\n\n// Dropdown Indicators\n\n.dropdown-menu {\n\n  &::before,\n  &::after {\n    position: absolute;\n    width: 14px;\n    height: 14px;\n    left: 5px;\n    top: -5px;\n    transform: rotate(45deg);\n    border-radius: 4px;\n    content: '';\n    display: block;\n    z-index: 5;\n  }\n\n  &::before {\n    background: $dropdown-bg;\n    z-index: 5;\n  }\n\n  &::after {\n    top: -6px;\n    background: $dropdown-border-color;\n    z-index: 4;\n  }\n\n  &[data-placement=\"top-start\"] {\n    &::before,\n    &::after {\n      top: auto;\n      bottom: -5px;\n    }\n\n    &::after {\n      bottom: -6px;\n    }\n  }\n\n  &[data-placement=\"left-start\"] {\n    &::before,\n    &::after {\n      left: auto;\n      right: -5px;\n      top: 5px;\n    }\n\n    &::after {\n      top: 5px;\n      right: -6px;\n    }\n  }\n\n  &[data-placement=\"right-start\"] {\n    &::before,\n    &::after {\n      right: auto;\n      left: -5px;\n      top: 5px;\n    }\n\n    &::after {\n      top: 5px;\n      left: -6px;\n    }\n  }\n\n  &.dropdown-menu-right {\n    &::before,\n    &::after {\n      left: auto;\n      right: 6px;\n    }\n\n    &::after {\n      right: 6px;\n    }\n  }\n\n  &.rm-pointers {\n    &::before,\n    &::after {\n      display: none;\n    }\n  }\n}\n\n// Dropdown Mega Menu\n\n.dropdown-mega-menu {\n  width: 56rem;\n  padding: $spacer;\n\n  .nav-item.nav-item-header {\n    text-transform: none;\n    font-size: $h6-font-size;\n    padding-top: 0;\n    font-weight: normal;\n  }\n\n  .grid-menu {\n    margin-bottom: 0;\n  }\n}\n\n.dropdown-mega-menu-sm {\n  width: 40rem;\n}\n\n// Dropdown Inline\n\nbody .dropdown-menu.dropdown-menu-inline {\n  border: 0;\n  position: static !important;\n  box-shadow: 0 0 0 transparent;\n  background: transparent;\n  @include border-radius(0);\n  display: inline-block;\n  float: none;\n  left: 0 !important;\n  top: 0 !important;\n  width: 100% !important;\n  transform: translateY(0) !important;\n\n  &::before,\n  &::after {\n    display: none;\n  }\n}\n","// NAVS\n\n@use \"sass:math\";\n\n.nav-item {\n  .nav-link {\n    font-weight: normal;\n  }\n}\n\n.nav-link {\n  display: flex;\n  align-items: center;\n  transition: background-color 0.3s ease, color 0.3s ease;\n  cursor: pointer;\n\n  .nav-link-icon {\n    color: $primary;\n    font-size: 1rem;\n    width: 30px;\n    text-align: center;\n    opacity: .45;\n    margin-left: -10px;\n  }\n\n  &:hover {\n    color: $gray-700;\n\n    .nav-link-icon {\n      opacity: .9;\n      color: $primary;\n    }\n  }\n\n  &:disabled,\n  &.disabled {\n    .nav-link-icon {\n      opacity: .3;\n    }\n  }\n}\n\n.nav-item {\n  &.nav-item-header {\n    text-transform: uppercase;\n    font-size: math.div($font-size-base, 1.2);\n    color: $gray-600;\n    font-weight: bold;\n    padding: $nav-link-padding-y $nav-link-padding-x;\n  }\n\n  &.nav-item-btn {\n    padding: $nav-link-padding-y $nav-link-padding-x;\n  }\n\n  &.nav-item-divider {\n    margin: $nav-link-padding-y 0;\n    height: 1px;\n    overflow: hidden;\n    background: $gray-300;\n  }\n}\n\n.nav {\n  .badge {\n    margin-left: 8px;\n  }\n}\n\n.nav-pills {\n  .nav-link {\n\n    &.active,\n    &.active:hover {\n      color: $white;\n\n      .nav-link-icon {\n        color: $white;\n        opacity: .8;\n      }\n    }\n\n    &:hover {\n      color: $gray-700 !important;\n    }\n  }\n}\n\n// Grid Menus\n\n.grid-menu {\n\n  [class*=\"col-\"] {\n    border-right: $border-color solid 0;\n    border-bottom: $border-color solid 1px;\n\n    &:hover {\n      z-index: 5;\n    }\n  }\n\n  // @include media-breakpoint-between(sm, xl) {\n\n    [class*=\"col-\"]:nth-last-child(-n+2) {\n      border-bottom-width: 0;\n    }\n\n    [class*=\"col-\"]:nth-child(1n) {\n      border-right-width: 1px;\n    }\n\n    [class*=\"col-\"]:nth-child(2n) {\n      border-right-width: 0;\n    }\n  // }\n\n  [class*=\"col-\"]:nth-last-child(-n+1) {\n    border-bottom-width: 0;\n  }\n\n  &.grid-menu-3col {\n\n    // @include media-breakpoint-up(xl) {\n\n      [class*=\"col-\"]:nth-last-child(-n+3) {\n        border-bottom-width: 0;\n      }\n\n      [class*=\"col-\"]:nth-child(2n) {\n        border-right-width: 1px;\n      }\n\n      [class*=\"col-\"]:nth-child(3n) {\n        border-right-width: 0;\n      }\n    // }\n  }\n\n  .btn {\n    display: block;\n    border: 0;\n    min-width: 100%;\n  }\n}\n\n","// Badges\n\n// @each $color, $value in $theme-colors {\n//   .badge-#{$color} {\n//     @include badge-variant($value);\n//   }\n// }\n\n.badge {\n  font-weight: bold;\n  text-transform: uppercase;\n  padding: 5px 10px;\n  min-width: 19px;\n}\n\n.badge-light {\n  background: $white;\n}\n\n.badge-dot {\n  text-indent: -999em;\n  padding: 0;\n  width: 8px;\n  height: 8px;\n  border: transparent solid 1px;\n  @include border-radius(30px);\n  min-width: 2px;\n}\n\n.badge-dot-lg {\n  width: 10px;\n  height: 10px;\n}\n\n.badge-dot-xl {\n  width: 18px;\n  height: 18px;\n  position: relative;\n\n  &::before {\n    content: '';\n    width: 10px;\n    height: 10px;\n    @include border-radius($border-radius);\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    margin: -5px 0 0 -5px;\n    background: $white;\n  }\n}\n\n.badge-dot-sm {\n  width: 6px;\n  height: 6px;\n}\n\n.btn {\n  .badge {\n    margin-left: 8px;\n  }\n\n  .badge-dot {\n    position: absolute;\n    border: $white solid 2px;\n    top: -5px;\n    right: -5px;\n    width: 11px;\n    height: 11px;\n\n    &.badge-dot-lg {\n      width: 14px;\n      height: 14px;\n    }\n\n    &.badge-dot-sm {\n      width: 8px;\n      height: 8px;\n      border-width: 1px;\n    }\n  }\n\n  .badge-dot-inside {\n    top: 10px;\n    right: 10px;\n  }\n}\n\n.btn-sm {\n  .badge-dot-sm {\n    top: 1px;\n    right: 4px;\n  }\n\n  .badge-dot {\n    top: 0px;\n    right: 2px;\n  }\n\n  .badge-dot-lg {\n    top: -3px;\n    right: -2px;\n  }\n\n  .rounded-pill {\n    position: absolute;\n    top: -4px;\n    right: -4px;\n  }\n}\n\n.badge-abs {\n  position: absolute;\n  right: -3px;\n  top: -3px;\n}\n\n// Avatars\n\n.avatar-icon-wrapper {\n  display: inline-block;\n  margin-right: .1rem;\n  position: relative;\n\n  .badge {\n    position: absolute;\n    right: -2px;\n    top: -2px;\n\n    &:empty {\n      display: block;\n    }\n\n    &.badge-bottom {\n      top: auto;\n      right: -2px;\n      bottom: -2px;\n    }\n  }\n\n  .badge-dot {\n    width: 10px;\n    height: 10px;\n    border: $white solid 2px;\n\n    &.badge-dot-lg {\n      width: 14px;\n      height: 14px;\n      border: $white solid 2px;\n      top: 0;\n      right: 0;\n\n      &.badge-bottom {\n        top: auto;\n        right: 0;\n        bottom: 0;\n      }\n    }\n  }\n}\n\n.avatar-icon-add {\n\n  .avatar-icon {\n    background: $dropdown-link-hover-bg;\n    border: lighten($primary, 15%) dashed 1px;\n    color: $primary;\n    text-align: center;\n    opacity: .6;\n\n    i {\n      font-style: normal;\n      vertical-align: middle;\n      font-size: $h4-font-size;\n      display: block;\n      height: 100%;\n    }\n  }\n\n  &:hover {\n    cursor: pointer;\n\n    .avatar-icon {\n      opacity: 1;\n    }\n  }\n}\n\na.avatar-icon-wrapper {\n  &:hover {\n\n    .avatar-icon {\n      opacity: .8;\n    }\n  }\n}\n\n.avatar-icon {\n  display: block;\n  width: 44px;\n  height: 44px;\n  transition: all .2s;\n  opacity: 1;\n  @include border-radius(50px);\n\n  &.rounded {\n    @include border-radius(($border-radius-lg * 1.3) !important);\n  }\n}\n\n.avatar-icon-xl {\n  .avatar-icon {\n    width: 64px;\n    height: 64px;\n  }\n\n  &.avatar-icon-add {\n    i {\n      font-size: $h2-font-size;\n    }\n  }\n}\n\n.avatar-icon-lg {\n  .avatar-icon {\n    width: 54px;\n    height: 54px;\n  }\n\n  &.avatar-icon-add {\n    i {\n      font-size: $h3-font-size;\n    }\n  }\n}\n\n.avatar-icon-sm {\n  .avatar-icon {\n    width: 34px;\n    height: 34px;\n  }\n\n  &.avatar-icon-add {\n    i {\n      font-size: $font-size-lg;\n    }\n  }\n}\n\n.avatar-icon-xs {\n  .avatar-icon {\n    width: 26px;\n    height: 26px;\n    transition: transform .2s;\n  }\n\n  &.avatar-icon-add {\n    i {\n      line-height: 26px;\n      font-size: $font-size-base;\n    }\n  }\n\n  &:hover {\n    .avatar-icon {\n      transform: scale(2);\n    }\n  }\n}\n\n.avatar-icon {\n  border: $white solid 3px;\n  overflow: hidden;\n\n  img {\n    width: 100%;\n    height: 100%;\n  }\n}\n\n.avatar-wrapper-overlap {\n  .avatar-icon-wrapper {\n    z-index: 5;\n    margin-left: -18px;\n\n    &:hover {\n      z-index: 7;\n    }\n\n    &.avatar-icon-xl {\n      margin-left: -30px;\n    }\n    &.avatar-icon-lg {\n      margin-left: -24px;\n    }\n    &.avatar-icon-sm {\n      margin-left: -14px;\n    }\n    &.avatar-icon-xs {\n      margin-left: -10px;\n    }\n\n    &.avatar-icon-add,\n    &:first-child {\n      margin-left: 0 !important;\n    }\n  }\n}\n\n// Badge Pulse\n\n@-webkit-keyframes sploosh {\n  0% {\n    box-shadow: 0 0 0 0px rgba(#333, .2);\n  }\n  100% {\n    box-shadow: 0 0 0 8px rgba(#333, 0);\n  }\n}\n\n@-webkit-keyframes pulse {\n  0% {\n    -webkit-transform: scale(1);\n  }\n  16.5% {\n    -webkit-transform: scale(1.2);\n  }\n  33% {\n    -webkit-transform: scale(1.1);\n  }\n  100% {\n    -webkit-transform: scale(1);\n  }\n}\n\n.badge-pulse {\n  -webkit-animation: pulse 2s ease-out;\n  -webkit-animation-iteration-count: infinite;\n  position: relative;\n\n  &::before,\n  &::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    border: 0;\n\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n\n    -webkit-animation: sploosh 2s cubic-bezier(0.165, 0.84, 0.44, 1);\n    -webkit-animation-iteration-count: infinite;\n  }\n\n  &::after {\n    -webkit-animation-delay: .33s;\n    -webkit-animation-duration: 2.2s;\n  }\n}","// CARDS\n\n@use \"sass:math\";\n\n.card {\n  box-shadow: $box-shadow-default;\n  border-width: 0;\n  transition: all .2s;\n\n  & > .dropdown-menu-header {\n    margin: 0;\n\n    .dropdown-menu-header-inner {\n      @include border-top-radius($card-border-radius);\n    }\n  }\n\n  &.text-dark.text-white,\n  &.text-white {\n    .card-footer,\n    .card-header {\n      background: rgba(255, 255, 255, .1);\n      color: rgba(255, 255, 255, .9);\n    }\n  }\n\n  &.text-dark.text-white {\n    .card-footer,\n    .card-header {\n      color: rgba(0, 0, 0, .9);\n    }\n  }\n\n  .card-footer {\n    display: flex;\n    align-items: center;\n  }\n}\n\n.btn-actions-pane-right {\n  margin-left: auto;\n  white-space: nowrap;\n}\n\n.btn-actions-pane-left {\n  margin-right: auto;\n}\n\n.actions-icon-btn {\n  .btn-icon-only {\n    padding-left: 0;\n    padding-right: 0;\n\n    .btn-icon-wrapper {\n      font-size: 1.3rem;\n      width: 30px;\n      text-align: center;\n    }\n\n    color: $gray-700;\n\n    &:hover {\n      color: $primary;\n    }\n  }\n}\n\n.card-header,\n.card-title {\n  text-transform: uppercase;\n  color: rgba(darken($primary, 40%), .7);\n  font-weight: bold;\n  font-size: $font-size-base;\n}\n\n.card-header {\n  display: flex;\n  align-items: center;\n  border-bottom-width: 1px;\n  padding-top: 0;\n  padding-bottom: 0;\n  padding-right: math.div($card-spacer-x, 2);\n  height: 3.5rem;\n\n  &.no-border {\n    border: 0;\n    padding: 0;\n    height: auto;\n  }\n\n  .menu-header-subtitle {\n    display: block;\n  }\n\n  &.card-header-tab {\n    .nav {\n      width: auto;\n      margin-left: auto;\n    }\n\n    .card-header-title {\n      display: flex;\n      align-items: center;\n      white-space: nowrap;\n    }\n  }\n\n  .header-icon {\n    font-size: ($font-size-lg * 1.5);\n    margin-right: math.div($card-spacer-x, 2);\n  }\n\n  & > .nav {\n    margin-left: -(math.div($card-spacer-x, 2));\n    height: 100%;\n    width: 100%;\n\n    .nav-item {\n      position: relative;\n      height: 100%;\n      display: flex;\n      align-items: center;\n    }\n\n    .nav-link {\n      text-transform: none;\n      width: 100%;\n      display: block;\n      color: $gray-700;\n\n      &::before {\n        content: '';\n        @include border-radius(15px);\n        background: $primary;\n        transition: all .2s;\n        height: 4px;\n        width: 100%;\n        position: absolute;\n        left: 0;\n        bottom: -2px;\n        opacity: 0;\n      }\n\n      &:hover {\n        color: $primary;\n      }\n\n      &.active {\n        color: $primary;\n\n        &::before {\n          opacity: 1;\n        }\n      }\n    }\n  }\n\n  &.card-header-tab-animation {\n    .nav .nav-link {\n      &::before {\n        transform: scale(0);\n        opacity: 1;\n        width: 90%;\n        left: 5%;\n      }\n\n      &.active,\n      &:hover {\n        &::before {\n          transform: scale(1);\n        }\n      }\n    }\n  }\n}\n\n.card-border {\n  box-shadow: 0 0 0 transparent;\n  border-width: 1px;\n}\n\n.card-hover-shadow {\n  &:hover {\n    box-shadow: 0 0.46875rem 2.1875rem rgba(darken($primary, 50%), .03),\n    0 0.9375rem 1.40625rem rgba(darken($primary, 50%), .03),\n    0 0.25rem 0.53125rem rgba(darken($primary, 50%), .05),\n    0 0.125rem 0.1875rem rgba(darken($primary, 50%), .03);\n  }\n}\n\n.card-hover-shadow-2x {\n  &:hover {\n    box-shadow: 0 0.66875rem 2.3875rem rgba(darken($primary, 50%), .03),\n    0 1.1375rem 1.60625rem rgba(darken($primary, 50%), .03),\n    0 0.45rem 0.73125rem rgba(darken($primary, 50%), .05),\n    0 0.325rem 0.3875rem rgba(darken($primary, 50%), .03);\n  }\n}\n\n.card-subtitle {\n  margin-bottom: $card-spacer-y;\n  font-size: $font-size-sm;\n  color: rgba(darken($primary, 40%), .55);\n}\n\n@each $color, $value in $theme-colors {\n  .card-shadow-#{$color} {\n    box-shadow: 0 0.46875rem 2.1875rem rgba($value, .03),\n    0 0.9375rem 1.40625rem rgba($value, .03),\n    0 0.25rem 0.53125rem rgba($value, .05),\n    0 0.125rem 0.1875rem rgba($value, .03);\n  }\n}\n\n// Large Card Header\n\n.card-header-lg {\n  padding: ($card-spacer-y * 2) ($card-spacer-x * 2);\n  height: auto;\n}\n\n.sticky-active-class {\n  .sticky-inner-wrapper {\n    & > div {\n      box-shadow: $box-shadow-default;\n    }\n  }\n}","// TABS\n\n@use \"sass:math\";\n\n.nav-pills,\n.nav-tabs {\n  margin-bottom: $spacer;\n}\n\n.nav-link {\n  font-weight: bold;\n\n  &:hover {\n    cursor: pointer;\n  }\n}\n\n.nav-tabs {\n  .nav-link {\n\n    &:hover {\n      color: $primary !important;\n    }\n\n    &.active {\n      color: $primary;\n    }\n  }\n}\n\n.nav-pills {\n  .nav-link {\n\n    &:hover {\n      color: $primary !important;\n    }\n\n    &.active {\n      background: $primary;\n\n      &:hover {\n        color: $white !important;\n      }\n    }\n  }\n}\n\n// Fancy Tabs\n\n.RRT__container {\n  position: relative;\n}\n\n.RRT__tabs {\n  display: flex;\n  flex-wrap: wrap;\n  position: relative;\n}\n\n.RRT__accordion {\n  flex-direction: column;\n}\n\n.RRT__tab {\n  cursor: pointer;\n  z-index: 1;\n  white-space: nowrap;\n  padding: $nav-link-padding-y $nav-link-padding-x;\n  transition: all .2s;\n\n  &:hover {\n    color: $primary;\n  }\n\n  &:focus {\n    outline: 0;\n  }\n}\n\n.RRT__tab--selected {\n  color: $primary;\n}\n\n.RRT__tab--disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.RRT__tab:focus {\n  z-index: 2;\n}\n\n.RRT__tab--selected .RRT__removable {\n  position: relative;\n}\n\n.RRT__tab--selected .RRT__removable-text {\n  margin-right: 10px;\n}\n\n.RRT__tab--selected .RRT__removable-icon {\n  position: absolute;\n  font-size: 18px;\n  right: 0.5em;\n  top: 0.2em;\n}\n\n// Alternate Style\n\n.body-tabs.body-tabs-layout {\n  &.body-tabs-big {\n    display: flex;\n    flex-direction: row;\n    align-items: stretch;\n    @extend .container;\n    margin: 0 auto;\n    padding: 10px;\n    @include border-radius(50px);\n    border: $gray-200 solid 1px;\n    z-index: 7;\n\n    .RRT__tab {\n      margin: 0;\n      font-size: 1rem;\n      font-weight: 300;\n      padding: 0;\n      height: 50px;\n      line-height: 50px;\n      flex: 1;\n      text-align: center;\n      position: relative;\n      color: $primary;\n\n      &:hover {\n        color: $gray-900;\n      }\n\n      &.RRT__tab--selected {\n        color: $white;\n\n        &:hover {\n          color: $white;\n        }\n      }\n    }\n\n    & + .RRT__inkbar-wrapper {\n      height: 70px !important;\n      top: -70px !important;\n      @extend .container;\n      margin: 0 auto -3.4rem;\n      position: relative;\n      padding: 0 10px;\n\n      &::before {\n        position: absolute;\n        content: '';\n        background: $white;\n        width: 100%;\n        height: 100%;\n        left: 0;\n        top: -11px;\n        @include border-radius(50px);\n      }\n\n      .RRT__inkbar {\n        height: 50px !important;\n        margin-top: 10px;\n        @include border-radius(50px);\n        box-shadow: 0 0 0 transparent;\n      }\n\n      & + .RRT__panel {\n        margin-top: -1rem;\n      }\n    }\n  }\n}\n\n// Panels\n\n.RRT__panel {\n  margin-top: $spacer;\n}\n\n.RRT__accordion .RRT__panel {\n}\n\n// Show More\n\n.RRT__showmore {\n  @include border-radius($border-radius);\n  background: $primary;\n  cursor: pointer;\n  z-index: 1;\n  white-space: nowrap;\n  font-weight: bold;\n  width: 36px;\n  text-align: center;\n  height: 36px;\n  display: block;\n  margin-left: 15px;\n  position: absolute;\n  right: $grid-gutter-width;\n  top: 50%;\n  margin-top: -18px;\n  font-size: 1.4rem;\n\n  &:focus {\n    outline: none;\n\n  }\n}\n\n.RRT__showmore-label {\n  position: relative;\n  z-index: 1;\n  color: $white;\n  width: 36px;\n  text-align: center;\n  height: 36px;\n  line-height: 24px;\n}\n\n.RRT__showmore--selected {\n  box-shadow: 0 16px 26px -10px rgba($primary, 0.56),\n  0 4px 25px 0px rgba(0, 0, 0, 0.12),\n  0 8px 10px -5px rgba($primary, 0.2);\n}\n\n.RRT__showmore-list {\n  position: absolute;\n  right: -1px;\n  top: 100%;\n  display: none;\n  min-width: $dropdown-min-width;\n  padding: $dropdown-padding-y 0;\n  margin: $dropdown-spacer 0 0; // override default ul\n  font-size: $font-size-base; // Redeclare because nesting can cause inheritance issues\n  color: $body-color;\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: $dropdown-bg;\n  background-clip: padding-box;\n  border: $dropdown-border-width solid $dropdown-border-color;\n  @include border-radius($dropdown-border-radius);\n  box-shadow: $box-shadow-default;\n\n  .RRT__tab {\n    display: block;\n    width: 100%; // For `<button>`s\n    padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n    clear: both;\n    font-weight: $font-weight-normal;\n    color: $dropdown-link-color;\n    text-align: inherit; // For `<button>`s\n    white-space: nowrap; // prevent links from randomly breaking onto new lines\n    background-color: transparent; // For `<button>`s\n    border: 0; // For `<button>`s\n    margin: 0;\n\n    &:hover,\n    &.RRT__tab--selected {\n      color: $dropdown-link-hover-color !important;\n      text-decoration: none;\n      background: $dropdown-link-hover-bg;\n    }\n  }\n}\n\n.RRT__showmore-list--opened {\n  display: block;\n\n  .RRT__tab--selected {\n    color: $primary;\n  }\n}\n\n// Inkbar\n\n.RRT__inkbar-wrapper {\n  width: 100%;\n}\n\n.RRT__inkbar {\n  position: relative;\n  bottom: 0;\n  height: 3px;\n  margin-top: -3px;\n  background-color: $primary;\n  @include border-radius(15px);\n  transition: all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1) 0s;\n  z-index: 2;\n}\n\n.card-tabs {\n  .card-header {\n    padding: 0 1.25rem;\n\n    &.RRT__tabs {\n      cursor: pointer;\n      font-weight: normal;\n\n      .RRT__tab {\n        text-transform: none;\n        line-height: 1.3;\n      }\n    }\n  }\n\n  .RRT__inkbar-wrapper {\n    width: calc(100% - 1.5rem) !important;\n    margin-left: 1.25rem;\n  }\n\n  .RRT__panel {\n    padding: $spacer;\n    margin: 0;\n  }\n\n  &.text-white {\n\n    .RRT__tab {\n      color: rgba(255, 255, 255, .6);\n\n      &:hover {\n        color: $white;\n      }\n    }\n\n    .RRT__tab--selected {\n      color: $white;\n    }\n\n    .RRT__inkbar {\n      background: lighten($primary, 40%);\n    }\n  }\n}\n\n.card-tabs-animated {\n  .RRT__container > .RRT__tabs {\n    background: transparent;\n    position: relative;\n    z-index: 7;\n\n    &.card-header {\n      border-bottom: 0;\n      height: auto;\n      padding: $layout-spacer-x $layout-spacer-x math.div($layout-spacer-x, 3);\n    }\n  }\n\n  .RRT__inkbar-wrapper {\n    position: absolute;\n    top: $layout-spacer-x;\n    z-index: 5;\n  }\n\n  .RRT__tab {\n    padding: $nav-link-padding-y ($nav-link-padding-x * 1.2);\n  }\n\n  .RRT__tab--selected {\n    color: $white;\n  }\n\n  .RRT__inkbar {\n    height: 35px;\n    margin-top: 0;\n    @include border-radius($border-radius);\n    box-shadow: 0 16px 26px -10px rgba($primary, 0.56),\n    0 4px 25px 0px rgba(0, 0, 0, 0.12),\n    0 8px 10px -5px rgba($primary, 0.2);\n  }\n}\n\n.card-tabs-animated-inner {\n  .RRT__tabs {\n    padding: 0 5%;\n  }\n\n  .RRT__inkbar-wrapper {\n    left: 5%;\n    width: 90%;\n    height: 36px;\n    top: 14px;\n  }\n\n  .RRT__inkbar {\n    height: 36px;\n  }\n}\n\n.body-tabs {\n  border-bottom: $gray-300 solid 2px;\n\n  & > .RRT__tab {\n    padding: math.div($layout-spacer-x, 1.5) math.div($layout-spacer-x, 1.2);\n    font-weight: normal;\n    font-size: $font-size-base;\n  }\n\n  &.body-tabs-alt {\n    & > .RRT__tab {\n      padding: math.div($layout-spacer-x, 1.1) math.div($layout-spacer-x, 3);\n      font-weight: normal;\n      font-size: 0.86rem;\n      width: 33%;\n      text-align: center;\n    }\n\n    .RRT__inkbar {\n      height: 2px;\n      margin-top: -2px;\n    }\n  }\n}\n\n.popover,\n.dropdown-menu {\n  .RRT__panel {\n    margin: 0;\n    padding: 0;\n    position: relative;\n\n    &::after,\n    &::before {\n      width: 100%;\n      bottom: auto;\n      top: 0;\n      left: 0;\n      height: 20px;\n      position: absolute;\n      z-index: 10;\n      content: '';\n      background: linear-gradient(to bottom, rgba(255, 255, 255, 1) 20%, rgba(255, 255, 255, 0) 100%);\n      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffff', endColorstr='#00ffffff', GradientType=0);\n    }\n\n    &::after {\n      bottom: 0;\n      top: auto;\n\n      background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 80%);\n      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00ffffff', endColorstr='#ffffff', GradientType=0);\n    }\n  }\n}\n\n// Tabs alternate\n\n.tabs-lg-alternate {\n  &.card-header {\n    padding: 0;\n    height: auto;\n\n    .widget-number {\n      font-size: $h2-font-size;\n      font-weight: 300;\n    }\n\n    .tab-subheading {\n      padding: 5px 0 0;\n      opacity: .6;\n      transition: all .2s;\n    }\n\n    & > .nav {\n      margin: 0;\n\n      .nav-link {\n        padding: $layout-spacer-x 0;\n        border-right: $gray-200 solid 1px;\n        background: $gray-100;\n\n        &:hover {\n          background: $white;\n          .tab-subheading {\n            color: $black;\n            opacity: .9;\n          }\n        }\n\n        &::before {\n          background: $white;\n          border-radius: 0;\n        }\n\n        &.active {\n          background: $white;\n\n          .tab-subheading {\n            color: $black;\n            opacity: .9;\n          }\n        }\n      }\n\n      .nav-item:last-child {\n        .nav-link {\n          border-right: 0;\n        }\n      }\n    }\n  }\n}\n","// Accordions\n\n.accordion-wrapper {\n  @include border-radius($border-radius);\n  border: $gray-200 solid 1px;\n\n  & > .card {\n    box-shadow: 0 0 0 0 transparent;\n\n    & > .card-header {\n      padding: 1rem;\n      height: auto;\n\n      .btn:active,\n      .btn:focus,\n      .btn:hover {\n        text-decoration: none;\n      }\n\n      .form-heading {\n        p {\n          margin: 0;\n        }\n      }\n    }\n\n    .collapse {\n      border-bottom: transparent solid 1px;\n\n      &.show {\n        border-bottom-color: $gray-200;\n      }\n    }\n  }\n}","// Modals\n\n.modal-header,\n.modal-footer {\n  background: $gray-100;\n}\n\n.modal-footer {\n  @include border-bottom-radius($border-radius);\n}\n\n.modal-dialog {\n  box-shadow: $box-shadow-lg-default;\n  @include border-radius($border-radius);\n}","$primary-color: $primary !default;\n$ball-size: 15px !default;\n$margin: 2px !default;\n$line-height: 35px !default;\n$line-width: 4px !default;\n\n\n@mixin global-bg() {\n  background-color: $primary-color;\n}\n\n@mixin global-animation() {\n  animation-fill-mode: both;\n}\n\n@mixin balls() {\n  @include global-bg();\n\n  width: $ball-size;\n  height: $ball-size;\n  border-radius: 100%;\n  margin: $margin;\n}\n\n@mixin lines() {\n  @include global-bg();\n\n  width: $line-width;\n  height: $line-height;\n  border-radius: 2px;\n  margin: $margin;\n}\n\n\n/**\n * Dots\n */\n@import '../../../node_modules/loaders.css/src/animations/ball-pulse';\n@import '../../../node_modules/loaders.css/src/animations/ball-pulse-sync';\n@import '../../../node_modules/loaders.css/src/animations/ball-scale';\n@import '../../../node_modules/loaders.css/src/animations/ball-rotate';\n@import '../../../node_modules/loaders.css/src/animations/ball-clip-rotate';\n@import '../../../node_modules/loaders.css/src/animations/ball-clip-rotate-pulse';\n@import '../../../node_modules/loaders.css/src/animations/ball-clip-rotate-multiple';\n@import '../../../node_modules/loaders.css/src/animations/ball-scale-ripple';\n@import '../../../node_modules/loaders.css/src/animations/ball-scale-ripple-multiple';\n@import '../../../node_modules/loaders.css/src/animations/ball-beat';\n@import '../../../node_modules/loaders.css/src/animations/ball-scale-multiple';\n@import '../../../node_modules/loaders.css/src/animations/ball-triangle-trace';\n@import '../../../node_modules/loaders.css/src/animations/ball-pulse-rise';\n@import '../../../node_modules/loaders.css/src/animations/ball-grid-beat';\n@import '../../../node_modules/loaders.css/src/animations/ball-grid-pulse';\n@import '../../../node_modules/loaders.css/src/animations/ball-spin-fade-loader';\n@import '../../../node_modules/loaders.css/src/animations/ball-spin-loader';\n@import '../../../node_modules/loaders.css/src/animations/ball-zig-zag';\n@import '../../../node_modules/loaders.css/src/animations/ball-zig-zag-deflect';\n\n/**\n * Lines\n */\n@import '../../../node_modules/loaders.css/src/animations/line-scale';\n@import '../../../node_modules/loaders.css/src/animations/line-scale-random';\n@import '../../../node_modules/loaders.css/src/animations/line-scale-pulse-out';\n@import '../../../node_modules/loaders.css/src/animations/line-scale-pulse-out-rapid';\n@import '../../../node_modules/loaders.css/src/animations/line-spin-fade-loader';\n\n/**\n * Misc\n */\n@import '../../../node_modules/loaders.css/src/animations/triangle-skew-spin';\n@import '../../../node_modules/loaders.css/src/animations/square-spin';\n@import '../../../node_modules/loaders.css/src/animations/pacman';\n@import '../../../node_modules/loaders.css/src/animations/cube-transition';\n@import '../../../node_modules/loaders.css/src/animations/semi-circle-spin';\n","@import '../variables';\n@import '../mixins';\n@import '../functions';\n\n@keyframes scale {\n  0% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  45% {\n    transform: scale(0.1);\n    opacity: 0.7;\n  }\n  80% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n// mixins should be separated out\n@mixin ball-pulse($n:3, $start:0) {\n  @for $i from $start through $n {\n    > div:nth-child(#{$i}) {\n      animation: scale 0.75s delay(0.12s, $n, $i) infinite cubic-bezier(.2,.68,.18,1.08);\n    }\n  }\n}\n\n.ball-pulse {\n  @include ball-pulse();\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    display: inline-block;\n  }\n}\n","@mixin global-bg() {\n  background-color: $primary-color;\n}\n\n@mixin global-animation() {\n  animation-fill-mode: both;\n}\n\n@mixin balls() {\n  @include global-bg();\n\n  width: $ball-size;\n  height: $ball-size;\n  border-radius: 100%;\n  margin: $margin;\n}\n\n@mixin lines() {\n  @include global-bg();\n\n  width: $line-width;\n  height: $line-height;\n  border-radius: 2px;\n  margin: $margin;\n}\n","@import '../variables';\n@import '../mixins';\n@import '../functions';\n\n$amount: 10px;\n\n@keyframes ball-pulse-sync {\n  33% {\n    transform: translateY($amount);\n  }\n  66% {\n    transform: translateY(-$amount);\n  }\n  100% {\n    transform: translateY(0);\n  }\n}\n\n@mixin ball-pulse-sync($n:3, $start:0) {\n  @for $i from $start through $n {\n    > div:nth-child(#{$i}) {\n      animation: ball-pulse-sync 0.6s delay(0.07s, $n, $i) infinite ease-in-out;\n    }\n  }\n}\n\n.ball-pulse-sync {\n  @include ball-pulse-sync();\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    display: inline-block;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n@keyframes ball-scale {\n  0% {\n    transform: scale(0.0);\n  }\n  100% {\n    transform: scale(1.0);\n    opacity: 0;\n  }\n}\n\n.ball-scale {\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    display: inline-block;\n    height: 60px;\n    width: 60px;\n    animation: ball-scale 1s 0s ease-in-out infinite;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n@keyframes rotate {\n  0% {\n    transform: rotate(0deg);\n  }\n  50% {\n    transform: rotate(180deg);\n  }\n  100% {\n    transform: rotate(360deg);\n }\n}\n\n.ball-rotate {\n  position: relative;\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    position: relative;\n\n    &:first-child {\n      animation: rotate 1s 0s cubic-bezier(.7,-.13,.22,.86) infinite;\n    }\n\n    &:before, &:after {\n      @include balls();\n\n      content: \"\";\n      position: absolute;\n      opacity: 0.8;\n    }\n\n    &:before {\n      top: 0px;\n      left: -28px;\n    }\n\n    &:after {\n      top: 0px;\n      left: 25px;\n    }\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n@keyframes rotate {\n  0% {\n    transform: rotate(0deg) scale(1);\n  }\n  50% {\n    transform: rotate(180deg) scale(0.6);\n  }\n  100% {\n   transform: rotate(360deg) scale(1);\n }\n}\n\n.ball-clip-rotate {\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    border: 2px solid $primary-color;\n    border-bottom-color: transparent;\n    height: 25px;\n    width: 25px;\n    background: transparent !important;\n    display: inline-block;\n    animation: rotate 0.75s 0s linear infinite;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n@keyframes rotate {\n  0% {\n    transform: rotate(0deg) scale(1);\n  }\n  50% {\n    transform: rotate(180deg) scale(0.6);\n  }\n  100% {\n   transform: rotate(360deg) scale(1);\n }\n}\n\n@keyframes scale {\n  30% {\n    transform: scale(0.3);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n.ball-clip-rotate-pulse {\n  position: relative;\n  transform: translateY(-15px);\n\n  > div {\n    @include global-animation();\n\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    border-radius: 100%;\n\n    &:first-child {\n      background: $primary-color;\n      height: 16px;\n      width: 16px;\n      top: 7px;\n      left: -7px;\n      animation: scale 1s 0s cubic-bezier(.09,.57,.49,.9) infinite;\n    }\n\n    &:last-child {\n      position: absolute;\n      border: 2px solid $primary-color;\n      width: 30px;\n      height: 30px;  \n      left: -16px;\n      top: -2px;\n      background: transparent;\n      border: 2px solid;\n      border-color: $primary-color transparent $primary-color transparent;\n      animation: rotate 1s 0s cubic-bezier(.09,.57,.49,.9) infinite;\n      animation-duration: 1s;\n    }\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n@keyframes rotate {\n  0% {\n    transform: rotate(0deg) scale(1);\n  }\n  50% {\n    transform: rotate(180deg) scale(0.6);\n  }\n  100% {\n   transform: rotate(360deg) scale(1);\n }\n}\n\n.ball-clip-rotate-multiple {\n  position: relative;\n\n  > div {\n    @include global-animation();\n\n    position: absolute;\n    left: -20px;\n    top: -20px;\n    border: 2px solid $primary-color;\n    border-bottom-color: transparent;\n    border-top-color: transparent;\n    border-radius: 100%;\n    height: 35px;\n    width: 35px;\n    animation: rotate 1s 0s ease-in-out infinite;\n\n    &:last-child {\n      display: inline-block;\n      top: -10px;\n      left: -10px;\n      width: 15px;\n      height: 15px;\n      animation-duration: 0.5s;\n      border-color: $primary-color transparent $primary-color transparent;\n      animation-direction: reverse;\n    }\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n@keyframes ball-scale-ripple {\n  0% {\n    transform: scale(0.1);\n    opacity: 1;\n  }\n  70% {\n    transform: scale(1);\n    opacity: 0.7;\n  }\n  100% {\n    opacity: 0.0;\n  }\n}\n\n.ball-scale-ripple {\n\n  > div {\n    @include global-animation();\n\n    height: 50px;\n    width: 50px;\n    border-radius: 100%;\n    border: 2px solid $primary-color;;\n    animation: ball-scale-ripple 1s 0s infinite cubic-bezier(.21,.53,.56,.8);\n  }\n}\n","@import '../variables';\n@import '../mixins';\n@import '../functions';\n\n$size: 50px;\n\n@keyframes ball-scale-ripple-multiple {\n  0% {\n    transform: scale(0.1);\n    opacity: 1;\n  }\n  70% {\n    transform: scale(1);\n    opacity: 0.7;\n  }\n  100% {\n    opacity: 0.0;\n  }\n}\n\n@mixin ball-scale-ripple-multiple ($n:3, $start:0) {\n  @for $i from $start through $n {\n    > div:nth-child(#{$i}) {\n      animation-delay: delay(0.2s, $n, $i - 1);\n    }\n  }\n}\n\n.ball-scale-ripple-multiple {\n  @include ball-scale-ripple-multiple();\n\n  position: relative;\n  transform: translateY(-$size / 2);\n\n  > div {\n    @include global-animation();\n\n    position: absolute;\n    top: -2px;\n    left: -26px;\n    width: $size;\n    height: $size;\n    border-radius: 100%;\n    border: 2px solid $primary-color;\n    animation: ball-scale-ripple-multiple 1.25s 0s infinite cubic-bezier(.21,.53,.56,.8);\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n@keyframes ball-beat {\n  50% {\n    opacity: 0.2;\n    transform: scale(0.75);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.ball-beat {\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    display: inline-block;\n    animation: ball-beat 0.7s 0s infinite linear;\n\n    &:nth-child(2n-1) {\n      animation-delay: -0.35s !important;\n    }\n  }\n}\n","@import '../variables';\n@import '../mixins';\n@import '../functions';\n\n$size: 60px;\n\n@keyframes ball-scale-multiple {\n  0% {\n    transform: scale(0.0);\n    opacity: 0;\n  }\n  5% {\n    opacity: 1;\n  }\n  100% {\n    transform: scale(1.0);\n    opacity: 0;\n  }\n}\n\n@mixin ball-scale-multiple ($n:3, $start:0) {\n  @for $i from 2 through $n {\n    > div:nth-child(#{$i}) {\n      animation-delay: delay(0.2s, $n, $i - 1);\n    }\n  }\n}\n\n.ball-scale-multiple {\n  @include ball-scale-multiple();\n\n  position: relative;\n  transform: translateY(-$size / 2);\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    position: absolute;\n    left: -30px;\n    top: 0px;\n    opacity: 0;\n    margin: 0;\n    width: $size;\n    height: $size;\n    animation: ball-scale-multiple 1s 0s linear infinite;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n$amount: 50px;\n\n@keyframes ball-triangle-path-1 {\n  33% {\n    transform: translate($amount / 2, -$amount);\n  }\n  66% {\n    transform: translate($amount, 0px);\n  }\n  100% {\n    transform: translate(0px, 0px);\n  }\n}\n\n@keyframes ball-triangle-path-2 {\n  33% {\n    transform: translate($amount / 2, $amount);\n  }\n  66% {\n    transform: translate(- $amount / 2, $amount);\n  }\n  100% {\n    transform: translate(0px, 0px);\n  }\n}\n\n@keyframes ball-triangle-path-3 {\n  33% {\n    transform: translate(-$amount, 0px);\n  }\n  66% {\n    transform: translate(- $amount / 2, -$amount);\n  }\n  100% {\n    transform: translate(0px, 0px);\n  }\n}\n\n@mixin ball-triangle-path($n:3) {\n  $animations: ball-triangle-path-1 ball-triangle-path-2 ball-triangle-path-3;\n\n  @for $i from 1 through $n {\n    > div:nth-child(#{$i}) {\n      animation-name: nth($animations, $i);\n      animation-delay: 0;\n      animation-duration: 2s;\n      animation-timing-function: ease-in-out;\n      animation-iteration-count: infinite;\n    }\n  }\n}\n\n.ball-triangle-path {\n  position: relative;\n  @include ball-triangle-path();\n  transform: translate(-$amount / 1.667, -$amount / 1.333);\n\n  > div {\n    @include global-animation();\n\n    position: absolute;\n    width: 10px;\n    height: 10px;\n    border-radius: 100%;\n    border: 1px solid $primary-color;\n\n    &:nth-of-type(1) {\n      top: $amount;\n    }\n\n    &:nth-of-type(2) {\n      left: $amount / 2;\n    }\n\n    &:nth-of-type(3) {\n      top: $amount;\n      left: $amount;\n    }\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n$rise-amount: 30px;\n\n@keyframes ball-pulse-rise-even {\n  0% {\n    transform: scale(1.1);\n  }\n  25% {\n    transform: translateY(-$rise-amount);\n  }\n  50% {\n    transform: scale(0.4);\n  }\n  75% {\n    transform: translateY($rise-amount);\n  }\n  100% {\n    transform: translateY(0);\n    transform: scale(1.0);\n  }\n}\n\n@keyframes ball-pulse-rise-odd {\n  0% {\n    transform: scale(0.4);\n  }\n  25% {\n    transform: translateY($rise-amount);\n  }\n  50% {\n    transform: scale(1.1);\n  }\n  75% {\n    transform: translateY(-$rise-amount);\n  }\n  100% {\n    transform: translateY(0);\n    transform: scale(0.75);\n  }\n}\n\n.ball-pulse-rise {\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    display: inline-block;\n    animation-duration: 1s;\n    animation-timing-function: cubic-bezier(.15,.46,.9,.6);\n    animation-iteration-count: infinite;\n    animation-delay: 0;\n\n    &:nth-child(2n) {\n      animation-name: ball-pulse-rise-even;\n    }\n\n    &:nth-child(2n-1) {\n      animation-name: ball-pulse-rise-odd;\n    }\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n@keyframes ball-grid-beat {\n  50% {\n    opacity: 0.7;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@mixin ball-grid-beat($n:9) {\n  @for $i from 1 through $n {\n    > div:nth-child(#{$i}) {\n      animation-delay: ((random(100) / 100) - 0.2) + s;\n      animation-duration: ((random(100) / 100) + 0.6) + s;\n    }\n  }\n\n}\n\n.ball-grid-beat {\n  @include ball-grid-beat();\n  width: ($ball-size * 3) + $margin * 6;\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    display: inline-block;\n    float: left;\n    animation-name: ball-grid-beat;\n    animation-iteration-count: infinite;\n    animation-delay: 0;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n@keyframes ball-grid-pulse {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(0.5);\n    opacity: 0.7;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n@mixin ball-grid-pulse($n:9) {\n  @for $i from 1 through $n {\n    > div:nth-child(#{$i}) {\n      animation-delay: ((random(100) / 100) - 0.2) + s;\n      animation-duration: ((random(100) / 100) + 0.6) + s;\n    }\n  }\n\n}\n\n.ball-grid-pulse {\n  @include ball-grid-pulse();\n  width: ($ball-size * 3) + $margin * 6;\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    display: inline-block;\n    float: left;\n    animation-name: ball-grid-pulse;\n    animation-iteration-count: infinite;\n    animation-delay: 0;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n@import '../functions';\n\n$radius: 25px;\n\n@keyframes ball-spin-fade-loader {\n  50% {\n    opacity: 0.3;\n    transform: scale(0.4);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@mixin ball-spin-fade-loader($n:8, $start:1) {\n  @for $i from $start through $n {\n    > div:nth-child(#{$i}) {\n      $iter: 360 / $n;\n      $quarter: ($radius / 2) + ($radius / 5.5);\n\n      @if $i == 1 {\n        top: $radius;\n        left: 0;\n      } @else if $i == 2 {\n        top: $quarter;\n        left: $quarter;\n      } @else if $i == 3 {\n        top: 0;\n        left: $radius;\n      } @else if $i == 4 {\n        top: -$quarter;\n        left: $quarter;\n      } @else if $i == 5 {\n        top: -$radius;\n        left: 0;\n      } @else if $i == 6 {\n        top: -$quarter;\n        left: -$quarter;\n      } @else if $i == 7 {\n        top: 0;\n        left: -$radius;\n      } @else if $i == 8 {\n        top: $quarter;\n        left: -$quarter;\n      }\n\n      animation: ball-spin-fade-loader 1s delay(0.12s, $n, $i - 1) infinite linear;\n    }\n  }\n}\n\n.ball-spin-fade-loader {\n  @include ball-spin-fade-loader();\n\n  position: relative;\n  top: -10px;\n  left: -10px;\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    position: absolute;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n$radius: 45px;\n\n@keyframes ball-spin-loader {\n  75% {\n    opacity: 0.2;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@mixin ball-spin-loader($n:8, $start:1) {\n  @for $i from $start through $n {\n    > span:nth-child(#{$i}) {\n      $iter: 360 / $n;\n      $quarter: ($radius / 2) + ($radius / 5.5);\n\n      @if $i == 1 {\n        top: $radius;\n        left: 0;\n      } @else if $i == 2 {\n        top: $quarter;\n        left: $quarter;\n      } @else if $i == 3 {\n        top: 0;\n        left: $radius;\n      } @else if $i == 4 {\n        top: -$quarter;\n        left: $quarter;\n      } @else if $i == 5 {\n        top: -$radius;\n        left: 0;\n      } @else if $i == 6 {\n        top: -$quarter;\n        left: -$quarter;\n      } @else if $i == 7 {\n        top: 0;\n        left: -$radius;\n      } @else if $i == 8 {\n        top: $quarter;\n        left: -$quarter;\n      }\n\n      animation: ball-spin-loader 2s ($i * 0.9s) infinite linear;\n    }\n  }\n}\n\n.ball-spin-loader {\n  @include ball-spin-loader();\n  position: relative;\n\n  > div {\n    @include global-animation();\n\n    position: absolute;\n    width: 15px;\n    height: 15px;\n    border-radius: 100%;\n    background: green;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n$amount: 30px;\n\n@keyframes ball-zig {\n  33% {\n    transform: translate(-$amount/2, -$amount);\n  }\n  66% {\n    transform: translate($amount/2, -$amount);\n  }\n  100% {\n    transform: translate(0, 0);\n  }\n}\n\n@keyframes ball-zag {\n  33% {\n    transform: translate($amount/2, $amount);\n  }\n  66% {\n    transform: translate(-$amount/2, $amount);\n  }\n  100% {\n    transform: translate(0, 0);\n  }\n}\n\n.ball-zig-zag {\n  position: relative;\n  transform: translate(-$amount / 2, -$amount / 2);\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    position: absolute;\n    margin-left: $amount / 2;\n    top: 4px;\n    left: -7px;\n\n    &:first-child {\n      animation: ball-zig 0.7s 0s infinite linear;\n    }\n\n    &:last-child {\n      animation: ball-zag 0.7s 0s infinite linear;\n    }\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n$amount: 30px;\n\n@keyframes ball-zig-deflect {\n  17% {\n    transform: translate(-$amount/2, -$amount);\n  }\n  34% {\n    transform: translate($amount/2, -$amount);\n  }\n  50% {\n    transform: translate(0, 0);\n  }\n  67% {\n    transform: translate($amount/2, -$amount);\n  }\n  84% {\n    transform: translate(-$amount/2, -$amount);\n  }\n  100% {\n    transform: translate(0, 0);\n  }\n}\n\n@keyframes ball-zag-deflect {\n  17% {\n    transform: translate($amount/2, $amount);\n  }\n  34% {\n    transform: translate(-$amount/2, $amount);\n  }\n  50% {\n    transform: translate(0, 0);\n  }\n  67% {\n    transform: translate(-$amount/2, $amount);\n  }\n  84% {\n    transform: translate($amount/2, $amount);\n  }\n  100% {\n    transform: translate(0, 0);\n  }\n}\n\n.ball-zig-zag-deflect {\n  position: relative;\n  transform: translate(-$amount / 2, -$amount / 2);\n\n  > div {\n    @include balls();\n    @include global-animation();\n\n    position: absolute;\n    margin-left: $amount / 2;\n    top: 4px;\n    left: -7px;\n\n    &:first-child {\n      animation: ball-zig-deflect 1.5s 0s infinite linear;\n    }\n\n    &:last-child {\n      animation: ball-zag-deflect 1.5s 0s infinite linear;\n    }\n  }\n}\n\n","@import '../variables';\n@import '../mixins';\n@import '../functions';\n\n@keyframes line-scale {\n  0% {\n    transform: scaley(1.0);\n  }\n  50% {\n    transform: scaley(0.4);\n  }\n  100% {\n    transform: scaley(1.0);\n  }\n}\n\n@mixin line-scale($n:5) {\n  @for $i from 1 through $n {\n    > div:nth-child(#{$i}) {\n      animation: line-scale 1s delay(0.1s, $n, $i) infinite cubic-bezier(.2,.68,.18,1.08);\n    }\n  }\n}\n\n.line-scale {\n  @include line-scale();\n\n  > div {\n    @include lines();\n    @include global-animation();\n\n    display: inline-block;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n@keyframes line-scale-party {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    $random: 0.5;\n    transform: scale($random);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n@mixin line-scale-party($n:4) {\n  @for $i from 1 through $n {\n    > div:nth-child(#{$i}) {\n      animation-delay: ((random(100) / 100) - 0.2) + s;\n      animation-duration: ((random(100) / 100) + 0.3) + s;\n    }\n  }\n}\n\n.line-scale-party {\n  @include line-scale-party();\n\n  > div {\n    @include lines();\n    @include global-animation();\n\n    display: inline-block;\n    animation-name: line-scale-party;\n    animation-iteration-count: infinite;\n    animation-delay: 0;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n@import '../functions';\n\n@keyframes line-scale-pulse-out {\n  0% {\n    transform: scaley(1.0);\n  }\n  50% {\n    transform: scaley(0.4);\n  }\n  100% {\n    transform: scaley(1.0);\n  }\n}\n\n.line-scale-pulse-out {\n\n  > div {\n    @include lines();\n    @include global-animation();\n\n    display: inline-block;\n    animation: line-scale-pulse-out 0.9s delay(0.2s, 3, 0) infinite cubic-bezier(.85,.25,.37,.85);\n\n    &:nth-child(2), &:nth-child(4) {\n      animation-delay: delay(0.2s, 3, 1) !important;\n    }\n\n    &:nth-child(1), &:nth-child(5) {\n      animation-delay: delay(0.2s, 3, 2) !important;\n    }\n\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n@keyframes line-scale-pulse-out-rapid {\n  0% {\n    transform: scaley(1.0);\n  }\n  80% {\n    transform: scaley(0.3);\n  }\n  90% {\n    transform: scaley(1.0);\n  }\n}\n\n.line-scale-pulse-out-rapid {\n\n  > div {\n    @include lines();\n    @include global-animation();\n\n    display: inline-block;\n    vertical-align: middle;\n    animation: line-scale-pulse-out-rapid 0.9s -0.5s infinite cubic-bezier(.11,.49,.38,.78);\n\n    &:nth-child(2), &:nth-child(4) {\n      animation-delay: -0.25s !important;\n    }\n\n    &:nth-child(1), &:nth-child(5) {\n      animation-delay: 0s !important;\n    }\n  }\n}\n","@import '../variables';\n@import '../mixins';\n@import '../functions';\n\n$radius: 20px;\n\n@keyframes line-spin-fade-loader {\n  50% {\n    opacity: 0.3;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@mixin line-spin-fade-loader($n:8, $start:1) {\n  @for $i from $start through $n {\n    > div:nth-child(#{$i}) {\n      $iter: 360 / $n;\n      $quarter: ($radius / 2) + ($radius / 5.5);\n\n      @if $i == 1 {\n        top: $radius;\n        left: 0;\n      } @else if $i == 2 {\n        top: $quarter;\n        left: $quarter;\n        transform: rotate(-45deg);\n      } @else if $i == 3 {\n        top: 0;\n        left: $radius;\n        transform: rotate(90deg);\n      } @else if $i == 4 {\n        top: -$quarter;\n        left: $quarter;\n        transform: rotate(45deg);\n      } @else if $i == 5 {\n        top: -$radius;\n        left: 0;\n      } @else if $i == 6 {\n        top: -$quarter;\n        left: -$quarter;\n        transform: rotate(-45deg);\n      } @else if $i == 7 {\n        top: 0;\n        left: -$radius;\n        transform: rotate(90deg);\n      } @else if $i == 8 {\n        top: $quarter;\n        left: -$quarter;\n        transform: rotate(45deg);\n      }\n\n      animation: line-spin-fade-loader 1.2s delay(0.12s, $n, $i) infinite ease-in-out;\n    }\n  }\n}\n\n.line-spin-fade-loader {\n  @include line-spin-fade-loader();\n  position: relative;\n  top: -10px;\n  left: -4px;\n\n  > div {\n    @include lines();\n    @include global-animation();\n\n    position: absolute;\n    width: 5px;\n    height: 15px;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n$size: 20px;\n\n@keyframes triangle-skew-spin {\n  25% {\n    transform: perspective(100px) rotateX(180deg) rotateY(0);\n  }\n  50% {\n    transform: perspective(100px) rotateX(180deg) rotateY(180deg);\n  }\n  75% {\n    transform: perspective(100px) rotateX(0) rotateY(180deg);\n  }\n  100% {\n    transform: perspective(100px) rotateX(0) rotateY(0);\n  }\n}\n\n.triangle-skew-spin {\n\n  > div {\n    @include global-animation();\n\n    width: 0;\n    height: 0;\n    border-left: $size solid transparent;\n    border-right: $size solid transparent;\n    border-bottom: $size solid $primary-color;\n    animation: triangle-skew-spin 3s 0s cubic-bezier(.09,.57,.49,.9) infinite;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n@keyframes square-spin {\n  25% {\n    transform: perspective(100px) rotateX(180deg) rotateY(0);\n  }\n  50% {\n    transform: perspective(100px) rotateX(180deg) rotateY(180deg);\n  }\n  75% {\n    transform: perspective(100px) rotateX(0) rotateY(180deg);\n  }\n  100% {\n    transform: perspective(100px) rotateX(0) rotateY(0);\n  }\n}\n\n.square-spin {\n\n  > div {\n    @include global-animation();\n\n    width: 50px;\n    height: 50px;\n    background: $primary-color;\n    animation: square-spin 3s 0s cubic-bezier(.09,.57,.49,.9) infinite;\n  }\n}\n","@import '../variables';\n@import '../mixins';\n@import '../functions';\n\n$size: 25px;\n\n@keyframes rotate_pacman_half_up  {\n    0% {\n         transform:rotate(270deg);\n    }\n    50% {\n         transform:rotate(360deg);\n    }\n    100% {\n         transform:rotate(270deg);\n    }\n}\n\n@keyframes rotate_pacman_half_down  {\n    0% {\n         transform:rotate(90deg);\n    }\n    50% {\n         transform:rotate(0deg);\n    }\n    100% {\n         transform:rotate(90deg);\n    }\n}\n\n@mixin pacman_design(){\n    width: 0px;\n    height: 0px;\n    border-right: $size solid transparent;\n    border-top: $size solid $primary-color;\n    border-left: $size solid $primary-color;\n    border-bottom: $size solid $primary-color;\n    border-radius: $size;\n}\n\n@keyframes pacman-balls {\n  75% {\n    opacity: 0.7;\n  }\n  100% {\n    transform: translate(-4 * $size, -$size / 4);\n  }\n}\n\n@mixin ball-placement($n:3, $start:0) {\n  @for $i from $start through $n {\n    > div:nth-child(#{$i + 2}) {\n      animation: pacman-balls 1s delay(.33s, $n, $i) infinite linear;\n    }\n  }\n}\n\n.pacman {\n  @include ball-placement();\n\n  position: relative;\n\n  > div:first-of-type {\n    @include pacman_design();\n    animation: rotate_pacman_half_up 0.5s 0s infinite;\n    position: relative;\n    left: -30px;\n  }\n\n  > div:nth-child(2) {\n    @include pacman_design();\n    animation: rotate_pacman_half_down 0.5s 0s infinite;\n    margin-top: -2 * $size;\n    position: relative;\n    left: -30px;\n  }\n\n  > div:nth-child(3),\n  > div:nth-child(4),\n  > div:nth-child(5),\n  > div:nth-child(6) {\n    @include balls();\n\n    width: 10px;\n    height: 10px;\n\n    position: absolute;\n    transform: translate(0, -$size / 4);\n    top: 25px;\n    left: 70px;\n  }\n}","@import '../variables';\n@import '../mixins';\n\n$amount: 50px;\n$size: 10px;\n\n@keyframes cube-transition {\n  25% {\n    transform: translateX($amount) scale(0.5) rotate(-90deg);\n  }\n  50% {\n    transform: translate($amount, $amount) rotate(-180deg);\n  }\n  75% {\n    transform: translateY($amount) scale(0.5) rotate(-270deg);\n  }\n  100% {\n    transform: rotate(-360deg);\n  }\n}\n\n.cube-transition {\n  position: relative;\n  transform: translate(-$amount / 2, -$amount / 2);\n\n  > div {\n    @include global-animation();\n\n    width: $size;\n    height: $size;\n    position: absolute;\n    top: -5px;\n    left: -5px;\n    background-color: $primary-color;\n    animation: cube-transition 1.6s 0s infinite ease-in-out;\n\n    &:last-child {\n      animation-delay: -0.8s\n    }\n  }\n}\n","@import '../variables';\n@import '../mixins';\n\n$size: 35px;\n$pos: 30%;\n\n@keyframes spin-rotate {\n  0% {\n    transform: rotate(0deg);\n  }\n  50% {\n    transform: rotate(180deg);\n  }\n  100% {\n    transform: rotate(360deg);\n }\n}\n\n.semi-circle-spin {\n  position: relative;\n  width: $size;\n  height: $size;\n  overflow: hidden;\n\n  > div {\n    position: absolute;\n    border-width: 0px;\n    border-radius: 100%;\n    animation: spin-rotate 0.6s 0s infinite linear;\n    background-image: linear-gradient(transparent 0%, transparent (100% - $pos), $primary-color $pos, $primary-color 100%);\n    width: 100%;\n    height: 100%;\n  }\n}","// Progress Bar\n\n.progress {\n\n  .progress-bar {\n    &:last-child {\n      @include border-end-radius($progress-border-radius);\n    }\n  }\n\n  &.progress-bar-sm {\n    height: .5rem;\n  }\n\n  &.progress-bar-xs {\n    height: .3rem;\n  }\n\n  &.progress-bar-rounded {\n    @include border-radius(30px);\n  }\n\n}\n\n.progress-bar-animated-alt {\n  &.progress-bar,\n  .progress-bar {\n    position: relative;\n\n    &::after {\n      content: '';\n      opacity: 0;\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      background: $white;\n      animation: progress-active 2s ease infinite;\n    }\n  }\n}\n\n@keyframes progress-active {\n  0% {\n    opacity: .4;\n    width: 0\n  }\n  100% {\n    opacity: 0;\n    width: 100%\n  }\n}","@use \"sass:math\";\n\n.vertical-timeline {\n  width: 100%;\n  position: relative;\n  padding: ($spacer * 1.5) 0 ($spacer);\n\n  &::after {\n    content: '';\n    display: table;\n    clear: both\n  }\n\n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 67px;\n    height: 100%;\n    width: 4px;\n    background: $gray-200;\n    @include border-radius($border-radius);\n  }\n}\n\n.vertical-timeline-element {\n  position: relative;\n  margin: 0 0 ($spacer);\n\n  &:after {\n    content: \"\";\n    display: table;\n    clear: both\n  }\n\n  &:last-child {\n    margin-bottom: 0\n  }\n}\n\n.vertical-timeline-element-content {\n  position: relative;\n  margin-left: 90px;\n  font-size: $font-size-xs;\n\n  &:after {\n    content: \"\";\n    display: table;\n    clear: both\n  }\n\n  .timeline-title {\n    font-size: $font-size-xs;\n    text-transform: uppercase;\n    margin: 0 0 math.div($spacer, 2);\n    padding: 2px 0 0;\n    font-weight: bold;\n  }\n\n  p {\n    color: $gray-600;\n    margin: 0 0 math.div($spacer, 2);\n  }\n\n  .vertical-timeline-element-date {\n    display: block;\n    position: absolute;\n    left: -90px;\n    top: 0;\n    padding-right: 10px;\n    text-align: right;\n    color: $gray-500;\n    font-size: math.div($font-size-xs, 1.05);\n    white-space: nowrap;\n  }\n}\n\n.vertical-timeline-element-icon {\n  position: absolute;\n  top: 0;\n  left: 60px;\n\n  .badge-dot-xl {\n    box-shadow: 0 0 0 5px $white;\n  }\n}\n\n.vertical-timeline-element--no-children .vertical-timeline-element-content {\n  background: 0 0;\n  box-shadow: none;\n\n  &::before {\n    display: none;\n  }\n}\n\n.vertical-without-time {\n  &::before {\n    left: 11px;\n  }\n\n  .vertical-timeline-element-content {\n    margin-left: 36px;\n  }\n\n  .vertical-timeline-element-icon {\n    left: 4px;\n  }\n}\n\n.vertical-time-icons {\n  padding: ($spacer * 2) 0 0;\n\n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 14px;\n    height: 100%;\n    width: 6px;\n    background: $gray-200;\n    @include border-radius($border-radius);\n  }\n\n  .vertical-timeline-element {\n    margin-bottom: $spacer;\n  }\n\n  .vertical-timeline-element-content {\n    margin-left: 50px;\n  }\n\n  .vertical-timeline-element-icon {\n    width: 34px;\n    height: 34px;\n    left: 0;\n    top: -7px;\n\n    .timeline-icon {\n      width: 34px;\n      height: 34px;\n      background: $white;\n      @include border-radius(50px);\n      border-width: 2px;\n      border-style: solid;\n      box-shadow: 0 0 0 5px $white;\n      text-align: center;\n      display: flex;\n      align-items: center;\n      align-content: center;\n\n      i {\n        display: block;\n        font-size: 1.1rem;\n        margin: 0 auto;\n      }\n\n      svg {\n        margin: 0 auto;\n      }\n    }\n  }\n}\n\n// Simple Dots Timeline\n\n.vertical-time-simple {\n  padding: math.div($spacer, 2) 0;\n\n  .vertical-timeline-element {\n    margin: 0 0 math.div($spacer, 2);\n  }\n\n  .timeline-title {\n    font-weight: normal;\n    font-size: math.div($font-size-lg, 1.2);\n    padding: 0;\n  }\n\n  .vertical-timeline-element-icon {\n    height: 14px;\n    width: 14px;\n    background: $gray-200;\n    position: absolute;\n    left: 6px;\n    top: 2px;\n    display: block;\n    @include border-radius(20px);\n\n    &::after {\n      content: '';\n      position: absolute;\n      background: $white;\n      left: 50%;\n      top: 50%;\n      margin: -4px 0 0 -4px;\n      display: block;\n      width: 8px;\n      height: 8px;\n      @include border-radius(20px);\n    }\n  }\n\n  .timeline-title {\n    text-transform: none;\n  }\n}\n\n@mixin timeline-variant($parent, $color) {\n  #{$parent} {\n    .vertical-timeline-element-icon {\n      background: $color;\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  @include timeline-variant(\".dot-#{$color}\", $value);\n}\n\n\n// Animations\n\n.vertical-timeline--animate .vertical-timeline-element-icon.is-hidden {\n  visibility: hidden\n}\n\n.vertical-timeline--animate .vertical-timeline-element-icon.bounce-in {\n  visibility: visible;\n  animation: cd-bounce-1 .8s\n}\n\n@-webkit-keyframes cd-bounce-1 {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale(.5)\n  }\n\n  60% {\n    opacity: 1;\n    -webkit-transform: scale(1.2)\n  }\n\n  100% {\n    -webkit-transform: scale(1)\n  }\n\n}\n\n@-moz-keyframes cd-bounce-1 {\n  0% {\n    opacity: 0;\n    -moz-transform: scale(.5)\n  }\n\n  60% {\n    opacity: 1;\n    -moz-transform: scale(1.2)\n  }\n\n  100% {\n    -moz-transform: scale(1)\n  }\n\n}\n\n@keyframes cd-bounce-1 {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale(.5);\n    -moz-transform: scale(.5);\n    -ms-transform: scale(.5);\n    -o-transform: scale(.5);\n    transform: scale(.5)\n  }\n\n  60% {\n    opacity: 1;\n    -webkit-transform: scale(1.2);\n    -moz-transform: scale(1.2);\n    -ms-transform: scale(1.2);\n    -o-transform: scale(1.2);\n    transform: scale(1.2)\n  }\n\n  100% {\n    -webkit-transform: scale(1);\n    -moz-transform: scale(1);\n    -ms-transform: scale(1);\n    -o-transform: scale(1);\n    transform: scale(1)\n  }\n\n}\n\n.vertical-timeline--animate .vertical-timeline-element-content.is-hidden {\n  visibility: hidden\n}\n\n.vertical-timeline--animate .vertical-timeline-element-content.bounce-in {\n  visibility: visible;\n  -webkit-animation: cd-bounce-2 .6s;\n  -moz-animation: cd-bounce-2 .6s;\n  animation: cd-bounce-2 .6s\n}\n\n@media only screen and (min-width: 1170px) {\n  .vertical-timeline--two-columns.vertical-timeline--animate .vertical-timeline-element.vertical-timeline-element--right .vertical-timeline-element-content.bounce-in, .vertical-timeline--two-columns.vertical-timeline--animate .vertical-timeline-element:nth-child(even):not(.vertical-timeline-element--left) .vertical-timeline-element-content.bounce-in {\n    -webkit-animation: cd-bounce-2-inverse .6s;\n    -moz-animation: cd-bounce-2-inverse .6s;\n    animation: cd-bounce-2-inverse .6s\n  }\n\n}\n\n@media only screen and (max-width: 1169px) {\n  .vertical-timeline--animate .vertical-timeline-element-content.bounce-in {\n    visibility: visible;\n    -webkit-animation: cd-bounce-2-inverse .6s;\n    -moz-animation: cd-bounce-2-inverse .6s;\n    animation: cd-bounce-2-inverse .6s\n  }\n\n}\n\n@-webkit-keyframes cd-bounce-2 {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateX(-100px)\n  }\n\n  60% {\n    opacity: 1;\n    -webkit-transform: translateX(20px)\n  }\n\n  100% {\n    -webkit-transform: translateX(0)\n  }\n\n}\n\n@-moz-keyframes cd-bounce-2 {\n  0% {\n    opacity: 0;\n    -moz-transform: translateX(-100px)\n  }\n\n  60% {\n    opacity: 1;\n    -moz-transform: translateX(20px)\n  }\n\n  100% {\n    -moz-transform: translateX(0)\n  }\n\n}\n\n@keyframes cd-bounce-2 {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateX(-100px);\n    -moz-transform: translateX(-100px);\n    -ms-transform: translateX(-100px);\n    -o-transform: translateX(-100px);\n    transform: translateX(-100px)\n  }\n\n  60% {\n    opacity: 1;\n    -webkit-transform: translateX(20px);\n    -moz-transform: translateX(20px);\n    -ms-transform: translateX(20px);\n    -o-transform: translateX(20px);\n    transform: translateX(20px)\n  }\n\n  100% {\n    -webkit-transform: translateX(0);\n    -moz-transform: translateX(0);\n    -ms-transform: translateX(0);\n    -o-transform: translateX(0);\n    transform: translateX(0)\n  }\n\n}\n\n@-webkit-keyframes cd-bounce-2-inverse {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateX(100px)\n  }\n\n  60% {\n    opacity: 1;\n    -webkit-transform: translateX(-20px)\n  }\n\n  100% {\n    -webkit-transform: translateX(0)\n  }\n\n}\n\n@-moz-keyframes cd-bounce-2-inverse {\n  0% {\n    opacity: 0;\n    -moz-transform: translateX(100px)\n  }\n\n  60% {\n    opacity: 1;\n    -moz-transform: translateX(-20px)\n  }\n\n  100% {\n    -moz-transform: translateX(0)\n  }\n\n}\n\n@keyframes cd-bounce-2-inverse {\n  0% {\n    opacity: 0;\n    -webkit-transform: translateX(100px);\n    -moz-transform: translateX(100px);\n    -ms-transform: translateX(100px);\n    -o-transform: translateX(100px);\n    transform: translateX(100px)\n  }\n\n  60% {\n    opacity: 1;\n    -webkit-transform: translateX(-20px);\n    -moz-transform: translateX(-20px);\n    -ms-transform: translateX(-20px);\n    -o-transform: translateX(-20px);\n    transform: translateX(-20px)\n  }\n\n  100% {\n    -webkit-transform: translateX(0);\n    -moz-transform: translateX(0);\n    -ms-transform: translateX(0);\n    -o-transform: translateX(0);\n    transform: translateX(0)\n  }\n\n}","// List Group\n\n@use \"sass:math\";\n\n.todo-list-wrapper {\n  .todo-indicator {\n    position: absolute;\n    width: 4px;\n    height: 60%;\n    @include border-radius($border-radius-lg);\n    left: math.div($card-spacer-x, 2);\n    top: 20%;\n    opacity: .6;\n    transition: opacity .2s;\n  }\n\n  .list-group-item {\n    &:hover {\n      .todo-indicator {\n        opacity: .9;\n      }\n    }\n  }\n\n  .custom-control,\n  input[checkbox] {\n    margin-left: math.div($card-spacer-x, 2);\n  }\n}\n\n.list-group-flush + .card-footer {\n  border-top: 0;\n}\n\n.rm-list-borders {\n  .list-group-item {\n    border: 0;\n    padding: math.div($card-spacer-y, 1.5) 0;\n  }\n}\n\n.rm-list-borders-scroll {\n  .list-group-item {\n    border: 0;\n    padding-right: ($card-spacer-y * 1.5);\n  }\n}","// Input groups\n\n.input-group {\n  .input-group-prepend {\n    div:not([class]) .react-datepicker__input-container,\n    & + div .react-datepicker__input-container {\n      .form-control {\n        @include border-start-radius(0);\n        @include border-end-radius($input-border-radius !important);\n      }\n    }\n  }\n\n  & > div:not([class]) {\n    position: relative;\n    flex: 1 1 auto;\n    width: 1%;\n\n    & .react-datepicker__input-container {\n      .form-control {\n        @include border-end-radius(0);\n      }\n\n    }\n  }\n}\n\n.input-group {\n  .input-group-prepend {\n    & + div {\n      position: relative;\n      flex: 1 1 auto;\n      width: 1%;\n    }\n  }\n\n  & > .react-datepicker-wrapper {\n    position: relative;\n    flex: 1 1 auto;\n    width: 1%;\n\n    & > .react-datepicker__input-container > .form-control {\n      @include border-start-radius(0);\n    }\n  }\n}\n\n// Forms Legend\n\nlegend {\n  font-size: $font-size-base;\n  font-weight: bold;\n}\n\n// Headings\n\n.form-heading {\n  font-size: $font-size-lg;\n  margin: 0;\n  color: $primary;\n\n  p {\n    color: $gray-600;\n    padding: 0.3rem 0 0;\n    font-size: $font-size-base;\n  }\n}\n.customPassErr {\n  margin-top: 0.25rem;\n    font-size: 0.875em;\n    color: #d92550;\n}\n\n.custom-select {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n}","// Pagination\n\n@use \"sass:math\";\n\n.pagination {\n  .page-number {\n    @extend .page-item;\n  }\n\n  li {\n    a {\n      position: relative;\n      display: block;\n      padding: $pagination-padding-y $pagination-padding-x;\n      margin-left: -$pagination-border-width;\n      // line-height: $pagination-line-height;\n      color: $pagination-color;\n      background-color: $pagination-bg;\n      border: $pagination-border-width solid $pagination-border-color;\n\n      &:hover {\n        z-index: 2;\n        color: $pagination-hover-color;\n        text-decoration: none;\n        background-color: $pagination-hover-bg;\n        border-color: $pagination-hover-border-color;\n      }\n\n      &:focus {\n        z-index: 2;\n        outline: $pagination-focus-outline;\n        box-shadow: $pagination-focus-box-shadow;\n      }\n\n      // Opinionated: add \"hand\" cursor to non-disabled .page-link elements\n      &:not(:disabled):not(.disabled) {\n        cursor: pointer;\n      }\n    }\n\n    &:first-child {\n      a {\n        margin-left: 0;\n        @include border-start-radius($border-radius);\n      }\n    }\n    &:last-child {\n      a {\n        @include border-end-radius($border-radius);\n      }\n    }\n\n    &.active a {\n      z-index: 1;\n      color: $pagination-active-color;\n      background-color: $pagination-active-bg;\n      border-color: $pagination-active-border-color;\n\n      &:hover {\n        color: $pagination-active-color;\n      }\n    }\n\n    &.disabled a {\n      color: $pagination-disabled-color;\n      pointer-events: none;\n      // Opinionated: remove the \"hand\" cursor set previously for .page-link\n      cursor: auto;\n      background-color: $pagination-disabled-bg;\n      border-color: $pagination-disabled-border-color;\n    }\n  }\n}\n\n// Pagination Rounded\n\n.pagination-rounded {\n  li a {\n    @include border-radius(50px !important);\n    margin: 0 math.div($layout-spacer-x, 5);\n  }\n}","// Chat\n\n@use \"sass:math\";\n\n.chat-box-wrapper {\n  display: flex;\n  clear: both;\n  padding: math.div($layout-spacer-x, 2);\n\n  & + .chat-box-wrapper {\n    padding-top: 0;\n  }\n\n  .chat-box {\n    box-shadow: 0 0 0 transparent;\n    position: relative;\n    opacity: 1;\n    background: $dropdown-link-hover-bg;\n    border: 0;\n    padding: math.div($layout-spacer-x, 2) $layout-spacer-x;\n    @include border-radius(30px);\n    border-top-left-radius: $border-radius;\n    flex: 1;\n    display: flex;\n    max-width: 50%;\n    min-width: 100%;\n    text-align: left;\n\n    & + small {\n      text-align: left;\n      padding: math.div($layout-spacer-x, 3) 0 0;\n      margin-left: $layout-spacer-x;\n      display: block;\n    }\n  }\n\n  &.chat-box-wrapper-right {\n    text-align: right;\n\n    .chat-box {\n      @include border-radius(30px);\n      border-top-left-radius: 30px;\n      border-top-right-radius: $border-radius;\n      margin-left: auto;\n\n      & + small {\n        text-align: right;\n        margin-right: $layout-spacer-x;\n        margin-left: 0;\n      }\n    }\n\n  }\n}\n","// Wizard Multi Step\n\n@use \"sass:math\";\n\n.forms-wizard {\n  margin: 0;\n  padding: 0;\n  list-style-type: none;\n  width: 100%;\n  display: table;\n  table-layout: fixed;\n  @include border-radius($border-radius);\n\n  li {\n    display: table-cell;\n    vertical-align: middle;\n    text-align: center;\n    cursor: pointer;\n    font-size: math.div($font-size-lg, 1.1);\n    padding: math.div($layout-spacer-x, 1.5) 0;\n    color: $gray-500;\n    position: relative;\n\n    &::after,\n    &::before {\n      position: absolute;\n      height: 4px;\n      top: 50%;\n      margin-top: -(math.div($layout-spacer-x, 1.5));\n      width: 50%;\n      content: '';\n      background: $gray-300;\n      z-index: 5;\n      transition: all .2s;\n    }\n\n    &::after {\n      left: 50%;\n    }\n\n    &::before {\n      left: 0;\n    }\n\n    &:first-child {\n      &::before {\n        @include border-start-radius(20px);\n      }\n    }\n\n    &:last-child {\n      &::after {\n        @include border-end-radius(20px);\n      }\n    }\n\n    em {\n      font-style: normal;\n      font-size: $h4-font-size;\n      background: $gray-400;\n      color: $white;\n      text-align: center;\n      padding: 0;\n      width: 40px;\n      height: 40px;\n      line-height: 40px;\n      @include border-radius(50px);\n      display: block;\n      margin: 0 auto 0.5rem;\n      position: relative;\n      z-index: 7;\n      transition: all .2s;\n    }\n\n    &.form-wizard-step-doing {\n      color: $gray-700;\n      em {\n        background: $primary;\n      }\n\n      &::before {\n        background: $primary;\n      }\n    }\n\n    &.form-wizard-step-done {\n      em {\n        font-family: 'Linearicons-Free';\n        @extend .lnr-checkmark-circle !optional;\n        background: $success;\n        overflow: hidden;\n        &::before {\n          width: 42px;\n          height: 42px;\n          font-size: 1.2rem;\n          line-height: 40px;\n          text-align: center;\n          display: block;\n        }\n      }\n\n      &::after,\n      &::before {\n        background: $success;\n      }\n    }\n\n    &:hover {\n      color: $gray-600;\n    }\n  }\n}\n\n\n// Form Wizard Alternate\n\n.forms-wizard-alt {\n  .forms-wizard {\n    li {\n      font-size: $font-size-base;\n\n      em {\n        width: 14px;\n        height: 14px;\n        line-height: 14px;\n        text-indent: -999rem;\n        border: $white solid 2px;\n        margin: -7px auto 0;\n\n      }\n    }\n  }\n}\n\n.forms-wizard-vertical {\n  .forms-wizard {\n    display: block;\n    width: 30%;\n    float: left;\n    padding: 0 $layout-spacer-x $layout-spacer-x 0;\n\n    li {\n      text-align: left;\n      display: flex;\n      align-items: center;\n      align-content: flex-start;\n      padding: math.div($layout-spacer-x, 2);\n      margin-bottom: math.div($layout-spacer-x, 3);\n      @include border-radius($border-radius-lg);\n      transition: all .2s;\n\n      &::before,\n      &::after {\n        display: none;\n      }\n\n      em {\n        margin: 0 math.div($layout-spacer-x, 2) 0 0;\n      }\n\n      &:hover {\n        background: $gray-200;\n      }\n\n      &.form-wizard-step-doing {\n        background: $primary;\n        color: $white;\n\n        em {\n          background: rgba(255,255,255,.2);\n        }\n      }\n    }\n  }\n\n  .form-wizard-content {\n    width: 70%;\n    overflow: auto;\n  }\n}\n@media screen and (min-width: 360px) and (max-width: 812px) {\n  .forms-wizard-vertical {\n    .forms-wizard {\n      display: block;\n      width: 50%;\n      float: left;\n      padding: 0 $layout-spacer-x $layout-spacer-x 0;\n  \n      li {\n        text-align: left;\n        display: flex;\n        align-items: center;\n        align-content: flex-start;\n        padding: math.div($layout-spacer-x, 2);\n        margin-bottom: math.div($layout-spacer-x, 3);\n        @include border-radius($border-radius-lg);\n        transition: all .2s;\n  \n        &::before,\n        &::after {\n          display: none;\n        }\n  \n        em {\n          margin: 0 math.div($layout-spacer-x, 2) 0 0;\n        }\n  \n        &:hover {\n          background: $gray-200;\n        }\n  \n        &.form-wizard-step-doing {\n          background: $primary;\n          color: $white;\n  \n          em {\n            background: rgba(255,255,255,.2);\n          }\n        }\n      }\n    }\n  \n    .form-wizard-content {\n      width: 50%;\n      overflow: auto;\n    }\n  }\n}","// Chart boxes\n\n// Variables\n\n@use \"sass:math\";\n\n$widget-spacer: $spacer;\n\n%center-elem {\n  display: flex;\n  align-content: center;\n  align-items: center;\n}\n\n.widget-chart {\n  text-align: center;\n  padding: $widget-spacer;\n  position: relative;\n\n  .progress-sub-label {\n    opacity: .8;\n    padding: 5px 0 0;\n  }\n\n  .progress-circle-wrapper {\n    min-width: 68px;\n    margin-right: $widget-spacer;\n\n    .react-sweet-progress-symbol {\n      font-size: $font-size-xs;\n    }\n  }\n\n  .widget-chart-content {\n    position: relative;\n    z-index: 5;\n  }\n\n  .widget-chart-content-lg {\n    padding: ($widget-spacer * 2) 0 $widget-spacer  ($widget-spacer * 2);\n\n    .widget-numbers {\n      margin-bottom: 0;\n    }\n  }\n\n  .widget-chart-wrapper {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    opacity: .25;\n    z-index: 6;\n    @include border-bottom-radius($card-border-radius);\n    overflow: hidden;\n  }\n\n  .widget-numbers {\n    font-weight: bold;\n    font-size: 2.5rem;\n    display: block;\n    line-height: 1;\n    margin: $widget-spacer auto;\n\n    & + .widget-chart-flex,\n    & + .widget-description,\n    & + .widget-subheading {\n      margin-top: -(math.div($widget-spacer, 2));\n    }\n  }\n\n  .widget-subheading {\n    margin: -0.5rem 0 0;\n    display: block;\n    opacity: .6;\n\n    &:first-child {\n      margin-top: 0;\n    }\n\n    & + .widget-numbers {\n      margin-top: math.div($widget-spacer, 2);\n    }\n  }\n\n  .widget-description {\n    margin: $widget-spacer 0 0;\n  }\n\n  &.widget-chart-hover {\n    transition: all .2s;\n\n    &:hover {\n      z-index: 15;\n      transform: scale(1.15);\n      box-shadow: 0 0.46875rem 4.1875rem rgba(darken($primary, 50%), .05),\n      0 0.9375rem 2.40625rem rgba(darken($primary, 50%), .05),\n      0 0.25rem 1.3125rem rgba(darken($primary, 50%), .06),\n      0 0.125rem 1.1875rem rgba(darken($primary, 50%), .06);\n      cursor: pointer;\n      background: $white;\n    }\n  }\n\n  .widget-chart-actions {\n    position: absolute;\n    right: math.div($widget-spacer, 2);\n    top: math.div($widget-spacer, 2);\n    z-index: 12;\n\n    .btn-link {\n      font-size: 1.1rem;\n      padding-top: 0;\n      padding-bottom: 0;\n      opacity: .6;\n    }\n  }\n\n  .widget-progress-wrapper {\n    margin-top: $widget-spacer;\n\n    &.progress-wrapper-bottom {\n      position: absolute;\n      left: 0;\n      bottom: 0;\n      width: 100%;\n\n      .progress {\n        margin: 0 -1px -1px;\n      }\n\n      .progress {\n        @include border-top-radius(0);\n        @include border-bottom-radius($card-border-radius);\n\n        .progress-bar {\n          border-bottom-left-radius: $card-border-radius;\n        }\n      }\n\n    }\n  }\n\n  .widget-chart-flex {\n    display: flex;\n    align-items: center;\n    align-content: center;\n    margin-bottom: $widget-spacer;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    .widget-subheading {\n      margin: 0;\n    }\n\n    .widget-description {\n      margin-top: 0;\n    }\n  }\n\n  &.text-start {\n    flex-direction: row;\n    align-items: center;\n\n    .icon-wrapper {\n      min-width: 54px;\n      margin: 0 ($widget-spacer) 0 0;\n    }\n\n    .widget-numbers {\n      margin-left: 0;\n    }\n\n    .widget-chart-content {\n      display: flex;\n      flex-direction: column;\n      align-content: center;\n      flex: 1;\n      position: relative;\n\n      & > .widget-numbers:first-child {\n        margin-top: 0;\n      }\n\n      .widget-description {\n        align-self: flex-start;\n      }\n    }\n\n    .widget-chart-wrapper {\n      height: 35%;\n    }\n  }\n\n  &.widget-chart-left {\n    padding-bottom: 15%;\n  }\n\n  .chart-wrapper-relative {\n    position: relative;\n    opacity: 1;\n    margin-top: ($widget-spacer);\n  }\n}\n\n.widget-chart-actions {\n  position: absolute;\n  right: $widget-spacer;\n  top: $widget-spacer;\n  z-index: 12;\n\n  .btn-link {\n    font-size: 1.1rem;\n    padding-top: 0;\n    padding-bottom: 0;\n    opacity: .6;\n  }\n}\n\n.widget-chart,\n.widget-content {\n  &:hover {\n    .widget-chart-actions {\n      .btn-link {\n        opacity: 1;\n      }\n    }\n  }\n}\n\n.grid-menu {\n  .widget-chart {\n    &.widget-chart-hover {\n      &:hover {\n        background: $card-bg;\n        @include border-radius($border-radius);\n      }\n    }\n  }\n\n}\n\n.icon-wrapper {\n  width: 54px;\n  height: 54px;\n  margin: 0 auto;\n  @extend %center-elem;\n  position: relative;\n  overflow: hidden;\n\n  &[class*=\"border-\"] {\n    border-width: 1px;\n    border-style: solid;\n  }\n\n  .icon-wrapper-bg {\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    z-index: 3;\n    opacity: .2;\n\n    &.bg-light {\n      opacity: .08;\n    }\n\n  }\n\n  i {\n    margin: 0 auto;\n    font-size: 1.7rem;\n    position: relative;\n    z-index: 5;\n\n    &:before {\n      margin-top: -3px;\n    }\n  }\n\n  .progress-circle-wrapper {\n    width: 100%;\n    margin-right: 0;\n  }\n}\n\n.widget-chart2 {\n  .widget-chart-flex {\n    display: flex;\n    align-items: baseline;\n    align-content: center;\n    margin-bottom: 0;\n\n    .widget-subtitle,\n    .widget-title {\n    }\n\n    .widget-subtitle {\n      margin-left: auto;\n    }\n\n    .widget-numbers {\n      font-weight: normal;\n    }\n\n    & + .widget-chart-flex {\n      .widget-numbers {\n        margin-bottom: 0;\n      }\n    }\n  }\n\n  .widget-chat-wrapper-outer {\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    max-width: 100%;\n\n    .widget-chart-wrapper {\n      height: 70px;\n      opacity: .8;\n      position: relative;\n      margin: $widget-spacer auto (-(math.div($widget-spacer, 2)));\n    }\n\n    .widget-chart-wrapper-lg {\n      height: 130px;\n    }\n  }\n}\n\n// Widgets with bottom border\n\n.card-btm-border {\n  border-bottom: transparent solid 4px;\n}\n\n// Progress Box\n\n.progress-box {\n  text-align: center;\n\n  h4 {\n    font-size: $font-size-base;\n    font-weight: bold;\n    opacity: .6;\n    text-transform: uppercase;\n    padding-bottom: math.div($widget-spacer, 3)\n  }\n\n  svg {\n    margin: 0 auto;\n  }\n}\n\n.svg-bg {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  opacity: .1;\n\n  svg {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    left: 0;\n    top: 0;\n  }\n}\n\n.widget-numbers-sm {\n  font-size: 1.5rem;\n}","// Content Boxes\n\n// Variables\n\n@use \"sass:math\";\n\n$widget-spacer: $spacer;\n\n.widget-content {\n  padding: $widget-spacer;\n  flex-direction: row;\n  align-items: center;\n\n  .widget-content-wrapper {\n    display: flex;\n    flex: 1;\n    position: relative;\n    align-items: center;\n  }\n\n  .widget-content-left {\n\n    .widget-heading {\n      opacity: .8;\n      font-weight: bold;\n    }\n\n    .widget-subheading {\n      opacity: .5;\n    }\n  }\n\n  .widget-content-right {\n    margin-left: auto;\n  }\n\n  .widget-numbers {\n    font-weight: bold;\n    font-size: 1.8rem;\n    display: block;\n  }\n\n  .widget-content-outer {\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n  }\n\n  .widget-progress-wrapper {\n    margin-top: $widget-spacer;\n\n    .progress-sub-label {\n      margin-top: math.div($widget-spacer, 3);\n      opacity: .5;\n      display: flex;\n      align-content: center;\n      align-items: center;\n\n      .sub-label-left {\n\n      }\n\n      .sub-label-right {\n        margin-left: auto;\n      }\n    }\n  }\n\n  .widget-content-right {\n    &.widget-content-actions {\n      visibility: hidden;\n      opacity: 0;\n      transition: opacity .2s;\n    }\n  }\n\n  &:hover {\n    .widget-content-right {\n      &.widget-content-actions {\n        visibility: visible;\n        opacity: 1;\n      }\n    }\n  }\n}\n","// Profile Boxes\n\n@use \"sass:math\";\n\n.profile-block {\n  position: relative;\n  overflow: hidden;\n\n  .profile-blur {\n    width: 100%;\n    height: 100%;\n    filter: blur(5px);\n    transform: scale(1.8);\n    position: absolute;\n    left: -25%;\n    top: -25%;\n  }\n\n  .profile-inner {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    opacity: .5;\n    left: 0;\n    top: 0;\n  }\n\n  .dropdown-menu-header {\n\n    .menu-header-content {\n      padding: $layout-spacer-lg;\n\n      .menu-header-title {\n        margin: math.div($layout-spacer-x, 2) 0 0;\n      }\n\n      .menu-header-subtitle {\n        margin: math.div($layout-spacer-x, 3) 0 0;\n      }\n    }\n\n    .menu-header-btn-pane {\n      margin: math.div($layout-spacer-x, 3) 0 0;\n\n      .btn-icon {\n        color: $white;\n        padding: 0;\n        width: 44px;\n        height: 44px;\n        line-height: 37px;\n        font-size: $font-size-lg;\n\n        &:hover {\n          background: rgba(255, 255, 255, .2);\n        }\n      }\n    }\n  }\n\n}","// User Pages\n\n.app-logo {\n  height: $logo-height;\n  width: $logo-width;\n  background: url(\"../../assets/utils/images/Arkos_color_logo\\ 1.svg\");\n}\n\n.app-logo-inverse {\n  height: $logo-height;\n  width: $logo-width;\n  background: url(\"../../assets/utils/images/Arkos_white_logo\\ 1.svg\");\n}\n\n.app-login-box {\n  .app-logo {\n    margin-bottom: $layout-spacer-lg;\n  }\n\n  h4 {\n    margin-bottom: $layout-spacer-x;\n    font-weight: normal;\n\n    div {\n      opacity: 0.6;\n    }\n\n    span {\n      font-size: $font-size-lg;\n    }\n  }\n}\n\nspan.ps-menu-label i {\n  font-size: 24px;\n  position: relative;\n  top: 5px;\n  margin-right: 16px;\n}\n\ni.pe {\n  font-size: 24px;\n  position: relative;\n  right: 5px;\n}\n\n.css-dip3t8 {\n  background-color: rgb(249 249 249 / 0%) !important;\n}\n\n.css-1wvake5 {\n  border: none !important;\n}\n\n.page-heading-sections {\n  padding-bottom: 19px;\n\n  h2 {\n    margin-bottom: 0px;\n    font-weight: 600;\n    font-size: 24px;\n    line-height: 36px;\n    color: #1d1d1d;\n  }\n\n  .form-check {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 11px;\n\n    label.form-check-label {\n      font-weight: 400;\n      font-size: 15px;\n      line-height: 22px;\n      color: #3f3f3f;\n    }\n\n    input.form-check-input {\n      width: 20px;\n      height: 20px;\n\n      &:focus {\n        box-shadow: none;\n      }\n\n      &:checked {\n        background-color: #545cd8;\n        border-color: #545cd8;\n      }\n    }\n  }\n}\n\n.formula-page {\n  .rounded-3 {\n    border: 1px solid #cacaca;\n    border-radius: 10px !important;\n    margin-top: 30px;\n  }\n\n  table {\n    margin-bottom: 0px !important;\n\n    thead {\n      background-color: #545cd8;\n      color: #fff;\n\n      tr {\n        th {\n          text-align: center;\n          padding: 17px 34px;\n          font-weight: 500;\n          font-size: 15px;\n          line-height: 22px;\n          color: #ffffff;\n        }\n      }\n    }\n\n    tbody {\n      tr {\n        td {\n          text-align: center;\n          font-weight: 400;\n          font-size: 15px;\n          line-height: 22px;\n          color: #1d1d1d;\n          padding: 10px;\n\n          a {\n            padding-left: 10px;\n          }\n        }\n      }\n\n      .input-group {\n        border: 1px solid #c8c8c8;\n        border-radius: 4px;\n        max-width: 172px;\n        margin: 0px !important;\n\n        .form-control {\n          border: 0px;\n        }\n      }\n    }\n\n    button {\n      background: #545cd8;\n      border-color: #545cd8;\n      color: #1d1d1d;\n      font-size: 15px;\n    }\n  }\n  .foot-form {\n    background: #f4f4f4;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 27px 34px;\n    gap: 10px;\n    flex-wrap: wrap;\n    border-top: 1px solid #e7e7e7 !important;\n\n    .auto-generate {\n      min-width: 172px;\n      margin-bottom: 0px !important;\n      border: 1px solid #c8c8c8;\n      border-radius: 4px;\n      max-width: 20%;\n\n      .form-control {\n        border: 0px !important;\n        box-shadow: none;\n        &:hover {\n          box-shadow: none;\n        }\n      }\n\n      span {\n        border-top-right-radius: 4px;\n        border-bottom-right-radius: 4px;\n        background-color: #f2f2f2;\n        padding: 5px 10px;\n        width: 35px;\n        height: 35px;\n        text-align: center;\n      }\n    }\n\n    .search-items {\n      position: relative;\n      border: 1px solid #ccc;\n      border-radius: 4px;\n      min-width: 200px;\n      padding-left: 30px;\n      background: #fff;\n      max-width: 20%;\n      flex-shrink: 1;\n\n      &::before {\n        content: \"\";\n        display: block;\n        position: absolute;\n        left: 15px;\n        top: 9px;\n        background-image: url(../../assets/demo-ui/images/search-icons.png);\n        background-size: contain;\n        background-repeat: no-repeat;\n        width: 17px;\n        height: 17px;\n      }\n\n      .mb-3 {\n        margin-bottom: 0px !important;\n      }\n\n      select.form-select {\n        border: 0px;\n        margin: 0px;\n        box-shadow: none;\n        &:focus,\n        &:hover {\n          box-shadow: none;\n        }\n      }\n    }\n    .btn {\n      padding: 10px 25px !important;\n    }\n  }\n\n  .editbtns {\n    background: transparent;\n    box-shadow: none;\n    border: 0;\n  }\n\n  .delet-icon {\n    text-align: center;\n  }\n\n  span.tags {\n    padding: 5px 21px;\n    border-radius: 50px;\n    background: #dddddd;\n    font-size: 13px;\n    margin-left: 20px;\n  }\n}\n\n.equation-modal {\n  .modal-content {\n    min-width: 700px;\n    textarea {\n      height: 200px;\n      resize: none;\n      box-shadow: none;\n      margin-bottom: 24px;\n      &:hover,\n      &:focus {\n        box-shadow: none;\n      }\n    }\n    .search-input {\n      background: #ffffff;\n      border: 1px solid #1d1d1d;\n      border-radius: 50px;\n      color: #1d1d1d;\n      font-family: \"Poppins\";\n      font-style: normal;\n      font-weight: 600;\n      font-size: 14px;\n      line-height: 21px;\n      padding: 11px 24px;\n      box-shadow: none;\n    }\n    table {\n      tr {\n        td,\n        th {\n          padding: 10px 20px;\n        }\n      }\n    }\n\n    .rounded-3 {\n      border: 1px solid #cacaca;\n      border-radius: 10px !important;\n      margin-top: 16px;\n      margin-bottom: 50px;\n    }\n  }\n  .modal-head {\n    padding-left: 30px;\n    padding-right: 30px;\n  }\n  .modal-body {\n    padding-left: 30px;\n    padding-right: 30px;\n  }\n  .modal-footer {\n    padding: 26px 30px 50px;\n    button {\n      border-radius: 50px;\n      font-size: 15px;\n      padding: 9px 25px;\n      width: 100px;\n\n      .btn-secondary-1 {\n        border: 1px solid #1d1d1d;\n        color: #1d1d1d !important;\n        background-color: #ffffff;\n      }\n\n      .btn-secondary {\n        background-color: #1d1d1d;\n      }\n    }\n  }\n  &.twocol {\n    .modal-dialog {\n      max-width: 1000px;\n    }\n  }\n}\n\n.foot-save-btn {\n  border-radius: 50px;\n  font-size: 15px;\n  padding: 9px 40px;\n  width: 142px;\n}\n\n.listing-table {\n  margin-bottom: 30px;\n}\n\n.equation-box {\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); \n  padding: 16px;\n  border-radius: 8px; \n  background-color: #fff; \n}\n\n.equation-box .text-primary {\n  font-weight: bold; \n}\n\n\n.formula_acceptance {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex-wrap: nowrap;\n  gap: 18px;\n  padding: 27px 35px;\n  background: #ffffff;\n  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.12);\n  border-radius: 10px;\n  margin-bottom: 36px;\n  margin-top: 30px;\n  @media (max-width: 767px) {\n    flex-direction: column;\n  }\n  label {\n    font-family: \"Poppins\", sans-serif;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 27px;\n    color: #1d1d1d;\n    margin-right: 45px;\n  }\n  .data-field {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: 14px;\n    min-width: 40%;\n    @media (max-width: 992px) {\n      min-width: 30%;\n    }\n    span {\n      font-family: \"Poppins\", sans-serif;\n      font-style: normal;\n      font-weight: 500;\n      font-size: 14px;\n      line-height: 21px;\n      color: #5e5e5e;\n    }\n    .auto-generate {\n      // min-width: 142px;\n      margin-bottom: 0px !important;\n      border: 1px solid #c8c8c8;\n      border-radius: 4px;\n      display: flex;\n      flex-wrap: nowrap;\n      .form-control {\n        border: 0px !important;\n        box-shadow: none;\n        &:hover {\n          box-shadow: none;\n        }\n      }\n\n      span {\n        border-top-right-radius: 4px;\n        border-bottom-right-radius: 4px;\n        background-color: #f2f2f2;\n        padding: 5px 10px;\n        width: 35px;\n        height: 35px;\n        text-align: center;\n      }\n    }\n    input {\n      // width: 306px;\n      flex-shrink: 1;\n    }\n  }\n\n  \n}\n\n.filter-search header {\n  padding: 0!important;\n}\n","// Applications\n\n@use \"sass:math\";\n\n$app-layout-sidebar-width         : 270px;\n$app-layout-aside-width           : 60px;\n$app-layout-header-height         : 50px;\n\n\n\n.app-inner-layout {\n\n  &.rm-sidebar {\n    .app-inner-layout__wrapper {\n      .app-inner-layout__content {\n        width: auto;\n        float: none;\n      }\n    }\n  }\n\n  .app-inner-layout__header {\n    width: 100%;\n    padding: $layout-spacer-x;\n    text-align: left;\n\n    .app-page-title {\n      margin: 0;\n      padding: 0;\n      background: transparent;\n    }\n\n    border-bottom: $gray-200 solid 1px;\n  }\n\n  .app-inner-layout__header-boxed {\n    padding: $layout-spacer-x;\n\n    .app-inner-layout__header {\n      @include border-radius($border-radius-lg);\n    }\n  }\n\n  .app-inner-layout__wrapper {\n    position: relative;\n    display: flex;\n    flex-direction: row;\n    min-height: 100vh;\n\n    .app-inner-layout__content {\n      flex: 1;\n      display: flex;\n\n      &.card {\n        box-shadow: 0 0 0 0 transparent;\n        border-radius: 0;\n        border: 0;\n      }\n\n      .app-inner-layout__top-pane {\n        display: flex;\n        align-content: center;\n        align-items: center;\n        text-align: left;\n        padding: math.div($layout-spacer-x, 2) $layout-spacer-x;\n      }\n\n      .pane-left {\n        display: flex;\n        align-items: center;\n      }\n\n      .pane-right {\n        display: flex;\n        align-items: center;\n        margin-left: auto;\n      }\n\n      .app-inner-layout__bottom-pane {\n        padding: $layout-spacer-x;\n        border-top: $gray-200 solid 1px;\n      }\n    }\n\n    .app-inner-layout__sidebar {\n      width: $app-layout-sidebar-width;\n      list-style: none;\n      text-align: left;\n      order: -1;\n      flex: 0 0 $app-layout-sidebar-width;\n      display: flex;\n      margin: 0;\n      position: relative;\n\n      .dropdown-item {\n        white-space: normal;\n      }\n\n      &.card {\n        box-shadow: 0 0 0 0 transparent;\n        border-radius: 0;\n        background: $gray-100;\n        border: 0;\n        border-right: $gray-200 solid 1px;\n        border-left: $gray-200 solid 1px;\n      }\n\n      .app-inner-layout__sidebar-footer,\n      .app-inner-layout__sidebar-header {\n        background: $gray-100;\n      }\n    }\n\n    .app-inner-layout__aside {\n      width: $app-layout-aside-width;\n    }\n  }\n\n  .app-inner-layout__footer {\n    width: 100%;\n    height: $app-layout-header-height;\n  }\n}\n\n.app-wrapper-footer {\n  .app-footer {\n    border-top: $gray-200 solid 1px;\n\n    .app-footer__inner {\n      border-left: $gray-200 solid 1px;\n    }\n  }\n}\n\n// Components\n\n@import \"chat\";\n\n// Responsive\n\n.mobile-app-menu-btn {\n  display: none;\n  margin: 3px $layout-spacer-x 0 0;\n}\n\n@import \"responsive\";","// Chat\n$app-layout-chat-sidebar-width: 360px;\n\n.chat-layout {\n  &.app-inner-layout {\n    .app-inner-layout__sidebar {\n      width: $app-layout-chat-sidebar-width;\n      flex: 0 0 $app-layout-chat-sidebar-width;\n    }\n  }\n\n  .app-inner-layout__top-pane h4 {\n    font-size: $h5-font-size;\n\n    div {\n      font-size: $font-size-base;\n    }\n  }\n\n  .chat-box-wrapper {\n    padding: $layout-spacer-x;\n  }\n}\n\n@include media-breakpoint-down(lg) {\n  .chat-layout {\n    &.app-inner-layout {\n      .app-inner-layout__sidebar {\n        .widget-content .widget-content-left .widget-subheading {\n          white-space: normal;\n        }\n      }\n    }\n  }\n}","// Responsive Applications\n\n@include media-breakpoint-down(md) {\n  .app-inner-layout__sidebar {\n    display: none !important;\n  }\n\n  .mobile-app-menu-btn {\n    display: block;\n  }\n\n  .open-mobile-menu {\n\n    .app-inner-layout__sidebar {\n      display: block !important;\n    }\n  }\n}","/*\n * Container style\n */\n.ps {\n  overflow: hidden !important;\n  overflow-anchor: none;\n  touch-action: auto;\n}\n\n/*\n * Scrollbar rail styles\n */\n.ps__rail-x {\n  display: none !important;\n  opacity: 0;\n  transition: background-color .2s linear, opacity .2s linear;\n  height: 15px;\n  /* there must be 'bottom' or 'top' for ps__rail-x */\n  bottom: 0;\n  /* please don't change 'position' */\n  position: absolute;\n  z-index: 7;\n}\n\n.ps__rail-y {\n  display: none;\n  opacity: 0;\n  transition: background-color .2s linear, opacity .2s linear;\n  width: 15px;\n  /* there must be 'right' or 'left' for ps__rail-y */\n  right: 0;\n  /* please don't change 'position' */\n  position: absolute;\n  @include border-radius(50px);\n  z-index: 7;\n}\n\n.ps--active-x > .ps__rail-x,\n.ps--active-y > .ps__rail-y {\n  display: block;\n  background-color: transparent;\n}\n\n.ps:hover > .ps__rail-x,\n.ps:hover > .ps__rail-y,\n.ps--focus > .ps__rail-x,\n.ps--focus > .ps__rail-y,\n.ps--scrolling-x > .ps__rail-x,\n.ps--scrolling-y > .ps__rail-y {\n  opacity: 0.6;\n}\n\n.ps__rail-x:hover,\n.ps__rail-y:hover,\n.ps__rail-x:focus,\n.ps__rail-y:focus {\n  background-color: rgba(0, 0, 0, .1);\n  opacity: 0.9;\n}\n\n/*\n * Scrollbar thumb styles\n */\n.ps__thumb-x {\n  background-color: rgba(0, 0, 0, .1);\n  border-radius: 6px;\n  transition: background-color .2s linear, height .2s ease-in-out;\n  height: 6px;\n  /* there must be 'bottom' for ps__thumb-x */\n  bottom: 2px;\n  /* please don't change 'position' */\n  position: absolute;\n}\n\n.ps__thumb-y {\n  background-color: rgba(0, 0, 0, .1);\n  border-radius: 6px;\n  transition: background-color .2s linear, width .2s ease-in-out;\n  width: 6px;\n  /* there must be 'right' for ps__thumb-y */\n  right: 2px;\n  /* please don't change 'position' */\n  position: absolute;\n}\n\n.ps__rail-x:hover > .ps__thumb-x,\n.ps__rail-x:focus > .ps__thumb-x {\n  background-color: rgba(0, 0, 0, .12);\n  height: 11px;\n}\n\n.ps__rail-y:hover > .ps__thumb-y,\n.ps__rail-y:focus > .ps__thumb-y {\n  background-color: rgba(0, 0, 0, .12);\n  width: 11px;\n}\n\n/* MS supports */\n@supports (-ms-overflow-style: none) {\n  .ps {\n    overflow: auto !important;\n  }\n}\n\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  .ps {\n    overflow: auto !important;\n  }\n}\n\n.scrollbar-container {\n  position: relative;\n  height: 100%;\n}\n\n// Scroll Areas\n\n.scroll-area {\n  overflow-x: hidden;\n  height: 400px;\n}\n\n.scroll-area-xs {\n  height: 150px;\n  overflow-x: hidden;\n}\n\n.scroll-area-sm {\n  height: 200px;\n  overflow-x: hidden;\n}\n\n.scroll-area-md {\n  height: 300px;\n  overflow-x: hidden;\n}\n\n.scroll-area-lg {\n  height: 400px;\n  overflow-x: hidden;\n}\n\n.scroll-area-x {\n  overflow-x: auto;\n  width: 100%;\n  max-width: 100%;\n}\n\n.shadow-overflow {\n  position: relative;\n\n  &::after,\n  &::before {\n    width: 100%;\n    bottom: auto;\n    top: 0;\n    left: 0;\n    height: $layout-spacer-x;\n    position: absolute;\n    z-index: 10;\n    content: '';\n    background: linear-gradient(to bottom, rgba(255, 255, 255, 1) 20%, rgba(255, 255, 255, 0) 100%);\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffff', endColorstr='#00ffffff', GradientType=0);\n  }\n\n  &::after {\n    bottom: 0;\n    top: auto;\n\n    background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 80%);\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00ffffff', endColorstr='#ffffff', GradientType=0);\n  }\n\n}","\n@use \"sass:math\";\n\n.rc-tabs {\n  box-sizing: border-box;\n  position: relative;\n  overflow: hidden;\n}\n\n.rc-tabs-bar,\n.rc-tabs-nav-container {\n  font-size: 14px;\n  line-height: 1.5;\n  box-sizing: border-box;\n  overflow: hidden;\n  position: relative;\n  white-space: nowrap;\n  outline: none;\n  zoom: 1;\n  transition: padding .45s;\n}\n\n.rc-tabs-ink-bar {\n  margin-top: 0;\n  @include border-radius($border-radius);\n  box-shadow:\n          0 16px 26px -10px rgba($primary, 0.56),\n          0 4px 25px 0px rgba(0, 0, 0, 0.12),\n          0 8px 10px -5px rgba($primary, 0.2);\n}\n\n.rc-tabs-ink-bar-animated {\n  transition: all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1) 0s;\n}\n\n.rc-tabs-tab-prev,\n.rc-tabs-tab-next {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  z-index: 1;\n  line-height: 36px;\n  cursor: pointer;\n  border: none;\n  background-color: transparent;\n  position: absolute;\n}\n\n.rc-tabs-tab-prev-icon,\n.rc-tabs-tab-next-icon {\n  position: relative;\n  display: inline-block;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  line-height: inherit;\n  vertical-align: baseline;\n  text-align: center;\n  text-transform: none;\n  font-smoothing: antialiased;\n  text-stroke-width: 0;\n  font-family: sans-serif;\n}\n\n.rc-tabs-tab-prev-icon:before,\n.rc-tabs-tab-next-icon:before {\n  display: block;\n}\n\n.rc-tabs-tab-btn-disabled {\n  cursor: default;\n  color: $gray-700;\n}\n\n.rc-tabs-nav-wrap {\n  overflow: hidden;\n}\n\n.rc-tabs-nav {\n  box-sizing: border-box;\n  padding-left: 0;\n  position: relative;\n  margin: 0;\n  float: left;\n  list-style: none;\n  display: inline-block;\n  transform-origin: 0 0;\n\n  & > div:first-child {\n    z-index: 5;\n    position: relative;\n  }\n}\n\n.rc-tabs-nav-animated {\n  transition: transform 0.5s cubic-bezier(0.35, 0, 0.25, 1);\n}\n\n.rc-tabs-nav:before,\n.rc-tabs-nav:after {\n  display: table;\n  content: \" \";\n}\n\n.rc-tabs-nav:after {\n  clear: both;\n}\n\n.rc-tabs-tab {\n  box-sizing: border-box;\n  position: relative;\n  display: block;\n  transition: color 0.3s cubic-bezier(0.35, 0, 0.25, 1);\n  padding: 8px 20px;\n  cursor: pointer;\n}\n\n.rc-tabs-tab:hover {\n  color: $primary;\n}\n\n.rc-tabs-tab-active,\n.rc-tabs-tab-active:hover {\n  color: $white;\n  cursor: default;\n  transform: translateZ(0);\n}\n\n.rc-tabs-tab-disabled {\n  cursor: default;\n  color: $gray-700;\n}\n\n.rc-tabs-tab-disabled:hover {\n  color: $gray-700;\n}\n\n.rc-tabs-content {\n  zoom: 1;\n}\n\n.rc-tabs-content .rc-tabs-tabpane {\n  overflow: hidden;\n}\n\n.rc-tabs-content-animated {\n  transition: transform 0.3s cubic-bezier(0.35, 0, 0.25, 1), margin-left 0.3s cubic-bezier(0.35, 0, 0.25, 1), margin-top 0.3s cubic-bezier(0.35, 0, 0.25, 1);\n  display: -ms-flexbox;\n  display: flex;\n  will-change: transform;\n}\n\n.rc-tabs-content-animated .rc-tabs-tabpane {\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n}\n\n.no-flexbox .rc-tabs-content {\n  transform: none !important;\n  overflow: hidden;\n}\n\n.no-csstransitions .rc-tabs-tabpane-inactive,\n.no-flexbox .rc-tabs-tabpane-inactive,\n.rc-tabs-content-no-animated .rc-tabs-tabpane-inactive {\n  display: none;\n}\n\n.rc-tabs-bottom .rc-tabs-tab-arrow-show {\n  opacity: 1;\n  width: 100%;\n  height: 35px;\n}\n\n\n.rc-tabs-top .rc-tabs-tab-arrow-show {\n  opacity: 1;\n  width: 100%;\n  height: 35px;\n}\n\n.rc-tabs-top .rc-tabs-content {\n  width: 100%;\n}\n\n.rc-tabs-top .rc-tabs-nav-container-scrolling {\n  padding-left: 35px;\n  padding-right: 35px;\n}\n\n.rc-tabs-top .rc-tabs-nav-scroll {\n  width: 99999px;\n}\n\n.rc-tabs-top .rc-tabs-nav-swipe {\n  position: relative;\n  left: 0;\n}\n\n.rc-tabs-top .rc-tabs-nav-swipe .rc-tabs-nav {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex: 1;\n  flex: 1;\n  width: 100%;\n}\n\n.rc-tabs-top .rc-tabs-nav-swipe .rc-tabs-nav .rc-tabs-tab {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n  margin-right: 0;\n  padding: 8px 0;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n.rc-tabs-top .rc-tabs-nav-wrap {\n  width: 100%;\n  padding: $layout-spacer-x math.div($grid-gutter-width, 2);\n}\n\n.rc-tabs-top .rc-tabs-content-animated {\n  -ms-flex-direction: row;\n  flex-direction: row;\n}\n\n.rc-tabs-top .rc-tabs-content-animated .rc-tabs-tabpane {\n  width: 100%;\n}\n\n.rc-tabs-top .rc-tabs-tab-next {\n  right: 2px;\n}\n\n.rc-tabs-top .rc-tabs-tab-next-icon:before {\n  content: \">\";\n}\n\n.rc-tabs-top .rc-tabs-tab-prev {\n  left: 0;\n}\n\n.rc-tabs-top .rc-tabs-tab-prev-icon:before {\n  content: \"<\";\n}\n\n.rc-tabs-top .rc-tabs-tab-prev,\n.rc-tabs-top .rc-tabs-tab-next {\n  margin-right: -2px;\n  width: 0;\n  height: 0;\n  top: 0;\n  text-align: center;\n  opacity: 0;\n  transition: width .3s, height .3s, opacity .3s;\n}\n\n.rc-tabs-top .rc-tabs-tab-arrow-show {\n  opacity: 1;\n  width: 35px;\n  height: 100%;\n}\n\n.rc-tabs-top .rc-tabs-ink-bar {\n  height: 35px;\n  bottom: 0;\n  left: 0;\n  background: $primary;\n}\n\n.rc-tabs-top .rc-tabs-tab {\n  float: left;\n  height: 100%;\n  line-height: 1.3;\n  margin-right: math.div($layout-spacer-x, 2);\n}\n\n.rc-tabs-top .rc-tabs-tabpane-inactive {\n  height: 0;\n  overflow: visible;\n}\n","/*!\n * Ladda\n * http://lab.hakim.se/ladda\n * MIT licensed\n *\n * Copyright (C) 2018 Hakim El Hattab, http://hakim.se\n */\n\n\n/*************************************\n * CONFIG\n */\n\n@use \"sass:math\";\n\n$spinnerSize: 32px !default;\n\n\n/*************************************\n * MIXINS\n */\n\n@mixin transition( $value ) {\n  transition: $value !important;\n}\n\n@mixin transform( $value ) {\n  transform: $value;\n}\n\n/*************************************\n * Opacity animation for spin.js\n */\n\n@keyframes ladda-spinner-line-fade {\n  0%, 100% {\n    opacity: 0.22; /* minimum opacity */\n  }\n  1% {\n    opacity: 1;\n  }\n}\n\n\n/*************************************\n * BUTTON BASE\n */\n\n.ladda-button {\n  position: relative;\n}\n\n\n/* Spinner animation */\n.ladda-button .ladda-spinner {\n  position: absolute;\n  z-index: 2;\n  display: inline-block;\n  width: $spinnerSize;\n  top: 50%;\n  margin-top: 0;\n  opacity: 0;\n  pointer-events: none;\n}\n\n/* Button label */\n.ladda-button .ladda-label {\n  position: relative;\n  z-index: 3;\n}\n\n[class*=\"btn-outline-\"] {\n  .ladda-spinner div div div {\n    background: $black !important;\n  }\n\n  &.ladda-button .ladda-label {\n    transition: none !important;\n  }\n}\n\n/* Progress bar */\n.ladda-button .ladda-progress {\n  position: absolute;\n  width: 0;\n  height: 100%;\n  left: 0;\n  top: 0;\n  background: rgba( 0, 0, 0, 0.2 );\n  display: none;\n\n  @include transition( 0.1s linear all );\n}\n.ladda-button[data-loading] .ladda-progress {\n  display: block;\n}\n\n\n/*************************************\n * EASING\n */\n\n.ladda-button,\n.ladda-button .ladda-spinner,\n.ladda-button .ladda-label {\n  @include transition( 0.3s cubic-bezier(0.175, 0.885, 0.320, 1.275) all );\n}\n\n.ladda-button[data-style=zoom-in],\n.ladda-button[data-style=zoom-in] .ladda-spinner,\n.ladda-button[data-style=zoom-in] .ladda-label,\n.ladda-button[data-style=zoom-out],\n.ladda-button[data-style=zoom-out] .ladda-spinner,\n.ladda-button[data-style=zoom-out] .ladda-label {\n  @include transition( 0.3s ease all );\n}\n\n\n/*************************************\n * EXPAND RIGHT\n */\n\n.ladda-button[data-style=expand-right] {\n  .ladda-spinner {\n    right: math.div($spinnerSize, -2) + 10;\n  }\n\n  &[data-size=\"s\"] .ladda-spinner,\n  &[data-size=\"xs\"] .ladda-spinner {\n    right: math.div($spinnerSize, -2) + 4;\n  }\n\n  &[data-loading] {\n    padding-right: 56px;\n\n    .ladda-spinner {\n      opacity: 1;\n    }\n\n    &[data-size=\"s\"],\n    &[data-size=\"xs\"] {\n      padding-right: 40px;\n    }\n  }\n}\n\n\n/*************************************\n * EXPAND LEFT\n */\n\n.ladda-button[data-style=expand-left] {\n  .ladda-spinner {\n    left: math.div($spinnerSize, 2) + 10;\n  }\n\n  &[data-size=\"s\"] .ladda-spinner,\n  &[data-size=\"xs\"] .ladda-spinner {\n    left: 4px;\n  }\n\n  &[data-loading] {\n    padding-left: 56px;\n\n    .ladda-spinner {\n      opacity: 1;\n    }\n\n    &[data-size=\"s\"],\n    &[data-size=\"xs\"] {\n      padding-left: 40px;\n    }\n  }\n}\n\n\n/*************************************\n * EXPAND UP\n */\n\n.ladda-button[data-style=expand-up] {\n  overflow: hidden;\n\n  .ladda-spinner {\n    top: -$spinnerSize;\n    left: 50%;\n    margin-left: 0;\n  }\n\n  &[data-loading] {\n    padding-top: 54px;\n\n    .ladda-spinner {\n      opacity: 1;\n      top: math.div($spinnerSize, 2) + 10;\n      margin-top: 0;\n    }\n\n    &[data-size=\"s\"],\n    &[data-size=\"xs\"] {\n      padding-top: 32px;\n\n      .ladda-spinner {\n        top: 4px;\n      }\n    }\n  }\n}\n\n\n/*************************************\n * EXPAND DOWN\n */\n\n.ladda-button[data-style=expand-down] {\n  overflow: hidden;\n\n  .ladda-spinner {\n    top: 52px;\n    left: 50%;\n    margin-left: 0;\n  }\n\n  &[data-size=\"s\"] .ladda-spinner,\n  &[data-size=\"xs\"] .ladda-spinner {\n    top: 40px;\n  }\n\n  &[data-loading] {\n    padding-bottom: 54px;\n\n    .ladda-spinner {\n      opacity: 1;\n    }\n\n    &[data-size=\"s\"],\n    &[data-size=\"xs\"] {\n      padding-bottom: 32px;\n    }\n  }\n}\n\n\n/*************************************\n * SLIDE LEFT\n */\n.ladda-button[data-style=slide-left] {\n  overflow: hidden;\n\n  .ladda-label {\n    position: relative;\n  }\n  .ladda-spinner {\n    left: 100%;\n    margin-left: 0;\n  }\n\n  &[data-loading] {\n    .ladda-label {\n      opacity: 0;\n      left: -100%;\n    }\n    .ladda-spinner {\n      opacity: 1;\n      left: 50%;\n    }\n  }\n}\n\n\n/*************************************\n * SLIDE RIGHT\n */\n.ladda-button[data-style=slide-right] {\n  overflow: hidden;\n\n  .ladda-label {\n    position: relative;\n  }\n  .ladda-spinner {\n    right: 100%;\n    margin-left: 0;\n    left: math.div($spinnerSize, 2);\n\n    [dir=\"rtl\"] & {\n      right: auto;\n    }\n  }\n\n  &[data-loading] {\n    .ladda-label {\n      opacity: 0;\n      left: 100%;\n    }\n    .ladda-spinner {\n      opacity: 1;\n      left: 50%;\n    }\n  }\n}\n\n\n/*************************************\n * SLIDE UP\n */\n.ladda-button[data-style=slide-up] {\n  overflow: hidden;\n\n  .ladda-label {\n    position: relative;\n  }\n  .ladda-spinner {\n    left: 50%;\n    margin-left: 0;\n    margin-top: 1em;\n  }\n\n  &[data-loading] {\n    .ladda-label {\n      opacity: 0;\n      top: -1em;\n    }\n    .ladda-spinner {\n      opacity: 1;\n      margin-top: 0;\n    }\n  }\n}\n\n\n/*************************************\n * SLIDE DOWN\n */\n.ladda-button[data-style=slide-down] {\n  overflow: hidden;\n\n  .ladda-label {\n    position: relative;\n  }\n  .ladda-spinner {\n    left: 50%;\n    margin-left: 0;\n    margin-top: -2em;\n  }\n\n  &[data-loading] {\n    .ladda-label {\n      opacity: 0;\n      top: 1em;\n    }\n    .ladda-spinner {\n      opacity: 1;\n      margin-top: 0;\n    }\n  }\n}\n\n\n/*************************************\n * ZOOM-OUT\n */\n\n.ladda-button[data-style=zoom-out] {\n  overflow: hidden;\n}\n.ladda-button[data-style=zoom-out] .ladda-spinner {\n  left: 50%;\n  margin-left: $spinnerSize;\n\n  @include transform( scale( 2.5 ) );\n}\n.ladda-button[data-style=zoom-out] .ladda-label {\n  position: relative;\n  display: inline-block;\n}\n\n.ladda-button[data-style=zoom-out][data-loading] .ladda-label {\n  opacity: 0;\n\n  @include transform( scale( 0.5 ) );\n}\n.ladda-button[data-style=zoom-out][data-loading] .ladda-spinner {\n  opacity: 1;\n  margin-left: 0;\n\n  @include transform( none );\n}\n\n\n/*************************************\n * ZOOM-IN\n */\n\n.ladda-button[data-style=zoom-in] {\n  overflow: hidden;\n}\n.ladda-button[data-style=zoom-in] .ladda-spinner {\n  left: 50%;\n  margin-left: math.div($spinnerSize, -2);\n\n  @include transform( scale( 0.2 ) );\n}\n.ladda-button[data-style=zoom-in] .ladda-label {\n  position: relative;\n  display: inline-block;\n}\n\n.ladda-button[data-style=zoom-in][data-loading] .ladda-label {\n  opacity: 0;\n\n  @include transform( scale( 2.2 ) );\n}\n.ladda-button[data-style=zoom-in][data-loading] .ladda-spinner {\n  opacity: 1;\n  margin-left: 0;\n\n  @include transform( none );\n}\n\n\n/*************************************\n * CONTRACT\n */\n\n.ladda-button[data-style=contract] {\n  overflow: hidden;\n  width: 100px;\n}\n.ladda-button[data-style=contract] .ladda-spinner {\n  left: 50%;\n  margin-left: 0;\n}\n\n.ladda-button[data-style=contract][data-loading] {\n  border-radius: 50%;\n  width: 52px;\n}\n.ladda-button[data-style=contract][data-loading] .ladda-label {\n  opacity: 0;\n}\n.ladda-button[data-style=contract][data-loading] .ladda-spinner {\n  opacity: 1;\n}\n\n\n\n/*************************************\n * OVERLAY\n */\n\n.ladda-button[data-style=contract-overlay] {\n  overflow: hidden;\n  width: 100px;\n\n  box-shadow: 0px 0px 0px 2000px rgba(0,0,0,0);\n}\n.ladda-button[data-style=contract-overlay] .ladda-spinner {\n  left: 50%;\n  margin-left: 0;\n}\n\n.ladda-button[data-style=contract-overlay][data-loading] {\n  border-radius: 50%;\n  width: 52px;\n\n  /*outline: 10000px solid rgba( 0, 0, 0, 0.5 );*/\n  box-shadow: 0px 0px 0px 2000px rgba(0,0,0,0.8);\n}\n.ladda-button[data-style=contract-overlay][data-loading] .ladda-label {\n  opacity: 0;\n}\n.ladda-button[data-style=contract-overlay][data-loading] .ladda-spinner {\n  opacity: 1;\n}\n\n\n[dir=\"rtl\"] .ladda-spinner > div {\n  left: 25% !important;\n}","@charset \"UTF-8\";\n/*!\n * Hamburgers\n * @description Tasty CSS-animated hamburgers\n * @author Jonathan Suh @jonsuh\n * @site https://jonsuh.com/hamburgers\n * @link https://github.com/jonsuh/hamburgers\n */\n\n// Settings\n// ==================================================\n$hamburger-padding-x           : 0px !default;\n$hamburger-padding-y           : 0px !default;\n$hamburger-layer-width         : 24px !default;\n$hamburger-layer-height        : 2px !default;\n$hamburger-layer-spacing       : 4px !default;\n$hamburger-layer-color         : $primary !default;\n$hamburger-layer-border-radius : 10px !default;\n$hamburger-hover-opacity       : 0.7 !default;\n$hamburger-active-layer-color  : $hamburger-layer-color !default;\n$hamburger-active-hover-opacity: $hamburger-hover-opacity !default;\n\n// To use CSS filters as the hover effect instead of opacity,\n// set $hamburger-hover-use-filter as true and\n// change the value of $hamburger-hover-filter accordingly.\n$hamburger-hover-use-filter   : false !default;\n$hamburger-hover-filter       : opacity(50%) !default;\n$hamburger-active-hover-filter: $hamburger-hover-filter !default;\n\n// Types (Remove or comment out what you don’t need)\n// ==================================================\n$hamburger-types: (\n  //3dx,\n  //3dx-r,\n  //3dy,\n  //3dy-r,\n  //3dxy,\n  //3dxy-r,\n  //arrow,\n  //arrow-r,\n  //arrowalt,\n  //arrowalt-r,\n  //arrowturn,\n  //arrowturn-r,\n  //boring,\n  //collapse,\n  //collapse-r,\n  elastic,\n  //elastic-r,\n  //emphatic,\n  //emphatic-r,\n  //minus,\n  //slider,\n  //slider-r,\n  //spin,\n  //spin-r,\n  //spring,\n  //spring-r,\n  //stand,\n  //stand-r,\n  //squeeze,\n  //vortex,\n  //vortex-r\n) !default;\n\n// Base Hamburger (We need this)\n// ==================================================\n@import \"base\";\n\n// Hamburger types\n// ==================================================\n@import \"types/3dx\";\n@import \"types/3dx-r\";\n@import \"types/3dy\";\n@import \"types/3dy-r\";\n@import \"types/3dxy\";\n@import \"types/3dxy-r\";\n@import \"types/arrow\";\n@import \"types/arrow-r\";\n@import \"types/arrowalt\";\n@import \"types/arrowalt-r\";\n@import \"types/arrowturn\";\n@import \"types/arrowturn-r\";\n@import \"types/boring\";\n@import \"types/collapse\";\n@import \"types/collapse-r\";\n@import \"types/elastic\";\n@import \"types/elastic-r\";\n@import \"types/emphatic\";\n@import \"types/emphatic-r\";\n@import \"types/minus\";\n@import \"types/slider\";\n@import \"types/slider-r\";\n@import \"types/spin\";\n@import \"types/spin-r\";\n@import \"types/spring\";\n@import \"types/spring-r\";\n@import \"types/stand\";\n@import \"types/stand-r\";\n@import \"types/squeeze\";\n@import \"types/vortex\";\n@import \"types/vortex-r\";\n\n// ==================================================\n// Cooking up additional types:\n//\n// The Sass for each hamburger type should be nested\n// inside an @if directive to check whether or not\n// it exists in $hamburger-types so only the CSS for\n// included types are generated.\n//\n// e.g. hamburgers/types/_new-type.scss\n//\n// @if index($hamburger-types, new-type) {\n//   .hamburger--new-type {\n//     ...\n//   }\n// }\n","// Hamburger\n// ==================================================\n@use \"sass:math\";\n\n.hamburger {\n  padding: $hamburger-padding-y $hamburger-padding-x;\n  display: inline-block;\n  cursor: pointer;\n\n  transition-property: opacity, filter;\n  transition-duration: 0.15s;\n  transition-timing-function: linear;\n\n  // Normalize (<button>)\n  font: inherit;\n  color: inherit;\n  text-transform: none;\n  background-color: transparent;\n  border: 0;\n  margin: 0;\n  overflow: visible;\n\n  &:hover {\n    @if $hamburger-hover-use-filter == true {\n      filter: $hamburger-hover-filter;\n    }\n    @else {\n      opacity: $hamburger-hover-opacity;\n    }\n  }\n\n  &.is-active {\n    &:hover {\n      @if $hamburger-hover-use-filter == true {\n        filter: $hamburger-active-hover-filter;\n      }\n      @else {\n        opacity: $hamburger-active-hover-opacity;\n      }\n    }\n\n    .hamburger-inner,\n    .hamburger-inner::before,\n    .hamburger-inner::after {\n      background-color: $hamburger-active-layer-color;\n    }\n  }\n}\n\n.hamburger-box {\n  width: $hamburger-layer-width;\n  height: $hamburger-layer-height * 3 + $hamburger-layer-spacing * 2;\n  display: inline-block;\n  position: relative;\n}\n\n.hamburger-inner {\n  display: block;\n  top: 50%;\n  margin-top: math.div($hamburger-layer-height, -2);\n\n  &,\n  &::before,\n  &::after {\n    width: $hamburger-layer-width;\n    height: $hamburger-layer-height;\n    background-color: $hamburger-layer-color;\n    border-radius: $hamburger-layer-border-radius;\n    position: absolute;\n    transition-property: transform;\n    transition-duration: 0.15s;\n    transition-timing-function: ease;\n  }\n\n  &::before,\n  &::after {\n    content: \"\";\n    display: block;\n  }\n\n  &::before {\n    top: ($hamburger-layer-spacing + $hamburger-layer-height) * -1;\n  }\n\n  &::after {\n    bottom: ($hamburger-layer-spacing + $hamburger-layer-height) * -1;\n  }\n}\n","@use \"sass:math\";\n\n@if index($hamburger-types, elastic) {\n  /*\n   * Elastic\n   */\n  .hamburger--elastic {\n    .hamburger-inner {\n      top: math.div($hamburger-layer-height, 2);\n      transition-duration: 0.275s;\n      transition-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);\n\n      &::before {\n        top: $hamburger-layer-height + $hamburger-layer-spacing;\n        transition: opacity 0.125s 0.275s ease;\n      }\n\n      &::after {\n        top: ($hamburger-layer-height * 2) + ($hamburger-layer-spacing * 2);\n        transition: transform 0.275s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n      }\n    }\n\n    &.is-active {\n      .hamburger-inner {\n        $y-offset: $hamburger-layer-spacing + $hamburger-layer-height;\n\n        transform: translate3d(0, $y-offset, 0) rotate(135deg);\n        transition-delay: 0.075s;\n\n        &::before {\n          transition-delay: 0s;\n          opacity: 0;\n        }\n\n        &::after {\n          transform: translate3d(0, $y-offset * -2, 0) rotate(-270deg);\n          transition-delay: 0.075s;\n        }\n      }\n    }\n  }\n}\n","// Drawers\n\n@use \"sass:math\";\n\n.drawer-content-wrapper {\n  background: $white;\n  position: relative;\n  padding: $layout-spacer-x;\n\n  .drawer-heading {\n    font-size: $font-size-sm;\n    color: $body-color;\n    margin: 0;\n    background: $gray-100;\n    padding: math.div($layout-spacer-x, 2) $layout-spacer-x;\n    border-bottom: $gray-300 solid 1px;\n    border-top: $gray-300 solid 1px;\n\n    &:first-child {\n      border-top: 0;\n    }\n  }\n\n  .drawer-section {\n    padding: $layout-spacer-x;\n  }\n\n  & > .app-sidebar__heading:first-child {\n    margin-top: 0;\n  }\n}\n\n.drawer-nav-btn {\n  @include border-radius(30px);\n  background: $white;\n  position: fixed;\n  right: math.div($layout-spacer-x, 2);\n  top: math.div($layout-spacer-x, 2);\n  padding: math.div($layout-spacer-x, 3);\n  box-shadow: $box-shadow-sm;\n  z-index: 20;\n\n  .hamburger {\n    margin-top: 4px;\n  }\n}","// @use \"sass:math\";\n\n// body.stop-scrolling {\n//   height: 100%;\n//   overflow: hidden;\n// }\n\n// .sweet-overlay {\n//   position: fixed;\n//   top: 0;\n//   right: 0;\n//   bottom: 0;\n//   left: 0;\n//   z-index: $zindex-modal-backdrop;\n//   background-color: $modal-backdrop-bg;\n//   opacity: $modal-backdrop-opacity !important;\n// }\n\n// .sweet-alert {\n//   background-color: $white;\n//   width: 30%;\n//   padding: $spacer;\n//   @include border-radius($border-radius);\n//   text-align: center;\n//   position: fixed;\n//   left: 50%;\n//   top: 50%;\n//   margin-left: -15%;\n//   margin-top: -15%;\n//   overflow: hidden;\n//   display: none;\n//   z-index: 99999;\n//   box-shadow: $box-shadow-lg-default;\n\n//   h2 {\n//     color: $gray-700;\n//     text-align: center;\n//     text-transform: none;\n//     position: relative;\n//     margin: math.div($spacer-sm, 2) 0;\n//     padding: 0;\n//     display: block;\n//   }\n\n//   p {\n//     color: $gray-500;\n//     text-align: center;\n//     position: relative;\n//     float: none;\n//     margin: 0;\n//     padding: 0;\n//   }\n\n//   fieldset {\n//     border: none;\n//     position: relative;\n//   }\n\n//   .sa-error-container {\n//     background-color: $gray-100;\n//     margin-left: -17px;\n//     margin-right: -17px;\n//     overflow: hidden;\n//     padding: 0 10px;\n//     max-height: 0;\n//     transition: padding 0.15s, max-height 0.15s;\n\n//     &.show {\n//       padding: 10px 0;\n//       max-height: 100px;\n//       transition: padding 0.25s, max-height 0.25s;\n//     }\n\n//     .icon {\n//       display: inline-block;\n//       width: 24px;\n//       height: 24px;\n//       border-radius: 50%;\n//       background-color: $danger;\n//       color: $white;\n//       line-height: 24px;\n//       text-align: center;\n//       margin-right: 3px;\n//     }\n\n//     p {\n//       display: inline-block;\n//     }\n//   }\n\n//   .sa-input-error {\n//     position: absolute;\n//     top: 29px;\n//     right: 26px;\n//     width: 20px;\n//     height: 20px;\n//     opacity: 0;\n//     -webkit-transform: scale(0.5);\n//     transform: scale(0.5);\n//     -webkit-transform-origin: 50% 50%;\n//     transform-origin: 50% 50%;\n//     -webkit-transition: all 0.1s;\n//     transition: all 0.1s;\n\n//     &::before, &::after {\n//       content: \"\";\n//       width: 20px;\n//       height: 6px;\n//       background-color: $danger;\n//       border-radius: 3px;\n//       position: absolute;\n//       top: 50%;\n//       margin-top: -4px;\n//       left: 50%;\n//       margin-left: -9px;\n//     }\n\n//     &::before {\n//       -webkit-transform: rotate(-45deg);\n//       transform: rotate(-45deg);\n//     }\n\n//     &::after {\n//       -webkit-transform: rotate(45deg);\n//       transform: rotate(45deg);\n//     }\n\n//     &.show {\n//       opacity: 1;\n//       -webkit-transform: scale(1);\n//       transform: scale(1);\n//     }\n//   }\n\n//   input {\n//     width: 100%;\n//     box-sizing: border-box;\n//     border-radius: 3px;\n//     border: 1px solid #d7d7d7;\n//     height: 43px;\n//     margin-top: 10px;\n//     margin-bottom: 17px;\n//     font-size: 18px;\n//     box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06);\n//     padding: 0 12px;\n//     display: none;\n//     -webkit-transition: all 0.3s;\n//     transition: all 0.3s;\n//   }\n\n//   input:focus {\n//     outline: none;\n//     box-shadow: 0 0 3px #c4e6f5;\n//     border: 1px solid #b4dbed;\n//   }\n\n//   .sweet-alert.show-input input {\n//     display: block;\n//   }\n\n//   .sa-confirm-button-container {\n//     display: inline-block;\n//     position: relative;\n//   }\n\n//   .la-ball-fall {\n//     position: absolute;\n//     left: 50%;\n//     top: 50%;\n//     margin-left: -27px;\n//     margin-top: 4px;\n//     opacity: 0;\n//     visibility: hidden;\n//   }\n\n//   button {\n//     display: inline-block;\n//     font-weight: $btn-font-weight;\n//     text-align: center;\n//     white-space: nowrap;\n//     font-size: $font-size-base;\n//     vertical-align: middle;\n//     user-select: none;\n//     border: $btn-border-width solid transparent;\n//     @include button-size($btn-padding-y, $btn-padding-x, $font-size-base, $btn-border-radius);\n//     @include transition($btn-transition);\n//     @include button-variant($primary, $primary);\n\n//     // Share hover and focus styles\n//     // @include hover-focus {\n//     //   text-decoration: none;\n//     // }\n\n//     &:focus,\n//     &.focus {\n//       outline: 0;\n//       box-shadow: $btn-focus-box-shadow;\n//     }\n\n//     // Disabled comes first so active can properly restyle\n//     &.disabled,\n//     &:disabled {\n//       opacity: $btn-disabled-opacity;\n//       @include box-shadow(none);\n//     }\n//   }\n\n//   button.cancel {\n//     font-weight: $font-weight-normal;\n//     color: $link-color;\n//     background-color: transparent;\n//     border-color: transparent;\n//     margin-right: 0.5rem;\n\n//     // @include hover {\n//     //   color: $link-hover-color;\n//     //   text-decoration: $link-hover-decoration;\n//     //   background-color: transparent;\n//     //   border-color: transparent;\n//     // }\n\n//     &:active,\n//     &.active,\n//     &:focus,\n//     &.focus {\n//       text-decoration: none;\n//       border-color: transparent;\n//       box-shadow: none;\n//       background-color: transparent;\n//     }\n\n//     &:disabled,\n//     &.disabled {\n//       color: $btn-link-disabled-color;\n//       pointer-events: none;\n//     }\n//   }\n\n//   button.confirm[disabled] ~ .la-ball-fall {\n//     opacity: 1;\n//     visibility: visible;\n//     transition-delay: 0s;\n//   }\n\n//   &[data-has-cancel-button=false] button {\n//     box-shadow: none !important;\n//   }\n\n//   &[data-has-confirm-button=false][data-has-cancel-button=false] {\n//     padding-bottom: 40px;\n//   }\n\n//   .sa-button-container {\n//     padding: $spacer 0 0;\n//   }\n\n// }\n\n.sa-icon {\n  width: 80px;\n  height: 80px;\n  border: 4px solid $gray-300;\n  -webkit-border-radius: 40px;\n  border-radius: 50%;\n  margin: 20px auto;\n  padding: 0;\n  position: relative;\n  box-sizing: content-box;\n\n  &.sa-error {\n    border-color: $danger;\n\n    .sa-x-mark {\n      position: relative;\n      display: block;\n    }\n\n    .sa-line {\n      position: absolute;\n      height: 5px;\n      width: 47px;\n      background-color: $danger;\n      display: block;\n      top: 37px;\n      border-radius: 2px;\n\n      &.sa-left {\n        -webkit-transform: rotate(45deg);\n        transform: rotate(45deg);\n        left: 17px;\n      }\n\n      &.sa-right {\n        -webkit-transform: rotate(-45deg);\n        transform: rotate(-45deg);\n        right: 16px;\n      }\n    }\n  }\n\n  &.sa-warning {\n    border-color: $warning;\n\n    .sa-body {\n      position: absolute;\n      width: 5px;\n      height: 47px;\n      left: 50%;\n      top: 10px;\n      -webkit-border-radius: 2px;\n      border-radius: 2px;\n      margin-left: -2px;\n      background-color: $warning;\n    }\n\n    .sa-dot {\n      position: absolute;\n      width: 7px;\n      height: 7px;\n      -webkit-border-radius: 50%;\n      border-radius: 50%;\n      margin-left: -3px;\n      left: 50%;\n      bottom: 10px;\n      background-color: $warning;\n    }\n  }\n\n  &.sa-info {\n    border-color: $info;\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      width: 5px;\n      height: 29px;\n      left: 50%;\n      bottom: 17px;\n      border-radius: 2px;\n      margin-left: -2px;\n      background-color: $info;\n    }\n\n    &::after {\n      content: \"\";\n      position: absolute;\n      width: 7px;\n      height: 7px;\n      border-radius: 50%;\n      margin-left: -3px;\n      top: 19px;\n      background-color: $info;\n    }\n  }\n\n  &.sa-success {\n    border-color: $success;\n\n    &::before,\n    &::after {\n      content: '';\n      -webkit-border-radius: 40px;\n      border-radius: 50%;\n      position: absolute;\n      width: 60px;\n      height: 120px;\n      background: $white;\n      -webkit-transform: rotate(45deg);\n      transform: rotate(45deg);\n    }\n\n    &::before {\n      -webkit-border-radius: 120px 0 0 120px;\n      border-radius: 120px 0 0 120px;\n      top: -7px;\n      left: -33px;\n      -webkit-transform: rotate(-45deg);\n      transform: rotate(-45deg);\n      -webkit-transform-origin: 60px 60px;\n      transform-origin: 60px 60px;\n    }\n\n    &::after {\n      -webkit-border-radius: 0 120px 120px 0;\n      border-radius: 0 120px 120px 0;\n      top: -11px;\n      left: 30px;\n      -webkit-transform: rotate(-45deg);\n      transform: rotate(-45deg);\n      -webkit-transform-origin: 0 60px;\n      transform-origin: 0 60px;\n    }\n\n    .sa-placeholder {\n      width: 80px;\n      height: 80px;\n      border: 4px solid rgba(165, 220, 134, 0.2);\n      -webkit-border-radius: 40px;\n      border-radius: 40px;\n      border-radius: 50%;\n      box-sizing: content-box;\n      position: absolute;\n      left: -4px;\n      top: -4px;\n      z-index: 2;\n    }\n\n    .sa-fix {\n      width: 5px;\n      height: 90px;\n      background-color: $white;\n      position: absolute;\n      left: 28px;\n      top: 8px;\n      z-index: 1;\n      -webkit-transform: rotate(-45deg);\n      transform: rotate(-45deg);\n    }\n\n    .sa-line {\n      height: 5px;\n      background-color: $success;\n      display: block;\n      border-radius: 2px;\n      position: absolute;\n      z-index: 2;\n\n      &.sa-tip {\n        width: 25px;\n        left: 14px;\n        top: 46px;\n        -webkit-transform: rotate(45deg);\n        transform: rotate(45deg);\n      }\n\n      &.sa-long {\n        width: 47px;\n        right: 8px;\n        top: 38px;\n        -webkit-transform: rotate(-45deg);\n        transform: rotate(-45deg);\n      }\n    }\n  }\n\n  &.sa-custom {\n    background-size: contain;\n    border-radius: 0;\n    border: none;\n    background-position: center center;\n    background-repeat: no-repeat;\n  }\n}\n\n// @media all and (max-width: 540px) {\n//   .sweet-alert {\n//     width: auto;\n//     margin-left: 0;\n//     margin-right: 0;\n//     left: 15px;\n//     right: 15px;\n//   }\n// }\n\n// /*\n//  * Animations\n//  */\n// @-webkit-keyframes showSweetAlert {\n//   0% {\n//     transform: scale(0.7);\n//     -webkit-transform: scale(0.7);\n//   }\n//   45% {\n//     transform: scale(1.05);\n//     -webkit-transform: scale(1.05);\n//   }\n//   80% {\n//     transform: scale(0.95);\n//     -webkit-transform: scale(0.95);\n//   }\n//   100% {\n//     transform: scale(1);\n//     -webkit-transform: scale(1);\n//   }\n// }\n\n// @keyframes showSweetAlert {\n//   0% {\n//     transform: scale(0.7);\n//     -webkit-transform: scale(0.7);\n//   }\n//   45% {\n//     transform: scale(1.05);\n//     -webkit-transform: scale(1.05);\n//   }\n//   80% {\n//     transform: scale(0.95);\n//     -webkit-transform: scale(0.95);\n//   }\n//   100% {\n//     transform: scale(1);\n//     -webkit-transform: scale(1);\n//   }\n// }\n\n// @-webkit-keyframes hideSweetAlert {\n//   0% {\n//     transform: scale(1);\n//     -webkit-transform: scale(1);\n//   }\n//   100% {\n//     transform: scale(0.5);\n//     -webkit-transform: scale(0.5);\n//   }\n// }\n\n// @keyframes hideSweetAlert {\n//   0% {\n//     transform: scale(1);\n//     -webkit-transform: scale(1);\n//   }\n//   100% {\n//     transform: scale(0.5);\n//     -webkit-transform: scale(0.5);\n//   }\n// }\n\n// @-webkit-keyframes slideFromTop {\n//   0% {\n//     top: 0%;\n//   }\n//   100% {\n//     top: 50%;\n//   }\n// }\n\n// @keyframes slideFromTop {\n//   0% {\n//     top: 0%;\n//   }\n//   100% {\n//     top: 50%;\n//   }\n// }\n\n// @-webkit-keyframes slideToTop {\n//   0% {\n//     top: 50%;\n//   }\n//   100% {\n//     top: 0%;\n//   }\n// }\n\n// @keyframes slideToTop {\n//   0% {\n//     top: 50%;\n//   }\n//   100% {\n//     top: 0%;\n//   }\n// }\n\n// @-webkit-keyframes slideFromBottom {\n//   0% {\n//     top: 70%;\n//   }\n//   100% {\n//     top: 50%;\n//   }\n// }\n\n// @keyframes slideFromBottom {\n//   0% {\n//     top: 70%;\n//   }\n//   100% {\n//     top: 50%;\n//   }\n// }\n\n// @-webkit-keyframes slideToBottom {\n//   0% {\n//     top: 50%;\n//   }\n//   100% {\n//     top: 70%;\n//   }\n// }\n\n// @keyframes slideToBottom {\n//   0% {\n//     top: 50%;\n//   }\n//   100% {\n//     top: 70%;\n//   }\n// }\n\n// .showSweetAlert[data-animation=pop] {\n//   -webkit-animation: showSweetAlert 0.3s;\n//   animation: showSweetAlert 0.3s;\n// }\n\n// .showSweetAlert[data-animation=none] {\n//   -webkit-animation: none;\n//   animation: none;\n// }\n\n// .showSweetAlert[data-animation=slide-from-top] {\n//   -webkit-animation: slideFromTop 0.3s;\n//   animation: slideFromTop 0.3s;\n// }\n\n// .showSweetAlert[data-animation=slide-from-bottom] {\n//   -webkit-animation: slideFromBottom 0.3s;\n//   animation: slideFromBottom 0.3s;\n// }\n\n// .hideSweetAlert[data-animation=pop] {\n//   -webkit-animation: hideSweetAlert 0.2s;\n//   animation: hideSweetAlert 0.2s;\n// }\n\n// .hideSweetAlert[data-animation=none] {\n//   -webkit-animation: none;\n//   animation: none;\n// }\n\n// .hideSweetAlert[data-animation=slide-from-top] {\n//   -webkit-animation: slideToTop 0.4s;\n//   animation: slideToTop 0.4s;\n// }\n\n// .hideSweetAlert[data-animation=slide-from-bottom] {\n//   -webkit-animation: slideToBottom 0.3s;\n//   animation: slideToBottom 0.3s;\n// }\n\n@-webkit-keyframes animateSuccessTip {\n  0% {\n    width: 0;\n    left: 1px;\n    top: 19px;\n  }\n  54% {\n    width: 0;\n    left: 1px;\n    top: 19px;\n  }\n  70% {\n    width: 50px;\n    left: -8px;\n    top: 37px;\n  }\n  84% {\n    width: 17px;\n    left: 21px;\n    top: 48px;\n  }\n  100% {\n    width: 25px;\n    left: 14px;\n    top: 45px;\n  }\n}\n\n@keyframes animateSuccessTip {\n  0% {\n    width: 0;\n    left: 1px;\n    top: 19px;\n  }\n  54% {\n    width: 0;\n    left: 1px;\n    top: 19px;\n  }\n  70% {\n    width: 50px;\n    left: -8px;\n    top: 37px;\n  }\n  84% {\n    width: 17px;\n    left: 21px;\n    top: 48px;\n  }\n  100% {\n    width: 25px;\n    left: 14px;\n    top: 45px;\n  }\n}\n\n@-webkit-keyframes animateSuccessLong {\n  0% {\n    width: 0;\n    right: 46px;\n    top: 54px;\n  }\n  65% {\n    width: 0;\n    right: 46px;\n    top: 54px;\n  }\n  84% {\n    width: 55px;\n    right: 0;\n    top: 35px;\n  }\n  100% {\n    width: 47px;\n    right: 8px;\n    top: 38px;\n  }\n}\n\n@keyframes animateSuccessLong {\n  0% {\n    width: 0;\n    right: 46px;\n    top: 54px;\n  }\n  65% {\n    width: 0;\n    right: 46px;\n    top: 54px;\n  }\n  84% {\n    width: 55px;\n    right: 0;\n    top: 35px;\n  }\n  100% {\n    width: 47px;\n    right: 8px;\n    top: 38px;\n  }\n}\n\n// @-webkit-keyframes rotatePlaceholder {\n//   0% {\n//     transform: rotate(-45deg);\n//     -webkit-transform: rotate(-45deg);\n//   }\n//   5% {\n//     transform: rotate(-45deg);\n//     -webkit-transform: rotate(-45deg);\n//   }\n//   12% {\n//     transform: rotate(-405deg);\n//     -webkit-transform: rotate(-405deg);\n//   }\n//   100% {\n//     transform: rotate(-405deg);\n//     -webkit-transform: rotate(-405deg);\n//   }\n// }\n\n// @keyframes rotatePlaceholder {\n//   0% {\n//     transform: rotate(-45deg);\n//     -webkit-transform: rotate(-45deg);\n//   }\n//   5% {\n//     transform: rotate(-45deg);\n//     -webkit-transform: rotate(-45deg);\n//   }\n//   12% {\n//     transform: rotate(-405deg);\n//     -webkit-transform: rotate(-405deg);\n//   }\n//   100% {\n//     transform: rotate(-405deg);\n//     -webkit-transform: rotate(-405deg);\n//   }\n// }\n\n.animateSuccessTip {\n  -webkit-animation: animateSuccessTip 0.75s;\n  animation: animateSuccessTip 0.75s;\n}\n\n.animateSuccessLong {\n  -webkit-animation: animateSuccessLong 0.75s;\n  animation: animateSuccessLong 0.75s;\n}\n\n.sa-icon.sa-success.animate::after {\n  -webkit-animation: rotatePlaceholder 4.25s ease-in;\n  animation: rotatePlaceholder 4.25s ease-in;\n}\n\n// @-webkit-keyframes animateErrorIcon {\n//   0% {\n//     transform: rotateX(100deg);\n//     -webkit-transform: rotateX(100deg);\n//     opacity: 0;\n//   }\n//   100% {\n//     transform: rotateX(0deg);\n//     -webkit-transform: rotateX(0deg);\n//     opacity: 1;\n//   }\n// }\n\n// @keyframes animateErrorIcon {\n//   0% {\n//     transform: rotateX(100deg);\n//     -webkit-transform: rotateX(100deg);\n//     opacity: 0;\n//   }\n//   100% {\n//     transform: rotateX(0deg);\n//     -webkit-transform: rotateX(0deg);\n//     opacity: 1;\n//   }\n// }\n\n// .animateErrorIcon {\n//   -webkit-animation: animateErrorIcon 0.5s;\n//   animation: animateErrorIcon 0.5s;\n// }\n\n// @-webkit-keyframes animateXMark {\n//   0% {\n//     transform: scale(0.4);\n//     -webkit-transform: scale(0.4);\n//     margin-top: 26px;\n//     opacity: 0;\n//   }\n//   50% {\n//     transform: scale(0.4);\n//     -webkit-transform: scale(0.4);\n//     margin-top: 26px;\n//     opacity: 0;\n//   }\n//   80% {\n//     transform: scale(1.15);\n//     -webkit-transform: scale(1.15);\n//     margin-top: -6px;\n//   }\n//   100% {\n//     transform: scale(1);\n//     -webkit-transform: scale(1);\n//     margin-top: 0;\n//     opacity: 1;\n//   }\n// }\n\n// @keyframes animateXMark {\n//   0% {\n//     transform: scale(0.4);\n//     -webkit-transform: scale(0.4);\n//     margin-top: 26px;\n//     opacity: 0;\n//   }\n//   50% {\n//     transform: scale(0.4);\n//     -webkit-transform: scale(0.4);\n//     margin-top: 26px;\n//     opacity: 0;\n//   }\n//   80% {\n//     transform: scale(1.15);\n//     -webkit-transform: scale(1.15);\n//     margin-top: -6px;\n//   }\n//   100% {\n//     transform: scale(1);\n//     -webkit-transform: scale(1);\n//     margin-top: 0;\n//     opacity: 1;\n//   }\n// }\n\n// .animateXMark {\n//   -webkit-animation: animateXMark 0.5s;\n//   animation: animateXMark 0.5s;\n// }\n\n// @-webkit-keyframes pulseWarning {\n//   0% {\n//     border-color: #F8D486;\n//   }\n//   100% {\n//     border-color: $warning;\n//   }\n// }\n\n// @keyframes pulseWarning {\n//   0% {\n//     border-color: #F8D486;\n//   }\n//   100% {\n//     border-color: $warning;\n//   }\n// }\n\n// .pulseWarning {\n//   -webkit-animation: pulseWarning 0.75s infinite alternate;\n//   animation: pulseWarning 0.75s infinite alternate;\n// }\n\n// @-webkit-keyframes pulseWarningIns {\n//   0% {\n//     background-color: #F8D486;\n//   }\n//   100% {\n//     background-color: $warning;\n//   }\n// }\n\n// @keyframes pulseWarningIns {\n//   0% {\n//     background-color: #F8D486;\n//   }\n//   100% {\n//     background-color: $warning;\n//   }\n// }\n\n// .pulseWarningIns {\n//   -webkit-animation: pulseWarningIns 0.75s infinite alternate;\n//   animation: pulseWarningIns 0.75s infinite alternate;\n// }\n\n// @-webkit-keyframes rotate-loading {\n//   0% {\n//     transform: rotate(0deg);\n//   }\n//   100% {\n//     transform: rotate(360deg);\n//   }\n// }\n\n// @keyframes rotate-loading {\n//   0% {\n//     transform: rotate(0deg);\n//   }\n//   100% {\n//     transform: rotate(360deg);\n//   }\n// }\n\n// /* Internet Explorer 9 has some special quirks that are fixed here */\n// /* The icons are not animated. */\n// /* This file is automatically merged into sweet-alert.min.js through Gulp */\n// /* Error icon */\n// .sweet-alert .sa-icon.sa-error .sa-line.sa-left {\n//   -ms-transform: rotate(45deg) \\9\n// ;\n// }\n\n// .sweet-alert .sa-icon.sa-error .sa-line.sa-right {\n//   -ms-transform: rotate(-45deg) \\9\n// ;\n// }\n\n/* Success icon */\n.sweet-alert .sa-icon.sa-success {\n  border-color: transparent \\9\n;\n}\n\n.sweet-alert .sa-icon.sa-success .sa-line.sa-tip {\n  -ms-transform: rotate(45deg) \\9\n;\n}\n\n.sweet-alert .sa-icon.sa-sucsuccesscess .sa-line.sa-long {\n  -ms-transform: rotate(-45deg) \\9\n;\n}\n\n// /*!\n//  * Load Awesome v1.1.0 (http://github.danielcardoso.net/load-awesome/)\n//  * Copyright 2015 Daniel Cardoso <@DanielCardoso>\n//  * Licensed under MIT\n//  */\n// .la-ball-fall,\n// .la-ball-fall > div {\n//   position: relative;\n//   -webkit-box-sizing: border-box;\n//   -moz-box-sizing: border-box;\n//   box-sizing: border-box;\n// }\n\n// .la-ball-fall {\n//   display: block;\n//   font-size: 0;\n//   color: #fff;\n// }\n\n// .la-ball-fall.la-dark {\n//   color: #333;\n// }\n\n// .la-ball-fall > div {\n//   display: inline-block;\n//   float: none;\n//   background-color: currentColor;\n//   border: 0 solid currentColor;\n// }\n\n// .la-ball-fall {\n//   width: 54px;\n//   height: 18px;\n// }\n\n// .la-ball-fall > div {\n//   width: 10px;\n//   height: 10px;\n//   margin: 4px;\n//   border-radius: 100%;\n//   opacity: 0;\n//   -webkit-animation: ball-fall 1s ease-in-out infinite;\n//   -moz-animation: ball-fall 1s ease-in-out infinite;\n//   -o-animation: ball-fall 1s ease-in-out infinite;\n//   animation: ball-fall 1s ease-in-out infinite;\n// }\n\n// .la-ball-fall > div:nth-child(1) {\n//   -webkit-animation-delay: -200ms;\n//   -moz-animation-delay: -200ms;\n//   -o-animation-delay: -200ms;\n//   animation-delay: -200ms;\n// }\n\n// .la-ball-fall > div:nth-child(2) {\n//   -webkit-animation-delay: -100ms;\n//   -moz-animation-delay: -100ms;\n//   -o-animation-delay: -100ms;\n//   animation-delay: -100ms;\n// }\n\n// .la-ball-fall > div:nth-child(3) {\n//   -webkit-animation-delay: 0ms;\n//   -moz-animation-delay: 0ms;\n//   -o-animation-delay: 0ms;\n//   animation-delay: 0ms;\n// }\n\n// .la-ball-fall.la-sm {\n//   width: 26px;\n//   height: 8px;\n// }\n\n// .la-ball-fall.la-sm > div {\n//   width: 4px;\n//   height: 4px;\n//   margin: 2px;\n// }\n\n// .la-ball-fall.la-2x {\n//   width: 108px;\n//   height: 36px;\n// }\n\n// .la-ball-fall.la-2x > div {\n//   width: 20px;\n//   height: 20px;\n//   margin: 8px;\n// }\n\n// .la-ball-fall.la-3x {\n//   width: 162px;\n//   height: 54px;\n// }\n\n// .la-ball-fall.la-3x > div {\n//   width: 30px;\n//   height: 30px;\n//   margin: 12px;\n// }\n\n// /*\n//  * Animation\n//  */\n// @-webkit-keyframes ball-fall {\n//   0% {\n//     opacity: 0;\n//     -webkit-transform: translateY(-145%);\n//     transform: translateY(-145%);\n//   }\n//   10% {\n//     opacity: .5;\n//   }\n//   20% {\n//     opacity: 1;\n//     -webkit-transform: translateY(0);\n//     transform: translateY(0);\n//   }\n//   80% {\n//     opacity: 1;\n//     -webkit-transform: translateY(0);\n//     transform: translateY(0);\n//   }\n//   90% {\n//     opacity: .5;\n//   }\n//   100% {\n//     opacity: 0;\n//     -webkit-transform: translateY(145%);\n//     transform: translateY(145%);\n//   }\n// }\n\n// @-moz-keyframes ball-fall {\n//   0% {\n//     opacity: 0;\n//     -moz-transform: translateY(-145%);\n//     transform: translateY(-145%);\n//   }\n//   10% {\n//     opacity: .5;\n//   }\n//   20% {\n//     opacity: 1;\n//     -moz-transform: translateY(0);\n//     transform: translateY(0);\n//   }\n//   80% {\n//     opacity: 1;\n//     -moz-transform: translateY(0);\n//     transform: translateY(0);\n//   }\n//   90% {\n//     opacity: .5;\n//   }\n//   100% {\n//     opacity: 0;\n//     -moz-transform: translateY(145%);\n//     transform: translateY(145%);\n//   }\n// }\n\n// @-o-keyframes ball-fall {\n//   0% {\n//     opacity: 0;\n//     -o-transform: translateY(-145%);\n//     transform: translateY(-145%);\n//   }\n//   10% {\n//     opacity: .5;\n//   }\n//   20% {\n//     opacity: 1;\n//     -o-transform: translateY(0);\n//     transform: translateY(0);\n//   }\n//   80% {\n//     opacity: 1;\n//     -o-transform: translateY(0);\n//     transform: translateY(0);\n//   }\n//   90% {\n//     opacity: .5;\n//   }\n//   100% {\n//     opacity: 0;\n//     -o-transform: translateY(145%);\n//     transform: translateY(145%);\n//   }\n// }\n\n// @keyframes ball-fall {\n//   0% {\n//     opacity: 0;\n//     -webkit-transform: translateY(-145%);\n//     -moz-transform: translateY(-145%);\n//     -o-transform: translateY(-145%);\n//     transform: translateY(-145%);\n//   }\n//   10% {\n//     opacity: .5;\n//   }\n//   20% {\n//     opacity: 1;\n//     -webkit-transform: translateY(0);\n//     -moz-transform: translateY(0);\n//     -o-transform: translateY(0);\n//     transform: translateY(0);\n//   }\n//   80% {\n//     opacity: 1;\n//     -webkit-transform: translateY(0);\n//     -moz-transform: translateY(0);\n//     -o-transform: translateY(0);\n//     transform: translateY(0);\n//   }\n//   90% {\n//     opacity: .5;\n//   }\n//   100% {\n//     opacity: 0;\n//     -webkit-transform: translateY(145%);\n//     -moz-transform: translateY(145%);\n//     -o-transform: translateY(145%);\n//     transform: translateY(145%);\n//   }\n// }\n","@use \"sass:math\";\n\n.#{$rt-namespace}__toast-container {\n    z-index: $rt-z-index;\n    position: fixed;\n    padding: 0;\n    width: $rt-toast-width;\n    box-sizing: border-box;\n    color: $white;\n    &--top-left {\n        top: $spacer;\n        left: $spacer;\n    }\n    &--top-center {\n        top: $spacer;\n        left: 50%;\n        margin-left: -(math.div($rt-toast-width, 2));\n    }\n    &--top-right {\n        top: $spacer;\n        right: $spacer;\n    }\n    &--bottom-left {\n        bottom: $spacer;\n        left: $spacer;\n    }\n    &--bottom-center {\n        bottom: $spacer;\n        left: 50%;\n        margin-left: -(math.div($rt-toast-width, 2));\n    }\n    &--bottom-right {\n        bottom: $spacer;\n        right: $spacer;\n    }\n}\n\n@media #{$rt-mobile} {\n    .#{$rt-namespace}__toast-container {\n        width: 100vw;\n        padding: 0;\n        left: 0;\n        margin: 0;\n        &--top-left,\n        &--top-center,\n        &--top-right {\n            top: 0;\n        }\n        &--bottom-left,\n        &--bottom-center,\n        &--bottom-right {\n            bottom: 0;\n        }\n        &--rtl{\n          right: 0;\n          left: initial;\n        }\n    }\n}\n","$rt-namespace: 'Toastify';\n$rt-toast-width: 320px !default;\n$rt-toast-background: #ffffff !default;\n$rt-toast-min-height: 54px !default;\n$rt-toast-max-height: 800px !default;\n\n\n$rt-color-default: #fff !default;\n$rt-color-info: $info !default;\n$rt-color-success: $success !default;\n$rt-color-warning: $warning !default;\n$rt-color-error: $danger !default;\n\n$rt-color-progress-default: $primary !default;\n\n$rt-mobile: \"only screen and (max-width : 480px)\" !default;\n$rt-font-family: sans-serif !default;\n$rt-z-index: 9999 !default;\n\n","@use \"sass:math\";\n\n.#{$rt-namespace}__toast {\n    position: relative;\n    min-height: $rt-toast-min-height;\n    box-sizing: border-box;\n    margin-bottom: 1rem;\n    padding: $spacer;\n    @include border-radius($border-radius);\n    box-shadow: $box-shadow-default;\n    display: flex;\n    justify-content: space-between;\n    max-height: $rt-toast-max-height;\n    overflow: hidden;\n    font-family: $rt-font-family;\n    cursor: pointer;\n    direction: ltr;\n    &--rtl {\n        direction: rtl;\n    }\n    &--default {\n        background: $rt-color-default;\n        color: $gray-700;\n        @include box-shadow-architect($primary);\n    }\n    &--info {\n        background: $rt-color-info;\n        @include box-shadow-architect($info);\n    }\n    &--success {\n        background: $rt-color-success;\n        @include box-shadow-architect($success);\n    }\n    &--warning {\n        background: $rt-color-warning;\n        @include box-shadow-architect($warning);\n    }\n    &--error {\n        background: $rt-color-error;\n        @include box-shadow-architect($danger);\n    }\n    &-body {\n        margin: auto 0;\n        padding: 0 0 math.div($spacer, 2.5);\n    }\n}\n\n@media #{$rt-mobile} {\n  .#{$rt-namespace}__toast{\n    margin-bottom: 0;  \n  }\n}",".#{$rt-namespace}__close-button {\n  color: $white;\n  font-size: 14px;\n  background: transparent;\n  outline: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  opacity: 0.7;\n  transition: 0.3s ease;\n  position: absolute;\n  top: 5px;\n  right: 9px;\n  &--default {\n    color: #000;\n    opacity: 0.3;\n  }\n\n  &:hover,\n  &:focus {\n    opacity: 1;\n  }\n}\n","@keyframes #{$rt-namespace}__trackProgress {\n  0%{\n    width: 96%;\n  }\n  100%{\n    width: 0;\n  }\n}\n\n.#{$rt-namespace}__progress-bar {\n  position: absolute;\n  bottom: 9%;\n  left: 2%;\n  width: 0;\n  height: 5px;\n  z-index: $rt-z-index;\n  animation: #{$rt-namespace}__trackProgress linear 1;\n  background-color: rgba(255,255,255,.3);\n  @include border-radius($border-radius);\n\n  &--rtl {\n    right: 0;\n    left: initial;\n  }\n  &--default{\n    background: $rt-color-progress-default;\n  }\n\n  &--info{}\n  &--success{}\n  &--warning{}\n  &--error{}\n}\n","@mixin timing-function {\n    animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);\n}\n\n@keyframes #{$rt-namespace}__bounceInRight {\n    from,\n    60%,\n    75%,\n    90%,\n    to {\n        @include timing-function;\n    }\n    from {\n        opacity: 0;\n        transform: translate3d(3000px, 0, 0);\n    }\n    60% {\n        opacity: 1;\n        transform: translate3d(-25px, 0, 0);\n    }\n    75% {\n        transform: translate3d(10px, 0, 0);\n    }\n    90% {\n        transform: translate3d(-5px, 0, 0);\n    }\n    to {\n        transform: none;\n    }\n}\n\n@keyframes #{$rt-namespace}__bounceOutRight {\n    20% {\n        opacity: 1;\n        transform: translate3d(-20px, 0, 0);\n    }\n    to {\n        opacity: 0;\n        transform: translate3d(2000px, 0, 0);\n    }\n}\n\n@keyframes #{$rt-namespace}__bounceInLeft {\n    from,\n    60%,\n    75%,\n    90%,\n    to {\n        @include timing-function;\n    }\n    0% {\n        opacity: 0;\n        transform: translate3d(-3000px, 0, 0);\n    }\n    60% {\n        opacity: 1;\n        transform: translate3d(25px, 0, 0);\n    }\n    75% {\n        transform: translate3d(-10px, 0, 0);\n    }\n    90% {\n        transform: translate3d(5px, 0, 0);\n    }\n    to {\n        transform: none;\n    }\n}\n\n@keyframes #{$rt-namespace}__bounceOutLeft {\n    20% {\n        opacity: 1;\n        transform: translate3d(20px, 0, 0);\n    }\n    to {\n        opacity: 0;\n        transform: translate3d(-2000px, 0, 0);\n    }\n}\n\n@keyframes #{$rt-namespace}__bounceInUp {\n    from,\n    60%,\n    75%,\n    90%,\n    to {\n        @include timing-function;\n    }\n    from {\n        opacity: 0;\n        transform: translate3d(0, 3000px, 0);\n    }\n    60% {\n        opacity: 1;\n        transform: translate3d(0, -20px, 0);\n    }\n    75% {\n        transform: translate3d(0, 10px, 0);\n    }\n    90% {\n        transform: translate3d(0, -5px, 0);\n    }\n    to {\n        transform: translate3d(0, 0, 0);\n    }\n}\n\n@keyframes #{$rt-namespace}__bounceOutUp {\n    20% {\n        transform: translate3d(0, -10px, 0);\n    }\n    40%,\n    45% {\n        opacity: 1;\n        transform: translate3d(0, 20px, 0);\n    }\n    to {\n        opacity: 0;\n        transform: translate3d(0, -2000px, 0);\n    }\n}\n\n@keyframes #{$rt-namespace}__bounceInDown {\n    from,\n    60%,\n    75%,\n    90%,\n    to {\n        @include timing-function;\n    }\n    0% {\n        opacity: 0;\n        transform: translate3d(0, -3000px, 0);\n    }\n    60% {\n        opacity: 1;\n        transform: translate3d(0, 25px, 0);\n    }\n    75% {\n        transform: translate3d(0, -10px, 0);\n    }\n    90% {\n        transform: translate3d(0, 5px, 0);\n    }\n    to {\n        transform: none;\n    }\n}\n\n@keyframes #{$rt-namespace}__bounceOutDown {\n    20% {\n        transform: translate3d(0, 10px, 0);\n    }\n    40%,\n    45% {\n        opacity: 1;\n        transform: translate3d(0, -20px, 0);\n    }\n    to {\n        opacity: 0;\n        transform: translate3d(0, 2000px, 0);\n    }\n}\n\n.#{$rt-namespace}__bounce-enter {\n    &--top-left,\n    &--bottom-left {\n        animation-name: #{$rt-namespace}__bounceInLeft;\n    }\n    &--top-right,\n    &--bottom-right {\n        animation-name: #{$rt-namespace}__bounceInRight;\n    }\n    &--top-center {\n        animation-name: #{$rt-namespace}__bounceInDown;\n    }\n    &--bottom-center {\n        animation-name: #{$rt-namespace}__bounceInUp;\n    }\n}\n\n.#{$rt-namespace}__bounce-exit {\n    &--top-left,\n    &--bottom-left {\n        animation-name: #{$rt-namespace}__bounceOutLeft;\n    }\n    &--top-right,\n    &--bottom-right {\n        animation-name: #{$rt-namespace}__bounceOutRight;\n    }\n    &--top-center {\n        animation-name: #{$rt-namespace}__bounceOutUp;\n    }\n    &--bottom-center {\n        animation-name: #{$rt-namespace}__bounceOutDown;\n    }\n}","@keyframes #{$rt-namespace}__zoomIn {\n    from {\n        opacity: 0;\n        transform: scale3d(0.3, 0.3, 0.3);\n    }\n    50% {\n        opacity: 1;\n    }\n}\n\n@keyframes #{$rt-namespace}__zoomOut {\n    from {\n        opacity: 1;\n    }\n    50% {\n        opacity: 0;\n        transform: scale3d(0.3, 0.3, 0.3);\n    }\n    to {\n        opacity: 0\n    }\n}\n\n.#{$rt-namespace}__zoom-enter {\n    animation-name: #{$rt-namespace}__zoomIn;\n}\n\n.#{$rt-namespace}__zoom-exit {\n    animation-name: #{$rt-namespace}__zoomOut;\n}\n","@keyframes #{$rt-namespace}__flipIn {\n    from {\n        transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n        animation-timing-function: ease-in;\n        opacity: 0;\n    }\n    40% {\n        transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n        animation-timing-function: ease-in;\n    }\n    60% {\n        transform: perspective(400px) rotate3d(1, 0, 0, 10deg);\n        opacity: 1\n    }\n    80% {\n        transform: perspective(400px) rotate3d(1, 0, 0, -5deg);\n    }\n    to {\n        transform: perspective(400px);\n    }\n}\n\n@keyframes #{$rt-namespace}__flipOut {\n    from {\n        transform: perspective(400px);\n    }\n    30% {\n        transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n        opacity: 1\n    }\n    to {\n        transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n        opacity: 0\n    }\n}\n\n.#{$rt-namespace}__flip-enter {\n    animation-name: #{$rt-namespace}__flipIn;\n}\n\n.#{$rt-namespace}__flip-exit {\n    animation-name: #{$rt-namespace}__flipOut;\n}\n","@mixin transform {\n    transform: translate3d(0, 0, 0);\n}\n\n@keyframes #{$rt-namespace}__slideInRight {\n    from {\n        transform: translate3d(110%, 0, 0);\n        visibility: visible;\n    }\n    to {\n        @include transform;\n    }\n}\n\n@keyframes #{$rt-namespace}__slideInLeft {\n    from {\n        transform: translate3d(-110%, 0, 0);\n        visibility: visible;\n    }\n    to {\n        @include transform;\n    }\n}\n\n@keyframes #{$rt-namespace}__slideInUp {\n    from {\n        transform: translate3d(0, 110%, 0);\n        visibility: visible;\n    }\n    to {\n        @include transform;\n    }\n}\n\n@keyframes #{$rt-namespace}__slideInDown {\n    from {\n        transform: translate3d(0, -110%, 0);\n        visibility: visible;\n    }\n    to {\n        @include transform;\n    }\n}\n\n@keyframes #{$rt-namespace}__slideOutRight {\n    from {\n        @include transform;\n    }\n    to {\n        visibility: hidden;\n        transform: translate3d(110%, 0, 0);\n    }\n}\n\n@keyframes #{$rt-namespace}__slideOutLeft {\n    from {\n        @include transform;\n    }\n    to {\n        visibility: hidden;\n        transform: translate3d(-110%, 0, 0);\n    }\n}\n\n@keyframes #{$rt-namespace}__slideOutDown {\n    from {\n        @include transform;\n    }\n    to {\n        visibility: hidden;\n        transform: translate3d(0, 500px, 0);\n    }\n}\n\n@keyframes #{$rt-namespace}__slideOutUp {\n    from {\n        @include transform;\n    }\n    to {\n        visibility: hidden;\n        transform: translate3d(0, -500px, 0);\n    }\n}\n\n.#{$rt-namespace}__slide-enter {\n    &--top-left,\n    &--bottom-left {\n        animation-name: #{$rt-namespace}__slideInLeft;\n    }\n    &--top-right,\n    &--bottom-right {\n        animation-name: #{$rt-namespace}__slideInRight;\n    }\n    &--top-center {\n        animation-name: #{$rt-namespace}__slideInDown;\n    }\n    &--bottom-center {\n        animation-name: #{$rt-namespace}__slideInUp;\n    }\n}\n\n.#{$rt-namespace}__slide-exit {\n    &--top-left,\n    &--bottom-left {\n        animation-name: #{$rt-namespace}__slideOutLeft;\n    }\n    &--top-right,\n    &--bottom-right {\n        animation-name: #{$rt-namespace}__slideOutRight;\n    }\n    &--top-center {\n        animation-name: #{$rt-namespace}__slideOutUp;\n    }\n    &--bottom-center {\n        animation-name: #{$rt-namespace}__slideOutDown;\n    }\n}","/* -- container -- */\n.rodal,\n.rodal-mask {\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 100;\n}\n\n.rodal {\n  position: fixed;\n}\n\n/* -- mask -- */\n.rodal-mask {\n  position: absolute;\n  background-color: $modal-backdrop-bg;\n  opacity: $modal-backdrop-opacity;\n}\n\n/* -- dialog -- */\n.rodal-dialog {\n  position: absolute;\n  top: 10%;\n  left: 0;\n  right: 0;\n  margin: auto;\n  z-index: 101;\n  background: $white;\n  box-shadow: $box-shadow-lg-default;\n  @include border-radius($border-radius);\n  height: auto !important;\n}\n\n.rodal-dialog:focus {\n  outline: none;\n}\n\n/* -- close button -- */\n.rodal-close {\n  position: absolute;\n  cursor: pointer;\n  top: 16px;\n  right: 16px;\n  width: 16px;\n  height: 16px;\n}\n\n.rodal-close:before,\n.rodal-close:after {\n  position: absolute;\n  content: '';\n  height: 2px;\n  width: 100%;\n  top: 50%;\n  left: 0;\n  margin-top: -1px;\n  background: $gray-500;\n  border-radius: 100%;\n  transition: background .2s;\n}\n\n.rodal-close:before {\n  transform: rotate(45deg);\n}\n\n.rodal-close:after {\n  transform: rotate(-45deg);\n}\n\n.rodal-close:hover:before,\n.rodal-close:hover:after {\n  background: $gray-800;\n}\n\n/* -- fade -- */\n\n@keyframes rodal-fade-enter {\n  from {\n    opacity: 0;\n  }\n}\n\n.rodal-fade-enter {\n  animation: rodal-fade-enter both ease-in;\n}\n\n@keyframes rodal-fade-leave {\n  to {\n    opacity: 0\n  }\n}\n\n.rodal-fade-leave {\n  animation: rodal-fade-leave both ease-out;\n}\n\n@keyframes rodal-zoom-enter {\n  from {\n    transform: scale3d(.3, .3, .3);\n  }\n}\n\n.rodal-zoom-enter {\n  animation: rodal-zoom-enter both cubic-bezier(0.4, 0, 0, 1.5);\n}\n\n@keyframes rodal-zoom-leave {\n  to {\n    transform: scale3d(.3, .3, .3);\n  }\n}\n\n.rodal-zoom-leave {\n  animation: rodal-zoom-leave both;\n}\n\n@keyframes rodal-slideDown-enter {\n  from {\n    transform: translate3d(0, -100px, 0);\n  }\n}\n\n.rodal-slideDown-enter {\n  animation: rodal-slideDown-enter both cubic-bezier(0.4, 0, 0, 1.5);\n}\n\n@keyframes rodal-slideDown-leave {\n  to {\n    transform: translate3d(0, -100px, 0);\n  }\n}\n\n.rodal-slideDown-leave {\n  animation: rodal-slideDown-leave both;\n}\n\n/* -- slideLeft -- */\n\n@keyframes rodal-slideLeft-enter {\n  from {\n    transform: translate3d(-150px, 0, 0);\n  }\n}\n\n.rodal-slideLeft-enter {\n  animation: rodal-slideLeft-enter both cubic-bezier(0.4, 0, 0, 1.5);\n}\n\n@keyframes rodal-slideLeft-leave {\n  to {\n    transform: translate3d(-150px, 0, 0);\n  }\n}\n\n.rodal-slideLeft-leave {\n  animation: rodal-slideLeft-leave both;\n}\n\n/* -- slideRight -- */\n\n@keyframes rodal-slideRight-enter {\n  from {\n    transform: translate3d(150px, 0, 0);\n  }\n}\n\n.rodal-slideRight-enter {\n  animation: rodal-slideRight-enter both cubic-bezier(0.4, 0, 0, 1.5);\n}\n\n@keyframes rodal-slideRight-leave {\n  to {\n    transform: translate3d(150px, 0, 0);\n  }\n}\n\n.rodal-slideRight-leave {\n  animation: rodal-slideRight-leave both;\n}\n\n/* -- slideUp -- */\n\n@keyframes rodal-slideUp-enter {\n  from {\n    transform: translate3d(0, 100px, 0);\n  }\n}\n\n.rodal-slideUp-enter {\n  animation: rodal-slideUp-enter both cubic-bezier(0.4, 0, 0, 1.5);\n}\n\n@keyframes rodal-slideUp-leave {\n  to {\n    transform: translate3d(0, 100px, 0);\n  }\n}\n\n.rodal-slideUp-leave {\n  animation: rodal-slideUp-leave both;\n}\n\n/* -- flip -- */\n\n@keyframes rodal-flip-enter {\n  from {\n    transform: perspective(400px) rotate3d(1, 0, 0, 60deg);\n  }\n  70% {\n    transform: perspective(400px) rotate3d(1, 0, 0, -15deg);\n  }\n  to {\n    transform: perspective(400px);\n  }\n}\n\n.rodal-flip-enter {\n  animation: rodal-flip-enter both ease-in;\n  backface-visibility: visible !important;\n}\n\n@keyframes rodal-flip-leave {\n  from {\n    transform: perspective(400px);\n  }\n  30% {\n    transform: perspective(400px) rotate3d(1, 0, 0, -15deg);\n  }\n  to {\n    transform: perspective(400px) rotate3d(1, 0, 0, 45deg);\n  }\n}\n\n.rodal-flip-leave {\n  animation: rodal-flip-leave both;\n  backface-visibility: visible !important;\n}\n\n/* -- rotate -- */\n\n@keyframes rodal-rotate-enter {\n  from {\n    transform: rotate3d(0, 0, 1, -180deg) scale3d(.3, .3, .3);\n  }\n}\n\n.rodal-rotate-enter {\n  animation: rodal-rotate-enter both;\n  transform-origin: center;\n}\n\n@keyframes rodal-rotate-leave {\n  to {\n    transform: rotate3d(0, 0, 1, 180deg) scale3d(.3, .3, .3);\n  }\n}\n\n.rodal-rotate-leave {\n  animation: rodal-rotate-leave both;\n  transform-origin: center;\n}\n\n/* -- door -- */\n\n@keyframes rodal-door-enter {\n  from {\n    transform: scale3d(0, 1, 1);\n  }\n}\n\n.rodal-door-enter {\n  animation: rodal-door-enter both cubic-bezier(0.4, 0, 0, 1.5);\n}\n\n@keyframes rodal-door-leave {\n  60% {\n    transform: scale3d(.01, 1, 1);\n  }\n  to {\n    transform: scale3d(0, 1, .1);\n  }\n}\n\n.rodal-door-leave {\n  animation: rodal-door-leave both;\n}",".react-sweet-progress {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.react-sweet-progress-symbol {\n  display: flex;\n  align-items: center;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n  width: 35px;\n  height: 20px;\n  padding-left: 10px;\n  color: rgba(0, 0, 0, 0.7);\n  font-weight: 200;\n}\n\n.react-sweet-progress-symbol-absolute {\n  display: -ms-flexbox;\n  display: flex;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  transform: translate3d(-50%, -50%, 0);\n}\n\n.react-sweet-progress-symbol-absolute .react-sweet-progress-symbol {\n  padding: 0;\n  width: 100%;\n}\n\n.react-sweet-progress-circle-outer {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.react-sweet-progress-line {\n  width: 100%;\n  border-radius: 100px;\n  background-color: #efefef;\n  vertical-align: middle;\n}\n\n.react-sweet-progress-line-inner {\n  position: relative;\n  min-height: 10px;\n  border-radius: 100px;\n  transition: width 0.3s ease;\n}\n\n.react-sweet-progress-line-inner-status-active:before {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  border-radius: 10px;\n  background: #fff;\n  animation: active-anim 2s cubic-bezier(0.25, 1, 0.6, 1) infinite;\n  content: \"\";\n  opacity: 0;\n}\n\n@keyframes active-anim {\n  0% {\n    width: 0;\n    opacity: .1;\n  }\n  20% {\n    width: 0;\n    opacity: .5;\n  }\n  to {\n    width: 100%;\n    opacity: 0;\n  }\n}\n\n.react-sweet-progress-circle path {\n  stroke-linecap: round;\n}\n","/* Slider */\n\n.slick-slider {\n  position: relative;\n  display: block;\n  box-sizing: border-box;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -ms-touch-action: pan-y;\n  touch-action: pan-y;\n  -webkit-tap-highlight-color: transparent;\n  max-width: 1400px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.slick-slider-sm {\n  .slick-slider {\n    max-width: 450px;\n\n    .slick-prev {\n      left: -20px;\n    }\n\n    .slick-next {\n      right: -20px;\n    }\n  }\n}\n\n.slick-slider-md {\n  .slick-slider {\n    max-width: 650px;\n    margin: 0 auto;\n  }\n}\n\n.slick-slider-hover {\n  .slick-arrow {\n    opacity: 0;\n    background: $primary-color;\n    color: $white !important;\n  }\n\n  .slick-prev {\n    left: -30px;\n\n  }\n\n  .slick-next {\n    right: -30px;\n  }\n\n\n  &:hover {\n    .slick-arrow {\n      opacity: 1;\n    }\n  }\n}\n\n.slick-list {\n  position: relative;\n  overflow: hidden;\n  display: block;\n  margin: 0;\n  padding: 0;\n\n  &:focus {\n    outline: none;\n  }\n\n  &.dragging {\n    cursor: pointer;\n    cursor: hand;\n  }\n}\n\n.slick-slider .slick-track,\n.slick-slider .slick-list {\n  -webkit-transform: translate3d(0, 0, 0);\n  -moz-transform: translate3d(0, 0, 0);\n  -ms-transform: translate3d(0, 0, 0);\n  -o-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0);\n}\n\n.slick-track {\n  position: relative;\n  left: 0;\n  top: 0;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n\n  &:before,\n  &:after {\n    content: \"\";\n    display: table;\n  }\n\n  &:after {\n    clear: both;\n  }\n\n  .slick-loading & {\n    visibility: hidden;\n  }\n}\n\n.slick-slide {\n  float: left;\n  height: 100%;\n  min-height: 1px;\n  [dir=\"rtl\"] & {\n    float: right;\n  }\n  img {\n    display: block;\n  }\n  &.slick-loading img {\n    display: none;\n  }\n\n  display: none;\n\n  &.dragging img {\n    pointer-events: none;\n  }\n\n  .slick-initialized & {\n    display: block;\n  }\n\n  .slick-loading & {\n    visibility: hidden;\n  }\n\n  .slick-vertical & {\n    display: block;\n    height: auto;\n    border: 1px solid transparent;\n  }\n}\n\n.slick-arrow.slick-hidden {\n  display: none;\n}\n\n@import \"slick-theme\";","// Default Variables\n\n@use \"sass:math\";\n\n$slick-font-path: \"./fonts/\" !default;\n$slick-font-family: \"slick\" !default;\n$slick-loader-path: \"./\" !default;\n$slick-arrow-color: $primary !default;\n$slick-next-character: \"\\E684\" !default;\n$slick-prev-character: \"\\E686\" !default;\n$slick-dot-size: 6px !default;\n$slick-opacity-default: 0.75 !default;\n$slick-opacity-on-hover: 1 !default;\n$slick-opacity-not-active: 0.25 !default;\n\n/* Arrows */\n\n.slick-prev,\n.slick-next {\n  position: absolute;\n  display: block;\n  height: 40px;\n  width: 40px;\n  cursor: pointer;\n  color: $gray-600;\n  top: 50%;\n  transform: translate(0, -80%);\n  padding: 0;\n  border: none;\n  outline: none;\n  box-shadow: $box-shadow-default;\n  transition: all .2s;\n  font-family: 'Pe-icon-7-stroke';\n  @include border-radius(50px);\n  background: $white;\n  z-index: 6;\n  overflow: hidden;\n\n  &::before {\n    font-size: 35px;\n    height: 40px;\n    line-height: 40px;\n    width: 40px;\n  }\n\n  &:hover, &:focus {\n    outline: none;\n    box-shadow: $box-shadow-lg;\n    color: $primary;\n  }\n\n  &.slick-disabled:before {\n    opacity: $slick-opacity-not-active;\n  }\n}\n\n.slick-prev {\n  left: 0;\n  &:before {\n    content: $slick-prev-character;\n\n  }\n}\n\n.slick-next {\n  right: 0;\n  &:before {\n    content: $slick-next-character;\n  }\n}\n\n/* Dots */\n\n.slick-dots {\n  list-style: none;\n  display: block;\n  text-align: center;\n  padding: 0;\n  margin: math.div($layout-spacer-x, 2) 0 0;\n  width: 100%;\n  li {\n    position: relative;\n    display: inline-block;\n    padding: 0;\n    margin: 0 5px;\n    cursor: pointer;\n    transform: scale(.8);\n    transition: all .2s;\n\n    button {\n      border: 0;\n      background: transparent;\n      display: block;\n      height: 14px;\n      width: 14px;\n      background: $primary;\n      cursor: pointer;\n      position: relative;\n      @include border-radius(20px);\n      color: transparent;\n\n      &::before {\n        content: '';\n        position: absolute;\n        background: $white;\n        left: 50%;\n        top: 50%;\n        margin: -4px 0 0 -4px;\n        display: block;\n        width: 8px;\n        height: 8px;\n        @include border-radius(20px);\n      }\n\n    }\n    &.slick-active {\n      transform: scale(1.2);\n    }\n  }\n}\n\n.slick-center {\n  transform: scale(1.1);\n}\n\n.slick-slider {\n  .slide-img-bg {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    background-size: cover;\n    opacity: .4;\n    z-index: 10;\n  }\n\n  .slider-content {\n    position: relative;\n    z-index: 15;\n    text-align: center;\n    margin: 0 ($spacer-lg * 2);\n\n    h3 {\n      font-size: $h3-font-size;\n      font-weight: normal;\n      margin-bottom: $spacer-sm;\n    }\n\n    p {\n      font-size: $h6-font-size;\n      opacity: .7;\n    }\n  }\n}\n\n// slider-light\n\n.slider-light {\n  .slick-dots {\n    position: absolute;\n    bottom: 10px;\n\n    li button {\n      background: rgba(255, 255, 255, 0.25);\n    }\n  }\n\n  .slick-prev,\n  .slick-next {\n    background: transparent;\n    color: $white;\n    box-shadow: 0 0 0 0 transparent;\n\n    &:hover {\n      background: rgba(255,255,255,.15);\n    }\n  }\n\n  .slick-next {\n    right: 15px;\n  }\n\n  .slick-prev {\n    left: 15px;\n  }\n\n  .slider-content {\n    color: $white;\n  }\n}\n",".loading-indicator {\n  text-align: center;\n}\n\n.loading-bullet {\n  display: inline-block;\n  opacity: 0;\n  font-size: 2em;\n  color: #02a17c;\n}\n\n.block-ui {\n  position: relative;\n  min-height: 3em;\n}\n\n.block-ui-container {\n  position: absolute;\n  z-index: 1010;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  height: 100%;\n  min-height: 2em;\n  cursor: wait;\n  overflow: hidden;\n}\n\n.block-ui-container:focus {\n  outline: none;\n}\n\n.block-ui-overlay {\n  width: 100%;\n  height: 100%;\n  opacity: 0.5;\n  filter: alpha(opacity=50);\n  background-color: white;\n}\n\n.block-ui-message-container {\n  position: absolute;\n  top: 50%;\n  left: 0;\n  width: 100%;\n  right: 0;\n  text-align: center;\n  transform: translateY(-50%);\n  z-index: 10001;\n}\n\n.block-ui-message {\n  color: #333;\n  background: none;\n  z-index: 1011;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.block-overlay-dark {\n  .block-ui-overlay {\n    background: rgba(0,0,0,1);\n  }\n}","// Tooltips & Popovers\n\n// Popover\n\n@use \"sass:math\";\n\n.popover {\n  box-shadow: $box-shadow-default;\n\n  .grid-menu {\n    margin-bottom: -$popover-body-padding-y;\n    padding: 1px;\n\n    [class*=\"col-\"] {\n      padding: $popover-body-padding-y;\n    }\n\n    & + .nav {\n      .nav-item-btn {\n        margin-bottom: $popover-body-padding-y;\n      }\n    }\n  }\n\n  .grid-menu-xl {\n    margin-bottom: -(math.div($popover-body-padding-y, 1.35));\n\n    [class*=\"col-\"] {\n      padding: 0;\n    }\n  }\n\n  .popover-inner {\n    .dropdown-menu-header {\n      @include border-top-radius($popover-border-radius);\n      overflow: hidden;\n      margin-top: -1px;\n      margin-left: -1px;\n      margin-right: -1px;\n    }\n  }\n}\n\n.rm-max-width {\n  & > .popover {\n    max-width: initial;\n  }\n}\n\n.rm-pointers {\n  & > .popover {\n    .arrow {\n      display: none !important;\n    }\n  }\n}\n\n@mixin bg-popover($parent, $color) {\n  #{$parent} {\n    background-color: $color !important;\n  }\n}\n\n@each $color, $value in $theme-colors {\n  @include bg-popover(\".popover-#{$color}\", $value);\n}\n\n.popover-custom {\n  .popover-body {\n    padding-top: 0;\n    padding-left: 0;\n    padding-right: 0;\n\n    .dropdown-menu-header {\n      margin-top: 0;\n      @include border-top-radius($popover-border-radius);\n      overflow: hidden;\n\n      .menu-header-content {\n        padding: 0 $layout-spacer-x;\n      }\n\n      .dropdown-menu-header-inner.bg-light {\n        color: rgba(0, 0, 0, .8);\n      }\n    }\n  }\n\n  &.popover-custom-lg {\n    min-width: 22rem;\n  }\n\n  &.popover-custom-xl {\n    min-width: 25rem;\n  }\n\n  &.popover-custom-sm {\n    min-width: 15rem;\n  }\n}\n\n.popover-bg {\n  border: 0;\n\n  .arrow {\n    display: none;\n  }\n\n  .popover-header {\n    background: rgba(255, 255, 255, .1);\n    border-bottom: 0;\n    color: rgba(255, 255, 255, 1);\n\n    &::before {\n      display: none;\n    }\n  }\n\n  .popover-body {\n    color: rgba(255, 255, 255, .7);\n  }\n\n  &.text-dark {\n    .popover-header {\n      color: rgba(0, 0, 0, .8);\n    }\n\n    .popover-body {\n      color: rgba(0, 0, 0, .7);\n    }\n  }\n}\n\n// Tooltip\n\n.tooltip-light {\n  & > .tooltip {\n    .tooltip-inner {\n      background: $white;\n      color: $gray-800;\n      box-shadow: $box-shadow-default;\n      border: $popover-border-color solid 1px;\n    }\n\n    .arrow {\n      display: none;\n    }\n  }\n}\n","// Sticky Elements\n\n.scrollable-block {\n  margin-bottom: 50px;\n  overflow: hidden;\n  position: relative;\n  .sticky {\n    z-index: 2;\n  }\n}",".rbc-btn {\n  color: inherit;\n  font: inherit;\n  margin: 0;\n}\n\nbutton.rbc-btn {\n  overflow: visible;\n  text-transform: none;\n  -webkit-appearance: button;\n  cursor: pointer;\n}\n\nbutton[disabled].rbc-btn {\n  cursor: not-allowed;\n}\n\nbutton.rbc-input::-moz-focus-inner {\n  border: 0;\n  padding: 0;\n}\n","@import 'scss/variables';\n@import 'scss/reset';\n\n\n.rbc-calendar {\n  box-sizing: border-box;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n    flex: 1 1;\n    min-height: 580px;\n}\n\n.rbc-calendar *,\n.rbc-calendar *:before,\n.rbc-calendar *:after {\n  box-sizing: inherit;\n}\n\n.rbc-abs-full {\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n\n.rbc-ellipsis {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rbc-rtl {\n  direction: rtl;\n}\n\n.rbc-off-range {\n  color: $out-of-range-color;\n}\n\n.rbc-header {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding: 0 3px;\n  text-align: center;\n  vertical-align: middle;\n  font-weight: bold;\n  font-size: 90%;\n  min-height: 0;\n  flex: 1 0;\n  flex-basis: auto !important;\n\n  > a {\n    &, &:active, &:visited {\n      color: inherit;\n      text-decoration: none;\n    }\n  }\n}\n\n.rbc-row-content {\n  position: relative;\n  user-select: none;\n  z-index: 4;\n}\n\n.rbc-today {\n  background-color: $today-highlight-bg;\n}\n\n\n@import 'scss/toolbar';\n@import 'scss/event';\n@import 'scss/month';\n@import 'scss/agenda';\n@import 'scss/time-grid';\n","\n@use \"sass:math\";\n\n$out-of-range-color: lighten(#333, 50%);\n\n$calendar-border: $gray-200;\n$cell-border: $gray-200;\n\n$border-color: $gray-300;\n\n$segment-width: percentage(math.div(1, 7));\n\n$time-selection-color: #white;\n$time-selection-bg-color: rgba(0,0,0, .50);\n$date-selection-bg-color: rgba(0,0,0, .10);\n\n\n$event-bg: $primary;\n$event-border: darken($event-bg, 10%);\n$event-color: $white;\n$event-border-radius: $border-radius;\n$event-padding: $dropdown-spacer;\n$event-zindex: 4;\n\n$btn-color: $white;\n$btn-bg: $primary;\n$btn-border: $primary;\n\n$current-time-color: $success;\n\n$rbc-css-prefix: rbc-i;\n\n$today-highlight-bg: $dropdown-link-hover-bg;\n","@use \"sass:math\";\n\n@import 'variables';\n\n$active-background: darken($btn-bg, 10%);\n$active-border: darken($btn-border, 12%);\n\n.rbc-toolbar {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n  font-size: 16px;\n\n  .rbc-toolbar-label {\n    width: 100%;\n    padding: 0 10px;\n    text-align: center;\n  }\n\n  & button {\n    color: $btn-color;\n    display: inline-block;\n    margin: 0;\n    text-align: center;\n    vertical-align: middle;\n    background: $primary;\n    border: 1px solid $btn-border;\n    padding: .375rem 1rem;\n    border-radius: $border-radius;\n    line-height: normal;\n    white-space: nowrap;\n    font-weight: bold;\n    text-transform: capitalize;\n    font-size: math.div($font-size-sm, 1.1);\n\n    &:active,\n    &.rbc-active {\n      background-image: none;\n      box-shadow: inset 0 3px 5px rgba(0,0,0,.125);\n      background-color: $active-background;\n      border-color: $active-border;\n\n      &:hover,\n      &:focus {\n        color: $btn-color;\n        background-color: darken($btn-bg, 17%);\n        border-color: darken($btn-border, 25%);\n      }\n    }\n\n    &:focus {\n      color: $btn-color;\n      background-color: $active-background;\n      border-color: $active-border;\n    }\n\n    &:hover {\n      color: $btn-color;\n      background-color: $active-background;\n      border-color: $active-border;\n    }\n  }\n}\n\n.rbc-btn-group {\n  display: inline-block;\n  white-space: nowrap;\n\n  > button:first-child:not(:last-child) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n\n  > button:last-child:not(:first-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n\n  .rbc-rtl & > button:first-child:not(:last-child) {\n    border-radius: 4px;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n\n  .rbc-rtl & > button:last-child:not(:first-child) {\n    border-radius: 4px;\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n\n  > button:not(:first-child):not(:last-child) {\n    border-radius: 0;\n  }\n\n  button + button {\n    margin-left: -1px;\n  }\n\n  .rbc-rtl & button + button {\n    margin-left: 0;\n    margin-right: -1px;\n  }\n\n  & + &,\n  & + button {\n    margin-left: 10px;\n  }\n}\n","@import 'variables';\n\n.rbc-event {\n  cursor: pointer;\n  padding: $event-padding;\n  background-color: $event-bg;\n  border-radius: $event-border-radius;\n  color: $event-color;\n\n  &.rbc-selected {\n    background-color: darken($event-bg, 10%);\n  }\n}\n\n.rbc-event-label {\n  @extend .rbc-ellipsis;\n  font-size: 80%;\n}\n\n.rbc-event-overlaps {\n  box-shadow: -1px 1px 5px 0px rgba(51,51,51,.5);\n}\n\n.rbc-event-continues-prior {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.rbc-event-continues-after {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n\n.rbc-event-continues-earlier {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.rbc-event-continues-later {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n","@import 'variables';\n\n\n.rbc-row {\n  display: flex;\n  flex-direction: row;\n}\n\n.rbc-row-segment {\n  padding: 0 1px 1px 1px;\n\n  .rbc-event-content {\n    @extend .rbc-ellipsis;\n  }\n}\n\n.rbc-selected-cell {\n  background-color: $date-selection-bg-color;\n}\n\n\n.rbc-show-more {\n  @extend .rbc-ellipsis;\n  background-color: rgba(255, 255, 255, 0.3);\n  z-index: $event-zindex;\n  font-weight: bold;\n  font-size: 85%;\n  height: auto;\n  line-height: normal;\n  white-space: nowrap;\n}\n\n.rbc-month-view {\n  position: relative;\n  border: 1px solid $calendar-border;\n  display: flex;\n  flex-direction: column;\n  flex: 1 0 0;\n  width: 100%;\n  user-select: none;\n\n  height: 100%; // ie-fix\n\n  .rbc-header {\n    border-bottom: 1px solid $cell-border;\n  }\n\n  .rbc-header + .rbc-header {\n    border-left: 1px solid $cell-border;\n  }\n\n  .rbc-rtl & .rbc-header + .rbc-header {\n    border-left-width: 0;\n    border-right: 1px solid $cell-border;\n  }\n}\n\n.rbc-month-header {\n  display: flex;\n  flex-direction: row;\n}\n\n.rbc-month-row {\n  display: flex;\n  position: relative;\n  flex-direction: column;\n  flex: 1 0 0;\n  overflow: hidden;\n\n  height: 100%; // ie-fix\n\n  & + & {\n    border-top: 1px solid $cell-border;\n  }\n}\n\n.rbc-date-cell {\n  padding-right: 5px;\n  text-align: right;\n  flex: 1 1;\n\n  &.rbc-now {\n    font-weight: bold;\n  }\n\n  > a {\n    &, &:active, &:visited {\n      color: inherit;\n      text-decoration: none;\n    }\n  }\n}\n\n.rbc-row-bg {\n  @extend .rbc-abs-full;\n  display: flex;\n  flex-direction: row;\n  flex: 1 0 0;\n  overflow: hidden;\n}\n\n.rbc-day-bg {\nflex: 1 0;\n  & + & {\n    border-left: 1px solid $cell-border;\n  }\n\n  .rbc-rtl & + & {\n    border-left-width: 0;\n    border-right: 1px solid $cell-border;\n  }\n}\n\n.rbc-off-range-bg {\n    background: $gray-100;\n}\n\n.rbc-overlay {\n  position: absolute;\n  z-index: $event-zindex + 1;\n  border: 1px solid #e5e5e5;\n  background-color: #fff;\n  box-shadow: 0 5px 15px rgba(0,0,0,.25);\n  padding: 10px;\n\n  > * + * {\n    margin-top: 1px;\n  }\n}\n\n.rbc-overlay-header {\n  border-bottom: 1px solid #e5e5e5;\n  margin: -10px -10px 5px -10px ;\n  padding: 2px 10px;\n}\n","\n.rbc-agenda-view {\n  display: flex;\n  flex-direction: column;\n  flex: 1 0 0;\n  overflow: auto;\n\n  table {\n    width: 100%;\n    border: 1px solid $cell-border;\n\n    tbody > tr > td {\n      padding: 5px 10px;\n      vertical-align: top;\n\n    }\n\n    .rbc-agenda-time-cell {\n      padding-left: 15px;\n      padding-right: 15px;\n      text-transform: lowercase;\n    }\n\n    tbody > tr > td + td {\n      border-left: 1px solid $cell-border;\n    }\n\n    .rbc-rtl & {\n      tbody > tr > td + td {\n        border-left-width: 0;\n        border-right: 1px solid $cell-border;\n      }\n    }\n\n    tbody > tr + tr {\n      border-top: 1px solid $cell-border;\n    }\n\n    thead > tr > th {\n      padding: 3px 5px;\n      text-align: left;\n      border-bottom: 1px solid $cell-border;\n\n      .rbc-rtl & {\n        text-align: right;\n      }\n    }\n  }\n}\n\n.rbc-agenda-time-cell {\n  text-transform: lowercase;\n\n  .rbc-continues-after:after {\n    content: ' »'\n  }\n  .rbc-continues-prior:before {\n    content: '« '\n  }\n}\n\n.rbc-agenda-date-cell,\n.rbc-agenda-time-cell {\n  white-space: nowrap;\n}\n\n\n\n.rbc-agenda-event-cell {\n  width: 100%\n}\n","@import 'variables';\n\n\n.rbc-time-column {\n  display: flex;\n  flex-direction: column;\n  min-height: 100%;\n\n  .rbc-timeslot-group {\n    flex: 1;\n  }\n}\n\n\n.rbc-timeslot-group {\n  border-bottom: 1px solid $cell-border;\n  min-height: 40px;\n  display: flex;\n  flex-flow: column nowrap;\n}\n\n.rbc-time-gutter,\n.rbc-header-gutter {\n  flex: none;\n}\n\n.rbc-label {\n  padding: 0 5px;\n}\n\n.rbc-day-slot {\n  position: relative;\n\n  .rbc-event {\n    border: 1px solid $event-border;\n    display: flex;\n    max-height: 100%;\n    flex-flow: column wrap;\n    align-items: flex-start;\n    overflow: hidden;\n  }\n\n  .rbc-event-label {\n    flex: none;\n    padding-right: 5px;\n    width: auto;\n  }\n\n  .rbc-event-content {\n    width: 100%;\n    flex: 1 1 0;\n    word-wrap: break-word;\n    line-height: 1;\n    height: 100%;\n    min-height: 1em;\n  }\n\n  .rbc-time-slot {\n    border-top: 1px solid lighten($cell-border, 10%);\n  }\n}\n\n.rbc-time-slot {\n  flex: 1 0 0;\n\n  &.rbc-now {\n    font-weight: bold;\n  }\n}\n\n.rbc-day-header {\n  text-align: center;\n}\n\n.rbc-day-slot .rbc-event {\n  position: absolute;\n  z-index: 2;\n}\n","@import 'variables';\n@import 'time-column';\n\n.rbc-slot-selection {\n  z-index: 10;\n  position: absolute;\n  cursor: default;\n  background-color: $time-selection-bg-color;\n  color: $time-selection-color;\n  font-size: 75%;\n  padding: 3px;\n}\n\n.rbc-time-view {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  width: 100%;\n  border: 1px solid $calendar-border;\n  min-height: 0;\n\n  .rbc-time-gutter {\n    white-space: nowrap;\n  }\n\n  .rbc-allday-cell {\n    width: 100%;\n    position: relative;\n  }\n\n  .rbc-allday-events {\n    position: relative;\n    z-index: 4;\n  }\n\n  .rbc-row {\n    min-height: 20px;\n  }\n}\n\n\n.rbc-time-header {\n  display: flex;\n  flex: 0 0 auto; // should not shrink below height\n  flex-direction: column;\n\n  &.rbc-overflowing {\n    border-right: 1px solid $cell-border;\n  }\n\n  .rbc-rtl &.rbc-overflowing {\n    border-right-width: 0;\n    border-left: 1px solid $cell-border;\n  }\n\n  > .rbc-row > * + * {\n    border-left: 1px solid $cell-border;\n  }\n\n  .rbc-rtl & > .rbc-row > * + * {\n    border-left-width: 0;\n    border-right: 1px solid $cell-border;\n  }\n\n  > .rbc-row:first-child {\n    border-bottom: 1px solid  $cell-border;\n  }\n\n  .rbc-gutter-cell {\n    flex: none;\n  }\n\n  > .rbc-gutter-cell + * {\n    width: 100%;\n  }\n}\n\n.rbc-time-content {\n  display: flex;\n  flex: 1 0 0%;\n  align-items: flex-start;\n  width: 100%;\n  border-top: 2px solid $calendar-border;\n  overflow-y: auto;\n  position: relative;\n\n  > .rbc-time-gutter {\n    flex: none;\n  }\n\n  > * + * > * {\n    border-left: 1px solid $cell-border;\n  }\n\n  .rbc-rtl & > * + * > * {\n    border-left-width: 0;\n    border-right: 1px solid $cell-border;\n  }\n\n  > .rbc-day-slot {\n    width: 100%;\n    user-select: none;\n  }\n}\n\n.rbc-current-time-indicator {\n  position: absolute;\n  z-index: 1;\n  left: 0;\n  height: 1px;\n\n  background-color: $current-time-color;\n  pointer-events: none;\n\n  &::before {\n    display: block;\n\n    position: absolute;\n    left: -3px;\n    top: -3px;\n\n    content: ' ';\n    background-color: $current-time-color;\n\n    border-radius: 50%;\n    width: 8px;\n    height: 8px;\n  }\n\n  .rbc-rtl &::before {\n    left: 0;\n    right: -3px;\n  }\n}\n","// Layout Splitter\n\n.handle-bar {\n  background: transparent !important;\n  @include border-radius(30px);\n\n  &:active,\n  &:hover,\n  &.handle-bar_clone {\n    background-color: $gray-200 !important;\n  }\n\n  &.resize-not-allowed:hover {\n    background-color: $gray-200;\n  }\n\n  .handle-bar_drag {\n    border-color: $primary !important;\n  }\n}","/**\n * Extra class applied to VirtualScroll through className prop\n */\n.rst__virtualScrollOverride {\n  overflow: auto !important;\n}\n\n.ReactVirtualized__Grid__innerScrollContainer {\n  overflow: visible !important;\n}\n\n.rst__rtl .ReactVirtualized__Grid__innerScrollContainer {\n  direction: rtl;\n}\n\n.ReactVirtualized__Grid {\n  outline: none;\n}\n\n.rst__node {\n  min-width: 100%;\n  white-space: nowrap;\n  position: relative;\n  text-align: left;\n}\n\n.rst__node.rst__rtl {\n  text-align: right;\n}\n\n.rst__nodeContent {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n}\n\n/* ==========================================================================\n   Scaffold\n\n    Line-overlaid blocks used for showing the tree structure\n   ========================================================================== */\n.rst__lineBlock,\n.rst__absoluteLineBlock {\n  height: 100%;\n  position: relative;\n  display: inline-block;\n}\n\n.rst__absoluteLineBlock {\n  position: absolute;\n  top: 0;\n}\n\n.rst__lineHalfHorizontalRight::before,\n.rst__lineFullVertical::after,\n.rst__lineHalfVerticalTop::after,\n.rst__lineHalfVerticalBottom::after {\n  position: absolute;\n  content: '';\n  background-color: black;\n}\n\n/**\n * +-----+\n * |     |\n * |  +--+\n * |     |\n * +-----+\n */\n.rst__lineHalfHorizontalRight::before {\n  height: 1px;\n  top: 50%;\n  right: 0;\n  width: 50%;\n}\n\n.rst__rtl.rst__lineHalfHorizontalRight::before {\n  left: 0;\n  right: initial;\n}\n\n.rst__lineFullVertical::after,\n.rst__lineHalfVerticalTop::after,\n.rst__lineHalfVerticalBottom::after {\n  width: 1px;\n  left: 50%;\n  top: 0;\n  height: 100%;\n}\n\n.rst__rtl.rst__lineFullVertical::after,\n.rst__rtl.rst__lineHalfVerticalTop::after,\n.rst__rtl.rst__lineHalfVerticalBottom::after {\n  right: 50%;\n  left: initial;\n}\n\n.rst__lineHalfVerticalTop::after {\n  height: 50%;\n}\n\n.rst__lineHalfVerticalBottom::after {\n  top: auto;\n  bottom: 0;\n  height: 50%;\n}\n\n/* Highlight line for pointing to dragged row destination\n   ========================================================================== */\n.rst__highlightLineVertical {\n  z-index: 3;\n}\n.rst__highlightLineVertical::before {\n  position: absolute;\n  content: '';\n  background-color: $primary;\n  width: 8px;\n  margin-left: -4px;\n  left: 50%;\n  top: 0;\n  height: 100%;\n}\n\n.rst__rtl.rst__highlightLineVertical::before {\n  margin-left: initial;\n  margin-right: -4px;\n  left: initial;\n  right: 50%;\n}\n\n@keyframes arrow-pulse {\n  0% {\n    transform: translate(0, 0);\n    opacity: 0;\n  }\n  30% {\n    transform: translate(0, 300%);\n    opacity: 1;\n  }\n  70% {\n    transform: translate(0, 700%);\n    opacity: 1;\n  }\n  100% {\n    transform: translate(0, 1000%);\n    opacity: 0;\n  }\n}\n.rst__highlightLineVertical::after {\n  content: '';\n  position: absolute;\n  height: 0;\n  margin-left: -4px;\n  left: 50%;\n  top: 0;\n  border-left: 4px solid transparent;\n  border-right: 4px solid transparent;\n  border-top: 4px solid white;\n  animation: arrow-pulse 1s infinite linear both;\n}\n\n.rst__rtl.rst__highlightLineVertical::after {\n  margin-left: initial;\n  margin-right: -4px;\n  right: 50%;\n  left: initial;\n}\n\n/**\n * +-----+\n * |     |\n * |  +--+\n * |  |  |\n * +--+--+\n */\n.rst__highlightTopLeftCorner::before {\n  z-index: 3;\n  content: '';\n  position: absolute;\n  border-top: solid 8px $primary;\n  border-left: solid 8px $primary;\n  box-sizing: border-box;\n  height: calc(50% + 4px);\n  top: 50%;\n  margin-top: -4px;\n  right: 0;\n  width: calc(50% + 4px);\n}\n\n.rst__rtl.rst__highlightTopLeftCorner::before {\n  border-right: solid 8px $primary;\n  border-left: none;\n  left: 0;\n  right: initial;\n}\n\n/**\n * +--+--+\n * |  |  |\n * |  |  |\n * |  +->|\n * +-----+\n */\n.rst__highlightBottomLeftCorner {\n  z-index: 3;\n}\n.rst__highlightBottomLeftCorner::before {\n  content: '';\n  position: absolute;\n  border-bottom: solid 8px $primary;\n  border-left: solid 8px $primary;\n  box-sizing: border-box;\n  height: calc(100% + 4px);\n  top: 0;\n  right: 12px;\n  width: calc(50% - 8px);\n}\n\n.rst__rtl.rst__highlightBottomLeftCorner::before {\n  border-right: solid 8px $primary;\n  border-left: none;\n  left: 12px;\n  right: initial;\n}\n\n.rst__highlightBottomLeftCorner::after {\n  content: '';\n  position: absolute;\n  height: 0;\n  right: 0;\n  top: 100%;\n  margin-top: -12px;\n  border-top: 12px solid transparent;\n  border-bottom: 12px solid transparent;\n  border-left: 12px solid $primary;\n}\n\n.rst__rtl.rst__highlightBottomLeftCorner::after {\n  left: 0;\n  right: initial;\n  border-right: 12px solid $primary;\n  border-left: none;\n}\n\n.rst__rowWrapper {\n  padding: 10px 10px 10px 0;\n  height: 100%;\n  box-sizing: border-box;\n}\n\n.rst__rtl.rst__rowWrapper {\n  padding: 10px 0 10px 10px;\n}\n\n.rst__row {\n  height: 100%;\n  white-space: nowrap;\n  display: flex;\n}\n.rst__row > * {\n  box-sizing: border-box;\n}\n\n/**\n * The outline of where the element will go if dropped, displayed while dragging\n */\n.rst__rowLandingPad,\n.rst__rowCancelPad {\n  border: none !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n.rst__rowLandingPad > *,\n.rst__rowCancelPad > * {\n  opacity: 0 !important;\n}\n.rst__rowLandingPad::before,\n.rst__rowCancelPad::before {\n  background-color: lightblue;\n  border: 1px dashed $white;\n  content: '';\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: -1;\n}\n\n/**\n * Alternate appearance of the landing pad when the dragged location is invalid\n */\n.rst__rowCancelPad::before {\n  background-color: #e6a8ad;\n}\n\n/**\n * Nodes matching the search conditions are highlighted\n */\n.rst__rowSearchMatch {\n  outline: solid 3px #0080ff;\n}\n\n/**\n * The node that matches the search conditions and is currently focused\n */\n.rst__rowSearchFocus {\n  outline: solid 3px #fc6421;\n}\n\n.rst__rowContents,\n.rst__rowLabel,\n.rst__rowToolbar,\n.rst__moveHandle,\n.rst__toolbarButton {\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.rst__rowContents {\n  position: relative;\n  height: 100%;\n  border: solid $gray-300 1px;\n  border-left: none;\n  padding: 0 5px 0 10px;\n  border-radius: 2px;\n  min-width: 230px;\n  flex: 1 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-color: white;\n}\n\n.rst__rtl.rst__rowContents {\n  border-right: none;\n  border-left: solid $gray-300 1px;\n  padding: 0 10px 0 5px;\n}\n\n.rst__rowContentsDragDisabled {\n  border-left: solid $gray-300 1px;\n}\n\n.rst__rtl.rst__rowContentsDragDisabled {\n  border-right: solid $gray-300 1px;\n  border-left: solid $gray-300 1px;\n}\n\n.rst__rowLabel {\n  flex: 0 1 auto;\n  padding-right: 20px;\n}\n.rst__rtl.rst__rowLabel {\n  padding-left: 20px;\n  padding-right: inherit;\n}\n\n.rst__rowToolbar {\n  flex: 0 1 auto;\n  display: flex;\n}\n\n.rst__moveHandle,\n.rst__loadingHandle {\n  height: 100%;\n  width: 44px;\n  background: $gray-200\n  url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MiIgaGVpZ2h0PSI0MiI+PGcgc3Ryb2tlPSIjRkZGIiBzdHJva2Utd2lkdGg9IjIuOSIgPjxwYXRoIGQ9Ik0xNCAxNS43aDE0LjQiLz48cGF0aCBkPSJNMTQgMjEuNGgxNC40Ii8+PHBhdGggZD0iTTE0IDI3LjFoMTQuNCIvPjwvZz4KPC9zdmc+')\n  no-repeat center;\n  border: solid #aaa 1px;\n  cursor: move;\n  border-radius: 1px;\n  z-index: 1;\n}\n\n.rst__loadingHandle {\n  cursor: default;\n  background: $gray-200;\n}\n\n@keyframes pointFade {\n  0%,\n  19.999%,\n  100% {\n    opacity: 0;\n  }\n  20% {\n    opacity: 1;\n  }\n}\n\n.rst__loadingCircle {\n  width: 80%;\n  height: 80%;\n  margin: 10%;\n  position: relative;\n}\n\n.rst__loadingCirclePoint {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n\n.rst__rtl.rst__loadingCirclePoint {\n  right: 0;\n  left: initial;\n}\n\n.rst__loadingCirclePoint::before {\n  content: '';\n  display: block;\n  margin: 0 auto;\n  width: 11%;\n  height: 30%;\n  background-color: $white;\n  border-radius: 30%;\n  animation: pointFade 800ms infinite ease-in-out both;\n}\n.rst__loadingCirclePoint:nth-of-type(1) {\n  transform: rotate(0deg);\n}\n.rst__loadingCirclePoint:nth-of-type(7) {\n  transform: rotate(180deg);\n}\n.rst__loadingCirclePoint:nth-of-type(1)::before,\n.rst__loadingCirclePoint:nth-of-type(7)::before {\n  animation-delay: -800ms;\n}\n.rst__loadingCirclePoint:nth-of-type(2) {\n  transform: rotate(30deg);\n}\n.rst__loadingCirclePoint:nth-of-type(8) {\n  transform: rotate(210deg);\n}\n.rst__loadingCirclePoint:nth-of-type(2)::before,\n.rst__loadingCirclePoint:nth-of-type(8)::before {\n  animation-delay: -666ms;\n}\n.rst__loadingCirclePoint:nth-of-type(3) {\n  transform: rotate(60deg);\n}\n.rst__loadingCirclePoint:nth-of-type(9) {\n  transform: rotate(240deg);\n}\n.rst__loadingCirclePoint:nth-of-type(3)::before,\n.rst__loadingCirclePoint:nth-of-type(9)::before {\n  animation-delay: -533ms;\n}\n.rst__loadingCirclePoint:nth-of-type(4) {\n  transform: rotate(90deg);\n}\n.rst__loadingCirclePoint:nth-of-type(10) {\n  transform: rotate(270deg);\n}\n.rst__loadingCirclePoint:nth-of-type(4)::before,\n.rst__loadingCirclePoint:nth-of-type(10)::before {\n  animation-delay: -400ms;\n}\n.rst__loadingCirclePoint:nth-of-type(5) {\n  transform: rotate(120deg);\n}\n.rst__loadingCirclePoint:nth-of-type(11) {\n  transform: rotate(300deg);\n}\n.rst__loadingCirclePoint:nth-of-type(5)::before,\n.rst__loadingCirclePoint:nth-of-type(11)::before {\n  animation-delay: -266ms;\n}\n.rst__loadingCirclePoint:nth-of-type(6) {\n  transform: rotate(150deg);\n}\n.rst__loadingCirclePoint:nth-of-type(12) {\n  transform: rotate(330deg);\n}\n.rst__loadingCirclePoint:nth-of-type(6)::before,\n.rst__loadingCirclePoint:nth-of-type(12)::before {\n  animation-delay: -133ms;\n}\n.rst__loadingCirclePoint:nth-of-type(7) {\n  transform: rotate(180deg);\n}\n.rst__loadingCirclePoint:nth-of-type(13) {\n  transform: rotate(360deg);\n}\n.rst__loadingCirclePoint:nth-of-type(7)::before,\n.rst__loadingCirclePoint:nth-of-type(13)::before {\n  animation-delay: 0ms;\n}\n\n.rst__rowTitle {\n  font-weight: bold;\n}\n\n.rst__rowTitleWithSubtitle {\n  font-size: 85%;\n  display: block;\n  height: 0.8rem;\n}\n\n.rst__rowSubtitle {\n  font-size: 70%;\n  line-height: 1;\n}\n\n.rst__collapseButton,\n.rst__expandButton {\n  appearance: none;\n  border: none;\n  position: absolute;\n  border-radius: 100%;\n  box-shadow: 0 0 0 1px #000;\n  width: 16px;\n  height: 16px;\n  padding: 0;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  cursor: pointer;\n}\n.rst__rtl.rst__collapseButton,\n.rst__rtl.rst__expandButton {\n  transform: translate(50%, -50%);\n}\n.rst__collapseButton:focus,\n.rst__expandButton:focus {\n  outline: none;\n  box-shadow: 0 0 0 1px #000, 0 0 1px 3px #83bef9;\n}\n.rst__collapseButton:hover:not(:active),\n.rst__expandButton:hover:not(:active) {\n  background-size: 24px;\n  height: 20px;\n  width: 20px;\n}\n\n.rst__collapseButton {\n  background: $white\n  url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCI+PGNpcmNsZSBjeD0iOSIgY3k9IjkiIHI9IjgiIGZpbGw9IiNGRkYiLz48ZyBzdHJva2U9IiM5ODk4OTgiIHN0cm9rZS13aWR0aD0iMS45IiA+PHBhdGggZD0iTTQuNSA5aDkiLz48L2c+Cjwvc3ZnPg==')\n  no-repeat center;\n}\n\n.rst__expandButton {\n  background: $white\n  url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCI+PGNpcmNsZSBjeD0iOSIgY3k9IjkiIHI9IjgiIGZpbGw9IiNGRkYiLz48ZyBzdHJva2U9IiM5ODk4OTgiIHN0cm9rZS13aWR0aD0iMS45IiA+PHBhdGggZD0iTTQuNSA5aDkiLz48cGF0aCBkPSJNOSA0LjV2OSIvPjwvZz4KPC9zdmc+')\n  no-repeat center;\n}\n\n/**\n * Line for under a node with children\n */\n.rst__lineChildren {\n  height: 100%;\n  display: inline-block;\n  position: absolute;\n}\n.rst__lineChildren::after {\n  content: '';\n  position: absolute;\n  background-color: black;\n  width: 1px;\n  left: 50%;\n  bottom: 0;\n  height: 10px;\n}\n\n.rst__rtl.rst__lineChildren::after {\n  right: 50%;\n  left: initial;\n}\n\n.rst__placeholder {\n  position: relative;\n  height: 68px;\n  max-width: 300px;\n  padding: 10px;\n}\n.rst__placeholder,\n.rst__placeholder > * {\n  box-sizing: border-box;\n}\n.rst__placeholder::before {\n  border: 3px dashed $gray-200;\n  content: '';\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  bottom: 5px;\n  left: 5px;\n  z-index: -1;\n}\n\n/**\n * The outline of where the element will go if dropped, displayed while dragging\n */\n.rst__placeholderLandingPad,\n.rst__placeholderCancelPad {\n  border: none !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n.rst__placeholderLandingPad *,\n.rst__placeholderCancelPad * {\n  opacity: 0 !important;\n}\n.rst__placeholderLandingPad::before,\n.rst__placeholderCancelPad::before {\n  background-color: lightblue;\n  border-color: white;\n}\n\n/**\n * Alternate appearance of the landing pad when the dragged location is invalid\n */\n.rst__placeholderCancelPad::before {\n  background-color: #e6a8ad;\n}\n\n/* Collection default theme */\n\n.ReactVirtualized__Collection {\n}\n\n.ReactVirtualized__Collection__innerScrollContainer {\n}\n\n/* Grid default theme */\n\n.ReactVirtualized__Grid {\n}\n\n.ReactVirtualized__Grid__innerScrollContainer {\n}\n\n/* Table default theme */\n\n.ReactVirtualized__Table {\n}\n\n.ReactVirtualized__Table__Grid {\n}\n\n.ReactVirtualized__Table__headerRow {\n  font-weight: 700;\n  text-transform: uppercase;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.ReactVirtualized__Table__row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.ReactVirtualized__Table__headerTruncatedText {\n  display: inline-block;\n  max-width: 100%;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.ReactVirtualized__Table__headerColumn,\n.ReactVirtualized__Table__rowColumn {\n  margin-right: 10px;\n  min-width: 0px;\n}\n.ReactVirtualized__Table__rowColumn {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.ReactVirtualized__Table__headerColumn:first-of-type,\n.ReactVirtualized__Table__rowColumn:first-of-type {\n  margin-left: 10px;\n}\n.ReactVirtualized__Table__sortableHeaderColumn {\n  cursor: pointer;\n}\n\n.ReactVirtualized__Table__sortableHeaderIconContainer {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.ReactVirtualized__Table__sortableHeaderIcon {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 24px;\n  flex: 0 0 24px;\n  height: 1em;\n  width: 1em;\n  fill: currentColor;\n}\n\n/* List default theme */\n\n.ReactVirtualized__List {\n}","@use \"sass:math\";\n\n.ReactTable {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n\n  .rt-table {\n    flex: auto 1;\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    width: 100%;\n    border-collapse: collapse;\n    overflow: auto\n  }\n\n  .-pagination input,\n  .-pagination select,\n  .rt-thead.-filters input,\n  .rt-thead.-filters select {\n    display: block;\n    width: 100%;\n    color: $input-color;\n    background-color: $input-bg;\n    background-clip: padding-box;\n    border: $input-border-width solid $input-border-color;\n\n    height: $input-height-sm;\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    // line-height: $input-line-height-sm;\n    @include border-radius($input-border-radius-sm);\n\n    @if $enable-rounded {\n      border-radius: $input-border-radius;\n    } @else {\n      border-radius: 0;\n    }\n\n    @include box-shadow($input-box-shadow);\n    @include transition($input-transition);\n\n    &::-ms-expand {\n      background-color: transparent;\n      border: 0;\n    }\n\n    // @include form-control-focus();\n\n    // Placeholder\n    &::placeholder {\n      color: $input-placeholder-color;\n      opacity: 1;\n    }\n\n    &:disabled,\n    &[readonly] {\n      background-color: $input-disabled-bg;\n      opacity: 1;\n    }\n  }\n\n  .rt-thead {\n    flex: 1 0 auto;\n    display: flex;\n    flex-direction: column;\n    user-select: none;\n\n    &.-headerGroups {\n      background: rgba(0, 0, 0, 0.03);\n      border-bottom: 1px solid $table-border-color;\n\n      .rt-th,\n      .rt-td {\n        padding: $table-cell-padding-sm;\n        color: $table-head-color;\n\n        &:hover {\n          color: $table-head-color;\n        }\n\n        &:empty {\n          padding: 0;\n        }\n      }\n\n    }\n\n    &.-filters {\n      border-bottom: 1px solid $table-border-color;\n      background: $gray-100;\n\n      .rt-th {\n        border-right: 1px solid $table-border-color\n      }\n\n      &.-header {\n        box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.15)\n      }\n    }\n\n    .rt-tr {\n      text-align: center\n    }\n\n    .rt-th,\n    .rt-td {\n      padding: $table-cell-padding;\n      line-height: normal;\n      position: relative;\n      font-weight: bold;\n      border-right: 1px solid $table-border-color;\n      border-bottom: 1px solid $table-border-color;\n      transition: box-shadow .3s cubic-bezier(.175, .885, .32, 1.275);\n      box-shadow: inset 0 0 0 0 transparent;\n      color: $primary;\n\n      &:hover {\n        color: darken($primary, 15%);\n      }\n    }\n\n    .rt-th.-sort-asc,\n    .rt-td.-sort-asc {\n      box-shadow: inset 0 3px 0 0 $primary\n    }\n\n    .rt-th.-sort-desc,\n    .rt-td.-sort-desc {\n      box-shadow: inset 0 -3px 0 0 $primary\n    }\n\n    .rt-th.-cursor-pointer,\n    .rt-td.-cursor-pointer {\n      cursor: pointer\n    }\n\n    .rt-th:last-child,\n    .rt-td:last-child {\n      border-right: 0\n    }\n\n    .rt-resizable-header {\n      overflow: visible;\n    }\n\n    .rt-resizable-header:last-child {\n      overflow: hidden\n    }\n\n    .rt-resizable-header-content {\n      overflow: hidden;\n      text-overflow: ellipsis\n    }\n\n    .rt-header-pivot {\n      border-right-color: #f7f7f7\n    }\n\n    .rt-header-pivot:after,\n    .rt-header-pivot:before {\n      left: 100%;\n      top: 50%;\n      border: solid transparent;\n      content: \" \";\n      height: 0;\n      width: 0;\n      position: absolute;\n      pointer-events: none\n    }\n\n    .rt-header-pivot:after {\n      border-color: rgba(255, 255, 255, 0);\n      border-left-color: $white;\n      border-width: 8px;\n      margin-top: -8px\n    }\n\n    .rt-header-pivot:before {\n      border-color: rgba(102, 102, 102, 0);\n      border-left-color: #f7f7f7;\n      border-width: 10px;\n      margin-top: -10px\n    }\n  }\n\n  .rt-tbody {\n    flex: 99999 1 auto;\n    display: flex;\n    flex-direction: column;\n    overflow: auto;\n\n    .rt-tr-group {\n      border-bottom: solid 1px $table-border-color;\n    }\n\n    .rt-tr-group:last-child {\n      border-bottom: 0\n    }\n\n    .rt-td {\n      border-right: 1px solid $table-border-color;\n      align-items: center;\n      align-content: center;\n      display: flex;\n\n      [contenteditable=\"true\"] {\n        width: 100%;\n        border: 1px solid transparent;\n        background: $white !important;\n        @include border-radius($input-border-radius-sm);\n\n        &:focus {\n          padding: 3px 5px;\n          border-color: $input-focus-border-color;\n          outline: none;\n        }\n      }\n    }\n\n    .rt-td:last-child {\n      border-right: 0\n    }\n\n    .rt-expandable {\n      cursor: pointer;\n      text-overflow: clip\n    }\n  }\n\n  .rt-tr-group {\n    flex: 1 0 auto;\n    display: flex;\n    flex-direction: column;\n    align-items: stretch\n  }\n\n  .rt-tr {\n    flex: 1 0 auto;\n    display: inline-flex\n  }\n\n  .rt-th,\n  .rt-td {\n    flex: 1 0 0;\n    text-overflow: ellipsis;\n    padding: $table-cell-padding;\n    //overflow: hidden;\n    transition: .3s ease;\n    transition-property: width, min-width, padding, opacity;\n\n    &.-hidden {\n      width: 0 !important;\n      min-width: 0 !important;\n      padding: 0 !important;\n      border: 0 !important;\n      opacity: 0 !important\n    }\n  }\n\n  .rt-expander {\n    display: inline-block;\n    position: relative;\n    color: transparent;\n    margin: 0 10px 0 0;\n    &:after {\n      content: '';\n      position: absolute;\n      width: 0;\n      height: 0;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%) rotate(-90deg);\n      border-left: 5.04px solid transparent;\n      border-right: 5.04px solid transparent;\n      border-top: 7px solid rgba(0, 0, 0, 0.8);\n      transition: all .3s cubic-bezier(.175, .885, .32, 1.275);\n      cursor: pointer\n    }\n    &.-open:after {\n      transform: translate(-50%, -50%) rotate(0)\n    }\n  }\n\n  .rt-resizer {\n    display: inline-block;\n    position: absolute;\n    width: 36px;\n    top: 0;\n    bottom: 0;\n    right: -18px;\n    cursor: col-resize;\n    z-index: 10\n  }\n\n  .rt-tfoot {\n    flex: 1 0 auto;\n    display: flex;\n    flex-direction: column;\n    box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);\n\n    .rt-td {\n      border-right: 1px solid $table-border-color;\n      &:last-child {\n        border-right: 0\n      }\n    }\n  }\n\n  &.-striped .rt-tr.-odd {\n    background: rgba(0, 0, 0, 0.03)\n  }\n\n  &.-fixed {\n    .-header {\n      box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.07);\n    }\n\n    .pagination-bottom {\n      box-shadow: 0 -2px 7px 0 rgba(0, 0, 0, 0.07);\n    }\n  }\n\n  &.-highlight .rt-tbody .rt-tr:not(.-padRow):hover {\n    background: $dropdown-link-hover-bg\n  }\n\n  .-pagination {\n    z-index: 1;\n    display: flex;\n    justify-content: space-between;\n    align-items: stretch;\n    flex-wrap: wrap;\n    padding: 3px;\n    border-top: 2px solid rgba(0, 0, 0, 0.1);\n\n    .-btn {\n      appearance: none;\n      display: block;\n      width: 100%;\n      height: 100%;\n      border: 0;\n      border-radius: $border-radius;\n      padding: 6px;\n      font-size: 1em;\n      color: $primary;\n      background: $gray-100;\n      transition: all .2s ease;\n      cursor: pointer;\n      outline: none;\n      font-weight: bold;\n    }\n\n    .-btn[disabled] {\n      opacity: .5;\n      cursor: default\n    }\n\n    .-btn:not([disabled]):hover {\n      background: $primary;\n      color: $white\n    }\n\n    .-previous,\n    .-next {\n      flex: 1;\n      text-align: center\n    }\n\n    .-center {\n      text-align: center;\n      margin-bottom: 0;\n      display: flex;\n      flex-direction: row;\n      flex-wrap: wrap;\n      align-items: center;\n      justify-content: space-around\n    }\n\n    .-totalPages {\n      padding-left: 5px;\n      font-weight: bold;\n    }\n\n    .-pageInfo {\n      display: inherit;\n      margin: 3px 0 3px 10px;\n      white-space: nowrap;\n      height: 30px;\n      line-height: 30px;\n    }\n\n    .-pageJump {\n      display: inline-block;\n      margin: 0 5px;\n    }\n\n    .-pageJump input {\n      width: 70px;\n      text-align: center\n    }\n\n    .-pageSizeOptions {\n      margin: 3px 10px\n    }\n  }\n\n  .rt-noData {\n    display: block;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    background: rgba(255, 255, 255, 0.8);\n    transition: all .3s ease;\n    z-index: 1;\n    pointer-events: none;\n    padding: 20px;\n    color: rgba(0, 0, 0, 0.5)\n  }\n\n  .-loading {\n    display: block;\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    background: rgba(255, 255, 255, 0.8);\n    transition: all .3s ease;\n    z-index: -1;\n    opacity: 0;\n    pointer-events: none;\n  }\n\n  .-loading > div {\n    position: absolute;\n    display: block;\n    text-align: center;\n    width: 100%;\n    top: 50%;\n    left: 0;\n    font-size: 15px;\n    color: $primary;\n    transform: translateY(-52%);\n    transition: all .3s cubic-bezier(.25, .46, .45, .94)\n  }\n\n  .-loading.-active {\n    opacity: 1;\n    z-index: 2;\n    pointer-events: all;\n  }\n\n  .-loading.-active > div {\n    transform: translateY(50%)\n  }\n\n  .rt-resizing .rt-th,\n  .rt-resizing .rt-td {\n    transition: none !important;\n    cursor: col-resize;\n    user-select: none\n  }\n\n}\n\n.table thead th,\n.table td {\n  vertical-align: middle;\n}\n\n.table {\n  th .filter {\n    margin-top: math.div($layout-spacer-x, 4);\n    height: auto;\n    padding: 0.3rem 0.5rem;\n  }\n}\n\n.caret-4-asc,\n.caret-4-desc {\n  font-family: 'Linearicons-Free';\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  margin-left: math.div($layout-spacer-x, 4);\n}\n\n.table .sortable:hover {\n  .caret-4-asc,\n  .caret-4-desc {\n    color: $primary;\n  }\n}\n\n.caret-4-asc {\n  @extend .lnr-chevron-up !optional;\n}\n\n.caret-4-desc {\n  @extend .lnr-chevron-down !optional;\n}\n\n// Table sizing\n\n.table-lg {\n  th,\n  td {\n    padding: ($table-cell-padding * 2) ($table-cell-padding * 1.5);\n  }\n}\n\n//react-data-table-component  css\n\n.rdt_Table {\n  border: 1px solid rgba(0,0,0,.1);\n}\n\n.rdt_TableCol {\n  padding: 0.55rem;\n  line-height: normal;\n  position: relative;\n  font-weight: 700;\n  border-right: 1px solid #e9ecef;\n  border-bottom: 1px solid #e9ecef;\n  transition: box-shadow .3s cubic-bezier(.175,.885,.32,1.275);\n  box-shadow: inset 0 0 0 0 transparent;\n  color: #545cd8;\n}\n\n.rdt_TableCell {\n  border-right: 1px solid #e9ecef;\n}\n\n.rdt_TableRow:nth-child(odd) {\n  background-color: #FFFFFF;\n}\n.rdt_TableRow:nth-child(even) {\n  background-color: #f7f7f7;\n}\n\n.rdt_TableRow:hover {\n  background-color: $dropdown-link-hover-bg;\n}","// Linear Icons\n$linearicons-font-path: \"linearicons\";\n\n\n@font-face {\n  font-family: 'Linearicons-Free';\n  src:url('#{$linearicons-font-path}/Linearicons-Free.eot?w118d');\n  src:url('#{$linearicons-font-path}/Linearicons-Free.eot?#iefixw118d') format('embedded-opentype'),\n  url('#{$linearicons-font-path}/Linearicons-Free.woff2?w118d') format('woff2'),\n  url('#{$linearicons-font-path}/Linearicons-Free.woff?w118d') format('woff'),\n  url('#{$linearicons-font-path}/Linearicons-Free.ttf?w118d') format('truetype'),\n  url('#{$linearicons-font-path}/Linearicons-Free.svg?w118d#Linearicons-Free') format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n\n[class^=\"lnr-\"],\n[class*=\" lnr-\"] {\n  font-family: 'Linearicons-Free';\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.lnr-home:before {\n  content: \"\\e800\";\n}\n.lnr-apartment:before {\n  content: \"\\e801\";\n}\n.lnr-pencil:before {\n  content: \"\\e802\";\n}\n.lnr-magic-wand:before {\n  content: \"\\e803\";\n}\n.lnr-drop:before {\n  content: \"\\e804\";\n}\n.lnr-lighter:before {\n  content: \"\\e805\";\n}\n.lnr-poop:before {\n  content: \"\\e806\";\n}\n.lnr-sun:before {\n  content: \"\\e807\";\n}\n.lnr-moon:before {\n  content: \"\\e808\";\n}\n.lnr-cloud:before {\n  content: \"\\e809\";\n}\n.lnr-cloud-upload:before {\n  content: \"\\e80a\";\n}\n.lnr-cloud-download:before {\n  content: \"\\e80b\";\n}\n.lnr-cloud-sync:before {\n  content: \"\\e80c\";\n}\n.lnr-cloud-check:before {\n  content: \"\\e80d\";\n}\n.lnr-database:before {\n  content: \"\\e80e\";\n}\n.lnr-lock:before {\n  content: \"\\e80f\";\n}\n.lnr-cog:before {\n  content: \"\\e810\";\n}\n.lnr-trash:before {\n  content: \"\\e811\";\n}\n.lnr-dice:before {\n  content: \"\\e812\";\n}\n.lnr-heart:before {\n  content: \"\\e813\";\n}\n.lnr-star:before {\n  content: \"\\e814\";\n}\n.lnr-star-half:before {\n  content: \"\\e815\";\n}\n.lnr-star-empty:before {\n  content: \"\\e816\";\n}\n.lnr-flag:before {\n  content: \"\\e817\";\n}\n.lnr-envelope:before {\n  content: \"\\e818\";\n}\n.lnr-paperclip:before {\n  content: \"\\e819\";\n}\n.lnr-inbox:before {\n  content: \"\\e81a\";\n}\n.lnr-eye:before {\n  content: \"\\e81b\";\n}\n.lnr-printer:before {\n  content: \"\\e81c\";\n}\n.lnr-file-empty:before {\n  content: \"\\e81d\";\n}\n.lnr-file-add:before {\n  content: \"\\e81e\";\n}\n.lnr-enter:before {\n  content: \"\\e81f\";\n}\n.lnr-exit:before {\n  content: \"\\e820\";\n}\n.lnr-graduation-hat:before {\n  content: \"\\e821\";\n}\n.lnr-license:before {\n  content: \"\\e822\";\n}\n.lnr-music-note:before {\n  content: \"\\e823\";\n}\n.lnr-film-play:before {\n  content: \"\\e824\";\n}\n.lnr-camera-video:before {\n  content: \"\\e825\";\n}\n.lnr-camera:before {\n  content: \"\\e826\";\n}\n.lnr-picture:before {\n  content: \"\\e827\";\n}\n.lnr-book:before {\n  content: \"\\e828\";\n}\n.lnr-bookmark:before {\n  content: \"\\e829\";\n}\n.lnr-user:before {\n  content: \"\\e82a\";\n}\n.lnr-users:before {\n  content: \"\\e82b\";\n}\n.lnr-shirt:before {\n  content: \"\\e82c\";\n}\n.lnr-store:before {\n  content: \"\\e82d\";\n}\n.lnr-cart:before {\n  content: \"\\e82e\";\n}\n.lnr-tag:before {\n  content: \"\\e82f\";\n}\n.lnr-phone-handset:before {\n  content: \"\\e830\";\n}\n.lnr-phone:before {\n  content: \"\\e831\";\n}\n.lnr-pushpin:before {\n  content: \"\\e832\";\n}\n.lnr-map-marker:before {\n  content: \"\\e833\";\n}\n.lnr-map:before {\n  content: \"\\e834\";\n}\n.lnr-location:before {\n  content: \"\\e835\";\n}\n.lnr-calendar-full:before {\n  content: \"\\e836\";\n}\n.lnr-keyboard:before {\n  content: \"\\e837\";\n}\n.lnr-spell-check:before {\n  content: \"\\e838\";\n}\n.lnr-screen:before {\n  content: \"\\e839\";\n}\n.lnr-smartphone:before {\n  content: \"\\e83a\";\n}\n.lnr-tablet:before {\n  content: \"\\e83b\";\n}\n.lnr-laptop:before {\n  content: \"\\e83c\";\n}\n.lnr-laptop-phone:before {\n  content: \"\\e83d\";\n}\n.lnr-power-switch:before {\n  content: \"\\e83e\";\n}\n.lnr-bubble:before {\n  content: \"\\e83f\";\n}\n.lnr-heart-pulse:before {\n  content: \"\\e840\";\n}\n.lnr-construction:before {\n  content: \"\\e841\";\n}\n.lnr-pie-chart:before {\n  content: \"\\e842\";\n}\n.lnr-chart-bars:before {\n  content: \"\\e843\";\n}\n.lnr-gift:before {\n  content: \"\\e844\";\n}\n.lnr-diamond:before {\n  content: \"\\e845\";\n}\n.lnr-linearicons:before {\n  content: \"\\e846\";\n}\n.lnr-dinner:before {\n  content: \"\\e847\";\n}\n.lnr-coffee-cup:before {\n  content: \"\\e848\";\n}\n.lnr-leaf:before {\n  content: \"\\e849\";\n}\n.lnr-paw:before {\n  content: \"\\e84a\";\n}\n.lnr-rocket:before {\n  content: \"\\e84b\";\n}\n.lnr-briefcase:before {\n  content: \"\\e84c\";\n}\n.lnr-bus:before {\n  content: \"\\e84d\";\n}\n.lnr-car:before {\n  content: \"\\e84e\";\n}\n.lnr-train:before {\n  content: \"\\e84f\";\n}\n.lnr-bicycle:before {\n  content: \"\\e850\";\n}\n.lnr-wheelchair:before {\n  content: \"\\e851\";\n}\n.lnr-select:before {\n  content: \"\\e852\";\n}\n.lnr-earth:before {\n  content: \"\\e853\";\n}\n.lnr-smile:before {\n  content: \"\\e854\";\n}\n.lnr-sad:before {\n  content: \"\\e855\";\n}\n.lnr-neutral:before {\n  content: \"\\e856\";\n}\n.lnr-mustache:before {\n  content: \"\\e857\";\n}\n.lnr-alarm:before {\n  content: \"\\e858\";\n}\n.lnr-bullhorn:before {\n  content: \"\\e859\";\n}\n.lnr-volume-high:before {\n  content: \"\\e85a\";\n}\n.lnr-volume-medium:before {\n  content: \"\\e85b\";\n}\n.lnr-volume-low:before {\n  content: \"\\e85c\";\n}\n.lnr-volume:before {\n  content: \"\\e85d\";\n}\n.lnr-mic:before {\n  content: \"\\e85e\";\n}\n.lnr-hourglass:before {\n  content: \"\\e85f\";\n}\n.lnr-undo:before {\n  content: \"\\e860\";\n}\n.lnr-redo:before {\n  content: \"\\e861\";\n}\n.lnr-sync:before {\n  content: \"\\e862\";\n}\n.lnr-history:before {\n  content: \"\\e863\";\n}\n.lnr-clock:before {\n  content: \"\\e864\";\n}\n.lnr-download:before {\n  content: \"\\e865\";\n}\n.lnr-upload:before {\n  content: \"\\e866\";\n}\n.lnr-enter-down:before {\n  content: \"\\e867\";\n}\n.lnr-exit-up:before {\n  content: \"\\e868\";\n}\n.lnr-bug:before {\n  content: \"\\e869\";\n}\n.lnr-code:before {\n  content: \"\\e86a\";\n}\n.lnr-link:before {\n  content: \"\\e86b\";\n}\n.lnr-unlink:before {\n  content: \"\\e86c\";\n}\n.lnr-thumbs-up:before {\n  content: \"\\e86d\";\n}\n.lnr-thumbs-down:before {\n  content: \"\\e86e\";\n}\n.lnr-magnifier:before {\n  content: \"\\e86f\";\n}\n.lnr-cross:before {\n  content: \"\\e870\";\n}\n.lnr-menu:before {\n  content: \"\\e871\";\n}\n.lnr-list:before {\n  content: \"\\e872\";\n}\n.lnr-chevron-up:before {\n  content: \"\\e873\";\n}\n.lnr-chevron-down:before {\n  content: \"\\e874\";\n}\n.lnr-chevron-left:before {\n  content: \"\\e875\";\n}\n.lnr-chevron-right:before {\n  content: \"\\e876\";\n}\n.lnr-arrow-up:before {\n  content: \"\\e877\";\n}\n.lnr-arrow-down:before {\n  content: \"\\e878\";\n}\n.lnr-arrow-left:before {\n  content: \"\\e879\";\n}\n.lnr-arrow-right:before {\n  content: \"\\e87a\";\n}\n.lnr-move:before {\n  content: \"\\e87b\";\n}\n.lnr-warning:before {\n  content: \"\\e87c\";\n}\n.lnr-question-circle:before {\n  content: \"\\e87d\";\n}\n.lnr-menu-circle:before {\n  content: \"\\e87e\";\n}\n.lnr-checkmark-circle:before {\n  content: \"\\e87f\";\n}\n.lnr-cross-circle:before {\n  content: \"\\e880\";\n}\n.lnr-plus-circle:before {\n  content: \"\\e881\";\n}\n.lnr-circle-minus:before {\n  content: \"\\e882\";\n}\n.lnr-arrow-up-circle:before {\n  content: \"\\e883\";\n}\n.lnr-arrow-down-circle:before {\n  content: \"\\e884\";\n}\n.lnr-arrow-left-circle:before {\n  content: \"\\e885\";\n}\n.lnr-arrow-right-circle:before {\n  content: \"\\e886\";\n}\n.lnr-chevron-up-circle:before {\n  content: \"\\e887\";\n}\n.lnr-chevron-down-circle:before {\n  content: \"\\e888\";\n}\n.lnr-chevron-left-circle:before {\n  content: \"\\e889\";\n}\n.lnr-chevron-right-circle:before {\n  content: \"\\e88a\";\n}\n.lnr-crop:before {\n  content: \"\\e88b\";\n}\n.lnr-frame-expand:before {\n  content: \"\\e88c\";\n}\n.lnr-frame-contract:before {\n  content: \"\\e88d\";\n}\n.lnr-layers:before {\n  content: \"\\e88e\";\n}\n.lnr-funnel:before {\n  content: \"\\e88f\";\n}\n.lnr-text-format:before {\n  content: \"\\e890\";\n}\n.lnr-text-format-remove:before {\n  content: \"\\e891\";\n}\n.lnr-text-size:before {\n  content: \"\\e892\";\n}\n.lnr-bold:before {\n  content: \"\\e893\";\n}\n.lnr-italic:before {\n  content: \"\\e894\";\n}\n.lnr-underline:before {\n  content: \"\\e895\";\n}\n.lnr-strikethrough:before {\n  content: \"\\e896\";\n}\n.lnr-highlight:before {\n  content: \"\\e897\";\n}\n.lnr-text-align-left:before {\n  content: \"\\e898\";\n}\n.lnr-text-align-center:before {\n  content: \"\\e899\";\n}\n.lnr-text-align-right:before {\n  content: \"\\e89a\";\n}\n.lnr-text-align-justify:before {\n  content: \"\\e89b\";\n}\n.lnr-line-spacing:before {\n  content: \"\\e89c\";\n}\n.lnr-indent-increase:before {\n  content: \"\\e89d\";\n}\n.lnr-indent-decrease:before {\n  content: \"\\e89e\";\n}\n.lnr-pilcrow:before {\n  content: \"\\e89f\";\n}\n.lnr-direction-ltr:before {\n  content: \"\\e8a0\";\n}\n.lnr-direction-rtl:before {\n  content: \"\\e8a1\";\n}\n.lnr-page-break:before {\n  content: \"\\e8a2\";\n}\n.lnr-sort-alpha-asc:before {\n  content: \"\\e8a3\";\n}\n.lnr-sort-amount-asc:before {\n  content: \"\\e8a4\";\n}\n.lnr-hand:before {\n  content: \"\\e8a5\";\n}\n.lnr-pointer-up:before {\n  content: \"\\e8a6\";\n}\n.lnr-pointer-right:before {\n  content: \"\\e8a7\";\n}\n.lnr-pointer-down:before {\n  content: \"\\e8a8\";\n}\n.lnr-pointer-left:before {\n  content: \"\\e8a9\";\n}\n","/*\n*  Licensing: http://www.pixeden.com/icon-fonts/stroke-7-icon-font-set\n*/\n\n@import \"variables\";\n@import \"path\";\n@import \"core\";\n@import \"helper\";\n@import \"icons\";\n","@font-face {\n\tfont-family: 'Pe-icon-7-stroke';\n\tsrc:url('#{$pe-7s-font-path}/Pe-icon-7-stroke.eot?d7yf1v');\n\tsrc:url('#{$pe-7s-font-path}/Pe-icon-7-stroke.eot?#iefixd7yf1v') format('embedded-opentype'),\n\t\turl('#{$pe-7s-font-path}/Pe-icon-7-stroke.woff?d7yf1v') format('woff'),\n\t\turl('#{$pe-7s-font-path}/Pe-icon-7-stroke.ttf?d7yf1v') format('truetype'),\n\t\turl('#{$pe-7s-font-path}/Pe-icon-7-stroke.svg?d7yf1v#Pe-icon-7-stroke') format('svg');\n\tfont-weight: normal;\n\tfont-style: normal;\n}\n","[class^=\"#{$font-prefix}-\"], [class*=\" #{$font-prefix}-\"] {\n\tdisplay: inline-block;\n\tfont-family: 'Pe-icon-7-stroke';\n\tspeak: none;\n\tfont-style: normal;\n\tfont-weight: normal;\n\tfont-variant: normal;\n\ttext-transform: none;\n\tline-height: 1;\n\n\t/* Better Font Rendering =========== */\n\t-webkit-font-smoothing: antialiased;\n\t-moz-osx-font-smoothing: grayscale;\n}\n","\n/* HELPER CLASS\n * -------------------------- */\n\n/* FA based classes */\n\n/*! Modified from font-awesome helper CSS classes - PIXEDEN\n *  Font Awesome 4.0.3 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (CSS: MIT License)\n */\n\n/* makes the font 33% larger relative to the icon container */\n.pe-lg {\n  font-size: $font-size-base * 1.33;\n  line-height: 0.75em;\n  vertical-align: -15%;\n}\n\n.pe-2x {\n  font-size: 2 * $font-size-base;\n}\n\n.pe-3x {\n  font-size: 3 * $font-size-base;\n}\n\n.pe-4x {\n  font-size: 4 * $font-size-base;\n}\n\n.pe-5x {\n  font-size: 5 * $font-size-base;\n}\n\n.pe-fw {\n  width: 1.2857142857142858em;\n  text-align: center;\n}\n\n.pe-ul {\n  padding-left: 0;\n  margin-left: 2.142857142857143em;\n  list-style-type: none;\n  \n  & > li {\n    position: relative;\n  }\n}\n\n.pe-li {\n  position: absolute;\n  left: -2.142857142857143em;\n  width: 2.142857142857143em;\n  top: 0.14285714285714285em;\n  text-align: center;\n\n  &.pe-lg {\n    left: -1.8571428571428572em;\n  }\n}\n\n.pe-border {\n  padding: .2em .25em .15em;\n  border: solid 0.08em #eeeeee;\n  border-radius: .1em;\n}\n\n.pull-right {\n  float: right;\n}\n\n.pe {\n  &.pull-left {\n    float: left;\n    margin-right: .3em;\n    margin-left: .3em;\n  }\n}\n\n.pe-spin {\n  animation: spin 2s infinite linear;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(359deg);\n  }\n}\n\n.pe-rotate-90 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);\n  transform: rotate(90deg);\n}\n\n.pe-rotate-180 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n  transform: rotate(180deg);\n}\n\n.pe-rotate-270 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);\n  transform: rotate(270deg);\n}\n\n.pe-flip-horizontal {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1);\n  transform: scale(-1, 1);\n}\n\n.pe-flip-vertical {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1);\n  transform: scale(1, -1);\n}\n\n.pe-stack {\n  position: relative;\n  display: inline-block;\n  width: 2em;\n  height: 2em;\n  line-height: 2em;\n  vertical-align: middle;\n}\n\n.pe-stack-1x,\n.pe-stack-2x {\n  position: absolute;\n  left: 0;\n  width: 100%;\n  text-align: center;\n}\n\n.pe-stack-1x {\n  line-height: inherit;\n}\n\n.pe-stack-2x {\n  font-size: 2em;\n}\n\n.pe-inverse {\n  color: #ffffff;\n}\n\n/* Custom classes / mods - PIXEDEN */\n.pe-va {\n  vertical-align: middle;\n}\n\n.pe-border {\n  border: solid 0.08em #eaeaea;\n}\n",".#{$font-prefix}-album:before {\n  content: $font-var-album;\n}\n\n.#{$font-prefix}-arc:before {\n  content: $font-var-arc;\n}\n.#{$font-prefix}-back-2:before {\n  content: $font-var-back-2;\n}\n.#{$font-prefix}-bandaid:before {\n  content: $font-var-bandaid;\n}\n.#{$font-prefix}-car:before {\n  content: $font-var-car;\n}\n.#{$font-prefix}-diamond:before {\n  content: $font-var-diamond;\n}\n.#{$font-prefix}-door-lock:before {\n  content: $font-var-door-lock;\n}\n.#{$font-prefix}-eyedropper:before {\n  content: $font-var-eyedropper;\n}\n.#{$font-prefix}-female:before {\n  content: $font-var-female;\n}\n.#{$font-prefix}-gym:before {\n  content: $font-var-gym;\n}\n.#{$font-prefix}-hammer:before {\n  content: $font-var-hammer;\n}\n.#{$font-prefix}-headphones:before {\n  content: $font-var-headphones;\n}\n.#{$font-prefix}-helm:before {\n  content: $font-var-helm;\n}\n.#{$font-prefix}-hourglass:before {\n  content: $font-var-hourglass;\n}\n.#{$font-prefix}-leaf:before {\n  content: $font-var-leaf;\n}\n.#{$font-prefix}-magic-wand:before {\n  content: $font-var-magic-wand;\n}\n.#{$font-prefix}-male:before {\n  content: $font-var-male;\n}\n.#{$font-prefix}-map-2:before {\n  content: $font-var-map-2;\n}\n.#{$font-prefix}-next-2:before {\n  content: $font-var-next-2;\n}\n.#{$font-prefix}-paint-bucket:before {\n  content: $font-var-paint-bucket;\n}\n.#{$font-prefix}-pendrive:before {\n  content: $font-var-pendrive;\n}\n.#{$font-prefix}-photo:before {\n  content: $font-var-photo;\n}\n.#{$font-prefix}-piggy:before {\n  content: $font-var-piggy;\n}\n.#{$font-prefix}-plugin:before {\n  content: $font-var-plugin;\n}\n.#{$font-prefix}-refresh-2:before {\n  content: $font-var-refresh-2;\n}\n.#{$font-prefix}-rocket:before {\n  content: $font-var-rocket;\n}\n.#{$font-prefix}-settings:before {\n  content: $font-var-settings;\n}\n.#{$font-prefix}-shield:before {\n  content: $font-var-shield;\n}\n.#{$font-prefix}-smile:before {\n  content: $font-var-smile;\n}\n.#{$font-prefix}-usb:before {\n  content: $font-var-usb;\n}\n.#{$font-prefix}-vector:before {\n  content: $font-var-vector;\n}\n.#{$font-prefix}-wine:before {\n  content: $font-var-wine;\n}\n.#{$font-prefix}-cloud-upload:before {\n  content: $font-var-cloud-upload;\n}\n.#{$font-prefix}-cash:before {\n  content: $font-var-cash;\n}\n.#{$font-prefix}-close:before {\n  content: $font-var-close;\n}\n.#{$font-prefix}-bluetooth:before {\n  content: $font-var-bluetooth;\n}\n.#{$font-prefix}-cloud-download:before {\n  content: $font-var-cloud-download;\n}\n.#{$font-prefix}-way:before {\n  content: $font-var-way;\n}\n.#{$font-prefix}-close-circle:before {\n  content: $font-var-close-circle;\n}\n.#{$font-prefix}-id:before {\n  content: $font-var-id;\n}\n.#{$font-prefix}-angle-up:before {\n  content: $font-var-angle-up;\n}\n.#{$font-prefix}-wristwatch:before {\n  content: $font-var-wristwatch;\n}\n.#{$font-prefix}-angle-up-circle:before {\n  content: $font-var-angle-up-circle;\n}\n.#{$font-prefix}-world:before {\n  content: $font-var-world;\n}\n.#{$font-prefix}-angle-right:before {\n  content: $font-var-angle-right;\n}\n.#{$font-prefix}-volume:before {\n  content: $font-var-volume;\n}\n.#{$font-prefix}-angle-right-circle:before {\n  content: $font-var-angle-right-circle;\n}\n.#{$font-prefix}-users:before {\n  content: $font-var-users;\n}\n.#{$font-prefix}-angle-left:before {\n  content: $font-var-angle-left;\n}\n.#{$font-prefix}-user-female:before {\n  content: $font-var-user-female;\n}\n.#{$font-prefix}-angle-left-circle:before {\n  content: $font-var-angle-left-circle;\n}\n.#{$font-prefix}-up-arrow:before {\n  content: $font-var-up-arrow;\n}\n.#{$font-prefix}-angle-down:before {\n  content: $font-var-angle-down;\n}\n.#{$font-prefix}-switch:before {\n  content: $font-var-switch;\n}\n.#{$font-prefix}-angle-down-circle:before {\n  content: $font-var-angle-down-circle;\n}\n.#{$font-prefix}-scissors:before {\n  content: $font-var-scissors;\n}\n.#{$font-prefix}-wallet:before {\n  content: $font-var-wallet;\n}\n.#{$font-prefix}-safe:before {\n  content: $font-var-safe;\n}\n.#{$font-prefix}-volume2:before {\n  content: $font-var-volume2;\n}\n.#{$font-prefix}-volume1:before {\n  content: $font-var-volume1;\n}\n.#{$font-prefix}-voicemail:before {\n  content: $font-var-voicemail;\n}\n.#{$font-prefix}-video:before {\n  content: $font-var-video;\n}\n.#{$font-prefix}-user:before {\n  content: $font-var-user;\n}\n.#{$font-prefix}-upload:before {\n  content: $font-var-upload;\n}\n.#{$font-prefix}-unlock:before {\n  content: $font-var-unlock;\n}\n.#{$font-prefix}-umbrella:before {\n  content: $font-var-umbrella;\n}\n.#{$font-prefix}-trash:before {\n  content: $font-var-trash;\n}\n.#{$font-prefix}-tools:before {\n  content: $font-var-tools;\n}\n.#{$font-prefix}-timer:before {\n  content: $font-var-timer;\n}\n.#{$font-prefix}-ticket:before {\n  content: $font-var-ticket;\n}\n.#{$font-prefix}-target:before {\n  content: $font-var-target;\n}\n.#{$font-prefix}-sun:before {\n  content: $font-var-sun;\n}\n.#{$font-prefix}-study:before {\n  content: $font-var-study;\n}\n.#{$font-prefix}-stopwatch:before {\n  content: $font-var-stopwatch;\n}\n.#{$font-prefix}-star:before {\n  content: $font-var-star;\n}\n.#{$font-prefix}-speaker:before {\n  content: $font-var-speaker;\n}\n.#{$font-prefix}-signal:before {\n  content: $font-var-signal;\n}\n.#{$font-prefix}-shuffle:before {\n  content: $font-var-shuffle;\n}\n.#{$font-prefix}-shopbag:before {\n  content: $font-var-shopbag;\n}\n.#{$font-prefix}-share:before {\n  content: $font-var-share;\n}\n.#{$font-prefix}-server:before {\n  content: $font-var-server;\n}\n.#{$font-prefix}-search:before {\n  content: $font-var-search;\n}\n.#{$font-prefix}-film:before {\n  content: $font-var-film;\n}\n.#{$font-prefix}-science:before {\n  content: $font-var-science;\n}\n.#{$font-prefix}-disk:before {\n  content: $font-var-disk;\n}\n.#{$font-prefix}-ribbon:before {\n  content: $font-var-ribbon;\n}\n.#{$font-prefix}-repeat:before {\n  content: $font-var-repeat;\n}\n.#{$font-prefix}-refresh:before {\n  content: $font-var-refresh;\n}\n.#{$font-prefix}-add-user:before {\n  content: $font-var-add-user;\n}\n.#{$font-prefix}-refresh-cloud:before {\n  content: $font-var-refresh-cloud;\n}\n.#{$font-prefix}-paperclip:before {\n  content: $font-var-paperclip;\n}\n.#{$font-prefix}-radio:before {\n  content: $font-var-radio;\n}\n.#{$font-prefix}-note2:before {\n  content: $font-var-note2;\n}\n.#{$font-prefix}-print:before {\n  content: $font-var-print;\n}\n.#{$font-prefix}-network:before {\n  content: $font-var-network;\n}\n.#{$font-prefix}-prev:before {\n  content: $font-var-prev;\n}\n.#{$font-prefix}-mute:before {\n  content: $font-var-mute;\n}\n.#{$font-prefix}-power:before {\n  content: $font-var-power;\n}\n.#{$font-prefix}-medal:before {\n  content: $font-var-medal;\n}\n.#{$font-prefix}-portfolio:before {\n  content: $font-var-portfolio;\n}\n.#{$font-prefix}-like2:before {\n  content: $font-var-like2;\n}\n.#{$font-prefix}-plus:before {\n  content: $font-var-plus;\n}\n.#{$font-prefix}-left-arrow:before {\n  content: $font-var-left-arrow;\n}\n.#{$font-prefix}-play:before {\n  content: $font-var-play;\n}\n.#{$font-prefix}-key:before {\n  content: $font-var-key;\n}\n.#{$font-prefix}-plane:before {\n  content: $font-var-plane;\n}\n.#{$font-prefix}-joy:before {\n  content: $font-var-joy;\n}\n.#{$font-prefix}-photo-gallery:before {\n  content: $font-var-photo-gallery;\n}\n.#{$font-prefix}-pin:before {\n  content: $font-var-pin;\n}\n.#{$font-prefix}-phone:before {\n  content: $font-var-phone;\n}\n.#{$font-prefix}-plug:before {\n  content: $font-var-plug;\n}\n.#{$font-prefix}-pen:before {\n  content: $font-var-pen;\n}\n.#{$font-prefix}-right-arrow:before {\n  content: $font-var-right-arrow;\n}\n.#{$font-prefix}-paper-plane:before {\n  content: $font-var-paper-plane;\n}\n.#{$font-prefix}-delete-user:before {\n  content: $font-var-delete-user;\n}\n.#{$font-prefix}-paint:before {\n  content: $font-var-paint;\n}\n.#{$font-prefix}-bottom-arrow:before {\n  content: $font-var-bottom-arrow;\n}\n.#{$font-prefix}-notebook:before {\n  content: $font-var-notebook;\n}\n.#{$font-prefix}-note:before {\n  content: $font-var-note;\n}\n.#{$font-prefix}-next:before {\n  content: $font-var-next;\n}\n.#{$font-prefix}-news-paper:before {\n  content: $font-var-news-paper;\n}\n.#{$font-prefix}-musiclist:before {\n  content: $font-var-musiclist;\n}\n.#{$font-prefix}-music:before {\n  content: $font-var-music;\n}\n.#{$font-prefix}-mouse:before {\n  content: $font-var-mouse;\n}\n.#{$font-prefix}-more:before {\n  content: $font-var-more;\n}\n.#{$font-prefix}-moon:before {\n  content: $font-var-moon;\n}\n.#{$font-prefix}-monitor:before {\n  content: $font-var-monitor;\n}\n.#{$font-prefix}-micro:before {\n  content: $font-var-micro;\n}\n.#{$font-prefix}-menu:before {\n  content: $font-var-menu;\n}\n.#{$font-prefix}-map:before {\n  content: $font-var-map;\n}\n.#{$font-prefix}-map-marker:before {\n  content: $font-var-map-marker;\n}\n.#{$font-prefix}-mail:before {\n  content: $font-var-mail;\n}\n.#{$font-prefix}-mail-open:before {\n  content: $font-var-mail-open;\n}\n.#{$font-prefix}-mail-open-file:before {\n  content: $font-var-mail-open-file;\n}\n.#{$font-prefix}-magnet:before {\n  content: $font-var-magnet;\n}\n.#{$font-prefix}-loop:before {\n  content: $font-var-loop;\n}\n.#{$font-prefix}-look:before {\n  content: $font-var-look;\n}\n.#{$font-prefix}-lock:before {\n  content: $font-var-lock;\n}\n.#{$font-prefix}-lintern:before {\n  content: $font-var-lintern;\n}\n.#{$font-prefix}-link:before {\n  content: $font-var-link;\n}\n.#{$font-prefix}-like:before {\n  content: $font-var-like;\n}\n.#{$font-prefix}-light:before {\n  content: $font-var-light;\n}\n.#{$font-prefix}-less:before {\n  content: $font-var-less;\n}\n.#{$font-prefix}-keypad:before {\n  content: $font-var-keypad;\n}\n.#{$font-prefix}-junk:before {\n  content: $font-var-junk;\n}\n.#{$font-prefix}-info:before {\n  content: $font-var-info;\n}\n.#{$font-prefix}-home:before {\n  content: $font-var-home;\n}\n.#{$font-prefix}-help2:before {\n  content: $font-var-help2;\n}\n.#{$font-prefix}-help1:before {\n  content: $font-var-help1;\n}\n.#{$font-prefix}-graph3:before {\n  content: $font-var-graph3;\n}\n.#{$font-prefix}-graph2:before {\n  content: $font-var-graph2;\n}\n.#{$font-prefix}-graph1:before {\n  content: $font-var-graph1;\n}\n.#{$font-prefix}-graph:before {\n  content: $font-var-graph;\n}\n.#{$font-prefix}-global:before {\n  content: $font-var-global;\n}\n.#{$font-prefix}-gleam:before {\n  content: $font-var-gleam;\n}\n.#{$font-prefix}-glasses:before {\n  content: $font-var-glasses;\n}\n.#{$font-prefix}-gift:before {\n  content: $font-var-gift;\n}\n.#{$font-prefix}-folder:before {\n  content: $font-var-folder;\n}\n.#{$font-prefix}-flag:before {\n  content: $font-var-flag;\n}\n.#{$font-prefix}-filter:before {\n  content: $font-var-filter;\n}\n.#{$font-prefix}-file:before {\n  content: $font-var-file;\n}\n.#{$font-prefix}-expand1:before {\n  content: $font-var-expand1;\n}\n.#{$font-prefix}-exapnd2:before {\n  content: $font-var-exapnd2;\n}\n.#{$font-prefix}-edit:before {\n  content: $font-var-edit;\n}\n.#{$font-prefix}-drop:before {\n  content: $font-var-drop;\n}\n.#{$font-prefix}-drawer:before {\n  content: $font-var-drawer;\n}\n.#{$font-prefix}-download:before {\n  content: $font-var-download;\n}\n.#{$font-prefix}-display2:before {\n  content: $font-var-display2;\n}\n.#{$font-prefix}-display1:before {\n  content: $font-var-display1;\n}\n.#{$font-prefix}-diskette:before {\n  content: $font-var-diskette;\n}\n.#{$font-prefix}-date:before {\n  content: $font-var-date;\n}\n.#{$font-prefix}-cup:before {\n  content: $font-var-cup;\n}\n.#{$font-prefix}-culture:before {\n  content: $font-var-culture;\n}\n.#{$font-prefix}-crop:before {\n  content: $font-var-crop;\n}\n.#{$font-prefix}-credit:before {\n  content: $font-var-credit;\n}\n.#{$font-prefix}-copy-file:before {\n  content: $font-var-copy-file;\n}\n.#{$font-prefix}-config:before {\n  content: $font-var-config;\n}\n.#{$font-prefix}-compass:before {\n  content: $font-var-compass;\n}\n.#{$font-prefix}-comment:before {\n  content: $font-var-comment;\n}\n.#{$font-prefix}-coffee:before {\n  content: $font-var-coffee;\n}\n.#{$font-prefix}-cloud:before {\n  content: $font-var-cloud;\n}\n.#{$font-prefix}-clock:before {\n  content: $font-var-clock;\n}\n.#{$font-prefix}-check:before {\n  content: $font-var-check;\n}\n.#{$font-prefix}-chat:before {\n  content: $font-var-chat;\n}\n.#{$font-prefix}-cart:before {\n  content: $font-var-cart;\n}\n.#{$font-prefix}-camera:before {\n  content: $font-var-camera;\n}\n.#{$font-prefix}-call:before {\n  content: $font-var-call;\n}\n.#{$font-prefix}-calculator:before {\n  content: $font-var-calculator;\n}\n.#{$font-prefix}-browser:before {\n  content: $font-var-browser;\n}\n.#{$font-prefix}-box2:before {\n  content: $font-var-box2;\n}\n.#{$font-prefix}-box1:before {\n  content: $font-var-box1;\n}\n.#{$font-prefix}-bookmarks:before {\n  content: $font-var-bookmarks;\n}\n.#{$font-prefix}-bicycle:before {\n  content: $font-var-bicycle;\n}\n.#{$font-prefix}-bell:before {\n  content: $font-var-bell;\n}\n.#{$font-prefix}-battery:before {\n  content: $font-var-battery;\n}\n.#{$font-prefix}-ball:before {\n  content: $font-var-ball;\n}\n.#{$font-prefix}-back:before {\n  content: $font-var-back;\n}\n.#{$font-prefix}-attention:before {\n  content: $font-var-attention;\n}\n.#{$font-prefix}-anchor:before {\n  content: $font-var-anchor;\n}\n.#{$font-prefix}-albums:before {\n  content: $font-var-albums;\n}\n.#{$font-prefix}-alarm:before {\n  content: $font-var-alarm;\n}\n.#{$font-prefix}-airplay:before {\n  content: $font-var-airplay;\n}\n","$pe-7s-font-path: \"../fonts\" !default;\n$font-size-base: 1em !default;\n$font-prefix: \"pe-7s\" !default;\n\n$font-var-album: \"\\e6aa\";\n$font-var-arc: \"\\e6ab\";\n$font-var-back-2: \"\\e6ac\";\n$font-var-bandaid: \"\\e6ad\";\n$font-var-car: \"\\e6ae\";\n$font-var-diamond: \"\\e6af\";\n$font-var-door-lock: \"\\e6b0\";\n$font-var-eyedropper: \"\\e6b1\";\n$font-var-female: \"\\e6b2\";\n$font-var-gym: \"\\e6b3\";\n$font-var-hammer: \"\\e6b4\";\n$font-var-headphones: \"\\e6b5\";\n$font-var-helm: \"\\e6b6\";\n$font-var-hourglass: \"\\e6b7\";\n$font-var-leaf: \"\\e6b8\";\n$font-var-magic-wand: \"\\e6b9\";\n$font-var-male: \"\\e6ba\";\n$font-var-map-2: \"\\e6bb\";\n$font-var-next-2: \"\\e6bc\";\n$font-var-paint-bucket: \"\\e6bd\";\n$font-var-pendrive: \"\\e6be\";\n$font-var-photo: \"\\e6bf\";\n$font-var-piggy: \"\\e6c0\";\n$font-var-plugin: \"\\e6c1\";\n$font-var-refresh-2: \"\\e6c2\";\n$font-var-rocket: \"\\e6c3\";\n$font-var-settings: \"\\e6c4\";\n$font-var-shield: \"\\e6c5\";\n$font-var-smile: \"\\e6c6\";\n$font-var-usb: \"\\e6c7\";\n$font-var-vector: \"\\e6c8\";\n$font-var-wine: \"\\e6c9\";\n$font-var-cloud-upload: \"\\e68a\";\n$font-var-cash: \"\\e68c\";\n$font-var-close: \"\\e680\";\n$font-var-bluetooth: \"\\e68d\";\n$font-var-cloud-download: \"\\e68b\";\n$font-var-way: \"\\e68e\";\n$font-var-close-circle: \"\\e681\";\n$font-var-id: \"\\e68f\";\n$font-var-angle-up: \"\\e682\";\n$font-var-wristwatch: \"\\e690\";\n$font-var-angle-up-circle: \"\\e683\";\n$font-var-world: \"\\e691\";\n$font-var-angle-right: \"\\e684\";\n$font-var-volume: \"\\e692\";\n$font-var-angle-right-circle: \"\\e685\";\n$font-var-users: \"\\e693\";\n$font-var-angle-left: \"\\e686\";\n$font-var-user-female: \"\\e694\";\n$font-var-angle-left-circle: \"\\e687\";\n$font-var-up-arrow: \"\\e695\";\n$font-var-angle-down: \"\\e688\";\n$font-var-switch: \"\\e696\";\n$font-var-angle-down-circle: \"\\e689\";\n$font-var-scissors: \"\\e697\";\n$font-var-wallet: \"\\e600\";\n$font-var-safe: \"\\e698\";\n$font-var-volume2: \"\\e601\";\n$font-var-volume1: \"\\e602\";\n$font-var-voicemail: \"\\e603\";\n$font-var-video: \"\\e604\";\n$font-var-user: \"\\e605\";\n$font-var-upload: \"\\e606\";\n$font-var-unlock: \"\\e607\";\n$font-var-umbrella: \"\\e608\";\n$font-var-trash: \"\\e609\";\n$font-var-tools: \"\\e60a\";\n$font-var-timer: \"\\e60b\";\n$font-var-ticket: \"\\e60c\";\n$font-var-target: \"\\e60d\";\n$font-var-sun: \"\\e60e\";\n$font-var-study: \"\\e60f\";\n$font-var-stopwatch: \"\\e610\";\n$font-var-star: \"\\e611\";\n$font-var-speaker: \"\\e612\";\n$font-var-signal: \"\\e613\";\n$font-var-shuffle: \"\\e614\";\n$font-var-shopbag: \"\\e615\";\n$font-var-share: \"\\e616\";\n$font-var-server: \"\\e617\";\n$font-var-search: \"\\e618\";\n$font-var-film: \"\\e6a5\";\n$font-var-science: \"\\e619\";\n$font-var-disk: \"\\e6a6\";\n$font-var-ribbon: \"\\e61a\";\n$font-var-repeat: \"\\e61b\";\n$font-var-refresh: \"\\e61c\";\n$font-var-add-user: \"\\e6a9\";\n$font-var-refresh-cloud: \"\\e61d\";\n$font-var-paperclip: \"\\e69c\";\n$font-var-radio: \"\\e61e\";\n$font-var-note2: \"\\e69d\";\n$font-var-print: \"\\e61f\";\n$font-var-network: \"\\e69e\";\n$font-var-prev: \"\\e620\";\n$font-var-mute: \"\\e69f\";\n$font-var-power: \"\\e621\";\n$font-var-medal: \"\\e6a0\";\n$font-var-portfolio: \"\\e622\";\n$font-var-like2: \"\\e6a1\";\n$font-var-plus: \"\\e623\";\n$font-var-left-arrow: \"\\e6a2\";\n$font-var-play: \"\\e624\";\n$font-var-key: \"\\e6a3\";\n$font-var-plane: \"\\e625\";\n$font-var-joy: \"\\e6a4\";\n$font-var-photo-gallery: \"\\e626\";\n$font-var-pin: \"\\e69b\";\n$font-var-phone: \"\\e627\";\n$font-var-plug: \"\\e69a\";\n$font-var-pen: \"\\e628\";\n$font-var-right-arrow: \"\\e699\";\n$font-var-paper-plane: \"\\e629\";\n$font-var-delete-user: \"\\e6a7\";\n$font-var-paint: \"\\e62a\";\n$font-var-bottom-arrow: \"\\e6a8\";\n$font-var-notebook: \"\\e62b\";\n$font-var-note: \"\\e62c\";\n$font-var-next: \"\\e62d\";\n$font-var-news-paper: \"\\e62e\";\n$font-var-musiclist: \"\\e62f\";\n$font-var-music: \"\\e630\";\n$font-var-mouse: \"\\e631\";\n$font-var-more: \"\\e632\";\n$font-var-moon: \"\\e633\";\n$font-var-monitor: \"\\e634\";\n$font-var-micro: \"\\e635\";\n$font-var-menu: \"\\e636\";\n$font-var-map: \"\\e637\";\n$font-var-map-marker: \"\\e638\";\n$font-var-mail: \"\\e639\";\n$font-var-mail-open: \"\\e63a\";\n$font-var-mail-open-file: \"\\e63b\";\n$font-var-magnet: \"\\e63c\";\n$font-var-loop: \"\\e63d\";\n$font-var-look: \"\\e63e\";\n$font-var-lock: \"\\e63f\";\n$font-var-lintern: \"\\e640\";\n$font-var-link: \"\\e641\";\n$font-var-like: \"\\e642\";\n$font-var-light: \"\\e643\";\n$font-var-less: \"\\e644\";\n$font-var-keypad: \"\\e645\";\n$font-var-junk: \"\\e646\";\n$font-var-info: \"\\e647\";\n$font-var-home: \"\\e648\";\n$font-var-help2: \"\\e649\";\n$font-var-help1: \"\\e64a\";\n$font-var-graph3: \"\\e64b\";\n$font-var-graph2: \"\\e64c\";\n$font-var-graph1: \"\\e64d\";\n$font-var-graph: \"\\e64e\";\n$font-var-global: \"\\e64f\";\n$font-var-gleam: \"\\e650\";\n$font-var-glasses: \"\\e651\";\n$font-var-gift: \"\\e652\";\n$font-var-folder: \"\\e653\";\n$font-var-flag: \"\\e654\";\n$font-var-filter: \"\\e655\";\n$font-var-file: \"\\e656\";\n$font-var-expand1: \"\\e657\";\n$font-var-exapnd2: \"\\e658\";\n$font-var-edit: \"\\e659\";\n$font-var-drop: \"\\e65a\";\n$font-var-drawer: \"\\e65b\";\n$font-var-download: \"\\e65c\";\n$font-var-display2: \"\\e65d\";\n$font-var-display1: \"\\e65e\";\n$font-var-diskette: \"\\e65f\";\n$font-var-date: \"\\e660\";\n$font-var-cup: \"\\e661\";\n$font-var-culture: \"\\e662\";\n$font-var-crop: \"\\e663\";\n$font-var-credit: \"\\e664\";\n$font-var-copy-file: \"\\e665\";\n$font-var-config: \"\\e666\";\n$font-var-compass: \"\\e667\";\n$font-var-comment: \"\\e668\";\n$font-var-coffee: \"\\e669\";\n$font-var-cloud: \"\\e66a\";\n$font-var-clock: \"\\e66b\";\n$font-var-check: \"\\e66c\";\n$font-var-chat: \"\\e66d\";\n$font-var-cart: \"\\e66e\";\n$font-var-camera: \"\\e66f\";\n$font-var-call: \"\\e670\";\n$font-var-calculator: \"\\e671\";\n$font-var-browser: \"\\e672\";\n$font-var-box2: \"\\e673\";\n$font-var-box1: \"\\e674\";\n$font-var-bookmarks: \"\\e675\";\n$font-var-bicycle: \"\\e676\";\n$font-var-bell: \"\\e677\";\n$font-var-battery: \"\\e678\";\n$font-var-ball: \"\\e679\";\n$font-var-back: \"\\e67a\";\n$font-var-attention: \"\\e67b\";\n$font-var-anchor: \"\\e67c\";\n$font-var-albums: \"\\e67d\";\n$font-var-alarm: \"\\e67e\";\n$font-var-airplay: \"\\e67f\";\n","%triangle-arrow {\n  margin-left: -$datepicker__triangle-size;\n  position: absolute;\n\n  &,\n  &::before {\n    box-sizing: content-box;\n    position: absolute;\n    border: $datepicker__triangle-size solid transparent;\n\n    height: 0;\n    width: 1px;\n  }\n\n  &::before {\n    content: \"\";\n    z-index: -1;\n    border-width: $datepicker__triangle-size;\n\n    left: -$datepicker__triangle-size;\n    border-bottom-color: $datepicker__border-color;\n  }\n}\n\n%triangle-arrow-up {\n  @extend %triangle-arrow;\n\n  top: 0;\n  margin-top: -$datepicker__triangle-size;\n\n  &,\n  &::before {\n    border-top: none;\n    border-bottom-color: $datepicker__background-color;\n  }\n\n  &::before {\n    top: -1px;\n    border-bottom-color: $datepicker__border-color;\n  }\n}\n\n%triangle-arrow-down {\n  @extend %triangle-arrow;\n\n  bottom: 0;\n  margin-bottom: -$datepicker__triangle-size;\n\n  &,\n  &::before {\n    border-bottom: none;\n    border-top-color: #fff;\n  }\n\n  &::before {\n    bottom: -1px;\n    border-top-color: $datepicker__border-color;\n  }\n}\n","// Datepicker\n\n$datepicker__background-color: $white;\n$datepicker__border-color: $gray-300;\n$datepicker__highlighted-color: $primary;\n$datepicker__muted-color: $gray-400;\n$datepicker__selected-color: theme-color(\"primary\");\n$datepicker__text-color: $gray-700;\n$datepicker__header-color: $gray-800;\n$datepicker__navigation-disabled-color: darken($datepicker__muted-color, 5%)\n;\n\n$datepicker__border-radius: $border-radius;\n$datepicker__day-margin: 0.166rem;\n$datepicker__font-size: $font-size-base;\n$datepicker__font-family: $font-size-base;\n$datepicker__item-size: 2rem;\n$datepicker__margin: 0.5rem;\n$datepicker__navigation-size: 0.35rem;\n$datepicker__triangle-size: 6px;","@import \"variables\";\n@import \"mixins\";\n\n.react-datepicker-wrapper {\n  display: block;\n  z-index: 10;\n}\n\n.react-datepicker {\n  background-color: $white;\n  color: $datepicker__text-color;\n  border: 1px solid $datepicker__border-color;\n  border-radius: $datepicker__border-radius;\n  display: inline-block;\n  position: relative;\n\n  box-shadow: $box-shadow-default;\n}\n\n.react-datepicker--time-only {\n  .react-datepicker__triangle {\n    left: 35px;\n  }\n\n  .react-datepicker__time-container {\n    border-left: 0;\n  }\n\n  .react-datepicker__time {\n    border-radius: 0.3rem;\n  }\n\n  .react-datepicker__time-box {\n    border-radius: 0.3rem;\n  }\n}\n\n.react-datepicker__triangle {\n  position: absolute;\n  left: 50px;\n}\n\n.react-datepicker-popper {\n  z-index: 102;\n\n  &[data-placement^=\"bottom\"] {\n    margin-top: $datepicker__triangle-size + 2px;\n\n    .react-datepicker__triangle {\n      @extend %triangle-arrow-up;\n    }\n  }\n\n  &[data-placement^=\"top\"] {\n    margin-bottom: $datepicker__triangle-size + 2px;\n\n    .react-datepicker__triangle {\n      @extend %triangle-arrow-down;\n    }\n  }\n\n  &[data-placement^=\"right\"] {\n    margin-left: $datepicker__triangle-size;\n\n    .react-datepicker__triangle {\n      left: auto;\n      right: 42px;\n    }\n  }\n\n  &[data-placement^=\"left\"] {\n    margin-right: $datepicker__triangle-size;\n\n    .react-datepicker__triangle {\n      left: 42px;\n      right: auto;\n    }\n  }\n}\n\n.react-datepicker__header {\n  text-align: center;\n  background-color: $datepicker__background-color;\n  border-bottom: 1px solid $datepicker__border-color;\n  border-top-left-radius: $datepicker__border-radius;\n  border-top-right-radius: $datepicker__border-radius;\n  padding-top: 10px;\n  position: relative;\n\n  &--time {\n    padding-bottom: 8px;\n    padding-left: 5px;\n    padding-right: 5px;\n  }\n}\n\n.react-datepicker__year-dropdown-container--select,\n.react-datepicker__month-dropdown-container--select,\n.react-datepicker__month-year-dropdown-container--select,\n.react-datepicker__year-dropdown-container--scroll,\n.react-datepicker__month-dropdown-container--scroll,\n.react-datepicker__month-year-dropdown-container--scroll {\n  display: inline-block;\n  margin: 0 2px;\n}\n\n.react-datepicker__current-month,\n.react-datepicker-time__header {\n  margin-top: 0;\n  color: $datepicker__header-color;\n  font-weight: bold;\n  font-size: $datepicker__font-size * 1.1;\n}\n\n.react-datepicker-time__header {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.react-datepicker__navigation {\n  background: none;\n  line-height: $datepicker__item-size;\n  text-align: center;\n  cursor: pointer;\n  position: absolute;\n  top: 15px;\n  padding: 0;\n  border: $datepicker__navigation-size solid transparent;\n  z-index: 1;\n  height: 10px;\n  width: 10px;\n  text-indent: -999em;\n  overflow: hidden;\n\n  &--previous {\n    left: 10px;\n    border-right-color: $datepicker__muted-color;\n\n    &:hover {\n      border-right-color: darken($datepicker__muted-color, 10%);\n    }\n\n    &--disabled,\n    &--disabled:hover {\n      border-right-color: $datepicker__navigation-disabled-color;\n      cursor: default;\n    }\n  }\n\n  &--next {\n    right: 10px;\n    border-left-color: $datepicker__muted-color;\n    &--with-time:not(&--with-today-button) {\n      right: 80px;\n    }\n\n    &:hover {\n      border-left-color: darken($datepicker__muted-color, 10%);\n    }\n\n    &--disabled,\n    &--disabled:hover {\n      border-left-color: $datepicker__navigation-disabled-color;\n      cursor: default;\n    }\n  }\n\n  &--years {\n    position: relative;\n    top: 0;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n\n    &-previous {\n      top: 4px;\n      border-top-color: $datepicker__muted-color;\n\n      &:hover {\n        border-top-color: darken($datepicker__muted-color, 10%);\n      }\n    }\n\n    &-upcoming {\n      top: -4px;\n      border-bottom-color: $datepicker__muted-color;\n\n      &:hover {\n        border-bottom-color: darken($datepicker__muted-color, 10%);\n      }\n    }\n  }\n}\n\n.react-datepicker__month-container {\n  float: left;\n}\n\n.react-datepicker__month {\n  margin: $datepicker__margin;\n  text-align: center;\n}\n\n.react-datepicker__time-container {\n  float: right;\n  border-left: 1px solid $datepicker__border-color;\n  width: 120px;\n\n  &--with-today-button {\n    display: inline;\n    border: 1px solid #aeaeae;\n    border-radius: 0.3rem;\n    position: absolute;\n    right: -122px;\n    top: 0;\n  }\n\n  .react-datepicker__time {\n    position: relative;\n    background: white;\n\n    .react-datepicker__time-box {\n      width: 120px;\n      overflow-x: hidden;\n      margin: 0 auto;\n      text-align: center;\n      ul.react-datepicker__time-list {\n        list-style: none;\n        margin: 0;\n        padding: 0;\n        height: calc(195px + (#{$datepicker__item-size} / 2));\n        overflow-y: scroll;\n        width: 100%;\n        box-sizing: content-box;\n\n        li.react-datepicker__time-list-item {\n          padding: 5px 10px;\n          &:hover {\n            cursor: pointer;\n            background-color: $dropdown-link-hover-bg;\n          }\n          &--selected {\n            background-color: $datepicker__selected-color;\n            color: $white;\n            font-weight: bold;\n            &:hover {\n              background-color: $datepicker__selected-color;\n            }\n          }\n          &--disabled {\n            color: $datepicker__muted-color;\n\n            &:hover {\n              cursor: default;\n              background-color: transparent;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.react-datepicker__week-number {\n  color: $datepicker__muted-color;\n  display: inline-block;\n  width: $datepicker__item-size;\n  line-height: $datepicker__item-size;\n  text-align: center;\n  margin: $datepicker__day-margin;\n  &.react-datepicker__week-number--clickable {\n    cursor: pointer;\n    &:hover {\n      border-radius: $datepicker__border-radius;\n      background-color: $datepicker__background-color;\n    }\n  }\n}\n\n.react-datepicker__day-names {\n  background: $gray-100;\n  border-top: $gray-300 solid 1px;\n  margin-top: 10px;\n}\n\n.react-datepicker__day-names,\n.react-datepicker__week {\n  white-space: nowrap;\n}\n\n.react-datepicker__day-name,\n.react-datepicker__day,\n.react-datepicker__time-name {\n  color: $datepicker__text-color;\n  display: inline-block;\n  width: $datepicker__item-size;\n  line-height: $datepicker__item-size;\n  text-align: center;\n  margin: $datepicker__day-margin;\n}\n\n.react-datepicker__day {\n  cursor: pointer;\n  @include border-radius($datepicker__border-radius);\n\n  &:hover {\n    background-color: $primary;\n    color: $white;\n  }\n\n  &--today {\n    font-weight: bold;\n  }\n\n  &--highlighted {\n    border-radius: $datepicker__border-radius;\n    background-color: $datepicker__highlighted-color;\n    color: $white;\n\n    &:hover {\n      background-color: darken($datepicker__highlighted-color, 5%);\n    }\n\n    &-custom-1 {\n      color: $warning;\n    }\n\n    &-custom-2 {\n      color: $focus;\n    }\n  }\n\n  &--selected {\n    background-color: $success;\n    color: $white;\n\n    &:hover {\n      background-color: $success;\n      color: $white;\n    }\n  }\n\n  &--in-selecting-range,\n  &--in-range {\n    background-color: $dropdown-link-hover-bg;\n    color: $dropdown-link-hover-color;\n\n    &:hover {\n      background-color: $dropdown-link-hover-bg;\n      color: $dropdown-link-hover-color;\n    }\n\n  }\n\n  &--keyboard-selected {\n    border-radius: $datepicker__border-radius;\n    background-color: lighten($success, 10%);\n    color: $white;\n\n    &:hover {\n      background-color: darken($success, 5%);\n    }\n  }\n\n  &--in-selecting-range:not(&--in-range) {\n    background-color: $dropdown-link-hover-bg;\n  }\n\n  &--in-range:not(&--in-selecting-range) {\n    .react-datepicker__month--selecting-range & {\n      background-color: $success;\n      color: $white;\n    }\n  }\n\n  &--disabled {\n    cursor: default;\n    color: $datepicker__muted-color;\n\n    &:hover {\n      background-color: transparent;\n      color: $datepicker__muted-color;\n    }\n  }\n}\n\n\n.react-datepicker__day--selecting-range-start,\n.react-datepicker__day--selecting-range-end {\n  background-color: $success  !important;\n  color: $white !important;\n}\n\n.react-datepicker__year-read-view,\n.react-datepicker__month-read-view,\n.react-datepicker__month-year-read-view {\n  border: 1px solid transparent;\n  border-radius: $datepicker__border-radius;\n\n  &:hover {\n    cursor: pointer;\n\n    .react-datepicker__year-read-view--down-arrow,\n    .react-datepicker__month-read-view--down-arrow {\n      border-top-color: darken($datepicker__muted-color, 10%);\n    }\n  }\n\n  &--down-arrow {\n    @extend %triangle-arrow-down;\n    border-top-color: $datepicker__muted-color;\n    float: right;\n    margin-left: 20px;\n    top: 8px;\n    position: relative;\n    border-width: $datepicker__navigation-size;\n  }\n}\n\n.react-datepicker__year-dropdown,\n.react-datepicker__month-dropdown,\n.react-datepicker__month-year-dropdown {\n  background-color: $datepicker__background-color;\n  position: absolute;\n  width: 50%;\n  left: 25%;\n  top: 30px;\n  z-index: 1;\n  text-align: center;\n  border-radius: $datepicker__border-radius;\n  border: 1px solid $datepicker__border-color;\n\n  &:hover {\n    cursor: pointer;\n  }\n\n  &--scrollable {\n    height: 150px;\n    overflow-y: scroll;\n  }\n}\n\n.react-datepicker__year-option,\n.react-datepicker__month-option,\n.react-datepicker__month-year-option {\n  line-height: 20px;\n  width: 100%;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n\n  &:first-of-type {\n    border-top-left-radius: $datepicker__border-radius;\n    border-top-right-radius: $datepicker__border-radius;\n  }\n\n  &:last-of-type {\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    border-bottom-left-radius: $datepicker__border-radius;\n    border-bottom-right-radius: $datepicker__border-radius;\n  }\n\n  &:hover {\n    background-color: $datepicker__muted-color;\n\n    .react-datepicker__navigation--years-upcoming {\n      border-bottom-color: darken($datepicker__muted-color, 10%);\n    }\n\n    .react-datepicker__navigation--years-previous {\n      border-top-color: darken($datepicker__muted-color, 10%);\n    }\n  }\n\n  &--selected {\n    position: absolute;\n    left: 15px;\n  }\n}\n\n.react-datepicker__close-icon {\n  background-color: transparent;\n  border: 0;\n  cursor: pointer;\n  outline: 0;\n  padding: 0;\n  vertical-align: middle;\n  position: absolute;\n  height: 16px;\n  width: 16px;\n  top: 25%;\n  right: 7px;\n\n  &::after {\n    background-color: $datepicker__selected-color;\n    border-radius: 50%;\n    bottom: 0;\n    box-sizing: border-box;\n    color: $white;\n    content: \"\\00d7\";\n    cursor: pointer;\n    font-size: 12px;\n    height: 16px;\n    width: 16px;\n    line-height: 1;\n    margin: -8px auto 0;\n    padding: 2px;\n    position: absolute;\n    right: 0px;\n    text-align: center;\n  }\n}\n\n.react-datepicker__today-button {\n  background: $datepicker__background-color;\n  border-top: 1px solid $datepicker__border-color;\n  cursor: pointer;\n  text-align: center;\n  font-weight: bold;\n  padding: 5px 0;\n  clear: left;\n}\n\n.react-datepicker__portal {\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  z-index: $zindex-modal-backdrop;\n  background-color: rgba($modal-backdrop-bg, $modal-backdrop-opacity);\n  left: 0;\n  top: 0;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n\n  .react-datepicker__day-name,\n  .react-datepicker__day,\n  .react-datepicker__time-name {\n    width: 3rem;\n    line-height: 3rem;\n  }\n\n  // Resize for small screens\n  @media (max-width: 400px), (max-height: 550px) {\n    .react-datepicker__day-name,\n    .react-datepicker__day,\n    .react-datepicker__time-name {\n      width: 2rem;\n      line-height: 2rem;\n    }\n  }\n\n  .react-datepicker__current-month,\n  .react-datepicker-time__header {\n    font-size: $datepicker__font-size * 1.8;\n  }\n\n  .react-datepicker__navigation {\n    border: 1.8 * $datepicker__navigation-size solid transparent;\n    margin-top: 3px;\n  }\n\n  .react-datepicker__navigation--previous {\n    border-right-color: $primary;\n\n    &:hover {\n      border-right-color: darken($primary, 10%);\n    }\n\n    &--disabled,\n    &--disabled:hover {\n      border-right-color: $datepicker__navigation-disabled-color;\n      cursor: default;\n    }\n  }\n\n  .react-datepicker__navigation--next {\n    border-left-color: $primary;\n\n    &:hover {\n      border-left-color: darken($primary, 10%);\n    }\n\n    &--disabled,\n    &--disabled:hover {\n      border-left-color: $datepicker__navigation-disabled-color;\n      cursor: default;\n    }\n  }\n}\n\n.rangeButtonSelectedStyle {\n  background: $primary !important;\n}\n\n.rangebuttonstyle {\n  outline: none !important;\n  color: $primary !important;\n}",".rc-slider-tooltip {\n  z-index: 555;\n}\n\n.rc-tooltip.rc-tooltip-zoom-enter,\n.rc-tooltip.rc-tooltip-zoom-leave {\n  display: block;\n}\n\n.rc-tooltip-zoom-enter,\n.rc-tooltip-zoom-appear {\n  opacity: 0;\n  animation-duration: 0.3s;\n  animation-fill-mode: both;\n  animation-timing-function: cubic-bezier(0.18, 0.89, 0.32, 1.28);\n  animation-play-state: paused;\n}\n\n.rc-tooltip-zoom-leave {\n  animation-duration: 0.3s;\n  animation-fill-mode: both;\n  animation-timing-function: cubic-bezier(0.6, -0.3, 0.74, 0.05);\n  animation-play-state: paused;\n}\n\n.rc-tooltip-zoom-enter.rc-tooltip-zoom-enter-active,\n.rc-tooltip-zoom-appear.rc-tooltip-zoom-appear-active {\n  animation-name: rcToolTipZoomIn;\n  animation-play-state: running;\n}\n\n.rc-tooltip-zoom-leave.rc-tooltip-zoom-leave-active {\n  animation-name: rcToolTipZoomOut;\n  animation-play-state: running;\n}\n\n@keyframes rcToolTipZoomIn {\n  0% {\n    opacity: 0;\n    transform-origin: 50% 50%;\n    transform: scale(0, 0);\n  }\n  100% {\n    opacity: 1;\n    transform-origin: 50% 50%;\n    transform: scale(1, 1);\n  }\n}\n\n@keyframes rcToolTipZoomOut {\n  0% {\n    opacity: 1;\n    transform-origin: 50% 50%;\n    transform: scale(1, 1);\n  }\n  100% {\n    opacity: 0;\n    transform-origin: 50% 50%;\n    transform: scale(0, 0);\n  }\n}\n\n.rc-tooltip {\n  position: absolute;\n  z-index: 1070;\n  display: block;\n  visibility: visible;\n  font-size: 12px;\n  line-height: 1.5;\n  opacity: 0.9;\n}\n\n.rc-tooltip-hidden {\n  display: none;\n}\n\n.rc-tooltip-placement-top,\n.rc-tooltip-placement-topLeft,\n.rc-tooltip-placement-topRight {\n  padding: 5px 0 9px 0;\n}\n\n.rc-tooltip-placement-right,\n.rc-tooltip-placement-rightTop,\n.rc-tooltip-placement-rightBottom {\n  padding: 0 5px 0 9px;\n}\n\n.rc-tooltip-placement-bottom,\n.rc-tooltip-placement-bottomLeft,\n.rc-tooltip-placement-bottomRight {\n  padding: 9px 0 5px 0;\n}\n\n.rc-tooltip-placement-left,\n.rc-tooltip-placement-leftTop,\n.rc-tooltip-placement-leftBottom {\n  padding: 0 9px 0 5px;\n}\n\n.rc-tooltip-inner {\n  padding: 12px 14px;\n  color: $white;\n  text-align: left;\n  text-decoration: none;\n  background-color: $gray-800;\n  border-radius: 6px;\n  box-shadow: 0 0 4px rgba(0, 0, 0, 0.17);\n  min-height: 34px;\n  font-weight: bold;\n}\n\n.rc-tooltip-arrow {\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-color: transparent;\n  border-style: solid;\n}\n\n.rc-tooltip-placement-top .rc-tooltip-arrow,\n.rc-tooltip-placement-topLeft .rc-tooltip-arrow,\n.rc-tooltip-placement-topRight .rc-tooltip-arrow {\n  bottom: 4px;\n  margin-left: -5px;\n  border-width: 5px 5px 0;\n  border-top-color: $gray-800;\n}\n\n.rc-tooltip-placement-top .rc-tooltip-arrow {\n  left: 50%;\n}\n\n.rc-tooltip-placement-topLeft .rc-tooltip-arrow {\n  left: 15%;\n}\n\n.rc-tooltip-placement-topRight .rc-tooltip-arrow {\n  right: 15%;\n}\n\n.rc-tooltip-placement-right .rc-tooltip-arrow,\n.rc-tooltip-placement-rightTop .rc-tooltip-arrow,\n.rc-tooltip-placement-rightBottom .rc-tooltip-arrow {\n  left: 4px;\n  margin-top: -5px;\n  border-width: 5px 5px 5px 0;\n  border-right-color: $gray-800;\n}\n\n.rc-tooltip-placement-right .rc-tooltip-arrow {\n  top: 50%;\n}\n\n.rc-tooltip-placement-rightTop .rc-tooltip-arrow {\n  top: 15%;\n  margin-top: 0;\n}\n\n.rc-tooltip-placement-rightBottom .rc-tooltip-arrow {\n  bottom: 15%;\n}\n\n.rc-tooltip-placement-left .rc-tooltip-arrow,\n.rc-tooltip-placement-leftTop .rc-tooltip-arrow,\n.rc-tooltip-placement-leftBottom .rc-tooltip-arrow {\n  right: 4px;\n  margin-top: -5px;\n  border-width: 5px 0 5px 5px;\n  border-left-color: $gray-800;\n}\n\n.rc-tooltip-placement-left .rc-tooltip-arrow {\n  top: 50%;\n}\n\n.rc-tooltip-placement-leftTop .rc-tooltip-arrow {\n  top: 15%;\n  margin-top: 0;\n}\n\n.rc-tooltip-placement-leftBottom .rc-tooltip-arrow {\n  bottom: 15%;\n}\n\n.rc-tooltip-placement-bottom .rc-tooltip-arrow,\n.rc-tooltip-placement-bottomLeft .rc-tooltip-arrow,\n.rc-tooltip-placement-bottomRight .rc-tooltip-arrow {\n  top: 4px;\n  margin-left: -5px;\n  border-width: 0 5px 5px;\n  border-bottom-color: $gray-800;\n}\n\n.rc-tooltip-placement-bottom .rc-tooltip-arrow {\n  left: 50%;\n}\n\n.rc-tooltip-placement-bottomLeft .rc-tooltip-arrow {\n  left: 15%;\n}\n\n.rc-tooltip-placement-bottomRight .rc-tooltip-arrow {\n  right: 15%;\n}\n","@import 'tooltip';\n\n.rc-slider {\n  position: relative;\n  height: 20px;\n  padding: 8px 0 0;\n  width: 100%;\n  @include border-radius($border-radius);\n  -ms-touch-action: none;\n  touch-action: none;\n  box-sizing: border-box;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.rc-slider-rail {\n  position: absolute;\n  width: 100%;\n  background-color: $gray-200;\n  height: 4px;\n  @include border-radius($border-radius);\n}\n\n.rc-slider-track {\n  position: absolute;\n  left: 0;\n  height: 4px;\n  @include border-radius($border-radius);\n  background-color: $primary;\n}\n\n.rc-slider-handle {\n  position: absolute;\n  margin-left: -8px;\n  margin-top: -6px;\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n  cursor: -webkit-grab;\n  cursor: grab;\n  border-radius: 50%;\n  border: solid 2px $primary;\n  background-color: $white;\n  -ms-touch-action: pan-x;\n  touch-action: pan-x;\n  transition: box-shadow 200ms;\n\n  &:focus {\n    outline: none;\n  }\n\n  &:focus,\n  &:active,\n  &:hover {\n    border-color: darken($primary, 15%);\n    box-shadow: 0 0.46875rem 2.1875rem rgba($primary, .8),\n    0 0.125rem 0.5875rem rgba($primary, .9);\n  }\n\n  &:active {\n    cursor: -webkit-grabbing;\n    cursor: grabbing;\n  }\n}\n\n.rc-slider-mark {\n  position: absolute;\n  top: 18px;\n  left: 0;\n  width: 100%;\n  font-size: 12px;\n}\n\n.rc-slider-mark-text {\n  position: absolute;\n  display: inline-block;\n  vertical-align: middle;\n  text-align: center;\n  cursor: pointer;\n  color: $gray-600;\n}\n\n.rc-slider-mark-text-active {\n  color: $gray-800;\n}\n\n.rc-slider-step {\n  position: absolute;\n  width: 100%;\n  height: 4px;\n  background: transparent;\n}\n\n.rc-slider-dot {\n  position: absolute;\n  bottom: -2px;\n  margin-left: -4px;\n  width: 8px;\n  height: 8px;\n  border: 2px solid $gray-300;\n  background-color: $white;\n  cursor: pointer;\n  border-radius: 50%;\n  vertical-align: middle;\n}\n\n.rc-slider-dot-active {\n  border-color: $primary;\n}\n\n.rc-slider-disabled {\n  background-color: $gray-200;\n}\n\n.rc-slider-disabled .rc-slider-track {\n  background-color: $gray-400;\n}\n\n.rc-slider-disabled .rc-slider-handle,\n.rc-slider-disabled .rc-slider-dot {\n  border-color: $gray-400;\n  box-shadow: none;\n  background-color: $white;\n  cursor: not-allowed;\n}\n\n.rc-slider-disabled .rc-slider-mark-text,\n.rc-slider-disabled .rc-slider-dot {\n  cursor: not-allowed !important;\n}\n\n.rc-slider-vertical {\n  width: 14px;\n  height: 100%;\n  padding: 0 5px;\n}\n\n.rc-slider-vertical .rc-slider-rail {\n  height: 100%;\n  width: 4px;\n}\n\n.rc-slider-vertical .rc-slider-track {\n  left: 5px;\n  bottom: 0;\n  width: 4px;\n}\n\n.rc-slider-vertical .rc-slider-handle {\n  margin-left: -6px;\n  margin-bottom: -7px;\n  -ms-touch-action: pan-y;\n  touch-action: pan-y;\n}\n\n.rc-slider-vertical .rc-slider-mark {\n  top: 0;\n  left: 18px;\n  height: 100%;\n}\n\n.rc-slider-vertical .rc-slider-step {\n  height: 100%;\n  width: 4px;\n}\n\n.rc-slider-vertical .rc-slider-dot {\n  left: 2px;\n  margin-bottom: -4px;\n}\n\n.rc-slider-vertical .rc-slider-dot:first-child {\n  margin-bottom: -4px;\n}\n\n.rc-slider-vertical .rc-slider-dot:last-child {\n  margin-bottom: -4px;\n}\n\n.rc-slider-tooltip-zoom-down-enter,\n.rc-slider-tooltip-zoom-down-appear {\n  animation-duration: .3s;\n  animation-fill-mode: both;\n  display: block !important;\n  animation-play-state: paused;\n}\n\n.rc-slider-tooltip-zoom-down-leave {\n  animation-duration: .3s;\n  animation-fill-mode: both;\n  display: block !important;\n  animation-play-state: paused;\n}\n\n.rc-slider-tooltip-zoom-down-enter.rc-slider-tooltip-zoom-down-enter-active,\n.rc-slider-tooltip-zoom-down-appear.rc-slider-tooltip-zoom-down-appear-active {\n  animation-name: rcSliderTooltipZoomDownIn;\n  animation-play-state: running;\n}\n\n.rc-slider-tooltip-zoom-down-leave.rc-slider-tooltip-zoom-down-leave-active {\n  animation-name: rcSliderTooltipZoomDownOut;\n  animation-play-state: running;\n}\n\n.rc-slider-tooltip-zoom-down-enter,\n.rc-slider-tooltip-zoom-down-appear {\n  transform: scale(0, 0);\n  animation-timing-function: cubic-bezier(0.23, 1, 0.32, 1);\n}\n\n.rc-slider-tooltip-zoom-down-leave {\n  animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\n}\n\n@keyframes rcSliderTooltipZoomDownIn {\n  0% {\n    opacity: 0;\n    transform-origin: 50% 100%;\n    transform: scale(0, 0);\n  }\n  100% {\n    transform-origin: 50% 100%;\n    transform: scale(1, 1);\n  }\n}\n\n@keyframes rcSliderTooltipZoomDownOut {\n  0% {\n    transform-origin: 50% 100%;\n    transform: scale(1, 1);\n  }\n  100% {\n    opacity: 0;\n    transform-origin: 50% 100%;\n    transform: scale(0, 0);\n  }\n}\n\n.rc-slider-tooltip {\n  position: absolute;\n  left: -9999px;\n  top: -9999px;\n  visibility: visible;\n  box-sizing: border-box;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.rc-slider-tooltip-hidden {\n  display: none;\n}\n\n.rc-slider-tooltip-placement-top {\n  padding: 4px 0 8px 0;\n}\n\n.rc-slider-tooltip-inner {\n  padding: 0 8px;\n  min-width: 28px;\n  height: 28px;\n  line-height: 28px;\n  color: $white;\n  text-align: center;\n  text-decoration: none;\n  background-color: $gray-900;\n  @include border-radius($border-radius);\n  box-shadow: $box-shadow-default;\n  font-weight: bold;\n}\n\n.rc-slider-tooltip-arrow {\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-color: transparent;\n  border-style: solid;\n}\n\n.rc-slider-tooltip-placement-top .rc-slider-tooltip-arrow {\n  bottom: 4px;\n  left: 50%;\n  margin-left: -4px;\n  border-width: 4px 4px 0;\n  border-top-color: $gray-900;\n}\n\n// Colors\n\n@each $color, $value in $theme-colors {\n  .rc-slider-#{$color} {\n    .rc-slider-track {\n      background-color: $value;\n    }\n\n    .rc-slider-handle {\n      border-color: $value;\n      background-color: $white;\n\n      &:focus,\n      &:active,\n      &:hover {\n        border-color: darken($value, 15%);\n        box-shadow: 0 0.46875rem 2.1875rem rgba($value, .8),\n        0 0.125rem 0.5875rem rgba($value, .9);\n      }\n    }\n\n    .rc-slider-dot-active {\n      border-color: $value;\n    }\n  }\n}\n\n// Alternate Styles\n\n.rc-slider-line {\n  .rc-slider-handle {\n    @include border-radius(0);\n    border-width: 0 3px 0 0;\n    margin-left: -8px;\n    width: 10px;\n    background-color: transparent;\n    box-shadow: 0 0 0 transparent !important;\n  }\n}\n\n.rc-slider-square {\n  .rc-slider-handle {\n    @include border-radius(3px);\n    border-widtH: 1px;\n\n    &:before {\n      position: absolute;\n      height: 8px;\n      width: 4px;\n      border: $gray-500 solid 1px;\n      border-width: 0 1px;\n      display: block;\n      content: '';\n      top: 50%;\n      left: 50%;\n      margin: -4px -2px;\n    }\n  }\n}\n\n// Sizing\n\n.rc-slider-lg {\n  &.rc-slider {\n    height: 20px;\n    padding: 8px 0 0;\n  }\n\n  .rc-slider-rail {\n    height: 4px;\n  }\n\n  .rc-slider-track {\n    height: 4px;\n  }\n\n  .rc-slider-handle {\n    margin-left: -10px;\n    margin-top: -8px;\n    width: 20px;\n    height: 20px;\n  }\n\n  &.rc-slider-line {\n    .rc-slider-handle {\n      margin-left: -8px;\n      width: 10px;\n    }\n  }\n\n  &.rc-slider-square {\n    .rc-slider-handle {\n      &:before {\n        height: 10px;\n        width: 6px;\n        margin: -5px -3px;\n      }\n    }\n  }\n\n}\n\n.rc-slider-sm {\n  &.rc-slider {\n    height: 20px;\n    padding: 8px 0 0;\n  }\n\n  .rc-slider-rail {\n    height: 4px;\n  }\n\n  .rc-slider-track {\n    height: 4px;\n  }\n\n  .rc-slider-handle {\n    margin-left: -6px;\n    margin-top: -4px;\n    width: 12px;\n    height: 12px;\n  }\n\n  &.rc-slider-line {\n    .rc-slider-handle {\n      margin-left: -8px;\n      width: 10px;\n    }\n  }\n\n  &.rc-slider-square {\n    .rc-slider-handle {\n      &:before {\n        height: 6px;\n        margin: -3px 0 0 -1px;\n        border: 0;\n        width: 2px;\n        background: $gray-500;\n      }\n    }\n  }\n}\n\n",".rdw-option-wrapper {\n  border: 1px solid #F1F1F1;\n  padding: 5px;\n  min-width: 25px;\n  height: 20px;\n  border-radius: 2px;\n  margin: 0 4px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  background: white;\n  text-transform: capitalize;\n}\n.rdw-option-wrapper:hover {\n  box-shadow: 1px 1px 0px #BFBDBD;\n}\n.rdw-option-wrapper:active {\n  box-shadow: 1px 1px 0px #BFBDBD inset;\n}\n.rdw-option-active {\n  box-shadow: 1px 1px 0px #BFBDBD inset;\n}\n.rdw-option-disabled {\n  opacity: 0.3;\n  cursor: default;\n}\n.rdw-dropdown-wrapper {\n  height: 30px;\n  background: white;\n  cursor: pointer;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  margin: 0 3px;\n  text-transform: capitalize;\n  background: white;\n}\n.rdw-dropdown-wrapper:focus {\n  outline: none;\n}\n.rdw-dropdown-wrapper:hover {\n  box-shadow: 1px 1px 0px #BFBDBD;\n  background-color: #FFFFFF;\n}\n.rdw-dropdown-wrapper:active {\n  box-shadow: 1px 1px 0px #BFBDBD inset;\n}\n.rdw-dropdown-carettoopen {\n  height: 0px;\n  width: 0px;\n  position: absolute;\n  top: 35%;\n  right: 10%;\n  border-top: 6px solid black;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n}\n.rdw-dropdown-carettoclose {\n  height: 0px;\n  width: 0px;\n  position: absolute;\n  top: 35%;\n  right: 10%;\n  border-bottom: 6px solid black;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n}\n.rdw-dropdown-selectedtext {\n  display: flex;\n  position: relative;\n  height: 100%;\n  align-items: center;\n  padding: 0 5px;\n}\n.rdw-dropdown-optionwrapper {\n  z-index: 100;\n  position: relative;\n  border: 1px solid #F1F1F1;\n  width: 98%;\n  background: white;\n  border-radius: 2px;\n  margin: 0;\n  padding: 0;\n  max-height: 250px;\n  overflow-y: scroll;\n}\n.rdw-dropdown-optionwrapper:hover {\n  box-shadow: 1px 1px 0px #BFBDBD;\n  background-color: #FFFFFF;\n}\n.rdw-dropdownoption-default {\n  min-height: 25px;\n  display: flex;\n  align-items: center;\n  padding: 0 5px;\n}\n.rdw-dropdownoption-highlighted {\n  background: #F1F1F1;\n}\n.rdw-dropdownoption-active {\n  background: #f5f5f5;\n}\n.rdw-dropdownoption-disabled {\n  opacity: 0.3;\n  cursor: default;\n}\n.rdw-inline-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n}\n.rdw-inline-dropdown {\n  width: 50px;\n}\n.rdw-inline-dropdownoption {\n  height: 40px;\n  display: flex;\n  justify-content: center;\n}\n.rdw-block-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n}\n.rdw-block-dropdown {\n  width: 110px;\n}\n.rdw-fontsize-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n}\n.rdw-fontsize-dropdown {\n  min-width: 40px;\n}\n.rdw-fontsize-option {\n  display: flex;\n  justify-content: center;\n}\n.rdw-fontfamily-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n}\n.rdw-fontfamily-dropdown {\n  width: 115px;\n}\n.rdw-fontfamily-placeholder {\n  white-space: nowrap;\n  max-width: 90px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.rdw-fontfamily-optionwrapper {\n  width: 140px;\n}\n.rdw-list-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n}\n.rdw-list-dropdown {\n  width: 50px;\n  z-index: 90;\n}\n.rdw-list-dropdownOption {\n  height: 40px;\n  display: flex;\n  justify-content: center;\n}\n.rdw-text-align-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n}\n.rdw-text-align-dropdown {\n  width: 50px;\n  z-index: 90;\n}\n.rdw-text-align-dropdownOption {\n  height: 40px;\n  display: flex;\n  justify-content: center;\n}\n.rdw-right-aligned-block {\n  text-align: right;\n}\n.rdw-left-aligned-block {\n  text-align: left !important;\n}\n.rdw-center-aligned-block {\n  text-align: center !important;\n}\n.rdw-justify-aligned-block {\n  text-align: justify !important;\n}\n.rdw-right-aligned-block > div {\n  display: inline-block;\n}\n.rdw-left-aligned-block > div {\n  display: inline-block;\n}\n.rdw-center-aligned-block > div {\n  display: inline-block;\n}\n.rdw-justify-aligned-block > div {\n  display: inline-block;\n}\n.rdw-colorpicker-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n  position: relative;\n}\n.rdw-colorpicker-modal {\n  position: absolute;\n  top: 35px;\n  left: 5px;\n  display: flex;\n  flex-direction: column;\n  width: 175px;\n  height: 175px;\n  border: 1px solid #F1F1F1;\n  padding: 15px;\n  border-radius: 2px;\n  z-index: 100;\n  background: white;\n  box-shadow: 3px 3px 5px #BFBDBD;\n}\n.rdw-colorpicker-modal-header {\n  display: flex;\n  padding-bottom: 5px;\n}\n.rdw-colorpicker-modal-style-label {\n  font-size: 15px;\n  width: 50%;\n  text-align: center;\n  cursor: pointer;\n  padding: 0 10px 5px;\n}\n.rdw-colorpicker-modal-style-label-active {\n  border-bottom: 2px solid #0a66b7;\n}\n.rdw-colorpicker-modal-options {\n  margin: 5px auto;\n  display: flex;\n  width: 100%;\n  height: 100%;\n  flex-wrap: wrap;\n  overflow: scroll;\n}\n.rdw-colorpicker-cube {\n  width: 22px;\n  height: 22px;\n  border: 1px solid #F1F1F1;\n}\n.rdw-colorpicker-option {\n  margin: 3px;\n  padding: 0;\n  min-height: 20px;\n  border: none;\n  width: 22px;\n  height: 22px;\n  min-width: 22px;\n  box-shadow: 1px 2px 1px #BFBDBD inset;\n}\n.rdw-colorpicker-option:hover {\n  box-shadow: 1px 2px 1px #BFBDBD;\n}\n.rdw-colorpicker-option:active {\n  box-shadow: -1px -2px 1px #BFBDBD;\n}\n.rdw-colorpicker-option-active {\n  box-shadow: 0px 0px 2px 2px #BFBDBD;\n}\n.rdw-link-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n  position: relative;\n}\n.rdw-link-dropdown {\n  width: 50px;\n}\n.rdw-link-dropdownOption {\n  height: 40px;\n  display: flex;\n  justify-content: center;\n}\n.rdw-link-dropdownPlaceholder {\n  margin-left: 8px;\n}\n.rdw-link-modal {\n  position: absolute;\n  top: 35px;\n  left: 5px;\n  display: flex;\n  flex-direction: column;\n  width: 235px;\n  height: 205px;\n  border: 1px solid #F1F1F1;\n  padding: 15px;\n  border-radius: 2px;\n  z-index: 100;\n  background: white;\n  box-shadow: 3px 3px 5px #BFBDBD;\n}\n.rdw-link-modal-label {\n  font-size: 15px;\n}\n.rdw-link-modal-input {\n  margin-top: 5px;\n  border-radius: 2px;\n  border: 1px solid #F1F1F1;\n  height: 25px;\n  margin-bottom: 15px;\n  padding: 0 5px;\n}\n.rdw-link-modal-input:focus {\n  outline: none;\n}\n.rdw-link-modal-buttonsection {\n  margin: 0 auto;\n}\n.rdw-link-modal-target-option {\n  margin-bottom: 20px;\n}\n.rdw-link-modal-target-option > span {\n  margin-left: 5px;\n}\n.rdw-link-modal-btn {\n  margin-left: 10px;\n  width: 75px;\n  height: 30px;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  cursor: pointer;\n  background: white;\n  text-transform: capitalize;\n}\n.rdw-link-modal-btn:hover {\n  box-shadow: 1px 1px 0px #BFBDBD;\n}\n.rdw-link-modal-btn:active {\n  box-shadow: 1px 1px 0px #BFBDBD inset;\n}\n.rdw-link-modal-btn:focus {\n  outline: none !important;\n}\n.rdw-link-modal-btn:disabled {\n  background: #ece9e9;\n}\n.rdw-link-dropdownoption {\n  height: 40px;\n  display: flex;\n  justify-content: center;\n}\n.rdw-history-dropdown {\n  width: 50px;\n}\n.rdw-embedded-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n  position: relative;\n}\n.rdw-embedded-modal {\n  position: absolute;\n  top: 35px;\n  left: 5px;\n  display: flex;\n  flex-direction: column;\n  width: 235px;\n  height: 180px;\n  border: 1px solid #F1F1F1;\n  padding: 15px;\n  border-radius: 2px;\n  z-index: 100;\n  background: white;\n  justify-content: space-between;\n  box-shadow: 3px 3px 5px #BFBDBD;\n}\n.rdw-embedded-modal-header {\n  font-size: 15px;\n  display: flex;\n}\n.rdw-embedded-modal-header-option {\n  width: 50%;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n.rdw-embedded-modal-header-label {\n  width: 95px;\n  border: 1px solid #f1f1f1;\n  margin-top: 5px;\n  background: #6EB8D4;\n  border-bottom: 2px solid #0a66b7;\n}\n.rdw-embedded-modal-link-section {\n  display: flex;\n  flex-direction: column;\n}\n.rdw-embedded-modal-link-input {\n  width: 88%;\n  height: 35px;\n  margin: 10px 0;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  font-size: 15px;\n  padding: 0 5px;\n}\n.rdw-embedded-modal-link-input-wrapper {\n  display: flex;\n  align-items: center;\n}\n.rdw-embedded-modal-link-input:focus {\n  outline: none;\n}\n.rdw-embedded-modal-btn-section {\n  display: flex;\n  justify-content: center;\n}\n.rdw-embedded-modal-btn {\n  margin: 0 3px;\n  width: 75px;\n  height: 30px;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  cursor: pointer;\n  background: white;\n  text-transform: capitalize;\n}\n.rdw-embedded-modal-btn:hover {\n  box-shadow: 1px 1px 0px #BFBDBD;\n}\n.rdw-embedded-modal-btn:active {\n  box-shadow: 1px 1px 0px #BFBDBD inset;\n}\n.rdw-embedded-modal-btn:focus {\n  outline: none !important;\n}\n.rdw-embedded-modal-btn:disabled {\n  background: #ece9e9;\n}\n.rdw-embedded-modal-size {\n  align-items: center;\n  display: flex;\n  margin: 8px 0;\n  justify-content: space-between;\n}\n.rdw-embedded-modal-size-input {\n  width: 80%;\n  height: 20px;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  font-size: 12px;\n}\n.rdw-embedded-modal-size-input:focus {\n  outline: none;\n}\n.rdw-emoji-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n  position: relative;\n}\n.rdw-emoji-modal {\n  overflow: auto;\n  position: absolute;\n  top: 35px;\n  left: 5px;\n  display: flex;\n  flex-wrap: wrap;\n  width: 235px;\n  height: 180px;\n  border: 1px solid #F1F1F1;\n  padding: 15px;\n  border-radius: 2px;\n  z-index: 100;\n  background: white;\n  box-shadow: 3px 3px 5px #BFBDBD;\n}\n.rdw-emoji-icon {\n  margin: 2.5px;\n  height: 24px;\n  width: 24px;\n  cursor: pointer;\n  font-size: 22px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.rdw-spinner {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  width: 100%;\n}\n.rdw-spinner > div {\n  width: 12px;\n  height: 12px;\n  background-color: #333;\n\n  border-radius: 100%;\n  display: inline-block;\n  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n  animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n}\n.rdw-spinner .rdw-bounce1 {\n  -webkit-animation-delay: -0.32s;\n  animation-delay: -0.32s;\n}\n.rdw-spinner .rdw-bounce2 {\n  -webkit-animation-delay: -0.16s;\n  animation-delay: -0.16s;\n}\n@-webkit-keyframes sk-bouncedelay {\n  0%, 80%, 100% { -webkit-transform: scale(0) }\n  40% { -webkit-transform: scale(1.0) }\n}\n@keyframes sk-bouncedelay {\n  0%, 80%, 100% {\n    -webkit-transform: scale(0);\n    transform: scale(0);\n  } 40% {\n    -webkit-transform: scale(1.0);\n    transform: scale(1.0);\n  }\n}\n.rdw-image-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n  position: relative;\n}\n.rdw-image-modal {\n  position: absolute;\n  top: 35px;\n  left: 5px;\n  display: flex;\n  flex-direction: column;\n  width: 235px;\n  border: 1px solid #F1F1F1;\n  padding: 15px;\n  border-radius: 2px;\n  z-index: 100;\n  background: white;\n  box-shadow: 3px 3px 5px #BFBDBD;\n}\n.rdw-image-modal-header {\n  font-size: 15px;\n  margin: 10px 0;\n  display: flex;\n}\n.rdw-image-modal-header-option {\n  width: 50%;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n.rdw-image-modal-header-label {\n  width: 80px;\n  background: #f1f1f1;\n  border: 1px solid #f1f1f1;\n  margin-top: 5px;\n}\n.rdw-image-modal-header-label-highlighted {\n  background: #6EB8D4;\n  border-bottom: 2px solid #0a66b7;\n}\n.rdw-image-modal-upload-option {\n  width: 100%;\n  color: gray;\n  cursor: pointer;\n  display: flex;\n  border: none;\n  font-size: 15px;\n  align-items: center;\n  justify-content: center;\n  background-color: #f1f1f1;\n  outline: 2px dashed gray;\n  outline-offset: -10px;\n  margin: 10px 0;\n  padding: 9px 0;\n}\n.rdw-image-modal-upload-option-highlighted {\n  outline: 2px dashed #0a66b7;\n}\n.rdw-image-modal-upload-option-label {\n  cursor: pointer;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 15px;\n}\n.rdw-image-modal-upload-option-label span{\n  padding: 0 20px;\n}\n.rdw-image-modal-upload-option-image-preview {\n  max-width: 100%;\n  max-height: 200px;\n}\n.rdw-image-modal-upload-option-input {\n\twidth: 0.1px;\n\theight: 0.1px;\n\topacity: 0;\n\toverflow: hidden;\n\tposition: absolute;\n\tz-index: -1;\n}\n.rdw-image-modal-url-section {\n  display: flex;\n  align-items: center;\n}\n.rdw-image-modal-url-input {\n  width: 90%;\n  height: 35px;\n  margin: 15px 0 12px;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  font-size: 15px;\n  padding: 0 5px;\n}\n.rdw-image-modal-btn-section {\n  margin: 10px auto 0;\n}\n.rdw-image-modal-url-input:focus {\n  outline: none;\n}\n.rdw-image-modal-btn {\n  margin: 0 5px;\n  width: 75px;\n  height: 30px;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  cursor: pointer;\n  background: white;\n  text-transform: capitalize;\n}\n.rdw-image-modal-btn:hover {\n  box-shadow: 1px 1px 0px #BFBDBD;\n}\n.rdw-image-modal-btn:active {\n  box-shadow: 1px 1px 0px #BFBDBD inset;\n}\n.rdw-image-modal-btn:focus {\n  outline: none !important;\n}\n.rdw-image-modal-btn:disabled {\n  background: #ece9e9;\n}\n.rdw-image-modal-spinner {\n  position: absolute;\n  top: -3px;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0.5;\n}\n.rdw-image-modal-alt-input {\n  width: 70%;\n  height: 20px;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  font-size: 12px;\n  margin-left: 5px;\n}\n.rdw-image-modal-alt-input:focus {\n  outline: none;\n}\n.rdw-image-modal-alt-lbl {\n  font-size: 12px;\n}\n.rdw-image-modal-size {\n  align-items: center;\n  display: flex;\n  margin: 8px 0;\n  justify-content: space-between;\n}\n.rdw-image-modal-size-input {\n  width: 40%;\n  height: 20px;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  font-size: 12px;\n}\n.rdw-image-modal-size-input:focus {\n  outline: none;\n}\n.rdw-image-mandatory-sign {\n  color: red;\n  margin-left: 3px;\n  margin-right: 3px;\n}\n.rdw-remove-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n  position: relative;\n}\n.rdw-history-wrapper {\n  display: flex;\n  align-items: center;\n  margin-bottom: 6px;\n}\n.rdw-history-dropdownoption {\n  height: 40px;\n  display: flex;\n  justify-content: center;\n}\n.rdw-history-dropdown {\n  width: 50px;\n}\n.rdw-link-decorator-wrapper {\n  position: relative;\n}\n.rdw-link-decorator-icon {\n  position: absolute;\n  left: 40%;\n  top: 0;\n  cursor: pointer;\n  background-color: white;\n}\n.rdw-mention-link {\n  text-decoration: none;\n  color: #1236ff;\n  background-color: #f0fbff;\n  padding: 1px 2px;\n  border-radius: 2px;\n}\n.rdw-suggestion-wrapper {\n  position: relative;\n}\n.rdw-suggestion-dropdown {\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #F1F1F1;\n  min-width: 100px;\n  max-height: 150px;\n  overflow: auto;\n  background: white;\n  z-index: 100;\n}\n.rdw-suggestion-option {\n  padding: 7px 5px;\n  border-bottom: 1px solid #f1f1f1;\n}\n.rdw-suggestion-option-active {\n  background-color: #F1F1F1;\n}\n.rdw-hashtag-link {\n  text-decoration: none;\n  color: #1236ff;\n  background-color: #f0fbff;\n  padding: 1px 2px;\n  border-radius: 2px;\n}\n.rdw-image-alignment-options-popup {\n  position: absolute;;\n  background: white;\n  display: flex;\n  padding: 5px 2px;\n  border-radius: 2px;\n  border: 1px solid #F1F1F1;\n  width: 105px;\n  cursor: pointer;\n  z-index: 100;\n}\n.rdw-alignment-option-left {\n  justify-content: flex-start;\n}\n.rdw-image-alignment-option {\n  height: 15px;\n  width: 15px;\n  min-width: 15px;\n}\n.rdw-image-alignment {\n  position: relative;\n}\n.rdw-image-imagewrapper {\n  position: relative;\n}\n.rdw-image-center {\n  display: flex;\n  justify-content: center;\n}\n.rdw-image-left {\n  display: flex;\n}\n.rdw-image-right {\n  display: flex;\n  justify-content: flex-end;\n}\n.rdw-image-alignment-options-popup-right {\n  right: 0;\n}\n.rdw-editor-main {\n  height: 100%;\n  overflow: auto;\n  box-sizing: border-box;\n}\n.rdw-editor-toolbar {\n  padding: 6px 5px 0;\n  border-radius: 2px;\n  border: 1px solid #F1F1F1;\n  display: flex;\n  justify-content: flex-start;\n  background: white;\n  flex-wrap: wrap;\n  font-size: 15px;\n  margin-bottom: 5px;\n  user-select: none;\n}\n.public-DraftStyleDefault-block {\n  margin: 1em 0;\n}\n.rdw-editor-wrapper:focus {\n  outline: none;\n}\n.rdw-editor-wrapper {\n  box-sizing: content-box;\n}\n.rdw-editor-main blockquote {\n  border-left: 5px solid #f1f1f1;\n  padding-left: 5px;\n}\n.rdw-editor-main pre {\n  background: #f1f1f1;\n  border-radius: 3px;\n  padding: 1px 10px;\n}/**\n * Draft v0.9.1\n *\n * Copyright (c) 2013-present, Facebook, Inc.\n * All rights reserved.\n *\n * This source code is licensed under the BSD-style license found in the\n * LICENSE file in the root directory of this source tree. An additional grant\n * of patent rights can be found in the PATENTS file in the same directory.\n */\n.DraftEditor-editorContainer,.DraftEditor-root,.public-DraftEditor-content{height:inherit;text-align:initial}.public-DraftEditor-content[contenteditable=true]{-webkit-user-modify:read-write-plaintext-only}.DraftEditor-root{position:relative}.DraftEditor-editorContainer{background-color:rgba(255,255,255,0);border-left:.1px solid transparent;position:relative;z-index:1}.public-DraftEditor-block{position:relative}.DraftEditor-alignLeft .public-DraftStyleDefault-block{text-align:left}.DraftEditor-alignLeft .public-DraftEditorPlaceholder-root{left:0;text-align:left}.DraftEditor-alignCenter .public-DraftStyleDefault-block{text-align:center}.DraftEditor-alignCenter .public-DraftEditorPlaceholder-root{margin:0 auto;text-align:center;width:100%}.DraftEditor-alignRight .public-DraftStyleDefault-block{text-align:right}.DraftEditor-alignRight .public-DraftEditorPlaceholder-root{right:0;text-align:right}.public-DraftEditorPlaceholder-root{color:#9197a3;position:absolute;z-index:0}.public-DraftEditorPlaceholder-hasFocus{color:#bdc1c9}.DraftEditorPlaceholder-hidden{display:none}.public-DraftStyleDefault-block{position:relative;white-space:pre-wrap}.public-DraftStyleDefault-ltr{direction:ltr;text-align:left}.public-DraftStyleDefault-rtl{direction:rtl;text-align:right}.public-DraftStyleDefault-listLTR{direction:ltr}.public-DraftStyleDefault-listRTL{direction:rtl}.public-DraftStyleDefault-ol,.public-DraftStyleDefault-ul{margin:16px 0;padding:0}.public-DraftStyleDefault-depth0.public-DraftStyleDefault-listLTR{margin-left:1.5em}.public-DraftStyleDefault-depth0.public-DraftStyleDefault-listRTL{margin-right:1.5em}.public-DraftStyleDefault-depth1.public-DraftStyleDefault-listLTR{margin-left:3em}.public-DraftStyleDefault-depth1.public-DraftStyleDefault-listRTL{margin-right:3em}.public-DraftStyleDefault-depth2.public-DraftStyleDefault-listLTR{margin-left:4.5em}.public-DraftStyleDefault-depth2.public-DraftStyleDefault-listRTL{margin-right:4.5em}.public-DraftStyleDefault-depth3.public-DraftStyleDefault-listLTR{margin-left:6em}.public-DraftStyleDefault-depth3.public-DraftStyleDefault-listRTL{margin-right:6em}.public-DraftStyleDefault-depth4.public-DraftStyleDefault-listLTR{margin-left:7.5em}.public-DraftStyleDefault-depth4.public-DraftStyleDefault-listRTL{margin-right:7.5em}.public-DraftStyleDefault-unorderedListItem{list-style-type:square;position:relative}.public-DraftStyleDefault-unorderedListItem.public-DraftStyleDefault-depth0{list-style-type:disc}.public-DraftStyleDefault-unorderedListItem.public-DraftStyleDefault-depth1{list-style-type:circle}.public-DraftStyleDefault-orderedListItem{list-style-type:none;position:relative}.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-listLTR:before{left:-36px;position:absolute;text-align:right;width:30px}.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-listRTL:before{position:absolute;right:-36px;text-align:left;width:30px}.public-DraftStyleDefault-orderedListItem:before{content:counter(ol0) \". \";counter-increment:ol0}.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth1:before{content:counter(ol1) \". \";counter-increment:ol1}.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth2:before{content:counter(ol2) \". \";counter-increment:ol2}.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth3:before{content:counter(ol3) \". \";counter-increment:ol3}.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth4:before{content:counter(ol4) \". \";counter-increment:ol4}.public-DraftStyleDefault-depth0.public-DraftStyleDefault-reset{counter-reset:ol0}.public-DraftStyleDefault-depth1.public-DraftStyleDefault-reset{counter-reset:ol1}.public-DraftStyleDefault-depth2.public-DraftStyleDefault-reset{counter-reset:ol2}.public-DraftStyleDefault-depth3.public-DraftStyleDefault-reset{counter-reset:ol3}.public-DraftStyleDefault-depth4.public-DraftStyleDefault-reset{counter-reset:ol4}\n\n.demo-editor {\n  height: 275px !important;\n  border: 1px solid #F1F1F1 !important;\n  padding: 5px !important;\n  border-radius: 2px !important;\n}","\n/// switch\n\n.has-switch {\n  border-radius: 30px;\n  cursor: pointer;\n  display: inline-block;\n  line-height: 1.72222;\n  overflow: hidden;\n  position: relative;\n  text-align: left;\n  width: 60px;\n  user-select: none;\n\n}\n.has-switch.deactivate {\n  opacity: 0.5;\n  filter: alpha(opacity=50);\n  cursor: default !important;\n}\n.has-switch.deactivate label,\n.has-switch.deactivate span {\n  cursor: default !important;\n}\n.has-switch > div {\n  position: relative;\n  top: 0;\n  width: 100px;\n}\n.has-switch > div.switch-animate {\n  transition: left 0.25s ease-out;\n}\n.has-switch > div.switch-off {\n  left: -35px;\n}\n\n.has-switch > div.switch-on {\n  left: 0;\n}\n\n@mixin icon-gradient ($top-color, $bottom-color){\n  background: $top-color;\n  background: linear-gradient(to bottom,  $top-color 0%,$bottom-color 100%);\n  background-size: 150% 150%;\n}\n\n.has-switch > div label {\n  background-color: #FFFFFF;\n  @include icon-gradient (rgba(255,255,255,1), rgba(241,241,242,1));\n\n  box-shadow: 0 1px 1px #FFFFFF inset, 0 1px 1px rgba(0, 0, 0, 0.25);\n  cursor: pointer;\n}\n.has-switch input[type=checkbox] {\n  display: none;\n}\n.has-switch span {\n  cursor: pointer;\n  float: left;\n  font-size: 11px;\n  font-weight: 400;\n  height: 24px;\n  line-height: 15px;\n  margin: 0;\n  padding-bottom: 6px;\n  padding-top: 5px;\n  position: relative;\n  text-align: center;\n  text-indent: -10px;\n  width: 50%;\n  z-index: 1;\n  transition: 0.25s ease-out;\n}\n.has-switch span.switch-left {\n  background-color: $primary;\n  border-left: 1px solid rgba(0, 0, 0, 0);\n  border-radius: 30px 0 0 30px;\n  color: #FFFFFF;\n}\n.has-switch .switch-off span.switch-left{\n  background-color: $gray-400 !important;\n}\n.has-switch span.switch-right {\n  border-radius: 0 30px 30px 0;\n  background-color: $primary;\n  color: #ffffff;\n  text-indent: 1px;\n}\n.has-switch .switch-off span.switch-right{\n  background-color: $gray-400 !important;\n}\n\n.has-switch label {\n  border-radius: 12px;\n  float: left;\n  height: 22px;\n  margin: 1px -13px;\n  padding: 0;\n  position: relative;\n  vertical-align: middle;\n  width: 22px;\n  z-index: 10;\n  -webkit-transition: 0.25s ease-out;\n  transition: 0.25s ease-out;\n}\n.has-switch .switch-on .fa-check:before{\n  margin-left: 10px;\n}\n.has-switch:hover .switch-on label{\n  margin: 1px -17px;\n  width: 26px;\n}\n.has-switch:hover .switch-off label{\n  margin: 1px -13px;\n  width: 26px;\n}\n\n// Sizing\n\n.has-switch-sm {\n  &.has-switch {\n    span {\n      height: 18px;\n      line-height: 18px;\n      padding: 0;\n    }\n    label {\n      height: 16px;\n      width: 16px;\n      margin: 1px -8px;\n    }\n\n    .switch-off {\n      label {\n        margin: 1px -13px;\n      }\n    }\n\n    &:hover {\n      .switch-on label {\n        margin: 1px -11px;\n        width: 20px;\n      }\n\n      .switch-off label {\n        margin: 1px -13px;\n        width: 20px;\n      }\n    }\n  }\n}","// Dropzone\n\n.dropzone-wrapper {\n  width: 100%;\n  border: $gray-400 dashed 2px;\n  @include border-radius($border-radius-lg);\n  display: flex;\n  align-items: center;\n  align-content: center;\n  text-align: center;\n  height: 230px;\n  transition: all .2s;\n\n  &:hover {\n    border-color: $primary;\n  }\n\n  & > div {\n    width: 100%;\n    height: 100%;\n    outline: none !important;\n    display: flex;\n    align-items: center;\n  }\n\n  &.dropzone-wrapper-lg {\n    height: 300px;\n  }\n\n  &.dropzone-wrapper-sm {\n    height: 150px;\n  }\n\n  input {\n    width: 100%;\n    height: 100%;\n  }\n\n  .dropzone-content {\n    margin: 0 auto;\n    color: $gray-600;\n  }\n\n  &[aria-disabled=\"true\"] {\n    border-color: $gray-300;\n\n    .dropzone-content {\n      color: $gray-400;\n    }\n  }\n}","@import '_mixins';\n\n.rbt {\n  outline: none;\n\n  &-menu {\n    margin-bottom: 2px;\n\n    & > li a {\n      overflow: hidden;\n      text-overflow: ellipsis;\n\n      &:focus {\n        outline: none;\n      }\n    }\n\n    &-pagination-option {\n      text-align: center;\n    }\n  }\n\n  // Hide IE's native \"clear\" button\n  & .rbt-input-main::-ms-clear {\n    display: none;\n  }\n\n  &-input-multi {\n    cursor: text;\n    overflow: hidden;\n    position: relative;\n\n    // BS4 uses the :disabled pseudo-class, which doesn't work with non-inputs.\n    &.form-control[disabled] {\n      background-color: #e9ecef;\n      opacity: 1;\n    }\n\n    input {\n      @include placeholder(#6c757d);\n    }\n\n    .rbt-input-wrapper {\n      margin-top: 2px;\n      overflow: hidden;\n    }\n\n    .rbt-input-main {\n      height: auto;\n    }\n\n    .rbt-input-hint-container {\n      display: inline-block;\n    }\n\n    &.input,\n    &.form-control {\n      &-lg {\n        .rbt-input-main {\n          height: auto;\n        }\n      }\n\n      &-sm {\n        .rbt-input-main {\n          height: auto;\n        }\n      }\n    }\n  }\n\n  &-close {\n    z-index: 1;\n\n    &-lg {\n      font-size: 24px;\n    }\n  }\n\n  &-token {\n    background-color: $dropdown-link-hover-bg;\n    border: 0;\n    @include border-radius($border-radius);\n    color: $primary;\n    display: inline-block;\n    line-height: 1em;\n    margin: 0 3px 3px 0;\n    padding: 4px 7px;\n    position: relative;\n\n    &-disabled {\n      background-color: $gray-100;\n      color: $gray-500;\n      pointer-events: none;\n    }\n\n    &-removeable {\n      cursor: pointer;\n      padding-right: 21px;\n    }\n\n    &-active {\n      background-color: $primary;\n      color: $white;\n      outline: none;\n      text-decoration: none;\n    }\n\n    & &-remove-button {\n      bottom: 0;\n      color: $gray-700;\n      font-size: inherit;\n      font-weight: normal;\n      opacity: 1;\n      outline: none;\n      padding: 3px 7px;\n      position: absolute;\n      right: 0;\n      text-shadow: none;\n      top: -1px;\n    }\n  }\n\n  &-loader {\n    @include animation(loader-animation 600ms infinite linear);\n    border: 1px solid $dropdown-link-hover-bg;\n    border-radius: 50%;\n    border-top-color: darken($dropdown-link-hover-bg, 10%);\n    display: block;\n    height: 16px;\n    width: 16px;\n\n    &-lg {\n      height: 20px;\n      width: 20px;\n    }\n  }\n\n  &-aux {\n    @include display-flex();\n    align-items: center;\n    bottom: 0;\n    justify-content: center;\n    pointer-events: none; /* Don't block clicks on the input */\n    position: absolute;\n    right: 0;\n    top: 0;\n    width: 34px;\n\n    &-lg {\n      width: 46px;\n    }\n\n    & .rbt-close {\n      margin-top: -1px;\n      pointer-events: auto; /* Override pointer-events: none; above */\n      background-color: transparent;\n      border: none;\n    }\n  }\n\n  .has-aux &-input {\n    padding-right: 34px;\n  }\n\n  &-highlight-text {\n    background-color: inherit;\n    color: inherit;\n    font-weight: bold;\n    padding: 0;\n  }\n}\n\n/* Input Groups */\n.input-group > .rbt {\n  @include flex(1);\n\n  & .rbt-input-hint-container {\n    @include display-flex();\n  }\n\n  & .rbt-input-hint {\n    // Form-controls within input-groups have a higher z-index.\n    z-index: 5;\n  }\n\n  & .rbt-aux {\n    // Form-controls within input-groups have a higher z-index.\n    z-index: 5;\n  }\n\n  &:not(:first-child) .form-control {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n\n  &:not(:last-child) .form-control {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n}\n\n@keyframes loader-animation {\n  to {\n    transform: rotate(1turn);\n  }\n}\n\n@-webkit-keyframes loader-animation {\n  to {\n    -webkit-transform: rotate(1turn);\n  }\n}\n\n.input-group > .rbt {\n  & .rbt-input-hint-container {\n    @include flex(1);\n    height: 100%;\n  }\n}\n\n.rbt-token-remove-button {\n  background-color: transparent;\n  border: none;\n}","\n@mixin animation($animation) {\n  -webkit-animation: $animation;\n  -o-animation: $animation;\n  animation: $animation;\n}\n\n@mixin box-shadow($shadow, $inset: false) {\n  @if $inset {\n    -webkit-box-shadow: $inset, $shadow;\n    -moz-box-shadow: $inset, $shadow;\n    box-shadow: $inset, $shadow;\n  } @else {\n    -webkit-box-shadow: $shadow;\n    -moz-box-shadow: $shadow;\n    box-shadow: $shadow;\n  }\n}\n\n@mixin display-flex()  {\n  display: -webkit-box;\n  display: -moz-box;\n  display: -ms-flexbox;\n  display: -webkit-flex;\n  display: flex;\n}\n\n@mixin flex($value) {\n  -webkit-box-flex: $value;\n  -moz-box-flex: $value;\n  -webkit-flex: $value;\n  -ms-flex: $value;\n  flex: $value;\n}\n\n@mixin placeholder($placeholder-color) {\n  // Firefox\n  &::-moz-placeholder {\n    color: $placeholder-color;\n    opacity: 1;\n  }\n\n  // Internet Explorer 10+\n  &:-ms-input-placeholder {\n    color: $placeholder-color;\n  }\n\n  // Safari and Chrome\n  &::-webkit-input-placeholder  {\n    color: $placeholder-color;\n  }\n}","@use './variables.scss' as *;\n@use './mixins.scss';\n/* for debugging */\n// *:focus {\n//   outline: 1px red solid !important;\n// }\n\n@keyframes react-widgets-autofill-start {\n  from {\n    /**/\n  }\n  to {\n    /**/\n  }\n}\n\n@keyframes react-widgets-autofill-cancel {\n  from {\n    /**/\n  }\n  to {\n    /**/\n  }\n}\n\n.rw-btn {\n  @include mixins.btn-input-reset;\n\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background-clip: $widget-background-clip;\n  cursor: pointer;\n\n  &:focus {\n    outline: none;\n  }\n\n  &:disabled,\n  fieldset[disabled] &,\n  // for picker-caret\n  .rw-state-disabled &,\n  .rw-state-readonly & {\n    cursor: inherit;\n  }\n  // easier to disable this way then check in each event handler\n  fieldset[disabled] & {\n    pointer-events: none;\n  }\n}\n\n// The Psuedo button on DropdownList and Multiselect\n// also composes rw-btn\n.rw-picker-caret,\n.rw-picker-btn {\n  color: $picker-btn-color;\n  align-items: $picker-btn-align-items;\n  justify-content: $picker-btn-justify-content;\n  padding-left: $picker-btn-padding-left;\n  padding-right: $picker-btn-padding-right;\n}\n\n.rw-picker-btn {\n  background-color: $picker-btn-bg;\n  // border color doesn't make sense here\n  // since it's surrounded by the input border\n\n  &:hover {\n    color: $picker-btn-hover-color;\n    background-color: $picker-btn-hover-bg;\n  }\n  &:active {\n    color: $picker-btn-active-color;\n    background-color: $picker-btn-active-bg;\n  }\n\n  &:disabled,\n  fieldset[disabled] & {\n    background-color: $picker-btn-disabled-bg;\n  }\n}\n\n.rw-input-addon {\n  // The input border should be more important here\n  &,\n  &.rw-picker-btn {\n    border-left: $input-addon-border-color 1px solid;\n\n    [dir='rtl'] & {\n      border-right: $input-addon-border-color 1px solid;\n      border-left: none;\n    }\n  }\n}\n\n.rw-sr {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n}\n\n.rw-widget {\n  border: none;\n  color: $widget-color;\n  font-weight: $widget-font-weight;\n  font-size: $widget-font-size;\n  font-family: $widget-font-family;\n  outline: none;\n  position: relative;\n\n  &,\n  & *,\n  &:after,\n  &:before,\n  & *:after,\n  & *:before {\n    box-sizing: border-box;\n  }\n}\n\n.rw-state-readonly,\n.rw-state-disabled,\nfieldset[disabled] .rw-widget {\n  cursor: not-allowed;\n}\n\n.rw-widget-picker {\n  display: grid;\n  overflow: hidden;\n  min-height: $input-height;\n  background-color: $input-bg;\n  border: $input-border-color $input-border-width solid;\n  border-radius: $input-border-radius;\n  outline: none;\n  grid-template: 1fr / 1fr $input-addon-width;\n  // ensure that the \"chrome\" is the same width as the actual container\n  width: 100%;\n\n  &.rw-hide-caret {\n    grid-template-columns: 1fr;\n  }\n\n  .rw-state-focus & {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    box-shadow: $widget-focus-box-shadow;\n    transition: if($widget-focus-box-shadow, $widget-focus-transition, null);\n\n    &.rw-widget-input {\n      @if ($input-box-shadow) {\n        box-shadow: #{$widget-focus-box-shadow}, #{$input-box-shadow};\n      }\n    }\n  }\n}\n\n.rw-input {\n  @include mixins.btn-input-reset;\n  @include mixins.input-base;\n\n  padding: 0 $input-padding-x;\n\n  &[type='text']::-ms-clear {\n    display: none;\n  }\n\n  &:disabled,\n  &:read-only {\n    // use parent style\n    cursor: inherit;\n  }\n}\n\n// This class represents the abstract container that is the \"input\" of any\n// given widget\n.rw-widget-input {\n  color: $input-color;\n  background-color: $input-bg;\n  box-shadow: $input-box-shadow;\n  background-clip: $widget-background-clip;\n  width: inherit;\n\n  // Listbox is also the rw-widget\n  &.rw-state-disabled,\n  .rw-state-disabled &,\n  fieldset[disabled] & {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n  }\n}\n\n.rw-placeholder,\n.rw-input::placeholder {\n  color: $input-placeholder-color;\n\n  .rw-state-disabled & {\n    color: $input-disabled-placeholder-color;\n  }\n}\n\n// https://github.com/klarna/ui/blob/master/Field/styles.scss\n.rw-detect-autofill {\n  @include mixins.btn-input-reset;\n  @include mixins.input-base;\n}\n\n.rw-detect-autofill:-webkit-autofill {\n  animation-name: react-widgets-autofill-start;\n  animation-duration: 0.01ms;\n}\n\n.rw-detect-autofill:not(:-webkit-autofill) {\n  animation-name: react-widgets-autofill-cancel;\n  animation-duration: 0.01ms;\n}\n\n.rw-webkit-autofill .rw-widget-container,\n.rw-input:-webkit-autofill {\n  background-color: $input-autofill-bg !important;\n  background-image: none !important;\n  color: $input-autofill-color !important;\n}\n","@use './variables.scss' as *;\n\n@mixin border-box() {\n  background-clip: border-box;\n\n  &,\n  & * {\n    box-sizing: border-box;\n  }\n\n  &:before,\n  & *:before,\n  &:after,\n  & *:after {\n    box-sizing: border-box;\n  }\n}\n\n@mixin unstyled-list() {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n@mixin focus-ring() {\n  z-index: 1;\n  box-shadow: $widget-focus-box-shadow;\n  transition: if($widget-focus-box-shadow, $widget-focus-transition, null);\n}\n\n@mixin focus() {\n  &:focus {\n    @include focus-ring();\n\n    [data-intent='mouse'] & {\n      z-index: auto;\n      box-shadow: none;\n    }\n  }\n}\n\n@mixin btn-input-reset {\n  padding: 0;\n  margin: 0;\n  border: none;\n  color: inherit;\n  box-shadow: none;\n  background: none;\n  font: inherit;\n  line-height: inherit;\n  -ms-touch-action: manipulation;\n  touch-action: manipulation;\n  outline: 0;\n}\n\n@mixin input-base {\n  caret-color: $input-caret-color;\n\n  &:disabled {\n    // For safari, which seems to ignore color on disabled inputs\n    // opacity for IOS\n    -webkit-text-fill-color: $input-disabled-color;\n    opacity: 1;\n  }\n}\n","$components: (\n  'Listbox',\n  'DropdownList',\n  'Combobox',\n  'Autocomplete',\n  'Multiselect',\n  'DatePicker',\n  'Calendar',\n  'TimeInput',\n  'NumberPicker'\n) !default;\n\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n\n//\n// Widget States\n//\n$widget-font-weight: null !default; // TODO\n$widget-font-size: 1em !default;\n$widget-font-family: inherit !default;\n\n$widget-border-radius: 4px !default;\n\n$widget-bg: #fff !default;\n$widget-color: $gray-900;\n$widget-border-color: #ccc !default;\n$widget-disabled-bg: $gray-200 !default;\n\n$widget-hover-bg: $gray-200 !default;\n$widget-hover-border-color: $widget-hover-bg !default;\n$widget-hover-color: null !default;\n\n$widget-focus-width: 3px !default;\n$widget-focus-color: rgba(0, 123, 255, 0.25) !default;\n$widget-focus-box-shadow: 0 0 0 $widget-focus-width $widget-focus-color !default;\n$widget-focus-transition: box-shadow 0.15s ease-in-out !default;\n\n$widget-background-clip: padding-box !default;\n\n//\n// Buttons\n//\n$picker-btn-align-items: null !default; // TD\n$picker-btn-justify-content: null !default; // TD\n\n$picker-btn-padding-left: null !default;\n$picker-btn-padding-right: null !default;\n$picker-btn-color: $widget-color !default;\n$picker-btn-border-color: null !default;\n$picker-btn-bg: null !default;\n$picker-btn-disabled-bg: $widget-disabled-bg !default;\n\n$picker-btn-hover-color: null !default;\n$picker-btn-hover-border-color: null !default;\n$picker-btn-hover-bg: $widget-hover-bg !default;\n\n$picker-btn-active-color: null !default;\n$picker-btn-active-border-color: null !default;\n$picker-btn-active-bg: $gray-300 !default;\n\n//\n// Picker inputs\n//\n\n$input-height: 38px !default; // 2.5em is good for 16px roots\n$input-color: $gray-700 !default;\n$input-caret-color: null !default;\n$input-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075) !default;\n$input-padding-x: 0.857em !default;\n\n$input-bg: $widget-bg !default;\n$input-placeholder-color: #999 !default;\n\n$input-border-color: $widget-border-color !default;\n$input-border-width: 1px !default;\n$input-border-radius: $widget-border-radius !default;\n\n$input-disabled-bg: $widget-disabled-bg !default;\n$input-disabled-border-color: null !default;\n$input-disabled-color: null !default;\n$input-disabled-placeholder-color: #999 !default;\n\n$input-focus-bg: null !default;\n$input-focus-border-color: #80bdff !default; // 25% lighter active-bg\n$input-focus-color: null !default;\n\n$input-autofill-bg: rgb(232, 240, 254) !default;\n$input-autofill-color: rgb(0, 0, 0) !default;\n\n$input-addon-width: 1.9em !default;\n$input-addon-border-color: $input-border-color !default;\n","@use './variables.scss' as *;\n\n$color: $widget-color !default;\n$font-size: $widget-font-size !default;\n$padding-y: 0.5em !default;\n\n$_hover-bg: $widget-hover-bg;\n$_hover-border-color: $widget-hover-border-color;\n$_hover-color: $widget-hover-color;\n\n$focus-bg: $_hover-bg !default;\n$focus-border-color: $_hover-border-color !default;\n$focus-color: $_hover-color !default;\n\n$selected-bg: #007bff !default;\n$selected-border-color: $selected-bg !default;\n$selected-color: #fff !default;\n\n$disabled-bg: transparent !default;\n$disabled-border-color: transparent !default;\n$disabled-color: $gray-300 !default;\n\n$option-padding-y: 0.25em !default;\n$option-padding-x: 1.5em !default;\n$option-muted-color: $gray-400 !default;\n\n$option-create-bg: $widget-bg !default;\n\n$optgroup-color: null !default;\n$optgroup-font-weight: bold !default;\n\n@mixin List() {\n  .rw-list {\n    // outline: 0;\n    font-size: $font-size;\n    overflow-x: visible;\n    overflow-y: auto;\n    padding-top: $padding-y;\n    padding-bottom: $padding-y;\n\n    &:focus {\n      outline: none;\n    }\n  }\n\n  .rw-list-option {\n    user-select: none;\n    color: $color;\n    cursor: pointer;\n    border: 1px solid transparent;\n    background-clip: $widget-background-clip;\n\n    &:hover,\n    [data-intent='keyboard'] &.rw-state-focus:not(.rw-state-selected) {\n      background-color: $focus-bg;\n      border-color: $focus-border-color;\n      color: $focus-color;\n    }\n\n    &.rw-state-selected {\n      background-color: $selected-bg;\n      border-color: $selected-border-color;\n      color: $selected-color;\n    }\n\n    &.rw-state-disabled {\n      cursor: not-allowed; // required to override the cursor above\n      background-color: $disabled-bg;\n      border-color: $disabled-border-color;\n      color: $disabled-color;\n    }\n  }\n\n  .rw-list-empty,\n  .rw-list-option,\n  .rw-list-optgroup {\n    padding: $option-padding-y $option-padding-x;\n    outline: none;\n  }\n\n  .rw-list-empty {\n    text-align: center;\n    color: $option-muted-color;\n  }\n\n  .rw-list-optgroup {\n    color: $optgroup-color;\n    font-weight: $optgroup-font-weight;\n    padding-top: 7px;\n  }\n\n  .rw-list-option-create {\n    @extend .rw-list-option;\n\n    display: block;\n    font-size: $font-size;\n    padding: $option-padding-y $option-padding-x;\n  }\n}\n","@use './variables.scss' as *;\n\n@mixin Listbox() {\n  .rw-listbox {\n    border-radius: $widget-border-radius;\n    background-color: $widget-bg;\n    border: $widget-border-color 1px solid;\n\n    &.rw-state-focus {\n      color: $input-focus-color;\n      background-color: $input-focus-bg;\n      border-color: $input-focus-border-color;\n      box-shadow: #{$widget-focus-box-shadow}, #{$input-box-shadow};\n      transition: if($widget-focus-box-shadow, $widget-focus-transition, null);\n    }\n\n    &.rw-state-disabled > *,\n    fieldset[disabled] & > * {\n      pointer-events: none;\n    }\n\n    &.rw-state-readonly > * {\n      cursor: inherit;\n    }\n  }\n}\n","@use './variables.scss' as *;\n\n$widget-offset: 2px !default;\n$max-height: 250px;\n$bg: $widget-bg !default;\n$border: $widget-border-color !default;\n$border-radius: $widget-border-radius !default;\n$box-shadow-offset: 1em !default;\n$box-shadow: 0 0.5em 1em rgba(#000, 0.175) !default;\n$box-shadow-up: 0 0.5em 1em rgba(#000, 0.175) !default;\n\n$zindex: 1005 !default;\n$zindex-focused: $zindex + 1 !default;\n\n@mixin Popup() {\n  .rw-popup-container {\n    position: absolute;\n    z-index: $zindex;\n    top: 100%;\n    left: -$box-shadow-offset;\n    right: -$box-shadow-offset;\n    padding: 0 $box-shadow-offset;\n\n    &.rw-dropup {\n      top: auto;\n      bottom: 100%;\n    }\n\n    .rw-state-focus & {\n      z-index: $zindex-focused;\n    }\n  }\n\n  .rw-slide-transition {\n    // the offsets allows for drop shadow to not be clipped by the container\n    // width: 100%;\n    margin-bottom: $box-shadow-offset;\n    // margin: 0 $box-shadow-offset;\n\n    .rw-dropup > & {\n      margin-bottom: 0;\n      margin-top: $box-shadow-offset;\n    }\n  }\n\n  .rw-popup {\n    overflow: auto; // this is needed for some reason to clip scrollbar corners\n    -webkit-overflow-scrolling: touch;\n    margin-top: $widget-offset;\n    border-radius: $border-radius;\n    box-shadow: $box-shadow;\n    border: $border 1px solid;\n    background-clip: $widget-background-clip;\n    background: $bg;\n\n    & .rw-list {\n      max-height: $max-height;\n    }\n\n    .rw-dropup & {\n      margin-top: 0;\n      margin-bottom: $widget-offset;\n      box-shadow: $box-shadow-up;\n    }\n  }\n\n  .rw-slide-transition {\n    transition: transform 130ms, opacity 100ms;\n  }\n\n  .rw-slide-transition-entering {\n    overflow: hidden;\n\n    & .rw-slide-transition {\n      transform: translateY(0);\n      opacity: 1;\n      transition-timing-function: ease-out;\n    }\n  }\n\n  .rw-slide-transition-exiting {\n    & .rw-slide-transition {\n      transition-timing-function: ease-in;\n    }\n  }\n\n  .rw-slide-transition-exiting,\n  .rw-slide-transition-exited {\n    overflow: hidden;\n\n    & .rw-slide-transition {\n      opacity: 0;\n      transform: translateY(-10%);\n    }\n\n    &.rw-dropup .rw-slide-transition {\n      opacity: 0;\n      transform: translateY(10%);\n    }\n  }\n\n  .rw-slide-transition-exited {\n    display: none;\n  }\n}\n","@use './variables.scss' as *;\n@use './mixins.scss';\n\n@mixin DropdownList() {\n  .rw-dropdown-list {\n    width: 100%;\n  }\n\n  .rw-dropdownlist-search {\n    @include mixins.btn-input-reset;\n    @include mixins.input-base;\n  }\n\n  .rw-dropdown-list-value {\n  }\n\n  .rw-dropdown-list-input {\n    padding: 0 $input-padding-x;\n    align-self: center;\n    display: grid;\n    min-width: 0;\n    grid-template: 1fr / 1fr;\n\n    & > * {\n      grid-area: 1/1;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      overflow: hidden;\n    }\n\n    [dir='rtl'] & {\n      padding-right: $input-padding-x;\n      padding-left: 0;\n    }\n  }\n}\n","@mixin Combobox() {\n  .rw-combobox-input {\n    background-color: transparent;\n    z-index: 1;\n  }\n}\n","@use './variables.scss' as *;\n@use './mixins.scss';\n\n$gutter-pt: 0.115 !default;\n$tag-padding-left: 0.35em !default;\n$tag-padding-right: 0.35em !default;\n\n$tag-color: null !default;\n$tag-border-color: $gray-300 !default;\n$tag-bg: $gray-300 !default;\n\n$tag-height-pt: 1 - ($gutter-pt * 2) !default;\n$tag-gutter: calc(\n  #{$input-height} * #{$gutter-pt} - #{$input-border-width}\n) !default;\n$tag-height: calc(#{$input-height} * #{$tag-height-pt}) !default;\n$tag-border-radius: 3px !default;\n\n$tag-btn-padding-y: 0 !default;\n$tag-btn-padding-x: 0.35em !default;\n\n$tag-btn-bg: null !default;\n$tag-btn-border-color: null !default;\n$tag-btn-color: null !default;\n\n$tag-btn-hover-bg: null !default;\n$tag-btn-hover-border-color: null !default;\n$tag-btn-hover-color: null !default;\n\n$tag-btn-active-bg: null !default;\n$tag-btn-active-border-color: null !default;\n$tag-btn-active-color: null !default;\n\n@mixin Multiselect() {\n  .rw-multiselect {\n  }\n\n  .rw-multiselect-input {\n    @include mixins.btn-input-reset;\n    @include mixins.input-base;\n\n    height: calc(#{$input-height} - #{$input-border-width} * 2);\n    padding: 0 $input-padding-x;\n    max-width: 100%; // breaks to a new line but doesn't stop growing\n\n    &:disabled,\n    &:read-only {\n      // use parent style\n      cursor: inherit;\n    }\n  }\n\n  .rw-multiselect-taglist {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-start;\n    width: 100%;\n    outline: none;\n    cursor: text;\n\n    .rw-state-disabled & {\n      cursor: unset;\n    }\n  }\n\n  .rw-multiselect-tag {\n    display: inline-flex;\n    color: $tag-color;\n    margin-left: $tag-gutter;\n    margin-top: $tag-gutter;\n    min-height: $tag-height;\n    border-radius: $tag-border-radius;\n    background-color: $tag-bg;\n    border: if($tag-border-color, 1px solid $tag-border-color, null);\n    // reset the text selection cursor on the parent\n    cursor: default;\n    max-width: 100%;\n    align-items: center;\n    // border radius clipping when there are background colors, e.g. hover/active\n    // easier than rtl border radius'in\n    overflow: hidden;\n\n    &:focus {\n      outline: none;\n    }\n\n    [dir='rtl'] & {\n      margin-left: 0;\n      margin-right: $tag-gutter;\n      padding: 0 $tag-padding-left 0 $tag-padding-right;\n    }\n\n    &.rw-state-focus {\n      @include mixins.focus-ring();\n    }\n\n    &.rw-state-disabled,\n    fieldset[disabled] & {\n      opacity: 0.65;\n    }\n  }\n\n  .rw-multiselect-tag-label {\n    padding: 0 $tag-padding-right 0 $tag-padding-left;\n  }\n\n  .rw-multiselect-tag-btn {\n    @include mixins.btn-input-reset;\n\n    cursor: pointer;\n    align-self: stretch;\n\n    padding: $tag-btn-padding-y $tag-btn-padding-x;\n    color: $tag-btn-color;\n    border-color: $tag-btn-border-color;\n    background-color: $tag-btn-bg;\n\n    &:hover {\n      color: $tag-btn-hover-color;\n      border-color: $tag-btn-hover-border-color;\n      background-color: $tag-btn-hover-bg;\n    }\n    &:active {\n      color: $tag-btn-active-color;\n      background-color: $tag-btn-active-bg;\n      border-color: $tag-btn-active-border-color;\n    }\n\n    &:focus {\n      outline: none;\n    }\n\n    &:disabled {\n      cursor: inherit;\n    }\n  }\n}\n","@use './variables.scss' as *;\n@use './mixins.scss';\n@use './list.scss' as list;\n\n$bg: $widget-bg !default;\n\n$btn-bg: #fff !default;\n$btn-color: $widget-color !default;\n$btn-border-color: null !default;\n$btn-muted-color: $gray-400;\n$btn-border-radius: $widget-border-radius !default;\n\n$btn-hover-bg: $widget-hover-bg !default;\n$btn-hover-border-color: $widget-hover-border-color !default;\n$btn-hover-color: $widget-hover-color !default;\n\n$btn-active-color: null !default;\n$btn-active-border-color: null !default;\n$btn-active-bg: $gray-300 !default;\n\n$btn-focus-color: null !default;\n$btn-focus-border-color: null !default;\n$btn-focus-bg: null !default;\n\n$cell-align: center !default;\n$cell-padding: 0.25em !default;\n$cell-color: $btn-color !default;\n$cell-border-color: null !default;\n$cell-border-radius: $btn-border-radius !default;\n\n$cell-hover-bg: $btn-hover-bg !default;\n$cell-hover-border-color: $btn-hover-border-color !default;\n$cell-hover-color: $btn-hover-color !default;\n\n$cell-active-bg: $btn-active-bg !default;\n$cell-active-border-color: $btn-active-border-color !default;\n$cell-active-color: $btn-active-color !default;\n\n$cell-select-color: list.$selected-color !default;\n$cell-select-border-color: list.$selected-border-color !default;\n$cell-select-bg: list.$selected-bg !default;\n\n@mixin _translate($x, $y) {\n  transform: translate(#{$x}, #{$y});\n\n  @supports (transform-style: preserve-3d) {\n    transform: translate3d(#{$x}, #{$y}, 0);\n  }\n}\n\n@mixin Calendar() {\n  .rw-calendar-popup {\n    right: auto;\n    min-width: 0;\n    width: 22em;\n  }\n\n  .rw-calendar {\n    overflow: hidden;\n  }\n\n  .rw-calendar-contained {\n    border-radius: $widget-border-radius;\n    background-color: $bg;\n    border: $widget-border-color 1px solid;\n  }\n\n  .rw-calendar-now {\n    font-weight: bold;\n  }\n  .rw-calendar-header {\n    display: flex;\n    padding: 0.8em;\n  }\n\n  .rw-cell,\n  .rw-calendar-btn {\n    background-clip: $widget-background-clip;\n\n    @include mixins.focus();\n\n    // TODO: normal button disabled\n    &:disabled,\n    &.rw-state-disabled {\n      pointer-events: none;\n      opacity: 0.35;\n    }\n  }\n\n  .rw-calendar-btn {\n    line-height: 2em;\n    border-radius: $btn-border-radius;\n    border-color: $btn-border-color;\n\n    &:hover {\n      background-color: $btn-hover-bg;\n    }\n    &:active {\n      background-color: $btn-active-bg;\n    }\n  }\n\n  .rw-calendar-btn-left,\n  .rw-calendar-btn-today,\n  .rw-calendar-btn-right,\n  .rw-calendar-btn-view {\n    padding: 0.3em 0.6em;\n  }\n\n  .rw-calendar-btn-left,\n  .rw-calendar-btn-right {\n    [dir='rtl'] & {\n      transform: scale(-1, 1);\n    }\n  }\n  .rw-calendar-btn-view {\n    font-weight: bold;\n\n    & > :last-child {\n      margin: 0 0.5em;\n    }\n\n    & + * {\n      margin-left: auto;\n\n      [dir='rtl'] & {\n        margin-left: 0;\n        margin-right: auto;\n      }\n    }\n  }\n\n  .rw-calendar-grid {\n    display: table;\n    outline: none;\n    height: 14em;\n    padding: $widget-focus-width;\n    table-layout: fixed;\n    border-collapse: separate;\n    border-spacing: 0;\n    width: 100%;\n    background-color: $bg;\n  }\n  .rw-calendar-head {\n    display: table-header-group;\n  }\n  .rw-calendar-body {\n    display: table-row-group;\n  }\n\n  .rw-calendar-row {\n    display: table-row;\n  }\n\n  .rw-head-cell {\n    display: table-cell;\n    text-align: $cell-align;\n    border-bottom: 1px solid $input-border-color;\n    padding: $cell-padding;\n  }\n\n  .rw-cell {\n    display: table-cell;\n    color: $cell-color;\n    vertical-align: middle;\n    border-color: $cell-border-color;\n    border-radius: $cell-border-radius;\n    cursor: pointer;\n    line-height: normal;\n    text-align: center;\n    border: 1px solid transparent;\n    padding: $cell-padding;\n    outline: none;\n\n    &:hover {\n      background-color: $cell-hover-bg;\n    }\n    &:active {\n      background-color: $cell-active-bg;\n    }\n\n    &.rw-state-selected {\n      background-color: $cell-select-bg;\n      border-color: $cell-select-border-color;\n      color: $cell-select-color;\n    }\n\n    .rw-calendar-month & {\n      text-align: $cell-align;\n    }\n  }\n\n  .rw-cell-off-range {\n    color: $btn-muted-color;\n  }\n\n  .rw-calendar-transition-group {\n    position: relative;\n    overflow: hidden;\n  }\n\n  .rw-calendar-transition {\n    width: 100%;\n    overflow: hidden;\n    transition: transform 0.2s ease-in-out 0ms;\n    @include _translate(0, 0);\n  }\n\n  .rw-calendar-transition-next {\n    -webkit-backface-visibility: hidden;\n    backface-visibility: hidden;\n\n    .rw-calendar-transition-top & {\n      @include _translate(0, -100%);\n    }\n    .rw-calendar-transition-bottom & {\n      @include _translate(0, 100%);\n    }\n    .rw-calendar-transition-right & {\n      @include _translate(-100%, 0);\n    }\n    .rw-calendar-transition-left & {\n      @include _translate(100%, 0);\n    }\n\n    &.rw-calendar-transition-active {\n      @include _translate(0, 0);\n    }\n  }\n\n  .rw-calendar-transition-prev {\n    -webkit-backface-visibility: hidden;\n    backface-visibility: hidden;\n    position: absolute;\n    left: 0;\n    top: 0;\n\n    .rw-calendar-transition-top & {\n      @include _translate(0, 100%);\n    }\n    .rw-calendar-transition-bottom & {\n      @include _translate(0, -100%);\n    }\n    .rw-calendar-transition-right & {\n      @include _translate(100%, 0);\n    }\n    .rw-calendar-transition-left & {\n      @include _translate(-100%, 0);\n    }\n  }\n}\n","@mixin DateTimePicker() {\n  .rw-popup {\n    display: flex;\n    flex-direction: column;\n\n    & > .rw-time-input {\n      align-self: center;\n      margin: 1em 0;\n    }\n  }\n}\n","@use './variables.scss' as *;\n@use './mixins.scss';\n\n@mixin TimeInput() {\n  .rw-time-input {\n    display: inline-flex;\n    min-height: $input-height;\n    align-items: center;\n    background-color: $input-bg;\n    border: $input-border-color $input-border-width solid;\n    border-radius: $input-border-radius;\n    outline: none;\n    cursor: text;\n  }\n\n  .rw-time-part-input {\n    @include mixins.btn-input-reset;\n    @include mixins.input-base;\n\n    padding: 0 0.5em;\n    // min-height: $input-height;\n\n    &,\n    &::placeholder {\n      text-align: center;\n    }\n  }\n\n  .rw-time-part-meridiem {\n    @include mixins.btn-input-reset;\n\n    padding: 0 0.5em;\n    text-transform: lowercase;\n    font-variant: small-caps;\n\n    & :focus {\n      outline: none;\n    }\n  }\n\n  .rw-time-input-clear {\n    padding: 0 0.4em;\n    outline: none;\n    opacity: 0;\n    margin-left: auto;\n\n    [dir='rtl'] & {\n      margin-left: revert;\n      margin-right: auto;\n    }\n\n    .rw-time-input:hover &.rw-show,\n    .rw-time-input.rw-state-focus &.rw-show {\n      opacity: 1;\n    }\n  }\n}\n","@use './variables.scss' as *;\n\n@mixin NumberPicker() {\n  .rw-number-picker-spinners {\n    display: flex;\n    flex-direction: column;\n\n    .rw-btn {\n      flex: 1 1 0;\n    }\n  }\n}\n","// Theme Options\n\n// Variables\n\n@use \"sass:math\";\n\n$theme-options-width: 500px;\n\n.ui-theme-settings {\n  position: fixed;\n  z-index: 155;\n  right: -30px;\n  top: 0;\n  height: 100vh;\n  transform: translate($theme-options-width);\n  transition: all .2s;\n  box-shadow: -0.46875rem 0 2.1875rem rgba(darken($primary, 50%), .03),\n  -0.9375rem 0 1.40625rem rgba(darken($primary, 50%), .03),\n  -0.25rem 0 0.53125rem rgba(darken($primary, 50%), .05),\n  -0.125rem 0 0.1875rem rgba(darken($primary, 50%), .03);\n\n  .btn-open-options {\n    @include border-radius(50px);\n    position: absolute;\n    left: -114px;\n    bottom: 80px;\n    padding: 0;\n    height: 54px;\n    line-height: 54px;\n    width: 54px;\n    text-align: center;\n    display: block;\n    box-shadow: $box-shadow-default;\n    margin-top: -27px;\n\n    svg {\n      top: 50%;\n      left: 50%;\n      position: absolute;\n      margin: -0.5em 0 0 -0.5em;\n    }\n  }\n\n  .theme-settings__inner {\n    background: $white;\n    width: $theme-options-width;\n    height: 100vh;\n    padding: 0;\n  }\n\n  &.settings-open {\n    transform: translate(0);\n    right: 0;\n  }\n\n  .theme-settings-swatches {\n    text-align: center;\n\n    .swatch-holder-img {\n      width: 72px;\n      height: auto;\n      @include border-radius(3px);\n\n      img {\n        width: 100%;\n      }\n    }\n  }\n\n  .themeoptions-heading {\n    font-size: $font-size-lg;\n    color: $body-color;\n    margin: 0;\n    background: $gray-100;\n    padding: math.div($layout-spacer-x, 2) $layout-spacer-x;\n    border-bottom: $gray-300 solid 1px;\n    border-top: $gray-300 solid 1px;\n    display: flex;\n    align-items: center;\n    align-content: center;\n\n    &:first-child {\n      border-top: 0;\n    }\n  }\n\n  .list-group-item {\n    h5 {\n      color: $primary;\n      font-size: $font-size-sm;\n      text-transform: uppercase;\n      margin: 0;\n      text-align: center;\n    }\n  }\n}\n\n.swatch-holder {\n  width: 24px;\n  height: 24px;\n  line-height: 24px;\n  margin: 5px 5px 0;\n  transition: all .2s;\n  opacity: .7;\n  display: inline-block;\n  @include border-radius(30px);\n\n  &.active {\n    border: $white solid 2px;\n    box-shadow: 0 0 0 5px $primary;\n    opacity: 1;\n  }\n\n  &:hover {\n    opacity: 1;\n  }\n}\n\n.swatch-holder-lg {\n  width: 48px;\n  height: 48px;\n  line-height: 48px;\n}","// DEMO\n\n@use \"sass:math\";\n\n@import \"elements/theme-options\";\n\n// Icons demo\n\n.font-icon-wrapper {\n  text-align: center;\n  border: $gray-200 solid 1px;\n  @include border-radius($border-radius);\n  margin: 0 0 10px;\n  padding: 5px;\n\n  &.font-icon-lg {\n    float: left;\n    padding: 10px;\n    text-align: center;\n    margin-right: 15px;\n    min-width: 64px;\n\n    i {\n      font-size: $h1-font-size;\n    }\n  }\n\n  &:hover {\n    background: $gray-100;\n    color: $primary;\n\n    p {\n      color: $gray-600;\n    }\n  }\n\n  i {\n    font-size: ($font-size-lg * 1.5);\n  }\n\n  p {\n    color: $gray-500;\n    font-size: math.div($font-size-sm, 1.2);\n    margin: 5px 0 0;\n  }\n}\n\n.btn-icon-vertical {\n  min-width: 100px;\n}\n\n.card.mb-3 {\n  margin-bottom: $grid-gutter-width !important;\n}\n\n// Image BG\n\n.demo-image-bg {\n  height: 350px;\n  margin-bottom: $grid-gutter-width;\n}\n\n// Loaders wrapper\n\n.loader-wrapper {\n  width: 150px;\n  height: 100px;\n  float: left;\n}\n\n// Slick slider\n\n.slider-item {\n  background: $gray-300;\n  @include border-radius($border-radius);\n  color: $gray-600;\n  font-size: 36px;\n  padding: 0;\n  position: relative;\n  height: 150px;\n  line-height: 150px;\n  text-align: center;\n  margin: 0 $layout-spacer-x;\n  transition: all .2s;\n}\n\n.slick-center {\n  .slider-item {\n    background: $gray-500;\n    color: $gray-700;\n  }\n}\n\n// Image Crop\n\n.after-img {\n  max-width: 100%;\n}\n","// Responsive\n\n@use \"sass:math\";\n\n@media only screen and (max-width: 1320px) {\n  .header-user-info {\n    display: none;\n  }\n}\n\n@include media-breakpoint-down(md) {\n\n  .app-main {\n    display: block;\n  }\n\n  .dropdown-menu {\n    &::before,\n    &::after {\n      display: none;\n    }\n  }\n\n  .app-sidebar {\n    flex: 0 0 $app-sidebar-width !important;\n    width: $app-sidebar-width !important;\n    transform: translateX(-$app-sidebar-width);\n\n    .app-header__logo {\n      display: none;\n    }\n  }\n\n  .sidebar-mobile-open {\n\n    .app-sidebar {\n\n      transform: translateX(0);\n\n      .app-sidebar__inner {\n\n        .app-sidebar__heading {\n          text-indent: initial;\n\n          &::before {\n            display: none;\n          }\n        }\n\n        .metismenu-link {\n          text-indent: initial;\n          padding: 0 $layout-spacer-x 0 45px;\n        }\n\n        .metismenu-icon {\n          text-indent: initial;\n          left: 5px;\n          margin-left: 0;\n        }\n\n        .metismenu-state-icon {\n          visibility: visible;\n        }\n\n        .metismenu-container {\n          &.visible {\n            padding: .5em 0 0 2rem;\n\n            & > .metismenu-item > .metismenu-link {\n              height: 2.3em;\n            }\n          }\n\n          .metismenu-container {\n            .metismenu-link {\n              padding-left: 1em;\n            }\n          }\n        }\n      }\n\n      .app-header__logo {\n        width: auto !important;\n\n        .logo-src {\n          width: $logo-width !important;\n          margin-left: auto;\n          margin-right: 0;\n        }\n      }\n    }\n\n    .fixed-sidebar .app-sidebar {\n      height: 100%;\n    }\n\n    .sidebar-mobile-overlay {\n      display: block;\n    }\n  }\n\n  .app-main {\n\n    .app-main__outer {\n      padding-left: 0 !important;\n      width: auto;\n    }\n  }\n\n  .app-header {\n    justify-content: space-between;\n\n    .app-header__logo {\n      display: none;\n      order: 2;\n      background: transparent !important;\n      border: 0 !important;\n    }\n\n    .app-header__content {\n      visibility: hidden;\n      opacity: 0;\n      box-shadow: $box-shadow-default;\n      position: absolute;\n      left: 5%;\n      width: 90%;\n      top: 0;\n      transition: all .2s;\n      background: $white;\n      @include border-radius(50px);\n      padding: 0 10px;\n      overflow: hidden;\n\n      .header-btn-lg {\n        margin-left: .5rem;\n        padding: 0 .5rem;\n\n        .hamburger-box {\n          margin-top: 5px;\n        }\n\n        & + .header-btn-lg {\n          display: none;\n        }\n      }\n\n      .app-header-left {\n        .nav {\n          display: none;\n        }\n      }\n\n      &.header-mobile-open {\n        visibility: visible;\n        opacity: 1;\n        top: $app-header-height + 20;\n      }\n    }\n\n    .app-header__mobile-menu {\n      display: flex;\n      order: 1;\n    }\n\n    .app-header__menu {\n      display: flex;\n      order: 3;\n    }\n\n    &.header-text-light {\n      .app-header__menu {\n        & > span .btn,\n        & > .btn {\n          background: rgba(255, 255, 255, .1);\n          border-color: rgba(255, 255, 255, .1);\n        }\n      }\n\n      .header-mobile-open {\n        background: $gray-800;\n      }\n\n    }\n  }\n\n  .popover,\n  .dropdown-menu {\n    position: fixed !important;\n    z-index: 50;\n    left: 5% !important;\n    top: 50% !important;\n    width: 90% !important;\n    transform: translateY(-50%) !important;\n    min-width: 10px !important;\n\n    .btn-icon-vertical .btn-icon-wrapper {\n      display: none;\n    }\n\n  }\n\n  .popover {\n    max-width: initial;\n\n    .arrow {\n      display: none !important;\n    }\n  }\n\n  .app-page-title {\n    text-align: center;\n\n    .page-title-heading,\n    .page-title-wrapper {\n      margin: 0 auto;\n      display: block;\n    }\n\n    .page-title-actions {\n      margin: math.div($grid-gutter-width, 2) auto 0;\n    }\n\n    .page-title-actions,\n    .page-title-subheading {\n      .breadcrumb-item,\n      .breadcrumb {\n        display: inline-block;\n      }\n    }\n  }\n\n  // Footer\n\n  .app-footer .app-footer__inner {\n    .app-footer-right {\n      display: none;\n    }\n\n    .app-footer-left {\n      width: 100%;\n\n      .footer-dots {\n        margin: 0 auto;\n      }\n    }\n  }\n\n  .fixed-footer {\n    &.closed-sidebar {\n      .app-footer {\n        .app-footer__inner {\n          margin-left: 0 !important;\n        }\n      }\n    }\n  }\n\n  // Components\n\n  .widget-content {\n    .widget-numbers {\n      font-size: 1.6rem;\n      line-height: 1;\n    }\n  }\n\n  .slick-slider-sm {\n    .slick-slider {\n      max-width: 650px !important;\n    }\n  }\n\n  .body-tabs.body-tabs-layout {\n    &.body-tabs-big {\n      display: block !important;\n\n      .RRT__tab {\n        display: inline-block !important;\n        padding: 0 $layout-spacer-x !important;\n      }\n\n      .RRT__showmore {\n        margin-top: -20px;\n      }\n    }\n  }\n\n  .ReactTable .-pagination {\n    .-center {\n      display: none;\n    }\n\n    .-previous {\n      padding-right: 3px;\n    }\n  }\n\n  .bg-transparent.list-group-item {\n    border-color: transparent;\n  }\n\n  .tabs-lg-alternate.card-header {\n\n    & > .nav .nav-item {\n      .widget-number {\n        font-size: 1.5rem;\n      }\n    }\n  }\n\n  .page-title-head {\n    display: block;\n  }\n}\n\n@include media-breakpoint-between(xs, md) {\n\n  .app-page-title .page-title-icon,\n  .ui-theme-settings {\n    display: none;\n  }\n\n  .card-header {\n    &.responsive-center {\n      display: block;\n      text-align: center;\n      height: auto;\n      padding: $layout-spacer-x;\n\n      .nav,\n      .btn-actions-pane-right {\n        margin: math.div($layout-spacer-x, 2) 0 0;\n\n        .d-inline-block.ml-2 {\n          width: 100% !important;\n          text-align: left;\n          margin: 0 !important;\n        }\n      }\n    }\n  }\n\n  .slick-slider-sm {\n    .slick-slider {\n      max-width: 650px !important;\n    }\n  }\n}\n\n@include media-breakpoint-up(lg) {\n\n  .slick-slider-sm {\n    .slick-slider {\n      max-width: 850px !important;\n    }\n  }\n}\n\n@include media-breakpoint-down(lg) {\n\n  .-hide-paging .-pagination .-center {\n    display: none;\n  }\n}\n\n@include media-breakpoint-down(sm) {\n  .app-main .app-main__inner {\n    padding: 15px 15px 0;\n  }\n\n  .mbg-3,\n  body .card.mb-3 {\n    margin-bottom: math.div($grid-gutter-width, 2) !important;\n  }\n\n  .app-page-title {\n    padding: math.div($grid-gutter-width, 2);\n    margin: (-(math.div($grid-gutter-width, 2))) (-(math.div($grid-gutter-width, 2))) $grid-gutter-width;\n  }\n\n  .body-tabs.body-tabs-layout {\n    margin-left: (-(math.div($grid-gutter-width, 2)));\n    margin-right: (-(math.div($grid-gutter-width, 2)));\n    padding: 0 math.div($grid-gutter-width, 2);\n  }\n\n  .app-main .app-main__inner > .RRT__container > .RRT__panel {\n    margin-top: math.div($grid-gutter-width, 2);\n  }\n\n  .popover,\n  .dropdown-menu {\n    width: 80%;\n    left: 10%;\n  }\n\n  body .card-header {\n    height: auto;\n    display: block;\n    padding: math.div($layout-spacer-x, 2) $layout-spacer-x;\n    text-align: center;\n\n    .btn-actions-pane-right {\n      padding: math.div($layout-spacer-x, 2) 0 0;\n    }\n\n    .actions-icon-btn {\n      padding: 0;\n    }\n  }\n\n  .card-header {\n    &.card-header-tab {\n      .card-header-title {\n        display: inline-flex !important;\n        line-height: 1;\n      }\n\n      & > .nav {\n        margin: math.div($layout-spacer-x, 2) 0 (-(math.div($layout-spacer-x, 2)));\n        display: table !important;\n        width: 100%;\n\n        .nav-item {\n          display: table-cell;\n        }\n      }\n    }\n  }\n\n  .header-icon {\n    display: none;\n  }\n\n  .profile-responsive-sm,\n  .profile-responsive {\n    .dropdown-menu-header .menu-header-content.btn-pane-right {\n      display: block;\n      text-align: center;\n\n      .avatar-icon-wrapper {\n        margin-right: 0 !important;\n      }\n\n      .menu-header-btn-pane {\n        margin-top: 1rem;\n      }\n    }\n  }\n\n  .slick-slider-sm .slick-slider .slick-prev {\n    left: math.div($grid-gutter-width, 2);\n  }\n\n  .slick-slider-sm .slick-slider .slick-next {\n    right: math.div($grid-gutter-width, 2);\n  }\n}\n\n@media only screen and (min-width: 1200px) and (max-width: 1500px) {\n  .profile-responsive {\n    .dropdown-menu-header .menu-header-content.btn-pane-right {\n      display: block;\n      text-align: center;\n\n      .avatar-icon-wrapper {\n        margin-right: 0 !important;\n      }\n\n      .menu-header-btn-pane {\n        margin-top: 1rem;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
